"use strict";

//***Modal Dialog for Application Updates - non angular **/
var modalUpdates;
var isDownloanding = false;
var isCheckForUpdate = false;
(function () {
  if ('applicationCache' in window && !('serviceWorker' in navigator)) {
    modalUpdates = $('.modal-updating').modal({
      backdrop: 'static',
      keyboard: true,
      show: false
    });

    modalUpdates.show = function () {
      modalUpdates.removeClass('update-success');
      modalUpdates.find('.progress').show();
      modalUpdates.find('.message-success').hide();
      modalUpdates.find('.message-danger').hide();
      modalUpdates.find('.message-no-update').hide();
      modalUpdates.find('.btn-update-retry').hide();
      modalUpdates.find('.btn-update-close').hide();
      modalUpdates.find('.btn-update-ok').hide();
      $('.modal-dialog').modal('hide');
      modalUpdates.modal('show');
    };

    modalUpdates.hide = function () {
      modalUpdates.modal('hide');
    };

    modalUpdates.success = function () {
      modalUpdates.show();
      modalUpdates.find('.progress').hide();
      modalUpdates.find('.message-success').show();
      modalUpdates.find('.message-danger').hide();
      modalUpdates.find('.message-no-update').hide();
      modalUpdates.find('.btn-update-retry').hide();
      modalUpdates.find('.btn-update-close').hide();
      modalUpdates.find('.btn-update-ok').show();
      modalUpdates.addClass('update-success');
      setTimeout(function () {
        modalUpdates.modal('hide');
      }, 2000);
    };

    modalUpdates.noUpdate = function () {
      modalUpdates.show();
      modalUpdates.find('.progress').hide();
      modalUpdates.find('.message-success').hide();
      modalUpdates.find('.message-danger').hide();
      modalUpdates.find('.message-no-update').show();
      modalUpdates.find('.btn-update-retry').hide();
      modalUpdates.find('.btn-update-close').hide();
      modalUpdates.find('.btn-update-ok').show();
      isCheckForUpdate = false;
    };

    modalUpdates.failure = function (errorMessage) {
      modalUpdates.show();
      modalUpdates.find('.progress').hide();
      modalUpdates.find('.message-success').hide();
      modalUpdates.find('.message-danger').show();
      modalUpdates.find('.message-no-update').hide();
      modalUpdates.find('.btn-update-retry').show();
      modalUpdates.find('.btn-update-close').show();
      modalUpdates.find('.btn-update-ok').hide(); //setTimeout(function(){location.reload();}, 2000);

      if (errorMessage && errorMessage != '') {
        modalUpdates.find('.update-error').text(errorMessage);
      } else {
        modalUpdates.find('.update-error').text('');
      }
    };

    modalUpdates.on('hidden.bs.modal', function (e) {
      var b = modalUpdates.hasClass('update-success');
      if (b) location.reload(true);
    });
  }
}).call(void 0); //** ApplicationCache Events & Actions **//

(function () {
  ////////////////////////////////////////////////////index scripts (cache)////////////////////////////////////////////////////
  if ('applicationCache' in window && !('serviceWorker' in navigator)) {
    // Convenience array of status values
    var cacheHandler = function cacheHandler() {};

    cacheHandler.cacheStatusValues = [];
    cacheHandler.cacheStatusValues[0] = 'uncached';
    cacheHandler.cacheStatusValues[1] = 'idle';
    cacheHandler.cacheStatusValues[2] = 'checking';
    cacheHandler.cacheStatusValues[3] = 'downloading';
    cacheHandler.cacheStatusValues[4] = 'updateready';
    cacheHandler.cacheStatusValues[5] = 'obsolete';

    cacheHandler.onDownloading = function (e) {
      isDownloanding = true;
      modalUpdates.show();
      cacheHandler.logEvent(e);
    };

    cacheHandler.onCached = function (e) {
      modalUpdates.hide();
      cacheHandler.logEvent(e);
    };

    cacheHandler.onChecking = function (e) {
      //ShowWaitDialog();
      cacheHandler.logEvent(e);
    };

    cacheHandler.onProgress = function (e) {};

    cacheHandler.onObsolete = function (e) {};

    cacheHandler.onError = function (e) {
      //debugger;
      var message = "Could not download application updates due to an unexpected error.\n" + "make sure that cache.manifest is being served with MIME type: text/cache-manifest"; //actual error message if any

      if (e.message) message = e.message;
      console.error(message); //hide update dialog if visible

      if (isDownloanding) {
        modalUpdates.failure(message);
      } else {
        modalUpdates.hide();
      }
    };

    cacheHandler.onNoUpdate = function (e) {
      if (isCheckForUpdate) {
        modalUpdates.noUpdate();
      } else {
        modalUpdates.hide();
      }

      isDownloanding = false;
      cacheHandler.logEvent(e);
    };

    cacheHandler.onUpdateReady = function (e) {
      try {
        cache.swapCache();
      } catch (e) {}

      cacheHandler.logEvent(e);
      isDownloanding = false;
      modalUpdates.success(); //location.reload(true);
    }; // Log every event to the console


    cacheHandler.logEvent = function (e) {// var status, type, message; //online,
      // //online = (navigator.online) ? 'yes' : 'no';
      // status = cacheHandler.cacheStatusValues[cache.status];
      // type = e.type;
      // message = '';//'online: ' + online;
      // message += 'CACHE: event: ' + type;
      // message += ', status: ' + status;
      // if (type == 'error' && navigator.online) {
      // message += ' (prolly a syntax error in manifest)';
      // }
      // console.log(message);
    };

    var cache = window.applicationCache;
    cache.addEventListener('cached', cacheHandler.onCached, false);
    cache.addEventListener('checking', cacheHandler.onChecking, false);
    cache.addEventListener('downloading', cacheHandler.onDownloading, false);
    cache.addEventListener('error', cacheHandler.onError, false); //cache.addEventListener('error', cacheHandler.logEvent, false);

    cache.addEventListener('noupdate', cacheHandler.onNoUpdate, false);
    cache.addEventListener('obsolete', cacheHandler.onObsolete, false);
    cache.addEventListener('progress', cacheHandler.onProgress, false);
    cache.addEventListener('updateready', cacheHandler.onUpdateReady, false);
  }

  $('#update-error-btn').click(function () {
    var alert = $('.hidden-update-error');

    if (alert.hasClass('hidden')) {
      alert.removeClass('hidden');
      $('#update-error-btn').text("show less");
    } else {
      alert.addClass('hidden');
      $('#update-error-btn').text("show more");
    }
  });
  $('body').on('click', '#update-check-btn', function () {
    isCheckForUpdate = true;
    var url = location.origin;
    $.ajax({
      type: "GET",
      url: url,
      cache: false,
      success: function success() {
        //get cache
        var cache = window.applicationCache; // Update the user's cache

        if (cache != null && cache != undefined && (cache.status == 1 || cache.status > 3)) {
          cache.update();
        }
      }
      /*,
                  error: function(){
                      console.log('error');
                  }*/

    });
  });
}).call(void 0);
$(document).on("keydown", '.modal textarea', function (e) {
  var zIndex = $(this).parents('.modal').css('z-index');

  if (zIndex) {
    $(this).parents('.modal').css('z-index', zIndex + 1);
    $(this).parents('.modal').css('z-index', zIndex);
  }
});
"use strict";

$(function () {
  angular.bootstrap(document, ['a3.cabin.reports']);
});
var a3_cabin_reports = angular.module('a3.cabin.reports', [//angular modules
'ngSanitize', 'ngRoute', 'ngTouch', //3rd party modules
'angular-md5', 'LocalStorageModule', 'ui.bootstrap', 'nya.bootstrap.select', 'ui.toggle', 'ui.sortable', //Our modules
'MyDirectives', 'LocalStorageMD5Module']);
"use strict";

(function () {
  'use strict'; // setup routing

  a3_cabin_reports.config(routeConfig);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name routeConfig
  * @description 
  *   Route configuration
  * @ngInject
  */

  function routeConfig($routeProvider) {
    $routeProvider.when('/', {
      controller: 'CalendarCtrl',
      templateUrl: 'views/calendar.html'
    }).when('/login', {
      controller: 'LoginCtrl',
      templateUrl: 'views/login.html'
    }).when('/flightinfo/:flightId', {
      controller: 'FlightInfoCtrl',
      templateUrl: 'views/flight-info.html',
      reloadOnSearch: false
    }).when('/selectedflightinfo/:flightId/:flightDate/:flightNo/:departure', {
      controller: 'SelectedFlightCtrl',
      templateUrl: 'views/SearchFlights/selected-flight-info.html',
      reloadOnSearch: false
    }).when('/leaverequest', {
      controller: 'LeaveRequestCtrl',
      templateUrl: 'views/LeaveRequest/leaveRequest.html'
    }).when('/jumpseatrequests', {
      controller: 'JumpseatRequestsCtrl',
      templateUrl: 'views/JumpseatRequests/jumpseatRequests.html'
    }).when('/pax/:flightId', {
      controller: 'PaxCtrl',
      templateUrl: 'views/pax.html'
    }).when('/report/:reportId/', {
      controller: 'ReportCtrl',
      templateUrl: 'views/report.html'
    }).when('/report/:reportId/:flightId', {
      controller: 'ReportCtrl',
      templateUrl: 'views/report.html'
    }).when('/pdf/:reportId', {
      controller: 'ReportCtrl',
      templateUrl: 'views/report.html'
    }).when('/reset', {
      controller: 'ResetDeviceCtrl',
      templateUrl: 'views/reset.html'
    }).when('/debug', {
      controller: 'DebugCtrl',
      templateUrl: 'views/debug.html'
    }).when('/assessment/:flightId', {
      controller: 'AssessmentCtrl',
      templateUrl: 'views/assessment.html'
    }).when('/saAssessment/:flightId', {
      controller: 'SaAssessmentCtrl',
      templateUrl: 'views/SAFeedbacks/saAssessment.html'
    }).when('/assfReport/:flightId', {
      controller: 'ASSFReportCtrl',
      templateUrl: 'views/SecurityForms/assfReport.html'
    }).when('/faqs', {
      controller: 'FaqsCtrl',
      templateUrl: 'views/faqs.html'
    }).when('/rosterRequests', {
      controller: 'RequestsCtrl',
      templateUrl: 'views/RosterRequests/requests.html'
    }).when('/memos/:filter', {
      controller: 'MemosCtrl',
      templateUrl: 'views/memos.html'
    }).when('/memos', {
      controller: 'MemosCtrl',
      templateUrl: 'views/memos.html'
    }).when('/messages/:flightId', {
      controller: 'MessageCtrl',
      templateUrl: 'views/messages.html'
    }).when('/messages/', {
      controller: 'MessageCtrl',
      templateUrl: 'views/messages.html'
    }).when('/ticket', {
      controller: 'TicketCtrl',
      templateUrl: 'views/ticket.html'
    }).when('/bucket', {
      controller: 'BucketCtrl',
      templateUrl: 'views/Bucket/bucketCalendar.html'
    }).when('/bucketDay/:dutyId', {
      controller: 'BucketDayCtrl',
      templateUrl: 'views/Bucket/bucketDay.html'
    }).when('/groundDuty/:groundDutyId', {
      controller: 'GroundDutyCtrl',
      templateUrl: 'views/GroundDuty/groundDuty-info.html'
    }).when('/crewRoute/:dutyNo/:dutyDay', {
      controller: 'CrewRouteCtrl',
      templateUrl: 'views/CrewRoute/crew-route-info.html'
    }).when('/reportsHistory/:reportId/:flightId/:reportType', {
      controller: 'ReportsHistoryCtrl',
      templateUrl: 'views/reportsHistory.html'
    }).when('/flightcourse/:courseId/:dutyNo/:dutyDay/:date', {
      controller: 'FlightCourseCtrl',
      templateUrl: 'views/Training/flightCourse.html'
    }).when('/flightcourse/:courseId/:dutyNo/:dutyDay/:date/:flightId', {
      controller: 'FlightCourseCtrl',
      templateUrl: 'views/Training/flightCourse.html'
    }).when('/groundcourse/:courseId/:dutyId/:date', {
      controller: 'GroundCourseCtrl',
      templateUrl: 'views/Training/groundCourse.html'
    }).when('/safetyreport/cabincrewreport/:flightId', {
      controller: 'SafetyCtrl',
      templateUrl: 'views/Safety/cabinCrewReport.html'
    }).when('/safetyreport/fatiguereport/:flightId', {
      controller: 'FatigueCtrl',
      templateUrl: 'views/Safety/fatigueReport.html'
    }).when('/groundHistory/:courseId/:dutyId/:date/:phaseId', {
      controller: 'ModuleHistoryCtrl',
      templateUrl: 'views/Training/moduleHistory.html'
    }).when('/flightHistory/:courseId/:dutyNo/:dutyDay/:date/:phaseId', {
      controller: 'ModuleHistoryCtrl',
      templateUrl: 'views/Training/moduleHistory.html'
    }).when('/traineecourse/:traineeCourseId/:dutyId/:date', {
      controller: 'TraineeCourseCtrl',
      templateUrl: 'views/TraineeCourse/trainee-course.tpl.html'
    }).when('/mealLibrary', {
      controller: 'PassengerMealsCtrl',
      templateUrl: 'views/PassengerMealsInfo/mealsLibrary.html'
    }).when('/mealLibrary/:flightId/:cabinClass', {
      controller: 'PassengerMealsCtrl',
      templateUrl: 'views/PassengerMealsInfo/mealsLibrary.html'
    }).when('/mealLibrary/:flightId/:mealClass/:searchText', {
      controller: 'PassengerMealsCtrl',
      templateUrl: 'views/PassengerMealsInfo/mealsLibrary.html'
    }).when('/crewExpiries', {
      controller: 'CrewExpiriesCtrl',
      templateUrl: 'views/CrewExpiries/crewExpiries.html'
    }).when('/lottery/:flightId/:lotteryId', {
      controller: 'LotteryCtrl',
      templateUrl: 'views/Lottery/lottery-details.html'
    }).otherwise({
      redirectTo: '/'
    });
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.run(runBlock);
  /* @ngInject */

  function runBlock($rootScope, $timeout, $location, $anchorScroll, UserFactory, UserTokenFactory, $templateCache, SettingsMain, SWUpdateService, CabinReportLocalEditFactory, CrewAssessmentFactory, PaxInfoFactory, LogService, SaCrewAssessmentFactory, ASSFReportFactory) {
    //make sure that each route change validates that the user is still logged in
    var valid = ['/login', '/reset', '/debug', '/ticket'];
    $rootScope.$on('$routeChangeStart', function (event, next, current) {
      if (valid.indexOf($location.$$path) < 0 && !UserFactory.isLoggedIn()) {
        event.preventDefault();
        $location.path('/login');
      } //START - SERVICE WORKERS


      if ('serviceWorker' in navigator) {
        SWUpdateService.initialize();
        navigator.serviceWorker.getRegistration().then(function (registration) {
          $rootScope.SWRegistration = registration;
        });
        SWUpdateService.checkUpdates($rootScope.SWRegistration);
      } //END - SERVICE WORKERS


      $anchorScroll.yOffset = 100;

      if (valid.indexOf($location.$$path) < 0 && (!current || !current.$$route || !next.$$route || current.$$route.controller != next.$$route.controller)) {
        //Check if temp report of any kind exists
        var editingPage = SettingsMain.getEditingPage();
        SettingsMain.setEditingPage(null);

        if (editingPage == 'report') {
          // check if a temp report exists in local storage
          if (CabinReportLocalEditFactory.getCabinReportLocalEditFromTemp() != null) {
            $location.path("report/temp");
          }
        } else if (editingPage == 'assessment') {
          // check if a temp assessment exists in local storage
          if (CrewAssessmentFactory.getTempAssessment() != null) {
            $location.path("assessment/temp");
          }
        } else if (editingPage == 'saAssessment') {
          // check if a temp assessment exists in local storage
          if (SaCrewAssessmentFactory.getTempAssessment() != null) {
            $location.path("saAssessment/temp");
          }
        } else if (editingPage == 'assfReport') {
          // check if a temp assfReport exists in local storage
          if (ASSFReportFactory.getTempAssfReport() != null) {
            $location.path("assfReport/temp");
          }
        } //Method: Clear specific cache on route change


        if (typeof current !== 'undefined') {
          $templateCache.remove(current.templateUrl);
        }
      }
    });
    $rootScope.idbSupported = "indexedDB" in window;
    $rootScope.isOffline = !window.navigator.onLine;
    window.addEventListener('offline', function (e) {
      $timeout($rootScope.isOffline = !window.navigator.onLine);
    });
    window.addEventListener('online', function (e) {
      $timeout($rootScope.isOffline = !window.navigator.onLine);
    });
    $("body").on("click", ".memo-body a", function () {
      var link = $(this).attr("href");

      if (link && link.indexOf("surveymonkey") > 0) {
        LogService.debug(link);
      }
    }); //maintain the user token, outside the localStorage, needed for submitting js errors

    var user = UserFactory.getUser();
    if (user && user.token) UserTokenFactory.setToken(user.token);else UserTokenFactory.setToken('');
  }
})();
"use strict";

(function () {
  // Warning!!! This an auto generated file. Any Changes will be lost. If u want to add or edit go to config.json 
  a3_cabin_reports.constant("liveVersion", true);
  a3_cabin_reports.constant("defaultCalendarDate", null);
  a3_cabin_reports.constant("defaultBucketDate", null);
  a3_cabin_reports.constant("refreshDelaySeconds", 120);
  a3_cabin_reports.constant("mealCriteriaIsEnabled", false);
  a3_cabin_reports.constant("isJumpseatRequestsVisible", true);
  a3_cabin_reports.constant("apiUrl", "https://cabinreportuat.aegeanair.com/api/v1.14");
  a3_cabin_reports.constant("azureADAuth", {
    "clientId": "6dac8675-e0b7-48f3-b8d0-2e12539b8f28",
    "tenantId": "00ab5264-f7ed-4d89-9011-19bf33ed8169",
    "authority": "https://login.microsoftonline.com/aegeancloud.onmicrosoft.com"
  });
  a3_cabin_reports.constant("customerIncidentQuestionIds", [220, 222]);
  a3_cabin_reports.constant("enableFaceMasks", false);
  a3_cabin_reports.constant("ssrCodes", [{
    "code": "AOXY",
    "description": "Airline Supplied Oxygen"
  }, {
    "code": "AVIH",
    "description": "Animal in Hold"
  }, {
    "code": "AVML",
    "description": "Vegetarian Hindu meal"
  }, {
    "code": "BBNL",
    "description": "Baby meal request"
  }, {
    "code": "BIKE",
    "description": "Request for carriage of bicycle"
  }, {
    "code": "BLML",
    "description": "Bland meal request"
  }, {
    "code": "BLND",
    "description": "Blind passenger information"
  }, {
    "code": "CBBG",
    "description": "Bulky cabin baggage request"
  }, {
    "code": "CHLD",
    "description": "Child information"
  }, {
    "code": "CHML",
    "description": "Child Meal Request"
  }, {
    "code": "DBML",
    "description": "Diabetic meal request"
  }, {
    "code": "DEAF",
    "description": "Deaf passenger information"
  }, {
    "code": "DEPA",
    "description": "Accompanied Deportee Information"
  }, {
    "code": "DEPU",
    "description": "Deportee unaccompanied"
  }, {
    "code": "DHCS",
    "description": "Deadhead crew seating"
  }, {
    "code": "DPNA",
    "description": "Disabled passenger needing assistance"
  }, {
    "code": "EMIG",
    "description": "Emigrant"
  }, {
    "code": "ESAN",
    "description": "Passenger with emotional support/psychiatric"
  }, {
    "code": "ESCD",
    "description": "Passenger escorting deportee"
  }, {
    "code": "EXST",
    "description": "Request for extra seat"
  }, {
    "code": "FAMS",
    "description": "Family seating"
  }, {
    "code": "FPML",
    "description": "Fruit platter meal request"
  }, {
    "code": "FRED",
    "description": "Meal and assist request"
  }, {
    "code": "GFML",
    "description": "Gluten intolerant meal request"
  }, {
    "code": "GPST",
    "description": "Group seating request"
  }, {
    "code": "HAJJ",
    "description": "HAJJ Passengers"
  }, {
    "code": "HNML",
    "description": "Hindu meal request"
  }, {
    "code": "INAD",
    "description": "Inadmissable"
  }, {
    "code": "INFT",
    "description": "Infant information"
  }, {
    "code": "KSML",
    "description": "Kosher meal request"
  }, {
    "code": "LCML",
    "description": "Low calorie meal request"
  }, {
    "code": "LFML",
    "description": "Low fat meal request"
  }, {
    "code": "LSML",
    "description": "Low salt meal request"
  }, {
    "code": "MAAS",
    "description": "Meet and assist request"
  }, {
    "code": "MEDA",
    "description": "Medical assistance information"
  }, {
    "code": "MEQT",
    "description": "Medical equipment"
  }, {
    "code": "MOML",
    "description": "Halaal meal request"
  }, {
    "code": "NFML",
    "description": "No fish meal request"
  }, {
    "code": "NLML",
    "description": "Low lactose meal request"
  }, {
    "code": "NOML",
    "description": "Meal on board not required"
  }, {
    "code": "PETC",
    "description": "Pet in cabin request"
  }, {
    "code": "POXY",
    "description": "Passenger own oxygen"
  }, {
    "code": "RVML",
    "description": "Vegetarian raw meal request"
  }, {
    "code": "SEML",
    "description": "Seafood meal request"
  }, {
    "code": "SFML",
    "description": "Seafood meal request"
  }, {
    "code": "SPML",
    "description": "Special meal request"
  }, {
    "code": "SVAN",
    "description": "Passenger with service animal in cabin"
  }, {
    "code": "UMNR",
    "description": "Unaccompanied minor information"
  }, {
    "code": "VGML",
    "description": "Vegetarian vegan meal request"
  }, {
    "code": "VJML",
    "description": "Vegetarian Jain meal request"
  }, {
    "code": "VLML",
    "description": "Vegetarian Lacto-Ovo meal request"
  }, {
    "code": "VOML",
    "description": "Vegetarian Oriental meal request"
  }, {
    "code": "WCBD",
    "description": "Wheelchair Dry-cell battery request"
  }, {
    "code": "WCBW",
    "description": "Wheelchair Wet-cell battery request"
  }, {
    "code": "WCHC",
    "description": "Wheelchair To seat request"
  }, {
    "code": "WCHR",
    "description": "Wheelchair To aircraft door request"
  }, {
    "code": "WCHS",
    "description": "Wheelchair Up/down stairs request"
  }, {
    "code": "WCLB",
    "description": "Wheelchair - Lithium ion Battery"
  }, {
    "code": "WCMP",
    "description": "Wheelchair Manual powered request"
  }, {
    "code": "WCOB",
    "description": "Wheelchair On board request"
  }, {
    "code": "WEAP",
    "description": "WEAP Firearms or ammunition booked & carried as checked"
  }, {
    "code": "XBGS",
    "description": "DCS Excess Baggage Request"
  }, {
    "code": "FAML",
    "description": "BC HB choice A"
  }, {
    "code": "FBML",
    "description": "BC HB choice B"
  }, {
    "code": "BFML",
    "description": "BC HML beef choice"
  }, {
    "code": "CKML",
    "description": "BC HML chicken choice"
  }, {
    "code": "FSML",
    "description": "BC HML fish choice"
  }, {
    "code": "COML",
    "description": "Cold cut platter"
  }, {
    "code": "DEML",
    "description": "Dessert choice"
  }]);
  a3_cabin_reports.constant("bookmarkThreshold", 15);
  a3_cabin_reports.constant("turnArroundTimesAcTypes", ["319", "320", "321", "32Q", "32N", "32X"]);
  a3_cabin_reports.constant("waterUpliftSupportingAcTypes", ["319", "320", "321", "32Q", "32N", "32X"]);
  a3_cabin_reports.constant("enableWaterUpliftReporting", false);
  a3_cabin_reports.constant("operationalPhases", [{
    "key": "3287",
    "value": "On Stand"
  }, {
    "key": "3288",
    "value": "Towing"
  }, {
    "key": "9242",
    "value": "Towing - Stand to Stand"
  }, {
    "key": "9243",
    "value": "Towing - to/from maint"
  }, {
    "key": "3289",
    "value": "Parked"
  }, {
    "key": "3290",
    "value": "Pushback"
  }, {
    "key": "3291",
    "value": "Taxi-out"
  }, {
    "key": "3292",
    "value": "Take-off"
  }, {
    "key": "3293",
    "value": "Initial Climb"
  }, {
    "key": "3294",
    "value": "Climb"
  }, {
    "key": "3295",
    "value": "Cruise"
  }, {
    "key": "3296",
    "value": "Descent"
  }, {
    "key": "3297",
    "value": "Holding"
  }, {
    "key": "3298",
    "value": "Approach"
  }, {
    "key": "3299",
    "value": "Landing"
  }, {
    "key": "3300",
    "value": "Taxi-in"
  }, {
    "key": "3301",
    "value": "Maintenance"
  }, {
    "key": "3302",
    "value": "All"
  }, {
    "key": "3303",
    "value": "In Aircraft"
  }, {
    "key": "3304",
    "value": "In Position at Aircraft"
  }, {
    "key": "3305",
    "value": "In Transit To / From Stand"
  }, {
    "key": "3306",
    "value": "Moving on Stand"
  }, {
    "key": "3307",
    "value": "Positioning to Aircraft"
  }, {
    "key": "3308",
    "value": "Removing from Aircraft"
  }, {
    "key": "3309",
    "value": "Other"
  }, {
    "key": "3310",
    "value": "Hover"
  }, {
    "key": "3311",
    "value": "In Flight"
  }, {
    "key": "3312",
    "value": "Multiple"
  }, {
    "key": "3313",
    "value": "Parked On / By Stand"
  }, {
    "key": "9241",
    "value": "Arrival"
  }, {
    "key": "9244",
    "value": "Arrival - Marshaling"
  }, {
    "key": "9245",
    "value": "Arrival - Guidance"
  }, {
    "key": "9246",
    "value": "Servicing"
  }, {
    "key": "9247",
    "value": "Servicing - De-icing"
  }, {
    "key": "9248",
    "value": "Servicing - Fueling"
  }, {
    "key": "9249",
    "value": "Servicing - Catering"
  }, {
    "key": "9250",
    "value": "Servicing - Lavatory"
  }, {
    "key": "9251",
    "value": "Servicing - Water"
  }, {
    "key": "9252",
    "value": "Servicing - Cleaning"
  }, {
    "key": "9253",
    "value": "Servicing - Line Maint"
  }, {
    "key": "9254",
    "value": "Servicing - Coning"
  }, {
    "key": "9255",
    "value": "Servicing - GPU"
  }, {
    "key": "9256",
    "value": "Servicing - PCA"
  }, {
    "key": "9257",
    "value": "Servicing - Bridging"
  }, {
    "key": "9258",
    "value": "Servicing - Chocking"
  }, {
    "key": "9259",
    "value": "Loading"
  }, {
    "key": "9260",
    "value": "Loading - Passenger"
  }, {
    "key": "9261",
    "value": "Loading - Baggage"
  }, {
    "key": "9262",
    "value": "Loading - Cargo"
  }, {
    "key": "9263",
    "value": "Unloading"
  }, {
    "key": "9264",
    "value": "Unloading - Passenger"
  }, {
    "key": "9265",
    "value": "Unloading - Baggage"
  }, {
    "key": "9266",
    "value": "Unloading - Cargo"
  }]);
})();
"use strict";

(function () {
  // Warning!!! This an auto generated file. Any Changes will be lost. If u want to add or edit go to config.json 
  a3_cabin_reports.constant("version", "appVersion_20260916134420");
})();
"use strict";

(function () {
  'use strict'; //Default Configuration For Charts

  a3_cabin_reports.constant('barOptions', barOptions);
  a3_cabin_reports.constant('pieDoughnutOptions', pieDoughnutOptions);
  var barOptions = {
    ///Boolean - Whether grid lines are shown across the chart
    scaleShowGridLines: true,
    //String - Colour of the grid lines
    scaleGridLineColor: "rgba(0,0,0,.05)",
    //Number - Width of the grid lines
    scaleGridLineWidth: 1,
    //Boolean - Whether to show horizontal lines (except X axis)
    scaleShowHorizontalLines: true,
    //Boolean - Whether to show vertical lines (except Y axis)
    scaleShowVerticalLines: true,
    //Boolean - Whether the line is curved between points
    bezierCurve: true,
    //Number - Tension of the bezier curve between points
    bezierCurveTension: 0.4,
    //Boolean - Whether to show a dot for each point
    pointDot: true,
    //Number - Radius of each point dot in pixels
    pointDotRadius: 4,
    //Number - Pixel width of point dot stroke
    pointDotStrokeWidth: 1,
    //Number - amount extra to add to the radius to cater for hit detection outside the drawn point
    pointHitDetectionRadius: 20,
    //Boolean - Whether to show a stroke for datasets
    datasetStroke: true,
    //Number - Pixel width of dataset stroke
    datasetStrokeWidth: 2,
    //Boolean - Whether to fill the dataset with a colour
    datasetFill: true,
    //String - A legend template
    legendTemplate: "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<datasets.length; i++){%><li><span style=\"background-color:<%=datasets[i].strokeColor%>\"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>"
  };
  var pieDoughnutOptions = {
    //Boolean - Whether we should show a stroke on each segment
    segmentShowStroke: true,
    //String - The colour of each segment stroke
    segmentStrokeColor: "#fff",
    //Number - The width of each segment stroke
    segmentStrokeWidth: 2,
    //Number - The percentage of the chart that we cut out of the middle
    percentageInnerCutout: 50,
    // This is 0 for Pie charts
    //Number - Amount of animation steps
    animationSteps: 100,
    //String - Animation easing effect
    animationEasing: "easeOutBounce",
    //Boolean - Whether we animate the rotation of the Doughnut
    animateRotate: true,
    //Boolean - Whether we animate scaling the Doughnut from the centre
    animateScale: false,
    //String - A legend template
    legendTemplate: "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<segments.length; i++){%><li><span style=\"background-color:<%=segments[i].fillColor%>\"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>",
    onAnimationComplete: function onAnimationComplete() {
      this.showTooltip(this.segments, true);
    },
    tooltipEvents: [],
    showTooltips: true
  };
})();
"use strict";

(function () {
  'use strict';

  angular.module('MyDirectives', [])
  /**
   * HTML5 SignaturePad Directive
   * This directive is intended to place a canvas within a form
   * which can then be drawn upon. Once it is drawn updon, it will be
   * considered 'valid'
   *
   * Thanks to Thomas J Bradley for the Signature Pad plugin for jQuery
   * http://thomasjbradley.ca/lab/signature-pad/
   *
   */
  .directive('sigpad', function ($timeout) {
    return {
      templateUrl: 'views/sigPad.html',
      // Use a template in an external file
      restrict: 'E',
      // Must use <sigpad> element to invoke directive
      scope: true,
      // Create a new scope for the directive
      require: 'ngModel',
      // Require the ngModel controller for the linking function
      link: function link(scope, element, attr, ctrl) {
        // Attach the Signature Pad plugin to the template and keep a reference to the signature pad as 'sigPadAPI'
        var sigPadAPI = $(element).signaturePad({
          drawOnly: true,
          lineColour: '#FFF',
          penWidth: 6
        }); // Clear the canvas when the 'clear' button is clicked

        $(attr.clearbtn).on('click', function (e) {
          sigPadAPI.clearCanvas();
        });
        $(element).find('.pad').on('touchend', function (obj) {
          scope.updateModel();
        }); // when the mouse is lifted from the canvas, set the signature pad data as the model value

        scope.updateModel = function () {
          $timeout(function () {
            var sig = sigPadAPI.getSignature();

            if (sig != null && sig.length == 0) {
              var sig = null;
            }

            ctrl.$setViewValue(sig);
          });
        }; // Render the signature data when the model has data. Otherwise clear the canvas.


        ctrl.$render = function () {
          if (ctrl.$viewValue) {
            sigPadAPI.regenerate(ctrl.$viewValue);
          } else {
            // This occurs when signatureData is set to null in the main controller
            sigPadAPI.clearCanvas();
          }
        }; // Validate signature pad.
        // See http://docs.angularjs.org/guide/forms for more detail on how this works.


        ctrl.$parsers.unshift(function (viewValue) {
          if (sigPadAPI.validateForm()) {
            ctrl.$setValidity('sigpad', true);
            return viewValue;
          } else {
            ctrl.$setValidity('sigpad', false); //undefined to viewValue cause of bug

            return viewValue;
          }
        });
      }
    };
  })
  /**
   * Regenerate Signature Pad data as Base64 encoded PNG data.
   * This uses the getSignatureImage() function of the Signature Pad API.
   * It only works in modern browsers, and is flaky in IE.
   */
  .directive('regensigpad', function () {
    return {
      template: '<img ng-src="{{pic}}" />',
      restrict: 'E',
      scope: {
        sigdata: '@'
      },
      link: function link(scope, element, attr, ctrl) {
        // When the sigdata attribute changes...
        attr.$observe('sigdata', function (val) {
          // ... create a blank canvas template and attach the signature pad plugin
          var sigPadAPI = $('<div class="sig sigWrapper"><canvas class="pad" width="436" height="120"></canvas></div>').signaturePad({
            displayOnly: true
          }); // regenerate the signature onto the canvas

          if (val) {
            sigPadAPI.regenerate(val);
          } else {
            // This occurs when signatureData is set to null in the main controller
            sigPadAPI.clearCanvas();
          } // convert the canvas to a PNG (Newer versions of Chrome, FF, and Safari only.)


          scope.pic = sigPadAPI.getSignatureImage();
        });
      }
    };
  })
  /* Used to capture images from the device's camera
  * and resize them using given dimensions and quality
  * <input type="file" capture="camera" accept="image/*"
  	id="photoAddFile" image="imageBrowsed"
  onfilechange="imageChanged(data)"
  maxwidth="{{width}}" maxheight="{{height}}" quality="{{quality}}"
  imagetype="image/jpeg" >
  */
  .directive('image', function ($q) {
    'use strict';

    var URL = window.URL || window.webkitURL;
    return {
      restrict: 'A',
      scope: {
        /*image: '=',*/
        maxwidth: '@?',
        maxheight: '@?',
        quality: '@?',
        imagetype: '@?',
        onfilechange: '&'
      },
      link: function postLink(scope, element, attrs, ctrl) {
        var onFileChangeCallback = scope.onfilechange;
        var onFileFailureCallback = scope.onfileerror;
        var filename = "";
        var options;

        var getOptions = function getOptions() {
          var options = {
            maxWidth: parseFloat(scope.maxwidth) || 1024,
            maxHeight: parseFloat(scope.maxheight) || 768,
            quality: parseFloat(scope.quality) || 0.8,
            imageType: scope.imagetype || 'image/jpeg',
            canvas: true
          };
          return options;
        };

        var whenError = function whenError(errorMessage) {
          scope.$apply(function () {
            if (typeof onFileFailureCallback == 'function') {
              //to pass data in the message, we need to have an object with attrs named as in
              //the html part, eg  onfilechange="imageChanged(data)"
              onFileFailureCallback({
                err: errorMessage
              });
            }
          });
        };

        var whenReady = function whenReady(img) {
          if (!(img.src || img instanceof HTMLCanvasElement)) {
            whenError('Loading image file failed');
          } else {
            var data = img.src || img.toDataURL(options.imageType, options.quality);
            var imageResult = {
              dataURL: data,
              fileName: filename,
              fileType: options.imageType
            };
            scope.$apply(function () {
              if (typeof onFileChangeCallback == 'function') {
                //to pass data in the message, we need to have an object with attrs named as in
                //the html part, eg  onfilechange="imageChanged(data)"
                onFileChangeCallback({
                  data: imageResult
                });
              }
            });
          }
        };

        element.bind('change', function (evt) {
          evt.preventDefault(); //e = e.originalEvent;

          var target = evt.dataTransfer || evt.target;
          var files = target && target.files;

          if (files) {
            var file;
            options = getOptions(); //read latest settings

            for (var i = 0; i < files.length; i++) {
              file = files[i];
              filename = file.name; //start by get metadata, to autoset the orientation of the image

              loadImage.parseMetaData(file, //when metadata are ready, use them and then load image
              function (data) {
                if (data.exif) {
                  options.orientation = data.exif.get('Orientation');
                }

                if (!loadImage(file, whenReady, options)) {
                  whenError('Your browser does not support capturing images.');
                }
              });
            }
          }
        });
      }
    };
  }).directive('integer', function () {
    return {
      require: 'ngModel',
      link: function link(scope, elm, attrs, ctrl) {
        ctrl.$parsers.unshift(function (viewValue) {
          var INTEGER_REGEXP = /^\-?\d+$/;

          if (INTEGER_REGEXP.test(viewValue)) {
            // it is valid
            ctrl.$setValidity('integer', true);
            return viewValue;
          } else {
            // it is invalid, return undefined (no model update)
            ctrl.$setValidity('integer', false);
            return undefined;
          }
        });
      }
    };
  }).directive('smartFloat', function () {
    return {
      require: 'ngModel',
      link: function link(scope, elm, attrs, ctrl) {
        ctrl.$parsers.unshift(function (viewValue) {
          var FLOAT_REGEXP = /^\-?\d+((\.|\,)\d+)?$/;

          if (FLOAT_REGEXP.test(viewValue)) {
            ctrl.$setValidity('float', true);
            return parseFloat(viewValue.replace(',', '.'));
          } else {
            ctrl.$setValidity('float', false);
            return undefined;
          }
        });
      }
    };
  }).directive('validNumber', function () {
    return function (scope, element, attrs) {
      //        var keyCode = [8,9,37,39, 46,48,49,50,51,52,53,54,55,56,57 ,96,97,98,99,100,101,102,103,104,105,110];
      var keyCode = [8, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 110, 190];
      element.bind("keydown", function (event) {
        if ($.inArray(event.which, keyCode) == -1) {
          scope.$apply(function () {
            scope.$eval(attrs.onlyNum);
            event.preventDefault();
          });
          event.preventDefault();
        }
      });
    };
  }).directive('chart', function () {
    var baseWidth = 600;
    var baseHeight = 400;
    return {
      restrict: 'E',
      template: '<canvas></canvas>',
      scope: {
        chartObject: "=value"
      },
      link: function link(scope, element, attrs) {
        var canvas = element.find('canvas')[0];
        var context = canvas.getContext('2d');
        var chart;
        var options = {
          type: attrs.type || "Line",
          width: attrs.width || baseWidth,
          height: attrs.height || baseHeight
        };
        canvas.width = options.width;
        canvas.height = options.height;
        chart = new Chart(context);

        if (scope.chartObject) {
          scope.$watch(function () {
            return element.attr('type');
          }, function (value) {
            if (!value) return;
            options.type = value;
            var chartType = options.type;
            chart[chartType](scope.chartObject.data, scope.chartObject.options);
          }); //Update when charts data changes

          scope.$watch(function () {
            return scope.chartObject;
          }, function (value) {
            if (!value) return;
            var chartType = options.type;
            chart[chartType](scope.chartObject.data, scope.chartObject.options);
            if (scope.chartInstance) scope.chartInstance.destroy();
            scope.chartInstance = chart[chartType](scope.chartObject.data, scope.chartObject.options);
          }, true);
        }
      }
    };
  }).directive('canvasGauge', function () {
    return {
      restrict: 'E',
      replace: true,
      template: '<canvas></canvas>',
      scope: {
        val: '=value'
      },
      link: function link($scope, element, attrs) {
        var width = parseInt(attrs.width || '100');
        $scope.height = width * 0.55;
        element.attr('height', $scope.height + 'px');
        var placeholder = attrs.placeholder || '(@)';
        var mask = attrs.mask || placeholder;
        var canvas = element[0];
        var animID = 0;
        var curValue = 0;
        var endValue = 0;
        var oldValue = 0;
        var direction = 0;

        var render = function render(val) {
          var value = val || 0;

          if (canvas.getContext) {
            var ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            var calcPercent = function calcPercent(total, perc) {
              return total * perc / 100;
            };

            var per = (value - $scope.min) * 100 / ($scope.max - $scope.min); // Value converted to percentage using min and max

            var pad = calcPercent(canvas.width, 15); // Inner padding around the container

            var x = canvas.width / 2; // x coordinate

            var y = canvas.width / 2.3; // y coordinate

            var startAngle = 0; // Starting point on circle

            var radius = x - pad; // Circle's radius

            var lineWidth = canvas.width / 8; // Thickness of the drawing tip

            var fontSize = canvas.width * 0.1; // Default size of the text font (10% of canvas width)

            ctx.imageSmoothingEnabled = true;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 0;
            ctx.shadowBlur = 0;
            ctx.beginPath();
            ctx.arc(x, y, radius, Math.PI, Math.PI * 2, false);
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = $scope.underColor;
            ctx.stroke();
            ctx.closePath();
            var endAngle = Math.PI * per / 100 + Math.PI;
            ctx.beginPath();
            ctx.arc(x, y, radius, Math.PI, endAngle, false);
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = $scope.overColor;
            ctx.stroke();
            ctx.closePath();
            ctx.font = 'bold ' + fontSize + 'pt Calibri';
            ctx.textAlign = 'center';
            ctx.fillStyle = $scope.textColor;
            ctx.shadowColor = $scope.shadeColors($scope.smallTextColor, -30);
            ctx.shadowOffsetX = 1;
            ctx.shadowOffsetY = 1;
            ctx.shadowBlur = 0;
            ctx.fillText(mask.replace(placeholder, parseFloat(value.toFixed(2)).toString()), x, y);

            if (canvas.width > 119) {
              y = canvas.width / 2.2 + calcPercent(canvas.height, 10) + canvas.width / 100 - 1;
              x = pad;
              ctx.font = 'normal ' + fontSize / 2 + 'pt Calibri';
              ctx.shadowOffsetX = 0;
              ctx.shadowOffsetY = 0;
              ctx.fillStyle = $scope.smallTextColor;
              ctx.fillText($scope.min, x, y);
              y = canvas.width / 2.2 + calcPercent(canvas.height, 10) + canvas.width / 100 - 1;
              x = canvas.width - pad;
              ctx.font = 'normal ' + fontSize / 2 + 'pt Calibri';
              ctx.fillStyle = $scope.smallTextColor;
              ctx.fillText($scope.max, x, y);
            }
          }
        };

        var animate = function animate() {
          var flag = direction == 1 ? curValue <= endValue : curValue >= endValue;

          if (flag == true) {
            render(curValue);
            curValue += direction;
            animID = requestAnimationFrame(animate);
          } else {
            oldValue = endValue;
            render(endValue);
            cancelAnimationFrame(animID);
          }
        };

        $scope.shadeColors = function (color, percent) {
          var f = parseInt(color.slice(1), 16),
              t = percent < 0 ? 0 : 255;
          var p = percent < 0 ? percent * -1 : percent;
          var R = f >> 16;
          var G = f >> 8 & 0x00FF;
          var B = f & 0x0000FF;
          return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
        };

        $scope.$watch('val', function (newval, oldval) {
          $scope.min = attrs.min || 0;
          $scope.max = attrs.max || 100;
          $scope.underColor = attrs.underColor || '#EFEFEF';
          $scope.overColor = attrs.overColor || '#000';
          $scope.textColor = attrs.textColor || $scope.overColor;
          $scope.smallTextColor = attrs.smallTextColor || getComputedStyle(element[0]).getPropertyValue("color");
          curValue = parseFloat(oldValue);
          endValue = parseFloat(newval); //alert(curValue + ' -- ' + endValue);

          direction = endValue < curValue ? -1 : 1;
          animate();
        });
      }
    };
  }).directive('bsHasError', [function () {
    return {
      restrict: "A",
      link: function link(scope, element, attrs, ctrl) {
        var input = element.find('input[ng-model]');

        if (input) {
          scope.$watch(function () {
            return input.hasClass('ng-invalid') && input.hasClass('ng-dirty');
          }, function (isInvalid) {
            element.toggleClass('has-error', isInvalid);
          });
        }
      }
    };
  }]);
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('AirportContactFactory', AirportContactFactory);
  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name AirportContactFactory
  * @description 
  *   Add, Update, Delete and Get Airport Contacts.
  * @ngInject
  */

  function AirportContactFactory(GenericService) {
    /**
    * Initialize the AirportContact
    * @memberof AirportContactFactory
    */
    function Airport() {
      this.Iata = null;
      this.Contacts = null;
    }

    var objType = 'airportContacts';
    var objCallback = Airport;
    var service = {
      fromObjectList: fromObjectList,
      getAirportContactsFromStorage: getAirportContactsFromStorage,
      setAirportContactsToStorage: setAirportContactsToStorage,
      clearAirportContactsFromStorage: clearAirportContactsFromStorage,
      getAirportContacts: getAirportContacts,
      upsertAirportContacts: upsertAirportContacts
    };
    /**
     * Extend an array of Objects from the default airportContact Object
     * @memberof AirportContactFactory
     * @param {Array} objList  an Array Of airportContact
     * @returns {Array} airportContact
     */

    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallback);
    }
    /**
     * Get airportContacts
     * @memberof AirportContactFactory
     * @returns {Array} airportContacts
     */


    function getAirportContactsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Save airportContacts to storage
     * @memberof AirportContactFactory
     * @param {Array} airportContacts A list of AirportContacts
     */


    function setAirportContactsToStorage(airportContacts) {
      GenericService.saveAll(airportContacts, objType, objCallback);
    }
    /**
     * Remove the airportContacts of  the local storage
     * @memberof AirportContactFactory
     */


    function clearAirportContactsFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }
    /**
     * Get the contacts for a given airport
     * @memberof AirportContactFactory
     */


    function getAirportContacts(airportIata) {
      var all = this.getAirportContactsFromStorage();
      if (!all) return null;
      var airport = all.filter(function (item) {
        return item.Iata == airportIata;
      });
      if (!airport || airport.length == 0) return null; //we expect a single airport item per iata

      return airport[0]; //return GenericService.fromObjectList(airport[0].Contacts, Contact);
    }
    /**
     * Upsert airport contacts
     * @memberof AirportContactFactory
     */


    function upsertAirportContacts(airportContacts) {
      var newStations = airportContacts.map(function (x) {
        return x.Iata;
      });
      var contactsLS = this.getAirportContactsFromStorage();
      contactsLS = contactsLS.filter(function (x) {
        return !newStations.includes(x.Iata);
      });
      var updatedContactList = contactsLS.concat(airportContacts);
      setAirportContactsToStorage(updatedContactList);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('AirportHotelFactory', AirportHotelFactory);
  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name AirportHotelFactory
  * @description 
  *   Add, Update, Delete and Get Airport Hotels.
  * @ngInject
  */

  function AirportHotelFactory(GenericService) {
    /**
    * Initialize the AirportHotel
    * @memberof AirportHotelFactory
    */
    function Airport() {
      this.Iata = null;
      this.Hotels = null;
    }

    var objType = 'airportHotels';
    var objCallback = Airport;
    var service = {
      fromObjectList: fromObjectList,
      getAirportHotelsFromStorage: getAirportHotelsFromStorage,
      setAirportHotelsToStorage: setAirportHotelsToStorage,
      clearAirportHotelsFromStorage: clearAirportHotelsFromStorage,
      getAirportHotels: getAirportHotels,
      upsertAirportHotels: upsertAirportHotels
    };
    /**
     * Extend an array of Objects from the default airportHotel Object
     * @memberof AirportHotelFactory
     * @param {Array} objList  an Array Of airportHotel
     * @returns {Array} airportHotel
     */

    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallback);
    }
    /**
     * Get airportHotels
     * @memberof AirportHotelFactory
     * @returns {Array} airportHotels
     */


    function getAirportHotelsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Save airportHotels to storage
     * @memberof AirportHotelFactory
     * @param {Array} airportHotels A list of AirportHotels
     */


    function setAirportHotelsToStorage(airportHotels) {
      GenericService.saveAll(airportHotels, objType, objCallback);
    }
    /**
     * Remove the airportHotels of  the local storage
     * @memberof AirportHotelFactory
     */


    function clearAirportHotelsFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }
    /**
     * Get the Hotels for a given airport
     * @memberof AirportHotelFactory
     */


    function getAirportHotels(airportIata, fltDate) {
      var all = this.getAirportHotelsFromStorage();
      if (!all) return null;
      var airport = all.filter(function (item) {
        return item.Iata == airportIata;
      });
      if (!airport || airport.length == 0) return null; //for each airport hotel
      //from all available hotel priorities, find the one matching the active period 

      angular.forEach(airport[0].Hotels, function (hotel) {
        var fltActiveHotels = hotel.HotelPriorities.filter(function (item) {
          return fltDate >= item.ActiveBegin && fltDate <= item.ActiveEnd;
        });
        if (!fltActiveHotels || fltActiveHotels.length == 0) return; //hotel inactive in FltDate - ActivePriority will be undefined for this hotel

        hotel.ActivePriority = fltActiveHotels[0].PriorityNo; //set the ActivePriority field for the hotel to be displayed in UI
      }); //we expect a single airport item per iata

      return airport[0]; //return GenericService.fromObjectList(airport[0].Hotels, Hotel);
    }
    /**
    *  Upsert aircraft hotels
    * @memberof AirportHotelFactory
    */


    function upsertAirportHotels(airportHotels) {
      var newHotels = airportHotels.map(function (x) {
        return x.Iata;
      });
      var hotelsLS = this.getAirportHotelsFromStorage();
      hotelsLS = hotelsLS.filter(function (x) {
        return !newHotels.includes(x.Iata);
      });
      var updatedHotelsList = hotelsLS.concat(airportHotels);
      setAirportHotelsToStorage(updatedHotelsList);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('AssessmentCtrl', AssessmentCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name AssessmentCtrl
  * @description 
  *   Manages the Cabin Crew Feedback View 
  * @ngInject
  */

  function AssessmentCtrl($scope, $location, CrewAssessmentFactory, $routeParams, SettingsMain, orderByFilter, FlightFactory, $timeout, localStorageMD5Service) {
    var editingPage = SettingsMain.getEditingPage();
    var flightId = $routeParams.flightId;
    var minDate, maxDate, flightRouteString, crewAssessment;
    SettingsMain.setEditingPage("assessment");
    var text = "";

    if (flightId == "temp") {
      crewAssessment = CrewAssessmentFactory.getTempAssessment();
      $scope.flight = FlightFactory.getFlightFromStorage(crewAssessment.FlightId);
      SettingsMain.setEditingPage(null);
    } else {
      $scope.flight = FlightFactory.getFlightFromStorage(flightId);

      if ($scope.flight.assessment) {
        crewAssessment = CrewAssessmentFactory.getCrewAssessmentFromStorage($scope.flight.assessment.Id);
      }
    }

    if (crewAssessment) {
      var flights = orderByFilter(crewAssessment.Flights, orderByDate, false);

      for (var i = 0; i < flights.length; i++) {
        if (i == 0) {
          minDate = flights[i].ScheduledDepartureDateUTC + "T" + flights[i].ScheduledDepartureTimeUTC;
          flightRouteString = flights[i].Departure;
        } else if (i == flights.length - 1) {
          maxDate = flights[i].ScheduledArrival;
          flightRouteString = flightRouteString + "-" + flights[i].Departure + "-" + flights[i].Arrival;
        } else {
          flightRouteString = flightRouteString + "-" + flights[i].Departure;
        }
      }

      var route = {
        Route: crewAssessment.Route,
        DutyDate: crewAssessment.DutyDate,
        MinDate: minDate,
        MaxDate: maxDate,
        FlightRoute: flightRouteString,
        FeedbackDate: crewAssessment.FeedbackDate
      };

      for (var i = 0; i < crewAssessment.assessedBy.length; i++) {
        if (i > 0) {
          var assessed = ', ' + crewAssessment.assesedBy[i].Name;
        } else {
          var assessed = crewAssessment.assessedBy[i].Name;
        }

        text = text.concat(assessed);
      }

      $scope.isFirstOpen = true;
      $scope.assessment = crewAssessment;
      $scope.togglePanel = togglePanel;
      $scope.route = route;
      $scope.assessedBy = text;
    }

    $scope.clearRemarks = clearRemarks;
    $scope.avgValue = avgValue;
    $scope.updateValues = updateValues;
    $scope.IsCompleted = IsCompleted;
    $scope.IsSynched = IsSynched;
    $scope.assessments_not_completed = CrewAssessmentFactory.getCountOfUncompletedAssessments();
    $scope.saveClicked = saveClicked;
    $scope.saveDraftClicked = saveDraftClicked;
    $scope.assesmentCSSClass = assesmentCSSClass;
    $scope.assesmentIconClass = assesmentIconClass;
    $scope.isPanelOpen = true;
    $scope.discard = discard;
    $scope.infosaveaction = false; // kzan:: test reasons

    $scope.feedbackDate = $scope.flight.ScheduledDepartureDateUTC;
    $scope.hasCommonFlightWithFA = hasCommonFlightWithFA;
    $scope.showFlightsForCrewMember = showFlightsForCrewMember;
    $scope.filteredByFeedbackDate = filteredByFeedbackDate;
    /**
     * Display a  successful save message according to the save status 
     * @memberof AssessmentCtrl
     * @param {string} state  the state of the selected Cabin Crew Feedback
     */

    function infoSaveOperation(state) {
      if (state == 'Completed') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      } else if (state == 'Draft') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      } else if (state == 'discard') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      }

      $timeout(function () {
        $scope.infosaveaction = false;
      }, 5000);
    }
    /**
     * Convers date string to JS object
     * @memberof AssessmentCtrl
     * @param {string} ScheduledArrival The string date of ScheduledArrival 
     * @returns {Object} ScheduledArrival
     */


    function orderByDate(item) {
      var date = new Date(item.ScheduledArrival);
      return date;
    }
    /**
     * Clear Remarks
     * @memberof AssessmentCtrl
     * @param {string} item The Crew assessment Template question item 
     */


    function clearRemarks(item) {
      // put preset comments
      if (item != null && item.ItemDescr) {
        item.ItemDescr = null;
      }

      if (item != null && item.Review) {
        item.Review = null;
      }
    }
    /**
     * Returns the avarage score of the questions.
     * @memberof AssessmentCtrl
     * @param {array} items The Crew assessment Template question items 
     * @returns {number} retval
     */


    function avgValue(items) {
      var sum = 0;

      if (!items || items.length == 0) {
        return sum;
      }

      for (var i = 0; i < items.length; i++) {
        if (items[i]) {
          sum = sum + parseInt(items[i].ItemValue);
        }
      }

      var retval = sum / items.length ? (sum / items.length).toFixed(1) : '-';
      return retval;
    }
    /**
     * Updates the value for the selected crewmember for this Cabin Crew Feedback and update the temporary Cabin Crew Feedback
     * @memberof AssessmentCtrl 
     * @param {object} crewMember The Crew member
     * @param {object} assessment The Crew assessment 
     */


    function updateValues(crewMember, assessment) {
      // Check if review exists
      var hasReview = crewMember.Review != null && crewMember.Review.trim().length > 0; // Check if all critical ratings have comments

      var hasCriticalRatingsWithoutComments = false;

      if (crewMember.assessmentItems) {
        for (var i = 0; i < crewMember.assessmentItems.length; i++) {
          var item = crewMember.assessmentItems[i];

          if ((item.ItemValue === '1' || item.ItemValue === '5') && (!item.ItemDescr || item.ItemDescr.toString().trim().length === 0)) {
            hasCriticalRatingsWithoutComments = true;
            break;
          }
        }
      } // Member is completed only if has review AND no critical ratings without comments


      crewMember.IsCompleted = hasReview && !hasCriticalRatingsWithoutComments;
      CrewAssessmentFactory.saveTempAssessment(assessment, $scope.flight.FlightId);
    }

    $scope.hasInvalidCriticalRatings = hasInvalidCriticalRatings;
    /**
     * Evaluate if this Cabin Crew Feedback is valid and ready to send
     * @memberof AssessmentCtrl 
     * @param {object} assessment The Crew assessment 
     * @returns {boolean} isCompleted
     */
    // function IsCompleted(crewAssessment) {
    //     var isCompleted = true;
    //     for (var j = 0; j < crewAssessment.CrewAssessmentMembers.length; j++) {
    //         if (!(crewAssessment.CrewAssessmentMembers[j].Review != null && crewAssessment.CrewAssessmentMembers[j].Review.trim().length > 0)) {
    //             if (!crewAssessment.CrewAssessmentMembers[j].IsExist && (crewAssessment.CrewAssessmentMembers[j].IsValid || crewAssessment.CrewAssessmentMembers[j].IsOverride)) {
    //                 isCompleted = false;
    //             }
    //         }
    //     }
    //     return isCompleted;
    // }

    function IsCompleted(crewAssessment) {
      var isCompleted = true;

      if (!crewAssessment || !Array.isArray(crewAssessment.CrewAssessmentMembers)) {
        return false;
      }

      for (var j = 0; j < crewAssessment.CrewAssessmentMembers.length; j++) {
        var member = crewAssessment.CrewAssessmentMembers[j]; // Skip if member doesn't exist or is not applicable

        if (member.IsExist || !member.IsValid && !member.IsOverride) {
          continue;
        } // Check if review is required and missing


        if (!(member.Review != null && member.Review.trim().length > 0)) {
          isCompleted = false;
        } // Check if any assessment item has critical rating (1 or 5) without comment


        if (member.assessmentItems) {
          for (var i = 0; i < member.assessmentItems.length; i++) {
            var item = member.assessmentItems[i];

            if ((item.ItemValue === '1' || item.ItemValue === '5') && (!item.ItemDescr || item.ItemDescr.toString().trim().length === 0)) {
              isCompleted = false;
            }
          }
        }
      }

      return isCompleted;
    }

    function hasInvalidCriticalRatings(crewAssessment) {
      for (var j = 0; j < crewAssessment.CrewAssessmentMembers.length; j++) {
        var member = crewAssessment.CrewAssessmentMembers[j]; // Skip if member doesn't exist or is not applicable

        if (member.IsExist || !member.IsValid && !member.IsOverride) {
          continue;
        }

        if (member.assessmentItems) {
          for (var i = 0; i < member.assessmentItems.length; i++) {
            var item = member.assessmentItems[i];

            if ((item.ItemValue === '1' || item.ItemValue === '5') && (!item.ItemDescr || item.ItemDescr.toString().trim().length === 0)) {
              return true;
            }
          }
        }
      }

      return false;
    }
    /**
     * Evaluate if this Cabin Crew Feedback is synched
     * @memberof AssessmentCtrl 
     * @param {object} assessment The Crew assessment 
     * @returns {boolean} IsSynched
     */


    function IsSynched() {
      var IsSynched = false;

      if (crewAssessment && crewAssessment.Status == "Stored") {
        IsSynched = true;
      }

      return IsSynched;
    }
    /**
     * Save the Cabin Crew Feedback
     * @memberof AssessmentCtrl 
     * @param {object} assessment The Cabin Crew Feedback
     */


    function saveAssessment(assessment) {
      CrewAssessmentFactory.setCrewAssessmentToStorage(assessment);
      CrewAssessmentFactory.updateFlightsAssessment(assessment);
    }
    /**
     * Save the Cabin Crew Feedback As Completed
     * @memberof AssessmentCtrl 
     * @param {object} assessment The Cabin Crew Feedback
     */


    function saveClicked(assessment) {
      assessment.Status = 'Completed';
      saveAssessment(assessment);
      infoSaveOperation(assessment.Status);
      SettingsMain.setEditingPage(null);
      CrewAssessmentFactory.clearTempAssessment();
      $location.path('/flightinfo/' + $scope.flight.FlightId);
    }
    /**
     * Discard all the changes on the cabin crew feedback that are not saved
     * @memberof AssessmentCtrl 
     */


    function discard() {
      SettingsMain.setEditingPage(null);
      $scope.assessment = CrewAssessmentFactory.getCrewAssessmentFromStorage($scope.flight.assessment.Id);
      infoSaveOperation('discard');
    }
    /**
     * Save the Cabin Crew Feedback As Draft
     * @memberof AssessmentCtrl 
     * @param {object} assessment The Cabin Crew Feedback
     */


    function saveDraftClicked(assessment) {
      assessment.Status = 'Draft';
      saveAssessment(assessment);
      infoSaveOperation(assessment.Status);
      SettingsMain.setEditingPage(null);
      CrewAssessmentFactory.clearTempAssessment();
    }
    /**
     * Open and close the selected Panel
     * @memberof AssessmentCtrl 
     * @param {number} panelId The panel's Id
     */


    function togglePanel(panelId) {
      $('#' + panelId).toggle();
      if (panelId == "info-panel") $scope.isPanelOpen = !$scope.isPanelOpen;
    }
    /**
     * The css class for the selected crew member
     * @memberof AssessmentCtrl 
     * @param {Object} crewMember The assessed crew member
     * @returns {string} cssClass
     */
    // function assesmentCSSClass(crewMember) {
    //     if (!crewMember.IsExist && crewMember.IsCompleted && (crewMember.IsValid || crewMember.IsOverride)) {
    //         return 'panel-blue';
    //     } else if (!crewMember.IsExist && !crewMember.IsCompleted && (crewMember.IsValid || crewMember.IsOverride)) {
    //         return 'panel-orange';
    //     } else if (!crewMember.IsExist && !crewMember.IsValid && !crewMember.IsOverride) {
    //         return 'panel-default';
    //     } else if (crewMember.IsExist) {
    //         return 'panel-green';
    //     }
    // }


    function assesmentCSSClass(crewMember) {
      if (crewMember.IsExist) {
        return 'panel-green';
      }

      if (!crewMember.IsValid && !crewMember.IsOverride) {
        return 'panel-default';
      } // Check if has critical ratings without comments


      var hasCriticalWithoutComments = false;

      if (crewMember.assessmentItems) {
        for (var i = 0; i < crewMember.assessmentItems.length; i++) {
          var item = crewMember.assessmentItems[i];

          if ((item.ItemValue === '1' || item.ItemValue === '5') && (!item.ItemDescr || item.ItemDescr.toString().trim().length === 0)) {
            hasCriticalWithoutComments = true;
            break;
          }
        }
      } // If has critical ratings without comments, always show orange (incomplete)


      if (hasCriticalWithoutComments) {
        return 'panel-orange';
      } // Otherwise, check normal completion status


      if (crewMember.IsCompleted) {
        return 'panel-blue';
      } else {
        return 'panel-orange';
      }
    }
    /**
    * The icon for the selected crew member
    * @memberof AssessmentCtrl 
    * @param {Object} crewMember The assessed crew member
    * @returns {string} iconClass
    */


    function assesmentIconClass(crewMember) {
      if (!crewMember.IsExist && crewMember.IsCompleted && (crewMember.IsValid || crewMember.IsOverride)) {
        return 'fa fa-check';
      } else if (!crewMember.IsExist && !crewMember.IsCompleted && (crewMember.IsValid || crewMember.IsOverride)) {
        return 'fa fa-pencil';
      } else if (!crewMember.IsExist && !crewMember.IsValid && !crewMember.IsOverride) {
        return 'fa fa-times';
      } else if (crewMember.IsExist) {
        return 'fa fa-floppy-o';
      }
    } // Helper function to format date consistently


    function formatDateToString(date) {
      if (!date) return null;
      var d = new Date(date);
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }

    function filteredByFeedbackDate(flight) {
      // Format both dates to yyyy-MM-dd 
      var flightDate = formatDateToString(flight.ScheduledDepartureDateUTC);
      var feedbackDate = formatDateToString($scope.feedbackDate);
      return flightDate === feedbackDate;
    }

    ;

    function showFlightsForCrewMember(crewMember) {
      if (!crewMember || !crewMember.aimsId) {
        crewMember.filteredFlights = [];
        return;
      }

      var result = []; // Format feedback date 

      var feedbackDateFormatted = formatDateToString($scope.feedbackDate);
      var commonFlightsWithFA = localStorageMD5Service.get('CommonFlightsWithFA') || []; // Loop through all common flights with Flight Attendants (FA)

      (commonFlightsWithFA || []).forEach(function (cf) {
        // Check if the current SA matches the given crew member
        if (cf.FaAimsId === crewMember.aimsId) {
          // Loop through all flights for this FA
          (cf.Flights || []).forEach(function (f) {
            var flightDateFormatted = formatDateToString(f.ScheduledDepartureDateUTC || f.FlightDate); // If the flight date matches the feedback date, include it

            if (flightDateFormatted === feedbackDateFormatted) {
              result.push(f);
            }
          });
        }
      }); // Save the filtered flights into the crew member object

      crewMember.filteredFlights = result;
    }

    ; // Checks if there is at least one common flight with this crew member

    function hasCommonFlightWithFA(crewMember) {
      // If filteredFlights hasn't been calculated yet, calculate it now
      if (!crewMember.filteredFlights) {
        $scope.showFlightsForCrewMember(crewMember);
      }

      return crewMember.filteredFlights && crewMember.filteredFlights.length > 0;
    }

    ;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('AssessmentSyncResultFactory', AssessmentSyncResultFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name AssessmentSyncResultFactory
  * @description 
  *   Add, Update, Delete and Get Cabin Crew Feedback Sync Results.
  * @ngInject
  */

  function AssessmentSyncResultFactory(GenericService) {
    /**
    * Initialize the CrewAssessment
    * @memberof AssessmentSyncResultFactory
    */
    function AssessmentSyncResult() {
      this.Route = null;
      this.DutyDate = null;
      this.message = null;
      this.success = null;
    }

    var objType = 'assessmentSyncResults';
    var objCallback = AssessmentSyncResult;
    var service = {
      getAssessmentSyncResultsFromStorage: getAssessmentSyncResultsFromStorage,
      setAssessmentSyncResultsToStorage: setAssessmentSyncResultsToStorage,
      getSuccesses: getSuccesses,
      getFailures: getFailures
    };
    /**
    * Get Assessment Sync Results
    * @memberof AssessmentSyncResultFactory
    * @returns {Array} AssessmentSyncResults 
    */

    function getAssessmentSyncResultsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Save Assessment Sync Results in Local Storage
     * @memberof AssessmentSyncResultFactory
     * @param {Array} AssessmentSyncResults A list of Assessment Sync Results
     */


    function setAssessmentSyncResultsToStorage(assessmentSyncResults) {
      GenericService.saveAll(assessmentSyncResults, objType, objCallback);
    }
    /**
    * Get Successfull Assessment Sync Results from Local Storage
    * @memberof AssessmentSyncResultFactory
    * @param {Array} AssessmentSyncResults A list of Assessment Sync Results
    * @returns {Array} AssessmentSyncResults 
    */


    function getSuccesses(syncResults) {
      var result = 0;

      if (!syncResults) {
        return result;
      }

      for (var i = 0; i < syncResults.length; i++) {
        if (syncResults[i].success == true) {
          result = result + 1;
        }
      }

      return result;
    }
    /**
    * Get Failed Assessment Sync Results from Local Storage
    * @memberof AssessmentSyncResultFactory
    * @param {Array} AssessmentSyncResults A list of Assessment Sync Results
    * @returns {Array} AssessmentSyncResults 
    */


    function getFailures(syncResults) {
      var result = 0;

      if (!syncResults) {
        return result;
      }

      for (var i = 0; i < syncResults.length; i++) {
        if (syncResults[i].success == false) {
          result = result + 1;
        }
      }

      return result;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CrewAssessmentFactory', CrewAssessmentFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CrewAssessmentFactory
  * @description 
  *   Add, Update, Delete and Get Cabin Crew Feedback.
  * @ngInject
  */

  function CrewAssessmentFactory(localStorageMD5Service, CrewAssessmentMemberFactory, FlightFactory, CrewAssessmentTemplateFactory, CabinReportLocalEditFactory, GenericService, UserFactory, defaultCalendarDate) {
    /**
    * Initialize the CrewAssessment
    * @memberof CrewAssessmentFactory
    */
    function CrewAssessment() {
      this.Id = null;
      this.UserId = null;
      this.Route = null;
      this.DutyDate = null;
      this.DutyDay = null;
      this.AcType = null;
      this.Status = 'Pending';
      this.IsExist = false;
      this.assessedBy = [];
      this.CrewAssessmentMembers = [];
      this.Flights = [];
      this.GetId = GetId;
      this.start = null;
      this.end = null;
      this.FeedbackDate = null;
    }

    var objType = 'crewAssessments';
    var objCallback = CrewAssessment;
    var service = {
      getCrewAssessmentsFromStorage: getCrewAssessmentsFromStorage,
      setCrewAssessmentsToStorage: setCrewAssessmentsToStorage,
      setCrewAssessmentToStorage: setCrewAssessmentToStorage,
      getCrewAssessmentFromStorage: getCrewAssessmentFromStorage,
      getCountOfUncompletedAssessments: getCountOfUncompletedAssessments,
      getCrewAssessmentByRouteAndDay: getCrewAssessmentByRouteAndDay,
      getCrewAssessmentByDutyNoAndDay: getCrewAssessmentByDutyNoAndDay,
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      getNewCrewAssessment: getNewCrewAssessment,
      getTempAssessment: getTempAssessment,
      saveTempAssessment: saveTempAssessment,
      clearTempAssessment: clearTempAssessment,
      updateCrewMembers: updateCrewMembers,
      updateCrewAssessment: updateCrewAssessment,
      getAssesedCabinReports: getAssesedCabinReports,
      existsForRouteDutyDate: existsForRouteDutyDate,
      getAssementsReadyToSend: getAssementsReadyToSend,
      storeFlightsWithAssessments: storeFlightsWithAssessments,
      updateFlightsAssessment: updateFlightsAssessment,
      updateAssessmentFlights: updateAssessmentFlights,
      updateAndMergeAllFaAssessments: updateAndMergeAllFaAssessments,
      getFaMembersForFeedback: getFaMembersForFeedback,
      hasSyncedFeedbacks: hasSyncedFeedbacks
    }; //object functions

    /**
     * Overide default get Id
     * @memberof CrewAssessmentFactory
     * @returns {number} Id 
     */

    function GetId() {
      return this.Id;
    } //factory functions

    /**
    * Get Crew Assessments
    * @memberof CrewAssessmentFactory
    * @returns {Array} crewAssesments 
    */


    function getCrewAssessmentsFromStorage() {
      var lsItems = GenericService.list(objType, objCallback);
      var items = [];

      for (var i = 0; i < lsItems.length; i++) {
        if (lsItems[i]) {
          items.push(lsItems[i]);
        }
      }

      return items;
    }
    /**
     * Save Crew Assessments to storage
     * @memberof CrewAssessmentFactory
     * @param {Array} crewAssessments A list of Cabin Crew Feedbacks
     */


    function setCrewAssessmentsToStorage(crewAssessments) {
      GenericService.saveAll(crewAssessments, objType, objCallback);
    }
    /**
     * Save one Crew Assessment to storage
     * @memberof CrewAssessmentFactory
     * @param {Object} crewAssessment A Cabin Crew Feedback
     */


    function setCrewAssessmentToStorage(crewAssessment) {
      GenericService.save(crewAssessment, objType, objCallback);
    }
    /**
     * Get a Crew Assessment from storage
     * @memberof CrewAssessmentFactory
     * @param {number} crewAssessmentId  the Id of the selected Crew Assessment
     * @returns {Object} crewAssesment
     */


    function getCrewAssessmentFromStorage(crewAssessmentId) {
      return GenericService.get(crewAssessmentId, objType, objCallback);
    }
    /**
     * Get Count of Uncompleted Assessments 
     * @memberof CrewAssessmentFactory
     * @returns {number} count
     */


    function getCountOfUncompletedAssessments() {
      var crewAssessments = getCrewAssessmentsFromStorage();
      var count = 0;
      if (crewAssessments == null) return 0;

      for (var i = 0; i < crewAssessments.length; i++) {
        if (!crewAssessments[i].IsExist && crewAssessments[i].Status != "Completed") {
          count++;
        }
      }

      return count;
    }

    ;
    /**
     * Extend Object from the default CrewAssessment Object
     * @memberof CrewAssessmentFactory
     * @param {Object} obj  a crewAssesment
     * @returns {Object} crewAssesment
     */

    function fromObject(obj) {
      return GenericService.fromObject(obj, objCallback);
    }
    /**
     * Extend an array of Objects from the default CrewAssessment Object
     * @memberof CrewAssessmentFactory
     * @param {Array} objList  an Array Of crewAssesments
     * @returns {Array} crewAssesments
     */


    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallback);
    }
    /**
     * Initialize a new Crew Assessment from the default Constructor
     * @memberof CrewAssessmentFactory
     * @returns {Object} crewAssesment
     */


    function getNewCrewAssessment() {
      return GenericService.constructor(objCallback);
    }

    ;
    /**
     * Get the Temporary Assessment from the local storage
     * @memberof CrewAssessmentFactory
     * @returns {Object} crewAssesment
     */

    function getTempAssessment() {
      var crewAssessmentLocalEdit = localStorageMD5Service.get('crewAssessmentLocalEdit_TEMP');
      return fromObject(crewAssessmentLocalEdit);
    }

    ;
    /**
     * Save the Temporary Assessment to  the local storage
     * @memberof CrewAssessmentFactory
     * @param {Object} assessment  a crewAssesment
     * @param {number} FlightId  a crewAssesment
     */

    function saveTempAssessment(assessment, FlightId) {
      if (assessment) {
        assessment.FlightId = FlightId;
        localStorageMD5Service.remove('crewAssessmentLocalEdit_TEMP');
        localStorageMD5Service.set('crewAssessmentLocalEdit_TEMP', assessment);
      }
    }

    ;
    /**
     * Remove the Temporary Assessment of  the local storage
     * @memberof CrewAssessmentFactory
     */

    function clearTempAssessment() {
      localStorageMD5Service.remove('crewAssessmentLocalEdit_TEMP');
    }

    ;
    /**
     * Update and merge all FA assessments
     * @memberof CrewAssessmentFactory
     * @param {Array} assessments  an array of crew assessments
     */

    function updateAndMergeAllFaAssessments(newFaAssessments) {
      var oldFaAssessments = getCrewAssessmentsFromStorage() || [];
      newFaAssessments = newFaAssessments || [];
      var finalFaAssessments = [];
      var assessmentsToCreate = []; // group old by Route+DutyDate

      var oldGroups = {};
      oldFaAssessments.forEach(function (item) {
        var key = item.Route + "|" + item.DutyDate;
        if (!oldGroups[key]) oldGroups[key] = [];
        oldGroups[key].push(item);
      }); // group new by Route+DutyDate

      var newGroups = {};
      newFaAssessments.forEach(function (item) {
        var key = item.Route + "|" + item.DutyDate;
        if (!newGroups[key]) newGroups[key] = [];
        newGroups[key].push(item);
      }); // process each new group

      for (var key in newGroups) {
        var newGroup = newGroups[key];
        var oldGroup = oldGroups[key] || [];

        if (newGroup.length === oldGroup.length && newGroup.length > 0) {
          // counts equal → update one by one, matched by FeedbackDate
          newGroup.forEach(function (n) {
            // find matching old by FeedbackDate 
            var match = oldGroup.find(function (o) {
              return o.FeedbackDate === n.FeedbackDate;
            } //|| (!o.FeedbackDate && !n.FeedbackDate) //(null/undefined allowed to match empty)
            );

            if (match) {
              var updated = updateCrewAssessment(match, n);
              finalFaAssessments.push(updated);
            } else {
              // no match → treat as new
              assessmentsToCreate.push(n);
            }
          });
        } else {
          // counts differ → ignore olds, just create all news
          assessmentsToCreate = assessmentsToCreate.concat(newGroup);
        }
      } // create new assessments


      var created = createCrewAssessments(assessmentsToCreate);
      finalFaAssessments = finalFaAssessments.concat(created); // replace storage with only updated + created

      setCrewAssessmentsToStorage(finalFaAssessments);
      storeFlightsWithAssessments();
    }
    /**
     * Update CrewMembers of the assessment based on CCMSPositions
     * @memberof CrewAssessmentFactory
     * @param {string} CCMSPositions  the ccms Position of the Flight
     * @param {string} Route  The route of the assessment
     * @param {string} DutyDate  The duty date of the assessment
     */


    function updateCrewMembers(CCMSPositions, Route, DutyDate, flightDate) {
      var assessment = getCrewAssessmentByRouteAndDay(Route, DutyDate, flightDate);
      var crewAssessmentTemplate = CrewAssessmentTemplateFactory.getCrewAssessmentTemplateFromStorage();
      var routeFlights = FlightFactory.getFlightsByRoutePerDay(Route, DutyDate, flightDate);
      var isChanged = false;

      if (CCMSPositions != null && assessment != null) {
        for (var i = 0; i < CCMSPositions.length; i++) {
          var isExists = false;

          for (var j = 0; j < assessment.CrewAssessmentMembers.length; j++) {
            if (CCMSPositions[i].CrewId == assessment.CrewAssessmentMembers[j].aimsId) {
              isExists = true;

              if (CCMSPositions[i].CCMS == "N/A") {
                var isValid = false;

                for (var h = 0; h < routeFlights.length; h++) {
                  var localReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(routeFlights[h].FlightId);

                  if (localReport != null) {
                    for (var e = 0; e < localReport.CCMSCrewPositions.length; e++) {
                      if (CCMSPositions[i].CrewId == localReport.CCMSCrewPositions[e].CrewId && localReport.CCMSCrewPositions[e].CCMS != "N/A") {
                        isValid = true;
                        break;
                      }
                    }
                  }

                  if (isValid) {
                    break;
                  }
                }

                if (assessment.CrewAssessmentMembers[j].IsValid != isValid) {
                  isChanged = true;
                }

                assessment.CrewAssessmentMembers[j].IsValid = isValid;
              } else {
                if (!assessment.CrewAssessmentMembers[j].IsValid) {
                  isChanged = true;
                }

                assessment.CrewAssessmentMembers[j].IsValid = true;
              }
            }
          }

          if (!isExists && CCMSPositions[i].IsManual) {
            var crewMember = CrewAssessmentMemberFactory.newMember();
            crewMember.aimsId = CCMSPositions[i].CrewId;
            crewMember.assessmentItems = crewAssessmentTemplate;
            crewMember.name = CCMSPositions[i].Name;
            crewMember.position = CCMSPositions[i].Position;
            crewMember.shortname = CCMSPositions[i].Initials;
            crewMember.IsManual = true;
            crewMember.IsCompleted = false;
            crewMember.IsValid = CCMSPositions[i].CCMS != "N/A";
            isChanged = true;
            assessment.CrewAssessmentMembers.push(crewMember);
          }
        }

        for (var i = 0; i < assessment.CrewAssessmentMembers.length; i++) {
          for (var h = 0; h < routeFlights.length; h++) {
            var localReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(routeFlights[h].FlightId);

            if (localReport != null) {
              isExists = false;

              for (var j = 0; j < localReport.CCMSCrewPositions.length; j++) {
                if (localReport.CCMSCrewPositions[j].CrewId == assessment.CrewAssessmentMembers[i].aimsId) {
                  isExists = true;
                  break;
                }
              }
            }
          }

          if (!isExists) {
            if (assessment.CrewAssessmentMembers[i].IsValid) {
              isChanged = true;
            }

            assessment.CrewAssessmentMembers[i].IsValid = false;
          }
        }

        if (isChanged && assessment.Status != "Pending") {
          assessment.Status = "Draft";
          var flights = FlightFactory.getFlightsFromStorage();

          for (var i = 0; i < flights.length; i++) {
            if (flights[i].assessment && flights[i].assessment.Id == assessment.Id) {
              flights[i].assessment.Status = assessment.Status;
            }
          }

          FlightFactory.setFlightsToStorage(flights);
        }

        setCrewAssessmentToStorage(assessment);
      }
    }
    /**
     * Update Assessment from the new Assessment from Sync
     * @memberof CrewAssessmentFactory
     * @param {Object} assessment  The assessment
     * @param {Object} newAssessment  The new assessment
     */


    function updateCrewAssessment(assessment, newAssessment) {
      var crewAssessmentTemplate = CrewAssessmentTemplateFactory.getCrewAssessmentTemplateFromStorage();
      if (crewAssessmentTemplate == null) return assessment; // Load the flight

      var flights = FlightFactory.getFlightsByRoutePerDay(assessment.Route, assessment.DutyDate, newAssessment.FeedbackDate);
      if (flights == null) return assessment;
      assessment.Flights = [];
      assessment.AcType = flights[0].AcType;
      assessment = updateAssessmentFlights(assessment, flights);
      assessment.FeedbackDate = newAssessment.FeedbackDate;
      var isUpdated = false; // Flags to check member states

      var validCrewCount = 0; // Non-outdated and exists

      var outdatedCrewCount = 0; // Outdated

      var nonExistentCrewCount = 0; // Non-outdated but doesn't exist
      //filter by feedback date

      newAssessment.assessmentCrew = crewAssessmentFilteredByFeedbackDate(newAssessment); //filter by common flights in the route

      var flightIds = flights.map(function (f) {
        return f.FlightId;
      });
      newAssessment.assessmentCrew = filterCrewAssessmentMembersByCommonFlightsInRoute(newAssessment.assessmentCrew, flightIds);

      for (var i = 0; i < newAssessment.assessmentCrew.length; i++) {
        var isCreated = false; // Update flags based on crew member status

        if (newAssessment.assessmentCrew[i].IsOutdated && !newAssessment.assessmentCrew[i].IsExist) {
          outdatedCrewCount++;
        } else if (!newAssessment.assessmentCrew[i].IsExist) {
          nonExistentCrewCount++;
        } else {
          validCrewCount++;
        }

        for (var l = 0; l < assessment.CrewAssessmentMembers.length; l++) {
          if (newAssessment.assessmentCrew[i].CrewAimsId == assessment.CrewAssessmentMembers[l].aimsId || newAssessment.assessmentCrew[i].CrewId == assessment.CrewAssessmentMembers[l].Id) {
            assessment.CrewAssessmentMembers[l].aimsId = newAssessment.assessmentCrew[i].CrewAimsId;
            assessment.CrewAssessmentMembers[l].id = newAssessment.assessmentCrew[i].CrewId;
            assessment.CrewAssessmentMembers[l].name = newAssessment.assessmentCrew[i].Name;
            assessment.CrewAssessmentMembers[l].IsValid = true;
            assessment.CrewAssessmentMembers[l].IsOutdated = newAssessment.assessmentCrew[i].IsOutdated;
            assessment.CrewAssessmentMembers[l].EndPeriod = newAssessment.assessmentCrew[i].EndPeriod;
            var newAssessmentItems = [];

            for (var j = 0; j < crewAssessmentTemplate.length; j++) {
              var question = {
                Id: crewAssessmentTemplate[j].Id,
                Description: crewAssessmentTemplate[j].Description,
                Label: crewAssessmentTemplate[j].Label,
                OrderNo: crewAssessmentTemplate[j].OrderNo,
                ItemValue: crewAssessmentTemplate[j].ItemValue,
                ItemDescr: null
              };

              if (assessment.CrewAssessmentMembers[l].assessmentItems) {
                for (var h = 0; h < assessment.CrewAssessmentMembers[l].assessmentItems.length; h++) {
                  if (crewAssessmentTemplate[j].Id == assessment.CrewAssessmentMembers[l].assessmentItems[h].Id) {
                    question.ItemValue = assessment.CrewAssessmentMembers[l].assessmentItems[h].ItemValue;
                    question.ItemDescr = assessment.CrewAssessmentMembers[l].assessmentItems[h].ItemDescr;
                  }
                }
              }

              newAssessmentItems.push(question);
            }

            assessment.CrewAssessmentMembers[l].assessmentItems = newAssessmentItems;

            if (assessment.CrewAssessmentMembers[l].IsExist != newAssessment.assessmentCrew[i].IsExist) {
              assessment.CrewAssessmentMembers[l].IsExist = newAssessment.assessmentCrew[i].IsExist;
              isUpdated = true;
            }

            isCreated = true;
            break;
          }
        }

        if (!isCreated) {
          var crewMember = CrewAssessmentMemberFactory.newMember();
          crewMember.aimsId = newAssessment.assessmentCrew[i].CrewAimsId;
          crewMember.id = newAssessment.assessmentCrew[i].CrewId;
          crewMember.assessmentItems = crewAssessmentTemplate;
          crewMember.name = newAssessment.assessmentCrew[i].Name;
          crewMember.IsCompleted = false;
          crewMember.IsValid = true;
          crewMember.IsExist = newAssessment.assessmentCrew[i].IsExist;
          crewMember.IsOutdated = newAssessment.assessmentCrew[i].IsOutdated;
          crewMember.EndPeriod = newAssessment.assessmentCrew[i].EndPeriod;
          assessment.CrewAssessmentMembers.push(crewMember);
          isUpdated = true;
        }
      }

      for (var l = 0; l < assessment.CrewAssessmentMembers.length; l++) {
        var isExists = false;

        for (var i = 0; i < newAssessment.assessmentCrew.length; i++) {
          if (newAssessment.assessmentCrew[i].CrewAimsId == assessment.CrewAssessmentMembers[l].aimsId || newAssessment.assessmentCrew[i].CrewId == assessment.CrewAssessmentMembers[l].Id) {
            isExists = true;
            break;
          }
        }

        if (!isExists && !assessment.CrewAssessmentMembers[l].IsManual) {
          assessment.CrewAssessmentMembers.splice(l, 1);
          l--; // Adjust index after removal

          isUpdated = true;
        }
      } // Update the Status based on the flags


      if (validCrewCount > 0) {
        // If there's at least one valid (non-outdated and existing) crew member
        assessment.Status = "Stored";
      } else if (outdatedCrewCount > 0 && nonExistentCrewCount === 0) {
        // All members are outdated
        assessment.Status = "Outdated";
      } else if (nonExistentCrewCount > 0) {
        // If there are non-outdated but non-existent members
        assessment.Status = "Pending";
      } else if (isUpdated && assessment.Status == "Stored") {
        // If there were updates and it was stored before, downgrade to Draft
        assessment.Status = "Draft";
      }

      assessment.assessedBy = newAssessment.assessedBy; // Update IsExist based on the flag

      assessment.IsExist = validCrewCount > 0;
      return assessment;
    }
    /**
     * Get only the reports that have a stored or complete Assessment
     * @memberof CrewAssessmentFactory
     * @returns {Array} crewAssesments 
     */


    function getAssesedCabinReports() {
      var reports = CabinReportLocalEditFactory.getCabinReportsFromStorage();
      var assessments = getCrewAssessmentsFromStorage();
      var assesedReports = [];

      for (var i = 0; i < assessments.length; i++) {
        if (assessments[i].Status != "Completed" && !assessments[i].IsExist && assessments[i].CrewAssessmentMembers.length > 0) {
          var isCompleted = true;
          var routeReports = [];

          for (var j = 0; j < reports.length; j++) {
            if (reports[j].Route == assessments[i].Route && reports[j].DutyDate == assessments[i].DutyDate) {
              if (reports[j].Status != "completed") {
                isCompleted = false;
              } else {
                routeReports.push(reports[j]);
              }
            }
          }

          if (isCompleted) {
            var flights = FlightFactory.getFlightsByRoutePerDay(assessments[i].Route, assessments[i].DutyDate, assessments[i].FeedbackDate);

            for (var j = 0; j < flights.length; j++) {
              if (flights[j].cabinReportStatusDescr == "Pending") {
                isCompleted = false;
                break;
              }
            }
          }

          if (!isCompleted) {
            assesedReports = assesedReports.concat(routeReports);
          } else if (routeReports != []) {
            routeReports.sort(function (a, b) {
              return new Date(b.ScheduledDeparture) - new Date(a.ScheduledDeparture);
            });
            routeReports.splice(0, 1);
            assesedReports = assesedReports.concat(routeReports);
          }
        } else {
          for (var j = 0; j < reports.length; j++) {
            if (reports[j].Route == assessments[i].Route && reports[j].DutyDate == assessments[i].DutyDate) {
              if (reports[j].Status == "completed") {
                assesedReports.push(reports[j]);
              }
            }
          }
        }
      } //orphaned reports


      for (var j = 0; j < reports.length; j++) {
        if (!existsForRouteDutyDate(reports[j].Route, reports[j].DutyDate, reports[j].FeedbackDate)) {
          if (reports[j].Status == "completed") {
            assesedReports.push(reports[j]);
          }
        }
      }

      return assesedReports;
    }
    /**
     * Find if an assessment exists for the selected Route and Duty Date
     * @memberof CrewAssessmentFactory
     * @param {string} Route  The route of the assessment
     * @param {string} DutyDate  The duty date of the assessment
     * @returns {boolean} isExist 
     */


    function existsForRouteDutyDate(Route, DutyDate, FeedbackDate) {
      var assessments = getCrewAssessmentsFromStorage();
      var isExist = false;

      for (var j = 0; j < assessments.length; j++) {
        if (assessments[j].Route == Route && assessments[j].DutyDate == DutyDate && (!assessments[j].FeedbackDate || assessments[j].FeedbackDate == FeedbackDate)) {
          isExist = true;
          break;
        }
      }

      return isExist;
    }
    /**
     * Update Assessment Information from flights
     * @memberof CrewAssessmentFactory
     * @param {Object} crewAssessment  The crew assessment
     * @param {Array} flights  The flights of the Assessment
     */


    function updateAssessmentFlights(crewAssessment, flights) {
      for (var i = 0; i < flights.length; i++) {
        if (crewAssessment.start && crewAssessment.end) {
          var flightStart = Date.parse(flights[i].ScheduledDeparture);
          var flightEnd = Date.parse(flights[i].ScheduledArrival);
          var assesmentStart = Date.parse(crewAssessment.start);

          if (flightStart < assesmentStart) {
            crewAssessment.start = flights[i].ScheduledDeparture;
          } else {
            var assesmentEnd = Date.parse(crewAssessment.end);

            if (flightEnd > assesmentEnd) {
              crewAssessment.end = flights[i].ScheduledArrival;
            }
          }
        } else {
          crewAssessment.start = flights[i].ScheduledDeparture;
          crewAssessment.end = flights[i].ScheduledArrival;
        }

        var flight = {
          FlightId: flights[i].FlightId,
          ScheduledDepartureDateUTC: flights[i].ScheduledDepartureDateUTC,
          FlightNo: flights[i].FlightNo,
          Departure: flights[i].Departure,
          Arrival: flights[i].Arrival,
          ScheduledDepartureTimeUTC: flights[i].ScheduledDepartureTimeUTC,
          ScheduledDeparture: flights[i].ScheduledDeparture,
          ScheduledArrival: flights[i].ScheduledArrival,
          AcTailNo: flights[i].AcTailNo,
          DutyDate: flights[i].DutyDate
        };
        crewAssessment.Flights.push(flight);
      }

      return crewAssessment;
    }
    /**
     * Returns the a list of cabin Crew Feedbacks that are ready to send (the reports of the assessment are completed or synched)
     * @memberof CrewAssessmentFactory
     * @param {string} Route  The route of the assessment
     * @param {string} DutyDate  The duty date of the assessment
     * @returns {Array} assessmentsToSend  
     */


    function getAssementsReadyToSend() {
      var assessments = getCrewAssessmentsFromStorage();
      var assessmentsToSend = [];

      for (var i = 0; i < assessments.length; i++) {
        if (assessments[i].Status == "Completed") {
          assessmentsToSend.push(assessments[i]); ////Send assessments anyway...
          // var isCompleted = true;
          // var flights = FlightFactory.getFlightsByRoute(assessments[i].Route, assessments[i].DutyDate);
          // for (var j = 0; j < flights.length; j++) {
          // 	if (flights[j].LineStatus == "pending" || flights[j].LineStatus == "pendingoverdue" || flights[j].LineStatus == "draft") {
          // 		isCompleted = false;
          // 		break;
          // 	}
          // }
          // if (isCompleted) {
          // 	assessmentsToSend.push(assessments[i])
          // }
        }
      }

      return assessmentsToSend;
    }
    /**
     * Store Assessment inside the flights
     * @memberof CrewAssessmentFactory
     */


    function storeFlightsWithAssessments() {
      var flights = FlightFactory.getFlightsFromStorage();
      var crewAssessments = getCrewAssessmentsFromStorage();

      for (var i = 0; i < flights.length; i++) {
        for (var j = 0; j < crewAssessments.length; j++) {
          if (flights[i].Route == crewAssessments[j].Route && (crewAssessments[j].FeedbackDate && flights[i].FlightDate == crewAssessments[j].FeedbackDate || !crewAssessments[j].FeedbackDate && flights[i].DutyDate == crewAssessments[j].DutyDate)) {
            flights[i].assessment = {
              Id: crewAssessments[j].Id,
              Status: crewAssessments[j].Status,
              IsExist: crewAssessments[j].IsExist,
              IsAssessedBy: crewAssessments[j].assessedBy.length > 0,
              IsCrewLess: crewAssessments[j].CrewAssessmentMembers.length < 1,
              FeedbackDate: crewAssessments[j].FeedbackDate
            };
            break;
          }
        }
      }

      FlightFactory.setFlightsToStorage(flights);
    }
    /**
     * Update Assessments which are stored inside the flights 
     * @memberof CrewAssessmentFactory
     * @param {Object} crewAssessment  The crew assessment\
     */


    function updateFlightsAssessment(assessment) {
      var flights = FlightFactory.getFlightsFromStorage();

      for (var i = 0; i < flights.length; i++) {
        //TODO:: if assessment.Id =0 ? then route + dutyDate + feedbackdate
        if (flights[i].assessment && flights[i].assessment.Id == assessment.Id) {
          flights[i].assessment.Status = assessment.Status;
        }
      }

      FlightFactory.setFlightsToStorage(flights);
    }
    /**
          * Create New Crew Assessments from the api assessments
          * @memberof CrewAssessmentFactory
          * @returns {Array} crewAssessments 
          */


    function createCrewAssessments(assessments) {
      var crewAssessments = [];

      for (var i = 0; i < assessments.length; i++) {
        var crewAssessment = createNewCrewAssessment(assessments[i]);

        if (crewAssessment) {
          crewAssessments.push(crewAssessment);
        }
      }

      return crewAssessments;
    }
    /**
          * Create New Crew Assessment from the api assessments
          * @memberof CrewAssessmentFactory
          * @returns {object} assessment 
          */


    function createNewCrewAssessment(assessment) {
      // load the user
      var user = UserFactory.getUser();
      if (user == null) return null; // load the crewAssessmentTemplate

      var crewAssessmentTemplates = CrewAssessmentTemplateFactory.getCrewAssessmentTemplateFromStorage();
      if (crewAssessmentTemplates == null) return null; // load the flight

      var flights = FlightFactory.getFlightsByRoutePerDay(assessment.Route, assessment.DutyDate, assessment.FeedbackDate);
      if (flights == null || flights.length == 0) return null; // create the new crewAssessment

      var crewAssessment = getNewCrewAssessment();
      crewAssessment.Id = assessment.Id == null ? guid() : assessment.Id;
      crewAssessment.UserId = user.id;
      crewAssessment.Route = assessment.Route;
      crewAssessment.DutyDate = assessment.DutyDate;
      crewAssessment.DutyDay = assessment.DutyDay;
      crewAssessment.AcType = flights[0].AcType;
      crewAssessment = updateAssessmentFlights(crewAssessment, flights);
      crewAssessment.assessedBy = assessment.assessedBy;
      crewAssessment.FeedbackDate = assessment.FeedbackDate;
      var IsExist = true; //filter by feedback date

      assessment.assessmentCrew = crewAssessmentFilteredByFeedbackDate(assessment); //filter by common flights in the route

      var flightIds = flights.map(function (f) {
        return f.FlightId;
      }); // Filter the CrewAssessmentMembers to include only those with common flights in the route

      assessment.assessmentCrew = filterCrewAssessmentMembersByCommonFlightsInRoute(assessment.assessmentCrew, flightIds); //add crew members

      for (var i = 0; i < assessment.assessmentCrew.length; i++) {
        //check for double crew members
        if (crewAssessment.CrewAssessmentMembers && !crewAssessment.CrewAssessmentMembers.some(function (member) {
          return member.aimsId === assessment.assessmentCrew[i].CrewAimsId;
        })) {
          var crewMember = CrewAssessmentMemberFactory.newMember();
          crewMember.aimsId = assessment.assessmentCrew[i].CrewAimsId;
          crewMember.id = assessment.assessmentCrew[i].CrewId;
          crewMember.assessmentItems = crewAssessmentTemplates;
          crewMember.name = assessment.assessmentCrew[i].Name;
          crewMember.IsCompleted = false;
          crewMember.IsValid = true;
          crewMember.IsExist = assessment.assessmentCrew[i].IsExist;
          crewMember.IsOutdated = assessment.assessmentCrew[i].IsOutdated;
          crewMember.EndPeriod = assessment.assessmentCrew[i].EndPeriod;

          if (!assessment.assessmentCrew[i].IsExist) {
            IsExist = false;
          }

          crewAssessment.CrewAssessmentMembers.push(crewMember);
        }
      }

      crewAssessment.IsExist = IsExist;

      if (IsExist) {
        crewAssessment.Status = "Stored";
      } // return the new crewAssessment


      return crewAssessment;
    }

    function getFaMembersForFeedback(faMembersIdsInRoute, crewAssessmentInLS) {
      // Check if faMembersIdsInRoute or crewAssessmentInLS is not defined/null
      if (!faMembersIdsInRoute || !crewAssessmentInLS) {
        console.error("empty crewAssessmentInLS or faMembersIdsInRoute");
        return [];
      } // Get the current date + 1 day


      var nowPlusOne = new Date();
      nowPlusOne.setDate(nowPlusOne.getDate() + 1);

      if (defaultCalendarDate) {
        nowPlusOne = new Date(defaultCalendarDate);
      }

      var commonFaMembers = crewAssessmentInLS.CrewAssessmentMembers.filter(function (member) {
        var memberEndDate = new Date(member.EndPeriod); // Check if the member's ID matches and the endDate is valid

        return faMembersIdsInRoute.includes(member.aimsId) //Temporarily disabled the end date check
        // && memberEndDate >= nowPlusOne // End date is greater than or equal to now + 1
        ;
      });
      return commonFaMembers;
    }
    /*
    * Get Crew Assessment By duty number and Day
    * @memberof CrewAssessmentFactory
    * @param {string} dutyNo  the Duty Number of the desired Crew Assessment
    * @param {string} dutyDay  the Duty Day of the desired Crew Assessment
    * @param {string} feedbackDate  the Feedback Date of the desired Crew Assessment
    * @returns {Object} crewAssessment
    */


    function getCrewAssessmentByDutyNoAndDay(dutyNo, dutyDay, feedbackDate) {
      var crewAssessments = getCrewAssessmentsFromStorage();
      if (crewAssessments == null || dutyNo == null || dutyDay == null) return null;
      var result = null;
      var arrayLength = crewAssessments.length;

      for (var i = 0; i < arrayLength; i++) {
        if (crewAssessments[i].DutyNo == dutyNo && crewAssessments[i].DutyDay == dutyDay && (!crewAssessments[i].FeedbackDate || crewAssessments[i].FeedbackDate == feedbackDate)) {
          result = crewAssessments[i];
          break;
        }
      }

      return result;
    }
    /**
    * Get Crew Assessment By Route and Day
    * @memberof CrewAssessmentFactory
    * @param {string} route  the Route of the desired Crew Assessment
    * @param {string} dutyDay  the Duty Day of the desired Crew Assessment
    * @param {string} feedbackDate  the Feedback Date of the desired Crew Assessment
    * @returns {Object} crewAssessment
    */


    function getCrewAssessmentByRouteAndDay(route, dutyDay, feedbackDate) {
      var crewAssessments = getCrewAssessmentsFromStorage();
      if (crewAssessments == null || route == null || dutyDay == null) return null;
      var result = null;
      var arrayLength = crewAssessments.length;

      for (var i = 0; i < arrayLength; i++) {
        if (crewAssessments[i].Route == route && crewAssessments[i].DutyDay == dutyDay && (!crewAssessments[i].FeedbackDate || crewAssessments[i].FeedbackDate == feedbackDate)) {
          result = crewAssessments[i];
          break;
        }
      }

      return result;
    }

    function hasSyncedFeedbacks(route, dutyDay, feedbackDate) {
      var isSynced = false;
      var crewAssessments = getCrewAssessmentsFromStorage();

      if (crewAssessments && crewAssessments.length > 0) {
        var storedFeedback = crewAssessments.find(function (f) {
          return f.Route == route && f.DutyDay == dutyDay && (!f.FeedbackDate || f.FeedbackDate == feedbackDate);
        });

        if (storedFeedback && storedFeedback.IsExist) {
          isSynced = true;
        }
      }

      return isSynced;
    } // Filters the assessmentCrew to include only those matching the FeedbackDate (if any)


    function crewAssessmentFilteredByFeedbackDate(assessment) {
      var filteredCrew = [];

      if (assessment && assessment.assessmentCrew && assessment.assessmentCrew.length > 0) {
        for (var i = 0; i < assessment.assessmentCrew.length; i++) {
          if (!assessment.FeedbackDate || assessment.FeedbackDate == assessment.assessmentCrew[i].FlightDate) {
            filteredCrew.push(assessment.assessmentCrew[i]);
          }
        }
      }

      return filteredCrew;
    } // Filters the CrewAssessmentMembers to include only those with common flights in the route


    function filterCrewAssessmentMembersByCommonFlightsInRoute(members, flightIdsInRoute) {
      if (!members || members.length === 0 || !flightIdsInRoute || flightIdsInRoute.length === 0) {
        return [];
      }

      var commonFlightsWithFA = localStorageMD5Service.get('CommonFlightsWithFA') || [];
      var faAimsIds = commonFlightsWithFA.filter(function (entry) {
        return entry.Flights.some(function (flight) {
          return flightIdsInRoute.includes(flight.FlightId);
        });
      }).map(function (entry) {
        return entry.FaAimsId;
      });
      return members.filter(function (member) {
        return faAimsIds.includes(member.CrewAimsId);
      });
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CrewAssessmentMemberFactory', CrewAssessmentMemberFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CrewAssessmentMemberFactory
  * @description 
  *   Initializes new Crew Assessment Members
  * @ngInject
  */

  function CrewAssessmentMemberFactory() {
    /**
    * Initialize the Crew Assessment Member
    * @memberof CrewAssessmentMemberFactory
    */
    function CrewAssessmentMember() {
      this.aimsId = null;
      this.id = null;
      this.name = null;
      this.IsCompleted = false;
      this.IsValid = true;
      this.IsOverride = false;
      this.IsManual = false;
      this.IsExist = false;
      this.Review = null;
      this.assessmentItems = [];
      this.IsOutdated = false;
      this.EndPeriod = null;
    }

    var service = {
      newMember: newMember
    };
    /**
     * Create New Crew Assessment Member
     * @memberof CrewAssessmentMemberFactory
     * @returns {object} CrewAssessmentMember 
     */

    function newMember() {
      return new CrewAssessmentMember();
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CrewAssessmentTemplateFactory', CrewAssessmentTemplateFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CrewAssessmentTemplateFactory
  * @description 
  *   Get,Set new Crew Assessment Templates
  * @ngInject
  */

  function CrewAssessmentTemplateFactory(GenericService) {
    /**
    * Initialize the Crew Assessment Template
    * @memberof CrewAssessmentTemplateFactory
    */
    function CrewAssessmentTemplate() {
      this.Id = null;
      this.Description = null;
      this.Label = null;
      this.OrderNo = null;
      this.ItemValue = 3;
      this.GetId = GetId;
    }

    var objType = 'CrewAssessmentTemplate';
    var objCallback = CrewAssessmentTemplate;
    var service = {
      getCrewAssessmentTemplateFromStorage: getCrewAssessmentTemplateFromStorage,
      setCrewAssessmentTemplateToStorage: setCrewAssessmentTemplateToStorage
    }; //Object services

    /**
     * Overide default get Id
     * @memberof CrewAssessmentTemplateFactory
     * @returns {number} Id 
     */

    function GetId() {
      return this.Id;
    } // Factory Services

    /**
     * Get Crew Assessment Templates
     * @memberof CrewAssessmentTemplateFactory
     * @returns {Array} CrewAssessmentTemplates 
     */


    function getCrewAssessmentTemplateFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Get Assessment Sync Results
     * @memberof CrewAssessmentTemplateFactory
     * @param {Array} CrewAssessmentTemplates A list of Crew assesment template questions
     */


    function setCrewAssessmentTemplateToStorage(crewAssessmentTemplate) {
      GenericService.saveAll(crewAssessmentTemplate, objType, objCallback);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('AssignmentModalCtrl', AssignmentModalCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name AssignmentModalCtrl
  * @description 
  *  Manages the Assignment Modal
  * @ngInject
  */

  function AssignmentModalCtrl($scope, assignment, info, $uibModalInstance, CampaignFactory) {
    $scope.assignment = JSON.parse(JSON.stringify(assignment));
    $scope.info = info;
    $scope.cancel = cancel;
    $scope.submit = submit;
    $scope.giftStatus = CampaignFactory.giftStatusList();
    /**
     * Close the modal
     * @memberof AssignmentModalCtrl
     */

    function cancel() {
      $uibModalInstance.dismiss('close');
    }

    function submit() {
      CampaignFactory.updateCampaignPassenger(info.flightId, $scope.assignment);
      $uibModalInstance.close('close');
    }
  }
})();
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  'use strict';

  a3_cabin_reports.factory('CampaignFactory', CampaignFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CampaignFactory
  * @description 
  *   Add, Update, Delete and Get Campaigns.
  * @ngInject
  */

  function CampaignFactory(GenericService, FlightFactory) {
    var objType = 'Campaigns';
    var objCallback = Campaign;
    /**
     * Initialize the Campaign
     * @memberof CampaignFactory
     */

    function Campaign() {
      this.GetId = GetId;
    }

    var service = {
      giftStatusList: giftStatusList,
      getFlightsCampaignsFromStorage: getFlightsCampaignsFromStorage,
      getCampaignsByFlightId: getCampaignsByFlightId,
      saveFlightCampaignsToStorage: saveFlightCampaignsToStorage,
      updateCampaignPassenger: updateCampaignPassenger,
      updateSeatNoPaxAssignments: updateSeatNoPaxAssignments,
      getPaxAssignmentsFromStorage: getPaxAssignmentsFromStorage,
      mergeCampaigns: mergeCampaigns,
      getPaxAssignment: getPaxAssignment,
      hasPendingFeedbacks: hasPendingFeedbacks,
      syncResultFormat: syncResultFormat,
      cleanOldCampaigns: cleanOldCampaigns
    }; //Object Functions

    /**
     * Overide default get Id
     * @memberof FlightFactory
     * @returns {number} Id 
     */

    function GetId() {
      return this.FlightId;
    }
    /**
      * Get Campaigns
      * @memberof CampaignFactory
      * @param {function} callback  
      */


    function getFlightsCampaignsFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    ;
    /**
     * Save Campaigns to storage
     * @memberof CampaignFactory
     * @param {Array} flightCampaigns A list of flightCampaigns
     */

    function setFlightCampaignsToStorage(flightCampaigns) {
      GenericService.saveAll(flightCampaigns, objType, objCallback);
    }
    /**
    * Get single flight Campaigns
    * @memberof CampaignFactory
    * @param {function} callback  
    */


    function getCampaignsByFlightId(flightId) {
      return GenericService.get(flightId, objType, objCallback);
    }

    ;
    /**
    * Set single flight Campaigns
    * @memberof CampaignFactory
    * @param {function} callback  
    */

    function addFlightCampaigns(FlightCampaigns) {
      FlightCampaigns.IsFeedbackReady = !hasPendingFeedbacks(FlightCampaigns);
      return GenericService.add(FlightCampaigns, objType, objCallback);
    }

    ;
    /**
    * Get assignments from storage
    * @memberof CampaignFactory
    * @param {function} callback  
    */

    function getPaxAssignmentsFromStorage() {
      var assignmentsToSend = [];
      var data = getFlightsCampaignsFromStorage();

      if (data) {
        var flightsReadyList = data.filter(function (d) {
          return d.IsFeedbackReady;
        });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = flightsReadyList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var flight = _step.value;
            var flightStored = FlightFactory.getFlightFromStorage(flight.FlightId);
            var isSyncTimeValid = flightStored == null || moment().valueOf() > moment.utc(flightStored.ScheduledDeparture).valueOf();

            if (isSyncTimeValid) {
              flight.CampaignsList.forEach(function (camp) {
                camp.Treatments.forEach(function (treat) {
                  treat.Assignments.forEach(function (assign) {
                    var assignToSend = _objectSpread({}, assign, {
                      Status: +assign.StatusStr
                    });

                    assignmentsToSend.push(assignToSend);
                  });
                });
              });
            } // else{
            //     clearFlightCampaignsFromStorage(flight.FlightId)
            // }

          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return {
          FlightsToFetch: data.map(function (flt) {
            return flt.FlightId;
          }),
          AssignmentsToUpdate: assignmentsToSend
        };
      }
    }

    ;
    /**
    * Get assignment from storage with flightId, PNR, UCI
    * @memberof CampaignFactory
    * @param {function} callback  
    */

    function getPaxAssignment(flightId, pnr, uci) {
      var fltCampaigns = getCampaignsByFlightId(flightId);
      var data = {
        campaign: null,
        treatment: null,
        assignment: null
      };

      if (fltCampaigns) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = fltCampaigns.CampaignsList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var camp = _step2.value;
            data.campaign = {
              title: camp.CampaignTitle,
              briefings: camp.Briefings
            };
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = camp.Treatments[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var treat = _step3.value;
                data.treatment = {
                  title: treat.Title,
                  description: treat.Description,
                  briefings: treat.Briefings
                };
                data.assignment = treat.Assignments.find(function (a) {
                  return a.UCI == uci && a.PNR == pnr;
                });
                if (data.assignment) break;
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                  _iterator3["return"]();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            if (data.assignment) break;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      return data;
    }

    function mergeCampaigns(data) {
      //Current flights to store
      var flightIdList = getFlightsCampaignsFromStorage().map(function (x) {
        return x.FlightId;
      });

      if (data.UpdateAssignmentsSuccess) {
        var incomingfltIds = data.FlightsCampaigns.map(function (x) {
          return x.FlightId;
        });
        flightIdList.forEach(function (id) {
          if (!incomingfltIds.includes(id)) {
            clearFlightCampaignsFromStorage(id);
          }
        });
      }

      if (data.GetAssignmentsSuccess) {
        updateIncomingStore(data.FlightsCampaigns);
        data.FlightsCampaigns.forEach(function (flight) {
          //curent store not include incoming flight
          if (!flightIdList.includes(flight.FlightId)) addFlightCampaigns(flight); //current store include flight	
          else saveFlightCampaignsToStorage(flight);
        });
      }
    }

    function updateIncomingStore(incomingCamps) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = incomingCamps[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var flt = _step4.value;
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = flt.CampaignsList[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var camp = _step5.value;
              var _iteratorNormalCompletion6 = true;
              var _didIteratorError6 = false;
              var _iteratorError6 = undefined;

              try {
                for (var _iterator6 = camp.Treatments[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  var treat = _step6.value;
                  var _iteratorNormalCompletion7 = true;
                  var _didIteratorError7 = false;
                  var _iteratorError7 = undefined;

                  try {
                    for (var _iterator7 = treat.Assignments[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                      var assign = _step7.value;
                      var currentAssignment = findCurrentAssignment(assign);

                      if (currentAssignment) {
                        //&& ((assign.AutoSet && !currentAssignment.AutoSet) || (!assign.AutoSet && !currentAssignment.AutoSet))) {
                        assign.Status = currentAssignment.Status;
                        assign.StatusStr = currentAssignment.StatusStr;
                        assign.Rate = currentAssignment.Rate;
                        assign.Comments = currentAssignment.Comments; //assign.AutoSet = currentAssignment.Status != 5 ? false : currentAssignment.AutoSet;
                      }
                    }
                  } catch (err) {
                    _didIteratorError7 = true;
                    _iteratorError7 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion7 && _iterator7["return"] != null) {
                        _iterator7["return"]();
                      }
                    } finally {
                      if (_didIteratorError7) {
                        throw _iteratorError7;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion6 && _iterator6["return"] != null) {
                    _iterator6["return"]();
                  }
                } finally {
                  if (_didIteratorError6) {
                    throw _iteratorError6;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
                _iterator5["return"]();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
            _iterator4["return"]();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }

    function findCurrentAssignment(assignment) {
      var currentCamps = getFlightsCampaignsFromStorage();
      var currentAssignment;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = currentCamps[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var flt = _step8.value;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = flt.CampaignsList[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var camp = _step9.value;
              var _iteratorNormalCompletion10 = true;
              var _didIteratorError10 = false;
              var _iteratorError10 = undefined;

              try {
                for (var _iterator10 = camp.Treatments[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                  var treat = _step10.value;
                  currentAssignment = treat.Assignments.find(function (assign) {
                    return assign.Id == assignment.Id;
                  });
                  if (currentAssignment) break;
                }
              } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion10 && _iterator10["return"] != null) {
                    _iterator10["return"]();
                  }
                } finally {
                  if (_didIteratorError10) {
                    throw _iteratorError10;
                  }
                }
              }

              if (currentAssignment) break;
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9["return"] != null) {
                _iterator9["return"]();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }

          if (currentAssignment) break;
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8["return"] != null) {
            _iterator8["return"]();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return currentAssignment;
    }
    /**
     * Update FlightCampaigns to Storage
     * @memberof CampaignFactory
     * @param {object} CampaignPassenger a CampaignPassenger
     */


    function saveFlightCampaignsToStorage(campaignPassenger) {
      campaignPassenger.IsFeedbackReady = !hasPendingFeedbacks(campaignPassenger);
      GenericService.save(campaignPassenger, objType, objCallback);
    }

    ;

    function updateCampaignPassenger(flightId, assignment) {
      var data = getCampaignsByFlightId(flightId);
      var assignmentLs;

      if (data) {
        var fltCampaings = _objectSpread({}, data);

        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = fltCampaings.CampaignsList[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var camp = _step11.value;
            var _iteratorNormalCompletion12 = true;
            var _didIteratorError12 = false;
            var _iteratorError12 = undefined;

            try {
              for (var _iterator12 = camp.Treatments[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                var treat = _step12.value;
                assignmentLs = treat.Assignments.find(function (a) {
                  return a.Id == assignment.Id;
                });

                if (assignmentLs) {
                  assignmentLs.Status = +assignment.StatusStr;
                  assignmentLs.StatusStr = assignment.StatusStr;
                  assignmentLs.Rate = +assignment.StatusStr == 1 ? assignment.Rate : 0;
                  assignmentLs.Comments = assignment.Comments; //delete assignmentLs["AutoSet"];

                  break;
                }
              }
            } catch (err) {
              _didIteratorError12 = true;
              _iteratorError12 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion12 && _iterator12["return"] != null) {
                  _iterator12["return"]();
                }
              } finally {
                if (_didIteratorError12) {
                  throw _iteratorError12;
                }
              }
            }

            if (assignmentLs) break;
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11["return"] != null) {
              _iterator11["return"]();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        saveFlightCampaignsToStorage(fltCampaings);
      }
    }

    function updateSeatNoPaxAssignments(fltCampaings, paxinfoList) {
      fltCampaings.forEach(function (fltcamp) {
        fltcamp.CampaignsList.forEach(function (camp) {
          var paxinfo = paxinfoList.find(function (p) {
            return p.FlightId == fltcamp.FlightId;
          });

          if (paxinfo) {
            var paxinfoFlatten = flatten(paxinfo.Seatmap.map(function (s) {
              return s.Columns;
            }));
            camp.Treatments.forEach(function (treat) {
              treat.Assignments.forEach(function (assign) {
                var pax = paxinfoFlatten.find(function (s) {
                  return s.PNR == assign.PNR && s.UCI == assign.UCI;
                });

                if (pax) {
                  assign.SeatNo = pax.SeatNo;
                } // else {
                // 	assign.Status = 5;
                // 	assign.AutoSet = true;
                // 	assign.StatusStr = '5';
                // 	assign.Comments = null;
                // 	assign.Rate = 0;
                // }

              });
            });
          }
        });
      });
    }

    function giftStatusList() {
      return [{
        label: "-select one-",
        value: "0"
      }, {
        label: "Delivered",
        value: "1"
      }, {
        label: "Not delivered",
        value: "2"
      }, {
        label: "Damaged",
        value: "3"
      }, {
        label: "Not available",
        value: "4"
      }, {
        label: "No show",
        value: "5"
      }, {
        label: "No interest",
        value: "7"
      }];
    }
    /**
     * Remove fligthcampaigns from the local storage
     * @memberof CampaignFactory
     */


    function clearFlightCampaignsFromStorage(flightId) {
      GenericService.remove(flightId, objType, objCallback);
    }

    function hasPendingFeedbacks(data) {
      var feedbackReadyCounter = 0; //var data = getCampaignsByFlightId(flightId);

      if (data) {
        var _iteratorNormalCompletion13 = true;
        var _didIteratorError13 = false;
        var _iteratorError13 = undefined;

        try {
          for (var _iterator13 = data.CampaignsList[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
            var camp = _step13.value;
            var _iteratorNormalCompletion14 = true;
            var _didIteratorError14 = false;
            var _iteratorError14 = undefined;

            try {
              for (var _iterator14 = camp.Treatments[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                var treat = _step14.value;
                feedbackReadyCounter += treat.Assignments.filter(function (a) {
                  return a.Status > 0;
                }).length;
              }
            } catch (err) {
              _didIteratorError14 = true;
              _iteratorError14 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion14 && _iterator14["return"] != null) {
                  _iterator14["return"]();
                }
              } finally {
                if (_didIteratorError14) {
                  throw _iteratorError14;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError13 = true;
          _iteratorError13 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion13 && _iterator13["return"] != null) {
              _iterator13["return"]();
            }
          } finally {
            if (_didIteratorError13) {
              throw _iteratorError13;
            }
          }
        }
      }

      return !(data.AssignmentsCounter == feedbackReadyCounter);
    }

    function syncResultFormat(result) {
      var updateText;
      var upClass;
      var fetchText;
      var fetchClass;

      if (result.UpdateAssignmentsSuccess == null) {
        updateText = "No Campaigns Feedbacks were uploaded to the server. ";
        upClass = "alert-cyan";
      } else if (result.UpdateAssignmentsSuccess == true) {
        updateText = "Campaigns Feedbacks were uploaded to the server. ";
        upClass = "alert-cyan";
      } else {
        updateText = "Campaigns Feedbacks failed to be uploaded to the server. ";
        upClass = "alert-deep-orange";
      }

      if (result.GetAssignmentsSuccess == false) {
        fetchText = "Campaigns Feedbacks failed to be fetched by the server.";
        fetchClass = "alert-deep-orange";
      } else if (result.GetAssignmentsSuccess == true && result.FlightsCampaigns.length > 0) {
        fetchText = "Campaigns Feedbacks were fetched by the server.";
        fetchClass = "alert-cyan";
      } else {
        fetchText = "No Campaigns Feedbacks were fetched by the server.";
        fetchClass = "alert-cyan";
      }

      return {
        updMessage: updateText,
        updClass: upClass,
        ftcMessage: fetchText,
        ftcClass: fetchClass
      };
    }

    function flatten(arr) {
      return arr.reduce(function (flat, toFlatten) {
        return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
      }, []);
    }
    /**
           * Clean Old Data
           * @memberof CampaignFactory
           * @param {Array} pendingFlightIds FlightIds with pending reports
           */


    function cleanOldCampaigns(pendingFlightIds) {
      var now = moment();
      getFlightsCampaignsFromStorage(function (campaigns) {
        var pendingCampaigns = campaigns.FlightsCampaigns.filter(function (item) {
          return pendingFlightIds.includes(item.FlightId);
        }); // keep only the campaigns with pending reports

        setFlightCampaignsToStorage(pendingCampaigns);
      });
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.filter('bytes', bytes);
  /**
  * @memberof CabinReports
  * @ngdoc filter
  * @name bytes
  * @description 
  *  Transform Bytes to  'kB', 'MB', 'GB', 'TB', 'PB'
  * @ngInject
  */

  function bytes() {
    return function (bytes, precision) {
      if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
      if (typeof precision === 'undefined') precision = 1;
      var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
          number = Math.floor(Math.log(bytes) / Math.log(1024));
      return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('DataCleanerFactory', DataCleanerFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name DataCleanerFactory
   * @description 
   *   Cleans the Data of the application
   * @ngInject
   */

  function DataCleanerFactory(localStorageMD5Service, IndexedDBService, GenericService) {
    var service = {
      deleteAllReports: deleteAllReports,
      deleteAllServerData: deleteAllServerData,
      deleteAllData: deleteAllData,
      deleteOrphanedLocalFlights: deleteOrphanedLocalFlights,
      deleteOrphanedLocalReports: deleteOrphanedLocalReports,
      deleteSynchedLocalCabinReports: deleteSynchedLocalCabinReports,
      deleteIndexedDB: deleteIndexedDB,
      deleteOldCrewMealsRatings: deleteOldCrewMealsRatings,
      deleteOrphanedCustomerEvents: deleteOrphanedCustomerEvents
    };
    /**
     * Delete All Cabin Reports
     * @memberof DataCleanerFactory
     */

    function deleteAllReports() {
      localStorageMD5Service.remove('cabinReportLocalEdits');
      localStorageMD5Service.remove('cabinReportLocalEdit_TEMP');
      deleteOrphanedLocalFlights();
    }

    ;
    /**
     * Delete Basic Server data
     * @memberof DataCleanerFactory
     */

    function deleteAllServerData() {
      localStorageMD5Service.remove('flights');
      localStorageMD5Service.remove('reportGuids');
      localStorageMD5Service.remove('aircraftTypes');
      localStorageMD5Service.remove('cabinReportTemplateItems');
      localStorageMD5Service.remove('cabinReportSyncResults');
      localStorageMD5Service.remove('assessmentSyncResults');
      localStorageMD5Service.remove('waterUpliftActions');
      localStorageMD5Service.remove('acSupplies');
      localStorageMD5Service.remove('specialMealSources');
      localStorageMD5Service.remove('specialMealTypes');
      localStorageMD5Service.remove('currencies');
      localStorageMD5Service.remove('travelValueIncompleteReasons');
      localStorageMD5Service.remove('incompleteInFlightServiceListOfValues');
      localStorageMD5Service.remove('ccms');
      localStorageMD5Service.remove('scheduleChanges');
      localStorageMD5Service.remove('CheckIn');
      localStorageMD5Service.remove('flightCheckIns');
      localStorageMD5Service.remove('CrewAssessmentTemplate');
      localStorageMD5Service.remove('FAQItem');
      localStorageMD5Service.remove('PaxInfo');
      localStorageMD5Service.remove('flightEventTypes');
      localStorageMD5Service.remove('flightEvents');
      deleteOrphanedLocalFlights();
    }

    ;
    /**
     * Delete All Server data
     * @memberof DataCleanerFactory
     */

    function deleteAllData() {
      localStorageMD5Service.clearAll();
      IndexedDBService.deleteDatabase();
    }

    ;

    function deleteIndexedDB() {
      return IndexedDBService.deleteDatabase();
    }
    /**
     * Delete local flights that have no stored local reports
     * @memberof DataCleanerFactory
     */


    function deleteOrphanedLocalFlights() {
      var existingLocalFlights = localStorageMD5Service.get('localFlights');
      if (existingLocalFlights == null) return;
      var finalLocalFlights = [];
      var cabinReportLocalEdits = localStorageMD5Service.get('cabinReportLocalEdits');
      if (cabinReportLocalEdits == null) cabinReportLocalEdits = []; // check every local flight that has a saved cabin report

      for (var i = 0; i < existingLocalFlights.length; i++) {
        var hasCabinReport = false;

        for (var j = 0; j < cabinReportLocalEdits.length; j++) {
          if (cabinReportLocalEdits[j].FlightId != null && cabinReportLocalEdits[j].FlightId == existingLocalFlights[i].FlightId || cabinReportLocalEdits[j].FlightAimsId != null && cabinReportLocalEdits[j].FlightAimsId == existingLocalFlights[i].FlightAimsId) {
            hasCabinReport = true;
            break;
          }
        } // if it has a cabin report, add it to the flights to save


        if (hasCabinReport) finalLocalFlights.push(existingLocalFlights[i]);
      } // save the resulting local flights


      localStorageMD5Service.set('localFlights', finalLocalFlights);
    }
    /**
     * Delete local reports that have no stored local flights
     * @memberof DataCleanerFactory
     */


    function deleteOrphanedLocalReports() {
      var existingLocalCabinReports = localStorageMD5Service.get('cabinReportLocalEdits');
      var flights = localStorageMD5Service.get('flights');
      if (existingLocalCabinReports == null || flights == null || existingLocalCabinReports.length == 0 || flights.length == 0) return 0;
      var finalLocalCabinReports = [];

      for (var i = 0; i < existingLocalCabinReports.length; i++) {
        var remove = false;

        if (existingLocalCabinReports[i].Status == 'synched') {
          remove = true;

          if (existingLocalCabinReports[i].FlightId != null || existingLocalCabinReports[i].FlightAimsId != null) {
            for (var j = 0; j < flights.length; j++) {
              if (existingLocalCabinReports[i].FlightId != null && existingLocalCabinReports[i].FlightId == flights[j].FlightId || existingLocalCabinReports[i].FlightAimsId != null && existingLocalCabinReports[i].FlightAimsId == flights[j].FlightAimsId) {
                remove = false;
              }
            }
          }
        }

        if (!remove) finalLocalCabinReports.push(existingLocalCabinReports[i]);
      } // save the resulting local reports


      localStorageMD5Service.set('cabinReportLocalEdits', finalLocalCabinReports);
    }
    /**
     * Delete  Synched Local CabinReports
     * @memberof DataCleanerFactory
     */


    function deleteSynchedLocalCabinReports() {
      var existingLocalCabinReports = localStorageMD5Service.get('cabinReportLocalEdits');
      var flights = localStorageMD5Service.get('flights');
      if (existingLocalCabinReports == null || flights == null || existingLocalCabinReports.length == 0 || flights.length == 0) return 0;
      var finalLocalCabinReports = [];
      var deleted = 0;
      var user = localStorageMD5Service.get('user');
      ; // check every saved cabin report

      for (var i = 0; i < existingLocalCabinReports.length; i++) {
        var remove = false;

        if (existingLocalCabinReports[i].Status == 'synched') {
          if (existingLocalCabinReports[i].FlightId != null || existingLocalCabinReports[i].FlightAimsId != null) {
            for (var j = 0; j < flights.length; j++) {
              if (existingLocalCabinReports[i].FlightId != null && existingLocalCabinReports[i].FlightId == flights[j].FlightId || existingLocalCabinReports[i].FlightAimsId != null && existingLocalCabinReports[i].FlightAimsId == flights[j].FlightAimsId) {
                for (var h = 0; h < flights[j].cabinReports.length; h++) {
                  if (flights[j].cabinReports[h].AuthorAimsId == user.aimsId) {
                    remove = true;
                    deleted++;
                  }
                }
              }
            }
          }
        }

        if (!remove) finalLocalCabinReports.push(existingLocalCabinReports[i]);
      } // save the resulting local reports


      localStorageMD5Service.set('cabinReportLocalEdits', finalLocalCabinReports);
      return deleted;
    }
    /**
    * Deletes CrewMealRatings that are older than 20 days
    * @memberof DataCleanerFactory
    */


    function deleteOldCrewMealsRatings() {
      var res = GenericService.list("CrewMealRatings", objCallbackRatings);
      var lastDate = new Date();
      lastDate.setDate(lastDate.getDate() - 20);
      var crewMealIdsFiltered = res.filter(function (r) {
        return new Date(r.TimeStamp) >= lastDate;
      });
      GenericService.saveOne(crewMealIdsFiltered, "CrewMealRatings");
    }
    /**
     * Deletes customer events whose flight doesn't exist
     */


    function deleteOrphanedCustomerEvents() {
      var flights = localStorageMD5Service.get('flights');
      var customerEvents = localStorageMD5Service.get('CustomerEvents');
      var finalCustomerEvents = [];

      if (customerEvents && flights && flights.length > 0) {
        customerEvents.forEach(function (event) {
          //Search if event's flight exist
          if (flights.find(function (x) {
            return x.FlightId == event.FlightId;
          })) {
            finalCustomerEvents.push(event);
          }
        }); //save the resulting customer events

        localStorageMD5Service.set('CustomerEvents', finalCustomerEvents);
      }
    }

    function objCallbackRatings() {
      this.CrewMealId = null, this.TimeStamp = null;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.filter('fltSplit', fltSplit);
  /**
  * @memberof CabinReports
  * @ngdoc filter
  * @name messageFilter
  * @description 
  *   Filters messages in order to show only the unread.
  * @ngInject
  */

  function fltSplit() {
    return function (fltSplit) {
      var formattedFltNo = fltSplit;

      if (typeof fltSplit === 'string' || fltSplit instanceof String) {
        formattedFltNo = fltSplit.replace(/(\w{2})/, '$1 ');
      }

      return formattedFltNo;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('GenericModalFactory', GenericModalFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name GenericModalFactory
  * @description 
  *    Initialize generic Modals
  * @ngInject
  */

  function GenericModalFactory() {
    var service = {
      createNew: createNew,
      fromObject: fromObject,
      deleteFromList: deleteFromList,
      fromObjectList: fromObjectList
    };
    /**
     * Greate new Object  based on given constructor
     * @memberof GenericModalFactory
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} result
     */

    function createNew(callback) {
      var result = new callback();
      result.Id = guid();
      return result;
    }
    /**
     * Extend given object 
     * @memberof GenericModalFactory
     * @param {object} obj The object that will be extended
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} object
     */


    function fromObject(obj, callback) {
      if (obj == null) return null;
      var object = new callback();
      angular.extend(object, obj);
      return object;
    }
    /**
     * Delete an object from given List
     * @memberof GenericModalFactory
     * @param {object} obj The object that will be removed
     * @param {array} objList A list that will be modified
     * @returns {array} objList
     */


    function deleteFromList(obj, objList) {
      // find the current item in the array (if present)
      var arrayLength = objList.length;
      var itemIndex = -1;

      for (var i = 0; i < arrayLength; i++) {
        if (objList[i].Id == obj.Id) {
          itemIndex = i;
          break;
        }
      }

      if (itemIndex >= 0) objList.splice(itemIndex, 1);
      return objList;
    }
    /**
     * Extend given object list
     * @memberof GenericModalFactory
     * @param {array} objList The list of objects that will be extended
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} objList
     */


    function fromObjectList(objList, callback) {
      if (objList == null) return [];
      var arrayLength = objList.length;
      var newobjList = new Array();

      for (var i = 0; i < arrayLength; i++) {
        var obj = new callback();
        angular.extend(obj, objList[i]);
        newobjList.push(obj);
      }

      return newobjList;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('GenericService', GenericService);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name GenericService
  * @description 
  *    Generic add, edit or remove
  * @ngInject
  */

  function GenericService(localStorageMD5Service) {
    var objectType = null;
    var objectCallback = null;
    var service = {
      initiate: initiate,
      get: get,
      getOne: getOne,
      list: list,
      save: save,
      saveOne: saveOne,
      saveAll: saveAll,
      remove: remove,
      removeAll: removeAll,
      add: add,
      constructor: constructor,
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      saveByFilter: saveByFilter,
      removeByFilter: removeByFilter
    };
    /**
     * initiate type and callback
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor
     * @memberof GenericService
     */

    function initiate(type, callback) {
      objectType = type;
      objectCallback = callback;
    }
    /**
     * Get the requested object
     * @memberof GenericService
     * @param {number} id The unique identifier
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} result
     */


    function get(id, type, callback) {
      initiate(type, callback);
      var objects = list(type, callback);
      if (objects == null) return null;
      var result = null;
      var arrayLength = objects.length;

      for (var i = 0; i < arrayLength; i++) {
        if (objects[i].GetId() == id) {
          result = objects[i];
          break;
        }
      }

      return result;
    }
    /**
    * Get all the objects
    * @memberof GenericService
    * @param {string} type A string which identifies the local storage name
    * @param {function} callback A callback function that behaves as a constructor
    * @returns {array} objectList
    */


    function list(type, callback) {
      initiate(type, callback);
      var objects = localStorageMD5Service.get(objectType);
      return fromObjectList(objects, callback);
    }
    /**
     * Get the unique object of this storage
     * @memberof GenericService
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} result
     */


    function getOne(type, callback) {
      initiate(type, callback);
      var object = localStorageMD5Service.get(objectType);
      return fromObject(object, callback);
    }
    /**
     * Save the unique object of this storage
     * @memberof GenericService
     * @param {object} obj The object to save
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor\
     */


    function saveOne(obj, type, callback) {
      localStorageMD5Service.set(type, obj);
    }
    /**
     * update the  object
     * @memberof GenericService
     * @param {object} object The object to save
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor\
     */


    function save(object, type, callback) {
      initiate(type, callback);
      var objects = list(type, callback);
      var updatedobject = fromObject(object, callback);
      var arrayLength = objects.length;

      for (var i = 0; i < arrayLength; i++) {
        if (objects[i].GetId() == updatedobject.GetId()) {
          objects[i] = updatedobject;
          break;
        }
      }

      saveAll(objects, type, callback);
    }
    /**
     * Save the  objects 
     * @memberof GenericService
     * @param {array} objects The objects to save
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor\
     */


    function saveAll(objects, type, callback) {
      initiate(type, callback);
      localStorageMD5Service.set(objectType, objects);
    }
    /**
     * remove the  object based on its unique identifier
     * @memberof GenericService
     * @param {number} Id  The unique identifier
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor
     */


    function remove(Id, type, callback) {
      initiate(type, callback);
      var objects = list(type, callback);
      var newObjects = [];
      var arrayLength = objects.length;

      for (var i = 0; i < arrayLength; i++) {
        if (objects[i].GetId() != Id) {
          newObjects.push(objects[i]);
        }
      }

      saveAll(newObjects, type, callback);
    }
    /**
     * remove all the  objects
     * @memberof GenericService
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor
     */


    function removeAll(type, callback) {
      initiate(type, callback);
      localStorageMD5Service.remove(objectType);
    }
    /**
     * add  the  object
     * @memberof GenericService
     * @param {object} object The object to save
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor
     */


    function add(obj, type, callback) {
      var objects = list(type, callback);
      objects.push(obj);
      saveAll(objects, type, callback);
    }
    /**
     * Create a new  object
     * @memberof GenericService
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} object
     */


    function constructor(callback) {
      var object = new callback();
      return object;
    }
    /**
     * Extend given object 
     * @memberof GenericService
     * @param {object} obj The object that will be extended
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} object
     */


    function fromObject(obj, callback) {
      if (obj == null) return null;
      var object = new callback();
      angular.extend(object, obj);
      return object;
    }

    ;
    /**
     * Extend given object list
     * @memberof GenericService
     * @param {array} objList The list of objects that will be extended
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} objList
     */

    function fromObjectList(objList, callback) {
      if (objList == null) return [];
      var arrayLength = objList.length;
      var objects = new Array();

      for (var i = 0; i < arrayLength; i++) {
        objects.push(fromObject(objList[i], callback));
      }

      return objects;
    }

    ;
    /**
     * Update object in local storage - Search it by filters
     * @param {object} object The objects to save
     * @param {array} filters Array of property-value pairs to act as ids 
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback  A callback function that behaves as a constructor
     */

    function saveByFilter(object, filters, type, callback) {
      initiate(type, callback);
      var objects = list(type, callback);
      var updatedobject = fromObject(object, callback);
      var arrayLength = objects.length;

      for (var j = 0; j < arrayLength; j++) {
        var retVal = true;
        var storageObject = objects[j];

        for (var i = 0; i < filters.length; i++) {
          if (storageObject[filters[i][0]] != filters[i][1]) {
            retVal = false;
            break;
          }
        }

        if (retVal) {
          objects[j] = updatedobject;
          break;
        }
      }

      saveAll(objects, type, callback);
    }
    /**
     * Remove object from local strage - Search it by filters
     * @param {array} filters Array of property-value pairs to act as ids 
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback  A callback function that behaves as a constructor
     */


    function removeByFilter(filters, type, callback) {
      initiate(type, callback);
      var objects = list(type, callback);
      var newObjects = [];
      var arrayLength = objects.length;

      for (var j = 0; j < arrayLength; j++) {
        var storageObject = objects[j];

        for (var i = 0; i < filters.length; i++) {
          if (storageObject[filters[i][0]] != filters[i][1]) {
            newObjects.push(storageObject);
            break;
          }
        }
      }

      saveAll(newObjects, type, callback);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('GenericValuesFactory', GenericValuesFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name GenericValuesFactory
  * @description 
  *    Generic add, edit or remove for list of values
  * @ngInject
  */

  function GenericValuesFactory(localStorageMD5Service) {
    var service = {
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      objList: objList,
      getValuesFromStorage: getValuesFromStorage,
      setValuesToStorage: setValuesToStorage,
      clearValuesFromStorage: clearValuesFromStorage,
      getValuesFromStorageAsStrings: getValuesFromStorageAsStrings
    };
    /**
     * Extend given object 
     * @memberof GenericValuesFactory
     * @param {object} obj The object that will be extended
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} object
     */

    function fromObject(obj, callback) {
      if (obj == null) return null;
      var newObj = new callback();
      newObj.Code = obj;
      return newObj;
    }

    ;
    /**
     * Extend given object list
     * @memberof GenericValuesFactory
     * @param {array} objList The list of objects that will be extended
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} objList
     */

    function fromObjectList(objList, callback) {
      if (objList == null) return null;
      var arrayLength = objList.length;
      var newObjList = [];

      for (var i = 0; i < arrayLength; i++) {
        var newObj = new callback();
        newObj.Code = objList[i];
        newObjList.push(newObj);
      }

      return newObjList;
    }

    ;
    /**
     * Get all the object's Code from given list
     * @memberof GenericValuesFactory
     * @param {array} objectList An object list
     * @returns {array} objectList
     */

    function objList(objList) {
      if (objList == null) return [];
      var arrayLength = objList.length;
      var newObjList = [];

      for (var i = 0; i < arrayLength; i++) {
        newObjList.push(objList[i].Code);
      }

      return newObjList;
    }

    ;
    /**
     * Get all the objects
     * @memberof GenericValuesFactory
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {array} objectList
     */

    function getValuesFromStorage(callback, type) {
      var objects = localStorageMD5Service.get(type);
      return fromObjectList(objects, callback);
    }
    /**
     * Set all the objects
     * @memberof GenericValuesFactory
     * @param {array} objects A list of objects.
     * @param {string} type A string which identifies the local storage name
     */


    function setValuesToStorage(objects, type) {
      localStorageMD5Service.set(type, objects);
    }
    /**
     * Remove all the objects
     * @memberof GenericValuesFactory
     * @param {string} type A string which identifies the local storage name
     */


    function clearValuesFromStorage(type) {
      localStorageMD5Service.remove(type);
    }
    /**
     * Get all the objects codes from local storage
     * @memberof GenericValuesFactory
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {array} objectList
     */


    function getValuesFromStorageAsStrings(callback, type) {
      var result = [];
      var objs = getValuesFromStorage(callback, type);

      if (objs != null || objs != undefined) {
        for (var i = 0; i < objs.length; i++) {
          result.push(objs[i].Code);
        }
      }

      return result;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('IndexedDBService', IndexedDBService);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name IndexedDBService
   * @description 
   *    Generic add, edit or remove for IndexedDB
   * @ngInject
   */

  function IndexedDBService($q, LogService) {
    var idbSupported = "indexedDB" in window;

    if (!idbSupported) {
      LogService.debug("No IndexedDb is supported for this browser's version");
    }

    return {
      /**
       * initiate or update indexedDB storage
       * @memberof IndexedDBService
       * @returns {object} promise
       */
      init: function init() {
        var deferred = $q.defer();
        var request = indexedDB.open("a3.cabin.reports", 11);

        request.onupgradeneeded = function (e) {
          // The database did not previously exist, so create object stores and indexes.
          var db = request.result;

          if (e.oldVersion < 1) {
            var gameStore = db.createObjectStore("Memos", {
              keyPath: "Id"
            });
            gameStore.createIndex("id_idx", "Id", {
              unique: true
            });
          }

          if (e.oldVersion < 2) {
            var gameStore1 = db.createObjectStore("MemoImages", {
              keyPath: "imageId"
            });
            gameStore1.createIndex("id_idx", "imageId", {
              unique: true
            });
            gameStore1.createIndex("memoId", "memoId", {
              unique: false
            });
          }

          if (e.oldVersion < 5 && !db.objectStoreNames.contains('PaxInfo')) {
            var gameStore2 = db.createObjectStore("PaxInfo", {
              keyPath: "FlightId"
            });
            gameStore2.createIndex("id_idx", "FlightId", {
              unique: true
            });
          }

          if (e.oldVersion <= 6 && !db.objectStoreNames.contains('Reports')) {
            var gameStore3 = db.createObjectStore("Reports", {
              keyPath: "FlightId"
            });
            gameStore3.createIndex("id_idx", "FlightId", {
              unique: true
            });
          }

          if (e.oldVersion <= 7 && !db.objectStoreNames.contains('Courses')) {
            var gameStore3 = db.createObjectStore("Courses", {
              keyPath: "Id"
            });
            gameStore3.createIndex("id_idx", "Id", {
              unique: true
            });
            var store4 = db.createObjectStore("TrainingSessions", {
              keyPath: ['day', 'courseId', 'dutyId']
            });
            store4.createIndex("id_idx", ['day', 'courseId', 'dutyId'], {
              unique: true
            });
            store4.createIndex("day_idx", "day", {
              unique: false
            });
            store4.createIndex("courseId_idx", "courseId", {
              unique: false
            });
          }

          if (e.oldVersion <= 8 && !db.objectStoreNames.contains('FlightSessions')) {
            var store = db.createObjectStore("FlightSessions", {
              keyPath: ['day', 'courseId', 'dutyNo', 'dutyDay']
            });
            store.createIndex("id_idx", ['day', 'courseId', 'dutyNo', 'dutyDay'], {
              unique: true
            });
            store.createIndex("day_idx", "day", {
              unique: false
            });
            store.createIndex("courseId_idx", "courseId", {
              unique: false
            });
          }

          if (e.oldVersion <= 9 && !db.objectStoreNames.contains('ToolkitItems')) {
            var gameStore2 = db.createObjectStore("ToolkitItems", {
              keyPath: "Id"
            });
            gameStore2.createIndex("id_idx", "Id", {
              unique: true
            });
          }

          if (e.oldVersion <= 10 && !db.objectStoreNames.contains('PassengerMealServices')) {
            var gameStore = db.createObjectStore("PassengerMealServices", {
              keyPath: "Id"
            });
            gameStore.createIndex("id_idx", "Id", {
              unique: true
            });
          }

          if (e.oldVersion <= 11 && !db.objectStoreNames.contains('AllExpiries')) {
            var gameStore = db.createObjectStore("AllExpiries", {
              keyPath: "ExpiryTypeId"
            });
            gameStore.createIndex("id_idx", "ExpiryTypeId", {
              unique: true
            });
          }
        };

        request.onsuccess = function () {
          deferred.resolve(request.result);
        };

        request.onerror = function () {
          LogService.error(request.error);
          deferred.reject(request.error);
        };

        return deferred.promise;
      },
      deleteDatabase: function deleteDatabase(callback) {
        var deferred = $q.defer();
        var request = indexedDB.deleteDatabase("a3.cabin.reports");

        request.onsuccess = function () {
          deferred.resolve();
        };

        request.onerror = function (ex) {
          deferred.reject(ex);
        };

        request.onabort = function (ex) {
          deferred.reject(ex);
        };

        return deferred.promise;
      },
      info: function info(storeName) {
        var deferred = $q.defer();

        var info = function info(db) {
          var tx = db.transaction([storeName], "readonly");
          var store = tx.objectStore(storeName);
          store.indexNames;
          store.keyPath;
          var indexes = "No indexes Found";

          if (store.indexNames && store.indexNames.length > 0) {
            indexes = "Indexes :: ";

            for (var i = 0; i < store.indexNames.length; i++) {
              if (i < store.indexNames.length - 1) {
                indexes = indexes + store.indexNames[i] + ",";
              } else {
                indexes = indexes + store.indexNames[i];
              }
            }
          }

          var keypath = store.keyPath ? "Keypath :: " + store.keyPath : "No keypath";
          var errorMsg = "Store ::" + storeName + " - " + indexes + " - " + keypath;
          LogService.debug(errorMsg);

          tx.oncomplete = function (e) {
            // All requests have succeeded and the transaction has committed.
            deferred.resolve();
          };

          tx.onerror = function (ex) {
            deferred.reject(ex);
          };

          tx.onabort = function (ex) {
            deferred.reject(ex);
          };
        };

        if (idbSupported) {
          this.init().then(info);
        } else {
          deferred.resolve();
        }

        return deferred.promise;
      },

      /**
       * Add  the  object
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {object} entity The object to add
       * @returns {object} promise
       */
      add: function add(storeName, entity) {
        var deferred = $q.defer();

        var add = function add(db) {
          var tx = db.transaction([storeName], "readwrite");
          var store = tx.objectStore(storeName);
          store.add(entity);

          tx.oncomplete = function (e) {
            // All requests have succeeded and the transaction has committed.
            deferred.resolve(entity.id);
          };

          tx.onerror = function (ex) {
            deferred.reject(ex);
          };

          tx.onabort = function (ex) {
            deferred.reject(ex);
          };
        };

        if (idbSupported) {
          this.init().then(add);
        } else {
          deferred.resolve();
        }

        return deferred.promise;
      },

      /**
       * Add all the  objects
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {array} entity The objects to add
       * @returns {object} promise
       */
      addAll: function addAll(storeName, entity) {
        var deferred = $q.defer();

        var add = function add(db) {
          var tx = db.transaction([storeName], "readwrite");
          var store = tx.objectStore(storeName);
          var count = 0; //Insert several objects: [{obj},{obj},{obj}]

          for (var i = 0; i < entity.length; i++) {
            store.add(entity[i]);
            count++;
          }

          tx.oncomplete = function (e) {
            // All requests have succeeded and the transaction has committed.
            deferred.resolve(count);
          };

          tx.onerror = function (ex) {
            deferred.reject(ex);
          };

          tx.onabort = function (ex) {
            deferred.reject(ex);
          }; //db.close();

        };

        if (idbSupported) {
          this.init().then(add);
        } else {
          deferred.resolve();
        }

        return deferred.promise;
      },

      /**
       * update object
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {array} entity The object to update
       * @returns {object} promise
       */
      put: function put(storeName, entity) {
        var deferred = $q.defer();

        var put = function put(db) {
          var tx = db.transaction([storeName], "readwrite");
          var store = tx.objectStore(storeName);
          store.put(entity);

          tx.oncomplete = function () {
            // All requests have succeeded and the transaction has committed.
            deferred.resolve(tx.result);
          };

          tx.onerror = function () {
            deferred.reject(tx);
          };

          tx.onabort = function () {
            deferred.reject(tx);
          };
        };

        if (idbSupported) {
          this.init().then(put);
        } else {
          deferred.resolve();
        }

        return deferred.promise;
      },

      /**
       * Get the requested object by the default index
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {number} id The unique identifier
       * @returns {object} promise
       */
      getById: function getById(storeName, id) {
        var deferred = $q.defer();

        var getById = function getById(db) {
          var tx = db.transaction([storeName], "readonly");
          var store = tx.objectStore(storeName);
          var index = store.index("id_idx");
          var request = index.get(id);

          request.onsuccess = function () {
            deferred.resolve(request.result);
          };

          request.onerror = function () {
            deferred.reject(request.error);
          };

          tx.onabort = function () {
            deferred.reject(tx.error);
          };
        };

        if (idbSupported) {
          this.init().then(getById);
        } else {
          deferred.resolve(null);
        }

        return deferred.promise;
      },

      /**
       * Get the requested object by the selected index
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {string} indexName A string which identifies the index name
       * @param {number} id The unique identifier
       * @returns {object} promise
       */
      getByIndex: function getByIndex(storeName, indexName, value) {
        var deferred = $q.defer();

        var getByIndex = function getByIndex(db) {
          var tx = db.transaction([storeName], "readonly");
          var store = tx.objectStore(storeName);
          var index = store.index(indexName);
          var request = index.openCursor(IDBKeyRange.only(value)); //IDBKeyRange.only(value)

          var results = [];

          request.onsuccess = function () {
            var cursor = request.result;

            if (cursor) {
              results.push(cursor.value);
              cursor["continue"]();
            } else {
              deferred.resolve(results);
            }
          };

          request.onerror = function (r) {
            deferred.reject(r.error);
          };

          tx.onabort = function (r) {
            deferred.reject(r.error);
          };
        };

        if (idbSupported) {
          this.init().then(getByIndex);
        } else {
          deferred.resolve(null);
        }

        return deferred.promise;
      },

      /**
       * Get the all objects of the selected store
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {string} indexName A string which identifies the index name (optional)
       * @returns {object} promise
       */
      getAll: function getAll(storeName, indexName) {
        var deferred = $q.defer();
        if (indexName === undefined) indexName = 'id_idx';

        var all = function all(db) {
          var tx = db.transaction([storeName], "readonly");
          var store = tx.objectStore(storeName); //var index = store.index(indexName);

          var request = store.openCursor(); //IDBKeyRange.only("Fred")

          var results = [];

          request.onsuccess = function () {
            var cursor = request.result;

            if (cursor) {
              results.push(cursor.value);
              cursor["continue"]();
            } else {
              deferred.resolve(results);
            }
          };

          request.onerror = function () {
            LogService.error(request.error);
            deferred.reject(request.error);
          };

          tx.onabort = function () {
            deferred.reject(tx.error);
          };
        };

        if (idbSupported) {
          this.init().then(all);
        } else {
          deferred.resolve([]);
        }

        return deferred.promise;
      },

      /**
       * Count  all objects of the selected store
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {string} indexName A string which identifies the index name (optional)
       * @returns {object} promise
       */
      count: function count(storeName, indexName) {
        var deferred = $q.defer();
        if (indexName === undefined) indexName = 'id_idx';

        var count = function count(db) {
          var tx = db.transaction([storeName], "readonly");
          var store = tx.objectStore(storeName);
          var index = store.index(indexName);
          var request = index.count();

          request.onsuccess = function () {
            deferred.resolve(request.result);
          };

          request.onerror = function () {
            deferred.reject(request.error);
          };

          tx.onabort = function () {
            deferred.reject(tx.error);
          };
        };

        if (idbSupported) {
          this.init().then(count);
        } else {
          deferred.resolve(0);
        }

        return deferred.promise;
      },

      /**
       * Delete the requested object
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {number} id The unique identifier
       * @returns {object} promise
       */
      remove: function remove(storeName, id) {
        var deferred = $q.defer();

        var remove = function remove(db) {
          var tx = db.transaction([storeName], "readwrite");
          var store = tx.objectStore(storeName);
          store["delete"](id);

          tx.oncomplete = function (e) {
            // All requests have succeeded and the transaction has committed.
            deferred.resolve(id);
          };

          tx.onerror = function (r) {
            deferred.reject(r.error);
          };

          tx.onabort = function (r) {
            deferred.reject(r.error);
          };
        };

        if (idbSupported) {
          this.init().then(remove);
        } else {
          deferred.resolve();
        }

        return deferred.promise;
      },

      /**
       * Delete the requested object by the selected index
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {string} indexName A string which identifies the index name (optional)
       * @param {number} id The unique identifier
       * @returns {object} promise
       */
      removeByIndex: function removeByIndex(storeName, indexName, value) {
        var deferred = $q.defer();

        var removeByIndex = function removeByIndex(db) {
          var tx = db.transaction([storeName], "readwrite");
          var store = tx.objectStore(storeName);
          var index = store.index(indexName);
          var request = index.openKeyCursor(IDBKeyRange.only(value)); //IDBKeyRange.only(value)

          var results = [];

          request.onsuccess = function () {
            var cursor = request.result;

            if (cursor) {
              store["delete"](cursor.primaryKey);
              cursor["continue"]();
            } else {
              deferred.resolve(results);
            }
          };

          request.onerror = function (r) {
            deferred.reject(r.error);
          };

          tx.onabort = function (r) {
            deferred.reject(r.error);
          };
        };

        if (idbSupported) {
          this.init().then(removeByIndex);
        } else {
          deferred.resolve();
        }

        return deferred.promise;
      },

      /**
       * Delete all the objects
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @returns {object} promise
       */
      removeAll: function removeAll(storeName) {
        var deferred = $q.defer();

        var remove = function remove(db) {
          var tx = db.transaction([storeName], "readwrite");
          var store = tx.objectStore(storeName);
          store.clear();

          tx.oncomplete = function (e) {
            // All requests have succeeded and the transaction has committed.
            deferred.resolve('success');
          };

          tx.onerror = function (r) {
            deferred.reject(r.error);
          };

          tx.onabort = function (r) {
            deferred.reject(r.error);
          }; //db.close();

        };

        if (idbSupported) {
          this.init().then(remove);
        } else {
          deferred.resolve();
        }

        return deferred.promise;
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('ModalDialogResultFactory', ModalDialogResultFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name ModalDialogResultFactory
  * @description 
  *    Modal Dialog Creator
  * @ngInject
  */

  function ModalDialogResultFactory() {
    /**
    * Initialize the ModalDialogResult
    * @memberof ModalDialogResultFactory
    */
    function ModalDialogResult() {
      this.IsInsertMode = null;
      this.Object = null;
    }

    var service = {
      createNew: createNew
    };
    /**
    * Create a new  ModalDialogResult object
    * @memberof ModalDialogResultFactory
    * @returns {object} object
    */

    function createNew() {
      return new ModalDialogResult();
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.service("PushNotifier", PushNotifier);
  /**
  * @memberof CabinReports
  * @ngdoc service
  * @name PushNotifier
  * @description 
  *  Push notification functionality
  * @ngInject
  */

  function PushNotifier($q, FlightFactory, PaxInfoFactory) {
    var service = {
      Generate: Generate,
      formatInfoToCompare: formatInfoToCompare,
      compareAndExtractChanges: compareAndExtractChanges,
      MessageGenerator: BodyGenerator,
      CheckForPermissionsAndSupport: CheckForPermissionsAndSupport
    };
    var browserSupportsNotifications = "Notification" in window;

    function CheckForPermissionsAndSupport() {
      var deferred = $q.defer(); // Let's check if the browser supports notifications

      if (!browserSupportsNotifications) {
        console.debug("This browser does not support system notifications");
        deferred.resolve(false);
      } // // Otherwise, we need to ask the user for permission


      if (browserSupportsNotifications && Notification.permission !== 'denied') {
        var permissionQ = Notification.requestPermission();

        if (permissionQ) {
          permissionQ.then(function (result) {
            var value = result === "granted";
            deferred.resolve(value);
          }), function (reason) {
            LogService.error(reason);
            deferred.reject(reason);
          };
        } else {
          deferred.resolve(false);
        }
      } else {
        deferred.resolve(false);
      }

      return deferred.promise;
    }

    function Generate(title, body) {
      // Let's check whether notification permissions have already been granted
      if (browserSupportsNotifications && Notification.permission === "granted") {
        // If it's okay let's create a notification
        var notification = new Notification(title, {
          body: body,
          icon: './img/a3_logo.png'
        });
        setTimeout(function () {
          notification.close();
        }, 5000);
      }
    }

    function formatInfoToCompare(flightId) {
      var flightInfo = FlightFactory.getFlightFromStorage(flightId);
      var data = {
        CTOT: flightInfo.CTOT,
        ATD: flightInfo.ATD,
        ETA: flightInfo.ETA,
        ETD: flightInfo.ETD
      };
      data['Departure Gate'] = flightInfo.DepartureGate;
      data['Departure Stand'] = flightInfo.DepartureStand;
      data['Scheduled Departure Time UTC'] = flightInfo.ScheduledDepartureTimeUTC;
      var deferred = $q.defer();
      PaxInfoFactory.getPaxInfoFromStorage(flightId, function (paxinfo) {
        data['Passenger Info'] = paxinfo ? moment.utc(paxinfo.LastRun).format('dd-MM-yyyy HH:mm') : null;
        deferred.resolve(data);
      });
      return deferred.promise;
    }

    function compareAndExtractChanges(currentData, updatedData) {
      var changes = [];

      for (var key in currentData) {
        if (currentData[key] != updatedData[key]) {
          var ovalue = currentData[key];
          var nvalue = updatedData[key];

          if (key === "CTOT" || key === "ATD" || key === "ETA" || key === "ETD" || key === "Scheduled Departure Time UTC") {
            if (currentData[key] != null) {
              ovalue = moment.utc(currentData[key]).format('HH:mm');
            }

            if (updatedData[key] != null) {
              nvalue = moment.utc(updatedData[key]).format('HH:mm');
            }
          }

          changes.push({
            type: key,
            oldValue: ovalue,
            newValue: nvalue
          });
        }
      }

      return changes;
    }

    function BodyGenerator(changes) {
      var message = '';
      changes.forEach(function (x) {
        var phrase = null;

        if (x.type == 'Passenger Info') {
          phrase = "Passenger Info have been updated. \n";
        } else if (!x.oldValue) {
          phrase = x.type + ": " + x.newValue + " \n";
        } else if (x.oldValue && x.newValue) {
          phrase = x.type + ": " + x.oldValue + "\u2192" + x.newValue + " \n";
        } else {
          phrase = x.type + " has no value\n";
        }

        message = message + phrase;
      });
      return message;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.filter('search', search);
  /**
  * @memberof CabinReports
  * @ngdoc filter
  * @name search
  * @description 
  * @ngInject
  */

  function search() {
    /**
     * Filter available toolkit items by search text
     * @param {array} itemArray Array to be filtered
     * @param {string} text Search text input 
     */
    return function (itemArray, text) {
      if (!itemArray || text == undefined || text == null) {
        return [];
      }

      if (!text.length) {
        return itemArray;
      }

      var searchRegex = /[ ,;]+/;
      var searchWords = text.toLowerCase().split(searchRegex);
      searchWords = searchWords.filter(function (x) {
        return x.length > 0;
      }); //FOR FUTURE: Add Dynamic fields for search

      return itemArray.filter(function (x) {
        return searchWords.some(function (y) {
          return x.Title.toLowerCase().includes(y);
        }) || searchWords.some(function (y) {
          return x.Description.toLowerCase().includes(y);
        }) || searchWords.some(function (y) {
          return x.Comments && x.Comments.toLowerCase().includes(y);
        }) || searchWords.some(function (y) {
          return x.Tags.some(function (t) {
            return t.toLowerCase().includes(y);
          });
        });
      });
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('SettingsMain', SettingsMain);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name SettingsMain
  * @description 
  *    Generic add, edit or remove
  * @ngInject
  */

  function SettingsMain($log, localStorageMD5Service, FlightFactory) {
    /**
    * Initialize the PageMainSettings
    * @memberof SettingsMain
    */
    function PageMainSettings() {
      this.EditingPage = null;
      this.IsAssessmentEnabled = null;
      this.calendarViewStyle = null;
      this.selectedDate = null;
      this.IsShopInTheCloudEnable = null;
    }

    var service = {
      getSettings: getSettings,
      setSettings: setSettings,
      getEditingPage: getEditingPage,
      setEditingPage: setEditingPage,
      setIsAssessmentEnabled: setIsAssessmentEnabled,
      getIsAssessmentEnabled: getIsAssessmentEnabled,
      setIsShopInTheCloudEnable: setIsShopInTheCloudEnable,
      getIsShopInTheCloudEnable: getIsShopInTheCloudEnable,
      setCalendarViewStyle: setCalendarViewStyle,
      getCalendarViewStyle: getCalendarViewStyle,
      getCalendarSelectedDate: getCalendarSelectedDate,
      setCalendarSelectedDate: setCalendarSelectedDate
    }; //factory functions

    /**
    * Get Application Settings
    * @memberof SettingsMain
    * @returns {object} settings 
    */

    function getSettings() {
      var settings = new PageMainSettings();
      var settingsStored = localStorageMD5Service.get('settingsMain');

      if (settingsStored) {
        if (settingsStored.EditingPage) settings.EditingPage = settingsStored.EditingPage;
        settings.IsAssessmentEnabled = settingsStored.IsAssessmentEnabled;
        settings.calendarViewStyle = settingsStored.calendarViewStyle;
        settings.selectedDate = settingsStored.selectedDate;
        settings.IsShopInTheCloudEnable = settingsStored.IsShopInTheCloudEnable;
      }

      return settings;
    }
    /**
        * Set Application Settings
        * @param {object} settings
        * @memberof SettingsMain
        */


    function setSettings(settings) {
      localStorageMD5Service.set('settingsMain', settings);
    }
    /**
     * Get editing page
     * @memberof SettingsMain
     * @returns {string} EditingPage
     */


    function getEditingPage() {
      var settings = getSettings();
      return settings.EditingPage;
    }
    /**
     * Set editing page
     * @param {string} value
     * @memberof SettingsMain
     */


    function setEditingPage(value) {
      var settings = getSettings();
      settings.EditingPage = value;
      setSettings(settings);
    }
    /**
     * Get if  assessment  is enabled
     * @memberof SettingsMain
     * @returns {boolean} isEnabled
     */


    function getIsAssessmentEnabled() {
      var settings = getSettings();
      var isEnabled = settings.IsAssessmentEnabled;

      if (isEnabled) {
        var flights = FlightFactory.getFlightsFromStorage();

        if (flights) {
          for (var i = 0; i < flights.length; i++) {
            if ((flights[i].AcType == 'DH4' || flights[i].AcType == 'DH8' || flights[i].AcType == 'AT4') && flights[i].isDHC) {
              isEnabled = false;
              break;
            }
          }
        }
      }

      return isEnabled;
    }
    /**
     * Set if  assessment  is enabled
     * @param {string} value
     * @memberof SettingsMain
     */


    function setIsAssessmentEnabled(value) {
      var settings = getSettings();
      settings.IsAssessmentEnabled = value;
      setSettings(settings);
    }
    /**
     * Set if  ShopInTheCloud  is enabled
     * @param {string} value
     * @memberof SettingsMain
     */


    function setIsShopInTheCloudEnable(value) {
      var settings = getSettings();
      if (!value) value = false;
      settings.IsShopInTheCloudEnable = value;
      setSettings(settings);
    }

    function getIsShopInTheCloudEnable() {
      var settings = getSettings();
      return settings.IsShopInTheCloudEnable;
    }
    /**
    * Get prefered calendar view style
    * @memberof SettingsMain
    * @returns {string} viewStyle
    */


    function getCalendarViewStyle() {
      var settings = getSettings();
      var viewStyle = settings.calendarViewStyle;
      return viewStyle;
    }
    /**
     * Set prefered calendar view style
     * @param {string} value
     * @memberof SettingsMain
     */


    function setCalendarViewStyle(value) {
      var settings = getSettings();
      settings.calendarViewStyle = value;
      setSettings(settings);
    }
    /**
     * Get selected calendar date
     * @memberof SettingsMain
     * @returns {string} selectedDate
     */


    function getCalendarSelectedDate() {
      var settings = getSettings();
      var selectedDate = settings.selectedDate;
      return selectedDate;
    }
    /**
     * Set selected calendar date
     * @param {string} value
     * @memberof SettingsMain
     */


    function setCalendarSelectedDate(value) {
      var settings = getSettings();
      settings.selectedDate = value;
      setSettings(settings);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('TimeLogFactory', TimeLogFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name TimeLogFactory
  * @description 
  *   Get list, Update list & Acknowledge schedule changes
  * @ngInject
  */

  function TimeLogFactory(GenericService) {
    /**
     * Initialize the ScheduleChanges
     * @memberof TimeLogFactory
     */
    function TimeLog() {
      this.Date = null;
      this.ClientTimeLog = "";
      this.ApiTimeLog = "";
    }

    var objType = 'timeLogs';
    var objCallback = TimeLog;
    var service = {
      timeLogToStorage: timeLogToStorage,
      cleanOldData: cleanOldData
    };
    /**
     * Save all time logs to storage
     * @memberof TimeLogFactory
     * @param {Array} CrewPhoneNumbers
     */

    function setTimeLogsToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }
    /**
     * get all time logs from storage
     * @memberof TimeLogFactory
     */


    function getTimeLogsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Save the time log to storage
           * @memberof TimeLogFactory
     * @param  clientTimeLog 
           * @param  apiTimeLog 
     */


    function timeLogToStorage(timeLogStr, apiTimelog) {
      var timeLog = new TimeLog();
      timeLog.Date = moment.utc();
      timeLog.ClientTimeLog = timeLogStr;
      timeLog.ApiTimeLog = apiTimelog;
      GenericService.add(timeLog, objType, objCallback);
    }
    /**
    * Clean old time logs
    */


    function cleanOldData() {
      var now = moment();
      var timeLogs = getTimeLogsFromStorage();
      var latestTimeLogs = []; //Filter out crew check-ins of old flights

      timeLogs.forEach(function (x) {
        var date = moment(x.Date);

        if (now.diff(date, 'days') < 2) {
          latestTimeLogs.push(x);
        }
      });
      setTimeLogsToStorage(latestTimeLogs);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.service("UpdateService", UpdateService);
  /**
  * @memberof CabinReports
  * @ngdoc service
  * @name UpdateService
  * @description 
  *  Update functionality
  * @ngInject
  */

  function UpdateService(SyncLogFactory) {
    /**
     * Version patcher
     * @memberof UpdateService
     * @returns {string} NeedsSync 
     */
    function patcher(version) {
      var NeedsSync = false;

      if (version == "1.0") {
        SyncLogFactory.updateSyncVersion("1.1"); //patching to next version

        patcher("1.1");
        NeedsSync = true;
      } else if (version == "1.1") {
        SyncLogFactory.updateSyncVersion("1.2"); //patching to next version
        //patcher("1.2");

        NeedsSync = true;
      }

      return NeedsSync;
    }

    return {
      /**
       * updates application 
       * @memberof UpdateService
       * @returns {string} NeedsSync 
       */
      updater: function updater() {
        var synclog = SyncLogFactory.getSyncLog();

        if (synclog == undefined || synclog == null) {
          return false;
        } else if (synclog.isUpdated) {
          return true;
        } else {
          var NeedsSync = patcher(synclog.version);
          return NeedsSync;
        }
      }
    };
  }
})();
"use strict";

// create guid
var guid = function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return function () {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  };
}(); // generic sort function


var sort_by = function sort_by(field, reverse, primer) {
  var key = function key(x) {
    return primer ? primer(x[field]) : x[field];
  };

  return function (a, b) {
    var A = key(a),
        B = key(b);
    return (A < B ? -1 : A > B ? 1 : 0) * [-1, 1][+!!reverse];
  };
}; //used to adjust textarea to fit their content


var autoAdjustTextarea = function autoAdjustTextarea(element) {
  try {
    if (element) {
      //element appears to have 0 scrollHeight when hidden (parent is hidden etc)
      if (element.scrollHeight > 0) {
        element.style.overflow = 'hidden';
        element.style.height = 0;

        if (element.scrollHeight > 40) {
          element.style.height = element.scrollHeight + 'px';
        } else {
          element.style.height = 40 + 'px';
        }
      }
    }
  } catch (e) {}
};
"use strict";

(function () {
  "use strict";

  a3_cabin_reports.factory("AirlineInfoFactory", AirlineInfoFactory);
  /**
   * Stores crew airline infos/options and backend default selection (FleetId).
   * @ngInject
   */

  function AirlineInfoFactory() {
    var service = {
      // Legacy metadata (company/aoc/address/licenses)
      setCrewAirlineInfos: setCrewAirlineInfos,
      getCrewAirlineInfos: getCrewAirlineInfos,
      clearCrewAirlineInfosFromStorage: clearCrewAirlineInfosFromStorage,
      // Options from active qualifications
      setCrewAirlineOptions: setCrewAirlineOptions,
      getCrewAirlineOptions: getCrewAirlineOptions,
      clearCrewAirlineOptionsFromStorage: clearCrewAirlineOptionsFromStorage,
      // Backend default FleetId
      setDefaultFleetId: setDefaultFleetId,
      getDefaultFleetId: getDefaultFleetId,
      clearDefaultFleetIdFromStorage: clearDefaultFleetIdFromStorage
    };

    function setCrewAirlineInfos(infos) {
      localStorage.setItem("crewAirlineInfos", JSON.stringify(infos || []));
    }

    function getCrewAirlineInfos() {
      return JSON.parse(localStorage.getItem("crewAirlineInfos")) || [];
    }

    function clearCrewAirlineInfosFromStorage() {
      localStorage.removeItem("crewAirlineInfos");
    }

    function setCrewAirlineOptions(options) {
      localStorage.setItem("crewAirlineOptions", JSON.stringify(options || []));
    }

    function getCrewAirlineOptions() {
      return JSON.parse(localStorage.getItem("crewAirlineOptions")) || [];
    }

    function clearCrewAirlineOptionsFromStorage() {
      localStorage.removeItem("crewAirlineOptions");
    }

    function setDefaultFleetId(fleetId) {
      if (fleetId === null || fleetId === undefined || fleetId === "") {
        localStorage.removeItem("defaultFleetId");
        return;
      } // Store as string, parse later


      localStorage.setItem("defaultFleetId", String(fleetId));
    }

    function getDefaultFleetId() {
      var v = localStorage.getItem("defaultFleetId");
      if (!v) return null;
      var n = Number(v);
      return isNaN(n) ? null : n;
    }

    function clearDefaultFleetIdFromStorage() {
      localStorage.removeItem("defaultFleetId");
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('BucketCtrl', BucketCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name BucketCtrl
  * @description 
  *   View bucket
  * @ngInject
  */

  function BucketCtrl($scope, $location, BucketFactory, UserFactory, MessageFactory, $timeout, SettingsMain, defaultBucketDate) {
    var ownDuties = [];
    var sharedDuties = [];
    var approvedDuties = [];
    $scope.state = 'bucketCalendar';
    var user = UserFactory.getUser();
    $scope.isSecure = UserFactory.isSecure();
    $scope.isUserSA = user.position == 'SA' ? true : false;
    $scope.logged_user_info = user.aimsId + ' - ' + user.name;
    $scope.getCalendarData = getCalendarData;
    $scope.showErrorMessage = false;
    var selectedDate = SettingsMain.getCalendarSelectedDate(); //Redirect to month that was previously selected

    SettingsMain.setCalendarSelectedDate(null); //Then reinitialize to current month

    getCalendarData();

    function getCalendarData() {
      progressBarBox(true);
      BucketFactory.getDutyObject(function (responseData) {
        ownDuties = responseData.data.data.Duties;
        sharedDuties = responseData.data.data.SharedDuties;
        approvedDuties = responseData.data.data.ApprovedDuties;
        setupView();
        progressBarBox(false);
      })["catch"](function (error) {
        $scope.showErrorMessage = true;
        progressBarBox(false);
        console.error('Load duties error', error.status, error.statusText);
      });
    }

    function setupView() {
      if (!UserFactory.isLoggedIn()) {
        $location.path("/login");
      }

      $scope.number_of_messages = MessageFactory.getMessagesFromStorage().length;
      $scope.number_of_messages_not_readen = MessageFactory.getCountOfUnreadMessages();
      /*var ownEvents = formatDuties(ownDuties, true, false);
      if (sharedDuties.length > 0) {
          var sharedEvents = formatDuties(sharedDuties, false, false);
          var events = ownEvents.concat(sharedEvents);
      } else {
          var events = ownEvents;
      }*/

      $scope.notification = createNotification(ownDuties);
      var ownEvents = formatDuties(ownDuties, true, false);
      var events = ownEvents;

      if (approvedDuties != null || approvedDuties != undefined) {
        if (approvedDuties.length > 0) {
          var appvovedEvents = formatDuties(approvedDuties, true, true);
          var events = events.concat(appvovedEvents);
        }
      }

      calendar(events);
    }
    /**
     * Transform routes in calendar events
     * @memberof BucketCtrl
     * @param {array} routes - The Scheduled Routes 
     * @return {array} events 
     */


    function formatDuties(duties, isOwnDuty, isApproved) {
      var dutiesEvents = [];

      for (var i = 0; i < duties.length; i++) {
        if (duties[i].IsUpdated) {
          console.log(duties[i]);
        }
        /*************** Add main event for duty *********************/
        // var eType = (isOwnDuty ? 'own-' : 'shared-') + duties[i].DutyType.toLowerCase();


        var eClassName = getEventClassName(duties[i], isOwnDuty, isApproved);
        var eIcons = getEventIcons(duties[i], isOwnDuty, isApproved);
        var eTitle = getEventTitle(duties[i], isOwnDuty) + (duties[i].TotalSharedDuties == undefined ? "" : duties[i].TotalSharedDuties);
        var eOtherInfos = getOtherInfos(duties[i], isOwnDuty);
        var event = {
          _id: duties[i].Id,
          // type: eType,
          icons: eIcons,
          className: eClassName["class"],
          title: eTitle,
          start: duties[i].DutyBegin == duties[i].DutyEnd ? duties[i].DutyDateS : duties[i].DutyBegin,
          end: duties[i].DutyBegin == duties[i].DutyEnd ? null : duties[i].DutyEnd,
          sortOrder: isOwnDuty ? 1 : -1,
          otherInfos: eOtherInfos,
          shareable: duties[i].Shareable,
          isOwnDuty: isOwnDuty,
          isApproved: isApproved,
          isOwnApproved: duties[i].HasApprovedProposals,
          listViewColor: eClassName.color
        };
        dutiesEvents.push(event);
      }

      return dutiesEvents;
    }

    function createNotification(duties) {
      var NewPendingProposalsCount = 0;
      var NewApprovedProposalsCount = 0;
      var NewRejectedProposalsCount = 0;
      var notificationText = null;

      for (var i = 0; i < duties.length; i++) {
        if (duties[i].IsUpdated) {
          if (duties[i].HasApprovedProposals) {
            NewApprovedProposalsCount++;
          } else {
            NewPendingProposalsCount += duties[i].NewPendingProposalsCount;
            NewRejectedProposalsCount += duties[i].NewRejectedProposalsCount;
          }
        }
      }
      /* var notification = {
                   NewPendingProposalsCount : NewPendingProposalsCount,
                   NewApprovedProposalsCount : NewApprovedProposalsCount,
                   NewRejectedProposalsCount : NewRejectedProposalsCount
               }*/


      if (NewPendingProposalsCount + NewApprovedProposalsCount + NewRejectedProposalsCount > 0) {
        notificationText = "You have ";
        var hasPrevious = false;

        if (NewPendingProposalsCount) {
          notificationText = notificationText + NewPendingProposalsCount + " pending";
          hasPrevious = true;
        }

        if (NewRejectedProposalsCount) {
          var conjuction = hasPrevious ? NewApprovedProposalsCount ? ", " : " and " : "";
          notificationText = notificationText + conjuction + NewRejectedProposalsCount + " rejected";
          hasPrevious = true;
        }

        if (NewApprovedProposalsCount) {
          var conjuction = hasPrevious ? " and " : "";
          notificationText = notificationText + conjuction + NewApprovedProposalsCount + " accepted";
        }

        notificationText = notificationText + " proposals.";
      }

      return notificationText;
    }
    /**
     * Returns an array of strings for icons to display in the event tile
     * @memberof BucketCtrl
     * @param {object} duty - The Scheduled duty 
     * @param {boolean} ownDuty - Is set to true when the duty is current user's duty, otherwise is set to false
     * @return {array} icons - The array of strings for icons to display in the event tile.
     */


    function getEventIcons(duty, isOwnDuty, isApproved) {
      var icons = [];
      if (!isOwnDuty) icons.push('fa-sing-in');else {
        if (duty.IsUpdated) icons.push('fa-star text-orange');
        /*  if (duty.PendingProposalsCount > 0 && !isApproved) icons.push('fa-info-circle');*/

        if (!duty.Shareable || isApproved) icons.push('fa-lock');
        if (duty.Shared && !isApproved) icons.push('fa-bitbucket');
      }
      return icons;
    }
    /**
     * Returns the title for the event tile
     * @memberof BucketCtrl
     * @param {object} duty - The Scheduled duty 
     * @param {boolean} ownDuty - Is set to true when the duty is current user's duty, otherwise is set to false
     * @return {string} title - The title to display in the event tile.
     */


    function getEventTitle(duty, isOwnDuty) {
      var title = '';
      if (isOwnDuty) title += duty.Title;else title += 'Shared duties: ';
      return title;
    }
    /**
     * Returns the class for the event tile
     * @memberof BucketCtrl
     * @param {object} duty - The Scheduled duty 
     * @param {boolean} ownDuty - Is set to true when the duty is current user's duty, otherwise is set to false
     * @return {string} className - The class(es) to use for displaying the event tile.
     */


    function getEventClassName(duty, isOwnDuty, isApproved) {
      var eventClass = {
        "class": 'fc-bucket ',
        color: ''
      };

      if (isOwnDuty) {
        eventClass["class"] += 'fc-own ';
        var hasApprovedTrade = duty.HasApprovedProposals;

        if (isApproved == true) {
          eventClass["class"] += 'fc-green-inverted ';
          eventClass.color = 'lv-green-inverted';
        } else if (hasApprovedTrade) {
          eventClass["class"] += 'fc-green ';
          eventClass.color = 'lv-green';
        } else if (duty.Shared) {
          eventClass["class"] += 'fc-primary-inverted ';
          eventClass.color = 'lv-blue';
        }
        /*     else if (duty.Shareable && duty.PendingProposalsCount == 0) {
                eventClass.class += 'fc-blue ';
                eventClass.color = 'lv-blue';
            } else if (duty.PendingProposalsCount > 0) {
                eventClass.class += 'fc-orange ';
                eventClass.color = 'lv-orange';
            } else if (duty.Bookmarks != undefined && duty.Bookmarks.length > 0) {
                eventClass.class += 'fc-purple-inverted ';
                eventClass.color = 'lv-purple-inverted';
            } */
        else {
            eventClass["class"] += 'fc-white ';
            eventClass.color = 'lv-white';
          }
      } else {
        eventClass["class"] += 'fc-aluminum ';
        eventClass.color = 'lv-aluminum';
      }

      return eventClass;
    }
    /**
     * Returns an array of objects for infos (label, number) to display in the event tile
     * @memberof BucketCtrl
     * @param {object} duty - The Scheduled duty 
     * @param {boolean} ownDuty - Is set to true when the duty is current user's duty, otherwise is set to false
     * @return {array} infos - The array of objects for infos (label, number) to display in the event tile.
     */


    function getOtherInfos(duty, isOwnDuty) {
      var infos = [];

      if (isOwnDuty) {
        var hasApprovedTrade = duty.HasApprovedProposals;

        if (!hasApprovedTrade) {
          if (duty.PendingProposalsCount > 0) infos.push({
            label: 'Proposals',
            num: duty.PendingProposalsCount
          });
          if (duty.BookmarksCount > 0) infos.push({
            label: 'Bookmarks',
            num: duty.BookmarksCount
          }); // var totalBookmarks = (duty.bookmarks == undefined ? 0 : duty.bookmarks.length);
          // if (totalBookmarks > 0) infos.push({ label: 'Bookmarks', num: totalBookmarks.toString() });
        }
      } //  else {
      //     if (duty.TotalSharedDuties > 0) infos.push({ label: 'Total', num: duty.TotalSharedDuties.toString() });
      //     //if (duty.unclaimedShared > 0) infos.push({ label: 'Unclaimed', num: duty.unclaimedShared.toString() });
      // }


      return infos;
    }

    function calendar(events) {
      $('#calendar').fullCalendar('destroy');
      $("#calendar").fullCalendar({
        defaultView: getDefaultView(),
        defaultDate: defaultBucketDate,
        firstDay: 1,
        lang: 'en',
        editable: false,
        draggable: false,
        selectable: false,
        selectHelper: false,
        unselectAuto: false,
        disableResizing: false,
        droppable: false,
        fixedWeekCount: false,
        nextDayThreshold: "00:00:00",
        header: {
          left: 'title',
          center: '',
          right: 'month,listMonth today prev,next'
        },
        timeFormat: 'HH:mm',
        displayEventEnd: true,
        events: events,
        eventOrder: "sortOrder",
        eventRender: function eventRender(event, element, icon) {
          element.find('.fc-title').prepend("<br/>");

          if ($('#calendar').fullCalendar('getView').type === 'listMonth') {
            element.find('.fc-list-item-title').addClass('listview-icon');
            $.each(event.className, function (index, icon) {
              element.addClass(event.listViewColor);
            });
            $.each(event.icons, function (index, icon) {
              element.find('.listview-icon').prepend("<i style='padding-right:5px;' class='fa " + icon + " '></i> ");
            });

            if (event.otherInfos != null && event.otherInfos.length > 0) {
              $.each(event.otherInfos, function (index, info) {
                if (info.label == 'Proposals') element.find('.fc-list-item-title').append("<span class='badge badge-primary pull-right'>" + info.num + "</span>");
              });
            }
          } else {
            if (event.icons != null && event.icons.length > 0) {
              element.find('.fc-title').prepend("<span class='calendar-icon'></span>");
              $.each(event.icons, function (index, icon) {
                element.find('.calendar-icon').append("<i class='fa " + icon + " '></i> ");
              });
            }

            if (event.otherInfos != null && event.otherInfos.length > 0) {
              $.each(event.otherInfos, function (index, info) {
                element.find('.fc-title').append("<div class='small text-right'><strong>" + info.label + ": " + info.num + "</strong></div>");
                element.find('.fc-list-item-title').add("<span class='badge badge-primary pull-right'>" + info.num + "</span>");
              });
            }
          }
        },
        eventResize: function eventResize(event, delta, revertFunc) {
          changeView(detectMobile(), '#calendar');
        },
        dayRender: function dayRender(date, cell) {},
        // dayClick: function(date, jsEvent, view) {
        //     $timeout(function(){ gotoDayBucketView(date); })
        // },
        eventClick: function eventClick(calEvent, jsEvent, view) {
          if (calEvent.shareable == true && calEvent.isOwnDuty && (!calEvent.isApproved || calEvent.isOwnApproved)) {
            $timeout(function () {
              gotoDayBucketView(calEvent._id);
            });
          } else if (calEvent.shareable == false && calEvent.isOwnDuty) {
            if (!calEvent.isApproved) {
              //don't allow click for approved duty
              $timeout(function () {
                unableShare();
              });
            }
          }
        },
        height: 'auto'
      });
      $('.fc-listMonth-button').click(function () {
        SettingsMain.setCalendarViewStyle('listMonth');
      });
      $('.fc-month-button').click(function () {
        SettingsMain.setCalendarViewStyle('month');
      });

      if (selectedDate != null && selectedDate != undefined) {
        $("#calendar").fullCalendar('gotoDate', selectedDate);
      }
    }

    function getDefaultView() {
      var calendarStyle = SettingsMain.getCalendarViewStyle();

      if (calendarStyle == null) {
        calendarStyle = detectMobile() ? "listMonth" : "month";
      }

      return calendarStyle;
    }

    function detectMobile() {
      var isMobile = window.innerWidth <= 800 && window.innerHeight <= 735;
      return isMobile;
    }
    /**
     * Redirects to bucket calendar day 
     * @memberof BucketCtrl
     */


    function gotoDayBucketView(dutyId) {
      $location.path('/bucketDay/' + dutyId);
    }
  }

  function unableShare() {
    bootbox.dialog({
      message: "<div class='alert alert-warning'>You can't share this duty, please try another shareable duty.</div>",
      title: "Warning",
      buttons: {
        cancel: {
          label: "Close",
          className: "btn-default",
          callback: function callback() {}
        }
      }
    });
  }

  function progressBarBox(isOpen) {
    if (isOpen) {
      bootbox.dialog({
        closeButton: false,
        message: '<div class="text-center"><i class="fa fa-spin fa-spinner"></i> Please wait...</div>' //title: "Please wait..."

      });
    } else {
      bootbox.hideAll();
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('BucketFactory', BucketFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name BucketFactory
   * @description 
   * Get Duties from API 
   * @ngInject
   */

  function BucketFactory(GenericService, $http, $q, apiUrl, LogService) {
    /**
     * Initialize Bucket
     * @memberof BucketFactory
     */
    var service = {
      getDutyObject: getDutyObject,
      getDutyById: getDutyById,
      shareDuty: shareDuty,
      acknowledgeProposal: acknowledgeProposal,
      fetchProposal: fetchProposal,
      createProposal: createProposal,
      evaluateProposal: evaluateProposal,
      undoProposalStatus: undoProposalStatus,
      fetchSharedProposal: fetchSharedProposal
    };
    /**
     * Gets Bucket Calendar object
     * @memberof BucketFactory
     * @param {function} callback 
     */

    function getDutyObject(callback) {
      return $http.get(apiUrl + '/bucket/', {
        'Content-Type': 'application/json'
      }).then(callback);
    }
    /**
     * Gets duty object and shared duties object for the BucketDay View
     * @memberof BucketFactory
     * @param {number} dutyId 
     * @param {function} callback 
     */


    function getDutyById(dutyId, callback) {
      return $http.get(apiUrl + '/bucket/GetBucketDuty/' + dutyId, {
        'Content-Type': 'application/json'
      }).then(callback);
    }
    /**
     * Shares/Unshares duty
     * @memberof BucketFactory
     * @param {object} duty 
     * @param {function} callback 
     * @param {function} errorCallback 
     */


    function shareDuty(duty, callback, errorCallback) {
      //todo remove when api became correct
      var dutyMinified = {
        Id: duty.Id,
        Shareable: duty.Shareable,
        Shared: duty.Shared,
        Comments: duty.Comments,
        CrewInformation: {
          Email: null,
          Phone: null,
          Comments: null
        }
      };
      return $http.post(apiUrl + '/bucket/ShareDuty/', dutyMinified, {
        'Content-Type': 'application/json'
      }).then(callback)["catch"](errorCallback);
    }
    /**
     * Makes proposal acknowledged 
     * @memberof BucketFactory
     * @param {number} proposalId 
     * @param {function} callback 
     */


    function acknowledgeProposal(proposalId, callback) {
      return $http.get(apiUrl + '/bucket/AcknowledgeProposal?proposalId=' + proposalId, {
        'Content-Type': 'application/json'
      }).then(callback);
    }
    /**
     * Fetches proposal info 
     * @memberof BucketFactory
     * @param {number} dutyId 
     * @param {function} callback 
     * @returns {object} - Promise containing Proposed and Requested duties alongside Crew and Route details for each one
     */


    function fetchProposal(dutyId, callback) {
      return $http.get(apiUrl + '/bucket/FetchProposal?id=' + dutyId, {
        'Content-Type': 'application/json'
      }).then(callback);
    }
    /**
     * Fetches shared proposal info
     * @param {number} dutyId 
     * @param {number} sharedDutyId 
     * @param {function} callback
     * @returns {object} - Promise containing Proposed and Requested duties alongside Crew and Route details for each one
     */


    function fetchSharedProposal(dutyId, sharedDutyId, callback) {
      return $http.get(apiUrl + '/bucket/FetchSharedProposal?dutyId=' + dutyId + '&sharedDutyId=' + sharedDutyId, {
        'Content-Type': 'application/json'
      }).then(callback);
    }
    /**
     * Creates/Sends Proposal
     * @memberof BucketFactory
     * @param {object} proposal - Containing proposedDutiesIdList and requestedDutiesIdList
     * @param {function} callback
     * @returns {object} - Promise containing updated proposal 
     */


    function createProposal(proposal, callback) {
      return $http.post(apiUrl + '/bucket/CreateProposal', proposal, {
        'Content-Type': 'application/json'
      }).then(callback);
    }
    /**
     * Approves/Rejects proposal
     * @memberof BucketFactory
     * @param {object} proposal - Containing Id and isApproved
     * @param {function} callback
     * @returns {object} - Promise containing updated proposal 
     */


    function evaluateProposal(proposal, callback) {
      return $http.put(apiUrl + '/bucket/EvaluateProposal/' + proposal.Id, proposal.isApproved, {
        'Content-Type': 'application/json'
      }).then(callback);
    }
    /**
     * Reverts proposal to previous status
     * @memberof BucketFactory
     * @param {number} proposalId 
     * @param {function} callback 
     * @returns {object} - Promise containing updated proposal
     */


    function undoProposalStatus(proposalId, callback) {
      return $http.put(apiUrl + '/bucket/UndoProposalStatus/' + proposalId, {
        'Content-Type': 'application/json'
      }).then(callback);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('BucketDayCtrl', BucketDayCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name BucketDayCtrl
   * @description 
   *   Shows the Bucket Day informations
   * @ngInject
   */

  function BucketDayCtrl($scope, BucketFactory, $routeParams, $location, $uibModal, UserFactory, SettingsMain, $timeout) {
    $scope.isSharedLate = false;
    $scope.selectedStates = "Shared, Pending";
    /**
     * Checks if duty wont be approved in time because of the weekend  
     * @memberof BucketDayCtrl
     */

    function checkLateShare() {
      var today = new Date();
      var dutyDay = new Date($scope.duty.DutyBegin); // how many days until duty date

      var trimmedToday = new Date(today);
      var trimmedDutyDay = new Date(dutyDay);
      var diffDays = Date.DifferenceInDays(trimmedToday.trimTime(), trimmedDutyDay.trimTime()); //friday saturday sunday

      var fss = [5, 6, 0]; //saturday sunday monday

      var ssm = [6, 0, 1]; // today is Fr,Sa,Su   AND   duty on Sa,Su,Mo   AND   same weekend

      if (fss.contains(today.getDay()) && ssm.contains(dutyDay.getDay()) && diffDays < 4) {
        //friday before 14:00 is not a late share
        if (!(today.getDay() == 5 && today.getUTCHours() < 14)) $scope.isSharedLate = true;
      }
    }

    $scope.currentDutyId = dutyId;
    $scope.initialized = false;
    $scope.displayMessage = displayMessage;
    $scope.confirmUnshare = confirmUnshare;
    $scope.shareDuty = shareDuty;
    $scope.isLoading = false;
    var dutyId = $routeParams.dutyId;
    $scope.currentDutyId = dutyId;
    var user = UserFactory.getUser();
    $scope.activeTab = 0;
    $scope.duty = null;
    $scope.Duties = [];
    $scope.proposals = [];
    $scope.toggle = {
      Accepted: true,
      Rejected: false,
      Pending: true,
      Bookmarks: true
    };
    $scope.getProposalBorderStyle = getProposalBorderStyle;

    function getProposalBorderStyle(proposal) {
      var textclass = "";

      if (proposal.Status == "Pending" && proposal.State == 'Out') {
        textclass = "border-left-light-blue";
      } else if (proposal.Status == "Rejected" || proposal.Status == "RejectedBySTP") {
        textclass = "border-left-red";
      } else if (proposal.Status == "Pending" && proposal.State == 'In') {
        textclass = "border-left-orange";
      } else if (proposal.Status == "Approved" || proposal.Status == "ApprovedBySTP") {
        textclass = "border-left-green";
      } else if (proposal.Status == "Shared") {
        textclass = "border-left-blue-gray";
      }

      return textclass;
    }

    $scope.logged_user_info = user.aimsId + ' - ' + user.name;
    $scope.hasTimeChange = false;
    $scope.approvedDuty = null;
    $scope.showMobileProposalCriteria = false;
    $scope.filterProposal = filterProposal;
    $scope.hasProposals = hasProposals;

    function hasProposals() {
      var value = false;

      if ($scope.duty && $scope.duty.Duties) {
        for (var i = 0; i < $scope.duty.Duties.length; i++) {
          if ($scope.duty.Duties[i].Id > 0) {
            value = true;
            break;
          }
        }

        if (!value && $scope.activeTab != 1) {
          $scope.activeTab = 1;
        }
      }

      return value;
    }

    function filterProposal(proposal) {
      var isShown = false; ///ng-if="proposal.Id >0 && filterProposal(proposal)"

      if (proposal.Id > 0) {
        if (proposal.Status == "Approved" || proposal.Status == "ApprovedBySTP") {
          $scope.approvedDuty = true;
          if ($scope.toggle.Accepted) isShown = true;
        } else if (proposal.Status == "Pending" && $scope.toggle.Pending) {
          isShown = true;
        } else if ((proposal.Status == "Rejected" || proposal.Status == "RejectedBySTP") && ($scope.toggle.Rejected || !proposal.isAcknowledged)) {
          isShown = true;
        } else if (proposal.Status == "Bookmarked" && $scope.toggle.Bookmarks) {
          isShown = true;
        }
      }

      return isShown;
    }

    $scope.returnToBucket = returnToBucket;
    $scope.refresh = getData;
    getData();

    function getData() {
      $scope.isLoading = true;
      BucketFactory.getDutyById(dutyId, function (responseData) {
        $scope.initialized = true;
        $scope.isLoading = false;
        $scope.duty = responseData.data.data.duty;
        $scope.currentDutyDate = $scope.duty.DutyDateS;
        $scope.Duties = responseData.data.data.duty.Duties;
        $scope.totalItems = $scope.Duties.length;
        $scope.currentPage = 1;
        SettingsMain.setCalendarSelectedDate($scope.currentDutyDate);
        checkLateShare();
        initProposalsView();
      })["catch"](function (error) {
        $scope.isLoading = false;
        console.error('Wrong AimsId', error.status, error.statusText);
        returnToBucket();
      });
    }

    function initProposalsView() {
      $scope.approvedDuty = false;

      for (var i = 0; i < $scope.duty.Duties.length; i++) {
        if ($scope.duty.Duties[i].Status == "Approved" || $scope.duty.Duties[i].Status == "ApprovedBySTP") {
          $scope.approvedDuty = true;
        }
      }
    }
    /**
     * Opens a dialog with information on a duty, 
     * Depending on the duty type (in proposal, out proposal or shared by other in bucket) different options are displayed:
     * 1. In proposal
     *      - Approve (available when in proposal not reviewed, will set status to Approved)
     *      - Reject (available when in proposal not reviewed, will set status to Rejected)
     *      - Reset (available when in proposal has been reviewed, will set status to Pending)
     *      - Close (available always, just closes dialog, no action performed)
     * 2. Out proposal
     *      - Remove (available when out proposal not reviewed, will remove request from duty)
     *      - Close (available always, just closes dialog, no action performed)
     * 3. Shared in bucket
     *      - Request (available always, will send a request for duty, will be added in out proposals)
     *      - Close (available always, just closes dialog, no action performed)
     * @memberof BucketCtrl
     */

    /**
     * Prompts user to confirm sharing duty, if user agrees then the duty dialog will open  
     * @memberof BucketCtrl
     */


    function shareDuty(_duty) {
      //if (confirm('You are about to share into global bucket the selected duty. Do you wish to continue?')) {
      _duty.fromShareBtn = true;
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgDuty.html',
        controller: 'BucketModalCtrl',
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          duty: function duty() {
            return _duty;
          },
          currentDutyId: function currentDutyId() {
            return dutyId;
          }
        }
      });
      modalInstance.result.then(function (refresh) {
        if (refresh) {
          getData();
        }
      }); //}
    }
    /**
     * Prompts user to confirm removing duty from shared bucket, if user agrees then all proposal for the duty will be removed (will be displayed as N/A to other users)  
     * @memberof BucketCtrl
     */


    function confirmUnshare() {
      bootbox.dialog({
        message: "<strong>Please confirm that you wish to Un-share your duty.</strong><br/><br/>",
        title: "Unshare",
        buttons: {
          confirm: {
            label: '<i class="fa fa-trash-o widget-icon text-white"></i> Confirm',
            className: "btn-warning",
            callback: function callback() {
              BucketFactory.shareDuty($scope.duty, function (responseData) {
                $scope.responseText = responseData.data.data;
                getData();
              });
            }
          },
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          }
        }
      });
    }
    /**
     * Redirects to bucket' calendar
     * @memberof BucketCtrl
     */


    function returnToBucket() {
      SettingsMain.setEditingPage(null);
      $location.path("/bucket/");
    }
    /**
     * Redirects to flights' calendar
     * @memberof BucketCtrl
     */


    function gotoFlightsCalendar() {
      SettingsMain.setEditingPage(null);
      $location.path("/");
    } //Pagination


    $scope.pageOptions = [{
      name: '5',
      value: '5'
    }, {
      name: '8',
      value: '8'
    }, {
      name: '15',
      value: '15'
    }, {
      name: '30',
      value: '30'
    }, {
      name: '50',
      value: '50'
    }];
    $scope.viewby = $scope.pageOptions[1].value;
    $scope.currentPage = 1;
    $scope.itemsPerPage = $scope.viewby;
    $scope.maxSize = 5; //Number of pager buttons to show

    $scope.setPage = setPage;
    $scope.setItemsPerPage = setItemsPerPage;
    /**
    * Set pagination page number
    * @memberof BucketDayCtrl
    * @param {number} pageNo list page number
    */

    function setPage(pageNo) {
      $scope.currentPage = pageNo;
    }
    /**
     * Set items per  page 
     * @memberof BucketDayCtrl
     * @param {number} num the Number of items to show per page
     */


    function setItemsPerPage(num) {
      $scope.itemsPerPage = num;
      $scope.currentPage = 1; //reset to first page
    }

    function displayMessage(message, hasErrors) {
      $scope.showResponse = true;
      $scope.responseText = message;
      $scope.responseHasErrors = hasErrors;
      $timeout(function () {
        if (!hasErrors) {
          $scope.showResponse = false;
        }
      }, 1000);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('BucketModalCtrl', BucketModalCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name BucketModalCtrl
   * @description 
   * Shows Share/Unshare Modal 
   * @ngInject
   */

  function BucketModalCtrl($scope, $timeout, $uibModalInstance, duty, currentDutyId, BucketFactory) {
    $scope.duty = duty;
    $scope.currentDutyId = currentDutyId;
    $scope.closeDuty = closeDuty;
    $scope.shareDuty = shareDuty;
    $scope.responseText = null;
    $scope.responseHasErrors = null;
    $scope.submitted = false;
    /**
     * Close the modal
     * @memberof BucketModalCtrl
     */

    function closeDuty(refresh) {
      $uibModalInstance.close(refresh);
    }
    /**
     * Adds/Removes duty to/from global bucket
     * @memberof BucketModalCtrl
     */


    function shareDuty() {
      $scope.submitted = true;
      duty.Comments = $scope.duty.Comments;
      BucketFactory.shareDuty(duty, function (responseData) {
        displayMessage("Duty shared.", false);
        $timeout(function () {
          closeDuty(true);
        }, 5000);
      }, function () {
        displayMessage("Failed to share duty.", true);
      });
    }
    /**
     * Displays message when share/unshare 
     * @memberof BucketModalCtrl
     * @param {string} message 
     * @param {boolean} hasErrors 
     */


    function displayMessage(message, hasErrors) {
      $scope.responseText = message;
      $scope.responseHasErrors = hasErrors;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('proposal', proposal);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name proposal
  * @restrict E
  * @description
  *   Implementation of proposal
  *   Initialize the proposal element of bucket
  * @example
  *   Usage:
  *   <proposal    proposal="proposal"  
  *                current-duty-id="currentDutyId"  
  *                current-duty-date="currentDutyDate" 
  *                onDisplay="functionCallback" 
  *                onRefresh="functionCallback"
  *                action-disabled="approvedDuty" 
  *                shared-count="duty.Duties.length"
  *    </proposal>
  * @ngInject
  */

  function proposal(BucketFactory, $uibModal, $filter) {
    function link(scope, element, attrs) {
      scope.isOpen = false;
      scope.successful = false;
      scope.error = false;
      scope.proposal.createDisabled = false;
      scope.duty = scope.proposal.Duty;
      scope.loading = false;
      scope.errorMessage = null;
      scope.ProposedDuties = new Array();
      scope.RequestedDuties = new Array();
      scope.AllDuties = new Array();
      scope.fetch = fetchInformation;
      scope.viewInfoModal = viewInfoModal;
      scope.createProposal = createProposal;
      scope.evaluateProposal = evaluateProposal;
      scope.undoProposalStatus = undoProposalStatus;
      scope.acknowledgeProposal = acknowledgeProposal;
      scope.confirmCreateProposal = confirmCreateProposal;
      scope.getFirstInfoIcon = getFirstInfoIcon;
      scope.getSecondInfoIcon = getSecondInfoIcon;
      scope.hasSecondInfoIcon = hasSecondInfoIcon;
      scope.getTextColor = getTextColor;
      scope.getFirstActionIcon = getFirstActionIcon;
      scope.hasFirstActionIcon = hasFirstActionIcon;
      scope.getSecondActionIcon = getSecondActionIcon;
      scope.hasSecondActionIcon = hasSecondActionIcon;
      scope.getFetchIcon = getFetchIcon;
      scope.getInfoMessage = getInfoMessage;
      scope.firstAction = firstAction;
      scope.secondaryAction = secondaryAction;
      scope.showEndDate = showEndDate;
      scope.showTime = showTime;

      if (scope.duty.Comments && scope.duty.Comments != "") {
        scope.dutyCommentElipsis = dutyCommentElipsis(110);
        scope.showFullComment = false;
      }

      scope.toggleFullCommentVisibility = toggleFullCommentVisibility;
      /**
       * Toggles proposal comment
       * @memberof proposal
       */

      function toggleFullCommentVisibility() {
        scope.showFullComment = !scope.showFullComment;
      }
      /**
       * Shows only the first charNo characters of the comment
       * @memberof proposal
       * @param {number} charNo 
       */


      function dutyCommentElipsis(charNo) {
        var comments = scope.duty.Comments;

        if (scope.duty.Comments.length > charNo) {
          comments = scope.duty.Comments.substring(0, charNo) + "...";
        }

        return comments;
      }
      /**
      * Updates proposal when a change occurs (create, evaluate or undo)
      * @memberof proposal
      * @param {object} newProp - The updated proposal 
      */


      function updateProposal(newProp) {
        if (newProp) {
          scope.proposal.Status = newProp.Status;
          scope.proposal.State = newProp.State;
          scope.proposal.Id = newProp.Id;
          scope.proposal.isAcknowledged = newProp.isAcknowledged;
        }
      }
      /**
       * Fetches proposal info (Proposed and Requested duties alongside Crew and Route details for each one)  
       * @memberof proposal
       */


      function fetchInformation() {
        if (!(scope.actionDisabled && scope.proposal.Status == 'Shared')) {
          if (!(scope.proposal.AllDuties && scope.proposal.AllDuties.length > 0)) {
            scope.loading = true;

            if (scope.proposal.Status == "Shared" && !scope.actionDisabled) {
              BucketFactory.fetchSharedProposal(scope.currentDutyId, scope.duty.Id, insertInformation)["catch"](errorCall);
            } else {
              BucketFactory.fetchProposal(scope.proposal.Id, insertInformation)["catch"](errorCall);
            }
          } else {
            scope.isOpen = !scope.isOpen; //collapse
          }
        }
      }
      /**
       * Handles error from fetchSharedProposal() and fetchProposal()  
       * @memberof proposal
       */


      function errorCall() {
        scope.isOpen = false;
        scope.loading = false;
        displayMessage("Failed to fetch information.", true);
      }
      /**
       * Callback for handling the successful response of fetchSharedProposal() and fetchProposal()
       * @memberof proposal
       * @param {object} data 
       */


      function insertInformation(data) {
        var success = data.data.success;
        var errorMessage = data.data.errorMessage; //always show duties even if success is false

        if (data.data.data.duty) {
          var ProposedDuties = data.data.data.duty.ProposedDuties;
          var RequestedDuties = data.data.data.duty.RequestedDuties;
          scope.proposal.HasMultiDuties = data.data.data.duty.HasMultiDuties;
          ProposedDuties = $filter('orderBy')(ProposedDuties, 'DutyDate');
          RequestedDuties = $filter('orderBy')(RequestedDuties, 'DutyDate');

          if (ProposedDuties && RequestedDuties) {
            scope.proposal.AllDuties = [];
            var tableMaxRowLength = ProposedDuties.length > RequestedDuties.length ? ProposedDuties.length : RequestedDuties.length;

            for (var i = 0; i < tableMaxRowLength; i++) {
              if (scope.proposal.Status == "Shared" || scope.proposal.State == "Out") {
                var matchedDuty = {
                  Proposed: ProposedDuties[i],
                  //you give
                  Requested: RequestedDuties[i] //you take

                };
              } else {
                //scope.proposal.State == "In"
                var matchedDuty = {
                  Proposed: RequestedDuties[i],
                  //you give
                  Requested: ProposedDuties[i] //you take

                };
              }

              scope.proposal.AllDuties.push(matchedDuty);
            }

            scope.proposal.ProposedDuties = ProposedDuties;
            scope.proposal.RequestedDuties = RequestedDuties;
            scope.isOpen = true;
          }
        }

        if (!success) {
          //if not enough rest time
          //if no available combinations
          scope.proposal.createDisabled = true;
        } else {
          scope.proposal.createDisabled = false;
        } //always show errorMessage even if success is true


        if (errorMessage && errorMessage.length > 0) {
          displayMessage(errorMessage, true);
        } else {
          scope.errorMessage = null;
        }

        scope.loading = false;
      }
      /**
       * Opens modal for a specific duty in the table - Shows route and crew info 
       * @memberof proposal
       * @param {number} id 
       */


      function viewInfoModal(id) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Dialogs/dlgProposalInfo.html',
          controller: 'ProposalInfoModalCtr',
          size: 'lg',
          resolve: {
            ProposedDuties: function ProposedDuties() {
              return scope.proposal.ProposedDuties;
            },
            RequestedDuties: function RequestedDuties() {
              return scope.proposal.RequestedDuties;
            },
            Id: function Id() {
              return id;
            },
            Status: function Status() {
              return scope.proposal.Status;
            },
            State: function State() {
              return scope.proposal.State;
            }
          }
        });
      }
      /**
       * Creates/Sends proposal
       * @memberof proposal
       */


      function createProposal() {
        var proposedDutiesIdList = [];
        var requestedDutiesIdList = [];
        angular.forEach(scope.proposal.ProposedDuties, function (duty) {
          proposedDutiesIdList.push(duty.Id);
        });
        angular.forEach(scope.proposal.RequestedDuties, function (duty) {
          requestedDutiesIdList.push(duty.Id);
        }); //request body

        var proposal = {
          'proposedDutiesIdList': proposedDutiesIdList,
          'requestedDutiesIdList': requestedDutiesIdList
        };
        scope.loading = true;
        BucketFactory.createProposal(proposal, function (responseData) {
          displayMessage("Proposal has been sent", false);
          scope.loading = false;
          updateProposal(responseData.data.data);

          if (scope.proposal.HasMultiDuties) {
            scope.refresh(); //needed in order to hide other duty from same proposal
          }
        })["catch"](function () {
          displayMessage("Failed to send proposal.", true);
          scope.loading = false;
        });
      }
      /**
       * Approves/Rejects proposal
       * @memberof proposal
       * @param {boolean} isApproved
       */


      function evaluateProposal(isApproved) {
        var proposal = {};
        proposal.Id = scope.proposal.Id;
        proposal.isApproved = isApproved;
        var onSuccessMessage, onFailureMessage;

        if (isApproved) {
          proposal.Status = "Approved";
          var onSuccessMessage = "Approved proposal.";
          var onFailureMessage = "Failed to approve proposal.";
        } else {
          proposal.Status = "Rejected";
          var onSuccessMessage = "Rejected proposal.";
          var onFailureMessage = "Failed to reject proposal.";
        }

        scope.loading = true;
        BucketFactory.evaluateProposal(proposal).then(function (responseData) {
          var success = responseData.data.success;

          if (success) {
            var newProp = responseData.data.data;
            updateProposal(newProp);

            if (isApproved) {
              scope.refresh(); //needed in order to disable other proposals
            }

            displayMessage(onSuccessMessage, false);
          } else {
            displayMessage(onFailureMessage, true);
          }
        })["catch"](function () {
          displayMessage(onFailureMessage, true);
        });
        scope.loading = false;
      }
      /**
       * Reverts proposal to previous status
       * @memberof proposal
       */


      function undoProposalStatus() {
        scope.loading = true;
        var proposal = {};
        proposal.Id = scope.proposal.Id;
        var onSuccessMessage, onFailureMessage;

        if (scope.proposal.Status == "Approved" || scope.proposal.Status == "Rejected" && scope.proposal.State == 'In') {
          var onSuccessMessage = "Proposal has been reset.";
          var onFailureMessage = "Failed to reset proposal.";
        } else {
          //(scope.proposal.Status == "Pending" && scope.proposal.State=='Out')
          var onSuccessMessage = "Withdrew proposal.";
          var onFailureMessage = "Failed to withraw proposal.";
        }

        BucketFactory.undoProposalStatus(proposal.Id).then(function (responseData) {
          var previousStatus = scope.proposal.Status;
          var HasMultiDuties = scope.proposal.HasMultiDuties;
          var newProp = responseData.data.data;
          displayMessage(onSuccessMessage, false);
          scope.loading = false;
          updateProposal(newProp);

          if (previousStatus == "Approved") {
            scope.refresh(); //needed in order to enable other proposals again        
          } else if (previousStatus == "Pending" && HasMultiDuties) {
            scope.refresh(); //needed in order to show other duties from same proposal       
          }
        })["catch"](function () {
          scope.loading = false;
          displayMessage(onFailureMessage, true);
        });
      }
      /**
       * Displays error or success message
       * @memberof proposal
       * @param {string} message 
       * @param {boolean} hasErrors 
       */


      function displayMessage(message, hasErrors) {
        if (hasErrors) {
          scope.errorMessage = message;
        } else {
          scope.errorMessage = null;
        }
      }
      /**
       * Makes proposal acknowledged 
       * Available when status is 'RejectedBySTP' or status is 'Rejected' and state  is 'Out'
       * @memberof proposal
       */


      function acknowledgeProposal() {
        scope.loading = true;
        var proposalId = scope.proposal.Id;
        var onFailureMessage = "Failed to acknowledge proposal.";
        BucketFactory.acknowledgeProposal(proposalId).then(function (responseData) {
          scope.proposal.isAcknowledged = true;
          scope.loading = false;
        })["catch"](function () {
          scope.loading = false;
          displayMessage(onFailureMessage, true);
        });
      }
      /**
       * Changes proposal's first info icon depending on its state and status
       * @memberof proposal
       * @returns {string} - Icon name
       */


      function getFirstInfoIcon() {
        var icon = "";

        if (scope.proposal.Status == "Pending" && scope.proposal.State == 'Out') {
          icon = "fa-thumbs-up";
        } else if (scope.proposal.Status == "Rejected") {
          icon = "fa-thumbs-down";
        } else if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In') {
          icon = "fa-thumbs-o-up";
        } else if (scope.proposal.Status == "Shared") {
          icon = "fa-bitbucket";
        } else if (scope.proposal.Status == "Approved") {
          icon = "fa fa-handshake-o";
        } else if (scope.proposal.Status == "ApprovedBySTP") {
          icon = "fa-thumbs-up";
        } else if (scope.proposal.Status == "RejectedBySTP") {
          icon = "fa-thumbs-o-down";
        }

        return icon;
      }
      /**
      * Changes proposal's second info icon depending on its state and status
      * @memberof proposal
      * @returns {string} - Icon name
      */


      function getSecondInfoIcon() {
        var icon = "";

        if (scope.proposal.Status == "Pending" && scope.proposal.State == 'Out') {
          icon = "fa-clock-o text-gray";
        } else if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In') {
          icon = "fa-question-circle-o";
        }

        return icon;
      }
      /**
       * Determines second info icon's visibility
       * @memberof proposal
       * @returns {boolean}
       */


      function hasSecondInfoIcon() {
        return scope.proposal.Status == "Pending" && scope.proposal.State == 'In' || scope.proposal.Status == "Pending" && scope.proposal.State == 'Out';
      }
      /**
       * Changes column color depending on proposal's state and status
       * @memberof proposal
       * @returns {string} - Color's class
       */


      function getTextColor() {
        var textclass = "";

        if (scope.proposal.Status == "Pending" && scope.proposal.State == 'Out') {
          textclass = "text-light-blue";
        } else if (scope.proposal.Status == "Rejected") {
          textclass = "text-red";
        } else if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In') {
          textclass = "text-orange";
        } else if (scope.proposal.Status == "Approved") {
          textclass = "text-green";
        } else if (scope.proposal.Status == "Shared") {
          textclass = "text-blue-gray";
        } else if (scope.proposal.Status == "ApprovedBySTP") {
          textclass = "text-green";
        } else if (scope.proposal.Status == "RejectedBySTP") {
          textclass = "text-red";
        }

        return textclass;
      }
      /**
       * Changes proposal's first action icon depending on its state and status
       * @memberof proposal
       * @returns {string} - Icon name
       */


      function getFirstActionIcon() {
        var icon = "";

        if (scope.proposal.createDisabled) {
          icon = "fa-ban text-red"; //no action permitted
        } else if (scope.proposal.Status == "Pending" && scope.proposal.State == 'Out' || scope.proposal.Status == "Approved") {
          icon = " fa-times text-gray "; //undo
        } else if (scope.proposal.Status == "Rejected" && scope.proposal.State == "In") {
          icon = " fa-times text-gray "; //undo
        } else if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In' && !scope.actionDisabled) {
          icon = "fa-thumbs-o-up text-green"; //approve
        } else if (scope.proposal.Status == "Shared" && !scope.actionDisabled) {
          icon = "fa-thumbs-o-up text-light-blue"; //create
        }

        return icon;
      }
      /**
       * Changes proposal's fetch icon if create action is disabled  
       * @memberof proposal
       * @returns {string} - Icon name
       */


      function getFetchIcon() {
        var icon = "";

        if (scope.proposal.createDisabled) {
          icon = "fa-ban text-red";
        } else {
          icon = "fa-search";
        }

        return icon;
      }
      /**
       * Changes proposal's second action icon depending on its state and status
       * @memberof proposal
       * @returns {string} - Icon name
       */


      function getSecondActionIcon() {
        var icon = "";

        if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In') {
          icon = "fa-thumbs-o-down text-red"; //reject
        }

        return icon;
      }
      /**
      * Determines first action icon's visibility
      * @memberof proposal
      * @returns {boolean}
      */


      function hasFirstActionIcon() {
        return !(scope.proposal.Status == "ApprovedBySTP" || scope.proposal.Status == "RejectedBySTP");
      }
      /**
       * Determines second action icon's visibility
       * @memberof proposal
       * @returns {boolean}
       */


      function hasSecondActionIcon() {
        return scope.proposal.Status == "Pending" && scope.proposal.State == 'In' || scope.proposal.Status == "Shared";
      }
      /**
       * Returns info message depending on proposal's state and status
       * @memberof proposal
       * @returns {string} - Message
       */


      function getInfoMessage() {
        var text = "";

        if (scope.proposal.Status == "Pending" && scope.proposal.State == 'Out') {
          text = "your proposal is pending";
        } else if (scope.proposal.Status == "Rejected" && scope.proposal.State == 'Out') {
          text = "your proposal has been rejected";
        } else if (scope.proposal.Status == "Rejected" && scope.proposal.State == 'In') {
          text = "you have rejected the proposal";
        } else if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In') {
          text = "your response is pending";
        } else if (scope.proposal.Status == "Approved" && scope.proposal.State == 'In') {
          text = "you have accepted the proposal. Your request is sent for approval";
        } else if (scope.proposal.Status == "Approved" && scope.proposal.State == 'Out') {
          text = "your proposal has been accepted! Your request is sent for approval";
        } else if (scope.proposal.Status == "ApprovedBySTP") {
          text = "your request has been approved!";
        } else if (scope.proposal.Status == "RejectedBySTP") {
          text = "your request has been rejected by STP";
        }

        return text;
      }
      /**
       * Determines duty's endDate visibility
       * @memberof proposal
       * @returns {boolean}
       */


      function showEndDate(duty) {
        var show = false;
        var diffMin = Date.DifferenceInMinutes(duty.DutyBegin, duty.DutyEnd);
        var diffHours = diffMin / 60;

        if (diffHours >= 24) {
          //endDate will show if duty exceeds 24 hours
          show = true;
        }

        return show;
      }
      /**
       * Hides duty begin and end time if needed
       * @param {object} duty 
       */


      function showTime(duty) {
        var show = true;
        var diffMin = Date.DifferenceInMinutes(duty.DutyBegin, duty.DutyEnd);

        if (!diffMin) {
          //Time will not show if duty lasts all day (ex. Day Off: 00:00 - 00:00)
          show = false;
        }

        return show;
      }
      /**
       * Chooses first icon's action depending on proposal's state and status
       * @memberof proposal
       */


      function firstAction() {
        if (scope.proposal.Status == "Pending" && scope.proposal.State == 'Out') {
          undoProposalStatus();
        } else if (scope.proposal.Status == "Approved") {
          confirmUndoApproved();
        } else if (scope.proposal.Status == "Rejected" && scope.proposal.State == 'In') {
          undoProposalStatus();
        } else if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In') {
          evaluateProposal(true); //approve
        } else if (scope.proposal.Status == "Shared" && !scope.proposal.createDisabled) {
          if (scope.errorMessage && scope.errorMessage.length > 0) {
            confirmCreateProposal(); //fetch success with errorMessage
          } else {
            createProposal();
          }
        }
      }
      /**
       * Chooses second icon's action depending on proposal's state and status
       * @memberof proposal
       */


      function secondaryAction() {
        if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In') {
          evaluateProposal(false); // reject proposal
        }
      }
      /**
      * Opens confirmation modal when undo is requested on an approved proposal
      * @memberof proposal
      */


      function confirmUndoApproved() {
        bootbox.dialog({
          message: "<strong>You are about to cancel your accepted proposal.</strong><br/><br/>",
          title: "Caution!",
          buttons: {
            confirm: {
              label: 'Confirm',
              className: "btn-danger",
              callback: function callback() {
                undoProposalStatus();
              }
            },
            cancel: {
              label: "Cancel",
              className: "btn-default",
              callback: function callback() {}
            }
          }
        });
      }
      /**
       * Opens confirmation modal when create is requested on an alternate proposal
       * @memberof proposal
       */


      function confirmCreateProposal() {
        bootbox.dialog({
          message: "<strong>Would you like to proceed with the alternate proposal?</strong><br/><br/>",
          title: "Send request",
          buttons: {
            confirm: {
              label: 'Confirm',
              className: "btn-success",
              callback: function callback() {
                createProposal();
              }
            },
            cancel: {
              label: "Cancel",
              className: "btn-default",
              callback: function callback() {}
            }
          }
        });
      }
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/bucket/proposal.tpl.html',
      scope: {
        proposal: '=',
        displayMessage: '&onDisplay',
        refresh: '&onRefresh',
        actionDisabled: '=',
        currentDutyDate: '=',
        currentDutyId: '=',
        sharedCount: '='
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('ProposalInfoModalCtr', ProposalInfoModalCtr);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name ProposalInfoModalCtr
   * @description 
   * Shows duty crew and route info
   * @ngInject
   */

  function ProposalInfoModalCtr($scope, $uibModalInstance, ProposedDuties, RequestedDuties, Id, Status, State) {
    $scope.RequestedDuties = RequestedDuties;
    $scope.ProposedDuties = ProposedDuties;
    $scope.cancel = cancel;
    $scope.next = next;
    $scope.previous = previous;
    var allDuties = []; //"You give" items are put first in list

    if (Status == "Shared" || State == "Out") {
      allDuties = ProposedDuties.concat(RequestedDuties);
    } else {
      //State == "In"
      allDuties = RequestedDuties.concat(ProposedDuties);
    }

    for (var i = 0; i < allDuties.length; i++) {
      if (allDuties[i].Id == Id) {
        $scope.currentPage = i + 1;
        break;
      }
    }

    $scope.allDuties = allDuties;
    /**
     * Moves to next duty
     * @memberof ProposalInfoModalCtr
     */

    function next() {
      if ($scope.currentPage != allDuties.length) $scope.currentPage++;
    }
    /**
     * Moves to previous duty
     * @memberof ProposalInfoModalCtr
     */


    function previous() {
      if ($scope.currentPage != 1) $scope.currentPage--;
    }
    /**
     * Closes modal
     * @memberof ProposalInfoModalCtr
     */


    function cancel() {
      $uibModalInstance.close('cancel');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CheckInFactory', CheckInFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CheckInFactory
  * @description 
  *   Get list, Update list & Acknowledge schedule changes
  * @ngInject
  */

  function CheckInFactory(GenericService, $http, apiUrl, LogService) {
    /**
     * Initialize the ScheduleChanges
     * @memberof CheckInFactory
     */
    function CheckIn() {}

    var objType = 'CheckIn';
    var objCallback = CheckIn;
    var response = {
      success: false,
      message: '',
      checkInInfo: null
    };
    var service = {
      setCheckInInfoToStorage: setCheckInInfoToStorage,
      getCheckInInfoFromStorage: getCheckInInfoFromStorage,
      checkIn: checkIn,
      saveCheckInDelay: saveCheckInDelay
    };
    /**
     * Save check in info
     * @param {array} checkInInfo 
     */

    function setCheckInInfoToStorage(checkInInfo) {
      if (checkInInfo == undefined || checkInInfo == null) {
        GenericService.removeAll(objType);
      } else {
        GenericService.saveOne(checkInInfo, objType, objCallback);
      }
    }
    /**
     * Get check in info
     */


    function getCheckInInfoFromStorage() {
      return GenericService.getOne(objType, objCallback);
      ;
    }
    /**
     * Check In
     * @returns {promise} response
     */


    function checkIn(confirmed) {
      return $http.get(apiUrl + '/CrewCheckIn/CheckIn?confirmed=' + confirmed, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return updateCheckInCallBack(res);
      })["catch"](function (res) {
        return checkInFailedCallBack(res);
      });
    }
    /**
     * Update Schedule changes dates
     * @param {object} res 
     * @param {object} objectToAdd 
     * @returns {object} response
     */


    function updateCheckInCallBack(res) {
      response.success = res.data.success;

      if (res.data.success) {
        //update local storage
        setCheckInInfoToStorage(res.data.data);
        response.checkInInfo = res.data.data;

        if (response.checkInInfo && response.checkInInfo.Confirmed && response.checkInInfo.ErrorExplanation === "") {
          response.message = "Success! Check In Confirmed.";
        } else if (response.checkInInfo && !response.checkInInfo.Confirmed && response.checkInInfo.ErrorExplanation === "") {
          response.message = "Ready for Check In.";
        } else if (response.checkInInfo) {
          response.message = response.checkInInfo.ErrorExplanation;
        } else {
          response.message = "You have not pending Check In.";
        }
      } else {
        response.message = res.data.errorMessage;
      }

      return response;
    }
    /**
    * The callback function upon failure on submit
    * @returns {object} response
    */


    function checkInFailedCallBack(res) {
      response.success = false;
      response.message = "Oops! Something went wrong"; // status -1 means request was cancelled (offline/navigation), not an app error

      if (res && res.status === -1) {
        return response;
      } //TODO::Check status=500 error: returns res = {data: {…}, status: 500, config: {…}, statusText: "Internal Server Error", headers: ƒ}
      // res.data.data is null


      if (res.data && res.data.data) {
        response.checkInInfo = res.data.data;
      } else {
        //log results
        var responseString = JSON.stringify(res);
        LogService.error('CheckIn Failed CallBack, Response: ' + responseString);
      }

      return response;
    }
    /**
     * Save Check In Delay
     * @returns {promise} response
     */


    function saveCheckInDelay(delayMinutes) {
      var checkInInfo = getCheckInInfoFromStorage();
      checkInInfo.DelayMinutes = +delayMinutes;
      return $http.post(apiUrl + '/CrewCheckIn/SaveCheckInDelay', checkInInfo, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return updateCheckInDelayCallBack(res);
      })["catch"](function (res) {
        return checkInFailedCallBack(res);
      });
    }

    function updateCheckInDelayCallBack(res) {
      response.success = res.data.success;

      if (res.data.success) {
        response.message = "Success! Delay message was sent.";
      } else {
        response.message = res.data.errorMessage;
      }

      return response;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('CheckInModalCtrl', CheckInModalCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name CheckInModalCtrl
  * @description 
  * Check in Modal
  * @ngInject
  */

  function CheckInModalCtrl($scope, CheckInFactory, $route, $uibModalInstance) {
    $scope.showContent = 'actions';
    $scope.cancel = cancel;
    $scope.checkInInfo = null;
    $scope.CheckInAction = CheckInAction;
    $scope.BackToActions = BackToActions;
    $scope.ConfirmCheckIn = ConfirmCheckIn;
    $scope.SendDelayMessage = SendDelayMessage;
    $scope.GetCheckInInfoFromServer = GetCheckInInfoFromServer;
    $scope.responseObj = {
      success: false,
      message: '',
      checkInInfo: null
    };
    $scope.results = [];
    $scope.selectedDelayMinutes = 10;
    $scope.onMinutesChange = onMinutesChange;
    $scope.numberDown = numberDown;
    $scope.numberUp = numberUp;
    GetCheckInInfoFromServer();

    function GetCheckInInfoFromServer() {
      $scope.showContent = 'loading';
      var confirmCheckIn = false;
      CheckInFactory.checkIn(confirmCheckIn).then(function (res) {
        return handleRefreshResponse(res);
      })["catch"](function (res) {
        return handleRefreshResponse(res);
      });
    }

    function handleRefreshResponse(res) {
      $scope.showContent = 'actions';
      $scope.responseObj = res;
    }

    function CheckInAction() {
      $scope.showContent = 'confirm';
    }

    function BackToActions() {
      $scope.showContent = 'actions';
    }

    function ConfirmCheckIn() {
      $scope.showContent = 'loading';
      var confirmCheckIn = true;
      CheckInFactory.checkIn(confirmCheckIn).then(function (res) {
        return handleSubmitResponse(res);
      })["catch"](function (res) {
        return handleSubmitResponse(res);
      });
    }

    function handleSubmitResponse(res) {
      $scope.showContent = 'results';
      $scope.responseObj = res;
    }

    function onMinutesChange(minutes) {
      $scope.selectedDelayMinutes = minutes;
    }

    function SendDelayMessage() {
      $scope.showContent = 'loading';
      CheckInFactory.saveCheckInDelay($scope.selectedDelayMinutes).then(function (res) {
        return handleDelayMessageResponse(res);
      })["catch"](function (res) {
        return handleDelayMessageResponse(res);
      });
    }

    function handleDelayMessageResponse(res) {
      $scope.showContent = 'results';
      $scope.responseObj.success = res.success;
      $scope.responseObj.message = res.message;
    }
    /**
     * Decrease field value by 5
     */


    function numberDown(selectedDelayMinutes) {
      if (selectedDelayMinutes > 0) {
        $scope.selectedDelayMinutes = selectedDelayMinutes - 5;
      }
    }
    /**
     * Increase field value by 5
     */


    function numberUp(selectedDelayMinutes) {
      $scope.selectedDelayMinutes = selectedDelayMinutes + 5;
    }
    /**
    * Closes modal
    */


    function cancel() {
      $uibModalInstance.close('cancel'); // if($scope.responseObj.success){
      //     $route.reload();
      // }
    }
  }
})();
"use strict";

(function () {
  "use strict";

  a3_cabin_reports.controller("CrewExpiriesCtrl", CrewExpiriesCtrl);
  /**
   * @ngInject
   */

  function CrewExpiriesCtrl($scope, ExpiriesFactory, AirlineInfoFactory, UserFactory) {
    $scope.user = UserFactory.getUser();
    $scope.exportInProgress = false; // ----------------------------
    // View model 
    // ----------------------------

    $scope.vm = {
      selectedAirline: null,
      selectedFleetId: null,
      selectedAirlineInfos: []
    }; // ----------------------------
    // Expiries
    // ----------------------------

    $scope.allExpiries = [];
    ExpiriesFactory.getAllExpiriesFromStorage().then(function (allExpiries) {
      $scope.allExpiries = (allExpiries || []).sort(function (a, b) {
        var da = a && a.ExpiryDate ? new Date(a.ExpiryDate).getTime() : Number.POSITIVE_INFINITY;
        var db = b && b.ExpiryDate ? new Date(b.ExpiryDate).getTime() : Number.POSITIVE_INFINITY;
        return da - db;
      });
    });

    $scope.getHighlight = function (expiryDate) {
      if (!expiryDate) return;
      var today = new Date();
      var expDate = new Date(expiryDate);
      if (isNaN(expDate.getTime())) return;
      var diffDays = Math.ceil((expDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
      if (diffDays < 30) return "#D43F3A";
      if (diffDays < 90) return "#FFaB5E";
    }; // ----------------------------
    // Airline data (from storage)
    // ----------------------------


    $scope.crewAirlineInfos = AirlineInfoFactory.getCrewAirlineInfos() || [];
    $scope.crewAirlineOptions = AirlineInfoFactory.getCrewAirlineOptions() || []; // ----------------------------
    // Helpers
    // ----------------------------

    function norm(s) {
      return (s || "").toString().trim().toLowerCase();
    }

    $scope.cleanDisplayValue = function (value) {
      return (value || "").toString().replace(/[\s,]+$/, "").trim();
    };

    function findAirlineByFleetId(fleetId) {
      var list = $scope.crewAirlineOptions || [];
      var id = Number(fleetId);
      if (isNaN(id)) return null;

      for (var i = 0; i < list.length; i++) {
        if (Number(list[i].FleetId) === id) return list[i];
      }

      return null;
    }

    function recomputeSelectedInfos() {
      var infos = $scope.crewAirlineInfos || [];
      var sel = $scope.vm.selectedAirline;

      if (!sel) {
        $scope.vm.selectedAirlineInfos = infos;
        return;
      }

      var hasFleetOnInfo = infos.some(function (x) {
        return x && x.FleetId != null;
      }); // Prefer exact FleetId match when possible

      if (hasFleetOnInfo && sel.FleetId != null) {
        $scope.vm.selectedAirlineInfos = infos.filter(function (x) {
          return Number(x.FleetId) === Number(sel.FleetId);
        });
        return;
      } // Fallback: keyword match on CompanyName


      var airline = norm(sel.Airline);
      $scope.vm.selectedAirlineInfos = infos.filter(function (x) {
        return norm(x.CompanyName).indexOf(airline) >= 0;
      });
    }

    function applySelectionByAirline(airlineObj) {
      if (!airlineObj) {
        $scope.vm.selectedAirline = null;
        $scope.vm.selectedFleetId = null;
        $scope.vm.selectedAirlineInfos = [];
        return;
      }

      $scope.vm.selectedAirline = airlineObj;
      $scope.vm.selectedFleetId = Number(airlineObj.FleetId);
      recomputeSelectedInfos();
    } // ----------------------------
    // INIT
    // ----------------------------


    (function init() {
      var options = $scope.crewAirlineOptions || [];

      if (!options.length) {
        applySelectionByAirline(null);
        return;
      }

      var defaultFleetId = AirlineInfoFactory.getDefaultFleetId ? AirlineInfoFactory.getDefaultFleetId() : null;
      var selected = defaultFleetId != null ? findAirlineByFleetId(defaultFleetId) : null;
      if (!selected) selected = options[0];
      applySelectionByAirline(selected);
    })(); // ----------------------------
    // User actions
    // ----------------------------


    $scope.switchAirline = function () {
      var options = $scope.crewAirlineOptions || [];
      if (options.length < 2) return;
      var current = $scope.vm.selectedAirline; // Guard: if selection is missing, pick first

      if (!current || current.FleetId == null) {
        applySelectionByAirline(options[0]);
        return;
      }

      var index = options.findIndex(function (x) {
        return Number(x.FleetId) === Number(current.FleetId);
      });
      if (index < 0) index = 0;
      var nextIndex = (index + 1) % options.length;
      applySelectionByAirline(options[nextIndex]);
    };

    $scope.getAirlineLogoUrl = function () {
      if (!$scope.vm.selectedAirline) return null;
      var airline = norm($scope.vm.selectedAirline.Airline);
      if (airline === "aegean") return "img/a3_logo.png";
      if (airline === "olympic") return "img/Logo_OA.png";
      return "img/a3_logo.png";
    };

    function formatDate(value) {
      if (!value) return null;
      var d = new Date(value);
      if (isNaN(d.getTime())) return null;
      return d.toString("yyyy/MM/dd");
    }

    function getLicenseNumbers(infos) {
      var map = {};
      var result = [];
      (infos || []).forEach(function (info) {
        var values = [info && info.LicenseNo, info && info.SecondaryLicenseNo];
        values.forEach(function (value) {
          var key = (value || "").toString().trim();
          if (!key || map[key]) return;
          map[key] = true;
          result.push(key);
        });
      });
      return result.join(", ");
    }

    function buildExportPayload() {
      var selectedInfos = $scope.vm.selectedAirlineInfos || [];
      var licenseNumbers = getLicenseNumbers(selectedInfos);
      var primaryInfo = selectedInfos.length ? selectedInfos[0] : null;
      var airline = $scope.vm.selectedAirline || null;
      var crewMemberAimsId = $scope.user && $scope.user.aimsId ? Number($scope.user.aimsId) : null;
      return {
        Rows: ($scope.allExpiries || []).map(function (x) {
          return {
            CrewMemberAimsId: crewMemberAimsId,
            CrewMemberName: $scope.user && $scope.user.name ? $scope.user.name : null,
            Airline: airline ? airline.Airline : null,
            AirlineCode: airline && airline.Airline ? norm(airline.Airline) : null,
            FleetId: airline ? airline.FleetId : null,
            CompanyName: primaryInfo && primaryInfo.CompanyName ? primaryInfo.CompanyName : null,
            AOC: primaryInfo && primaryInfo.AOC ? primaryInfo.AOC : null,
            Address: primaryInfo && primaryInfo.Address ? primaryInfo.Address : null,
            LicenseNo: primaryInfo && primaryInfo.LicenseNo ? primaryInfo.LicenseNo : null,
            SecondaryLicenseNo: primaryInfo && primaryInfo.SecondaryLicenseNo ? primaryInfo.SecondaryLicenseNo : null,
            LicenseNumbers: licenseNumbers,
            Code: x && x.ExpiryType ? x.ExpiryType.toString().trim() : null,
            ExpiryType: x && x.ExpiryType ? x.ExpiryType.toString().trim() : null,
            ExpiryTypeId: x && x.ExpiryTypeId != null ? x.ExpiryTypeId : null,
            Description: x && x.Description ? x.Description : null,
            LastDone: formatDate(x && x.LastCkecked),
            ExpiryDate: formatDate(x && x.ExpiryDate),
            NextPlanned: formatDate(x && (x.NextPlanned || x.NextPlannedDate))
          };
        })
      };
    }

    $scope.exportToPdf = function () {
      if ($scope.exportInProgress) return;
      $scope.exportInProgress = true;
      var payload = buildExportPayload();
      ExpiriesFactory.exportCrewExpiriesToPdf(payload).then(function (response) {
        var disposition = response && response.headers && response.headers("content-disposition");
        var fileName = "CrewExpiries.pdf";

        if (disposition) {
          var match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);

          if (match && match[1]) {
            fileName = decodeURIComponent(match[1]);
          }
        }

        var blob = new Blob([response.data], {
          type: "application/pdf"
        });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
          return;
        }

        var url = window.URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })["catch"](function () {
        bootbox.alert("Failed to export Crew Expiries PDF.");
      })["finally"](function () {
        $scope.exportInProgress = false;
      });
    };
  }
})();
"use strict";

(function () {
  "use strict";

  a3_cabin_reports.factory("ExpiriesFactory", ExpiriesFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name ExpiriesFactory
   * @description
   *   Get medical & passport expiries.
   * @ngInject
   */

  function ExpiriesFactory($http, apiUrl, GenericService, IndexedDBService) {
    var objType = "CrewExpiries";
    var objCallback = CrewExpiries;
    /**
     * Initialize the ScheduleChanges
     * @memberof ScheduleAcknowledgeFactory
     */

    function CrewExpiries() {
      this.expiries = [];
      this.showExpiriesModal = false;
    }

    var service = {
      setCrewExpiriesToStorage: setCrewExpiriesToStorage,
      getCrewExpiriesFromStorage: getCrewExpiriesFromStorage,
      showExpiriesModal: showExpiriesModal,
      showExpiriesAlert: showExpiriesAlert,
      updateShowExpiriesModal: updateShowExpiriesModal,
      setAllExpiriesToStorage: setAllExpiriesToStorage,
      getAllExpiriesFromStorage: getAllExpiriesFromStorage,
      showExpiredExpiriesAlert: showExpiredExpiriesAlert,
      getExpiredExpiries: getExpiredExpiries,
      exportCrewExpiriesToPdf: exportCrewExpiriesToPdf
    };
    /**
     * Save expiries info to storage
     * @param {array} objList A list of Crew Expiries
     */

    function setCrewExpiriesToStorage(objList) {
      if (objList != null) {
        var crewExpiries = {
          expiries: objList,
          showExpiriesModal: true
        };
        GenericService.saveOne(crewExpiries, objType, objCallback);
      }
    }
    /**
     * Get expiries info from storage
     */


    function getCrewExpiriesFromStorage() {
      return GenericService.getOne(objType, objCallback);
    }

    function setAllExpiriesToStorage(objList) {
      if (objList && Array.isArray(objList)) {
        var allExpiries = {
          expiries: objList,
          showExpiriesModal: false
        };
        IndexedDBService.removeAll("AllExpiries").then(function () {
          return IndexedDBService.addAll("AllExpiries", objList);
        })["catch"](function (error) {
          console.error("Failed to store non-medical/passport expiries:", error);
        });
      }
    }

    function getAllExpiriesFromStorage() {
      return IndexedDBService.getAll("AllExpiries");
    }
    /**
     * Shows expiries modal
     * @memberof ExpiriesFactory
     * @returns {bool} returns the value of showExpiriesModal property
     */


    function showExpiriesModal() {
      var crewExpiries = getCrewExpiriesFromStorage();
      var needsReminder = false;

      if (crewExpiries && crewExpiries.expiries && crewExpiries.showExpiriesModal) {
        needsReminder = crewExpiries.expiries.some(function (item) {
          return (item.ExpiryTypeId == 1 || item.ExpiryTypeId == 2 || item.ExpiryTypeId == 66) && item.NeedsHardAlert;
        });
      }

      return needsReminder;
    }
    /**
     * Shows expiries alert
     * @memberof ExpiriesFactory
     * @returns {bool} returns the value of showExpiriesAlert property
     */


    function showExpiriesAlert() {
      var crewExpiries = getCrewExpiriesFromStorage();
      var needsAlert = false;

      if (crewExpiries && crewExpiries.expiries) {
        needsAlert = crewExpiries.expiries.some(function (item) {
          return (item.ExpiryTypeId == 1 || item.ExpiryTypeId == 2 || item.ExpiryTypeId == 66) && item.NeedsSoftAlert;
        });
      }

      return needsAlert;
    }
    /* Update expiries modal object to storage
     * @memberof ExpiriesFactory
     * @param {bool} canShowModal whether the modal can be displayed
     */


    function updateShowExpiriesModal(canShowModal) {
      var crewExpiries = getCrewExpiriesFromStorage();
      crewExpiries.showExpiriesModal = canShowModal;
      GenericService.saveOne(crewExpiries, objType, objCallback);
    }

    function showExpiredExpiriesAlert() {
      return getExpiredExpiries().then(function (expiredItems) {
        return expiredItems.length > 0;
      });
    }

    function getExpiredExpiries() {
      return getAllExpiriesFromStorage().then(function (crewExpiries) {
        if (!crewExpiries || !Array.isArray(crewExpiries)) {
          return [];
        } //var today = new Date("2016,06,01");


        var today = new Date();
        var expiredItems = crewExpiries.filter(function (item) {
          // Guard: null item or missing date => ignore (NOT expired)
          if (!item || !item.ExpiryDate) {
            return false;
          }

          var expiryDate = new Date(item.ExpiryDate);

          if (isNaN(expiryDate.getTime())) {
            return false;
          }

          var isExpired = expiryDate < today;
          var isNotMedicalOrPassport = item.ExpiryTypeId != 1 && item.ExpiryTypeId != 2 && item.ExpiryTypeId != 66;
          return isExpired && isNotMedicalOrPassport;
        });
        return expiredItems;
      });
    }
    /**
     * Export crew expiries to PDF file
     * @param {object} payload currently displayed data for export
     */


    function exportCrewExpiriesToPdf(payload) {
      return $http.post(apiUrl + "/CrewExpiries/ExportToPdf", payload, {
        headers: {
          "Content-Type": "application/json"
        },
        responseType: "arraybuffer"
      });
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('CrewCallCtrl', CrewCallCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name CrewCallCtrl
  * @description 
  *   View confirmation warning when clicking on a crew member's telephone - Monitor call requests
  * @ngInject
  */

  function CrewCallCtrl($scope, $uibModalInstance, crew, flightId, groundDutyId, CrewCallFactory, UserFactory, LogCallFactory) {
    $scope.close = close;
    $scope.call = call;
    $scope.beforeCall = true;
    $scope.crewFixed = null;

    if (crew.id) {
      $scope.crewFixed = crew;
    } else {
      $scope.crewFixed = {
        id: crew.Id,
        name: crew.Name,
        PhoneNumber: crew.PhoneNumber
      };
    }
    /**
     * Close the modal
     */


    function close() {
      $uibModalInstance.close(false);
    }
    /**
     * Confirm Call
     */


    function call() {
      $scope.beforeCall = false;
      var user = UserFactory.getUser();
      var logData = {
        Requester: user.id,
        Requestee: $scope.crewFixed.id,
        FlightId: flightId,
        GroundDutyId: groundDutyId,
        Date: moment.utc()
      };

      if ($scope.isOffline) {
        //Offline: save audit to local storage, send later on sync
        LogCallFactory.saveLogCall(logData);
      } else {
        //Online : API call to save audit right now
        CrewCallFactory.LogCall(logData, function (responseData) {});
      }
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CrewCallFactory', CrewCallFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name CrewCallFactory
   * @ngInject
   */

  function CrewCallFactory(GenericService, $http, apiUrl) {
    function CrewCall() {
      this.FlightId = null;
      this.CrewId = null;
      this.phoneNumber = null;
    }

    var objType = 'crewCall';
    var objCallback = CrewCall;
    var service = {
      getCrewCallsFromStorage: getCrewCallsFromStorage,
      setCrewCallsToStorage: setCrewCallsToStorage,
      getCrewCallFromStorage: getCrewCallFromStorage,
      getFlightCrewCallsFromStorage: getFlightCrewCallsFromStorage,
      saveCrewCall: saveCrewCall,
      cleanOldData: cleanOldData,
      LogCall: LogCall,
      cleanFlightCrewNumbers: cleanFlightCrewNumbers,
      saveFlightPhoneNumbers: saveFlightPhoneNumbers
    };
    /**
    * Get Crew Phone Numbers.
    * @memberof CrewCallFactory
    * @returns {Array} CrewPhoneNumbers 
    */

    function getCrewCallsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Get Crew Phone Numbers for specified flight
     * @memberof CrewCallFactory
     * @param {number} flightId
     * @returns {Array} CrewPhoneNumbers 
     */


    function getFlightCrewCallsFromStorage(flightId) {
      var phoneNumbers = GenericService.list(objType, objCallback);
      return phoneNumbers.filter(function (x) {
        return x.FlightId == flightId;
      });
    }
    /**
     * Save Crew Phone Numbers to storage
     * @memberof CrewCallFactory
     * @param {Array} CrewPhoneNumbers
     */


    function setCrewCallsToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }
    /**
     * Get Crew Phone Number from storage 
     * @memberof CrewCallFactory
     * @param {number} crewId
     * @param {number} flightId
     * @return {object} crew phone number
     */


    function getCrewCallFromStorage(crewId, flightId) {
      var phoneNumbers = getCrewCallsFromStorage();
      return phoneNumbers.find(function (x) {
        return x.FlightId == flightId && x.CrewId == crewId;
      });
    }
    /**
    * Save a fetched crew phone number
     * @memberof CrewCallFactory
    * @param {object} crewCall 
    */


    function saveCrewCall(crewCall) {
      GenericService.add(crewCall, objType, objCallback);
    }
    /**
     * Clean ls from old flight phone numbers
     * @param {array} flights Synced flights
     */


    function cleanOldData(responseFlightIds) {
      var phoneNumbers = getCrewCallsFromStorage(); //Filter out phone numbers of old flights

      phoneNumbers = phoneNumbers.filter(function (x) {
        return responseFlightIds.includes(x.FlightId);
      });
      var now = moment.utc();
      var keepingPhoneNumbers = [];
      phoneNumbers.forEach(function (item) {
        //Fetch FROM
        //Convert from Date UTC to Moment UTC
        var dateSTD = new Date(item.STD).fromUTC();
        var std = moment(dateSTD).utc();
        var minFetchTime = moment(std).add(-24, 'hours'); //Fetch UNTIL
        //Convert from Date UTC to Moment UTC

        var dateSTA = new Date(item.STA).fromUTC();
        var sta = moment(dateSTA).utc();
        var maxFetchTime = moment(sta).add(2, 'hours');
        var isAfter = now.isAfter(minFetchTime);
        var isBefore = now.isBefore(maxFetchTime);

        if (isAfter && isBefore) {
          keepingPhoneNumbers.push(item);
        }
      });
      setCrewCallsToStorage(keepingPhoneNumbers);
    }
    /**
     * Log call request
     * @param {string} logData Requester, Requestee, FlightId
     * @param {function} callback 
     * @param {function} errorCallback 
     */


    function LogCall(logData, callback, errorCallback) {
      return $http.post(apiUrl + '/Info/LogCrewMemberCall', logData, {
        'Content-Type': 'application/json'
      }).then(callback)["catch"](errorCallback);
    }
    /**
     * Clean all stored phone numbers for selected flight
     * @param {number} flightId 
     */


    function cleanFlightCrewNumbers(flightId) {
      var phoneNumbers = getCrewCallsFromStorage();
      phoneNumbers = phoneNumbers.filter(function (x) {
        return x.FlightId != flightId;
      });
      setCrewCallsToStorage(phoneNumbers);
    }
    /**
     * Save any found crew phone numbers for specified flight
     * @param {number} flightId 
     * @param {array} crew 
     * @param {datetime} sta 
     * @param {datetime} std 
     */


    function saveFlightPhoneNumbers(flightId, crew, sta, std) {
      crew.forEach(function (user) {
        if (user.PhoneNumber) {
          var crewPhone = {
            FlightId: flightId,
            CrewId: user.id,
            PhoneNumber: user.PhoneNumber,
            STA: sta,
            //sta & std values will be used during sync to check timerange eligibility (-24h sta / +2h std)
            STD: std
          };
          saveCrewCall(crewPhone);
        }
      });
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('FlightCheckInsFactory', FlightCheckInsFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name FlightCheckInsFactory
   * @ngInject
   */

  function FlightCheckInsFactory(GenericService) {
    function FlightCheckIn() {
      this.FlightId = null;
      this.CrewId = null;
      this.CheckIn = null;
      this.WillBeThereAt = null;
    }

    var objType = 'flightCheckIns';
    var objCallback = FlightCheckIn;
    var service = {
      updateFlightCrewCheckInToStorage: updateFlightCrewCheckInToStorage,
      getFlightCrewCheckInFromStorage: getFlightCrewCheckInFromStorage,
      cleanOldData: cleanOldData
    };
    /**
    * Get Crew Check-Ins.
    * @memberof CrewCallFactory
    * @returns {Array} CrewPhoneNumbers 
    */

    function getCrewCheckInFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Save crew checkIns to storage
     * @memberof CrewCallFactory
     * @param {Array} CrewPhoneNumbers
     */


    function setCrewCheckInToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }
    /**
     * Update Crew CheckIns for specified flight
     * @memberof CrewCallFactory
     * @param {} flight duty
     * @returns {Array} CrewFlightCrewCheckIns 
     */


    function updateFlightCrewCheckInToStorage(duty) {
      //Get all checkIns exept current flight from storage
      var storedCheckIns = getCrewCheckInFromStorage();
      var storedCheckInsFiltered = storedCheckIns.filter(function (f) {
        return f.FlightId != duty.FlightInfo.FlightId;
      }); //Get checkIns from duty and add new crew checkIns to list

      if (duty && duty.FlightInfo && duty.FlightInfo.crew) {
        duty.FlightInfo.crew.forEach(function (item) {
          storedCheckInsFiltered.push({
            FlightId: duty.FlightInfo.FlightId,
            CrewId: item.id,
            CheckIn: item.CheckIn,
            WillBeThereAt: item.WillBeThereAt
          });
        }); //save checkIns

        setCrewCheckInToStorage(storedCheckInsFiltered);
      }
    }
    /**
     * Get Crew CheckIns for specified flight
     * @memberof CrewCallFactory
     * @param {number} flightId
     * @returns {Array} CrewFlightCrewCheckIns 
     */


    function getFlightCrewCheckInFromStorage(flightId) {
      var storedCheckIns = getCrewCheckInFromStorage();
      return storedCheckIns.filter(function (x) {
        return x.FlightId == flightId;
      });
    }
    /**
    * Clean ls from old flights crew check-ins
    * @param {array} flights Synced flights
    */


    function cleanOldData(responseFlightIds) {
      var storedCheckIns = getCrewCheckInFromStorage(); //Filter out crew check-ins of old flights

      var previousCheckIns = storedCheckIns.filter(function (x) {
        return responseFlightIds.includes(x.FlightId);
      });
      setCrewCheckInToStorage(previousCheckIns);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('crewInfo', crewInfo);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name crewInfo
  * @restrict E
  * @description
  *   Crew Table with a double row per crew member
  * @example
  *   Usage:
  *   <crew-info></crew-info>
  * @ngInject
  */

  function crewInfo($uibModal, UserFactory, PaxInfoFactory) {
    function link(scope, element, attrs) {
      scope.user = UserFactory.getUser();
      scope.openPhoneConfirmation = openPhoneConfirmation;
      scope.showInfoRow = showInfoRow;
      scope.showArrivalFormat = showArrivalFormat;
      scope.hiddenButtonHistory = scope.aircraftroute;

      if (scope.type == "flight") {
        var positionOrder = ['CP', 'FO'];
        scope.crewMembers = scope.crew.filter(function (x) {
          return (x.position == 'CP' || x.position == "FO") && !x.isDHC;
        }).sort(function (a, b) {
          // 1. Order: CP→FO
          var posDiff = positionOrder.indexOf(a.position) - positionOrder.indexOf(b.position);
          if (posDiff !== 0) return posDiff; // 2. If same position, order by aimsId

          return a.aimsId < b.aimsId ? -1 : a.aimsId > b.aimsId ? 1 : 0;
        }); // scope.crewMembers = scope.crew.filter(x => (x.position == 'CP' || x.position == "FO") && !x.isDHC) .sort((a, b) => {
        //     const positionOrder = ['CP', 'FO' ]; 
        //     return positionOrder.indexOf(a.position) - positionOrder.indexOf(b.position);
        // });
      } else if (scope.type == "cabin") {
        var _positionOrder = ['SA', 'FA'];
        scope.crewMembers = scope.crew.filter(function (x) {
          return (x.position == 'SA' || x.position == "FA") && !x.isDHC;
        }).sort(function (a, b) {
          // 1. Order: SA→FA  
          var posDiff = _positionOrder.indexOf(a.position) - _positionOrder.indexOf(b.position);

          if (posDiff !== 0) return posDiff; // 2. If same position, order by aimsId

          return a.aimsId < b.aimsId ? -1 : a.aimsId > b.aimsId ? 1 : 0;
        });
      } else {
        scope.crewMembers = scope.crew.filter(function (x) {
          return x.isDHC;
        });

        if (scope.crewMembers.length > 0 && !scope.hiddenButtonHistory) {
          PaxInfoFactory.getPaxInfoList(scope.selectedflightid, function (passengerList) {
            if (passengerList) {
              scope.crewMembers.forEach(function (crewMember) {
                var matchedPassenger = passengerList.filter(function (x) {
                  return x.IsDHC && x.Fullname.toUpperCase().includes(crewMember.name.toUpperCase());
                });

                if (matchedPassenger && matchedPassenger.length > 0) {
                  crewMember.seatNo = matchedPassenger[0].SeatNo;
                }
              });
            }
          });
        }
      }

      function openPhoneConfirmation(_crew) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/CrewInfo/dlgConfirmCrewCall.html',
          controller: 'CrewCallCtrl',
          size: 'md',
          resolve: {
            crew: function crew() {
              return _crew;
            },
            flightId: function flightId() {
              return scope.selectedflightid;
            },
            groundDutyId: function groundDutyId() {
              return null;
            }
          }
        });
        modalInstance.result.then(function (confirm) {});
      }

      function showInfoRow(item) {
        var differentUser = scope.user.aimsId != item.aimsId;
        var phoneAvailable = item.PhoneNumber && item.PhoneNumber != '';
        var previousDutyAvailable = item.PreviousDuty && item.PreviousDuty.isDifferent;
        var phonesAvailable = scope.crew.filter(function (x) {
          return x.PhoneNumber && x.PhoneNumber != '';
        }).length > 0;
        var checkInStatusAvailable = scope.crew.filter(function (x) {
          return x.CheckIn || x.WillBeThereAt;
        }).length > 0;
        var needsAdditionalFeedback = item.needsAdditionalFeedback;
        return differentUser && (phoneAvailable || previousDutyAvailable || phonesAvailable || checkInStatusAvailable || needsAdditionalFeedback);
      }

      function showArrivalFormat(previousDuty) {
        var formatedArrival = '';
        var dateFormat = 'HH:mm';

        if (previousDuty.showArrivalDate) {
          dateFormat = 'dd/MM HH:mm';
        }

        if (previousDuty.ATA) {
          formatedArrival = '- A ' + moment(previousDuty.ATA).format(dateFormat);
        } else if (previousDuty.ETA) {
          formatedArrival = '- E ' + moment(previousDuty.ETA).format(dateFormat);
        } else {
          formatedArrival = '- S ' + moment(previousDuty.STA).format(dateFormat);
        }

        return formatedArrival;
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/CrewInfo/crewInfo.tpl.html',
      scope: {
        crew: "=",
        type: "=",
        selectedflightid: "=",
        aircraftroute: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('crewPreviousInfo', crewPreviousInfo);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name crewPreviousInfo
  * @restrict E
  * @description
  *   Crew Table with a double row per crew member showing previous duty info
  * @example
  *   Usage:
  *     <crew-previous-info crew="flight.crew" type="'flight'"></crew-previous-info>
  * @ngInject
  */

  function crewPreviousInfo($uibModal, UserFactory) {
    function link(scope, element, attrs) {
      scope.user = UserFactory.getUser();
      scope.filterByPreviousDuty = filterByPreviousDuty;

      if (scope.type == "flight") {
        scope.crewMembers = scope.crew.filter(function (x) {
          return (x.position == 'CP' || x.position == "FO") && !x.isDHC;
        });
      } else if (scope.type == "cabin") {
        scope.crewMembers = scope.crew.filter(function (x) {
          return (x.position == 'SA' || x.position == "FA") && !x.isDHC;
        });
      } else {
        scope.crewMembers = scope.crew.filter(function (x) {
          return x.isDHC;
        });
      }

      function filterByPreviousDuty() {
        return function (crew) {
          return crew.PreviousDuty && crew.PreviousDuty.isDifferent;
        };
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/CrewInfo/crewPreviousInfo.tpl.html',
      scope: {
        crew: "=",
        type: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('LogCallFactory', LogCallFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name LogCallFactory
   * @ngInject
   */

  function LogCallFactory(GenericService, $http, apiUrl) {
    function LogCall() {
      this.Requester = null;
      this.Requestee = null;
      this.FlightId = null;
      this.GroundDutyId = null;
      this.Date = null;
    }

    var objType = 'logCall';
    var objCallback = LogCall;
    var service = {
      getLogCallsFromStorage: getLogCallsFromStorage,
      cleanLogsFromStorage: cleanLogsFromStorage,
      saveLogCall: saveLogCall
    };
    /**
    * Get Offline Logged Calls.
    * @memberof LogCallFactory
    */

    function getLogCallsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
    * Clean local storage
    * @memberof CrewCallFactory
    */


    function cleanLogsFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }
    /**
    * Save an offline call request
     * @memberof CrewCallFactory
    * @param {object} logData 
    */


    function saveLogCall(logData) {
      GenericService.add(logData, objType, objCallback);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('PreviousDutyFactory', PreviousDutyFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name PreviousDutyFactory
   * @ngInject
   */

  function PreviousDutyFactory(GenericService, $http, apiUrl) {
    function PreviousDuty() {
      this.FlightId = null;
      this.CrewId = null;
      this.PreviousDuty = null;
    }

    var objType = 'previousDuty';
    var objCallback = PreviousDuty;
    var service = {
      getPreviousDutiesFromStorage: getPreviousDutiesFromStorage,
      setPreviousDutiesToStorage: setPreviousDutiesToStorage,
      getPreviousDutyFromStorage: getPreviousDutyFromStorage,
      getFlightPreviousDutiesFromStorage: getFlightPreviousDutiesFromStorage,
      savePreviousDuty: savePreviousDuty,
      cleanOldData: cleanOldData,
      cleanFlightPreviousDuties: cleanFlightPreviousDuties,
      saveFlightPreviousDuties: saveFlightPreviousDuties
    };
    /**
    * Get Crew Phone Numbers.
    * @memberof PreviousDutyFactory
    * @returns {Array} PreviousDuties 
    */

    function getPreviousDutiesFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Get Crew Phone Numbers for specified flight
     * @memberof PreviousDutyFactory
     * @param {number} flightId
     * @returns {Array} PreviousDuties 
     */


    function getFlightPreviousDutiesFromStorage(flightId) {
      var previousDuties = GenericService.list(objType, objCallback);
      return previousDuties.filter(function (x) {
        return x.FlightId == flightId;
      });
    }
    /**
     * Save Crew Phone Numbers to storage
     * @memberof PreviousDutyFactory
     * @param {Array} PreviousDuties
     */


    function setPreviousDutiesToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }
    /**
     * Get Previous Duty from storage 
     * @memberof PreviousDutyFactory
     * @param {number} crewId
     * @param {number} flightId
     * @return {object} previous duty info
     */


    function getPreviousDutyFromStorage(crewId, flightId) {
      var previousDuties = getPreviousDutiesFromStorage();
      return previousDuties.find(function (x) {
        return x.FlightId == flightId && x.CrewId == crewId;
      });
    }
    /**
    * Save a fetched previous duty
     * @memberof PreviousDutyFactory
    * @param {object} previousDuty 
    */


    function savePreviousDuty(previousDuty) {
      GenericService.add(previousDuty, objType, objCallback);
    }
    /**
     * Clean ls from old flight previous duties
     * @param {array} flights Synced flights
     */


    function cleanOldData(responseFlightIds) {
      var previousDuties = getPreviousDutiesFromStorage(); //Filter out previous duties of old flights

      previousDuties = previousDuties.filter(function (x) {
        return responseFlightIds.includes(x.FlightId);
      });
      setPreviousDutiesToStorage(previousDuties);
    }
    /**
     * Clean all stored previous duties for selected flight
     * @param {number} flightId 
     */


    function cleanFlightPreviousDuties(flightId) {
      var previousDuties = getPreviousDutiesFromStorage();
      previousDuties = previousDuties.filter(function (x) {
        return x.FlightId != flightId;
      });
      setPreviousDutiesToStorage(previousDuties);
    }
    /**
     * Save previous duty info for each flight crew member that has one 
     * @param {number} flightId 
     * @param {array} crew 
     */


    function saveFlightPreviousDuties(flightId, crew) {
      crew.forEach(function (user) {
        if (user.PreviousDuty) {
          var previousDuty = {
            FlightId: flightId,
            CrewId: user.id,
            PreviousDuty: user.PreviousDuty
          };
          savePreviousDuty(previousDuty);
        }
      });
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('CrewContactsModalCtrl', CrewContactsModalCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name CrewContactsModalCtrl
   * @description 
   * Shows crew detais with contacts 
   * @ngInject
   */

  function CrewContactsModalCtrl($scope, $timeout, $uibModalInstance, crewInfo, selectedflightid, selectedFlightNo) {
    $scope.crew = crewInfo;
    $scope.selectedflightid = selectedflightid;
    $scope.closeCrewPanel = closeCrewPanel;
    $scope.selectedFlightNo = selectedFlightNo;
    /**
     * Close the modal 
     * @memberof BucketModalCtrl
     */

    function closeCrewPanel() {
      $uibModalInstance.close();
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CrewHotelFactory', CrewHotelFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CrewHotelFactory
  * @description 
  * Get hotels
  * @ngInject
  */

  function CrewHotelFactory(GenericService, $http, apiUrl) {
    var objType = 'crewHotel';
    var objCallback = CrewHotel;
    var service = {
      getCrewHotelsFromStorage: getCrewHotelsFromStorage,
      setCrewHotelsToStorage: setCrewHotelsToStorage,
      getCrewHotelFromStorage: getCrewHotelFromStorage
    };
    /**
    * Initialize the CrewHotel
    * @memberof CrewHotelFactory
    */

    function CrewHotel() {
      this.AimsId = null;
      this.CrewName = null;
      this.DutyDate = null;
      this.Base = null;
      this.Airport = null;
      this.HotelNo = null;
      this.HotelName = null;
      this.GroundTime = null;
    }
    /**
     * Get Crew Hotels
     * @memberof CrewHotelFactory
     * @returns {Array} CrewHotels 
     */


    function getCrewHotelsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Save Crew Hotels to storage
     * @memberof GroundDutyFactory
     * @param {Array} objList A list of Crew Hotels
     */


    function setCrewHotelsToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }
    /**
    * Get a specific Hotel
    * @memberof CrewHotelFactory
    * @returns {object} CrewHotel
    */


    function getCrewHotelFromStorage(dutydate) {
      var crewHotels = getCrewHotelsFromStorage();
      if (crewHotels == null) return [];
      var arrayLength = crewHotels.length;

      for (var i = 0; i < arrayLength; i++) {
        if (crewHotels[i].Dutydate == dutydate) {
          return crewHotels[i];
        }
      }
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CrewMealFactory', CrewMealFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CrewMealFactory
  * @description 
  * Get and Update Crew Meals 
  * @ngInject
  */

  function CrewMealFactory(GenericService, $http, apiUrl) {
    var objType = 'crewMeal';
    var objCallback = CrewMeal;
    var objCallbackRatings = RatingObj;
    var ratingSubmitResponseObj = {
      success: false,
      message: ''
    };
    var service = {
      getCrewMealsFromStorage: getCrewMealsFromStorage,
      setCrewMealsToStorage: setCrewMealsToStorage,
      getCrewMealFromStorage: getCrewMealFromStorage,
      sendCrewMealsRatingReport: sendCrewMealsRatingReport,
      hasRating: hasRating,
      getCrewMealsDidNotEatReasons: getCrewMealsDidNotEatReasons
    };
    /**
    * Initialize the CrewMeal
    * @memberof CrewMealFactory
    */

    function CrewMeal() {
      this.CateringMealId = null;
      this.Title = null;
      this.Description = null;
    }

    function RatingObj() {
      this.CrewMealId = null, this.TimeStamp = null;
    }
    /**
     * Get Crew Meals
     * @memberof CrewMealFactory
     * @returns {Array} CrewMeals 
     */


    function getCrewMealsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Save Crew Meals to storage
     * @memberof GroundDutyFactory
     * @param {Array} objList A list of Crew Meals
     */


    function setCrewMealsToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }
    /**
    * Get a specific Crew Meal
    * @memberof CrewMealFactory
    * @returns {object} CrewMeal
    */


    function getCrewMealFromStorage(cateringMealId) {
      var crewMeals = getCrewMealsFromStorage();
      if (crewMeals == null) return [];
      var arrayLength = crewMeals.length;

      for (var i = 0; i < arrayLength; i++) {
        if (crewMeals[i].CateringMealId == cateringMealId) {
          return crewMeals[i];
        }
      }
    }
    /**
    * Checks if the specified crew meal has rating
    * @memberof CrewMealFactory
    * @returns {boolean} response
    */


    function hasRating(crewMealId) {
      var res = GenericService.list("CrewMealRatings", objCallbackRatings);
      return res.some(function (e) {
        return e.CrewMealId === crewMealId.toString();
      });
    }
    /**
    * Sends the crew meals rating report
    * @memberof CrewMealFactory
    * @returns {ratingSubmitResponseObj} ratingSubmitResponseObj
    */


    function sendCrewMealsRatingReport(ratingForm) {
      var objectToAdd = {
        CrewMealId: ratingForm.CrewMealId,
        TimeStamp: new Date()
      };
      return $http.post(apiUrl + '/CrewMealsRating/SaveReport', ratingForm, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return saveReportSuccessCallBack(res, objectToAdd);
      })["catch"](function (res) {
        return saveReportFailedCallBack(res);
      });
    }
    /**
    * The callback function if the save report succeed
    * @returns {ratingSubmitResponseObj} ratingSubmitResponseObj
    */


    function saveReportSuccessCallBack(res, objectToAdd) {
      ratingSubmitResponseObj.success = res.data.success;

      if (res.data.success) {
        GenericService.add(objectToAdd, "CrewMealRatings", objCallbackRatings);
        ratingSubmitResponseObj.message = "Thank you for your feedback";
      } else {
        ratingSubmitResponseObj.message = res.data.errorMessage;
      }

      return ratingSubmitResponseObj;
    }
    /**
    * Gets the choices for the dropdown if a crew member did not eat their meal
    * @returns {ratingSubmitResponseObj} ratingSubmitResponseObj
    */


    function getCrewMealsDidNotEatReasons() {
      return $http.get(apiUrl + '/CrewMealsRating/GetCrewMealsDidNotEatReasons', {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return res.data;
      });
    }
    /**
    * The callback function if the save report fail
    * @returns {ratingSubmitResponseObj} ratingSubmitResponseObj
    */


    function saveReportFailedCallBack(res) {
      ratingSubmitResponseObj.success = false;
      ratingSubmitResponseObj.message = "Something went wrong!";
      return ratingSubmitResponseObj;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('CrewRouteCtrl', CrewRouteCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name CrewRouteCtrl
   * @description 
   * Shows the crew route information
   * @ngInject
   */

  function CrewRouteCtrl($scope, $filter, $route, $location, $routeParams, $uibModal, FlightFactory, SyncLogFactory, GroundDutyFactory, CrewRouteFactory) {
    var _dutyNo = $routeParams.dutyNo;
    var _dutyDay = $routeParams.dutyDay;
    $scope.crewRouteDuty = CrewRouteFactory.getCrewRouteFromStorage(_dutyNo, _dutyDay);
    var groundDuties = GroundDutyFactory.getGroundDutiesByDutyNo(_dutyNo, _dutyDay);

    if (groundDuties.length > 0) {
      //there are ground duties in this crew route
      angular.forEach(groundDuties, function (groundDuty) {
        groundDuty.DutyType = "Ground";
        groundDuty.Start = groundDuty.DutyBegin;
      });
    }

    var flights = FlightFactory.getFlightsByDutyNo(_dutyNo, _dutyDay);

    if (flights.length > 0) {
      //there are flights in this crew route
      angular.forEach(flights, function (flight) {
        flight.DutyType = "Flight";
        flight.Start = flight.ScheduledDeparture;
      });
    }

    var crewRoute = groundDuties.concat(flights);
    crewRoute = $filter('orderBy')(crewRoute, 'Start', false);
    $scope.crewRoute = crewRoute;
    $scope.currentDutyDay = null;
    $scope.differentDay = differentDay;
    $scope.currentPage = 1;
    $scope.previous = previous;
    $scope.next = next;
    $scope.openRefresh = openRefresh;
    $scope.dutyNo = _dutyNo;
    $scope.dutyDay = _dutyDay;
    $scope.firstFlightId = getFirstFlightId();
    /**
    * Get the flightId from the first leg of the route
    */

    function getFirstFlightId() {
      var flightId = null;

      if (flights.length > 0) {
        flightId = flights[0].FlightId;
      }

      return flightId;
    }
    /**
     * Checks if two dates have the same day
     * @param {string} day1 
     * @param {string} day2 
     */


    function differentDay(day1, day2) {
      day1 = new Date(day1).trimTime().getDay();
      day2 = new Date(day2).trimTime().getDay();
      return day1 == day2 ? false : true;
    }
    /**
     * Moves pager to previous page
     */


    function previous() {
      if ($scope.currentPage != 1) $scope.currentPage--;
    }
    /**
     * Moves pager to next page
     */


    function next() {
      if ($scope.currentPage != crewRoute.length) $scope.currentPage++;
    }
    /**
     * Opens refresh modal
     */


    function openRefresh() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/CrewRoute/dlgCrewRouteRefresh.html',
        controller: 'CrewRouteRefreshModalCtrl',
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          crewroute: function crewroute() {
            return $scope.crewRoute;
          },
          crewRouteDuty: function crewRouteDuty() {
            return $scope.crewRouteDuty;
          },
          dutyNo: function dutyNo() {
            return Number(_dutyNo);
          },
          dutyDay: function dutyDay() {
            return Number(_dutyDay);
          },
          forCurrentDay: function forCurrentDay() {
            return null;
          }
        }
      });
      modalInstance.result.then(function (transferData) {
        if (transferData.sync) {
          SyncLogFactory.forceSync();
          $location.path("/"); //crew route has significantly changed
        } else if (transferData.refresh) {
          $route.reload(); //crew route was updated
        }
      });
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CrewRouteFactory', CrewRouteFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CrewRouteFactory
  * @description 
  * Get and Update Crew Routes 
  * @ngInject
  */

  function CrewRouteFactory(GenericService, FlightFactory, GroundDutyFactory, $filter, AircaftPositionsFactory, CrewMealFactory, FlightDelaysFactory) {
    var objType = 'crewRoute';
    var objCallback = CrewRoute;
    var service = {
      getCrewRoutesFromStorage: getCrewRoutesFromStorage,
      setCrewRoutesToStorage: setCrewRoutesToStorage,
      setCourseCompleted: setCourseCompleted,
      setCoursePending: setCoursePending,
      updateCrewMealsInRoute: updateCrewMealsInRoute,
      updateRouteLastRefreshDate: updateRouteLastRefreshDate,
      getCrewRouteFromStorage: getCrewRouteFromStorage,
      getCrewRouteDuties: getCrewRouteDuties,
      getCrewRouteInfoPanel: getCrewRouteInfoPanel,
      getCrewRouteFlights: getCrewRouteFlights,
      getSACrewMembersFromRoute: getSACrewMembersFromRoute,
      getFACrewMembersFromRoute: getFACrewMembersFromRoute,
      updateCrewRouteDuty: updateCrewRouteDuty,
      addCrewRouteDuty: addCrewRouteDuty,
      getManualFlightTrainingsFromStorage: getManualFlightTrainingsFromStorage,
      removeFlightTraining: removeFlightTraining,
      insertCrewRoutesWithPendingTrainings: insertCrewRoutesWithPendingTrainings
    };
    /**
    * Initialize the CrewRoute
    * @memberof CrewRouteFactory
    */

    function CrewRoute() {
      this.DutyDay = null;
      this.DutyNo = null;
      this.Route = null;
      this.DutyBegin = null;
      this.DutyEnd = null;
      this.CrewMeals = []; //new property: get the value from CrewAssessmentFactory

      this.LastRefreshed = null;
    }
    /**
     * Get Crew Routes
     * @memberof CrewRouteFactory
     * @returns {Array} CrewRoutes 
     */


    function getCrewRoutesFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Save Crew Routes to storage
     * @memberof GroundDutyFactory
     * @param {Array} objList A list of Crew Routes
     */


    function setCrewRoutesToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }
    /**
    * Get a specific Crew Route
    * @memberof CrewRouteFactory
    * @returns {object} CrewRoute
    */


    function getCrewRouteFromStorage(dutyNo, dutyDay) {
      var crewRoutes = getCrewRoutesFromStorage();
      if (crewRoutes == null) return [];
      var arrayLength = crewRoutes.length;

      for (var i = 0; i < arrayLength; i++) {
        if (crewRoutes[i].DutyNo == dutyNo && crewRoutes[i].DutyDay == dutyDay) {
          return crewRoutes[i];
        }
      }
    }

    function setCourseCompleted(dutyNo, dutyDay, courseId, date) {
      var crewRoutes = getCrewRoutesFromStorage();
      var crewRoute = crewRoutes.find(function (cr) {
        return cr.DutyNo == dutyNo && cr.DutyDay == dutyDay;
      });

      if (!crewRoute || !Array.isArray(crewRoute.FlightIds) || !Array.isArray(crewRoute.Courses)) {
        return;
      }

      var flightIds = crewRoute.FlightIds;
      var flights = FlightFactory.getFlightsFromStorage().filter(function (x) {
        return flightIds.includes(x.FlightId);
      });
      var crewRouteCourse = crewRoute.Courses.find(function (x) {
        return x.CourseId == courseId && new moment(x.Date).isSame(date);
      });
      if (crewRouteCourse) crewRouteCourse.Status = "Completed";
      flights.forEach(function (flight) {
        var flightCourse = flight.Courses.find(function (x) {
          return x.CourseId == courseId && new moment(x.Date).isSame(date);
        });

        if (flightCourse) {
          flightCourse.Status = "Completed";
          FlightFactory.updateFlight(flight);
        }
      });
      GenericService.saveAll(crewRoutes, objType, objCallback);
    }

    function setCoursePending(dutyNo, dutyDay, courseId, date) {
      var crewRoutes = getCrewRoutesFromStorage();
      var crewRoute = crewRoutes.find(function (cr) {
        return cr.DutyNo == dutyNo && cr.DutyDay == dutyDay;
      });

      if (!crewRoute || !Array.isArray(crewRoute.Courses)) {
        return;
      }

      var crewRouteCourse = crewRoute.Courses.find(function (x) {
        return x.CourseId == courseId && new moment(x.Date).isSame(date);
      });
      if (crewRouteCourse) crewRouteCourse.Status = "Pending";
      GenericService.saveAll(crewRoutes, objType, objCallback);
    }

    function getCrewRouteDuties(dutyNo, dutyDay, flightDate) {
      var groundDuties = GroundDutyFactory.getGroundDutiesByDutyNo(dutyNo, dutyDay).filter(function (x) {
        return x.DutyDate == flightDate;
      });

      if (groundDuties.length > 0) {
        //there are ground duties in this crew route
        angular.forEach(groundDuties, function (groundDuty) {
          groundDuty.DutyType = "Ground";
          groundDuty.Start = groundDuty.DutyBegin; // groundDuty.Date = groundDuty.DutyDate;
        });
      } // var flights = FlightFactory.getFlightsByDutyNo(dutyNo, dutyDay).filter(x => x.DutyDate == flightDate);


      var flights = getCrewRouteFlights(dutyNo, dutyDay, flightDate);

      if (flights.length > 0) {
        //there are flights in this crew route
        angular.forEach(flights, function (flight) {
          flight.DutyType = "Flight";
          flight.Start = flight.ScheduledDeparture;
          flight.showNextAcPos = false;
          flight.showPreviousAcPos = false;
          flight.hasChangeAircraft = false;
          flight.isFirst = false;
          flight.isLast = false;
          flight.BTime = "";
          flight.Delay = 0;
          flight.ArrDelay = 0;
          flight.crewMeals = "";
          flight.aircaftPositions = null;
          flight.flightDelays = null;
        });
      }

      flights = $filter('orderBy')(flights, 'Start'); // check if aircraft change exists          

      flights.forEach(function (flight, index, array) {
        flight.isFirst = index == 0;
        flight.isLast = index + 1 == array.length;

        if (flight.isFirst) {
          flight.showPreviousAcPos = true;
        }

        if (flight.isLast) {
          flight.showNextAcPos = true;
        }

        if (!flight.isFirst && flights[index - 1].AcTailNo != flight.AcTailNo) {
          flight.showPreviousAcPos = true;
        }

        if (!flight.isLast && flights[index + 1].AcTailNo != flight.AcTailNo) {
          flight.showNextAcPos = true;
          flight.hasChangeAircraft = true;
        }

        var diffMin = Date.DifferenceInMinutes(flight.ScheduledDeparture, flight.ScheduledArrival);
        flight.BTime = Date.MinutesToStringSimple(diffMin);
        flight.Delay = moment(flight.ATD).diff(moment(flight.ScheduledDeparture), 'minutes') || "";
        flight.ArrDelay = moment(flight.ATA).diff(moment(flight.ScheduledArrival), 'minutes') || "";
        flight.aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId(flight.FlightId);

        if (flight.aircaftPositions) {
          // Previous Flight
          flight.aircaftPositions.PreviousFlightDelay = moment(flight.aircaftPositions.PreviousATD).diff(moment(flight.aircaftPositions.PreviousSTD), 'minutes') || "";
          flight.aircaftPositions.PreviousFlightArrDelay = moment(flight.aircaftPositions.PreviousATA).diff(moment(flight.aircaftPositions.PreviousSTA), 'minutes') || "";
          var diffPreviousFlightMin = Date.DifferenceInMinutes(flight.aircaftPositions.PreviousSTD, flight.aircaftPositions.PreviousSTA);
          flight.aircaftPositions.PreviousFlightBTime = Date.MinutesToStringSimple(diffPreviousFlightMin);
          flight.aircaftPositions.PreviousDelays = FlightDelaysFactory.getFlightDelaysByFlightId(flight.aircaftPositions.PreviousFlightId); // Next Flight

          flight.aircaftPositions.NextFlightDelay = moment(flight.aircaftPositions.NextATD).diff(moment(flight.aircaftPositions.NextSTD), 'minutes') || "";
          flight.aircaftPositions.NextFlightArrDelay = moment(flight.aircaftPositions.NextATA).diff(moment(flight.aircaftPositions.NextSTA), 'minutes') || "";
          var diffNextFlightMin = Date.DifferenceInMinutes(flight.aircaftPositions.NextSTD, flight.aircaftPositions.NextSTA);
          flight.aircaftPositions.NextFlightBTime = Date.MinutesToStringSimple(diffNextFlightMin);
          flight.aircaftPositions.NextDelays = FlightDelaysFactory.getFlightDelaysByFlightId(flight.aircaftPositions.NextFlightId);
        }

        flight.flightDelays = FlightDelaysFactory.getFlightDelaysByFlightId(flight.FlightId);
      });
      var crewRouteDuties = groundDuties.concat(flights);
      crewRouteDuties = $filter('orderBy')(crewRouteDuties, 'Start');
      return crewRouteDuties;
    }

    function getCrewRouteFlights(dutyNo, dutyDay, flightDate) {
      var crewRoutes = getCrewRoutesFromStorage() || [];
      var crewRoute = crewRoutes.find(function (cr) {
        return cr.DutyNo == dutyNo && cr.DutyDay == dutyDay;
      });

      if (!crewRoute || !Array.isArray(crewRoute.FlightIds)) {
        return [];
      }

      var flightIds = crewRoute.FlightIds;
      var flights = FlightFactory.getFlightsFromStorage().filter(function (x) {
        return flightIds.includes(x.FlightId) && x.FlightDate == flightDate;
      });
      return flights;
    }

    function getCrewRouteAllFlights(dutyNo, dutyDay) {
      var crewRoutes = getCrewRoutesFromStorage();
      var crewRoute = crewRoutes.find(function (cr) {
        return cr.DutyNo == dutyNo && cr.DutyDay == dutyDay;
      });
      var flights = [];

      if (crewRoute && crewRoute.FlightIds && crewRoute.FlightIds.length > 0) {
        flights = FlightFactory.getFlightsFromStorage().filter(function (x) {
          return crewRoute.FlightIds.includes(x.FlightId);
        });
      }

      return flights;
    }

    function getSACrewMembersFromRoute(dutyNo, dutyDay, flightDate) {
      var flights = getCrewRouteFlights(dutyNo, dutyDay, flightDate);
      var saMembers = [];
      flights.forEach(function (flight) {
        flight.crew.forEach(function (member) {
          if (member.position == 'SA' && !member.isDHC) {
            saMembers.push(member.aimsId);
          }
        });
      });
      return saMembers;
    }

    function getFACrewMembersFromRoute(dutyNo, dutyDay, flightDate) {
      var flights = getCrewRouteFlights(dutyNo, dutyDay, flightDate);
      var faMembers = [];
      flights.forEach(function (flight) {
        flight.crew.forEach(function (member) {
          if (member.position == 'FA' && !member.isDHC) {
            faMembers.push(member.aimsId);
          }
        });
      });
      return faMembers;
    }

    function updateCrewRouteDuty(flightTraining) {
      GenericService.updateFlight(flightTraining, objType, objCallback);
    }

    function addCrewRouteDuty(flightTraining) {
      var crewRoutes = getCrewRoutesFromStorage();
      var crewRoute = crewRoutes.find(function (cr) {
        return cr.DutyNo == flightTraining.DutyNo && cr.DutyDay == flightTraining.DutyDay;
      });

      if (crewRoute) {
        crewRoute.isManualEntry = true;
        crewRoute.hasPendingCourse = true;
      } else {
        GenericService.add(flightTraining, objType, objCallback);
      }
    }

    function removeFlightTraining(dutyNo, dutyDay) {
      var crewRoutes = getCrewRoutesFromStorage();
      var crewRoute = crewRoutes.find(function (cr) {
        return cr.DutyNo == dutyNo && cr.DutyDay == dutyDay;
      });

      if (!crewRoute) {
        return;
      }

      crewRoute.isManualEntry = false;
      crewRoute.hasPendingCourse = false;
      GenericService.saveAll(crewRoutes, objType, objCallback);
    }
    /**Get manual flight trainings from storage*/


    function getManualFlightTrainingsFromStorage() {
      var crewRoutes = getCrewRoutesFromStorage();
      return crewRoutes.filter(function (x) {
        return x.isManualEntry;
      });
    }

    function updateCrewMealsInRoute(dutyNo, dutyDay, newCrewMeals, newFlightIds) {
      var crewRoutes = getCrewRoutesFromStorage();
      var crewRoute = crewRoutes.find(function (cr) {
        return cr.DutyNo == dutyNo && cr.DutyDay == dutyDay;
      });

      if (!crewRoute || !Array.isArray(crewRoute.CrewMeals)) {
        return;
      }

      if (!Array.isArray(newFlightIds)) {
        newFlightIds = [];
      }

      if (!Array.isArray(newCrewMeals)) {
        newCrewMeals = [];
      }

      var crewMealsInRoute = crewRoute.CrewMeals.filter(function (f) {
        return !newFlightIds.includes(f.FlightId);
      });
      crewMealsInRoute = crewMealsInRoute.concat(newCrewMeals);
      crewRoute.CrewMeals = crewMealsInRoute;
      GenericService.saveAll(crewRoutes, objType, objCallback);
    }

    function insertCrewRoutesWithPendingTrainings(instructorPendingRoutes) {
      if (instructorPendingRoutes.length > 0) {
        var crewRoutes = getCrewRoutesFromStorage();
        var crewRoutesIdsLS = crewRoutes.map(function (x) {
          return x.DutyNo;
        });
        var routesToInsert = instructorPendingRoutes.filter(function (f) {
          return !crewRoutesIdsLS.includes(f.DutyNo);
        });

        if (routesToInsert.length > 0) {
          var updatedCrewRoutesList = crewRoutes.concat(routesToInsert);
          GenericService.saveAll(updatedCrewRoutesList, objType, objCallback);
        }
      }
    }
    /**
     * Update last Refresh date for a specific Crew Route
     * @memberof CrewRouteFactory
     */


    function updateRouteLastRefreshDate(dutyNo, dutyDay) {
      var crewRoutes = getCrewRoutesFromStorage();
      var crewRoute = crewRoutes.find(function (cr) {
        return cr.DutyNo == dutyNo && cr.DutyDay == dutyDay;
      });

      if (!crewRoute) {
        return;
      }

      crewRoute.LastRefreshed = moment().toDate().toUTC();
      GenericService.saveAll(crewRoutes, objType, objCallback);
    }
    /**
     * Get Crew Route Info panel information (inside Flight-page)
     * @memberof CrewRouteFactory
     * @returns {object} flights
     */


    function getCrewRouteInfoPanel(flight) {
      var panelInfo = null;
      var crewRouteInfo = getCrewRouteFromStorage(flight.DutyNo, flight.DutyDay);
      var crewRouteDuties = getCrewRouteDuties(flight.DutyNo, flight.DutyDay, flight.FlightDate);
      var crewRouteFlightDuties = crewRouteDuties.filter(function (x) {
        return x.DutyType === "Flight";
      });
      var hasAircraftPositions = crewRouteFlightDuties.length && crewRouteFlightDuties.length > 0 && crewRouteFlightDuties[0].aircaftPositions != null; //update crewRouteDuties with the crewMeals

      var crewMealsPerFlightId = [];
      crewRouteInfo.CrewMeals.forEach(function (meals) {
        if (meals.CrewMealsCateringIds) {
          var crewMealsTitles = "";

          for (var j = 0; j < Object.values(meals.CrewMealsCateringIds).length; j++) {
            if (j != 0) {
              crewMealsTitles += " & ";
            }

            var crewMealDetails = CrewMealFactory.getCrewMealFromStorage(Object.values(meals.CrewMealsCateringIds)[j]);
            crewMealsTitles += crewMealDetails.ShortTitle;
          }

          crewMealsPerFlightId.push({
            flightId: meals.FlightId,
            crewMeals: crewMealsTitles
          });
        }
      });

      if (crewMealsPerFlightId.length > 0) {
        crewRouteDuties.forEach(function (duty) {
          if (duty.FlightId == crewMealsPerFlightId[0].flightId) {
            duty.crewMeals = crewMealsPerFlightId[0].crewMeals;
          }
        });
      }

      var routeNeedRefresh = false;

      if (!crewRouteInfo.LastRefreshed) {
        routeNeedRefresh = true;
      }

      return panelInfo = {
        crewRouteDuties: crewRouteDuties,
        routeNeedRefresh: routeNeedRefresh,
        hasAircraftPositions: hasAircraftPositions
      };
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('CrewRouteRefreshModalCtrl', CrewRouteRefreshModalCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name CrewRouteRefreshModalCtrl
   * @description 
   * 
   * @ngInject
   */

  function CrewRouteRefreshModalCtrl($scope, $filter, $uibModalInstance, crewroute, crewRouteDuty, dutyNo, dutyDay, forCurrentDay, InfoAPIService, FlightSessionFactory, CourseFactory, AirportContactFactory, CrewRouteFactory, LuggageComplianceFactory, GroundServicesFactory, AircraftDifferencesFactory, AirportHotelFactory, TimeLogFactory, CrewCallFactory, PreviousDutyFactory, CampaignFactory, AimsCrewMemosFactory, FlightDelaysFactory, CustomerEventHistoryFactory, FlightServiceEventsFactory, FlightOrdersFactory, SettingsMain, FlightMealCriteriaFactory, MisconnectionFlightsFactory) {
    //timer
    var t0 = performance.now();
    var timeLog = "RefreshFlight: ";
    var tFrom = 0;
    var tTo = 0; // tFrom = performance.now();
    // //do smth
    // tTo = performance.now();
    // timeLog = timeLog + " | smthTime: " + (tTo-tFrom); 

    var isShopInTheCloudEnable = SettingsMain.getIsShopInTheCloudEnable();
    $scope.isRefreshing = true;
    $scope.refreshResultsVisible = false;
    $scope.error = false;
    $scope.sync = false;
    $scope.collapse = collapse;
    $scope.close = close;
    $scope.crewroute = crewroute;
    $scope.crewRouteDuty = crewRouteDuty;
    $scope.crewRouteGeneral = {
      statuses: [],
      isCollapsed: false
    }; //For refresh Flight page: forCurrentDay is not null

    if (forCurrentDay) {
      //Get only the flights from the current day
      var currentDayDuties = crewroute.filter(function (item) {
        return item.DutyType == 'Flight' && item.FlightDate == forCurrentDay || item.DutyType == 'Ground' && item.DutyDate == forCurrentDay;
      });
      crewroute = currentDayDuties;
      $scope.crewroute = currentDayDuties;
      crewRouteDuty.CurrentDutyDate = forCurrentDay;

      if (currentDayDuties.some(function (s) {
        return s.DutyType == 'Flight';
      })) {
        $scope.crewRouteGeneral.statuses = [{
          datatype: "Meals",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Campaigns",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Hotels",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Airport Contacts",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Ground Services",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Aircraft Differences",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Aims Memos",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Flight Service Events",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Misconnection Flights",
          status: "PENDING",
          text: "Pending..."
        }];
      }
    } //add DataStatus to each duty


    for (var i = 0; i < crewroute.length; i++) {
      if (crewroute[i].DutyType == 'Flight') {
        crewroute[i].DataStatus = [{
          datatype: "Flight Status",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Aircraft Movement",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Crew Info",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Crew Contacts",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Pax Info",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Connections",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Luggage Info",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Training Info",
          status: "PENDING",
          text: "Pending..."
        }];

        if (isShopInTheCloudEnable) {
          crewroute[i].DataStatus.push({
            datatype: "Shop In The Cloud",
            status: "PENDING",
            text: "Pending..."
          });
        }
      } else if (crewroute[i].DutyType == 'Ground') {
        if (crewroute[i].isTraining) {
          crewroute[i].DataStatus = [{
            datatype: "Duty Info",
            status: "PENDING",
            text: "Pending..."
          }, {
            datatype: "Instructors",
            status: "PENDING",
            text: "Pending..."
          }, {
            datatype: "Trainees",
            status: "PENDING",
            text: "Pending..."
          }];
        } else {
          crewroute[i].DataStatus = [{
            datatype: "Duty Info",
            status: "PENDING",
            text: "Pending..."
          }];
        }
      }
    } //separate flights and groundDuties 


    var currentFlights = [];
    var currentGroundDuties = [];

    for (var i = 0; i < crewroute.length; i++) {
      if (crewroute[i].DutyType == 'Flight') currentFlights.push(crewroute[i]);else if (crewroute[i].DutyType == 'Ground') currentGroundDuties.push(crewroute[i]);
      crewroute[i].isCollapsed = false;
    } //get latest info


    InfoAPIService.refreshCrewRoute(crewRouteDuty, function (responseData) {
      tTo = performance.now();
      timeLog = timeLog + " | apiResponseTime: " + (tTo - t0);
      $scope.isRefreshing = false;
      var response = responseData.data.data;
      var responseStatuses = {
        meals: false,
        airportContacts: false,
        groundServices: false,
        aircraftDifferences: false,
        airportHotels: false,
        campaigns: false,
        crewAimsMemos: false,
        flightServiceEvents: false,
        misconnectionFlights: false
      };

      if (forCurrentDay) {
        var responseFlightIds = response.Flights.map(function (x) {
          return x.FlightInfo.FlightId;
        }); //Update CrewMeals in the current route // only for refresh flight

        if (response.CrewMeals != undefined && response.CrewMeals != null) {
          tFrom = performance.now();
          CrewRouteFactory.updateCrewMealsInRoute(dutyNo, dutyDay, response.CrewMeals, responseFlightIds);
          responseStatuses.meals = true;
          tTo = performance.now();
          timeLog = timeLog + " | updateCrewMealsInRoute: " + (tTo - tFrom);
        } // Update Airport Contacts


        if (response.AirportContacts && response.AirportContacts.length > 0) {
          tFrom = performance.now();
          AirportContactFactory.upsertAirportContacts(response.AirportContacts);
          responseStatuses.airportContacts = true;
          tTo = performance.now();
          timeLog = timeLog + " | upsertAirportContacts: " + (tTo - tFrom);
        } // Update ground services


        if (response.GroundServices && response.GroundServices.length > 0) {
          tFrom = performance.now();
          GroundServicesFactory.upsertGroundServices(response.GroundServices);
          responseStatuses.groundServices = true;
          tTo = performance.now();
          timeLog = timeLog + " | upsertGroundServices: " + (tTo - tFrom);
        } // Update aircraft differences


        if (response.AircraftDifferences && response.AircraftDifferences.length > 0) {
          tFrom = performance.now();
          AircraftDifferencesFactory.upsertAircraftDifferences(response.AircraftDifferences);
          responseStatuses.aircraftDifferences = true;
          tTo = performance.now();
          timeLog = timeLog + " | upsertAircraftDifferences: " + (tTo - tFrom);
        } // Update airport hotels


        if (response.AirportHotels && response.AirportHotels.length > 0) {
          tFrom = performance.now();
          AirportHotelFactory.upsertAirportHotels(response.AirportHotels);
          responseStatuses.airportHotels = true;
          tTo = performance.now();
          timeLog = timeLog + " | upsertAirportHotels: " + (tTo - tFrom);
        } // Update Aims Crew Memos


        if (response.CrewAimsMemos && response.CrewAimsMemos.length > 0) {
          tFrom = performance.now();
          AimsCrewMemosFactory.upsertAimsCrewMemos(response.CrewAimsMemos);
          responseStatuses.crewAimsMemos = true;
          tTo = performance.now();
          timeLog = timeLog + " | upsertAimsCrewMemos: " + (tTo - tFrom);
        } // Update campaigns


        if (response.Campaigns && response.Campaigns.FlightsCampaigns.length > 0) {
          tFrom = performance.now();
          CampaignFactory.mergeCampaigns(response.Campaigns);
          responseStatuses.campaigns = true;
          tTo = performance.now();
          timeLog = timeLog + " | mergeCampaigns: " + (tTo - tFrom);
        } // Update Flight Delays


        if (response.FlightDelays && response.FlightDelays.length > 0) {
          tFrom = performance.now();
          FlightDelaysFactory.upsertFlightDelays(response.FlightDelays);
          tTo = performance.now();
          timeLog = timeLog + " | upsertFlightDelays: " + (tTo - tFrom);
        } //Get Customer Event History - one stop shop


        if (response.OneStopShop && response.OneStopShop.CustomerEventHistory && response.OneStopShop.CustomerEventHistory.length > 0) {
          tFrom = performance.now();
          CustomerEventHistoryFactory.refreshPassengerHistory(response.OneStopShop.CustomerEventHistory);
          tTo = performance.now();
          timeLog = timeLog + " | mergeCampaigns: " + (tTo - tFrom);
        } //Get flight service events


        if (response.FlightServiceEvents && response.FlightServiceEvents.length > 0) {
          tFrom = performance.now();
          responseStatuses.flightServiceEvents = true;
          FlightServiceEventsFactory.upsertEvents(response.FlightServiceEvents);
          tTo = performance.now();
          timeLog = timeLog + " | upsertFlightServiceEvents " + (tTo - tFrom);
        } //Get Flight Meal Criteria


        if (response.FlightMealCriteria && response.FlightMealCriteria.length > 0) {
          tFrom = performance.now();
          responseStatuses.flightMealCriteria = true;
          FlightMealCriteriaFactory.upsertMealCriteria(response.FlightMealCriteria);
          tTo = performance.now();
          timeLog = timeLog + " | upsertFlightMealCriteria " + (tTo - tFrom);
        } // get Misconnection Flights


        if (response.MisconnectionFlights && response.MisconnectionFlights.length > 0) {
          tFrom = performance.now();
          responseStatuses.misconnectionFlights = true;
          MisconnectionFlightsFactory.upsertMisconnectionFlights(response.MisconnectionFlights);
          tTo = performance.now();
          timeLog = timeLog + " | upsertMisconnectionFlights " + (tTo - tFrom);
        }
      } //if there are significant changes in crew route user should sync


      tFrom = performance.now();
      var needsSynchCheck = needsSynch(currentFlights, response.Flights, currentGroundDuties, response.GroundDuties);
      tTo = performance.now();
      timeLog = timeLog + " | needsSynchCheck: " + (tTo - tFrom);

      if (needsSynchCheck) {
        $scope.sync = true;
      } else {
        //Manage details info and Update local storage
        if (response.Flights.length) {
          //Manage crew route statuses
          tFrom = performance.now();
          InfoAPIService.updateCrewRouteStatusSetter($scope.crewRouteGeneral.statuses, responseStatuses);
          tTo = performance.now();
          timeLog = timeLog + " | updateCrewRouteStatusSetter: " + (tTo - tFrom);
          tFrom = performance.now();
          setupFlightInfo(response.Flights);
          tTo = performance.now();
          timeLog = timeLog + " | setupFlightInfo: " + (tTo - tFrom);
          tFrom = performance.now();
          updateFlights(response.Flights);
          tTo = performance.now();
          timeLog = timeLog + " | updateFlights: " + (tTo - tFrom); //Get Flight orders and update the LS - [shop in the cloud]

          if (isShopInTheCloudEnable && response.RouteOrders && response.RouteOrders.Success && response.RouteOrders.FlightOrders && response.RouteOrders.FlightIds.length > 0) {
            tFrom = performance.now();
            FlightOrdersFactory.upsertFlightOrders(response.RouteOrders.FlightOrders, responseFlightIds);
            tTo = performance.now();
            timeLog = timeLog + " | upsertFlightOrders: " + (tTo - tFrom);
          } //Save training


          tFrom = performance.now();
          response.Flights.forEach(function (flight) {
            var trainingCourses = flight.TrainingCourses;

            if (trainingCourses && trainingCourses.length && flight.FlightInfo) {
              trainingCourses.forEach(function (trainingCourse) {
                CourseFactory.upsertCourse(trainingCourse, function (course) {
                  FlightSessionFactory.applyTraineeInfoToSession(course, course.Id, new moment(flight.FlightInfo.FlightDate).format("YYYY-MM-DD"), dutyNo, dutyDay, function (session) {});
                });
              });
            }
          });
          tTo = performance.now();
          timeLog = timeLog + " | SaveTraining: " + (tTo - tFrom);
        }

        if (response.GroundDuties.length) {
          tFrom = performance.now();
          setupGroundInfo(response.GroundDuties);
          tTo = performance.now();
          timeLog = timeLog + " | setupGroundInfo: " + (tTo - tFrom);
          tFrom = performance.now();
          updateGroundDuties(response.GroundDuties);
          tTo = performance.now();
          timeLog = timeLog + " | updateGroundDuties: " + (tTo - tFrom);
        }

        $scope.refreshResultsVisible = true;
        tFrom = performance.now();
        CrewRouteFactory.updateRouteLastRefreshDate(dutyNo, dutyDay);
        tTo = performance.now();
        timeLog = timeLog + " | updateRouteLastRefreshDate: " + (tTo - tFrom);
        tTo = performance.now();
        timeLog = timeLog + " | Start-End: " + (tTo - t0);
        TimeLogFactory.timeLogToStorage(timeLog, response.Timelog);
      }
    })["catch"](function () {
      $scope.error = true;
      $scope.isRefreshing = false;
    });
    /**
     * Checks if crew route has significantly changed and needs sync
     * @memberof CrewRouteRefreshModalCtrl
     * @param {array} currentFlights   Array of current flights
     * @param {array} newFlights       Array of newly fetched flights
     * @param {array} currentGroundDuties  Array of current ground duties
     * @param {array} newGroundDuties      Array of newly fetched ground duties
     */

    function needsSynch(currentFlights, newFlights, currentGroundDuties, newGroundDuties) {
      var sync = false; //1.Crew Route may not exist any more

      if (!newFlights.length && !newGroundDuties.length) {
        sync = true;
      } //2.Duties may have been added/removed 
      else if (newFlights.length != currentFlights.length || newGroundDuties.length != currentGroundDuties.length) {
          sync = true; //different size arrays
        } else {
          //same size arrays
          if (currentFlights.length && newFlights.length) {
            //compare current with new flights
            currentFlights = $filter('orderBy')(currentFlights, 'FlightId');
            newFlights = $filter('orderBy')(newFlights, 'FlightInfo.FlightId');

            for (var i = 0; i < currentFlights.length; i++) {
              if (newFlights[i].FlightInfo && currentFlights[i].FlightId != newFlights[i].FlightInfo.FlightId) {
                sync = true;
                break;
              }
            }
          }

          if (currentGroundDuties.length && newGroundDuties.length) {
            //compare current with new ground duties
            currentGroundDuties = $filter('orderBy')(currentGroundDuties, 'Id');
            newGroundDuties = $filter('orderBy')(newGroundDuties, 'Id');

            for (var i = 0; i < currentGroundDuties.length; i++) {
              if (currentGroundDuties[i].Id != newGroundDuties[i].Id) {
                sync = true;
                break;
              }
            }
          }
        }

      return sync;
    }
    /**
     * Updates Flight in Local Storage
     * @memberof CrewRouteRefreshModalCtrl
     * @param {array} newFlights 
     */


    function updateFlights(newFlights) {
      for (var i = 0; i < newFlights.length; i++) {
        InfoAPIService.updateFlightLocalStorage(newFlights[i]);
        InfoAPIService.updatePhiloxeniaQuestions(newFlights[i]);
        LuggageComplianceFactory.updateLuggageComplianceStorage(newFlights[i].LuggageCompliance, newFlights[i].FlightId);
        InfoAPIService.updateCrewCheckIn(newFlights[i]); //Update previous Duties & phone calls
        //1. First remove all additional info (phone numbers & previous duties) for this flight

        CrewCallFactory.cleanFlightCrewNumbers(newFlights[i].FlightInfo.FlightId);
        PreviousDutyFactory.cleanFlightPreviousDuties(newFlights[i].FlightInfo.FlightId); //2. Then save any fetched info

        if (newFlights[i].FlightInfo) {
          var crew = newFlights[i].FlightInfo.crew;
          CrewCallFactory.saveFlightPhoneNumbers(newFlights[i].FlightInfo.FlightId, crew, newFlights[i].FlightInfo.ScheduledArrival, newFlights[i].FlightInfo.ScheduledDeparture);
          PreviousDutyFactory.saveFlightPreviousDuties(newFlights[i].FlightInfo.FlightId, crew);
        }
      }
    }
    /**
     * Updates Flight's Data Status
     * @memberof CrewRouteRefreshModalCtrl
     * @param {array} newFlights 
     */


    function setupFlightInfo(newFlights) {
      newFlights = $filter('orderBy')(newFlights, 'Start', false);
      currentFlights = $filter('orderBy')(currentFlights, 'Start', false);

      for (var i = 0; i < newFlights.length; i++) {
        InfoAPIService.updateFlightStatusSetter(newFlights[i], currentFlights[i].DataStatus);
      }
    }
    /**
     * Updates Ground Duty's Data Status
     * @memberof CrewRouteRefreshModalCtrl
     * @param {array} newGroundDuties 
     */


    function setupGroundInfo(newGroundDuties) {
      newGroundDuties = $filter('orderBy')(newGroundDuties, 'Start', false);
      currentGroundDuties = $filter('orderBy')(currentGroundDuties, 'Start', false);

      for (var i = 0; i < newGroundDuties.length; i++) {
        InfoAPIService.updateGroundStatusSetter(newGroundDuties[i], currentGroundDuties[i].DataStatus);
      }
    }
    /**
     * Updates Ground Duty in Local Storage
     * @memberof CrewRouteRefreshModalCtrl
     * @param {array} newFlights 
     */


    function updateGroundDuties(newGroundDuties) {
      for (var i = 0; i < newGroundDuties.length; i++) {
        InfoAPIService.updateGroundDutyLocalStorage(newGroundDuties[i]);
      }
    }
    /**
     * Shows Details 
     * @memberof CrewRouteRefreshModalCtrl
     * @param {object} duty 
     */


    function collapse(duty) {
      if (!$scope.isRefreshing && $scope.refreshResultsVisible) duty.isCollapsed = !duty.isCollapsed;
    }
    /**
     * Closes the modal
     * @memberof CrewRouteRefreshModalCtrl
     */


    function close() {
      $uibModalInstance.close({
        sync: $scope.sync,
        refresh: $scope.refreshResultsVisible
      });
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('CustomerModalCtrl', CustomerModalCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name CustomerCtrl
  * @description 
  *  Report a bug of the application
  * @ngInject
  */

  function CustomerModalCtrl($scope, $uibModalInstance, $timeout, InfoAPIService, customerIncident) {
    $scope.successful = false;
    $scope.error = false;
    var q = InfoAPIService.sendCustomerIncident(customerIncident.flightDescription, customerIncident.question, customerIncident.description, customerIncident.image);
    q.then(function (responseData) {
      if (responseData.data.data) {
        $scope.successful = true;
      } else {
        $scope.error = true;
      }

      $timeout(function () {
        $uibModalInstance.close();
      }, 3000);
    }, function () {
      $scope.error = true;
      $timeout(function () {
        $uibModalInstance.close();
      }, 3000);
    });
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('ASSFReportCtrl', ASSFReportCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name ASSFReportCtrl
  * @description 
  *   The aircraft security report page
  * @ngInject
  */

  function ASSFReportCtrl($scope, $routeParams, $location, SettingsMain, FlightFactory, $timeout, ASSFReportFactory, ASSFSyncInfoFactory, UserFactory, AircaftPositionsFactory, $uibModal) {
    var flightId = $routeParams.flightId;
    SettingsMain.setEditingPage("assfReport");
    $scope.user = UserFactory.getUser();
    $scope.sendClicked = sendClicked;
    $scope.saveClicked = saveClicked;
    $scope.saveDraftClicked = saveDraftClicked;
    $scope.discard = discard;
    $scope.IsCompleted = IsCompleted;
    $scope.assfReport = null;
    $scope.flight = null;
    $scope.dateOptions = {
      formatYear: 'yyyy',
      startingDay: 1
    };
    $scope.infosaveaction = false;
    $scope.infosaveactiontype = null;
    $scope.infoSaveOperation = infoSaveOperation;
    $scope.clearSignature = clearSignature;
    $scope.checkForCommanderSignature = checkForCommanderSignature;
    $scope.showCommanderSignature = false;
    $scope.openSignatureModal = openSignatureModal;
    $scope.panels = {
      allInOne: {
        open: true
      }
    };

    if (flightId == "temp") {
      $scope.assfReport = ASSFReportFactory.getTempAssessment();
      $scope.flight = FlightFactory.getFlightFromStorage(assfReport.flightId);
      SettingsMain.setEditingPage(null);
    } else {
      $scope.flight = FlightFactory.getFlightFromStorage(flightId);
      $scope.assfReport = ASSFReportFactory.getAssfReportFromStorage($scope.flight.FlightId);

      if (!$scope.assfReport) {
        $scope.assfReport = ASSFReportFactory.getNewAssfReport();
      }
    }

    $scope.assfReport.commanderSignature = $scope.assfReport.commanderSignature || null;
    $scope.assfReport.cabinCrewSignature = $scope.assfReport.cabinCrewSignature || null;
    $scope.assfReport.flightCrewSignature = $scope.assfReport.flightCrewSignature || null;
    $scope.assfReport.groundServiceProviderSignature = $scope.assfReport.groundServiceProviderSignature || null;
    $scope.openSignatureModal = openSignatureModal;
    $scope.signatureButtonClass = signatureButtonClass;

    function signatureButtonClass(role) {
      // role: "Commander", "CabinCrew", "FlightCrew", "GroundServiceProvider"
      var field = role.charAt(0).toLowerCase() + role.slice(1) + 'Signature'; // π.χ. "commanderSignature"

      return $scope.assfReport[field] ? 'btn btn-success' : 'btn btn-primary';
    }

    autofillFields($scope.assfReport);
    $scope.cabinCrew = $scope.flight.crew.filter(function (member) {
      return member.position === 'SA' || member.position === 'FA';
    });
    $scope.flightCrew = $scope.flight.crew.filter(function (member) {
      return member.position === 'CP' || member.position === 'FO';
    });
    $scope.cpCrew = $scope.flight.crew.filter(function (member) {
      return member.position === 'CP';
    });
    var selectedCabinCrew = $scope.cabinCrew.find(function (c) {
      return c.name.trim() === $scope.user.name.trim();
    });

    if (!$scope.assfReport.cabinCrewName && selectedCabinCrew) {
      $scope.assfReport.cabinCrewName = selectedCabinCrew.name.trim();
    }

    var selectedFlightCrew = $scope.flightCrew.find(function (c) {
      return c.name.trim() === $scope.user.name.trim();
    });

    if (!$scope.assfReport.flightCrewName && selectedFlightCrew) {
      $scope.assfReport.flightCrewName = selectedFlightCrew.name.trim();
    } //Get the active version of the assf report and set it to the assf report. 


    var assfInfo = ASSFSyncInfoFactory.getASSFInfo();

    if (assfInfo && assfInfo.ActiveVersion && assfInfo.ActiveVersion.Notes) {
      $scope.reportNotes = assfInfo.ActiveVersion.Notes;
    } // Update the area categories if they are not set


    if (!$scope.assfReport.areaCategories || $scope.assfReport.areaCategories.length === 0) {
      if (assfInfo && assfInfo.ActiveVersion && assfInfo.ActiveVersion.AreaCategories) {
        $scope.assfReport.areaCategories = angular.copy(assfInfo.ActiveVersion.AreaCategories);
      }
    }

    $scope.getNowTimeUTC = getNowTimeUTC;
    $scope.searchCompletedTimeChanged = searchCompletedTimeChanged; //var hasSearchCompletedTime = false;
    // Initialize the time control with UTC values

    $scope.searchCompletedTime = {
      time: $scope.assfReport.searchCompleted ? moment($scope.assfReport.searchCompleted).utc().toDate() : null,
      timeChanged: function timeChanged(newVal) {
        if (!newVal) return; // Convert local input time to UTC 

        var localTime = moment(newVal);
        var utcTime = moment.utc().hours(localTime.hours()).minutes(localTime.minutes());
        $scope.assfReport.searchCompleted = utcTime.toDate(); // Force display of UTC time

        $scope.searchCompletedTime.time = utcTime.toDate();
      }
    };

    function openSignatureModal(_signatureType) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgAssfSignature.html',
        controller: 'AssfSignatureCtrl',
        controllerAs: 'vm',
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          reportData: function reportData() {
            return $scope.assfReport;
          },
          signatureType: function signatureType() {
            return _signatureType;
          }
        }
      });
      modalInstance.result.then(function () {
        saveDraftClicked(true);
      });
    }

    function saveDraftClicked(notShowFeedback) {
      $scope.assfReport.status = 'Draft';
      ASSFReportFactory.setAssfReportToStorage($scope.assfReport);
      ASSFReportFactory.updateFlightAssfStatus($scope.assfReport);

      if (!notShowFeedback) {
        infoSaveOperation('Draft');
      }

      SettingsMain.setEditingPage(null);
      ASSFReportFactory.clearTempAssfReport();
    }

    function clearSignature(type) {
      if (type === 'FlightCrew') {
        $scope.assfReport.flightCrewSignature = null;
      } else if (type === 'Commander') {
        $scope.assfReport.commanderSignature = null;
      } else if (type === 'CabinCrew') {
        $scope.assfReport.cabinCrewSignature = null;
      } else if (type === 'GroundServiceProvider') {
        $scope.assfReport.groundServiceProviderSignature = null;
      }
    }

    $scope.searchCompletedDate = {
      value: $scope.assfReport.searchCompleted ? moment($scope.assfReport.searchCompleted).utc().toDate() : null,
      set: function set(newVal) {
        if (!newVal) {
          $scope.assfReport.searchCompleted = null;
          $scope.searchCompletedTime.time = null;
          return;
        } // Convert to UTC and preserve existing time if any


        var newDate = moment(newVal).utc();

        if ($scope.searchCompletedTime.time) {
          var currentTime = moment($scope.searchCompletedTime.time).utc();
          newDate.hours(currentTime.hours());
          newDate.minutes(currentTime.minutes());
        }

        var utcDate = newDate.toDate();
        $scope.assfReport.searchCompleted = utcDate;
        $scope.searchCompletedTime.time = utcDate;
      }
    }; // Update the applicability rules if they are not set

    function searchCompletedTimeChanged() {
      if (!$scope.searchCompletedTime.time) {
        return;
      } // Keep everything in UTC


      var newTime = moment.utc($scope.searchCompletedTime.time);
      var currentDate = $scope.assfReport.searchCompleted ? moment(newTime) : moment.utc();
      currentDate.hours(newTime.hours());
      currentDate.minutes(newTime.minutes());
      $scope.assfReport.searchCompleted = currentDate.toDate();
      $scope.searchCompletedDate.value = currentDate.toDate();
    }

    function getNowTimeUTC() {
      // Get current UTC time
      var utcNow = moment.utc(); // Set UTC time to all controls

      $scope.searchCompletedTime.time = utcNow.toDate().toUTC();
      $scope.searchCompletedDate.value = utcNow.toDate().toUTC();
      $scope.assfReport.searchCompleted = utcNow.toDate().toUTC();
      var notShowFeedback = true;
      saveDraftClicked(notShowFeedback);
    }

    $scope.allAreasSelected = function () {
      if (!$scope.assfReport || !$scope.assfReport.areaCategories) return false;
      return $scope.assfReport.areaCategories.every(function (x) {
        var areas = Array.isArray(x.SearchAreas) ? x.SearchAreas : [];
        return areas.length > 0 && areas.every(function (a) {
          return !!a.Checked;
        });
      });
    };
    /**
     * Evaluate if this ASSF Report is valid and ready to send
     * @memberof ASSFReportCtrl 
     * @param {object} assfReport The ASSF Report
     * @returns {boolean} isCompleted
     */


    function IsCompleted() {
      if (!$scope.assfReport) {
        return false;
      } // Not applicable reports are considered complete


      if ($scope.assfReport.notApplicable) {
        return true;
      }

      var hasRequiredSignatures = Boolean( // If Commander signature is required (i.e. showCommanderSignature is true), it must have name+sig
      (!$scope.showCommanderSignature || $scope.assfReport.commanderSignature && $scope.assfReport.commanderName) && // Cabin‐Crew must always have name+signature
      $scope.assfReport.cabinCrewSignature && $scope.assfReport.cabinCrewName // Ground‐Service must always have name+signature
      && $scope.assfReport.groundServiceProviderSignature && $scope.assfReport.groundServiceProviderName // Flight Crew: either no name at all, or (if name is set) then signature must also be set
      && (!$scope.assfReport.flightCrewName || $scope.assfReport.flightCrewSignature)); // Search completion must be marked

      var searchCompleted = Boolean($scope.assfReport.searchCompleted instanceof Date && !isNaN($scope.assfReport.searchCompleted));

      if ($scope.assfReport && typeof $scope.assfReport.searchCompleted === 'string') {
        $scope.assfReport.searchCompleted = new Date($scope.assfReport.searchCompleted);
      }

      var allAreasSelected = $scope.allAreasSelected();
      return hasRequiredSignatures && searchCompleted && allAreasSelected;
    }

    function clearSignature(type) {
      if (type === 'FlightCrew') {
        $scope.assfReport.flightCrewSignature = null;
      } else if (type === 'Commander') {
        $scope.assfReport.commanderSignature = null;
      } else if (type === 'CabinCrew') {
        $scope.assfReport.cabinCrewSignature = null;
      } else if (type === 'GroundServiceProvider') {
        $scope.assfReport.groundServiceProviderSignature = null;
      }
    }
    /**
     * Save the assf report As Draft
     * @memberof ASSFReportCtrl 
     * @param {object} assf report
     */


    function sendClicked() {
      saveClicked($scope.assfReport); //Change the double utc conversion to a single one (UI issue with UTC dates)

      $scope.assfReport.searchCompleted = moment.utc($scope.assfReport.searchCompleted).local().toDate(); //todo: send the report to api, get the response message and show it to the user

      ASSFReportFactory.sendReport($scope.assfReport).then(function (res) {
        return handleSubmitResponse(res);
      });
    }

    function handleSubmitResponse(res) {
      $scope.assfReport.status = "Stored";
      saveReport($scope.assfReport);
      infoSaveOperation($scope.assfReport.status);
      $timeout(function () {
        $location.path('/flightinfo/' + $scope.flight.FlightId);
      }, 5000);
    }
    /**
     * Save the assf report As Completed
     * @memberof ASSFReportCtrl 
     * @param {object} assfForm The assf report
     */


    function saveClicked() {
      $scope.assfReport.status = 'Completed';
      saveReport($scope.assfReport);
      infoSaveOperation($scope.assfReport.status);
      SettingsMain.setEditingPage(null);
      ASSFReportFactory.clearTempAssfReport();
    }
    /**
     * Discard all the changes on the assf form that are not saved
     * @memberof ASSFReportCtrl 
     */


    function discard() {
      SettingsMain.setEditingPage(null);
      $scope.assfReport = ASSFReportFactory.getAssfReportFromStorage($scope.flight.FlightId);
      infoSaveOperation('discard');
    }
    /**
     * Save the ASSF Report 
     * @memberof ASSFReportCtrl 
     * @param {object} assfForm The Cabin Crew Feedback
     */


    function saveReport(assfForm) {
      autofillFields(assfForm);
      ASSFReportFactory.setAssfReportToStorage(assfForm);
      ASSFReportFactory.updateFlightAssfStatus(assfForm);
    }

    function autofillFields(assfForm) {
      $scope.flight.aircraftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId($scope.flight.FlightId);

      if (assfForm.authorId == null) {
        assfForm.authorId = $scope.user.id;
      }

      assfForm.submissionTimestamp = moment.utc().toDate();
      ;
      assfForm.flightId = $scope.flight.FlightId;
      assfForm.flightNumber = $scope.flight.FlightNo;
      assfForm.flightDate = $scope.flight.FlightDate;
      assfForm.flightOrigin = $scope.flight.Departure;
      assfForm.commanderName = $scope.flight.crew.find(function (member) {
        return member.position === 'CP';
      }).name;

      if ($scope.flight.aircraftPositions) {
        assfForm.previousFlightOrigin = $scope.flight.aircraftPositions.PreviousStation;
      }

      if (assfInfo && assfInfo.ActiveVersion) {
        assfForm.formVersionId = assfInfo.ActiveVersion.Id;
      } else {
        assfForm.formVersionId = null;
      }

      if ($scope.flight.assfReport && $scope.flight.assfReport.isRequired) {
        assfForm.isRequired = $scope.flight.assfReport.isRequired;

        if ($scope.flight.assfReport.isRequired == true && assfForm.notApplicable == true) {
          assfForm.isRequired = false;
          $scope.flight.assfReport.isRequired = false; //Update flight status in LS

          ASSFReportFactory.updateFlightAssfStatus(assfForm);
        }
      } //assfForm.isRequired = $scope.flight.assfReport.isRequired !== undefined && $scope.flight.assfReport.isRequired !== null ? $scope.flight.assfReport.isRequired : false;

    }
    /**
     * Display a  successful save message according to the save status 
     * @memberof ASSFReportCtrl
     * @param {string} state  the state of the selected assf report
     */


    function infoSaveOperation(state) {
      if (state == 'Completed') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      } else if (state == 'Draft') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      } else if (state == 'discard') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      } else if (state == 'Stored') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      } //hide the message after 5 seconds


      $timeout(function () {
        $scope.infosaveaction = false;
      }, 5000);
    }

    function checkForCommanderSignature() {
      var isInList = $scope.cpCrew.find(function (crewMember) {
        return crewMember.name === $scope.assfReport.flightCrewName;
      });

      if (!isInList) {
        $scope.showCommanderSignature = true;
      } else {
        $scope.showCommanderSignature = false;
      }
    }

    ; // Check if all areas in a category are selected

    $scope.isAllSelected = function (category) {
      if (!category.SearchAreas || category.SearchAreas.length === 0) {
        return false;
      }

      return category.SearchAreas.every(function (area) {
        return area.Checked;
      });
    }; // Check if some (but not all) areas in a category are selected


    $scope.isPartiallySelected = function (category) {
      if (!category.SearchAreas || category.SearchAreas.length === 0) {
        return false;
      }

      var checkedCount = category.SearchAreas.filter(function (area) {
        return area.Checked;
      }).length;
      return checkedCount > 0 && checkedCount < category.SearchAreas.length;
    }; // Toggle all areas in a category


    $scope.toggleSelectAll = function (category) {
      var shouldCheck = !$scope.isAllSelected(category);
      category.SearchAreas.forEach(function (area) {
        area.Checked = shouldCheck;
      });
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('ASSFReportFactory', ASSFReportFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name ASSFReportFactory
  * @description 
  *   Add, Update, Delete and Get aircraft security search form reports.
  * @ngInject
  */

  function ASSFReportFactory(localStorageMD5Service, FlightFactory, $http, apiUrl, GenericService) {
    /**
    * Initialize the ASSFReport
    * @memberof ASSFReportFactory
    */
    function ASSFReport() {
      this.flightId = null;
      this.authorId = null;
      this.submissionTimestamp = null;
      this.flightNumber = null;
      this.flightDate = null;
      this.previousFlightOrigin = null;
      this.formVersionId = null;
      this.isRequired = false;
      this.searchCompleted = null;
      this.commanderName = null;
      this.commanderSignature = null;
      this.flightCrewName = null;
      this.flightCrewSignature = null;
      this.cabinCrewName = null;
      this.cabinCrewSignature = null;
      this.groundServiceProviderName = null;
      this.groundServiceProviderSignature = null;
      this.notApplicable = false;
      this.areaCategories = [];
      this.status = 'Pending';
      this.GetId = GetId;
    }

    var objType = 'ASSFReports';
    var objCallback = ASSFReport;
    var service = {
      getAssfReportsFromStorage: getAssfReportsFromStorage,
      getAssfReportFromStorage: getAssfReportFromStorage,
      setAssfReportToStorage: setAssfReportToStorage,
      setAssfReportsToStorage: setAssfReportsToStorage,
      updateFlightsAssfStatus: updateFlightsAssfStatus,
      updateFlightAssfStatus: updateFlightAssfStatus,
      cleanOldData: cleanOldData,
      sendReport: sendReport,
      getNewAssfReport: getNewAssfReport,
      getTempAssfReport: getTempAssfReport,
      saveTempAssfReport: saveTempAssfReport,
      clearTempAssfReport: clearTempAssfReport
    };

    function getAssfReportFromStorage(flightId) {
      return GenericService.get(flightId, objType, objCallback);
    }

    function getAssfReportsFromStorage() {
      var lsItems = GenericService.list(objType, objCallback);
      var items = [];

      for (var i = 0; i < lsItems.length; i++) {
        if (lsItems[i]) {
          items.push(lsItems[i]);
        }
      }

      return items;
    }

    function updateFlightAssfStatus(assfForm) {
      //Update the flight status in the local storage
      var flight = FlightFactory.getFlightFromStorage(assfForm.flightId);

      if (flight) {
        flight.assfReport = {
          id: assfForm.id,
          status: assfForm.status,
          isRequired: assfForm.isRequired !== undefined && assfForm.isRequired !== null ? assfForm.isRequired : false
        };
        FlightFactory.updateFlight(flight);
      }
    }

    function updateFlightsAssfStatus(syncedFlightIds) {
      var flights = FlightFactory.getFlightsFromStorage();
      var oldAssfReports = getAssfReportsFromStorage();

      for (var i = 0; i < flights.length; i++) {
        if (syncedFlightIds && syncedFlightIds.includes(flights[i].flightId)) {
          flights[i].assfReport = {
            id: null,
            status: 'Stored'
          };
        } else {
          var matchingReport = oldAssfReports.find(function (report) {
            return report.flightId === flights[i].flightId;
          });

          if (matchingReport) {
            flights[i].assfReport = {
              id: matchingReport.id,
              status: matchingReport.status,
              isRequired: matchingReport.isRequired !== undefined && matchingReport.isRequired !== null ? matchingReport.isRequired : false
            };
          }
        }
      }

      FlightFactory.setFlightsToStorage(flights);
    }
    /**
     * Save the assf report to storage
     * @memberof CrewAssessmentFactory
     * @param {Object} ASSF Report - Aircraft Security Search Form Report
     */


    function setAssfReportToStorage(assfReport) {
      if (assfReport != null) {
        if (GenericService.get(assfReport.flightId, objType, objCallback)) {
          GenericService.save(assfReport, objType, objCallback);
        } else {
          GenericService.add(assfReport, objType, objCallback);
        }
      }
    }
    /**
     * Send the assf report to the server
     * @memberof CrewAssessmentFactory
     *  @param {Object} ASSF Report - Aircraft Security Search Form Report
     *  @returns {Promise} A promise that resolves to the response from the server
     **/


    function sendReport(assfReport) {
      if (assfReport != null) {
        return $http.post(apiUrl + '/AircraftSecuritySearchForm/SaveSearchReport', assfReport, {
          'Content-Type': 'application/json'
        }).then(function (res) {
          return saveReportSuccessCallBack(res, assfReport);
        })["catch"](function (res) {
          return saveReportFailedCallBack(res);
        });
      }
    }

    function saveReportSuccessCallBack(res, assfReport) {
      if (res.data && res.data.success) {
        // Save the report to local storage
        assfReport.status = 'Stored';
        setAssfReportToStorage(assfReport);
        return res.data;
      } else {
        throw new Error('Failed to save security search form report. Error message:' + res.data.message);
      }
    }

    function saveReportFailedCallBack(res) {
      var errorMessage = res.data && res.data.Message ? res.data.Message : 'Failed to save security search form report';
      throw new Error(errorMessage);
    }
    /**
     * save the assf reports to storage   
     * @memberof CrewAssessmentFactory
     * @param {Array} AssfReports
     */


    function setAssfReportsToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }
    /**
     * Initialize a new AssfReport from the default Constructor
     * @memberof ASSFReportFactory
     * @returns {Object} crewAssesment
     */


    function getNewAssfReport() {
      return GenericService.constructor(objCallback);
    }

    ;
    /**
     * Get the Temporary AssfReport from the local storage
     * @memberof ASSFReportFactory
     * @returns {Object} AssfReport
     */

    function getTempAssfReport() {
      var AssfReportLocalEdit = localStorageMD5Service.get('AssfReportLocalEdit_TEMP');
      return fromObject(AssfReportLocalEdit);
    }

    ;
    /**
     * Save the Temporary AssfReport to  the local storage
     * @memberof ASSFReportFactory
     * @param {Object} AssfReport 
     * @param {number} FlightId  a crewAssesment
     */

    function saveTempAssfReport(report, flightId) {
      if (report) {
        report.flightId = flightId;
        localStorageMD5Service.remove('AssfReportLocalEdit_TEMP');
        localStorageMD5Service.set('AssfReportLocalEdit_TEMP', report);
      }
    }

    ;
    /**
     * Remove the Temporary AssfReport of  the local storage
     * @memberof ASSFReportFactory
     */

    function clearTempAssfReport() {
      localStorageMD5Service.remove('AssfReportLocalEdit_TEMP');
    }

    ; //object functions

    /**
     * Overide default get Id
     * @memberof ASSFReportFactory
     * @returns {number} Id 
     */

    function GetId() {
      return this.flightId;
    }
    /**
     * Extend Object from the default AssfReport Object
     * @memberof ASSFReportFactory
     * @param {Object} obj  a AssfReport
     * @returns {Object} AssfReport
     */


    function fromObject(obj) {
      return GenericService.fromObject(obj, objCallback);
    }
    /**
     * Clean ls from old flight previous duties
     * @param {array} flights Synced flights
     */


    function cleanOldData(responseFlightIds) {
      var reportsInLS = getAssfReportsFromStorage(); //Filter out previous duties of old flights

      reportsInLS = reportsInLS.filter(function (x) {
        return responseFlightIds.includes(x.flightId);
      });
      setAssfReportsToStorage(reportsInLS);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('ASSFSyncInfoFactory', ASSFSyncInfoFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name ASSFSyncInfoFactory
  * @description 
  * Add, Update and Get SaFeedbacks Info
  * @ngInject
  */

  function ASSFSyncInfoFactory(GenericService, defaultCalendarDate) {
    var objType = 'ASSFSyncInfo';
    var objCallback = ASSFSyncInfo;
    /**
     * Initialize the ASSFSyncInfo
     * @memberof ASSFSyncInfoFactory
     */

    function ASSFSyncInfo() {
      this.ActiveVersion = {};
      this.ApplicabilityRules = [];
      this.SyncedFlightIds = [];
    }

    var service = {
      setASSFInfo: setASSFInfo,
      getASSFInfo: getASSFInfo //checkIsRequired: checkIsRequired

    };

    function setASSFInfo(syncInfo) {
      if (syncInfo != null && syncInfo.ActiveVersion && syncInfo.ApplicabilityRules) {
        var assfInfo = {
          ActiveVersion: syncInfo.ActiveVersion,
          ApplicabilityRules: syncInfo.ApplicabilityRules,
          SyncedFlightIds: syncInfo.SyncedFlightIds
        };
        GenericService.saveOne(assfInfo, objType, objCallback);
      }
    }
    /**
     * Get assf Info from local storage
     */


    function getASSFInfo() {
      return GenericService.getOne(objType, objCallback);
    } //Object services

    /**
     * Overide default get Id
     * @memberof ASSFSyncInfoFactory
     * @returns {number} Id 
     */


    function GetId() {
      return this.Id;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('departureInfoPanel', departureInfoPanel);
  /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name departureInfoPanel
   * @restrict EA
   * @description
   *   Departure Info Panel using separate controller.
   * @example
   *   <departure-info-panel></departure-info-panel>
   * @ngInject
   */

  function departureInfoPanel() {
    return {
      restrict: 'EA',
      templateUrl: 'views/directives/departureInfoPanel.tpl.html',
      scope: {},
      controller: 'JeppessenFlightDetailsCtrl'
    };
  }
})();
"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  'use strict';

  a3_cabin_reports.controller('JeppessenFlightDetailsCtrl', JeppessenFlightDetailsCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name JeppessenFlightDetailsCtrl
  * @description 
  *   Get the departure info times.
  * @ngInject
  */

  function JeppessenFlightDetailsCtrl($scope, $interval, LogService, refreshDelaySeconds, defaultCalendarDate, JeppesenFlightDetailsFactory, $routeParams, FlightFactory, $uibModal) {
    $scope.departureInfo = {};
    var flightId = $routeParams.flightId;
    var flight = FlightFactory.getFlightFromStorage(flightId);
    var autoUpdateInterval = null;
    var autoUpdateIntervalTimeOffset = null;
    var autoUpdateCounter = 0;
    $scope.STD = new Date(flight.ScheduledDeparture);
    $scope.isUpdatedTsat = false;
    $scope.isUpdatedTobt = false;
    $scope.isUpdatedCtot = false;
    $scope.isUpdatedETD = false;
    $scope.showReLoginNotice = false;
    $scope.reLoginNoticeMessage = "Your session has expired. Please sign in again to continue receiving departure updates.";
    var raw = JeppesenFlightDetailsFactory.getJeppesenDetailsFromStorage(flightId) || {};
    var ctotRaw = JeppesenFlightDetailsFactory.getCtotHistoryFromStorage(flightId) || [];
    $scope.ctotHistoryRaw = ctotRaw;
    $scope.ctotHistory = ctotRaw.map(function (entry) {
      return {
        value: new Date(entry.NewCTOT),
        previous: new Date(entry.OldCTOT),
        modified: new Date(entry.ModificationDate)
      };
    });
    $scope.departureInfo = raw.jeppesenData && raw.jeppesenData.length ? normalizeRawJeppesenArray(raw.jeppesenData) : {};
    /**
    * Returns the most recent CTOT value:
    * - From CTOT history if available
    * - Otherwise from flight.CTOT
    */

    $scope.getCurrentCTOT = function () {
      if ($scope.ctotHistoryRaw && $scope.ctotHistoryRaw.length) {
        var latest = $scope.ctotHistoryRaw.slice().sort(function (a, b) {
          return new Date(b.ModificationDate) - new Date(a.ModificationDate);
        })[0];
        return new Date(latest.NewCTOT);
      }

      return flight.CTOT ? new Date(flight.CTOT) : null;
    }; // $scope.departureInfo.ETD = $scope.departureInfo.ETD || new Date($scope.STD.getTime() + 10 * 60 * 1000); // Default ETD to STD + 10 minutes
    // Labels to show in UI


    $scope.timeLabels = ['STD', 'TOBT', 'TSAT', 'CTOT'];
    /**
    * Converts raw Jeppesen records into a structured object
    * with arrays per label and proper date formatting.
    */

    function normalizeRawJeppesenArray(rawArray) {
      var result = {
        TOBT: [],
        TSAT: [],
        CTOT: [],
        STD: null,
        ETD: null
      };
      rawArray.forEach(function (entry) {
        if (entry.STD) result.STD = new Date(entry.STD);
        if (entry.ETD) result.ETD = new Date(entry.ETD);
        ['TOBT', 'TSAT', 'CTOT'].forEach(function (key) {
          if (entry[key]) {
            result[key].push({
              value: new Date(entry[key]),
              lastUpdated: new Date(entry.Created || entry.CreatedDate || new Date())
            });
          }
        });
      });
      ['TOBT', 'TSAT', 'CTOT'].forEach(function (key) {
        result[key].sort(function (a, b) {
          return new Date(b.lastUpdated) - new Date(a.lastUpdated);
        });
      });
      return result;
    }
    /**
    * Delay check for TSAT > STD + 10 mins
    */


    $scope.isTsatDelayed = function () {
      if (!$scope.departureInfo.STD || !$scope.departureInfo.TSAT || !$scope.departureInfo.TSAT.length > 0) return false;
      var std = $scope.departureInfo.STD.getTime();
      var tsat = $scope.departureInfo.TSAT[0].value.getTime();
      var delayMinutes = 10 * 60 * 1000;
      return tsat - std >= delayMinutes;
    };
    /**
    * Delay check for TOBT > STD + 5 mins
    */


    $scope.isTobtDelayed = function () {
      if (!$scope.departureInfo.STD || !$scope.departureInfo.TOBT || !$scope.departureInfo.TOBT.length > 0) return false;
      var std = $scope.departureInfo.STD.getTime();
      var tobt = $scope.departureInfo.TOBT[0].value.getTime();
      var delayMinutes = 5 * 60 * 1000;
      return tobt - std >= delayMinutes;
    };
    /**
     * CTOT warning if CTOT > TOBT + 15 mins
     */


    $scope.isCtotWarning = function () {
      if (!$scope.departureInfo.CTOT || !$scope.departureInfo.CTOT.length > 0 || !$scope.departureInfo.TOBT || !$scope.departureInfo.TOBT.length > 0) return false;
      var ctot = $scope.departureInfo.CTOT[0].value.getTime();
      var tobt = $scope.departureInfo.TOBT[0].value.getTime();
      var warningMinutes = 15 * 60 * 1000;
      return ctot - tobt >= warningMinutes;
    };
    /**
    * Opens generic history modal for TOBT, TSAT
    */


    $scope.openHistoryDialog = function (label) {
      var history = angular.copy($scope.departureInfo[label]);
      $uibModal.open({
        templateUrl: 'views/Dialogs/dlgJeppesenHistory.html',
        controller: function controller($scope, $uibModalInstance) {
          $scope.label = label;
          $scope.history = history;

          $scope.cancel = function () {
            $uibModalInstance.dismiss();
          };
        }
      });
    };
    /**
    * Opens CTOT-specific history modal
    */


    $scope.openCtotHistoryDialog = function () {
      $uibModal.open({
        templateUrl: 'views/Dialogs/dlgCTOTHistory.html',
        controller: function controller($scope, $uibModalInstance, historyRaw) {
          $scope.history = historyRaw.slice().sort(function (a, b) {
            return new Date(b.ModificationDate) - new Date(a.ModificationDate);
          }).map(function (entry) {
            return {
              value: new Date(entry.NewCTOT),
              lastUpdated: new Date(entry.ModificationDate)
            };
          });
          ;

          $scope.cancel = function () {
            $uibModalInstance.dismiss();
          };
        },
        resolve: {
          historyRaw: function historyRaw() {
            return $scope.ctotHistoryRaw;
          }
        }
      });
    };

    $scope.$on('$destroy', function () {
      $interval.cancel(autoUpdateInterval);
    });
    autoFetchDepartureDetailsInterval();
    /**
     * Fetches and updates Jeppesen flight details & CTOT history from api
     * and saves them back to local storage if available.
     */

    function autoFetchDepartureDetailsInterval() {
      autoUpdateCounter++; // Keep flight times fresh for interval decisions (ETD/ATD can change in storage).

      flight = FlightFactory.getFlightFromStorage(flightId) || flight;
      var estimatedDepartureTime = flight.ETD || flight.ScheduledDeparture;
      var actualDepartureTime = flight.ATD;
      var intervalTime = timerDelayGenerator(actualDepartureTime, estimatedDepartureTime, autoUpdateCounter);

      if ($scope.departureInfo && window.navigator.onLine && intervalTime > 0) {
        JeppesenFlightDetailsFactory.getDepartureDetails(flightId, flight.FlightNo, flight.DutyDate, flight.Departure).then(function (responseData) {
          $scope.showReLoginNotice = false;

          if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined) {
            var err = new Error();
            err.status = -1;
            var msg = "ResponseData error in autoflightInfoInterval :" + JSON.stringify(responseData);
            LogService.debug(msg, err);
            return;
          }

          var raw = JeppesenFlightDetailsFactory.getJeppesenDetailsFromStorage(flightId) || {};
          var ctotRaw = JeppesenFlightDetailsFactory.getCtotHistoryFromStorage(flightId) || [];
          var oldCtot = $scope.getCurrentCTOT();
          var oldtsat = $scope.departureInfo.TSAT && $scope.departureInfo.TSAT.length > 0 ? $scope.departureInfo.TSAT[0].value : null;
          var oldtobt = $scope.departureInfo.TOBT && $scope.departureInfo.TOBT.length > 0 ? $scope.departureInfo.TOBT[0].value : null;
          var oldETD = $scope.departureInfo.ETD ? $scope.departureInfo.ETD.toISOString() : null; //Update scopes

          $scope.ctotHistoryRaw = ctotRaw;
          $scope.departureInfo = raw.jeppesenData && raw.jeppesenData.length ? normalizeRawJeppesenArray(raw.jeppesenData) : {}; //Update flight times from storage

          $scope.departureInfo.ETD = flight.ETD ? new Date(flight.ETD) : null;
          $scope.departureInfo.STD = flight.ScheduledDeparture ? new Date(flight.ScheduledDeparture) : null;
          $scope.departureInfo.ATD = flight.ATD ? new Date(flight.ATD) : null; //Check last values:

          var newtsat = $scope.departureInfo.TSAT && $scope.departureInfo.TSAT.length > 0 ? $scope.departureInfo.TSAT[0].value : null;
          var newtobt = $scope.departureInfo.TOBT && $scope.departureInfo.TOBT.length > 0 ? $scope.departureInfo.TOBT[0].value : null;
          var newCtot = $scope.getCurrentCTOT();
          $scope.isUpdatedTsat = normalizeTime(oldtsat) !== normalizeTime(newtsat);
          $scope.isUpdatedTobt = normalizeTime(oldtobt) !== normalizeTime(newtobt);
          $scope.isUpdatedCtot = normalizeTime(oldCtot) !== normalizeTime(newCtot);
          $scope.isUpdatedETD = normalizeTime(oldETD) !== normalizeTime($scope.departureInfo.ETD);
        } // , function (err) {
        //      LogService.debug("Error fetching departure details: " + err);
        // })
        , function (err) {
          // status -1 = request cancelled (offline / navigation away) — not an app error
          if (err && err.status === -1) return; // 401 with missing token during session expiry/navigation to login is expected

          if (err && err.status === 401 && err.data === "No Token Found") {
            $scope.showReLoginNotice = true;
            $interval.cancel(autoUpdateInterval);
            return;
          }

          var errorMessage = "Error fetching departure details";

          if (err && _typeof(err) === "object") {
            try {
              errorMessage += ": " + JSON.stringify(err);
            } catch (e) {
              errorMessage += ": [object with circular reference]";
            }
          } else {
            errorMessage += ": " + err;
          }

          LogService.debug(errorMessage, err);
        })["finally"](function () {
          $scope.isFetchingDepartureData = false;
        });

        if (intervalTime != autoUpdateIntervalTimeOffset) {
          autoUpdateIntervalTimeOffset = intervalTime;
          $interval.cancel(autoUpdateInterval);
          autoUpdateInterval = $interval(autoFetchDepartureDetailsInterval, autoUpdateIntervalTimeOffset);
        }
      } else {
        $interval.cancel(autoUpdateInterval);
        $scope.showAutoUpdatePanel = false;
      }
    }

    function normalizeTime(t) {
      return t ? new Date(t).toISOString() : null;
    }

    function timerDelayGenerator(actualDepartureTime, estimatedDepartureTime, autoUpdateCounter) {
      var intervalTime = -1;
      var sec = 1000;
      var minutes = 60 * sec;
      var actualTimestamp = -1;
      var estimatedDepTimestamp = moment.utc(estimatedDepartureTime).valueOf();
      var nowTimeStamp = moment().valueOf();

      if (actualDepartureTime) {
        actualTimestamp = moment.utc(actualDepartureTime).valueOf();

        if (actualTimestamp > 0 && (actualTimestamp < nowTimeStamp || estimatedDepTimestamp - 120 * minutes < nowTimeStamp)) {
          // Flight already departed or too close based on time window.
          intervalTime = -1;
        } else {
          intervalTime = refreshDelaySeconds * sec;
        }
      } else if (estimatedDepTimestamp - 120 * minutes <= nowTimeStamp && estimatedDepTimestamp + 30 * minutes >= nowTimeStamp) {
        intervalTime = refreshDelaySeconds * sec;
      } //Test cases in development


      if (defaultCalendarDate) {
        nowTimeStamp = moment(defaultCalendarDate).valueOf();

        if (autoUpdateCounter < 2) {
          return refreshDelaySeconds * sec;
        }
      }

      return intervalTime;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('JeppesenFlightDetailsFactory', JeppesenFlightDetailsFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name JeppesenFlightDetailsFactory
  * @description 
  *   Departure info panel (STD, TOBT, etc).
  * @ngInject
  */

  function JeppesenFlightDetailsFactory(GenericService, $http, $q, LogService, apiUrl, FlightFactory) {
    var objType = 'JeppesenFlightDetails';
    var objCallback = JeppesenDetails;
    var objectTypeHistory = 'CTOTChangeHistory';
    var objCallbackHistory = CtotHistoryEntry;

    function JeppesenDetails() {
      this.flightId = null;
      this.jeppesenData = {};
      this.showDepartureInfoModal = false;
      this.GetId = GetId;
    }

    function CtotHistoryEntry() {
      this.flightId = null;
      this.ctotHistory = [];
      this.GetId = GetId;
    }

    var service = {
      getJeppesenDetailsFromStorage: getJeppesenDetailsFromStorage,
      setJeppesenFlightDetailsToStorage: setJeppesenFlightDetailsToStorage,
      getAllJeppesenDetailsFromStorage: getAllJeppesenDetailsFromStorage,
      setAllToStorage: setAllToStorage,
      getCtotHistoryFromStorage: getCtotHistoryFromStorage,
      setCtotHistoryToStorage: setCtotHistoryToStorage,
      getAllCtotHistoriesFromStorage: getAllCtotHistoriesFromStorage,
      // Common
      setToStorage: setToStorage,
      cleanOldData: cleanOldData,
      // Departure info
      getDepartureDetails: getDepartureDetails
    };
    /**
    * Overide default get Id
    * @memberof JeppesenFlightDetailsFactory
    * @returns {number} Id 
    */

    function GetId() {
      return this.flightId;
    }
    /**
    * Retrieves Jeppesen details for a specific flight from local storage
    */


    function getJeppesenDetailsFromStorage(flightId) {
      return GenericService.get(flightId, objType, objCallback);
    }
    /**
     * Saves new Jeppesen data to local storage for a flight
     */


    function setJeppesenFlightDetailsToStorage(flightId, details) {
      if (!flightId || !details) return;
      var item = getJeppesenDetailsFromStorage(flightId) || new JeppesenDetails();
      item.flightId = flightId;
      item.jeppesenData = details;
      setToStorage(item, objType, objCallback);
    }
    /**
     * Retrieves all Jeppesen details from local storage    
     * @returns {Array} Array of JeppesenDetails objects
     */


    function getAllJeppesenDetailsFromStorage() {
      var all = GenericService.list(objType, objCallback);
      var items = [];

      for (var i = 0; i < all.length; i++) {
        if (all[i]) {
          items.push(all[i]);
        }
      }

      return items;
    }
    /**   
     * Retrieves all CTOT history entries from local storage
     * @returns {Array} Array of CtotHistoryEntry objects
     */


    function setAllToStorage(list) {
      GenericService.saveAll(list, objType);
    }
    /**         
     * Retrieves all CTOT history entries from local storage
     * @returns {Array} Array of CtotHistoryEntry objects
     */


    function getCtotHistoryFromStorage(flightId) {
      var record = GenericService.get(flightId, objectTypeHistory, objCallbackHistory);
      return record && record.ctotHistory ? record.ctotHistory : [];
    }
    /**         
     * Retrieves all CTOT history entries from local storage
     * @returns {Array} Array of CtotHistoryEntry objects                       
     */


    function setCtotHistoryToStorage(flightId, historyArray) {
      if (!flightId || !Array.isArray(historyArray)) return;
      var item = GenericService.get(flightId, objectTypeHistory, objCallbackHistory) || new CtotHistoryEntry();
      item.flightId = flightId;
      item.ctotHistory = historyArray;
      setToStorage(item, objectTypeHistory, objCallbackHistory);
    }
    /**
     * Retrieves all CTOT history entries from local storage
     * @returns {Array} Array of CtotHistoryEntry objects
     */


    function getAllCtotHistoriesFromStorage() {
      var all = GenericService.list(objectTypeHistory, objCallbackHistory);
      var items = [];

      for (var i = 0; i < all.length; i++) {
        if (all[i]) {
          items.push(all[i]);
        }
      }

      return items;
    }
    /**
     * Saves an object to local storage
     * Adds or updates based on existing entry
     */


    function setToStorage(obj, type, callback) {
      if (!obj) return;

      if (GenericService.get(obj.flightId, type, callback)) {
        GenericService.save(obj, type, callback);
      } else {
        GenericService.add(obj, type, callback);
      }
    }
    /**
     * Removes all entries from storage except for valid flightIds (cleanup)
     */


    function cleanOldData(validFlightIds) {
      if (!Array.isArray(validFlightIds)) return;
      var allDetails = getAllJeppesenDetailsFromStorage();
      var filtered = allDetails.filter(function (x) {
        return validFlightIds.includes(x.flightId);
      });
      setAllToStorage(filtered);
    }
    /**
     * Fetches departure details for a flight from the API and updates local storage  
     * @returns {Promise} A promise that resolves with the response data
     * */


    function getDepartureDetails(flightId, flightNo, flightDate, departure) {
      var call = $q.defer();
      var flightDateStr = flightDate.toString('yyyy-MM-dd');
      $http.get(apiUrl + '/info/DepartureDetails?flightId=' + flightId + '&flightNo=' + flightNo + '&flightDate=' + flightDateStr + '&departure=' + departure, {
        'Content-Type': 'application/json'
      }).then(function (responseData) {
        if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined) {
          var err = new Error();
          err.status = -1;
          var msg = "ResponseData error on get departure details :" + JSON.stringify(responseData);
          LogService.debug(msg, err);
          call.reject(err);
          return;
        }

        var jeppesenDetails = responseData.data.data.jeppesenFlightDetails;

        if (jeppesenDetails) {
          setJeppesenFlightDetailsToStorage(flightId, jeppesenDetails);
        }

        var ctotHistory = responseData.data.data.ctotHistory;

        if (Array.isArray(ctotHistory) && ctotHistory.length > 0) {
          setCtotHistoryToStorage(flightId, ctotHistory);
        }

        var flightDetailsSync = responseData.data.data.flightTimeDeparture; // update flight departure details

        if (flightDetailsSync) {
          var flightForLS = FlightFactory.getFlightFromStorage(flightId);
          var updateTheFlight = false;

          if (flightForLS) {
            if (flightForLS.ScheduledDeparture != flightDetailsSync.STD) {
              flightForLS.ScheduledDeparture = flightDetailsSync.STD;
              updateTheFlight = true;
            }

            if (flightForLS.ETD != flightDetailsSync.ETD) {
              flightForLS.ETD = flightDetailsSync.ETD;
              updateTheFlight = true;
            }

            if (flightForLS.ATD != flightDetailsSync.ATD) {
              flightForLS.ATD = flightDetailsSync.ATD;
              updateTheFlight = true;
            }
          }

          if (updateTheFlight) {
            FlightFactory.updateFlight(flightForLS);
          }
        }

        call.resolve(responseData);
      }, function (err) {
        call.reject(err);
      });
      return call.promise;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('aircraftDifferences', aircraftDifferences);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name aircraftDifferences
  * @restrict E
  * @description
  *   Implementation of aircraft differences
  *
  *   Display the differences of Aircrafts
  * @attr {String} registration The registration of the aircraft.
  * @example
  *   Usage:
  *   <aircraft-differences registration="sxreg"></aircraft-differences>
  * @ngInject
  */

  function aircraftDifferences(AircraftDifferencesFactory) {
    function link(scope, element, attributes) {
      var AircraftDifferencesObj = AircraftDifferencesFactory.getAircraftDifferenceFromStorageByRegistration(attributes.registration);
      scope.AircraftDifferences = AircraftDifferencesObj != null && AircraftDifferencesObj.AircraftDifferences != null ? AircraftDifferencesObj.AircraftDifferences : [];
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/directives/aircraftDifferences.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('autorefresh', autorefresh);

  function autorefresh($interval, $timeout, PushNotifier, InfoAPIService, FlightFactory, PaxInfoFactory, AircaftPositionsFactory, CrewCallFactory, PreviousDutyFactory, CrewRouteFactory) {
    function link($scope, element, attrs) {
      //var flight = $scope.flight;
      //$scope.flight from parent scope
      //Auto refresh functionality start
      var browserNotificationsEnabled = false;
      var autoUpdateInterval = null;
      var autoUpdateIntervalTimeOffset = null;
      $scope.showAlternativeNotifications = false;
      $scope.showAutoUpdatePanel = false; //Check if push notification are enabled

      PushNotifier.CheckForPermissionsAndSupport().then(function (res) {
        browserNotificationsEnabled = res;
      });
      var ScheduledDepartureTimeStamp = 0;

      if ($scope.flight) {
        ScheduledDepartureTimeStamp = moment.utc($scope.flight.ScheduledDeparture).valueOf();
      }

      var now = moment().valueOf();
      $scope.showAutoUpdatePanel = ScheduledDepartureTimeStamp - 70 * 60000 <= now && ScheduledDepartureTimeStamp + 30 * 60000 >= now && $scope.flight.DepartureEU;
      $scope.radioModel = false;
      $scope.$watch('radioModel', function (value) {
        if (value == true) autoflightInfoInterval();

        if (value == false) {
          $interval.cancel(autoUpdateInterval);
          autoUpdateInterval = null;
        }
      });

      function autoflightInfoInterval() {
        var intervalTime = timerDelayGenerator($scope.flight.ScheduledDeparture);
        var currentInfo = null;
        PushNotifier.formatInfoToCompare($scope.flight.FlightId).then(function (data) {
          currentInfo = data;

          if (intervalTime > 0) {
            InfoAPIService.getPax($scope.flight.FlightId).then(function (responseData) {
              $scope.flight = FlightFactory.getFlightFromTotalFlights($scope.flight.FlightId); //UPDATE CREW INFO
              //1. First remove all additional info (phone numbers & previous duties) for this flight

              CrewCallFactory.cleanFlightCrewNumbers($scope.flight.FlightId);
              PreviousDutyFactory.cleanFlightPreviousDuties($scope.flight.FlightId); //2. Then save any fetched info

              if (responseData.data.data.FlightInfo) {
                var crew = responseData.data.data.FlightInfo.crew;
                CrewCallFactory.saveFlightPhoneNumbers($scope.flight.FlightId, crew, $scope.flight.ScheduledArrival, $scope.flight.ScheduledDeparture);
                PreviousDutyFactory.saveFlightPreviousDuties($scope.flight.FlightId, crew);
              }

              PaxInfoFactory.getPaxInfoFromStorage($scope.flight.FlightId, function (paxInfo) {
                $scope.paxInfo = paxInfo;

                if (paxInfo) {
                  $scope.cStat = paxInfo.PaxTotalC / paxInfo.ConfigurationC * 100;
                  $scope.yStat = paxInfo.PaxTotalY / paxInfo.ConfigurationY * 100;
                  $scope.mealsChart = $scope.generateMealChart(paxInfo);
                  var listSentTimestamp = new Date(paxInfo.LastRun).getTime();
                  var DepartureTimestamp = new Date($scope.flight.ScheduledDeparture).getTime(); //20 minutes before takeoff

                  if (DepartureTimestamp - listSentTimestamp <= 1200000) {
                    $scope.IsProvisional = false;
                  }
                }
              }); //Update scopes for the CrewRoutePanel in Flight-page

              $scope.crewRouteInfoPanel = CrewRouteFactory.getCrewRouteInfoPanel($scope.flight);
              $scope.aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId($scope.flight.FlightId);
              $scope.flightETA = $scope.flight.ETA ? moment($scope.flight.ETA).valueOf() : new Date($scope.flight.ScheduledArrival).getTime();
              var updatedInfo = null;
              PushNotifier.formatInfoToCompare($scope.flight.FlightId).then(function (data) {
                updatedInfo = data;
                var changes = PushNotifier.compareAndExtractChanges(currentInfo, updatedInfo);
                var message = PushNotifier.MessageGenerator(changes);

                if (changes && changes.length > 0) {
                  if (browserNotificationsEnabled) {
                    try {
                      PushNotifier.Generate('Changes', message);
                    } catch (e) {
                      $scope.changes = changes;
                      $scope.showAlternativeNotifications = true;
                    }
                  } else {
                    $scope.changes = changes;
                    $scope.showAlternativeNotifications = true;
                  }
                }
              });
            }, function (responseData) {
              if (browserNotificationsEnabled && window.navigator.onLine) {
                try {
                  PushNotifier.Generate('Changes', 'Update failed');
                } catch (ex) {//TODO: add related messagge KVEN,EPAP
                }
              }
            });

            if (intervalTime != autoUpdateIntervalTimeOffset) {
              autoUpdateIntervalTimeOffset = intervalTime;
              $interval.cancel(autoUpdateInterval);
              autoUpdateInterval = $interval(autoflightInfoInterval, autoUpdateIntervalTimeOffset);
            }
          } else {
            $interval.cancel(autoUpdateInterval);
            $scope.showAutoUpdatePanel = false;
          }
        });
      }

      function timerDelayGenerator(departureTime) {
        var intervalTime = -1;
        var depTimestamp = moment.utc(departureTime).valueOf();
        var nowTimeStamp = moment().valueOf();
        var minutes = 60000;

        if (depTimestamp - 70 * minutes <= nowTimeStamp && depTimestamp + 30 * minutes >= nowTimeStamp) {
          var absoluteMinuteDiff = Math.abs(depTimestamp - nowTimeStamp);

          if (absoluteMinuteDiff <= 15 * minutes) {
            intervalTime = 1 * minutes;
          } else {
            intervalTime = 3 * minutes;
          }
        }

        return intervalTime;
      }
    }

    return {
      restrict: 'E',
      templateUrl: 'views/directives/autofresh.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('basicFooter', basicFooter);
  /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name basicFooter
   * @restrict E
   * @description
   *   Implementation of basicFooter (appears in groundDuty-info view)
   *
   *   Initialize a basic Footer Template and its Navigation Functionality
   *   Used in groundDuty and crewRoute view
   * @example
   *   Usage:
   *   <basic-footer></bacic-footer>
   * @ngInject
   */

  function basicFooter($location, SettingsMain, UserFactory, DataCleanerFactory) {
    /**
     * Initialize basicFooter and events
     * @memberof basicFooter
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attrs attribute of this element
     */
    function link(scope, element, attrs) {
      if (scope.groundDuty || scope.crewRoute) {
        /**
         * Open a modal from which u can Logout from the application
         * @memberof groundFooter  
         */
        var logout = function logout() {
          var isSecure = UserFactory.isSecure();
          bootbox.dialog({
            message: (isSecure ? "<strong class='text-danger'>Due to the fact that you are working over a public computer, all stored data will be deleted on logout!</strong><br/><br/>" : "You will be able to login again into the same account, even if there is no internet access.<br/><br/>") + "Please confirm that you wish to log out.",
            title: "<strong>User Logout<strong>",
            buttons: {
              cancel: {
                label: "Cancel",
                className: "btn-default",
                callback: function callback() {}
              },
              logout: {
                label: "Logout",
                className: "btn-warning",
                callback: function callback() {
                  UserFactory.clearActiveUser();
                  if (isSecure) DataCleanerFactory.deleteAllData();
                  UserFactory.azSignOut();
                  location.reload(true); // need to reload, in order for the
                  // browser to check the cache.manifest
                  // and discover any changes
                }
              }
            }
          });
        };
        /**
         * Navigate to Calendar View
         * @memberof groundFooter  
         */


        var gotoCalendar = function gotoCalendar() {
          // handleIfReport(state, flightId, report);
          SettingsMain.setEditingPage(null); // go to dashboard

          $location.path("/");
        };
        /**
         * Navigate to Bucket Calendar View
         * @memberof groundFooter  
         */


        var gotoBucketCalendar = function gotoBucketCalendar() {
          SettingsMain.setEditingPage(null);
          $location.path('/bucket');
        };
        /**
         * Navigate to FAQs View
         * @memberof groundFooter  
         */


        var gotoFAQs = function gotoFAQs() {
          SettingsMain.setEditingPage(null);
          $location.path('/faqs');
        };
        /**
        * Navigate to Roster Requests View
        * @memberof mainFooter  
        */


        var gotoRequests = function gotoRequests() {
          SettingsMain.setEditingPage(null);
          $location.path("/rosterRequests");
        };
        /**
         * Navigate to Messages View
         * @memberof groundFooter  
         */


        var gotoMessageLibrary = function gotoMessageLibrary() {
          $location.path('/messages');
        };
        /**
        * Navigate to Meal Library View
        * @memberof groundFooter  
        */


        var gotoMealLibrary = function gotoMealLibrary() {
          $location.path('/mealLibrary');
        };

        var state = scope.state;
        var user = UserFactory.getUser();
        var delay = 60000;
        scope.gotoMessageLibrary = gotoMessageLibrary;
        scope.gotoFAQs = gotoFAQs;
        scope.gotoRequests = gotoRequests;
        scope.gotoBucketCalendar = gotoBucketCalendar;
        scope.gotoCalendar = gotoCalendar;
        scope.gotoMealLibrary = gotoMealLibrary;
        scope.logout = logout;
      }
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/Main/basic-footer.tpl.html",
      scope: false,
      link: link
    };
  }
})();
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  'use strict';

  a3_cabin_reports.directive('campaigns', campaigns);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name campaigns
  * @restrict E
  * @description
  *   Implementation of issues
  *
  *   Initialize the campaigns template
  * @example
  *   Usage:
  *   <campaigns campaigns="campaigns"></campaigns>
  * @ngInject
  */

  function campaigns($uibModal, CampaignFactory) {
    var _ref;

    function link(scope) {
      scope.currentTreatment = 0;
      scope.previousTreatment = previousTreatment;
      scope.nextTreatment = nextTreatment;
      scope.openAssignment = openAssignment;
      scope.FlightCampaigns = {}; //Keeps modified accordion group open

      scope.status = {
        isItemOpen: new Array(scope.FlightCampaigns.length)
      };
      checkForCompletion();

      function openAssignment(_assignment, flightId, campaign, treatment, cindex) {
        scope.status.isItemOpen[cindex] = true;
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Dialogs/dlgCampaignAssignment.html',
          controller: 'AssignmentModalCtrl',
          size: 'md',
          keyboard: false,
          resolve: {
            assignment: function assignment() {
              return _objectSpread({}, _assignment);
            },
            info: function info() {
              return {
                flightId: +flightId,
                campaign: campaign,
                treatment: treatment
              };
            }
          }
        });
        modalInstance.closed.then(function () {
          scope.campaigns = CampaignFactory.getCampaignsByFlightId(+flightId);
          checkForCompletion();
        });
      }

      function previousTreatment(index) {
        if (index > 0) scope.currentTreatment = index - 1;
      }

      function nextTreatment(index, lenght) {
        if (index < lenght - 1) scope.currentTreatment = index + 1;
      }

      function isOpen(index) {
        return latestOpen == index;
      }

      function checkForCompletion() {
        if (scope.campaigns && scope.campaigns.CampaignsList && scope.campaigns.CampaignsList.length > 0) {
          scope.campaigns.CampaignsList.forEach(function (c) {
            c.Treatments.forEach(function (t) {
              var assignmentsWithStatus = t.Assignments.filter(function (a) {
                return +a.Status > 0;
              });
              t.CompleteFeedbacksCount = assignmentsWithStatus.length;
              var feedbacksCompleted = t.Assignments.every(function (a) {
                return a.Status > 0;
              });

              if (feedbacksCompleted) {
                t.FeedbacksCompleted = true;
              } else {
                t.FeedbacksCompleted = false;
              }
            });
            var campaignCompleted = c.Treatments.every(function (t) {
              return t.FeedbacksCompleted == true;
            });

            if (campaignCompleted) {
              c.TreamentsCompleted = true;
            } else {
              c.TreamentsCompleted = false;
            }
          });
          scope.FlightCampaigns = scope.campaigns;
          scope.flight.hasPendingFeedbacks = CampaignFactory.hasPendingFeedbacks(scope.campaigns);
        }
      }
    }

    return _ref = {
      restrict: 'E',
      scope: {
        campaigns: '@'
      },
      terminal: true,
      templateUrl: 'views/directives/campaigns.tpl.html'
    }, _defineProperty(_ref, "scope", false), _defineProperty(_ref, "link", link), _ref;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('crewMeals', crewMeals);
  /**
     * @memberof CabinReports
     * @ngdoc directive
     * @name crewMeals
     * @restrict E
     * @description
     *   Implementation of crew meals
     *
     *   Display the crew meals
     * @attr {String} dutyNo 
     * @attr {String} dutyDay  
     * @attr {String} flight-id
     * @example
     *   Usage:
     *   <crew-meals duty-no="137979375664" duty-day="13318" flight-id="123"></crew-meals>
     *   
     * @ngInject
     */

  function crewMeals(CrewRouteFactory, CrewMealFactory, FlightFactory, $sce, $timeout, $location, mealCriteriaIsEnabled) {
    /**
     * Initialize crewMeals
     * @memberof crewMeals
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attributes attributes of this element
     */
    function link(scope, element, attributes) {
      scope.togglePanel = togglePanel;
      scope.route = CrewRouteFactory.getCrewRouteFromStorage(scope.dutyNo, scope.dutyDay);
      scope.HasRegChanged = false;
      scope.noClicked = noClicked;
      scope.yesClicked = yesClicked;
      scope.submitRatingClicked = submitRatingClicked;
      scope.canceClicked = canceClicked;
      scope.clearFormData = clearFormData; //for flight page

      scope.isFlightPanel = scope.flightId !== "";
      scope.flightCrewMeals = null; //for route page

      scope.isRoutePanel = scope.flightId == null || scope.flightId === "";
      scope.routeCrewMeals = [];
      scope.showCrewMealsPanel = false; //Rating Form

      scope.ratingForm = {
        CateringMealId: '',
        FlightId: '',
        Rating: '',
        Comments: '',
        DidNotEatReasonId: ''
      };
      scope.submitRatingMessage = '';
      scope.showPanel = "meals";
      scope.DidNotEatReasons = [];
      scope.isOffline = !window.navigator.onLine;
      scope.gotoMealLibrary = gotoMealLibrary;
      scope.mealCriteriaIsEnabled = mealCriteriaIsEnabled;
      scope.popoverInfo = {
        title: $sce.trustAsHtml(' Attention'),
        contentHtml: $sce.trustAsHtml('<div style="width:210px;">' + 'There is an aircraft change on your route. Please arrange to take your assigned meal with you.' + '<div/>')
      };
      window.addEventListener('offline', function (e) {
        $timeout(scope.isOffline = !window.navigator.onLine);
      });
      window.addEventListener('online', function (e) {
        $timeout(scope.isOffline = !window.navigator.onLine);
      }); //Get scope values

      if (scope.isFlightPanel && scope.route) {
        var crewMeals = scope.route.CrewMeals;

        for (var i = 0; i < crewMeals.length; i++) {
          if (crewMeals[i].FlightId == scope.flightId) {
            scope.flightCrewMeals = new FlightCrewMeal(crewMeals[i]);
            scope.showCrewMealsPanel = true;
            break;
          }
        }

        scope.HasRegChanged = hasRegChanged(scope.flightId);
      }

      if (scope.isRoutePanel && scope.route && scope.route.CrewMeals.length > 0) {
        var crewMeals = scope.route.CrewMeals;

        for (var i = 0; i < crewMeals.length; i++) {
          scope.routeCrewMeals.push(new FlightCrewMeal(crewMeals[i]));
          scope.showCrewMealsPanel = true;
        }

        scope.HasRegChanged = hasRegChanged(crewMeals[0].FlightId);
      }

      if (!scope.isOffline && scope.showCrewMealsPanel) {
        CrewMealFactory.getCrewMealsDidNotEatReasons().then(function (res) {
          return scope.DidNotEatReasons = res;
        });
      } //FlightCrewMeal Constructor


      function FlightCrewMeal(flight) {
        this.FlightDate = moment(flight.FlightDate).format("DD/MM");
        this.FlightNo = flight.FlightNo;
        this.FlightDeparture = flight.FlightDeparture;
        this.CrewMeals = "";
        this.CrewMealsDescriptions = [];

        for (var i = 0; i < Object.values(flight.CrewMealsCateringIds).length; i++) {
          if (i != 0) {
            this.CrewMeals += " & ";
          }

          var crewMealDetails = CrewMealFactory.getCrewMealFromStorage(Object.values(flight.CrewMealsCateringIds)[i]);
          var hasRating = CrewMealFactory.hasRating(Object.keys(flight.CrewMealsCateringIds)[i]);
          this.CrewMeals += crewMealDetails.Title;
          this.CrewMealsDescriptions.push({
            CrewMealId: Object.keys(flight.CrewMealsCateringIds)[i],
            CateringMealId: crewMealDetails.CateringMealId,
            Title: crewMealDetails.Title,
            Description: crewMealDetails.Description,
            HasRating: hasRating
          });
        }
      } //Change Registration check


      function hasRegChanged(flightId) {
        var retVal = false;
        var flights = FlightFactory.getFlightsByFlightId(flightId);

        if (flights.length > 0) {
          var acTailNo = flights[0].AcTailNo;

          for (var i = 0; i < flights.length; i++) {
            if (flights[i].AcTailNo != acTailNo) {
              retVal = true;
              break;
            }
          }
        }

        return retVal;
      }
      /**
       * toggle Panel
       * @memberof crewMeals
       * @param {number} panelId
       */


      function togglePanel(panelId) {
        $('#' + panelId).toggle();
      }

      function noClicked(cateringMealId, crewMealId) {
        clearFormData(cateringMealId, crewMealId);
        scope.showPanel = "didNotEatMeal";
      }

      function yesClicked(cateringMealId, crewMealId) {
        clearFormData(cateringMealId, crewMealId);
        scope.showPanel = "mealRating";
      } //function checkConnection


      function clearFormData(cateringMealId, crewMealId) {
        scope.ratingForm.CateringMealId = cateringMealId;
        scope.ratingForm.FlightId = scope.flightId;
        scope.ratingForm.CrewMealId = crewMealId;
        scope.ratingForm.Rating = '';
        scope.ratingForm.DidNotEatReasonId = '';
        scope.ratingForm.Comments = '';
        scope.isOffline = !window.navigator.onLine;
      }

      function canceClicked() {
        scope.showPanel = "meals";
      }

      function submitRatingClicked() {
        scope.showPanel = "loading";
        CrewMealFactory.sendCrewMealsRatingReport(this.ratingForm).then(function (res) {
          return handleSubmitResponse(res);
        });
      }

      function handleSubmitResponse(res) {
        if (res.success) {
          var index = scope.flightCrewMeals.CrewMealsDescriptions.findIndex(function (x) {
            return x.CateringMealId == scope.ratingForm.CateringMealId;
          });
          scope.flightCrewMeals.CrewMealsDescriptions[index].HasRating = true;
          manageResponseMessage("success", res.message);
        } else {
          manageResponseMessage("failure", res.message);
        }
      }

      function manageResponseMessage(panelToShow, message) {
        scope.submitRatingMessage = message;
        scope.showPanel = panelToShow;
        $timeout(function () {
          scope.showPanel = "meals";
        }, 3000);
      } //navigates to meal library


      function gotoMealLibrary(searchText) {
        $location.path('/mealLibrary/' + scope.flightId + '/' + "CREW" + '/' + searchText);
      }
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/directives/crewMeals.tpl.html',
      scope: {
        dutyNo: '@',
        dutyDay: '@',
        flightId: '@'
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('eventHistory', eventHistory);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name eventHistory
  * @restrict E
  * @description
  *   Implementation of eventHistory
  *   Initialize the Event History of report incidents (mockup view).
  * @example
  *   Usage:
  *   <event-history></event-history>
  * @ngInject
  */

  function eventHistory() {
    return {
      restrict: 'E',
      templateUrl: 'views/directives/eventHistory.tpl.html'
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('flightCrew', flightCrew);
  /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name flightCrew
    * @restrict E
    * @description
    *  Initialize Flight Crew Information
    * @example
    *   Usage:
    *   <flight-crew></flight-crew>
    * @ngInject 
    */

  function flightCrew() {
    function link(scope, element, attrs) {}

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/directives/flightCrew.tpl.html",
      scope: {
        flight: '='
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('flightFooter', flightFooter);
  /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name flightFooter
   * @restrict E
   * @description
   *   Implementation of FlightFooter
   *
   *   Initialize The flights Footer Template and its Navigation, Sync, Footer Functionality
   * @example
   *   Usage:
   *   <flight-footer></flight-footer>
   * @ngInject
   */

  function flightFooter(orderByFilter, $location, $sce, $timeout, $interval, $filter, apiUrl, $uibModal, $route, SettingsMain, MemoFactory, MessageFactory, FlightFactory, UserFactory, DataCleanerFactory, CabinReportLocalEditFactory, ReportGuidFactory, SyncLogFactory, CrewRouteFactory, GroundDutyFactory) {
    /**
     * Initialize flightFooter and events
     * @memberof flightFooter
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service}   attrs attribute of this element
     */
    function link(scope, element, attrs) {
      if (scope.flight) {
        /**
         * Find previous,next and current flight of the Route of the selected flight
         * @memberof flightFooter
         * @param {number} flightId input the Id of a Flight  
         * @returns {Object} previous,next and current flight
         */
        var getPreviousAndNextFlights = function getPreviousAndNextFlights(flightId) {
          var nextFlight, previousFlight, currentFlight;
          var flights = FlightFactory.getFlightsByRoute(scope.flight.Route, scope.flight.DutyDate);
          flights = orderByFilter(flights, orderByDate, false);

          function orderByDate(item) {
            var date = new Date(item.ScheduledDeparture);
            return date;
          }

          for (var i = 0; i < flights.length; i++) {
            if (flights[i].FlightId == flightId) {
              if (i >= 1) {
                previousFlight = flights[i - 1];
              }

              if (i + 1 < flights.length) {
                nextFlight = flights[i + 1];
              }

              currentFlight = flights[i];
            }
          }

          return {
            nextFlight: nextFlight,
            previousFlight: previousFlight,
            currentFlight: currentFlight
          };
        };
        /**
         * It handles the cabin report when u want to navigate to another view
         * @memberof flightFooter
         * @param {String} state input the current state (view)  
         * @param {number} flightId input the Id of a Flight  
         * @param {Object} report input the cabin report  
         */


        var handleIfReport = function handleIfReport(state, flightId, report) {
          if (state == 'report') {
            if (report == null) {
              report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);
            }

            var guid = report.ReportGuid;
            var status = report.Status; // delete the temp report

            CabinReportLocalEditFactory.deleteTempReport(); //reuse guid if this was a new report

            if (status == 'pending') ReportGuidFactory.restoreGuid(report.ReportGuid);
          }
        };
        /**
         * Open the Cabin Report for the  selected Flight
         * @memberof flightFooter  
         * @param {number} flightId input the Id of a Flight
         */


        var openReport = function openReport(flightId) {
          var user = UserFactory.getUser();
          var token = '';

          if (user != null) {
            token = user.token;
            token = encodeURIComponent(token);
          } // load the flight


          var flight = FlightFactory.getFlightFromStorage(flightId);

          if (flight == null) {
            // if not found, also check the local flights
            var flight = FlightFactory.getLocalFlightFromStorage(flightId);
            if (flight == null) return;
          } // load the reports


          var serverReportForThisUser = flight.getServerCabinReportForUser(user.aimsId);
          var serverReportsByAnotherUser = flight.getServerCabinReportsByAnotherUser(user.aimsId);
          var localReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId); // no stored local report

          if (localReport == null) {
            // has server report from this user and from other users
            if (serverReportForThisUser != null && serverReportsByAnotherUser.length > 0) {
              // show selection dialog
              openReportDialog(flightId);
            } // has server report only from this user
            else if (serverReportForThisUser != null && serverReportsByAnotherUser.length == 0) {
                $location.path("reportsHistory/" + serverReportForThisUser.ReportId + "/" + flightId + "/Cabin");
              } // has server report only from other users
              else if (serverReportForThisUser == null && serverReportsByAnotherUser.length > 0) {
                  // show selection dialog
                  openReportDialog(flightId);
                } // no server reports, create a new local report directly
                else {
                    $location.path("report/new:" + -1 + "/" + flightId);
                  }
          } // has stored local report
          else {
              // special case: has server report from this user, and not from
              // other users
              if (serverReportForThisUser != null && serverReportsByAnotherUser.length == 0) {
                // open the local report for editing
                $location.path("report/" + localReport.ReportGuid);
              } // general case: has server report from this user or from other
              // users
              else if (serverReportForThisUser != null || serverReportsByAnotherUser.length > 0) {
                  // show selection dialog
                  openReportDialog(flightId);
                } // no server reports, open the local report directly
                else {
                    // open the existing report for editing
                    $location.path("report/" + localReport.ReportGuid);
                  }
            }
        };
        /**
         * Open a modal to choose an action when there is already a cabin report from another user
         * @memberof flightFooter  
         * @param {number} flightId input the Id of a Flight
         */


        var openReportDialog = function openReportDialog(_flightId) {
          var modalInstance = $uibModal.open({
            templateUrl: './views/Dialogs/dlgOpenReport.html',
            controller: 'OpenReportDialogCtrl',
            size: 'md',
            resolve: {
              flightId: function flightId() {
                return _flightId;
              }
            }
          });
          modalInstance.result.then(function () {}, function () {});
        };
        /**
         * Open a modal from which u can Logout from the application
         * @memberof flightFooter  
         */


        var logout = function logout() {
          var isSecure = UserFactory.isSecure();
          bootbox.dialog({
            message: (isSecure ? "<strong class='text-danger'>Due to the fact that you are working over a public computer, all stored data will be deleted on logout!</strong><br/><br/>" : "You will be able to login again into the same account, even if there is no internet access.<br/><br/>") + "Please confirm that you wish to log out.",
            title: "<strong>User Logout<strong>",
            buttons: {
              cancel: {
                label: "Cancel",
                className: "btn-default",
                callback: function callback() {}
              },
              logout: {
                label: "Logout",
                className: "btn-warning",
                callback: function callback() {
                  UserFactory.clearActiveUser();
                  if (isSecure) DataCleanerFactory.deleteAllData();
                  UserFactory.azSignOut();
                  location.reload(true); // need to reload, in order for the
                  // browser to check the cache.manifest
                  // and discover any changes
                }
              }
            }
          });
        };
        /**
         * Redirects to Reset Device View
         * @memberof flightFooter  
         */


        var resetDevice = function resetDevice() {
          SettingsMain.setEditingPage(null);
          $location.path("/reset");
        };
        /**
         * Open a modal from which you can delete all available reports
         * @memberof flightFooter  
         * @method
         */


        var deleteAllReports = function deleteAllReports() {
          bootbox.dialog({
            message: "Use this process to clear your device from all locally stored Cabin Reports, in order to save up space, when available storage space is not sufficient for the application to function properly.<br/><br/>" + "<h4>ATTENTION</h4>" + "This action will delete all Cabin Reports from your device, <span style='text-decoration: underline;'>including draft and completed ones not sent to the server</span>.",
            title: "<strong>Application Logs Reset<strong>",
            buttons: {
              cancel: {
                label: "Cancel",
                className: "btn-default",
                callback: function callback() {}
              },
              danger: {
                label: "Delete All Cabin Reports",
                className: "btn-danger",
                callback: function callback() {
                  DataCleanerFactory.deleteAllReports();
                  $route.reload();
                  bootbox.alert("All Cabin Reports have been successfully deleted.", function () {});
                }
              }
            }
          });
        };
        /**
         * Navigate to Calendar View
         * @memberof flightFooter  
         */


        var gotoCalendar = function gotoCalendar() {
          handleIfReport(state, flightId, report);
          SettingsMain.setEditingPage(null); // go to dashboard

          $location.path("/");
        };
        /**
         * Navigate to Bucket Calendar View
         * @memberof flightFooter  
         */


        var gotoBucketCalendar = function gotoBucketCalendar() {
          SettingsMain.setEditingPage(null);
          $location.path('/bucket');
        };
        /**
         * Navigate to FAQs View
         * @memberof flightFooter  
         */


        var gotoFAQs = function gotoFAQs() {
          SettingsMain.setEditingPage(null);
          $location.path('/faqs');
        };
        /**
         * Navigate to Roster Requests
         * @memberof flightFooter  
         */


        var gotoRequests = function gotoRequests() {
          SettingsMain.setEditingPage(null);
          $location.path('/rosterRequests');
        };
        /**
         * Navigate to Selected Flight Information View
         * @param {number} flightId input the Id of a Flight
         * @memberof flightFooter  
         */


        var gotoFlight = function gotoFlight(flightId) {
          SettingsMain.setEditingPage(null);
          handleIfReport(state, flightId, report);
          $location.path('/flightinfo/' + flightId);
        };
        /**
         * Navigate to Messages View
         * @memberof flightFooter  
         */


        var gotoMessageLibrary = function gotoMessageLibrary() {
          handleIfReport(state, flightId, report);
          $location.path('/messages');
        };
        /**
         * Navigate to the Current Flight's Information View
         * @memberof flightFooter  
         */


        var gotoFlightInfo = function gotoFlightInfo() {
          gotoFlight(flightId);
        };
        /**
         * Navigate to Submit ticket view
         * @memberof flightFooter  
         */


        var gotoTicket = function gotoTicket() {
          // go to Submit ticket view
          $location.path("/ticket");
        };

        var goToSafetyReport = function goToSafetyReport(flightId) {
          $location.path('/safetyreport/cabincrewreport/' + flightId);
        };

        var goToFatigueReport = function goToFatigueReport(flightId) {
          $location.path('/safetyreport/fatiguereport/' + flightId);
        };
        /**
         * Open current's Flight Cabin Report
         * @memberof flightFooter  
         */


        var openCabinReport = function openCabinReport() {
          SettingsMain.setEditingPage(null);
          openReport(flightId);
        };
        /**
         * Navigate to the Current Flight's Pax Information View
         * @memberof flightFooter  
         */


        var gotoPaxInfo = function gotoPaxInfo() {
          SettingsMain.setEditingPage(null);
          handleIfReport(state, flightId, report);
          $location.path('/pax/' + flightId);
        };
        /**
         * Open current's Flight Cabin Crew Feedback Report
         * @memberof flightFooter  
         */


        var openAssessment = function openAssessment() {
          SettingsMain.setEditingPage(null);
          $location.path("assessment/" + flightId);
        };
        /**
         * Open current's Flight SA Feedback Report
         * @memberof flightFooter  
         */


        var openSaAssessment = function openSaAssessment() {
          SettingsMain.setEditingPage(null);
          $location.path("saAssessment/" + flightId);
        };
        /**
         * Navigate to Memos Library
         * @memberof flightFooter  
         */


        var gotoMemosLibrary = function gotoMemosLibrary() {
          SettingsMain.setEditingPage(null);
          handleIfReport(state, flightId, report);
          $location.path('/memos');
        }; //todo:: clean up
        // /**
        //  * Get the latest Pax and Gate Informations
        //  * @memberof flightFooter  
        //  */
        // function SynchPaxAndGates() {
        //     var modalInstance = $uibModal.open({
        //         templateUrl: 'views/Dialogs/dlgLightSync.html',
        //         controller: 'SyncPaxCtrl',
        //         size: 'md',
        //         backdrop: 'static',
        //         keyboard: false,
        //         resolve: {
        //             flightId: function () {
        //                 return flightId;
        //             },
        //         }
        //     })
        //     modalInstance.result.then(function () {
        //         scope.lastSync = new Date().getTime();
        //     }, function () {});
        // }

        /**
         * Opens refresh modal for results
         */


        var RefreshRoute = function RefreshRoute() {
          var _dutyNo = scope.flight.DutyNo;
          var _dutyDay = scope.flight.DutyDay;

          var _crewRouteDuty = CrewRouteFactory.getCrewRouteFromStorage(_dutyNo, _dutyDay);

          var groundDuties = GroundDutyFactory.getGroundDutiesByDutyNo(_dutyNo, _dutyDay);

          if (groundDuties.length > 0) {
            //there are ground duties in this crew route
            angular.forEach(groundDuties, function (groundDuty) {
              groundDuty.DutyType = "Ground";
              groundDuty.Start = groundDuty.DutyBegin;
            });
          }

          var flights = FlightFactory.getFlightsByDutyNo(_dutyNo, _dutyDay);

          if (flights.length > 0) {
            //there are flights in this crew route
            angular.forEach(flights, function (flight) {
              flight.DutyType = "Flight";
              flight.Start = flight.ScheduledDeparture;
            });
          }

          var crewRoute = groundDuties.concat(flights);
          crewRoute = $filter('orderBy')(crewRoute, 'Start', false);
          var modalInstance = $uibModal.open({
            templateUrl: 'views/CrewRoute/dlgCrewRouteRefresh.html',
            controller: 'CrewRouteRefreshModalCtrl',
            backdrop: 'static',
            keyboard: false,
            size: 'md',
            resolve: {
              crewroute: function crewroute() {
                return crewRoute;
              },
              crewRouteDuty: function crewRouteDuty() {
                return _crewRouteDuty;
              },
              dutyNo: function dutyNo() {
                return Number(_dutyNo);
              },
              dutyDay: function dutyDay() {
                return Number(_dutyDay);
              },
              forCurrentDay: function forCurrentDay() {
                return scope.flight.FlightDate;
              }
            }
          });
          modalInstance.result.then(function (transferData) {
            scope.lastSync = new Date().getTime();

            if (transferData.sync) {
              SyncLogFactory.forceSync();
              $location.path("/"); //crew route has significantly changed
            } else if (transferData.refresh) {
              $route.reload(); //crew route was updated
            }
          });
        };
        /**
         * Show Popover that advices User to sync so he can get the latest Pax and Gate Informations
         * @memberof flightFooter  
         */


        var showSyncPopover = function showSyncPopover() {
          var firstSyncWarning = departure - 4500000; //75 mintes before takeoff

          var secondSyncWarning = departure - 600000; //10 minutes before takeoff

          var now = new Date().getTime();
          var lastSync = scope.lastSync;

          if (now > firstSyncWarning && now < secondSyncWarning && (!lastSync || lastSync < firstSyncWarning) || now > secondSyncWarning && now < departure && (!lastSync || lastSync < secondSyncWarning)) {
            scope.enableSyncPopover = true;
          }
        };
        /**
         * Calculate the time difference of pax info list from now
         * @memberof flightFooter  
         */


        var returnTimeDiff = function returnTimeDiff() {
          //time difference in minutes from: now and pax info list date
          scope.paxTimeDiffInMins = Math.round((new Date().getTime() - new Date(scope.paxInfo.LastRun).getTime()) / 60000);
        };

        var flightId = scope.flight.FlightId;
        var state = scope.state;
        var report = scope.report;
        var flights = getPreviousAndNextFlights(flightId);
        var user = UserFactory.getUser();
        var delay = 60000;
        var isAssessmentEnabled = SettingsMain.getIsAssessmentEnabled();
        var showAssessment = isAssessmentEnabled && scope.flight.assessment;
        var showFlightReport = scope.flight.LineStatus != 'na';
        var hasMultipleReports = showAssessment && !scope.flight.assessment.IsExist && showFlightReport;
        var reportsPopoverTemplateUrl = 'views/directives/reportsPopover.tpl.html';

        if (state == 'pax' || state == 'flight' && scope.paxInfo) {
          var now = new Date().getTime();
          var departure = new Date(scope.flight.ScheduledDeparture).getTime();

          if (departure < now) {
            var openSyncPopover = $interval(showSyncPopover, delay);
          }
        }

        if (state == 'pax' || state == 'flight') {
          if (scope.paxInfo && new Date(scope.flight.ScheduledDeparture).getTime() > new Date().getTime()) {
            returnTimeDiff();
            var showTimeDiff = $interval(returnTimeDiff, delay);
          }
        }

        scope.showAssessment = showAssessment;
        scope.showFlightReport = showFlightReport;
        scope.hasMultipleReports = hasMultipleReports;
        scope.reportsPopoverTemplateUrl = reportsPopoverTemplateUrl;
        scope.gotoFAQs = gotoFAQs;
        scope.gotoRequests = gotoRequests;
        scope.gotoFlight = gotoFlight;
        scope.previousFlight = flights.previousFlight;
        scope.nextFlight = flights.nextFlight;
        scope.gotoBucketCalendar = gotoBucketCalendar;
        scope.gotoCalendar = gotoCalendar;
        scope.gotoFlightInfo = gotoFlightInfo;
        scope.openCabinReport = openCabinReport;
        scope.logout = logout;
        scope.resetDevice = resetDevice;
        scope.deleteAllReports = deleteAllReports;
        scope.gotoMessageLibrary = gotoMessageLibrary;
        scope.gotoPaxInfo = gotoPaxInfo;
        scope.gotoMemosLibrary = gotoMemosLibrary;
        scope.RefreshRoute = RefreshRoute;
        scope.showPopover = false;
        scope.showMobileMenu = false;
        scope.userPosition = user.position;
        scope.openAssessment = openAssessment;
        scope.openSaAssessment = openSaAssessment;
        scope.gotoTicket = gotoTicket;
        scope.goToSafetyReport = goToSafetyReport;
        scope.goToFatigueReport = goToFatigueReport;
        scope.syncWarning = $sce.trustAsHtml('<div class="border-left-orange" style="padding-left: 0.3em"><i class="text-orange fa fa-exclamation-triangle"></i> You are <strong>strongly</strong> advised to sync your device.</div>');
        scope.enableSyncPopover = false;
        scope.lastSync = null;
        element.on('$destroy', function () {
          $interval.cancel(openSyncPopover);
          $interval.cancel(showTimeDiff);
        });
      }
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/Flight/footer.tpl.html",
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('flightHeader', flightHeader);
  /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name flightHeader
    * @restrict E
    * @description
    *   Implementation of flightHeader
    *    Initialize the template of the header while you are in the Flight Level
    * @example
    *   Usage:
    *   <flight-header></flight-header>
    * @ngInject 
    */

  function flightHeader() {
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/Flight/header.tpl.html",
      scope: false
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('groundCrew', groundCrew);
  /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name groundCrew
    * @restrict E
    * @description
    * Initialize Trainer and Trainee Info
    * @example
    *   Usage:
    *   <ground-crew></ground-crew>
    * @ngInject 
    */

  function groundCrew() {
    function link(scope, element, attrs) {
      scope.groundDuty = scope.duty;
      scope.toggleCrewList = toggleCrewList;
      scope.groundDuty.Trainees.forEach(function (relatedTrainees) {
        relatedTrainees.isCollapsed = false;
        relatedTrainees.dynamicSize = 10;
      });
      /**
       * @memberof GroundDutyCtrl
       * @name toggleCrewList
       * @description 
       * Οnly show the first 10 trainees - if more then toggle
       */

      function toggleCrewList(relatedTrainees) {
        relatedTrainees.isCollapsed = !relatedTrainees.isCollapsed;
        if (relatedTrainees.isCollapsed) relatedTrainees.dynamicSize = relatedTrainees.CrewMembers.length;else relatedTrainees.dynamicSize = 10;
      }
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/directives/groundCrew.tpl.html",
      scope: {
        duty: '='
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('groundHeader', groundHeader);
  /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name groundHeader
    * @restrict E
    * @description
    *   Implementation of groundHeader (appears in groundDuty-info view)
    *    Initialize the template of the header while you are in the Ground Duty Level
    * @example
    *   Usage:
    *   <ground-header></ground-header>
    * @ngInject 
    */

  function groundHeader() {
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/GroundDuty/header.tpl.html",
      scope: false
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('groundInfo', groundInfo);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name groundInfo
  * @restrict EA
  * @description
  *   Implementation of groundInfo
  *
  *   Initialize the ground information (Contacts,Hotels)
  * @attr {String} station The name of the station to get the ground information.
  * @example
  *   Usage:
  *   <div groundInfo stations="ATH,LHR"></div>
  * @ngInject
  */

  function groundInfo(AirportContactFactory, AirportHotelFactory) {
    /**
     * Calculates distinct HotelTypes (used for filtering results)
     * @memberof AirportHotelCtrl
     * @param {array} All the airport Hotels (object which containts Hotels property)
     * @return {array} The distinct HotelTypes as an array of strings
    */
    function findDistinctHotelTypes(items) {
      var unique = {};
      var distinct = [];

      for (var i in items) {
        if (items[i].Name && typeof unique[items[i].Name] == "undefined") {
          distinct.push(items[i].Name);
        }

        unique[items[i].Name] = 0;
      }

      return distinct;
    }
    /**
      * Used to properly display some Hotel Types, eg nulls
      * @memberof AirportHotelCtrl
      * @param {string} The Hotel type to examine and "fix"
      * @return {string} The "fixed" string for the given Hotel type (maybe the same as the input value if no fix is needed)
      */


    function printHotelType(HotelType) {
      if (!HotelType || HotelType == '') {
        console.log(HotelType);
        HotelType = '-no Hotel type-';
      }

      return HotelType;
    }
    /**
    * Calculates distinct ContactTypes (used for filtering results)
    * @memberof AirportContactCtrl
    * @param {array} All the airport contacts (object which containts Contacts property)
    * @return {array} The distinct ContactTypes as an array of strings
    */


    function findDistinctContactTypes(items) {
      var unique = {};
      var distinct = [];

      for (var i in items) {
        if (items[i].ContactType && typeof unique[items[i].ContactType] == "undefined") {
          distinct.push(items[i].ContactType);
        }

        unique[items[i].ContactType] = 0;
      }

      return distinct;
    }
    /**
     * Used to properly display some Contact Types, eg nulls
     * @memberof AirportContactCtrl
     * @param {string} The contact type to examine and "fix"
     * @return {string} The "fixed" string for the given contact type (maybe the same as the input value if no fix is needed)
     */


    function printContactType(contactType) {
      if (!contactType || contactType == '') return '-no contact type-';
      return contactType;
    }

    return {
      restrict: 'EA',
      terminal: true,
      templateUrl: 'views/directives/groundInfo.tpl.html',
      scope: true,
      link: function link($scope, element, attrs) {
        var stations = attrs.stations ? attrs.stations.split(",") : [];
        $scope.stationsInfo = [];
        $scope.filterHotelType = '';
        $scope.filterContactType = ''; //scope methods

        $scope.printHotelType = printHotelType;
        $scope.printContactType = printContactType;
        $scope.showInfo = showInfo;
        angular.forEach(stations, function (station) {
          var stationInfo = {};
          var flightDate = $scope.flight && $scope.flight.FlightDate ? $scope.flight.FlightDate : null;
          var contactInfo = AirportContactFactory.getAirportContacts(station);
          stationInfo.Contacts = contactInfo ? contactInfo.Contacts : [];
          stationInfo.ContactTypes = findDistinctContactTypes(stationInfo.Contacts);
          var hotelInfo = AirportHotelFactory.getAirportHotels(station, flightDate);
          stationInfo.Hotels = hotelInfo ? hotelInfo.Hotels : [];
          stationInfo.HotelTypes = findDistinctHotelTypes(stationInfo.Hotels);
          stationInfo.ActiveHotels = false;
          stationInfo.ActiveContacts = false;
          stationInfo.ActiveGeneralInfo = false;
          stationInfo.Name = station;

          if (stationInfo.Hotels.length > 0 || stationInfo.Contacts.length > 0) {
            $scope.stationsInfo.push(stationInfo);
          }
        });
        var oldViewStation = '';
        var oldViewType = '';

        function showInfo(station, type) {
          angular.forEach($scope.stationsInfo, function (stationInfo) {
            if (stationInfo.Name == station.Name) {
              if (type == 'Hotels') {
                stationInfo.ActiveHotels = !stationInfo.ActiveHotels;
                stationInfo.ActiveContacts = false;
                stationInfo.ActiveGeneralInfo = false;
              } else if (type == 'Contacts') {
                stationInfo.ActiveContacts = !stationInfo.ActiveContacts;
                stationInfo.ActiveHotels = false;
                stationInfo.ActiveGeneralInfo = false;
              } else if (type == 'General') {
                stationInfo.ActiveGeneralInfo = !stationInfo.ActiveGeneralInfo;
                stationInfo.ActiveHotels = false;
                stationInfo.ActiveContacts = false;
              }
            } else {
              stationInfo.ActiveHotels = false;
              stationInfo.ActiveContacts = false;
              stationInfo.ActiveGeneralInfo = false;
            }
          });
        }
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('groundServices', groundServices);
  /**
     * @memberof CabinReports
     * @ngdoc directive
     * @name groundServices
     * @restrict E
     * @description
     *   Implementation of ground services 
     *
     *   Display the ground services
     * @attr {String} arrival The flight arrival station.
     * @attr {String} departure The flight departure station.
     * @attr {String} flight-id The flight id.
     * @example
     *   Usage:
     *   <ground-services arrival="ATH" departure="MAD" flight-id="123"></ground-services>
     *   
     * @ngInject
     */

  function groundServices(GroundServicesFactory, CabinReportLocalEditFactory, CabinReportLocalEditCreatorFactory, FlightFactory, $sce) {
    /**
     * Initialize groundServices
     * @memberof groundServices
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attributes attributes of this element
     */
    function link(scope, element, attributes) {
      scope.togglePanel = togglePanel;
      scope.flight = FlightFactory.getFlightFromTotalFlights(scope.flightId);
      scope.isInFinalState = isInFinalState;
      scope.saveNewUsedState = saveNewUsedState;
      scope.DepartureGroundServices = [];
      scope.ArrivalGroundServices = [];
      scope.popoverInfo = {
        title: $sce.trustAsHtml(' Info'),
        contentHtml: $sce.trustAsHtml('<div style="width:210px;"><span class="text-blue"><i class="fa fa-square"></i></span> Contracted Services' + '<br /><span class="text-gray"><i class="fa fa-square"></i></span> Non Contracted Services' + '<div/>')
      };
      var report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(scope.flightId);

      if (report == null) {
        if (scope.departure) {
          scope.DepartureGroundServices = GroundServicesFactory.getGroundServicesByStation(scope.departure);
        } // if (scope.arrival){
        //     scope.ArrivalGroundServices = GroundServicesFactory.getGroundServicesByStation(scope.arrival);
        // }

      } else {
        report = CabinReportLocalEditFactory.checkForNewGroundServices(report);

        if (scope.departure) {
          scope.DepartureGroundServices = report.DepartureGroundServices;
        } // if (scope.arrival){
        //     scope.ArrivalGroundServices = report.ArrivalGroundServices;
        // }

      }
      /**
       * Check if the report is in a final state so that we cant edit any more
       * @memberof groundServices
       * @returns {boolean} true if final, false otherwise
       */


      function isInFinalState() {
        var isInFinalState = scope.flight.LineStatus === 'na' || scope.flight.LineStatus === 'stored' || scope.flight.LineStatus === 'storedotheruser' || scope.flight.LineStatus === 'stored+otheruser' || scope.flight.LineStatus === 'synched' || scope.flight.LineStatus === 'synchedotheruser';
        return isInFinalState;
      }
      /**
       * When a ground service usage is toggled on or off,
       * create the report if it doesnt exist
       * or just save the changes
       * @memberof groundServices
       */


      function saveNewUsedState() {
        //if report is pending, it doesnt exist yet. create it
        if (scope.flight.LineStatus === 'pending' || scope.flight.LineStatus === 'pendingoverdue') {
          report = CabinReportLocalEditCreatorFactory.createNewLocalReportForFlight(scope.flightId);

          if (scope.departure) {
            report.DepartureGroundServices = scope.DepartureGroundServices;
          } else {
            report.DepartureGroundServices = [];
          } // if (scope.arrival){
          //     report.ArrivalGroundServices = scope.ArrivalGroundServices;
          // }else{
          //     report.ArrivalGroundServices = [];
          // }


          report.Status = 'draft';
          report.saveReport();
          FlightFactory.updateFlightFromReport(report);
        }

        CabinReportLocalEditFactory.setCabinReportToStorage(report);
      } //TODO : find a more angular way (EPAP)

      /**
       * toggle Panel
       * @memberof groundServices
       * @param {number} panelId
       */


      function togglePanel(panelId) {
        $('#' + panelId).toggle();
      }
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/directives/groundServices.tpl.html',
      scope: {
        arrival: '@',
        departure: '@',
        flightId: '@'
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('issues', issues);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name issues
  * @restrict EA
  * @description
  *   Implementation of issues
  *
  *   Initialize the issues telplates for the cabin report form according to their type
  * @attr {String} type The name of the type to initialize the according Issue template.
  * @example
  *   Usage:
  *   <div issues type="travelvalues"></div>
  * @ngInject
  */

  function issues() {
    function _templateUrl(type) {
      var template = 'views/reportItems/empty.html';

      if (type == 'bar') {
        template = 'views/Report/bar.tpl.html';
      } else if (type == 'medicalincidents') {
        template = 'views/Report/medicalIncidents.tpl.html';
      } // else if(type=='securitycheck'){
      // 	template='views/Report/securityCheck.tpl.html';
      // }
      else if (type == 'specialmeals') {
          template = 'views/Report/specialMeals.tpl.html';
        } else if (type == 'supplies') {
          template = 'views/Report/supplies.tpl.html';
        } else if (type == 'travelvalues') {
          template = 'views/Report/travelValues.tpl.html';
        } else if (type == 'um') {
          template = 'views/Report/um.tpl.html';
        } else if (type == 'various') {
          template = 'views/Report/various.tpl.html';
        } else if (type == 'wateruplift') {
          template = 'views/Report/waterUplift.tpl.html';
        } else if (type == 'groundservices') {
          template = 'views/Report/groundServices.tpl.html';
        } else if (type == 'flightOrders') {
          template = 'views/Report/flightOrders.tpl.html';
        } else if (type == 'changedseats') {
          template = 'views/Report/changedSeats.tpl.html';
        } else if (type == 'upgd') {
          template = 'views/Report/upgd.tpl.html';
        } else if (type == 'incompleteServices') {
          template = 'views/Report/incompleteServices.tpl.html';
        } // else if(type=='boardingtimes'){
        // 	template='views/Report/boardingTimes.tpl.html';
        // }
        // else if(type=='disembarkationtimes'){
        // 	template='views/Report/disembarkationTimes.tpl.html';
        // }
        else if (type == 'luggage') {
            template = 'views/Report/luggage.tpl.html';
          } else if (type == 'foundProperty') {
            template = 'views/Report/foundProperty.tpl.html';
          }

      return template;
    }

    return {
      restrict: 'EA',
      terminal: false,
      templateUrl: function templateUrl(element, attrs) {
        return _templateUrl(attrs.type);
      },
      scope: false
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('mainFooter', mainFooter);
  /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name mainFooter
    * @restrict E
    * @description
    *   Implementation of mainFooter
    *   Initialize The main Footer Template and its Navigation, Sync, Footer Functionality
    * @example
    *   Usage:
    *   <main-footer></main-footer>
    * @ngInject 
    */

  function mainFooter($location, SettingsMain, UserFactory, $uibModal, MessageFactory, DataCleanerFactory, $route, MemoFactory, FaqFactory, RequestFactory, $sce, $timeout, FlightFactory, LeaveRequestFactory, PassengerMealServiceFactory, isJumpseatRequestsVisible) {
    /**
     * Initialize mainFooter and events
     * @memberof mainFooter
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attrs attribute of this element
     */
    function link(scope, element, attrs) {
      var messagesCount = 0;
      var messages = [];
      var unreadMessagesCount = 0;
      var memosCount = 0;
      var memos = [];
      var faqs = [];
      var newFAQCount = 0;
      var updatedFAQCount = 0;
      /**
       * Open a modal from which u can Logout from the application
       * @memberof mainFooter  
       */

      function logout() {
        var isSecure = UserFactory.isSecure();
        bootbox.dialog({
          message: (isSecure ? "<strong class='text-danger'>Due to the fact that you are working over a public computer, all stored data will be deleted on logout!</strong><br/><br/>" : "You will be able to login again into the same account, even if there is no internet access.<br/><br/>") + "Please confirm that you wish to log out.",
          title: "<strong>User Logout<strong>",
          buttons: {
            cancel: {
              label: "Cancel",
              className: "btn-default",
              callback: function callback() {}
            },
            logout: {
              label: "Logout",
              className: "btn-warning",
              callback: function callback() {
                UserFactory.clearActiveUser();
                if (isSecure) DataCleanerFactory.deleteAllData();
                UserFactory.azSignOut();
                location.reload(true); // need to reload, in order for the
                // browser to check the cache.manifest
                // and discover any changes
              }
            }
          }
        });
      }
      /**
       * Redirects to Reset Device View
       * @memberof mainFooter  
       */


      function resetDevice() {
        $location.path("/reset");
      }
      /**
       * Open a modal from which you can delete all available reports
       * @memberof mainFooter  
       * @method
       */


      function deleteAllReports() {
        bootbox.dialog({
          message: "Use this process to clear your device from all locally stored Cabin Reports, in order to save up space, when available storage space is not sufficient for the application to function properly.<br/><br/>" + "<h4>ATTENTION</h4>" + "This action will delete all Cabin Reports from your device, <span style='text-decoration: underline;'>including draft and completed ones not sent to the server</span>.",
          title: "<strong>Application Logs Reset<strong>",
          buttons: {
            cancel: {
              label: "Cancel",
              className: "btn-default",
              callback: function callback() {}
            },
            danger: {
              label: "Delete All Cabin Reports",
              className: "btn-danger",
              callback: function callback() {
                DataCleanerFactory.deleteAllReports();
                $route.reload();
                bootbox.alert("All Cabin Reports have been successfully deleted.", function () {});
              }
            }
          }
        });
      }
      /**
       * Navigate to Calendar View
       * @memberof mainFooter  
       */


      function gotoCalendar() {
        SettingsMain.setEditingPage(null); // go to dashboard

        $location.path("/");
      }
      /**
       * Navigate to Submit ticket view
       * @memberof mainFooter  
       */


      function gotoTicket() {
        // go to Submit ticket view
        $location.path("/ticket");
      }
      /**
       * Navigate to Messages View
       * @memberof mainFooter  
       */


      function gotoMessageLibrary() {
        $location.path('/messages');
      }
      /**
       * Navigate to Memos Library
       * @memberof mainFooter  
       */


      function gotoMemos() {
        $location.path('/memos');
      }
      /**
      	* Navigate to Bucket
      	* @memberof mainFooter  
      	*/


      function gotoBucketCalendar() {
        $location.path('/bucket');
      }
      /**
       * Navigate to FAQs View
       * @memberof mainFooter  
       */


      function gotoFAQs() {
        $location.path('/faqs');
      }
      /**
       * Navigate to Roster Requests View
       * @memberof mainFooter  
       */


      function gotoRequests() {
        $location.path("/rosterRequests");
      }
      /**
       * Navigate to Annual Leaves View
       * @memberof mainFooter  
       */


      function gotoLeaveRequests() {
        $location.path('/leaverequest');
      }
      /**
       * Navigate to Jumpseat Requests View
       * @memberof mainFooter  
       */


      function gotoJumpseatRequests() {
        $location.path('/jumpseatrequests');
      }

      function gotoMealLibrary() {
        $location.path('/mealLibrary');
      }

      function gotoCrewExpiries() {
        $location.path('/crewExpiries');
      }
      /**
       * Open the "Search Flight Info" Modal
       * @memberof CalendarCtrl
       */


      function openSearchFlightsModal() {
        var modalInstance = $uibModal.open({
          templateUrl: './views/SearchFlights/dlgSearchFlights.html',
          controller: 'SearchFlightsCtrl',
          size: 'md',
          backdrop: 'static',
          keyboard: false
        });
      }

      messages = MessageFactory.getMessagesFromStorage();
      messagesCount = messages.length;

      for (var i = 0; i < messages.length; i++) {
        if (messages[i].ReadDt == null) {
          unreadMessagesCount++;
        }
      }

      MemoFactory.getNotHiddenMemos(function (results) {
        scope.memosCount = results.length;
      });
      faqs = FaqFactory.getFAQsFromStorage();

      for (var i = 0; i < faqs.length; i++) {
        if (faqs[i].newItems) {
          newFAQCount += faqs[i].newItems;
        }

        if (faqs[i].updatedItems) {
          updatedFAQCount += faqs[i].updatedItems;
        }
      }

      scope.messagesCount = messagesCount;
      scope.unreadMessagesCount = unreadMessagesCount;
      scope.logout = logout;
      scope.resetDevice = resetDevice;
      scope.deleteAllReports = deleteAllReports;
      scope.gotoMessageLibrary = gotoMessageLibrary;
      scope.gotoMemos = gotoMemos;
      scope.gotoBucketCalendar = gotoBucketCalendar;
      scope.memosCount = memosCount;
      scope.gotoFAQs = gotoFAQs;
      scope.gotoRequests = gotoRequests;
      scope.gotoLeaveRequests = gotoLeaveRequests;
      scope.gotoJumpseatRequests = gotoJumpseatRequests;
      scope.newFAQCount = newFAQCount;
      scope.updatedFAQCount = updatedFAQCount;
      scope.gotoCalendar = gotoCalendar;
      scope.showPopover = false;
      scope.gotoTicket = gotoTicket;
      scope.leaveRequestInformation = LeaveRequestFactory.getLeaveRequestInformation();

      scope.isLeaveWidgetVisible = function (info) {
        if (!info) return false;
        if (info.GroupStatus !== 'OPEN' && info.GroupStatus !== 'PROCESS') return false; //if (info.CloseDate && new Date(info.CloseDate) < new Date()) return false;

        return true;
      };

      scope.openSearchFlightsModal = openSearchFlightsModal;
      scope.gotoMealLibrary = gotoMealLibrary;
      scope.gotoCrewExpiries = gotoCrewExpiries;
      scope.isJumpseatRequestsVisible = isJumpseatRequestsVisible;
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/Main/footer.tpl.html",
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_cabin_reports.directive('memosByCategory', memosByCategory);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name memosByCategory
  * @restrict E
  * @description
  *   Implementation of memosByCategory
  *   Initialize the panels with memos group by category.
  * @example
  *   Usage:
  *   <memos-by-category Type="Flight/F , Ground/G, Duty/D" Id="FlightId, GroundId, DutyNo" Day="DutyDay"></memos-by-category>
  * @ngInject
  */

  function memosByCategory(MemoFactory, MemoImagesFactory, $uibModal, DataCleanerFactory, GroundDutyFactory, FlightFactory) {
    function link($scope, attrs) {
      $scope.togglePanel = togglePanel;
      var Id = $scope.id;
      /**
       * toggle Panel
       * @memberof memosByCategory
       * @param {number} panelId
       */

      function togglePanel(panelId) {
        $('#' + panelId).toggle();
      } //Initialize Memos


      if ($scope.type == "duty" || $scope.type == "d") {
        MemoFactory.getMemosForCrewRoute(Id, $scope.day, function (results) {
          $scope.memos = filterMemos(results);
        });
      } else if ($scope.type == "ground" || $scope.type == "g") {
        MemoFactory.getMemosForGroundDuty(Id, function (results) {
          $scope.memos = filterMemos(results);
        });
      } //(attrs.type == "flight" || attrs.type == "f") default Flight type
      else {
          MemoFactory.getMemosForFlight(Id, function (results) {
            $scope.memos = filterMemos(results);
          });
        }
      /**
       * filter memos
       * @memberof memosByCategory
       * @param {object} data
       */


      function filterMemos(data) {
        //normalize memos
        var distinctMemos = normalizeMemos(data);

        if (distinctMemos.length != data.length) {
          MemoFactory.getMemosFromStorage(function (allMemos) {
            var distinctMemosAll = normalizeMemos(allMemos);
            MemoImagesFactory.getMemoImagesFromStorage(function (allMemoImages) {
              var distinctMemoImagesAll = normalizeMemoImages(allMemoImages);
              recreateIndexedDB(distinctMemosAll, allMemoImages);
            });
          });
        }

        var memosByCategory = [];

        for (var i = 0; i < distinctMemos.length; i++) {
          var memo = distinctMemos[i];

          if (!memosByCategory.filter(function (e) {
            return e.CategoryId != undefined && e.CategoryId == memo.CategoryId || e.Category != undefined && memo.Category == e.Category;
          }).length > 0) {
            memosByCategory.push({
              CategoryId: memo.CategoryId,
              Category: memo.Category,
              memoList: [memo]
            });
          } else if (memosByCategory.filter(function (e) {
            return e.CategoryId != undefined && e.CategoryId == memo.CategoryId || e.Category != undefined && memo.Category == e.Category;
          }).length > 0) {
            memosByCategory.filter(function (object) {
              if (object.CategoryId != undefined && object.CategoryId == memo.CategoryId || object.Category != undefined && memo.Category == object.Category) {
                return object;
              }

              ;
            })[0].memoList.push(memo);
          }
        }

        return memosByCategory;
      }

      function recreateIndexedDB(distinctMemosAll, distinctMemosImagesAll) {
        //delete indexdb
        var q = DataCleanerFactory.deleteIndexedDB();
        q.then(function () {
          MemoFactory.setMemosToStorage(distinctMemosAll);
          MemoImagesFactory.setMemoImagesToStorage(distinctMemosImagesAll); //save normalize data to indexedDB

          LogService.debug("Recreated IndexedDB");
        });
        q["catch"](function (ex) {
          console.log(ex);
        });
      }

      function normalizeMemos(data) {
        var distinctData = [];

        if (data && data.length > 1) {
          var sortData = data.dynamicSort("Id");

          for (var i = 0; i < sortData.length - 1; i++) {
            if (sortData[i + 1].Id == sortData[i].Id) {
              //swap rows in  list - check lastUpdated property, latest at the end
              if (sortData[i].LastUpdated && sortData[i + 1].LastUpdated) {
                var memoDateA = new Date(sortData[i].LastUpdated);
                var memoDateB = new Date(sortData[i + 1].LastUpdated);

                if (memoDateA.getTime() > memoDateB.getTime()) {
                  var temp = sortData[i + 1];
                  sortData[i + 1] = sortData[i];
                  sortData[i] = temp;
                }
              }
            } else {
              distinctData.push(sortData[i]);
            }
          }

          distinctData.push(sortData[sortData.length - 1]);
        } else {
          distinctData = data;
        }

        return distinctData;
      }

      function normalizeMemoImages(data) {
        var distinctData = [];

        if (data && data.length > 1) {
          var sortData = data.dynamicSort("imageId");

          for (var i = 0; i < sortData.length - 1; i++) {
            if (!(sortData[i + 1].imageId == sortData[i].imageId)) {
              distinctData.push(sortData[i]);
            }
          }

          distinctData.push(sortData[sortData.length - 1]);
        } else {
          distinctData = data;
        }

        return distinctData;
      }

      $scope.openMemo = openMemo;
      /**
       * Open modal to see information for the selected Memo
       * @memberof memosByCategory
       * @param {object} memo A memo object
       */

      function openMemo(_memo) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Dialogs/dlgMemo.html',
          controller: 'MemoModalCtrl',
          size: 'lg',
          keyboard: false,
          resolve: {
            memo: function memo() {
              return _memo;
            }
          }
        });
        modalInstance.result.then(function () {
          if (_memo.ReadDt == null) {
            _memo.ReadDt = new Date();
            MemoFactory.saveOneMemoToStorage(_memo);

            if ($scope.type == "ground") {
              MemoFactory.markGroundDutiesUnread();
            }
          }
        });
      }
    }

    return {
      restrict: 'E',
      templateUrl: "views/directives/memosByCategoryPanel.tpl.html",
      scope: {
        type: '@',
        id: '=',
        day: '='
      },
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_cabin_reports.directive('reportsPanel', reportsPanel);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name reportsPanel
  * @restrict E
  * @description
  *   Implementation of reportsPanel
  *   Initialize the panels with reports.
  * @example
  *   Usage:
  *   <reports-panel flight-id="flight.id" assessment-only="false"></reports-panel>
  * @ngInject
  */

  function reportsPanel(SettingsMain, $location, $anchorScroll, enableWaterUpliftReporting, waterUpliftSupportingAcTypes, defaultCalendarDate, UserFactory, CrewRouteFactory, SaFeedbackInfoFactory, SaCrewAssessmentFactory, AircaftPositionsFactory, ASSFSyncInfoFactory, ASSFReportFactory, CrewAssessmentFactory) {
    function link($scope, element, attrs) {
      //Initialize CSS classes
      $scope.togglePanel = togglePanel; //$scope.showCampaignsFeedback = CampaignFactory.hasPendingFeedbacks($scope.flight.FlightId);

      $scope.goToCampaignsPanel = function () {
        $location.hash('campaigns');
        $anchorScroll();
      };

      $scope.openFaAssessment = openFaAssessment;
      $scope.faFeedbacks = {
        show: false,
        status: 'Pending',
        bottomClass: '',
        textClass: 'text-gray'
      };
      $scope.openSaAssessment = openSaAssessment;
      $scope.saFeedbacks = {
        show: false,
        status: 'Pending',
        bottomClass: '',
        textClass: 'text-gray'
      };
      $scope.openASSFReport = openASSFReport;
      $scope.assfReport = {
        flightId: null,
        show: false,
        status: 'Pending',
        isRequired: false,
        bottomClass: '',
        textClass: ''
      };
      var RuleType = {
        PreviousFlightArrivedFrom: 0,
        FlightDepartsFrom: 1,
        FlightArrivesTo: 2
      };
      var RuleRegionCountry = {
        EU: 0,
        Schengen: 1,
        Countries: 2
      };
      var user = UserFactory.getUser();

      if (attrs.crewRoutePage != "true") {
        $scope.showReports = true;
        $scope.getBottomClass = getBottomClass;
        $scope.getTextClass = getTextClass;
        $scope.getTopClass = getTopClass;
        $scope.hasIcon = hasIcon;
        $scope.isWaterUpliftRequired = isWaterUpliftRequired;
      } else {
        $scope.showReports = false;
      } //FA Feedbacks


      var showFaAssessment = false;

      if (attrs.crewRoutePage != "true" && isAssessmentEnabled && $scope.flight.assessment) {
        showFaAssessment = true;
      }

      var isAssessmentEnabled = SettingsMain.getIsAssessmentEnabled();

      if (attrs.crewRoutePage != "true" && user.position == 'SA' && isAssessmentEnabled && $scope.flight.assessment) {
        var faMembersAimsIdsFromRoute = CrewRouteFactory.getFACrewMembersFromRoute($scope.flight.DutyNo, $scope.flight.DutyDay, $scope.flight.FlightDate);
        var crewAssessmentInLS = CrewAssessmentFactory.getCrewAssessmentByRouteAndDay($scope.flight.Route, $scope.flight.DutyDay, $scope.flight.FlightDate);
        var faMembersNeedFeedback = CrewAssessmentFactory.getFaMembersForFeedback(faMembersAimsIdsFromRoute, crewAssessmentInLS);
        $scope.faFeedbacks.show = true;

        if (faMembersNeedFeedback && faMembersNeedFeedback.length > 0) {
          var isSynced = CrewAssessmentFactory.hasSyncedFeedbacks($scope.flight.Route, $scope.flight.DutyDay, $scope.flight.FlightDate); //Update status:

          if (isSynced) {
            $scope.faFeedbacks.status = "Synched";
          } else if (crewAssessmentInLS) {
            $scope.faFeedbacks.status = crewAssessmentInLS.Status;
          } else {
            $scope.faFeedbacks.status = "Pending";
          } //Update classes:


          if ($scope.flight.assessment && $scope.flight.assessment.IsExist || $scope.faFeedbacks.status == "Stored" || $scope.faFeedbacks.status == "Synched" || $scope.faFeedbacks.status == "Outdated") {
            $scope.faFeedbacks.textClass = "text-green";
          } else if ($scope.faFeedbacks.status == "Pending") {
            $scope.faFeedbacks.textClass = "text-blue";
          } else if ($scope.faFeedbacks.status == "Draft") {
            $scope.faFeedbacks.textClass = "text-orange";
          } else if ($scope.faFeedbacks.status == "Completed") {
            $scope.faFeedbacks.textClass = "text-purple";
          }
        }
      } //SA Feedbacks


      function hasMoreThanOneYearEmployment(hireDate) {
        if (!hireDate) return true;
        var today = new Date();
        var hireDate = new Date(hireDate); // Set "one year ago from today"

        var oneYearAgo = new Date();
        oneYearAgo.setFullYear(today.getFullYear() - 1); // Return true if hired before or on one year ago

        return hireDate <= oneYearAgo;
      }

      if (attrs.crewRoutePage != "true" && user.position == 'FA' && hasMoreThanOneYearEmployment(user.hireDate)) {
        var saMembersAimsIdsFromRoute = CrewRouteFactory.getSACrewMembersFromRoute($scope.flight.DutyNo, $scope.flight.DutyDay, $scope.flight.FlightDate); //TODO:: find the crew route by day 

        var saMembersNeedFeedback = SaFeedbackInfoFactory.getSaMembersForFeedback(saMembersAimsIdsFromRoute);

        if ($scope.flight.saAssessment && saMembersNeedFeedback && saMembersNeedFeedback.length > 0) {
          $scope.saFeedbacks.show = true;

          var _isSynced = SaFeedbackInfoFactory.hasSyncedFeedbacks($scope.flight.DutyNo, $scope.flight.DutyDay, $scope.flight.FlightDate);

          var feedbackInLS = SaCrewAssessmentFactory.getCrewAssessmentByDutyNoAndDay($scope.flight.DutyNo, $scope.flight.DutyDay, $scope.flight.FlightDate); //Update status:

          if (_isSynced) {
            $scope.saFeedbacks.status = "Synched";
          } else if (feedbackInLS) {
            $scope.saFeedbacks.status = feedbackInLS.Status;
          } else {
            $scope.saFeedbacks.status = "Pending";
          } //Update classes:


          if ($scope.saFeedbacks.status == "Stored" || $scope.saFeedbacks.status == "Synched") {
            $scope.saFeedbacks.textClass = "text-green";
          } else if ($scope.saFeedbacks.status == "Pending") {
            $scope.saFeedbacks.textClass = "text-blue";
          } else if ($scope.saFeedbacks.status == "Draft") {
            $scope.saFeedbacks.textClass = "text-orange";
          } else if ($scope.saFeedbacks.status == "Completed") {
            $scope.saFeedbacks.textClass = "text-purple";
          }
        }
      } //ASSF reports


      if (user.position == 'SA') {
        var assfInfo = ASSFSyncInfoFactory.getASSFInfo(); //from Flight Info page:  $scope.flight.FlightId
        //from Route  Info page:  $scope.firstFlightId

        var flightId = null;

        if ($scope.flight) {
          flightId = $scope.flight.FlightId;
        } else {
          flightId = $scope.firstFlightId;
        }

        $scope.assfReport.flightId = flightId; //Check if ASSF report is required

        if (assfInfo && assfInfo.ActiveVersion) {
          $scope.assfReport.show = true; //Check for assf synced
          //Get status from assf reports in LS if exists there

          var isASSFReportSynced = assfInfo.SyncedFlightIds.includes(flightId);
          var assfReportInLS = ASSFReportFactory.getAssfReportFromStorage(flightId); //Update status:

          if (isASSFReportSynced) {
            $scope.assfReport.status = "Synched";

            if (assfReportInLS) {
              $scope.assfReport.isRequired = assfReportInLS.notApplicable == false ? assfReportInLS.isRequired : false;
            } else {
              $scope.assfReport.isRequired = false;
            }
          } else if (assfReportInLS) {
            $scope.assfReport.status = assfReportInLS.status;
            $scope.assfReport.isRequired = assfReportInLS.notApplicable == false ? assfReportInLS.isRequired : false;
          } else {
            $scope.assfReport.status = "Pending";
            $scope.assfReport.isRequired = false;

            if (assfInfo.ApplicabilityRules) {
              $scope.assfReport.isRequired = checkASSFReportIsRequired($scope.flight, assfInfo.ApplicabilityRules);
            }
          } //Update classes:


          if ($scope.assfReport.isRequired == false) {
            $scope.assfReport.textClass = "text-gray";
          } else if ($scope.assfReport.status == "Stored" || $scope.assfReport.status == "Synched") {
            $scope.assfReport.textClass = "text-green";
          } else if ($scope.assfReport.status == "Pending") {
            $scope.assfReport.textClass = "text-blue";
          } else if ($scope.assfReport.status == "Draft") {
            $scope.assfReport.textClass = "text-orange";
          } else if ($scope.assfReport.status == "Completed") {
            $scope.assfReport.textClass = "text-purple";
          }
        }
      }

      function openFaAssessment() {
        SettingsMain.setEditingPage(null);

        if ($scope.flight) {
          $location.path("assessment/" + $scope.flight.FlightId);
        } else {
          $location.path("assessment/" + $scope.firstFlightId);
        }
      }

      function openSaAssessment() {
        SettingsMain.setEditingPage(null);

        if ($scope.flight) {
          $location.path("saAssessment/" + $scope.flight.FlightId);
        } else {
          $location.path("saAssessment/" + $scope.firstFlightId);
        }
      }

      function openASSFReport() {
        if ($scope.assfReport.status !== "Stored" && $scope.assfReport.status !== "Synched") {
          SettingsMain.setEditingPage(null);

          if ($scope.flight) {
            $location.path("assfReport/" + $scope.flight.FlightId);
          } else {
            $location.path("assfReport/" + $scope.firstFlightId);
          }
        }
      } //check if ASSF report is required


      function checkASSFReportIsRequired(flight, applicabilityRules) {
        var returnValue = false;

        if (!flight || !applicabilityRules) {
          return false;
        }

        var loggedCrewMember = flight.crew.find(function (c) {
          return c.aimsId == $scope.user.aimsId;
        });

        if (!loggedCrewMember || loggedCrewMember.isDHC) {
          return false;
        }

        var hasPreviousFlightArrivedFrom = applicabilityRules.some(function (rule) {
          return rule.Type === RuleType.PreviousFlightArrivedFrom;
        });

        if (hasPreviousFlightArrivedFrom) {
          //then we need the previous flight info:
          flight.aircraftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId(flight.FlightId);
        }

        returnValue = applicabilityRules.some(function (rule) {
          // Extract country codes from ASSFApplicabilityRuleCountries
          //const countryCodes = rule.ASSFApplicabilityRuleCountries?.map(c => c.Code) || [];
          var countryCodes = rule.ASSFApplicabilityRuleCountries && Array.isArray(rule.ASSFApplicabilityRuleCountries) ? rule.ASSFApplicabilityRuleCountries.map(function (c) {
            return c.Code;
          }) : [];

          switch (rule.Type) {
            case RuleType.PreviousFlightArrivedFrom:
              return flight.aircraftPositions && (rule.RegionCountry === RuleRegionCountry.EU && rule.IsEU === flight.aircraftPositions.PreviousEU || rule.RegionCountry === RuleRegionCountry.Schengen && rule.IsSchengen === flight.aircraftPositions.PreviousSchengen || rule.RegionCountry === RuleRegionCountry.Countries && countryCodes.includes(flight.aircraftPositions.PreviousCountryISO));

            case RuleType.FlightDepartsFrom:
              return rule.RegionCountry === RuleRegionCountry.EU && rule.IsEU === flight.DepartureEU || rule.RegionCountry === RuleRegionCountry.Schengen && rule.IsSchengen === flight.DepartureSchengen || rule.RegionCountry === RuleRegionCountry.Countries && countryCodes.includes(flight.DepartureCountryISO);

            case RuleType.FlightArrivesTo:
              return rule.RegionCountry === RuleRegionCountry.EU && rule.IsEU === flight.ArrivalEU || rule.RegionCountry === RuleRegionCountry.Schengen && rule.IsSchengen === flight.ArrivalSchengen || rule.RegionCountry === RuleRegionCountry.Countries && countryCodes.includes(flight.ArrivalCountryISO);

            default:
              return false;
          }
        }); //update status in flight

        $scope.assfReport.isRequired = returnValue;

        if ($scope.flight.assfReport == undefined || $scope.flight.assfReport == null || $scope.flight.assfReport.isRequired == undefined || $scope.flight.assfReport.isRequired == null || $scope.flight.assfReport.isRequired !== returnValue) {
          ASSFReportFactory.updateFlightAssfStatus($scope.assfReport);
        }

        return returnValue;
      }

      function isWaterUpliftRequired() {
        var today = new Date($scope.flight.FlightDate);
        return (today.getDate() == 1 || today.getDate() == 15) && enableWaterUpliftReporting && waterUpliftSupportingAcTypes.includes($scope.flight.AcType);
      }
      /**
       * toggle Panel
       * @memberof reportsPanel
       * @param {number} panelId
       */


      function togglePanel(panelId) {
        $('#' + panelId).toggle();
      }
      /**
       * Return the text ccs class accoriding to report status
       * @memberof FlightInfoCtrl
       * @returns {string} cssClass
       */


      function getTextClass() {
        var classname = "";
        if ($scope.flight.LineStatus === 'na') classname = "text-gray";else if ($scope.flight.LineStatus === 'pending') classname = "text-blue";else if ($scope.flight.LineStatus === 'pendingoverdue') classname = "text-blue";else if ($scope.flight.LineStatus === 'draft' || $scope.flight.LineStatus === 'draftotheruser') {
          classname = "text-orange";
        } else if ($scope.flight.LineStatus === 'completed' || $scope.flight.LineStatus === 'completedotheruser') {
          classname = "text-purple";
        } else if ($scope.flight.LineStatus === 'stored' || $scope.flight.LineStatus === 'storedotheruser' || $scope.flight.LineStatus === 'stored+otheruser' || $scope.flight.LineStatus === 'synched' || $scope.flight.LineStatus === 'synchedotheruser') {
          classname = "text-green";
        }
        return classname;
      }
      /**
       * Return the panel upper ccs class accoriding to report status
       * @memberof FlightInfoCtrl
       * @returns {string} cssClass
       */


      function getTopClass() {
        var classname = "";
        if ($scope.flight.LineStatus === 'na') classname = "border-top-gray";else if ($scope.flight.LineStatus === 'pending') classname = "border-top-blue";else if ($scope.flight.LineStatus === 'pendingoverdue') classname = "border-top-blue";else if ($scope.flight.LineStatus === 'draft' || $scope.flight.LineStatus === 'draftotheruser') {
          classname = "border-top-orange";
        } else if ($scope.flight.LineStatus === 'completed' || $scope.flight.LineStatus === 'completedotheruser') {
          classname = "border-top-purple";
        } else if ($scope.flight.LineStatus === 'stored' || $scope.flight.LineStatus === 'storedotheruser' || $scope.flight.LineStatus === 'stored+otheruser' || $scope.flight.LineStatus === 'synched' || $scope.flight.LineStatus === 'synchedotheruser') {
          classname = "border-top-green";
        }
        return classname;
      }
      /**
       * Return the panel border ccs class accoriding to report status
       * @memberof FlightInfoCtrl
       * @returns {string} cssClass
       */


      function getBottomClass() {
        var classname = "";
        if ($scope.flight.LineStatus === 'na') classname = "border-bottom-gray";else if ($scope.flight.LineStatus === 'pending') classname = "border-bottom-blue";else if ($scope.flight.LineStatus === 'pendingoverdue') classname = "border-bottom-blue";else if ($scope.flight.LineStatus === 'draft' || $scope.flight.LineStatus === 'draftotheruser') {
          classname = "border-bottom-orange";
        } else if ($scope.flight.LineStatus === 'completed' || $scope.flight.LineStatus === 'completedotheruser') {
          classname = "border-bottom-purple";
        } else if ($scope.flight.LineStatus === 'stored' || $scope.flight.LineStatus === 'storedotheruser' || $scope.flight.LineStatus === 'stored+otheruser' || $scope.flight.LineStatus === 'synched' || $scope.flight.LineStatus === 'synchedotheruser') {
          classname = "border-bottom-green";
        }
        return classname;
      }
      /**
       * If report from another user exists, show icon
       * @memberof FlightInfoCtrl
       * @returns {boolean} hasIcon
       */


      function hasIcon() {
        var hasIcon = false;

        if ($scope.flight.LineStatus === 'draftotheruser' || $scope.flight.LineStatus === 'completedotheruser' || $scope.flight.LineStatus === 'storedotheruser' || $scope.flight.LineStatus === 'stored+otheruser' || $scope.flight.LineStatus === 'synchedotheruser') {
          hasIcon = true;
        }

        return hasIcon;
      }
    }

    return {
      restrict: 'E',
      templateUrl: "views/directives/reportsPanel.tpl.html",
      scope: true,
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_cabin_reports.directive('securitySearch', securitySearch);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name securitySearch
  * @restrict E
  * @description
  *   Implementation of securitySearch
  *   Initialize the panel with previous flight info.
  * @example
  *   Usage:
  *   <security-search id="FlightId"></security-search>
  * @ngInject
  */

  function securitySearch(AircaftPositionsFactory, FlightFactory) {
    function link($scope) {
      var showSecurityMsg = false;
      var securitySearchRequired = null;
      var DepartureUK = null;
      var DepartureEU = null;
      var DepartureCDG = null;
      var PreviousEU = null;
      var aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId($scope.id);
      var flightInfo = FlightFactory.getFlightFromStorage($scope.id);

      if (flightInfo) {
        DepartureUK = flightInfo.DepartureCountry == "UNITED KINGDOM";
        DepartureEU = flightInfo.DepartureEU;
        DepartureCDG = flightInfo.Departure == "CDG"; // RULE 1: Current Departure Airport is UK
        // RULE 2: Current Departure Airport is Non EU
        // RULE 3: Current Departure Airport is CDG Airport

        if (DepartureUK || !DepartureEU || DepartureCDG) {
          securitySearchRequired = true;
        } else {
          securitySearchRequired = false;
        }
      }

      if (aircaftPositions) {
        // RULE 4: Previous Origin Airport is Non EU
        PreviousEU = aircaftPositions.PreviousEU;

        if (!PreviousEU) {
          securitySearchRequired = true;
        } else {
          securitySearchRequired = false;
        }
      }

      if (securitySearchRequired != null) {
        showSecurityMsg = true;
      }

      $scope.showSecurityMsg = showSecurityMsg;
      $scope.securitySearchRequired = securitySearchRequired;
      $scope.aircaftPositions = aircaftPositions;
    }

    return {
      restrict: 'E',
      templateUrl: "views/directives/securitySearch.tpl.html",
      scope: {
        id: '='
      },
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('showerrormessage', showerrormessage);
  /**
  * @ngdoc directive
  * @name showerrormessage
  * @restrict EA
  * @description
  *   Implementation of show error message
  * @attr {String} message: the error message.
  * @example
  *   Usage:
  *   <showerrormessage message="No internet access.."></showerrormessage>
  * @ngInject
  */

  function showerrormessage() {
    function link($scope, element, attrs) {
      $scope.errorMessage = attrs.message;
      $scope.hasMessage = attrs.message != null && attrs.message.length > 0;
    }

    return {
      restrict: 'E',
      template: '<div class="bs-callout border-left-red col-xs-offset-1" ng-if="hasMessage">  <i class="fa fa-warning"></i> {{errorMessage}} </div>',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('ssr', ssr);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name ssr
  * @restrict EA
  * @description
  *   Implementation of issues
  *
  *   Initialize the special service template
  * @attr {String} format The name of the format to initialize the ssr.
  * @example
  *   Usage:
  *   <div ssr format="compact"></div>
  * @ngInject
  */

  function ssr($sce, ssrCodes, waterUpliftSupportingAcTypes) {
    return {
      restrict: 'EA',
      terminal: true,
      templateUrl: 'views/directives/ssr.tpl.html',
      scope: {
        paxInfo: '=',
        flight: '='
      },
      link: function link($scope, element, attrs) {
        $scope.format = attrs.format;
        $scope.VIP = detailedInfo('VIP');
        $scope.UPGD = detailedInfo('UPGD'); // Platinum is a new tier, so calculate its summary defensively without changing existing tiers.

        $scope.FQTVPlatinumSummary = getTierSummary('Platinum');
        $scope.FQTVPlatinum = detailedTierInfo('Platinum');
        $scope.FQTVGold = detailedInfo('FQTVGold');
        $scope.FQTVSilver = detailedInfo('FQTVSilver');
        $scope.UMNR = detailedInfo('UMNR');
        $scope.PRM = detailedInfo('WCBD,WCBW,WCHC,WCHR,WCHS,WCLB,WCMP,WCOB');
        $scope.DEAF = detailedInfo('DEAF');
        $scope.BLND = detailedInfo('BLND');
        $scope.DPNA = detailedInfo('DPNA');
        $scope.DEP = detailedInfo('DEPA,DEPU,ESCD');
        $scope.INAD = detailedInfo('INAD');
        $scope.MEDA = detailedInfo('AOXY,MEDA,MEQT,POXY');
        $scope.CBBG = detailedInfo('CBBG');
        $scope.OTH = detailedInfo('AVIH,BIKE,EMIG,ESAN,EXST,FAMS,GPST,HAJJ,PETC,SVAN,WEAP,XBGS,MAAS');
        $scope.UndeliveredChargeableSeats = detailedInfo('UndeliveredChargeableSeats');
        $scope.showFQTVPlatinum = false;
        $scope.showFQTVGold = false;
        $scope.showFQTVSilver = false;
        $scope.showUMNR = false;
        $scope.showPRM = false;
        $scope.showDEAF = false;
        $scope.showBLND = false;
        $scope.showDPNA = false;
        $scope.showDEP = false;
        $scope.showINAD = false;
        $scope.showMEDA = false;
        $scope.showCBBG = false;
        $scope.showOTH = false;
        $scope.showIrregularites = false;
        $scope.showVIP = false;
        $scope.hasZones = hasZones;
        $scope.zoneC = getZone('C');
        $scope.zoneY = getZone('Y');
        $scope.waterQuantity = getWaterQuantity();
        $scope.supportsWaterUpliftAcType = supportsWaterUpliftAcType();
        $scope.UMNRDetails = umnrInfo('UMNR');

        function umnrInfo(umnr) {
          if ($scope.paxInfo) {
            $scope.totalUMNR = [];
            $scope.paxInfo.Seatmap.forEach(function (row) {
              row.Columns.forEach(function (column) {
                if (column.SSR.IsUMNR) $scope.totalUMNR.push(column);
              });
            });
          }
        }

        function supportsWaterUpliftAcType() {
          return waterUpliftSupportingAcTypes.includes($scope.flight.AcType);
        }

        function getWaterQuantity() {
          var totalPax = $scope.flight.BookedC + $scope.flight.BookedY;
          var startDate = moment($scope.flight.ScheduledDeparture);
          var endDate = moment($scope.flight.ScheduledArrival);
          var duration = moment.duration(endDate.diff(startDate)).asHours();
          var waterQuantity = (0, 18 * totalPax * duration) / 200;
          var formattedwaterQuantity = waterQuantity.toString().substring(0, 4);
          return formattedwaterQuantity;
        }

        function hasZones() {
          var retVal = false;
          if ($scope.flight && $scope.flight.Zones && $scope.flight.Zones.length > 0) retVal = true;
          return retVal;
        }

        function getZone(classService) {
          var retVal = '';
          var zone;

          if ($scope.flight && $scope.flight.Zones) {
            // zone = $scope.flight.Zones.find(function (item) {
            //     return item.Class == classService || item.Class == '';
            // });
            for (var i = 0; i < $scope.flight.Zones.length; i++) {
              if ($scope.flight.Zones[i].Class == classService || $scope.flight.Zones[i].Class == '') {
                zone = $scope.flight.Zones[i];
                break;
              }
            }
          }

          if (zone) retVal = zone.Title;
          return retVal;
        }

        function getTierSummary(tierName) {
          var emptySummary = {
            C: 0,
            Y: 0,
            Total: 0
          };

          if (!$scope.paxInfo || tierName != 'Platinum') {
            return emptySummary;
          }

          var summaryC = $scope.paxInfo.PassengerSummaryC && $scope.paxInfo.PassengerSummaryC.FQTVPlatinum;
          var summaryY = $scope.paxInfo.PassengerSummaryY && $scope.paxInfo.PassengerSummaryY.FQTVPlatinum;

          if (typeof summaryC === 'number' && typeof summaryY === 'number') {
            return {
              C: summaryC,
              Y: summaryY,
              Total: summaryC + summaryY
            };
          }

          if (!$scope.paxInfo.Seatmap) {
            return emptySummary;
          }

          var result = {
            C: 0,
            Y: 0,
            Total: 0
          };
          $scope.paxInfo.Seatmap.forEach(function (row) {
            row.Columns.forEach(function (column) {
              if (!column.IsEmptySeat && column.SeatMode == 'Seat' && column.Fqtv && column.Fqtv.TierLevel == 'PLTM') {
                if (column.Cabin == 'C') {
                  result.C++;
                } else {
                  result.Y++;
                }
              }
            });
          });
          result.Total = result.C + result.Y;
          return result;
        }

        function detailedTierInfo(tierName) {
          var tierSummary = getTierSummary(tierName);
          var htmlPopover = '';

          if (tierSummary.Total > 0) {
            htmlPopover = '<div class="row"> <strong class="col-xs-3 col-md-2 col-xs-offset-1 col-md-offset-4">C ' + tierSummary.C + '</strong>';
            htmlPopover = htmlPopover + ' <strong class="col-xs-3 col-md-2">Y ' + tierSummary.Y + '</strong>';
            htmlPopover = htmlPopover + '</div>';
          }

          return $sce.trustAsHtml(htmlPopover);
        }

        function detailedInfo(properties) {
          var propertiesArray = properties.split(',');
          var htmlPopover = '';

          if ($scope.paxInfo && $scope.paxInfo.PassengerSummaryC && $scope.paxInfo.PassengerSummaryY) {
            if (propertiesArray.length > 1) {
              htmlPopover = '<div class="row"><div class="col-sm-offset-9  col-xs-offset-8 col-xs-1"><strong>C</strong></div><div class=" col-xs-1"><strong>Y</strong></div><div class=" col-xs-1"><strong>Total</strong></div> </div>';
              angular.forEach(propertiesArray, function (property) {
                var Total = $scope.paxInfo.PassengerSummaryC['Total' + property] + $scope.paxInfo.PassengerSummaryY['Total' + property];

                if (Total > 0) {
                  var code = '';

                  for (var i = 0; i < ssrCodes.length; i++) {
                    if (ssrCodes[i].code == property) {
                      code = ssrCodes[i].description;
                    }
                  }

                  htmlPopover = htmlPopover + '<div class="row"> <strong class="col-xs-2">' + property + "</strong>";
                  htmlPopover = htmlPopover + '<span class="col-sm-7 col-xs-6 text-medium">' + code + "</span>";
                  htmlPopover = htmlPopover + '<div class="col-xs-1">' + $scope.paxInfo.PassengerSummaryC[property] + "</div>";
                  htmlPopover = htmlPopover + '<div class="col-xs-1">' + $scope.paxInfo.PassengerSummaryY[property] + "</div>";
                  htmlPopover = htmlPopover + '<div class="col-xs-1">' + Total + "</div></div>";
                }
              });
            } else {
              angular.forEach(propertiesArray, function (property) {
                var Total = $scope.paxInfo.PassengerSummaryC['Total' + property] + $scope.paxInfo.PassengerSummaryY['Total' + property];
                htmlPopover = '<div class="row"> <strong class="col-xs-3 col-md-2 col-xs-offset-1 col-md-offset-4">C ' + $scope.paxInfo.PassengerSummaryC[property] + '</strong>';
                htmlPopover = htmlPopover + ' <strong class="col-xs-3 col-md-2">Y ' + $scope.paxInfo.PassengerSummaryY[property] + '</strong>';

                if (Total) {
                  htmlPopover = htmlPopover + ' <strong class="col-xs-4 col-md-3"> Total ' + Total + '</strong>';
                }

                htmlPopover = htmlPopover + '</div>';
              });
            }
          }

          return $sce.trustAsHtml(htmlPopover);
        }
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('updateConfirm', updateConfirm);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name updateConfirm
  * @restrict E
  * @description
  *   Implementation of aircraft differences
  *
  *   Display the confirm textto update service workers version
  * @example
  *   Usage:
  *   <update-confirm></update-confirm>
  * @ngInject
  */

  function updateConfirm(SWUpdateService) {
    function link($scope, element, attributes) {
      //if serviceWorker registered
      if ($scope.SWRegistration != null) {
        $scope.needUpdate = null;
        $scope.update = update; //get waiting service worker if exists

        $scope.needUpdate = $scope.SWRegistration.waiting; //if waiting service woker exists check how long its been waiting

        if ($scope.needUpdate != null) {
          SWUpdateService.checkVersionExpiration($scope.SWRegistration);
        }
      }

      function update() {
        SWUpdateService.update($scope.SWRegistration);
      }
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/directives/updateConfirm.tpl.html',
      scope: true,
      link: link
    };
  }
})();
"use strict";

// array functions
Array.prototype.dynamicSort = function (property, orderByAsc) {
  function dynamicSortComparator(property, orderByAsc) {
    var sortOrder = orderByAsc ? 1 : -1;
    return function (a, b) {
      var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  var sortedArray = this;

  if (property != null && property != undefined) {
    orderByAsc = orderByAsc == null || orderByAsc == undefined ? true : orderByAsc;
    sortedArray = this.sort(dynamicSortComparator(property, orderByAsc));
  }

  return sortedArray;
};

Array.prototype.unique = function () {
  var arr = [];

  for (var i = 0; i < this.length; i++) {
    if (!arr.contains(this[i])) {
      arr.push(this[i]);
    }
  }

  return arr;
};

Array.prototype.contains = function (v) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] === v) return true;
  }

  return false;
};

Array.prototype.groupByKey = function (key) {
  return this.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};
"use strict";

// date functions
Date.prototype.toUTC = function () {
  return new Date(this.getTime() + this.getTimezoneOffset() * 60 * 1000);
};

Date.prototype.fromUTC = function () {
  return new Date(this.getTime() - this.getTimezoneOffset() * 60 * 1000);
};

Date.prototype.trimTime = function () {
  this.setHours(0, 0, 0, 0);
  return this;
};

var _DatetoJSON = Date.prototype.toJSON;

Date.prototype.toJSON = function () {
  try {
    return _DatetoJSON.call(this);
  } catch (e) {
    if (e instanceof RangeError) {
      return null;
    }

    throw e;
  }
};

Date.DifferenceInMinutes = function (firstDate, secondDate) {
  var diffInMins = null;

  if (firstDate && secondDate) {
    var _MS_TO_MINUTES = 1000 * 60;

    var date1 = new Date(firstDate);
    var date2 = new Date(secondDate);
    diffInMins = Math.floor((date2.getTime() - date1.getTime()) / _MS_TO_MINUTES);
  }

  return diffInMins;
};

Date.DifferenceInDays = function (firstDate, secondDate) {
  var diffInDays = null;

  if (firstDate && secondDate) {
    var _MS_TO_DAYS = 1000 * 3600 * 24;

    diffInDays = Math.floor((secondDate.getTime() - firstDate.getTime()) / _MS_TO_DAYS);
  }

  return diffInDays;
};

Date.MinutesToString = function (minutes) {
  var hours = Math.floor(minutes / 60);
  var mins = minutes % 60;
  return (hours > 0 ? hours + (hours == 1 ? "hr " : "hrs ") : "") + (mins > 0 ? mins + (mins == 1 ? "min" : "mins") : "");
};

Date.prototype.AddDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

Date.MinutesToStringSimple = function (minutes) {
  var hours = Math.floor(minutes / 60);
  var mins = minutes % 60;
  return (hours != 0 ? hours + ":" : "00" + ":") + (mins > 9 ? mins : "0" + mins);
};
"use strict";

// generic string functions
String.prototype.endsWith = function (suffix) {
  return this.indexOf(suffix, this.length - suffix.length) !== -1;
};

if (typeof String.prototype.startsWith != 'function') {
  // see below for better implementation!
  String.prototype.startsWith = function (str) {
    return this.indexOf(str) == 0;
  };
}

String.prototype.reverse = function () {
  return this.split("").reverse().join("");
};

String.prototype.getHash = function () {
  var shaObj = new jsSHA("SHA-512", "TEXT");
  shaObj.update(this);
  var hash = shaObj.getHash("HEX");
  return hash;
};

String.prototype.elipsis = function (charNo) {
  return this.length > charNo ? this.substring(0, charNo) + "..." : this;
};
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('FaqFactory', FaqFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name FaqFactory
  * @description 
  *   Add, Update, Delete and Get FAQ.
  * @ngInject
  */

  function FaqFactory(GenericService) {
    /**
    * Initialize the FAQ
    * @memberof FaqFactory
    */
    function FAQ() {
      this.Id = null;
      this.FAQCategory = null;
      this.FAQSubcategory = null;
      this.Question = null;
      this.Answer = null;
      this.IsNew = null; //if FAQ is brand new

      this.WasUpdated = null; //if FAQ was updated
    }

    var objType = 'FAQItem';
    var objCallback = FAQ;
    var service = {
      getFAQsFromStorage: getFAQsFromStorage,
      setFAQsToStorage: setFAQsToStorage,
      setFAQsFromServer: setFAQsFromServer
    };
    /**
     * Get FAQs
     * @memberof FaqFactory
     * @returns {Array} faqs 
     */

    function getFAQsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Set FAQs
     * @memberof FaqFactory
     * @param {array} FAQItem 
     */


    function setFAQsToStorage(FAQItem) {
      GenericService.saveAll(FAQItem, objType, objCallback);
    }
    /**
     * Delete FAQs
     * @memberof FaqFactory
     */


    function clearFAQsFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }
    /**
     * Set FAQs from api data
     * @memberof FaqFactory
     * @param {array} FAQItem 
     */


    function setFAQsFromServer(newFAQs) {
      var oldFAQs = getFAQsFromStorage();

      if (oldFAQs.length > 0) {
        var newPairList = [];
        var oldPairList = []; //make a list with all new FAQ Question-Answer pair

        for (var i = 0; i < newFAQs.length; i++) {
          for (var j = 0; j < newFAQs[i].Subcategories.length; j++) {
            for (var k = 0; k < newFAQs[i].Subcategories[j].Pairs.length; k++) {
              newPairList.push(newFAQs[i].Subcategories[j].Pairs[k]);
            }

            ;
          }

          ;
        }

        ; //make a list with all old FAQ Question-Answer pair

        for (var i = 0; i < oldFAQs.length; i++) {
          for (var j = 0; j < oldFAQs[i].Subcategories.length; j++) {
            for (var k = 0; k < oldFAQs[i].Subcategories[j].Pairs.length; k++) {
              oldPairList.push(oldFAQs[i].Subcategories[j].Pairs[k]);
            }

            ;
          }

          ;
        }

        ; //iterate both lists and check if there are new or updated items

        for (var i = 0; i < newPairList.length; i++) {
          var exists = false;

          for (var j = 0; j < oldPairList.length; j++) {
            if (newPairList[i].Id == oldPairList[j].Id && newPairList[i].LastUpdated != oldPairList[j].LastUpdated) {
              newPairList[i].WasUpdated = true;
              exists = true;
              break;
            }

            if (newPairList[i].Id == oldPairList[j].Id) {
              exists = true;
              break;
            }
          }

          if (!exists) {
            newPairList[i].IsNew = true;
          }
        } //enter updated list to FAQ Object


        for (var i = 0; i < newFAQs.length; i++) {
          newFAQs[i].updatedItems = 0;
          newFAQs[i].newItems = 0;

          for (var j = 0; j < newFAQs[i].Subcategories.length; j++) {
            for (var k = 0; k < newFAQs[i].Subcategories[j].Pairs.length; k++) {
              for (var l = 0; l < newPairList.length; l++) {
                if (newFAQs[i].Subcategories[j].Pairs[k].Id == newPairList[l].Id) {
                  newFAQs[i].Subcategories[j].Pairs[k] = newPairList[l];

                  if (newPairList[l].IsNew) {
                    newFAQs[i].newItems++;
                  }

                  if (newPairList[l].WasUpdated) {
                    newFAQs[i].updatedItems++;
                  }

                  break;
                }
              }

              ;
            }

            ;
          }

          ;
        }

        ;
        setFAQsToStorage(newFAQs);
      } else {
        setFAQsToStorage(newFAQs);
      }
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('FaqsCtrl', FaqsCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name FaqsCtrl
  * @description 
  *   Shows Faqs
  * @ngInject
  */

  function FaqsCtrl($scope, FaqFactory, $uibModal, $route) {
    var FAQs = FaqFactory.getFAQsFromStorage();
    $scope.state = 'faqs';
    $scope.newFAQCount = 0;
    $scope.updatedFAQCount = 0;
    $scope.openAnswer = openAnswer;
    $scope.FAQItems = FAQs;
    $scope.updateFAQs = updateFAQs;
    $scope.searchText = '';
    $scope.btnFilter = '';

    for (var i = 0; i < FAQs.length; i++) {
      if (FAQs[i].newItems) {
        $scope.newFAQCount += FAQs[i].newItems;
      }

      if (FAQs[i].updatedItems) {
        $scope.updatedFAQCount += FAQs[i].updatedItems;
      }
    }
    /**
    * Open selected FAQ
    * @memberof FaqsCtrl 
    * @param {object} pair The FAQ
    */


    function openAnswer(_pair) {
      var modalInstance = $uibModal.open({
        templateUrl: './views/Dialogs/dlgOpenAnswer.html',
        controller: 'FaqsModalCtrl',
        size: 'lg',
        resolve: {
          pair: function pair() {
            return _pair;
          }
        }
      });
      modalInstance.result.then(function () {
        //FAQ is no longer New or Updated
        if (_pair.IsNew || _pair.WasUpdated) {
          for (var i = 0; i < FAQs.length; i++) {
            for (var j = 0; j < FAQs[i].Subcategories.length; j++) {
              for (var k = 0; k < FAQs[i].Subcategories[j].Pairs.length; k++) {
                if (FAQs[i].Subcategories[j].Pairs[k].Id == _pair.Id) {
                  if (FAQs[i].Subcategories[j].Pairs[k].IsNew) {
                    FAQs[i].Subcategories[j].Pairs[k].IsNew = false;
                    FAQs[i].newItems--;
                  }

                  if (FAQs[i].Subcategories[j].Pairs[k].WasUpdated) {
                    FAQs[i].Subcategories[j].Pairs[k].WasUpdated = false;
                    FAQs[i].updatedItems--;
                  }
                }
              }
            }
          }

          FaqFactory.setFAQsToStorage(FAQs);
          $route.reload();
        }
      }, function () {});
    }
    /**
     * Filter FAQs
     * @memberof FaqsCtrl 
     * @param {string} searchText The search text
     * @param {string} btnFilter  New, updated or all
     */


    function updateFAQs(searchText, btnFilter) {
      var oldFAQs = FAQs;
      var FAQ = [];
      searchText = searchText.toLowerCase();

      for (var i = 0; i < oldFAQs.length; i++) {
        var Category = {};
        Category.Subcategories = [];
        var showCategory = false;

        for (var j = 0; j < oldFAQs[i].Subcategories.length; j++) {
          var Subcategory = {};
          Subcategory.Pairs = [];
          var showSubCategory = false;

          for (var k = 0; k < oldFAQs[i].Subcategories[j].Pairs.length; k++) {
            var question = oldFAQs[i].Subcategories[j].Pairs[k].Question.toLowerCase();
            var answer = oldFAQs[i].Subcategories[j].Pairs[k].Answer.toLowerCase();

            if ((question.indexOf(searchText) > -1 || answer.indexOf(searchText) > -1) && (!btnFilter || btnFilter == 'new' && oldFAQs[i].Subcategories[j].Pairs[k].IsNew || btnFilter == 'updated' && oldFAQs[i].Subcategories[j].Pairs[k].WasUpdated)) {
              showCategory = true;
              showSubCategory = true;
              Subcategory.Pairs.push(oldFAQs[i].Subcategories[j].Pairs[k]);
            }
          }

          if (showSubCategory) {
            Subcategory.SubcategoryDescription = oldFAQs[i].Subcategories[j].SubcategoryDescription;
            Category.Subcategories.push(Subcategory);
          }
        }

        if (showCategory) {
          Category.CategoryDescription = oldFAQs[i].CategoryDescription;
          FAQ.push(Category);
        }
      }

      $scope.FAQItems = FAQ;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('FaqsModalCtrl', FaqsModalCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name FaqsModalCtrl
  * @description 
  *   Shows an FAQ 
  * @ngInject
  */

  function FaqsModalCtrl($scope, $uibModalInstance, pair) {
    $scope.pair = pair;
    $scope.cancel = cancel;
    /**
     * Close the modal
     * @memberof FaqsModalCtrl
     */

    function cancel() {
      $uibModalInstance.close('close');
    }
  }
})();
"use strict";

(function () {
  a3_cabin_reports.directive('aimsCrewMemos', aimsCrewMemos);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name aimsCrewMemos
  * @restrict E
  * @description
  *   Implementation of aimsCrewMemos
  *   Initialize the Aims Crew Memos
  * @example
  *   Usage:
  *   <aims-crew-memos  date="date"></aimsCrewMemos>
  * @ngInject
  */

  function aimsCrewMemos(AimsCrewMemosFactory) {
    function link($scope, element, attrs) {
      $scope.aimsCrewMemos = AimsCrewMemosFactory.getAimsCrewMemosByDate(attrs.date);
    }

    return {
      restrict: 'E',
      templateUrl: "views/directives/aimsCrewMemos.tpl.html",
      scope: true,
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('AimsCrewMemosFactory', AimsCrewMemosFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name AimsCrewMemosFactory
  * @description 
  *   Add, Update, Delete and Get Aims Crew Memos.
  * @ngInject
  */

  function AimsCrewMemosFactory(GenericService) {
    /**
    * Initialize the AircaftPositions
    * @memberof AircaftPositionsFactory
    */
    function AimsCrewMemos() {
      this.Date = null;
      this.Line = null;
      this.OrderNo = null;
      this.GetId = GetId;
    }

    var objType = 'AimsCrewMemos';
    var objCallback = AimsCrewMemos;
    var service = {
      getAimsCrewMemosFromStorage: getAimsCrewMemosFromStorage,
      setAimsCrewMemosToStorage: setAimsCrewMemosToStorage,
      clearAimsCrewMemosFactoryFromStorage: clearAimsCrewMemosFactoryFromStorage,
      getAimsCrewMemosByDate: getAimsCrewMemosByDate,
      upsertAimsCrewMemos: upsertAimsCrewMemos,
      cleanOldAimsCrewMemos: cleanOldAimsCrewMemos
    };
    /**
     * Overide default get Id
     * @memberof AimsCrewMemosFactory
     * @returns {string} Id 
     */

    function GetId() {
      return this.Date;
    }
    /**
     * Get Aims Crew Memos
     * @memberof AimsCrewMemosFactory
     * @returns {Array} Aims Crew Memos
     */


    function getAimsCrewMemosFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Save Aims Crew Memos to storage
     * @memberof AimsCrewMemosFactory
     * @param {Array} A list of Aims Crew Memos
     */


    function setAimsCrewMemosToStorage(aircaftPositions) {
      GenericService.saveAll(aircaftPositions, objType, objCallback);
    }
    /**
     * Remove the  Aims Crew Memos of  the local storage
     * @memberof AimsCrewMemosFactory
     */


    function clearAimsCrewMemosFactoryFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }
    /**
     * Get AimsCrewMemosFactory of this flight by date
     * @memberof AimsCrewMemosFactory
     * @returns {Object} AimsCrewMemosFactory
     */


    function getAimsCrewMemosByDate(date) {
      var crewMemos = getAimsCrewMemosFromStorage();
      var datesMemos = [];
      var arrayLength = crewMemos.length;

      for (var i = 0; i < arrayLength; i++) {
        if (crewMemos[i].GetId() == date) {
          datesMemos.push(crewMemos[i]);
        }
      }

      return datesMemos;
    }
    /**
    *  Upsert Aims Crew Memos
    * @memberof AimsCrewMemosFactory
    */


    function upsertAimsCrewMemos(aimsCrewMemos) {
      var newCrewMemos = aimsCrewMemos.map(function (x) {
        return x.Date;
      });
      var aimsCrewMemosLS = this.getAimsCrewMemosFromStorage();
      aimsCrewMemosLS = aimsCrewMemosLS.filter(function (x) {
        return !newCrewMemos.includes(x.Date);
      });
      var allAimsCrewMemos = aimsCrewMemosLS.concat(aimsCrewMemos);
      setAimsCrewMemosToStorage(allAimsCrewMemos);
    }
    /**
     * Clean Old Data
     * @memberof AimsCrewMemosFactory
     */


    function cleanOldAimsCrewMemos() {
      var now = moment();
      getAimsCrewMemosFromStorage(function (crewMemos) {
        var memosToKeep = crewMemos.filter(function (item) {
          var memoDate = moment(item.Date);
          return now.diff(memoDate, 'days') < 5;
        }); // keep only the memo with pending reports

        setAimsCrewMemosToStorage(memosToKeep);
      });
    } // var dutyDate = moment(cabinReportLocalEdits[i].DutyDate);
    // if (cabinReportLocalEdits[i].Status !== 'stored' && now.diff(dutyDate, 'days') < 5) {


    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('AircaftPositionsFactory', AircaftPositionsFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name AircaftPositionsFactory
  * @description 
  *   Add, Update, Delete and Get AircaftPositions.
  * @ngInject
  */

  function AircaftPositionsFactory(GenericService) {
    /**
    * Initialize the AircaftPositions
    * @memberof AircaftPositionsFactory
    */
    function AircaftPositions() {
      this.FlightId = null;
      this.PreviousFlightNo = null;
      this.PreviousStation = null;
      this.PreviousSTA = null;
      this.PreviousETA = null;
      this.PreviousATA = null;
      this.PreviousGATE = null;
      this.PreviousSTAND = "";
      this.PreviousSTANDArrival = "";
      this.NextFlightNo = null;
      this.NextStation = null;
      this.NextSTD = null;
      this.NextETD = null;
      this.NextATD = null;
      this.NextGATE = null;
      this.NextSTAND = "";
      this.NextSTANDArrival = "";
      this.GetId = GetId;
    }

    var objType = 'aircaftpositions';
    var objCallback = AircaftPositions;
    var service = {
      getAircaftPositionsFromStorage: getAircaftPositionsFromStorage,
      setAircaftPositionsToStorage: setAircaftPositionsToStorage,
      clearAircaftPositionsFromStorage: clearAircaftPositionsFromStorage,
      getAircaftPositionsByFlightId: getAircaftPositionsByFlightId,
      updateAircraftPositionsToStorage: updateAircraftPositionsToStorage,
      cleanOldData: cleanOldData
    };
    /**
     * Overide default get Id
     * @memberof AircaftPositionsFactory
     * @returns {number} Id 
     */

    function GetId() {
      return this.FlightId;
    }
    /**
     * Get messages
     * @memberof AircaftPositionsFactory
     * @returns {Array} Aircaft Positions 
     */


    function getAircaftPositionsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Save Aircaft Positions to storage
     * @memberof AircaftPositionsFactory
     * @param {Array} messages A list of Aircaft Positions
     */


    function setAircaftPositionsToStorage(aircaftPositions) {
      GenericService.saveAll(aircaftPositions, objType, objCallback);
    }
    /**
     * Remove the Aircaft Positions of  the local storage
     * @memberof AircaftPositionsFactory
     */


    function clearAircaftPositionsFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }
    /**
     * Get Aircaft Positions of this flight
     * @memberof AircaftPositionsFactory
     * @returns {Object} Aircaft Positions 
     */


    function getAircaftPositionsByFlightId(flightId) {
      return GenericService.get(flightId, objType, objCallback);
    }
    /**
    * Update Aircraft Position to storage
    * @memberof AircaftPositionsFactory
    * @param {object} aircraftPositions  Aircraft Positions
    */


    function updateAircraftPositionsToStorage(aircraftPositions, flightId) {
      if (GenericService.get(flightId, objType, objCallback)) {
        GenericService.save(aircraftPositions, objType, objCallback);
      } else if (aircraftPositions != null) GenericService.add(aircraftPositions, objType, objCallback);
    }
    /**
           * Clean ls from old flights aircraft positions
           * @param {array} flights Synced flights
           */


    function cleanOldData(responseFlightIds) {
      var previousAircaftPositions = getAircaftPositionsFromStorage();
      previousAircaftPositions = previousAircaftPositions.filter(function (x) {
        return responseFlightIds.includes(x.FlightId);
      });
      setAircaftPositionsToStorage(previousAircaftPositions);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('AircraftDifferencesFactory', AircraftDifferencesFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name AircraftDifferencesFactory
  * @description 
  *   Add, Update, Delete and Get AircraftDifferences.
  * @ngInject
  */

  function AircraftDifferencesFactory(GenericService, FlightFactory) {
    /**
    * Initialize the AircraftPositions
    * @memberof AircraftDifferencesFactory
    */
    function AircraftDifferences() {
      this.GetId = GetId;
    }

    var objType = 'AircraftDifferences';
    var objCallback = AircraftDifferences;
    var service = {
      getAircraftDifferencesFromStorage: getAircraftDifferencesFromStorage,
      setAircraftDifferencesToStorage: setAircraftDifferencesToStorage,
      clearAircraftDifferencesFromStorage: clearAircraftDifferencesFromStorage,
      getAircraftDifferencesByFlightId: getAircraftDifferencesByFlightId,
      getAircraftDifferenceFromStorageByRegistration: getAircraftDifferenceFromStorageByRegistration,
      upsertAircraftDifferences: upsertAircraftDifferences
    };
    /**
     * Override default get Id
     * @memberof AircraftDifferencesFactory
     * @returns {number} Id 
     */

    function GetId() {
      return this.Registration;
    }
    /**
     * Get messages
     * @memberof AircraftDifferencesFactory
     * @returns {Array} Aircraft Differences 
     */


    function getAircraftDifferencesFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    function getAircraftDifferenceFromStorageByRegistration(registration) {
      return GenericService.get(registration, objType, objCallback);
    }
    /**
     * Save Aircraft Differences to storage
     * @memberof AircraftDifferencesFactory
     * @param {Array} messages A list of Aircraft Differences
     */


    function setAircraftDifferencesToStorage(aircraftDifferences) {
      GenericService.saveAll(aircraftDifferences, objType, objCallback);
    }
    /**
     * Remove the Aircraft Differences of  the local storage
     * @memberof AircraftDifferencesFactory
     */


    function clearAircraftDifferencesFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }
    /**
     * Get Aircraft Differences of this flight
     * @memberof AircraftDifferencesFactory
     * @returns {Object} Aircraft Differences 
     */


    function getAircraftDifferencesByFlightId(flightId) {
      var retVal = [];
      var flight = FlightFactory.getFlightFromStorage(flightId);

      if (!flight) {
        flight = FlightFactory.getLocalFlightFromStorage(flightId);
      }

      if (!flight) {
        return [];
      }

      var difference = getAircraftDifferenceFromStorageByRegistration(flight.AcTailNo);
      retVal = difference != null && difference.AircraftDifferences != null ? difference.AircraftDifferences : [];
      return retVal; // return GenericService.get(flightId,objType,objCallback);
    }
    /**
     * Upsert aircraft differences
     * @memberof AircraftDifferencesFactory
     */


    function upsertAircraftDifferences(aircraftDifferences) {
      var newAircraftDifferences = aircraftDifferences.map(function (x) {
        return x.Registration;
      });
      var aircraftDifferencesLS = this.getAircraftDifferencesFromStorage();
      aircraftDifferencesLS = aircraftDifferencesLS.filter(function (x) {
        return !newAircraftDifferences.includes(x.Registration);
      });
      var updatedAircraftDifferences = aircraftDifferencesLS.concat(aircraftDifferences);
      setAircraftDifferencesToStorage(updatedAircraftDifferences);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('crewRouteInfoPanel', crewRouteInfoPanel);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name crewRouteInfoPanel
  * @restrict EA
  * @description
  *   Implementation of crewRouteInfoPanel
  *
  *   Initialize the crew Route Info panel 
  * @example
  *   Usage:
  *   <div crew-route-info-panel></div> or <crew-route-info-panel></crew-route-info-panel>
  * @ngInject
  */

  function crewRouteInfoPanel($routeParams, $uibModal) {
    function link($scope, element, attrs) {
      $scope.showDefaultView = showDefaultView;
      $scope.showFlightTimes = showFlightTimes;
      $scope.showCommercialView = showCommercialView;
      $scope.showDelaysView = showDelaysView;
      $scope.showHiddenRows = false;
      $scope.toggleshowHiddenRows = toggleshowHiddenRows;
      $scope.defaultColumns = true;
      $scope.commercialColumns = false;
      $scope.timesColumns = false;
      $scope.delaysColumns = false;
      $scope.crewMeals = '';
      $scope.showDate = showDate;
      $scope.openCrewContactsModal = openCrewContactsModal;

      function showDefaultView() {
        $scope.defaultColumns = true;
        $scope.timesColumns = false;
        $scope.commercialColumns = false;
        $scope.delaysColumns = false;
      }

      function showFlightTimes() {
        $scope.defaultColumns = false;
        $scope.timesColumns = true;
        $scope.commercialColumns = false;
        $scope.delaysColumns = false;
      }

      function showCommercialView() {
        $scope.defaultColumns = false;
        $scope.timesColumns = false;
        $scope.commercialColumns = true;
        $scope.delaysColumns = false;
      }

      function showDelaysView() {
        $scope.defaultColumns = false;
        $scope.timesColumns = false;
        $scope.commercialColumns = false;
        $scope.delaysColumns = true;
      }

      function toggleshowHiddenRows() {
        if ($scope.crewRouteInfoPanel.hasAircraftPositions) {
          $scope.showHiddenRows = !$scope.showHiddenRows;
        }
      }

      function showDate(acRouteSTD, flightSTD) {
        var datediff = moment(acRouteSTD).startOf('day').diff(moment(flightSTD).startOf('day'), 'days');
        return datediff != 0;
      }
      /**
       * Open dialog with the crew details
       * @memberof BucketCtrl
       */


      function openCrewContactsModal(_crewInfo, _selectedflightid, _selectedFlightNo) {
        if (_crewInfo && _crewInfo.length > 0) {
          var modalInstance = $uibModal.open({
            templateUrl: 'views/CrewRoute/dlgCrewContacts.html',
            controller: 'CrewContactsModalCtrl',
            backdrop: 'static',
            keyboard: false,
            size: 'md',
            resolve: {
              crewInfo: function crewInfo() {
                return _crewInfo;
              },
              selectedflightid: function selectedflightid() {
                return _selectedflightid;
              },
              selectedFlightNo: function selectedFlightNo() {
                return _selectedFlightNo;
              }
            }
          });
        }
      }
    }

    return {
      restrict: 'EA',
      terminal: true,
      templateUrl: 'views/directives/crewRouteInfoPanel.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('FlightConfigCtrl', FlightConfigCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name FlightConfigCtrl
  * @description 
  *   Set the ETA of the flight
  * @ngInject
  */

  function FlightConfigCtrl($scope, $uibModalInstance, flight, FlightFactory) {
    $scope.cancel = cancel;
    $scope.save = save;
    $scope.flightETA = new Date(flight.ETA ? flight.ETA : flight.ScheduledArrival);
    /**
     * Save the new ETA
     * @memberof FlightConfigCtrl
     */

    function save() {
      if ($scope.flightETA) {
        var ETAdate = $scope.flightETA;
        var STDdate = new Date(flight.ScheduledDeparture);
        var ETAtimestamp = ETAdate.getTime();
        var STDtimestamp = STDdate.getTime();
        ETAdate.setUTCFullYear(STDdate.getUTCFullYear());
        ETAdate.setUTCMonth(STDdate.getUTCMonth());
        ETAdate.setUTCDate(STDdate.getUTCDate());

        if (ETAtimestamp < STDtimestamp) {
          ETAdate.setUTCDate(STDdate.getUTCDate() + 1);
        }

        $scope.flightETA = ETAdate;
      }

      flight.ETA = $scope.flightETA;
      FlightFactory.updateFlight(flight);
      $uibModalInstance.close(flight);
    }
    /**
     * Close the modal
     * @memberof FlightConfigCtrl
     */


    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('FlightDelaysFactory', FlightDelaysFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name FlightDelaysFactory
  * @description 
  *   Add, Update, Delete and Get FlightDelays.
  * @ngInject
  */

  function FlightDelaysFactory(GenericService) {
    var objType = 'FlightDelays';
    var objCallback = FlightDelays;
    /**
     * Initialize the FlightDelays
     * @memberof FlightDelaysFactory
     */

    function FlightDelays() {
      this.GetId = GetId;
    }

    var service = {
      getFlightDelaysFromStorage: getFlightDelaysFromStorage,
      setFlightDelaysToStorage: setFlightDelaysToStorage,
      getFlightDelaysByFlightId: getFlightDelaysByFlightId,
      addFlightDelays: addFlightDelays,
      upsertFlightDelays: upsertFlightDelays,
      cleanOldFlightDelays: cleanOldFlightDelays
    }; //Object Functions

    /**
     * Overide default get Id
     * @memberof FlightFactory
     * @returns {number} Id 
     */

    function GetId() {
      return this.FlightId;
    }
    /**
      * Get FlightDelays
      * @memberof FlightDelaysFactory
      * @param {function} callback  
      */


    function getFlightDelaysFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    ;
    /**
    * Save FlightDelays to storage
    * @memberof FlightDelaysFactory
    * @param {Array} FlightDelays A list of FlightDelays
    */

    function setFlightDelaysToStorage(flightDelays) {
      GenericService.saveAll(flightDelays, objType, objCallback);
    }
    /**
    * Get single flight FlightDelays
    * @memberof FlightDelaysFactory
    * @param {function} callback  
    */


    function getFlightDelaysByFlightId(flightId) {
      return GenericService.get(flightId, objType, objCallback);
    }

    ;
    /**
    * Set single flight FlightDelays
    * @memberof FlightDelaysFactory
    * @param {function} callback  
    */

    function addFlightDelays(FlightDelays) {
      return GenericService.add(FlightDelays, objType, objCallback);
    }

    ;
    /**
    *  Upsert Flight Delays
    * @memberof FlightDelaysFactory
    */

    function upsertFlightDelays(newflightDelays) {
      var newFLightIds = newflightDelays.map(function (x) {
        return x.FlightId;
      });
      var flightDelaysLS = this.getFlightDelaysFromStorage();
      flightDelaysLS = flightDelaysLS.filter(function (x) {
        return !newFLightIds.includes(x.FlightId);
      });
      var allFlightDelays = flightDelaysLS.concat(newflightDelays);
      setFlightDelaysToStorage(allFlightDelays);
    }
    /**
           * Clean Old Data
           * @memberof FlightDelaysFactory
           * @param {Array} pendingFlightIds FlightIds with pending reports
           */


    function cleanOldFlightDelays(pendingFlightIds) {
      var now = moment();
      getFlightDelaysFromStorage(function (flightDelays) {
        var pendingFlightDelays = flightDelays.filter(function (item) {
          var date = moment(item.FlightDate);
          return pendingFlightIds.includes(item.FlightId) || now.diff(date, 'days') < 5;
        }); // keep only the FlightDelays with pending reports

        setFlightDelaysToStorage(pendingFlightDelays);
      });
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('FlightGateCtrl', FlightGateCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name FlightGateCtrl
  * @description 
  *   View all flight connections and search for more possible connecting flights
  * @ngInject
  */

  function FlightGateCtrl($scope, $uibModalInstance, flight, FlightGateFactory, SyncLogFactory, FlightFactory, PaxInfoFactory) {
    var flightId = flight.FlightId;
    var items = [];
    var syncLog = SyncLogFactory.getSyncLog();
    var distinct_gates = [];
    var searchFilters = flight.FlightsFilters;
    var gates = FlightGateFactory.getAfterSTDFromStorage(flight.ScheduledDeparture, flight.Arrival);
    $scope.isConnectedFlightClose = isConnectedFlightClose;
    $scope.TimeDifference = TimeDifference;
    $scope.IsOld = IsOld;
    $scope.searchText = '';
    $scope.addFilter = addFilter;
    $scope.removeFilter = removeFilter;
    $scope.cancel = cancel;
    $scope.filters = searchFilters;
    PaxInfoFactory.getPaxInfoFromStorage(flight.FlightId, function (paxInfo) {
      if (paxInfo) {
        items = paxInfo.TotalFlights;
        $scope.items = items.sort(function (a, b) {
          return new Date(a.STD).getTime() - new Date(b.STD).getTime();
        });

        for (var i = 0; i < gates.length; i++) {
          var exists = false;

          for (var j = 0; j < items.length; j++) {
            if (items[j].FlightNo == gates[i].FlightNo && items[j].Dep == gates[i].Dep) {
              var connectingTime = new Date(items[j].STD_lcl);
              var flightGateTime = new Date(gates[i].STD);

              if (connectingTime.getTime() == flightGateTime.getTime()) {
                if (!items[j].Codeshares || items[j].Codeshares.length == 0) {
                  items[j].Codeshares == gates[i].Codeshares;
                }

                exists = true;
                break;
              }
            }
          }

          if (!exists) {
            var distinct_gate = {
              FlightNo: gates[i].FlightNo,
              Gate: gates[i].DepGate,
              Arr: gates[i].Arrival,
              STD_lcl: gates[i].STD_lcl,
              STD: gates[i].STD,
              pax: null,
              Codeshares: gates[i].Codeshares,
              UpdatedDate: gates[i].lastUpdate
            };
            distinct_gates.push(distinct_gate);
          }
        }
      }
    });
    var flightArrivalTime = new Date(flight.ScheduledArrival).getTime();
    $scope.hasGates = distinct_gates.length > 0;
    $scope.flightETA = flight.ETA ? new Date(flight.ETA).getTime() : flightArrivalTime;
    applyFilter();
    /**
     * Calculates if a connecting flight is departs sort time after fligths arrival 
     * @memberof FlightGateCtrl
     * @param {string} connection Connection STD
     * @return {string} cssClass
     */

    function isConnectedFlightClose(connection) {
      if (!connection) {
        return '';
      }

      var connFlightDate = new Date(connection).getTime();
      if ($scope.flightETA > connFlightDate) return '';

      if (connFlightDate - $scope.flightETA < 3600001) {
        return 'bg-bisque';
      }

      if (connFlightDate - $scope.flightETA < 6480000) {
        return 'bg-cornsilk';
      }

      return '';
    }
    /**
     * Returns the time difference
     * @memberof FlightGateCtrl
     * @param {string} time Connection STD
     * @return {string} timeDifference
     */


    function TimeDifference(time) {
      var timeString = '';
      var sign = '';
      var dayString = null;

      if (time) {
        var connFlightDate = new Date(time);
        var ms = connFlightDate.getTime() - $scope.flightETA; // this is a time in milliseconds

        if (ms < 0) {
          ms = -ms;
          sign = "-";
        }

        var days = Math.floor(ms / (24 * 60 * 60 * 1000));
        days = days < 0 ? days + 1 : days;
        var daysms = ms % (24 * 60 * 60 * 1000);
        var hours = Math.floor(daysms / (60 * 60 * 1000));
        var hoursms = ms % (60 * 60 * 1000);
        var minutes = Math.floor(hoursms / (60 * 1000));
        timeString = '<strong>' + sign + (hours > 0 ? ("0" + hours).substr(-2) + ":" : '') + ("0" + minutes).substr(-2) + '\'' + '<strong>';
        dayString = ' <span class="badge">' + days + 'd</span>';
      }

      return timeString + (days && days != 0 ? dayString : '');
    }
    /**
     * Checks if the data are new
     * @memberof FlightGateCtrl
     * @param {string} time timestamp
     * @return {boolean} IsOld
     */


    function IsOld(time) {
      IsOld = false;

      if (time) {
        var now = new Date();
        var timeDate = new Date(time);
        var diff = now.getTime() - timeDate.getTime();

        if (diff > 3600000) {
          IsOld = true;
        }
      }

      return IsOld;
    }
    /**
    * Apply given filters to show connectings flights
    * @memberof FlightGateCtrl
    */


    function applyFilter() {
      var newFlightgates = [];

      if (searchFilters.length > 0) {
        for (var i = 0; i < distinct_gates.length; i++) {
          for (var j = 0; j < searchFilters.length; j++) {
            var row = distinct_gates[i].FlightNo + "," + distinct_gates[i].Codeshares.toString();

            if (row.indexOf(searchFilters[j].toString()) >= 0) {
              newFlightgates.push(distinct_gates[i]);
              break;
            }
          }
        }
      }

      $scope.gates = newFlightgates.sort(function (a, b) {
        return new Date(a.STD).getTime() - new Date(b.STD).getTime();
      });
    }
    /**
     * Add a filter
     * @memberof FlightGateCtrl
     * @param {string} searchText Search text
     */


    function addFilter(searchText) {
      if (searchText.trim().length > 0) {
        var exists = false;

        for (var i = 0; i < $scope.filters.length; i++) {
          if ($scope.filters[i] == searchText.toString().toUpperCase()) {
            exists = true;
            break;
          }
        }

        if (!exists) {
          var flight = FlightFactory.getFlightFromStorage(flightId);
          searchFilters.push(searchText.toString().toUpperCase());
          flight.FlightsFilters = searchFilters;
          FlightFactory.updateFlight(flight);
          $scope.filters = searchFilters;
        }

        $scope.searchText = "";
        applyFilter();
      }
    }
    /**
     * Remove a filter
     * @memberof FlightGateCtrl
     * @param {item} string filter
     */


    function removeFilter(item) {
      var flight = FlightFactory.getFlightFromStorage(flightId);
      var index = searchFilters.indexOf(item);
      searchFilters.splice(index, 1);
      flight.FlightsFilters = searchFilters;
      FlightFactory.updateFlight(flight);
      $scope.filters = searchFilters;
      applyFilter();
    }
    /**
     * Close the modal
     * @memberof FlightGateCtrl
     */


    function cancel() {
      $uibModalInstance.close($scope.gates);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('FlightGateFactory', FlightGateFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name FlightGateFactory
  * @description 
  *   Add, Update, Delete and Get Flight Gates.
  * @ngInject
  */

  function FlightGateFactory(GenericService) {
    /**
    * Initialize the FlightGate
    * @memberof FlightGateFactory
    */
    function FlightGate() {
      this.FlightDate = null;
      this.Codeshares = [];
      this.FlightNo = null;
      this.Departure = null;
      this.Arrival = null;
      this.STD = null;
      this.STA = null;
      this.ETD = null;
      this.ETA = null;
      this.STD_Diff = null;
      this.STA_Diff = null;
      this.STD_lcl = null;
      this.STA_lcl = null;
      this.ETD_lcl = null;
      this.ETA_lcl = null;
      this.DepGate = null;
      this.DepStand = null;
      this.AcType = null;
      this.lastUpdate = null; //net fields used to hold values before latest update

      this.previousUpdate = null;
      this.previousGate = null;
      this.previousSTD = null;
      this.previousSTD_lcl = null;
      this.previousSTD_Diff = null;
      this.previousSTA = null;
      this.previousSTA_lcl = null;
      this.previousSTA_Diff = null; //object functions

      this.getRoute = getRoute;
      this.dtSTD = dtSTD;
      this.dtSTA = dtSTA;
      this.dtETD = dtETD;
      this.dtETA = dtETA;
      this.dtSTD_lcl = dtSTD_lcl;
      this.dtSTA_lcl = dtSTA_lcl;
      this.dtETD_lcl = dtETD_lcl;
      this.dtETA_lcl = dtETA_lcl;
      this.dateSTD = dateSTD;
      this.timeSTD = timeSTD;
      this.timeSTA = timeSTA;
      this.timeETD = timeETD;
      this.timeETA = timeETA;
      this.timeSTD_lcl = timeSTD_lcl;
      this.timeSTA_lcl = timeSTA_lcl;
      this.timeETD_lcl = timeETD_lcl;
      this.timeETA_lcl = timeETA_lcl;
      this.hasETD = hasETD;
      this.hasETA = hasETA;
      this.depDelay = depDelay;
      this.arrDelay = arrDelay;
      this.setUpdatedNow = setUpdatedNow;
      this.gateChanged = gateChanged;
      this.stdChanged = stdChanged;
      this.staChanged = staChanged;
      this.stdDiffChanged = stdDiffChanged;
      this.staDiffChanged = staDiffChanged;
      this.toString = toString;
      this.changesToString = changesToString;
      this.getKey = getKey;
    }

    var objType = 'FlightGates';
    var objCallback = FlightGate;
    var service = {
      processUpdatedData: processUpdatedData,
      getFromStorage: getFromStorage,
      getAfterSTDFromStorage: getAfterSTDFromStorage,
      setToStorage: setToStorage
    }; //Object functions

    function getRoute() {
      if (this.Departure == null && this.Arrival == null) return '-null-';else return (this.Departure || '?') + '-' + (this.Arrival || '?');
    }
    /**
    * Transform STD iso string to datetime
    * @memberof FlightGateFactory
    * @return {object} date
    */


    function dtSTD() {
      return stringIsoToDateTime(this.STD);
    }
    /**
    * Transform STA iso string to datetime
    * @memberof FlightGateFactory
    * @return {object} date
    */


    function dtSTA() {
      return stringIsoToDateTime(this.STA);
    }
    /**
    * Transform ETD iso string to datetime
    * @memberof FlightGateFactory
    * @return {object} date
    */


    function dtETD() {
      return stringIsoToDateTime(this.ETD);
    }
    /**
    * Transform ETA iso string to date
    * @memberof FlightGateFactory
    * @return {object} date
    */


    function dtETA() {
      return stringIsoToDateTime(this.ETA);
    }
    /**
    * Transform local STD iso string to datetime
    * @memberof FlightGateFactory
    * @return {object} date
    */


    function dtSTD_lcl() {
      return stringIsoToDateTime(this.STD_lcl);
    }
    /**
    * Transform local STA iso string to datetime
    * @memberof FlightGateFactory
    * @return {object} date
    */


    function dtSTA_lcl() {
      return stringIsoToDateTime(this.STA_lcl);
    }
    /**
    * Transform local ETD iso string to datetime
    * @memberof FlightGateFactory
    * @return {object} date
    */


    function dtETD_lcl() {
      return stringIsoToDateTime(this.ETD_lcl);
    }
    /**
    * Transform local ETA iso string to datetime
    * @memberof FlightGateFactory
    * @return {object} date
    */


    function dtETA_lcl() {
      return stringIsoToDateTime(this.ETA_lcl);
    }
    /**
    * Transform STD iso string to date string
    * @memberof FlightGateFactory
    * @return {string} date
    */


    function dateSTD() {
      return stringIsoToDateString(this.STD);
    }
    /**
    * Transform STD iso string to time string 
    * @memberof FlightGateFactory
    * @return {string} time
    */


    function timeSTD() {
      return stringIsoToTimeString(this.STD);
    }
    /**
    * Transform STA iso string to time string 
    * @memberof FlightGateFactory
    * @return {string} time
    */


    function timeSTA() {
      return stringIsoToTimeString(this.STA);
    }
    /**
    * Transform ETD iso string to time string
    * @memberof FlightGateFactory
    * @return {object} time
    */


    function timeETD() {
      return stringIsoToTimeString(this.ETD);
    }
    /**
    * Transform ETA iso string to time string
    * @memberof FlightGateFactory
    * @return {string} time
    */


    function timeETA() {
      return stringIsoToTimeString(this.ETA);
    }
    /**
    * Transform STD iso string to local time string
    * @memberof FlightGateFactory
    * @return {string} time
    */


    function timeSTD_lcl() {
      return stringIsoToTimeString(this.STD_lcl);
    }
    /**
    * Transform local STA iso string to string time
    * @memberof FlightGateFactory
    * @return {string} time
    */


    function timeSTA_lcl() {
      return stringIsoToTimeString(this.STA_lcl);
    }
    /**
    * Transform local ETD iso string to time string
    * @memberof FlightGateFactory
    * @return {string} time
    */


    function timeETD_lcl() {
      return stringIsoToTimeString(this.ETD_lcl);
    }
    /**
    * Transform local ETA iso string to time
    * @memberof FlightGateFactory
    * @return {string} time
    */


    function timeETA_lcl() {
      return stringIsoToTimeString(this.ETA_lcl);
    }
    /**
    * check if gate has ETD
    * @memberof FlightGateFactory
    * @return {boolean} hasETD
    */


    function hasETD() {
      if (this.ETD && this.STD != this.ETD && this.dtSTD() < this.dtETD()) return true;else return false;
    }
    /**
    * check if gate has ETA
    * @memberof FlightGateFactory
    * @return {boolean} hasETA
    */


    function hasETA() {
      return this.ETA && this.STA != this.ETA && this.dtSTA() < this.dtETA();
    }
    /**
    * Return departure delay
    * @memberof FlightGateFactory
    * @return {string} STD_Diff
    */


    function depDelay() {
      if (this.hasETD() && this.STD_Diff && this.STD_Diff > 0) return this.STD_Diff;else return null;
    }
    /**
    * Return arrival delay
    * @memberof FlightGateFactory
    * @return {boolean} STA_Diff
    */


    function arrDelay() {
      if (this.hasETA() && this.STA_Diff && this.STA_Diff > 0) return this.STA_Diff;else return null;
    }
    /**
    * record the current time as the lastUpdate of the object
    * @memberof FlightGateFactory
    */


    function setUpdatedNow() {
      this.lastUpdate = new Date();
      if (this.DepGate == null) this.DepGate = '';
    }
    /**
    * Check if the gate has changed since the last update
    * @memberof FlightGateFactory
    * @return {boolean} gateChanged
    */


    function gateChanged() {
      if (!this.previousGate) return false;else return true;
    }
    /**
    * Check if the STD has changed since the last update
    * @memberof FlightGateFactory
    * @return {boolean} stdChanged
    */


    function stdChanged() {
      if (!this.previousSTD) return false;else return true;
    }
    /**
    * Check if the STA has changed since the last update
    * @memberof FlightGateFactory
    * @return {boolean} staChanged
    */


    function staChanged() {
      if (!this.previousSTA) return false;else return true;
    }
    /**
    * Check if the STD diff has changed since the last update
    * @memberof FlightGateFactory
    * @return {boolean} stdDiffChanged
    */


    function stdDiffChanged() {
      if (!this.previousSTD_Diff) return false;else return true;
    }
    /**
    * Check if the STA diff has changed since the last update
    * @memberof FlightGateFactory
    * @return {boolean} staDiffChanged
    */


    function staDiffChanged() {
      if (!this.previousSTA_Diff) return false;else return true;
    }
    /**
    * Print the flight gate info
    * @memberof FlightGateFactory
    * @return {string} toSting
    */


    function toString() {
      var s = this.dateSTD() + ' ' + this.FlightNo;
      s += ' ' + this.Departure + '-' + this.Arrival;
      s += ' ' + (this.hasETD() ? 'ETD' + this.timeETD_lcl() + (this.depDelay() ? '[+' + this.depDelay() + '\']' : '') : 'STD' + this.timeSTD_lcl());
      s += '->' + (this.hasETA() ? 'ETA' + this.timeETA_lcl() + '[' + (this.STA_Diff > 0 ? '+' : '-') + this.STA_Diff + '\']' : 'STA' + this.timeSTA_lcl());
      s += this.DepGate ? ' Gate: ' + this.DepGate : '';
      return s;
    }
    /**
    * Show all the changes of  the flight gates
    * @memberof FlightGateFactory
    * @return {string} toSting
    */


    function changesToString() {
      var s = '';
      if (this.stdChanged()) s += 'STD: ' + stringIsoToTimeString(this.previousSTD) + ' -> ' + this.timeSTD();
      if (self.stdDiffChanged()) s += (s == '' ? '' : ', ') + 'departure delay: ' + this.previousSTD_Diff + ' -> ' + this.STD_Diff;
      if (self.staChanged()) s += (s == '' ? '' : ', ') + 'STA: ' + stringIsoToTimeString(this.previousSTA) + ' -> ' + this.timeSTA();
      if (self.staDiffChanged()) s += (s == '' ? '' : ', ') + 'arrival delay: ' + this.previousSTA_Diff + ' -> ' + this.STA_Diff;
      if (self.gateChanged()) s += (s == '' ? '' : ', ') + ' gate: ' + this.previousGate + ' -> ' + this.DepGate;
      return s;
    }
    /**
    * returns a string with all the fields uniquely defining a flight, concatenated
    * @memberof FlightGateFactory
    * @return {string} key
    */


    function getKey() {
      var s = this.FlightDate + '|' + this.FlightNo + '|' + this.Departure + '-' + this.Arrival;
      return s;
    } //Service functions

    /**
    * Transform iso datetime string to date time Object
    * @memberof FlightGateFactory
    * @return {Object} DateTime
    */


    function stringIsoToDateTime(str) {
      var dt = null;

      try {
        if (str) {
          //replace T in order to avoid browser converting datetime to browser's timezone
          //eg 2016-05-17T23:04:00 would be converted to Wed May 18 2016 02:04:00 GMT+0300 (GTB Daylight Time) when we want it to be Tue May 17 2016 23:04:00 GMT+0300 (GTB Daylight Time)
          str = str.replace('T', ' ');
          dt = new Date(str);
        }
      } catch (e) {}

      return dt;
    }
    /**
    * Transform iso datetime string to date string
    * @memberof FlightGateFactory
    * @return {string} date
    */


    function stringIsoToDateString(str) {
      var dt = stringIsoToDateTime(str);
      var s = null;

      if (dt) {
        var year = dt.getFullYear();
        var month = dt.getMonth() + 1;
        var day = dt.getDate();
        s = (day < 10 ? '0' : '') + day + '.' + (month < 10 ? '0' : '') + month + '.' + year;
      }

      return s;
    }
    /**
    * Transform iso datetime string to time string
    * @memberof FlightGateFactory
    * @return {string} time
    */


    function stringIsoToTimeString(str) {
      var dt = stringIsoToDateTime(str);
      var s = null;

      if (dt) {
        var hour = dt.getHours();
        var min = dt.getMinutes();
        s = (hour < 10 ? '0' : '') + hour + ':' + (min < 10 ? '0' : '') + min + '';
      }

      return s;
    }
    /**
    * Process updated list of fligths 'gates' and store them.Before storing them, we need to identify changes in Gates and in ETD/ETA to notify customers when required. 
    * @memberof FlightGateFactory
    */


    function processUpdatedData(data) {
      //Update List
      var list = fromObjectList(data); //Original List

      var listPrevious = getFromStorage(); //Search each "new" flight in the new list, and check if it has been modified since last update

      if (list && list.length > 0) {
        var flight, flightPrevious, hasChanged;
        var previousLength = listPrevious.length;

        for (var i = 0; i < list.length; i++) {
          flight = list[i]; //mark that this flight was updated now

          flight.setUpdatedNow(); //check for flight in previous list, and if found, check for changes

          if (listPrevious && previousLength > 0) {
            for (var p = 0; p < previousLength; p++) {
              flightPrevious = listPrevious[p];

              if (flight.getKey() === flightPrevious.getKey()) {
                hasChanged = false;

                if (flight.DepGate != flightPrevious.DepGate) {
                  hasChanged = true;
                  flight.previousGate = flightPrevious.DepGate;
                }

                if (flight.STD != flightPrevious.STD) {
                  hasChanged = true;
                  flight.previousSTD = flightPrevious.STD;
                  flight.previousSTD_lcl = flightPrevious.STD_lcl;
                }

                if (flight.STA != flightPrevious.STA) {
                  hasChanged = true;
                  flight.previousSTA = flightPrevious.STA;
                  flight.previousSTA_lcl = flightPrevious.STA_lcl;
                }

                if (flight.STD_Diff != flightPrevious.STD_Diff) {
                  hasChanged = true;
                  flight.previousSTD_Diff = flightPrevious.STD_Diff;
                }

                if (flight.STA_Diff != flightPrevious.STA_Diff) {
                  hasChanged = true;
                  flight.previousSTA_Diff = flightPrevious.STA_Diff;
                }

                if (hasChanged) {
                  flight.previousUpdate = flightPrevious.lastUpdate;
                }

                break;
              }
            }
          }
        }
      }

      setToStorage(list);
    }
    /**
    * Get flightgates from storage
    * @memberof FlightGateFactory
    * @return {array} flightgates
    */


    function getFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
    * Get flightgates after std and flight gates selected departure
    * @memberof FlightGateFactory
    * @param {string} std  STD iso datetime string   
    * @param {string} dep  Departure
    * @return {array} flightgates
    */


    function getAfterSTDFromStorage(std, dep) {
      var newFlightgates = [];
      var now_utc = new Date(std);
      var date = now_utc.getTime();
      var flightgates = getFromStorage();

      for (var i = 0; i < flightgates.length; i++) {
        var dateSTD = new Date(flightgates[i].STD);
        var dateETD = null;

        if (dateETD) {
          dateETD = new Date(flightgates[i].ETD);
        }

        if ((dateSTD.getTime() >= date || dateETD != null && dateETD.getTime() >= date) && dep == flightgates[i].Departure && //check only for 2 days later
        dateSTD.getTime() <= date + 172800000) {
          newFlightgates.push(flightgates[i]);
        }
      }

      return newFlightgates;
    }
    /**
    * Set flightgates from storage
    * @memberof FlightGateFactory
    * @param {array} data
    */


    function setToStorage(data) {
      GenericService.saveAll(data, objType, objCallback);
    }
    /**
     * Extend an array of Objects from the default FlightGate Object
     * @memberof FlightGateFactory
     * @param {Array} objList  an Array Of FlightGates
     * @returns {Array} FlightGates
     */


    function fromObjectList(objList) {
      if (!objList) return [];
      var arrayLength = objList.length;
      var result = [];

      for (var i = 0; i < arrayLength; i++) {
        var item = new FlightGate();
        angular.extend(item, objList[i]);
        result.push(item);
      }

      return result;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('FlightInfoCtrl', FlightInfoCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name FlightInfoCtrl
   * @description 
   *   Shows the flight informations
   * @ngInject
   */

  function FlightInfoCtrl($scope, FlightFactory, MessageFactory, $routeParams, AircaftPositionsFactory, CrewCallFactory, PreviousDutyFactory, $location, $uibModal, PaxInfoFactory, CampaignFactory, UserFactory, barOptions, $anchorScroll, enableFaceMasks, FlightCheckInsFactory, CrewRouteFactory, defaultCalendarDate, mealCriteriaIsEnabled, LotteryFactory) {
    var flightId = $routeParams.flightId;
    var flight = FlightFactory.getFlightFromTotalFlights(flightId);
    var crewPhoneNumbers = CrewCallFactory.getFlightCrewCallsFromStorage(flightId);
    var previousDuties = PreviousDutyFactory.getFlightPreviousDutiesFromStorage(flightId);
    $scope.user = UserFactory.getUser();
    $scope.flightId = flightId;
    $scope.shownSideMenu = false;
    $scope.sideMenuItems = [];
    $scope.showSidePanel = showSidePanel;
    $scope.hideSidePanel = hideSidePanel;
    $scope.goToPanel = goToPanel;
    $scope.gotoMealLibrary = gotoMealLibrary;
    $scope.mealCriteriaIsEnabled = mealCriteriaIsEnabled;
    $scope.isMobile = window.innerWidth <= 800 && window.innerHeight <= 740;
    $scope.campaigns = CampaignFactory.getCampaignsByFlightId(+flightId); // function detectMobile() {
    //     $scope.isMobile =(window.innerWidth <= 800 && window.innerHeight <= 740); 
    //     console.log($scope.isMobile);
    //     return $scope.isMobile;		
    // }	

    function hideSidePanel() {
      $scope.shownSideMenu = false;
    }

    function goToPanel(id) {
      $location.hash(id);
      $anchorScroll();
      hideSidePanel();
    }

    ;

    function gotoMealLibrary(cabinClass) {
      $location.path('/mealLibrary/' + $scope.flightId + '/' + cabinClass);
    }

    function showSidePanel() {
      $scope.sideMenuItems = [];
      $('.panel-heading .title').each(function () {
        var menuItem = {};
        menuItem.id = $(this).attr("id");
        menuItem.title = $(this).html();
        menuItem.icon = $(this).data('icon');
        $scope.sideMenuItems.push(menuItem);
      });
      $scope.shownSideMenu = true;
    }

    if (!flight) {
      // go to dashboard if no flight
      $location.path("/");
    } else {
      //Initialize Zones
      var onlyUnique = function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
      };

      var RenderFlightZones = function RenderFlightZones(zones) {
        if (!zones) return;
        var flightZones = [];
        var zoneTitles = zones.map(function (item) {
          return item.Title;
        });
        var uniqueZones = zoneTitles.filter(onlyUnique); // //or
        // var uniqueZones2 = Array.from(new Set(zoneTitles));

        uniqueZones.forEach(function (element) {
          var getZoneCounter = zoneTitles.filter(function (item) {
            return item == element;
          });

          if (getZoneCounter.length > 1) {
            flightZones.push({
              Title: element.Title,
              Class: null
            });
          } else {
            var zone = zones.filter(function (item) {
              return item.Title == element;
            });
            flightZones.push(zone[0]);
          }
        });
        return flightZones;
      }; //Initialize Messages


      //Controllers Functions
      //TODO : find a more angular way (EPAP)

      /**
       * toggle View Mode
       * @memberof FlightInfoCtrl
       * @param {string} elem
       * @param {string} className     
       */
      var toggleViewMode = function toggleViewMode(elem, className) {
        $('body').find('div#' + elem + ' > div').not('.tip').hide("slow");
        $('body').find('div#' + elem + ' div.' + className).not('.tip').show("slow");
      }; //TODO : find a more angular way (EPAP)

      /**
       * toggle Panel
       * @memberof FlightInfoCtrl
       * @param {number} panelId
       */


      var togglePanel = function togglePanel(panelId) {
        $('#' + panelId).toggle();
        if (panelId == "info-panel") $scope.isPanelOpen = !$scope.isPanelOpen;
      };
      /**
       * Open modal to see information for the selected message
       * @memberof FlightInfoCtrl
       * @param {object} message A message object
       */


      var openMessage = function openMessage(_message) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Dialogs/dlgMessage.html',
          controller: 'MessageModalCtrl',
          size: 'lg',
          keyboard: false,
          backdrop: "static",
          resolve: {
            message: function message() {
              return _message;
            }
          }
        });
        modalInstance.result.then(function () {
          if (_message.ReadDt == null) {
            MessageFactory.markReaden(_message.Id);
            _message.ReadDt = new Date();
          }
        });
      };
      /**
       * Open modal to see information for gates and connections
       * @memberof FlightInfoCtrl
       */


      var openGates = function openGates() {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Dialogs/dlgFlightGates.html',
          controller: 'FlightGateCtrl',
          size: 'lg',
          resolve: {
            flight: function flight() {
              return $scope.flight;
            }
          }
        });
        modalInstance.result.then(function (selectedItem) {
          $scope.gates = selectedItem;
        });
      };
      /**
       * Return the text ccs class accoriding to report status
       * @memberof FlightInfoCtrl
       * @returns {string} cssClass
       */


      var getTextClass = function getTextClass() {
        var classname = "";
        if (flight.LineStatus === 'na') classname = "text-gray";else if (flight.LineStatus === 'pending') classname = "text-blue";else if (flight.LineStatus === 'pendingoverdue') classname = "text-blue";else if (flight.LineStatus === 'draft' || flight.LineStatus === 'draftotheruser') {
          classname = "text-orange";
        } else if (flight.LineStatus === 'completed' || flight.LineStatus === 'completedotheruser') {
          classname = "text-purple";
        } else if (flight.LineStatus === 'stored' || flight.LineStatus === 'storedotheruser' || flight.LineStatus === 'stored+otheruser' || flight.LineStatus === 'synched' || flight.LineStatus === 'synchedotheruser') {
          classname = "text-green";
        }
        return classname;
      };
      /**
       * Return the panel upper ccs class accoriding to report status
       * @memberof FlightInfoCtrl
       * @returns {string} cssClass
       */


      var getTopClass = function getTopClass() {
        var classname = "";
        if (flight.LineStatus === 'na') classname = "border-top-gray";else if (flight.LineStatus === 'pending') classname = "border-top-blue";else if (flight.LineStatus === 'pendingoverdue') classname = "border-top-blue";else if (flight.LineStatus === 'draft' || flight.LineStatus === 'draftotheruser') {
          classname = "border-top-orange";
        } else if (flight.LineStatus === 'completed' || flight.LineStatus === 'completedotheruser') {
          classname = "border-top-purple";
        } else if (flight.LineStatus === 'stored' || flight.LineStatus === 'storedotheruser' || flight.LineStatus === 'stored+otheruser' || flight.LineStatus === 'synched' || flight.LineStatus === 'synchedotheruser') {
          classname = "border-top-green";
        }
        return classname;
      };
      /**
       * Return the panel border ccs class accoriding to report status
       * @memberof FlightInfoCtrl
       * @returns {string} cssClass
       */


      var getBottomClass = function getBottomClass() {
        var classname = "";
        if (flight.LineStatus === 'na') classname = "border-bottom-gray";else if (flight.LineStatus === 'pending') classname = "border-bottom-blue";else if (flight.LineStatus === 'pendingoverdue') classname = "border-bottom-blue";else if (flight.LineStatus === 'draft' || flight.LineStatus === 'draftotheruser') {
          classname = "border-bottom-orange";
        } else if (flight.LineStatus === 'completed' || flight.LineStatus === 'completedotheruser') {
          classname = "border-bottom-purple";
        } else if (flight.LineStatus === 'stored' || flight.LineStatus === 'storedotheruser' || flight.LineStatus === 'stored+otheruser' || flight.LineStatus === 'synched' || flight.LineStatus === 'synchedotheruser') {
          classname = "border-bottom-green";
        }
        return classname;
      };
      /**
       * If report from another user exists, show icon
       * @memberof FlightInfoCtrl
       * @returns {boolean} hasIcon
       */


      var hasIcon = function hasIcon() {
        var hasIcon = false;

        if (flight.LineStatus === 'draftotheruser' || flight.LineStatus === 'completedotheruser' || flight.LineStatus === 'storedotheruser' || flight.LineStatus === 'stored+otheruser' || flight.LineStatus === 'synchedotheruser') {
          hasIcon = true;
        }

        return hasIcon;
      };
      /**
       * Calculates if a connecting flight is departs sort time after fligths arrival 
       * @memberof FlightInfoCtrl
       * @param {string} connection Connection STD
       * @return {string} cssClass
       */


      var isConnectedFlightClose = function isConnectedFlightClose(connection) {
        if (!connection) {
          return '';
        }

        var connFlightDate = new Date(connection.STD).getTime();
        if ($scope.flightETA > connFlightDate) return '';

        if (connFlightDate - $scope.flightETA < connection.MCT * 60000) {
          return 'bg-bisque';
        }

        if (connFlightDate - $scope.flightETA < (connection.MCT + 15) * 60000) {
          return 'bg-cornsilk';
        }

        return '';
      };
      /**
       * Returns the time difference
       * @memberof FlightInfoCtrl
       * @param {string} time Connection STD
       * @return {string} timeDifference
       */


      var TimeDifference = function TimeDifference(time) {
        var timeString = '';
        var sign = '';
        var dayString = null;

        if (time) {
          var connFlightDate = new Date(time);
          var ms = connFlightDate.getTime() - $scope.flightETA; // this is a time in milliseconds

          if (ms < 0) {
            ms = -ms;
            sign = "-";
          }

          var days = Math.floor(ms / (24 * 60 * 60 * 1000));
          days = days < 0 ? days + 1 : days;
          var daysms = ms % (24 * 60 * 60 * 1000);
          var hours = Math.floor(daysms / (60 * 60 * 1000));
          var hoursms = ms % (60 * 60 * 1000);
          var minutes = Math.floor(hoursms / (60 * 1000));
          timeString = '<strong>' + sign + (hours > 0 ? ("0" + hours).substr(-2) + ":" : '') + ("0" + minutes).substr(-2) + '\'' + '<strong>';
          dayString = ' <span class="badge">' + days + 'd</span>';
        }

        return timeString + (days && days != 0 ? dayString : '');
      };
      /**
       * Open Flight config modal
       * @memberof FlightInfoCtrl
       */


      var openFlightConfig = function openFlightConfig() {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Dialogs/dlgFlightConfig.html',
          controller: 'FlightConfigCtrl',
          size: 'md',
          resolve: {
            flight: function flight() {
              return $scope.flight;
            }
          }
        });
        modalInstance.result.then(function (selectedItem) {
          $scope.flightETA = new Date(selectedItem.ETA).getTime();
          $scope.flight = selectedItem;
        });
      };
      /**
       * Returns the assessment Text Class
       * @memberof FlightInfoCtrl
       * @return {string} classname
       */


      var getAssessmentTextClass = function getAssessmentTextClass() {
        var classname = "";

        if (flight.assessment) {
          if (flight.assessment.IsExist) {
            classname = "text-green";
          } else if (flight.assessment.Status === 'Pending') classname = "text-blue";else if (flight.assessment.Status === 'Draft') {
            classname = "text-orange";
          } else if (flight.assessment.Status === 'Completed') {
            classname = "text-purple";
          } else if (flight.assessment.Status === 'Stored') {
            classname = "text-green";
          }
        }

        return classname;
      };
      /**
       * Returns the crew Chart
       * @memberof FlightInfoCtrl
       * @param {object} flight The flight object
       * @return {object} crewChart
       */


      var generateCrewChart = function generateCrewChart(flight) {
        var cp = 0;
        var fo = 0;
        var sa = 0;
        var fa = 0;
        var dhcCp = 0;
        var dhcFo = 0;
        var dhcSa = 0;
        var dhcFa = 0;

        if (flight.crew) {
          for (var i = 0; i < flight.crew.length; i++) {
            if (flight.crew[i].isDHC) {
              switch (flight.crew[i].position) {
                case "CP":
                  dhcCp++;
                  break;

                case "FO":
                  dhcFo++;
                  break;

                case "SA":
                  dhcSa++;
                  break;

                case "FA":
                  dhcFa++;
                  break;
              }
            } else {
              switch (flight.crew[i].position) {
                case "CP":
                  cp++;
                  break;

                case "FO":
                  fo++;
                  break;

                case "SA":
                  sa++;
                  break;

                case "FA":
                  fa++;
                  break;
              }
            }
          }
        }

        var crewData = {
          labels: ["CP", "FO", "SA", "FA"],
          datasets: [{
            label: "Crew",
            fillColor: "rgba(33,150,243,0.5)",
            strokeColor: "rgba(33,150,243,0.8)",
            highlightFill: "rgba(33,150,243,0.75)",
            highlightStroke: "rgba(33,150,243,1)",
            data: [cp, fo, sa, fa]
          }, {
            label: "DHC",
            fillColor: "rgba(99,181,246,0.5)",
            strokeColor: "rgba(99,181,246,0.8)",
            highlightFill: "rgba(99,181,246,0.75)",
            highlightStroke: "rgba(99,181,246,1)",
            data: [dhcCp, dhcFo, dhcSa, dhcFa]
          }]
        };
        var crewChart = {
          "data": crewData,
          "options": barOptions
        };
        return crewChart;
      };
      /**
       * Returns the meal Chart
       * @memberof FlightInfoCtrl
       * @param {object} paxInfo The passenger list
       * @return {object} mealChart
       */


      var generateMealChart = function generateMealChart(paxInfo) {
        var labels = [];
        var mealCdata = [];
        var mealYdata = [];

        for (var i = 0; i < paxInfo.PassengerSummaryC.SpecialMeals.length; i++) {
          labels.push(paxInfo.PassengerSummaryC.SpecialMeals[i].Name);
          mealCdata.push(paxInfo.PassengerSummaryC.SpecialMeals[i].Count);
          mealYdata.push(0);
        }

        for (var i = 0; i < paxInfo.PassengerSummaryY.SpecialMeals.length; i++) {
          var exists = false;

          for (var h = 0; h < labels.length; h++) {
            if (labels[h] == paxInfo.PassengerSummaryY.SpecialMeals[i].Name) {
              mealYdata[h] = paxInfo.PassengerSummaryY.SpecialMeals[i].Count;
              exists = true;
              break;
            }
          }

          if (!exists) {
            labels.push(paxInfo.PassengerSummaryY.SpecialMeals[i].Name);
            mealCdata.push(paxInfo.PassengerSummaryY.SpecialMeals[i].Count);
            mealYdata.push(0);
          }
        }

        var mealsData = {
          labels: labels,
          datasets: [{
            label: "Business",
            fillColor: "rgba(139,195,74,0.5)",
            strokeColor: "rgba(139,195,74,0.8)",
            highlightFill: "rgba(139,195,74,0.75)",
            highlightStroke: "rgba(139,195,74,1)",
            data: mealCdata
          }, {
            label: "Economy",
            fillColor: "rgba(173,213,128,0.5)",
            strokeColor: "rgba(173,213,128,0.8)",
            highlightFill: "rgba(173,213,128,0.75)",
            highlightStroke: "rgba(173,213,128,1)",
            data: mealYdata
          }]
        };
        var mealsChartData = {
          "data": mealsData,
          "options": barOptions
        };
        return mealsChartData;
      };
      /**
       * Returns the meal Chart
       * @memberof FlightInfoCtrl
       * @param {array} gates The total available gates
       * @param {array} FlightsFilters The flilters for the gates
       * @return {array} distinct_gates
       */


      var generateDistinctGates = function generateDistinctGates(gates, FlightsFilters) {
        var distinct_gates = [];

        for (var i = 0; i < gates.length; i++) {
          for (var j = 0; j < FlightsFilters.length; j++) {
            var row = gates[i].FlightNo + "," + gates[i].Codeshares.toString();

            if (row.indexOf(FlightsFilters[j].toString()) >= 0) {
              var distinct_gate = {
                FlightNo: gates[i].FlightNo,
                Gate: gates[i].DepGate,
                Arr: gates[i].Arrival,
                STD_lcl: gates[i].STD_lcl,
                STD: gates[i].STD,
                pax: null,
                Codeshares: gates[i].Codeshares
              };
              distinct_gates.push(distinct_gate);
              break;
            }
          }
        }

        return distinct_gates;
      };

      var applyPhoneNumber = function applyPhoneNumber() {
        flight.crew.forEach(function (user) {
          var phoneNumberInfo = crewPhoneNumbers.find(function (x) {
            return x.CrewId == user.id;
          });

          if (phoneNumberInfo) {
            user.PhoneNumber = phoneNumberInfo.PhoneNumber;
          } else {
            user.PhoneNumber = null;
          }
        });
      };

      var applyPreviousDuty = function applyPreviousDuty() {
        var dutyDate = moment(flight.ScheduledDeparture).startOf('day');
        flight.crew.forEach(function (user) {
          var previousDutyInfo = previousDuties.find(function (x) {
            return x.CrewId == user.id;
          });

          if (previousDutyInfo) {
            user.PreviousDuty = previousDutyInfo.PreviousDuty;
          } else {
            user.PreviousDuty = null;
          }

          if (user.PreviousDuty && user.PreviousDuty.isFlight) {
            var arrivalDate = user.PreviousDuty.ATA;
            if (!arrivalDate) arrivalDate = user.PreviousDuty.ETA;
            if (!arrivalDate) arrivalDate = user.PreviousDuty.STA;
            user.PreviousDuty.showArrivalDate = !moment(arrivalDate).startOf('day').isSame(dutyDate);
            var departureDate = user.PreviousDuty.ATA;
            if (!departureDate) departureDate = user.PreviousDuty.ETA;
            if (!departureDate) departureDate = user.PreviousDuty.STA;
            user.PreviousDuty.showDepartureDate = !moment(departureDate).startOf('day').isSame(dutyDate);
          }

          if (user.PreviousDuty && !user.PreviousDuty.isFlight) {
            user.PreviousDuty.showDate = !moment(user.PreviousDuty.GroundDutyDate).startOf('day').isSame(dutyDate);
          }
        });
      };

      var applyCrewCheckInStatus = function applyCrewCheckInStatus() {
        var crewCheckInStatuses = FlightCheckInsFactory.getFlightCrewCheckInFromStorage(flightId);
        flight.crew.forEach(function (user) {
          var statuses = crewCheckInStatuses.find(function (x) {
            return x.CrewId == user.id;
          });

          if (statuses) {
            user.CheckIn = statuses.CheckIn;
            user.WillBeThereAt = statuses.WillBeThereAt;
          } else {
            user.CheckIn = null;
            user.WillBeThereAt = null;
          }
        });
      };

      applyPhoneNumber();
      applyPreviousDuty();
      applyCrewCheckInStatus();
      PaxInfoFactory.setMaskPaxInfoInRoute(flight); // ── Lottery ──────────────────────────────────────────────────────────

      $scope.applicableLotteries = LotteryFactory.getApplicableLotteries(flight);
      var submittedLotteries = LotteryFactory.getSubmittedLotteriesFromStorage() || [];

      $scope.isLotterySubmitted = function (lotteryId) {
        var key = String(lotteryId) + '_' + String(flightId);
        return submittedLotteries.some(function (s) {
          return String(s.Id) === key;
        }) || LotteryFactory.hasPendingResult(key);
      };

      $scope.openLottery = function (lotteryId) {
        $location.path('/lottery/' + flightId + '/' + lotteryId);
      }; // ─────────────────────────────────────────────────────────────────────


      $scope.flightCrewPreviousDuty = flight.crew.filter(function (x) {
        return x.PreviousDuty && x.PreviousDuty.isDifferent && (x.position == "CP" || x.position == "FO") && !x.isDHC;
      }).length;
      $scope.cabinCrewPreviousDuty = flight.crew.filter(function (x) {
        return x.PreviousDuty && x.PreviousDuty.isDifferent && (x.position == "SA" || x.position == "FA") && !x.isDHC;
      }).length;
      $scope.dhcCrewPreviousDuty = flight.crew.filter(function (x) {
        return x.PreviousDuty && x.PreviousDuty.isDifferent && x.isDHC;
      }).length;
      $scope.hasPreviousDuties = $scope.flightCrewPreviousDuty + $scope.cabinCrewPreviousDuty + $scope.dhcCrewPreviousDuty; // Check if the flight is today or in the past for displaying departure panel

      $scope.isTodayOrPast = function (scheduledDeparture) {
        if (!scheduledDeparture) return false;
        var depDate = moment(scheduledDeparture).startOf('day');

        if (defaultCalendarDate) {
          depDate = moment(defaultCalendarDate).startOf('day');
        }

        var now = moment().startOf('day');
        return depDate.isSameOrBefore(now);
      }; //Update scopes for the CrewRoutePanel in Flight-page


      $scope.crewRouteInfoPanel = CrewRouteFactory.getCrewRouteInfoPanel(flight);
      $scope.saEligibility = flight.LineStatus != 'na'; //  (flight.Position == "SA" || (flight.Position != "SA" && !flight.getSeniorAttendantsCount() && flight.Fleet.Id==2 ));
      //Manage Face Mask Panel visibility - Show only to SA or OA flights with no SA

      $scope.enableFaceMasks = enableFaceMasks && flight && $scope.saEligibility; //todo :: epap replace with flightId 1312896

      var aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId(flight.FlightId);
      $scope.state = 'flight';
      $scope.flight = flight;
      $scope.aircaftPositions = aircaftPositions;
      $scope.IsProvisional = true;
      $scope.flightZones = RenderFlightZones(flight.Zones);
      $scope.messages = MessageFactory.getMessagesFromIds(flight.messages);
      var messages = $scope.messages;
      $scope.openMessage = openMessage; //Initialize scope variables

      $scope.isEnabled = false;
      $scope.isPanelOpen = true;
      $scope.showConnFlights = true; //Charts

      $scope.crewChart = generateCrewChart(flight);
      $scope.generateMealChart = generateMealChart; //1226541

      PaxInfoFactory.getPaxInfoFromStorage(flight.FlightId, function (paxInfo) {
        $scope.paxInfo = paxInfo;

        if (paxInfo) {
          $scope.cStat = paxInfo.PaxTotalC / paxInfo.ConfigurationC * 100;
          $scope.yStat = paxInfo.PaxTotalY / paxInfo.ConfigurationY * 100;
          $scope.mealsChart = generateMealChart(paxInfo);
          var listSentTimestamp = new Date(paxInfo.LastRun).getTime();
          var DepartureTimestamp = new Date(flight.ScheduledDeparture).getTime(); //20 minutes before takeoff

          if (DepartureTimestamp - listSentTimestamp <= 1200000) {
            $scope.IsProvisional = false;
          }
        }
      });
      var flightArrivalTime = new Date(flight.ScheduledArrival).getTime();
      $scope.flightETA = flight.ETA ? new Date(flight.ETA).getTime() : flightArrivalTime; //Initialize scope functionality

      $scope.isConnectedFlightClose = isConnectedFlightClose;
      $scope.TimeDifference = TimeDifference;
      $scope.openFlightConfig = openFlightConfig;
      $scope.openGates = openGates; //TODO : find a more angular way (EPAP)

      $scope.togglePanel = togglePanel; //TODO : find a more angular way (EPAP)

      $scope.toggleViewMode = toggleViewMode; //Initialize CSS classes

      $scope.getTextClass = getTextClass();
      $scope.getTopClass = getTopClass();
      $scope.getBottomClass = getBottomClass();
      $scope.hasIcon = hasIcon();
      $scope.getAssessmentTextClass = getAssessmentTextClass();
      $scope.staffTravellers = [];
      PaxInfoFactory.getPaxInfoFromStorage(flight.FlightId, function (paxInfo) {
        $scope.paxInfo = paxInfo;

        if (paxInfo) {
          $scope.staffTravellers = paxInfo.StaffPassengers;
        } // Show panel if there's at least one          


        $scope.hasStaffTravellers = function () {
          if ($scope.staffTravellers && $scope.staffTravellers.length > 0) {
            return true;
          }

          return false;
        };

        $scope.getGroupedStaff = function (type) {
          return $scope.staffTravellers.filter(function (p) {
            return p.StaffTravellerType === type;
          }).sort(function (a, b) {
            return a.Fullname.localeCompare(b.Fullname);
          });
        };
      });
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('flightStatus', flightStatus);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name flightStatus
  * @restrict EA
  * @description
  *   Implementation of flightStatus
  *
  *   Initialize the flight Status panel needs to have flight in scope
  * @example
  *   Usage:
  *   <div flight-status></div>
  * @ngInject
  */

  function flightStatus(AircaftPositionsFactory) {
    function link($scope, element, attrs) {
      $scope.securitySearch = false;
      $scope.previousActualTAT = null;
      $scope.previousEstimatedTAT = null;
      $scope.previousScheduledTAT = null;
      $scope.previousDiffWithSceduled = null;
      $scope.nextActualTAT = null;
      $scope.nextEstimatedTAT = null;
      $scope.nextScheduledTAT = null;
      $scope.nextDiffWithSceduled = null;

      if ($scope.flight && $scope.flight.FlightId) {
        $scope.aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId($scope.flight.FlightId);
      }

      if ($scope.aircaftPositions != null) {//TurnAroundTime();
      }

      function TurnAroundTime() {
        var previousTemporaryActualValue;
        var nextTemporaryActualValue; //TurnAroundTime for previous flight

        if ($scope.aircaftPositions.PreviousATA && $scope.flight.ATD) {
          previousTemporaryActualValue = Date.DifferenceInMinutes($scope.aircaftPositions.PreviousATA, $scope.flight.ATD);
          $scope.previousActualTAT = normalizeMins(previousTemporaryActualValue);
        } else if ($scope.aircaftPositions.PreviousETA && $scope.flight.ETD) {
          previousTemporaryActualValue = Date.DifferenceInMinutes($scope.aircaftPositions.PreviousETA, $scope.flight.ETD);
          $scope.previousEstimatedTAT = normalizeMins(previousTemporaryActualValue);
        }

        if ($scope.aircaftPositions.PreviousSTA && $scope.flight.ScheduledDeparture) {
          var previousTemporaryScheduledValue = Date.DifferenceInMinutes($scope.aircaftPositions.PreviousSTA, $scope.flight.ScheduledDeparture);
          $scope.previousScheduledTAT = normalizeMins(previousTemporaryScheduledValue);
          var tempDiff = previousTemporaryActualValue - previousTemporaryScheduledValue; //difference (mins) between Actual and Scheduled

          if (tempDiff >= -70 && tempDiff <= 70) $scope.previousDiffWithSceduled = normalizeMins(tempDiff, true);
        } //TurnAroundTime for next flight


        if ($scope.flight.ATA && $scope.aircaftPositions.NextATD) {
          nextTemporaryActualValue = Date.DifferenceInMinutes($scope.aircaftPositions.flight.ATA, $scope.aircaftPositions.NextATD);
          $scope.nextActualTAT = normalizeMins(nextTemporaryActualValue);
        } else if ($scope.flight.ETA && $scope.aircaftPositions.NextETD) {
          nextTemporaryActualValue = Date.DifferenceInMinutes($scope.aircaftPositions.flight.ETA, $scope.aircaftPositions.NextETD);
          $scope.nextEstimatedTAT = normalizeMins(nextTemporaryActualValue);
        }

        if ($scope.flight.ScheduledArrival && $scope.aircaftPositions.NextSTD) {
          var nextTemporaryScheduledValue = Date.DifferenceInMinutes($scope.aircaftPositions.ScheduledArrival, $scope.aircaftPositions.NextSTD);
          $scope.nextScheduledTAT = normalizeMins(nextTemporaryScheduledValue);
          var tempDiff = nextTemporaryActualValue - nextTemporaryScheduledValue; //difference (mins) between Actual and Scheduled

          if (tempDiff >= -70 && tempDiff <= 70) $scope.nextDiffWithSceduled = normalizeMins(tempDiff, true);
        }
      }

      function normalizeMins(diffInMins, canBeNegativeNumber) {
        var returnString = ""; //negative value - return mins

        if (canBeNegativeNumber && diffInMins < 0) {
          returnString = diffInMins * -1 + "mins less than scheduled";
        } //positive value - return mins
        else if (canBeNegativeNumber) {
            returnString = diffInMins + "mins more than scheduled";
          } //positive value - return hours like "2hrs 30mins"
          else {
              returnString = Date.MinutesToString(diffInMins);
            }

        return returnString;
      }

      function needsSecuritySearch() {
        if ($scope.aircaftPositions.PreviousEU) {
          $scope.securitySearch = false;
        }

        if ($scope.aircaftPositions.PreviousCounty == "SWITZERLAND" || $scope.aircaftPositions.PreviousCounty == "NORWAY" || $scope.aircaftPositions.PreviousCounty == "ICELAND" || $scope.aircaftPositions.PreviousCounty == "MONTENEGRO") {
          $scope.securitySearch = false;
        }

        if ($scope.aircaftPositions.PreviousCounty == "UNITED KINGDOM" || $scope.aircaftPositions.PreviousCounty == "FRANCE") {
          $scope.securitySearch = true;
        }

        if ($scope.flight.ArrivalCountry == "TURKEY" || $scope.flight.ArrivalCountry == "EGYPT" || $scope.flight.ArrivalCountry == "ISRAEL" || $scope.flight.ArrivalCountry == "JORDAN" || $scope.flight.ArrivalCountry == "SAUDI ARABIA") {
          $scope.securitySearch = true;
        }
      }
    }

    return {
      restrict: 'EA',
      terminal: true,
      templateUrl: 'views/directives/flightStatus.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('GroundServicesFactory', GroundServicesFactory);
  /**
   * @memberOf CabinReports
   * @ngdoc factory
   * @name GroundServicesFactory
   * @description
   * Get Ground Services
   * @gnInject
   */

  function GroundServicesFactory(GenericService) {
    /**
    * Initialize the GroundServices
    * @memberof GroundServicesFactory
    */
    function GroundService() {
      this.Station = null;
    }

    var objType = 'groundServices';
    var objCallBack = GroundService;
    var service = {
      fromObjectList: fromObjectList,
      getGroundServicesFromStorage: getGroundServicesFromStorage,
      setGroundServicesToStorage: setGroundServicesToStorage,
      clearGroundServicesFromStorage: clearGroundServicesFromStorage,
      getGroundServicesByStation: getGroundServicesByStation,
      upsertGroundServices: upsertGroundServices
    };
    /**
     * Extend an array of Objects from the default GroundService Object
     * @memberof GroundServicesFactory
     * @param {Array} objList  an Array Of ground Services
     * @returns {Array} groundServices
     */

    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallBack);
    }
    /**
    * Get ground services from local storage
    * @memberof GroundServicesFactory
    * @returns {Array} groundServices 
    */


    function getGroundServicesFromStorage() {
      return GenericService.list(objType, objCallBack);
    }
    /**
     * Save ground services to storage
     * @memberof GroundServicesFactory
     * @param {Array} List of ground services
     */


    function setGroundServicesToStorage(groundServices) {
      for (var i = 0; i < groundServices.length; i++) {
        for (var j = 0; j < groundServices[i].Services.length; j++) {
          // isDefault could be null
          if (groundServices[i].Services[j].IsDefault) groundServices[i].Services[j].Used = 1;else groundServices[i].Services[j].Used = 0;
        }
      }

      GenericService.saveAll(groundServices, objType, objCallBack);
    }
    /**
     * Remove the ground services from the local storage
     * @memberof GroundServicesFactory
     */


    function clearGroundServicesFromStorage() {
      GenericService.removeAll(objType, objCallBack);
    }
    /**
     * Get Ground Services of a current station from the local storage
     * @memberof GroundServicesFactory
     * @param {number} station 
     * @return {object} GroundServices 
     */


    function getGroundServicesByStation(station) {
      var objects = getGroundServicesFromStorage();
      if (objects == null) return [];
      var results = [];
      var arrayLength = objects.length;

      for (var i = 0; i < arrayLength; i++) {
        if (objects[i].Station == station) {
          results = objects[i].Services;
        }
      }

      return results;
    }
    /**
     * Upsert ground services
     * @memberof GroundServicesFactory
     */


    function upsertGroundServices(groundServices) {
      var newStations = groundServices.map(function (x) {
        return x.Station;
      });
      var servicesLS = this.getGroundServicesFromStorage();
      servicesLS = servicesLS.filter(function (x) {
        return !newStations.includes(x.Station);
      });
      var updatedServicesList = servicesLS.concat(groundServices);
      setGroundServicesToStorage(updatedServicesList);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('passengerEvents', passengerEvents);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name passengerEvents
  * @restrict E
  * @description
  *   Implementation of passengerEvents
  * @example
  *   Usage:
  *   <passenger-events></passenger-events>
  * @ngInject
  */

  function passengerEvents(ToolkitFactory, CustomerEventFactory) {
    function link(scope) {
      var Passengers = []; //Get all OneStopShop customer events of this flight

      var customerEvents = CustomerEventFactory.groupFlightCustomerEventsByPassenger(scope.flightId);
      ToolkitFactory.getToolkitItemsFromStorage(function (toolKitItems) {
        //Merge each event with its toolkit Item
        customerEvents.forEach(function (customerEvent) {
          customerEvent.OneStopShopEvents.forEach(function (event) {
            event.ToolkitItem = toolKitItems.find(function (x) {
              return x.Id == event.ToolkitItemId;
            });
            event.Treatment = toolKitItems.find(function (x) {
              return x.Id == event.ToolkitItemId;
            }).Treatments.find(function (t) {
              return t.Id == event.TreatmentId;
            });
          });
        }); // OneStopShopEvent Passengers

        customerEvents.forEach(function (customerEvent) {
          //Passenger already exists - Only add events
          if (Passengers.map(function (p) {
            return p.UCI;
          }).includes(customerEvent.UCI)) {
            Passengers.find(function (p) {
              return p.UCI == customerEvent.UCI;
            }).OneStopShopEvents = customerEvent.OneStopShopEvents;
          } //Add Passenger Info & Events
          else {
              var passenger = {
                UCI: customerEvent.UCI,
                GivenName: customerEvent.GivenName,
                Surname: customerEvent.Surname,
                SeatNo: customerEvent.SeatNo,
                OneStopShopEvents: customerEvent.OneStopShopEvents,
                numberOfEvents: customerEvent.OneStopShopEvents.length,
                isOpen: false
              };
              Passengers.push(passenger);
            }
        });
        scope.Passengers = Passengers;
      });
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/Flight/passengerEvents.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.filter('paxNames', paxNames);
  /**
  * @memberof CabinReports
  * @ngdoc filter
  * @name paxNames
  * @description 
  *  List pax names in list and return $sce html 
  * @ngInject
  */

  function paxNames($sce) {
    return function (input) {
      var html = '"<div class=\'row\'><div class=\'col-sm-offset-6 col-sm-2\'><strong>C</strong></div><div class=\' col-sm-1\'><strong>Y</strong></div> </div>';
      html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> Passengers </strong>";
      html = html + '<div class=\'col-xs-2\'>' + (input.PassengerSummaryC ? input.PassengerSummaryC.Passengers : 0) + "</div>";
      html = html + '<div class=\'col-xs-1\'>' + (input.PassengerSummaryY ? input.PassengerSummaryY.Passengers : 0) + '</div></div>';
      html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> PRM </strong>";
      html = html + '<div class=\'col-xs-2\'>' + (input.PassengerSummaryC ? input.PassengerSummaryC.PRM : 0) + "</div>";
      html = html + '<div class=\'col-xs-1\'>' + (input.PassengerSummaryY ? input.PassengerSummaryY.PRM : 0) + '</div></div>';
      html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> UMNR </strong>";
      html = html + '<div class=\'col-xs-2\'>' + (input.PassengerSummaryC ? input.PassengerSummaryC.UMNR : 0) + "</div>";
      html = html + '<div class=\'col-xs-1\'>' + (input.PassengerSummaryY ? input.PassengerSummaryY.UMNR : 0) + '</div></div>';
      html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> DEP </strong>";
      html = html + '<div class=\'col-xs-2\'>' + (input.PassengerSummaryC ? input.PassengerSummaryC.DEP : 0) + "</div>";
      html = html + '<div class=\'col-xs-1\'>' + (input.PassengerSummaryY ? input.PassengerSummaryY.DEP : 0) + '</div></div>\"';
      return $sce.trustAsHtml(html);
    };
  }

  ;
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('SyncPaxCtrl', SyncPaxCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name SyncPaxCtrl
  * @description 
  *   Get the latest  PAX and gate Information
  * @ngInject
  */

  function SyncPaxCtrl($scope, InfoAPIService, $uibModalInstance, $route, flightId, LogService, FlightFactory, FlightSessionFactory, CourseFactory, CrewCallFactory, PreviousDutyFactory) {
    var flight = FlightFactory.getFlightFromTotalFlights(flightId);
    $scope.hideElements = true;
    $scope.showOnSuccess = false;
    $scope.showOnEmptyData = false;
    $scope.showOnSuccessNoFlightData = false;
    $scope.showOnOutOfDateRange = false;
    $scope.cancel = cancel;
    $scope.flightId = flightId;
    $scope.isFetchingFlightData = false;
    $scope.flightDataStatus = [{
      datatype: "Flight Status",
      status: "PENDING",
      text: "Pending..."
    }, {
      datatype: "Aircraft Movement",
      status: "PENDING",
      text: "Pending..."
    }, {
      datatype: "Crew Info",
      status: "PENDING",
      text: "Pending..."
    }, {
      datatype: "Crew Contacts",
      status: "PENDING",
      text: "Pending..."
    }, // {
    // 	datatype: "Aims Crew Memos",
    // 	status: "PENDING",
    // 	text: "Pending..."
    // },
    {
      datatype: "Pax Info",
      status: "PENDING",
      text: "Pending..."
    }, {
      datatype: "Meals",
      status: "PENDING",
      text: "Pending..."
    }, {
      datatype: "Connections",
      status: "PENDING",
      text: "Pending..."
    }, {
      datatype: "Campaigns",
      status: "PENDING",
      text: "Pending..."
    }, {
      datatype: "Luggage Info",
      status: "PENDING",
      text: "Pending..."
    }, {
      datatype: "Training Info",
      status: "PENDING",
      text: "Pending..."
    }];
    $uibModalInstance.closed.then(function () {
      $route.reload();
    });
    var isThisFlightSynced = false;
    /**
     * Close the modal
     * @memberof SyncPaxCtrl
     */

    function cancel() {
      $uibModalInstance.close('close');
    }

    ;
    var q = InfoAPIService.getPax(flightId);
    $scope.isFetchingFlightData = true;
    q.then(function (responseData) {
      updateStatusGenerator(responseData);
      $scope.isFetchingFlightData = !$scope.isFetchingFlightData;

      if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined) {
        var err = new Error();
        err.status = -1;
        var msg = "ResponseData error in sync :" + JSON.stringify(responseData);
        LogService.debug(msg, err);
        q.reject(err);
      } //Save training


      var trainingCourses = responseData.data.data.TrainingCourses;

      if (trainingCourses && trainingCourses.length) {
        trainingCourses.forEach(function (trainingCourse) {
          CourseFactory.upsertCourse(trainingCourse, function (course) {
            FlightSessionFactory.applyTraineeInfoToSession(course, course.Id, new moment(flight.DutyDate).format("YYYY-MM-DD"), flight.DutyNo, flight.DutyDay, function (session) {});
          });
        });
      } //1. First remove all additional info (phone numbers & previous duties) for this flight


      CrewCallFactory.cleanFlightCrewNumbers(flightId);
      PreviousDutyFactory.cleanFlightPreviousDuties(flightId); //2. Then save any fetched info

      if (responseData.data.data.FlightInfo) {
        var crew = responseData.data.data.FlightInfo.crew;
        CrewCallFactory.saveFlightPhoneNumbers(flightId, crew, flight.ScheduledArrival, flight.ScheduledDeparture);
        PreviousDutyFactory.saveFlightPreviousDuties(flightId, crew);
      } //Save pax


      if (responseData.data.data.CabinServiceManagementLists) {
        for (var i = 0; i < responseData.data.data.CabinServiceManagementLists.length; i++) {
          if (responseData.data.data.CabinServiceManagementLists[i].FlightId == flightId) {
            //check for out of date range pax info
            var today = new Date().getTime();
            var paxDate = new Date(responseData.data.data.CabinServiceManagementLists[i].LastRun).getTime();

            if (paxDate <= today - 172800000) {
              $scope.showOnOutOfDateRange = true;
              break;
            }

            $scope.pax = responseData.data.data.CabinServiceManagementLists[i];
            $scope.showOnSuccess = true;
            isThisFlightSynced = true;
            break;
          }
        }

        if (!$scope.showOnSuccess) {
          $scope.showOnSuccessNoFlightData = true;
        } // $timeout(function () {
        // 	$uibModalInstance.close();
        // 	$route.reload();
        // }, 3000);

      } else {
        $scope.showOnEmptyData = true;
      }
    }, function (responseData) {
      updateStatusGenerator(responseData);
      $scope.isFetchingFlightData = !$scope.isFetchingFlightData;
      $scope.hideElements = false;
    });

    function updateStatusGenerator(data) {
      if (!data.data || !data.data.success) {
        for (var i = 0; i < $scope.flightDataStatus.length; i++) {
          $scope.flightDataStatus[i].status = "FAIL";
          $scope.flightDataStatus[i].text = "Update failed";
        }
      } else {
        if (!data.data.data.Campaigns.GetAssignmentsSuccess) {
          $scope.flightDataStatus[6].status = "FAIL";
          $scope.flightDataStatus[6].text = "Update failed";
        }

        var newDuty = data.data.data;
        InfoAPIService.updateFlightStatusSetter(newDuty, $scope.flightDataStatus);
      }
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('turnAroundTimes', turnAroundTimes);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name turnAroundTimes
  * @restrict EA
  * @description
  *   Implementation of turnAroundTimes
  *
  *   Initialize the turn Around Times panel needs to have flight in scope
  * @example
  *   Usage:
  *   <div turn-around-times></div>
  * @ngInject
  */

  function turnAroundTimes(AircaftPositionsFactory, turnArroundTimesAcTypes) {
    /**
     * Initialize turnAroundTimes
     * @memberof turnAroundTimes
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attributes attributes of this element
     */
    function link($scope, element, attrs) {
      $scope.showTaTpanel = false;
      var supportsTurnArroundTimes = $scope.flight && turnArroundTimesAcTypes.includes($scope.flight.AcType);

      if ($scope.flight && $scope.flight.FlightId && $scope.flight.ATD && supportsTurnArroundTimes) {
        var aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId($scope.flight.FlightId);

        if (aircaftPositions != null && aircaftPositions.PreviousATA) {
          /* var scheduledGroundTime = Date.DifferenceInMinutes(aircaftPositions.PreviousSTA, $scope.flight.ScheduledDeparture);
           var actualGroundTime = Date.DifferenceInMinutes(aircaftPositions.PreviousATA, $scope.flight.ScheduledDeparture);
          */
          var std = moment.utc($scope.flight.ScheduledDeparture);
          var atd = moment.utc($scope.flight.ATD);
          var startofTAT = moment.utc($scope.flight.ScheduledDeparture).add(-45, 'm');
          var prevATA = moment.utc(aircaftPositions.PreviousATA);
          var lateArrival = prevATA.diff(startofTAT, 'm');
          var scheduledTurnAroundTime = std.diff(startofTAT, 'm');
          var comparedValue = startofTAT;

          if (lateArrival > 0) {
            var comparedValue = prevATA;
          }

          var actualTurnAroundTime = atd.diff(comparedValue, 'm');
          $scope.scheduledTurnAroundTime = scheduledTurnAroundTime;
          $scope.actualTurnAroundTime = actualTurnAroundTime;
          $scope.lateArrival = lateArrival;
          $scope.showTaTpanel = true;
        }
      }
    }

    return {
      restrict: 'EA',
      terminal: true,
      templateUrl: 'views/directives/turnAroundTimes.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('FlightMealCriteriaFactory', FlightMealCriteriaFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name FlightMealCriteriaFactory
  * @description 
  * Get selected flight info
  * @ngInject
  */

  function FlightMealCriteriaFactory(GenericService) {
    var service = {
      setMealCriteria: setMealCriteria,
      getMealCriteria: getMealCriteria,
      getMealCriteriaByFlightIdFromLS: getMealCriteriaByFlightIdFromLS,
      upsertMealCriteria: upsertMealCriteria,
      cleanOldDataMealCriteria: cleanOldDataMealCriteria
    };
    /**
    * Initialize the MealCriteria 
    * @memberof FlightMealCriteriaFactory
    */

    function MealCriteria() {
      this.Id = null;
      this.LocalSTD = null;
      this.Rotation = null;
      this.MealType = null;
      this.Zone = null;
    }

    var objType = 'mealCriteriaList';
    var objTypeCallback = MealCriteria;
    /**
     * Save Meal Criteria
     * @memberof FlightMealCriteriaFactory
     * @param {Array} mealCriteria
     */

    function setMealCriteria(mealCriteria) {
      GenericService.saveAll(mealCriteria, objType);
    }
    /**
     * Get Meal Criteria
     * @memberof FlightMealCriteriaFactory
     * @returns {Array} MealCriteria
     */


    function getMealCriteria() {
      return GenericService.list(objType, objTypeCallback);
    }
    /**
     * Get Meal Criteria by FlightId from Local Storage
     * @memberof FlightMealCriteriaFactory
     */


    function getMealCriteriaByFlightIdFromLS(flightId) {
      var storedMealCriteria = getMealCriteria();
      return storedMealCriteria.filter(function (x) {
        return x.FlightId == flightId;
      });
    }

    function upsertMealCriteria(mealCriteria) {
      var flightIds = mealCriteria.map(function (x) {
        return x.FlightId;
      });
      var storedMealCriteria = getMealCriteria();
      var otherMealCriteria = storedMealCriteria.filter(function (x) {
        return !flightIds.includes(x.FlightId);
      });
      var mergeMealCriteria = otherMealCriteria.concat(mealCriteria);
      setMealCriteria(mergeMealCriteria);
    }
    /**
     * Clean Old Data Service Events
     * @memberof FlightMealCriteriaFactory
     * @param {Array} responseFlightIds
     */


    function cleanOldDataMealCriteria(responseFlightIds) {
      var storedMealCriteria = getMealCriteria();
      var previousMealCriteria = storedMealCriteria.filter(function (x) {
        return responseFlightIds.includes(x.FlightId);
      });
      setMealCriteria(previousMealCriteria);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('flightMealPanel', flightMealPanel);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name flightMealPanel
  * @restrict E
  * @description
  *   Implementation of flightMealPanel directive
  * @example
  *   Usage:
  *   <flight-meal-panel></flight-meal-panel>
  * @ngInject
  */

  function flightMealPanel($location, FlightMealCriteriaFactory) {
    function link(scope, element, attributes) {
      scope.mealCriteria = null;
      scope.showPanel = null;
      scope.gotoMealLibrary = gotoMealLibrary; //navigates to meal library

      function gotoMealLibrary(mealClass, searchText) {
        $location.path('/mealLibrary/' + scope.flightId + '/' + mealClass + '/' + searchText);
      } //get from LS the meal criteria for the flight


      if (scope.flightId) scope.mealCriteria = FlightMealCriteriaFactory.getMealCriteriaByFlightIdFromLS(scope.flightId);
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/FlightMealPanel/flightMealPanel.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('AddFlightCtrl', AddFlightCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name AddFlightCtrl
  * @description 
  *   Add a new flight that is not in schedule
  * @ngInject
  */

  function AddFlightCtrl($scope, UserFactory, FlightFactory, AircraftTypeFactory, $uibModalInstance, $route) {
    $scope.isSecure = UserFactory.isSecure(); // cancel

    $scope.doCancel = doCancel; // add flight

    $scope.doAdd = doAdd; // setup datetime pickers

    var now = new Date();
    var minSelectableDate = new Date();
    var maxSelectableDate = new Date();
    minSelectableDate.setDate(now.getDate() - 15);
    maxSelectableDate.setDate(now.getDate() + 2);
    $scope.minSelectableDateStr = minSelectableDate.toString('dd-MM-yyyy');
    $scope.maxSelectableDateStr = maxSelectableDate.toString('dd-MM-yyyy');
    $scope.selectedDate = null;
    $scope.selectedTime = null;
    $scope.hstep = 1;
    $scope.mstep = 1;
    $scope.ismeridian = false;
    $scope.dateFormat = 'dd-MM-yyyy';
    $scope.hourFormat = "HH:mm";
    $scope.datepicker = {
      opened: false
    };
    $scope.openDatepicker = openDatepicker;
    $scope.createFlightFromUIValues = createFlightFromUIValues;
    $scope.processForm = processForm; // initialize form data

    $scope.formData = {}; // setup aircraft types

    var actypes = AircraftTypeFactory.getAircraftTypesFromStorage();
    if (!(actypes instanceof Array)) actypes = [];
    actypes.push({
      Code: 'other'
    });
    $scope.aircraftTypes = actypes;
    /**
     * Open Datepicker
     * @memberof AddFlightCtrl
     */

    function openDatepicker() {
      $scope.datepicker.opened = true;
    }
    /**
     * Close the modal
     * @memberof AddFlightCtrl
     */


    function doCancel() {
      $uibModalInstance.close('cancel');
    }
    /**
     * Add the flight to schedule
     * @memberof AddFlightCtrl
     */


    function doAdd() {
      $scope.processForm();
    }
    /**
     * Get the values from ui and create a flight 
     * @memberof AddFlightCtrl
     */
    // 


    function createFlightFromUIValues() {
      // get moment dt from controls
      var flightDate = $scope.formData.flightDateStr;
      var flightSTD = $scope.formData.flightTimeStr; // convert them to dates

      flightDate = new Date(flightDate);
      flightSTD = new Date(flightSTD); // combine date and time

      flightDate.setHours(flightSTD.getHours(), flightSTD.getMinutes(), 0, 0); // flightDate = flightDate.fromUTC();
      // get other flight details

      var flightNumber = $scope.formData.flightNumber;
      var flightDeparture = $scope.formData.flightDeparture;
      var flightDestination = $scope.formData.flightDestination;
      var flightRegNo = $scope.formData.flightRegNo;
      var flightAcType = null;
      if ($scope.formData.flightAcType != null) flightAcType = $scope.formData.flightAcType; // try to create a local flight

      var newFlight = FlightFactory.createLocalFlight(flightDate, flightNumber, flightDeparture, flightDestination, flightRegNo, flightAcType);
      return newFlight;
    }
    /**
     * Process and validate the form
     * @memberof AddFlightCtrl
     */


    function processForm() {
      // if all valid
      if ($scope.formFlight.$valid) {
        try {
          // try to create a local flight
          var newFlight = $scope.createFlightFromUIValues(); // save the local flight

          if (newFlight != null) {
            FlightFactory.saveLocalFlight(newFlight);
          }

          if (newFlight == null) {
            bootbox.alert("<h4>Error</h4>Unable to create a flight record.");
          } else {
            (function () {
              $uibModalInstance.close();
              $route.reload();
            })();
          }
        } catch (e) {
          bootbox.alert("<h4>Error</h4>Unable to create a flight record due to unexpected error:\n" + e.message);
        }
      } else {
        bootbox.alert("Please fill in all the required fields.");
      }
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('CalendarCtrl', CalendarCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name CalendarCtrl
   * @description 
   *   View your schedule (flights and ground duties)
   * @ngInject
   */

  function CalendarCtrl($scope, defaultCalendarDate, LeaveRequestFactory, version, $location, FlightFactory, UserFactory, MemoFactory, MessageFactory, UpdateService, SyncLogFactory, $timeout, $uibModal, CrewRouteFactory, CrewHotelFactory, GroundDutyFactory, localStorageMD5Service, SettingsMain, TrainingSessionFactory, FlightSessionFactory, ScheduleAcknowledgeFactory, CheckInFactory, ExpiriesFactory, $route, TraineeCoursesDetailsFactory, RequestFactory, SaFeedbackInfoFactory) {
    var flights = FlightFactory.getFlightsFromStorage();
    var user = UserFactory.getUser();
    var isAssessmentEnabled = SettingsMain.getIsAssessmentEnabled();
    $scope.isSecure = UserFactory.isSecure();
    $scope.state = 'calendar';
    $scope.setupView = setupView;
    $scope.logged_user_info = user.aimsId + ' - ' + user.name;
    $scope.storageUsage = storageUsage();
    $scope.addFlight = addFlight;
    $scope.openSynch = openSynch;
    $scope.pendingOverdueReports = 0;
    $scope.draftReports = 0;
    $scope.completedReports = 0;
    $scope.isUserSA = user.position == 'SA' ? true : false;
    $scope.gotoUnreadMemos = gotoUnreadMemos;
    $scope.gotoMessages = gotoMessages;
    $scope.gotoLeaves = gotoLeaves;
    $scope.hasUnsetTraining = false;
    $scope.hasScheduleChanged = false;
    $scope.acknowledge = acknowledge;
    $scope.showPasswordExpiryAlert = false;
    $scope.showExpiriesAlertCalendar = false;
    $scope.showSubmissionDeadlineAlertCalendar = false;
    $scope.expiryList = [];
    $scope.expiredExpiriesList = [];
    $scope.submissionDeadline = null;
    $scope.showCheckInAction = false;
    $scope.openCheckIn = openCheckInModal;
    $scope.searchPastGroundDuties = searchPastGroundDuties;
    $scope.hasManualEntry = false;
    $scope.gotoGroundDutyInfo = gotoGroundDutyInfo;
    $scope.removeManualEntry = removeManualEntry;
    $scope.daysDiff = daysDiff;
    $scope.hasTraineeCourse = false;
    $scope.gotoFlightInfo = gotoFlightInfo;
    $scope.removeFlightTrainingManualEntry = removeFlightTrainingManualEntry;
    $scope.gotoCrewRouteInfo = gotoCrewRouteInfo;
    $scope.pastTrainingsViewSummary = pastTrainingsViewSummary;
    $scope.viewPastTrainings = false;
    $scope.removePendingGDEntry = removePendingGDEntry;
    $scope.removePendingFlightEntry = removePendingFlightEntry;
    $scope.showExpiredExpiriesAlertCalendar = false;
    $scope.passwordExpiry = {
      showAlert: false,
      lastChange: null,
      daysLeft: null
    };

    function pastTrainingsViewSummary() {
      $scope.viewPastTrainings = !$scope.viewPastTrainings;
    }

    var groundSessions = [];
    var flightSessions = [];
    TrainingSessionFactory.getAll(function (savedGroundSessions) {
      FlightSessionFactory.getAll(function (savedFlightSessions) {
        groundSessions = savedGroundSessions;
        flightSessions = savedFlightSessions;
        $scope.setupView(false);
      });
    });

    if (version) {
      $scope.version = version.replace('appVersion_', '');
    } else {
      $scope.version = '';
    }
    /**
     * Calculates the local storage Usage
     * @memberof CalendarCtrl
     * @return {string} usage
     */


    function storageUsage() {
      var usage = localStorageMD5Service.usedSize();
      return usage;
    }
    /**
     * Calculates days left
     * @memberof CalendarCtrl
     * @return {string} usage
     */


    function daysDiff(date) {
      var today = moment().startOf('day');
      var expiryDate = moment(date);
      return expiryDate.diff(today, 'days');
    }
    /**
     * Setups Calendar View
     * @memberof CalendarCtrl
     * @param {boolean} isReload
     */


    function setupView(isReload) {
      if (!UserFactory.isLoggedIn()) {
        $location.path("/login");
      }

      $scope.NeedsToSync = UpdateService.updater();
      $scope.number_of_messages = MessageFactory.getMessagesFromStorage().length;
      $scope.number_of_messages_not_readen = MessageFactory.getCountOfUnreadMessages();
      $scope.leaveRequest = LeaveRequestFactory.getLeaveRequestInformation();
      $scope.leaveRequestCloseDate = $scope.leaveRequest ? moment($scope.leaveRequest.CloseDate).format('Do of MMMM') : null;
      $scope.expiryList = ExpiriesFactory.getCrewExpiriesFromStorage();
      $scope.submissionDeadline = RequestFactory.getSubmissionDeadlineDateFromStorage(); //Get count of unread memos but remove the ones that belong in 'Training Surveys' Category

      MemoFactory.getUnreadMemos(function (memos) {
        $scope.unreadMemosCount = memos && memos.length || 0;
      }); // read the flights from the local storage and display them

      var flights = FlightFactory.getFlightsFromStorageAndCheckIfTooOld(); // also load the flights created by the user

      flights = FlightFactory.getLocalFlightsAndMergeWithServerFlights(flights); // if no local flights are found then force sync

      if (!isReload) {
        needsToSync = true;
      }

      var crewRoutes = CrewRouteFactory.getCrewRoutesFromStorage();
      var groundDuties = GroundDutyFactory.getGroundDutiesFromStorage();
      var crewHotels = CrewHotelFactory.getCrewHotelsFromStorage();
      var crewRoutesEvents = formatCrewRoutes(crewRoutes);
      var traineeGroundCourses = TraineeCoursesDetailsFactory.getTraineeCourses();
      var groundDutiesEvents = formatGroundDuties(groundDuties, traineeGroundCourses); // Get incomplete past duties

      $scope.totalIncompleteGD = [];
      $scope.totalIncompleteGD = groundDuties.filter(function (x) {
        return x.isManualEntry == true && !x.hasPendingCourse;
      }); // Flight duties

      $scope.totalIncompleteFlightDuties = [];
      $scope.totalIncompleteFlightDuties = crewRoutes.filter(function (x) {
        return x.isManualEntry && !x.hasPendingCourse;
      }); //

      if ($scope.totalIncompleteGD.length > 0 || $scope.totalIncompleteFlightDuties.length > 0) {
        $scope.showPastTrainingsSummary = true;
      } // Used for pending trainings notification        


      $scope.manualGroundDuties = GroundDutyFactory.getManualGroundDutiesFromStorage();
      findManualEntries($scope.manualGroundDuties);
      $scope.manualFlightTrainings = CrewRouteFactory.getManualFlightTrainingsFromStorage();
      findManualFlightTrainingEntries($scope.manualFlightTrainings);
      var traineeFlightCourses = TraineeCoursesDetailsFactory.getFlightCourses();
      var flightEvents = formatFlights(flights, traineeFlightCourses);
      var crewHotelsEvents = formatHotels(crewHotels);
      var events = flightEvents.concat(groundDutiesEvents).concat(crewRoutesEvents).concat(crewHotelsEvents);
      var specialDates = findScheduleChangedDates();
      $scope.events = events;
      calendar(events, specialDates);
      var needsToSync = false; // check the last sync date

      var lastLog = SyncLogFactory.getSyncLog();
      var canShowSync = true;

      if (lastLog == null) {
        needsToSync = true;
      } else {
        canShowSync = lastLog.canShowSync(); //used to avoid showing again and again the dialog :: delay X minutes before showing again

        if (lastLog.date == null) needsToSync = true;else if (lastLog.date != null) {
          if (Date.today().add(-1).days().toUTC().isAfter(new Date(lastLog.date).toUTC()) || lastLog.forceSync) {
            if (!isReload) needsToSync = true;
          }
        }
      }

      var isOpenUpdateModal = ($(".modal-updating").data('bs.modal') || {
        isShown: false
      }).isShown;

      if (needsToSync && canShowSync && !isOpenUpdateModal) {
        $scope.openSynch();
      } else {
        MemoFactory.getMandatoryUnreadMemos(function (memos) {
          $scope.mandatoryUnread = memos.length;

          if ($scope.mandatoryUnread > 0) {
            openMandatoryModal();
          }
        });
      }

      $scope.showExpiriesAlertCalendar = showExpiriesAlertCalendar();
      $scope.showSubmissionDeadlineAlertCalendar = showSubmissionDeadlineAlertCalendar(); // Expired Expiries

      $scope.showExpiredExpiriesAlertCalendar = false;
      $scope.expiredExpiriesList = [];
      ExpiriesFactory.getExpiredExpiries().then(function (list) {
        $scope.expiredExpiriesList = list || [];
        $scope.showExpiredExpiriesAlertCalendar = $scope.expiredExpiriesList.length > 0;
      }, function () {
        $scope.expiredExpiriesList = [];
        $scope.showExpiredExpiriesAlertCalendar = false;
      });
      $scope.showCheckInAction = showCheckInAction();
      preparePasswordExpiryData();
      showReminderModal();
    }
    /**
     * Finds the dates with a change on their schedule
     * @memberof CalendarCtrl
     * @return {array} scheduleChangedDates
     */


    function findScheduleChangedDates() {
      var scheduleChangedDates = ScheduleAcknowledgeFactory.getScheduleChangesFromStorage();
      $scope.hasScheduleChanged = scheduleChangedDates.some(function (s) {
        return s;
      });
      return scheduleChangedDates;
    }
    /**
     * Finds the dates with manual pending training entries on their schedule
     * @memberof CalendarCtrl        
     */


    function findManualEntries(manualDuties) {
      for (var i = 0; i < manualDuties.length; i++) {
        if (manualDuties[i].hasPendingCourse) {
          $scope.hasManualEntry = true;
          break;
        }
      }
    }

    function findManualFlightTrainingEntries(manualFlightTrainings) {
      for (var i = 0; i < manualFlightTrainings.length; i++) {
        if (manualFlightTrainings[i].hasPendingCourse) {
          $scope.hasManualEntry = true;
          break;
        }
      }
    }
    /**
     * Initialize Calendar
     * @memberof CalendarCtrl
     * @param {array} events Flights and Ground duties 
     * @param {array} specialDates The Schedule Changed Dates
     */


    function calendar(events, specialDates) {
      $("#calendar").fullCalendar({
        defaultView: getDefaultView(),
        defaultDate: defaultCalendarDate,
        firstDay: 1,
        lang: 'en',
        editable: false,
        draggable: false,
        selectable: false,
        selectHelper: false,
        unselectAuto: false,
        disableResizing: false,
        droppable: false,
        fixedWeekCount: false,
        nextDayThreshold: "00:00:00",
        header: {
          left: 'title',
          center: '',
          right: 'month,listMonth today prev,next'
        },
        timeFormat: 'HH:mm',
        displayEventEnd: true,
        events: events,
        eventRender: function eventRender(event, element, icon) {
          if ($('#calendar').fullCalendar('getView').type === 'listMonth') {
            element.find('.fc-list-item-title').addClass('listview-icon');
            $.each(event.className, function (index, icon) {
              element.addClass(event.listViewColor);
            }); // $.each(event.icons, function (index, icon) {
            //     element.find('.listview-icon').prepend("<i style='padding-right:5px;' class='fa " + icon + " '></i> ");
            // });

            if (!event.description == "") {
              element.find('.fc-list-item-title').append("<span>" + "  " + event.description + "</span>");
            }

            if (!event.icon == "") {
              element.find('.fc-list-item-title').append("<i class='listViewCalendar-icon fa " + event.icon + " '></i>");
            }

            if (!event.second_icon == "") {
              element.find('.fc-list-item-title').append("<i class='listViewCalendar-icon fa " + event.second_icon + " '></i>");
            }

            if (!event.third_icon == "") {
              element.find('.fc-list-item-title').append("<i class='listViewCalendar-icon fa " + event.third_icon + " '></i>");
            }
          } else {
            if (event.type == "crewRoute" || event.type == "hotel") {
              element.find('.fc-time').remove();
            }

            element.find('.fc-title').prepend("<br/>");

            if (!event.description == "") {
              if (event.routeIndicators && event.routeIndicators.length > 0) {
                var routeIndicatorLetters = "";

                for (var j = 0; j < event.routeIndicators.length; j++) {
                  var letter = "<strong class='pull-right " + event.routeIndicators[j].routeIndicatorColor + "'>" + event.routeIndicators[j].routeIndicatorCode + "</strong>";
                  routeIndicatorLetters = routeIndicatorLetters + letter;
                }

                element.find('.fc-title').append("<br/><span class='calendar-light'>" + event.description + "</span>" + routeIndicatorLetters + "<br/>");
              } else {
                element.find('.fc-title').append("<br/><span class='calendar-light'>" + event.description + "</span> <br/>");
              }
            }

            if (!event.icon == "") {
              element.find('.fc-title').append("<i class='calendar-icon fa " + event.icon + " '></i>");
            }

            if (!event.second_icon == "") {
              element.find('.fc-title').append("<i class='calendar-second-icon fa " + event.second_icon + " '></i>");
            }

            if (!event.third_icon == "") {
              element.find('.fc-title').append("<i class='calendar-second-icon fa " + event.third_icon + " '></i>");
            }
          }
        },
        dayRender: function dayRender(date, cell) {
          for (var i = 0; i < specialDates.length; i++) {
            var objdate = new Date(specialDates[i]);
            if (date._d.getFullYear() == objdate.getFullYear() && date._d.getDate() == objdate.getDate() && date._d.getMonth() == objdate.getMonth()) cell.addClass('bg-yellow');
          }
        },
        dayClick: function dayClick(date, jsEvent, view) {},
        eventClick: function eventClick(calEvent, jsEvent, view) {
          if (calEvent.type == "flight") {
            $timeout(function () {
              gotoFlightInfo(calEvent._id);
            });
          } else if (calEvent.type == "groundDuty") {
            $timeout(function () {
              gotoGroundDutyInfo(calEvent._id);
            });
          } else if (calEvent.type == "crewRoute") {
            $timeout(function () {
              gotoCrewRouteInfo(calEvent.dutyNo, calEvent.dutyDay);
            });
          }
        },
        height: 'auto'
      });

      function getDefaultView() {
        var calendarStyle = SettingsMain.getCalendarViewStyle();

        if (calendarStyle == null) {
          calendarStyle = detectMobile() ? "listMonth" : "month";
        }

        return calendarStyle;
      }

      function detectMobile() {
        var isMobile = window.innerWidth <= 800 && window.innerHeight <= 735;
        return isMobile;
      }

      $('.fc-listMonth-button').click(function () {
        SettingsMain.setCalendarViewStyle('listMonth');
      });
      $('.fc-month-button').click(function () {
        SettingsMain.setCalendarViewStyle('month');
      });
    }
    /**
     * Transform flights in calendar events
     * @memberof CalendarCtrl
     * @param {array} flights The Scheduled Flights 
     * @return {array} events 
     */


    function formatFlights(flights, traineeFlightCourses) {
      var flightEvents = [];

      for (var i = 0; i < flights.length; i++) {
        var description = flights[i].getRoute();
        var title = flights[i].FlightNo;
        var third_icon = "";
        var flightCourseStatuses = [];
        var flightCoursesFlat = [];

        if (flights[i].TrainingIndicatorCode) {
          title = title + " " + flights[i].TrainingIndicatorCode;
        }
        /* Trainee flight courses */


        var relatedFlightTraineeCourses = [];

        for (var j = 0; j < traineeFlightCourses.length; j++) {
          if (flights[i].IsTrainee == true && flights[i].FlightId == traineeFlightCourses[j].FlightId) {
            relatedFlightTraineeCourses = traineeFlightCourses.find(function (x) {
              return x.FlightId == flights[i].FlightId;
            });
            flightCoursesFlat = flightCoursesFlat.concat(relatedFlightTraineeCourses);
            /*  NotSet = 0,
                InProgress = 1,
                Completed = 2,
                Pending = 3,
                NeedsApproval = 4,
                NotCompleted = 5 
            */
          }

          if (flightCoursesFlat.length > 0) {
            console.log(relatedFlightTraineeCourses);
            console.log(flightCourseStatuses);
          }
        }

        if (flightCoursesFlat.length > 0) {
          flightCoursesFlat.forEach(function (x) {
            flightCourseStatuses.push(x.Status);
          });
        }

        if (flightCourseStatuses.includes(1)) {
          //Pending
          third_icon = "fa-graduation-cap text-blue";
        } else if (flightCourseStatuses.includes(2)) {
          //Completed
          third_icon = "fa-graduation-cap text-green";
        } else if (flightCourseStatuses.includes(4) || flightCourseStatuses.includes(5)) {
          //Needs approval or stopped
          third_icon = "fa-graduation-cap text-orange";
        }

        var classname = "";
        var icon = "fa-plane";
        var second_icon = "";
        var id = flights[i].FlightId;
        var type = "flight";
        var listViewColor = "";
        /*              Weights for status of reports
                        6 --> na
                        5 --> draft
                        4 --> pendingoverdue
                        3 --> pending
                        2 --> completed
                        1 --> synched */

        var CabinReportStatusWeight = 0;
        if (flights[i].LineStatus === 'na') CabinReportStatusWeight = 6;else if (flights[i].LineStatus === 'pending') CabinReportStatusWeight = 3;else if (flights[i].LineStatus === 'pendingoverdue') {
          CabinReportStatusWeight = 4;
          $scope.pendingOverdueReports++;
        } else if (flights[i].LineStatus === 'draft' || flights[i].LineStatus === 'draftotheruser') {
          $scope.draftReports++;
          CabinReportStatusWeight = 5;
        } else if (flights[i].LineStatus === 'completed' || flights[i].LineStatus === 'completedotheruser') {
          $scope.completedReports++;
          CabinReportStatusWeight = 2;
        } else if (flights[i].LineStatus === 'stored' || flights[i].LineStatus === 'storedotheruser' || flights[i].LineStatus === 'stored+otheruser' || flights[i].LineStatus === 'synched' || flights[i].LineStatus === 'synchedotheruser') {
          CabinReportStatusWeight = 1;
        }
        var faAssessmentStatusWeight = 0;

        if (isAssessmentEnabled && flights[i].assessment) {
          if (flights[i].assessment.IsExist || flights[i].assessment.Status == 'Stored' || flights[i].assessment.Status == 'Synched') {
            faAssessmentStatusWeight = 1;
          } else if (flights[i].assessment.Status == 'Completed') {
            faAssessmentStatusWeight = 2;
          } else if (flights[i].assessment.Status == 'Pending') {
            faAssessmentStatusWeight = 3;
          } else if (flights[i].assessment.Status == 'Draft') {
            faAssessmentStatusWeight = 5;
          }
        }

        var saAssessmentStatusWeight = 0;

        if (isAssessmentEnabled && flights[i].saAssessment) {
          var nowUtc = moment();

          if (defaultCalendarDate) {
            nowUtc = moment(defaultCalendarDate);
          } // Check if the assessment is outdated


          var isOutDated = flights[i].saAssessment.LatestEndPeriod ? moment(flights[i].saAssessment.LatestEndPeriod).add(1, 'day').isBefore(nowUtc, 'day') : false;

          if (flights[i].saAssessment.IsExist || flights[i].saAssessment.Status == 'Stored' || isOutDated) {
            saAssessmentStatusWeight = 1;
          } else if (flights[i].saAssessment.Status == 'Completed') {
            saAssessmentStatusWeight = 2;
          } else if (flights[i].saAssessment.Status == 'Pending') {
            saAssessmentStatusWeight = 3;
          } else if (flights[i].saAssessment.Status == 'Draft') {
            saAssessmentStatusWeight = 5;
          }
        }

        var assfReportWeight = 0;

        if ($scope.isUserSA) {
          if (flights[i].assfReport && flights[i].assfReport.isRequired) {
            if (flights[i].assfReport.status == 'Stored') {
              assfReportWeight = 1;
            } else if (flights[i].assfReport.status == 'Completed') {
              assfReportWeight = 2;
            } else if (flights[i].assfReport.status == 'Pending') {
              assfReportWeight = 3;
            } else if (flights[i].assfReport.status == 'Draft') {
              assfReportWeight = 5;
            }
          }
        }

        var statusWeight = 0;
        var statusWeightWithoutReport = Math.max(assfReportWeight, faAssessmentStatusWeight, saAssessmentStatusWeight || 0); // Compute the maximum:

        if (statusWeightWithoutReport !== 0 && CabinReportStatusWeight == 6) {
          statusWeight = statusWeightWithoutReport;
        } else {
          statusWeight = Math.max(CabinReportStatusWeight, assfReportWeight, faAssessmentStatusWeight, saAssessmentStatusWeight || 0);
        }

        if (statusWeight == 6) {
          if (flights[i].IsDHC) {
            classname = "fc-aluminum";
            icon = "";
            listViewColor = "lv-aluminium";
          } else {
            classname = "fc-white";
            icon = "";
            listViewColor = "lv-white";
          }
        } else if (statusWeight == 5) {
          classname = "fc-orange";
          icon = "fa-pencil";
          listViewColor = "lv-orange";
        } else if (statusWeight == 4) {
          classname = "fc-seablue";
          icon = "fa-exclamation-triangle text-lemon";
          listViewColor = "lv-seablue";
        } else if (statusWeight == 3) {
          classname = "fc-blue";
          icon = "fa-plus";
          listViewColor = "lv-blue";
        } else if (statusWeight == 2) {
          classname = "fc-purple";
          icon = "fa-check-circle";
          listViewColor = "lv-purple";
        } else if (statusWeight == 1) {
          classname = "fc-green";
          icon = "fa-cloud-download";
          listViewColor = "lv-green";
        }

        if (flights[i].IsScheduleChanged && flights[i].LineStatus != 'na') {
          classname = classname + " text-yellow-important";
        }

        if (flights[i].LineStatus === 'draftotheruser' || flights[i].LineStatus === 'completedotheruser' || flights[i].LineStatus === 'synchedotheruser' || flights[i].LineStatus === 'storedotheruser' || flights[i].LineStatus === 'stored+otheruser') second_icon = "fa-user";
        var IsScheduleChanged = flights[i].IsScheduleChanged;
        var ScheduledDeparture = flights[i].ScheduledDeparture;

        if (flights[i].ScheduledArrival == null) {
          var ScheduledArrival = ScheduledDeparture;
        } else {
          var ScheduledArrival = flights[i].ScheduledArrival;
        }

        var event = {
          _id: id,
          title: title,
          start: ScheduledDeparture,
          end: ScheduledArrival,
          description: description,
          icon: icon,
          second_icon: second_icon,
          className: classname,
          type: type,
          isScheduleChanged: IsScheduleChanged,
          listViewColor: listViewColor,
          third_icon: third_icon
        };
        flightEvents.push(event);
      }

      return flightEvents;
    }
    /**
     * Transform Ground Duties in calendar events
     * @memberof CalendarCtrl
     * @param {array} duties The Scheduled Ground Duties 
     * @return {array} events 
     */


    function formatGroundDuties(duties, traineeGroundCourses) {
      var groundEvents = [];
      var now = moment.utc();

      for (var i = 0; i < duties.length; i++) {
        var description = duties[i].Code;
        var title = duties[i].Title ? duties[i].Title : duties[i].Duty;
        var classname = "fc-white";
        var icon = "";
        var second_icon = "";

        if (duties[i].RelatedGroundDuties && duties[i].RelatedGroundDuties.length > 1) {
          icon = "fa-graduation-cap"; // icon only if training
          //Get ground courses

          var courseStatuses = [];
          var coursesFlat = [];

          for (var j = 0; j < duties[i].RelatedGroundDuties.length; j++) {
            /* Trainee ground courses */
            if (traineeGroundCourses.length > 0) {
              var relatedTraineeCourse = traineeGroundCourses.find(function (x) {
                return x.GroundDutyId == duties[i].Id;
              });
            }

            var relatedDutyCourse = duties[i].RelatedGroundDuties[j].Courses;

            if (relatedDutyCourse) {
              coursesFlat = coursesFlat.concat(relatedDutyCourse);
            }

            if (relatedTraineeCourse) {
              coursesFlat = coursesFlat.concat(relatedTraineeCourse);
            }

            coursesFlat.forEach(function (x) {
              courseStatuses.push(x.Status);
            });
          }
          /*Statuses
              Completed : session has been sent
              Outdated  :	session submission is overdue
              Draft	  : session completion has started but not submitted
              Pending   : session submission not yet due
          */

          /*  NotSet = 0,
              InProgress = 1,
              Completed = 2,
              Pending = 3,
              NeedsApproval = 4,
              NotCompleted = 5 
          */


          if (courseStatuses.includes("Pending") || courseStatuses.includes(1)) {
            //Pending
            classname = "fc-blue-inverted"; //Outdated

            var dutyEnd = moment.utc(duties[i].DutyEnd);
            var duration = moment.duration(now.diff(dutyEnd)).asHours();

            if (duration > 1) {
              if (courseStatuses.includes("Pending") || courseStatuses.includes('1')) $scope.hasUnsetTraining = true;
              classname = "fc-seablue-inverted";
              second_icon = "fa-exclamation-triangle text-yellow second-icon-training"; // isManualEntry = true;
            } //Draft


            var courseId = coursesFlat[0].CourseId; // Fix msis // each duty should contain ONLY ONE COURSE

            var duty = duties[i];

            if (groundSessions && groundSessions.length) {
              var existingSession = groundSessions.find(function (s) {
                return s.courseId == courseId && s.day == duty.DutyDateS && s.dutyId == duty.Id;
              });

              if (existingSession && !existingSession.HasLimitedInfo && existingSession.trainees && existingSession.trainees.length) {
                //a training session with trainees exists
                classname = "fc-orange-inverted";
                icon = "fa-graduation-cap";
                second_icon = ""; // isManualEntry = true;
              }
            }
          } else if (courseStatuses.includes("Completed") || courseStatuses.includes(2)) {
            //Completed
            classname = "fc-green-inverted ";
          } else if (courseStatuses.includes(4) || courseStatuses.includes(5)) {
            //Needs approval or stopped
            classname = "fc-orange-inverted";
          }
        }

        if (duties[i].Unread) {
          second_icon = "fa-envelope text-orange";
        }

        var id = duties[i].Id;
        var type = "groundDuty";
        var start = duties[i].DutyBegin ? duties[i].DutyBegin : duties[i].DutyDateS ? duties[i].DutyDateS : duties[i].DutyDate;
        var end = duties[i].DutyEnd;
        var listViewColor = "lv-white";
        var event = {
          _id: id,
          title: title,
          start: start,
          end: end,
          description: description,
          icon: icon,
          second_icon: second_icon,
          className: classname,
          type: type,
          listViewColor: listViewColor
        };
        groundEvents.push(event);
      }

      return groundEvents;
    }
    /**
     * Transform Crew Routes in calendar events
     * @memberof CalendarCtrl
     * @param {array} routes The Scheduled Crew Routes 
     * @return {array} events 
     */


    function formatCrewRoutes(routes) {
      var crewRouteEvents = [];
      var now = moment.utc();

      for (var i = 0; i < routes.length; i++) {
        var description = routes[i].Route; // var title = (duties[i].Title)? duties[i].Title : duties[i].Duty;

        var classname = "fc-white";
        var icon = "";
        var second_icon = ""; //TODO:: athe clean up
        // var assessmentStatus = "";
        // if (isAssessmentEnabled && routes[i].AssessmentInfo) {
        //     if (routes[i].AssessmentInfo.IsExist || routes[i].AssessmentInfo.Status == "Stored") {
        //         assessmentStatus = "Synced";
        //         //classname = "fc-green-inverted ";
        //     } else if (routes[i].AssessmentInfo.Status == "Pending") {
        //         assessmentStatus = "Pending";
        //         //classname = "fc-blue-inverted";
        //     } else if (routes[i].AssessmentInfo.Status == "Draft") {
        //         assessmentStatus = "Draft";
        //         //classname = "fc-orange-inverted";
        //     } else if (routes[i].AssessmentInfo.Status == "Completed") {
        //         assessmentStatus = "Completed";
        //         //classname = "fc-purple-inverted";
        //     }
        // }
        //Get ground courses

        var courseStatuses = [];
        var courses = routes[i].Courses;
        courses.forEach(function (x) {
          courseStatuses.push(x.Status);
        });
        /*Statuses
            Completed : session has been sent
            Outdated  :	session submission is overdue
            Draft	  : session completion has started but not submitted
            Pending   : session submission not yet due
        */

        var trainingStatus = "";

        if (courseStatuses.includes("Pending")) {
          //Pending
          trainingStatus = "Pending"; //Outdated

          var dutyEnd = moment.utc(routes[i].DutyEnd);
          var duration = moment.duration(now.diff(dutyEnd)).asHours();

          if (duration > 1) {
            if (courseStatuses.includes("Pending")) $scope.hasUnsetTraining = true;
            trainingStatus = "Outdated";
          } //Draft


          var courseIds = courses.map(function (x) {
            return x.CourseId;
          });
          var route = routes[i];

          if (flightSessions && flightSessions.length) {
            //TODO msis fix
            var dutyBegin = new moment(route.DutyBegin).format("YYYY-MM-DD");
            var dutyEnd = new moment(route.DutyEnd).format("YYYY-MM-DD");
            var existingSessions = flightSessions.filter(function (s) {
              return courseIds.includes(s.courseId) && (new moment(s.day).isSame(dutyBegin) || new moment(s.day).isSame(dutyEnd) || new moment(s.day).isBetween(dutyBegin, dutyEnd)) && s.dutyDay == route.DutyDay && s.dutyNo == route.DutyNo;
            });

            if (existingSessions && existingSessions.some(function (x) {
              return !x.HasLimitedInfo && x.trainees && x.trainees.length;
            })) {
              //a training session with trainees exists
              trainingStatus = "Draft";
            }
          }
        } else if (courseStatuses.includes("Completed")) {
          //Completed
          trainingStatus = "Completed";
          classname = "fc-green-inverted ";
        } // Status outcome form bot assessment and training


        if (trainingStatus == "Outdated") {
          second_icon = "fa-exclamation-triangle text-yellow second-icon-training";
          classname = "fc-seablue-inverted";
        } else if (trainingStatus == "Draft") {
          classname = "fc-orange-inverted";
        } else if (trainingStatus == "Pending") {
          classname = "fc-blue-inverted"; // } else if (assessmentStatus == "Completed" ) {
          //     classname = "fc-purple-inverted";
        } else if (trainingStatus == "Completed") {
          classname = "fc-green-inverted";
        }

        if (courses && courses.length) {
          icon = "fa-graduation-cap";
        }

        var routeIndicators = [];

        if (routes[i].RouteIndicators) {
          // Swap : [RECTYPE] = 106
          // Pre-Assigned : [RECTYPE] = 1
          // Requested : [RECTYPE] = 100
          // Unfinalised : [RECTYPE] = 101
          var routeIndicatorCodes = routes[i].RouteIndicators.split(',').map(Number);

          for (var j = 0; j < routeIndicatorCodes.length; j++) {
            var routeIndicatorCode = "";
            var routeIndicatorColor = "";

            if (routeIndicatorCodes[j]) {
              if (routeIndicatorCodes[j] == 106) {
                routeIndicatorCode = "S";
                routeIndicatorColor = "text-purple";
              } else if (routeIndicatorCodes[j] == 1) {
                routeIndicatorCode = "P";
                routeIndicatorColor = "text-teal";
              } else if (routeIndicatorCodes[j] == 100) {
                routeIndicatorCode = "R";
              } else if (routeIndicatorCodes[j] == 101) {
                routeIndicatorCode = "U";
                routeIndicatorColor = "text-red";
              }

              if (routeIndicatorCode.length > 0) {
                routeIndicators.push({
                  routeIndicatorCode: routeIndicatorCode,
                  routeIndicatorColor: routeIndicatorColor
                });
              }
            }
          }
        } // var id = routes[i].Id;


        var type = "crewRoute";
        var dutyNo = routes[i].DutyNo;
        var dutyDay = routes[i].DutyDay;
        var start = routes[i].DutyBegin ? routes[i].DutyBegin : routes[i].DutyDateS ? routes[i].DutyDateS : routes[i].DutyDate;
        var end = routes[i].DutyEnd;
        var listViewColor = "lv-white";
        var event = {
          // _id:id,
          // title: title,
          dutyNo: dutyNo,
          dutyDay: dutyDay,
          start: start,
          end: end,
          description: description,
          icon: icon,
          second_icon: second_icon,
          className: classname,
          type: type,
          listViewColor: listViewColor,
          routeIndicators: routeIndicators
        };
        crewRouteEvents.push(event);
      }

      return crewRouteEvents;
    }
    /**
     * Transform Crew Hotels in calendar events
     * @memberof CalendarCtrl
     * @param {array} crew hotels 
     * @return {array} events 
     */


    function formatHotels(hotels) {
      var crewRouteEvents = [];

      for (var i = 0; i < hotels.length; i++) {
        //var description = hotels[i].HotelName;
        var title = hotels[i].HotelName;
        var classname = "fc-gray-inverted";
        var icon = "fa-bed";
        var second_icon = ""; // var id = routes[i].Id;

        var type = "hotel";
        var start = moment(hotels[i].DutyDate).endOf('day').toJSON(); // var end = hotels[i].DutyDate;

        var listViewColor = "lv-white";
        var event = {
          // _id:id,
          title: title,
          start: start,
          end: start,
          //description:description,
          icon: icon,
          second_icon: second_icon,
          className: classname,
          type: type,
          listViewColor: listViewColor
        };
        crewRouteEvents.push(event);
      }

      return crewRouteEvents;
    }
    /** Removes manual training entry */


    function removeManualEntry(groundDuty) {
      GroundDutyFactory.removeGroundDuty(groundDuty);
      $route.reload();
    }
    /**
     * Removes manual flight training entry 
     * @param {*} dutyNo 
     * @param {*} dutyDay 
     */


    function removeFlightTrainingManualEntry(dutyNo, dutyDay) {
      CrewRouteFactory.removeFlightTraining(dutyNo, dutyDay);
      setupView();
      $route.reload();
    }

    function removePendingGDEntry(groundDuty) {
      $scope.totalIncompleteGD.find(function (x) {
        return x.Id == groundDuty;
      }).isManualEntry = false;
      GroundDutyFactory.removeGroundDuty(groundDuty);
      return $scope.totalIncompleteGD;
    }

    function removePendingFlightEntry(dutyNo, dutyDay) {
      $scope.totalIncompleteFlightDuties.find(function (x) {
        return x.FlightId == dutyNo;
      }).isManualEntry = false;
      return $scope.totalIncompleteFlightDuties;
    }
    /**
     * Open Synch Modal
     * @memberof CalendarCtrl
     */


    function openSynch() {
      //store last time the sync dialog was displayed
      SyncLogFactory.setLastShow();
      openSynchModal();
    }

    function openSynchModal() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgSynch.html',
        controller: 'SynchCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      });
      modalInstance.result.then(function (synchresult) {
        //refresh the view after a successful sync
        if (!synchresult == 'cancel') {
          $scope.setupView(true);
        }
      }, function () {});
    }

    function openMandatoryModal() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgMandatory.html',
        controller: 'MandatoryModalCtrl',
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          mandatoryUnread: $scope.mandatoryUnread
        }
      });
    }
    /**
     * Open the "Add a flight" Modal
     * @memberof CalendarCtrl
     */


    function addFlight() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgAddFlight.html',
        controller: 'AddFlightCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      });
    }
    /**
     * Open the "Search Ground Duties" Modal
     * @memberof CalendarCtrl
     */


    function searchPastGroundDuties() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgSearchGroundDuties.html',
        controller: 'SearchPastGDCtrl',
        size: 'md',
        backdrop: 'static',
        keyboard: false
      });
    }

    function acknowledge() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgAcknowledgeChanges.html',
        controller: 'AcknowledgeModalCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      });
    }
    /**
     * Gets showExpiriesAlert value
     * @memberof calendarNotifications
     */


    function showExpiriesAlertCalendar() {
      return ExpiriesFactory.showExpiriesAlert();
    }
    /**
     * Gets showSubmissionDeadlineAlert value
     * @memberof calendarNotifications
     */


    function showSubmissionDeadlineAlertCalendar() {
      return RequestFactory.showSubmissionDeadlineAlert();
    }

    function showCheckInAction() {
      var retVal = false;
      var checkInInfo = CheckInFactory.getCheckInInfoFromStorage();

      if (checkInInfo && checkInInfo.AimsId > 0) {
        var now = moment.utc(); //Fetch FROM
        //Convert from Date UTC to Moment UTC

        var std = moment.utc(checkInInfo.STD);
        var minFetchTime = moment(std).add(-2, 'hours'); //Fetch UNTIL    

        var maxFetchTime = moment(std).add(10, 'minutes');
        var isAfter = now.isAfter(minFetchTime);
        var isBefore = now.isBefore(maxFetchTime);

        if (isAfter && isBefore) {
          retVal = true;
        } //console.log({"isAfter":isAfter, "isBefore": isBefore, "now":now, "std":std, "minFetchTime":minFetchTime,"maxFetchTime":maxFetchTime});

      }

      return retVal;
    }

    function preparePasswordExpiryData() {
      //update PasswordExpiry scope:
      var user = UserFactory.getUser();

      if (user && user.passwordLastChangeDate) {
        var today = new Date();
        var lastChangeDate = new Date(user.passwordLastChangeDate);
        var expirationDate = lastChangeDate.AddDays(90); // how many days until duty date

        var diffDays = Date.DifferenceInDays(today.trimTime(), expirationDate.trimTime());
        $scope.passwordExpiry = {
          showAlert: diffDays >= 0 && diffDays <= 14,
          lastChange: lastChangeDate,
          daysLeft: diffDays
        };
      }
    }
    /**
     * Shows the bootbox for schedule acknowledge reminder
     * @memberof calendarNotifications
     */


    function showReminderModal() {
      var _showScheduleChangesReminder = ScheduleAcknowledgeFactory.showScheduleChangesModal();

      var _showExpiriesReminder = ExpiriesFactory.showExpiriesModal();

      var _showSubmissionDeadlineReminder = RequestFactory.showSubmissionDeadlineModal();

      var _showSaAssessmentReminder = SaFeedbackInfoFactory.showSaAssessmentReminderModal();

      if (_showScheduleChangesReminder || _showExpiriesReminder || _showSubmissionDeadlineReminder || _showSaAssessmentReminder) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Dialogs/dlgReminderModal.html',
          controller: 'ReminderModalCtrl',
          size: 'md',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            showScheduleChangesReminder: function showScheduleChangesReminder() {
              return _showScheduleChangesReminder;
            },
            showExpiriesReminder: function showExpiriesReminder() {
              return _showExpiriesReminder;
            },
            showSubmissionDeadlineReminder: function showSubmissionDeadlineReminder() {
              return _showSubmissionDeadlineReminder;
            },
            showSaAssessmentReminder: function showSaAssessmentReminder() {
              return _showSaAssessmentReminder;
            }
          }
        });
      }
    }

    function showExpiredExpiriesAlertCalendar() {
      return ExpiriesFactory.showExpiredExpiriesAlert();
    }
    /**
     * Open Check in Modal
     * @memberof CalendarCtrl
     */


    function openCheckInModal() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgCheckIn.html',
        controller: 'CheckInModalCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      });
    }
    /**
     * Redirect to flight Info
     * @memberof CalendarCtrl
     */


    function gotoFlightInfo(FlightId) {
      $location.path('/flightinfo/' + FlightId);
    }
    /**
     * Redirect to groundDuty Info
     * @memberof CalendarCtrl
     */


    function gotoGroundDutyInfo(GroundDutyId) {
      $location.path('/groundDuty/' + GroundDutyId);
    }
    /**
    * Redirect to crewRoute Info
    * @memberof CalendarCtrl
    */


    function gotoCrewRouteInfo(dutyNo, dutyDay) {
      $location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
    }
    /**
     * Redirect to crewRoute Info
     * @memberof CalendarCtrl
     */


    function gotoCrewRouteInfo(dutyNo, dutyDay) {
      $location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
    }
    /**
     * Redirect to Library Info with filter enabled
     * @memberof CalendarCtrl
     */


    function gotoUnreadMemos() {
      $location.path('/memos/unread');
    }
    /**
     * Redirect to messages
     * @memberof CalendarCtrl
     */


    function gotoMessages() {
      $location.path('/messages/');
    }
    /**
     * Redirect to leaves
     * @memberof CalendarCtrl
     */


    function gotoLeaves() {
      $location.path('/leaverequest/');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('FlightFactory', FlightFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name FlightFactory
  * @description 
  *   Add, Update, Delete and Get Flights 
  * @ngInject
  */

  function FlightFactory($log, $filter, localStorageMD5Service, UserFactory, CabinReportLocalEditFactory, ServerCabinReportFactory, FlightCrewMemberFactory, MessageFactory, liveVersion, GenericService, SyncLogFactory) {
    var daysThatAFlightIsConsideredTooOld = -20;
    /**
    * Initialize the Flight
    * @memberof FlightFactory
    */

    function Flight() {
      this.AcTailNo = null;
      this.AcType = null;
      this.Category = null;
      this.CrewAimsId = null;
      this.Departure = null;
      this.Arrival = null;
      this.FlightAimsId = null;
      this.FlightId = null;
      this.FlightDate = null;
      this.FlightNo = null;
      this.IsDHC = null;
      this.Position = null; //v1.1 added pax and dep/arr details

      this.BookedC = null;
      this.BookedY = null;
      this.BookedInf = null;
      this.BookedPad = null;
      this.BookedChld = null;
      this.ActualC = null;
      this.ActualY = null;
      this.ActualInf = null;
      this.ActualPad = null;
      this.ActualChld = null;
      this.DepartureICAO = null;
      this.DepartureCountry = null;
      this.DepartureName = null;
      this.ArrivalICAO = null;
      this.ArrivalCountry = null;
      this.ArrivalName = null;
      this.ScheduledDeparture = null;
      this.Status = null;
      this.LineStatus = null;
      this.LineStatusDescr = null;
      this.LocalReportId = null;
      this.ServerReportLink = null;
      this.ScheduledDepartureDateUTC = null;
      this.ScheduledDepartureTimeUTC = null;
      this.LocalReportHasNothingToReport = false;
      this.ServerReportHasNothingToReport = false;
      this.IsLocal = false;
      this.cabinReports = [];
      this.cabinReportStatusDescr = '';
      this.crew = new Array(); //new fields

      this.DepartureGate = null;
      this.DepartureTimezone = null;
      this.ArrivalTimezone = null;
      this.CallSign = null;
      this.ScheduledArrival = null;
      this.messages = null;
      this.assessment = null;
      this.Route = null;
      this.DutyDate = null;
      this.FlightsFilters = [];
      this.ETA = null;
      this.IsScheduleChanged = false; //zones

      this.Zones = []; //

      this.AircraftDifferences = [];
      this.GetId = GetId;
      this.getRoute = getRoute;
      this.getDescription = getDescription;
      this.getSeniorAttendantsCount = getSeniorAttendantsCount; //TODO REMOVE CHECK VALIDITY WITH NEW VIEW

      this.initializeCabinReportStatus = initializeCabinReportStatus;
      this.getCabinReportStatusDescr = getCabinReportStatusDescr;
      this.getServerCabinReportForUser = getServerCabinReportForUser;
      this.getServerCabinReportsByAnotherUser = getServerCabinReportsByAnotherUser;
      this.initialize = initialize;
    }

    var service = {
      getFlightsFromStorage: getFlightsFromStorage,
      getFlightFromTotalFlights: getFlightFromTotalFlights,
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      getFlightsFromStorageAndCheckIfTooOld: getFlightsFromStorageAndCheckIfTooOld,
      setFlightsToStorage: setFlightsToStorage,
      storeFlightsWithReportsAndMessages: storeFlightsWithReportsAndMessages,
      getFlightFromStorage: getFlightFromStorage,
      getFlightsByRoute: getFlightsByRoute,
      getFlightsByRoutePerDay: getFlightsByRoutePerDay,
      getLocalFlightFromStorage: getLocalFlightFromStorage,
      createLocalFlight: createLocalFlight,
      saveLocalFlight: saveLocalFlight,
      getLocalFlightsAndMergeWithServerFlights: getLocalFlightsAndMergeWithServerFlights,
      updateFlightFromReport: updateFlightFromReport,
      updateFlight: updateFlight,
      mergeFlightInfo: mergeFlightInfo,
      markScheduleChangedFlights: markScheduleChangedFlights,
      initializeFlights: initializeFlights,
      getFlightsByDutyNo: getFlightsByDutyNo,
      getFlightsWithStoredReport: getFlightsWithStoredReport,
      getFlightsByFlightId: getFlightsByFlightId,
      insertFlightsWithPendingTrainings: insertFlightsWithPendingTrainings,
      getTheFirstAndTheLastFlightDates: getTheFirstAndTheLastFlightDates
    };
    var objType = 'flights';
    var objCallback = Flight; //Object Functions

    /**
     * Overide default get Id
     * @memberof FlightFactory
     * @returns {number} Id 
     */

    function GetId() {
      return this.FlightId;
    }
    /**
     * Get flight's Route
     * @memberof FlightFactory
     * @returns {string} route 
     */


    function getRoute() {
      if (this.Departure == null && this.Arrival == null) return '-null-';else return (this.Departure || '?') + '-' + (this.Arrival || '?');
    }
    /**
     * Get flight's description
     * @memberof FlightFactory
     * @returns {string} description 
     */


    function getDescription() {
      if (this.FlightNo == null && this.Departure == null && this.Arrival == null) return '-null-';else return (this.ScheduledDepartureDateUTC || '?') + ' ' + (this.FlightNo || '?') + ' ' + (this.Departure || '?') + '-' + (this.Arrival || '?');
    }
    /**
     * Get flight's Senior Attendants Count
     * @memberof FlightFactory
     * @returns {number} seniorAttendantsCount 
     */


    function getSeniorAttendantsCount() {
      if (this.crew == null || this.crew.length == 0) return 0;
      var count = 0;
      var attendants = $filter('filter')(this.crew, {
        position: 'SA',
        isDHC: false
      });
      if (attendants != null) count = attendants.length;
      return count;
    }

    function insertFlightsWithPendingTrainings(flightsWithPendings) {
      if (flightsWithPendings) {
        var flights = getFlightsFromStorage();
        var flightIdsLS = flights.map(function (x) {
          return x.FlightId;
        });
        var flightsToInsert = flightsWithPendings.filter(function (f) {
          return !flightIdsLS.includes(f.FlightId);
        });
        var updatedFlightList = flights.concat(flightsToInsert);
        setFlightsToStorage(updatedFlightList);
      }
    }
    /**
     * Initialize Cabin report Status
     * @memberof FlightFactory
     */


    function initializeCabinReportStatus() {
      // load the user
      var user = UserFactory.getUser(); //Cannot file a report when a problem with the user or if the
      //person is DHC on that flight

      if (user == null || this.IsDHC != 0) {
        this.LineStatus = "na";
        return;
      } //not an SA? Normally not allowed to file a report
      //UNLESS there is no SA on board
      else if (this.Position != 'SA' && this.getSeniorAttendantsCount() > 0 && this.AcType != "AT4") {
          //console.debug('FA with ' + this.getSeniorAttendantsCount() + ' SA(s) on board!');
          this.LineStatus = "na";
          return;
        } // initialize to pending


      this.LineStatus = "pending"; // check if there is a local edit report or a server report for this
      // flight

      var serverReportForThisUser = this.getServerCabinReportForUser(user.aimsId);
      var serverReportsByAnotherUser = this.getServerCabinReportsByAnotherUser(user.aimsId);
      var hasServerReportForThisUser = serverReportForThisUser != null;
      var hasServerReportsByAnotherUser = serverReportsByAnotherUser.length > 0;
      var localReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(this.FlightId);
      this.LocalReportId = null;
      this.ServerReportLink = null; // if there is a local copy of the report

      if (localReport != null) {
        this.LocalReportId = localReport.ReportGuid;
        this.LocalReportHasNothingToReport = localReport.NothingToReport;

        if (localReport.Status === 'draft') {
          if (hasServerReportsByAnotherUser) this.LineStatus = "draftotheruser";else this.LineStatus = "draft";
        } else if (localReport.Status === 'completed') {
          if (hasServerReportsByAnotherUser) this.LineStatus = "completedotheruser";else this.LineStatus = "completed";
        } else if (localReport.Status === 'synched') {
          if (hasServerReportsByAnotherUser) this.LineStatus = "synchedotheruser";else this.LineStatus = "synched";
        } else {
          if (hasServerReportsByAnotherUser) this.LineStatus = "draftotheruser";else this.LineStatus = "draft";
        }
      } else {
        // if there is a server report by this and by another user
        if (hasServerReportForThisUser && hasServerReportsByAnotherUser) {
          this.LineStatus = "stored+otheruser"; // Something if this or any other user has something to
          // report

          this.ServerReportHasNothingToReport = serverReportForThisUser.ReportedItems == 0;

          if (this.ServerReportHasNothingToReport) {
            // if nothing to report by this user, check if any other
            // user has something to report
            for (var i = 0; i < serverReportsByAnotherUser.length; i++) {
              if (serverReportsByAnotherUser[i].ReportedItems > 0) {
                this.ServerReportHasNothingToReport = false;
                break;
              }
            }
          }
        } // if there is a server report for another user
        else if (hasServerReportsByAnotherUser) {
            this.LineStatus = "storedotheruser";
            this.ServerReportHasNothingToReport = true;

            for (var i = 0; i < serverReportsByAnotherUser.length; i++) {
              if (serverReportsByAnotherUser[i].ReportedItems > 0) {
                this.ServerReportHasNothingToReport = false;
                break;
              }
            }
          } // if there is a server report for only this user
          else if (hasServerReportForThisUser) {
              this.LineStatus = "stored";
              this.ServerReportHasNothingToReport = serverReportForThisUser.ReportedItems == 0;
            } // no server report
            else {
                this.LocalReportId = "new"; // no server report found for this user, status is pending

                if (new Date(this.ScheduledDeparture) < new Date()) {
                  this.LineStatus = "pendingoverdue";
                } else {
                  this.LineStatus = "pending";
                }
              }
      }
    }
    /**
     * Get Cabin Report Status Descr
     * @memberof FlightFactory
     * @returns {string} description 
     */


    function getCabinReportStatusDescr() {
      if (this.LineStatus === 'na') return "n/a";else if (this.LineStatus === 'pending') return "Pending";else if (this.LineStatus === 'pendingoverdue') return "Pending";else if (this.LineStatus === 'draft') return "Draft";else if (this.LineStatus === 'completed') return "Completed";else if (this.LineStatus === 'synched') return "Synched";else if (this.LineStatus === 'draftotheruser') return "Draft +";else if (this.LineStatus === 'completedotheruser') return "Completed +";else if (this.LineStatus === 'synchedotheruser') return "Synched +";else if (this.LineStatus === 'stored') return "Stored";else if (this.LineStatus === 'storedotheruser') return "Stored";else if (this.LineStatus === 'stored+otheruser') return "Stored +";else return this.LineStatus;
    }
    /**
     * Get Server CabinReport For the selected User
     * @memberof FlightFactory
     * @param {number} userAimsId The user aims Id
     * @return {object} cabinReport 
     */


    function getServerCabinReportForUser(userAimsId) {
      if (this.cabinReports == null) return null;
      var result = null;

      for (var i = 0; i < this.cabinReports.length; i++) {
        if (this.cabinReports[i] != null) {
          if (this.cabinReports[i].AuthorAimsId == userAimsId) {
            result = this.cabinReports[i];
            break;
          }
        }
      }

      return result;
    }
    /**
     * Get Server CabinReport For others than the selected User
     * @memberof FlightFactory
     * @param {number} userAimsId The user aims Id
     * @return {object} cabinReport 
     */


    function getServerCabinReportsByAnotherUser(userAimsId) {
      if (this.cabinReports == null) return new Array();
      var result = new Array();

      for (var i = 0; i < this.cabinReports.length; i++) {
        if (this.cabinReports[i] != null) {
          if (this.cabinReports[i].AuthorAimsId != userAimsId) {
            result.push(this.cabinReports[i]);
          }
        }
      }

      return result;
    }
    /**
     * Initialize Cabin Report
     * @memberof FlightFactory
     */


    function initialize() {
      try {
        // SD date/time
        if (this.ScheduledDeparture != null) {
          var STD = this.ScheduledDeparture;
          if (STD.indexOf('Z') < 0) STD += 'Z';
          STD = new moment(STD);
          STD = new Date(STD);
          STD = STD.toUTC();
          this.ScheduledDepartureDateUTC = STD.toString('yyyy-MM-dd');
          this.ScheduledDepartureTimeUTC = STD.toString('HH:mm');
        } // initialize the cabin report status field


        this.initializeCabinReportStatus(); // initialize css classes for display

        this.cabinReportStatusDescr = this.getCabinReportStatusDescr();
      } catch (ex) {
        $log.error("initialize failed: " + ex.message);
      }
    } //Factory Functions

    /**
     * Extend Object from the default Flight Object
     * @memberof FlightFactory
     * @param {Object} obj  a Flight
     * @returns {Object} Flight
     */


    function fromObject(obj) {
      if (obj == null) return null;
      var flight = new Flight();
      angular.extend(flight, obj);
      if (obj.crew == null) obj.crew = [];
      flight.crew = new Array();

      for (var j = 0; j < obj.crew.length; j++) {
        flight.crew.push(FlightCrewMemberFactory.fromObject(obj.crew[j]));
      }

      return flight;
    }

    ;
    /**
     * Extend an array of Objects from the default flight Object
     * @memberof FlightFactory
     * @param {Array} objList  an Array Of flights
     * @returns {Array} flights
     */

    function fromObjectList(objList) {
      if (objList == null) return [];
      var arrayLength = objList.length;
      var flights = new Array();

      for (var i = 0; i < arrayLength; i++) {
        var flight = new Flight();
        angular.extend(flight, objList[i]);
        if (objList[i].crew == null) objList[i].crew = [];
        flights.push(flight);
      }

      return flights;
    }

    ;
    /**
     * Returns all the flights from storage
     * @memberof FlightFactory
     * @returns {Array} flights
     */

    function getFlightsFromStorage() {
      var objects = localStorageMD5Service.get(objType);
      return fromObjectList(objects);
    }
    /**
    * Returns the flights from local storage only if they are recent
    * @memberof FlightFactory
    * @returns {Array} flights
    */


    function getFlightsFromStorageAndCheckIfTooOld() {
      var result = getFlightsFromStorage();
      if (result == null) return null;
      var dataIsRecent = false;
      var arrayLength = result.length; // loop all flights and break if a flight in the last 10 days is found

      for (var i = 0; i < arrayLength; i++) {
        if (Date.today().add(daysThatAFlightIsConsideredTooOld).days().toUTC().isBefore(new Date(result[i].ScheduledDeparture).toUTC().trimTime())) {
          dataIsRecent = true;
          break;
        }
      }

      if (dataIsRecent == true || !liveVersion) return result;else return null;
    }
    /**
     * Set flights to  storage
     * @memberof FlightFactory
     * @returns {Array} flights
     */


    function setFlightsToStorage(flights) {
      for (var i = 0; i < flights.length; i++) {
        if (flights[i].FlightId == undefined || flights[i].FlightId == null) {
          flights[i].FlightId = guid();
        }
      }

      localStorageMD5Service.set('flights', flights);
    }
    /**
     * Initialize flights and save them
     * @memberof FlightFactory
     */


    function initializeFlights() {
      var objList = localStorageMD5Service.get(objType);
      if (objList == null) return null;
      var arrayLength = objList.length;
      var flights = new Array();

      for (var i = 0; i < arrayLength; i++) {
        var flight = new Flight();
        angular.extend(flight, objList[i]);
        if (objList[i].crew == null) objList[i].crew = [];
        flight.crew = new Array();

        for (var j = 0; j < objList[i].crew.length; j++) {
          flight.crew.push(FlightCrewMemberFactory.fromObject(objList[i].crew[j]));
        }

        flight.initialize();
        flights.push(flight);
      }

      localStorageMD5Service.set('flights', flights);
    }
    /**
    * Store Flights With Reports And Messages
    * @memberof FlightFactory
    * @param {Array} flights 
    * @param {Array} cabinReports
    * @param {Array} messages
    */


    function storeFlightsWithReportsAndMessages(flights, cabinReports, messages) {
      var flightsX = fromObjectList(flights);
      var cabinReportsX = ServerCabinReportFactory.fromObjectList(cabinReports);
      var messagesX = MessageFactory.fromObjectList(messages);

      if (flightsX && flightsX instanceof Array && flightsX.length > 0 && (cabinReportsX || messagesX)) {
        // loop all flights
        var user = UserFactory.getUser();
        var f, pr, me;

        for (var fi = 0; fi < flightsX.length; fi++) {
          f = flightsX[fi]; // find cabin reports for this flight

          f.cabinReports = [];
          f.messages = [];

          if (cabinReportsX && cabinReportsX instanceof Array && cabinReportsX.length > 0) {
            for (var pri = 0; pri < cabinReportsX.length; pri++) {
              pr = cabinReportsX[pri];

              if (pr.FlightId != null && pr.FlightId == f.FlightId) {
                if (pr.AuthorAimsId == f.CrewAimsId) {
                  pr.Source = ServerCabinReportFactory.constSourceStoredOwn;
                  f.cabinReports.push(pr);
                } else {
                  pr.Source = ServerCabinReportFactory.constSourceStoredOther;
                  f.cabinReports.push(pr);
                }
              }
            }
          }

          if (messagesX && messagesX instanceof Array && messagesX.length > 0) {
            for (var mi = 0; mi < messagesX.length; mi++) {
              me = messagesX[mi];
              var vf = moment.utc(me.ValidFrom);
              var vt = moment.utc(me.ValidTo);

              if (moment.utc(f.FlightDate).isBetween(vf, vt, undefined, '[]')) {
                if (me.QueryType.trim() == 'Country' && (me.Country.trim() == f.ArrivalCountry || me.Country.trim() == f.DepartureCountry)) {
                  f.messages.push(me.Id);
                } else if (me.QueryType.trim() == 'FlightNo' && me.FlightNo == f.FlightNo) {
                  f.messages.push(me.Id);
                } else if (me.QueryType.trim() == 'Airports') {
                  if (me.FlightDirection == 'DEP' && me.AirportA == f.Departure && me.AirportB == f.Arrival) {
                    f.messages.push(me.Id);
                  } else if (me.FlightDirection == 'ARR' && me.AirportB == f.Departure && me.AirportA == f.Arrival) {
                    f.messages.push(me.Id);
                  } else if (me.FlightDirection == 'ANY' && (me.AirportA == f.Departure && me.AirportB == f.Arrival || me.AirportB == f.Departure && me.AirportA == f.Arrival)) {
                    f.messages.push(me.Id);
                  }
                } else if (me.QueryType.trim() == 'Airport') {
                  if (me.FlightDirection == 'DEP' && me.AirportA == f.Departure) {
                    f.messages.push(me.Id);
                  } else if (me.FlightDirection == 'ARR' && me.AirportA == f.Arrival) {
                    f.messages.push(me.Id);
                  } else if (me.FlightDirection == 'ANY' && (me.AirportA == f.Departure || me.AirportA == f.Arrival)) {
                    f.messages.push(me.Id);
                  }
                } else if (me.QueryType.trim() == 'Registration' && f.AcTailNo == me.Registration) {
                  f.messages.push(me.Id);
                } else if (me.QueryType.trim() == 'AcType' && f.AcType == me.AcType) {
                  f.messages.push(me.Id);
                }
              }
            }
          }

          f.initialize();
        }
      }

      localStorageMD5Service.set('flights', flightsX);
    }
    /**
     * Get Flight from local and storage flights
     * @memberof FlightFactory
     * @param {number} flightId 
     * @return {object} flight
     */


    function getFlightFromTotalFlights(flightId) {
      var flight = getFlightFromStorage(flightId);

      if (!flight) {
        flight = getLocalFlightFromStorage(flightId);
      }

      return flight;
    }
    /**
     * Get Flight from storage flights
     * @memberof FlightFactory
     * @param {number} flightId 
     * @return {object} flight
     */


    function getFlightFromStorage(flightId) {
      var objects = localStorageMD5Service.get(objType);
      if (objects == null) return null;
      var result = null;
      var arrayLength = objects.length;

      for (var i = 0; i < arrayLength; i++) {
        if (objects[i].FlightId == flightId) {
          result = objects[i];
          break;
        }
      }

      return fromObject(result);
    }
    /**
     * Get the Flights of the selected route
     * @memberof FlightFactory
     * @param {string} Route 
     * @param {string} DutyDate 
     * @return {array} flights
     */


    function getFlightsByRoute(Route, DutyDate) {
      var flights = getFlightsFromStorage();
      if (flights == null) return [];
      var result = [];
      var arrayLength = flights.length;

      for (var i = 0; i < arrayLength; i++) {
        if (flights[i].Route == Route && flights[i].DutyDate == DutyDate) {
          result.push(flights[i]);
        }
      }

      return result;
    }

    function getFlightsByRoutePerDay(Route, DutyDate, FeedbackDate) {
      var flights = getFlightsFromStorage();
      if (flights == null) return [];
      var result = [];
      var arrayLength = flights.length;

      for (var i = 0; i < arrayLength; i++) {
        if (flights[i].Route == Route && (FeedbackDate && flights[i].FlightDate == FeedbackDate || !FeedbackDate && flights[i].DutyDate == DutyDate)) {
          result.push(flights[i]);
        }
      }

      return result;
    }
    /**
    * create a local flight (Add flight button on main screen)
    * @memberof FlightFactory
    * @param {string} datetime 
    * @param {string} number 
    * @param {string} departure 
    * @param {string} destination 
    * @param {string} regno 
    * @param {string} actype 
    * @return {object} flight
    */


    function createLocalFlight(datetime, number, departure, destination, regno, actype) {
      var user = UserFactory.getUser();
      if (user == null) return null;
      var result = new Flight();
      result.AcTailNo = regno;
      result.AcType = actype;
      result.Category = '-';
      result.CrewAimsId = user.aimsId;
      result.Departure = departure;
      result.Arrival = destination;
      result.FlightAimsId = guid();
      result.FlightId = guid();
      result.FlightDate = datetime.toString('yyyy-MM-dd') + 'T' + datetime.toString('HH:mm:ss');
      ;
      result.FlightNo = number;
      result.IsDHC = 0;
      result.Position = user.position;
      result.ScheduledDeparture = datetime.toString('yyyy-MM-dd') + 'T' + datetime.toString('HH:mm:ss');
      result.Status = 'OK';
      result.IsLocal = true;
      result.initialize();
      return result;
    }
    /**
     * Save a local flight
     * @memberof FlightFactory
     * @param {object} flight
     */


    function saveLocalFlight(flight) {
      // get the local flights array from storage
      var localFlights = fromObjectList(localStorageMD5Service.get('localFlights'));
      if (localFlights == null) localFlights = new Array(); // find the current flight in the array (if present)

      var arrayLength = localFlights.length;
      var flightIndex = -1;

      for (var i = 0; i < arrayLength; i++) {
        if (localFlights[i].FlightId != null && localFlights[i].FlightId == flight.FlightId) {
          flightIndex = i;
          break;
        }
      } // add or update a copy of the current report


      if (flightIndex >= 0) localFlights[flightIndex] = flight;else localFlights.push(flight); // save

      localStorageMD5Service.set('localFlights', localFlights);
    }
    /**
     * merges the given flights with the stored local flights
     * @memberof FlightFactory
     * @param {array} serverFlights 
     * @return {array} flights
     */


    function getLocalFlightsAndMergeWithServerFlights(serverFlights) {
      if (serverFlights == null) serverFlights = []; // get the local flights array from storage

      var localFlights = fromObjectList(localStorageMD5Service.get('localFlights'));
      if (localFlights == null) localFlights = []; // add the local flight to the given array

      var arrayLength = localFlights.length;

      for (var i = 0; i < arrayLength; i++) {
        localFlights[i].initialize();
        serverFlights.push(localFlights[i]);
      }

      return serverFlights;
    }
    /**
     * Get Flight from local flights
     * @memberof FlightFactory
     * @param {number} flightId 
     * @return {object} flight
     */


    function getLocalFlightFromStorage(flightId) {
      var flight = GenericService.get(flightId, 'localFlights', objCallback);

      if (flight) {
        flight.initialize();
      }

      return fromObject(flight);
    }
    /**
     * Update Flight from report
     * @memberof FlightFactory
     * @param {object} report 
     */


    function updateFlightFromReport(report) {
      var flight = getFlightFromStorage(report.FlightId);

      if (flight != null && flight != undefined) {
        var reportIndex;
        flight.AcTailNo = report.AcTailNo;
        flight.AcType = report.AcType;
        var allflights = getFlightsFromStorage();

        for (var i = 0; i < allflights.length; i++) {
          if (allflights[i].FlightId != null && allflights[i].FlightId == report.FlightId) {
            reportIndex = i;
            break;
          }
        }

        flight.initialize();
        allflights[reportIndex] = flight;
        setFlightsToStorage(allflights);
      }
    }
    /**
     * Update Flight 
     * @memberof FlightFactory
     * @param {object} flight 
     */


    function updateFlight(flight) {
      // get the  flights array from storage
      var flights = getFlightsFromStorage(); // find the current flight in the array (if present)

      var arrayLength = flights.length;
      var flightIndex = -1;

      for (var i = 0; i < arrayLength; i++) {
        if (flights[i].FlightId != null && flights[i].FlightId == flight.FlightId) {
          flightIndex = i;
          break;
        }
      } //Add or update a copy of the current report


      if (flightIndex >= 0) flights[flightIndex] = flight;else flights.push(flight); //Save

      localStorageMD5Service.set('flights', flights);
    }
    /**
     * mark Schedule Changed Flights by comparing flights from new and old data
     * @memberof FlightFactory
     * @param {object} newFlights 
     * @param {object} oldFlights
     * @return {object} newFlights 
     */


    function markScheduleChangedFlights(newFlights, oldFlights) {
      var lastScheduleDate = SyncLogFactory.getLastScheduleDate(); //if there are no old flights  or no last schedule date

      if (oldFlights && lastScheduleDate) {
        //loop all new flights
        var exists;

        for (var i = 0; i < newFlights.length; i++) {
          //loop all old flights
          exists = false;

          for (var j = 0; j < oldFlights.length; j++) {
            if (newFlights[i].FlightNo == oldFlights[j].FlightNo && newFlights[i].FlightNo == oldFlights[j].FlightNo && newFlights[i].FlightDate == oldFlights[j].FlightDate && newFlights[i].Departure == oldFlights[j].Departure) {
              exists = true;
              break;
            }
          } //check if flight is newly added and is before the last schedule date


          var flightDate = new Date(newFlights[i].FlightDate);

          if (!exists && flightDate.getTime() <= lastScheduleDate) {
            newFlights[i].IsScheduleChanged = true;
          }
        }
      }

      return newFlights;
    } //factory functions

    /**
     * Update Passenger information
     * @memberof FlightFactory
     * @param {object} flightInfo  The flight informations 
     */


    function mergeFlightInfo(flightInfo, showPaxNames) {
      if (flightInfo) {
        var currentFlightInfo = GenericService.get(flightInfo.FlightId, objType, objCallback);
        currentFlightInfo.CrewAimsId = flightInfo.CrewAimsId;
        currentFlightInfo.DutyDate = flightInfo.DutyDate;
        currentFlightInfo.Route = flightInfo.Route;
        currentFlightInfo.FlightId = flightInfo.FlightId;
        currentFlightInfo.FlightAimsId = flightInfo.FlightAimsId;
        currentFlightInfo.FlightDate = flightInfo.FlightDate;
        currentFlightInfo.FlightNo = flightInfo.FlightNo;
        currentFlightInfo.Departure = flightInfo.Departure;
        currentFlightInfo.Arrival = flightInfo.Arrival;
        currentFlightInfo.AcType = flightInfo.AcType;
        currentFlightInfo.AcTailNo = flightInfo.AcTailNo;
        currentFlightInfo.ScheduledDeparture = flightInfo.ScheduledDeparture;
        currentFlightInfo.ScheduledArrival = flightInfo.ScheduledArrival;
        currentFlightInfo.BookedC = flightInfo.BookedC;
        currentFlightInfo.BookedY = flightInfo.BookedY;
        currentFlightInfo.BookedInf = flightInfo.BookedInf;
        currentFlightInfo.BookedPad = flightInfo.BookedPad;
        currentFlightInfo.BookedChld = flightInfo.BookedChld;
        currentFlightInfo.ActualC = flightInfo.ActualC;
        currentFlightInfo.ActualY = flightInfo.ActualY;
        currentFlightInfo.ActualInf = flightInfo.ActualInf;
        currentFlightInfo.ActualPad = flightInfo.ActualPad;
        currentFlightInfo.ActualChld = flightInfo.ActualChld;
        currentFlightInfo.Category = flightInfo.Category;
        currentFlightInfo.Status = flightInfo.Status;
        currentFlightInfo.Position = flightInfo.Position;
        currentFlightInfo.IsDHC = flightInfo.IsDHC;
        currentFlightInfo.CallSign = flightInfo.CallSign;
        currentFlightInfo.DepartureGate = flightInfo.DepartureGate;
        currentFlightInfo.DepartureStand = flightInfo.DepartureStand;
        currentFlightInfo.ArrivalStand = flightInfo.ArrivalStand;
        currentFlightInfo.DepartureICAO = flightInfo.DepartureICAO;
        currentFlightInfo.DepartureName = flightInfo.DepartureName;
        currentFlightInfo.DepartureCountry = flightInfo.DepartureCountry;
        currentFlightInfo.ArrivalICAO = flightInfo.ArrivalICAO;
        currentFlightInfo.ArrivalName = flightInfo.ArrivalName;
        currentFlightInfo.ArrivalCountry = flightInfo.ArrivalCountry;
        currentFlightInfo.DepartureTimezone = flightInfo.DepartureTimezone;
        currentFlightInfo.ArrivalTimezone = flightInfo.ArrivalTimezone;
        currentFlightInfo.DepartureSchengen = flightInfo.DepartureSchengen;
        currentFlightInfo.ArrivalSchengen = flightInfo.ArrivalSchengen;
        currentFlightInfo.DepartureEU = flightInfo.DepartureEU;
        currentFlightInfo.ArrivalEU = flightInfo.ArrivalEU;
        currentFlightInfo.ETD = flightInfo.ETD;
        currentFlightInfo.ATD = flightInfo.ATD;
        currentFlightInfo.ETA = flightInfo.ETA;
        currentFlightInfo.ATA = flightInfo.ATA;
        currentFlightInfo.CTOT = flightInfo.CTOT;
        currentFlightInfo.DepartureCountryISO = flightInfo.DepartureCountryISO;
        currentFlightInfo.ArrivalCountryISO = flightInfo.ArrivalCountryISO;
        currentFlightInfo.crew = flightInfo.crew;
        currentFlightInfo.Zones = flightInfo.Zones;
        currentFlightInfo.showPaxNames = showPaxNames;
        GenericService.save(currentFlightInfo, objType, objCallback);
      }
    }
    /**
           * Get Flights of a Crew Route
           * @memberof FlightFactory
           * @param {number} dutyNo 
           * @param {string} dutyDay
     * @return {array} flights
           */


    function getFlightsByDutyNo(dutyNo, dutyDay) {
      var flights = getFlightsFromStorage();
      if (flights == null) return [];
      var result = [];
      var arrayLength = flights.length;

      for (var i = 0; i < arrayLength; i++) {
        if (flights[i].DutyNo == dutyNo && flights[i].DutyDay == dutyDay) {
          result.push(flights[i]);
        }
      }

      return result;
    }
    /**
           * Get Flights of a Crew Route using a flightId
           * @memberof FlightFactory
           * @param {number} flightId 
     * @return {array} flights
           */


    function getFlightsByFlightId(flightId) {
      var result = [];
      var flight = getFlightFromStorage(flightId);
      var flights = getFlightsFromStorage();

      if (flight != null) {
        for (var i = 0; i < flights.length; i++) {
          if (flights[i].DutyNo == flight.DutyNo && flights[i].DutyDay == flight.DutyDay) {
            result.push(flights[i]);
          }
        }
      }

      return result;
    }
    /**
           * Get Flights with report status "Stored"
           * @memberof FlightFactory
     * @return {array} flights
           */


    function getFlightsWithStoredReport() {
      var flights = getFlightsFromStorage();
      if (flights == null) return [];
      var result = [];
      var arrayLength = flights.length;

      for (var i = 0; i < arrayLength; i++) {
        if (flights[i].cabinReportStatusDescr == "Stored") {
          result.push(flights[i]);
        }
      }

      return result;
    }

    function getTheFirstAndTheLastFlightDates() {
      var flights = getFlightsFromStorage();

      var parseDate = function parseDate(dateString) {
        return new Date(dateString);
      };

      var firstFlightDate = null;
      var lastFlightDate = null;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = flights[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var obj = _step.value;
          //const currentDate = new Date(obj.FlightDate);
          var currentDate = parseDate(obj.FlightDate);

          if (!firstFlightDate || currentDate < firstFlightDate) {
            firstFlightDate = currentDate;
          }

          if (!lastFlightDate || currentDate > lastFlightDate) {
            lastFlightDate = currentDate;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {
        firstDate: firstFlightDate,
        lastDate: lastFlightDate
      };
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('FlightCrewMemberFactory', FlightCrewMemberFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name FlightCrewMemberFactory
  * @description 
  *   Add, Update, Delete and Get Flight Crew Members.
  * @ngInject
  */

  function FlightCrewMemberFactory(GenericModalFactory) {
    /**
    * Initialize the FlightCrewMember
    * @memberof FlightCrewMemberFactory
    */
    function FlightCrewMember() {
      this.aimsId = null;
      this.id = null;
      this.isDHC = null;
      this.name = null;
      this.position = null;
      this.sex = null;
      this.shortname = null;
    }

    var service = {
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      deleteFromList: deleteFromList
    };
    /**
    * Extend Object from the default FlightCrewMember Object
    * @memberof FlightCrewMemberFactory
    * @param {Object} obj a FlightCrewMember
    * @returns {Object} FlightCrewMember
    */

    function fromObject(obj) {
      return GenericModalFactory.fromObject(obj, FlightCrewMember);
    }
    /**
     * Delete object from given list and update it
     * @memberof FlightCrewMemberFactory
     * @param {object} obj  a Flight Crew Member
     * @param {Array} objList  an Array Of Flight Crew Member
     * @returns {Array} FlightCrewMembers
     *
     */


    function deleteFromList(obj, objList) {
      return GenericModalFactory.deleteFromList(obj, objList);
    }
    /**
     * Extend an array of Objects from the default Flight Crew Member Object
     * @memberof FlightCrewMemberFactory
     * @param {Array} objList  an Array Of Flight Crew Member
     * @returns {Array} FlightCrewMembers
     */


    function fromObjectList(objList) {
      return GenericModalFactory.fromObjectList(objList, FlightCrewMember);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('ReminderModalCtrl', ReminderModalCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name ReminderModalCtrl
  * @description 
  * Warning Modal about acknowledge schedule changes and medical & passport expiries
  * @ngInject
  */

  function ReminderModalCtrl(showExpiriesReminder, showSubmissionDeadlineReminder, showScheduleChangesReminder, showSaAssessmentReminder, ExpiriesFactory, RequestFactory, ScheduleAcknowledgeFactory, $scope, $uibModalInstance, SaFeedbackInfoFactory) {
    $scope.cancel = cancel; //from parent view:

    $scope.showScheduleChangesReminder = showScheduleChangesReminder;
    $scope.showExpiriesReminder = showExpiriesReminder;
    $scope.showSubmissionDeadlineReminder = showSubmissionDeadlineReminder;
    $scope.showSaAssessmentReminder = showSaAssessmentReminder;
    $scope.expiryList = ExpiriesFactory.getCrewExpiriesFromStorage();
    $scope.submissionDeadline = RequestFactory.getSubmissionDeadlineDateFromStorage();
    $scope.daysDiff = daysDiff;
    /**
     * Calculates days left
     * @return {string} usage
     */

    function daysDiff(date) {
      var today = moment().startOf('day');
      var expiryDate = moment(date);
      return expiryDate.diff(today, 'days');
    }
    /**
    * Closes modal
    * @memberof ProposalInfoModalCtr
    */


    function cancel() {
      if ($scope.showScheduleChangesReminder) {
        ScheduleAcknowledgeFactory.updateShowScheduleChangesModal(false);
      }

      if ($scope.showExpiriesReminder) {
        ExpiriesFactory.updateShowExpiriesModal(false);
      }

      if ($scope.showSubmissionDeadlineReminder) {
        RequestFactory.updateShowSubmissionDeadlineModal(false);
      }

      if ($scope.showSaAssessmentReminder) {
        SaFeedbackInfoFactory.updateShowSaAssessmentModal(false);
      }

      $uibModalInstance.close('cancel');
    }
  }
})();
"use strict";

(function () {
  "use strict";

  a3_cabin_reports.factory("GroomingCategoriesFactory", GroomingCategoriesFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name GroomingCategoriesFactory
   * @description
   * Get grooming categories
   * @ngInject
   */

  function GroomingCategoriesFactory($http, apiUrl, GenericService) {
    var groomingReportsByCrew = {};
    var service = {
      setGroomingCategories: setGroomingCategories,
      getGroomingCategories: getGroomingCategories,
      collectGroomingReports: collectGroomingReports,
      saveGroomingReports: saveGroomingReports,
      loadGroomingReports: loadGroomingReports,
      clearGroomingReportsFromStorage: clearGroomingReportsFromStorage
    };
    /**
     * Initialize the GroomingCategory
     * @memberof GroomingCategoriesFactory
     */

    function GroomingCategory() {
      this.Id = null;
      this.Label = null;
      this.Description = null;
      this.OrderNo = null;
      this.Active = false;
    }

    var objEventType = "groomingCategories";
    var objCallback = GroomingCategory;
    /**
     * Save grooming categories
     * @memberof GroomingCategoriesFactory
     * @param {Array} GroomingCategories
     */

    function setGroomingCategories(groomingCategories) {
      GenericService.saveAll(groomingCategories, objEventType);
    }
    /**
     * Get Event Types
     * @memberof FlightServiceEventsFactory
     * @returns {Array} EventTypes
     */


    function getGroomingCategories() {
      return GenericService.list(objEventType, objCallback);
    }

    function collectGroomingReports(groomingReportsByCrew) {
      var groomingReports = [];

      if (groomingReportsByCrew) {
        for (var crewId in groomingReportsByCrew) {
          var crewReports = groomingReportsByCrew[crewId];
          crewReports.forEach(function (category) {
            if (category.UserInput && category.UserInput.trim() !== "") {
              groomingReports.push({
                crewId: crewId,
                groomingCategoryId: category.Id,
                feedback: category.UserInput.trim()
              });
            }
          });
        }
      }

      return groomingReports;
    }

    function saveGroomingReports(groomingReports) {
      localStorage.setItem("groomingReports", JSON.stringify(groomingReports));
    }

    function loadGroomingReports() {
      try {
        var raw = localStorage.getItem("groomingReports");
        if (!raw) return {};
        return JSON.parse(raw) || {};
      } catch (e) {
        return {};
      }
    }

    function clearGroomingReportsFromStorage() {
      localStorage.removeItem("groomingReports");
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('GroomimgCategoriesModalCtrl', GroomimgCategoriesModalCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name GroomimgCategoriesModalCtrl
  * @description 
  * Grooming Categories Form Modal
  * @ngInject
  */

  function GroomimgCategoriesModalCtrl($scope, $uibModalInstance, crewData, groomingCategories) {
    $scope.crewData = crewData;
    var originalCategories = angular.copy(groomingCategories); // Deep copy for preservation

    $scope.groomingCategories = angular.copy(groomingCategories); // Working copy for the modal

    $scope.close = close;
    $scope.save = save;

    $scope.isSaveEnabled = function () {
      return $scope.groomingCategories.every(function (category) {
        if (category.isSelected) {
          return category.UserInput && category.UserInput.trim() !== '';
        }

        return true;
      });
    };

    $scope.toggleCategorySelection = function (category) {
      category.isSelected = !category.isSelected; // Clear remarks if the category is unchecked

      if (!category.isSelected) {
        category.UserInput = ""; // Reset the input field
      }
    }; // Function to clear specific input


    $scope.clearInput = function (category) {
      category.UserInput = '';
    }; // Close the modal


    function close() {
      $scope.groomingCategories = angular.copy(originalCategories);
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      angular.copy($scope.groomingCategories, groomingCategories); // Close the modal and return the updated grooming categories

      $uibModalInstance.close($scope.groomingCategories);
    }

    ;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('faceMasks', faceMasks);
  /**
     * @memberof CabinReports
     * @ngdoc directive
     * @name faceMasks
     * @restrict E
     * @description
     *   Implementation of Face Masks 
     *
     * Display the Face Masks Record Panel
     * @attr {String} flight-id
     * @example
     *   Usage:
     *   <face-masks flight-id="123"></face-masks>
     *   
     * @ngInject
     */

  function faceMasks(FlightFactory, FaceMasksFactory, $sce, $timeout) {
    /**
     * Initialize faceMasks
     * @memberof faceMasks
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attributes attributes of this element
     */
    function link(scope, element, attributes) {
      scope.togglePanel = togglePanel;
      scope.submit = submit;
      scope.numberDown = numberDown;
      scope.numberUp = numberUp;
      scope.validInput = validInput;
      scope.validateForm = validateForm;
      scope.requiredFields = false;
      scope.invalidForm = false;
      scope.LastUpdated = null;
      initializePanel();
      /**
       * Initialize Form Values
       * @memberof faceMasks
       */

      function initializePanel() {
        var flight = FlightFactory.getFlightFromStorage(scope.flightId);
        var DryStoreFound = 0;
        var DryStoreLeft = 0;
        var UniversalFound = 0;
        var UniversalLeft = 0; //Check if there is existing data

        if (flight.FaceMasks) {
          DryStoreFound = flight.FaceMasks.DryStoreFound;
          DryStoreLeft = flight.FaceMasks.DryStoreLeft;
          UniversalFound = flight.FaceMasks.UniversalFound;
          UniversalLeft = flight.FaceMasks.UniversalLeft;
          scope.LastUpdated = flight.FaceMasks.LastUpdated;
        }

        var masksForm = {
          Types: [{
            Type: "A",
            Title: "FFP2 Masks",
            Fields: [{
              Title: "Found",
              Value: DryStoreFound
            }, {
              Title: "Left",
              Value: DryStoreLeft
            }]
          }, {
            Type: "B",
            Title: "Surgical Face masks",
            Fields: [{
              Title: "Found",
              Value: UniversalFound
            }, {
              Title: "Left",
              Value: UniversalLeft
            }]
          }],
          FlightId: scope.flightId
        };
        scope.submitMessage = '';
        scope.masksForm = masksForm;
        scope.showPanel = "masks";
        validateForm();
      }
      /**
       * Check if all required fields exist and have a valid value
       * @memberof faceMasks
       */


      function validateForm() {
        scope.requiredFields = scope.masksForm.Types.some(function (t) {
          return t.Fields.some(function (f) {
            return f.Value === null;
          });
        });
        scope.invalidForm = scope.masksForm.Types.some(function (t) {
          return t.Fields.some(function (f) {
            return f.Value === undefined;
          });
        }); //Hide other alerts when form is invalid

        if (scope.requiredFields || scope.invalidForm) {
          scope.showPanel = "masks";
        }
      }
      /**
       * Toggle Panel
       * @memberof faceMasks
       * @param {number} panelId
       */


      function togglePanel(panelId) {
        $('#' + panelId).toggle();
      }

      function validInput(field) {
        var isValid = true;

        if (field.Value == null || field.Value == undefined) {
          isValid = false;
        }

        return isValid;
      }
      /**
       * Decrease field value by 1
       * @memberof faceMasks
       * @param {object} field 
       */


      function numberDown(field) {
        if (field.Value > 0) {
          field.Value--;
        }
      }
      /**
       * Increase field value by 1
       * @memberof faceMasks
       * @param {object} field 
       */


      function numberUp(field) {
        field.Value++;
      }
      /**
       * Submit form
       * @memberof faceMasks
       */


      function submit() {
        if (scope.isOffline) {
          scope.showPanel = "offline";
        } else {
          scope.showPanel = "loading";
          var DryStoreFound = scope.masksForm.Types.find(function (t) {
            return t.Type == "A";
          }).Fields.find(function (f) {
            return f.Title == "Found";
          }).Value;
          var DryStoreLeft = scope.masksForm.Types.find(function (t) {
            return t.Type == "A";
          }).Fields.find(function (f) {
            return f.Title == "Left";
          }).Value;
          var UniversalFound = scope.masksForm.Types.find(function (t) {
            return t.Type == "B";
          }).Fields.find(function (f) {
            return f.Title == "Found";
          }).Value;
          var UniversalLeft = scope.masksForm.Types.find(function (t) {
            return t.Type == "B";
          }).Fields.find(function (f) {
            return f.Title == "Left";
          }).Value;
          var FlightMaskReport = {
            FlightId: scope.masksForm.FlightId,
            DryStoreFound: DryStoreFound,
            DryStoreLeft: DryStoreLeft,
            UniversalFound: UniversalFound,
            UniversalLeft: UniversalLeft,
            LastUpdated: new Date()
          };
          FaceMasksFactory.submitFaceMaskReport(FlightMaskReport).then(function (res) {
            return handleSubmitResponse(res, FlightMaskReport.LastUpdated);
          });
        }
      }
      /**
       * Manage API response
       * @param {object} res 
       * @param {date} timestamp 
       */


      function handleSubmitResponse(res, timestamp) {
        if (res.success) {
          manageResponseMessage("success", res.message);
          scope.LastUpdated = timestamp;
          $timeout(function () {
            scope.showPanel = "masks";
          }, 6000);
        } else {
          manageResponseMessage("failure", res.message);
        }
      }
      /**
       * Manage message alerts
       * @param {string} panelToShow 
       * @param {string} message 
       */


      function manageResponseMessage(panelToShow, message) {
        scope.submitMessage = message;
        scope.showPanel = panelToShow;
      }
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/FaceMasks/faceMasks.tpl.html',
      scope: {
        flightId: '@',
        isOffline: '='
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('FaceMasksFactory', FaceMasksFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name FaceMasksFactory
   * @description 
   * Get, Set and Submit Face Mask Info per flight.
   * @ngInject
   */

  function FaceMasksFactory(FlightFactory, $http, apiUrl) {
    var submitResponseObj = {
      success: false,
      message: ''
    };
    var service = {
      submitFaceMaskReport: submitFaceMaskReport
    };
    /**
     * Sends the Face Masks report
     * @memberof FaceMasksFactory
     * @param {object} flightMasks The Flight Face Masks Report
     * @returns {promise} submitResponseObj
     */

    function submitFaceMaskReport(flightMasks) {
      var objectToAdd = flightMasks;
      return $http.post(apiUrl + '/FaceMasks/', flightMasks, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return saveReportSuccessCallBack(res, objectToAdd);
      })["catch"](function (res) {
        return saveReportFailedCallBack(res);
      });
    }
    /**
     * The callback function upon successful submit
     * @param {object} res 
     * @param {object} objectToAdd 
     * @returns {object} submitResponseObj
     */


    function saveReportSuccessCallBack(res, objectToAdd) {
      submitResponseObj.success = res.data.success;

      if (res.data.success) {
        //Attach face mask info to flight
        var flight = FlightFactory.getFlightFromStorage(objectToAdd.FlightId);
        flight.FaceMasks = objectToAdd;
        FlightFactory.updateFlight(flight);
        submitResponseObj.message = "Success! Your input has been sent";
      } else {
        submitResponseObj.message = res.data.errorMessage;
      }

      return submitResponseObj;
    }
    /**
    * The callback function upon failure on submit
    * @returns {object} submitResponseObj
    */


    function saveReportFailedCallBack(res) {
      submitResponseObj.success = false;
      submitResponseObj.message = "Oops! Something went wrong";
      return submitResponseObj;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('gdCrewInfo', gdCrewInfo);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name crewInfo
  * @restrict E
  * @description
  *   Crew Table with a double row per crew member
  * @example
  *   Usage:
  *   <gd-crew-info crew="crewMembers" grounddutyid="id"></gd-crew-info>
  * @ngInject
  */

  function gdCrewInfo($uibModal, UserFactory) {
    function link(scope) {
      scope.user = UserFactory.getUser();
      scope.openPhoneConfirmation = openPhoneConfirmation;
      scope.showInfoRow = showInfoRow;

      function openPhoneConfirmation(_crew) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/CrewInfo/dlgConfirmCrewCall.html',
          controller: 'CrewCallCtrl',
          size: 'md',
          resolve: {
            crew: function crew() {
              return _crew;
            },
            groundDutyId: function groundDutyId() {
              return scope.grounddutyid;
            },
            flightId: function flightId() {
              return null;
            }
          }
        });
        modalInstance.result.then(function (confirm) {});
      }

      function showInfoRow(item) {
        var differentUser = scope.user.aimsId != item.AIMS_ID;
        var phoneAvailable = item.PhoneNumber && item.PhoneNumber != '';
        return differentUser && phoneAvailable;
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/GroundDuty/gdCrewInfo.tpl.html',
      scope: {
        crew: "=",
        grounddutyid: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('GroundDutyCtrl', GroundDutyCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name GroundDutyCtrl
   * @description 
   * Shows the ground duty information
   * @ngInject
   */

  function GroundDutyCtrl(GroundDutyFactory, CourseFactory, TrainingSessionFactory, $scope, $location, $routeParams) {
    $scope.toggleCrewList = toggleCrewList;
    $scope.toggleEditMode = toggleEditMode;
    $scope.selectTrainee = selectTrainee;
    $scope.refresh = refresh;
    $scope.refreshSuccess = true;
    $scope.isRefreshing = false;
    $scope.instructors = [];
    $scope.trainees = [];
    var groundDutyId = Number($routeParams.groundDutyId);
    var groundDuty = GroundDutyFactory.getGroundDutyFromStorage(groundDutyId);
    $scope.dutyCourses = GroundDutyFactory.getGroundDutyActiveCourses(groundDutyId);
    $scope.groundDutyId = groundDutyId;

    if (!groundDuty) {
      // go to dashboard if no groundDuty
      $location.path("/");
    } else {
      //Toggle trainees
      groundDuty.Trainees.forEach(function (relatedTrainees) {
        relatedTrainees.isCollapsed = false;
        relatedTrainees.dynamicSize = 10;
      }); //Collect all trainees in list

      var traineesFlat = [];
      groundDuty.Trainees.forEach(function (related) {
        related.CrewMembers.forEach(function (trainee) {
          traineesFlat.push(trainee);
        });
      });
      groundDuty.traineesFlat = traineesFlat;

      if (groundDuty.RelatedGroundDuties) {
        $scope.courses = GroundDutyFactory.getGroundDutyActiveCourses(groundDutyId);
      }

      updateCrewMemberScopes(groundDuty);
      $scope.groundDuty = groundDuty;
      $scope.groundDutyId = groundDutyId;
    }

    function toggleCrewList(relatedTrainees) {
      relatedTrainees.isCollapsed = !relatedTrainees.isCollapsed;
      if (relatedTrainees.isCollapsed) relatedTrainees.dynamicSize = relatedTrainees.CrewMembers.length;else relatedTrainees.dynamicSize = 10;
    }

    function toggleEditMode(elem, className) {
      $('body').find('div#' + elem + ' > div').not('.tip').hide("slow");
      $('body').find('div#' + elem + ' div.' + className).not('.tip').show("slow");
    }
    /**
     * Edit ground duty's attendance list
     * @param {object} trainee 
     */


    function selectTrainee(trainee) {
      //Value will be saved in ground duty's crew members
      trainee.Absent = !trainee.Absent;
      GroundDutyFactory.updateGroundDuty($scope.groundDuty);
    }
    /**
     * Sync ground duty
     */


    function refresh() {
      var courseIds = $scope.dutyCourses.map(function (x) {
        return x.CourseId;
      }).filter(onlyUnique);
      var refreshGroundDuty = {
        DutyId: groundDutyId,
        CourseIds: courseIds
      };
      $scope.isRefreshing = true; //get latest info

      GroundDutyFactory.refresh(refreshGroundDuty, function (responseData) {
        $scope.isRefreshing = false;
        $scope.refreshSuccess = true; //update ground duty.

        var groundDuty = responseData.data.GroundDuty;

        if (groundDuty && groundDuty.Id != 0 && groundDuty.Code) {
          GroundDutyFactory.mergeGroundDutyInfo(groundDuty);
        } //Save training


        var trainingCourses = responseData.data.TrainingCourses;

        if (trainingCourses && trainingCourses.length) {
          trainingCourses.forEach(function (trainingCourse) {
            CourseFactory.upsertCourse(trainingCourse, function (course) {
              TrainingSessionFactory.applyTraineeInfoToSession(course, course.Id, $scope.groundDuty.DutyDateS, groundDutyId, function (session) {});
            });
          });
        }

        updateCrewMemberScopes(groundDuty);
      })["catch"](function () {
        $scope.refreshSuccess = false;
        $scope.isRefreshing = false;
      });
    }

    function updateCrewMemberScopes(groundDuty) {
      if (groundDuty && groundDuty.RelatedGroundDuties && groundDuty.RelatedGroundDuties.length > 0) {
        var relatedDutyIns = groundDuty.RelatedGroundDuties.filter(function (x) {
          return x.IsInstructor == true;
        });

        if (relatedDutyIns && relatedDutyIns.length > 0) {
          $scope.instructors = relatedDutyIns[0].CrewMembers;
        }

        var relatedDutyTr = groundDuty.RelatedGroundDuties.filter(function (x) {
          return x.IsInstructor == false;
        });

        if (relatedDutyTr && relatedDutyTr.length > 0) {
          $scope.trainees = relatedDutyTr.flatMap(function (a) {
            return a.CrewMembers;
          });
        }
      }
    }

    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }
  }
})();
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

(function () {
  'use strict';

  a3_cabin_reports.factory('GroundDutyFactory', GroundDutyFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name GroundDutyFactory
  * @description 
  * Add, Update and Get Ground Duties.
  * @ngInject
  */

  function GroundDutyFactory(GenericService, $http, apiUrl) {
    /**
    * Initialize the GroundDuty
    * @memberof GroundDutyFactory
    */
    function GroundDuty() {
      this.Id = null;
      this.Duty = null;
      this.DutyDescription = null;
      this.DutyBegin = null;
      this.DutyEnd = null;
      this.GetId = GetId;
      this.isTraining = false;
      this.icon = null;
      this.Instructors = new Array();
      this.Trainees = new Array();
      this.isManualEntry = false;
      this.hasPendingCourse = false;
    }

    var objType = 'groundDuty';
    var objCallback = GroundDuty;
    var service = {
      getGroundDutiesFromStorage: getGroundDutiesFromStorage,
      setGroundDutiesToStorage: setGroundDutiesToStorage,
      getGroundDutyFromStorage: getGroundDutyFromStorage,
      getGroundDutyActiveCourses: getGroundDutyActiveCourses,
      getGroundDutiesByDutyNo: getGroundDutiesByDutyNo,
      mergeGroundDutyInfo: mergeGroundDutyInfo,
      updateGroundDuty: updateGroundDuty,
      setCourseCompleted: setCourseCompleted,
      setCoursePending: setCoursePending,
      isLastDay: isLastDay,
      mergeGroundDutiesToStorage: mergeGroundDutiesToStorage,
      refresh: refresh,
      addGroundDuty: addGroundDuty,
      removeGroundDuty: removeGroundDuty,
      getManualGroundDutiesFromStorage: getManualGroundDutiesFromStorage,
      getFirstAndLastDateOfGroundDuties: getFirstAndLastDateOfGroundDuties
    };
    /**
     * Overide default get Id
     * @memberof GroundDutyFactory
     * @returns {number} Id 
     */

    function GetId() {
      return this.Id;
    }
    /**
     * Get Ground Duties.
     * @memberof GroundDutyFactory
     * @returns {Array} GroundDuties 
     */


    function getGroundDutiesFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Get GroundDuty from storage groundDuties
     * @memberof GroundDutyFactory
     * @param {number} groundDutyId 
     * @return {object} groundDuty
     */


    function getGroundDutyFromStorage(groundDutyId) {
      var groundDuty = GenericService.get(groundDutyId, objType, objCallback);
      var instructors = [];
      var trainees = [];

      if (groundDuty != null && groundDuty != undefined) {
        //only training
        if (groundDuty.RelatedGroundDuties && groundDuty.RelatedGroundDuties.length > 1) {
          groundDuty.isTraining = true;
          groundDuty.RelatedGroundDuties.forEach(function (element) {
            if (element.IsInstructor) {
              instructors.push(element);
            } else {
              trainees.push(element);
            }
          });
          groundDuty.Trainees = trainees;
          groundDuty.Instructors = instructors;
        }
      }

      return groundDuty;
    }
    /**
     * Save Ground Duties to storage
     * @memberof GroundDutyFactory
     * @param {Array} GroundDuties A list of Ground Duties
     */


    function setGroundDutiesToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }
    /**Save Ground Duties to storage but keep local storage values
     * Necessary to maintain Absent values in training duties
     */


    function mergeGroundDutiesToStorage(objList, fromSync) {
      var groundDuties = getGroundDutiesFromStorage();

      if (!fromSync) {
        groundDuties.filter(function (x) {
          return x.isManualEntry;
        }).forEach(function (duty) {
          objList.push(duty);
        });
      }

      if (groundDuties) {
        objList.forEach(function (incomingDuty) {
          if (incomingDuty.RelatedGroundDuties) {
            var incomingTraineesFlat = [];
            incomingDuty.RelatedGroundDuties.filter(function (x) {
              return !x.IsInstructor;
            }).forEach(function (related) {
              related.CrewMembers.forEach(function (trainee) {
                incomingTraineesFlat.push(trainee);
              });
            }); //Initialize all as present

            incomingTraineesFlat.forEach(function (incomingTrainee) {
              incomingTrainee.Absent = false;
            }); //Copy Absent value from existing local storage duties

            var existingDuty = groundDuties.find(function (x) {
              return x.Id == incomingDuty.Id;
            });

            if (existingDuty && existingDuty.RelatedGroundDuties) {
              var existingTraineesFlat = [];
              existingDuty.RelatedGroundDuties.filter(function (x) {
                return !x.IsInstructor;
              }).forEach(function (related) {
                related.CrewMembers.forEach(function (trainee) {
                  existingTraineesFlat.push(trainee);
                });
              });
              incomingTraineesFlat.forEach(function (incomingTrainee) {
                var existingTrainee = existingTraineesFlat.find(function (x) {
                  return x.Id == incomingTrainee.Id;
                });

                if (existingTrainee) {
                  incomingTrainee.Absent = existingTrainee.Absent;
                }
              });
            }
          }
        });
      }

      GenericService.saveAll(objList, objType);
    }
    /**
     * Get GroundDuties of a Crew Route
     * @memberof GroundDutyFactory 
     * @param {number} dutyNo 
     * @param {string} dutyDay
     * @return {array} groundDuties
     */


    function getGroundDutiesByDutyNo(dutyNo, dutyDay) {
      var groundDuties = getGroundDutiesFromStorage();
      if (groundDuties == null) return [];
      var result = [];
      var instructors = [];
      var trainees = [];
      var arrayLength = groundDuties.length;

      for (var i = 0; i < arrayLength; i++) {
        if (groundDuties[i].DutyNo == dutyNo && groundDuties[i].DutyDay == dutyDay) {
          //only training
          if (groundDuties[i].RelatedGroundDuties && groundDuties[i].RelatedGroundDuties.length > 1) {
            groundDuties[i].isTraining = true;
            instructors = [];
            trainees = [];
            groundDuties[i].RelatedGroundDuties.forEach(function (element) {
              if (element.IsInstructor) {
                instructors.push(element);
              } else {
                trainees.push(element);
              }
            });
            groundDuties[i].Trainees = trainees;
            groundDuties[i].Instructors = instructors;
          }

          result.push(groundDuties[i]);
        }
      }

      return result;
    }
    /**
     * Merge new info to current Ground Duty
     * @memberof GroundDutyFactory
     * @param {object} duty 
     */


    function mergeGroundDutyInfo(duty) {
      var currentGroundDutyInfo = GenericService.get(duty.Id, objType, objCallback);
      currentGroundDutyInfo.Code = duty.Code;
      currentGroundDutyInfo.Description = duty.Description;
      currentGroundDutyInfo.DutyDate = duty.DutyDate;
      currentGroundDutyInfo.GroundDutyNo = duty.GroundDutyNo;
      currentGroundDutyInfo.DutyDateS = duty.DutyDateS;
      currentGroundDutyInfo.DutyBegin = duty.DutyBegin;
      currentGroundDutyInfo.DutyEnd = duty.DutyEnd;
      currentGroundDutyInfo.DutyDay = duty.DutyDay;
      currentGroundDutyInfo.DutyNo = duty.DutyNo;
      currentGroundDutyInfo.Route = duty.Route;

      if (currentGroundDutyInfo.RelatedGroundDuties && currentGroundDutyInfo.RelatedGroundDuties.length) {
        currentGroundDutyInfo.RelatedGroundDuties = duty.RelatedGroundDuties;
      }

      GenericService.save(currentGroundDutyInfo, objType, objCallback);
    }
    /**
     * Check in calendar if this is the last day of this duty
     * @param {object} groundDuty 
     */


    function isLastDay(groundDuty, course) {
      //Get duty's Trainee codes
      var traineeCodes = _toConsumableArray(new Set(groundDuty.RelatedGroundDuties.filter(function (x) {
        return x.Courses && x.Courses.find(function (y) {
          return y.CourseId == course.Id;
        });
      }).map(function (r) {
        return r.Code;
      }))); //Get Remaining Trainee codes


      var remainingTraineeCodes = [];
      var remainingGroundDuties = GenericService.list(objType, objCallback) //get all grounDuties
      .filter(function (x) {
        return x.RelatedGroundDuties && x.RelatedGroundDuties.length > 1 && //filter only training
        dateDifference(groundDuty.DutyBegin, x.DutyBegin) < 0;
      }); //check later duty date

      remainingGroundDuties.forEach(function (groundDuty) {
        var codes = groundDuty.RelatedGroundDuties.filter(function (x) {
          return !x.IsInstructor;
        }).map(function (y) {
          return y.Code;
        }); //only trainee codes

        remainingTraineeCodes = remainingTraineeCodes.concat(codes);
      });
      remainingTraineeCodes = _toConsumableArray(new Set(remainingTraineeCodes)); //remove duplicates

      return !remainingTraineeCodes.some(function (r) {
        return traineeCodes.includes(r);
      });
    }
    /**
     * Compares two dates
     * @param {date} currentDate 
     * @param {date} checkDate 
     */


    function dateDifference(currentDate, checkDate) {
      var currentDate = moment(currentDate);
      var checkDate = moment(checkDate);
      return currentDate.diff(checkDate);
    }

    function updateGroundDuty(groundDuty) {
      GenericService.save(groundDuty, objType, objCallback);
    }

    function addGroundDuty(groundDuty) {
      var storedGroundDuty = GenericService.get(groundDuty.Id, objType, objCallback);

      if (!storedGroundDuty) {
        GenericService.add(groundDuty, objType, objCallback);
      } else {
        updateGroundDuty(groundDuty);
      }
    }

    function removeGroundDuty(groundDuty) {
      GenericService.remove(groundDuty, objType, objCallback);
    }

    function setCourseCompleted(dutyId, courseId) {
      var groundDuty = GenericService.get(dutyId, objType, objCallback);
      groundDuty.RelatedGroundDuties.filter(function (x) {
        return x.Courses;
      }).forEach(function (item) {
        var groundDutyCourse = item.Courses.find(function (x) {
          return x.CourseId == courseId;
        });

        if (groundDutyCourse) {
          groundDutyCourse.Status = "Completed";
        }
      });
      var allCoursesAreCompleted = false;

      if (groundDuty.RelatedGroundDuties && groundDuty.RelatedGroundDuties.length > 0) {
        allCoursesAreCompleted = groundDuty.RelatedGroundDuties.filter(function (x) {
          return x.Courses && x.Courses.length > 0;
        }).every(function (relatedDuty) {
          return relatedDuty.Courses.every(function (course) {
            return course.Status == "Completed";
          });
        });
      }

      if (groundDuty.isManualEntry && allCoursesAreCompleted) {
        groundDuty.hasPendingCourse = false;
      }

      updateGroundDuty(groundDuty);
    }

    function setCoursePending(dutyId, courseId) {
      var groundDuty = GenericService.get(dutyId, objType, objCallback);
      groundDuty.RelatedGroundDuties.filter(function (x) {
        return x.Courses;
      }).forEach(function (item) {
        var groundDutyCourse = item.Courses.find(function (x) {
          return x.CourseId == courseId;
        });
        if (groundDutyCourse) groundDutyCourse.Status = "Pending";
      });
      updateGroundDuty(groundDuty);
    }

    function getGroundDutyActiveCourses(groundDutyId) {
      var groundDuty = GenericService.get(groundDutyId, objType, objCallback);
      var courses = [];

      if (groundDuty != null && groundDuty != undefined) {
        if (groundDuty.RelatedGroundDuties && groundDuty.RelatedGroundDuties.length > 1) {
          groundDuty.RelatedGroundDuties.filter(function (x) {
            return !x.IsInstructor && x.Courses;
          }).forEach(function (item) {
            courses.push.apply(courses, _toConsumableArray(item.Courses));
          });
        }
      }

      return courses;
    }

    function refresh(refreshGroundDuty, callback) {
      return $http.post(apiUrl + '/GroundDuty/Refresh', refreshGroundDuty, {
        'Content-Type': 'application/json'
      }).then(callback);
    }
    /**Get manual Ground Duties from storage*/


    function getManualGroundDutiesFromStorage() {
      var groundDuties = getGroundDutiesFromStorage();
      return groundDuties.filter(function (x) {
        return x.isManualEntry;
      });
    }

    function getFirstAndLastDateOfGroundDuties() {
      var groundDuties = getGroundDutiesFromStorage();

      var parseDate = function parseDate(dateString) {
        return new Date(dateString);
      };

      var firstDutyDate = null;
      var lastDutyDate = null;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = groundDuties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var obj = _step.value;
          var currentDate = parseDate(obj.DutyDate);

          if (!firstDutyDate || currentDate < firstDutyDate) {
            firstDutyDate = currentDate;
          }

          if (!lastDutyDate || currentDate > lastDutyDate) {
            lastDutyDate = currentDate;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {
        firstDate: firstDutyDate,
        lastDate: lastDutyDate
      };
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('SearchPastGDCtrl', SearchPastGDCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name SearchPastGDCtrl
  * @description 
  *   Search pending duties 
  * @ngInject
  */

  function SearchPastGDCtrl($scope, GroundDutyFactory, PastDutyFactory, $uibModalInstance, $route, CourseFactory, defaultCalendarDate, CrewRouteFactory, FlightFactory) {
    $scope.dutyId = null;
    $scope.showContent = 'search';
    $scope.course = {
      isCourseLimited: true
    };
    $scope.hasError = false; // cancel

    $scope.doCancel = doCancel;
    $scope.closeModal = closeModal;
    $scope.showMessage = true;
    var today = new Date().toUTC();

    if (defaultCalendarDate) {
      today = new Date(defaultCalendarDate).toUTC();
    }

    $scope.dutyDatePicker = {
      value: today,
      format: 'dd-MM-yyyy',
      opened: false
    };
    $scope.dateFormat = 'dd-MM-yyyy';
    $scope.openDatepicker = openDatepicker;

    function openDatepicker() {
      $scope.dutyDatePicker.opened = true;
    }

    $scope.searchGDByDate = searchGDByDate;
    $scope.searchNotStarted = searchNotStarted;

    function searchGDByDate() {
      $scope.hasError = false;
      $scope.showContent = 'loading';
      PastDutyFactory.getPastDuties($scope.dutyDatePicker.value.toString('yyyy-MM-dd')).then(function (res) {
        return handleSubmitResponse(res);
      })["catch"](function (res) {
        return handleFailedResponse(res);
      });
    }

    function searchNotStarted() {
      $scope.hasError = false;
      $scope.showContent = 'loading';
      PastDutyFactory.getNotStartedDuties($scope.dutyDatePicker.value.toString('yyyy-MM-dd')).then(function (res) {
        return handleNotStartedSubmitResponse(res);
      })["catch"](function (res) {
        return handleNotStartedFailedResponse(res);
      });
    } // search pending gd


    $scope.searchGD = searchGD;
    /**
     * Close the modal
     * @memberof SearchPastGDCtrl
     */

    function doCancel() {
      $uibModalInstance.close('cancel');
    }

    function searchGD() {
      $scope.showContent = 'loading';
      PastDutyFactory.getPastDuties('').then(function (res) {
        return handleSubmitResponse(res);
      })["catch"](function (res) {
        return handleFailedResponse(res);
      });
    }

    function handleSubmitResponse(res) {
      $scope.showContent = 'results';
      $scope.availableCources = res.data.trainingCourses;
      $scope.pendingDuties = res.data.pendingGroundDuties;
      $scope.flightTrainings = res.data.pendingRoutes;
      $scope.pendingFlightCourses = res.data.flightCourses;
      var flights = res.data.flightsForPendingRoutes;
      FlightFactory.insertFlightsWithPendingTrainings(flights);
      $scope.availableCources.forEach(function (course) {
        course.HasLimitedInfo = true;
        CourseFactory.upsertCourse(course, function () {});
      });
      $scope.pendingDuties.forEach(function (duty) {
        duty.isManualEntry = true;
        duty.hasPendingCourse = true;
        GroundDutyFactory.addGroundDuty(duty);
      });
      $scope.flightTrainings.forEach(function (pendingRoute) {
        pendingRoute.isManualEntry = true;
        pendingRoute.hasPendingCourse = true;
        CrewRouteFactory.addCrewRouteDuty(pendingRoute);
      });
      $scope.pendingFlightCourses.forEach(function (course) {
        course.HasLimitedInfo = true;
        CourseFactory.upsertCourse(course, function () {});
      });
    }

    function handleNotStartedSubmitResponse(res) {
      $scope.showContent = 'notStartedResults';
      $scope.notStartedGroundDuties = res.data.notStartedGroundDuties;
      $scope.groundCourses = res.data.trainingCourses;
      $scope.notStartedGroundDuties.forEach(function (duty) {
        duty.isManualEntry = true;
        duty.hasPendingCourse = true;
        GroundDutyFactory.addGroundDuty(duty);
      });
      $scope.groundCourses.forEach(function (course) {
        course.HasLimitedInfo = true;
        CourseFactory.upsertCourse(course, function () {});
      });
    }

    function closeModal() {
      $uibModalInstance.close();
      $route.reload();
    }

    function handleFailedResponse(res) {
      $scope.showContent = 'results';
      $scope.hasError = true;
    }

    function handleNotStartedFailedResponse(res) {
      $scope.showContent = 'notStartedResults';
      $scope.hasError = true;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('PastDutyFactory', PastDutyFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name PastDutyFactory
  * @description 
  * Get Past  Duties.
  * @ngInject
  */

  function PastDutyFactory($http, apiUrl) {
    var service = {
      getPastDuties: getPastDuties,
      getNotStartedDuties: getNotStartedDuties
    };

    function getPastDuties(selectedDate, callback) {
      return $http.get(apiUrl + '/Training/GetPastDuties?specificDutyDate=' + selectedDate, {
        'Content-Type': 'application/json'
      })["catch"](callback);
    }

    function getNotStartedDuties(selectedDate, callback) {
      return $http.get(apiUrl + '/Training/GetNotStartedDuties?specificDutyDate=' + selectedDate, {
        'Content-Type': 'application/json'
      })["catch"](callback);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.config(compileProviderConfig);
  /**
  * @memberof CabinReports
  * @ngdoc config
  * @name compileProviderConfig
  * @description 
  *   Config aHref Sanitization Whitelist (make "safe" to download image from data url)
  * @ngInject
  */

  function compileProviderConfig($compileProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|ghttps?|ms-appx|x-wmapp0|data|tel):/);
  }
})();
"use strict";

(function () {
  'use strict'; // By default, AngularJS will catch errors and log them to
  // the Console. We want to keep that behavior; however, we
  // want to intercept it so that we can also log the errors
  // to the server for later analysis.

  a3_cabin_reports.config(exceptionConfig);
  /**
  * @memberof CabinReports
  * @ngdoc config
  * @name exceptionConfig
  * @description 
  *   By default, AngularJS will catch errors and log them to
  *   the Console. We want to keep that behavior; however, we
  *   want to intercept it so that we can also log the errors
  *   to the server for later analysis.
  * @ngInject
  */

  function exceptionConfig($provide) {
    $provide.decorator('$exceptionHandler', extendExceptionHandler);
  }
  /**
  * @memberof exceptionConfig
  * @description 
  *   Override default exception handling and log errors 
  * @ngInject
  */


  function extendExceptionHandler($delegate, LogService) {
    return function (exception, cause) {
      $delegate(exception, cause);
      var exceptionMessage = exception && exception.message ? exception.message : String(exception || '');
      var isCalendarTemplateLoadCancellation = exceptionMessage.indexOf('$compile:tpload') >= 0 && exceptionMessage.indexOf('views/calendar.html') >= 0 && exceptionMessage.indexOf('p1=-1') >= 0; // Ignore expected template-load cancellation during route/login transitions.

      if (isCalendarTemplateLoadCancellation) {
        return;
      }
      /**
       * Could add the error to a service's collection,
       * add errors to $rootScope, log errors to remote web server,
       * or log locally. Or throw hard. It is entirely up to you.
       * throw exception;
       */


      LogService.error(exception, cause);
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('http401interceptor', http401interceptor);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name http401interceptor
  * @description 
  *   Redirect HTTP401 to login page, examine json format on success
  * @ngInject
  */

  function http401interceptor($q, $location, $log, LogService) {
    return {
      'response': function response(_response) {
        // do something on success
        //expecting specific object as a response: success:true/false,errorMessage:string,data:any not null object
        //var contentType=response.headers("content-type");
        var header = "";
        if (typeof _response != 'undefined' && _response != null && _response && typeof _response.headers != 'undefined' && _response.headers != null && _response.headers && _response.headers() && _response.headers("content-type")) header = _response.headers("content-type").substring(0, 16);

        if (header === "application/json") {
          var errorMessage = "";
          var isError = false;

          if (_response == null || _response.data == null || _response.data.success == null || _response.data.errorMessage == null || _response.data.data === 'undefined') {
            isError = true;
            errorMessage = "Server response not found";
          } else if (_response.data.success == false) {
            isError = true;
            errorMessage = _response.data.errorMessage;
          }

          if (isError) $q.reject(_response, errorMessage);
        } else {
          //try to log error cases
          var err = null;
          if (typeof _response === 'undefined' || _response == null) err = "Response was empty";else if (!_response.headers) err = "Response does not contain headers";else if (!_response.status) err = "Response does not have a status";else if (_response.status >= 400) err = "Response status was " + _response.status + " instead of 200";
          if (err != null) LogService.debug(err);
        }

        return _response || $q.when(_response);
      },
      // optional method
      'responseError': function responseError(rejection) {
        if (rejection.status === 401) {
          $log.error('Authorization failed. Need to login again');

          if ($location.path() != '/login') {
            $location.path('/login'); //force refresh so that the browser will download any updates from the cache.manifest
            //without refresh, user may stick to an older version for ever

            setTimeout(function () {
              window.location.reload(true);
            }, 1000);
          }

          return $q.reject(rejection);
        } else {
          return $q.reject(rejection);
        }
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('httpCrewTokenInterceptor', httpCrewTokenInterceptor);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name httpCrewTokenInterceptor
  * @description 
  *  Add CrewToken on non login requests
  * @ngInject
  */

  function httpCrewTokenInterceptor($location, localStorageMD5Service, UserTokenFactory) {
    return {
      request: function request(config) {
        if ($location.$$url != "/login") {
          // get the user token
          var user = localStorageMD5Service.get('user');
          var token = '';
          if (user != null) token = user.token;
          config.headers['X-CrewToken'] = token;
        }

        return config;
      },
      response: function response(_response) {
        if (_response.headers()['content-type'] === "application/json; charset=utf-8") {
          var expiresAt = _response.headers()['x-expires-token'];

          var crewToken = _response.headers()['x-rolling-token'];

          if (expiresAt && crewToken) {
            var user = localStorageMD5Service.get('user');

            if (user != null) {
              user.token = crewToken;
              user.expires = expiresAt;
              localStorageMD5Service.set('user', user);
            }

            UserTokenFactory.setToken(crewToken);
          }
        }

        return _response;
      }
    };
  }
})();
"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  'use strict';

  a3_cabin_reports.factory('httpHeaderInterceptor', httpHeaderInterceptor);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name httpHeaderInterceptor
  * @description 
  *  Add CrewToken on non login requests
  * @ngInject
  */

  function httpHeaderInterceptor($location, localStorageMD5Service) {
    return {
      request: function request(config) {
        if ($location.$$url != "/login") {
          if (config.url.includes("api")) {
            var user = localStorageMD5Service.get('user');
            var aimsIdToString = user.aimsId.toString();

            if (config.method === "POST" || config.method === "PUT") {
              var dataToHash = _typeof(config.data) === "object" ? angular.toJson(config.data) + aimsIdToString : config.data + aimsIdToString;
              var hash = dataToHash.getHash();
              config.headers['X-VCode'] = hash;
            } else if (config.method === "GET") {
              var absolutePath = config.url;
              var stringToHash = absolutePath.substring(absolutePath.lastIndexOf("/") + 1, absolutePath.length);
              var hash = (stringToHash + aimsIdToString).getHash();
              config.headers['X-VCode'] = hash;
            }
          }
        }

        return config;
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.config(httpProviderConfig);
  /**
  * @memberof CabinReports
  * @ngdoc config
  * @name httpProviderConfig
  * @description 
  *  Register interceptors and modify headers
  * @ngInject
  */

  function httpProviderConfig($httpProvider) {
    $httpProvider.defaults.useXDomain = true;
    delete $httpProvider.defaults.headers.common['X-Requested-With'];
    $httpProvider.interceptors.push('http401interceptor');
    $httpProvider.interceptors.push('httpCrewTokenInterceptor');
    $httpProvider.interceptors.push('httpHeaderInterceptor');
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.config(localStorageMD5Config);
  /**
  * @memberof CabinReports
  * @ngdoc config
  * @name localStorageMD5Config
  * @description 
  *   Config localStorageMD5ServiceProvider directly by using localStorageMD5ServiceProvider
  * @ngInject
  */

  function localStorageMD5Config(localStorageMD5ServiceProvider, localStorageServiceProvider) {
    //localStorageMD5ServiceProvider.help();
    var regx = /[?&]secure[&#]?/;

    if (regx.exec(window.location.href)) {
      console.log('*** SECURE MODE ***');
      localStorageServiceProvider.setStorageType('sessionStorage');
    }

    localStorageServiceProvider.setPrefix('a3.cabin.reports');
    localStorageServiceProvider.setStorageCookie(10, '/');
    localStorageMD5ServiceProvider.enableCompression();
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory("LogService", LogService);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name LogService
  * @description 
  *  The error log service is our wrapper around the core error
  *  handling ability of AngularJS. Notice that we pass off to
  *  the native "$log" method and then handle our additional
  *  server-side logging.
  * @ngInject
  */

  function LogService($log, $injector, $window, apiUrl, version, UserTokenFactory) {
    var lastError = null; //define how many seconds to wait before resending the same error (to avoid multiple errors for the same prob)

    var acceptedTimeDiff = 5;

    function post(errorMessage, stackTrace, cause) {
      try {
        var $http = $injector.get("$http");
        /*// get the user token
        var user = UserFactory.getUser();
        var token = '';
        if (user != null)
        	token = user.token;*/

        var token = UserTokenFactory.getToken(); // Log the JavaScript error to the server.
        // --
        // NOTE: In this demo, the POST URL doesn't
        // exists and will simply return a 404.

        $http({
          method: "POST",
          url: apiUrl + "/log",
          contentType: "application/json",
          data: {
            errorUrl: $window.location.href,
            errorMessage: version + " " + errorMessage,
            stackTrace: stackTrace,
            cause: cause || ""
          },
          beforeSend: function beforeSend(request) {
            request.setRequestHeader('X-CrewToken', token);
          }
        });
      } catch (loggingError) {
        // For Developers - log the log-failure.
        $log.warn("Error logging failed");
        $log.log(loggingError);
      }
    }

    ;

    function postFilter(errorMessage, stackTrace, cause) {
      if (lastError != null && lastError.errorDescr == errorMessage) {
        var timestampDiff = Date.now() - lastError.timestamp;
        var timeDiffInSec = timestampDiff / 1000;

        if (timeDiffInSec > acceptedTimeDiff) {
          lastError = {
            'errorDescr': errorMessage,
            'timestamp': Date.now()
          };
          post(errorMessage, stackTrace, cause);
        }
      } else {
        lastError = {
          'errorDescr': errorMessage,
          'timestamp': Date.now()
        };
        post(errorMessage, stackTrace, cause);
      }
    }

    ;
    return {
      debug: function debug(errorMessage, error) {
        if (error == null) {
          error = new Error();
        }

        if (errorMessage != null) {
          error.description = errorMessage;
        }

        post(error.description, error.stack, "");
      },
      error: function error(exception, cause) {
        // Pass off the error to the default error handler
        // on the AngualrJS logger. This will output the
        // error to the console (and let the application
        // keep running normally for the user).
        $log.error.apply($log, arguments); // Now, we need to try and log the error the server.
        // --
        // NOTE: In production, I have some debouncing
        // logic here to prevent the same client from
        // logging the same error over and over again! All
        // that would do is add noise to the log.

        var errorMessage = exception.toString(); //var stackTrace = stacktraceService.print({ e: exception });
        //var stackTrace = $log.info({ e: exception });

        var stackTrace = exception.stack;
        postFilter(errorMessage, stackTrace, cause);
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('UserTokenFactory', UserTokenFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name UserTokenFactory
  * @description 
  *  Used to maintain the user token, outside the localStorage, in order to be accessible from the service which logs js errors
  * /(this service may not use localstorage provider)
  * @ngInject
  */

  function UserTokenFactory() {
    return {
      token: '',
      setToken: function setToken(value) {
        this.token = value;
      },
      getToken: function getToken() {
        return this.token;
      }
    };
  }
})();
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  'use strict';

  a3_cabin_reports.controller('EventFormModalCtrl', EventFormModalCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name EventFormModalCtrl
  * @description 
  * Flight Fervice Event Form Modal
  * @ngInject
  */

  function EventFormModalCtrl($scope, eventType, $uibModalInstance, FlightServiceEventsFactory) {
    $scope.eventType = _objectSpread({}, JSON.parse(JSON.stringify(eventType)));
    var defaultStart = $scope.eventType.event.StartTime ? moment($scope.eventType.event.StartTime) : null;
    var defaultEnd = $scope.eventType.event.EndTime ? moment($scope.eventType.event.EndTime) : null;
    $scope.cancel = cancel;
    $scope.close = close;
    $scope.submit = submit;
    $scope.startGetTime = startGetTime;
    $scope.endGetTime = endGetTime;
    $scope.resetStart = resetStart;
    $scope.resetEnd = resetEnd;
    $scope.clearRemarks = clearRemarks;
    $scope.requiredValueChanged = requiredValueChanged;
    $scope.hasInvalidTimeRange = hasInvalidTimeRange;
    $scope.showStart = defaultStart != null;
    $scope.showEnd = defaultEnd != null;
    $scope.showStartToggle = showStartToggle;
    $scope.showEndToggle = showEndToggle;
    $scope.showContent = 'eventForm';
    $scope.resultMessage = "";
    $scope.formValues = {};
    $scope.formValues.StartTime = $scope.eventType.event.StartTime ? moment($scope.eventType.event.StartTime) : null;
    $scope.formValues.EndTime = $scope.eventType.event.EndTime ? moment($scope.eventType.event.EndTime) : null;
    $scope.formValues.notRequired = $scope.eventType.event.NotRequired;
    $scope.formValues.showTimePickers = !$scope.formValues.notRequired;

    function startGetTime() {
      $scope.formValues.StartTime = getNowValue();
    }

    function endGetTime() {
      $scope.formValues.EndTime = getNowValue();
    }

    function resetStart() {
      $scope.formValues.StartTime = defaultStart;
    }

    function resetEnd() {
      $scope.formValues.EndTime = defaultEnd;
    }

    function clearRemarks() {
      $scope.eventType.event.Remarks = '';
    }

    function showStartToggle() {
      $scope.showStart = !$scope.showStart;

      if (!$scope.showStart) {
        // When Start is hidden, End cannot be validly submitted either.
        $scope.showEnd = false;
        $scope.formValues.StartTime = null;
        $scope.formValues.EndTime = null;
      }
    }

    function showEndToggle() {
      $scope.showEnd = !$scope.showEnd;

      if (!$scope.showEnd) {
        $scope.formValues.EndTime = null;
      } else {
        $scope.showStart = true;
      }
    }

    function requiredValueChanged() {
      $scope.formValues.notRequired = !$scope.formValues.notRequired;

      if ($scope.formValues.notRequired) {
        $scope.formValues.showTimePickers = false;
        $scope.formValues.StartTime = null;
        $scope.formValues.EndTime = null;
        clearRemarks();
      } else {
        $scope.formValues.showTimePickers = true;
      }
    }

    function getNowValue() {
      var currentUtcTime = new Date().toUTC();
      return moment.utc(currentUtcTime).format();
    }

    function hasInvalidTimeRange() {
      if (!$scope.formValues.showTimePickers) {
        return false;
      }

      if (!$scope.showStart || !$scope.showEnd) {
        return false;
      }

      if (!$scope.formValues.StartTime || !$scope.formValues.EndTime) {
        return false;
      }

      return moment($scope.formValues.EndTime).isBefore(moment($scope.formValues.StartTime));
    }
    /**
           * Close the modal
           */


    function cancel() {
      var doRefreshPanel = true;
      $uibModalInstance.close(doRefreshPanel);
    }

    function close() {
      var doRefreshPanel = true;
      $uibModalInstance.close(doRefreshPanel);
    }
    /**
           * Submit event
           */


    function submit() {
      if (hasInvalidTimeRange()) {
        return;
      }

      $scope.showContent = "loading"; // UpdateTimes

      $scope.eventType.event.StartTime = $scope.showStart && $scope.formValues.StartTime !== null && $scope.formValues.StartTime !== undefined ? moment($scope.formValues.StartTime) : null;
      $scope.eventType.event.EndTime = $scope.showEnd && $scope.formValues.EndTime !== null && $scope.formValues.EndTime !== undefined ? moment($scope.formValues.EndTime) : null;
      $scope.eventType.event.NotRequired = $scope.formValues.notRequired;
      FlightServiceEventsFactory.saveEvent($scope.eventType.event).then(function (res) {
        return handleSaveResponse(res);
      })["catch"](function (res) {
        return SaveFailedCallBack(res);
      });
    }
    /**
           * Response success
           */


    function handleSaveResponse(results) {
      if (results && results.data && results.data.success && results.data.data && results.data.data.length > 0) {
        FlightServiceEventsFactory.setEventsForFlightId($scope.eventType.event.FlightId, results.data.data); //Success

        $scope.resultMessage = "Success";
        $scope.showContent = 'results';
      } else {
        //Failed
        $scope.resultMessage = "Failed";
        $scope.showContent = 'results';
      }
    }
    /**
           * Response failed
           */


    function SaveFailedCallBack() {
      $scope.resultMessage = "Failed";
      $scope.showContent = 'results';
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('flightServiceEvents', flightServiceEvents);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name flightServiceEvents
  * @restrict E
  * @description
  *   Implementation of flightServiceEvents panel
  * @example
  *   Usage:
  *   <flight-service-events></flight-service-events>
  * @ngInject
  */

  function flightServiceEvents(FlightServiceEventsFactory, $sce, $uibModal) {
    function link(scope, element, attributes) {
      //scope.save = save;
      scope.events = [];
      scope.eventTypes = [];
      scope.openEvent = openEvent;
      scope.isRefreshing = false;
      scope.refreshEvents = refreshEvents; //get from LS the events & the types

      getEventsNTypes(scope.flightId);

      function getEventsNTypes(flightId) {
        scope.showPanel = null;
        scope.eventTypes = FlightServiceEventsFactory.getEventTypes();
        scope.events = FlightServiceEventsFactory.getEventsByFlightIdFromLS(flightId); //Merge eventTypes and events using common Code property

        scope.eventTypes.forEach(function (type) {
          var eventInType = scope.events.filter(function (x) {
            return x.EventCode == type.Code;
          });

          if (eventInType[0]) {
            type.event = eventInType[0];
          } else {
            type.event = {
              FlightId: flightId,
              EventTypeId: type.Id,
              EventCode: type.Code,
              StartTime: null,
              EndTime: null,
              NotRequired: null,
              Remarks: null
            };
          }
        });
      }

      function refreshEvents() {
        scope.isRefreshing = true;

        if (scope.isOffline) {
          scope.showPanel = "offline";
          scope.isRefreshing = false;
        } else {
          FlightServiceEventsFactory.getEvents(scope.flightId).then(function (res) {
            return handleRefreshResponse(res);
          });
        }
      }

      function handleRefreshResponse(results) {
        if (results && results.data && results.data.success && results.data.data && results.data.data.length > 0) {
          FlightServiceEventsFactory.setEventsForFlightId(scope.flightId, results.data.data);
          getEventsNTypes(scope.flightId);
        }

        scope.isRefreshing = false;
      }
      /**
      * Open modal to see information for the selected Memo
      * @memberof memosByCategory
      * @param {object} eventType with event object
      */


      function openEvent(_eventType) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/FlightServiceEvents/dlgEventForm.html',
          controller: 'EventFormModalCtrl',
          backdrop: 'static',
          keyboard: false,
          size: 'md',
          resolve: {
            eventType: function eventType() {
              return _eventType;
            }
          }
        });
        modalInstance.result.then(function () {
          //dismiss event
          refreshEvents();
        }, function () {
          //close event
          refreshEvents();
        });
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/FlightServiceEvents/flightServiceEvents.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  'use strict';

  a3_cabin_reports.factory('FlightServiceEventsFactory', FlightServiceEventsFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name FlightServiceEventsFactory
  * @description 
  * Get selected flight info
  * @ngInject
  */

  function FlightServiceEventsFactory($http, apiUrl, GenericService) {
    var service = {
      setEventTypes: setEventTypes,
      setEventsForFlightId: setEventsForFlightId,
      getEventsFromLS: getEventsFromLS,
      getEventTypes: getEventTypes,
      getEventsByFlightIdFromLS: getEventsByFlightIdFromLS,
      getEvents: getEvents,
      saveEvent: saveEvent,
      cleanOldDataServiceEvents: cleanOldDataServiceEvents,
      upsertEvents: upsertEvents
    };
    /**
    * Initialize the EventType 
    * @memberof FlightServiceEventsFactory
    */

    function EventType() {
      this.Id = null;
      this.Code = null;
      this.Title = null;
      this.Description = null;
      this.EnableStartTime = true;
      this.EnableEndTime = false;
      this.EnableNotRequired = false;
      this.AllowRemarks = false;
    }

    var objEventType = 'flightEventTypes';
    var objEventTypeCallback = EventType;
    /**
     * Save Event Types
     * @memberof FlightServiceEventsFactory
     * @param {Array} EventTypes
     */

    function setEventTypes(eventTypes) {
      GenericService.saveAll(eventTypes, objEventType);
    }
    /**
     * Get Event Types
     * @memberof FlightServiceEventsFactory
     * @returns {Array} EventTypes 
     */


    function getEventTypes() {
      return GenericService.list(objEventType, objEventTypeCallback);
    }
    /**
    * Initialize the Event 
    * @memberof FlightServiceEventsFactory
    */


    function Event() {
      this.FlightId = null;
      this.EventTypeId = null;
      this.EventCode = null;
      this.StartTime = null;
      this.EndTime = null;
      this.NotRequired = null;
      this.Remarks = null;
      this.LastUpdated = null;
    }

    var objEvent = 'flightEvents';
    var objEventCallback = Event;

    function getEventsFromLS() {
      return GenericService.list(objEvent, objEventCallback);
    }

    function getEventsByFlightIdFromLS(flightId) {
      var storedEvents = getEventsFromLS();
      return storedEvents.filter(function (x) {
        return x.FlightId == flightId;
      });
    }

    function upsertEvents(events) {
      var flightIds = events.map(function (x) {
        return x.FlightId;
      });
      var storedEvents = getEventsFromLS();
      var otherEvents = storedEvents.filter(function (x) {
        return !flightIds.includes(x.FlightId);
      });
      var mergeEvents = otherEvents.concat(events);
      setEvents(mergeEvents);
    }

    function setEventsForFlightId(flightId, events) {
      var storedEvents = getEventsFromLS();
      var filterEvents = storedEvents.filter(function (x) {
        return x.FlightId != flightId;
      });
      var mergeEvents = filterEvents.concat(events);
      setEvents(mergeEvents);
    }

    function setEvents(events) {
      GenericService.saveAll(events, objEvent);
    }

    function getEvents(flightId, callback) {
      var uri = encodeURI(apiUrl + '/FlightServiceEvents/GetEvents?flightId=' + flightId);
      return $http.get(uri, {
        'Content-Type': 'application/json'
      })["catch"](callback);
    }

    function saveEvent(event, callback) {
      var eventTimesFixed = _objectSpread({}, event);

      if (event.StartTime) {
        eventTimesFixed.StartTime = event.StartTime.clone();
        var startDateObj = new Date(eventTimesFixed.StartTime).fromUTC();
        eventTimesFixed.StartTime = moment(startDateObj);
      } else {
        eventTimesFixed.StartTime = null;
      }

      if (event.EndTime) {
        eventTimesFixed.EndTime = event.EndTime.clone();
        var endDateObj = new Date(eventTimesFixed.EndTime).fromUTC();
        eventTimesFixed.EndTime = moment(endDateObj);
      } else {
        eventTimesFixed.EndTime = null;
      }

      return $http.post(apiUrl + '/FlightServiceEvents/SaveEvent', eventTimesFixed, {
        'Content-Type': 'application/json'
      })["catch"](callback);
    }

    function cleanOldDataServiceEvents(responseFlightIds) {
      var storedEvents = getEventsFromLS();
      var previousEvents = storedEvents.filter(function (x) {
        return responseFlightIds.includes(x.FlightId);
      });
      setEvents(previousEvents);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('annualLeavesSummary', annualLeavesSummary);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name annualLeavesSummary
  * @restrict E
  * @description
  *    Display a summary of Annual Leaves read from localStorage.
  *    Consecutive dates with the same Type are grouped into a single date-range row.
  *    Data shape from storage: { Date, Type, DutyDescription }
  * @example
  *   Usage:
  *   <annual-leaves-summary></annual-leaves-summary>
  * @ngInject
  */

  function annualLeavesSummary(AnnualLeavesFactory) {
    function link($scope) {
      $scope.showAnnualLeavesSummary = false;
      $scope.isPanelOpen = true;

      $scope.togglePanel = function () {
        $scope.isPanelOpen = !$scope.isPanelOpen;
      };

      var typeColorMap = {
        'ALV': 'leave-badge-blue',
        'RLV': 'leave-badge-orange',
        'OLV': 'leave-badge-green',
        'WLV': 'leave-badge-red'
      };

      $scope.getTypeBadgeClass = function (type) {
        return typeColorMap[type] || 'leave-badge-gray';
      };

      var annualLeavesInfo = AnnualLeavesFactory.getAnnualLeavesToStorage();

      if (annualLeavesInfo && annualLeavesInfo.length > 0) {
        $scope.showAnnualLeavesSummary = true;
        $scope.annualLeaves = groupAnnualLeaves(annualLeavesInfo);
      }

      function groupAnnualLeaves(leaves) {
        var grouped = [];
        leaves = leaves.slice().sort(function (a, b) {
          return new Date(a.Date) - new Date(b.Date);
        });

        for (var i = 0; i < leaves.length; i++) {
          var prev = grouped[grouped.length - 1];

          if (i !== 0 && prev.type === leaves[i].Type && new Date(leaves[i].Date) - new Date(prev.dateTo) === 86400000) {
            prev.dateTo = leaves[i].Date;
            prev.DutyCounter++;
          } else {
            grouped.push({
              type: leaves[i].Type,
              description: leaves[i].DutyDescription,
              dateFrom: leaves[i].Date,
              dateTo: leaves[i].Date,
              DutyCounter: 1
            });
          }
        }

        return grouped;
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/LeaveRequest/annual-leaves-summary.tpl.html',
      scope: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('AnnualLeavesFactory', AnnualLeavesFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name AnnualLeavesFactory
   * @description 
   *    Get Annual Leaves Data 
   * @ngInject
   */

  function AnnualLeavesFactory(GenericService) {
    /**
     * Initialize the AnnualLeaves
     * @memberof CheckInFactory
     */
    function AnnualLeaves() {}

    var objType = 'AnnualLeaves';
    var objCallback = AnnualLeaves;
    var service = {
      setAnnualLeavesToStorage: setAnnualLeavesToStorage,
      getAnnualLeavesToStorage: getAnnualLeavesToStorage
    };
    /**
    * Save Annual Leaves
    * @param {array} annualLeavesInInfo 
    */

    function setAnnualLeavesToStorage(annualLeavesInInfo) {
      if (annualLeavesInInfo == undefined || annualLeavesInInfo == null) {
        GenericService.removeAll(objType);
      } else {
        GenericService.saveAll(annualLeavesInInfo, objType, objCallback);
      }
    }
    /**
     * Get annual leaves from localStorage (populated by calendar sync).
     * @returns {array} list of AnnualLeave objects { Date, Type, DutyDescription }
     */


    function getAnnualLeavesToStorage() {
      return GenericService.list(objType, objCallback);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('flexCombination', FlexCombination);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name FlexCombination
  * @restrict E
  * @description
  *   Implementation of Flex Combinations
  *
  *   Initialize the Flex Combination of a season
  * @example
  *   Usage:
  *   <flex-combination season-configuration="seasonConfiguration"  season-request="seasonRequest"></flex-combination>
  * @ngInject
  */

  function FlexCombination($timeout) {
    function link(scope, element, attrs) {
      angular.forEach(scope.seasonRequest.LeaveRequestPriorityPeriods, function (value, key) {
        var temp = value.MockLeaveRequestPrioritySlots;
        var temp2 = value.LeaveRequestPrioritySlots;
        $timeout(function () {
          value.MockLeaveRequestPrioritySlots = angular.fromJson(temp);
          value.LeaveRequestPrioritySlots = angular.fromJson(temp2);
        });
      });
      scope.sortableOptions = {
        handle: '>.row .myHandle',
        update: function update(e, ui) {},
        stop: function stop(e, ui) {
          for (var i = 0; i < scope.seasonRequest.LeaveRequestPriorityPeriods.length; i++) {
            sortSetupOrderNo(scope.seasonRequest.LeaveRequestPriorityPeriods[i]);
          }
        }
      };
      scope.setupOrderNo = setupOrderNo;

      function sortSetupOrderNo(period) {
        if (Array.isArray(period.LeaveRequestPrioritySlots)) {
          for (var i = 0; i < period.LeaveRequestPrioritySlots.length; i++) {
            period.LeaveRequestPrioritySlots[i].OrderNo = i + 1;
          }
        }
      }

      ;

      function setupOrderNo(period) {
        if (Array.isArray(period.MockLeaveRequestPrioritySlots)) {
          period.LeaveRequestPrioritySlots = [];

          for (var i = 0; i < period.MockLeaveRequestPrioritySlots.length; i++) {
            var temp = Object.assign({}, period.MockLeaveRequestPrioritySlots[i]);
            temp.OrderNo = i + 1;
            period.LeaveRequestPrioritySlots.push(temp);
          }
        }
      }

      ;
      scope.removeSlot = removeSlot;

      function removeSlot(slotIndex, period) {
        period.LeaveRequestPrioritySlotsHelper = [];

        for (var i = 0; i < period.LeaveRequestPrioritySlots.length; i++) {
          if (i != slotIndex) {
            period.LeaveRequestPrioritySlotsHelper.push(period.LeaveRequestPrioritySlots[i]);
          }
        }

        period.LeaveRequestPrioritySlots = period.LeaveRequestPrioritySlotsHelper;
        period.MockLeaveRequestPrioritySlots = period.LeaveRequestPrioritySlotsHelper;
        setupOrderNo(period);
      }
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/LeaveRequest/flexCombinations.tpl.html',
      scope: {
        seasonConfiguration: '<',
        seasonRequest: '=',
        editable: '<'
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('LeaveRequestCtrl', LeaveRequestCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name LeaveRequestCtrl
  * @description 
  *   View Leave Request Tool
  * @ngInject
  */

  function LeaveRequestCtrl($scope, $filter, $route, LeaveRequestFactory, $uibModal, $timeout, $location) {
    $scope.state = 'leaveRequest';
    $scope.getRandomBorderColor = getRandomBorderColor;
    $scope.getRandomTextColor = getRandomTextColor;
    $scope.IsValidLeaveRequest = IsValidLeaveRequest;
    $scope.showHelp = showHelp;
    $scope.showSuccessLeaveApplicationMessage = false;
    $scope.hasErrors = false;
    $scope.leaveFormReady = false;
    $scope.isOnline = window.navigator.onLine;

    if (!$scope.isOnline) {
      bootbox.alert({
        title: "<div class='text-orange'>No Internet</div>",
        message: 'Please check the internet connection!'
      });
      return;
    }

    progressBarBox(true);
    LeaveRequestFactory.getConfigurationDetails(function (responseData) {
      if (responseData.data && responseData.data.data && responseData.data.data.QualificationGroup && responseData.data.data.LeaveRequestInformation) {
        $scope.QualificationGroup = responseData.data.data.QualificationGroup;
        $scope.LeaveRequestInformation = responseData.data.data.LeaveRequestInformation;
        $scope.QualificationGroup.RequestLessDays = $scope.QualificationGroup.RequestLessDays ? $scope.QualificationGroup.RequestLessDays : false;
        $scope.QualificationGroup.RequestNoLeave = $scope.QualificationGroup.RequestNoLeave ? $scope.QualificationGroup.RequestNoLeave : false; //FOR TEST: 
        //$scope.LeaveRequestInformation.GroupStatus="PROCESS";

        $scope.closeDateStr = moment($scope.LeaveRequestInformation.CloseDate).format('Do of MMMM');
        $scope.isOpen = $scope.LeaveRequestInformation.GroupStatus == "OPEN";
        $scope.LeaveRequest = {
          YearId: $scope.LeaveRequestInformation.YearId,
          MemberId: $scope.LeaveRequestInformation.MemberId,
          RequestNoleave: responseData.data.data.LeaveRequest ? responseData.data.data.LeaveRequest.RequestNoleave : false,
          // Default: Request Leave selected
          LeaveRequestSeasons: []
        };

        if (responseData.data.data.LeaveRequest) {
          $scope.showSuccessLeaveApplicationMessage = true;
        }

        if (responseData.data.data.LeaveRequest && !responseData.data.data.LeaveRequest.RequestNoleave) {
          mergeRequest(responseData.data.data.LeaveRequest, $scope.QualificationGroup.Seasons);
        } else {
          initializeNewRequest($scope.QualificationGroup.Seasons); //Temporary: Hide Instructions
          //if($scope.isOpen) $timeout(showHelp,500);
        }

        $scope.leaveFormReady = true;
      } else {
        $scope.hasErrors = true;
      }

      progressBarBox(false);
    }, function (data) {
      console.error('LeaveRequest getConfigurationDetails error:', data);
      progressBarBox(false);
    });

    function mergeRequest(leaveRequest, seasons) {
      $scope.LeaveRequest = leaveRequest;

      for (var j = 0; j < leaveRequest.LeaveRequestSeasons.length; j++) {
        leaveRequest.LeaveRequestSeasons[j].HasSpecificCombinations = $filter('filter')(leaveRequest.LeaveRequestSeasons[j].LeaveRequestPriorities, {
          Type: 'All'
        }).length > 0;

        for (var i = 0; i < seasons.length; i++) {
          if (seasons[i].Id == leaveRequest.LeaveRequestSeasons[j].SeasonId) {
            leaveRequest.LeaveRequestSeasons[j].StartDate = seasons[i].StartDate;
            leaveRequest.LeaveRequestSeasons[j].EndDate = seasons[i].EndDate;
            leaveRequest.LeaveRequestSeasons[j].Slots = seasons[i].Slots;
            leaveRequest.LeaveRequestSeasons[j].Configurations = seasons[i].Configurations;
            setupMockLeaveRequestPriorities(leaveRequest.LeaveRequestSeasons[j].LeaveRequestPriorities, seasons[i].Slots);

            for (var h = 0; h < seasons[i].Configurations.length; h++) {
              if (seasons[i].Configurations[h].Id == leaveRequest.LeaveRequestSeasons[j].ConfigurationId) {
                leaveRequest.LeaveRequestSeasons[j].Configuration = seasons[i].Configurations[h];
              }
            }
          }
        }
      }

      $scope.LeaveRequest = leaveRequest;
    }

    function setupMockLeaveRequestPriorities(priorities, slots) {
      for (var i = 0; i < priorities.length; i++) {
        for (var j = 0; j < priorities[i].LeaveRequestPriorityPeriods.length; j++) {
          for (var h = 0; h < priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots.length; h++) {
            var tempOrderNo = priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots[h].OrderNo; //need clone the priority slot to fix conflicts with onder numbers

            priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots[h] = JSON.parse(JSON.stringify(findSlot(priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots[h], slots)));

            if (priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots[h]) {
              priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots[h].OrderNo = tempOrderNo;
            }
          } //need clone the priority slot to fix conflicts with onder numbers


          priorities[i].LeaveRequestPriorityPeriods[j].MockLeaveRequestPrioritySlots = JSON.parse(JSON.stringify(priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots));
        }
      }
    }

    function findSlot(value, slots) {
      var temp = null;

      for (var i = 0; i < slots.length; i++) {
        if (slots[i].Id == value.Id) {
          temp = slots[i];
        }
      }

      return temp;
    }

    function showHelp() {
      $uibModal.open({
        templateUrl: 'views/LeaveRequest/dlgLeaveRequestInstructions.html',
        controller: 'LeaveRequestInstructionsCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {}
      });
    }

    function initializeNewRequest(seasons) {
      for (var i = 0; i < seasons.length; i++) {
        var leaveRequestSeason = seasons[i];
        leaveRequestSeason.SeasonId = leaveRequestSeason.Id;
        var flexLeaveRequestPriority = {
          Type: "Any",
          Priority: 1000,
          LeaveRequestPriorityPeriods: []
        };
        var configurationDays = [];

        for (var j = 0; j < seasons[i].Configurations.length; j++) {
          configurationDays.push(seasons[i].Configurations[j].Days);
        }

        leaveRequestSeason.Days = configurationDays.unique();
        leaveRequestSeason.HasSpecificCombinations = false;
        leaveRequestSeason.LeaveRequestPriorities = [flexLeaveRequestPriority];
        $scope.LeaveRequest.LeaveRequestSeasons.push(leaveRequestSeason);
      }
    }

    function IsValidLeaveRequest() {
      var isValid = true;

      if (!$scope.LeaveRequest.RequestNoleave) {
        //Validate only if Requested Leave
        if ($scope.LeaveRequest && !$scope.invalidSelectedLeaveDays) {
          for (var i = 0; i < $scope.LeaveRequest.LeaveRequestSeasons.length; i++) {
            for (var j = 0; j < $scope.LeaveRequest.LeaveRequestSeasons[i].LeaveRequestPriorities.length; j++) {
              if ($scope.LeaveRequest.LeaveRequestSeasons[i].LeaveRequestPriorities[j].HasInvalidPeriod) {
                isValid = false;
                break;
              }
            }

            if (!$scope.LeaveRequest.LeaveRequestSeasons[i].Configuration) {
              isValid = false;
              break;
            }
          }
        } else {
          isValid = false;
        }
      }

      return isValid;
    }

    $scope.updateLeaveRequestSeason = updateLeaveRequestSeason;
    $scope.showCombo = false;
    $scope.radioConfigurationModel = null;
    $scope.sendRequest = sendRequest;
    $scope.addComment = addComment;

    function addComment(request) {
      request.Comments = " ";
    }

    function sendRequest() {
      //Request No Leave: Clear any selected values
      if ($scope.LeaveRequest.RequestNoleave) {
        $scope.LeaveRequest.LeaveRequestSeasons = [];
      }

      progressBarBox(true);
      LeaveRequestFactory.saveLeaveRequest($scope.LeaveRequest, onSuccessSendRequest, onErrorSendRequest);
    }

    function onSuccessSendRequest(data) {
      progressBarBox(false);

      if (data.data.success == true) {
        ShowSuccessMessage();
      } else {
        ShowErrorMessage();
      }
    }

    function onErrorSendRequest(data) {
      progressBarBox(false);
      ShowErrorMessage();
    }

    function ShowSuccessMessage() {
      var closeDateStr = moment($scope.LeaveRequestInformation.CloseDate).format('Do of MMMM');
      bootbox.alert({
        title: "<div class='text-green'>Success</div>",
        message: "You have successfully submitted your leave request. You can modify your leave request untill the " + closeDateStr + ".",
        callback: function callback() {
          $route.reload();
        }
      });
    }

    function ShowErrorMessage() {
      bootbox.alert({
        title: "<div class='text-red'>Error</div>",
        message: "Failed to send your leave request. Please try again later",
        callback: function callback() {
          $route.reload();
        }
      });
    }

    function progressBarBox(isOpen) {
      if (isOpen) {
        bootbox.dialog({
          closeButton: false,
          message: '<div class="text-center"><i class="fa fa-spin fa-spinner"></i> Please wait...</div>' //title: "Please wait..."

        });
      } else {
        bootbox.hideAll();
      }
    }
    /*        function setupView() {
                if (!UserFactory.isLoggedIn()) {
                    $location.path("/login");
                }*/
    //$scope.sortableOptions['ui-floating'] = true;


    function updateLeaveRequestSeason(season) {
      season.ConfigurationId = season.Configuration.Id;

      for (var i = 0; i < season.LeaveRequestPriorities.length; i++) {
        for (var j = 0; j < season.Configuration.Periods.length; j++) {
          season.Configuration.Periods[j].ConfigurationPeriodId = season.Configuration.Periods[j].Id;
        }

        season.LeaveRequestPriorities[i].LeaveRequestPriorityPeriods = JSON.parse(JSON.stringify(season.Configuration.Periods));
      }

      var totalDays = 0;
      var hasConfig = true;

      for (var i = 0; i < $scope.LeaveRequest.LeaveRequestSeasons.length; i++) {
        totalDays = totalDays + ($scope.LeaveRequest.LeaveRequestSeasons[i].Configuration && $scope.LeaveRequest.LeaveRequestSeasons[i].Configuration.Days ? $scope.LeaveRequest.LeaveRequestSeasons[i].Configuration.Days : 0);
        hasConfig = hasConfig && $scope.LeaveRequest.LeaveRequestSeasons[i].Configuration;
      }

      if (totalDays > $scope.LeaveRequestInformation.LeaveDays) {
        $scope.invalidSelectedLeaveDays = true;
        bootbox.alert("<h4 class='text-deep-orange'>Warning!</h4> You are entilted to <strong>" + $scope.LeaveRequestInformation.LeaveDays + " leave days </strong> but you have selected a combination of  <strong>" + totalDays + " days</strong>. Please proceed with the necessary changes.");
      } else if ($scope.QualificationGroup && !$scope.QualificationGroup.RequestLessDays && totalDays < $scope.LeaveRequestInformation.LeaveDays) {
        $scope.invalidSelectedLeaveDays = true;

        if (hasConfig) {
          bootbox.alert("<h4 class='text-deep-orange'>Warning!</h4> You are entilted to <strong>" + $scope.LeaveRequestInformation.LeaveDays + " leave days </strong> but you have selected a combination of  <strong>" + totalDays + " days</strong>. Please proceed with the necessary changes.");
        }
      } else {
        $scope.invalidSelectedLeaveDays = false;
      }
    }

    function getRandomBorderColor(season) {
      var cssClass = "border-left-green";

      if (!season.Configuration) {
        cssClass = "border-left-orange";
      }

      return cssClass;
    }

    function getRandomTextColor(season) {
      var cssClass = "text-green";

      if (!season.Configuration) {
        cssClass = "text-orange";
      }

      return cssClass;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('LeaveRequestFactory', LeaveRequestFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name LeaveRequestFactory
   * @description 
   *    Get Leave Request Configuration Data and submit new Leave Request
   * @ngInject
   */

  function LeaveRequestFactory(GenericService, $http, $q, apiUrl) {
    var service = {
      getConfigurationDetails: getConfigurationDetails,
      saveLeaveRequestInformation: saveLeaveRequestInformation,
      getLeaveRequestInformation: getLeaveRequestInformation,
      saveLeaveRequest: saveLeaveRequest,
      getRequestedSlots: getRequestedSlots
    };
    /**
    * Initialize the LeaveRequestInformation
    * @memberof LeaveRequestFactory
    */

    function LeaveRequestInformation() {}

    var objType = 'LeaveRequestInformation';
    var objCallback = LeaveRequestInformation;
    var leaveRequestApiURL = apiUrl + '/LeaveRequest';
    /**
     * Get the LeaveRequestInformation and the qualification Group
     * @memberof LeaveRequestFactory
     * @param {function} callback  an on success callback function
     * @param {function} errorCallback  an on error callback function
     */

    function getConfigurationDetails(callback, errorCallback) {
      return $http.get(leaveRequestApiURL, {
        'Content-Type': 'application/json'
      }).then(function (responseData) {
        if (responseData && responseData.data && responseData.data.data && responseData.data.data.LeaveRequestInformation) {
          saveLeaveRequestInformation(responseData.data.data.LeaveRequestInformation);
        }

        callback(responseData);
      })["catch"](errorCallback);
    }

    function saveLeaveRequest(request, callback, errorCallback) {
      var cleanRequest = angular.toJson(request);
      console.log(cleanRequest);
      return $http.post(leaveRequestApiURL, cleanRequest, {
        'Content-Type': 'application/json'
      }).then(function (responseData) {
        if (responseData && responseData.data && responseData.data.data && responseData.data.data.LeaveRequestInformation) {
          saveLeaveRequestInformation(responseData.data.data.LeaveRequestInformation);
        }

        callback(responseData);
      })["catch"](errorCallback);
    }
    /**
     * Save the leave Request Information  Object in local storage
     * @memberof LeaveRequestFactory
     * @param {object} leaveRequestInformation  a leaveRequestInformation
     */


    function saveLeaveRequestInformation(leaveRequestInformation) {
      GenericService.saveOne(leaveRequestInformation, objType, objCallback);
    }
    /**
     * Save the leave Request Information  Object in local storage
     * @memberof LeaveRequestFactory     
     * @returns {object} leaveRequestInformation  
     */


    function getLeaveRequestInformation() {
      return GenericService.getOne(objType, objCallback);
    }
    /**
     * Fetch requested leave slots from Crew Planning Lab directly via API.
     * Returns current and next year slots regardless of submission period status.
     * Does NOT use localStorage. Requires internet connectivity.
     * Response shape mirrors GET /LeaveRequest: { QualificationGroup, LeaveRequestInformation, LeaveRequest }
     * @param {function} callback  on success callback
     * @param {function} errorCallback  on error callback
     */


    function getRequestedSlots(callback, errorCallback) {
      return $http.get(leaveRequestApiURL + '/RequestedSlots', {
        'Content-Type': 'application/json'
      }).then(function (responseData) {
        callback(responseData);
      })["catch"](errorCallback);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('LeaveRequestInstructionsCtrl', LeaveRequestInstructionsCtrl);
  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name LeaveRequestInstructionsCtrl
  * @description 
  *   Get the Leave Request Instructions
  * @ngInject
  */

  function LeaveRequestInstructionsCtrl($scope, $uibModalInstance) {
    $scope.page = 1;
    $scope.cancel = cancel;
    $scope.nextPage = nextPage;
    $scope.previousPage = previousPage;
    $scope.instructionPages = 3;
    /**
     * Goes to the next page of  leave instructions
     * @memberof LeaveRequestInstructionsCtrl
     */

    function nextPage() {
      $scope.page = $scope.page + 1;
      normalizePage();
    }
    /**
    * Goes to the previous page of leave instructions
    * @memberof LeaveRequestInstructionsCtrl
    */


    function previousPage() {
      $scope.page = $scope.page - 1;
      normalizePage();
    }
    /**
     * Normalize the page number if it is out of range
     * @memberof LeaveRequestInstructionsCtrl
     */


    function normalizePage() {
      if ($scope.page > $scope.instructionPages || $scope.page < 1) {
        $scope.page = 1;
      }
    }
    /**
     * Close the modal
     * @memberof LeaveRequestInstructionsCtrl
     */


    function cancel() {
      $uibModalInstance.close('close');
    }

    ;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('specificCombinations', SpecificCombinations);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name SpecificCombinations
  * @restrict E
  * @description
  *   Implementation of Specific Combinations
  *
  *   Initialize the Specific Combinations of a season
  * @example
  *   Usage:
  *   <specific-combinations season-configuration="seasonConfiguration"  season-requests="seasonRequests"></specific-combinations>
  * @ngInject
  */

  function SpecificCombinations($filter) {
    function link(scope, element, attrs) {
      scope.IsEditEnabled = false;
      scope.selectEditablePeriod = selectEditablePeriod;
      scope.updateEditablePeriod = updateEditablePeriod;
      scope.removeSpecificCombination = removeSpecificCombination;
      scope.addNewSpecificCombination = addNewSpecificCombination;
      scope.getBorderClass = getBorderClass;
      scope.selectedSlotTemp = null;
      scope.isDisabled = isDisabled;
      scope.specificCombinations = $filter('filter')(scope.seasonRequests, {
        Type: 'All'
      });
      scope.sortableOptions = {
        handle: '> .row .myHandle',
        update: function update(e, ui) {},
        stop: function stop(e, ui) {
          recalculatePriorities();
        }
      };

      function recalculatePriorities() {
        for (var i = 0; i < scope.specificCombinations.length; i++) {
          scope.specificCombinations[i].Priority = i + 1;
        }
      }

      function selectEditablePeriod(period, request) {
        if (!period.isEditable) {
          resetEditablePeriods();

          if (period.LeaveRequestPrioritySlots && period.LeaveRequestPrioritySlots.length > 0) {
            scope.selectedSlotTemp = period.LeaveRequestPrioritySlots[0];
          } else {
            scope.selectedSlotTemp = null;
          }

          scope.selectedRequestTemp = request;
          scope.selectedSlotDaysTemp = period.Days;
          period.isEditable = true;
          scope.IsEditEnabled = true;
        } else {
          resetEditablePeriods();
        }
      }

      function getBorderClass(request) {
        var hasEmptyFields = false;
        var hasFilledFields = false;
        var cssClass = "";

        for (var i = 0; i < request.LeaveRequestPriorityPeriods.length; i++) {
          hasEmptyFields = hasEmptyFields || !request.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots || request.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots.length == 0;
          hasFilledFields = hasFilledFields || !(!request.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots || request.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots.length == 0);
        }

        if (hasEmptyFields && hasFilledFields) {
          cssClass = 'specific-combination-orange';
          request.HasInvalidPeriod = true;
        } else if (hasEmptyFields && !hasFilledFields) {
          cssClass = 'specific-combination-blue';
          request.HasInvalidPeriod = false;
        } else if (hasFilledFields && !hasEmptyFields) {
          cssClass = 'specific-combination-green';
          request.HasInvalidPeriod = false;
        }

        return cssClass;
      }

      function isDisabled(slot) {
        var CSSclass = "";

        if (scope.selectedRequestTemp) {
          for (var i = 0; i < scope.selectedRequestTemp.LeaveRequestPriorityPeriods.length; i++) {
            if (scope.selectedRequestTemp.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots && scope.selectedRequestTemp.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots.length > 0 && (scope.selectedRequestTemp.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots[0].Id == slot.Id || scope.selectedRequestTemp.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots[0].EndDay >= slot.StartDay && scope.selectedRequestTemp.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots[0].StartDay <= slot.EndDay)) {
              CSSclass = "disabled";
              break;
            }
          }
        }

        return CSSclass;
      }

      function resetEditablePeriods() {
        for (var i = 0; i < scope.seasonRequests.length; i++) {
          for (var j = 0; j < scope.seasonRequests[i].LeaveRequestPriorityPeriods.length; j++) {
            scope.seasonRequests[i].LeaveRequestPriorityPeriods[j].isEditable = false;
          }
        }

        scope.IsEditEnabled = false;
      }

      function updateEditablePeriod(slot) {
        for (var i = 0; i < scope.seasonRequests.length; i++) {
          for (var j = 0; j < scope.seasonRequests[i].LeaveRequestPriorityPeriods.length; j++) {
            if (scope.seasonRequests[i].LeaveRequestPriorityPeriods[j].isEditable && slot && slot.Code) {
              scope.seasonRequests[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots = [slot];
            }
          }
        }

        resetEditablePeriods();
      }

      function removeSpecificCombination(priority) {
        var indexOfRemovedObj = null;

        for (var i = 0; i < scope.seasonRequests.length; i++) {
          if (scope.seasonRequests[i].Priority == priority) {
            indexOfRemovedObj = i;
          }
        }

        if (indexOfRemovedObj != null) {
          scope.seasonRequests.splice(indexOfRemovedObj, 1);
          scope.specificCombinations = $filter('filter')(scope.seasonRequests, {
            Type: 'All'
          });
          recalculatePriorities();
        }
      }

      function addNewSpecificCombination() {
        var newSpecificCombinationPriority = 1;

        if (scope.specificCombinations && scope.specificCombinations.length > 0) {
          newSpecificCombinationPriority = scope.specificCombinations.length + 1;
        }

        var newObj = {
          Type: "All",
          Priority: newSpecificCombinationPriority,
          LeaveRequestPriorityPeriods: []
        };
        scope.seasonRequests.push(newObj);
        updateLeaveRequestSeason();
        scope.specificCombinations = $filter('filter')(scope.seasonRequests, {
          Type: 'All'
        });
        scope.IsEditEnabled = false;
      }

      function updateLeaveRequestSeason() {
        scope.seasonConfiguration.ConfigurationId = scope.seasonConfiguration.Configuration.Id;

        for (var i = 0; i < scope.seasonRequests.length; i++) {
          for (var j = 0; j < scope.seasonConfiguration.Configuration.Periods.length; j++) {
            scope.seasonConfiguration.Configuration.Periods[j].ConfigurationPeriodId = scope.seasonConfiguration.Configuration.Periods[j].Id;
          }

          if (scope.seasonRequests[i].LeaveRequestPriorityPeriods && scope.seasonRequests[i].LeaveRequestPriorityPeriods.length == 0) {
            scope.seasonRequests[i].LeaveRequestPriorityPeriods = JSON.parse(JSON.stringify(scope.seasonConfiguration.Configuration.Periods));
          }
        }
      }
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/LeaveRequest/specificCombinations.tpl.html',
      scope: {
        seasonConfiguration: '<',
        seasonRequests: '=',
        editable: '<'
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('LuggageComplianceFactory', LuggageComplianceFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name LuggageComplianceFactory
  * @description 
  *   Add, Update, Delete and Get Luggage Compliance per passenger-flight
  * @ngInject
  */

  function LuggageComplianceFactory(GenericService, $http, apiUrl, $timeout) {
    var objType = 'LuggageCompliance';
    var objCallback = LuggageCompliance;
    /**
     * Initialize the Passenger Incident
     * @memberof LuggageComplianceFactory
     */

    function LuggageCompliance() {
      this.GetId = GetId;
      this.isSynced = false;
    }

    var submitResponseObj = {
      success: false,
      message: ''
    };
    var service = {
      setAllLuggageComplianceToStorage: setAllLuggageComplianceToStorage,
      setLuggageComplianceToStorage: setLuggageComplianceToStorage,
      saveLuggageComplianceToStorage: saveLuggageComplianceToStorage,
      getLuggageComplianceFromStorage: getLuggageComplianceFromStorage,
      updateLuggageCompliance: updateLuggageCompliance,
      saveLuggageCompliance: saveLuggageCompliance,
      getLuggageComplianceByFlightId: getLuggageComplianceByFlightId,
      getPassengerLuggageCompliance: getPassengerLuggageCompliance,
      removeLuggageCompliance: removeLuggageCompliance,
      removePendingsLuggageCompliance: removePendingsLuggageCompliance,
      removeLuggageComplianceByFlightId: removeLuggageComplianceByFlightId,
      deleteAllLuggageComplianceReportsByFlightId: deleteAllLuggageComplianceReportsByFlightId,
      submitLuggageCompliance: submitLuggageCompliance,
      syncResultFormat: syncResultFormat,
      updateLuggageComplianceStorage: updateLuggageComplianceStorage,
      saveFlightIsCompliantToStorage: saveFlightIsCompliantToStorage,
      getFlightCompliantStatus: getFlightCompliantStatus,
      cleanOldData: cleanOldData
    };

    function GetId() {
      return this.LocalId;
    }
    /**
     * Save All Luggage Compliance Passengers
     * @param {array} objList 
     */


    function setAllLuggageComplianceToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }
    /**
     * Add or Remove a Luggage Compliance Report
     * @param {object} luggageComplianceReport
     */


    function setLuggageComplianceToStorage(luggageComplianceReport) {
      var report = getPassengerLuggageCompliance(luggageComplianceReport.FlightId, luggageComplianceReport.UCI);

      if (report && !luggageComplianceReport.isChecked) {
        removeLuggageCompliance(report.LocalId);
      } else if (luggageComplianceReport.isChecked) {
        saveLuggageCompliance(luggageComplianceReport);
      }
    }
    /**
     * Add a Luggage Compliance Report if it doesn't already exist, when this function is executed in loop it needs the index of report to prevent same LocalIds.
     * @param {object} luggageComplianceReport
     * @param {object} reportIndex
     */


    function saveLuggageComplianceToStorage(luggageComplianceReport, reportIndex) {
      if (!reportIndex) {
        reportIndex = 0;
      }

      var report = getPassengerLuggageCompliance(luggageComplianceReport.FlightId, luggageComplianceReport.UCI);

      if (!report) {
        //use reportIndex to prevent same LocalId value
        saveLuggageCompliance(luggageComplianceReport, reportIndex);
      }
    }
    /**
     * Add a Luggage Compliance Report for whole flight if it doesn't already exist
     * @param {object} luggageComplianceReport
     */


    function saveFlightIsCompliantToStorage(luggageComplianceReport) {
      var luggageComplianceReports = getLuggageComplianceByFlightId(luggageComplianceReport.FlightId);
      var report = luggageComplianceReports.find(function (x) {
        return x.IsFlightCompliant === true;
      });

      if (!report) {
        saveLuggageCompliance(luggageComplianceReport);
      }
    }
    /**
     * Get all luggage compliance reports of a flight
     * @param {number} flightId 
     */


    function getLuggageComplianceByFlightId(flightId) {
      var allReports = getLuggageComplianceFromStorage();
      var flightReports = allReports.filter(function (x) {
        return x.FlightId == flightId;
      });
      return flightReports;
    }

    ;

    function getFlightCompliantStatus(flightId) {
      var returnStatus = {
        IsFlightCompliant: false,
        Status: '',
        HasPendingsReports: false
      };
      var luggageComplianceReports = getLuggageComplianceByFlightId(flightId);
      var flightCompliantReport = luggageComplianceReports.find(function (x) {
        return x.IsFlightCompliant;
      });

      if (flightCompliantReport) {
        returnStatus.IsFlightCompliant = true;

        if (flightCompliantReport.isSynced) {
          returnStatus.Status = 'synced';
        } else {
          returnStatus.Status = 'pending';
        }
      }

      returnStatus.HasPendingsReports = luggageComplianceReports.some(function (s) {
        return !s.IsFlightCompliant && !s.isSynced;
      });
      return returnStatus;
    }
    /**
     * Get all luggage compliance reports
     */


    function getLuggageComplianceFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Get luggage compliance report for a specific passenger in a specific flight
     * @param {number} flightId 
     * @param {number} uci 
     */


    function getPassengerLuggageCompliance(flightId, uci) {
      var luggageComplianceReports = getLuggageComplianceByFlightId(flightId);
      var passengerReport = luggageComplianceReports.find(function (x) {
        return x.UCI == uci;
      });
      return passengerReport;
    }
    /**
     * Update a luggage compliance report (Search by FlightId-UCI)
     * @param {object} luggageComplianceReport 
     */


    function updateLuggageCompliance(luggageComplianceReport) {
      GenericService.save(luggageComplianceReport, objType, objCallback);
    }
    /**
     * Create a new luggage compliance report
     * @param {object} luggageComplianceReport 
     */


    function saveLuggageCompliance(luggageComplianceReport, reportIndex) {
      if (!reportIndex) {
        reportIndex = 0;
      }

      luggageComplianceReport.LocalId = moment().valueOf() + reportIndex;
      luggageComplianceReport.isSynced = false;
      GenericService.add(luggageComplianceReport, objType, objCallback);
    }
    /**
     * Remove customer event from storage
     * @param {number} luggageComplianceReportId 
     */


    function removeLuggageCompliance(luggageComplianceReportId) {
      GenericService.remove(luggageComplianceReportId, objType, objCallback);
    }
    /**
     * Remove all pendings luggage compliance reports in a flight from storage
     * @param {number} flightId 
     */


    function removePendingsLuggageCompliance(flightId) {
      var pendingReports = getLuggageComplianceByFlightId(flightId).filter(function (x) {
        return !x.isSynced;
      });

      if (pendingReports) {
        pendingReports.forEach(function (unsyncedReport) {
          removeLuggageCompliance(unsyncedReport.LocalId);
        });
      }
    }
    /**
     * Remove all luggage compliance reports in a flight from storage
     * @param {number} flightId 
     */


    function removeLuggageComplianceByFlightId(flightId) {
      var reports = getLuggageComplianceByFlightId(flightId);

      if (reports) {
        reports.forEach(function (report) {
          removeLuggageCompliance(report.LocalId);
        });
      }
    }
    /**
     * Delete all luggage compliance reports of this flight from db and then from local storage
     * @param {number} flightId 
     */


    function deleteAllLuggageComplianceReportsByFlightId(flightId) {
      return $http.post(apiUrl + '/LuggageCompliance/ResetLuggageCompliance', flightId, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return deleteReportsSuccessCallBack(res, flightId);
      })["catch"](function (res) {
        return saveReportFailedCallBack(res);
      });
    }
    /**
          * The callback function upon successful submit
          * @param {object} res 
          * @param {object} objectToAdd 
          * @returns {object} submitResponseObj
          */


    function deleteReportsSuccessCallBack(res, flightId) {
      submitResponseObj.success = res.data.success;

      if (res.data.success) {
        removeAllLuggageCompliance(flightId);
        submitResponseObj.message = "Success";
      } else {
        submitResponseObj.message = res.data.errorMessage;
      }

      return submitResponseObj;
    }
    /**
     * Remove all luggage compliance reports of this flight from storage
     * @param {number} flightId 
     */


    function removeAllLuggageCompliance(flightId) {
      var allReports = getLuggageComplianceByFlightId(flightId);

      if (allReports) {
        allReports.forEach(function (report) {
          removeLuggageCompliance(report.LocalId);
        });
      }
    }
    /**
           * Sends flight's pending luggage compliance reports
           * @param {number} flightId The Flight identifier
           * @returns {promise} submitResponseObj
           */


    function submitLuggageCompliance(flightId) {
      var pendingReports = getLuggageComplianceByFlightId(flightId).filter(function (x) {
        return !x.isSynced;
      });
      var postData = {
        "FlightId": flightId,
        "LuggageCompliance": pendingReports
      };
      return $http.post(apiUrl + '/LuggageCompliance/Post', postData, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return saveReportSuccessCallBack(res, pendingReports, flightId);
      })["catch"](function (res) {
        return saveReportFailedCallBack(res);
      });
    }
    /**
           * The callback function upon successful submit
           * @param {object} res 
           * @param {object} objectToAdd 
           * @returns {object} submitResponseObj
           */


    function saveReportSuccessCallBack(res, pendingReports, flightId) {
      submitResponseObj.success = res.data.success;

      if (res.data.success) {
        updateLuggageComplianceStorage(res.data.data.LuggageComplianceReports, flightId);
        submitResponseObj.message = "Success! Your input has been sent";
      } else {
        submitResponseObj.message = res.data.errorMessage;
      }

      return submitResponseObj;
    }
    /**
    * The callback function upon failure on submit
    * @returns {object} submitResponseObj
    */


    function saveReportFailedCallBack(res) {
      submitResponseObj.success = false;
      submitResponseObj.message = "Oops! Something went wrong";
      return submitResponseObj;
    }
    /**
     * Shows sync result in dlgSync
     * @param {object} result Sync result status
     */


    function syncResultFormat(result) {
      var updateText;
      var upClass;

      if (result.ResponseSuccess == null) {
        updateText = "No One Piece Compliance Checks were uploaded to the server. ";
        upClass = "alert-cyan";
      } else if (result.ResponseSuccess == true) {
        updateText = "One Piece Compliance Checks were uploaded to the server. ";
        upClass = "alert-cyan";
        updateAllPendingsToSynced(result.LuggageComplianceReports);
      } else {
        updateText = "One Piece Compliance Checks failed to be uploaded to the server. ";
        upClass = "alert-deep-orange";
        cleanOldPendingChecks();
      }

      return {
        updMessage: updateText,
        updClass: upClass
      };
    }
    /**
     * When sync succeed, update the pending luggage reports to synced
     */


    function updateAllPendingsToSynced(syncedReports) {
      var syncedReportsFromLS = getLuggageComplianceFromStorage().filter(function (x) {
        return x.isSynced;
      });
      syncedReports.forEach(function (syncedReport, index) {
        syncedReport.isSynced = true;
        syncedReport.LocalId = moment().valueOf() + index;
        syncedReportsFromLS.push(syncedReport);
      });
      setAllLuggageComplianceToStorage(syncedReportsFromLS);
    }
    /**
     * When sync fails, check for 2 day old checks and delete them
     */


    function cleanOldPendingChecks() {
      var unsyncedReports = getLuggageComplianceFromStorage().filter(function (x) {
        return !x.isSynced;
      });
      var today = new Date();
      var trimmedToday = new Date(today);
      unsyncedReports.forEach(function (unsyncedReport) {
        var createdDay = new Date(unsyncedReport.Created);
        var trimmedDay = new Date(createdDay);
        var diffDays = Date.DifferenceInDays(trimmedToday.trimTime(), trimmedDay.trimTime());

        if (diffDays >= 2) {
          removeLuggageCompliance(unsyncedReport.LocalId);
        }
      });
    }

    function updateLuggageComplianceStorage(LuggageComplianceReports, flightId) {
      var allLuggageReports = getLuggageComplianceFromStorage();
      var luggageReports = allLuggageReports.filter(function (x) {
        return x.FlightId != flightId;
      });
      LuggageComplianceReports.forEach(function (syncedReport, index) {
        syncedReport.isSynced = true;
        syncedReport.LocalId = moment().valueOf() + index;
        luggageReports.push(syncedReport);
      });
      setAllLuggageComplianceToStorage(luggageReports);
    }
    /**
        * Clean ls from old luggage reports
        * @param {array} flights Synced flights
        */


    function cleanOldData(responseFlightIds) {
      var allLuggageReports = getLuggageComplianceFromStorage(); //Filter out Philoxenia Questions of old flights

      allLuggageReports = allLuggageReports.filter(function (x) {
        return x != null && responseFlightIds.includes(x.FlightId);
      });
      setAllLuggageComplianceToStorage(allLuggageReports);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('twoLuggageEvents', twoLuggageEvents);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name twoLuggageEvents
  * @restrict E
  * @description
  *   Implementation of twoLuggageEvents
  * @example
  *   Usage:
  *   <two-luggage-events></two-luggage-events>
  * @ngInject
  */

  function twoLuggageEvents(LuggageComplianceFactory, PaxInfoFactory, $timeout) {
    function link(scope) {
      scope.submit = submit;
      scope.reset = resetConfirm;
      scope.resetSynced = resetSyncedConfirm;
      scope.allPassengersAreComplianceConfirmation = allPassengersAreComplianceConfirmation;
      getLuggageCompliancePassengers();

      function getLuggageCompliancePassengers() {
        scope.hasSyncedPassengers = false;
        scope.Passengers = [];
        scope.pendingReports = [];
        var flightId = scope.flight.FlightId;
        scope.flightCompliant = LuggageComplianceFactory.getFlightCompliantStatus(flightId); //Get cabin luggage compliance reports for this flight

        var luggageComplianceReports = LuggageComplianceFactory.getLuggageComplianceByFlightId(flightId); //Get pax info

        PaxInfoFactory.getPaxInfoFromStorage(flightId, function (paxinfo) {
          if (paxinfo) {
            luggageComplianceReports.forEach(function (luggageReport) {
              var columns = [];
              paxinfo.Seatmap.forEach(function (row) {
                row.Columns.forEach(function (column) {
                  columns.push(column);
                });
              });
              var pax = columns.find(function (p) {
                return p.UCI == luggageReport.UCI;
              });

              if (pax) {
                //Passenger already exists - Only add events
                if (scope.Passengers.map(function (p) {
                  return p.UCI;
                }).includes(luggageReport.UCI)) {
                  scope.Passengers.find(function (p) {
                    return p.UCI == luggageReport.UCI;
                  }).isSynced = luggageReport.isSynced;
                } //Add Passenger Info & Events
                else {
                    var passenger = {
                      UCI: luggageReport.UCI,
                      isSynced: luggageReport.isSynced,
                      Name: pax.Fullname,
                      SeatNo: pax.SeatNo,
                      HasTwoLuggage: true,
                      isOpen: false
                    };
                    scope.Passengers.push(passenger);
                  }

                if (scope.Passengers.some(function (x) {
                  return x.isSynced;
                })) {
                  scope.hasSyncedPassengers = true;
                }
              }
            });
          }

          scope.pendingReports = scope.Passengers.filter(function (p) {
            return !p.isSynced;
          }); //Get flightIsCompliant report

          var flightIsCompliantReport = luggageComplianceReports.find(function (p) {
            return !p.isSynced && p.IsFlightCompliant;
          });

          if (flightIsCompliantReport) {
            scope.pendingReports.push(flightIsCompliantReport);
          }
        });
      }
      /**
       * Opens confirmation modal when undo is requested on an approved proposal
       * @memberof proposal
       */


      function allPassengersAreComplianceConfirmation() {
        if (!scope.flightCompliant.HasPendingsReports) {
          applyAllPassengersAreCompliant();
        } else if (!scope.flightCompliant.IsFlightCompliant && scope.flightCompliant.HasPendingsReports) {
          bootbox.dialog({
            message: '<i class="fa fa-exclamation-triangle text-orange"></i> All pending reports of passengers with 2 items on board will be cleared.',
            title: "Confirm",
            buttons: {
              confirm: {
                label: 'Confirm',
                className: "btn-success",
                callback: function callback() {
                  applyAllPassengersAreCompliant();
                }
              },
              cancel: {
                label: "Cancel",
                className: "btn-default",
                callback: function callback() {}
              }
            }
          });
        }
      }
      /**
       * Reset all synced luggage compliance reports of this flight and refresh
       */


      function resetSyncedConfirm() {
        bootbox.dialog({
          message: '<i class="fa fa-exclamation-triangle text-orange"></i> Reset synced reports.',
          title: "Confirm",
          buttons: {
            confirm: {
              label: 'Confirm',
              className: "btn-warning",
              callback: function callback() {
                resetAll();
                getLuggageCompliancePassengers();
              }
            },
            cancel: {
              label: "Cancel",
              className: "btn-default",
              callback: function callback() {}
            }
          }
        });
      }
      /**
       * Reset all pendings luggage compliance reports of this flight and refresh
       */


      function resetConfirm() {
        bootbox.dialog({
          message: '<i class="fa fa-exclamation-triangle text-orange"></i> Reset all pending reports of passengers with 2 items on board.',
          title: "Confirm",
          buttons: {
            confirm: {
              label: 'Confirm',
              className: "btn-warning",
              callback: function callback() {
                resetAllPendings();
                getLuggageCompliancePassengers();
              }
            },
            cancel: {
              label: "Cancel",
              className: "btn-default",
              callback: function callback() {}
            }
          }
        });
      }
      /**
       * Create or remove pending AllPassengersAreCompliant report of this flight
       */


      function applyAllPassengersAreCompliant() {
        if (scope.flightCompliant.HasPendingsReports || scope.flightCompliant.Status === 'pending') {
          resetAllPendings();
        }

        if (!scope.flightCompliant.IsFlightCompliant) {
          applyFlightComplianceReport();
        }

        getLuggageCompliancePassengers();
      }

      function applyFlightComplianceReport() {
        var cabinLuggageReport = {
          PNR: '',
          UCI: '',
          FlightId: scope.flight.FlightId,
          FareFamily: '',
          IsFlightCompliant: true,
          Created: moment()
        };
        LuggageComplianceFactory.saveFlightIsCompliantToStorage(cabinLuggageReport);
      }

      function resetAllPendings() {
        LuggageComplianceFactory.removePendingsLuggageCompliance(scope.flight.FlightId);
      }
      /**
       * Deletes all luggage compliance reports of this flight from DB and from local storage
       */


      function resetAll() {
        if (scope.isOffline) {
          scope.showPanel = "offline";
        } else {
          scope.showPanel = "loading";
          LuggageComplianceFactory.deleteAllLuggageComplianceReportsByFlightId(scope.flight.FlightId).then(function (res) {
            return handleSubmitResponse(res);
          });
        }
      }
      /**
       * Submit pending luggage compliance reports of this flight
       */


      function submit() {
        var flightId = scope.flight.FlightId;

        if (scope.isOffline) {
          scope.showPanel = "offline";
        } else {
          scope.showPanel = "loading";
          LuggageComplianceFactory.submitLuggageCompliance(flightId).then(function (res) {
            return handleSubmitResponse(res);
          });
        }
      }
      /**
       * Manage API response
       * @param {object} res 
       */


      function handleSubmitResponse(res) {
        getLuggageCompliancePassengers();

        if (res.success) {
          manageResponseMessage("success", res.message);
          $timeout(function () {
            scope.showPanel = "luggageCompliance";
          }, 6000);
        } else {
          manageResponseMessage("failure", res.message);
        }
      }
      /**
       * Manage message alerts
       * @param {string} panelToShow 
       * @param {string} message 
       */


      function manageResponseMessage(panelToShow, message) {
        scope.submitMessage = message;
        scope.showPanel = panelToShow;
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/LuggageCompliance/twoLuggageEvents.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  "use strict";

  a3_cabin_reports.controller("LotteryCtrl", LotteryCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name LotteryCtrl
   * @description
   *   Shows the details of a single Lottery for a given flight.
   *   Handles lottery execution, winner/substitute selection, contact capture,
   *   draft persistence and final submission.
   * @ngInject
   */
  // Main controller for the Lottery feature. Handles all UI state, animation, business logic, persistence, and navigation.

  function LotteryCtrl($scope, $routeParams, $location, $timeout, $interval, LotteryFactory, FlightFactory, PaxInfoFactory, $uibModal, UserFactory) {
    // ─── Route params ────────────────────────────────────────────────────────────
    // Parse route parameters for flight and lottery
    var flightId = parseInt($routeParams.flightId, 10);
    var lotteryId = parseInt($routeParams.lotteryId, 10);

    if (isNaN(flightId) || isNaN(lotteryId)) {
      $location.path("/");
      return;
    } // Get lottery and flight objects from factories


    var lottery = LotteryFactory.getLotteryById(lotteryId);
    var flight = FlightFactory.getFlightFromTotalFlights(flightId);

    if (!lottery || !flight) {
      $location.path("/flightinfo/" + flightId);
      return;
    } // Unique key for draft/submission storage


    var compositeKey = lotteryId + "_" + flightId; // ─── Scope state ─────────────────────────────────────────────────────────────
    // Scope state variables for UI and logic

    $scope.lottery = lottery; // Current lottery config

    $scope.flight = flight; // Current flight info

    $scope.isRunning = false; // Animation running flag

    $scope.results = null; // Results of the lottery (per gift)

    $scope.hasPaxList = false; // True if passenger list is loaded

    $scope.draftSaved = false; // True if draft was just saved

    $scope.isSubmitted = false; // True if results have been submitted

    $scope.showPreRunStep = false; // True when the user has entered the pre-draw confirmation step

    $scope.winnerReveal = {
      show: false,
      seat: "",
      name: ""
    }; // Overlay for winner animation
    // Helper: Returns true if any giftResult has more than one winner

    $scope.hasMultipleWinners = function (results) {
      if (!results || !results.length) return false;

      for (var i = 0; i < results.length; i++) {
        if (results[i].winners && results[i].winners.length > 1) {
          return true;
        }
      }

      return false;
    };

    $scope.toggleResults = false; // Collapse/expand results panel

    $scope.hasEligiblePassengers = false; // True if there are eligible passengers for the lottery

    $scope.eligiblePassengersMessage = ""; // Message to show if no eligible passengers
    // ─── Slot-machine animation state ───────────────────────────────────────────
    // Animation state for slot-machine effect

    $scope.animSeat = ""; // Current seat displayed

    $scope.animSeatChars = []; // Digits/letters of seat

    $scope.animFlip = false; // Flip animation toggle

    $scope.animProgress = 0; // Progress bar value

    $scope.animParticles = []; // Array of seat-number animation particles

    var _fastInterval = null;
    var _animStop = false;
    var _progInterval = null; // ─── Passengers ──────────────────────────────────────────────────────────────

    var allPassengers = [];
    var eligiblePool = [];
    var lotteryDemoTargetPassengers = 180;
    var lotteryDemoEnabled = false;

    function setAnimSeat(seat) {
      $scope.animFlip = !$scope.animFlip;
      $scope.animSeat = seat || "";
      $scope.animSeatChars = (seat || "").split("");
    }

    function getPaxKey(pax) {
      if (!pax) return "";
      return (pax.PNR || "") + "_" + (pax.SeatNo || "");
    }

    function isSamePax(a, b) {
      return getPaxKey(a) === getPaxKey(b);
    }

    function isValidEmail(email) {
      if (!email) return false;
      var value = email.trim().toLowerCase();
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function isValidPhone(phone) {
      if (!phone) return false;
      var value = phone.trim();
      return /^[0-9+\-\s()]{6,20}$/.test(value);
    }

    function buildAnimationParticles(source) {
      // animParticles: Array of seat-number animation particles for the slot-machine effect.
      // Each particle is a seat label with randomized style and animation, used for the animated overlay.
      var shades = ["#9ca3af", "#6b7280", "#374151", "#9ca3af", "#4b5563"];
      var particles = [];
      var maxParticles = 30;

      for (var k = 0; k < maxParticles; k++) {
        var seat = "??";

        if (source && source.length) {
          var p = source[Math.floor(Math.random() * source.length)];
          seat = (p.SeatNo || "??").toString();
        }

        var rot = (Math.random() * 30 - 15).toFixed(1) + "deg";
        particles.push({
          seat: seat,
          // The seat number to display
          style: {
            left: (Math.random() * 96).toFixed(1) + "%",
            // Horizontal position
            color: shades[Math.floor(Math.random() * shades.length)],
            // Text color
            "animation-duration": (4 + Math.random() * 5).toFixed(1) + "s",
            "animation-delay": "-" + (Math.random() * 7).toFixed(1) + "s",
            "--lottoRot": rot // Rotation for visual effect

          }
        });
      }

      return particles;
    }

    function getRandomEligibleSeat() {
      if (eligiblePool && eligiblePool.length) {
        var p = eligiblePool[Math.floor(Math.random() * eligiblePool.length)];
        return (p.SeatNo || "??").toString();
      }

      var d = "0123456789";
      var cols = "ABCDEF";
      return d[Math.floor(Math.random() * 10)] + d[Math.floor(Math.random() * 10)] + d[Math.floor(Math.random() * 10)] + cols[Math.floor(Math.random() * 6)];
    }

    function slowCycleEligible(speed) {
      if (_animStop) return;
      setAnimSeat(getRandomEligibleSeat());
      $timeout(function () {
        slowCycleEligible(Math.min(speed + 42, 620));
      }, speed);
    }

    function padSeatNumber(row) {
      var value = String(row);

      while (value.length < 3) {
        value = "0" + value;
      }

      return value;
    }

    function createDemoPassenger(row, seatLetter, cabin, index) {
      var seatNo = padSeatNumber(row) + seatLetter;
      var code = padSeatNumber(index + 1);
      return {
        SeatNo: seatNo,
        Fullname: "Demo Passenger " + code,
        GivenName: "Demo",
        Surname: "Passenger " + code,
        PNR: "DM" + code,
        UCI: 900000 + index,
        Cabin: cabin,
        SeatMode: "Seat",
        IsEmptySeat: false
      };
    }

    function buildDemoPassengers(existingPassengers, targetCount) {
      var passengers = Array.isArray(existingPassengers) ? existingPassengers.slice() : [];
      var seenSeats = {};
      var letters = ["A", "B", "C", "D", "E", "F"];
      var row = 1;
      var index = 0;
      passengers.forEach(function (pax) {
        if (pax && pax.SeatNo) {
          seenSeats[String(pax.SeatNo)] = true;
        }
      });

      while (passengers.length < targetCount) {
        for (var i = 0; i < letters.length && passengers.length < targetCount; i++) {
          var seatNo = padSeatNumber(row) + letters[i];

          if (seenSeats[seatNo]) {
            continue;
          }

          passengers.push(createDemoPassenger(row, letters[i], row <= 4 ? "C" : "Y", index));
          seenSeats[seatNo] = true;
          index++;
        }

        row++;
      }

      return passengers;
    }

    $scope.$on("$destroy", function () {
      _animStop = true;

      if (_fastInterval) {
        $interval.cancel(_fastInterval);
        _fastInterval = null;
      }

      if (_progInterval) {
        $interval.cancel(_progInterval);
        _progInterval = null;
      }
    }); // Load passenger list and restore draft/submission state on controller init

    PaxInfoFactory.getPaxInfoList(flightId, function (passengerList) {
      allPassengers = [];
      eligiblePool = [];

      if (Array.isArray(passengerList)) {
        allPassengers = passengerList;
        $scope.hasPaxList = allPassengers.length > 0;
      } else {
        allPassengers = [];
        $scope.hasPaxList = false;
      }

      if (lotteryDemoEnabled && allPassengers.length < lotteryDemoTargetPassengers) {
        allPassengers = buildDemoPassengers(allPassengers, lotteryDemoTargetPassengers);
        $scope.hasPaxList = allPassengers.length > 0;
      }

      updateEligibilityState();
      var submitted = LotteryFactory.getSubmittedLotteriesFromStorage() || [];
      $scope.isSubmitted = submitted.some(function (x) {
        return x.Id === compositeKey;
      }) || LotteryFactory.hasPendingResult(compositeKey); // Restore draft results only when passengers are available or results were
      // already submitted. A draft without passengers is stale and misleading.

      var draft = LotteryFactory.getDraftResult(lotteryId, flightId);

      if (draft && draft.GiftResults && ($scope.hasPaxList || $scope.isSubmitted)) {
        $scope.results = draft.GiftResults;
      }

      $scope.$applyAsync();
    }); // ─── Navigation ──────────────────────────────────────────────────────────────
    // Navigate back to flight info page

    $scope.back = function () {
      $location.path("/flightinfo/" + flightId);
    }; // Navigate to the main lottery page (reset animation state)


    $scope.goToLottery = function () {
      _animStop = true;

      if (_fastInterval) {
        $interval.cancel(_fastInterval);
        _fastInterval = null;
      }

      if (_progInterval) {
        $interval.cancel(_progInterval);
        _progInterval = null;
      }

      $scope.isRunning = false;
      $scope.showPreRunStep = false;
      $location.path("/lottery/" + flightId + "/" + lotteryId);
    }; // ─── Run lottery ─────────────────────────────────────────────────────────────
    // First entry point: shows the dedicated pre-draw step with the large CTA button


    $scope.runLottery = function () {
      if ($scope.isRunning || !$scope.hasPaxList || !$scope.hasEligiblePassengers || $scope.results || $scope.isSubmitted) {
        return;
      }

      $scope.showPreRunStep = true;
    };

    $scope.cancelPreRunStep = function () {
      if ($scope.isRunning) return;
      $scope.showPreRunStep = false;
    }; // Main entry point: runs the lottery animation and computes results


    $scope.beginLotteryDraw = function () {
      if ($scope.isRunning || !$scope.hasPaxList || !$scope.hasEligiblePassengers || $scope.results || $scope.isSubmitted) {
        return;
      }

      eligiblePool = buildEligiblePool(allPassengers, lottery.PassengersType);
      $scope.animParticles = buildAnimationParticles(eligiblePool && eligiblePool.length ? eligiblePool : allPassengers);
      $scope.showPreRunStep = false;
      $scope.isRunning = true;
      $scope.results = null;
      $scope.animProgress = 0;
      _animStop = false;
      setAnimSeat(getRandomEligibleSeat());

      var _startTime = Date.now();

      var _totalMs = 5200;

      if (_progInterval) {
        $interval.cancel(_progInterval);
      }

      _progInterval = $interval(function () {
        $scope.animProgress = Math.min(100, (Date.now() - _startTime) / _totalMs * 100);
      }, 50);

      if (_fastInterval) {
        $interval.cancel(_fastInterval);
      }

      _fastInterval = $interval(function () {
        setAnimSeat(getRandomEligibleSeat());
      }, 48);
      $timeout(function () {
        if (_fastInterval) {
          $interval.cancel(_fastInterval);
          _fastInterval = null;
        }

        slowCycleEligible(70);
      }, 2600);
      $timeout(function () {
        _animStop = true;

        if (_progInterval) {
          $interval.cancel(_progInterval);
          _progInterval = null;
        }

        $scope.animProgress = 100;
        var finalResults = executeLottery(allPassengers, lottery);
        $scope.results = finalResults;
        var finalSeat = null;

        if (finalResults && finalResults.length && finalResults[0].winners && finalResults[0].winners.length) {
          finalSeat = (finalResults[0].winners[0].SeatNo || "").toString();
        }

        if (!finalSeat) {
          finalSeat = getRandomEligibleSeat();
        }

        $timeout(function () {
          setAnimSeat(finalSeat);
          $scope.animFlip = !$scope.animFlip;
        }, 180);
        $timeout(function () {
          var winnerName = "";
          var winnerSeat = finalSeat;

          if (finalResults && finalResults.length && finalResults[0].winners && finalResults[0].winners.length) {
            winnerName = finalResults[0].winners[0].Fullname || "";
            winnerSeat = finalResults[0].winners[0].SeatNo || finalSeat;
          }

          $scope.winnerReveal = {
            show: true,
            seat: winnerSeat,
            name: winnerName,
            gift: finalResults && finalResults.length ? finalResults[0].gift : null,
            winners: finalResults && finalResults.length ? finalResults[0].winners : []
          };
          autoSaveDraft();
        }, 820);
      }, 5200);
    }; // ─── Draw algorithm ──────────────────────────────────────────────────────────
    // Core draw logic: executes the lottery for all gifts, picking winners/substitutes


    function executeLottery(passengers, lotteryConfig) {
      var pool = buildEligiblePool(passengers, lotteryConfig.PassengersType);
      var shuffled = fisherYatesShuffle(pool.slice());
      var used = [];
      var giftResults = [];
      angular.forEach(lotteryConfig.Gifts || [], function (gift) {
        var winners = drawPassengers(shuffled, used, gift.NumberOfWinners);
        var substitutes = drawPassengers(shuffled, used, gift.NumberOfSubstitutes);
        var selected = winners.map(function (p) {
          return {
            pax: p,
            email: "",
            phone: ""
          };
        });
        giftResults.push({
          gift: gift,
          winners: winners,
          substitutes: substitutes,
          selected: selected
        });
      });
      return giftResults;
    } // Filters passengers by lottery config (Business/Economy/All)


    function buildEligiblePool(passengers, passengersType) {
      var t = passengersType;

      if (t === 1 || t === "Business" || t === "C") {
        return passengers.filter(function (p) {
          return p.Cabin === "C";
        });
      }

      if (t === 2 || t === "Economy" || t === "Y") {
        return passengers.filter(function (p) {
          return p.Cabin === "Y";
        });
      }

      return passengers.slice();
    } // Unbiased random shuffle (Fisher-Yates)


    function fisherYatesShuffle(arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
      }

      return arr;
    } // Picks up to 'count' unique passengers from the shuffled pool, skipping already used


    function drawPassengers(shuffled, used, count) {
      var picked = [];

      for (var i = 0; i < shuffled.length && picked.length < count; i++) {
        var uid = getPaxKey(shuffled[i]);

        if (used.indexOf(uid) === -1) {
          picked.push(shuffled[i]);
          used.push(uid);
        }
      }

      return picked;
    } // ─── Recipient selection ─────────────────────────────────────────────────────
    // Returns true if the given passenger is currently selected as a final recipient for this gift


    $scope.isSelected = function (giftResult, pax) {
      return giftResult.selected.some(function (s) {
        return isSamePax(s.pax, pax);
      });
    }; // Returns the contact object for a selected passenger (for editing email/phone)


    $scope.getContact = function (giftResult, pax) {
      for (var i = 0; i < giftResult.selected.length; i++) {
        if (isSamePax(giftResult.selected[i].pax, pax)) {
          return giftResult.selected[i];
        }
      }

      return null;
    }; // Toggles selection of a passenger as a final recipient for a gift
    // Enforces max number of winners


    $scope.toggleRecipient = function (giftResult, pax) {
      var idx = -1;

      for (var i = 0; i < giftResult.selected.length; i++) {
        if (isSamePax(giftResult.selected[i].pax, pax)) {
          idx = i;
          break;
        }
      }

      if (idx > -1) {
        giftResult.selected.splice(idx, 1);
      } else {
        if (giftResult.selected.length >= giftResult.gift.NumberOfWinners) {
          return;
        }

        giftResult.selected.push({
          pax: pax,
          email: "",
          phone: ""
        });
      }

      autoSaveDraft();
    }; // Returns true if the passenger can be selected (not exceeding max winners)


    $scope.canSelectPassenger = function (giftResult, pax) {
      return $scope.isSelected(giftResult, pax) || giftResult.selected.length < giftResult.gift.NumberOfWinners;
    };

    var _contactSavePromise = null; // Debounced auto-save for contact details (email/phone)

    $scope.autoSaveContactDetails = function () {
      if (_contactSavePromise) {
        $timeout.cancel(_contactSavePromise);
      }

      _contactSavePromise = $timeout(function () {
        autoSaveDraft();
        _contactSavePromise = null;
      }, 400);
    }; // Returns true if email is valid or empty (for UI validation feedback)


    $scope.isValidEmailForView = function (email) {
      return !email || isValidEmail(email);
    }; // Returns true if phone is valid or empty (for UI validation feedback)


    $scope.isValidPhoneForView = function (phone) {
      return !phone || isValidPhone(phone);
    }; // Returns true if the selected count has reached the configured number of winners


    $scope.isGiftSelectionComplete = function (giftResult) {
      return giftResult.selected.length >= giftResult.gift.NumberOfWinners;
    }; // ─── Submit gate ─────────────────────────────────────────────────────────────
    // Returns true if the number of selected recipients does not exceed the allowed winners


    $scope.isGiftSelectionValid = function (giftResult) {
      return giftResult.selected.length <= giftResult.gift.NumberOfWinners;
    }; // Returns true if both email and phone are valid for a contact


    $scope.isContactValid = function (contact) {
      return !!contact && isValidEmail(contact.email) && isValidPhone(contact.phone);
    }; // Returns true if all selected recipients for a gift have valid contact details


    $scope.isGiftReadyToSubmit = function (giftResult) {
      if (!$scope.isGiftSelectionValid(giftResult)) return false;
      return giftResult.selected.every(function (s) {
        return $scope.isContactValid(s);
      });
    }; // Returns true if all gifts are ready to submit (validation passes)


    $scope.isSubmitEnabled = function () {
      if (!$scope.results || !$scope.results.length) return false; // At least one selected recipient across all gifts

      var totalSelected = $scope.results.reduce(function (sum, gr) {
        return sum + gr.selected.length;
      }, 0);
      if (totalSelected === 0) return false;
      return $scope.results.every(function (gr) {
        return $scope.isGiftReadyToSubmit(gr);
      });
    }; // ─── Persistence ─────────────────────────────────────────────────────────────
    // Saves the current results as a draft in local storage


    function autoSaveDraft() {
      if (!$scope.results) return;
      LotteryFactory.saveDraftResult({
        id: compositeKey,
        lotteryId: lotteryId,
        flightId: flightId,
        giftResults: $scope.results,
        savedAt: new Date().toISOString()
      });
    } // Manual save draft action (shows feedback)


    $scope.saveDraft = function () {
      autoSaveDraft();
      $scope.draftSaved = true;
      $timeout(function () {
        $scope.draftSaved = false;
      }, 2500);
    }; // Submits the final results (marks as submitted, removes draft)


    $scope.submitResults = function () {
      if (!$scope.isSubmitEnabled()) return;
      var user = UserFactory.getUser();
      var crewMemberId = user ? user.aimsId || user.AimsId || null : null;
      var submission = {
        id: compositeKey,
        lotteryId: lotteryId,
        flightId: flightId,
        crewMemberId: crewMemberId,
        flightDisplay: flight.FlightNo + ' ' + (flight.Departure || '') + '-' + (flight.Arrival || '') + (flight.ScheduledDeparture ? ' ' + new Date(flight.ScheduledDeparture).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }) : ''),
        giftResults: $scope.results,
        submittedAt: new Date().toISOString()
      };
      LotteryFactory.submitResult(submission);
      LotteryFactory.removeDraftResult(lotteryId, flightId);
      $scope.isSubmitted = true;
      $scope.winnerReveal = {
        show: false,
        seat: "",
        name: ""
      };
    }; // Opens a modal warning before rerunning the lottery (if not submitted)


    $scope.openRerunWarning = function () {
      if ($scope.isSubmitted) return;
      var modalInstance = $uibModal.open({
        templateUrl: "views/Dialogs/dlgRerunLotteryWarning.html",
        controller: "RerunLotteryWarningModalCtrl",
        size: "md",
        backdrop: "static",
        keyboard: false
      });
      modalInstance.result.then(function (confirmed) {
        if (confirmed) {
          $scope.confirmRerunLottery();
        }
      });
    }; // Confirms rerun: clears all state, removes draft, and starts a fresh lottery run


    $scope.confirmRerunLottery = function () {
      if ($scope.isSubmitted) return;
      if ($scope.isRunning) return;
      if (!$scope.hasPaxList) return;
      if (!$scope.hasEligiblePassengers) return; // Stop any running animation just in case

      _animStop = true;

      if (_fastInterval) {
        $interval.cancel(_fastInterval);
        _fastInterval = null;
      }

      if (_progInterval) {
        $interval.cancel(_progInterval);
        _progInterval = null;
      } // Clear current in-memory state


      $scope.results = null;
      $scope.draftSaved = false;
      $scope.showPreRunStep = false;
      $scope.animSeat = "";
      $scope.animSeatChars = [];
      $scope.animProgress = 0;
      $scope.winnerReveal = {
        show: false,
        seat: "",
        name: ""
      };
      $scope.animParticles = []; // Remove local draft so only latest run survives

      LotteryFactory.removeDraftResult(lotteryId, flightId); // Start fresh run with same lottery configuration

      $scope.runLottery();
    };

    function updateEligibilityState() {
      eligiblePool = buildEligiblePool(allPassengers, lottery.PassengersType);
      $scope.hasEligiblePassengers = eligiblePool.length > 0;
      $scope.eligiblePassengersMessage = "";

      if (!$scope.hasPaxList) {
        return;
      }

      if ($scope.hasEligiblePassengers) {
        return;
      }

      var passengerType = lottery.PassengersType;

      if (passengerType === 1 || passengerType === "Business" || passengerType === "C") {
        $scope.eligiblePassengersMessage = "No eligible Business Class passengers are available for this lottery.";
        return;
      }

      if (passengerType === 2 || passengerType === "Economy" || passengerType === "Y") {
        $scope.eligiblePassengersMessage = "No eligible Economy Class passengers are available for this lottery.";
        return;
      }

      $scope.eligiblePassengersMessage = "No eligible passengers are available for this lottery.";
    }
  }
})();
"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  "use strict";

  a3_cabin_reports.factory("LotteryFactory", LotteryFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name LotteryFactory
   * @description
   *   Stores, retrieves and filters Lotteries for flights.
   * @ngInject
   */

  function LotteryFactory(GenericService) {
    /**
     * Initialize the Lottery model
     * @memberof LotteryFactory
     */
    function Lottery() {
      this.Id = null;
      this.Name = null;
      this.LotteryMode = null; // 1='AllFlights' | 2='SpecificFlightNumbers' | 3='SpecificRoutes'

      this.Active = null;
      this.DateFrom = null;
      this.DateTo = null;
      this.FlightNumbers = null; // array of strings, e.g. ["A3747"] — used when LotteryMode = 2

      this.FlightRoutes = null; // array of { Departure, Arrival } objects — used when LotteryMode = 3

      this.Announcement = null;
      this.Gifts = null; // array of { Id, Description, NumberOfWinners, NumberOfSubstitutes }

      this.PassengersType = null;

      this.GetId = function () {
        return this.Id;
      };
    }
    /**
     * Initialize the SubmittedLottery model
     * @memberof LotteryFactory
     */


    function SubmittedLottery() {
      this.Id = null; // composite: LotteryId + '_' + FlightId

      this.LotteryId = null;
      this.FlightId = null;

      this.GetId = function () {
        return this.Id;
      };
    }

    var lotteryObjType = "LotteryItems";
    var submittedObjType = "SubmittedLotteries";
    var draftObjType = "LotteryDraftResults";
    var pendingObjType = "LotteryPendingResults";
    /**
     * Initialize the LotteryDraftResult model
     */

    function LotteryDraftResult() {
      this.Id = null; // composite: lotteryId + '_' + flightId

      this.LotteryId = null;
      this.FlightId = null;
      this.GiftResults = null;
      this.SavedAt = null;

      this.GetId = function () {
        return this.Id;
      };
    }
    /**
     * Initialize the LotteryPendingResult model (queued for backend sync)
     */


    function LotteryPendingResult() {
      this.Id = null; // composite: lotteryId + '_' + flightId

      this.LotteryId = null;
      this.FlightId = null;
      this.GiftResults = null;
      this.SubmittedAt = null;
      this.CrewMemberAimsId = null;
      this.FlightDisplay = null;

      this.GetId = function () {
        return this.Id;
      };
    }

    var service = {
      getLotteriesFromStorage: getLotteriesFromStorage,
      setLotteriesFromServer: setLotteriesFromServer,
      getLotteryById: getLotteryById,
      getApplicableLotteries: getApplicableLotteries,
      getSubmittedLotteriesFromStorage: getSubmittedLotteriesFromStorage,
      setSubmittedLotteriesFromServer: setSubmittedLotteriesFromServer,
      // Draft & submission
      saveDraftResult: saveDraftResult,
      getDraftResult: getDraftResult,
      removeDraftResult: removeDraftResult,
      submitResult: submitResult,
      getPendingResults: getPendingResults,
      removePendingResult: removePendingResult,
      hasPendingResult: hasPendingResult
    };
    return service; // ─── Storage ────────────────────────────────────────────────────────────────

    /**
     * Get all lotteries from local storage
     * @memberof LotteryFactory
     * @returns {Array} lotteries
     */

    function getLotteriesFromStorage() {
      return GenericService.list(lotteryObjType, Lottery);
    }
    /**
     * Persist lotteries received from the server
     * @memberof LotteryFactory
     * @param {Array} lotteries
     */


    function setLotteriesFromServer(lotteries) {
      if (!lotteries) return;
      GenericService.saveAll(lotteries, lotteryObjType, Lottery);
    }
    /**
     * Get a single lottery by Id
     * @memberof LotteryFactory
     * @param {number|string} id
     * @returns {object|null} lottery
     */


    function getLotteryById(id) {
      return GenericService.get(id, lotteryObjType, Lottery);
    } // ─── Applicability filtering ─────────────────────────────────────────────────

    /**
     * Check whether the flight date falls within the lottery's active period
     * @memberof LotteryFactory
     * @param {object} lottery
     * @param {Date} flightDate
     * @returns {boolean}
     */


    function isWithinActivePeriod(lottery, flightDate) {
      if (!lottery.Active) return false;
      if (!flightDate) return false;
      var date = new Date(flightDate);
      if (isNaN(date.getTime())) return false;
      date.setHours(0, 0, 0, 0);
      var from = lottery.DateFrom ? new Date(lottery.DateFrom) : null;
      var to = lottery.DateTo ? new Date(lottery.DateTo) : null;
      if (from) from.setHours(0, 0, 0, 0);
      if (to) to.setHours(0, 0, 0, 0);
      var afterFrom = !from || date >= from;
      var beforeTo = !to || date <= to;
      return afterFrom && beforeTo;
    }
    /**
     * Return all lotteries that are applicable to the given flight
     * @memberof LotteryFactory
     * @param {object} flight
     * @returns {Array} applicableLotteries
     */


    function getApplicableLotteries(flight) {
      if (!flight) return [];
      var lotteries = getLotteriesFromStorage();
      var flightDate = flight.ScheduledDeparture || flight.ScheduledDepartureDateUTC || null; // Normalize flight values once — trim + uppercase

      var flightNo = (flight.FlightNo || "").trim().toUpperCase();
      var flightRoute = ((flight.Departure || "").trim() + "-" + (flight.Arrival || "").trim()).toUpperCase();
      return lotteries.filter(function (lottery) {
        if (!isWithinActivePeriod(lottery, flightDate)) return false; // LotteryMode arrives as a numeric enum (1/2/3) but guard strings too

        var mode = lottery.LotteryMode;

        switch (mode) {
          case 1:
          case "AllFlights":
            return true;

          case 2:
          case "SpecificFlightNumbers":
            return lottery.FlightNumbers && lottery.FlightNumbers.some(function (fn) {
              return fn.trim().toUpperCase() === flightNo;
            });

          case 3:
          case "SpecificRoutes":
            return lottery.FlightRoutes && lottery.FlightRoutes.some(function (r) {
              // server may send a string "ATH-SKG" or an object { Departure, Arrival }
              var normalized = _typeof(r) === "object" && r !== null ? ((r.Departure || "").trim() + "-" + (r.Arrival || "").trim()).toUpperCase() : r.trim().toUpperCase();
              return normalized === flightRoute;
            });

          default:
            return false;
        }
      });
    } // ─── Submitted lotteries ─────────────────────────────────────────────────────

    /**
     * Get all submitted lottery records from local storage
     * @memberof LotteryFactory
     * @returns {Array} submittedLotteries
     */


    function getSubmittedLotteriesFromStorage() {
      return GenericService.list(submittedObjType, SubmittedLottery);
    }
    /**
     * Persist submitted lottery records received from the server
     * @memberof LotteryFactory
     * @param {Array} list  Array of { LotteryId, FlightId }
     */


    function setSubmittedLotteriesFromServer(list) {
      if (!list) return;
      var items = list.map(function (item) {
        var s = new SubmittedLottery();
        s.Id = item.LotteryId + "_" + item.FlightId;
        s.LotteryId = item.LotteryId;
        s.FlightId = item.FlightId;
        return s;
      });
      GenericService.saveAll(items, submittedObjType, SubmittedLottery);
    } // ─── Draft results ────────────────────────────────────────────────────────────

    /**
     * Save a lottery draft result to local storage (overwrites existing for same key).
     * @memberof LotteryFactory
     * @param {{id, lotteryId, flightId, giftResults, savedAt}} draft
     */


    function saveDraftResult(draft) {
      if (!draft || !draft.id) return;
      var all = GenericService.list(draftObjType, LotteryDraftResult) || [];
      var idx = -1;

      for (var i = 0; i < all.length; i++) {
        if (all[i].Id === draft.id) {
          idx = i;
          break;
        }
      }

      var item = new LotteryDraftResult();
      item.Id = draft.id;
      item.LotteryId = draft.lotteryId;
      item.FlightId = draft.flightId;
      item.GiftResults = draft.giftResults;
      item.SavedAt = draft.savedAt || new Date().toISOString();

      if (idx > -1) {
        all[idx] = item;
      } else {
        all.push(item);
      }

      GenericService.saveAll(all, draftObjType, LotteryDraftResult);
    }
    /**
     * Retrieve a lottery draft result from local storage.
     * @memberof LotteryFactory
     * @param {number} lotteryId
     * @param {number} flightId
     * @returns {object|null}
     */


    function getDraftResult(lotteryId, flightId) {
      var compositeId = lotteryId + "_" + flightId;
      return GenericService.get(compositeId, draftObjType, LotteryDraftResult);
    }
    /**
     * Remove a lottery draft result from local storage.
     * @memberof LotteryFactory
     * @param {number} lotteryId
     * @param {number} flightId
     */


    function removeDraftResult(lotteryId, flightId) {
      var compositeId = lotteryId + "_" + flightId;
      var all = GenericService.list(draftObjType, LotteryDraftResult) || [];
      var filtered = all.filter(function (d) {
        return d.Id !== compositeId;
      });
      GenericService.saveAll(filtered, draftObjType, LotteryDraftResult);
    } // ─── Pending results (queued for backend sync) ────────────────────────────────

    /**
     * Submit a completed lottery result: marks as submitted locally and queues for sync.
     * @memberof LotteryFactory
     * @param {{id, lotteryId, flightId, giftResults, submittedAt}} result
     */


    function submitResult(result) {
      if (!result || !result.id) return; // 1. Persist in pending queue (picked up by SyncAPIService on next sync)

      var pending = GenericService.list(pendingObjType, LotteryPendingResult) || [];
      var pendingIdx = -1;

      for (var i = 0; i < pending.length; i++) {
        if (pending[i].Id === result.id) {
          pendingIdx = i;
          break;
        }
      }

      var item = new LotteryPendingResult();
      item.Id = result.id;
      item.LotteryId = result.lotteryId;
      item.FlightId = result.flightId;
      item.GiftResults = result.giftResults;
      item.SubmittedAt = result.submittedAt || new Date().toISOString();
      item.CrewMemberAimsId = result.crewMemberId || null;
      item.FlightDisplay = result.flightDisplay || null;

      if (pendingIdx > -1) {
        pending[pendingIdx] = item;
      } else {
        pending.push(item);
      }

      GenericService.saveAll(pending, pendingObjType, LotteryPendingResult); // 2. Track as a submitted lottery so the details page knows

      var submitted = GenericService.list(submittedObjType, SubmittedLottery) || [];
      var subIdx = -1;

      for (var j = 0; j < submitted.length; j++) {
        if (submitted[j].Id === result.id) {
          subIdx = j;
          break;
        }
      }

      if (subIdx === -1) {
        var sub = new SubmittedLottery();
        sub.Id = result.id;
        sub.LotteryId = result.lotteryId;
        sub.FlightId = result.flightId;
        submitted.push(sub);
        GenericService.saveAll(submitted, submittedObjType, SubmittedLottery);
      }
    }
    /**
     * Get all pending lottery results waiting for sync.
     * @memberof LotteryFactory
     * @returns {Array}
     */


    function getPendingResults() {
      var pending = GenericService.list(pendingObjType, LotteryPendingResult) || [];
      return pending.map(function (item) {
        var results = [];
        angular.forEach(item.GiftResults || [], function (giftResult) {
          angular.forEach(giftResult.selected || [], function (selectedRecipient) {
            if (!selectedRecipient || !selectedRecipient.pax) {
              return;
            }

            results.push({
              GiftId: giftResult.gift ? giftResult.gift.Id : null,
              PassengerFullName: selectedRecipient.pax.Fullname || null,
              PassengerPNR: selectedRecipient.pax.PNR || null,
              PassengerUCI: selectedRecipient.pax.UCI || null,
              PassengerEmailAddress: selectedRecipient.email || null,
              PassengerTelephoneNumber: selectedRecipient.phone || null
            });
          });
        });
        return {
          FlightId: item.FlightId,
          LotteryId: item.LotteryId,
          CrewMemberAimsId: item.CrewMemberAimsId || null,
          SubmissionTimestamp: item.SubmittedAt,
          FlightDisplay: item.FlightDisplay || null,
          Results: results
        };
      });
    }
    /**
     * Remove a pending lottery result (called after successful backend upload).
     * @memberof LotteryFactory
     * @param {string} compositeId  lotteryId + '_' + flightId
     */


    function removePendingResult(compositeId) {
      var pending = GenericService.list(pendingObjType, LotteryPendingResult) || [];
      var filtered = pending.filter(function (p) {
        return p.Id !== compositeId;
      });
      GenericService.saveAll(filtered, pendingObjType, LotteryPendingResult);
    }
    /**
     * Check if a pending result exists for the given lottery/flight composite key.
     * @memberof LotteryFactory
     * @param {string} compositeId  lotteryId + '_' + flightId
     * @returns {boolean}
     */


    function hasPendingResult(compositeId) {
      var pending = GenericService.list(pendingObjType, LotteryPendingResult) || [];
      return pending.some(function (p) {
        return p.Id === compositeId;
      });
    }
  }
})();
"use strict";

(function () {
  "use strict";

  a3_cabin_reports.controller("RerunLotteryWarningModalCtrl", RerunLotteryWarningModalCtrl);

  function RerunLotteryWarningModalCtrl($scope, $uibModalInstance) {
    $scope.ok = function () {
      $uibModalInstance.close(true);
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss("cancel");
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.service("CabinAPIService", CabinAPIService);
  /**
  * @memberof CabinReports
  * @ngdoc service
  * @name CabinAPIService
  * @description 
  *   Api login service
  * @ngInject
  */

  function CabinAPIService($http, $q, apiUrl) {
    return {
      /**
      * Login to Pilot Api
      * @memberof PilotAPIService
      * @param {number} username
      * @returns {string} password
      */
      login: function login(token) {
        var call = $q.defer();
        var bearer = "Bearer " + token;
        $http.post(apiUrl + '/login', {}, {
          'headers': {
            'Content-Type': 'application/json',
            'Authorization': bearer
          }
        }).then(function (responseData) {
          call.resolve(responseData);
        }, function (err) {
          call.reject(err);
        });
        return call.promise;
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('LoginCtrl', LoginCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name LoginCtrl
  * @description 
  *  Manages the login view
  * @ngInject
  */

  function LoginCtrl($location, $scope, localStorageMD5Service, UserFactory) {
    $scope.isSupported = isSupported;
    $scope.isSecure = UserFactory.isSecure();
    $scope.isLoggingIn = false;
    $scope.formData = {};
    $scope.goSecure = goSecure;
    $scope.errorName = "";
    $scope.goNormal = goNormal;
    $scope.moreInfo = false; // used to show more info on the page

    $scope.toggleMoreInfo = toggleMoreInfo;
    $scope.processForm = processForm;
    $scope.resetDevice = resetDevice;
    $scope.resetUser = resetUser;
    $scope.loginFailedAttemps = UserFactory.getLoginFailedAttemps();
    /**
     * Informs you if local storage is supported 
     * @memberof LoginCtrl
     * @returns {boolean} isSupported
     */

    function isSupported() {
      return localStorageMD5Service.isSupported;
    }
    /**
     * Converts application to normal local storage mode 
     * @memberof LoginCtrl
     */


    function goNormal() {
      var path = window.location.href;
      path = path.replace('?secure', '');
      window.location = path;
      location.reload();
    }
    /**
         * Proccess login form and try to login
         * @memberof LoginCtrl
         */


    function goSecure() {
      var path = window.location.href;
      path = path + '?secure';
      window.location = path;
      location.reload();
    }
    /**
           * Show More info
           * @memberof LoginCtrl
           */


    function toggleMoreInfo() {
      $scope.moreInfo = !$scope.moreInfo;
    }
    /**
     * Proccess login form and try to login
     * @memberof LoginCtrl
     */


    function processForm() {
      $scope.loginFailedAttemps = UserFactory.getLoginFailedAttemps();

      if ($scope.loginFailedAttemps > 3) {
        localStorageMD5Service.remove('failedLoginAttemps');
        resetUser();
      } else {
        $scope.isLoggingIn = true;
        UserFactory.azlogin(afterLoginSuccess, afterLoginError, afterLoginFinal)["catch"](function (error) {
          //console.error("An error occurred during login:", error);
          afterLoginError();
        });
      }
    }
    /**
     * AfterLoginSuccess
     * @memberof LoginCtrl
     */


    function afterLoginSuccess() {
      $scope.isLoggingIn = false; // load main page

      $scope.errorName = "";
      $location.path("/");
    }
    /**
     * afterLoginFinal
     * @memberof LoginCtrl
     */


    function afterLoginFinal() {
      $scope.isLoggingIn = false;
    }
    /**
           * AfterLoginError
           * @memberof LoginCtrl
           */


    function afterLoginError(response) {
      $scope.isLoggingIn = false; // display an error message

      if (response && response.status == 401) {
        if (response.data && response.data.Message) $scope.errorName = response.data.Message.length > 1 ? response.data.Message : "You are not authorized to use this CLS Cabin app";else $scope.errorName = "You are not authorized to use this CLS Cabin app";
      } else if (response && response.status == 404) {
        $scope.errorName = "Could not reach the remote server for authentication. Please connect to the Internet and try again.";
      } else {
        $scope.errorName = "An error occured during authentication. Please make sure you are connected to the Internet and try again.";
      }

      ;
    }
    /**
           * Redirect to reset view
           * @memberof LoginCtrl
           */


    function resetDevice() {
      $location.path("/reset");
    }
    /**
           * Sign out
           * @memberof LoginCtrl
           */


    function resetUser() {
      UserFactory.azSignOut();
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('UserFactory', UserFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name UserFactory
  * @description 
  *   Add, Update, Delete and Get User.
  * @ngInject
  */
  //function UserFactory(localStorageMD5Service, CabinAPIService, DataCleanerFactory, GenericService, LogService, $http, apiUrl) {

  function UserFactory(LogService, localStorageMD5Service, $http, apiUrl, CabinAPIService, DataCleanerFactory, GenericService, azureADAuth) {
    var msalConfig = {
      auth: azureADAuth,
      cache: {
        cacheLocation: "sessionStorage",
        // This configures where your cache will be stored
        storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge

      }
    };
    var myMSALObj = new msal.PublicClientApplication(msalConfig);
    var username = null;
    myMSALObj.handleRedirectPromise().then(handleResponse)["catch"](function (error) {
      console.error(error);
      LogService.error(error, 'Failed to handle redirect Login');
    });

    function handleResponse(response) {
      if (response !== null) {
        username = response.account.username;
      } else {
        selectAccount();
      }
    }

    function selectAccount() {
      /**
       * See here for more info on account retrieval: 
       * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/Accounts.md
       */
      var currentAccounts = myMSALObj.getAllAccounts();

      if (currentAccounts.length === 0) {
        return;
      } else if (currentAccounts.length > 0) {
        username = currentAccounts[0].username;
      }
    }
    /**
          * Initialize the User
          * @memberof UserFactory
          */


    function User() {
      this.id = null;
      this.aimsId = null;
      this.name = null;
      this.shortname = null;
      this.position = null;
      this.hashedPwd = null;
      this.token = null;
      this.syncDialogLastDt = null;
      this.getDescription = getDescription;
      this.tokenExtended = false;
      this.hireDate = null;
    }

    var service = {
      getUser: getUser,
      setUser: setUser,
      isSecure: isSecure,
      isLoggedIn: isLoggedIn,
      clearActiveUser: clearActiveUser,
      setActiveUser: setActiveUser,
      login: login,
      extendToken: extendToken,
      azlogin: azlogin,
      azSignOut: azSignOut,
      getLoginFailedAttemps: getLoginFailedAttemps,
      newLoginFailedAttemp: newLoginFailedAttemp
    };
    var objType = 'user';
    var objCallback = User; //Object Functions

    function getDescription() {
      if (this.aimsid == null && this.name == null) return '-null-';else return (this.aimsid || '?') + ' - ' + (this.name || '?');
    } //Factory Functions

    /**
     * Get User 
     * @memberof UserFactory
     * @returns {Object} User
     */


    function getUser() {
      return GenericService.getOne(objType, objCallback);
    }
    /**
    * Save User 
    * @memberof UserFactory
    * @param {Object} User
    */


    function setUser(user) {
      GenericService.saveAll(user, objType, objCallback);
    }
    /**
     * Checks if local storage is on secure mode 
     * @memberof UserFactory
     * @param {boolean} isSecure
     */


    function isSecure() {
      return localStorageMD5Service.isSecure();
    }
    /**
    * Check if user exists and he has logged in
    * @memberof UserFactory
    * @param {boolean} isLoggedIn
    */


    function isLoggedIn() {
      var user = null;

      try {
        user = getUser();

        if (user != null) {
          var act = localStorageMD5Service.get('active');

          if (!act || !act.aimsId || act.aimsId != user.aimsId) {
            user = null;
          }
        } else user = null;
      } catch (e) {
        user = null;
      }

      return user;
    }
    /**
     * Clear Active User
     * @memberof UserFactory
     */


    function clearActiveUser() {
      localStorageMD5Service.remove('active');
    }
    /**
     * Save Active User 
     * @memberof UserFactory
     * @param {Object} User
     */


    function setActiveUser(user) {
      if (user != null && user.aimsId != null) {
        var value = {
          aimsId: user.aimsId
        };
        localStorageMD5Service.set('active', value);
      }
    }

    function azlogin(onsuccess, onerror, onfinally) {
      return new Promise(function (resolve, reject) {
        var loginRequest = {
          scopes: ["User.Read"]
        };
        var silentRequest = {
          scopes: ["openid", "profile", "User.Read"],
          redirectUri: "http://localhost:3000/blank.html"
        };

        if (username == null) {
          myMSALObj.loginRedirect(loginRequest);
          resolve(); // Resolve immediately for redirect scenario
        } else {
          silentRequest.account = myMSALObj.getAccountByUsername(username);
          var token = null;
          myMSALObj.acquireTokenSilent(silentRequest).then(function (tokenResponse) {
            if (!tokenResponse.idToken) {
              LogService.error('response.idToken is undefined');
              newLoginFailedAttemp(); // Run newLoginFailedAttemp() if idToken is undefined

              reject(new Error('Token is not available')); // Reject the promise
            } else {
              token = tokenResponse.idToken;
              localStorageMD5Service.remove('failedLoginAttemps');
              login(token, onsuccess, onerror, onfinally);
              resolve(); // Resolve after successful login
            }
          })["catch"](function (error) {
            if (error instanceof msal.InteractionRequiredAuthError) {
              LogService.error(error, 'Fallback to interaction when silent call fails'); // Handle the redirection process error here if needed

              myMSALObj.acquireTokenRedirect(silentRequest).then(function () {
                // Continue with the process after successful redirection
                resolve();
              })["catch"](function (redirectError) {
                LogService.error(redirectError, 'Error during redirection');
                newLoginFailedAttemp(); // Run newLoginFailedAttemp() for redirection errors

                reject(redirectError); // Reject the promise with the redirection error
              });
            } else {
              LogService.error(error, 'Failed to acquire token silently');
              newLoginFailedAttemp(); // Run newLoginFailedAttemp() for other errors

              reject(error); // Reject the promise with the error
            }
          });
        }
      });
    }

    function azSignOut() {
      /**
       * You can pass a custom request object below. This will override the initial configuration. For more information, visit:
       * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#request
       */
      var logoutRequest = {
        account: myMSALObj.getAccountByUsername(username),
        postLogoutRedirectUri: window.location.href
      };
      myMSALObj.logoutRedirect(logoutRequest);
    }
    /**
     * Add code to try to login locally if remote login fails with a 404 or timeout
     * @memberof UserFactory
     * @param {string} token
     * @param {function} onsuccess callback function if the call is a success
     * @param {function} onerror callback function if the call failed
     * @param {function} onfinally callback function that runs on the end
     */


    function login(token, onsuccess, onerror, onfinally) {
      clearActiveUser();
      var q = CabinAPIService.login(token);
      q.then(function (response) {
        // if the user that tries to log in is different than the last
        // logged in user, then reset all stored server data
        if (getUser() != null) {
          if (getUser().aimsId.toString() != response.data.data.aimsId.toString()) {
            DataCleanerFactory.deleteAllData();
          }
        } // delete any flights created locally, that do not have any local
        // reports


        DataCleanerFactory.deleteOrphanedLocalFlights(); // assign the logged in user

        var user = response.data.data;
        setUser(user);
        setActiveUser(user);

        if (typeof onsuccess == "function") {
          onsuccess();
        }
      });
      q["catch"](function (response) {
        if (typeof onerror == "function") {
          onerror(response);
        }
      });
      q["finally"](function (response) {
        if (typeof onfinally == "function") {
          onfinally();
        }
      });
      return q;
    }
    /**
    * the function that extends the token for limited time if a user forgot their password
    * @memberof UserFactory
    * @param {function} onsuccess callback function if the call is a success
    * @param {function} onerror callback function if the call failed
    */


    function extendToken(onsuccess, onerror) {
      var user = getUser();
      $http.post(apiUrl + '/login/extendtoken', {
        'Token': user.token
      }, {
        'Content-Type': 'application/json'
      }).then(function (response) {
        user.token = response.data.data;
        user.tokenExtended = true;
        setUser(user);
        setActiveUser(user);

        if (typeof onsuccess == "function") {
          onsuccess();
        }
      })["catch"](function (response) {
        if (typeof onerror == "function") {
          onerror(response);
        }
      });
    }

    function getLoginFailedAttemps() {
      var failedLoginAttemps = localStorageMD5Service.get('failedLoginAttemps');

      if (failedLoginAttemps) {
        return failedLoginAttemps;
      } else {
        return 0;
      }
    }

    function newLoginFailedAttemp() {
      var value = 1;
      var failedLoginAttemps = localStorageMD5Service.get('failedLoginAttemps');

      if (failedLoginAttemps && failedLoginAttemps !== "null") {
        var attempsToNumber = Number(failedLoginAttemps);
        value = value + attempsToNumber;
      }

      localStorageMD5Service.set('failedLoginAttemps', value);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('jumpseatRequestFormPanel', jumpseatRequestFormPanel);
  /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name jumpseatRequestFormPanel
   * @description
   *   Renders the Jumpseat Request form panel and uses parent scope form model.
   */

  function jumpseatRequestFormPanel() {
    /**
     * Initialize panel expand/collapse state.
     * @param {object} scope directive scope
     */
    function link(scope) {
      scope.requestFormPanelState = {
        isOpen: true
      };
      scope.toggleRequestFormPanel = toggleRequestFormPanel;
      /**
       * Toggle request form panel visibility.
       */

      function toggleRequestFormPanel() {
        scope.requestFormPanelState.isOpen = !scope.requestFormPanelState.isOpen;
      }
    }

    return {
      restrict: 'E',
      templateUrl: 'views/JumpseatRequests/requestFormPanel.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('jumpseatRequestRow', jumpseatRequestRow);
  /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name jumpseatRequestRow
   * @description
   *   Renders one jumpseat request row content for submitted/acknowledge panels.
   */

  function jumpseatRequestRow() {
    /**
     * Initialize directive state and helper methods.
     * @param {object} scope directive scope
     * @param {object} element directive element
     * @param {object} attrs directive attributes
     */
    function link(scope, element, attrs) {
      scope.isAcknowledge = false; //only for CP 

      scope.passengerRows = [];
      scope.getStatusLabel = getStatusLabel;
      scope.getStatusTextClass = getStatusTextClass;
      scope.getStatusBorderClass = getStatusBorderClass;
      scope.isGeneralDeclarationRequest = isGeneralDeclarationRequest;
      scope.handleCancel = handleCancel;
      scope.travelersCounter = 0;
      scope.$watchGroup(['request', 'crewInfo', 'ancillaries', 'isAcknowledge'], rebuildPassengerRows);
      /**
       * Rebuild passenger rows when request data changes.
       */

      function rebuildPassengerRows() {
        scope.passengerRows = buildPassengerRows(scope.request, scope.crewInfo);
      }
      /**
       * Resolve status label from ancillaries or fallback map.
       * @param {number} statusValue request status value
       * @returns {string} display label
       */


      function getStatusLabel(statusValue) {
        var statuses = scope.ancillaries && scope.ancillaries.Statuses ? scope.ancillaries.Statuses : null;
        var index;

        if (statuses && statuses.length) {
          for (index = 0; index < statuses.length; index += 1) {
            if (statuses[index].id === statusValue || statuses[index].value === statusValue) {
              return statuses[index].text || statuses[index].label;
            }
          }
        }

        if (statusValue === 1) {
          return 'Pending';
        }

        if (statusValue === 2) {
          return 'Accepted';
        }

        if (statusValue === 3) {
          return 'Rejected';
        }

        return 'Unknown';
      }
      /**
       * Map status to a text color css class.
       * @param {number} statusValue request status value
       * @returns {string} css class name
       */


      function getStatusTextClass(statusValue) {
        if (statusValue === 2) {
          return 'text-green';
        }

        if (statusValue === 3) {
          return 'text-red';
        }

        return 'text-blue';
      }
      /**
       * Map status to a left-border css class.
       * @param {number} statusValue request status value
       * @returns {string} css class name
       */


      function getStatusBorderClass(statusValue) {
        if (statusValue === 2) {
          return 'border-left-green';
        }

        if (statusValue === 3) {
          return 'border-left-red';
        }

        return 'border-left-blue';
      }
      /**
       * Check whether request type is General Declaration.
       * @param {number} requestType request type value
       * @returns {boolean} true for General Declaration
       */


      function isGeneralDeclarationRequest(requestType) {
        return requestType === 2;
      }
      /**
       * Invoke cancel callback when provided.
       */


      function handleCancel() {
        if (attrs.onCancel) {
          scope.onCancel({
            requestId: scope.request.RequestId
          });
        }
      }
      /**
       * Invoke accept callback when provided.
       */


      function handleAccept() {
        if (attrs.onAccept) {
          scope.onAccept({
            requestId: scope.request.RequestId
          });
        }
      }
      /**
       * Invoke reject callback when provided.
       */


      function handleReject() {
        if (attrs.onReject) {
          scope.onReject({
            requestId: scope.request.RequestId
          });
        }
      }
      /**
       * Build passenger rows based on TravelersType rules.
       * @param {object} request request object
       * @param {object} crewInfo crew info object
       * @returns {array} normalized passenger rows
       */


      function buildPassengerRows(request, crewInfo) {
        var passengers = request && request.Passengers ? request.Passengers : [];
        var rows = [];
        var crewName = crewInfo && crewInfo.Name ? crewInfo.Name : '';
        var index;

        if (request.TravelersType === 1) {
          scope.travelersCounter = 1;
          rows.push({
            Name: crewName,
            Relationship: '',
            IsSelf: true
          });
          return rows;
        }

        if (request.TravelersType === 2) {
          for (index = 0; index < passengers.length; index += 1) {
            rows.push(normalizePassenger(passengers[index]));
          }

          scope.travelersCounter = passengers.length;
          return rows;
        }

        if (request.TravelersType === 3) {
          rows.push({
            Name: crewName,
            Relationship: '',
            IsSelf: true
          });

          for (index = 0; index < passengers.length; index += 1) {
            if (passengers[index].Relationship === 'Self' || passengers[index].Name === crewName) {
              continue;
            }

            rows.push(normalizePassenger(passengers[index]));
          }

          scope.travelersCounter = rows.length;
        }

        return rows;
      }
      /**
       * Convert passenger relationship id to display text from ancillaries.
       * @param {object} passenger passenger object from API
       * @returns {object} normalized passenger object for UI
       */


      function normalizePassenger(passenger) {
        return {
          Name: passenger && passenger.Name ? passenger.Name : '',
          Relationship: getRelationshipText(passenger ? passenger.Relationship : null),
          IsSelf: passenger && passenger.IsSelf === true
        };
      }
      /**
       * Resolve relationship label from ancillaries by id.
       * @param {number|string} relationship relationship id or text
       * @returns {string} relationship display text
       */


      function getRelationshipText(relationship) {
        var relationships = scope.ancillaries && scope.ancillaries.PassengerRelationships ? scope.ancillaries.PassengerRelationships : [];
        var index;

        if (relationship === null || relationship === undefined) {
          return '';
        }

        if (typeof relationship === 'string') {
          return relationship;
        }

        for (index = 0; index < relationships.length; index += 1) {
          if (relationships[index].id === relationship || relationships[index].value === relationship) {
            return relationships[index].text || relationships[index].label || '';
          }
        }

        return '';
      }
    }

    return {
      restrict: 'E',
      templateUrl: 'views/JumpseatRequests/requestRow.tpl.html',
      scope: {
        request: '=',
        crewInfo: '=',
        ancillaries: '=',
        isAcknowledge: '=?',
        onCancel: '&',
        onAccept: '&',
        onReject: '&'
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('JumpseatRequestsCtrl', JumpseatRequestsCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name JumpseatRequestsCtrl
   * @description
   *   Controller for Jumpseat Requests
   * @ngInject
   */

  function JumpseatRequestsCtrl($scope, JumpseatRequestsFactory, UserFactory) {
    // Set state for footer navigation
    $scope.state = 'jumpseatRequests';
    $scope.jumpseatInfo = null;
    $scope.currentUser = UserFactory.getUser();
    $scope.jumpseatRequestForm = {};
    $scope.isSubmittingJumpseatRequest = false;
    $scope.jumpseatRequestFormState = {
      isFlightDatePickerOpen: false
    };
    $scope.jumpseatFlightDateOptions = {};
    $scope.refreshJumpseatInfo = refreshJumpseatInfo;
    $scope.confirmCancelSubmittedRequest = confirmCancelSubmittedRequest;
    $scope.confirmAcceptAcknowledgeRequest = confirmAcceptAcknowledgeRequest;
    $scope.confirmRejectAcknowledgeRequest = confirmRejectAcknowledgeRequest;
    $scope.openJumpseatFlightDatePicker = openJumpseatFlightDatePicker;
    $scope.onJumpseatRequestTypeChanged = onJumpseatRequestTypeChanged;
    $scope.onJumpseatTravelersTypeChanged = onJumpseatTravelersTypeChanged;
    $scope.shouldShowTravelersSection = shouldShowTravelersSection;
    $scope.shouldShowEntitledPassengersSection = shouldShowEntitledPassengersSection;
    $scope.addEntitledPassenger = addEntitledPassenger;
    $scope.removeEntitledPassenger = removeEntitledPassenger;
    $scope.submitJumpseatRequest = submitJumpseatRequest;
    $scope.getJumpseatStatusLabel = getJumpseatStatusLabel;
    $scope.getJumpseatStatusBadgeClass = getJumpseatStatusBadgeClass;
    $scope.isGeneralDeclarationRequest = isGeneralDeclarationRequest;
    $scope.getSubmittedPassengerRows = getSubmittedPassengerRows;
    $scope.hasSubmittedPassengerRows = hasSubmittedPassengerRows; // Initialize on controller load

    init();
    /**
     * Initialize controller data loading.
     */

    function init() {
      refreshJumpseatInfo();
    }
    /**
     * Refresh jumpseat information from service.
     * Blocks execution when device is offline.
     */


    function refreshJumpseatInfo() {
      if (!window.navigator.onLine) {
        bootbox.alert({
          title: "<div class='text-orange'>No Internet</div>",
          message: 'Please check the internet connection!'
        });
        return;
      }

      JumpseatRequestsFactory.getJumpseatInfo(function (responseData) {
        if (!responseData.success) {
          bootbox.alert({
            title: "<div class='text-red'>Error</div>",
            message: responseData.errorMessage || 'Unable to load Jumpseat Requests information.'
          });
          return;
        }

        $scope.jumpseatInfo = responseData.data;
        initializeJumpseatRequestForm();
        prepareSubmittedRequestsViewModel();
      }, function () {
        bootbox.alert({
          title: "<div class='text-red'>Error</div>",
          message: 'Unable to load Jumpseat Requests information.'
        });
      });
    }
    /**
     * Ask user confirmation before canceling a submitted request.
     * @param {number} requestId request identifier to cancel
     */


    function confirmCancelSubmittedRequest(requestId) {
      bootbox.dialog({
        message: '<strong>You are about to cancel this request. Are you sure?</strong><br/><br/>',
        title: 'Caution!',
        buttons: {
          confirm: {
            label: 'Confirm',
            className: 'btn-danger',
            callback: function callback() {
              runActionRequest('cancel', requestId, 'Request canceled successfully.');
            }
          },
          cancel: {
            label: 'Cancel',
            className: 'btn-default',
            callback: function callback() {}
          }
        }
      });
    }
    /**
     * Ask user confirmation before accepting an acknowledge request.
     * @param {number} requestId request identifier to accept
     */


    function confirmAcceptAcknowledgeRequest(requestId) {
      bootbox.dialog({
        message: '<strong>You are about to accept this request. Are you sure?</strong><br/><br/>',
        title: 'Caution!',
        buttons: {
          confirm: {
            label: 'Confirm',
            className: 'btn-green',
            callback: function callback() {
              runActionRequest('accept', requestId, 'Request accepted successfully.');
            }
          },
          cancel: {
            label: 'Cancel',
            className: 'btn-default',
            callback: function callback() {}
          }
        }
      });
    }
    /**
     * Ask user confirmation before rejecting an acknowledge request.
     * @param {number} requestId request identifier to reject
     */


    function confirmRejectAcknowledgeRequest(requestId) {
      bootbox.dialog({
        message: '<strong>You are about to reject this request. Are you sure?</strong><br/><br/>',
        title: 'Caution!',
        buttons: {
          confirm: {
            label: 'Confirm',
            className: 'btn-danger',
            callback: function callback() {
              runActionRequest('reject', requestId, 'Request rejected successfully.');
            }
          },
          cancel: {
            label: 'Cancel',
            className: 'btn-default',
            callback: function callback() {}
          }
        }
      });
    }
    /**
     * Open flight date picker for request form.
     */


    function openJumpseatFlightDatePicker() {
      $scope.jumpseatRequestFormState.isFlightDatePickerOpen = true;
    }
    /**
     * Handle request type changes and keep form consistency.
     */


    function onJumpseatRequestTypeChanged() {
      if (isGeneralDeclarationType($scope.jumpseatRequestForm.RequestType)) {
        $scope.jumpseatRequestForm.TravelersType = null;
        $scope.jumpseatRequestForm.EntitledPassengers = [];
        return;
      }

      if (!$scope.jumpseatRequestForm.TravelersType) {
        $scope.jumpseatRequestForm.TravelersType = getDefaultTravelersTypeId();
      }

      onJumpseatTravelersTypeChanged();
    }
    /**
     * Handle travelers type changes and passenger rows.
     */


    function onJumpseatTravelersTypeChanged() {
      if (!$scope.jumpseatRequestForm.EntitledPassengers) {
        $scope.jumpseatRequestForm.EntitledPassengers = [];
      }

      if (!shouldShowEntitledPassengersSection()) {
        $scope.jumpseatRequestForm.EntitledPassengers = [];
        return;
      }

      if ($scope.jumpseatRequestForm.EntitledPassengers.length === 0) {
        addEntitledPassenger();
      }
    }
    /**
     * Return true when travelers controls should be shown.
     * @returns {boolean} true when request is not GD
     */


    function shouldShowTravelersSection() {
      return !isGeneralDeclarationType($scope.jumpseatRequestForm.RequestType);
    }
    /**
     * Return true when entitled persons list should be shown.
     * @returns {boolean} true when travelers type needs entitled persons
     */


    function shouldShowEntitledPassengersSection() {
      return shouldShowTravelersSection() && ($scope.jumpseatRequestForm.TravelersType === 2 || $scope.jumpseatRequestForm.TravelersType === 3);
    }
    /**
     * Add one entitled person row to the request form.
     */


    function addEntitledPassenger() {
      $scope.jumpseatRequestForm.EntitledPassengers.push({
        Name: '',
        RelationshipId: getDefaultRelationshipId()
      });
    }
    /**
     * Remove one entitled person row from the request form.
     * @param {number} index row index to remove
     */


    function removeEntitledPassenger(index) {
      if (index >= 0 && index < $scope.jumpseatRequestForm.EntitledPassengers.length) {
        $scope.jumpseatRequestForm.EntitledPassengers.splice(index, 1);
      }

      if (shouldShowEntitledPassengersSection() && $scope.jumpseatRequestForm.EntitledPassengers.length === 0) {
        addEntitledPassenger();
      }
    }
    /**
     * Validate and submit jumpseat request form.
     */


    function submitJumpseatRequest() {
      var payload;

      if (!window.navigator.onLine) {
        bootbox.alert({
          title: "<div class='text-orange'>No Internet</div>",
          message: 'Please check the internet connection!'
        });
        return;
      }

      payload = buildSubmitRequestPayload();

      if (!payload) {
        return;
      }

      $scope.isSubmittingJumpseatRequest = true;
      JumpseatRequestsFactory.submitRequest(payload, function (responseData) {
        $scope.isSubmittingJumpseatRequest = false;

        if (!responseData.success) {
          bootbox.alert({
            title: "<div class='text-red'>Error</div>",
            message: responseData.errorMessage || 'Unable to submit jumpseat request.'
          });
          return;
        }

        bootbox.alert({
          title: "<div class='text-green'>Success</div>",
          message: 'Jumpseat request submitted successfully.',
          callback: function callback() {
            resetJumpseatRequestForm();
            refreshJumpseatInfo();
          }
        });
      }, function () {
        $scope.isSubmittingJumpseatRequest = false;
        bootbox.alert({
          title: "<div class='text-red'>Error</div>",
          message: 'Unable to submit jumpseat request.'
        });
      });
    }
    /**
     * Initialize request form defaults.
     */


    function initializeJumpseatRequestForm() {
      var dateFrom = $scope.jumpseatInfo.DateFrom ? new Date($scope.jumpseatInfo.DateFrom) : null;
      var dateTo = $scope.jumpseatInfo.DateTo ? new Date($scope.jumpseatInfo.DateTo) : null;
      $scope.jumpseatFlightDateOptions = {
        minDate: dateFrom,
        maxDate: dateTo,
        initDate: dateFrom,
        startingDay: 1
      };

      if (!$scope.jumpseatRequestForm || !$scope.jumpseatRequestForm._initialized) {
        $scope.jumpseatRequestForm = {
          _initialized: true,
          RequestType: getDefaultRequestTypeId(),
          FlightDate: null,
          FlightNo: '',
          Departure: '',
          TravelersType: getDefaultTravelersTypeId(),
          EntitledPassengers: []
        };
      }

      if (!$scope.jumpseatInfo.IsGDEligible) {
        $scope.jumpseatRequestForm.RequestType = getJumpseatRequestTypeId();
      }

      onJumpseatRequestTypeChanged();
    }
    /**
     * Reset jumpseat request form to its initial state.
     */


    function resetJumpseatRequestForm() {
      $scope.jumpseatRequestForm = {
        _initialized: false
      };
      $scope.jumpseatRequestFormState.isFlightDatePickerOpen = false;
    }
    /**
     * Build submit payload and validate required fields.
     * @returns {object|null} payload when valid, otherwise null
     */


    function buildSubmitRequestPayload() {
      var form = $scope.jumpseatRequestForm;
      var crewInfo = $scope.jumpseatInfo && $scope.jumpseatInfo.CrewInfo ? $scope.jumpseatInfo.CrewInfo : {};
      var passengers = [];
      var index;

      if (!form.FlightDate) {
        bootbox.alert({
          title: "<div class='text-orange'>Validation</div>",
          message: 'Flight Date is required.'
        });
        return null;
      }

      if (!form.FlightNo || !form.FlightNo.trim()) {
        bootbox.alert({
          title: "<div class='text-orange'>Validation</div>",
          message: 'Flight Number is required.'
        });
        return null;
      }

      if (!form.Departure || !form.Departure.trim()) {
        bootbox.alert({
          title: "<div class='text-orange'>Validation</div>",
          message: 'Departure is required.'
        });
        return null;
      }

      if (shouldShowTravelersSection() && !form.TravelersType) {
        bootbox.alert({
          title: "<div class='text-orange'>Validation</div>",
          message: 'Travelers Type is required.'
        });
        return null;
      }

      if (shouldShowEntitledPassengersSection()) {
        if (!form.EntitledPassengers || form.EntitledPassengers.length === 0) {
          bootbox.alert({
            title: "<div class='text-orange'>Validation</div>",
            message: 'At least one entitled person is required.'
          });
          return null;
        }

        for (index = 0; index < form.EntitledPassengers.length; index += 1) {
          if (!form.EntitledPassengers[index].Name || !form.EntitledPassengers[index].Name.trim()) {
            bootbox.alert({
              title: "<div class='text-orange'>Validation</div>",
              message: 'Entitled Person Name is required.'
            });
            return null;
          }

          if (!form.EntitledPassengers[index].RelationshipId) {
            bootbox.alert({
              title: "<div class='text-orange'>Validation</div>",
              message: 'Relationship is required.'
            });
            return null;
          }

          passengers.push({
            Name: form.EntitledPassengers[index].Name.trim(),
            Relationship: form.EntitledPassengers[index].RelationshipId
          });
        }
      }

      return {
        RequestType: form.RequestType,
        FlightDate: moment(form.FlightDate).format('YYYY-MM-DDTHH:mm:ss[Z]'),
        FlightNo: form.FlightNo.trim().toUpperCase(),
        Departure: form.Departure.trim().toUpperCase(),
        RequestorId: $scope.currentUser.id,
        TravelersType: shouldShowTravelersSection() ? form.TravelersType : 1,
        Passengers: passengers
      };
    }
    /**
     * Execute one request action call and show success/error feedback.
     * @param {string} actionType action type: cancel|accept|reject
     * @param {number} requestId request identifier
     * @param {string} successMessage message shown on success
     */


    function runActionRequest(actionType, requestId, successMessage) {
      var actionCall = getActionCall(actionType);

      if (!window.navigator.onLine) {
        bootbox.alert({
          title: "<div class='text-orange'>No Internet</div>",
          message: 'Please check the internet connection!'
        });
        return;
      }

      if (!actionCall) {
        bootbox.alert({
          title: "<div class='text-red'>Error</div>",
          message: 'Invalid action request.'
        });
        return;
      }

      bootbox.dialog({
        closeButton: false,
        message: '<div class="text-center"><i class="fa fa-spin fa-spinner"></i> Please wait...</div>'
      });
      actionCall(requestId, function (responseData) {
        bootbox.hideAll();

        if (!responseData.success) {
          bootbox.alert({
            title: "<div class='text-red'>Error</div>",
            message: responseData.errorMessage || 'Unable to complete jumpseat action.'
          });
          return;
        }

        bootbox.alert({
          title: "<div class='text-green'>Success</div>",
          message: successMessage,
          callback: function callback() {
            refreshJumpseatInfo();
          }
        });
      }, function () {
        bootbox.hideAll();
        bootbox.alert({
          title: "<div class='text-red'>Error</div>",
          message: 'Unable to complete jumpseat action.'
        });
      });
    }
    /**
     * Resolve proper service call function for action type.
     * @param {string} actionType action type value
     * @returns {function|null} action service function or null
     */


    function getActionCall(actionType) {
      if (actionType === 'cancel') {
        return JumpseatRequestsFactory.cancelRequest;
      }

      if (actionType === 'accept') {
        return JumpseatRequestsFactory.acceptRequest;
      }

      if (actionType === 'reject') {
        return JumpseatRequestsFactory.rejectRequest;
      }

      return null;
    }
    /**
     * Get default request type id according to eligibility.
     * @returns {number} request type id
     */


    function getDefaultRequestTypeId() {
      if (!$scope.jumpseatInfo.IsGDEligible) {
        return getJumpseatRequestTypeId();
      }

      return getJumpseatRequestTypeId();
    }
    /**
     * Get jumpseat request type id from ancillaries.
     * @returns {number} request type id for Jumpseat Request
     */


    function getJumpseatRequestTypeId() {
      var requestTypes = $scope.jumpseatInfo && $scope.jumpseatInfo.Ancillaries && $scope.jumpseatInfo.Ancillaries.RequestTypes ? $scope.jumpseatInfo.Ancillaries.RequestTypes : [];
      var index;

      for (index = 0; index < requestTypes.length; index += 1) {
        if ((requestTypes[index].text || '').toLowerCase().indexOf('jumpseat') !== -1) {
          return requestTypes[index].id;
        }
      }

      return 1;
    }
    /**
     * Check whether request type corresponds to General Declaration.
     * @param {number} requestTypeId request type id value
     * @returns {boolean} true when request type is General Declaration
     */


    function isGeneralDeclarationType(requestTypeId) {
      var requestTypes = $scope.jumpseatInfo && $scope.jumpseatInfo.Ancillaries && $scope.jumpseatInfo.Ancillaries.RequestTypes ? $scope.jumpseatInfo.Ancillaries.RequestTypes : [];
      var index;

      for (index = 0; index < requestTypes.length; index += 1) {
        if (requestTypes[index].id === requestTypeId) {
          return (requestTypes[index].text || '').toLowerCase().indexOf('general declaration') !== -1;
        }
      }

      return requestTypeId === 2;
    }
    /**
     * Get default travelers type id from ancillaries.
     * @returns {number} travelers type id
     */


    function getDefaultTravelersTypeId() {
      var travelersTypes = $scope.jumpseatInfo && $scope.jumpseatInfo.Ancillaries && $scope.jumpseatInfo.Ancillaries.TravelersTypes ? $scope.jumpseatInfo.Ancillaries.TravelersTypes : [];

      if (travelersTypes.length > 0) {
        return travelersTypes[0].id;
      }

      return 1;
    }
    /**
     * Get default relationship id from ancillaries.
     * @returns {number|null} relationship id
     */


    function getDefaultRelationshipId() {
      var relationships = $scope.jumpseatInfo && $scope.jumpseatInfo.Ancillaries && $scope.jumpseatInfo.Ancillaries.PassengerRelationships ? $scope.jumpseatInfo.Ancillaries.PassengerRelationships : [];

      if (relationships.length > 0) {
        return relationships[0].id;
      }

      return null;
    }
    /**
     * Resolve display label for a request status value.
     * @param {number} statusValue numeric status value
     * @returns {string} user-friendly status text
     */


    function getJumpseatStatusLabel(statusValue) {
      var statuses = $scope.jumpseatInfo && $scope.jumpseatInfo.Ancillaries ? $scope.jumpseatInfo.Ancillaries.Statuses : null;
      var index;

      if (statuses && statuses.length) {
        for (index = 0; index < statuses.length; index += 1) {
          if (statuses[index].value === statusValue) {
            return statuses[index].label;
          }
        }
      }

      if (statusValue === 1) {
        return 'Pending';
      }

      if (statusValue === 2) {
        return 'Accepted';
      }

      if (statusValue === 3) {
        return 'Rejected';
      }

      return 'Unknown';
    }
    /**
     * Map status value to existing badge class.
     * @param {number} statusValue numeric status value
     * @returns {string} css badge class
     */


    function getJumpseatStatusBadgeClass(statusValue) {
      if (statusValue === 2) {
        return 'badge-green';
      }

      if (statusValue === 3) {
        return 'badge-danger';
      }

      return 'badge-primary';
    }
    /**
     * Check whether request type is General Declaration.
     * @param {number} requestType request type value
     * @returns {boolean} true when request type is GD
     */


    function isGeneralDeclarationRequest(requestType) {
      return requestType === 1;
    }
    /**
     * Check whether a request has passenger rows for rendering.
     * @param {object} request submitted request object
     * @returns {boolean} true when at least one passenger row exists
     */


    function hasSubmittedPassengerRows(request) {
      return request && request._submittedPassengerRows && request._submittedPassengerRows.length > 0;
    }
    /**
     * Return cached passenger rows for a submitted request.
     * @param {object} request submitted request object
     * @returns {array} prepared passenger rows for the UI
     */


    function getSubmittedPassengerRows(request) {
      if (request && request._submittedPassengerRows) {
        return request._submittedPassengerRows;
      }

      if (request) {
        request._submittedPassengerRows = buildSubmittedPassengerRows(request);
        return request._submittedPassengerRows;
      }

      return [];
    }
    /**
     * Prepare submitted requests view-model after data load.
     */


    function prepareSubmittedRequestsViewModel() {
      var requests = $scope.jumpseatInfo && $scope.jumpseatInfo.SubmittedRequests ? $scope.jumpseatInfo.SubmittedRequests : [];
      var index;

      for (index = 0; index < requests.length; index += 1) {
        requests[index]._submittedPassengerRows = buildSubmittedPassengerRows(requests[index]);
      }
    }
    /**
     * Build passenger rows according to TravelersType rules.
     * @param {object} request submitted request object
     * @returns {array} normalized passenger rows for rendering
     */


    function buildSubmittedPassengerRows(request) {
      var passengers = request && request.Passengers ? request.Passengers : [];
      var passengerRows = [];
      var crewName = $scope.jumpseatInfo && $scope.jumpseatInfo.CrewInfo ? $scope.jumpseatInfo.CrewInfo.Name : '';
      var index; //TODO: change travelers values from specific numbers to more explicit constants in the service and use them here for better readability

      if (!request || request.TravelersType === 1) {
        return passengerRows;
      }

      if (request.TravelersType === 2) {
        return passengers;
      }

      if (request.TravelersType === 3) {
        passengerRows.push({
          Name: crewName,
          Relationship: '',
          IsSelf: true
        });

        for (index = 0; index < passengers.length; index += 1) {
          if (passengers[index].Relationship === 'Self' || passengers[index].Name === crewName) {
            continue;
          }

          passengerRows.push(passengers[index]);
        }
      }

      return passengerRows;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('JumpseatRequestsFactory', JumpseatRequestsFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name JumpseatRequestsFactory
   * @description
   *   Service for Jumpseat Requests data management
   * @ngInject
   */

  function JumpseatRequestsFactory($http, apiUrl) {
    var jumpseatApiURL = apiUrl + '/JumpseatRequests';
    var jumpseatInfoAction = jumpseatApiURL + '/GetJumpseatInfo';
    var cancelAction = jumpseatApiURL + '/CancelRequest';
    var submitRequestAction = jumpseatApiURL + '/SubmitRequest';
    var service = {
      getJumpseatInfo: getJumpseatInfo,
      cancelRequest: cancelRequest,
      submitRequest: submitRequest
    };
    /**
     * Get jumpseat information.
     * For now this returns mock data. Replace with jumpseatInfoAction when API is ready.
     * @param {function} callback an on success callback function
     * @param {function} errorCallback an on error callback function
     */

    function getJumpseatInfo(callback, errorCallback) {
      // Real API call (without mock data):
      return $http.post(jumpseatInfoAction, {
        'Content-Type': 'application/json'
      }).then(function (responseData) {
        callback(responseData.data);
      })["catch"](errorCallback); // Mock data call:
      // return $http.get('views/JumpseatRequests/jumpseatInfo.mock.json', { 'Content-Type': 'application/json' })
      //     .then(function (responseData) {
      //         var payload = responseData.data;
      //         callback({
      //             success: true,
      //             data: {
      //                 data: payload
      //             },
      //             errorMessage: null
      //         });
      //     })
      //     .catch(errorCallback); 
    }
    /**
     * Cancel an existing jumpseat request.
     * @param {number} requestId request identifier
     * @param {function} callback an on success callback function
     * @param {function} errorCallback an on error callback function
     */


    function cancelRequest(requestId, callback, errorCallback) {
      return $http.post(cancelAction, requestId, {
        'Content-Type': 'application/json'
      }).then(function (responseData) {
        callback(responseData.data);
      })["catch"](errorCallback);
    }
    /**
     * Submit a new jumpseat request.
     * @param {object} requestData jumpseat request payload
     * @param {function} callback an on success callback function
     * @param {function} errorCallback an on error callback function
     */


    function submitRequest(requestData, callback, errorCallback) {
      return $http.post(submitRequestAction, requestData, {
        'Content-Type': 'application/json'
      }).then(function (responseData) {
        callback(responseData.data);
      })["catch"](errorCallback);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('jumpseatSubmittedRequestsPanel', jumpseatSubmittedRequestsPanel);

  function jumpseatSubmittedRequestsPanel() {
    function link(scope) {
      scope.submittedRequestsPanelState = {
        isOpen: true
      };
      scope.toggleSubmittedRequestsPanel = toggleSubmittedRequestsPanel;

      function toggleSubmittedRequestsPanel() {
        scope.submittedRequestsPanelState.isOpen = !scope.submittedRequestsPanelState.isOpen;
      }

      scope.getStatusBorderClass = getStatusBorderClass;

      function getStatusBorderClass(statusValue) {
        if (statusValue === 2) {
          return 'border-left-green';
        }

        if (statusValue === 3) {
          return 'border-left-red';
        }

        return 'border-left-blue';
      }
    }

    return {
      restrict: 'E',
      templateUrl: 'views/JumpseatRequests/submittedRequestsPanel.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('CalendarRedirectModalCtrl', CalendarRedirectModalCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name CalendarRedirectModalCtrl
  * @description 
  * Modal to redirect to Calendar after all mandatory memos are read
  * @ngInject
  */

  function CalendarRedirectModalCtrl($scope, $location, $uibModalInstance) {
    $scope.gotoCalendar = gotoCalendar;

    function gotoCalendar() {
      cancel();
      $location.path('/');
    }
    /**
    * Closes modal
    * @memberof CalendarRedirectModalCtrl
    */


    function cancel() {
      $uibModalInstance.close('cancel');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('MandatoryModalCtrl', MandatoryModalCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name MandatoryModalCtrl
  * @description 
  * Warning Modal about unread mandatory memos
  * @ngInject
  */

  function MandatoryModalCtrl($scope, mandatoryUnread, MemoFactory, $uibModal, $routeParams, $location, $uibModalInstance) {
    $scope.mandatoryUnread = mandatoryUnread;
    $scope.gotoMandatoryUnreadMemos = gotoMandatoryUnreadMemos;

    function gotoMandatoryUnreadMemos() {
      $location.path('/memos/unreadMandatory');
      cancel();
    }
    /**
    * Closes modal
    * @memberof ProposalInfoModalCtr
    */


    function cancel() {
      $uibModalInstance.close('cancel');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('MemoFactory', MemoFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name MemoFactory
   * @description 
   *   Add, Update, Delete and Get Memos.
   * @ngInject
   */

  function MemoFactory(FlightFactory, GroundDutyFactory, IndexedDBService, PaxInfoFactory, $q) {
    /**
     * Initialize the Memo
     * @memberof MemoFactory
     */
    function Memo() {
      this.Id = null;
      this.expired = false;
    }

    var objType = 'Memos';
    var objCallback = Memo;
    var memoReadDatesById = {};
    var service = {
      getMemosFromStorage: getMemosFromStorage,
      setMemosToStorage: setMemosToStorage,
      clearMemosFromStorage: clearMemosFromStorage,
      getMemosForFlight: getMemosForFlight,
      getStoredMemosIds: getStoredMemosIds,
      saveOneMemoToStorage: saveOneMemoToStorage,
      addMemoToStorage: addMemoToStorage,
      deleteMemoFromStorage: deleteMemoFromStorage,
      setMemosFromServer: setMemosFromServer,
      getMemosForGroundDuty: getMemosForGroundDuty,
      getMemosForCrewRoute: getMemosForCrewRoute,
      getUnreadMemos: getUnreadMemos,
      getMandatoryUnreadMemos: getMandatoryUnreadMemos,
      getAllUnreadGroundDutyMemos: getAllUnreadGroundDutyMemos,
      markGroundDutiesUnread: markGroundDutiesUnread,
      info: info,
      getNotHiddenMemos: getNotHiddenMemos
    };
    /**
     * Get Memos
     * @memberof MemoFactory
     * @param {function} callback  
     */

    function getMemosFromStorage(callback) {
      //return GenericService.list(objType,objCallback);
      IndexedDBService.getAll(objType).then(function (results) {
        callback(results);
      });
    }

    ;
    /**
     * Set Memos
     * @memberof MemoFactory
     * @param {array} Memos   a list of memos to set to indexedDB
     */

    function setMemosToStorage(Memos) {
      setDateOfIssueDefault(Memos);
      IndexedDBService.addAll(objType, Memos);
    }

    ;
    /**
     * Update Memo to Storage
     * @memberof MemoFactory
     * @param {object} Memo   a memo
     */

    function saveOneMemoToStorage(Memo) {
      setDateOfIssueDefault(Memo);
      IndexedDBService.put(objType, Memo);
    }

    ;

    function info() {
      IndexedDBService.info(objType);
    }
    /**
     * Add Memo to Storage
     * @memberof MemoFactory
     * @param {object} Memo   a memo
     */


    function addMemoToStorage(Memo) {
      setDateOfIssueDefault(Memo);
      IndexedDBService.add(objType, Memo);
    }

    ;
    /**
     * Delete Memo from Storage
     * @memberof MemoFactory
     * @param {number} MemoId  The unique Identifier of the Memo
     */

    function deleteMemoFromStorage(MemoId) {
      IndexedDBService.remove(objType, MemoId);
    }

    ;
    /**
     * Clear Memo from Storage
     * @memberof MemoFactory
     */

    function clearMemosFromStorage() {
      IndexedDBService.removeAll(objType);
    }

    ;

    function setDateOfIssueDefault(memos) {
      if (!memos) {
        return;
      }

      if (angular.isArray(memos)) {
        for (var i = 0; i < memos.length; i++) {
          setDateOfIssueDefault(memos[i]);
        }

        return;
      }

      if (!memos.hasOwnProperty('DateOfIssue')) {
        memos.DateOfIssue = null;
      }
    }

    function ValidateCountryCategory(criteria, isDepartureCategory, isArrivalCategory) {
      var isValid = false;

      if (criteria.Special == "Specific") {
        isValid = (criteria.Field == "Intra" && isDepartureCategory || criteria.Field == "Extra" && !isDepartureCategory) && (criteria.FieldOptional == "Intra" && isArrivalCategory || criteria.FieldOptional == "Extra" && !isArrivalCategory);
      } else {
        if (criteria.Field == "Intra") {
          isValid = isDepartureCategory && criteria.Special != "To" || isArrivalCategory && criteria.Special != "From";
        } else if (criteria.Field == "Extra") {
          isValid = !isDepartureCategory && criteria.Special != "To" || !isArrivalCategory && criteria.Special != "From";
        }
      }

      return isValid;
    }

    function isValid(field, departureField, arrivalField, special) {
      var isValid = false;
      var isDeparture = departureField == field;
      var isArrival = arrivalField == field;

      if (special == "From") {
        isValid = isDeparture;
      } else if (special == "To") {
        isValid = isArrival;
      } else {
        isValid = isArrival || isDeparture;
      }

      return isValid;
    }
    /**
     * Gets all unread memos related to a Ground Duty
     * @memberof MemoFactory
     */


    function getAllUnreadGroundDutyMemos(callback) {
      getMemosFromStorage(function (results) {
        var memosCollection = results;
        var unreadGroundDutyMemos = [];

        for (var i = 0; i < memosCollection.length; i++) {
          for (var j = 0; j < memosCollection[i].MemoCriteria.length; j++) {
            var item = memosCollection[i].MemoCriteria[j];

            if (item.QueryType == "GroundDutyCode" && memosCollection[i].ReadDt == null) {
              unreadGroundDutyMemos.push(memosCollection[i]);
              break;
            }
          }
        }

        callback(unreadGroundDutyMemos);
      });
    }

    function getMemosForGroundDuty(Id, callback) {
      var groundDuty = GroundDutyFactory.getGroundDutyFromStorage(Id);

      if (!groundDuty) {
        return [];
      }

      getMemosFromStorage(function (results) {
        var memosCollection = results;
        var groundDutyMemos = [];
        var fromDutyDate = new Date(groundDuty.DutyDate).getTime();
        var toDutyDate = new Date(groundDuty.DutyDate).getTime();

        for (var i = 0; i < memosCollection.length; i++) {
          if (new Date(memosCollection[i].ValidFrom).getTime() <= fromDutyDate && new Date(memosCollection[i].ValidTo).getTime() >= toDutyDate) {
            for (var j = 0; j < memosCollection[i].MemoCriteria.length; j++) {
              var item = memosCollection[i].MemoCriteria[j];

              if (item.QueryType == "GroundDutyCode" && (item.Field == groundDuty.DutyNo || item.Field == groundDuty.GroundDutyNo)) {
                groundDutyMemos.push(memosCollection[i]);
                break;
              }
            }
          }
        }

        callback(groundDutyMemos);
      });
    }
    /**
     * Get Memos that are relate to this flight
     * @memberof MemoFactory
     * @param {number} Id  The unique Identifier of the Memo
     * @param {function} callback  The callback function
     */


    function getMemosForFlight(Id, callback) {
      var flight = FlightFactory.getFlightFromStorage(Id);

      if (!flight) {
        flight = FlightFactory.getLocalFlightFromStorage(Id);
      }

      if (!flight) {
        return [];
      }

      getMemosFromStorage(function (results) {
        var memosCollection = results;
        var flightMemos = [];
        PaxInfoFactory.getPaxInfoFromStorage(flight.FlightId, function (paxInfo) {
          for (var i = 0; i < memosCollection.length; i++) {
            if (new Date(memosCollection[i].ValidFrom).getTime() <= new Date(flight.ScheduledDeparture).getTime() && new Date(memosCollection[i].ValidTo).getTime() >= new Date(flight.ScheduledArrival).getTime()) {
              for (var j = 0; j < memosCollection[i].MemoCriteria.length; j++) {
                var item = memosCollection[i].MemoCriteria[j];

                if (item.AcRegistration == flight.AcTailNo || item.QueryType == "Airport" && isValid(item.Airport, flight.Departure, flight.Arrival, item.Special) || item.FlightNo == flight.FlightNo || item.AcType == flight.AcType || isValidZone(item, flight.Zones) || item.RouteStart == flight.Departure && item.RouteEnd == flight.Arrival || item.ViceVersa && item.RouteStart == flight.Arrival && item.RouteEnd == flight.Departure || item.QueryType == "Country" && isValid(item.Country, flight.DepartureCountry, flight.ArrivalCountry, item.Special) || item.QueryType == "Schengen" && ValidateCountryCategory(item, flight.DepartureSchengen, flight.ArrivalSchengen) || item.QueryType == "European" && ValidateCountryCategory(item, flight.DepartureEU, flight.ArrivalEU) || paxInfo && item.QueryType == "SsrCode" && PassengersHasSsrCode(paxInfo, item) || item.QueryType == "TrainingId" && item.Field == flight.TrainingIndicatorId) {
                  flightMemos.push(memosCollection[i]);
                  break;
                }
              }
            }
          }

          callback(flightMemos);
        });
      });
    }
    /**
     * Get Memos that are related to this crew route, by combining multiple flight and groundDuty memos 
     * @memberof MemoFactory
     * @param {number} DutyNo Crew Route Identifier
     * @param {number} DutyDay Crew Route Day
     * @param {function} callback  The callback function
     */


    function getMemosForCrewRoute(DutyNo, DutyDay, callback) {
      var groundDuties = GroundDutyFactory.getGroundDutiesByDutyNo(DutyNo, DutyDay);
      var flights = FlightFactory.getFlightsByDutyNo(DutyNo, DutyDay);
      PaxInfoFactory.getAllPaxInfoFromStorage(function (paxInfoResult) {
        getMemosFromStorage(function (results) {
          var memosCollection = results;
          var allMemos = [];

          for (var i = 0; i < memosCollection.length; i++) {
            var inserted = false; //first check if memo is connected with any groundDuties

            for (var g = 0; g < groundDuties.length; g++) {
              var fromDutyDate = new Date(groundDuties[g].DutyDate).getTime();
              var toDutyDate = new Date(groundDuties[g].DutyDate).getTime();

              if (new Date(memosCollection[i].ValidFrom).getTime() <= fromDutyDate && new Date(memosCollection[i].ValidTo).getTime() >= toDutyDate) {
                for (var j = 0; j < memosCollection[i].MemoCriteria.length; j++) {
                  var item = memosCollection[i].MemoCriteria[j];

                  if (item.QueryType == "GroundDutyCode" && (item.Field == groundDuties[g].DutyNo || item.Field == groundDuties[g].GroundDutyNo)) {
                    allMemos.push(memosCollection[i]);
                    inserted = true;
                    break;
                  }
                }
              }

              if (inserted) break; //don't check other groundDuties - memo is already inserted
            } //if memo was checked for all groundDuties and was not connected with any, check in flights


            if (!inserted) {
              for (var f = 0; f < flights.length; f++) {
                var paxInfo = null;

                if (new Date(memosCollection[i].ValidFrom).getTime() < new Date(flights[f].ScheduledDeparture).getTime() && new Date(memosCollection[i].ValidTo).getTime() > new Date(flights[f].ScheduledArrival).getTime()) {
                  //check if flight has paxInfo 
                  for (var p = 0; p < paxInfoResult.length; p++) {
                    if (paxInfoResult[p].FlightId == flights[f].FlightId) {
                      paxInfo = paxInfoResult[p];
                      break;
                    }
                  }

                  for (var j = 0; j < memosCollection[i].MemoCriteria.length; j++) {
                    var item = memosCollection[i].MemoCriteria[j];

                    if (item.AcRegistration == flights[f].AcTailNo || item.QueryType == "Airport" && isValid(item.Airport, flights[f].Departure, flights[f].Arrival, item.Special) || item.FlightNo == flights[f].FlightNo || item.AcType == flights[f].AcType || isValidZone(item.Zone, flights[f].Zones) || item.RouteStart == flights[f].Departure && item.RouteEnd == flights[f].Arrival || item.ViceVersa && item.RouteStart == flights[f].Arrival && item.RouteEnd == flights[f].Departure || item.QueryType == "Country" && isValid(item.Country, flights[f].DepartureCountry, flights[f].ArrivalCountry, item.Special) || item.QueryType == "Schengen" && ValidateCountryCategory(item, flights[f].DepartureSchengen, flights[f].ArrivalSchengen) || item.QueryType == "European" && ValidateCountryCategory(item, flights[f].DepartureEU, flights[f].ArrivalEU) || paxInfo && item.QueryType == "SsrCode" && PassengersHasSsrCode(paxInfo, item) || item.QueryType == "TrainingId" && item.Field == flights[f].TrainingIndicatorId) {
                      allMemos.push(memosCollection[i]);
                      inserted = true;
                      break;
                    }
                  }
                }

                if (inserted) break; //don't check other flights - memo is already inserted
              }
            }
          }

          callback(allMemos);
        });
      });
    }

    function PassengersHasSsrCode(paxInfo, memoCriterion) {
      var retVal = false;

      for (var key in paxInfo.PassengerSummaryY) {
        if (key === memoCriterion.Field && paxInfo.PassengerSummaryY[key] > 0) {
          retVal = true;
          break;
        }
      }

      for (var key in paxInfo.PassengerSummaryX) {
        if (key === memoCriterion.Field && paxInfo.PassengerSummaryY[key] > 0) {
          retVal = true;
          break;
        }
      }

      return retVal;
    }
    /**
     * Check if the zone is valid
     * @memberof MemoFactory
     * @param {CriteriaZone} Zone from MemoCriteria
     * @param {FlightZones} List of Zones from flight
     */


    function isValidZone(CriteriaZone, FlightZones) {
      if (!CriteriaZone || CriteriaZone.Type != "Zone" || !FlightZones || FlightZones.length == 0) {
        return false;
      } else {
        // some is equivalent to Any()
        var zoneExist = FlightZones.some(function (item) {
          return item.Title.toUpperCase() == CriteriaZone.Field.toUpperCase() && item.Class.toUpperCase() == CriteriaZone.FieldOptional.toUpperCase();
        });
        return zoneExist;
      }
    }
    /**
     * Get Stored Memos 
     * @memberof MemoFactory
     * @param {function} callback  The callback function
     */


    function getStoredMemosIds(callback) {
      getMemosFromStorage(function (memos) {
        var memoIds = [];
        memoReadDatesById = {};

        for (var i = 0; i < memos.length; i++) {
          var memoIdRead = {
            Id: memos[i].Id,
            ReadDt: memos[i].ReadDt
          };

          if (!memos[i].hasOwnProperty('DateOfIssue')) {
            memoReadDatesById[memos[i].Id] = memos[i].ReadDt;
            continue;
          }

          memoIds.push(memoIdRead);
        }

        callback(memoIds);
      });
    }
    /**
     * set memos from server api  
     * @memberof MemoFactory
     * @param {array} memos  The memos 
     * @param {array} memoIdsToSend  The old memos of the storage
     * @param {string} lastSyncDate  The last Sync Date 
     */


    function setMemosFromServer(memos, memoIdsToSend, lastSyncDate) {
      var hasDateOfIssueBackfill = hasMemosPendingDateOfIssue();

      if (!hasDateOfIssueBackfill && (!lastSyncDate || !memoIdsToSend || memoIdsToSend.length == 0)) {
        setMemosToStorage(memos);
      } else {
        for (var j = 0; j < memos.length; j++) {
          if (memoReadDatesById.hasOwnProperty(memos[j].Id)) {
            memos[j].ReadDt = memos[j].ReadDt || memoReadDatesById[memos[j].Id];
            memos[j].IsUpdated = true;
            memos[j].IsNew = false;
            saveOneMemoToStorage(memos[j]);
            continue;
          }

          var IsMemoIncluded = false;

          for (var h = 0; h < memoIdsToSend.length; h++) {
            if (memos[j].Id == memoIdsToSend[h].Id) {
              IsMemoIncluded = true;
              break;
            }
          }

          if (IsMemoIncluded) {
            memos[j].IsUpdated = true;
            memos[j].IsNew = false;
            saveOneMemoToStorage(memos[j]);
          } else {
            memos[j].IsNew = true;
            memos[j].IsUpdated = false;
            addMemoToStorage(memos[j]);
          }
        }

        memoReadDatesById = {};
      }
    }

    function hasMemosPendingDateOfIssue() {
      for (var memoId in memoReadDatesById) {
        if (memoReadDatesById.hasOwnProperty(memoId)) {
          return true;
        }
      }

      return false;
    }
    /**
     * Get Unread Memos 
     * @memberof MemoFactory
     */


    function getUnreadMemos(callback) {
      getNotHiddenMemos(function (memos) {
        if (!memos) return [];
        var arrayLength = memos.length;
        var result = [];

        for (var i = 0; i < arrayLength; i++) {
          if (!memos[i].ReadDt) {
            result.push(memos[i]);
          }
        }

        callback(result);
      });
    }
    /**
     * Get Count of Unread Mandatory Memos
     * @memberof MemoFactory
     */


    function getMandatoryUnreadMemos(callback) {
      getNotHiddenMemos(function (memos) {
        if (!memos) return [];
        var result = [];
        var arrayLength = memos.length;

        for (var i = 0; i < arrayLength; i++) {
          if (!memos[i].ReadDt && memos[i].IsMandatory) {
            result.push(memos[i]);
          }
        }

        callback(result);
      });
    }
    /**
    * Flags Ground Duties if they have at least one unread memo
    * @memberof MemoFactory
    */


    function markGroundDutiesUnread() {
      getAllUnreadGroundDutyMemos(function (groundDutyMemos) {
        var groundDuties = GroundDutyFactory.getGroundDutiesFromStorage();

        if (groundDuties != null) {
          for (var i = 0; i < groundDuties.length; i++) {
            groundDuties[i].Unread = false; //check if this ground duty has any unread ground duty memo

            var fromDutyDate = new Date(groundDuties[i].DutyDate).getTime();
            var toDutyDate = new Date(groundDuties[i].DutyDate).getTime();

            for (var j = 0; j < groundDutyMemos.length; j++) {
              if (new Date(groundDutyMemos[j].ValidFrom).getTime() <= fromDutyDate && new Date(groundDutyMemos[j].ValidTo).getTime() >= toDutyDate) {
                for (var z = 0; z < groundDutyMemos[j].MemoCriteria.length; z++) {
                  var item = groundDutyMemos[j].MemoCriteria[z];

                  if (item.Field == groundDuties[i].DutyNo || item.Field == groundDuties[i].GroundDutyNo) {
                    groundDuties[i].Unread = true;
                    break;
                  }
                }
              }
            }
          }

          GroundDutyFactory.setGroundDutiesToStorage(groundDuties);
        }
      });
    }
    /**
    * Exclude hidden memos from collection
    * @memberof MemoFactory
    */


    function getNotHiddenMemos(callback) {
      getMemosFromStorage(function (memos) {
        var result = [];

        if (memos) {
          result = memos.filter(function (memo) {
            return !memo.IsHidden;
          });
        }

        callback(result);
      });
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('MemoImagesFactory', MemoImagesFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name MemoImagesFactory
  * @description 
  *   Add, Update, Delete and Get Memo's Images.
  * @ngInject
  */

  function MemoImagesFactory(GenericService, IndexedDBService) {
    /**
    * Initialize the MemoImage
    * @memberof MemoImagesFactory
    */
    function MemoImage() {
      this.Id = null;
    }

    var objType = 'MemoImages';
    var objCallback = MemoImage;
    var service = {
      getMemoImagesFromStorage: getMemoImagesFromStorage,
      setMemoImagesToStorage: setMemoImagesToStorage,
      saveOneMemoImageToStorage: saveOneMemoImageToStorage,
      addMemoImageToStorage: addMemoImageToStorage,
      deleteMemoImageFromStorage: deleteMemoImageFromStorage,
      deleteMemoImageByMemoId: deleteMemoImageByMemoId,
      setImagesToServer: setImagesToServer,
      clearMemoImagesFromStorage: clearMemoImagesFromStorage,
      getMemoImagesByIndex: getMemoImagesByIndex,
      info: info
    };
    /**
     * Get Memo Images 
     * @memberof MemoImagesFactory
     * @param {function} callback  
     */

    function getMemoImagesFromStorage(callback) {
      //return GenericService.list(objType,objCallback);
      IndexedDBService.getAll(objType).then(function (results) {
        callback(results);
      });
    }

    ;
    /**
     * Get Memo Images  by memo Id
     * @memberof MemoImagesFactory
     * @param {number} id Memo Id  
     * @param {function} callback  
     */

    function getMemoImagesByIndex(id, callback) {
      //return GenericService.list(objType,objCallback);
      IndexedDBService.getByIndex(objType, 'memoId', id).then(function (results) {
        callback(results);
      });
    }

    ;
    /**
     * Add Memo Images 
     * @memberof MemoImagesFactory
     * @param {array} MemoImages List of memo images
     */

    function setMemoImagesToStorage(MemoImages) {
      //GenericService.saveAll(Memos,objType,objCallback);
      IndexedDBService.addAll(objType, MemoImages);
    }

    ;

    function info() {
      IndexedDBService.info(objType);
    }
    /**
     * Update Memo Images 
     * @memberof MemoImagesFactory
     * @param {object} MemoImage a memo image
     */


    function saveOneMemoImageToStorage(MemoImage) {
      IndexedDBService.put(objType, MemoImage);
    }

    ;
    /**
     * Add Memo Image
     * @memberof MemoImagesFactory
     * @param {object} MemoImage a memo image
     */

    function addMemoImageToStorage(MemoImage) {
      IndexedDBService.add(objType, MemoImage);
    }

    ;
    /**
     * Delete  Memo Image
     * @memberof MemoImagesFactory
     * @param {number} MemoImageId a memo image Id
     */

    function deleteMemoImageFromStorage(MemoImageId) {
      IndexedDBService.remove(objType, MemoImageId);
    }

    ;
    /**
     * Delete  Memo Image by MemoId
     * @memberof MemoImagesFactory
     * @param {number} MemoId a memo Id
     */

    function deleteMemoImageByMemoId(MemoId) {
      IndexedDBService.removeByIndex(objType, 'memoId', MemoId);
    }

    ;
    /**
     * Set  Memo Image by api call
     * @memberof MemoImagesFactory
     * @param {array} images List of memo images
     */

    function setImagesToServer(images) {
      for (var i = 0; i < images.length; i++) {
        addMemoImageToStorage(images[i]);
      }
    }
    /**
     * Remove  Memo Images from storage
     * @memberof MemoImagesFactory
     */


    function clearMemoImagesFromStorage() {
      IndexedDBService.removeAll(objType);
    }

    ;
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('MemoModalCtrl', MemoModalCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name MemoModalCtrl
  * @description 
  *  Manages the Memo Modal
  * @ngInject
  */

  function MemoModalCtrl($scope, memo, $uibModalInstance, MemoImagesFactory, $sce) {
    $scope.memo = memo;
    $scope.cancel = cancel;
    $scope.hasCountry = false;
    $scope.hasFlightNo = false;
    $scope.hasAirport = false;
    $scope.hasRoute = false;
    $scope.hasAcType = false;
    $scope.hasZone = false;
    $scope.hasEuropean = false;
    $scope.hasSchengen = false;
    $scope.hasAcRegistration = false;
    $scope.hasSsrCode = false;
    $scope.hasTrainingIndicator = false;
    $scope.hasGroundDuties = false;
    $scope.hasNone = true;
    $scope.images = [];
    $scope.showImage = showImage;
    $scope.body = $sce.trustAsHtml(memo.Body);
    MemoImagesFactory.getMemoImagesByIndex(memo.Id, function (results) {
      $scope.images = results;
    });
    /**
     * Open A new Tab and show the image 
     * @memberof MemoModalCtrl
     * @param {string} src Base64 endode string of Image
     */

    function showImage(src) {
      var image = new Image();
      image.src = src;
      var w = window.open("");
      w.document.write(image.outerHTML);
    }
    /**
     * Show the criteria of the memo 
     * @memberof MemoModalCtrl
     */


    (function changeFlags() {
      angular.forEach(memo.MemoCriteria, function (criteria) {
        if (criteria.Country || criteria.Type == "Country" && criteria.Field) {
          $scope.hasCountry = true;
          $scope.hasNone = false;
        }

        if (criteria.FlightNo || criteria.Type == "FlightNo" && criteria.Field) {
          $scope.hasFlightNo = true;
          $scope.hasNone = false;
        }

        if (criteria.Airport || criteria.Type == "Airport" && criteria.Field) {
          $scope.hasAirport = true;
          $scope.hasNone = false;
        }

        if (criteria.RouteStart || criteria.Type == "RouteStart" && criteria.Field) {
          $scope.hasRoute = true;
          $scope.hasNone = false;
        }

        if (criteria.AcType || criteria.Type == "AcType" && criteria.Field) {
          $scope.hasAcType = true;
          $scope.hasNone = false;
        }

        if (criteria.Zone || criteria.Type == "Zone" && criteria.Field) {
          $scope.hasZone = true;
          $scope.hasNone = false;
        }

        if (criteria.AcRegistration || criteria.Type == "AcRegistration" && criteria.Field) {
          $scope.hasAcRegistration = true;
          $scope.hasNone = false;
        }

        if (criteria.Type == "SsrCode" && criteria.Field) {
          $scope.hasSsrCode = true;
          $scope.hasNone = false;
        }

        if (criteria.Type == "TrainingId" && criteria.Field) {
          $scope.hasTrainingIndicator = true;
          $scope.hasNone = false;
        }

        if (criteria.Type == "European" && criteria.Field) {
          $scope.hasEuropean = true;
          $scope.hasNone = false;
        }

        if (criteria.Type == "Schengen" && criteria.Field) {
          $scope.hasSchengen = true;
          $scope.hasNone = false;
        }

        if (criteria.Type == "GroundDutyCode" && criteria.Field) {
          $scope.hasGroundDuties = true;
          $scope.hasNone = false;
        }
      });
    })();
    /**
     * Close the modal
     * @memberof MemoModalCtrl
     */


    function cancel() {
      $uibModalInstance.close('close');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('MemosCtrl', MemosCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name MemosCtrl
  * @description 
  *  Manages the Memos View
  * @ngInject
  */

  function MemosCtrl($scope, MemoFactory, $uibModal, $routeParams) {
    $scope.memosByCategory = [];
    $scope.openMemo = openMemo;
    $scope.searchText = '';
    $scope.searchMemos = searchMemos;
    $scope.state = 'memos';
    $scope.select = select;
    $scope.toggleSidePanel = toggleSidePanel;
    $scope.searchResultsCount = searchResultsCount;
    $scope.shownSideMenu = false;
    $scope.active = 1;
    $scope.showhideDescr = showhideDescr;
    $scope.toShowBody = true;
    $scope.toShowAppliesTo = true;
    $scope.hasCountry = false;
    $scope.hasFlightNo = false;
    $scope.hasAirport = false;
    $scope.hasRoute = false;
    $scope.hasAcType = false;
    $scope.hasZone = false;
    $scope.hasEuropean = false;
    $scope.hasSchengen = false;
    $scope.hasAcRegistration = false;
    $scope.hasSsrCode = false;
    $scope.hasTrainingIndicator = false;
    $scope.hasGroundDuties = false;
    $scope.hasNone = true;
    MemoFactory.getNotHiddenMemos(function (results) {
      var tommorowTimestamp = new Date().getTime() + 86400000;

      for (var i = 0; i < results.length; i++) {
        results[i].expired = new Date(results[i].ValidTo).getTime() < tommorowTimestamp;
      }

      $scope.memos = results;
      var memosByCategory = MemosByCategories(results);

      if ($routeParams.filter == 'unread') {
        $scope.radioModel = 'Unread';
        searchMemos($scope.searchText, 'Unread');
      } else if ($routeParams.filter == 'unreadMandatory') {
        $scope.radioModel = 'UnreadMandatory';
        searchMemos($scope.searchText, 'UnreadMandatory');
      } else {
        $scope.radioModel = 'All'; //default category on load

        $scope.selected = memosByCategory[0];
        $scope.memosByCategory = memosByCategory;
        searchResultsCount();
      }
    });

    function searchResultsCount() {
      var sum = 0;

      for (var i = 0; i < $scope.memosByCategory.length; i++) {
        sum += $scope.memosByCategory[i].memoList.length;
      }

      $scope.searchResults = sum;
    }

    function MemosByCategories(memoList) {
      var memos = [];

      for (var i = 0; i < memoList.length; i++) {
        var memo = memoList[i];

        if (!memos.filter(function (e) {
          return e.Category == memo.Category;
        }).length > 0) {
          memos.push({
            Category: memo.Category,
            memoList: [memo],
            filterList: [memo]
          });
        } else if (memos.filter(function (e) {
          return e.Category == memo.Category;
        }).length > 0) {
          memos.filter(function (object) {
            if (object.Category == memo.Category) {
              return object;
            }

            ;
          })[0].memoList.push(memo);
          memos.filter(function (object) {
            if (object.Category == memo.Category) {
              return object;
            }

            ;
          })[0].memoList.dynamicSort("LastUpdated", false);
        }

        (function changeFlags() {
          angular.forEach(memoList[i].MemoCriteria, function (criteria) {
            if (criteria.Country || criteria.Type == "Country" && criteria.Field) {
              $scope.hasCountry = true;
              $scope.hasNone = false;
            }

            if (criteria.FlightNo || criteria.Type == "FlightNo" && criteria.Field) {
              $scope.hasFlightNo = true;
              $scope.hasNone = false;
            }

            if (criteria.Airport || criteria.Type == "Airport" && criteria.Field) {
              $scope.hasAirport = true;
              $scope.hasNone = false;
            }

            if (criteria.RouteStart || criteria.Type == "RouteStart" && criteria.Field) {
              $scope.hasRoute = true;
              $scope.hasNone = false;
            }

            if (criteria.AcType || criteria.Type == "AcType" && criteria.Field) {
              $scope.hasAcType = true;
              $scope.hasNone = false;
            }

            if (criteria.Zone || criteria.Type == "Zone" && criteria.Field) {
              $scope.hasZone = true;
              $scope.hasNone = false;
            }

            if (criteria.AcRegistration || criteria.Type == "AcRegistration" && criteria.Field) {
              $scope.hasAcRegistration = true;
              $scope.hasNone = false;
            }

            if (criteria.Type == "SsrCode" && criteria.Field) {
              $scope.hasSsrCode = true;
              $scope.hasNone = false;
            }

            if (criteria.Type == "TrainingId" && criteria.Field) {
              $scope.hasTrainingIndicator = true;
              $scope.hasNone = false;
            }

            if (criteria.Type == "European" && criteria.Field) {
              $scope.hasEuropean = true;
              $scope.hasNone = false;
            }

            if (criteria.Type == "Schengen" && criteria.Field) {
              $scope.hasSchengen = true;
              $scope.hasNone = false;
            }

            if (criteria.Type == "GroundDutyCode" && criteria.Field) {
              $scope.hasGroundDuties = true;
              $scope.hasNone = false;
            }
          });
        })();
      }

      return memos.dynamicSort("Category", true);
    }

    function select(category) {
      selectMemoCategory(category);
      toggleSidePanel();
    }

    function selectMemoCategory(category) {
      var memosByCategory = $scope.memosByCategory;

      for (var i = 0; i < memosByCategory.length; i++) {
        if (memosByCategory[i].Category == category.Category) {
          $scope.selected = memosByCategory[i];
          break;
        }
      }
    }

    function showhideDescr() {
      $scope.toShowBody = !$scope.toShowBody;
      $scope.toShowAppliesTo = !$scope.toShowAppliesTo;
    }

    function toggleSidePanel() {
      $scope.shownSideMenu = !$scope.shownSideMenu;
    } //Pagination


    $scope.pageOptions = [{
      name: '5',
      value: '5'
    }, {
      name: '8',
      value: '8'
    }, {
      name: '15',
      value: '15'
    }, {
      name: '30',
      value: '30'
    }, {
      name: '50',
      value: '50'
    }];
    $scope.viewby = $scope.pageOptions[1].value;
    $scope.currentPage = 1;
    $scope.itemsPerPage = $scope.viewby;
    $scope.maxSize = 5; //Number of pager buttons to show

    $scope.setPage = setPage;
    $scope.setItemsPerPage = setItemsPerPage; //Controller functions

    /**
    * Set pagination page number
    * @memberof MemosCtrl
    * @param {number} pageNo list page number
    */

    function setPage(pageNo) {
      $scope.currentPage = pageNo;
    }
    /**
     * Set items per  page 
     * @memberof MemosCtrl
     * @param {number} num the Number of items to show per page
     */


    function setItemsPerPage(num) {
      $scope.itemsPerPage = num;
      $scope.currentPage = 1; //reset to first paghe
    }
    /**
     * View Selected Memo
     * @memberof MemosCtrl
     * @param {object} memo The selected Memo
     */


    function openMemo(_memo) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgMemo.html',
        controller: 'MemoModalCtrl',
        size: 'lg',
        keyboard: false,
        resolve: {
          memo: function memo() {
            return _memo;
          }
        }
      });
      modalInstance.result.then(function () {
        if (_memo.ReadDt == null) {
          _memo.ReadDt = new Date();
          MemoFactory.saveOneMemoToStorage(_memo); //check if memo is connected to a ground duty

          for (var i = 0; i < _memo.MemoCriteria.length; i++) {
            var item = _memo.MemoCriteria[i];

            if (item.QueryType == "GroundDutyCode") {
              MemoFactory.markGroundDutiesUnread();
              break;
            }
          }

          searchMemos($scope.searchText, '');
        }
      });
    }

    function redirectModal() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgCalendarRedirect.html',
        controller: 'CalendarRedirectModalCtrl',
        backdrop: 'static',
        size: 'md',
        keyboard: false
      });
    }
    /**
     * Search the selected text In Memo Title and body
     * @memberof MemosCtrl
     * @param {string} text The desired search text
     */


    function searchMemos(text, filter) {
      if (filter != '') {
        $scope.radioModel = filter;
      }

      var filteredMemos = [];
      var searchText = text.toLowerCase();
      var newList = $scope.memos;

      for (var i = 0; i < newList.length; i++) {
        if ($scope.radioModel == 'General') {
          if (newList[i].MemoCriteria && newList[i].MemoCriteria.length > 0) {
            continue;
          }
        } else if ($scope.radioModel == 'Unread') {
          if (newList[i].ReadDt) {
            continue;
          }
        } else if ($scope.radioModel == 'Mandatory') {
          if (!newList[i].IsMandatory) {
            continue;
          }
        } else if ($scope.radioModel == 'UnreadMandatory') {
          if (newList[i].ReadDt || !newList[i].IsMandatory) {
            continue;
          }
        } else if ($scope.radioModel == 'Monthly') {
          var diffTime = Math.abs(new Date() - moment.utc(newList[i].LastUpdated).utc().toDate());
          var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

          if (diffDays >= 30) {
            continue;
          }
        }

        var memoTitle = newList[i].Title.toLowerCase();

        if (memoTitle.indexOf(searchText) > -1) {
          filteredMemos.push(newList[i]);
          continue;
        }
      }

      var memosByCategory = MemosByCategories(filteredMemos);
      $scope.memosByCategory = memosByCategory;
      var showAllCategory = {
        Category: 'Show All',
        memoList: filteredMemos,
        filterList: filteredMemos
      };

      if (searchText != null && searchText != undefined && searchText.length > 0) {
        memosByCategory.push(showAllCategory);
      }

      searchResultsCount();

      if (!memosByCategory || !memosByCategory.length) {
        $scope.selected == null; //selected could be null if search didn't return any results

        if ($scope.radioModel == 'UnreadMandatory') {
          //all mandatory memos were read
          // $scope.radioModel = 'All';
          // searchMemos(searchText, '');
          redirectModal();
        }
      } else if ($scope.selected == null) {
        //search now returns results
        $scope.selected = memosByCategory[0];
      }

      if (searchText != null && searchText != undefined && searchText.length > 0) {
        $scope.selected = showAllCategory;
      }

      var select = false;

      for (var i = 0; i < memosByCategory.length; i++) {
        if ($scope.selected.Category == memosByCategory[i].Category) {
          selectMemoCategory(memosByCategory[i]);
          select = true;
          break;
        }
      }

      if (!select) $scope.selected = memosByCategory[0];
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('MessageCtrl', MessageCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name MessageCtrl
  * @description 
  *  Manages the messages View
  * @ngInject
  */

  function MessageCtrl($scope, MessageFactory, $filter, $sce) {
    var messages = [];
    $scope.messages = MessageFactory.getMessagesFromStorage();
    messages = $scope.messages;
    $scope.messageCount = messages.length;
    $scope.state = 'messages';
    $scope.openMessage = openMessage;
    $scope.isEnabled = false;
    $scope.setupView = setupView;
    $scope.trustAsHtml = trustAsHtml;
    /**
    * Trust this html style text
    * @memberof MessageCtrl
    * @param {string} body The body message
    */

    function trustAsHtml(body) {
      return $sce.trustAsHtml(body);
    }
    /**
    * Setup the message View
    * @memberof MessageCtrl
    * @param {boolean} isEnabled Show only unread messages
    */


    function setupView(isEnabled) {
      $scope.messages = $filter('messageFilter')(messages, isEnabled);
    }
    /**
     * View Selected message
     * @memberof MessageCtrl
     * @param {object} message The selected Message
     */


    function openMessage(message) {
      if (message.ReadDt == null) {
        MessageFactory.markReaden(message.Id);
        message.ReadDt = new Date();
      }
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.filter('messageFilter', messageFilter);
  /**
  * @memberof CabinReports
  * @ngdoc filter
  * @name messageFilter
  * @description 
  *   Filters messages in order to show only the unread.
  * @ngInject
  */

  function messageFilter() {
    return function (input, isEnable) {
      if (isEnable) {
        var result = [];

        for (var i = 0; i < input.length; i++) {
          if (input[i].ReadDt == null) {
            result.push(input[i]);
          }
        }

        return result;
      } else {
        return input;
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('MessageFactory', MessageFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name MessageFactory
  * @description 
  *   Add, Update, Delete and Get Messages.
  * @ngInject
  */

  function MessageFactory(GenericService) {
    /**
    * Initialize the Message
    * @memberof MessageFactory
    */
    function Message() {
      this.Id = null;
      this.Title = null;
      this.AuthorName = null;
      this.Body = null;
      this.AcType = null;
      this.AirportA = null;
      this.AirportB = null;
      this.Country = null;
      this.FlightDirection = null;
      this.FlightNo = null;
      this.ValidFrom = null;
      this.ValidTo = null;
      this.PositionCP = true;
      this.PositionFA = true;
      this.PositionFO = true;
      this.PositionSA = true;
      this.QueryType = null;
      this.ReadDt = null;
      this.Registration = null;
      this.FeedbackCause = null;
    }

    var objType = 'messages';
    var objCallback = Message;
    var service = {
      fromObjectList: fromObjectList,
      getMessagesFromStorage: getMessagesFromStorage,
      setMessagesToStorage: setMessagesToStorage,
      clearMessagesFromStorage: clearMessagesFromStorage,
      getCountOfUnreadMessages: getCountOfUnreadMessages,
      getMessagesFromIds: getMessagesFromIds,
      getUnreadMessages: getUnreadMessages,
      markReaden: markReaden,
      markReadAsSynched: markReadAsSynched,
      getUnsynchedReadMessages: getUnsynchedReadMessages,
      storeMessagesFromServer: storeMessagesFromServer
    };
    /**
     * Extend an array of Objects from the default message Object
     * @memberof MessageFactory
     * @param {Array} objList  an Array Of messages
     * @returns {Array} messages
     */

    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallback);
    }
    /**
     * Get messages
     * @memberof MessageFactory
     * @returns {Array} messages 
     */


    function getMessagesFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Save messages to storage
     * @memberof MessageFactory
     * @param {Array} messages A list of messages
     */


    function setMessagesToStorage(messages) {
      GenericService.saveAll(messages, objType, objCallback);
    }
    /**
     * Remove the messages of  the local storage
     * @memberof MessageFactory
     */


    function clearMessagesFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }
    /**
    * Get count of unread messages
    * @memberof MessageFactory
    * @returns {number} result 
    */


    function getCountOfUnreadMessages() {
      var messages = getMessagesFromStorage();
      if (!messages) return 0;
      var result = 0;
      var arrayLength = messages.length;

      for (var i = 0; i < arrayLength; i++) {
        if (!messages[i].ReadDt) {
          result++;
        }
      }

      return result;
    }
    /**
     * Get messages from given ids
     * @memberof MessageFactory
     * @param {Ids} List of Ids
     * @returns {Array} selectedMessages 
     */


    function getMessagesFromIds(Ids) {
      var messages = getMessagesFromStorage();
      var selectedMessages = [];

      if (Ids != undefined || Ids != null) {
        for (var i = 0; i < Ids.length; i++) {
          for (var j = 0; j < messages.length; j++) {
            if (Ids[i] == messages[j].Id) {
              selectedMessages.push(messages[j]);
              break;
            }
          }
        }
      }

      return selectedMessages;
    }
    /**
     * Get  unread messages
     * @memberof MessageFactory
     * @returns {Array} filteredMessages 
     */


    function getUnreadMessages() {
      var messages = getMessagesFromStorage();
      filteredMessages = [];

      for (var i = 0; i < messages.length; i++) {
        if (!messages[i].ReadDt == null) {
          filteredMessages.push(messages[i]);
        }
      }

      return filteredMessages;
    }
    /**
     * Mark the message as read and save it
     * @memberof MessageFactory
     * @param {string} messageId The message identifier
     */


    function markReaden(messageId) {
      // get the Message array from storage
      var messages = getMessagesFromStorage();
      if (messages == null) messages = []; // find the current Message from the array (if present)

      var arrayLength = messages.length;

      for (var i = 0; i < arrayLength; i++) {
        if (messages[i].Id == messageId) {
          messages[i].ReadDt = new Date();
          break;
        }
      }

      setMessagesToStorage(messages);
    }
    /**
     * Mark the messages as synched and save it
     * @memberof MessageFactory
     * @param {array} readMessages A list of synced messages
     */


    function markReadAsSynched(readMessages) {
      var messages = getMessagesFromStorage();

      if (readMessages && messages) {
        var id;

        for (var i = 0; i < readMessages.length; i++) {
          id = readMessages[i].Id;

          for (var x = 0; x < messages.length; x++) {
            if (messages[x].Id === id) {
              messages[x].Synched = true;
            }
          }
        }

        setMessagesToStorage(messages);
      }
    }
    /**
     * Get the messages that are unsynched and not read and save them
     * @memberof MessageFactory
     * @param {array} readMessages A list of synced messages
     */


    function getUnsynchedReadMessages() {
      var messages = getMessagesFromStorage();
      var data = fromObjectList(messages);
      var filtered = null;

      if (data && data.length > 0) {
        filtered = [];

        for (var i = 0; i < data.length; i++) {
          if (data[i].ReadDt && !data[i].Synched) {
            filtered.push({
              Id: data[i].Id,
              ReadDt: data[i].ReadDt
            });
          }
        }
      }

      return filtered;
    }
    /**
     * Store the messages from the sync api
     * @memberof MessageFactory
     * @param {array} readMessages A list of  messages
     */


    function storeMessagesFromServer(messages) {
      if (messages) {
        for (var i = 0; i < messages.length; i++) {
          messages[i].AuthorName = messages[i].AuthorName.replace("GATEWAY\\", "");
          messages[i].AuthorName = messages[i].AuthorName.replace(".", " "); //messages already saved as Read in the server, should not be send to the server again

          if (messages[i].ReadDt) messages[i].Synched = true;else messages[i].Synched = false;
        }
      }

      setMessagesToStorage(messages);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('MessageModalCtrl', MessageModalCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name MessageModalCtrl
  * @description 
  *  Manages the message Modal
  * @ngInject
  */

  function MessageModalCtrl($scope, message, $uibModalInstance, $sce) {
    $scope.message = message;
    $scope.cancel = cancel;
    $scope.messageBody = $sce.trustAsHtml(message.Body);
    /**
     * Close the modal
     * @memberof MemoModalCtrl
     */

    function cancel() {
      $uibModalInstance.close('close');
    }
  }
})();
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  'use strict';

  a3_cabin_reports.controller('PassengerMealsCtrl', PassengerMealsCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name PassengerMealsCtrl
  * @description 
  *  Manages the Meal Library View
  * @ngInject
  */

  function PassengerMealsCtrl($scope, $routeParams, PassengerMealServiceFactory, FlightMealCriteriaFactory, PaxMealEnums, mealCriteriaIsEnabled) {
    $scope.state = 'mealLibrary';
    $scope.selectedService = null;
    $scope.selectedCycle = null;
    $scope.filteredMeals = [];
    $scope.isAllCyclesSelected = false;
    $scope.areAllMealsOpen = false;
    $scope.filteredServices = [];
    $scope.mealServiceSearch = '';
    $scope.mealCriteriaIsEnabled = mealCriteriaIsEnabled;
    $scope.selectService = selectService;
    $scope.filterByCycle = filterByCycle;
    $scope.toggleAllMeals = toggleAllMeals;
    $scope.searchMeals = searchMeals;
    $scope.toggleSidePanel = toggleSidePanel;
    $scope.filterMealServices = filterMealServices; //extra filters using ancillaries

    $scope.ancillaries = PassengerMealServiceFactory.getPassengerMealServiceFromStorage();
    $scope.filterByMealCategory = filterByMealCategory;
    $scope.filterByFlightLeg = filterByFlightLeg;
    $scope.filterByCabinClass = filterByCabinClass;
    $scope.filterByServiceZones = filterByServiceZones;
    $scope.filterByMealClass = filterByMealClass;
    $scope.selectedMealCategoryId = null;
    $scope.selectedFlightLegId = null;
    $scope.selectedCabinClassId = null;
    $scope.selectedServiceZone = null;
    $scope.selectedMealClassId = null; //When user comes from flight info page with specific flightId

    var paramFlightId = $routeParams.flightId ? $routeParams.flightId : null;
    $scope.criteriaMealType = null;
    $scope.criteriaServiceZone = null;
    $scope.paramMealClassString = $routeParams.mealClass && $routeParams.mealClass !== 'undefined' ? $routeParams.mealClass : null;
    $scope.paramCabinClass = $routeParams.cabinClass && $routeParams.cabinClass !== 'undefined' ? $routeParams.cabinClass : null;
    $scope.paramSearchText = $routeParams.searchText && $routeParams.searchText !== 'undefined' ? $routeParams.searchText : '';
    var paramMealClass = null;

    if ($scope.paramMealClassString) {
      // Map string to enum value
      paramMealClass = PaxMealEnums.MealClass.GetValue($scope.paramMealClassString);
    }

    if ($scope.paramCabinClass) {
      $scope.selectedCabinClassId = PaxMealEnums.CabinClass.GetValue($scope.paramCabinClass);
    } // Pre-fill search if coming from flight info with searchText


    if ($scope.paramSearchText && $scope.paramSearchText.length >= 2) {
      $scope.mealServiceSearch = $scope.paramSearchText;
    }

    $scope.flightMealCriteria = null;
    $scope.preselectedRotation = null;

    if (paramFlightId) {
      $scope.flightMealCriteria = FlightMealCriteriaFactory.getMealCriteriaByFlightIdFromLS(paramFlightId);
    } // initialize in your controller


    $scope.isCriteriaVisible = true; // start expanded

    $scope.showCriteria = showCriteria;
    $scope.hideCriteria = hideCriteria;
    PassengerMealServiceFactory.getPassengerMealServicesFromStorage(function (results) {
      $scope.passengerMeals = results;

      if ($scope.passengerMeals.length > 0) {
        // Initially, show all services
        $scope.filteredServices = angular.copy($scope.passengerMeals);

        if ($scope.flightMealCriteria) {
          applyFlightMealCriteria($scope.flightMealCriteria);
        } else {
          // Default: select the first service if no criteria
          selectService($scope.passengerMeals[0]);
        }
      }
    }); // Apply flight meal criteria to pre-select filters and services

    function applyFlightMealCriteria(criteria) {
      //console.log('Applying flightMealCriteria:', criteria);
      var crit = Array.isArray(criteria) ? criteria[0] : criteria;
      if (!crit) return; // Meal Type → Meal Category Mapping

      $scope.criteriaMealType = crit.MealType || null;
      $scope.selectedMealCategoryId = PaxMealEnums.Category.GetValue(crit.MealType) || null; // Zone → Service Zone

      $scope.selectedServiceZone = crit.Zone || null;
      $scope.criteriaServiceZone = crit.Zone || null; // Store preselected rotation for later use

      $scope.preselectedRotation = crit.Rotation ? parseInt(crit.Rotation, 10) : null; // Get Meal class from redirect parameters

      $scope.selectedMealClassId = paramMealClass || null; // Filter Services Based on Zone + Meal Type

      applyFilters();

      if ($scope.paramSearchText && $scope.paramSearchText.length >= 2) {
        $scope.searchText = $scope.paramSearchText;
        searchMeals();
      }
    } // Select a service and reset cycles and meals


    function selectService(service) {
      $scope.selectedService = service; // Set the selected service

      $scope.isAllCyclesSelected = false; // Clear the search field when selecting a new service

      $scope.searchText = '';

      if (service.ServiceCycles && service.ServiceCycles.length > 0) {
        // If we have a preselected rotation, try to match it to a cycle
        if ($scope.preselectedRotation) {
          var rotationNum = $scope.preselectedRotation.toString();
          var matchedCycle = service.ServiceCycles.find(function (cycle) {
            var cycleNum = (cycle.CycleName || '').match(/\d+/);
            return cycleNum && cycleNum[0] === rotationNum;
          });

          if (matchedCycle) {
            console.log("Preselecting cycle for rotation ".concat(rotationNum));
            $scope.filterByCycle(matchedCycle);
            return;
          }
        } // Fallback: select first cycle if no match or no rotation set


        $scope.filterByCycle(service.ServiceCycles[0]);
      } else {
        $scope.selectedCycle = null;
        $scope.filteredMeals = [];
      }
    }

    ; // Filter meals by cycle when cycle radio button is selected

    function filterByCycle(cycle) {
      $scope.selectedCycle = cycle;
      $scope.isAllCyclesSelected = false; // Clear the search field

      $scope.searchText = '';
      $scope.filteredMeals = cycle.Meals.sort(function (a, b) {
        return a.MealName.localeCompare(b.MealName);
      });
    }

    ;

    function filterMealServices() {
      if ($scope.mealServiceSearch && $scope.mealServiceSearch.length >= 2) {
        $scope.filteredServices = $scope.passengerMeals.filter(function (service) {
          return service.ServiceName.toLowerCase().includes($scope.mealServiceSearch.toLowerCase());
        });
      } else {
        $scope.filteredServices = angular.copy($scope.passengerMeals);
      }
    }

    ; // Toggle opening/closing all meals

    function toggleAllMeals() {
      $scope.areAllMealsOpen = !$scope.areAllMealsOpen;
      $scope.filteredMeals.forEach(function (meal) {
        meal.isInfoVisible = $scope.areAllMealsOpen;
      });
    }

    ; // Search meals within the selected service or cycle

    function searchMeals() {
      if ($scope.searchText && $scope.searchText.length >= 2) {
        var searchTextLower = $scope.searchText.toLowerCase(); // If a specific cycle is selected, filter meals by that cycle

        if ($scope.selectedCycle) {
          $scope.filteredMeals = $scope.selectedCycle.Meals.map(function (meal) {
            var mealNameMatch = meal.MealName.toLowerCase().includes(searchTextLower); // Filter meal items that match search criteria

            var filteredMealItems = meal.MealItems.map(function (item) {
              var itemNameMatch = item.ItemName.toLowerCase().includes(searchTextLower);
              var allergenMatch = item.Allergen ? item.Allergen.toLowerCase().includes(searchTextLower) : false;
              var compositionMatch = item.Composition ? item.Composition.toLowerCase().includes(searchTextLower) : false;
              var matchFound = itemNameMatch || allergenMatch || compositionMatch;
              item.highlight = matchFound; // Highlight matched items

              return item;
            }).filter(function (item) {
              return item.highlight;
            }); // Return the meal if it or its items match the search

            if (mealNameMatch || filteredMealItems.length > 0) {
              return _objectSpread({}, meal, {
                MealItems: filteredMealItems,
                highlight: mealNameMatch
              });
            }

            return null;
          }).filter(function (meal) {
            return meal !== null;
          }); // If "All Cycles" is selected, filter meals from all cycles in the selected service
        } else if ($scope.isAllCyclesSelected && $scope.selectedService) {
          $scope.filteredMeals = $scope.selectedService.ServiceCycles.flatMap(function (cycle) {
            return cycle.Meals.map(function (meal) {
              var mealNameMatch = meal.MealName.toLowerCase().includes(searchTextLower);
              var filteredMealItems = meal.MealItems.map(function (item) {
                var itemNameMatch = item.ItemName.toLowerCase().includes(searchTextLower);
                var allergenMatch = item.Allergen ? item.Allergen.toLowerCase().includes(searchTextLower) : false;
                var compositionMatch = item.Composition ? item.Composition.toLowerCase().includes(searchTextLower) : false;
                var matchFound = itemNameMatch || allergenMatch || compositionMatch;
                item.highlight = matchFound;
                return item;
              }).filter(function (item) {
                return item.highlight;
              });

              if (mealNameMatch || filteredMealItems.length > 0) {
                return _objectSpread({}, meal, {
                  MealItems: filteredMealItems,
                  highlight: mealNameMatch
                });
              }

              return null;
            });
          }).filter(function (meal) {
            return meal !== null;
          }).sort(function (a, b) {
            return a.MealName.localeCompare(b.MealName);
          }); // Sort meals alphabetically
        } else {
          // If no cycle is selected, reset the meals (optional behavior if needed)
          $scope.filteredMeals = [];
        }
      } else {
        // If the search text is empty, show all meals for the selected cycle or all cycles
        if ($scope.selectedCycle) {
          $scope.filteredMeals = $scope.selectedCycle.Meals;
        } else if ($scope.isAllCyclesSelected) {
          $scope.filteredMeals = $scope.selectedService.ServiceCycles.flatMap(function (cycle) {
            return cycle.Meals;
          }).sort(function (a, b) {
            return a.MealName.localeCompare(b.MealName);
          }); // Sort meals alphabetically
        } else {
          $scope.filteredMeals = [];
        }
      }
    }

    function filterByMealCategory(category) {
      if ($scope.selectedMealCategoryId == category.id) {
        $scope.selectedMealCategoryId = null;
      } else {
        $scope.selectedMealCategoryId = category.id;
      }

      ;
      applyFilters();
    }

    function filterByFlightLeg(mealClass) {
      if ($scope.selectedFlightLegId == mealClass.id) {
        $scope.selectedFlightLegId = null;
      } else {
        $scope.selectedFlightLegId = mealClass.id;
      }

      ;
      applyFilters();
    }

    function filterByCabinClass(cabinClass) {
      if ($scope.selectedCabinClassId == cabinClass.id) {
        $scope.selectedCabinClassId = null;
      } else {
        $scope.selectedCabinClassId = cabinClass.id;
      }

      ;
      applyFilters();
    }

    function filterByServiceZones(serviceZone) {
      if ($scope.selectedServiceZone == serviceZone) {
        $scope.selectedServiceZone = null;
      } else {
        $scope.selectedServiceZone = serviceZone;
      }

      ;
      applyFilters();
    }

    function filterByMealClass(mealClass) {
      if ($scope.selectedMealClassId == mealClass.id) {
        $scope.selectedMealClassId = null;
      } else {
        $scope.selectedMealClassId = mealClass.id;
      }

      ;
      applyFilters();
    }

    function applyFilters() {
      $scope.filteredServices = $scope.passengerMeals.filter(function (service) {
        var matchesCategory = !$scope.selectedMealCategoryId || service.MealCategory && (service.MealCategory === $scope.selectedMealCategoryId || service.MealCategory === PaxMealEnums.Category.GetValue('Both'));
        var matchesMealClass = !$scope.selectedMealClassId || service.MealClass && service.MealClass === $scope.selectedMealClassId;
        var matchesFlightLeg = !$scope.selectedFlightLegId || service.FlightLeg && (service.FlightLeg === $scope.selectedFlightLegId || service.FlightLeg === PaxMealEnums.FlightLeg.GetValue('Both'));
        var matchesCabinClass = !$scope.selectedCabinClassId || service.CabinClass && service.CabinClass === $scope.selectedCabinClassId;
        var matchesServiceZone = !$scope.selectedServiceZone || service.ServiceZone && service.ServiceZone === $scope.selectedServiceZone;
        return matchesCategory && matchesMealClass && matchesFlightLeg && matchesCabinClass && matchesServiceZone;
      });
    } // Toggle visibility of meal details


    $scope.toggleVisibility = function (meal) {
      meal.isInfoVisible = !meal.isInfoVisible;
    };

    function toggleSidePanel() {
      $scope.shownSideMenu = !$scope.shownSideMenu;
    }

    function showCriteria() {
      $scope.isCriteriaVisible = true;
    }

    ;

    function hideCriteria() {
      $scope.isCriteriaVisible = false;
    }

    ;
  }
})();
"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  'use strict';

  a3_cabin_reports.factory('PassengerMealServiceFactory', PassengerMealServiceFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name PassengerMealServiceFactory
   * @description 
   *   Add, Update, Delete and Get Passenger meals allergen info.
   * @ngInject
   */

  function PassengerMealServiceFactory(IndexedDBService, GenericService) {
    /**
     * Initialize MealAllergen
     * @memberof PassengerMealServiceFactory
     */
    function PassengerMealService() {
      this.Id = null;
    }

    var objType = 'PassengerMealServices';
    var objCallback = PassengerMealService;
    var ancillariesObjType = 'PassengerMealAncillaries';
    var ancillariesObjCallback = PassengerMealAncillaries;

    function PassengerMealAncillaries() {
      this.AllMealCategories = [];
      this.AllMealClasses = [];
      this.AllFlightLegs = [];
      this.AllCabinClasses = [];
      this.AllZones = [];
    }

    var service = _defineProperty({
      setPassengerMealsServicesToStorage: setPassengerMealsServicesToStorage,
      getPassengerMealServicesFromStorage: getPassengerMealServicesFromStorage,
      getPassengerMealServiceFromStorage: getPassengerMealServiceFromStorage,
      checkAndsetPassengerMealsServicesToStorage: checkAndsetPassengerMealsServicesToStorage,
      setPassengerMealsAncillariesToStorage: setPassengerMealsAncillariesToStorage
    }, "getPassengerMealServicesFromStorage", getPassengerMealServicesFromStorage);
    /**
     * Get all passenger meal services
     * @memberof PassengerMealServiceFactory
     * @param {function} callback  
     */


    function getPassengerMealServicesFromStorage(callback) {
      IndexedDBService.getAll(objType).then(function (results) {
        callback(results);
      });
    }

    ;

    function checkAndsetPassengerMealsServicesToStorage(callback) {
      // Check if callback is null or undefined
      if (!callback || callback.length === 0) {
        return; // Exit the function if callback is null
      }

      IndexedDBService.getAll(objType).then(function (results) {
        // Handle cases where results are null or undefined
        if (!results || results.length === 0) {
          setPassengerMealsServicesToStorage(callback);
        } else {
          // Filter out any undefined or null entries in the results array
          var validResults = results.filter(function (service) {
            return service && service.UpdatedDate;
          }); // Check if validResults contains any valid services

          if (validResults.length > 0) {
            var storedLatestService = validResults.reduce(function (latest, current) {
              return new Date(latest.UpdatedDate) > new Date(current.UpdatedDate) ? latest : current;
            });
            var firstNewService = callback[0]; // Compare the dates

            var storedUpdatedDate = new Date(storedLatestService.UpdatedDate);
            var newUpdatedDate = new Date(firstNewService.UpdatedDate);

            if (newUpdatedDate > storedUpdatedDate) {
              IndexedDBService.removeAll(objType).then(function () {
                setPassengerMealsServicesToStorage(callback);
              });
            }
          } else {
            // If all entries are invalid, remove all entries from IndexedDB
            IndexedDBService.removeAll(objType).then(function () {
              setPassengerMealsServicesToStorage(callback);
            });
          }
        }
      });
    }

    function setPassengerMealsServicesToStorage(callback) {
      IndexedDBService.addAll(objType, callback);
    }

    ;
    /**
    * Get passenger meal service By Id
    * @memberof PassengerMealServiceFactory
    * @param {function} callback  
    */

    function getPassengerMealServiceFromStorage(serviceId, callback, errorCallback) {
      IndexedDBService.getById(objType, serviceId).then(function (result) {
        callback(result);
      })["catch"](errorCallback);
    }

    ;
    /**
     * Set passenger meal services to storage
     * @memberof PassengerMealServiceFactory
     * @param {Array} services - Array of PassengerMealService objects
     */

    function setPassengerMealsAncillariesToStorage(ancillariesFromSync) {
      GenericService.saveOne(ancillariesFromSync, ancillariesObjType, ancillariesObjCallback);
    }
    /**        
     * Get passenger meal ancillaries from storage
     * @memberof PassengerMealServiceFactory
     * @returns {Promise} Promise resolving to PassengerMealAncillaries object
     */


    function getPassengerMealServiceFromStorage() {
      return GenericService.getOne(ancillariesObjType, ancillariesObjCallback);
    }

    return service;
  }
})();
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

(function () {
  'use strict';

  a3_cabin_reports.constant('PaxMealEnums', function () {
    // === Utility to create enum objects with helpers ===
    function createEnum(items) {
      return Object.assign(_toConsumableArray(items), {
        GetValue: function GetValue(title) {
          var found = this.find(function (e) {
            return e.title === title;
          });
          return found ? found.value : null;
        },
        GetTitle: function GetTitle(value) {
          var found = this.find(function (e) {
            return e.value === value;
          });
          return found ? found.title : null;
        },
        GetDescription: function GetDescription(value) {
          var found = this.find(function (e) {
            return e.value === value;
          });
          return found ? found.description : null;
        }
      });
    } // === Enum definitions ===


    var Category = createEnum([{
      title: "Unknown",
      description: "Unknown",
      value: 0
    }, {
      title: "Other",
      description: "Other",
      value: 1
    }, {
      title: "Breakfast",
      description: "Breakfast",
      value: 2
    }, {
      title: "Meal",
      description: "Meal",
      value: 3
    }, {
      title: "Both",
      description: "Both",
      value: 4
    }]);
    var FlightLeg = createEnum([{
      title: "Unknown",
      description: "Unknown",
      value: 0
    }, {
      title: "Both",
      description: "Both",
      value: 1
    }, {
      title: "GO",
      description: "Go",
      value: 2
    }, {
      title: "RET",
      description: "Return",
      value: 3
    }]);
    var CabinClass = createEnum([{
      title: "Unknown",
      description: "Unknown",
      value: 0
    }, {
      title: "Uncategorized",
      description: "Uncategorized",
      value: 1
    }, {
      title: "BC",
      description: "Business Class",
      value: 2
    }, {
      title: "YC",
      description: "Economy Class",
      value: 3
    }]);
    var MealClass = createEnum([{
      title: "Unknown",
      description: "Unknown",
      value: 0
    }, {
      title: "OTHER",
      description: "Other",
      value: 1
    }, {
      title: "CREW",
      description: "Crew",
      value: 2
    }, {
      title: "BC SPML",
      description: "Business Class Special Meal",
      value: 3
    }, {
      title: "BC MEAL",
      description: "Business Class Standard Meal",
      value: 4
    }, {
      title: "YC SPML",
      description: "Economy Class Special Meal",
      value: 5
    }, {
      title: "YC MEAL",
      description: "Economy Class Standard Meal",
      value: 6
    }, {
      title: "SALES & SERVICE GOODS",
      description: "Sales & Service Goods",
      value: 7
    }]); // === Export all enums ===

    return {
      Category: Category,
      FlightLeg: FlightLeg,
      CabinClass: CabinClass,
      MealClass: MealClass
    };
  }());
})();
"use strict";

(function () {
  "use strict";

  a3_cabin_reports.controller("PassengerCtrl", PassengerCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name PassengerCtrl
   * @description
   *  Manages the passenger information view
   * @ngInject
   */

  function PassengerCtrl(passenger, flightId, report, paxInfo, LuggageComplianceFactory, CampaignFactory, $scope, $uibModalInstance, $timeout, FlightFactory, CabinReportLocalEditFactory, CabinReportLocalEditCreatorFactory, UserFactory, WifiVouchersFactory, WifiAvailabilityFactory, SettingsMain, MisconnectionFlightsFactory, defaultCalendarDate) {
    $scope.ReportIsFinal = false;
    var flight = FlightFactory.getFlightFromStorage(flightId);
    $scope.flight = flight;
    var user = UserFactory.getUser();
    var report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);
    if (isInFinalState(flight)) $scope.ReportIsFinal = true;
    $scope.closeModal = closeModal;
    $scope.passenger = passenger;
    $scope.modalInstance = $uibModalInstance;
    $scope.getFqtvTierDescription = getFqtvTierDescription;
    initPassengerConnectionInfo(); //upgrade passenger

    $scope.ugradePassenger = {
      showUpgradeInput: false,
      showUpgradeWarning: false,
      showUpgradeError: false,
      showSuccess: false,
      upgradedSeatNo: "",
      successMessage: "",
      upgradeRemarks: ""
    };
    $scope.submitUpgrade = submitUpgrade;
    $scope.saveUpgrade = saveUpgrade;
    $scope.undo = undo; //wifi scopes:

    var wifiAvailability = WifiAvailabilityFactory.getRegistrationsFromStorage();

    if (wifiAvailability) {
      $scope.supportsWifi = wifiAvailability.registrations.includes(flight.AcTailNo);
    } else {
      $scope.supportsWifi = false;
    }

    $scope.retrieveWifiVouchers = retrieveWifiVouchers;
    $scope.showPanel = "";
    $scope.notRetrieved = true;
    $scope.createTextVoucher = createTextVoucher;
    $scope.createStreamVoucher = createStreamVoucher; //Seat Change

    if (passenger.ChangedSeat) {
      $scope.passenger.IsSeatChanged = true;
    } else {
      $scope.passenger.IsSeatChanged = false;
    }

    $scope.changeSeatFormData = {
      changedSeatNo: "",
      seatChangeRemarks: "",
      showSeatChangeInput: false
    };
    $scope.showSeatChangeWarning = false;
    /**
     * Returns a display value for Platinum when older payloads do not include a description.
     * @memberof PassengerCtrl
     * @param {object} fqtv The passenger FQTV information
     * @returns {string} The tier description shown in Passenger Details
     */

    function getFqtvTierDescription(fqtv) {
      if (!fqtv) {
        return "";
      }

      if (fqtv.TierDescription) {
        return fqtv.TierDescription;
      } // Platinum may arrive as a tier code only until all upstream payloads include its description.


      if (fqtv.TierLevel == "PLTM") {
        return "Platinum";
      }

      return "";
    }

    $scope.showSeatChangeError = false;
    $scope.showSeatChangeSuccess = false;
    $scope.successSeatChangeMessage = "";
    $scope.submitSeatChange = submitSeatChange;
    $scope.undoSeatChange = undoSeatChange;
    $scope.saveSeatChange = saveSeatChange;
    $scope.closeChangeWarning = closeChangeWarning;
    $scope.linkedPassengersGroup = [];
    $scope.IsOld = IsOld;
    $scope.giftStatus = CampaignFactory.giftStatusList();
    $scope.isFeedbackUpdated = false;
    $scope.submitCampaignFeedback = submitCampaignFeedback;
    $scope.hideFooter = true;
    $scope.showOneStopShop = false;
    $scope.showShopInTheCloudTab = false;
    $scope.orderAvailability = orderAvailability;
    $scope.toggleFooter = toggleFooter;
    $scope.treatmentAvailability = treatmentAvailability; // Cabin Luggage Report

    $scope.saEligibility = flight.LineStatus != "na";
    $scope.flightCompliant = LuggageComplianceFactory.getFlightCompliantStatus(flightId);
    $scope.updateCabinLuggageReport = updateCabinLuggageReport;
    var luggageReport = LuggageComplianceFactory.getPassengerLuggageCompliance(flightId, $scope.passenger.UCI);
    $scope.passenger.luggageCompliance = {
      hasTwoLuggage: luggageReport != null,
      isSynced: luggageReport && luggageReport.isSynced
    };
    getlinkedPassengers();
    orderAvailability(passenger.FlightOrders ? passenger.FlightOrders.length : 0);

    function toggleFooter(hide) {
      $scope.hideFooter = hide;
    }
    /**
     * Gets called when user hits submit. Checks input then saves it
     * @memberof PassengerCtrl
     */


    function submitUpgrade() {
      $scope.ugradePassenger.showUpgradeWarning = false;
      $scope.ugradePassenger.showUpgradeError = false;

      if (!isSeatAvailableForUpgrate()) {
        return;
      }

      saveUpgrade();
    }
    /**
     * Gets called when input is ready
     * @memberof PassengerCtrl
     */


    function saveUpgrade() {
      $scope.ugradePassenger.showUpgradeWarning = false;
      $scope.ugradePassenger.showUpgradeError = false;
      updateReport();
    }
    /**
     * Checks if report is finalized
     * @memberof PassengerCtrl
     */


    function isInFinalState(flight) {
      var isInFinalState = flight.LineStatus === "na" || flight.LineStatus === "stored" || flight.LineStatus === "storedotheruser" || flight.LineStatus === "stored+otheruser" || flight.LineStatus === "synched" || flight.LineStatus === "synchedotheruser";
      return isInFinalState;
    }
    /**
     * fix any input into 000A format
     * @memberof PassengerCtrl
     */


    function formatSeatInput() {
      var missingZeroes = 4 - $scope.ugradePassenger.upgradedSeatNo.length;

      for (var i = 0; i < missingZeroes; i++) {
        $scope.ugradePassenger.upgradedSeatNo = "0" + $scope.ugradePassenger.upgradedSeatNo;
      }
    }
    /**
     * Puts the new seat upgrade in the report
     * @memberof PassengerCtrl
     */


    function updateReport() {
      var upgradedPassenger = {
        PNR: $scope.passenger.PNR,
        UCI: $scope.passenger.UCI,
        OriginalSeatNo: $scope.passenger.SeatNo,
        UpgradedSeatNo: $scope.ugradePassenger.upgradedSeatNo,
        Remarks: $scope.ugradePassenger.upgradeRemarks
      };

      if (report) {
        report.UpgradedPassengers.push(upgradedPassenger);
      } else {
        report = CabinReportLocalEditCreatorFactory.createNewLocalReportForFlight(flightId);
        report.UpgradedPassengers.push(upgradedPassenger);
        report.Status = "draft";
        report.saveReport();
        FlightFactory.updateFlightFromReport(report);
      }

      CabinReportLocalEditFactory.setCabinReportToStorage(report);
      $scope.passenger.UpgradedToSeat = upgradedPassenger;
      $scope.ugradePassenger.showSuccess = true;
      $scope.ugradePassenger.successMessage = "Upgrade submitted successfully!";
      $timeout(function () {
        $scope.ugradePassenger.showSuccess = false;
      }, 3500);
    }
    /**
     * Fills up the linked Passengers list.
     * @memberof PassengerCtrl
     */


    function getlinkedPassengers() {
      if (paxInfo && passenger.UCI) {
        for (var i = 0; i < paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
            if (passenger.LinkedPassengers && passenger.LinkedPassengers.includes(paxInfo.Seatmap[i].Columns[j].UCI)) {
              $scope.linkedPassengersGroup.push(paxInfo.Seatmap[i].Columns[j].SeatNo);
            }

            if (passenger.LinkedPassengersWithProductId && passenger.LinkedPassengersWithProductId.includes(paxInfo.Seatmap[i].Columns[j].ProductId)) {
              $scope.linkedPassengersGroup.push(paxInfo.Seatmap[i].Columns[j].SeatNo);
            }
          }
        }
      }
    }
    /**
     * Removes upgrade from report
     * @memberof PassengerCtrl
     */


    function undo() {
      if (report) {
        report.UpgradedPassengers = report.UpgradedPassengers.filter(function (p) {
          return p.OriginalSeatNo != passenger.SeatNo && p.UCI != passenger.UCI;
        });
        report.saveReport();
        FlightFactory.updateFlightFromReport(report);
        CabinReportLocalEditFactory.setCabinReportToStorage(report);
      }

      $scope.passenger.UpgradedToSeat = false;
      $scope.ugradePassenger.showSuccess = true;
      $scope.ugradePassenger.successMessage = "Upgrade removed successfuly!";
      $timeout(function () {
        $scope.ugradePassenger.showSuccess = false;
      }, 3500);
      $scope.ugradePassenger.showUpgradeInput = false;
    }
    /**
     * Checks if the seat is available and fires warnings or errors
     * @memberof PassengerCtrl
     * @param {string} seat The seat number
     * @return {boolean} isSeatAvailableForUpgrate
     */


    function isSeatAvailableForUpgrate() {
      $scope.ugradePassenger.upgradedSeatNo = $scope.ugradePassenger.upgradedSeatNo.toUpperCase();
      formatSeatInput();

      if (paxInfo) {
        for (var i = 0; i < paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
            if (paxInfo.Seatmap[i].Columns[j].SeatNo == $scope.ugradePassenger.upgradedSeatNo) {
              if (paxInfo.Seatmap[i].Columns[j].IsEmptySeat) {
                return true;
              }

              $scope.ugradePassenger.showUpgradeWarning = true;
              return false;
            }
          }
        }
      } //not found in seatmap


      $scope.showSeatChangeError = true;
      $scope.ugradePassenger.upgradedSeatNo = "";
      return false;
    } // Seat Change

    /**
     * Checks if the seat is available and fires warnings or errors
     * @memberof PassengerCtrl
     * @param {string} seat The seat number
     * @return {boolean} isSeatAvailableForChange
     */


    function isSeatAvailableForChange() {
      /** fix any input into 000A format */
      var missingZeroes = 4 - $scope.changeSeatFormData.changedSeatNo.length;

      for (var i = 0; i < missingZeroes; i++) {
        $scope.changeSeatFormData.changedSeatNo = "0" + $scope.changeSeatFormData.changedSeatNo;
      }

      $scope.changeSeatFormData.changedSeatNo = $scope.changeSeatFormData.changedSeatNo.toUpperCase();

      if (paxInfo) {
        for (var i = 0; i < paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
            if (paxInfo.Seatmap[i].Columns[j].SeatNo == $scope.changeSeatFormData.changedSeatNo) {
              if (paxInfo.Seatmap[i].Columns[j].IsEmptySeat && !IsAlreadyGivenSeat($scope.changeSeatFormData.changedSeatNo)) {
                return true;
              } else {
                $scope.showSeatChangeWarning = true;
                return false;
              }
            }
          }
        }
      } //not found in seatmap


      $scope.showSeatChangeError = true;
      $timeout(function () {
        $scope.showSeatChangeError = false;
        $scope.changeSeatFormData.changedSeatNo = "";
      }, 3500);
      return false;
    }

    function IsAlreadyGivenSeat(newSeatNo) {
      return report.ChangedSeats.some(function (item) {
        return item.NewSeatNo == newSeatNo;
      });
    }
    /**
     * Gets called when user hits submit. Checks input then saves it
     * @memberof PassengerCtrl
     */


    function submitSeatChange() {
      $scope.showSeatChangeWarning = false;
      $scope.showSeatChangeError = false;

      if (!isSeatAvailableForChange()) {
        return;
      }

      saveSeatChange();
    }

    function closeChangeWarning() {
      $scope.changeSeatFormData.showSeatChangeInput = !$scope.changeSeatFormData.showSeatChangeInput;
      $scope.showSeatChangeWarning = false;
      $scope.showSeatChangeError = false;
    }
    /**
     * Gets called when input is ready
     * @memberof PassengerCtrl
     */


    function saveSeatChange() {
      $scope.showSeatChangeWarning = false;
      $scope.showSeatChangeError = false;
      updateReportForSeatChange();
    }
    /**
     * Puts the new seat change in the report
     * @memberof PassengerCtrl
     */


    function updateReportForSeatChange() {
      var changedSeat = {
        Name: $scope.passenger.Fullname,
        PNR: $scope.passenger.PNR,
        UCI: $scope.passenger.UCI,
        OriginalSeatNo: $scope.passenger.SeatNo,
        NewSeatNo: $scope.changeSeatFormData.changedSeatNo,
        Remarks: $scope.changeSeatFormData.seatChangeRemarks
      };

      if (report) {
        report.ChangedSeats.push(changedSeat);
      } else {
        report = CabinReportLocalEditCreatorFactory.createNewLocalReportForFlight(flightId);
        report.ChangedSeats.push(changedSeat);
        report.Status = "draft";
        report.saveReport();
        FlightFactory.updateFlightFromReport(report);
      }

      CabinReportLocalEditFactory.setCabinReportToStorage(report);
      $scope.passenger.ChangedSeat = changedSeat;
      $scope.passenger.IsSeatChanged = true;
      $scope.showSeatChangeSuccess = true;
      $scope.successSeatChangeMessage = "Seat change submitted successfully!";
      $timeout(function () {
        $scope.showSeatChangeSuccess = false;
      }, 3500);
    }
    /**
     * Removes seat change from report
     * @memberof PassengerCtrl
     */


    function undoSeatChange() {
      if (report) {
        report.ChangedSeats = report.ChangedSeats.filter(function (p) {
          return p.OriginalSeatNo != passenger.SeatNo && p.UCI != passenger.UCI;
        });
        report.saveReport();
        FlightFactory.updateFlightFromReport(report);
        CabinReportLocalEditFactory.setCabinReportToStorage(report);
      }

      $scope.passenger.ChangedSeat = null; // ?

      $scope.passenger.IsSeatChanged = false;
      $scope.showSeatChangeSuccess = true;
      $scope.successSeatChangeMessage = "Seat change removed successfuly!";
      $scope.changeSeatFormData.showSeatChangeInput = false;
      $timeout(function () {
        $scope.showSeatChangeSuccess = false;
      }, 3500);
    }
    /**
     * Checks if the data are new
     * @memberof PassengerCtrl
     * @param {string} time timestamp
     * @return {boolean} IsOld
     */


    function IsOld(time) {
      IsOld = false;

      if (time) {
        var now = new Date();
        var timeDate = new Date(time);
        var diff = now.getTime() - timeDate.getTime();

        if (diff > 3600000) {
          IsOld = true;
        }
      }

      return IsOld;
    }
    /**
     * Add or remove passenger from the Cabin Luggage Compliance Report
     * */


    function updateCabinLuggageReport() {
      var cabinLuggageReport = {
        isChecked: $scope.passenger.luggageCompliance.hasTwoLuggage,
        PNR: $scope.passenger.PNR,
        UCI: $scope.passenger.UCI,
        FlightId: $scope.flight.FlightId,
        FareFamily: $scope.passenger.FareFamily,
        IsFlightCompliant: false,
        Created: moment()
      };
      LuggageComplianceFactory.setLuggageComplianceToStorage(cabinLuggageReport);
    }
    /**
     * Close the modal
     * @memberof PassengerCtrl
     */


    function closeModal() {
      $uibModalInstance.dismiss("");
    }
    /**
     * Close the modal
     * @memberof PassengerCtrl
     */


    function submitCampaignFeedback() {
      $scope.passenger.Campaign.assignment.Status = +$scope.passenger.Campaign.assignment.StatusStr;
      CampaignFactory.updateCampaignPassenger(+flightId, $scope.passenger.Campaign.assignment);
      $scope.isFeedbackUpdated = true;
      $timeout(function () {
        $scope.isFeedbackUpdated = false;
      }, 3500);
    }
    /**
     * Manages OneStopShop tab visibility
     * Gets called if there are OneStopShop treatments available for this passenger
     */


    function treatmentAvailability(counter) {
      if (user.position == "SA") {
        $scope.ossCounter = counter;
        $scope.showOneStopShop = true;
      }
    }
    /**
     * Manages ShopInTheCloud tab visibility
     * Gets called if there are orders available for this passenger and also checks if a pending report exists
     */


    function orderAvailability(counter) {
      if (!counter) {
        counter = 0;
      }

      var isShopInTheCloudEnable = SettingsMain.getIsShopInTheCloudEnable();

      if (isShopInTheCloudEnable && flight.LineStatus != "na" && flight.LineStatus != "stored") {
        $scope.ordersCounter = counter;
        $scope.showShopInTheCloudTab = true;
      }
    }
    /**
     * Retrieve wifi vouchers
     * @memberof PassengerCtrl
     */


    function retrieveWifiVouchers(pnr) {
      $scope.showPanel = "loading";
      var RequestWifiVouchers = {
        PNR: pnr,
        FlightId: $scope.flight.FlightId,
        FlightDate: passenger.STDLocal
      };
      WifiVouchersFactory.retrieveWifiVouchers(RequestWifiVouchers).then(function (res) {
        return retrieveHandleSubmitResponse(res);
      });
    }

    function retrieveHandleSubmitResponse(res) {
      $scope.newVoucherCode = false;
      handleSubmitResponse(res);
    }
    /**
     * Create wifi voucher - "Text and surf"
     * @memberof PassengerCtrl
     */


    function createTextVoucher() {
      $scope.showPanel = "loading";
      var RequestCreateVoucher = {
        PNR: passenger.PNR,
        FlightId: $scope.flight.FlightId,
        FlightNumber: $scope.flight.FlightNo,
        FullName: passenger.Fullname,
        PlanId: "2902",
        FlightDate: passenger.STDLocal
      };
      WifiVouchersFactory.createWifiVoucher(RequestCreateVoucher).then(function (res) {
        return createHandleSubmitResponse(res);
      });
    }
    /**
     * Create wifi voucher - "Stream"
     * @memberof PassengerCtrl
     */


    function createStreamVoucher(params) {
      $scope.showPanel = "loading";
      var RequestCreateVoucher = {
        PNR: passenger.PNR,
        FlightId: $scope.flight.FlightId,
        FlightNumber: $scope.flight.FlightNo,
        FullName: passenger.Fullname,
        PlanId: "2904",
        FlightDate: passenger.STDLocal
      };
      WifiVouchersFactory.createWifiVoucher(RequestCreateVoucher).then(function (res) {
        return createHandleSubmitResponse(res);
      });
    }

    function createHandleSubmitResponse(res) {
      $scope.newVoucherCode = true;
      handleSubmitResponse(res);
    }

    function handleSubmitResponse(res) {
      if (res.success) {
        if ($scope.newVoucherCode == false) {
          $scope.textAndSurfCodes = [];
          $scope.streamCodes = [];
          $scope.newVouchers = [];
        } else {
          $scope.newVouchers = res.data;
        }

        $scope.notRetrieved = false;
        manageResponseMessage("success", res.message);
        $scope.wifiVouchersCodes = res.data;
        $scope.wifiVouchersCodes.forEach(function (code) {
          if (code.Type == "Text & Surf") {
            $scope.textAndSurfCodes.push(code.VoucherCode);
          }
        });
        $scope.wifiVouchersCodes.forEach(function (code) {
          if (code.Type == "Stream") {
            $scope.streamCodes.push(code.VoucherCode);
          }
        });
      } else {
        $scope.newVoucherCode = false;
        manageResponseMessage("failure", res.message);
      }
    }
    /**
     * Manage message alerts
     * @param {string} panelToShow
     * @param {string} message
     */


    function manageResponseMessage(panelToShow, message) {
      $scope.submitMessage = message;
      $scope.showPanel = panelToShow;
    }
    /**
     * Initializes Passenger Connection Info using local misconnection data (per passenger).
     * It builds passenger.ConnectionLegs for the modal UI.
     */


    function initPassengerConnectionInfo() {
      try {
        if (!$scope.passenger || !$scope.passenger.UCI) {
          return;
        }

        var uci = $scope.passenger.UCI;
        var misconnectionFlightId = getMisconnectionFlightId(); // 1) Get misconnection flights for this disrupted flight from local storage

        var misconnectionFlights = MisconnectionFlightsFactory.getMisconnectionFlightsByFlightIdFromLS(misconnectionFlightId) || [];

        if (!misconnectionFlights.length) {
          return;
        } // 2) Find FlightConnectionPassenger that matches this UCI


        var passengerConnection = null;
        misconnectionFlights.forEach(function (result) {
          if (result.Passengers && result.Passengers.length) {
            result.Passengers.forEach(function (passenger) {
              if (passenger.UCI === uci && passenger.Actions && passenger.Actions.length) {
                // For now: first match wins
                passengerConnection = passenger;
              }
            });
          }
        });

        if (!passengerConnection) {
          return;
        } // 3) Build UI legs + showReprotection flag from passenger actions


        var connectionInfo = buildConnectionLegsFromActions(passengerConnection.Actions);

        if (connectionInfo && connectionInfo.legs && connectionInfo.legs.length) {
          $scope.passenger.ConnectionLegs = connectionInfo.legs;
          $scope.passenger.ShowReprotection = connectionInfo.showReprotection;
        }
      } catch (e) {
        console.error("Error initializing Passenger Connection Info", e);
      }
    }

    function getMisconnectionFlightId() {
      // Use the original flightId as base
      var misconnectionFlightId = flightId;

      if (defaultCalendarDate && misconnectionFlightId === "1226541") {
        misconnectionFlightId = 2242084;
      }

      return misconnectionFlightId;
    }
    /**
     * Returns true if reprotection is considered "new" for UI,
     * following the same rule as PaxCtrl coloring:
     * - RED / ShowReprotection = reprotection decided within 60 minutes before STD
     */


    function isNewReprotection(action) {
      //  return true; //only for the tests
      if (!action || !action.HasReprotectedAction || !action.STD || !action.ActionTimestamp) {
        return false;
      }

      var std = new Date(flight.ScheduledDeparture);
      var ts = new Date(action.ActionTimestamp);

      if (isNaN(std.getTime()) || isNaN(ts.getTime())) {
        // If dates are invalid, we do not treat it as a valid reprotection
        return false;
      }

      var diffMinutes = (std.getTime() - ts.getTime()) / 60000; // Same rule με PaxCtrl hasReprotection (RED):
      // "new" reprotection = from this point and closer than 60' to STD

      return diffMinutes <= 60;
    }
    /**
     * Builds an ordered list of connection legs (original + final reprotection).
     * Filters out late reprotections and maps actions into clean UI leg objects.
     * Returns only the missed flight (A) and the final valid journey (C).
     */


    function buildConnectionLegsFromActions(passengerActions) {
      if (!passengerActions || !passengerActions.length) {
        return {
          legs: [],
          showReprotection: false
        };
      } // 1) Order actions in journey order (A -> B -> C ...)


      var orderedActions = passengerActions.slice().sort(function (a, b) {
        return (a.FlightOccurrenceOrder || 0) - (b.FlightOccurrenceOrder || 0);
      }); // 2) Original flight: first non-reprotected action, fallback = first

      var originalFlightAction = orderedActions.find(function (a) {
        return !a.HasReprotectedAction;
      }) || orderedActions[0]; // 3) Valid reprotections: reprotected AND not "late"

      var validReprotectionActions = orderedActions.filter(function (action) {
        return isNewReprotection(action);
      });
      var hasValidReprotection = validReprotectionActions.length > 0; // ===== Case 1: there is a valid reprotection (A + final C journey) =====

      if (hasValidReprotection) {
        var latestWaveTimestamp = null;
        validReprotectionActions.forEach(function (action) {
          var ts = action.ActionTimestamp ? new Date(action.ActionTimestamp).getTime() : action.STD ? new Date(action.STD).getTime() : 0;

          if (latestWaveTimestamp === null || ts > latestWaveTimestamp) {
            latestWaveTimestamp = ts;
          }
        }); // Final reprotection journey (C): only actions from the last wave

        var finalReprotectionActions = validReprotectionActions.filter(function (action) {
          var ts = action.ActionTimestamp ? new Date(action.ActionTimestamp).getTime() : action.STD ? new Date(action.STD).getTime() : 0;
          return ts === latestWaveTimestamp;
        }); // Sort final journey in correct leg order

        finalReprotectionActions.sort(function (l, r) {
          return (l.FlightOccurrenceOrder || 0) - (r.FlightOccurrenceOrder || 0);
        }); // Avoid showing the same flight twice

        finalReprotectionActions = finalReprotectionActions.filter(function (action) {
          return !isSameConnectionLeg(action, originalFlightAction);
        });
        var legsWithReprot = [];

        if (originalFlightAction) {
          legsWithReprot.push(mapActionToLeg(originalFlightAction, false, // isNewFlight
          true // isOriginalMissed
          ));
        }

        finalReprotectionActions.forEach(function (action) {
          legsWithReprot.push(mapActionToLeg(action, true, // isNewFlight
          false // isOriginalMissed
          ));
        });
        markNextDayFlags(legsWithReprot);
        return {
          legs: legsWithReprot,
          showReprotection: true
        };
      } // ===== Case 2: no valid reprotection -> escort / normal connection =====


      var targetAction = orderedActions.find(function (a) {
        return a.FlightOccurrenceOrder === 1;
      }) || orderedActions[1] || orderedActions[0];
      var legsWithoutReprot = [];

      if (targetAction) {
        legsWithoutReprot.push(mapActionToLeg(targetAction, false, // isNewFlight
        false // isOriginalMissed
        ));
      }

      markNextDayFlags(legsWithoutReprot);
      return {
        legs: legsWithoutReprot,
        showReprotection: false
      };
    }

    function isSameConnectionLeg(left, right) {
      if (!left || !right) {
        return false;
      }

      var sameFlightNo = left.FlightNumber === right.FlightNumber;
      var sameDep = left.Departure === right.Departure;
      var sameArr = left.Arrival === right.Arrival;
      var leftDate = left.FlightDate ? new Date(left.FlightDate).toDateString() : null;
      var rightDate = right.FlightDate ? new Date(right.FlightDate).toDateString() : null;
      var sameDate = !leftDate || !rightDate || leftDate === rightDate;
      return sameFlightNo && sameDep && sameArr && sameDate;
    }
    /**
     * Returns a Date stripped to year-month-day (no time component)
     */


    function getDateOnly(dateValue) {
      var d = new Date(dateValue);
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }
    /**
     * Sets isNextDay = true for legs that depart on the next calendar day
     * compared to the first leg in the list.
     */


    function markNextDayFlags(legs) {
      if (!legs || !legs.length || !legs[0].stdLocal) {
        return;
      }

      var baseDepartureDate = getDateOnly(legs[0].stdLocal);
      legs.forEach(function (leg, index) {
        // First leg or missing date -> never marked as next day
        if (!leg.stdLocal || index === 0) {
          leg.isNextDay = false;
          return;
        }

        var legDepartureDate = getDateOnly(leg.stdLocal);
        leg.isNextDay = legDepartureDate > baseDepartureDate;
      });
    }
    /**
     * Maps a misconnection action to a UI leg for Passenger Connection Info.
     * @param {Object} action - raw action from backend
     * @param {boolean} isNewFlight - true if this leg belongs to the final reprotected journey (C)
     * @param {boolean} isOriginalMissed - true if this leg is the original missed flight (A)
     */


    function mapActionToLeg(action, isNewFlight, isOriginalMissed) {
      var stdLocal = action.STD_Local || action.STD || null;
      var stdUtc = action.STD || null;
      var etdLocal = action.ETD_Local || null;
      var etdUtc = action.ETD || null;
      var atdLocal = action.ATD_Local || null;
      var atdUtc = action.ATD || null; // Decide which time is considered "primary" for bold display:
      // - ETD if available
      // - otherwise STD

      var hasEtd = !!(etdLocal || etdUtc);
      var primaryTimeType = hasEtd ? "ETD" : "STD";
      return {
        // journey flags
        isNewFlight: !!isNewFlight,
        // final reprotection leg (C)
        isOriginalMissed: !!isOriginalMissed,
        // original missed leg (A)
        hasReprotection: !!action.HasReprotectedAction,
        hasEscort: !!action.HasEscortAction,
        order: action.FlightOccurrenceOrder || 0,
        flightNo: action.FlightNumber,
        departure: action.Departure,
        arrival: action.Arrival,
        // STD
        stdLocal: stdLocal,
        stdUtc: stdUtc,
        // ETD
        etdLocal: etdLocal,
        etdUtc: etdUtc,
        // ATD
        atdLocal: atdLocal,
        atdUtc: atdUtc,
        departureGate: action.Dep_Gate,
        primaryTimeType: primaryTimeType
      };
    }
    /**
     * Returns true if STD should be highlighted as primary time for this leg.
     */


    $scope.isStdHighlighted = function (leg) {
      if (!leg) {
        return false;
      } // We highlight STD when it is the primary time type


      return leg.primaryTimeType === "STD";
    };
  }
})();
"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  "use strict";

  a3_cabin_reports.controller("PaxCtrl", PaxCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name PaxCtrl
   * @description
   *  Manages the passenger seatmap and information view
   * @ngInject
   */

  function PaxCtrl($scope, FlightFactory, PaxInfoFactory, FlightOrdersFactory, CampaignFactory, CabinReportLocalEditFactory, LuggageComplianceFactory, UserFactory, $route, $routeParams, $uibModal, $location, SettingsMain, MisconnectionFlightsFactory, defaultCalendarDate) {
    var _flightId = $routeParams.flightId;
    var flight = FlightFactory.getFlightFromStorage(_flightId);

    var _report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(_flightId);

    $scope.state = "pax";
    $scope.flight = flight;
    $scope.showMobileMenuFilters = false;
    $scope.filterPax = filterPax;
    $scope.viewMode = viewMode;
    $scope.filterRow = filterRow;
    $scope.filterCol = filterCol;
    $scope.howClose = "";
    $scope.IsOld = IsOld;
    $scope.openPassenger = openPassenger;
    $scope.resetFilters = resetFilters;
    $scope.isConnectedFlightClose = isConnectedFlightClose;
    $scope.TimeDifference = TimeDifference;
    $scope.getTierCount = getTierCount;
    $scope.applyLuggageCompliance = applyLuggageCompliance;
    $scope.IsProvisional = true;
    $scope.specialMeals = 0;
    $scope.multiSelectCount = 0;
    $scope.luggageComplianceConfirmation = luggageComplianceConfirmation;
    $scope.close = close;
    $scope.toggleFlightInfoView = toggleFlightInfoView;
    $scope.mode = "seatMap";
    $scope.radioModel = "Seatmap";
    $scope.flightCompliant = LuggageComplianceFactory.getFlightCompliantStatus(_flightId);
    $scope.IsShopInTheCloudEnable = SettingsMain.getIsShopInTheCloudEnable();
    $scope.searchText = {
      passengerName: ""
    };
    var user = UserFactory.getUser();
    $scope.isUserSA = user.position == "SA" ? true : false;

    if (flight == null) {
      flight = FlightFactory.getLocalFlightFromStorage(_flightId);
    } // $scope.saEligibility = flight.LineStatus && flight.LineStatus != 'na';


    if (flight && flight.LineStatus && flight.LineStatus !== "na") {
      $scope.saEligibility = true;
    } else {
      $scope.saEligibility = false;
    }

    PaxInfoFactory.setMaskPaxInfoInRoute(flight);
    var _paxInfo = null;
    PaxInfoFactory.getPaxInfoFromStorage(_flightId, function (result) {
      _paxInfo = result;
      $scope.paxInfo = _paxInfo;
      var flightOrders = FlightOrdersFactory.getFlightOrdersFlattenedByFlightId(_flightId);

      if (_paxInfo && _report) {
        //Set upgraded seats and changed seats from report to paxinfo
        setUpgradedSeatsFromReport(_report.UpgradedPassengers);

        if (_report.ChangedSeats) {
          setChangedSeatsFromReport(_report.ChangedSeats); //Get ChangedSeats Counter

          $scope.paxInfo.changedSeatsNo = _report.ChangedSeats.length;
        } else {
          $scope.paxInfo.changedSeatsNo = 0;
        }
      }

      if (flight != null) {
        if (_paxInfo) {
          var connectingPax = 0;

          for (var i = 0; i < _paxInfo.ConnectingFlights.length; i++) {
            connectingPax = connectingPax + _paxInfo.ConnectingFlights[i].PassengerSummaryC.Passengers + _paxInfo.ConnectingFlights[i].PassengerSummaryY.Passengers;
          }

          $scope.connectingPax = connectingPax;

          for (var i = 0; i < _paxInfo.Seatmap.length; i++) {
            for (var j = 0; j < _paxInfo.Seatmap[i].Columns.length; j++) {
              if (_paxInfo.Seatmap[i].Columns[j].SpecialMeal) {
                $scope.specialMeals++;
              }

              if (_paxInfo.Seatmap[i].Columns[j].SpecialMealB) {
                $scope.specialMeals++;
              }

              if (_paxInfo.Seatmap[i].Columns[j].ConnectingFlightId && _paxInfo.Seatmap[i].Columns[j].ConnectingFlightId != 0) {
                for (var h = 0; h < _paxInfo.ConnectingFlights.length; h++) {
                  if (_paxInfo.Seatmap[i].Columns[j].ConnectingFlightId == _paxInfo.ConnectingFlights[h].FlightId) {
                    _paxInfo.Seatmap[i].Columns[j].Connection = _paxInfo.ConnectingFlights[h];
                  }
                }
              } //if(report && flight.showPaxNames){


              if (flight.showPaxNames && $scope.IsShopInTheCloudEnable && _paxInfo.Seatmap[i].Columns[j].Fullname != null) {
                var foundOrders;
                var orderStatusIsPending;

                (function () {
                  // Split Fullname into Firstname and Lastname
                  var _paxInfo$Seatmap$i$Co = _paxInfo.Seatmap[i].Columns[j].Fullname.split(" "),
                      _paxInfo$Seatmap$i$Co2 = _slicedToArray(_paxInfo$Seatmap$i$Co, 2),
                      lastname = _paxInfo$Seatmap$i$Co2[0],
                      firstname = _paxInfo$Seatmap$i$Co2[1]; //get flag for the flight orders - shop in the cloud


                  foundOrders = null;

                  if (flightOrders) {
                    foundOrders = flightOrders.Orders.filter(function (order) {
                      return order.Passenger.FirstName === firstname && order.Passenger.LastName === lastname && order.Passenger.PNR === _paxInfo.Seatmap[i].Columns[j].PNR;
                    });
                  }

                  if (foundOrders && foundOrders.length > 0) {
                    $scope.paxInfo.Seatmap[i].Columns[j].HasFlightOrder = true;
                    $scope.paxInfo.Seatmap[i].Columns[j].FlightOrders = foundOrders;
                    orderStatusIsPending = false;
                    foundOrders.forEach(function (order) {
                      if (!order.Status) {
                        orderStatusIsPending = true;
                      }
                    });
                    $scope.paxInfo.Seatmap[i].Columns[j].FlightOrderStatusIsPending = orderStatusIsPending;
                  } else {
                    $scope.paxInfo.Seatmap[i].Columns[j].HasFlightOrder = false;
                  }
                })();
              }
            }
          }

          if ($scope.IsShopInTheCloudEnable) {
            //Update passenger orders counter
            updateFlightOrdersCounters();
          }

          attachMisconnectionStatusToPax();
          var listSentTimestamp = new Date(_paxInfo.LastRun).getTime();
          var DepartureTimestamp = new Date(flight.ScheduledDeparture).getTime(); //20 minutes before takeoff

          if (DepartureTimestamp - listSentTimestamp <= 1200000) {
            $scope.IsProvisional = false;
          }
        }

        var flightArrivalTime = new Date(flight.ScheduledArrival).getTime();
        $scope.flightETA = flight.ETA ? new Date(flight.ETA).getTime() : flightArrivalTime;
        attachCampaign($scope.paxInfo);
        attachLuggageCompliance();
        initializeFilters();
        initializeViewMode();
      } else {
        $location.path("/");
      }
    });
    /**
     * Set upgraded seats from report to paxinfo
     * @memberof PaxCtrl
     */

    function setUpgradedSeatsFromReport(upgradedPassengers) {
      for (var k = 0; k < upgradedPassengers.length; k++) {
        for (var i = 0; i < $scope.paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < $scope.paxInfo.Seatmap[i].Columns.length; j++) {
            if ($scope.paxInfo.Seatmap[i].Columns[j].UCI == upgradedPassengers[k].UCI && $scope.paxInfo.Seatmap[i].Columns[j].PNR == upgradedPassengers[k].PNR) {
              $scope.paxInfo.Seatmap[i].Columns[j].UpgradedToSeat = upgradedPassengers[k];
            }
          }
        }
      }
    }
    /**
     * Set changed seats from report to paxinfo
     * @memberof PaxCtrl
     */


    function setChangedSeatsFromReport(changedSeats) {
      for (var k = 0; k < changedSeats.length; k++) {
        for (var i = 0; i < $scope.paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < $scope.paxInfo.Seatmap[i].Columns.length; j++) {
            if ($scope.paxInfo.Seatmap[i].Columns[j].UCI == changedSeats[k].UCI && $scope.paxInfo.Seatmap[i].Columns[j].PNR == changedSeats[k].PNR) {
              $scope.paxInfo.Seatmap[i].Columns[j].ChangedSeat = changedSeats[k];
            }
          }
        }
      }
    }
    /**
     * Toggle view from seatmap to paxlist
     * @memberof PaxCtrl
     */


    function toggleFlightInfoView(mode) {
      $scope.mode = mode;
    }
    /**
     * Initialize Passenger Filters
     * @memberof PaxCtrl
     */


    function initializeFilters() {
      $scope.filterPaxC = false;
      $scope.filterPaxY = false;
      $scope.filterAdults = false;
      $scope.filterChildren = false;
      $scope.filterInfants = false;
      $scope.filterUMs = false;
      $scope.filterFqtv = false;
      $scope.filterConnections = false;
      $scope.filterSpecialMeals = false;
      $scope.filterFqtvPlatinum = false;
      $scope.filterFqtvSilver = false;
      $scope.filterFqtvGold = false;
      $scope.filterWheelchair = false;
      $scope.filterAssistance = false;
      $scope.filterDeportees = false;
      $scope.filterVIP = false;
      $scope.filterFlightOrders = false;
      $scope.filterDHC = false;
      $scope.filterChargeableSeats = false;
      $scope.filterEligibleForUpgrade = false;
      $scope.filterSeatChanges = false;
      $scope.filterIrregularities = false;
      $scope.filterCampaigns = false;
      $scope.multiSelect = false; // $scope.searchText = { passengerName: ''};
    }
    /**
     * Filter Passenger by given filter
     * @memberof PaxCtrl
     * @param {string} criteria The selected filter criteria
     */


    function filterPax(criteria) {
      if (criteria == "PaxC") {
        var val = !$scope.filterPaxC;
        initializeFilters();
        $scope.filterPaxC = val;
      } else if (criteria == "PaxY") {
        var val = !$scope.filterPaxY;
        initializeFilters();
        $scope.filterPaxY = val;
      } else if (criteria == "Adults") {
        var val = !$scope.filterAdults;
        initializeFilters();
        $scope.filterAdults = val;
      } else if (criteria == "Children") {
        var val = !$scope.filterChildren;
        initializeFilters();
        $scope.filterChildren = val;
      } else if (criteria == "Infants") {
        var val = !$scope.filterInfants;
        initializeFilters();
        $scope.filterInfants = val;
      } else if (criteria == "Fqtv-platinum") {
        var val = !$scope.filterFqtvPlatinum;
        initializeFilters();
        $scope.filterFqtvPlatinum = val;
      } else if (criteria == "Fqtv-silver") {
        var val = !$scope.filterFqtvSilver;
        initializeFilters();
        $scope.filterFqtvSilver = val;
      } else if (criteria == "Fqtv-gold") {
        var val = !$scope.filterFqtvGold;
        initializeFilters();
        $scope.filterFqtvGold = val;
      } else if (criteria == "Connections") {
        var val = !$scope.filterConnections;
        $scope.showConnections = true;
        initializeFilters();
        $scope.filterConnections = val;
      } else if (criteria == "UMs") {
        var val = !$scope.filterUMs;
        initializeFilters();
        $scope.filterUMs = val;
      } else if (criteria == "SpecialMeals") {
        var val = !$scope.filterSpecialMeals;
        initializeFilters();
        $scope.showMeals = true;
        $scope.filterSpecialMeals = val;
      } else if (criteria == "Wheelchair") {
        var val = !$scope.filterWheelchair;
        initializeFilters();
        $scope.filterWheelchair = val;
      } else if (criteria == "Assistance") {
        var val = !$scope.filterAssistance;
        initializeFilters();
        $scope.filterAssistance = val;
      } else if (criteria == "Deportees") {
        var val = !$scope.filterDeportees;
        initializeFilters();
        $scope.filterDeportees = val;
      } else if (criteria == "VIP") {
        var val = !$scope.filterVIP;
        initializeFilters();
        $scope.filterVIP = val;
      } else if (criteria == "FlightOrders") {
        var val = !$scope.filterFlightOrders;
        initializeFilters();
        $scope.filterFlightOrders = val;
      } else if (criteria == "DHC") {
        var val = !$scope.filterDHC;
        initializeFilters();
        $scope.filterDHC = val;
      } else if (criteria == "ChargeableSeats") {
        var val = !$scope.filterChargeableSeats;
        initializeFilters();
        $scope.filterChargeableSeats = val;
      } else if (criteria == "UPGD") {
        var val = !$scope.filterEligibleForUpgrade;
        initializeFilters();
        $scope.filterEligibleForUpgrade = val;
      } else if (criteria == "SeatChange") {
        var val = !$scope.filterSeatChanges;
        initializeFilters();
        $scope.filterSeatChanges = val;
      } else if (criteria == "Irregularities") {
        var val = !$scope.filterIrregularities;
        initializeFilters();
        $scope.filterIrregularities = val;
      } else if (criteria == "Campaigns") {
        var val = !$scope.filterCampaigns;
        initializeFilters();
        $scope.filterCampaigns = val;
      } else if (criteria == "MultiSelect") {
        var val = !$scope.multiSelect; //initializeFilters();

        initialiazeMultiSelectCounter();
        $scope.multiSelect = val;
      } else if (criteria == "searchText") {
        var val = $scope.searchText.passengerName;
        initializeFilters();
      }
    }

    function initialiazeMultiSelectCounter() {
      $scope.paxInfo.Seatmap.forEach(function (row) {
        row.Columns.forEach(function (column) {
          column.isMultiSelected = false;
        });
      });
      $scope.multiSelectCount = 0;
    }

    function luggageComplianceConfirmation() {
      if ($scope.multiSelectCount > 0) {
        $scope.modalInstance = $uibModal.open({
          templateUrl: "dlgLuggageComplianceConfirmation.html",
          scope: $scope
        });
      }
    }

    function close() {
      $scope.modalInstance.close();
    }

    function applyLuggageCompliance() {
      var columns = [];
      $scope.paxInfo.Seatmap.forEach(function (row) {
        row.Columns.forEach(function (column) {
          columns.push(column);
        });
      });
      var selectedPassengers = columns.filter(function (c) {
        return c.isMultiSelected;
      });
      selectedPassengers.forEach(function (passenger, index) {
        var cabinLuggageReport = {
          PNR: passenger.PNR,
          UCI: passenger.UCI,
          FlightId: _flightId,
          FareFamily: passenger.FareFamily,
          IsFlightCompliant: false,
          Created: moment()
        };
        passenger.opcc = true; //attachLuggageCompliance

        LuggageComplianceFactory.saveLuggageComplianceToStorage(cabinLuggageReport, index);
      });
      $scope.modalInstance.close();
      filterPax("MultiSelect");
    }
    /**
     * Initialize View Mode
     * @memberof PaxCtrl
     */


    function initializeViewMode() {
      $scope.showPaxName = true;
      $scope.showDetails = true;
      $scope.showConnections = true;
      $scope.showMeals = false;
    }
    /**
     * Set the desired view style
     * @memberof PaxCtrl
     * @param {string} mode The view mode
     */


    function viewMode(mode) {
      if (mode == "PaxName") {
        $scope.showPaxName = !$scope.showPaxName;
      } else if (mode == "Details") {
        $scope.showDetails = !$scope.showDetails;
      } else if (mode == "Connections") {
        $scope.showConnections = !$scope.showConnections;
      } else if (mode == "Meals") {
        $scope.showMeals = !$scope.showMeals;
      }
    }
    /**
     * Show only the  Rows that have a passenger that is valid with the current filters
     * @memberof PaxCtrl
     * @param {object} row The passenger row
     */


    function filterRow(row) {
      var isValid = false;

      if ($scope.filterPaxC || $scope.filterPaxY || $scope.filterAdults || $scope.filterChildren || $scope.filterInfants || $scope.filterUMs || $scope.filterFqtv || $scope.filterConnections || $scope.filterSpecialMeals || $scope.filterFqtvPlatinum || $scope.filterFqtvSilver || $scope.filterFqtvGold || $scope.filterWheelchair || $scope.filterWheelchair || $scope.filterAssistance || $scope.filterDeportees || $scope.filterDHC || $scope.filterVIP || $scope.filterFlightOrders || $scope.filterChargeableSeats || $scope.filterEligibleForUpgrade || $scope.filterSeatChanges || $scope.filterIrregularities || $scope.filterCampaigns || $scope.multiSelect || $scope.searchText.passengerName.length > 1) {
        for (var i = 0; i < row.Columns.length; i++) {
          if (filterCol(row.Columns[i])) {
            isValid = true;
          }
        }
      } else {
        isValid = true;
      }

      return isValid;
    }
    /**
     * Disable the  passenger seats that is not valid with the current filters
     * @memberof PaxCtrl
     * @param {object} col The passenger seat
     */


    function filterCol(col) {
      var IsValid = true;

      if ($scope.filterPaxC && col.Cabin != "C") {
        IsValid = false;
      } else if ($scope.filterPaxY && col.Cabin != "Y") {
        IsValid = false;
      } else if ($scope.filterAdults && col.Type != "A") {
        IsValid = false;
      } else if ($scope.filterChildren && col.Type != "C") {
        IsValid = false;
      } else if ($scope.filterInfants && col.Type != "I" && !(col.Type == "A" && col.InfantName)) {
        IsValid = false;
      } else if ($scope.filterFqtv && col.Fqtv == null) {
        IsValid = false;
      } else if ($scope.filterConnections && col.Connection == null) {
        IsValid = false;
      } else if ($scope.filterUMs && !(col.SSR != null && col.SSR.IsUMNR)) {
        IsValid = false;
      } else if ($scope.filterSpecialMeals && col.SpecialMeal == null && col.SpecialMealB == null) {
        IsValid = false;
      } else if ($scope.filterFqtvPlatinum && !(col.Fqtv != null && col.Fqtv.TierLevel == "PLTM")) {
        IsValid = false;
      } else if ($scope.filterFqtvSilver && !(col.Fqtv != null && (col.Fqtv.TierLevel == "BLUT" || col.Fqtv.TierLevel == "SLVT"))) {
        IsValid = false;
      } else if ($scope.filterFqtvGold && !(col.Fqtv != null && col.Fqtv.TierLevel == "GLDT")) {
        IsValid = false;
      } else if ($scope.filterWheelchair && !(col.SSR != null && col.SSR.IsGroupPRM)) {
        IsValid = false;
      } else if ($scope.filterAssistance && !(col.SSR != null && (col.SSR.IsDEAF || col.SSR.IsBLND || col.SSR.IsDPNA))) {
        IsValid = false;
      } else if ($scope.filterDeportees && !(col.SSR != null && (col.SSR.IsINAD || col.SSR.IsGroupDEP))) {
        IsValid = false;
      } else if ($scope.filterVIP && !col.IsVIP) {
        IsValid = false;
      } else if ($scope.filterFlightOrders && !col.HasFlightOrder) {
        IsValid = false;
      } else if ($scope.filterDHC && !col.IsDHC) {
        IsValid = false;
      } else if ($scope.filterChargeableSeats && !(col.IsCHU || col.IsCHX)) {
        IsValid = false;
      } else if ($scope.filterEligibleForUpgrade && !col.IsEligibleForUpgrade) {
        IsValid = false;
      } else if ($scope.filterSeatChanges && !col.ChangedSeat) {
        IsValid = false;
      } else if ($scope.filterIrregularities && !col.UndeliveredChargeableSeat) {
        IsValid = false;
      } else if ($scope.filterCampaigns && !col.Campaign) {
        IsValid = false;
      } else if ($scope.multiSelect && (col.IsEmptySeat || col.SeatMode != "Seat")) {
        IsValid = false;
      } else if ($scope.searchText.passengerName.length > 1 && (col.Fullname == null || !col.Fullname.toLowerCase().includes($scope.searchText.passengerName.toLowerCase()))) {
        IsValid = false;
      }

      return IsValid;
    }
    /**
     * Initialize Passenger Filters and the desired view style
     * @memberof PaxCtrl
     */


    function resetFilters() {
      initializeFilters();
      initializeViewMode();
    }
    /**
     * Gets Platinum counters without depending on backend-only summary fields.
     * Uses summary values when available and falls back to the seat map.
     * @memberof PaxCtrl
     * @param {string} tierName The tier name to count
     * @returns {number} total passengers for the tier
     */


    function getTierCount(tierName) {
      if (!$scope.paxInfo || tierName != "Platinum") {
        return 0;
      }

      var summaryC = $scope.paxInfo.PassengerSummaryC && $scope.paxInfo.PassengerSummaryC.FQTVPlatinum;
      var summaryY = $scope.paxInfo.PassengerSummaryY && $scope.paxInfo.PassengerSummaryY.FQTVPlatinum;

      if (typeof summaryC === "number" && typeof summaryY === "number") {
        return summaryC + summaryY;
      }

      if (!$scope.paxInfo.Seatmap) {
        return 0;
      }

      var total = 0;
      $scope.paxInfo.Seatmap.forEach(function (row) {
        row.Columns.forEach(function (column) {
          if (!column.IsEmptySeat && column.Fqtv && column.Fqtv.TierLevel == "PLTM") {
            total++;
          }
        });
      });
      return total;
    }
    /**
     * Open Passenger Modal View
     * @memberof PaxCtrl
     * @param {object} inputObject The passenger information
     */


    function openPassenger(inputObject) {
      if ($scope.multiSelect && !inputObject.IsEmptySeat && (inputObject.SeatMode == "Seat" || inputObject.SeatMode == "Jumpseat")) {
        inputObject.isMultiSelected = !inputObject.isMultiSelected;
        var columns = [];
        $scope.paxInfo.Seatmap.forEach(function (row) {
          row.Columns.forEach(function (column) {
            columns.push(column);
          });
        });
        $scope.multiSelectCount = columns.filter(function (c) {
          return c.isMultiSelected;
        }).length;
      } else if (inputObject.IsEmptySeat == 0 && (inputObject.SeatMode == "Seat" || inputObject.SeatMode == "Jumpseat")) {
        // kzan::: Remove
        attachDummyConnection(inputObject);
        var modalInstance = $uibModal.open({
          templateUrl: "views/Dialogs/dlgPassenger.html",
          controller: "PassengerCtrl",
          size: "lg",
          backdrop: "static",
          keyboard: false,
          scope: $scope,
          resolve: {
            passenger: function passenger() {
              return inputObject;
            },
            flightId: function flightId() {
              return _flightId;
            },
            paxInfo: function paxInfo() {
              return _paxInfo;
            },
            report: function report() {
              return _report;
            }
          }
        });
        modalInstance.result.then(function () {
          //passenger upgraded, reload pax
          $route.reload();
        }, function () {
          //$route.reload();
          attachCampaign();
          updateCampaignsCounters();
          attachLuggageCompliance();
        });
      }
    }

    function attachDummyConnection(pax) {
      if (!pax) {
        return;
      } // Only override if there is no existing connection


      if (pax.Connection) {
        return;
      } // pax.Connection = {
      //     FlightNo: 'A3 940',
      //     Departure: 'ATH',
      //     Arrival: 'RUH',
      //     // Local time (what you show as "STD_Local" in the UI)
      //     STD_Local: new Date('2025-11-21T09:00:00'),
      //     // UTC time (or scheduled base time)
      //     STD: new Date('2025-11-21T07:00:00Z'),
      //     DepartureGate: 'A12',
      //     // Used by IsOld() in the template to show the gate warning
      //     UpdatedDate: new Date('2025-11-21T08:00:00Z')
      // };

    }
    /**
     * Checks if the data are new
     * @memberof PaxCtrl
     * @param {string} time timestamp
     * @return {boolean} IsOld
     */


    function IsOld(time) {
      IsOld = false;

      if (time) {
        var now = new Date();
        var timeDate = new Date(time);
        var diff = now.getTime() - timeDate.getTime();

        if (diff > 3600000) {
          IsOld = true;
        }
      }

      return IsOld;
    }
    /**
     * Calculates if a connecting flight is departs sort time after fligths arrival
     * @memberof PaxCtrl
     * @param {string} connection Connection STD
     * @return {string} cssClass
     */


    function isConnectedFlightClose(connection) {
      //disable bg colors for connections after customer request : 25-01-2026 (Re: Bug Report: Connections Panel & Pax Connection Info)
      return "";

      if (!connection) {
        return "";
      }

      var connFlightDate = new Date(connection.STD).getTime();
      if ($scope.flightETA > connFlightDate) return "";

      if (connFlightDate - $scope.flightETA < connection.MCT * 60000) {
        return "bg-bisque";
      }

      if (connFlightDate - $scope.flightETA < (connection.MCT + 15) * 60000) {
        return "bg-cornsilk";
      }

      return "";
    }
    /**
     * Returns the time difference
     * @memberof PaxCtrl
     * @param {string} time Connection STD
     * @return {string} timeDifference
     */


    function TimeDifference(time) {
      var timeString = "";
      var sign = "";
      var dayString = null;

      if (time) {
        var connFlightDate = new Date(time);
        var ms = connFlightDate.getTime() - $scope.flightETA; // this is a time in milliseconds

        if (ms < 0) {
          ms = -ms;
          sign = "-";
        }

        var days = Math.floor(ms / (24 * 60 * 60 * 1000));
        days = days < 0 ? days + 1 : days;
        var daysms = ms % (24 * 60 * 60 * 1000);
        var hours = Math.floor(daysms / (60 * 60 * 1000));
        var hoursms = ms % (60 * 60 * 1000);
        var minutes = Math.floor(hoursms / (60 * 1000));
        timeString = "<strong>" + sign + (hours > 0 ? ("0" + hours).substr(-2) + ":" : "") + ("0" + minutes).substr(-2) + "'" + "<strong>";
        dayString = ' <span class="badge mb-1half">' + days + "d</span>";
      }

      return timeString + (days && days != 0 ? dayString : "");
    }

    function attachCampaign() {
      if ($scope.paxInfo) {
        $scope.paxInfo.CampaignCounters = {
          pending: 0,
          completed: 0
        };
        $scope.paxInfo.Seatmap.forEach(function (s) {
          s.Columns.forEach(function (col) {
            if (col.UCI) {
              var campaignInfo = CampaignFactory.getPaxAssignment(+_flightId, col.PNR, col.UCI);

              if (campaignInfo.assignment) {
                col.Campaign = JSON.parse(JSON.stringify(campaignInfo));
                if (col.Campaign.assignment.Status == 0) $scope.paxInfo.CampaignCounters.pending += 1;
                if (col.Campaign.assignment.Status != 0) $scope.paxInfo.CampaignCounters.completed += 1;
              }
            }
          });
        });
      }
    }

    function attachLuggageCompliance() {
      if ($scope.paxInfo) {
        $scope.paxInfo.Seatmap.forEach(function (s) {
          s.Columns.forEach(function (col) {
            if (col.UCI) {
              var opccReport = LuggageComplianceFactory.getPassengerLuggageCompliance(_flightId, col.UCI);
              col.opcc = opccReport != null;
            }
          });
        });
      }
    }

    function updateCampaignsCounters() {
      $scope.paxInfo.CampaignCounters = {
        pending: 0,
        completed: 0
      };
      $scope.paxInfo.Seatmap.forEach(function (s) {
        s.Columns.forEach(function (col) {
          if (col.Campaign) {
            if (col.Campaign.assignment.Status == 0) {
              $scope.paxInfo.CampaignCounters.pending += 1;
            }

            if (col.Campaign.assignment.Status != 0) {
              $scope.paxInfo.CampaignCounters.completed += 1;
            }
          }
        });
      });
    }

    function updateFlightOrdersCounters() {
      var counters = {
        pendingOrders: 0,
        allOrders: 0
      }; //TODO: uncomment on live - create a temp report to active the orders
      //if(report && flight.showPaxNames){

      if (_report && flight.showPaxNames) {
        var passengerList = [];

        if ($scope.paxInfo) {
          for (var i = 0; i < $scope.paxInfo.Seatmap.length; i++) {
            for (var j = 0; j < $scope.paxInfo.Seatmap[i].Columns.length; j++) {
              var passenger = $scope.paxInfo.Seatmap[i].Columns[j];

              if (!passenger.IsEmptySeat && passenger.SeatMode == "Seat") {
                passengerList.push(passenger);
              }
            }
          }
        }

        counters = passengerList.reduce(function (acc, _ref) {
          var HasFlightOrder = _ref.HasFlightOrder,
              FlightOrderStatusIsPending = _ref.FlightOrderStatusIsPending;

          if (HasFlightOrder) {
            acc.allOrders++;

            if (FlightOrderStatusIsPending) {
              acc.pendingOrders++;
            }
          }

          return acc;
        }, {
          pendingOrders: 0,
          allOrders: 0
        });
      }

      $scope.paxInfo.flightOrdersCounters = counters;
      console.log($scope.paxInfo.flightOrdersCounters);
    }

    function attachMisconnectionStatusToPax() {
      if (!$scope.paxInfo || !$scope.paxInfo.Seatmap || !_flightId) {
        return;
      }

      var misconnectionStatusByUci = {};
      var misconnectionFlights = [];

      if (defaultCalendarDate && _flightId === "1226541") {
        misconnectionFlights = MisconnectionFlightsFactory.getMisconnectionFlightsByFlightIdFromLS(2242084 //<=(747 17-6-2016)
        ) || [];
      } else {
        // 1) Get misconnection flights for this disrupted flight from local storage
        misconnectionFlights = MisconnectionFlightsFactory.getMisconnectionFlightsByFlightIdFromLS(_flightId) || [];
      }

      if (!misconnectionFlights.length) {
        return;
      } // 2) For each passenger in the seatmap, check if they have a misconnection flight


      misconnectionFlights.forEach(function (misconnectionFlight) {
        if (!misconnectionFlight.Passengers || !misconnectionFlight.Passengers.length) {
          return;
        }

        misconnectionFlight.Passengers.forEach(function (pax) {
          if (!pax.UCI) {
            return;
          }

          var actions = pax.Actions || [];

          if (!actions.length) {
            return;
          }

          var currentStatus = misconnectionStatusByUci[pax.UCI] || {
            hasEscort: false,
            hasReprotection: false,
            lastUpdatedAction: null,
            showReprotection: false,
            reprotectionEvents: []
          };
          var statusFromActions = calculateStatusFromActions(actions); // Debug log per UCI (optional)

          console.log("[MC][UCI]", pax.UCI, {
            actions: actions,
            status: statusFromActions
          }); // Merge (OR) with existing status in case the same UCI appears in more than one route group

          currentStatus.hasEscort = currentStatus.hasEscort || statusFromActions.hasEscort;
          currentStatus.hasReprotection = currentStatus.hasReprotection || statusFromActions.hasReprotection; // Keep the latest reprotection decision timestamp

          if (statusFromActions.lastUpdatedAction) {
            if (!currentStatus.lastUpdatedAction || statusFromActions.lastUpdatedAction > currentStatus.lastUpdatedAction) {
              currentStatus.lastUpdatedAction = statusFromActions.lastUpdatedAction;
            }
          } // Final red flag for Pax List coloring


          currentStatus.showReprotection = currentStatus.hasReprotection;
          misconnectionStatusByUci[pax.UCI] = currentStatus;
        });
      }); // 3) Apply the computed status back to the seatmap passengers

      $scope.paxInfo.Seatmap.forEach(function (row) {
        row.Columns.forEach(function (col) {
          if (!col || col.IsEmptySeat || !col.UCI) {
            return;
          }

          var status = misconnectionStatusByUci[col.UCI];

          if (!status) {
            // Ensure previous flags do not leak into current coloring rules
            col.HasEscort = false;
            col.HasReprotection = false;
            col.LastUpdatedAction = null;
            col.ShowReprotection = false;
            col.MisconnectionDebug = null;
            return;
          } // Coloring rules for Pax List:
          // - Red    = ShowReprotection = true
          // - Yellow = HasEscort = true AND ShowReprotection = false
          // - White  = both false


          col.HasEscort = !!status.hasEscort;
          col.HasReprotection = !!status.hasReprotection; // keep for backward compatibility

          col.ShowReprotection = !!status.showReprotection; // Extra info for analysis / debugging on UI

          col.LastUpdatedAction = status.lastUpdatedAction || null;
          col.MisconnectionDebug = {
            hasEscort: status.hasEscort,
            hasReprotection: status.hasReprotection,
            showReprotection: status.showReprotection,
            lastUpdatedAction: status.lastUpdatedAction,
            reprotectionEvents: status.reprotectionEvents
          };
        });
      });
    }
    /**
     * Returns escort/reprotection status based on actions,
     * strictly following the rule:
     *  - RED    = reprotection decided >= 60 minutes before STD
     *  - WHITE  = reprotection decided < 60 minutes before STD ("old reprotection")
     *  - YELLOW = escort
     * Additionally:
     *  - lastUpdatedAction: latest valid reprotection decision timestamp
     *  - showReprotection: final flag used by Pax List coloring
     */


    function calculateStatusFromActions(actions) {
      var result = {
        hasEscort: false,
        hasReprotection: false,
        lastUpdatedAction: null,
        showReprotection: false,
        // debug info
        reprotectionEvents: []
      };

      if (!actions || !actions.length) {
        return result;
      }

      for (var i = 0; i < actions.length; i++) {
        var action = actions[i]; // ESCORT: always counts (no time restriction)

        if (action.HasEscortAction) {
          result.hasEscort = true;
        } // REPROTECTION: only counts if decided >= 60 minutes before STD


        if (action.HasReprotectedAction && action.STD && action.ActionTimestamp) {
          var std = new Date(flight.ScheduledDeparture);
          var ts = new Date(action.ActionTimestamp);

          if (isNaN(std.getTime()) || isNaN(ts.getTime())) {
            // Invalid dates → ignore this action and continue
            continue;
          }

          var diffMinutes = (std.getTime() - ts.getTime()) / 60000; // debug: store every reprotection decision

          result.reprotectionEvents.push({
            std: std,
            actionTimestamp: ts,
            diffMinutes: diffMinutes,
            isCountedAsNew: diffMinutes >= 60
          }); // keep the latest reprotection decision (for debugging / UI)

          if (!result.lastUpdatedAction || ts > result.lastUpdatedAction) {
            result.lastUpdatedAction = ts;
          } // RED only if reprotection is "new" (<= 60')


          if (diffMinutes <= 60) {
            result.hasReprotection = true;
          } // If > 60, we ignore it (remains WHITE)

        }
      } // Final flag that the Pax List will use for red color


      result.showReprotection = result.hasReprotection;
      return result;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('PaxInfoFactory', PaxInfoFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name PaxInfoFactory
  * @description 
  *   Add, Update, Delete and Get Passenger information.
  * @ngInject
  */

  function PaxInfoFactory($filter, IndexedDBService, localStorageMD5Service, SyncLogFactory, FlightFactory, CrewRouteFactory) {
    /**
     * Initialize the PaxInfo
     * @memberof PaxInfoFactory
     */
    //TODO EPAP :: CLEAN
    function PaxInfo() {
      this.Id = null;
      this.STD_utc = null;
      this.STD_lcl = null;
      this.STA_utc = null;
      this.STA_lcl = null;
      this.AcType = null;
      this.Registration = null;
      this.ConfigurationC = null;
      this.ConfigurationY = null;
      this.PaxTotalC = null;
      this.PaxTotalY = null;
      this.MarketingFlightNos = null;
      this.SupplementaryInfo = null;
      this.LastRun = null;
      this.Offpoints = [];
      this.ConnFlights = [];
      this.Seatmap = [];
      this.curtainRows = [];
      this.Statistics = {};
      this.GetId = GetId;
    }

    var objType = 'PaxInfo';
    var objCallback = PaxInfo;
    var service = {
      setPaxInfoToStorage: setPaxInfoToStorage,
      getPaxInfoFromStorage: getPaxInfoFromStorage,
      getPaxInfoList: getPaxInfoList,
      updatePaxInfo: updatePaxInfo,
      getAllPaxInfoFromStorage: getAllPaxInfoFromStorage,
      cleanOldDataPaxInfo: cleanOldDataPaxInfo,
      setMaskPaxInfoInRoute: setMaskPaxInfoInRoute
    };
    migratePaxInfo();
    /**
      * Overide default get Id
      * @memberof PaxInfoFactory
      * @returns {number} Id 
      */

    function GetId() {
      return this.FlightId;
    }
    /**
      * Set statistics and format passenger informtion of this flight
      * @memberof PaxInfoFactory
      * @param {paxInfo} paxInfo  The passenger information of a flight
      * @returns {object} statistics
      */
    //TODO EPAP CHANGE NAME


    function GetStatistics(paxInfo) {
      var statistics = {};
      var syncLog = SyncLogFactory.getSyncLog();

      if (paxInfo && paxInfo.Seatmap) {
        paxInfo.curtainRows = [];
        var cabinType;
        paxInfo.DHC = 0;

        for (var i = 0; i < paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
            if (paxInfo.Seatmap[i].Columns[j].Cabin == 'J') {
              paxInfo.Seatmap[i].Columns[j].Cabin = 'Y';
            }

            if (cabinType == null) {
              cabinType = paxInfo.Seatmap[i].Columns[j].Cabin;
            } else if (cabinType != paxInfo.Seatmap[i].Columns[j].Cabin && paxInfo.Seatmap[i - 1] && paxInfo.Seatmap[i].Columns[j].Cabin != null) {
              cabinType = paxInfo.Seatmap[i].Columns[j].Cabin;
              paxInfo.curtainRows.push(paxInfo.Seatmap[i - 1].RowNo);
            }
          }
        }
      }

      return statistics;
    }
    /**
     * Set Passenger information
     * @memberof PaxInfoFactory
     * @param {Array} paxInfos  The passenger informations 
     */


    function setPaxInfoToStorage(paxInfo, flightIds) {
      if (paxInfo) {
        // get paxInfo for the flights with draft reports from indexedDB (gets the new paxInfo if the flightId exists in sync response)
        getAllPaxInfoFromStorage(function (paxInfoResult) {
          var oldDraftPaxInfo = [];
          var paxInfoFlightIds = paxInfo.map(function (item) {
            return item.FlightId;
          });
          oldDraftPaxInfo = paxInfoResult.filter(function (item) {
            return flightIds.includes(item.FlightId) && !paxInfoFlightIds.includes(item.FlightId);
          }); // get new paxInfo

          IndexedDBService.removeAll(objType).then(function () {
            for (var i = 0; i < paxInfo.length; i++) {
              paxInfo[i].Statistics = GetStatistics(paxInfo[i]);
            }

            var newListPaxInfo = paxInfo.concat(oldDraftPaxInfo);
            IndexedDBService.addAll(objType, newListPaxInfo);
          });
        });
      }
    }
    /**
     * Clean Old Data
     * @memberof PaxInfoFactory
     * @param {Array} pendingFlightIds FlightIds with pending reports
     */


    function cleanOldDataPaxInfo(pendingFlightIds) {
      // get paxInfo for the flights with draft reports from indexedDB (gets the new paxInfo if the flightId exists in sync response)
      var now = moment();
      getAllPaxInfoFromStorage(function (paxInfoResult) {
        var oldDraftPaxInfo = paxInfoResult.filter(function (item) {
          return pendingFlightIds.includes(item.FlightId);
        }); // keep only the pax list with pending reports

        IndexedDBService.removeAll(objType).then(function () {
          IndexedDBService.addAll(objType, oldDraftPaxInfo);
        });
      });
    }
    /**
     * Get Passenger information for the selected flight
     * @memberof PaxInfoFactory
     * @param {number} flightId  The flight id 
     */


    function getPaxInfoFromStorage(flightId, callback) {
      //var intFlightId = 1226541;
      var intFlightId = +flightId;
      IndexedDBService.getById(objType, intFlightId).then(function (result) {
        // applyDummyTierDataForTestFlight(result, intFlightId);
        callback(result);
      });
    }
    /**
     * Get Passenger information list for the selected flight
     * @memberof PaxInfoFactory
     * @param {number} flightId  The flight id 
     */


    function getPaxInfoList(flightId, callback) {
      var intFlightId = +flightId;
      var passengerList = [];
      IndexedDBService.getById(objType, intFlightId).then(function (paxInfo) {
        if (paxInfo) {
          for (var i = 0; i < paxInfo.Seatmap.length; i++) {
            for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
              var passenger = paxInfo.Seatmap[i].Columns[j];

              if (!passenger.IsEmptySeat && passenger.SeatMode == "Seat") {
                passengerList.push(passenger);
              }
            }
          }
        }

        callback(passengerList);
      });
    }
    /**
    * Get Passenger information for the selected flights
    * @memberof PaxInfoFactory
    */


    function getAllPaxInfoFromStorage(callback) {
      IndexedDBService.getAll(objType).then(function (paxinfo) {
        callback(paxinfo);
      });
    }
    /**
     * Update Passenger information
     * @memberof PaxInfoFactory
     * @param {object} paxInfo  The passenger informations 
     */


    function updatePaxInfo(paxInfo) {
      if (paxInfo) {
        paxInfo.Statistics = GetStatistics(paxInfo);
        IndexedDBService.put(objType, paxInfo);
      }
    }
    /**
     * Update Passenger information
     * @memberof PaxInfoFactory
     */


    function migratePaxInfo() {
      var lsPaxInfo = localStorageMD5Service.get(objType);

      if (lsPaxInfo && lsPaxInfo.length > 0) {
        IndexedDBService.addAll(objType, lsPaxInfo);
        localStorageMD5Service.remove(objType);
      }
    }
    /**
     * Hide pax name with condition
     * @memberof PaxInfoFactory
     */


    function setMaskPaxInfoInRoute(flightInfo) {
      if (flightInfo && flightInfo.showPaxNames) {
        var applyMask = false;
        var flights = CrewRouteFactory.getCrewRouteFlights(flightInfo.DutyNo, flightInfo.DutyDay, flightInfo.FlightDate);
        flights = $filter('orderBy')(flights, 'ScheduledDeparture');
        var lastFlight = flights[flights.length - 1]; //TODO:: temporary comment just to test, uncomment it on deploy !!

        if (moment.utc().diff(moment(lastFlight.ATA), 'hours') > 6) {
          //set mask
          applyMask = true;
        } // else if (moment.utc().diff(moment(lastFlight.ETA), 'hours') > 4) {
        // 	//set mask
        // 	applyMask = true;
        // }
        // else if (moment.utc().diff(moment(lastFlight.ScheduledArrival), 'hours') > 4) {
        // 	//set mask
        // 	applyMask = true;
        // }


        if (applyMask) {
          flights.forEach(function (flight) {
            flight.showPaxNames = false;
            FlightFactory.updateFlight(flight);
          });
          var flightIds = flights.map(function (item) {
            return item.FlightId; // or Id (todo: check)
          });
          setMaskPaxInfoToStorage(flightIds);
        }
      }
    }

    function setMaskPaxInfoToStorage(flightIds) {
      getAllPaxInfoFromStorage(function (paxInfoResult) {
        var maskedPaxFlightList = [];
        maskedPaxFlightList = paxInfoResult.filter(function (item) {
          return flightIds.includes(item.FlightId);
        });

        for (var i = 0; i < maskedPaxFlightList.length; i++) {
          maskPaxNames(maskedPaxFlightList[i]);
        }

        var otherPaxInfo = paxInfoResult.filter(function (item) {
          return !flightIds.includes(item.FlightId);
        }); // get new paxInfo

        IndexedDBService.removeAll(objType).then(function () {
          var newListPaxInfo = otherPaxInfo.concat(maskedPaxFlightList);
          IndexedDBService.addAll(objType, newListPaxInfo);
        });
      });
    }

    function maskPaxNames(pax) {
      if (pax) {
        for (var i = 0; i < pax.Seatmap.length; i++) {
          for (var j = 0; j < pax.Seatmap[i].Columns.length; j++) {
            var passenger = pax.Seatmap[i].Columns[j];

            if (!passenger.IsEmptySeat && passenger.SeatMode == "Seat") {
              passenger.InfantName = passenger.InfantName ? "*****" : passenger.InfantName;
              passenger.InfantSurname = passenger.InfantSurname ? "*****" : passenger.InfantSurname;
              passenger.InfantGivenName = passenger.InfantGivenName ? "*****" : passenger.InfantGivenName;
              passenger.Fullname = passenger.Fullname ? "***** *****" : passenger.Fullname;
              passenger.Surname = passenger.Surname ? "*****" : passenger.Surname;
              passenger.GivenName = passenger.GivenName ? "*****" : passenger.GivenName;
            }
          }
        }
      }
    }
    /**
     * Temporary dummy tier data for manual verification on a specific flight.
     * Applies in-memory only when pax info is read from storage.
     * @memberof PaxInfoFactory
     * @param {object} paxInfo The passenger information
     * @param {number} flightId The flight id
     */


    function applyDummyTierDataForTestFlight(paxInfo, flightId) {
      if (!paxInfo || +flightId !== 1226977 || !paxInfo.Seatmap) {
        return;
      }

      var passengers = [];
      paxInfo.Seatmap.forEach(function (row) {
        row.Columns.forEach(function (column) {
          if (!column.IsEmptySeat && column.SeatMode == "Seat") {
            passengers.push(column);
          }
        });
      });

      if (passengers.length < 6) {
        return;
      }

      var tierAssignments = [{
        TierLevel: "PLTM",
        TierDescription: "Platinum",
        Carrier: "A3"
      }, {
        TierLevel: "GLDT",
        TierDescription: "Gold",
        Carrier: "A3"
      }, {
        TierLevel: "SLVT",
        TierDescription: "Silver",
        Carrier: "A3"
      }, {
        TierLevel: "BLUT",
        TierDescription: "Blue",
        Carrier: "A3"
      }, {
        TierLevel: "PLTM",
        TierDescription: "Platinum",
        Carrier: "A3"
      }, {
        TierLevel: "GLDT",
        TierDescription: "Gold",
        Carrier: "A3"
      }];
      tierAssignments.forEach(function (tierData, index) {
        var passenger = passengers[index];

        if (!passenger) {
          return;
        }

        passenger.Fqtv = passenger.Fqtv || {};
        passenger.Fqtv.Carrier = tierData.Carrier;
        passenger.Fqtv.TierLevel = tierData.TierLevel;
        passenger.Fqtv.TierDescription = tierData.TierDescription;
        passenger.Fqtv.Number = passenger.Fqtv.Number || "TEST" + String(index + 1).padStart(4, "0");
      });
      recalculateDummyTierSummaries(paxInfo);
    }
    /**
     * Recalculates tier summaries so counters match the injected test data.
     * @memberof PaxInfoFactory
     * @param {object} paxInfo The passenger information
     */


    function recalculateDummyTierSummaries(paxInfo) {
      if (!paxInfo || !paxInfo.Seatmap) {
        return;
      }

      paxInfo.PassengerSummaryC = paxInfo.PassengerSummaryC || {};
      paxInfo.PassengerSummaryY = paxInfo.PassengerSummaryY || {};
      paxInfo.PassengerSummaryC.FQTVPlatinum = 0;
      paxInfo.PassengerSummaryY.FQTVPlatinum = 0;
      paxInfo.PassengerSummaryC.FQTVGold = 0;
      paxInfo.PassengerSummaryY.FQTVGold = 0;
      paxInfo.PassengerSummaryC.FQTVSilver = 0;
      paxInfo.PassengerSummaryY.FQTVSilver = 0;
      paxInfo.Seatmap.forEach(function (row) {
        row.Columns.forEach(function (column) {
          if (column.IsEmptySeat || column.SeatMode != "Seat" || !column.Fqtv || !column.Cabin) {
            return;
          }

          var summary = column.Cabin == "C" ? paxInfo.PassengerSummaryC : paxInfo.PassengerSummaryY;

          if (column.Fqtv.TierLevel == "PLTM") {
            summary.FQTVPlatinum++;
          } else if (column.Fqtv.TierLevel == "GLDT") {
            summary.FQTVGold++;
          } else if (column.Fqtv.TierLevel == "SLVT" || column.Fqtv.TierLevel == "BLUT") {
            summary.FQTVSilver++;
          }
        });
      });
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('toolkit', toolkit);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name toolkit
  * @restrict E
  * @description
  *   Implementation of toolkit
  * @example
  *   Usage:
  *   <toolkit></toolkit>
  * @ngInject
  */

  function toolkit($timeout, ToolkitFactory, CustomerEventFactory) {
    function link(scope) {
      scope.closeAlert = closeAlert;
      scope.goBack = goBack;
      scope.removeCustomerEvent = removeCustomerEvent;
      scope.addEditIncident = addEditIncident;
      scope.isRedeemed = false;
      scope.getIsRedeemed = getIsRedeemed;
      scope.submitCustomerEvent = submitCustomerEvent;
      scope.toggleDeleteAlert = toggleDeleteAlert;
      scope.validForm = validForm;
      scope.emailFormat = /^[a-zA-Z]+[a-zA-Z0-9._]+@[a-zA-Z]+\.[a-zA-Z.]{2,5}$/;
      scope.mobileFormat = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
      scope.FQTVNumber = scope.passenger.Fqtv && scope.passenger.Fqtv.Carrier == "A3" ? scope.passenger.Fqtv.Number : null;
      setupToolkit();

      function setupToolkit() {
        initializeToolkit(scope.passenger, function (toolKitItems) {
          scope.toolkit = toolKitItems;
          scope.customerEvents = getCustomerEvents(toolKitItems, scope.flight.FlightId, scope.passenger.UCI);

          if (scope.toolkit.some(function (x) {
            return x.Treatments.length;
          })) {
            scope.treatmentAvailability({
              counter: scope.customerEvents.length
            });
          }

          if (scope.customerEvents.length > 0) {
            scope.isListView = true;
            scope.isEdit = false;
          } else {
            addEditIncident();
          }
        });
      }
      /**
      * Save Customer Event in local storage
      */


      function submitCustomerEvent() {
        var customerEvent = {
          ToolkitItemId: scope.newForm.selectedIncident.Id,
          TreatmentId: scope.newForm.selectedTreatment,
          PNR: scope.passenger.PNR,
          UCI: scope.passenger.UCI,
          FQTVNumber: scope.FQTVNumber,
          FQTVTierLevel: getFqtvTierLevelForCustomerEvent(scope.passenger, scope.newForm.selectedIncident, scope.newForm.selectedTreatment),
          NPS: scope.newForm.NPS,
          Comments: scope.newForm.CrewComments,
          FlightId: scope.flight.FlightId,
          FlightNo: scope.flight.FlightNo,
          Departure: scope.flight.Departure,
          Arrival: scope.flight.Arrival,
          FlightDate: scope.flight.FlightDate,
          Email: scope.newForm.passengerEmail,
          TelephoneCode: scope.newForm.telephoneCode,
          Mobile: scope.newForm.passengerMobile,
          ContactLanguage: scope.newForm.contactLanguage,
          GivenName: scope.passenger.GivenName,
          Surname: scope.passenger.Surname,
          SeatNo: scope.passenger.SeatNo,
          ClassOfService: scope.passenger.Cabin,
          LocalId: scope.newForm.LocalId ? scope.newForm.LocalId : moment().valueOf()
        };
        CustomerEventFactory.setCustomerEventToStorage(customerEvent);
        goBack();
        scope.isIncidentUpdated = true;
        $timeout(function () {
          scope.isIncidentUpdated = false;
        }, 5000);
      }
      /**
       * Add or update a customer event
       * @param {object} customerEvent Selected customer event from list (edit mode)
       */


      function addEditIncident(customerEvent) {
        scope.toolkitOptions = scope.toolkit.filter(function (x) {
          return !scope.customerEvents.some(function (y) {
            return y.Id == x.Id;
          }) && !x.Fallback;
        }).concat(scope.toolkit.filter(function (x) {
          return x.Fallback;
        }));
        scope.newForm = {
          selectedIncident: null,
          selectedTreatment: null,
          passengerEmail: null,
          contactLanguage: "EN",
          telephoneCode: "30",
          //Defaut value GR
          passengerMobile: null,
          NPS: null,
          CrewComments: null
        };
        scope.isEdit = customerEvent == null || customerEvent == undefined;

        if (customerEvent) {
          scope.newForm = {
            selectedIncident: customerEvent,
            selectedTreatment: customerEvent.CustomerEvent.TreatmentId,
            passengerEmail: customerEvent.CustomerEvent.Email,
            telephoneCode: customerEvent.CustomerEvent.TelephoneCode,
            passengerMobile: customerEvent.CustomerEvent.Mobile,
            contactLanguage: customerEvent.CustomerEvent.ContactLanguage,
            NPS: customerEvent.CustomerEvent.NPS,
            CrewComments: customerEvent.CustomerEvent.Comments,
            LocalId: customerEvent.CustomerEvent.LocalId
          };

          if (!scope.toolkitOptions.some(function (x) {
            return x.Id == customerEvent.Id;
          })) {
            scope.toolkitOptions.push(scope.toolkit.find(function (x) {
              return x.Id == customerEvent.Id;
            }));
          }
        }

        scope.isListView = false; //Change view
      }
      /**
       * Gets treatment redeem
       */


      function getIsRedeemed(item) {
        scope.isRedeem = scope.toolkitOptions.flatMap(function (x) {
          return x.Treatments;
        }).filter(function (s) {
          return s.Id == item;
        }).map(function (f) {
          return f.IsRedeemed;
        })[0];
      }
      /**
      * Go to Toolkit Items list view
      */


      function goBack() {
        scope.isIncidentUpdated = false;
        scope.deleteAlert = false;
        scope.isListView = true;
        scope.isEdit = false;
        scope.newForm = null;
        setupToolkit();
      }
      /**
       * Validate form before saving
       */


      function validForm() {
        // 1. Has a treatment selected
        // 2. Has NPS Score selected
        // 3. Has passenger email when nqtvNo is null or ( email or mobile is not null) 
        var validForm = false;
        var form = scope.newForm;

        if (form) {
          validForm = form.selectedIncident && form.selectedTreatment && form.NPS && (scope.FQTVNumber && (form.passengerEmail || form.passengerMobile) || !scope.FQTVNumber && form.passengerEmail);
        }

        return validForm;
      }
      /**
      * Remove Customer Event from local storage
      */


      function removeCustomerEvent() {
        CustomerEventFactory.removeCustomerEvent(scope.newForm.LocalId);
        scope.treatmentAvailability({
          counter: scope.customerEvents.length
        });
        goBack();
      }
      /**
       * Close successful save alert
       */


      function closeAlert() {
        scope.isIncidentUpdated = false;
      }

      function toggleDeleteAlert() {
        scope.deleteAlert = !scope.deleteAlert;
      }
    }

    var passengerCategories = {
      none: 0,
      gold: 1,
      business: 2,
      silver: 3,
      blue: 4,
      economy: 5,
      platinum: 6
    };
    /**
     * Gets all toolkit items and filter treatments depending on passenger's class
     * @param {object} passenger 
     * @param {function} callback 
     */

    function initializeToolkit(passenger, callback) {
      ToolkitFactory.getToolkitItemsFromStorage(function (toolKitItems) {
        var paxCategories = getPaxCategories(passenger);
        toolKitItems.forEach(function (item) {
          var matchingCategories = paxCategories.some(function (category) {
            return item.TouchpointCategories.includes(category);
          });
          var treatmentGroups = item.Treatments.groupByKey("PaxCategory");

          if (matchingCategories && paxCategories.contains(passengerCategories.platinum) && treatmentGroups[passengerCategories.platinum]) {
            item.Treatments = treatmentGroups[passengerCategories.platinum];
          } else if (matchingCategories && paxCategories.contains(passengerCategories.gold) && treatmentGroups[passengerCategories.gold]) {
            item.Treatments = treatmentGroups[passengerCategories.gold];
          } else if (matchingCategories && paxCategories.contains(passengerCategories.business) && treatmentGroups[passengerCategories.business]) {
            item.Treatments = treatmentGroups[passengerCategories.business];
          } else if (matchingCategories && paxCategories.contains(passengerCategories.silver) && treatmentGroups[passengerCategories.silver]) {
            item.Treatments = treatmentGroups[passengerCategories.silver];
          } else if (matchingCategories && paxCategories.contains(passengerCategories.blue) && treatmentGroups[passengerCategories.blue]) {
            item.Treatments = treatmentGroups[passengerCategories.blue];
          } else if (matchingCategories && paxCategories.contains(passengerCategories.economy) && treatmentGroups[passengerCategories.economy]) {
            item.Treatments = treatmentGroups[passengerCategories.economy];
          } else {
            //No available treatments for this passenger
            item.Treatments = [];
          }

          if (item.Treatments.length) {
            //Add 'No Treatment'
            item.Treatments = item.Treatments.concat(treatmentGroups[passengerCategories.none]);
          }
        }); //Toolkit Items without treatments should not be visible

        toolKitItems = toolKitItems.filter(function (t) {
          return t.Treatments && t.Treatments.length;
        });
        callback(toolKitItems);
      });
    }

    function getPaxCategories(passenger) {
      var passengerClass = passenger.Cabin;
      var passengerFqtv = passenger.Fqtv && passenger.Fqtv.Carrier == "A3" ? getPassengerTierDescription(passenger.Fqtv) : null;
      var paxCategories = [];

      if (passengerClass == 'C') {
        paxCategories.push(passengerCategories.business);
      }

      if (passengerFqtv == 'platinum') {
        paxCategories.push(passengerCategories.platinum);
      } else if (passengerFqtv == 'gold') {
        paxCategories.push(passengerCategories.gold);
      } else if (passengerFqtv == 'silver') {
        paxCategories.push(passengerCategories.silver);
      } else if (passengerFqtv == 'blue') {
        paxCategories.push(passengerCategories.blue);
      } else if (passengerClass == 'Y') {
        paxCategories.push(passengerCategories.economy);
      }

      return paxCategories;
    }

    function getPassengerTierDescription(fqtv) {
      if (!fqtv) {
        return null;
      }

      if (fqtv.TierDescription) {
        return fqtv.TierDescription.toLowerCase();
      }

      if (fqtv.TierLevel == "PLTM") {
        return "platinum";
      }

      return null;
    }

    function getFqtvTierLevelForCustomerEvent(passenger, selectedIncident, selectedTreatmentId) {
      if (!passenger.Fqtv || passenger.Fqtv.Carrier != "A3") {
        return null;
      }

      if (passenger.Fqtv.TierLevel == "PLTM" && !supportsPlatinumPassengers(selectedIncident, selectedTreatmentId)) {
        return null;
      }

      return passenger.Fqtv.TierLevel;
    }

    function supportsPlatinumPassengers(selectedIncident, selectedTreatmentId) {
      if (!selectedIncident) {
        return false;
      }

      if (selectedIncident.TouchpointCategories && selectedIncident.TouchpointCategories.includes(passengerCategories.platinum)) {
        return true;
      }

      var selectedTreatment = selectedIncident.Treatments && selectedIncident.Treatments.find(function (treatment) {
        return treatment.Id == selectedTreatmentId;
      });
      return selectedTreatment && selectedTreatment.PaxCategory == passengerCategories.platinum;
    }
    /**
     * Get customer events by flightId and UCI and attach them to their toolkitItem
     * @param {array} toolKitItems 
     * @param {number} flightId 
     * @param {number} UCI 
     */


    function getCustomerEvents(toolKitItems, flightId, UCI) {
      var customerEvents = []; //All events created for this passenger & on this flight

      var storedCustomerEvents = CustomerEventFactory.getFlightCustomerEvents(flightId, UCI);
      storedCustomerEvents.forEach(function (customerEvent) {
        var item = JSON.parse(JSON.stringify(toolKitItems.find(function (x) {
          return x.Id == customerEvent.ToolkitItemId;
        })));
        item.CustomerEvent = customerEvent;
        customerEvents.push(item);
      });
      return customerEvents;
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/OneStopShop/toolkit.tpl.html',
      scope: {
        flight: "=",
        passenger: "=",
        treatmentAvailability: "&onTreatmentAvailability"
      },
      link: link
    };
  }
})();
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

(function () {
  'use strict';

  a3_cabin_reports.factory('CustomerEventFactory', CustomerEventFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CustomerEventFactory
  * @description 
  *   Add, Update, Delete and Get Passenger Incidents
  * @ngInject
  */

  function CustomerEventFactory(GenericService) {
    var objType = 'CustomerEvents';
    var objCallback = CustomerEvent;
    /**
     * Initialize the Passenger Incident
     * @memberof CustomerEventFactory
     */

    function CustomerEvent() {
      this.GetId = GetId;
      this.Synced = false;
    }

    var service = {
      getCustomerEventsFromStorage: getCustomerEventsFromStorage,
      setCustomerEventToStorage: setCustomerEventToStorage,
      setCustomerEventsToStorage: setCustomerEventsToStorage,
      getCustomerEventsByFlightId: getCustomerEventsByFlightId,
      groupFlightCustomerEventsByPassenger: groupFlightCustomerEventsByPassenger,
      getFlightCustomerEvents: getFlightCustomerEvents,
      updateCustomerEvent: updateCustomerEvent,
      saveCustomerEvent: saveCustomerEvent,
      removeCustomerEvent: removeCustomerEvent,
      getUnsyncedCustomerEvents: getUnsyncedCustomerEvents,
      deleteOldCustomerEvents: deleteOldCustomerEvents
    };

    function GetId() {
      return this.LocalId;
    }
    /**
     * Save all Customer Events
     * @param {array} objList 
     */


    function setCustomerEventsToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }
    /**
     * Add or Update a Customer Event
     * @param {object} customerEvent 
     */


    function setCustomerEventToStorage(customerEvent) {
      var flightCustomerEvents = getFlightCustomerEvents(customerEvent.FlightId, customerEvent.UCI);

      if (flightCustomerEvents) {
        var incident = flightCustomerEvents.find(function (x) {
          return x.LocalId == customerEvent.LocalId;
        });

        if (incident) {
          updateCustomerEvent(customerEvent);
        } else {
          saveCustomerEvent(customerEvent);
        }
      } else {
        saveCustomerEvent(customerEvent);
      }
    }
    /**
     * Get all passenger events of a flight
     * @param {number} flightId 
     */


    function getCustomerEventsByFlightId(flightId) {
      var allIncidents = getCustomerEventsFromStorage();
      var flightIncidents = allIncidents.filter(function (x) {
        return x.FlightId == flightId;
      });
      return flightIncidents;
    }

    ;
    /**
     * Group all customer events of a flight by passenger
     * @param {number} flightId 
     */

    function groupFlightCustomerEventsByPassenger(flightId) {
      var oneStopShopPassengers = [];
      var allIncidents = getCustomerEventsFromStorage();
      var flightIncidents = allIncidents.filter(function (x) {
        return x.FlightId == flightId;
      });

      var oneStopShopPassengerIds = _toConsumableArray(new Set(flightIncidents.map(function (x) {
        return x.UCI;
      })));

      oneStopShopPassengerIds.forEach(function (id) {
        var incident = flightIncidents.find(function (x) {
          return x.UCI == id;
        });
        var passenger = {
          UCI: incident.UCI,
          GivenName: incident.GivenName,
          Surname: incident.Surname,
          SeatNo: incident.SeatNo,
          OneStopShopEvents: []
        };
        flightIncidents.filter(function (x) {
          return x.UCI == id;
        }).forEach(function (incident) {
          var event = {
            ToolkitItemId: incident.ToolkitItemId,
            TreatmentId: incident.TreatmentId,
            NPS: incident.NPS,
            Synced: incident.Synced
          };
          passenger.OneStopShopEvents.push(event);
        });
        oneStopShopPassengers.push(passenger);
      });
      return oneStopShopPassengers;
    }

    ;
    /**
     * Get all customer events
     */

    function getCustomerEventsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Get events for a specific passenger in a specific flight
     * @param {number} flightId 
     * @param {number} uci 
     */


    function getFlightCustomerEvents(flightId, uci) {
      var flightIncidents = getCustomerEventsByFlightId(flightId);
      var customerEvents = flightIncidents.filter(function (x) {
        return x.UCI == uci;
      });
      return customerEvents;
    }
    /**
     * Update a customer event (Search by FlightId-ToolkitItemId-UCI)
     * @param {object} customerEvent 
     */


    function updateCustomerEvent(customerEvent) {
      GenericService.save(customerEvent, objType, objCallback);
    }
    /**
     * Create a new customer event
     * @param {object} customerEvent 
     */


    function saveCustomerEvent(customerEvent) {
      GenericService.add(customerEvent, objType, objCallback);
    }
    /**
     * Remove customer event from storage   
     * @param {object} customerEvent 
     */


    function removeCustomerEvent(customerEventId) {
      GenericService.remove(customerEventId, objType, objCallback);
    }
    /**
     * Get Customers Events that have not yet been Synced
     */


    function getUnsyncedCustomerEvents() {
      var unsyncedEvents = getCustomerEventsFromStorage().filter(function (x) {
        return !x.Synced;
      }); //Give each event a temporary Id

      var tempId = 1;
      unsyncedEvents.forEach(function (event) {
        event.TemporaryId = tempId;
        tempId++; //No Treatment Id needs to be sent as null

        if (event.TreatmentId == -1) {
          event.TreatmentId = null;
        }
      });
      return unsyncedEvents;
    }
    /**
     * Deletes Customer Events that are older than 2 days
     * @memberof DataCleanerFactory
     */


    function deleteOldCustomerEvents() {
      var customerEvents = getCustomerEventsFromStorage();
      var fromDate = new Date();
      fromDate.setDate(fromDate.getDate() - 5);
      customerEvents = customerEvents.filter(function (x) {
        return x != null && x.FlightDate >= fromDate;
      });
      setCustomerEventsToStorage(customerEvents);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CustomerEventHistoryFactory', CustomerEventHistoryFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CustomerEventHistoryFactory
  * @description 
  *   Add, Update, Delete and Get History Customer Events for OneStopShop
  * @ngInject
  */

  function CustomerEventHistoryFactory(GenericService) {
    var objType = 'HistoryEvents';
    var objCallback = HistoryEvent;
    /**
     * Initialize the History Event
     * @memberof CustomerEventHistoryFactory
     */

    function HistoryEvent() {
      this.GetId = GetId;
    }

    var service = {
      setHistoryEventsToStorage: setHistoryEventsToStorage,
      getHistoryEventsFromStorage: getHistoryEventsFromStorage,
      getPassengerHistory: getPassengerHistory,
      refreshPassengerHistory: refreshPassengerHistory,
      deleteOldHistoryEvents: deleteOldHistoryEvents
    };

    function GetId() {
      return this.FlightId;
    }
    /**
     * Save all History Events
     * @param {array} objList 
     */


    function setHistoryEventsToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }
    /**
     * Get all History Events
     */


    function getHistoryEventsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     *  Get History Events of a specific passenger
     * @param {objects} passenger 
     */


    function getPassengerHistory(passenger) {
      var passengerFqtv = passenger.Fqtv ? passenger.Fqtv.Number : null;
      var passengerUci = passenger.UCI; //Filter passenger by FQTV and UCI

      var passengerHistoryEvents = getHistoryEventsFromStorage().filter(function (p) {
        return p.FQTVNumber && passengerFqtv && p.FQTVNumber == passengerFqtv || p.UCI == passengerUci;
      });
      return passengerHistoryEvents;
    }

    function refreshPassengerHistory(flightHistoryEvents) {
      var history = getHistoryEventsFromStorage();
      flightHistoryEvents.forEach(function (event) {
        var historyEvent = history.find(function (x) {
          return x.ToolkitItem.Id == event.ToolkitItem.Id && x.UCI == event.UCI && x.FlightNo == event.FlightNo && x.Departure == event.Departure && x.FlightDate == event.FlightDate;
        });

        if (!historyEvent) {
          GenericService.add(event, objType, objCallback);
        }
      });
    }
    /**
          * Deletes HistoryEvents that are older than 2 days
          * @memberof DataCleanerFactory
          */


    function deleteOldHistoryEvents() {
      var historyEvents = getHistoryEventsFromStorage();
      var fromDate = new Date();
      fromDate.setDate(fromDate.getDate() - 5);
      historyEvents = historyEvents.filter(function (x) {
        return x != null && x.FlightDate >= fromDate;
      });
      setHistoryEventsToStorage(historyEvents);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('history', history);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name history
  * @restrict E
  * @description
  *   Implementation of history
  * @example
  *   Usage:
  *   <history></history>
  * @ngInject
  */

  function history(ToolkitFactory, CustomerEventHistoryFactory) {
    function link(scope) {
      scope.history = CustomerEventHistoryFactory.getPassengerHistory(scope.passenger);
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/OneStopShop/history.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('onestopshopEvent', onestopshopEvent);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name onestopshopEvent
  * @restrict E
  * @description
  *   Implementation of onestopshopEvent
  * @example
  *   Usage:
  *   <onestopshop-event></onestopshop-event>
  * @ngInject
  */

  function onestopshopEvent() {
    function link(scope) {
      scope.ToolkitItem = scope.customerEvent.ToolkitItem;
      scope.Treatment = scope.customerEvent.Treatment;
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/OneStopShop/onestopshopEvent.tpl.html',
      scope: {
        customerEvent: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('ToolkitFactory', ToolkitFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name ToolkitFactory
   * @description 
   *   Add, Update, Delete and Get Memos.
   * @ngInject
   */

  function ToolkitFactory(IndexedDBService) {
    /**
     * Initialize the Toolkit Item
     * @memberof ToolkitFactory
     */
    function ToolkitItem() {
      this.Id = null;
    }

    var objType = 'ToolkitItems';
    var objCallback = ToolkitItem;
    var service = {
      setToolkitItemsFromServer: setToolkitItemsFromServer,
      getToolkitItemsFromStorage: getToolkitItemsFromStorage,
      setToolkitItemsToStorage: setToolkitItemsToStorage,
      saveToolkitItemToStorage: saveToolkitItemToStorage,
      addToolkitItemToStorage: addToolkitItemToStorage
    };
    /**
    * Set ToolkitItems from server API  
    * @memberof ToolkitFactory
    * @param {array} toolkitItems ToolkitItems Object
    */

    function setToolkitItemsFromServer(toolkitItems) {
      //Manually add 'No Treatment' option
      toolkitItems.forEach(function (item) {
        item.Treatments.push({
          Id: -1,
          PaxCategory: 0,
          Title: "No Treatment",
          Description: "",
          Type: "",
          Comments: null,
          ToolkitItemId: item.Id
        });
      });
      getToolkitItemsFromStorage(function (localToolkitItems) {
        // No Toolkit Items found - Save All Incoming
        if (!localToolkitItems || localToolkitItems.length == 0) {
          setToolkitItemsToStorage(toolkitItems);
        } else {
          for (var j = 0; j < toolkitItems.length; j++) {
            var isToolkitItemIncluded = false;

            for (var h = 0; h < localToolkitItems.length; h++) {
              if (toolkitItems[j].Id == localToolkitItems[h].Id) {
                isToolkitItemIncluded = true;
                break;
              }
            } //Update


            if (isToolkitItemIncluded) {
              saveToolkitItemToStorage(toolkitItems[j]);
            } //Add 
            else {
                addToolkitItemToStorage(toolkitItems[j]);
              }
          }

          localToolkitItems.filter(function (x) {
            return !toolkitItems.some(function (z) {
              return z.Id == x.Id;
            });
          }).forEach(function (item) {
            IndexedDBService.remove(objType, item.Id);
          });
        }
      });
    }
    /**
     * Get Toolkit Items
     * @memberof ToolkitFactory
     * @param {*} callback 
     */


    function getToolkitItemsFromStorage(callback) {
      IndexedDBService.getAll(objType).then(function (results) {
        callback(results);
      });
    }
    /**
     * Set Toolkit Items
     * @memberof ToolkitFactory
     * @param {array} ToolkitItems A list of Toolkit Items to set to indexedDB
     */


    function setToolkitItemsToStorage(ToolkitItems, callback, errorCallback) {
      IndexedDBService.addAll(objType, ToolkitItems).then(callback)["catch"](errorCallback);
      ;
    }

    ;
    /**
     * Add Toolkit Item to Storage
     * @memberof ToolkitFactory
     * @param {object} ToolkitItem
     */

    function addToolkitItemToStorage(ToolkitItem, callback, errorCallback) {
      IndexedDBService.add(objType, ToolkitItem).then(callback)["catch"](errorCallback);
    }

    ;
    /**
     * Update Toolkit Item in Storage
     * @memberof ToolkitFactory
     * @param {object} ToolkitItem
     */

    function saveToolkitItemToStorage(ToolkitItem, callback, errorCallback) {
      IndexedDBService.put(objType, ToolkitItem).then(callback)["catch"](errorCallback);
    }

    ;
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('philoxeniaQuestions', philoxeniaQuestions);
  /**
     * @memberof CabinReports
     * @ngdoc directive
     * @name philoxeniaQuestions
     * @restrict E
     * @description
     *   Implementation of philoxenia questions 
     *
     * Display the philoxenia questions Panel
     * @attr {String} flight-id
     * @example
     *   Usage:
     *   <philoxenia-questions flight-id="123"></philoxenia-questions>
     *   
     * @ngInject
     */

  function philoxeniaQuestions(PhiloxeniaQuestionsFactory) {
    /**
     * Initialize philoxeniaQuestions
     * @memberof philoxeniaQuestions
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attributes attributes of this element
     */
    function link(scope, element, attributes) {
      scope.togglePanel = togglePanel;
      scope.hasPhiloxeniaData = true;
      scope.philoxeniaData = null;
      scope.showPanel = showPanel();
      initializePanel();
      /**
       * Initialize Form Values
       * @memberof philoxeniaQuestions
       */

      function initializePanel() {
        var flightQuestions = PhiloxeniaQuestionsFactory.getFlightPhiloxeniaQuestionsFromStorage(+scope.flightId);

        if (!flightQuestions || !flightQuestions.Questions > 0 || !flightQuestions.RepliesCounter > 0) {
          scope.hasPhiloxeniaData = false;
        } else {
          scope.hasPhiloxeniaData = true;
          scope.philoxeniaData = flightQuestions;
        }
      }

      function showPanel() {
        var retVal = false;
        var now = moment.utc();
        var std = moment.utc(scope.std);
        var isAfter = now.isAfter(std);

        if (isAfter) {
          retVal = true;
        }

        return retVal;
      }
      /**
       * Toggle Panel
       * @memberof philoxeniaQuestions
       * @param {number} panelId
       */


      function togglePanel(panelId) {
        $('#' + panelId).toggle();
      }
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/directives/philoxeniaQuestions.tpl.html',
      scope: {
        flightId: '@',
        std: '@'
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('PhiloxeniaQuestionsFactory', PhiloxeniaQuestionsFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name PhiloxeniaQuestionsFactory
   * @ngInject
   */

  function PhiloxeniaQuestionsFactory(GenericService) {
    function PhiloxeniaQuestions() {
      this.FlightId = null;
      this.Questions = null;
      this.RepliesCounter = 0;
    }

    var objType = 'philoxeniaQuestions';
    var objCallback = PhiloxeniaQuestions;
    var ratingQuestions = [{
      Option: 1,
      OptionText: "Basic",
      Counter: 0,
      Percentage: null
    }, {
      Option: 2,
      OptionText: "Basic +",
      Counter: 0,
      Percentage: null
    }, {
      Option: 3,
      OptionText: "Expected",
      Counter: 0,
      Percentage: null
    }, {
      Option: 4,
      OptionText: "Expected +",
      Counter: 0,
      Percentage: null
    }, {
      Option: 5,
      OptionText: "Excellent",
      Counter: 0,
      Percentage: null
    }];
    var service = {
      updatePhiloxeniaQuestionsToStorage: updatePhiloxeniaQuestionsToStorage,
      getFlightPhiloxeniaQuestionsFromStorage: getFlightPhiloxeniaQuestionsFromStorage,
      cleanOldData: cleanOldData
    };
    /**
    * Get Philoxenia Questions.
    * @memberof PhiloxeniaQuestionsFactory
    * @returns {Array} PhiloxeniaQuestions 
    */

    function getPhiloxeniaQuestionsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Save Philoxenia Questions to storage
     * @memberof PhiloxeniaQuestionsFactory
     * @param {Array} PhiloxeniaQuestions
     */


    function setPhiloxeniaQuestionsToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }
    /**
     * Update Philoxenia Questions for specified flight
     * @memberof PhiloxeniaQuestionsFactory
     * @param {} PhiloxeniaQuestions questions for a flight
     * @returns {Array} PhiloxeniaQuestions
     */


    function updatePhiloxeniaQuestionsToStorage(philoxeniaQuestions) {
      //Get all PhiloxeniaQuestions exept current flight from storage
      var storedPhiloxeniaQuestions = getPhiloxeniaQuestionsFromStorage();
      var storedPhiloxeniaQuestionsFiltered = storedPhiloxeniaQuestions.filter(function (f) {
        return f != null && f.FlightId != philoxeniaQuestions.FlightId;
      }); //Add Philoxenia Questions for the current flight

      if (philoxeniaQuestions) {
        //get AVG value for Rating questions
        philoxeniaQuestions.Questions.forEach(function (question) {
          if (question.QuestionInfo.Type == "RATING") {
            //Get Option List
            var optionList = [];
            ratingQuestions.forEach(function (option) {
              var currentAnswer = question.AnswerCounters.filter(function (f) {
                return f.OptionId == option.Option;
              });

              if (currentAnswer.length > 0 && philoxeniaQuestions.RepliesCounter > 0) {
                option.Counter = currentAnswer[0].Counter;
                option.Percentage = currentAnswer[0].Counter / philoxeniaQuestions.RepliesCounter * 100;
              }

              optionList.push(option);
            });
            question.OptionList = optionList; //Get AVG value

            var value = 0;
            var weight = 0;
            question.AnswerCounters.forEach(function (answer) {
              value += +answer.TextValue * answer.Counter;
              weight += answer.Counter;
            });

            if (weight > 0) {
              question.AVG = value / weight;
            }
          } else {
            var selectedOptionIds = question.AnswerCounters.map(function (v) {
              return v.OptionId;
            }); //get AnswerCounter for selections with zero counter

            var optionsZeroCounter = question.QuestionInfo.Options.filter(function (x) {
              return !selectedOptionIds.includes(x.Id);
            });
            var optionsZeroCounterMapper = optionsZeroCounter.map(function (a) {
              return {
                OptionId: a.Id,
                TextValue: a.Value,
                Counter: 0
              };
            });
            question.AnswerCounters = question.AnswerCounters.concat(optionsZeroCounterMapper);
            question.AVG = 0;
          }
        }); //Get only questions with answers

        philoxeniaQuestions.Questions = philoxeniaQuestions.Questions.filter(function (f) {
          return f.AnswerCounters && f.AnswerCounters.length > 0;
        });
        storedPhiloxeniaQuestionsFiltered.push(philoxeniaQuestions); //save PhiloxeniaQuestions

        setPhiloxeniaQuestionsToStorage(storedPhiloxeniaQuestionsFiltered);
      }
    }
    /**
     * Get Philoxenia Questions for specified flight
     * @memberof PhiloxeniaQuestionsFactory
     * @param {number} flightId
     * @returns {Array} PhiloxeniaQuestions
     */


    function getFlightPhiloxeniaQuestionsFromStorage(flightId) {
      var storedPhiloxeniaQuestions = getPhiloxeniaQuestionsFromStorage();

      if (storedPhiloxeniaQuestions) {
        var flightPhiloxeniaQuestions = storedPhiloxeniaQuestions.filter(function (x) {
          return x != null && x.FlightId == flightId;
        });
        return flightPhiloxeniaQuestions[0];
      } else {
        return null;
      }
    }
    /**
    * Clean ls from old flights Philoxenia Questions
    * @param {array} flights Synced flights
    */


    function cleanOldData(responseFlightIds) {
      var previousPhiloxeniaQuestions = getPhiloxeniaQuestionsFromStorage(); //Filter out Philoxenia Questions of old flights

      previousPhiloxeniaQuestions = previousPhiloxeniaQuestions.filter(function (x) {
        return x != null && responseFlightIds.includes(x.FlightId);
      });
      setPhiloxeniaQuestionsToStorage(previousPhiloxeniaQuestions);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('MisconnectionFlightsFactory', MisconnectionFlightsFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name MisconnectionFlightsFactory
  * @description 
  * Get selected flight info
  * @ngInject
  */

  function MisconnectionFlightsFactory(GenericService) {
    var service = {
      setMisconnectionFlights: setMisconnectionFlights,
      getMisconnectionFlights: getMisconnectionFlights,
      getMisconnectionFlightsByFlightIdFromLS: getMisconnectionFlightsByFlightIdFromLS,
      upsertMisconnectionFlights: upsertMisconnectionFlights,
      cleanOldDataMisconnectionFlights: cleanOldDataMisconnectionFlights
    };
    /**
    * Initialize the MisconnectionFlights
    * @memberof MisconnectionFlightsFactory
    */

    function MisconnectionFlight() {
      this.DisruptedFlightId = null;
      this.DisruptedFltNo = null;
      this.DisruptedFlightCarrier = null;
      this.DisruptedFlightDate = null;
      this.DisruptedFlightDepature = null;
      this.DisruptedFlightArrival = null;
      this.DisruptedFlightDep_Gate = null;
      this.DisruptedFlightSTD = null;
      this.DisruptedFlightSTD_Local = null;
      this.DisruptedFlightETD = null;
      this.DisruptedFlightETD_Local = null;
      this.DisruptedFlightATD = null;
      this.DisruptedFlightATD_Local = null; //todo: additional fields for the connecting flight

      this.Passengers = [];
    }

    var objType = 'misconnectionFlightList';
    var objTypeCallback = MisconnectionFlight;
    /**
     * Save Misconnection Flights
     * @memberof MisconnectionFlightsFactory
     * @param {Array} misconnectionFlights
     */

    function setMisconnectionFlights(misconnectionFlights) {
      GenericService.saveAll(misconnectionFlights, objType);
    }
    /**
     * Get Misconnection Flights
     * @memberof MisconnectionFlightsFactory
     * @returns {Array} MisconnectionFlights
     */


    function getMisconnectionFlights() {
      return GenericService.list(objType, objTypeCallback);
    }
    /**
     * Get Misconnection Flights by FlightId from Local Storage
     * @memberof MisconnectionFlightsFactory
     */


    function getMisconnectionFlightsByFlightIdFromLS(flightId) {
      var storedMisconnectionFlights = getMisconnectionFlights();
      return storedMisconnectionFlights.filter(function (x) {
        return x.DisruptedFlightId == flightId;
      });
    }

    function upsertMisconnectionFlights(misconnectionFlights) {
      var flightIds = misconnectionFlights.map(function (x) {
        return x.DisruptedFlightId;
      });
      var storedMisconnectionFlights = getMisconnectionFlights();
      var otherMisconnectionFlights = storedMisconnectionFlights.filter(function (x) {
        return !flightIds.includes(x.DisruptedFlightId);
      });
      var mergeMisconnectionFlights = otherMisconnectionFlights.concat(misconnectionFlights);
      setMisconnectionFlights(mergeMisconnectionFlights);
    }
    /**
     * Clean Old Data Service Events
     * @memberof MisconnectionFlightsFactory
     * @param {Array} responseFlightIds
     */


    function cleanOldDataMisconnectionFlights(responseFlightIds) {
      var storedMisconnectionFlights = getMisconnectionFlights();
      var previousMisconnectionFlights = storedMisconnectionFlights.filter(function (x) {
        return responseFlightIds.includes(x.DisruptedFlightId);
      });
      setMisconnectionFlights(previousMisconnectionFlights);
    }

    return service;
  }
})();
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  'use strict';

  a3_cabin_reports.directive('misconnectionFlightsPanel', misconnectionFlightsPanel);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name misconnectionFlightsPanel
  * @restrict E
  * @description
  *   Implementation of misconnectionFlights panel
  * @example
  *   Usage:
  *   <misconnection-flights-panel></misconnection-flights-panel>
  * @ngInject
  */

  function misconnectionFlightsPanel(MisconnectionFlightsFactory, PaxInfoFactory, defaultCalendarDate) {
    function link(scope, element, attributes) {
      scope.showMisconnectionFlightsPanel = false;
      scope.preparedFlights = [];
      scope.getDisplayETD = getDisplayETD;
      scope.calcConnection = calcConnection;
      scope.hasAnyEscort = false;
      scope.hasAnyReprotection = false; //scope.paxInfo;
      // This directive can render on routes where no flight object exists.

      if (!scope.flight || !scope.flight.FlightId) {
        return;
      }

      var currentFlightId = null; //get from LS the misconnection flights

      if (defaultCalendarDate && scope.flight && scope.flight.FlightId == 1226541) {
        currentFlightId = 2242084; //<=(747 17-6-2016) 
      } else {
        currentFlightId = scope.flight ? scope.flight.FlightId : null;
      }

      getMisconnectionFlights(currentFlightId); //get misconnection flights by flight id from LS and prepare data for the panel

      function getMisconnectionFlights(flightId) {
        var misconnectionFlights = MisconnectionFlightsFactory.getMisconnectionFlightsByFlightIdFromLS(flightId);
        prepareMisconnectionTable(misconnectionFlights);
        scope.showMisconnectionFlightsPanel = true;
      } //prepare data for the misconnection flights panel


      function prepareMisconnectionTable(misconnectionFlights) {
        var flightsWithActions = [];
        var connectingFlights = [];
        var preparedFlights = [];
        PaxInfoFactory.getPaxInfoFromStorage(scope.flight.FlightId, function (paxInfo) {
          if (paxInfo) {
            connectingFlights = paxInfo.ConnectingFlights || [];
            misconnectionFlights.forEach(function (disrupted) {
              var allActions = [];
              disrupted.Passengers.forEach(function (p) {
                // Find STD and FlightNumber from THIS passenger's action with FlightOccurrenceOrder == 0
                var sortBySTD = null;
                var parentFlightNumber = null;
                var action0 = p.Actions.find(function (action) {
                  return action.FlightOccurrenceOrder === 0;
                });

                if (action0) {
                  sortBySTD = action0.STD;
                  parentFlightNumber = action0.FlightNumber;
                }

                p.Actions.forEach(function (a) {
                  allActions.push(_objectSpread({}, a, {
                    UCI: p.UCI,
                    sortBySTD: sortBySTD,
                    parentFlightNumber: parentFlightNumber
                  }));
                });
              }); // Group by FlightNumber + FlightDate + ParentFlightNumber

              var grouped = {};
              allActions.forEach(function (a) {
                var groupKey = (a.parentFlightNumber || '') + '_' + a.FlightNumber + a.FlightDate + '_' + a.HasReprotectedAction;

                if (!grouped[groupKey]) {
                  grouped[groupKey] = {
                    flight: a,
                    pax: [],
                    hasReprotectedAction: false,
                    hasEscortAction: false,
                    sortBySTD: a.sortBySTD,
                    parentFlightNumber: a.parentFlightNumber
                  };
                }

                grouped[groupKey].pax.push({
                  UCI: a.UCI
                });
                grouped[groupKey].hasReprotectedAction = grouped[groupKey].hasReprotectedAction || a.HasReprotectedAction;
                grouped[groupKey].hasEscortAction = grouped[groupKey].hasEscortAction || a.HasEscortAction;
              }); // Sort flights by Order and map to final structure

              var sortedFlights = Object.keys(grouped).map(function (key) {
                var x = grouped[key]; // Calculate passenger summaries from the grouped actions

                var passengerSummaryC = {
                  Passengers: 0,
                  PRM: 0,
                  UMNR: 0,
                  DEP: 0
                };
                var passengerSummaryY = {
                  Passengers: 0,
                  PRM: 0,
                  UMNR: 0,
                  DEP: 0
                }; // Find all matching actions for this flight to get cabin class info

                allActions.forEach(function (action) {
                  if (action.FlightNumber === x.flight.FlightNumber && action.FlightDate === x.flight.FlightDate && action.FlightOccurrenceOrder === x.flight.FlightOccurrenceOrder && action.HasReprotectedAction === x.hasReprotectedAction) {
                    if (action.CabinClass === 'C') {
                      passengerSummaryC.Passengers++;
                      if (action.HasPRM) passengerSummaryC.PRM++;
                      if (action.HasUMNR) passengerSummaryC.UMNR++;
                      if (action.HasDEP) passengerSummaryC.DEP++;
                    } else if (action.CabinClass === 'Y') {
                      passengerSummaryY.Passengers++;
                      if (action.HasPRM) passengerSummaryY.PRM++;
                      if (action.HasUMNR) passengerSummaryY.UMNR++;
                      if (action.HasDEP) passengerSummaryY.DEP++;
                    }
                  }
                });
                return {
                  FlightNumber: x.flight.FlightNumber,
                  FlightDate: x.flight.FlightDate,
                  Departure: x.flight.Departure,
                  Arrival: x.flight.Arrival,
                  STD: x.flight.STD,
                  Gate: x.flight.Dep_Gate,
                  Order: x.flight.FlightOccurrenceOrder,
                  Pax: x.pax.length,
                  HasReprotectedAction: x.hasReprotectedAction,
                  HasEscortAction: x.hasEscortAction,
                  ActionTimestamp: x.flight.ActionTimestamp,
                  SortBySTD: x.sortBySTD,
                  ParentFlightNumber: x.parentFlightNumber,
                  PassengerSummaryC: passengerSummaryC,
                  PassengerSummaryY: passengerSummaryY
                };
              }).sort(function (a, b) {
                return a.Order - b.Order;
              });
              var prevETA = null; // Calculate connection times

              sortedFlights.forEach(function (f) {
                if (f.Order === 0 || f.Order === 1) {
                  //scope value from user settings
                  prevETA = scope.flightETA;
                }

                f.Connection = calcConnection(f.STD, prevETA);
                var currentETA = new Date(f.STA);

                if (f.ETA) {
                  currentETA = new Date(f.ETA);
                }

                prevETA = currentETA;
              }); // Add to flightsWithActions

              sortedFlights.forEach(function (f) {
                return flightsWithActions.push({
                  DisruptedFlightId: disrupted.DisruptedFlightId,
                  Connection: f.Connection,
                  FlightNo: f.FlightNumber,
                  FlightDate: f.FlightDate,
                  Departure: f.Departure,
                  Arrival: f.Arrival,
                  Pax: f.Pax,
                  // FIX: Removed conditional - keep actual pax count
                  DepartureGate: f.Gate,
                  ETD: f.STD,
                  STD: f.STD,
                  // FIX: Added STD for getDisplayETD function
                  Order: f.Order,
                  HasReprotection: f.HasReprotectedAction,
                  HasEscort: f.HasEscortAction,
                  MatchChecked: false,
                  PaxCounter: f.Pax,
                  ActionTimestamp: f.ActionTimestamp,
                  SortBySTD: f.SortBySTD,
                  ParentFlightNumber: f.ParentFlightNumber,
                  PassengerSummaryC: f.PassengerSummaryC,
                  PassengerSummaryY: f.PassengerSummaryY
                });
              });
            }); //Sort by ActionTimestamp 

            flightsWithActions = flightsWithActions.sort(function (a, b) {
              return new Date(a.ActionTimestamp) - new Date(b.ActionTimestamp);
            }); // Match connecting flights with actions

            connectingFlights.forEach(function (connFlight) {
              var matchedFlights = flightsWithActions.filter(function (f) {
                return f.FlightNo === connFlight.FlightNo && f.FlightDate === connFlight.FlightDate && f.Departure === connFlight.Departure && //f.HasReprotection === connFlight.HasReprotection &&
                //f.HasEscort === connFlight.HasEscort &&
                f.Order === 1;
              });

              if (matchedFlights.length > 0) {
                // YES: apply flags and mark as matched
                matchedFlights.forEach(function (matchedFlight) {
                  matchedFlight.MatchChecked = true; // Save the action summaries before overwriting

                  matchedFlight.ActionSummaryC = JSON.parse(JSON.stringify(matchedFlight.PassengerSummaryC));
                  matchedFlight.ActionSummaryY = JSON.parse(JSON.stringify(matchedFlight.PassengerSummaryY));
                  matchedFlight.PaxCounter = (connFlight.PassengerSummaryC.Passengers || 0) + (connFlight.PassengerSummaryY.Passengers || 0);
                  matchedFlight.PassengerSummaryC = connFlight.PassengerSummaryC;
                  matchedFlight.PassengerSummaryY = connFlight.PassengerSummaryY;
                });
              } else {
                // NO: create a new entry for unmatched connecting flight
                var tempFlight = {
                  FlightNo: connFlight.FlightNo,
                  FlightDate: connFlight.FlightDate,
                  Departure: connFlight.Departure,
                  Arrival: connFlight.Arrival,
                  ETD: connFlight.ETD,
                  STD: connFlight.STD,
                  DepartureGate: connFlight.Dep_Gate,
                  Order: 0,
                  HasReprotection: false,
                  HasEscort: connFlight.HasEscort,
                  //false,
                  Connection: calcConnection(connFlight.STD, scope.flightETA),
                  PassengerSummaryC: connFlight.PassengerSummaryC,
                  PassengerSummaryY: connFlight.PassengerSummaryY,
                  MatchChecked: false,
                  PaxCounter: connFlight.PassengerIds.length,
                  SortBySTD: connFlight.STD || connFlight.ETD,
                  ParentFlightNumber: connFlight.FlightNo
                };
                preparedFlights.push(tempFlight);
              }
            }); // Add flights from flightsWithActions

            flightsWithActions.forEach(function (f) {
              var isNewAction = IsNewAction(f.ActionTimestamp, scope.flight.ScheduledDeparture);
              f.IsNewAction = isNewAction;

              if (!f.PassengerSummaryC) {
                f.PassengerSummaryC = {
                  Passengers: 0,
                  PRM: 0,
                  UMNR: 0,
                  DEP: 0
                };
              }

              if (!f.PassengerSummaryY) {
                f.PassengerSummaryY = {
                  Passengers: 0,
                  PRM: 0,
                  UMNR: 0,
                  DEP: 0
                };
              }

              if (f.Order <= 1 && isNewAction) {
                // paxCounter: all pax, Pax: pax from paxInfo (simple connections)
                if (f.MatchChecked && f.PaxCounter != f.Pax) {
                  // Find all matched actions for the same flight, get sums of their passengers.
                  var matchedFlights = flightsWithActions.filter(function (mf) {
                    return mf.FlightNo === f.FlightNo && mf.FlightDate === f.FlightDate && mf.Departure === f.Departure && mf.MatchChecked === true;
                  });
                  var totalActionSummaryC = {
                    Passengers: 0,
                    PRM: 0,
                    UMNR: 0,
                    DEP: 0
                  };
                  var totalActionSummaryY = {
                    Passengers: 0,
                    PRM: 0,
                    UMNR: 0,
                    DEP: 0
                  }; // Sum up all ActionSummaries from matched flights

                  matchedFlights.forEach(function (mf) {
                    if (mf.ActionSummaryC) {
                      totalActionSummaryC.Passengers += mf.ActionSummaryC.Passengers || 0;
                      totalActionSummaryC.PRM += mf.ActionSummaryC.PRM || 0;
                      totalActionSummaryC.UMNR += mf.ActionSummaryC.UMNR || 0;
                      totalActionSummaryC.DEP += mf.ActionSummaryC.DEP || 0;
                    }

                    if (mf.ActionSummaryY) {
                      totalActionSummaryY.Passengers += mf.ActionSummaryY.Passengers || 0;
                      totalActionSummaryY.PRM += mf.ActionSummaryY.PRM || 0;
                      totalActionSummaryY.UMNR += mf.ActionSummaryY.UMNR || 0;
                      totalActionSummaryY.DEP += mf.ActionSummaryY.DEP || 0;
                    }
                  });
                  var simplePaxC = {
                    Passengers: (f.PassengerSummaryC.Passengers || 0) - totalActionSummaryC.Passengers,
                    PRM: (f.PassengerSummaryC.PRM || 0) - totalActionSummaryC.PRM,
                    UMNR: (f.PassengerSummaryC.UMNR || 0) - totalActionSummaryC.UMNR,
                    DEP: (f.PassengerSummaryC.DEP || 0) - totalActionSummaryC.DEP
                  };
                  var simplePaxY = {
                    Passengers: (f.PassengerSummaryY.Passengers || 0) - totalActionSummaryY.Passengers,
                    PRM: (f.PassengerSummaryY.PRM || 0) - totalActionSummaryY.PRM,
                    UMNR: (f.PassengerSummaryY.UMNR || 0) - totalActionSummaryY.UMNR,
                    DEP: (f.PassengerSummaryY.DEP || 0) - totalActionSummaryY.DEP
                  };
                  var tempFlight = {
                    FlightNo: f.FlightNo,
                    Departure: f.Departure,
                    Arrival: f.Arrival,
                    ETD: f.ETD,
                    STD: f.STD,
                    DepartureGate: f.Dep_Gate,
                    Order: 0,
                    HasReprotection: false,
                    HasEscort: f.HasEscort,
                    //false,
                    Connection: calcConnection(f.STD, scope.flightETA),
                    PassengerSummaryC: simplePaxC,
                    PassengerSummaryY: simplePaxY,
                    MatchChecked: true,
                    PaxCounter: simplePaxC.Passengers + simplePaxY.Passengers,
                    //Order:0 sortSTD and parent from current flight
                    SortBySTD: f.ETD || f.STD,
                    ParentFlightNumber: f.FlightNo
                  }; //check if already added the flight:

                  var alreadyAdded = preparedFlights.some(function (pf) {
                    return pf.FlightNo === tempFlight.FlightNo && (pf.STD === tempFlight.STD || pf.ETD === tempFlight.ETD) && pf.Departure === tempFlight.Departure && pf.PaxCounter === tempFlight.PaxCounter && pf.Order === 0;
                  }); // Only add to preparedFlights if there are passengers after adjusting for reprotection actions

                  if (tempFlight.PaxCounter > 0 && !alreadyAdded && !f.HasEscort) {
                    preparedFlights.push(tempFlight);
                  } //Add flight with reprotections (use action summaries)


                  f.PassengerSummaryC = f.ActionSummaryC || {
                    Passengers: 0,
                    PRM: 0,
                    UMNR: 0,
                    DEP: 0
                  };
                  f.PassengerSummaryY = f.ActionSummaryY || {
                    Passengers: 0,
                    PRM: 0,
                    UMNR: 0,
                    DEP: 0
                  };
                  f.PaxCounter = f.HasEscort ? f.PaxCounter : f.Pax || 0;
                  preparedFlights.push(f);
                } else {
                  var currentPaxCounter = 0;

                  if (f.PassengerSummaryC && f.PassengerSummaryY) {
                    currentPaxCounter = (f.PassengerSummaryC.Passengers || 0) + (f.PassengerSummaryY.Passengers || 0);
                  } else {
                    currentPaxCounter = f.Pax;
                  }

                  f.PaxCounter = currentPaxCounter; //set pax counters to 0

                  if (f.HasReprotection && f.Order === 0) {
                    f.PaxCounter = 0;
                    f.PassengerSummaryC = {
                      Passengers: 0,
                      PRM: 0,
                      UMNR: 0,
                      DEP: 0
                    };
                    f.PassengerSummaryY = {
                      Passengers: 0,
                      PRM: 0,
                      UMNR: 0,
                      DEP: 0
                    };
                  }

                  preparedFlights.push(f);
                }
              } else if (f.Order == 1 && !isNewAction) {
                //if is old action, just show the connecting flight with no reprotection color, no canceled flight and without padding
                f.Order = 0;
                f.HasReprotection = false;
                preparedFlights.push(f);
              }
            }); // Set flags for panel legend

            scope.hasAnyEscort = preparedFlights.some(function (f) {
              return f.HasEscort;
            });
            scope.hasAnyReprotection = preparedFlights.some(function (f) {
              return f.HasReprotection && f.IsNewAction;
            }); // Sort preparedFlights: first by SortBySTD, then by ParentFlightNumber, then by actual STD, then by Order desc

            scope.preparedFlights = preparedFlights.sort(function (a, b) {
              // First sort by SortBySTD (handle null/undefined - use STD as fallback)
              var stdA = a.SortBySTD ? new Date(a.SortBySTD).getTime() : a.STD ? new Date(a.STD).getTime() : 0;
              var stdB = b.SortBySTD ? new Date(b.SortBySTD).getTime() : b.STD ? new Date(b.STD).getTime() : 0;

              if (stdA !== stdB) {
                return stdA - stdB;
              } // If SortBySTD is equal, sort by ParentFlightNumber


              var parentA = a.ParentFlightNumber || '';
              var parentB = b.ParentFlightNumber || '';

              if (parentA !== parentB) {
                return parentA.localeCompare(parentB);
              } // If ParentFlightNumber is equal, sort by actual flight time (ETD or STD)


              var departureTimeA = a.ETD ? new Date(a.ETD).getTime() : a.STD ? new Date(a.STD).getTime() : 0;
              var departureTimeB = b.ETD ? new Date(b.ETD).getTime() : b.STD ? new Date(b.STD).getTime() : 0;

              if (departureTimeA !== departureTimeB) {
                return departureTimeA - departureTimeB;
              } // If actual STD is also equal, sort by Order desc (1 first, then 0)


              var orderA = a.Order || 0;
              var orderB = b.Order || 0;
              return orderB - orderA;
            });
          }
        });
      } //check if the action is new (within 60 minutes before flight STD)


      function IsNewAction(actionTimestamp, flightSTD) {
        //return true; //only for the tests
        if (defaultCalendarDate && scope.flight.FlightId == 1226541) {
          console.log('opa!');
          return true; //always new for test flight
        }

        var isNew = false;
        var std = new Date(flightSTD);
        var ts = new Date(actionTimestamp);

        if (isNaN(std.getTime()) || isNaN(ts.getTime())) {
          return isNew;
        }

        var diffMinutes = (std.getTime() - ts.getTime()) / 60000;

        if (diffMinutes <= 60) {
          isNew = true;
        }

        return isNew;
      }

      scope.$watch('flightETA', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          reCalculateConnections(newValue);
        }
      });

      function reCalculateConnections(newTempETA) {
        var prevETA = null; // Calculate connection times

        scope.preparedFlights.forEach(function (f) {
          if (f.Order === 0 || f.Order === 1) {
            //scope value from user settings
            prevETA = scope.flightETA;
          }

          f.Connection = calcConnection(f.STD, newTempETA);
          var currentETA = new Date(f.STA);

          if (f.ETA) {
            currentETA = new Date(f.ETA);
          }

          prevETA = currentETA;
        });
      } //calculate connection time between disrupted flight and connecting flight


      function calcConnection(currentSTD, prevETA) {
        var timeString = '';
        var sign = '';
        var dayString = null;

        if (currentSTD) {
          var connFlightDate = new Date(currentSTD);
          var ms = connFlightDate.getTime() - prevETA; // this is a time in milliseconds

          if (ms < 0) {
            ms = -ms;
            sign = "-";
          }

          var days = Math.floor(ms / (24 * 60 * 60 * 1000));
          days = days < 0 ? days + 1 : days;
          var daysms = ms % (24 * 60 * 60 * 1000);
          var hours = Math.floor(daysms / (60 * 60 * 1000));
          var hoursms = ms % (60 * 60 * 1000);
          var minutes = Math.floor(hoursms / (60 * 1000));
          timeString = '<strong>' + sign + (hours > 0 ? ("0" + hours).substr(-2) + ":" : '') + ("0" + minutes).substr(-2) + '\'' + '<strong>';
          dayString = ' <span class="badge">' + days + 'd</span>';
        }

        return timeString + (days && days != 0 ? dayString : '');
      }
      /**
       * Returns the ETD for the flight
       * @memberof misconnectionFlightsPanel
       * @param {object} connFlight The connection flight object
       * @return {string} ETD string
       */


      function getDisplayETD(connFlight) {
        // Default prefix 
        var prefix = "S";
        var timeToShow = connFlight.STD; // If ATD is available, use this

        if (connFlight.ATD) {
          prefix = "A";
          timeToShow = connFlight.ATD;
        } // If ETD is available, use that
        else if (connFlight.ETD) {
            prefix = "E";
            timeToShow = connFlight.ETD;
          }

        var timeString = " - ";

        if (timeToShow) {
          timeString = moment(timeToShow).format("HH:mm");
        }

        var delay = ""; // Calculate delay only if ATD or ETD is available

        var actualTime = connFlight.ATD || connFlight.ETD;

        if (actualTime && connFlight.STD) {
          var actualTime = new Date(actualTime).getTime();
          var std = new Date(connFlight.STD).getTime();
          var diff = actualTime - std; // Only show delay if it's not zero

          var diffMinutes = Math.floor(diff / 60000);

          if (diffMinutes !== 0) {
            var sign = diffMinutes > 0 ? "+" : "";
            delay = "(" + sign + diffMinutes + ")";
          }
        } // Return full string
        // return prefix + ' <strong>' + timeString + '</strong>' + delay;


        return {
          prefix: prefix,
          time: timeString,
          delay: delay
        };
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/MisconnectionFlights/misconnectionFlightsPanel.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CabinReportLocalEditFactory', CabinReportLocalEditFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CabinReportLocalEditFactory
  * @description 
  *   Manage Local Cabin Reports.
  * @ngInject
  */

  function CabinReportLocalEditFactory($log, localStorageMD5Service, CCMSFactory, LogService, UserFactory, GenericService, GroundServicesFactory, BarTrolleyFactory, enableWaterUpliftReporting, waterUpliftSupportingAcTypes) {
    /**
     * Initialiaze CabinReportLocalEdit object 
     * @memberof CabinReportLocalEditFactory
     */
    function CabinReportLocalEdit() {
      this.ReportGuid = null;
      this.AuthorId = null;
      this.AuthorAimsId = null;
      this.AuthorName = null;
      this.Created = null;
      this.FlightAimsId = null;
      this.FlightId = null;
      this.LastUpdated = null;
      this.Departure = null;
      this.Arrival = null;
      this.AcType = null;
      this.AcTailNo = null;
      this.FlightDate = null;
      this.FlightNo = null; //v1.1 added pax and dep/arr details

      this.BookedC = null;
      this.BookedY = null;
      this.BookedInf = null;
      this.BookedPad = null;
      this.BookedChld = null;
      this.ActualC = null;
      this.ActualY = null;
      this.ActualInf = null;
      this.ActualPad = null;
      this.ActualChld = null;
      this.DepartureICAO = null;
      this.DepartureCountry = null;
      this.DepartureName = null;
      this.ArrivalICAO = null;
      this.ArrivalCountry = null;
      this.ArrivalName = null;
      this.ScheduledDeparture = null;
      this.ScheduledDepartureDateUTC = null;
      this.ScheduledDepartureTimeUTC = null;
      this.Departure = null;
      this.Arrival = null;
      this.ReportId = null;
      this.Status = null; // pending, draft, completed, synched

      this.IsValid = false; //new fields

      this.DepartureGate = null;
      this.DepartureTimezone = null;
      this.ArrivalTimezone = null;
      this.CallSign = null;
      this.ScheduledArrival = null;
      this.ActiveVariousIssues = 0;
      this.WarningVariousIssues = 0;
      this.CCMSCrewPositions = [];
      this.CCMSCrewPositionsIsValid = false;
      this.CCMSCrewPositionsErrorMessage = null;
      this.FlightReportSubmittedBy1L = true;
      this.CrewRemarks = null;
      this.ItemsFoundDescription = null;
      this.ItemsFoundAgent = null;
      this.ItemsFoundSignature = null;
      this.ItemsFoundSectionHasValue = false;
      this.ItemsFoundSectionIsValid = false;
      this.UMNumber = 0;
      this.UMDescription = null;
      this.UMAgent = null;
      this.UMSignature = null;
      this.UMSectionHasValue = false;
      this.UMSectionIsValid = false;
      this.WaterUpliftSuggestedQuantity = null;
      this.WaterUpliftInitial = null;
      this.WaterUpliftRemarks = null;
      this.WaterSectionHasValue = false;
      this.WaterSectionIsValid = false;
      this.GroundServicesSectionHasValue = false;
      this.BarTrolleys = [];
      this.BarTrolleysIsValid = false;
      this.FirstAidKits = [];
      this.FirstAidKitsIsValid = [];
      this.MedicalIncidents = [];
      this.MedicalIncidentsIsValid = [];
      this.SpecialMealIssues = [];
      this.SpecialMealIssuesIsValid = false;
      this.Supplies = [];
      this.SuppliesIsValid = false;
      this.SuppliesErrorMessage = null;
      this.TravelValueSeals = [];
      this.TravelValueSealsIsValid = false;
      this.TravelValueIncomplete = false;
      this.TravelValueIncompleteRow = null;
      this.TravelValueIncompleteReason = null;
      this.TravelValueRemarks = null;
      this.Remarks = null;
      this.VariousIssues = []; //v1.1 :: used to hold all crew (fd, cabin & dhc)

      this.crew = null;
      this.Route = null;
      this.DutyDate = null;
      this.getDescription = getDescription;
      this.getRoute = getRoute;
      this.updateTotals = updateTotals;
      this.validateCCMS = validateCCMS;
      this.getCCMSObj = getCCMSObj;
      this.saveReport = saveReport;
      this.saveReportAsTemp = saveReportAsTemp;
      this.getRemaining = getRemaining;
      this.ArrivalGroundServices = [];
      this.DepartureGroundServices = [];
      this.UpgradedPassengers = [];
      this.ChangedSeats = [];
      this.IncompleteServices = [];
      this.IncompleteServicesIsValid = false; //this.BoardingTimes = null;

      this.BoardingTimesRemarks = null;
      this.FirstPaxTime = null;
      this.LastPaxTime = null;
      this.showBarTrolleyUploadImage = true;
      this.showBarTrolleyInsertData = true;
      this.disableBarTrolleysPhotoRemarks = true;
      this.LuggageNumber = 0;
      this.LuggageDescription = null;
      this.FlightOrdersSectionHasValue = false;
      this.FlightOrders = [];
      this.FlightOrdersSectionErrorMessage = null;
      this.GetId = GetId;
      this.GroomingReports = [];
      this.FoundProperties = [];
      this.FoundPropertiesIsValid = true;
      this.FoundPropertiesSectionHasValue = false;
    }

    var objType = 'cabinReportLocalEdits';
    var objCallback = CabinReportLocalEdit;
    var service = {
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      getCabinReportsFromStorage: getCabinReportsFromStorage,
      setCabinReportsToStorage: setCabinReportsToStorage,
      deleteTempReport: deleteTempReport,
      getPreviousCabinReportCcmsPositions: getPreviousCabinReportCcmsPositions,
      deleteReport: deleteReport,
      setCabinReportToStorage: setCabinReportToStorage,
      getCabinReportLocalEditFromTemp: getCabinReportLocalEditFromTemp,
      getCabinReportLocalEditForFlight: getCabinReportLocalEditForFlight,
      getCabinReportLocalEdit: getCabinReportLocalEdit,
      getCabinReportLocalEditCountThatNeedToBeSynched: getCabinReportLocalEditCountThatNeedToBeSynched,
      IsExistForRouteDutyDate: IsExistForRouteDutyDate,
      getCabinReportLocalEditThatNeedToBeSynched: getCabinReportLocalEditThatNeedToBeSynched,
      getNewReport: getNewReport,
      markReportAsSynched: markReportAsSynched,
      checkForNewGroundServices: checkForNewGroundServices,
      getFlightIdsWithPendingReports: getFlightIdsWithPendingReports,
      getGroomingReports: getGroomingReports
    };

    function getGroomingReports() {
      var allReports = getCabinReportsFromStorage();
      var groomingReports = [];
      allReports.forEach(function (report) {
        if (report.GroomingReports) {
          report.GroomingReports.forEach(function (groomingReport) {
            if (!groomingReport.isSynced) {
              groomingReports.push({
                reportGuid: report.ReportGuid,
                crewId: groomingReport.crewId,
                groomingCategoryId: groomingReport.groomingCategoryId,
                feedback: groomingReport.feedback,
                isSynced: groomingReport.isSynced
              });
            }
          });
        }
      });
      return groomingReports;
    }
    /**
     * Overide default get Id
     * @memberof CabinReportLocalEditFactory
     * @returns {string} ReportGuid 
     */


    function GetId() {
      return this.ReportGuid;
    }
    /**
     * Get a short Description of this cabin report
     * @memberof CabinReportLocalEditFactory
     * @returns {string} Description 
     */


    function getDescription() {
      var s = this.FlightNo + ' ' + this.Departure + '-' + this.Arrival + ' ' + this.ScheduledDepartureDateUTC + ' by ' + this.AuthorName;
      return s;
    }
    /**
     * Get the Route of this cabin report
     * @memberof CabinReportLocalEditFactory
     * @returns {string} Route 
     */


    function getRoute() {
      if (this.Departure == null && this.Arrival == null) return '-';else return (this.Departure || '?') + '-' + (this.Arrival || '?');
    }
    /**
     * Update the totals of all the section of the report
     * @memberof CabinReportLocalEditFactory
     */


    function updateTotals() {
      // check the various issues
      var allActiveVariousIssues = 0;
      var allWarningVariousIssues = 0;
      var variousItemCount = this.VariousIssues.length;

      for (var i = 0; i < variousItemCount; i++) {
        if (this.VariousIssues[i].ItemHasValue == true) {
          if (this.VariousIssues[i].ItemValue != null && this.VariousIssues[i].ItemValue != '') {
            allActiveVariousIssues++;
          } else {
            allWarningVariousIssues++;
          }
        }
      }

      this.ActiveVariousIssues = allActiveVariousIssues;
      this.WarningVariousIssues = allWarningVariousIssues; // check if the report is valid

      this.IsValid = true; // various issues

      if (this.WarningVariousIssues > 0) {
        this.IsValid = false;
      } // ccms crew positions


      this.CCMSCrewPositionsIsValid = true;

      for (var i = 0; i < this.CCMSCrewPositions.length; i++) {
        if (this.CCMSCrewPositions[i].CrewId == null || this.CCMSCrewPositions[i].CrewId == '' ||
        /*(this.CCMSCrewPositions[i].Initials == null) || (this.CCMSCrewPositions[i].Initials == '') ||*/
        //AIMS has crew with empty 3ltr code
        this.CCMSCrewPositions[i].Name == null || this.CCMSCrewPositions[i].Name == '' || this.CCMSCrewPositions[i].Position == null || this.CCMSCrewPositions[i].Position == '') {
          this.IsValid = false;
          this.CCMSCrewPositionsIsValid = false;
        }
      }

      if (!this.validateCCMS()) {
        this.IsValid = false;
        this.CCMSCrewPositionsIsValid = false;
      }

      this.FlightReportSubmittedBy1L = false;
      var user = UserFactory.getUser();

      if (user.position == "FA") {
        this.FlightReportSubmittedBy1L = true;
      } else {
        for (var i = 0; i < this.CCMSCrewPositions.length; i++) {
          if (user.aimsId == this.CCMSCrewPositions[i].CrewId && (this.CCMSCrewPositions[i].CCMS == "1L" || this.CCMSCrewPositions[i].CCMS == null || this.CCMSCrewPositions[i].CCMS == "")) {
            this.FlightReportSubmittedBy1L = true;
            break;
          }
        }
      } // items found


      this.ItemsFoundSectionIsValid = true;
      this.ItemsFoundSectionHasValue = false;

      if (this.ItemsFoundDescription != null && this.ItemsFoundDescription != '' || this.ItemsFoundAgent != null && this.ItemsFoundAgent != '' || this.ItemsFoundSignature != null && this.ItemsFoundSignature != '') {
        this.ItemsFoundSectionHasValue = true;

        if (!(this.ItemsFoundDescription != null && this.ItemsFoundDescription != '' && this.ItemsFoundAgent != null && this.ItemsFoundAgent != '' && this.ItemsFoundSignature != null && this.ItemsFoundSignature != '')) {
          this.IsValid = false;
          this.ItemsFoundSectionIsValid = false;
        }
      } // unaccompanied minors


      this.UMSectionIsValid = true;
      this.UMSectionHasValue = false;
      this.UMNumber = parseInt(this.UMNumber);
      if (isNaN(this.UMNumber)) this.UMNumber = 0; //UM has a value, if UMNo > 0

      if (this.UMNumber != null && this.UMNumber > 0) this.UMSectionHasValue = true; //UM is invalid, if it has a value but not all required fields are in place

      if (this.UMSectionHasValue && (this.UMAgent == null || this.UMAgent == '' || this.UMSignature == null || this.UMSignature == '')) {
        this.IsValid = false;
        this.UMSectionIsValid = false;
      } // luggage 


      this.LuggageSectionIsValid = true;
      this.LuggageSectionHasValue = false;
      this.LuggageNumber = parseInt(this.LuggageNumber);
      if (isNaN(this.LuggageNumber)) this.LuggageNumber = 0; //Luggage has a value, if LuggageNo > 0

      if (this.LuggageNumber != null && this.LuggageNumber > 0) this.LuggageSectionHasValue = true;
      var today = new Date(this.FlightDate);
      this.WaterSectionIsValid = true;
      this.WaterSectionHasValue = false;

      if (enableWaterUpliftReporting && (this.WaterUpliftInitial != null && this.WaterUpliftInitial != '' || this.WaterUpliftRemarks != null && this.WaterUpliftRemarks != '' || (today.getDate() == 1 || today.getDate() == 15) && waterUpliftSupportingAcTypes.includes(this.AcType))) {
        this.WaterSectionHasValue = true;

        if (!(this.WaterUpliftInitial != null && this.WaterUpliftInitial != '')) {
          this.IsValid = false;
          this.WaterSectionIsValid = false;
        } else {
          this.WaterSectionIsValid = true;
        }
      }

      this.GroundServicesSectionHasValue = false;

      if (this.ArrivalGroundServices) {
        for (var i = 0; i < this.ArrivalGroundServices.length; i++) {
          if (this.ArrivalGroundServices[i].Used) {
            this.GroundServicesSectionHasValue = true;
          }
        }
      }

      if (this.DepartureGroundServices) {
        for (var i = 0; i < this.DepartureGroundServices.length; i++) {
          if (this.DepartureGroundServices[i].Used) {
            this.GroundServicesSectionHasValue = true;
          }
        }
      }

      this.FlightOrdersSectionHasValue = false;
      this.FlightOrdersSectionErrorMessage = null;

      if (!this.FlightOrders || !this.FlightOrders.Orders || this.FlightOrders.Orders.length == 0 || flightOrdersIsCompleted(this.FlightOrders)) {
        this.FlightOrdersSectionHasValue = true;
      } else {
        this.IsValid = false; //this.FlightOrdersSectionErrorMessage = "Please complete all orders.";
      } // ==============================
      // Found Properties
      // ==============================


      this.FoundPropertiesSectionHasValue = false;
      this.FoundPropertiesIsValid = true; // "Valid": no drafts exist

      this.HasFoundPropertyDraft = false; // helper flag for report status logic

      function hasText(value) {
        return value != null && String(value).trim() !== '';
      }

      function hasSignature(signature) {
        if (!signature) return false;
        if (Array.isArray(signature)) return signature.length > 0;
        return String(signature).trim() !== '';
      } // Entry has any user input


      function isFoundPropertyTouched(fp) {
        fp = fp || {};
        return hasText(fp.Category) || hasText(fp.DetailedDescription) || hasText(fp.SeatRow) || hasText(fp.Seat) || hasText(fp.Comments) || Array.isArray(fp.Images) && fp.Images.length > 0 || hasText(fp.AgentName) || hasSignature(fp.Signature);
      } // Mandatory fields only


      function isFoundPropertyComplete(fp) {
        fp = fp || {};
        return hasText(fp.Category) && hasText(fp.AgentName) && hasSignature(fp.Signature);
      }

      if (Array.isArray(this.FoundProperties) && this.FoundProperties.length > 0) {
        for (var i = 0; i < this.FoundProperties.length; i++) {
          var fp = this.FoundProperties[i] || {};

          if (!isFoundPropertyTouched(fp)) {
            // Untouched row: ignore it
            continue;
          }

          this.FoundPropertiesSectionHasValue = true; // AC 4.1: Incomplete entries must be saved as Draft

          fp.Status = isFoundPropertyComplete(fp) ? 'completed' : 'draft';

          if (fp.Status === 'draft') {
            this.HasFoundPropertyDraft = true;
            this.FoundPropertiesIsValid = false; // means: cannot complete report yet
          }
        } // AC 4.2: Report cannot be Completed if any found property is Draft


        if (this.HasFoundPropertyDraft) {
          this.IsValid = false;
        }
      } // bar/trolleys


      this.BarTrolleysIsValid = true;

      for (var i = 0; i < this.BarTrolleys.length; i++) {
        if ((this.BarTrolleys[i].Position == null || this.BarTrolleys[i].Position == '') && this.BarTrolleys[i].Photos.length == 0) {
          BarTrolleyFactory.deleteFromList(this.BarTrolleys[i], this.BarTrolleys); //this.IsValid = false;
          //this.BarTrolleysIsValid = false;
        }
      }

      showOrHideBarTrolleyInputs(this); // first aid kits

      this.FirstAidKitsIsValid = true;

      for (var i = 0; i < this.FirstAidKits.length; i++) {
        if (this.FirstAidKits[i].Position == null || this.FirstAidKits[i].Position == '') {
          this.IsValid = false;
          this.FirstAidKitsIsValid = false;
        }
      } // medical incidents


      this.MedicalIncidentsIsValid = true;

      for (var i = 0; i < this.MedicalIncidents.length; i++) {
        if (this.MedicalIncidents[i].Name == null || this.MedicalIncidents[i].Name == '' || this.MedicalIncidents[i].FAKUsed == null || this.MedicalIncidents[i].FAKUsed == '' || this.MedicalIncidents[i].Symptoms == null || this.MedicalIncidents[i].Symptoms == '' || this.MedicalIncidents[i].DoctorInvolved == null || this.MedicalIncidents[i].DoctorInvolved == '') {
          this.IsValid = false;
          this.MedicalIncidentsIsValid = false;
        }
      } // special meals issues


      this.SpecialMealIssuesIsValid = true;

      for (var i = 0; i < this.SpecialMealIssues.length; i++) {
        if (this.SpecialMealIssues[i].Name == null || this.SpecialMealIssues[i].Name == '' || this.SpecialMealIssues[i].Source == null || this.SpecialMealIssues[i].Source == '' || this.SpecialMealIssues[i].MealType == null || this.SpecialMealIssues[i].MealType == '') {
          this.IsValid = false;
          this.SpecialMealIssuesIsValid = false;
        }
      } // supplies


      this.SuppliesIsValid = true;
      this.SuppliesErrorMessage = null;

      for (var i = 0; i < this.Supplies.length; i++) {
        if (this.Supplies[i].SupplyType == null || this.Supplies[i].SupplyType == '' || this.Supplies[i].SupplyType == '-') {
          this.IsValid = false;
          this.SuppliesIsValid = false;
        }

        for (var j = 0; j < this.Supplies.length; j++) {
          if (this.Supplies[i].Id != this.Supplies[j].Id && this.Supplies[i].SupplyType == this.Supplies[j].SupplyType) {
            this.IsValid = false;
            this.SuppliesIsValid = false;
            this.SuppliesErrorMessage = "You cannot have the same supply issue more than once.";
          }
        }
      } // travel value seals


      this.TravelValueSealsIsValid = true;

      for (var i = 0; i < this.TravelValueSeals.length; i++) {
        if (this.TravelValueSeals[i].Position == null || this.TravelValueSeals[i].Position == '') {
          this.IsValid = false;
          this.TravelValueSealsIsValid = false;
        }
      } // travel value incomplete


      this.TravelValueIncompleteIsValid = true;
      this.TravelValueIncompleteErrorMessage = null;

      if (this.TravelValueIncomplete) {
        // "0" == "" so use === for comparison to empty string
        if (typeof this.TravelValueIncompleteRow == "undefined" || this.TravelValueIncompleteRow === "" || this.TravelValueIncompleteRow == null) {
          this.TravelValueIncompleteIsValid = false;
          this.TravelValueIncompleteErrorMessage = "Travel Value Stopped at row is required";
        } else if (typeof this.TravelValueIncompleteReason == "undefined" || this.TravelValueIncompleteReason == "" || this.TravelValueIncompleteReason == null) {
          this.TravelValueIncompleteIsValid = false;
          this.TravelValueIncompleteErrorMessage = "Travel Value Incomplete Reason is required";
        }
      } // Incomplete Services 


      this.IncompleteServicesIsValid = true;

      for (var i = 0; i < this.IncompleteServices.length; i++) {
        if (this.IncompleteServices[i].ServiceClass == null || this.IncompleteServices[i].FromRowNo == '' || this.IncompleteServices[i].ToRowNo == '' || this.IncompleteServices[i].ServiceType == '' || this.IncompleteServices[i].Reason == '' || this.IncompleteServices[i].FromRowNo > this.IncompleteServices[i].ToRowNo) {
          this.IsValid = false;
          this.IncompleteServicesIsValid = false;
        }
      }
    }
    /**
     * Validate the Crew Positions
     * @memberof CabinReportLocalEditFactory
     */


    function validateCCMS() {
      this.CCMSCrewPositionsErrorMessage = null;
      var valuesInError = new Array();

      for (var i = 0; i < this.CCMSCrewPositions.length; i++) {
        if (this.CCMSCrewPositions[i].CCMS == null || this.CCMSCrewPositions[i].CCMS == '') {
          this.CCMSCrewPositionsErrorMessage = "You must fill CCMS for all crew members";
          return false;
        }
      }

      var allCCMSPositions = CCMSFactory.getCCMSFromStorage(); // if not multiple then this position must not be found in another
      // place in the array

      var multiplePositionsInError = new Array();

      for (var i = 0; i < this.CCMSCrewPositions.length; i++) {
        var ccmsObj_i = this.getCCMSObj(allCCMSPositions, this.CCMSCrewPositions[i].CCMS);

        if (ccmsObj_i.ccmsPositionsIsValid) {
          var ccms_i = ccmsObj_i.ccms;

          if (ccms_i.Multiple == false) {
            for (var j = 0; j < this.CCMSCrewPositions.length; j++) {
              var ccmsObj_j = this.getCCMSObj(allCCMSPositions, this.CCMSCrewPositions[j].CCMS);

              if (ccmsObj_j.ccmsPositionsIsValid) {
                var ccms_j = ccmsObj_j.ccms;

                if (this.CCMSCrewPositions[i].CrewId != this.CCMSCrewPositions[j].CrewId) {
                  if (ccms_i.Position == ccms_j.Position) {
                    if (multiplePositionsInError.indexOf(ccms_i.Position) < 0) multiplePositionsInError.push(ccms_i.Position);
                  }
                }
              }
            }
          }
        } else {
          valuesInError.push(this.CCMSCrewPositions[i].CCMS);
          this.CCMSCrewPositions[i].CCMS = null;
        }
      }

      if (valuesInError.length == 1) {
        this.CCMSCrewPositionsErrorMessage = "You cannot assigned the position " + valuesInError + " in this flight";
      } else if (valuesInError.length > 1) {
        this.CCMSCrewPositionsErrorMessage = "You cannot assigned the positions " + valuesInError + " in this flight";
      }

      if (multiplePositionsInError.length > 0) {
        var multiplePositionError = "";

        for (var i = 0; i < multiplePositionsInError.length; i++) {
          if (multiplePositionError != "") {
            multiplePositionError = multiplePositionError + ", ";
          }

          multiplePositionError = multiplePositionError + multiplePositionsInError[i];
        }

        if (multiplePositionsInError.length == 1) this.CCMSCrewPositionsErrorMessage = "You have assigned the position " + multiplePositionError + " multiple times";else this.CCMSCrewPositionsErrorMessage = "You have assigned the positions " + multiplePositionError + " multiple times";
      }

      if (this.CCMSCrewPositionsErrorMessage != null) return false;else return true;
    }
    /**
     * Get the CCMS Positions of this aircraft
     * @memberof CabinReportLocalEditFactory
     */


    function getCCMSObj(ccms, pos) {
      var AcTypeIsValid = false;
      var ccmsPositionsIsValid = false;
      var ccmsObj = null;

      for (var i = 0; i < ccms.length; i++) {
        // find the positions for this aircraft type
        if (ccms[i].Aircraft == this.AcType) {
          AcTypeIsValid = true;

          for (var j = 0; j < ccms[i].Positions.length; j++) {
            if (ccms[i].Positions[j].Position == pos) {
              ccmsObj = ccms[i].Positions[j];
              ccmsPositionsIsValid = true;
            }
          }
        }
      }

      if (!AcTypeIsValid) {
        var log = "CCMS , POS=" + this.CCMSCrewPositions[j].CCMS + ", Ac=" + this.AcType + ", all=" + JSON.stringify(allCCMSPositions);
        log = log.replace(/"Multiple":/g, "").replace(/"Position":/g, "").replace(/"Aircraft"/g, "AC").replace(/true/g, 1).replace(/false/g, 0).replace(/"/g, "").replace(/Positions/g, "Ps");
        LogService.debug(log);
      }

      return {
        AcTypeIsValid: AcTypeIsValid,
        ccmsPositionsIsValid: ccmsPositionsIsValid,
        ccms: ccmsObj
      };
    }
    /**
     * Save the Cabin Report
     * @memberof CabinReportLocalEditFactory
     */


    function saveReport() {
      // update the LastUpdated field
      this.LastUpdated = new Date(); // get the reports array from storage

      var allReports = getCabinReportsFromStorage();
      if (allReports == null) allReports = new Array(); // find the current report from the array (if present)

      var arrayLength = allReports.length;
      var reportIndex = -1;

      for (var i = 0; i < arrayLength; i++) {
        if (allReports[i].ReportGuid == this.ReportGuid) {
          reportIndex = i;
          break;
        }
      } // add or update a copy of the current report


      if (reportIndex >= 0) allReports[reportIndex] = this;else allReports.push(this); // save

      setCabinReportsToStorage(allReports);
    }
    /**
     * Save the Report As Temp
     * @memberof CabinReportLocalEditFactory
     */


    function saveReportAsTemp() {
      // update the LastUpdated field
      this.LastUpdated = new Date(); // save as temp

      localStorageMD5Service.remove('cabinReportLocalEdit_TEMP');
      localStorageMD5Service.set('cabinReportLocalEdit_TEMP', this);
    }
    /**
     * Get the remaining characters of this field
     * @memberof CabinReportLocalEditFactory
     */


    function getRemaining(max, text) {
      if (typeof text === "undefined" || text === null) return '';
      if (typeof max === "undefined" || max === null || max < 0 || !max) max = 5000;
      var length = text.length;
      /*var matches = text.match(/\n/g);
      if (matches)
      	length += matches.length;*/
      //if(max > length)

      return 'characters left: ' + (max - length); //else
      //	return '-full-';
    } //Factory functions

    /**
     * Extend Object from the default local Cabin Report Object
     * @memberof CabinReportLocalEditFactory
     * @param {Object} obj  a CabinReportLocalEdit
     * @returns {Object} CabinReportLocalEdit
     */


    function fromObject(obj) {
      return GenericService.fromObject(obj, objCallback);
    }
    /**
     * Extend Object List from the default local Cabin Report Object
     * @memberof CabinReportLocalEditFactory
     * @param {Array} objList  a CabinReportLocalEdit list
     * @returns {Array} CabinReportLocalEdits
     */


    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallback);
    }
    /**
     * Get Cabin Reports from storage
     * @memberof CabinReportLocalEditFactory
     * @returns {Array} CabinReports
     */


    function getCabinReportsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Save Cabin Reports to storage
     * @memberof CabinReportLocalEditFactory
     * @param {Array} cabinReportLocalEdits A list of Cabin Reports 
     */


    function setCabinReportsToStorage(cabinReportLocalEdits) {
      GenericService.saveAll(cabinReportLocalEdits, objType, objCallback);
    }
    /**
     * Delete Cabin Temporary Report from storage
     * @memberof CabinReportLocalEditFactory
     */


    function deleteTempReport() {
      localStorageMD5Service.remove('cabinReportLocalEdit_TEMP');
    }
    /**
     * Get the CCMS positions of the previous flight
     * @memberof CabinReportLocalEditFactory
     * @param {string} guid The report GUID
     * @param {string} acNo The Aircaft Number
     * @param {string} flightDateUTC The flight date in UTC
     * @param {string} flightTimeUTC The flight time in UTC
     * @return {Array} CCMSpositions
     */


    function getPreviousCabinReportCcmsPositions(guid, acNo, flightDateUTC, flightTimeUTC) {
      var previousCcms = null;

      try {
        var flightDate = new Date(flightDateUTC + ' ' + flightTimeUTC); //date of ref flight

        var flightDateMatch = null;
        var flightDateCheck = null;
        var previousRep = null;
        var report = null;
        var reports = getCabinReportsFromStorage(); //console.debug('Find previous report for ' + acNo + ' ' + flightDateUTC + ' ' + flightTimeUTC);

        if (reports != null && reports.length > 0) {
          //loop all reports to find the previous one based on the input data
          var x;

          for (var i = 0; i < reports.length; i++) {
            report = reports[i];
            flightDateCheck = new Date(report.ScheduledDepartureDateUTC + " " + report.ScheduledDepartureTimeUTC); //console.debug('	' + report.AcTailNo + ' ' + report.FlightNo + ' ' + report.Departure + '-' + report.Arrival + ' ' + report.ScheduledDepartureDateUTC + " " + report.ScheduledDepartureTimeUTC);
            //flight too old to be "previous"

            if ((flightDate - flightDateCheck) / 1000 / 60 / 60 > 6) {
              x = 0; //console.debug('		past flight, not acceptable');
            } //same report as ref one
            else if (report.ReportGuid == guid) {
                x = 1; //console.debug('		same report');
              } //worse match than current one
              else if (flightDateMatch != null && flightDateCheck < flightDate && flightDateMatch < flightDateCheck) {
                  x = 2; //console.debug('		previous match is a closer one');
                } //later than ref flight
                else if (flightDate < flightDateCheck) {
                    x = 3; //console.debug('		later than ref flight');
                  } //match!
                  else {
                      //console.debug('		candidate');
                      //store selected report
                      previousRep = report;
                      flightDateMatch = flightDateCheck;
                    }
          }
        }

        if (previousRep != null && previousRep.CCMSCrewPositions != null && previousRep.CCMSCrewPositions.length > 0) {
          previousCcms = previousRep.CCMSCrewPositions;
        }
      } catch (e) {
        console.error(e);
      }

      return previousCcms;
    }
    /**
     * Delete Selected repport
     * @memberof CabinReportLocalEditFactory
     * @param {string} reportGuid The report's Identifier
     */


    function deleteReport(reportGuid) {
      GenericService.remove(reportGuid, objType, objCallback);
    }
    /**
     * Save Selected Cabin repport
     * @memberof CabinReportLocalEditFactory
     * @param {Object} report A Cabin Report
     */


    function setCabinReportToStorage(report) {
      GenericService.save(report, objType, objCallback);
    }
    /**
     * Get Temporary Cabin repport
     * @memberof CabinReportLocalEditFactory
     * @return {Object} report 
     */


    function getCabinReportLocalEditFromTemp() {
      var cabinReportLocalEdit = localStorageMD5Service.get('cabinReportLocalEdit_TEMP');
      cabinReportLocalEdit = checkForNewGroundServices(cabinReportLocalEdit);
      return fromObject(cabinReportLocalEdit);
    }
    /**
     * Get the Cabin repport of this flight
     * @memberof CabinReportLocalEditFactory
     * @param {number} flightId A flight Id
     * @return {Object} report 
     */


    function getCabinReportLocalEditForFlight(flightId) {
      var cabinReportLocalEdits = getCabinReportsFromStorage();
      if (cabinReportLocalEdits == null) return null;
      var result = null;
      var arrayLength = cabinReportLocalEdits.length;

      for (var i = 0; i < arrayLength; i++) {
        if (cabinReportLocalEdits[i].FlightId == flightId) {
          result = cabinReportLocalEdits[i];
          break;
        }
      }

      result = checkForNewGroundServices(result);
      return result;
    }
    /**
           * add any new ground services from storage to the existing report
           * @memberof CabinReportLocalEditFactory
     * @param {Object} report
           * @return {Object} report 
           */


    function checkForNewGroundServices(report) {
      if (report == null) return report;
      var depStorageGroundServices = GroundServicesFactory.getGroundServicesByStation(report.Departure); //var arrStorageGroundServices =  GroundServicesFactory.getGroundServicesByStation(report.Arrival);

      for (var i = 0; i < depStorageGroundServices.length; i++) {
        var found = false;

        for (var j = 0; j < report.DepartureGroundServices.length; j++) {
          if (depStorageGroundServices[i].ServiceType === report.DepartureGroundServices[j].ServiceType) {
            //this ground service is available according to the localstorage but its not in the report
            found = true;
            break;
          }
        }

        if (!found) {
          report.DepartureGroundServices.push(depStorageGroundServices[i]);
        }
      } //Disable arrival ground services from report:
      // for (var i = 0; i < arrStorageGroundServices.length; i++) {
      // 	var found = false;
      // 	for (var j = 0; j < report.ArrivalGroundServices.length; j++){
      // 		if (arrStorageGroundServices[i].ServiceType === report.ArrivalGroundServices[j].ServiceType){
      // 			//this ground service is available according to the localstorage but its not in the report
      // 			found = true;
      // 			break;
      // 		}
      // 	}
      // 	if (!found){
      // 		report.ArrivalGroundServices.push(arrStorageGroundServices[i]);
      // 	}
      //}


      return report;
    }
    /**
     * Get the Cabin repport
     * @memberof CabinReportLocalEditFactory
     * @param {string} reportGuid A report Id
     * @return {Object} report 
     */


    function getCabinReportLocalEdit(reportGuid) {
      var report = GenericService.get(reportGuid, objType, objCallback);
      report = checkForNewGroundServices(report);
      return report;
    }
    /**
     * Get the number of reports that need to be synched
     * @memberof CabinReportLocalEditFactory
     * @return {number} result A Cabin Report
     */


    function getCabinReportLocalEditCountThatNeedToBeSynched() {
      var cabinReportLocalEdits = getCabinReportsFromStorage();
      if (cabinReportLocalEdits == null) return 0;
      var result = 0;

      for (var i = 0; i < cabinReportLocalEdits.length; i++) {
        if (cabinReportLocalEdits[i].Status === 'completed') {
          result++;
        }
      }

      return result;
    }
    /**
     * Cabin report Exist For Route and DutyDate
     * @memberof CabinReportLocalEditFactory
     * @param {string} Route The flight's route
     * @param {string} Dutydate The flight's duty date
     * @return {boolean} result
     */


    function IsExistForRouteDutyDate(Route, Dutydate) {
      var cabinReportLocalEdits = getCabinReportsFromStorage();
      if (cabinReportLocalEdits == null) return false;
      var result = false;

      for (var i = 0; i < cabinReportLocalEdits.length; i++) {
        if (cabinReportLocalEdits[i].Route == Route && cabinReportLocalEdits[i].Dutydate) {
          result = true;
          break;
        }
      }

      return result;
    }
    /**
     * Get the reports that need to be synched
     * @memberof CabinReportLocalEditFactory
     * @return {array} result 
     */


    function getCabinReportLocalEditThatNeedToBeSynched() {
      var result = [];
      var cabinReportLocalEdits = getCabinReportsFromStorage();
      if (cabinReportLocalEdits == null) return result;

      for (var i = 0; i < cabinReportLocalEdits.length; i++) {
        if (cabinReportLocalEdits[i].Status === 'completed') {
          result.push(cabinReportLocalEdits[i]);
        }
      }

      return result;
    }
    /**
     * Gonstructor for a new cabin Report
     * @memberof CabinReportLocalEditFactory
     * @return {array} result 
     */


    function getNewReport() {
      return GenericService.constructor(objCallback);
    }
    /**
     * Mark selected report As Synched
     * @memberof CabinReportLocalEditFactory
     * @param {string} reportGuid The report Guid
     * @return {boolean} isSuccess 
     */


    function markReportAsSynched(reportGuid) {
      var report = getCabinReportLocalEdit(reportGuid);
      if (report == null) return false;
      report.Status = 'synched';
      report.saveReport();
      return true;
    }

    function showOrHideBarTrolleyInputs(report) {
      var photos = report.BarTrolleys.map(function (i) {
        return i.Photos;
      });
      var photosCount = 0;

      if (photos[0] != undefined) {
        photosCount = photos[0].length;
      }

      report.showBarTrolleyUploadImage = photosCount > 0 || report.BarTrolleys.length == 0;
      report.showBarTrolleyInsertData = !photosCount > 0 || report.BarTrolleys.length == 0;
      report.disableBarTrolleysPhotoRemarks = !photosCount > 0;
    }
    /**
     * Get flight ids with pending reports 
     * @memberof CabinReportLocalEditFactory
     * @return [long] List of flight ids 
     */


    function getFlightIdsWithPendingReports() {
      var cabinReportLocalEdits = getCabinReportsFromStorage();
      var flightIds = [];

      if (cabinReportLocalEdits != null) {
        var now = moment(); //var now = moment('2016-06-14') //For debug;

        for (var i = 0; i < cabinReportLocalEdits.length; i++) {
          var flightDate = moment(cabinReportLocalEdits[i].FlightDate);

          if (cabinReportLocalEdits[i].Status !== 'stored' && now.diff(flightDate, 'days') < 5) {
            flightIds.push(cabinReportLocalEdits[i].FlightId);
          }
        }
      }

      return flightIds;
    } //check if all orders are updated


    function flightOrdersIsCompleted(FlightOrders) {
      return !FlightOrders.Orders.some(function (order) {
        return order.Status == "Pending" || order.Status == "Not Delivered" && !order.Reason;
      });
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CabinReportLocalEditCreatorFactory', CabinReportLocalEditCreatorFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CabinReportLocalEditCreatorFactory
  * @description 
  *  Create a new local Report
  * @ngInject
  */

  function CabinReportLocalEditCreatorFactory(FlightFactory, ReportGuidFactory, CabinReportTemplateItemFactory, CabinReportLocalEditFactory, UserFactory, CCMSCrewPositionFactory, GroundServicesFactory, FlightOrdersFactory) {
    var service = {
      createNewLocalReportForFlight: createNewLocalReportForFlight
    };
    /**
     * Create a new Local Report For the Selected Flight
     * @memberof CrewAssessmentFactory
     * @param {number} flightId 
     * @returns {object} report 
     */

    function createNewLocalReportForFlight(flightId) {
      // load the user
      var user = UserFactory.getUser();
      if (user == null) return null; // check if a report exists for this flight and user

      var existingReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);
      if (existingReport != null) return existingReport; // get a guid for the report

      var newReportGuid = ReportGuidFactory.getNextGuid();
      if (newReportGuid == null) return null; // load the cabin report template

      var reportTemplateItems = CabinReportTemplateItemFactory.getCabinReportTemplateItemsFromStorage();
      if (reportTemplateItems == null) return null;
      if (reportTemplateItems.length == 0) return null; // load the flight

      var flight = FlightFactory.getFlightFromStorage(flightId);

      if (flight == null) {
        // if not found, also check the local flights
        var flight = FlightFactory.getLocalFlightFromStorage(flightId); // if still not found, then return null

        if (flight == null) return null;
      } // create the new report


      var newReport = CabinReportLocalEditFactory.getNewReport(); // assign data on the new report

      newReport.AuthorId = user.id;
      newReport.AuthorAimsId = user.aimsId;
      newReport.AuthorName = user.name;
      newReport.Created = new Date();
      newReport.FlightAimsId = flight.FlightAimsId;
      newReport.FlightId = flight.FlightId;
      newReport.LastUpdated = new Date();
      newReport.AcType = flight.AcType;
      newReport.AcTailNo = flight.AcTailNo;
      newReport.FlightDate = flight.FlightDate;
      newReport.FlightNo = flight.FlightNo;
      newReport.Departure = flight.Departure;
      newReport.Arrival = flight.Arrival;
      newReport.ScheduledDeparture = flight.ScheduledDeparture;
      newReport.ScheduledDepartureDateUTC = flight.ScheduledDepartureDateUTC;
      newReport.ScheduledDepartureTimeUTC = flight.ScheduledDepartureTimeUTC;
      newReport.ReportGuid = newReportGuid;
      newReport.ReportId = null;
      newReport.Status = 'pending';
      newReport.WaterUpliftSuggestedQuantity = flight.WaterUpliftSuggestedQuantity; // TODO

      newReport.VariousIssues = reportTemplateItems; //details from flight (assuming flight contains these fields)

      if (flight.DepartureName) {
        newReport.DepartureICAO = flight.DepartureICAO;
        newReport.DepartureCountry = flight.DepartureCountry;
        newReport.DepartureName = flight.DepartureName;
        newReport.ArrivalICAO = flight.ArrivalICAO;
        newReport.ArrivalCountry = flight.ArrivalCountry;
        newReport.ArrivalName = flight.ArrivalName;
      } //pax figures from flight (assuming flight contains these figures)


      if (flight.BookedY >= 0) {
        newReport.BookedC = flight.BookedC;
        newReport.BookedY = flight.BookedY;
        newReport.BookedInf = flight.BookedInf;
        newReport.BookedPad = flight.BookedPad;
        newReport.BookedChld = flight.BookedChld;
        newReport.ActualC = flight.ActualC;
        newReport.ActualY = flight.ActualY;
        newReport.ActualInf = flight.ActualInf;
        newReport.ActualPad = flight.ActualPad;
        newReport.ActualChld = flight.ActualChld;
      } // fix the CCMS positions


      for (var i = 0; i < flight.crew.length; i++) {
        if (flight.crew[i].isDHC == false && flight.crew[i].position != 'CP' && flight.crew[i].position != 'FO') {
          var crewPosition = CCMSCrewPositionFactory.createNew();
          crewPosition.CrewId = flight.crew[i].aimsId;
          crewPosition.Initials = flight.crew[i].shortname;
          crewPosition.Name = flight.crew[i].name;
          crewPosition.Position = flight.crew[i].position;
          crewPosition.IsManual = false;
          crewPosition.CrewComments = null;
          crewPosition.HasCrewComments = false;
          crewPosition.needsAdditionalFeedback = false;
          newReport.CCMSCrewPositions.push(crewPosition);
        }
      }

      newReport.crew = flight.crew; //new values

      newReport.DepartureTimezone = flight.DepartureTimezone;
      newReport.ArrivalTimezone = flight.ArrivalTimezone;
      newReport.CallSign = flight.CallSign;
      newReport.ScheduledArrival = flight.ScheduledArrival;
      newReport.DepartureGate = flight.DepartureGate;
      newReport.Route = flight.Route;
      newReport.DutyDate = flight.DutyDate; //add ground services

      newReport.DepartureGroundServices = GroundServicesFactory.getGroundServicesByStation(flight.Departure); //We don't show arrival services any more...  
      //newReport.ArrivalGroundServices = GroundServicesFactory.getGroundServicesByStation(flight.Arrival);
      //add flightOrders in report

      newReport.FlightOrders = FlightOrdersFactory.getFlightOrdersForCreateReportByFlightId(flight.FlightId);
      newReport.GroomingReports = [];
      newReport.updateTotals(); // return the new report

      return newReport;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CabinReportRestoreFactory', CabinReportRestoreFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CabinReportRestoreFactory
  * @description 
  *   Manage Local Cabin Reports.
  * @ngInject
  */

  function CabinReportRestoreFactory(localStorageMD5Service, FlightFactory, CabinReportLocalEditFactory, IndexedDBService) {
    var IdxType = 'Reports';
    var service = {
      getReportsFromIdx: getReportsFromIdx,
      setReportsToIdx: setReportsToIdx,
      updateReportToIdx: updateReportToIdx,
      addReportToIdx: addReportToIdx,
      deleteReportFromIdx: deleteReportFromIdx,
      clearReportsFromIdx: clearReportsFromIdx,
      getReportsFromLs: getReportsFromLs,
      backUpReports: backUpReports,
      restoreReports: restoreReports
    };
    /**
     * Get Reports
     * @memberof CabinReportRestoreFactory
     * @param {function} callback  
     */

    function getReportsFromIdx(callback) {
      //return GenericService.list(Idx,objCallback);
      IndexedDBService.getAll(IdxType).then(function (results) {
        callback(results);
      });
    }

    ;
    /**
     * Set Reports
     * @memberof CabinReportRestoreFactory
     * @param {array} Reports   a list of Reports to set to indexedDB
     */

    function setReportsToIdx(Reports) {
      IndexedDBService.addAll(IdxType, Reports);
    }

    ;
    /**
     * Update Report to Storage
     * @memberof CabinReportRestoreFactory
     * @param {object} Report   a Report
     */

    function updateReportToIdx(Report) {
      IndexedDBService.put(IdxType, Report);
    }

    ;

    function info() {
      IndexedDBService.info(IdxType);
    }
    /**
     * Add Report to Storage
     * @memberof CabinReportRestoreFactory
     * @param {object} Report   a Report
     */


    function addReportToIdx(Report) {
      IndexedDBService.add(IdxType, Report);
    }

    ;
    /**
     * Delete Report from Storage
     * @memberof CabinReportRestoreFactory
     * @param {number} RerportGuid  The unique Identifier of the Report
     */

    function deleteReportFromIdx(ReportId) {
      IndexedDBService.remove(IdxType, ReportId);
    }

    ;
    /**
     * Clear Report from Storage
     * @memberof CabinReportRestoreFactory
     */

    function clearReportsFromIdx() {
      IndexedDBService.removeAll(IdxType);
    }

    ;
    /**
     * Get Cabin Reports from storage
     * @memberof CabinReportLocalEditFactory
     * @returns {Array} CabinReports
     */

    function getReportsFromLs() {
      return localStorageMD5Service.get('cabinReportLocalEdits');
    }
    /**
     * Get reports from IndexedDB and delete the reports that have been stored
     * @memberof CabinReportRestoreFactory
     */


    function getReportsFromIdxDeleteStoredReports(callback) {
      var reportsIdx = [];
      var storedReportsLs = FlightFactory.getFlightsWithStoredReport();
      getReportsFromIdx(function (results) {
        for (var i = 0; i < results.length; i++) {
          var isStored = storedReportsLs.some(function (item) {
            return results[i].FlightId == item.FlightId && item.cabinReportStatusDescr == "Stored";
          });

          if (isStored) {
            deleteReportFromIdx(results[i].FlightId);
          } else {
            reportsIdx.push(results[i]);
          }
        }

        callback(reportsIdx);
      });
    }
    /**
     * Back up reports. Gets the reports from localstorage and save them to IndexedDB. 
     * Steps:
     * 1. Clear IndexedDB from reports which have been stored
     * 2. Replace the existing reports
     * 3. Insert if not existing
     * @memberof CabinReportRestoreFactory
     */


    function backUpReports() {
      //1
      //Get reports from indexedDB, check each of them if is existed at the StroredReport list
      getReportsFromIdxDeleteStoredReports(function (reportsIdx) {
        //2
        //Foreach report in the local storage, save to indexedId, if existed need to be replaced 
        //get reports from localStorage
        var reportsAll = [];
        reportsAll = getReportsFromLs();

        if (reportsAll && reportsAll.length > 0) {
          for (var i = 0; i < reportsAll.length; i++) {
            var reportLs = reportsAll[i];
            var isExisting = reportsIdx.some(function (item) {
              return reportLs.FlightId == item.FlightId;
            });

            if (isExisting) {
              //Replace the report
              deleteReportFromIdx(reportLs.FlightId);
              addReportToIdx(reportLs);
            } else {
              //Insert the report
              addReportToIdx(reportLs);
            }
          }
        }
      });
    }
    /**
    * Restore reports. Compares the reports from localstorage and from IndexedDB, and it inserts the reports that are missing from local storage. 
    * Steps:
    * 1.
    * @memberof CabinReportRestoreFactory
    * @returns {array} list of flightNo foreach restored report 
    */


    function restoreReports(callback) {
      getReportsFromIdxDeleteStoredReports(function (reportsIdx) {
        var results = [];
        var reportsAll = [];
        reportsAll = getReportsFromLs();

        for (var i = 0; i < reportsIdx.length; i++) {
          //Check if exists
          var isExisting = reportsAll.some(function (item) {
            return reportsIdx[i].FlightId == item.FlightId && (reportsIdx[i].Status == "draft" || reportsIdx[i].Status == "completed");
          });

          if (isExisting) {
            //Delete existing reports
            deleteReportFromIdx(reportsIdx[i].FlightId);
          } else {
            //Insert reports that are not existed
            var extendReport = CabinReportLocalEditFactory.fromObject(reportsIdx[i]);
            extendReport.Status = "draft";
            extendReport.saveReport();
            FlightFactory.updateFlightFromReport(extendReport); //Then delete from indexed db

            deleteReportFromIdx(reportsIdx[i].FlightId);
            results.push(reportsIdx[i].FlightNo);
          }
        }

        callback(results);
      });
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CabinReportSendToServerFactory', CabinReportSendToServerFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CabinReportSendToServerFactory
  * @description 
  *   Transform Cabin Reports in order to send them to the server
  * @ngInject
  */

  function CabinReportSendToServerFactory() {
    /**
    * Initialize the CabinReportSendToServer
    * @memberof CabinReportSendToServerFactory
    */
    function CabinReportSendToServer() {
      this.Created = null;
      this.LastUpdated = null;
      this.FlightAimsId = null;
      this.FlightId = null;
      this.FlightDate = null;
      this.FlightNo = null;
      this.Departure = null;
      this.Arrival = null;
      this.ReportGuid = null;
      this.AuthorCrewId = null;
      this.AuthorCrewAimsId = null;
      this.ActualPassengerC = "";
      this.ActualPassengerY = "";
      this.CCMSCrewPositions = [];
      this.CrewRemarks = null;
      this.ItemsFoundDescription = null;
      this.ItemsFoundAgent = null;
      this.ItemsFoundSignature = null;
      this.UMNumber = 0;
      this.UMDescription = null;
      this.UMAgent = null;
      this.UMSignature = null;
      this.WaterUpliftSuggestedQuantity = null;
      this.WaterUpliftInitial = null;
      this.WaterUpliftRemarks = null;
      this.BarTrolleys = [];
      this.FirstAidKits = [];
      this.MedicalIncidents = [];
      this.SpecialMealIssues = [];
      this.Supplies = [];
      this.TravelValueSeals = [];
      this.LuggageNumber = 0;
      this.LuggageDescription = null;
      this.FoundProperties = [];
      this.TravelValueIncomplete = false;
      this.TravelValueIncompleteRow = null;
      this.TravelValueIncompleteReason = null;
      this.TravelValueRemarks = null;
      this.Remarks = null;
      this.VariousIssues = [];
      this.DepartureGroundServices = [];
      this.ArrivalGroundServices = [];
      this.UpgradedPassengers = [];
      this.ChangedSeats = []; //BoardingTimes

      this.BoardingTimesRemarks = null;
      this.FirstPaxTime = null;
      this.LastPaxTime = null;
      this.GroomingReports = [];
    }
    /**
    * Initialize the CabinReportSendToServerItem
    * @memberof CabinReportSendToServerFactory
    */


    function CabinReportSendToServerItem() {
      this.ReportGuid = null;
      this.TemplateItemId = null;
      this.Value = 0;
      this.Remarks = '';
      this.Photos = new Array();
    }

    var service = {
      getCompletedListFromCabinReportLocalEdits: getCompletedListFromCabinReportLocalEdits,
      getReportFromCabinReportLocalEdit: getReportFromCabinReportLocalEdit,
      stripIds: stripIds
    };
    /**
     * Transform all cabin local reports in order to be sent to the server
     * @memberof CabinReportSendToServerFactory
     * @param {Array} cabinReportLocalEdits
     * @returns {Array} CabinReportSendToServer 
     */

    function getCompletedListFromCabinReportLocalEdits(cabinReportLocalEdits) {
      var result = [];
      if (cabinReportLocalEdits == null) return result;
      var arrayLength = cabinReportLocalEdits.length;

      for (var i = 0; i < arrayLength; i++) {
        if (cabinReportLocalEdits[i].Status === 'completed') {
          result.push(getReportFromCabinReportLocalEdit(cabinReportLocalEdits[i]));
        }
      } //Temporary: fix: Ground Services:  Used values (true/false) from local storage.


      var resultChecked = fixUsedValueLS(result); //TODO: flight orders

      return resultChecked;
    } //Temporary: fix - Ground Services - local storage from true/false values. (int Used: 0:false, 1:true, 2:inop) 


    function fixUsedValueLS(cabinReportLocalEdits) {
      for (var i = 0; i < cabinReportLocalEdits.length; i++) {
        if (cabinReportLocalEdits[i].DepartureGroundServices.length > 0) {
          for (var j = 0; j < cabinReportLocalEdits[i].DepartureGroundServices.length; j++) {
            if (cabinReportLocalEdits[i].DepartureGroundServices[j]) {
              if (cabinReportLocalEdits[i].DepartureGroundServices[j].Used === true) {
                cabinReportLocalEdits[i].DepartureGroundServices[j].Used = 1;
              } else if (cabinReportLocalEdits[i].DepartureGroundServices[j].Used === false) {
                cabinReportLocalEdits[i].DepartureGroundServices[j].Used = 0;
              }
            }
          }
        }
      }

      return cabinReportLocalEdits;
    }
    /**
    * Transform a cabin local reports in order to be sent to the server
    * @memberof CabinReportSendToServerFactory
    * @param {object} cabinReportLocalEdit
    * @returns {object} CabinReportSendToServer 
    */


    function getReportFromCabinReportLocalEdit(cabinReportLocalEdit) {
      var result = new CabinReportSendToServer();
      result.Created = cabinReportLocalEdit.Created;
      result.LastUpdated = cabinReportLocalEdit.LastUpdated;
      result.FlightAimsId = cabinReportLocalEdit.FlightAimsId;
      result.FlightId = cabinReportLocalEdit.FlightId;
      result.FlightDate = cabinReportLocalEdit.FlightDate;
      result.FlightNo = cabinReportLocalEdit.FlightNo;
      result.Departure = cabinReportLocalEdit.Departure;
      result.Arrival = cabinReportLocalEdit.Arrival;
      result.ReportGuid = cabinReportLocalEdit.ReportGuid;
      result.AuthorCrewId = cabinReportLocalEdit.AuthorId;
      result.AuthorCrewAimsId = cabinReportLocalEdit.AuthorAimsId;
      result.ActualPassengerC = cabinReportLocalEdit.ActualPassengerC;
      result.ActualPassengerY = cabinReportLocalEdit.ActualPassengerY;
      result.CrewRemarks = cabinReportLocalEdit.CrewRemarks;
      result.ItemsFoundDescription = cabinReportLocalEdit.ItemsFoundDescription;
      result.ItemsFoundAgent = cabinReportLocalEdit.ItemsFoundAgent;
      result.ItemsFoundSignature = cabinReportLocalEdit.ItemsFoundSignature;
      result.UMNumber = cabinReportLocalEdit.UMNumber;
      result.UMDescription = cabinReportLocalEdit.UMDescription;
      result.UMAgent = cabinReportLocalEdit.UMAgent;
      result.UMSignature = cabinReportLocalEdit.UMSignature;
      result.LuggageNumber = cabinReportLocalEdit.LuggageNumber;
      result.LuggageDescription = cabinReportLocalEdit.LuggageDescription;
      result.WaterUpliftSuggestedQuantity = cabinReportLocalEdit.WaterUpliftSuggestedQuantity;
      result.WaterUpliftInitial = cabinReportLocalEdit.WaterUpliftInitial;
      result.WaterUpliftRemarks = cabinReportLocalEdit.WaterUpliftRemarks;
      result.CCMSCrewPositions = stripIds(cabinReportLocalEdit.CCMSCrewPositions);
      result.BarTrolleys = stripIds(cabinReportLocalEdit.BarTrolleys);
      result.FirstAidKits = stripIds(cabinReportLocalEdit.FirstAidKits);
      result.MedicalIncidents = stripIds(cabinReportLocalEdit.MedicalIncidents);
      result.SpecialMealIssues = stripIds(cabinReportLocalEdit.SpecialMealIssues);
      result.Supplies = stripIds(cabinReportLocalEdit.Supplies);
      result.TravelValueSeals = stripIds(cabinReportLocalEdit.TravelValueSeals);
      result.TravelValueIncomplete = cabinReportLocalEdit.TravelValueIncomplete;
      result.TravelValueIncompleteRow = cabinReportLocalEdit.TravelValueIncompleteRow;
      result.TravelValueIncompleteReason = cabinReportLocalEdit.TravelValueIncompleteReason;
      result.TravelValueRemarks = cabinReportLocalEdit.TravelValueRemarks;
      result.Remarks = cabinReportLocalEdit.Remarks;
      result.ArrivalGroundServices = cabinReportLocalEdit.ArrivalGroundServices;
      result.DepartureGroundServices = cabinReportLocalEdit.DepartureGroundServices;
      result.UpgradedPassengers = cabinReportLocalEdit.UpgradedPassengers;
      result.ChangedSeats = cabinReportLocalEdit.ChangedSeats;
      result.IncompleteServices = cabinReportLocalEdit.IncompleteServices;
      result.BoardingTimesRemarks = cabinReportLocalEdit.BoardingTimesRemarks;
      result.DisembarkationTimeRemarks = cabinReportLocalEdit.DisembarkationTimesRemarks;
      result.FlightOrders = cabinReportLocalEdit.FlightOrders;

      if (cabinReportLocalEdit.FirstPaxTime) {
        result.FirstPaxTime = cabinReportLocalEdit.FirstPaxTime;
      }

      if (cabinReportLocalEdit.LastPaxTime) {
        result.LastPaxTime = cabinReportLocalEdit.LastPaxTime;
      }

      if (cabinReportLocalEdit.FirstPaxDisembarkationTime) {
        result.FirstPaxDisembarkationTime = cabinReportLocalEdit.FirstPaxDisembarkationTime;
      }

      if (cabinReportLocalEdit.LastPaxDisembarkationTime) {
        result.LastPaxDisembarkationTime = cabinReportLocalEdit.LastPaxDisembarkationTime;
      }

      result.VariousIssues = [];
      var itemCount = cabinReportLocalEdit.VariousIssues.length;

      for (var i = 0; i < itemCount; i++) {
        var newItem = new CabinReportSendToServerItem();
        newItem.ReportGuid = cabinReportLocalEdit.ReportGuid;
        newItem.TemplateItemId = cabinReportLocalEdit.VariousIssues[i].Id;
        newItem.Value = cabinReportLocalEdit.VariousIssues[i].ItemHasValue ? 1 : 0;

        if (newItem.Value == 1) {
          newItem.Remarks = cabinReportLocalEdit.VariousIssues[i].ItemValue;
          newItem.Photos = stripIds(cabinReportLocalEdit.VariousIssues[i].Photos);
        }

        result.VariousIssues.push(newItem);
      }

      result.GroomingReports = cabinReportLocalEdit.GroomingReports;
      result.FoundProperties = stripIds(cabinReportLocalEdit.FoundProperties);
      return result;
    }
    /**
     * Strip Ids of selected input
     * @memberof CabinReportSendToServerFactory
     * @param {array} inputArray
     * @returns {object} stripedInputArray 
     */


    function stripIds(inputArray) {
      for (var i = 0; i < inputArray.length; i++) {
        delete inputArray[i].Id;
      }

      return inputArray;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CabinReportSyncResultFactory', CabinReportSyncResultFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CabinReportSyncResultFactory
  * @description 
  *   Manage Cabin Report Sync Results
  * @ngInject
  */

  function CabinReportSyncResultFactory(GenericService) {
    /**
    * Initialize the CabinReportSyncResult
    * @memberof CabinReportSyncResultFactory
    */
    function CabinReportSyncResult() {
      this.reportGuid = null;
      this.message = null;
      this.success = null;
      this.FlightAimsId = null;
      this.FlightId = null;
      this.ScheduledDepartureDateUTC = null;
      this.FlightNo = null;
      this.Departure = null;
      this.Arrival = null;
      this.ScheduledDepartureTimeUTC = null;
      this.AcTailNo = null;
      this.Result = null;
      this.getRoute = getRoute;
    }
    /**
    * Get Report Route
    * @memberof CabinReportSyncResultFactory
    * @return {string} route
    */


    function getRoute() {
      if (this.Departure == null && this.Arrival == null) return '-null-';else return (this.Departure || '?') + '-' + (this.Arrival || '?');
    }

    var objType = 'cabinReportSyncResults';
    var objCallback = CabinReportSyncResult;
    var service = {
      getSyncResult: getSyncResult,
      getCabinReportSyncResultsFromStorage: getCabinReportSyncResultsFromStorage,
      setCabinReportSyncResultsToStorage: setCabinReportSyncResultsToStorage,
      getSuccesses: getSuccesses,
      getFailures: getFailures,
      fromObjectList: fromObjectList
    };
    /**
     * Extend an array of Objects from the default CabinReportSyncResult Object
     * @memberof CabinReportSyncResultFactory
     * @param {Array} objList  an Array Of Cabin Report Sync Results
     * @returns {Array} CabinReportSyncResults
     */

    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallback);
    }
    /**
     * Get Sync Result  from given list
     * @memberof CabinReportSyncResultFactory
     * @param {Array} syncResults  an Array Of Cabin Report Sync Results
     * @param {string} reportGuid The report's Guid
     * @returns {object} CabinReportSyncResult
     */


    function getSyncResult(syncResults, reportGuid) {
      if (syncResults == null) return null;
      var result = null;
      var arrayLength = syncResults.length;

      for (var i = 0; i < arrayLength; i++) {
        if (syncResults[i].reportGuid == reportGuid) {
          result = syncResults[i];
          break;
        }
      }

      return result;
    }

    ;
    /**
     * Get Sync Results
     * @memberof CabinReportSyncResultFactory
     * @returns {array} CabinReportSyncResults
     */

    function getCabinReportSyncResultsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Set Sync Results
     * @memberof CabinReportSyncResultFactory
     * @param {Array} syncResults  an Array Of Cabin Report Sync Results
     */


    function setCabinReportSyncResultsToStorage(cabinReportSyncResults) {
      GenericService.saveAll(cabinReportSyncResults, objType, objCallback);
    }
    /**
     * Get Successfull Sync Results from given syncResult
     * @memberof CabinReportSyncResultFactory
     * @returns {array} successes
     */


    function getSuccesses(syncResults) {
      var result = 0;

      for (var i = 0; i < syncResults.length; i++) {
        if (syncResults[i].success == true) {
          result = result + 1;
        }
      }

      return result;
    }
    /**
     * Get Failed Sync Results from given syncResults
     * @memberof CabinReportSyncResultFactory
     * @returns {array} failures
     */


    function getFailures(syncResults) {
      var result = 0;

      for (var i = 0; i < syncResults.length; i++) {
        if (syncResults[i].success == false) {
          result = result + 1;
        }
      }

      return result;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CabinReportTemplateItemFactory', CabinReportTemplateItemFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CabinReportTemplateItemFactory
  * @description 
  *   Manage Cabin Report Template Item.
  * @ngInject
  */

  function CabinReportTemplateItemFactory(GenericService) {
    /**
    * Initialize the CabinReportTemplateItem
    * @memberof CabinReportTemplateItemFactory
    */
    function CabinReportTemplateItem() {
      this.Id = null;
      this.Hint = null;
      this.Label = null;
      this.OrderNo = null;
      this.CategoryLabel = null;
      this.PresetComments = null;
      this.Photos = new Array();
      this.GetId = GetId;
    }

    var objType = 'cabinReportTemplateItems';
    var objCallback = CabinReportTemplateItem;
    var service = {
      getCabinReportTemplateItemsFromStorage: getCabinReportTemplateItemsFromStorage,
      setCabinReportTemplateItemsToStorage: setCabinReportTemplateItemsToStorage,
      newItem: newItem
    };
    /**
     * Overide default get Id
     * @memberof CabinReportTemplateItemFactory
     * @returns {number} Id 
     */

    function GetId() {
      return this.Id;
    }
    /**
    * Get Cabin Report Template Items
    * @memberof CabinReportTemplateItemFactory
    * @returns {Array} CabinReportTemplateItems 
    */


    function getCabinReportTemplateItemsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Save Cabin Report Template Items to storage
     * @memberof CabinReportTemplateItemFactory
     * @param {Array} CabinReportTemplateItems A list of Cabin Report Template Items
     */


    function setCabinReportTemplateItemsToStorage(cabinReportTemplateItems) {
      GenericService.saveAll(cabinReportTemplateItems, objType, objCallback);
    }
    /**
     * Create a new Cabin Report Template Item 
     * @memberof CabinReportTemplateItemFactory
     * @return {object} CabinReportTemplateItem
     */


    function newItem() {
      return GenericService.constructor(objCallback);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('ReportCtrl', ReportCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name ReportCtrl
  * @description 
  *  Manages the Report View
  * @ngInject
  */

  function ReportCtrl($scope, $log, $uibModal, $timeout, $routeParams, UserFactory, FlightFactory, CabinReportLocalEditFactory, CabinReportLocalEditCreatorFactory, $location, SettingsMain, WaterUpliftActionFactory, enableWaterUpliftReporting, BarTrolleyFactory, FirstAidKitFactory, MedicalIncidentFactory, SpecialMealIssueFactory, IncompleteServicesIssueFactory, SupplyFactory, TravelValueSealFactory, CCMSCrewPositionFactory, CCMSFactory, ReportGuidFactory, TravelValueIncompleteReasonFactory, LogService, CrewAssessmentFactory, $route, InfoAPIService, customerIncidentQuestionIds, PaxInfoFactory, FlightOrdersFactory, GroomingCategoriesFactory) {
    // get the report id
    var reportId = $routeParams.reportId;
    var _report = null;
    var user = UserFactory.getUser();
    var editingPage = SettingsMain.getEditingPage();
    $scope.IsShopInTheCloudEnable = SettingsMain.getIsShopInTheCloudEnable();
    $scope.IsCustomerIncident = IsCustomerIncident;
    $scope.enableWaterUpliftReporting = enableWaterUpliftReporting;
    $scope.updateOrderStatus = updateOrderStatus;
    $scope.flightOrdersRejectReasons = FlightOrdersFactory.getNotDeliveredReasons();
    $scope.clearFlightOrderFeedback = clearFlightOrderFeedback;

    function IsCustomerIncident(id) {
      return customerIncidentQuestionIds.includes(id);
    }

    var groomingCategories = GroomingCategoriesFactory.getGroomingCategories();
    $scope.hasGroomingCategories = groomingCategories.length > 0;

    $scope.discard = function () {
      if (_report == null) {
        _report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);
      }

      var guid = _report.ReportGuid;
      var status = _report.Status; // delete the temp report

      CabinReportLocalEditFactory.deleteTempReport(); //reuse guid if this was a new report

      if (status == 'pending') ReportGuidFactory.restoreGuid(_report.ReportGuid); // new / edit existing / load from temp

      if (reportId.startsWith('new:')) {
        var flightId = $routeParams.flightId; // create a new report

        var newLocalReport = CabinReportLocalEditCreatorFactory.createNewLocalReportForFlight(flightId);

        if (newLocalReport == null) {
          bootbox.alert("<h4>Attention</h4>Unable to create a new log!<br/>Available pool of resources has been depleted and you need to synchronize with the server to renew it.", function () {
            $location.path("/");
            $scope.$apply();
          });
        } else {
          // load the new report
          _report = newLocalReport;
        }
      } else if (reportId == 'temp') {
        // load the report from the temp place
        _report = CabinReportLocalEditFactory.getCabinReportLocalEditFromTemp();

        if (_report == null) {
          // since we could not load the temp report, delete it
          CabinReportLocalEditFactory.deleteTempReport();
          bootbox.alert("<h4>Warning</h4>Unable to load temporary log.<br/>No temporary log found in this device or the report was corrupted", function () {
            $location.path("/");
            $scope.$apply();
          });
        }
      } else {
        // load the report
        _report = CabinReportLocalEditFactory.getCabinReportLocalEdit(reportId);

        if (_report == null) {
          bootbox.alert("<h4>Warning</h4>Unable to load the requested log.<br/>This entry does not exist in this device, our its data are corrupted and the entry is unusable.", function () {
            $location.path("/");
            $scope.$apply();
          });
        }
      }

      $scope.report = _report;
      infoSaveOperation('discard');
    };

    $scope.state = 'report';
    $scope.logged_user_info = user.aimsId + ' - ' + user.name;
    $scope.isSecure = UserFactory.isSecure(); // new / edit existing / load from temp

    if (reportId.startsWith('new:')) {
      var flightId = $routeParams.flightId; // create a new report

      var newLocalReport = CabinReportLocalEditCreatorFactory.createNewLocalReportForFlight(flightId);

      if (newLocalReport == null) {
        bootbox.alert("<h4>Attention</h4>Unable to create a new log!<br/>Available pool of resources has been depleted and you need to synchronize with the server to renew it.", function () {
          $location.path("/");
          $scope.$apply();
        });
        return;
      } else {
        // load the new report
        _report = newLocalReport;
      }
    } else if (reportId == 'temp') {
      // load the report from the temp place
      _report = CabinReportLocalEditFactory.getCabinReportLocalEditFromTemp();

      if (_report == null) {
        // since we could not load the temp report, delete it
        CabinReportLocalEditFactory.deleteTempReport();
        bootbox.alert("<h4>Warning</h4>Unable to load temporary log.<br/>No temporary log found in this device or the report was corrupted", function () {
          $location.path("/");
          $scope.$apply();
        });
        return;
      }
    } else {
      // load the report
      _report = CabinReportLocalEditFactory.getCabinReportLocalEdit(reportId);

      if (_report == null) {
        bootbox.alert("<h4>Warning</h4>Unable to load the requested log.<br/>This entry does not exist in this device, our its data are corrupted and the entry is unusable.", function () {
          $location.path("/");
          $scope.$apply();
        });
        return;
      }
    }

    $scope.countDHC = 0;
    if (_report.crew) $scope.countDHC = _report.crew.filter(function (item) {
      return item.isDHC == true;
    }).length; //Additional feedback

    if (_report.crew) {
      var crewNeedsAdditionalFeedback = [];

      var crewMemberNeedsAdditionalFeedback = _report.crew.filter(function (x) {
        return x.needsAdditionalFeedback;
      });

      crewNeedsAdditionalFeedback.push(crewMemberNeedsAdditionalFeedback);

      if (crewNeedsAdditionalFeedback.length > 0) {
        var crewNeedsAdditionalFeedbackFlatten = crewNeedsAdditionalFeedback.flat();

        for (var i = 0; i < crewNeedsAdditionalFeedbackFlatten.length; i++) {
          _report.CCMSCrewPositions.find(function (x) {
            return x.CrewId == crewNeedsAdditionalFeedbackFlatten[i].aimsId;
          }).needsAdditionalFeedback = true;
          _report.CCMSCrewPositions.find(function (x) {
            return x.CrewId == crewNeedsAdditionalFeedbackFlatten[i].aimsId;
          }).AdditionalFeedback = crewNeedsAdditionalFeedbackFlatten[i].AdditionalFeedback;
          _report.CCMSCrewPositions.find(function (x) {
            return x.CrewId == crewNeedsAdditionalFeedbackFlatten[i].aimsId;
          }).AdditionalFeedbackId = crewNeedsAdditionalFeedbackFlatten[i].AdditionalFeedback.Id;
          _report.CCMSCrewPositions.find(function (x) {
            return x.CrewId == crewNeedsAdditionalFeedbackFlatten[i].aimsId;
          }).FeedbackAuthorName = crewNeedsAdditionalFeedbackFlatten[i].AdditionalFeedback.FeedbackAuthorName;
          _report.CCMSCrewPositions.find(function (x) {
            return x.CrewId == crewNeedsAdditionalFeedbackFlatten[i].aimsId;
          }).Route = _report.Route;
        }
      }
    } // update totals and set to scope


    _report.updateTotals();

    $scope.report = _report;
    $scope.infosaveaction = false; // save the report to a temp place

    if (_report.Status != 'synched') _report.saveReportAsTemp(); // set editing page to report

    SettingsMain.setEditingPage('report');

    if (_report && _report.ScheduledArrival) {
      var nowTimeStamp = moment.utc().valueOf();
      var schedullDepartureTimestamp = new Date(_report.ScheduledArrival).getTime();
      $scope.isFuture = false; //nowTimeStamp < schedullDepartureTimestamp;
    }

    $scope.showCompleted = showCompleted;
    $scope.showAll = showAll;
    $scope.compressedMode = false;

    function showCompleted() {
      if (!$scope.report.BarTrolleys || $scope.report.BarTrolleys.length == 0) $scope.panels.bars.visible = false;
      if (!$scope.report.MedicalIncidents || !(_report.FirstAidKits.length > 0 || _report.MedicalIncidents.length > 0)) $scope.panels.medical.visible = false;
      if (!$scope.report.ItemsFoundSectionHasValue) $scope.panels.security.visible = false;
      if (!$scope.report.SpecialMealIssues || $scope.report.SpecialMealIssues.length == 0) $scope.panels.special.visible = false;
      if (!$scope.report.Supplies || $scope.report.Supplies.length == 0) $scope.panels.supplies.visible = false;
      if (!$scope.report.TravelValueSeals || !(_report.TravelValueSeals.length > 0 || _report.TravelValueIncomplete || _report.TravelValueRemarks != null && _report.TravelValueRemarks != '')) $scope.panels.travel.visible = false;
      if (!$scope.report.UMSectionHasValue) $scope.panels.um.visible = false;
      if ($scope.report.ActiveVariousIssues == 0) $scope.panels.various.visible = false;
      if (!$scope.report.WaterSectionHasValue) $scope.panels.water.visible = false;
      if (!($scope.report.UpgradedPassengers.length > 0)) $scope.panels.upgd.visible = false;
      if (!($scope.report.ChangedSeats.length > 0)) $scope.panels.changedSeats.visible = false;
      if (!($scope.report.IncompleteServices.length > 0)) $scope.panels.incompleteServices.visible = false;
      if (!$scope.report.BoardingTimes || _report.BoardingTimesRemarks != null && _report.BoardingTimesRemarks != '') $scope.panels.travel.visible = false;
      if (!$scope.report.LuggageSectionHasValue) $scope.panels.luggage.visible = false;
      if (!$scope.report.FoundProperties || $scope.report.FoundProperties.length == 0) $scope.panels.foundProperty.visible = false;
      $scope.panels.leg.open = !$scope.panels.leg.open;
      $scope.compressedMode = true;
    }

    function showAll() {
      $scope.panels.bars.visible = true;
      $scope.panels.medical.visible = true; //$scope.panels.security.visible = true;

      $scope.panels.special.visible = true;
      $scope.panels.supplies.visible = true;
      $scope.panels.travel.visible = true;
      $scope.panels.various.visible = true;
      $scope.panels.water.visible = true;
      $scope.panels.groundServices.visible = true;
      $scope.panels.flightOrders.visible = true;
      $scope.panels.upgd.visible = true;
      $scope.panels.changedSeats.visible = true;
      $scope.panels.incompleteServices.visible = true;
      $scope.panels.boardingTimes.visible = true;
      $scope.panels.disembarkationTimes.visible = true;
      $scope.panels.luggage.visible = true;
      $scope.panels.foundProperty.visible = true;
      $scope.panels.leg.open = !$scope.panels.leg.open;
      $scope.compressedMode = false;
    }

    $scope.panels = {
      showOnlyOne: true,
      leg: {
        visible: true,
        open: true,
        cssClass: function cssClass() {
          return _report.IsValid ? 'panel-green' : 'panel-orange';
        }
      },
      info: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          return 'panel-green';
        }
      },
      ccms: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          return !_report.CCMSCrewPositionsIsValid || _report.CCMSCrewPositions.length == 0 ? 'panel-orange' : 'panel-green';
        }
      },
      bars: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (!_report.BarTrolleysIsValid) return 'panel-orange';else if (_report.BarTrolleys.length > 0) return 'panel-green';else return 'panel-default';
        }
      },
      medical: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (!_report.FirstAidKitsIsValid || !_report.MedicalIncidentsIsValid) return 'panel-orange';else if (_report.FirstAidKits.length > 0 || _report.MedicalIncidents.length > 0) return 'panel-green';else return 'panel-default';
        }
      },
      // security: {
      // 	visible: true,
      // 	open: false,
      // 	cssClass: function () {
      // 		if (!report.ItemsFoundSectionIsValid)
      // 			return 'panel-orange';
      // 		else if (report.ItemsFoundSectionHasValue)
      // 			return 'panel-green';
      // 		else
      // 			return 'panel-default';
      // 	}
      // },
      special: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (!_report.SpecialMealIssuesIsValid) return 'panel-orange';else if (_report.SpecialMealIssues.length > 0) return 'panel-green';else return 'panel-default';
        }
      },
      supplies: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (!_report.SuppliesIsValid) return 'panel-orange';else if (_report.Supplies.length > 0) return 'panel-green';else return 'panel-default';
        }
      },
      travel: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (!_report.TravelValueSealsIsValid || !_report.TravelValueIncompleteIsValid)
            /*!report.CashValuesIsValid)*/
            return 'panel-orange';else if (_report.TravelValueSeals.length > 0 || _report.TravelValueIncomplete || _report.TravelValueRemarks != null && _report.TravelValueRemarks != '') return 'panel-green';else return 'panel-default';
        }
      },
      um: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (!_report.UMSectionIsValid) return 'panel-orange';else if (_report.UMSectionHasValue) return 'panel-green';else return 'panel-default';
        }
      },
      various: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (_report.WarningVariousIssues > 0) return 'panel-orange';else if (_report.ActiveVariousIssues > 0) return 'panel-green';else return 'panel-default';
        }
      },
      water: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (!_report.WaterSectionIsValid) return 'panel-orange';else if (_report.WaterSectionHasValue) return 'panel-green';else return 'panel-default';
        }
      },
      groundServices: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (_report.GroundServicesSectionHasValue) return 'panel-green';else return 'panel-default';
        }
      },
      flightOrders: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (_report.FlightOrdersSectionHasValue) return 'panel-green';else return 'panel-orange';
        }
      },
      upgd: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (_report.UpgradedPassengers.length > 0) return 'panel-green';else return 'panel-default';
        }
      },
      changedSeats: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (_report.ChangedSeats.length > 0) return 'panel-green';else return 'panel-default';
        }
      },
      incompleteServices: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (_report.IncompleteServices.length > 0) return 'panel-green';else return 'panel-default';
        }
      },
      boardingTimes: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (_report.FirstPaxTime && _report.LastPaxTime) return 'panel-green';else return 'panel-default';
        }
      },
      disembarkationTimes: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (_report.FirstPaxDisembarkationTime && _report.LastPaxDisembarkationTime) return 'panel-green';else return 'panel-default';
        }
      },
      luggage: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (_report.LuggageNumber > 0) return 'panel-green';else return 'panel-default';
        }
      },
      foundProperty: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (!_report.FoundPropertiesIsValid) return 'panel-orange';
          if (_report.FoundProperties.length > 0) return 'panel-green';
          return 'panel-default';
        }
      }
    };

    $scope.panelClicked = function (e) {
      var q = $(e.currentTarget);
      if (q.hasClass('panel-sector')) q = q.find('textarea');else q = q.parent('.panel-sector').find('textarea');
      q.each(function (index, item) {
        autoAdjustTextarea(item);
      });
    };

    var flight = FlightFactory.getFlightFromStorage(_report.FlightId);

    if (flight == null) {
      flight = FlightFactory.getLocalFlightFromStorage(_report.FlightId);
    }

    if (flight == null) {
      handleIfReport(_report);
      SettingsMain.setEditingPage(null);
      $location.path("/");
    }

    if (flight != null) {
      $scope.flight = flight;
      var dateObj = new Date(flight.FlightDate);
      $scope.waterSectionRequired = dateObj.getDate() == 1 || dateObj.getDate() == 15;
    }

    if (flight == null) {
      handleIfReport(_report);
      SettingsMain.setEditingPage(null);
      $location.path("/");
    }

    if (flight != null) {
      $scope.flight = flight;
      var dateObj = new Date(flight.FlightDate);
      $scope.waterSectionRequired = dateObj.getDate() == 1 || dateObj.getDate() == 15;
    }

    $scope.sendCustomerIncident = sendCustomerIncident;
    /**
     * Send  application Customer Incident information
     * @memberof ReportCtrl
     */

    function sendCustomerIncident(description, label, photos) {
      var image = photos.length > 0 ? photos[0].PhotoData : null;
      var flightDate = new Date(flight.FlightDate);
      var flightDescription = flight.FlightNo + " " + flight.Departure + "-" + flight.Arrival + " " + (flightDate.getUTCDate() > 10 ? flightDate.getUTCDate() : "0" + flightDate.getUTCDate()) + "-" + (flightDate.getUTCMonth() > 9 ? flightDate.getUTCMonth() + 1 : "0" + (flightDate.getUTCMonth() + 1)) + "-" + flightDate.getUTCFullYear();
      var _customerIncident = {
        flightDescription: flightDescription,
        question: label,
        description: description,
        image: image
      };
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgCustomerIncidentSend.html',
        controller: 'CustomerModalCtrl',
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          customerIncident: function customerIncident() {
            return _customerIncident;
          }
        }
      });
    } //Clear Fields Functionality


    $scope.clearItemsFoundDescription = clearItemsFoundDescription;
    $scope.clearItemsFoundAgent = clearItemsFoundAgent;
    $scope.clearItemsFoundSignature = clearItemsFoundSignature;
    $scope.clearUMDescription = clearUMDescription;
    $scope.clearUMAgent = clearUMAgent;
    $scope.clearUMSignature = clearUMSignature;
    $scope.clearWaterRemarks = clearWaterRemarks;
    $scope.clearTravelValueRemarks = clearTravelValueRemarks;
    $scope.clearBoardingTimesRemarks = clearBoardingTimesRemarks;
    $scope.clearDisembarkationTimesRemarks = clearDisembarkationTimesRemarks;
    $scope.clearRemarks = clearRemarks;
    $scope.clearCrewRemarks = clearCrewRemarks;
    $scope.clearVariousItemRemarks = clearVariousItemRemarks;
    $scope.clearBarSealsPhotoRemarks = clearBarSealsPhotoRemarks;
    $scope.clearLuggageDescription = clearLuggageDescription;
    $scope.reportItemValueChanged = reportItemValueChanged;
    $scope.cancelClicked = cancelClicked;
    $scope.saveClicked = saveClicked;
    $scope.saveDraftClicked = saveDraftClicked;
    $scope.deleteReportClicked = deleteReportClicked; //update report when a report item is changed

    $scope.reportChanged = reportChanged; // Incomplete Travel
    // Get list of reasons

    $scope.reportTravelValueIncompleteReasons = TravelValueIncompleteReasonFactory.getReasonsFromStorage();
    $scope.plusTravelValueIncompleteRow = plusTravelValueIncompleteRow;
    $scope.minusTravelValueIncompleteRow = minusTravelValueIncompleteRow;
    $scope.reportTravelIncompleteChanged = reportTravelIncompleteChanged; //UMnumber

    $scope.plusUMNumber = plusUMNumber;
    $scope.minusUMNumber = minusUMNumber;
    $scope.clearUMNumber = clearUMNumber;
    $scope.waterUpliftActions = WaterUpliftActionFactory.getWaterUpliftActionsFromStorageAsStrings(); //copy positions from previous leg, to minimize input
    //normally, ac performs several legs in a row with the same crew, each at the same position on all legs

    $scope.copyCcmsPositions = copyCcmsPositions; // List of ccms position of this A/C

    $scope.reportCCMSPositions = reportCCMSPositions; //Modals
    // Bars Trolleys

    $scope.addNewBarTrolley = addNewBarTrolley;
    $scope.editBarTrolley = editBarTrolley;
    $scope.deleteBarTrolley = deleteBarTrolley; // Luggage Number

    $scope.plusLuggageNumber = plusLuggageNumber;
    $scope.minusLuggageNumber = minusLuggageNumber;
    $scope.clearLuggageNumber = clearLuggageNumber; // CCMS

    $scope.addNewCCMSCrewPosition = addNewCCMSCrewPosition;
    $scope.editCCMSCrewPosition = editCCMSCrewPosition;
    $scope.deleteCCMSCrewPosition = deleteCCMSCrewPosition;
    $scope.user = UserFactory.getUser();
    $scope.showFeedback = [];

    $scope.toggleAdditionalFeedback = function ($index) {
      $scope.showFeedback[$index] = !$scope.showFeedback[$index];
    }; //CCMS: Show(toggle) CrewComments


    $scope.showCrewComments = function (item) {
      if (item.HasCrewComments == true && !item.CrewComments) {
        item.HasCrewComments = false;
      } //Clear comments
      else if (item.HasCrewComments == true) {
          bootbox.dialog({
            message: "Please confirm that you wish to clear the comments",
            title: "<strong>Attention<strong>",
            buttons: {
              cancel: {
                label: "Cancel",
                className: "btn-default",
                callback: function callback() {}
              },
              ok: {
                label: "Ok",
                className: "btn-warning",
                callback: function callback() {
                  $timeout(function () {
                    item.CrewComments = null;
                    item.HasCrewComments = false;
                  });
                  return true;
                }
              }
            }
          });
        } else {
          item.HasCrewComments = true;
        }
    }; //Additional Feedback: Show(toggle) Crew Comments


    $scope.showAdditionalFeedback = function (item) {
      if (item.HasAdditionalFeedbackComments == true && !item.CrewComments) {
        item.HasAdditionalFeedbackComments = false;
      } //Clear comments
      else if (item.HasAdditionalFeedbackComments == true) {
          bootbox.dialog({
            message: "Please confirm that you wish to clear the comments",
            title: "<strong>Attention<strong>",
            buttons: {
              cancel: {
                label: "Cancel",
                className: "btn-default",
                callback: function callback() {}
              },
              ok: {
                label: "Ok",
                className: "btn-warning",
                callback: function callback() {
                  $timeout(function () {
                    item.CrewComments = null;
                    item.HasAdditionalFeedbackComments = false;
                  });
                  return true;
                }
              }
            }
          });
        } else {
          item.HasAdditionalFeedbackComments = true;
        }
    }; // Flight Detail


    $scope.openFlightDetailModal = openFlightDetailModal; // First Aid Kits

    $scope.addNewFirstAidKit = addNewFirstAidKit;
    $scope.editFirstAidKit = editFirstAidKit;
    $scope.deleteFirstAidKit = deleteFirstAidKit; // Medical Incidents

    $scope.addNewMedicalIncident = addNewMedicalIncident;
    $scope.editMedicalIncident = editMedicalIncident;
    $scope.deleteMedicalIncident = deleteMedicalIncident; // Special Meals

    $scope.addNewSpecialMealIssue = addNewSpecialMealIssue;
    $scope.editSpecialMealIssue = editSpecialMealIssue;
    $scope.deleteSpecialMealIssue = deleteSpecialMealIssue; // Supplies

    $scope.addNewSupply = addNewSupply;
    $scope.editSupply = editSupply;
    $scope.deleteSupply = deleteSupply; //UPGDs

    $scope.addNewUPGD = addNewUPGD;
    $scope.editUPGD = editUPGD;
    $scope.deleteUPGD = deleteUPGD; //Changed seats

    $scope.addNewChangedSeat = addNewChangedSeat;
    $scope.editChangedSeat = editChangedSeat;
    $scope.deleteChangedSeat = deleteChangedSeat; // Travel value seal 

    $scope.addNewTravelValueSeal = addNewTravelValueSeal;
    $scope.editTravelValueSeal = editTravelValueSeal;
    $scope.deleteTravelValueSeal = deleteTravelValueSeal; // Incomplete in-flight Services

    $scope.addIncompleteService = addIncompleteService;
    $scope.editIncompleteService = editIncompleteService;
    $scope.deleteIncompleteService = deleteIncompleteService; // Attatch Photo

    $scope.attachPhotoOnVariousItem = attachPhotoOnVariousItem;
    $scope.attachPhotoOnBarTrolley = attachPhotoOnBarTrolley;
    $scope.attachPhotoOnFlightOrder = attachPhotoOnFlightOrder;
    $scope.addNewEMKFirstAidKit = addNewEMKFirstAidKit; // Additional Feedback

    $scope.addAdditionalFeedback = addAdditionalFeedback; // Found Property 

    $scope.addNewFoundProperty = addNewFoundProperty;
    $scope.editFoundProperty = editFoundProperty;
    $scope.deleteFoundProperty = deleteFoundProperty; //Clear functions     

    /**
     * Clear Selected Field
     * @memberof ReportCtrl
     * @param {object} target the object whose field we want to clear
     * @param {string} fieldName the field Name to clear
     */

    function clearField(target, fieldName) {
      if (target[fieldName] == undefined || target[fieldName] == null || target[fieldName] == '') return false;
      bootbox.dialog({
        message: "Please confirm that you wish to clear this field",
        title: "<strong>Attention<strong>",
        buttons: {
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          },
          ok: {
            label: "Ok",
            className: "btn-warning",
            callback: function callback() {
              target[fieldName] = null;
              $timeout($scope.reportItemValueChanged); //TODO REMOVE COMMENT DANGEROUS $SCOPE $APPLY
              //$scope.$apply();

              return true;
            }
          }
        }
      });
    }
    /**
     * Clear itemsFoundDescription
     * @memberof ReportCtrl
     */


    function clearItemsFoundDescription() {
      clearField($scope.report, "ItemsFoundDescription");
    }
    /**
     * Clear itemsFoundAgent
     * @memberof ReportCtrl
     */


    function clearItemsFoundAgent() {
      clearField($scope.report, "ItemsFoundAgent");
    }
    /**
     * Clear itemsFoundSignature
     * @memberof ReportCtrl
     */


    function clearItemsFoundSignature() {
      clearField($scope.report, "ItemsFoundSignature");
    }
    /**
     * Clear UMDescription
     * @memberof ReportCtrl
     */


    function clearUMDescription() {
      clearField($scope.report, "UMDescription");
    }
    /**
     * Clear UMAgent
     * @memberof ReportCtrl
     */


    function clearUMAgent() {
      clearField($scope.report, "UMAgent");
    }
    /**
     * Clear UMSignature
     * @memberof ReportCtrl
     */


    function clearUMSignature() {
      clearField($scope.report, "UMSignature");
    }
    /**
     * Clear LuggageDescription
     * @memberof ReportCtrl
     */


    function clearLuggageDescription() {
      clearField($scope.report, "LuggageDescription");
    }
    /**
     * Clear WaterRemarks
     * @memberof ReportCtrl
     */


    function clearWaterRemarks() {
      clearField($scope.report, "WaterUpliftRemarks");
    }
    /**
     * Clear Travel Value Remarks
     * @memberof ReportCtrl
     */


    function clearTravelValueRemarks() {
      clearField($scope.report, "TravelValueRemarks");
    }
    /**
    * Clear boarding times Remarks
    * @memberof ReportCtrl
    */


    function clearBoardingTimesRemarks() {
      clearField($scope.report, "BoardingTimesRemarks");
    }
    /**
    * Clear disembarkation times Remarks
    * @memberof ReportCtrl
    */


    function clearDisembarkationTimesRemarks() {
      clearField($scope.report, "DisembarkationTimesRemarks");
    }
    /**
     * Clear Remarks
     * @memberof ReportCtrl
     */


    function clearRemarks() {
      clearField($scope.report, "Remarks");
    }
    /**
     * Clear Crew Remarks
     * @memberof ReportCtrl
     */


    function clearCrewRemarks() {
      clearField($scope.report, "CrewRemarks");
    }
    /**
     * Clear Various Item Remarks
     * @memberof ReportCtrl
     */


    function clearVariousItemRemarks(item) {
      if (item != null) {
        clearField(item, "ItemValue");
      }
    }
    /**
     * Clear Various Item Remarks
     * @memberof ReportCtrl
     */


    function clearBarSealsPhotoRemarks(item) {
      if (item != null) {
        clearField(item, "PhotoRemarks");
      }
    }
    /**
     * When the user types a value into a report item updates totals of the report
     * @memberof ReportCtrl
     */


    function reportItemValueChanged() {
      // update the report totals
      _report.updateTotals();
    }
    /**
     * Go to calendar and reset report
     * @memberof ReportCtrl
     */


    function cancelClicked() {
      //store report details
      var guid = _report.ReportGuid;
      var status = _report.Status; // delete the temp report

      CabinReportLocalEditFactory.deleteTempReport(); //reuse guid if this was a new report

      if (status == 'pending') ReportGuidFactory.restoreGuid(_report.ReportGuid); // set editing page to none

      SettingsMain.setEditingPage(null); // go to dashboard

      $location.path("/");
    }
    /**
     * Show information about the save action
     * @memberof ReportCtrl
     * @param {string} state The action of the save completed or draft or discard
     */


    function infoSaveOperation(state) {
      if (state == 'completed') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      } else if (state == 'draft') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      } else if (state == 'discard') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      }

      $timeout(function () {
        $scope.infosaveaction = false;
      }, 5000);
    }
    /**
     * Save Completed and Go to calendar
     * @memberof ReportCtrl
     */


    function saveClicked() {
      $scope.groomingReports = GroomingCategoriesFactory.collectGroomingReports($scope.groomingReportsByCrew);
      GroomingCategoriesFactory.saveGroomingReports($scope.groomingReportsByCrew);
      _report.GroomingReports = $scope.groomingReports;

      _report.updateTotals(); // make sure statuses/flags are up to date
      // AC 4.2: If any found property is Draft, the Cabin Report must be Draft


      if (_report.HasFoundPropertyDraft) {
        _report.Status = 'draft';

        _report.saveReport();

        FlightFactory.updateFlightFromReport(_report);
        CabinReportLocalEditFactory.deleteTempReport();
        CrewAssessmentFactory.updateCrewMembers(_report.CCMSCrewPositions, _report.Route, _report.DutyDate, $scope.flight.FlightDate);
        SettingsMain.setEditingPage(null);
        infoSaveOperation(_report.Status);
        return; // stay on the same page
      } // save the report


      _report.Status = 'completed';

      _report.saveReport();

      FlightFactory.updateFlightFromReport(_report); // delete the temp report

      CabinReportLocalEditFactory.deleteTempReport();
      CrewAssessmentFactory.updateCrewMembers(_report.CCMSCrewPositions, _report.Route, _report.DutyDate, $scope.flight.FlightDate); // set editing page to none

      SettingsMain.setEditingPage(null);
      infoSaveOperation(_report.Status); // go to flight info

      $location.path('/flightinfo/' + _report.FlightId);
    }
    /**
     * Save Draft
     * @memberof ReportCtrl
     */


    function saveDraftClicked() {
      // save the report
      _report.Status = 'draft';

      _report.saveReport();

      FlightFactory.updateFlightFromReport(_report);
      CrewAssessmentFactory.updateCrewMembers(_report.CCMSCrewPositions, _report.Route, _report.DutyDate, $scope.flight.FlightDate); // delete the temp report

      CabinReportLocalEditFactory.deleteTempReport(); // set editing page to none

      SettingsMain.setEditingPage(null);
      infoSaveOperation(_report.Status); // go to dashboard
      // $location.path("/");
    }
    /**
     * Delete Report
     * @memberof ReportCtrl
     */


    function deleteReportClicked() {
      var status = _report.status;
      var title = "Warning";

      if (status == 'synched') {
        title = "Attention";
      }

      bootbox.dialog({
        message: "Please confirm that you wish to reset this Cabin Report.",
        title: "<strong>" + title + "<strong>",
        buttons: {
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          },
          danger: {
            label: "Reset Cabin Report",
            className: "btn-warning",
            callback: function callback() {
              //store report details
              var guid = _report.ReportGuid;
              var status = _report.Status; // remove report from temp location and
              // possibly from permanent location

              CabinReportLocalEditFactory.deleteReport(_report.ReportGuid);
              CrewAssessmentFactory.updateCrewMembers(_report.CCMSCrewPositions, _report.Route, _report.DutyDate, $scope.flight.FlightDate); // delete the temp report

              CabinReportLocalEditFactory.deleteTempReport();
              FlightFactory.updateFlightFromReport(_report); //reuse guid if this was  report was never sent to the server

              if (status == 'draft' || status == 'completed') ReportGuidFactory.restoreGuid(_report.ReportGuid); // set editing page to none

              SettingsMain.setEditingPage(null); // next code moves user to main page

              $timeout(function () {
                if ($location.path() == "/report/temp") {
                  $scope.openReport();
                } else {
                  $route.reload();
                }
              });
            }
          }
        }
      });
    }
    /**
     * increase row no of travel value
     * @memberof ReportCtrl
     */


    function plusTravelValueIncompleteRow() {
      if (!_report.TravelValueIncompleteRow && _report.TravelValueIncompleteRow != 0) _report.TravelValueIncompleteRow = 0;else _report.TravelValueIncompleteRow++;
      if (_report.TravelValueIncompleteRow > 99) _report.TravelValueIncompleteRow = 99;
      $scope.reportItemValueChanged();
    }
    /**
     * decrease row no of travel value
     * @memberof ReportCtrl
     */


    function minusTravelValueIncompleteRow() {
      if (!_report.TravelValueIncompleteRow && _report.TravelValueIncompleteRow != 0) _report.TravelValueIncompleteRow = 0;else _report.TravelValueIncompleteRow--;
      if (_report.TravelValueIncompleteRow < 0) _report.TravelValueIncompleteRow = 0;
      $scope.reportItemValueChanged();
    }
    /**
     * travel value changed
     * @memberof ReportCtrl
     */


    function reportTravelIncompleteChanged() {
      if (!_report.TravelIncomplete) {
        _report.TravelValueIncompleteRow = null;
        _report.TravelValueIncompleteReason = null;
      }

      $scope.reportItemValueChanged();
    }
    /**
     * When report changes run to update the item
     * @memberof ReportCtrl
     */


    function reportChanged(item) {
      // put preset comments
      if (item != null) {
        if (item.PresetComments != null) {
          if (item.ItemValue == null || item.ItemValue == '') {
            item.ItemValue = item.PresetComments;
          }
        }
      } // update the report totals


      _report.updateTotals(); // save the report to a temp place


      if (_report.Status != 'synched') _report.saveReportAsTemp();
    } //CCMS

    /**
     * make the ccms positions
     * @memberof ReportCtrl
     */


    function reportCCMSPositions() {
      var reportCCMSPositions = new Array();
      var allCCMSPositions = CCMSFactory.getCCMSFromStorage();

      for (var i = 0; i < allCCMSPositions.length; i++) {
        // find the positions for this aircraft type
        if (allCCMSPositions[i].Aircraft == _report.AcType) {
          for (var j = 0; j < allCCMSPositions[i].Positions.length; j++) {
            reportCCMSPositions.push(allCCMSPositions[i].Positions[j].Position);
          }
        }
      }

      return reportCCMSPositions;
    }
    /**
     * Open confirmation modal for coping ccms 
     * @memberof ReportCtrl
     */


    function copyCcmsPositions() {
      bootbox.dialog({
        message: "Copy CCMS positions from previous leg?<br/><strong>Attention: </strong>Any current CCMS data will be overwritten",
        title: "<strong>CCMS Copy<strong>",
        buttons: {
          no: {
            label: "No",
            className: "btn-default",
            callback: function callback() {}
          },
          yes: {
            label: "Yes",
            className: "btn-warning",
            callback: function callback() {
              copyCcmsPositionsFinal();
              $timeout($scope.reportItemValueChanged);
            }
          }
        }
      });
    }
    /**
     * copy positions from previous leg, to minimize input, normally, ac performs several legs in a row with the same crew, each at the same position on all legs   
     * @memberof ReportCtrl
     */


    function copyCcmsPositionsFinal() {
      if (_report.CCMSCrewPositions == null || _report.CCMSCrewPositions.length == 0) return;
      var guid = _report.ReportGuid;
      var ac = _report.AcTailNo;
      var dt = _report.ScheduledDepartureDateUTC;
      var tm = _report.ScheduledDepartureTimeUTC;
      var previousCcms = CabinReportLocalEditFactory.getPreviousCabinReportCcmsPositions(guid, ac, dt, tm);

      if (previousCcms != null && previousCcms.length > 0) {
        var posX, posI, found; //TODO: Special treatment for manual entries: Add new ones, update existing will data (Id, Initials, Name, Position, CCMS)
        //loop all previous report positions

        for (var i = 0; i < previousCcms.length; i++) {
          posI = previousCcms[i];
          found = false; //loop all report positions

          for (var x = 0; x < _report.CCMSCrewPositions.length; x++) {
            posX = _report.CCMSCrewPositions[x]; //check for match

            if (posX.CrewId != null && posX.CrewId != '' && posI.CrewId != null && posI.CrewId != '' && posX.CrewId == posI.CrewId || posX.Initials != null && posX.Initials != '' && posI.Initials != null && posI.Initials != '' && posX.Initials == posI.Initials) {
              //copy only if source has CCMS set
              if (posI.CCMS != null && posI.CCMS != '') {
                //old crew matched to current crew
                posX.CCMS = posI.CCMS;
                found = true;
                break;
              }
            }
          } //if old record was a manual entry and not found in the current crew list, add it also here as manual


          if (posI.IsManual == true && !found) {
            //console.debug(posI);
            //console.debug(report);
            _report.CCMSCrewPositions.push(posI); //console.debug('Add code to copy manual crew member in this current report crew');

          }
        }
      }

      var s = '';
    } //UMNumber

    /**
     * increases UM number 
     * @memberof ReportCtrl
     */


    function plusUMNumber() {
      _report.UMNumber++;
      if (_report.UMNumber > 200) _report.UMNumber = 200;
      $scope.reportItemValueChanged();
    }
    /**
     * decreases UM number 
     * @memberof ReportCtrl
     */


    function minusUMNumber() {
      _report.UMNumber--;
      if (_report.UMNumber < 0) _report.UMNumber = 0;
      $scope.reportItemValueChanged();
    }
    /**
     * Clear UM number 
     * @memberof ReportCtrl
     */


    function clearUMNumber() {
      _report.UMNumber = 0;
      $scope.reportItemValueChanged();
    } //Luggage Number

    /**
     * increases Luggage number 
     * @memberof ReportCtrl
     */


    function plusLuggageNumber() {
      _report.LuggageNumber++;
      if (_report.LuggageNumber > 100) _report.LuggageNumber = 100;
      $scope.reportItemValueChanged();
    }
    /**
     * decreases Luggage number 
     * @memberof ReportCtrl
     */


    function minusLuggageNumber() {
      _report.LuggageNumber--;
      if (_report.LuggageNumber < 0) _report.LuggageNumber = 0;
      $scope.reportItemValueChanged();
    }
    /**
     * Clear Luggage number 
     * @memberof ReportCtrl
     */


    function clearLuggageNumber() {
      _report.LuggageNumber = 0;
      $scope.reportItemValueChanged();
    } // Bars Trolleys

    /**
     * define open bar/trolley dialog function
     * @memberof ReportCtrl
     */


    function openBarTrolleyModal(inputObject) {
      $uibModal.open({
        templateUrl: 'views/Dialogs/dlgBar.html',
        controller: 'BarTrolleyCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          bart: function bart() {
            return inputObject;
          }
        }
      }).result.then(function (result) {
        if (result != null) {
          if (result.isInsertMode) {
            _report.BarTrolleys.push(result.Object);
          } else {
            angular.extend(inputObject, result.Object);
          }
        }

        $scope.reportItemValueChanged();
      });
    }
    /**
     * add new bar/trolley
     * @memberof ReportCtrl
     */


    function addNewBarTrolley() {
      try {
        openBarTrolleyModal(null);
      } catch (e) {
        LogService.debug("template barTrolley url (null)", e);
      }
    }
    /**
     * edit bar/trolley
     * @memberof ReportCtrl
     */


    function editBarTrolley(bart) {
      try {
        openBarTrolleyModal(bart);
      } catch (e) {
        LogService.debug("template barTrolley url (bart)", e);
      }
    }
    /**
    * delete bar/trolley
    * @memberof ReportCtrl
    */


    function deleteBarTrolley(bart) {
      bootbox.dialog({
        message: "Are you sure you want to delete this record?",
        title: "<strong>Delete record<strong>",
        buttons: {
          no: {
            label: "No",
            className: "btn-default",
            callback: function callback() {}
          },
          yes: {
            label: "Yes",
            className: "btn-warning",
            callback: function callback() {
              BarTrolleyFactory.deleteFromList(bart, _report.BarTrolleys);
              $timeout($scope.reportItemValueChanged);
            }
          }
        }
      });
    } // function showOrHideBarTrolleyInputs() {
    // 	debugger;
    // 	$scope.showBarTrolleyUploadImage = $scope.report.BarTrolleys.filter(function (arg) { return filterPhotos(arg); }).length > 0 || $scope.report.BarTrolleys.length == 0;
    // 	$scope.showBarTrolleyInsertData = !$scope.report.BarTrolleys.filter(function (arg) { return filterPhotos(arg); }).length > 0 || $scope.report.BarTrolleys.length == 0;
    // }
    // function filterPhotos(arg) {
    // 	if (arg == null) {
    // 		return [];
    // 	}
    // 	else {
    // 		return arg.photos;
    // 	}
    // }
    // CCMS 

    /**
     * define open ccms crew position dialog function
     * @memberof ReportCtrl
     */


    function openCCMSCrewPositionModal(inputObject) {
      $uibModal.open({
        templateUrl: 'views/Dialogs/dlgCrew.html',
        controller: 'CCMSCrewPositionCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          crew: function crew() {
            return inputObject;
          }
        }
      }).result.then(function (result) {
        if (result != null && result.Object != null) {
          //check if the same crew member already exists
          var unique = true;
          var errorField = null;

          if (result.Object.CrewId != null && result.Object.CrewId != '') {
            if (_report.CCMSCrewPositions.filter(function (x) {
              return x.CrewId == result.Object.CrewId;
            }, true).length > 0) {
              unique = false;
              errorField = "id";
            }
          }

          if (result.Object.Initials != null && result.Object.Initials != '') {
            if (_report.CCMSCrewPositions.filter(function (x) {
              return x.Initials.toUpperCase() == result.Object.Initials.toUpperCase();
            }, true).length > 0) {
              unique = false;
              errorField = "initials";
            }
          }

          if (unique) {
            if (result.isInsertMode) {
              _report.CCMSCrewPositions.push(result.Object);
            } else {
              angular.extend(inputObject, result.Object);
            }

            $scope.reportItemValueChanged();
          } else {
            bootbox.alert("<h4>Warning</h4>Crew member with given " + errorField + ", already exists in this flight's crew and you may not add it again!");
          }
        }
      });
    }
    /**
     * add new ccms crew positio
     * @memberof ReportCtrl
     */


    function addNewCCMSCrewPosition() {
      openCCMSCrewPositionModal(null);
    } //TODO REMOVE UNUSED

    /**
     * edit ccms crew position
     * @memberof ReportCtrl
     */


    function editCCMSCrewPosition(crew) {
      openCCMSCrewPositionModal(crew);
    }
    /**
     * delete ccms crew position
     * @memberof ReportCtrl
     */


    function deleteCCMSCrewPosition(crew) {
      bootbox.dialog({
        message: "Are you sure you want to delete this record?",
        title: "<strong>Delete record<strong>",
        buttons: {
          no: {
            label: "No",
            className: "btn-default",
            callback: function callback() {}
          },
          yes: {
            label: "Yes",
            className: "btn-warning",
            callback: function callback() {
              CCMSCrewPositionFactory.deleteFromList(crew, _report.CCMSCrewPositions);
              $timeout($scope.reportItemValueChanged);
            }
          }
        }
      });
    } // Grooming issue modal


    $scope.openGroomingForm = function (crew) {
      if (!$scope.groomingReportsByCrew) {
        $scope.groomingReportsByCrew = GroomingCategoriesFactory.loadGroomingReports();
      } // Fetch existing data or initialize default data


      var existingData = $scope.groomingReportsByCrew[crew.CrewId];
      var groomingData = existingData || groomingCategories.map(function (category) {
        return {
          Id: category.Id,
          Label: category.Label,
          Description: category.Description,
          OrderNo: category.OrderNo,
          UserInput: ''
        };
      });
      $uibModal.open({
        templateUrl: 'views/Dialogs/dlgGroomingIssue.html',
        controller: 'GroomimgCategoriesModalCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          crewData: function crewData() {
            return crew;
          },
          groomingCategories: function groomingCategories() {
            return groomingData;
          }
        }
      }).result.then(function (result) {
        if (result) {
          // Save all categories for this crew, preserving the display of unfilled ones
          $scope.groomingReportsByCrew[crew.CrewId] = result; // Filter and log only completed categories

          var completedCategories = result.filter(function (category) {
            return category.UserInput && category.UserInput.trim() !== '';
          });
        }
      });
    }; // Flight Detail


    function openFlightDetailModal(inputObject) {
      $uibModal.open({
        templateUrl: 'views/Dialogs/dlgFlightDetail.html',
        controller: 'FlightDetailCtrl',
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          fd: function fd() {
            return inputObject;
          }
        }
      }).result.then(function (result) {
        if (result != null) {
          angular.extend(inputObject, result.Object);
        }

        $scope.reportItemValueChanged();
      });
    } // First Aid Kit

    /**
     * define open first aid kit dialog function
     * @memberof ReportCtrl
     */


    function openFirstAidKitModal(inputObject) {
      $uibModal.open({
        templateUrl: 'views/Dialogs/dlgFirstAid.html',
        controller: 'FirstAidKitCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          fak: function fak() {
            return inputObject;
          },
          IsEMK: inputObject != null && inputObject.IsEMK
        }
      }).result.then(function (result) {
        if (result != null) {
          if (result.isInsertMode) {
            _report.FirstAidKits.push(result.Object);
          } else {
            angular.extend(inputObject, result.Object);
          }
        }

        $scope.reportItemValueChanged();
      });
    }
    /**
     * add new EMK first aid kit
     * @memberof ReportCtrl
     */


    function addNewEMKFirstAidKit() {
      $uibModal.open({
        templateUrl: 'views/Dialogs/dlgFirstAid.html',
        controller: 'FirstAidKitCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          fak: null,
          IsEMK: true
        }
      }).result.then(function (result) {
        if (result != null) {
          if (result.isInsertMode) {
            _report.FirstAidKits.push(result.Object);
          } else {
            angular.extend(inputObject, result.Object);
          }
        }

        $scope.reportItemValueChanged();
      });
    }
    /**
     * add new first aid kit
     * @memberof ReportCtrl
     */


    function addNewFirstAidKit() {
      openFirstAidKitModal(null);
    }
    /**
     * edit first aid kit
     * @memberof ReportCtrl
     */


    function editFirstAidKit(fak) {
      openFirstAidKitModal(fak);
    }
    /**
     * delete first aid kit
     * @memberof ReportCtrl
     */


    function deleteFirstAidKit(fak) {
      bootbox.dialog({
        message: "Are you sure you want to delete this record?",
        title: "<strong>Delete record<strong>",
        buttons: {
          no: {
            label: "No",
            className: "btn-default",
            callback: function callback() {}
          },
          yes: {
            label: "Yes",
            className: "btn-warning",
            callback: function callback() {
              FirstAidKitFactory.deleteFromList(fak, _report.FirstAidKits);
              $timeout($scope.reportItemValueChanged);
            }
          }
        }
      });
    } // Medical Incidents

    /**
     * define open medical incident dialog function
     * @memberof ReportCtrl
     */


    function openMedicalIncidentModal(inputObject) {
      $uibModal.open({
        templateUrl: 'views/Dialogs/dlgMedical.html',
        controller: 'MedicalIncidentCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          med: function med() {
            return inputObject;
          }
        }
      }).result.then(function (result) {
        if (result != null) {
          if (result.isInsertMode) {
            _report.MedicalIncidents.push(result.Object);
          } else {
            angular.extend(inputObject, result.Object);
          }
        }

        $scope.reportItemValueChanged();
      }); //HACK FOR IOS:: Trying to sign, scrolls the modal dialog
      //following code, fixes that issue, but it is not a good looking solution

      $timeout(function () {
        if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
          $('.modal').css({
            position: 'absolute',
            marginTop: $(window).scrollTop() + 'px',
            bottom: 'auto'
          });
          $('.modal-backdrop').css({
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight) + 'px'
          });
        }
      }, 1000, false);
    }
    /**
     * add new medical incident
     * @memberof ReportCtrl
     */


    function addNewMedicalIncident() {
      openMedicalIncidentModal(null);
    }
    /**
     *  edit medical incident
     * @memberof ReportCtrl
     */


    function editMedicalIncident(med) {
      openMedicalIncidentModal(med);
    }
    /**
     * delete medical incident
     * @memberof ReportCtrl
     */


    function deleteMedicalIncident(med) {
      bootbox.dialog({
        message: "Are you sure you want to delete this record?",
        title: "<strong>Delete record<strong>",
        buttons: {
          no: {
            label: "No",
            className: "btn-default",
            callback: function callback() {}
          },
          yes: {
            label: "Yes",
            className: "btn-warning",
            callback: function callback() {
              MedicalIncidentFactory.deleteFromList(med, _report.MedicalIncidents);
              $scope.reportItemValueChanged();
              $scope.$apply();
            }
          }
        }
      });
    } // Special meals

    /**
     * define open special meal issue dialog function
     * @memberof ReportCtrl
     */


    function openSpecialMealIssueModal(inputObject) {
      $uibModal.open({
        templateUrl: 'views/Dialogs/dlgSpecialMeal.html',
        controller: 'SpecialMealIssueCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          smi: function smi() {
            return inputObject;
          }
        }
      }).result.then(function (result) {
        if (result != null) {
          if (result.isInsertMode) {
            _report.SpecialMealIssues.push(result.Object);
          } else {
            angular.extend(inputObject, result.Object);
          }
        }

        $scope.reportItemValueChanged();
      });
    }
    /**
     * add new special meal issue
     * @memberof ReportCtrl
     */


    function addNewSpecialMealIssue() {
      openSpecialMealIssueModal(null);
    }
    /**
     * edit special meal issue
     * @memberof ReportCtrl
     */


    function editSpecialMealIssue(smi) {
      openSpecialMealIssueModal(smi);
    }
    /**
     * delete special meal issue
     * @memberof ReportCtrl
     */


    function deleteSpecialMealIssue(smi) {
      bootbox.dialog({
        message: "Are you sure you want to delete this record?",
        title: "<strong>Delete record<strong>",
        buttons: {
          no: {
            label: "No",
            className: "btn-default",
            callback: function callback() {}
          },
          yes: {
            label: "Yes",
            className: "btn-warning",
            callback: function callback() {
              SpecialMealIssueFactory.deleteFromList(smi, _report.SpecialMealIssues);
              $timeout($scope.reportItemValueChanged);
            }
          }
        }
      });
    } // Supplies

    /**
     * define open supply dialog function
     * @memberof ReportCtrl
     */


    function openSupplyModal(inputObject) {
      $uibModal.open({
        templateUrl: 'views/Dialogs/dlgSupply.html',
        controller: 'SupplyCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          sup: function sup() {
            return inputObject;
          }
        }
      }).result.then(function (result) {
        if (result != null) {
          if (result.isInsertMode) {
            _report.Supplies.push(result.Object);
          } else {
            angular.extend(inputObject, result.Object);
          }
        }

        $scope.reportItemValueChanged();
      });
    }
    /**
     * add new supply
     * @memberof ReportCtrl
     */


    function addNewSupply() {
      openSupplyModal(null);
    }
    /**
     * edit supply
     * @memberof ReportCtrl
     */


    function editSupply(sup) {
      openSupplyModal(sup);
    }
    /**
     * delete supply
     * @memberof ReportCtrl
     */


    function deleteSupply(sup) {
      bootbox.dialog({
        message: "Are you sure you want to delete this record?",
        title: "<strong>Delete record<strong>",
        buttons: {
          no: {
            label: "No",
            className: "btn-default",
            callback: function callback() {}
          },
          yes: {
            label: "Yes",
            className: "btn-warning",
            callback: function callback() {
              SupplyFactory.deleteFromList(sup, _report.Supplies);
              $timeout($scope.reportItemValueChanged);
            }
          }
        }
      });
    } // Seat Upgrades


    checkEligibleUpgrades();
    /**
     * define open upgrade dialog function
     * @memberof ReportCtrl
     */

    function checkEligibleUpgrades() {
      var eligiblePassengers = [];
      var paxInfo = null;
      PaxInfoFactory.getPaxInfoFromStorage(_report.FlightId, function (result) {
        paxInfo = result;

        if (paxInfo && paxInfo.Seatmap) {
          for (var i = 0; i < paxInfo.Seatmap.length; i++) {
            for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
              if (paxInfo.Seatmap[i].Columns[j].IsEligibleForUpgrade && paxInfo.Seatmap[i].Columns[j].Cabin == 'Y') {
                var alreadyUpgraded = false;

                for (var k = 0; k < _report.UpgradedPassengers.length; k++) {
                  if (_report.UpgradedPassengers[k].UCI == paxInfo.Seatmap[i].Columns[j].UCI && _report.UpgradedPassengers[k].PNR == paxInfo.Seatmap[i].Columns[j].PNR && _report.UpgradedPassengers[k].OriginalSeatNo == paxInfo.Seatmap[i].Columns[j].SeatNo) {
                    alreadyUpgraded = true;
                  }
                }

                if (!alreadyUpgraded) {
                  eligiblePassengers.push(paxInfo.Seatmap[i].Columns[j]);
                }
              }
            }
          }
        }

        $scope.eligiblePassengers = eligiblePassengers.length;
      });
    }
    /**
     * define open upgrade dialog function
     * @memberof ReportCtrl
     */


    function openUPGDModal(inputObject) {
      PaxInfoFactory.getPaxInfoFromStorage(_report.FlightId, function (_paxInfo) {
        $uibModal.open({
          templateUrl: 'views/Dialogs/dlgUPGD.html',
          controller: 'UPGDCtrl',
          size: 'lg',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            upgradedPassenger: function upgradedPassenger() {
              return inputObject;
            },
            report: function report() {
              return _report;
            },
            paxInfo: function paxInfo() {
              return _paxInfo;
            }
          }
        }).result.then(function (result) {
          if (result != null) {
            if (result.isInsertMode) {
              _report.UpgradedPassengers.push(result.Object);
            } else {
              angular.extend(inputObject, result.Object);
            }
          }

          checkEligibleUpgrades();
          $scope.reportItemValueChanged();
        });
      });
    }
    /**
     * add new Upgrade
     * @memberof ReportCtrl
     */


    function addNewUPGD() {
      openUPGDModal(null);
    }
    /**
     * edit Upgrade
     * @memberof ReportCtrl
     */


    function editUPGD(upgradedPassenger) {
      openUPGDModal(upgradedPassenger);
    }
    /**
     * delete Upgrade
     * @memberof ReportCtrl
     */


    function deleteUPGD(upgradedPassenger) {
      bootbox.dialog({
        message: "Are you sure you want to delete this record?",
        title: "<strong>Delete record<strong>",
        buttons: {
          no: {
            label: "No",
            className: "btn-default",
            callback: function callback() {}
          },
          yes: {
            label: "Yes",
            className: "btn-warning",
            callback: function callback() {
              _report.UpgradedPassengers = _report.UpgradedPassengers.filter(function (p) {
                return p.OriginalSeatNo != upgradedPassenger.OriginalSeatNo && p.UCI != upgradedPassenger.UCI;
              });
              checkEligibleUpgrades();
              $timeout($scope.reportItemValueChanged);
            }
          }
        }
      });
    } // Change Seat


    $scope.allPassengers = 0;
    getAllPasseengersCounter();

    function getAllPasseengersCounter() {
      PaxInfoFactory.getPaxInfoFromStorage(_report.FlightId, function (result) {
        var paxInfo = result;
        var allPassengers = [];

        if (paxInfo) {
          for (var i = 0; i < paxInfo.Seatmap.length; i++) {
            for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
              if (paxInfo.Seatmap[i].Columns[j].SeatNo && !paxInfo.Seatmap[i].Columns[j].IsEmptySeat) {
                allPassengers.push(paxInfo.Seatmap[i].Columns[j]);
              }
            }
          }
        }

        $scope.allPassengers = allPassengers.length;
      });
    }
    /**
     * define open change seat dialog function
     * @memberof ReportCtrl
     */


    function openChangeSeatModal(inputObject) {
      PaxInfoFactory.getPaxInfoFromStorage(_report.FlightId, function (_paxInfo2) {
        $uibModal.open({
          templateUrl: 'views/Dialogs/dlgSeatChange.html',
          controller: 'SeatChangeCtrl',
          size: 'lg',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            changedSeat: function changedSeat() {
              return inputObject;
            },
            report: function report() {
              return _report;
            },
            paxInfo: function paxInfo() {
              return _paxInfo2;
            }
          }
        }).result.then(function (result) {
          if (result != null) {
            if (result.isInsertMode) {
              _report.ChangedSeats.push(result.Object);
            } else {
              angular.extend(inputObject, result.Object);
            }
          }

          $scope.reportItemValueChanged();
        });
      });
    }
    /**
     * add new seat change
     * @memberof ReportCtrl
     */


    function addNewChangedSeat() {
      openChangeSeatModal(null);
    }
    /**
     * edit changed seat
     * @memberof ReportCtrl
     */


    function editChangedSeat(changedSeat) {
      openChangeSeatModal(changedSeat);
    }
    /**
     * delete changed seat
     * @memberof ReportCtrl
     */


    function deleteChangedSeat(changedSeat) {
      bootbox.dialog({
        message: "Are you sure you want to delete this record?",
        title: "<strong>Delete record<strong>",
        buttons: {
          no: {
            label: "No",
            className: "btn-default",
            callback: function callback() {}
          },
          yes: {
            label: "Yes",
            className: "btn-warning",
            callback: function callback() {
              _report.ChangedSeats = _report.ChangedSeats.filter(function (p) {
                return p.OriginalSeatNo != changedSeat.OriginalSeatNo && p.UCI != changedSeat.UCI;
              });
              $timeout($scope.reportItemValueChanged);
            }
          }
        }
      });
    } // Travel value seal 

    /**
     * define open travel value seal dialog function
     * @memberof ReportCtrl
     */


    function openTravelValueSealModal(inputObject) {
      $uibModal.open({
        templateUrl: 'views/Dialogs/dlgTravelValueSeal.html',
        controller: 'TravelValueSealCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          tvs: function tvs() {
            return inputObject;
          }
        }
      }).result.then(function (result) {
        if (result != null) {
          if (result.isInsertMode) {
            _report.TravelValueSeals.push(result.Object);
          } else {
            angular.extend(inputObject, result.Object);
          }
        }

        $scope.reportItemValueChanged();
      });
    }
    /**
     * add new travel value seal
     * @memberof ReportCtrl
     */


    function addNewTravelValueSeal() {
      openTravelValueSealModal(null);
    }
    /**
     * edit travel value seal
     * @memberof ReportCtrl
     */


    function editTravelValueSeal(tvs) {
      openTravelValueSealModal(tvs);
    }
    /**
     * delete travel value seal
     * @memberof ReportCtrl
     */


    function deleteTravelValueSeal(tvs) {
      bootbox.dialog({
        message: "Are you sure you want to delete this record?",
        title: "<strong>Delete record<strong>",
        buttons: {
          no: {
            label: "No",
            className: "btn-default",
            callback: function callback() {}
          },
          yes: {
            label: "Yes",
            className: "btn-warning",
            callback: function callback() {
              TravelValueSealFactory.deleteFromList(tvs, _report.TravelValueSeals);
              $timeout($scope.reportItemValueChanged);
            }
          }
        }
      });
    } // Incomplete In-flight Services 

    /**
     * define open Incomplete In-flight Service dialog function
     * @memberof ReportCtrl
     */


    function openIncompleteServiceModal(inputObject) {
      $uibModal.open({
        templateUrl: 'views/Dialogs/dlgIncompleteServices.html',
        controller: 'IncompleteServicesIssueCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          service: function service() {
            return inputObject;
          },
          fleetId: function fleetId() {
            return flight.Fleet.Id;
          }
        }
      }).result.then(function (result) {
        if (result != null) {
          if (result.isInsertMode) {
            _report.IncompleteServices.push(result.Object);
          } else {
            angular.extend(inputObject, result.Object);
          }
        }

        $scope.reportItemValueChanged();
      });
    }
    /**
     * add new travel value seal
     * @memberof ReportCtrl
     */


    function addIncompleteService() {
      openIncompleteServiceModal(null);
    }
    /**
     * edit travel value seal
     * @memberof ReportCtrl
     */


    function editIncompleteService(service) {
      openIncompleteServiceModal(service);
    }
    /**
     * delete travel value seal
     * @memberof ReportCtrl
     */


    function deleteIncompleteService(service) {
      bootbox.dialog({
        message: "Are you sure you want to delete this record?",
        title: "<strong>Delete record<strong>",
        buttons: {
          no: {
            label: "No",
            className: "btn-default",
            callback: function callback() {}
          },
          yes: {
            label: "Yes",
            className: "btn-warning",
            callback: function callback() {
              IncompleteServicesIssueFactory.deleteFromList(service, _report.IncompleteServices);
              $timeout($scope.reportItemValueChanged);
            }
          }
        }
      });
    }
    /**
    * add new additional feedback
    * @memberof ReportCtrl
    */


    function addAdditionalFeedback() {
      openAdditionalFeedbackModal(null);
    }
    /**
     * edit additional feedback
     * @memberof ReportCtrl
     */


    function editAdditionalFeedback(feedback) {
      openAdditionalFeedbackModal(feedback);
    } // First Aid Kit

    /**
     * define open first aid kit dialog function
     * @memberof ReportCtrl
     */


    function openAdditionalFeedbackModal(inputObject) {
      $uibModal.open({
        templateUrl: 'views/Dialogs/dlgAdditionalFeedback.html',
        controller: 'AdditionalFeedbackCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          feedback: function feedback() {
            return inputObject;
          }
        }
      }).result.then(function (result) {
        if (result != null) {
          if (result.isInsertMode) {
            _report.FirstAidKits.push(result.Object);
          } else {
            angular.extend(inputObject, result.Object);
          }
        }

        $scope.reportItemValueChanged();
      });
    }
    /**
    * add new found property
    * @memberof ReportCtrl
    */


    function addNewFoundProperty() {
      openFoundPropertyModal(null, null);
    }
    /**
     * edit found property
     * @memberof ReportCtrl
     */


    function editFoundProperty(item, index) {
      openFoundPropertyModal(item, index);
    }
    /**
    * Returns true when a value is not null/undefined/empty after trimming.
    */


    function hasNonEmptyValue(value) {
      return value != null && String(value).trim().length > 0;
    }
    /**
     * Signature can be an array (strokes) or a string (base64).
     */


    function hasSignatureValue(signature) {
      if (!signature) return false;

      if (Array.isArray(signature)) {
        return signature.length > 0;
      }

      return String(signature).trim().length > 0;
    }
    /**
     * A Found Property entry is "completed" only when all mandatory fields are present.
     */


    function isFoundPropertyCompleted(foundProperty) {
      return !!foundProperty && hasNonEmptyValue(foundProperty.Category) && hasNonEmptyValue(foundProperty.AgentName) && hasSignatureValue(foundProperty.Signature);
    }
    /**
     * Some report statuses should not be auto-mutated by draft logic.
     */


    function isReportStatusLocked(reportStatus) {
      if (!reportStatus) return false;
      return String(reportStatus).toLowerCase() === "synched";
    }
    /**
     * Ensures every Found Property has a valid Status (draft/completed).
     * - Keeps explicit Status if valid.
     * - Otherwise computes it based on mandatory fields.
     */


    function getNormalizedFoundPropertyStatus(foundProperty) {
      var existingStatus = foundProperty && foundProperty.Status ? String(foundProperty.Status).toLowerCase() : "";

      if (existingStatus === "draft" || existingStatus === "completed") {
        return existingStatus;
      }

      return isFoundPropertyCompleted(foundProperty) ? "completed" : "draft";
    }
    /**
     * Updates report.Status based on Found Property statuses.
     * Rule: If at least one Found Property is draft -> report becomes draft.
     * Note: We do NOT auto-complete the report here. Save flow controls that.
     */


    function updateReportStatusFromFoundProperties() {
      if (!$scope.report) return;

      if (isReportStatusLocked($scope.report.Status)) {
        return;
      }

      var foundProperties = $scope.report.FoundProperties || [];
      var hasAnyDraftFoundProperty = false; // Normalize statuses first (covers older entries without Status)

      foundProperties.forEach(function (fp) {
        fp.Status = getNormalizedFoundPropertyStatus(fp);

        if (fp.Status === "draft") {
          hasAnyDraftFoundProperty = true;
        }
      });

      if (hasAnyDraftFoundProperty) {
        $scope.report.Status = "draft";
      }
    }
    /**
     * define open first aid kit dialog function
     * @memberof ReportCtrl
     */


    function openFoundPropertyModal(existingFoundProperty, existingIndex) {
      var isEditMode = !!existingFoundProperty; // Clone only when editing to avoid mutating the list item if user cancels

      var foundPropertyForModal = isEditMode ? angular.copy(existingFoundProperty) : {};
      $uibModal.open({
        templateUrl: "views/Dialogs/dlgFoundProperty.html",
        controller: "FoundPropertyCtrl",
        size: "lg",
        backdrop: "static",
        keyboard: false,
        resolve: {
          foundProperty: function foundProperty() {
            return foundPropertyForModal;
          },
          openItemPhotosModal: function openItemPhotosModal() {
            return _openItemPhotosModal;
          }
        }
      }).result.then(function (returnedFoundProperty) {
        $scope.report.FoundProperties = $scope.report.FoundProperties || []; // Normalize Status (modal may have set Status explicitly)

        returnedFoundProperty.Status = getNormalizedFoundPropertyStatus(returnedFoundProperty);

        if (isEditMode) {
          $scope.report.FoundProperties[existingIndex] = returnedFoundProperty;
        } else {
          $scope.report.FoundProperties.push(returnedFoundProperty);
        }

        updateReportStatusFromFoundProperties();
        $scope.report.updateTotals();

        if ($scope.report.Status !== 'synched') {
          $scope.report.saveReport();
          FlightFactory.updateFlightFromReport($scope.report);
        }

        $timeout($scope.reportItemValueChanged);
      })["catch"](function (dismissReason) {});
    }
    /**
     * delete found property
     * @memberof ReportCtrl
     */


    function deleteFoundProperty(foundPropertyToDelete) {
      bootbox.dialog({
        message: "Are you sure you want to delete this record?",
        title: "<strong>Delete record<strong>",
        buttons: {
          no: {
            label: "No",
            className: "btn-default",
            callback: function callback() {}
          },
          yes: {
            label: "Yes",
            className: "btn-warning",
            callback: function callback() {
              $scope.report.FoundProperties = $scope.report.FoundProperties || [];
              var index = $scope.report.FoundProperties.indexOf(foundPropertyToDelete);

              if (index !== -1) {
                $scope.report.FoundProperties.splice(index, 1);
              }

              updateReportStatusFromFoundProperties();
              $scope.report.updateTotals();

              if ($scope.report.Status !== 'synched') {
                $scope.report.saveReport();
                FlightFactory.updateFlightFromReport($scope.report);
              }

              $timeout($scope.reportItemValueChanged);
            }
          }
        }
      });
    } //TimePicker times - convert to Date UTC


    $scope.BoardingDisembarkationTimes = {
      FirstPaxDisembarkationTime: $scope.report.FirstPaxDisembarkationTime ? new Date($scope.report.FirstPaxDisembarkationTime).toUTC() : null,
      LastPaxDisembarkationTime: $scope.report.LastPaxDisembarkationTime ? new Date($scope.report.LastPaxDisembarkationTime).toUTC() : null,
      FirstPaxTime: $scope.report.FirstPaxTime ? new Date($scope.report.FirstPaxTime).toUTC() : null,
      LastPaxTime: $scope.report.LastPaxTime ? new Date($scope.report.LastPaxTime).toUTC() : null
    }; // Boarding times

    var hasFirstTime = false;
    var hasLastTime = false;
    $scope.FirstPaxGetTimeUTC = firstPaxGetTimeUTC;
    $scope.LastPaxGetTimeUTC = lastPaxGetTimeUTC;
    $scope.firstPaxTimeChanged = firstPaxTimeChanged;
    $scope.lastPaxTimeChanged = lastPaxTimeChanged;

    function firstPaxTimeChanged() {
      if (!hasFirstTime) {
        firstPaxGetTimeUTC();
        hasFirstTime = true;
      } else {
        //From timepicker(date) to report(moment)
        var dateObj = new Date($scope.BoardingDisembarkationTimes.FirstPaxTime).fromUTC();
        $scope.report.FirstPaxTime = moment(dateObj);
      }
    }

    function lastPaxTimeChanged() {
      if (!hasLastTime) {
        lastPaxGetTimeUTC();
        hasLastTime = true;
      } else {
        //From timepicker(date) to report(moment)
        var dateObj = new Date($scope.BoardingDisembarkationTimes.LastPaxTime).fromUTC();
        $scope.report.LastPaxTime = moment(dateObj);
      }
    }

    function firstPaxGetTimeUTC() {
      $scope.report.FirstPaxTime = moment.utc(); //convert to date for uib timepicker

      $scope.BoardingDisembarkationTimes.FirstPaxTime = moment($scope.report.FirstPaxTime).toDate().toUTC();
      saveDraftClicked();
    }

    function lastPaxGetTimeUTC() {
      $scope.report.LastPaxTime = moment.utc(); //convert to date for uib timepicker

      $scope.BoardingDisembarkationTimes.LastPaxTime = moment($scope.report.LastPaxTime).toDate().toUTC();
      saveDraftClicked();
    } // Disembarkation times


    var hasFirstDisembarkationTime = false;
    var hasLastDisembarkationTime = false;
    $scope.FirstPaxGetDisembarkationTimeUTC = firstPaxGetDisembarkationTimeUTC;
    $scope.LastPaxGetDisembarkationTimeUTC = lastPaxGetDisembarkationTimeUTC;
    $scope.firstPaxDisembarkationTimeChanged = firstPaxDisembarkationTimeChanged;
    $scope.lastPaxDisembarkationTimeChanged = lastPaxDisembarkationTimeChanged;

    function firstPaxDisembarkationTimeChanged() {
      if (!hasFirstDisembarkationTime) {
        firstPaxGetDisembarkationTimeUTC();
        hasFirstDisembarkationTime = true;
      } else {
        //From timepicker(date) to report(moment)
        var dateObj = new Date($scope.BoardingDisembarkationTimes.FirstPaxDisembarkationTime).fromUTC();
        $scope.report.FirstPaxDisembarkationTime = moment(dateObj);
      }
    }

    function lastPaxDisembarkationTimeChanged() {
      if (!hasLastDisembarkationTime) {
        lastPaxGetDisembarkationTimeUTC();
        hasLastDisembarkationTime = true;
      } else {
        //From timepicker(date) to report(moment)
        var dateObj = new Date($scope.BoardingDisembarkationTimes.LastPaxDisembarkationTime).fromUTC();
        $scope.report.LastPaxDisembarkationTime = moment(dateObj);
      }
    }

    function firstPaxGetDisembarkationTimeUTC() {
      //apply moment time in report
      $scope.report.FirstPaxDisembarkationTime = moment.utc(); //convert to date for uib timepicker

      $scope.BoardingDisembarkationTimes.FirstPaxDisembarkationTime = moment($scope.report.FirstPaxDisembarkationTime).toDate().toUTC();
      saveDraftClicked();
    }

    function lastPaxGetDisembarkationTimeUTC() {
      $scope.report.LastPaxDisembarkationTime = moment.utc(); //convert to date for uib timepicker

      $scope.BoardingDisembarkationTimes.LastPaxDisembarkationTime = moment($scope.report.LastPaxDisembarkationTime).toDate().toUTC();
      saveDraftClicked();
    } //Item Photos

    /**
     * define open item photos dialog function
     * @memberof ReportCtrl
     */


    function _openItemPhotosModal(inputObject) {
      $uibModal.open({
        templateUrl: 'views/Dialogs/dlgItemPhotos.html',
        controller: 'ItemPhotosCtrl',
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          item: function item() {
            return inputObject;
          }
        }
      }).result.then(function (result) {
        $scope.reportItemValueChanged();
      });
    }
    /**
     * attach Photo On Various Item
     * @memberof ReportCtrl
     */


    function attachPhotoOnVariousItem(item) {
      _openItemPhotosModal(item);
    }
    /**
    * attach Photo On Various Item
    * @memberof ReportCtrl
    */


    function attachPhotoOnBarTrolley(item) {
      if (item == undefined) {
        var x = BarTrolleyFactory.createNew();
        item = x;

        _report.BarTrolleys.push(item);
      }

      _openItemPhotosModal(item);
    }

    $scope.autoAdjustTarget = null;
    $scope.autoAdjustTimer = null;

    $scope.autoAdjustElement = function (element) {
      if (element) {
        autoAdjustTextarea(element);
      }
    };

    $scope.autoAdjustRun = function () {
      var t = $scope.autoAdjustTarget;
      $scope.autoAdjustElement(t);
      $scope.autoAdjustTarget = null;
      $scope.autoAdjustTimer = null; // also, update the report and save it to a temp place

      _report.updateTotals();

      if (_report.Status != 'synched') _report.saveReportAsTemp();
    };

    $scope.adjustTextarea = function ($event) {
      // $event.keyCode = 13
      // performing adjusts using a timer, to minimize times it executes, and
      // make it faster on ipad2
      if ($scope.autoAdjustTimer != null) {
        clearTimeout($scope.autoAdjustTimer); // old object pending... execute its adjustment and then plan new
        // object's adjustment

        if ($event.target != $scope.autoAdjustTarget) {
          $scope.autoAdjustRun();
        }
      }

      $scope.autoAdjustTarget = $event.target;
      $scope.autoAdjustTimer = setTimeout($scope.autoAdjustRun, 500);
    };
    /**
    * It handles the cabin report when u want to navigate to another view
    * @memberof CabinReports
    * @param {Object} report input the cabin report  
    */


    function handleIfReport(report) {
      if ($scope.state == 'report') {
        if (report == null) {
          report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(report.FlightId);
        } // delete the temp report


        CabinReportLocalEditFactory.deleteTempReport(); //reuse guid if this was a new report

        if (report.Status == 'pending') ReportGuidFactory.restoreGuid(report.ReportGuid);
      }
    }

    $scope.BarSealsImage = [];
    $scope.BarSealsImageRemarks; //-- Flight Orders - Shop In The Cloud

    function updateOrderStatus(order) {
      _report.updateTotals(); //report.saveReport();

    }
    /**
    * attach Photo On Flight Order
    * @memberof ReportCtrl
    */


    function attachPhotoOnFlightOrder(item) {
      _openItemPhotosModal(item);
    }
    /**
     * Clear Flight Order Feedback
     * @memberof ReportCtrl
     */


    function clearFlightOrderFeedback(item) {
      if (item != null) {
        clearField(item, "feedback");
      }
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('ReportGuidFactory', ReportGuidFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name ReportGuidFactory
  * @description 
  *   Manages ReportGuid
  * @ngInject
  */

  function ReportGuidFactory(localStorageMD5Service, GenericService) {
    /**
    * Initialize the ReportGuid
    * @memberof ReportGuidFactory
    */
    function ReportGuid() {
      this.Guid = null;
    }

    var objType = 'reportGuids';
    var objCallback = ReportGuid;
    var service = {
      getNextGuid: getNextGuid,
      setReportGuidsToStorage: setReportGuidsToStorage,
      restoreGuid: restoreGuid,
      getRemainingReportGuids: getRemainingReportGuids
    };
    /**
     * Extend Object from the default ReportGuid Object
     * @memberof ReportGuidFactory
     * @param {Object} obj  a ReportGuid
     * @returns {Object} ReportGuid
     */

    function fromObject(obj) {
      if (obj == null) return null;
      var reportGuid = new ReportGuid();
      reportGuid.Guid = obj;
      return reportGuid;
    }

    ;
    /**
      * Extend an array of Objects from the default ReportGuid Object
      * @memberof ReportGuidFactory
      * @param {Array} objList  an Array Of ReportGuids
      * @returns {Array} ReportGuids
      */

    function fromObjectList(objList) {
      if (objList == null) return null;
      var arrayLength = objList.length;
      var reportGuids = new Array();

      for (var i = 0; i < arrayLength; i++) {
        var reportGuid = new ReportGuid();
        reportGuid.Guid = objList[i];
        reportGuids.push(reportGuid);
      }

      return reportGuids;
    }

    ;
    /**
     * Get all the ReportGuid's guid from given list
     * @memberof ReportGuidFactory
     * @param {array} objectList An object list
     * @returns {array} guids
     */

    function toObjectList(guidList) {
      if (guidList == null) return null;
      var arrayLength = guidList.length;
      var objList = new Array();

      for (var i = 0; i < arrayLength; i++) {
        objList.push(guidList[i].Guid);
      }

      return objList;
    }

    ;
    /**
     * Get all the reportGuid objects
     * @memberof reportGuid
     * @returns {array} ACSupplies
     */

    function getReportGuidsFromStorage() {
      var reportGuids = localStorageMD5Service.get('reportGuids');
      return fromObjectList(reportGuids);
    }
    /**
     * Set all the reportGuid objects
     * @memberof ReportGuidFactory
     * @return {string} reportGuid
     */


    function setReportGuidsToStorage(reportGuids) {
      GenericService.saveAll(reportGuids, objType, objCallback);
    }
    /**
    * Delete all the reportGuid objects
    * @memberof ReportGuidFactory
    */


    function clearReportGuidsFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }
    /**
     * Get the next available guid and remove it from pool
     * @memberof ReportGuidFactory
     * @return {string} reportGuid
     */


    function getNextGuid() {
      var reportGuids = getReportGuidsFromStorage();
      if (reportGuids == null) return null;
      var validGuidIndex = -1;
      var resultingGuid = null;

      for (var i = 0; i < reportGuids.length; i++) {
        if (reportGuids[i].Guid != null && reportGuids[i].Guid != '') {
          validGuidIndex = i;
          resultingGuid = reportGuids[i].Guid;
          break;
        }
      }

      if (validGuidIndex >= 0) {
        // remove the guid from the array
        reportGuids.splice(validGuidIndex, 1); // save the new array

        setReportGuidsToStorage(toObjectList(reportGuids));
      }

      return resultingGuid;
    }
    /**
    * Restore previously used guid into the pool of guids,Used when a report is being cancelled or deleted (and it has not been sent to the server)
    * @memberof ReportGuidFactory
    * @param {string} reportGuid
    */


    function restoreGuid(guid) {
      //reject incorrect values
      if (typeof guid == 'undefined' || guid == null || guid == '') return false;
      var reportGuids = getReportGuidsFromStorage();
      if (reportGuids == null) reportGuids = [];
      var arrayLength = reportGuids.length;

      for (var i = 0; i < arrayLength; i++) {
        if (reportGuids[i].Guid == guid) {
          return false;
        }
      } //add the guid into the pool of guids


      var repGuid = fromObject(guid);
      reportGuids.push(repGuid); // save the new array

      setReportGuidsToStorage(toObjectList(reportGuids));
      return true;
    }
    /**
     * Get the  count of remaining reportGuid objects
     * @memberof reportGuid
     * @returns {number} reportGuidsLength
     */


    function getRemainingReportGuids() {
      var reportGuids = getReportGuidsFromStorage();
      if (reportGuids == null) return 0;
      return reportGuids.length;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('ReportsHistoryCtrl', ReportsHistoryCtrl);

  function ReportsHistoryCtrl($scope, $routeParams, $timeout, ReportsHistoryFactory, FlightFactory) {
    var reportId = $routeParams.reportId;
    var flightId = $routeParams.flightId;
    var reportType = $routeParams.reportType;
    var flight = FlightFactory.getFlightFromStorage(flightId);
    window.addEventListener('online', function (e) {
      $timeout(checkConnectionStatus());
    });
    $scope.reports = [];
    $scope.flight = flight;
    $scope.contentToShow = "loading";
    $scope.errorMessage = "";
    $scope.showImage = showImage;
    $scope.imageData = "";
    $scope.closeImage = closeImage;

    $scope.init = function () {
      checkConnectionStatus();
    };

    $scope.init();
    /**
     * Fetches the reports
     * @memberof ReportsHistoryCtrl  
     */

    function fetchReports() {
      ReportsHistoryFactory.getReportsHistory(reportId, reportType).then(function (response) {
        return handleResponse(response);
      })["catch"](function () {
        showError("We could not get any reports!");
      });
    }
    /**
     * Displays the error message
     * @memberof ReportsHistoryCtrl  
      * @param {string} message message to display
     */


    function showError(message) {
      $scope.contentToShow = "error";
      $scope.errorMessage = message;
    }
    /**
     * Checks if the client is online or offline 
     * if is online fetches the reports else displays relative message
     * @memberof ReportsHistoryCtrl  
     */


    function checkConnectionStatus() {
      var isOnline = window.navigator.onLine;

      if (isOnline) {
        fetchReports();
      } else {
        showError("Please check the internet connection!");
      }
    }
    /**
     * Handles the response from the API 
     * if is success displays the reports else shows the error message.
     * @memberof ReportsHistoryCtrl  
     * @param {object} response the response object from API
     */


    function handleResponse(response) {
      if (response.data.success) {
        if (response.data.data.length > 0) {
          $scope.contentToShow = "reports";
          $scope.reports = response.data.data;
        } else {
          showError("There are no reports for this flight!");
        }
      } else {
        showError("We could not get any reports!");
      }
    }
    /**
     * Displays the image in full screen
     * @memberof ReportsHistoryCtrl  
     * @param {object} ImageData The
     */


    function showImage(ImageData) {
      $scope.contentToShow = "image";
      $scope.imageData = ImageData;
    }
    /**
     * The function that closes the image and displays the reports again
     * @memberof ReportsHistoryCtrl  
     */


    function closeImage() {
      $scope.contentToShow = "reports";
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('ReportsHistoryFactory', ReportsHistoryFactory);
  /* @ngInject */

  function ReportsHistoryFactory($http, apiUrl) {
    /**
     * Fetches the ReportIncidents from API
     * @memberof ReportsHisReportsHistoryFactorytoryCtrl  
     */
    function getReportsHistory(reportId, reportType) {
      return $http.get(apiUrl + '/reports/GetHistoryReport?reportId=' + reportId + '&type=' + reportType, {
        'Content-Type': 'application/json'
      }).then(function (x) {
        return x;
      });
    }

    var service = {
      getReportsHistory: getReportsHistory
    };
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('SaAssessmentCtrl', SaAssessmentCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name AssessmentCtrl
  * @description 
  *   Manages the Cabin Crew Feedback View 
  * @ngInject
  */

  function SaAssessmentCtrl($scope, $location, SaCrewAssessmentFactory, $routeParams, SettingsMain, orderByFilter, FlightFactory, $timeout, LogService, localStorageMD5Service) {
    var flightId = $routeParams.flightId;
    var editingPage = SettingsMain.getEditingPage();
    var minDate, maxDate, flightRouteString;
    var commonFlightsWithSA = localStorageMD5Service.get('CommonFlightsWithSA') || [];
    SettingsMain.setEditingPage("saAssessment");
    var crewAssessment;

    if (flightId == "temp") {
      crewAssessment = SaCrewAssessmentFactory.getTempAssessment();
      $scope.flight = FlightFactory.getFlightFromStorage(crewAssessment.FlightId);
      SettingsMain.setEditingPage(null);
    } else {
      $scope.flight = FlightFactory.getFlightFromStorage(flightId);

      if ($scope.flight && $scope.flight.saAssessment && $scope.flight.saAssessment.Id) {
        crewAssessment = SaCrewAssessmentFactory.getCrewAssessmentFromStorage($scope.flight.saAssessment.Id);
      } else {
        LogService.error(new Error("Missing saAssessment for flightId: " + flightId));
        return;
      }
    }

    if (crewAssessment) {
      var flights = orderByFilter(crewAssessment.Flights, orderByDate, false);
      var flightIds = flights.map(function (f) {
        return f.FlightId;
      });

      for (var i = 0; i < flights.length; i++) {
        if (i == 0) {
          minDate = flights[i].ScheduledDepartureDateUTC + "T" + flights[i].ScheduledDepartureTimeUTC;
          flightRouteString = flights[i].Departure;
        } else if (i == flights.length - 1) {
          maxDate = flights[i].ScheduledArrival;
          flightRouteString = flightRouteString + "-" + flights[i].Departure + "-" + flights[i].Arrival;
        } else {
          flightRouteString = flightRouteString + "-" + flights[i].Departure;
        }
      }

      var route = {
        Route: crewAssessment.Route,
        DutyDate: crewAssessment.DutyDate,
        MinDate: minDate,
        MaxDate: maxDate,
        FlightRoute: flightRouteString
      };
      $scope.isFirstOpen = true;
      $scope.assessment = crewAssessment;
      $scope.togglePanel = togglePanel;
      $scope.route = route; //$scope.assessedBy = text;
    }

    $scope.clearRemarks = clearRemarks;
    $scope.avgValue = avgValue;
    $scope.updateValues = updateValues;
    $scope.IsCompleted = IsCompleted;
    $scope.IsSynched = IsSynched;
    $scope.assessments_not_completed = SaCrewAssessmentFactory.getCountOfUncompletedAssessments();
    $scope.saveClicked = saveClicked;
    $scope.saveDraftClicked = saveDraftClicked;
    $scope.assesmentCSSClass = assesmentCSSClass;
    $scope.assesmentIconClass = assesmentIconClass;
    $scope.isPanelOpen = true;
    $scope.discard = discard;
    $scope.infosaveaction = false;
    $scope.feedbackDate = $scope.flight.ScheduledDepartureDateUTC;
    $scope.filteredByFeedbackDate = filteredByFeedbackDate;
    $scope.showFlightsForCrewMember = showFlightsForCrewMember;
    $scope.hasCommonFlightWithSA = hasCommonFlightWithSA;
    /**
     * Display a  successful save message according to the save status 
     * @memberof AssessmentCtrl
     * @param {string} state  the state of the selected Cabin Crew Feedback
     */

    function infoSaveOperation(state) {
      if (state == 'Completed') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      } else if (state == 'Draft') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      } else if (state == 'discard') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      }

      $timeout(function () {
        $scope.infosaveaction = false;
      }, 5000);
    }
    /**
     * Convers date string to JS object
     * @memberof AssessmentCtrl
     * @param {string} ScheduledArrival The string date of ScheduledArrival 
     * @returns {Object} ScheduledArrival
     */


    function orderByDate(item) {
      var date = new Date(item.ScheduledArrival);
      return date;
    }
    /**
     * Clear Remarks
     * @memberof AssessmentCtrl
     * @param {string} item The Crew assessment Template question item 
     */


    function clearRemarks(item) {
      // put preset comments
      if (item != null && item.ItemDescr) {
        item.ItemDescr = null;
      }

      if (item != null && item.Review) {
        item.Review = null;
      }
    }
    /**
     * Returns the avarage score of the questions.
     * @memberof AssessmentCtrl
     * @param {array} items The Crew assessment Template question items 
     * @returns {number} retval
     */


    function avgValue(items) {
      var sum = 0;

      if (!items || items.length == 0) {
        return sum;
      }

      for (var i = 0; i < items.length; i++) {
        if (items[i]) {
          sum = sum + parseInt(items[i].ItemValue);
        }
      }

      var retval = sum / items.length ? (sum / items.length).toFixed(1) : '-';
      return retval;
    }
    /**
     * Updates the value for the selected crewmember for this Cabin Crew Feedback and update the temporary Cabin Crew Feedback
     * @memberof AssessmentCtrl 
     * @param {object} crewMember The Crew member
     * @param {object} assessment The Crew assessment 
     */
    // function updateValues(crewMember, assessment) {
    //     crewMember.IsCompleted = crewMember.Review != null && crewMember.Review.trim().length>0;
    // 	SaCrewAssessmentFactory.saveTempAssessment(assessment,$scope.flight.FlightId)
    // }


    function updateValues(crewMember, assessment) {
      // Check if review exists
      var hasReview = crewMember.Review != null && crewMember.Review.trim().length > 0; // Check if all critical ratings have comments

      var hasCriticalRatingsWithoutComments = false;

      if (crewMember.assessmentItems) {
        for (var i = 0; i < crewMember.assessmentItems.length; i++) {
          var item = crewMember.assessmentItems[i];

          if ((item.ItemValue === '1' || item.ItemValue === '5') && (!item.ItemDescr || item.ItemDescr.toString().trim().length === 0)) {
            hasCriticalRatingsWithoutComments = true;
            break;
          }
        }
      } // Member is completed only if has review AND no critical ratings without comments


      crewMember.IsCompleted = hasReview && !hasCriticalRatingsWithoutComments;
      SaCrewAssessmentFactory.saveTempAssessment(assessment, $scope.flight.FlightId);
    }

    $scope.hasInvalidCriticalRatings = hasInvalidCriticalRatings;
    /**
     * Evaluate if this Cabin Crew Feedback is valid and ready to send
     * @memberof AssessmentCtrl 
     * @param {object} assessment The Crew assessment 
     * @returns {boolean} isCompleted
     */

    function IsCompleted(crewAssessment) {
      var isCompleted = true;

      for (var j = 0; j < crewAssessment.CrewAssessmentMembers.length; j++) {
        var member = crewAssessment.CrewAssessmentMembers[j]; // Skip if member doesn't exist or is not applicable

        if (member.IsExist || !member.IsValid && !member.IsOverride) {
          continue;
        } // Check if review is required and missing


        if (!(member.Review != null && member.Review.trim().length > 0)) {
          isCompleted = false;
        } // Check if any assessment item has critical rating (1 or 5) without comment


        if (member.assessmentItems) {
          for (var i = 0; i < member.assessmentItems.length; i++) {
            var item = member.assessmentItems[i];

            if ((item.ItemValue === '1' || item.ItemValue === '5') && (!item.ItemDescr || item.ItemDescr.toString().trim().length === 0)) {
              isCompleted = false;
            }
          }
        }
      }

      return isCompleted;
    }

    function hasInvalidCriticalRatings(crewAssessment) {
      for (var j = 0; j < crewAssessment.CrewAssessmentMembers.length; j++) {
        var member = crewAssessment.CrewAssessmentMembers[j]; // Skip if member doesn't exist or is not applicable

        if (member.IsExist || !member.IsValid && !member.IsOverride) {
          continue;
        }

        if (member.assessmentItems) {
          for (var i = 0; i < member.assessmentItems.length; i++) {
            var item = member.assessmentItems[i];

            if ((item.ItemValue === '1' || item.ItemValue === '5') && (!item.ItemDescr || item.ItemDescr.toString().trim().length === 0)) {
              return true;
            }
          }
        }
      }

      return false;
    }
    /**
     * Evaluate if this Cabin Crew Feedback is synched
     * @memberof AssessmentCtrl 
     * @param {object} assessment The Crew assessment 
     * @returns {boolean} IsSynched
     */


    function IsSynched() {
      var IsSynched = false;

      if (crewAssessment && crewAssessment.Status == "Stored") {
        IsSynched = true;
      }

      return IsSynched;
    }
    /**
     * Save the Cabin Crew Feedback
     * @memberof AssessmentCtrl 
     * @param {object} assessment The Cabin Crew Feedback
     */


    function saveAssessment(assessment) {
      SaCrewAssessmentFactory.setCrewAssessmentToStorage(assessment);
      SaCrewAssessmentFactory.updateFlightsAssessment(assessment);
    }
    /**
     * Save the Cabin Crew Feedback As Completed
     * @memberof AssessmentCtrl 
     * @param {object} assessment The Cabin Crew Feedback
     */


    function saveClicked(assessment) {
      assessment.Status = 'Completed';
      saveAssessment(assessment);
      infoSaveOperation(assessment.Status);
      SettingsMain.setEditingPage(null);
      SaCrewAssessmentFactory.clearTempAssessment();
      $location.path('/flightinfo/' + $scope.flight.FlightId);
    }
    /**
     * Discard all the changes on the cabin crew feedback that are not saved
     * @memberof AssessmentCtrl 
     */


    function discard() {
      SettingsMain.setEditingPage(null);
      $scope.assessment = SaCrewAssessmentFactory.getCrewAssessmentFromStorage($scope.flight.saAssessment.Id);
      infoSaveOperation('discard');
    }
    /**
     * Save the Cabin Crew Feedback As Draft
     * @memberof AssessmentCtrl 
     * @param {object} assessment The Cabin Crew Feedback
     */


    function saveDraftClicked(assessment) {
      assessment.Status = 'Draft';
      saveAssessment(assessment);
      infoSaveOperation(assessment.Status);
      SettingsMain.setEditingPage(null);
      SaCrewAssessmentFactory.clearTempAssessment();
    }
    /**
     * Open and close the selected Panel
     * @memberof AssessmentCtrl 
     * @param {number} panelId The panel's Id
     */


    function togglePanel(panelId) {
      $('#' + panelId).toggle();
      if (panelId == "info-panel") $scope.isPanelOpen = !$scope.isPanelOpen;
    }
    /**
     * The css class for the selected crew member
     * @memberof AssessmentCtrl 
     * @param {Object} crewMember The assessed crew member
     * @returns {string} cssClass
     */


    function assesmentCSSClass(crewMember) {
      if (crewMember.IsExist) {
        return 'panel-green';
      }

      if (!crewMember.IsValid && !crewMember.IsOverride) {
        return 'panel-default';
      } // Check if has critical ratings without comments


      var hasCriticalWithoutComments = false;

      if (crewMember.assessmentItems) {
        for (var i = 0; i < crewMember.assessmentItems.length; i++) {
          var item = crewMember.assessmentItems[i];

          if ((item.ItemValue === '1' || item.ItemValue === '5') && (!item.ItemDescr || item.ItemDescr.toString().trim().length === 0)) {
            hasCriticalWithoutComments = true;
            break;
          }
        }
      } // If has critical ratings without comments, always show orange (incomplete)


      if (hasCriticalWithoutComments) {
        return 'panel-orange';
      } // Otherwise, check normal completion status


      if (crewMember.IsCompleted) {
        return 'panel-blue';
      } else {
        return 'panel-orange';
      }
    }
    /**
    * The icon for the selected crew member
    * @memberof AssessmentCtrl 
    * @param {Object} crewMember The assessed crew member
    * @returns {string} iconClass
    */


    function assesmentIconClass(crewMember) {
      if (!crewMember.IsExist && crewMember.IsCompleted && (crewMember.IsValid || crewMember.IsOverride)) {
        return 'fa fa-check';
      } else if (!crewMember.IsExist && !crewMember.IsCompleted && (crewMember.IsValid || crewMember.IsOverride)) {
        return 'fa fa-pencil';
      } else if (!crewMember.IsExist && !crewMember.IsValid && !crewMember.IsOverride) {
        return 'fa fa-times';
      } else if (crewMember.IsExist) {
        return 'fa fa-floppy-o';
      }
    } // Helper function to format date consistently


    function formatDateToString(date) {
      if (!date) return null;
      var d = new Date(date);
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }

    function filteredByFeedbackDate(flight) {
      // Format both dates to yyyy-MM-dd 
      var flightDate = formatDateToString(flight.ScheduledDepartureDateUTC);
      var feedbackDate = formatDateToString($scope.feedbackDate);
      return flightDate === feedbackDate;
    }

    ;

    function showFlightsForCrewMember(crewMember) {
      if (!crewMember || !crewMember.CrewAimsId) {
        crewMember.filteredFlights = [];
        return;
      }

      var result = []; // Format feedback date 

      var feedbackDateFormatted = formatDateToString($scope.feedbackDate); // Loop through all common flights with Senior Attendants (SA)

      (commonFlightsWithSA || []).forEach(function (cf) {
        // Check if the current SA matches the given crew member
        if (cf.SaAimsId === crewMember.CrewAimsId) {
          // Loop through all flights for this SA
          (cf.Flights || []).forEach(function (f) {
            var flightDateFormatted = formatDateToString(f.FlightDate); // If the flight date matches the feedback date, include it

            if (flightDateFormatted === feedbackDateFormatted) {
              result.push(f);
            }
          });
        }
      }); // Save the filtered flights into the crew member object

      crewMember.filteredFlights = result;
    }

    ; // Checks if there is at least one common flight with this crew member

    function hasCommonFlightWithSA(crewMember) {
      // If filteredFlights hasn't been calculated yet, calculate it now
      if (!crewMember.filteredFlights) {
        $scope.showFlightsForCrewMember(crewMember);
      }

      return crewMember.filteredFlights && crewMember.filteredFlights.length > 0;
    }

    ;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('SaAssessmentSyncResultFactory', SaAssessmentSyncResultFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name SaAssessmentSyncResultFactory
  * @description 
  *   Add, Update, Delete and Get Cabin Crew Feedback Sync Results.
  * @ngInject
  */

  function SaAssessmentSyncResultFactory(GenericService) {
    /**
    * Initialize the CrewAssessment
    * @memberof SaAssessmentSyncResultFactory
    */
    function SaAssessmentSyncResult() {
      this.Route = null;
      this.DutyDate = null;
      this.message = null;
      this.success = null;
    }

    var objType = 'saAssessmentSyncResults';
    var objCallback = SaAssessmentSyncResult;
    var service = {
      getAssessmentSyncResultsFromStorage: getAssessmentSyncResultsFromStorage,
      setAssessmentSyncResultsToStorage: setAssessmentSyncResultsToStorage,
      getSuccesses: getSuccesses,
      getFailures: getFailures
    };
    /**
    * Get Assessment Sync Results
    * @memberof SaAssessmentSyncResultFactory
    * @returns {Array} SA AssessmentSyncResults 
    */

    function getAssessmentSyncResultsFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Save Assessment Sync Results in Local Storage
     * @memberof SaAssessmentSyncResultFactory
     * @param {Array} SA AssessmentSyncResults A list of Assessment Sync Results
     */


    function setAssessmentSyncResultsToStorage(assessmentSyncResults) {
      GenericService.saveAll(assessmentSyncResults, objType, objCallback);
    }
    /**
    * Get Successfull Assessment Sync Results from Local Storage
    * @memberof SaAssessmentSyncResultFactory
    * @param {Array} AssessmentSyncResults A list of Assessment Sync Results
    * @returns {Array} SA AssessmentSyncResults 
    */


    function getSuccesses(syncResults) {
      var result = 0;

      if (!syncResults) {
        return result;
      }

      for (var i = 0; i < syncResults.length; i++) {
        if (syncResults[i].success == true) {
          result = result + 1;
        }
      }

      return result;
    }
    /**
    * Get Failed Assessment Sync Results from Local Storage
    * @memberof SaAssessmentSyncResultFactory
    * @param {Array} AssessmentSyncResults A list of Assessment Sync Results
    * @returns {Array} AssessmentSyncResults 
    */


    function getFailures(syncResults) {
      var result = 0;

      if (!syncResults) {
        return result;
      }

      for (var i = 0; i < syncResults.length; i++) {
        if (syncResults[i].success == false) {
          result = result + 1;
        }
      }

      return result;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('SaCrewAssessmentFactory', SaCrewAssessmentFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name SaCrewAssessmentFactory
  * @description 
  *   Add, Update, Delete and Get Cabin Crew Feedback.
  * @ngInject
  */

  function SaCrewAssessmentFactory(localStorageMD5Service, SaCrewAssessmentMemberFactory, FlightFactory, GenericService, CrewRouteFactory, SaFeedbackInfoFactory, UserFactory, defaultCalendarDate) {
    /**
    * Initialize the CrewAssessment
    * @memberof SaCrewAssessmentFactory
    */
    function SaCrewAssessment() {
      this.Id = null;
      this.AuthorId = null;
      this.Route = null;
      this.DutyDate = null;
      this.DutyDay = null;
      this.DutyNo = null;
      this.AcType = null;
      this.Status = 'Pending';
      this.IsExist = false;
      this.assessedBy = [];
      this.CrewAssessmentMembers = [];
      this.Flights = [];
      this.GetId = GetId;
      this.start = null;
      this.end = null;
      this.FeedbackDate = null;
    }

    var objType = 'SaCrewAssessments';
    var objCallback = SaCrewAssessment;
    var service = {
      getCrewAssessmentsFromStorage: getCrewAssessmentsFromStorage,
      setCrewAssessmentsToStorage: setCrewAssessmentsToStorage,
      setCrewAssessmentToStorage: setCrewAssessmentToStorage,
      getCrewAssessmentFromStorage: getCrewAssessmentFromStorage,
      getCountOfUncompletedAssessments: getCountOfUncompletedAssessments,
      getCrewAssessmentByDutyNoAndDay: getCrewAssessmentByDutyNoAndDay,
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      getNewCrewAssessment: getNewCrewAssessment,
      getTempAssessment: getTempAssessment,
      saveTempAssessment: saveTempAssessment,
      clearTempAssessment: clearTempAssessment,
      updateCrewAssessment: updateCrewAssessment,
      existsForRouteDutyDate: existsForRouteDutyDate,
      getAssementsReadyToSend: getAssementsReadyToSend,
      storeFlightsWithAssessments: storeFlightsWithAssessments,
      updateFlightsAssessment: updateFlightsAssessment,
      updateAssessmentFlights: updateAssessmentFlights,
      updateAndMergeAllSaAssessments: updateAndMergeAllSaAssessments
    }; //object functions

    /**
     * Overide default get Id
     * @memberof SaCrewAssessmentFactory
     * @returns {number} Id 
     */

    function GetId() {
      return this.Id;
    } //factory functions

    /**
    * Get Crew Assessments
    * @memberof SaCrewAssessmentFactory
    * @returns {Array} crewAssesments 
    */


    function getCrewAssessmentsFromStorage() {
      var lsItems = GenericService.list(objType, objCallback);
      var items = [];

      for (var i = 0; i < lsItems.length; i++) {
        if (lsItems[i]) {
          items.push(lsItems[i]);
        }
      }

      return items;
    }
    /**
     * Save Crew Assessments to storage
     * @memberof SaCrewAssessmentFactory
     * @param {Array} crewAssessments A list of Cabin Crew Feedbacks
     */


    function setCrewAssessmentsToStorage(crewAssessments) {
      GenericService.saveAll(crewAssessments, objType, objCallback);
    }
    /**
     * Save one Crew Assessment to storage
     * @memberof SaCrewAssessmentFactory
     * @param {Object} crewAssessment A Cabin Crew Feedback
     */


    function setCrewAssessmentToStorage(crewAssessment) {
      GenericService.save(crewAssessment, objType, objCallback);
    }
    /**
     * Get a Crew Assessment from storage
     * @memberof SaCrewAssessmentFactory
     * @param {number} crewAssessmentId  the Id of the selected Crew Assessment
     * @returns {Object} crewAssesment
     */


    function getCrewAssessmentFromStorage(crewAssessmentId) {
      return GenericService.get(crewAssessmentId, objType, objCallback);
    }
    /**
     * Get Count of Uncompleted Assessments 
     * @memberof SaCrewAssessmentFactory
     * @returns {number} count
     */


    function getCountOfUncompletedAssessments() {
      var crewAssessments = getCrewAssessmentsFromStorage();
      var count = 0;
      if (crewAssessments == null) return 0;

      for (var i = 0; i < crewAssessments.length; i++) {
        if (!crewAssessments[i].IsExist && crewAssessments[i].Status != "Completed") {
          count++;
        }
      }

      return count;
    }

    ;
    /**
     * Get  Crew Assessment By route and Duty Date
     * @memberof SaCrewAssessmentFactory
     * @param {string} DutyNo  the Route of the desired Crew Assessment
     * @param {string} DutyDay  the Duty Date of the desired Crew Assessment
     * @returns {Object} crewAssesment
     */

    function getCrewAssessmentByDutyNoAndDay(dutyNo, dutyDay, feedbackDate) {
      var crewAssessments = getCrewAssessmentsFromStorage();
      if (crewAssessments == null) return null;
      var result = null;
      var arrayLength = crewAssessments.length;

      for (var i = 0; i < arrayLength; i++) {
        if (crewAssessments[i].DutyNo == dutyNo && crewAssessments[i].DutyDay == dutyDay && (!crewAssessments[i].FeedbackDate || crewAssessments[i].FeedbackDate == feedbackDate)) {
          result = crewAssessments[i];
          break;
        }
      }

      return result;
    }
    /**
     * Extend Object from the default CrewAssessment Object
     * @memberof SaCrewAssessmentFactory
     * @param {Object} obj  a crewAssesment
     * @returns {Object} crewAssesment
     */


    function fromObject(obj) {
      return GenericService.fromObject(obj, objCallback);
    }
    /**
     * Extend an array of Objects from the default CrewAssessment Object
     * @memberof SaCrewAssessmentFactory
     * @param {Array} objList  an Array Of crewAssesments
     * @returns {Array} crewAssesments
     */


    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallback);
    }
    /**
     * Initialize a new Crew Assessment from the default Constructor
     * @memberof SaCrewAssessmentFactory
     * @returns {Object} crewAssesment
     */


    function getNewCrewAssessment() {
      return GenericService.constructor(objCallback);
    }

    ;
    /**
     * Get the Temporary Assessment from the local storage
     * @memberof SaCrewAssessmentFactory
     * @returns {Object} crewAssesment
     */

    function getTempAssessment() {
      var crewAssessmentLocalEdit = localStorageMD5Service.get('SaCrewAssessmentLocalEdit_TEMP');
      return fromObject(crewAssessmentLocalEdit);
    }

    ;
    /**
     * Save the Temporary Assessment to  the local storage
     * @memberof SaCrewAssessmentFactory
     * @param {Object} assessment  a crewAssesment
     * @param {number} FlightId  a crewAssesment
     */

    function saveTempAssessment(assessment, FlightId) {
      if (assessment) {
        assessment.FlightId = FlightId;
        localStorageMD5Service.remove('SaCrewAssessmentLocalEdit_TEMP');
        localStorageMD5Service.set('SaCrewAssessmentLocalEdit_TEMP', assessment);
      }
    }

    ;
    /**
     * Remove the Temporary Assessment of  the local storage
     * @memberof SaCrewAssessmentFactory
     */

    function clearTempAssessment() {
      localStorageMD5Service.remove('SaCrewAssessmentLocalEdit_TEMP');
    }

    ;
    /**
     * Update Assessment from the new Assessment from Sync
     * @memberof SaCrewAssessmentFactory
     * @param {Object} assessment  The assessment
     * @param {Object} newAssessment  The new assessment
     */

    function updateCrewAssessment(assessment, newAssessment) {
      var crewAssessmentTemplate = SaFeedbackInfoFactory.getQuestions();
      if (crewAssessmentTemplate == null) return assessment; // Load the flight

      var flights = FlightFactory.getFlightsByRoutePerDay(assessment.Route, assessment.DutyDate, newAssessment.FeedbackDate);
      if (flights == null) return assessment;
      assessment.Flights = [];
      assessment.AcType = flights[0].AcType;
      assessment.Base = flights[0].Departure;
      assessment = updateAssessmentFlights(assessment, flights);
      assessment.FeedbackDate = newAssessment.FeedbackDate;

      if (newAssessment.Id) {
        assessment.Id = newAssessment.Id;
      }

      var isUpdated = false; // Flags to check member states

      var validCrewCount = 0; // Non-outdated and exists

      var outdatedCrewCount = 0; // Outdated

      var nonExistentCrewCount = 0; // Non-outdated but doesn't exist
      //filter by feedback date

      newAssessment.CrewAssessmentMembers = crewAssessmentFilteredByFeedbackDate(newAssessment); //filter by common flights in the route

      var flightIds = flights.map(function (f) {
        return f.FlightId;
      });
      newAssessment.CrewAssessmentMembers = filterCrewAssessmentMembersByCommonFlightsInRoute(newAssessment.CrewAssessmentMembers, flightIds);

      for (var i = 0; i < newAssessment.CrewAssessmentMembers.length; i++) {
        var isCreated = false; //Calculate the IsOutdated

        var IsOutdated = calculateIsOutdated(newAssessment.CrewAssessmentMembers[i].EndPeriod); // Update flags based on crew member status

        if (IsOutdated && !newAssessment.CrewAssessmentMembers[i].IsExist) {
          outdatedCrewCount++;
        } else if (!newAssessment.CrewAssessmentMembers[i].IsExist) {
          nonExistentCrewCount++;
        } else {
          validCrewCount++;
        }

        for (var l = 0; l < assessment.CrewAssessmentMembers.length; l++) {
          if (newAssessment.CrewAssessmentMembers[i].CrewAimsId == assessment.CrewAssessmentMembers[l].CrewAimsId || newAssessment.CrewAssessmentMembers[i].CrewId == assessment.CrewAssessmentMembers[l].CrewId) {
            assessment.CrewAssessmentMembers[l].CrewAimsId = newAssessment.CrewAssessmentMembers[i].CrewAimsId;
            assessment.CrewAssessmentMembers[l].CrewId = newAssessment.CrewAssessmentMembers[i].CrewId;
            assessment.CrewAssessmentMembers[l].Name = newAssessment.CrewAssessmentMembers[i].Name;
            assessment.CrewAssessmentMembers[l].IsValid = true;
            assessment.CrewAssessmentMembers[l].IsOutdated = IsOutdated;
            assessment.CrewAssessmentMembers[l].EndPeriod = newAssessment.CrewAssessmentMembers[i].EndPeriod;
            var newAssessmentItems = [];

            for (var j = 0; j < crewAssessmentTemplate.length; j++) {
              var question = {
                Id: crewAssessmentTemplate[j].Id,
                Description: crewAssessmentTemplate[j].Description,
                Label: crewAssessmentTemplate[j].Label,
                OrderNo: crewAssessmentTemplate[j].OrderNo,
                ItemValue: crewAssessmentTemplate[j].ItemValue,
                ItemDescr: null
              };

              if (assessment.CrewAssessmentMembers[l].assessmentItems) {
                for (var h = 0; h < assessment.CrewAssessmentMembers[l].assessmentItems.length; h++) {
                  if (crewAssessmentTemplate[j].Id == assessment.CrewAssessmentMembers[l].assessmentItems[h].Id) {
                    question.ItemValue = assessment.CrewAssessmentMembers[l].assessmentItems[h].ItemValue;
                    question.ItemDescr = assessment.CrewAssessmentMembers[l].assessmentItems[h].ItemDescr;
                  }
                }
              }

              newAssessmentItems.push(question);
            }

            assessment.CrewAssessmentMembers[l].assessmentItems = newAssessmentItems;

            if (assessment.CrewAssessmentMembers[l].IsExist != newAssessment.CrewAssessmentMembers[i].IsExist) {
              assessment.CrewAssessmentMembers[l].IsExist = newAssessment.CrewAssessmentMembers[i].IsExist;
              isUpdated = true;
            }

            isCreated = true;
            break;
          }
        }

        if (!isCreated) {
          var crewMember = SaCrewAssessmentMemberFactory.newMember();
          crewMember.CrewAimsId = newAssessment.CrewAssessmentMembers[i].CrewAimsId;
          crewMember.CrewId = newAssessment.CrewAssessmentMembers[i].CrewId;
          crewMember.assessmentItems = crewAssessmentTemplate;
          crewMember.Name = newAssessment.CrewAssessmentMembers[i].Name;
          crewMember.IsCompleted = false;
          crewMember.IsValid = true;
          crewMember.IsExist = newAssessment.CrewAssessmentMembers[i].IsExist;
          crewMember.IsOutdated = newAssessment.CrewAssessmentMembers[i].IsOutdated;
          crewMember.EndPeriod = newAssessment.CrewAssessmentMembers[i].EndPeriod;
          assessment.CrewAssessmentMembers.push(crewMember);
          isUpdated = true;
        }
      }

      for (var l = 0; l < assessment.CrewAssessmentMembers.length; l++) {
        var isExists = false;

        for (var i = 0; i < newAssessment.CrewAssessmentMembers.length; i++) {
          if (newAssessment.CrewAssessmentMembers[i].CrewAimsId == assessment.CrewAssessmentMembers[l].CrewAimsId || newAssessment.CrewAssessmentMembers[i].CrewId == assessment.CrewAssessmentMembers[l].CrewId) {
            isExists = true;
            break;
          }
        }

        if (!isExists && !assessment.CrewAssessmentMembers[l].IsManual) {
          assessment.CrewAssessmentMembers.splice(l, 1);
          l--; // Adjust index after removal

          isUpdated = true;
        }
      } // Update the Status based on the flags


      if (validCrewCount > 0) {
        // If there's at least one valid (non-outdated and existing) crew member
        assessment.Status = "Stored";
      } else if (outdatedCrewCount > 0 && nonExistentCrewCount === 0) {
        // All members are outdated
        assessment.Status = "Outdated";
      } else if (nonExistentCrewCount > 0) {
        // If there are non-outdated but non-existent members
        assessment.Status = "Pending";
      } else if (isUpdated && assessment.Status == "Stored") {
        // If there were updates and it was stored before, downgrade to Draft
        assessment.Status = "Draft";
      } //set the Latest End Period


      assessment.LatestEndPeriod = moment.max(assessment.CrewAssessmentMembers.map(function (member) {
        return moment(member.EndPeriod);
      })).toDate();
      assessment.assessedBy = newAssessment.assessedBy; // Update IsExist based on the flag

      assessment.IsExist = validCrewCount > 0;
      return assessment;
    }
    /**
     * Find if an assessment exists for the selected Route and Duty Date
     * @memberof SaCrewAssessmentFactory
     * @param {string} Route  The route of the assessment
     * @param {string} DutyDate  The duty date of the assessment
     * @returns {boolean} isExist 
     */


    function existsForRouteDutyDate(Route, DutyDate) {
      var assessments = getCrewAssessmentsFromStorage();
      var isExist = false;

      for (var j = 0; j < assessments.length; j++) {
        if (assessments[j].Route == Route && assessments[j].DutyDate == DutyDate) {
          isExist = true;
          break;
        }
      }

      return isExist;
    }
    /**
     * Update Assessment Information from flights
     * @memberof SaCrewAssessmentFactory
     * @param {Object} crewAssessment  The crew assessment
     * @param {Array} flights  The flights of the Assessment
     */


    function updateAssessmentFlights(crewAssessment, flights) {
      for (var i = 0; i < flights.length; i++) {
        if (crewAssessment.start && crewAssessment.end) {
          var flightStart = Date.parse(flights[i].ScheduledDeparture);
          var flightEnd = Date.parse(flights[i].ScheduledArrival);
          var assesmentStart = Date.parse(crewAssessment.start);

          if (flightStart < assesmentStart) {
            crewAssessment.start = flights[i].ScheduledDeparture;
          } else {
            var assesmentEnd = Date.parse(crewAssessment.end);

            if (flightEnd > assesmentEnd) {
              crewAssessment.end = flights[i].ScheduledArrival;
            }
          }
        } else {
          crewAssessment.start = flights[i].ScheduledDeparture;
          crewAssessment.end = flights[i].ScheduledArrival;
        }

        var flight = {
          FlightId: flights[i].FlightId,
          ScheduledDepartureDateUTC: flights[i].ScheduledDepartureDateUTC,
          FlightNo: flights[i].FlightNo,
          Departure: flights[i].Departure,
          Arrival: flights[i].Arrival,
          ScheduledDepartureTimeUTC: flights[i].ScheduledDepartureTimeUTC,
          ScheduledDeparture: flights[i].ScheduledDeparture,
          ScheduledArrival: flights[i].ScheduledArrival,
          AcTailNo: flights[i].AcTailNo,
          DutyDate: flights[i].DutyDate
        };
        crewAssessment.Flights.push(flight);
      }

      return crewAssessment;
    }
    /**
     * Returns the a list of cabin Crew Feedbacks that are ready to send (the reports of the assessment are completed or synched)
     * @memberof SaCrewAssessmentFactory
     * @param {string} Route  The route of the assessment
     * @param {string} DutyDate  The duty date of the assessment
     * @returns {Array} assessmentsToSend  
     */


    function getAssementsReadyToSend() {
      var assessments = getCrewAssessmentsFromStorage();
      var assessmentsToSend = [];

      for (var i = 0; i < assessments.length; i++) {
        if (assessments[i].Status == "Completed") {
          assessmentsToSend.push(assessments[i]);
        }
      }

      return assessmentsToSend;
    }
    /**
     * Update Assessments which are stored inside the flights 
     * @memberof SaCrewAssessmentFactory
     * @param {Object} crewAssessment  The crew assessment\
     */


    function updateFlightsAssessment(assessment) {
      var flights = FlightFactory.getFlightsFromStorage();

      for (var i = 0; i < flights.length; i++) {
        //TODO:: if assessment.Id =0 ? then route + dutyDate + feedbackdate
        if (flights[i].saAssessment && assessment.Id == flights[i].saAssessment.Id) {
          flights[i].saAssessment.Status = assessment.Status;
        }
      }

      FlightFactory.setFlightsToStorage(flights);
    }
    /**
     * Update and merge all SA assessments
     * @memberof SaCrewAssessmentFactory
     */


    function updateAndMergeAllSaAssessments(newSaAssessments) {
      var oldSaAssessments = getCrewAssessmentsFromStorage() || [];
      newSaAssessments = newSaAssessments || [];
      var finalSaAssessments = [];
      var assessmentsToCreate = []; // group old by Route+DutyDate

      var oldGroups = {};
      oldSaAssessments.forEach(function (item) {
        var key = item.Route + "|" + item.DutyDate;
        if (!oldGroups[key]) oldGroups[key] = [];
        oldGroups[key].push(item);
      }); // group new by Route+DutyDate

      var newGroups = {};
      newSaAssessments.forEach(function (item) {
        var key = item.Route + "|" + item.DutyDate;
        if (!newGroups[key]) newGroups[key] = [];
        newGroups[key].push(item);
      }); // process each new group

      for (var key in newGroups) {
        var newGroup = newGroups[key];
        var oldGroup = oldGroups[key] || [];

        if (newGroup.length === oldGroup.length && newGroup.length > 0) {
          // counts equal → update one by one, matched by FeedbackDate
          newGroup.forEach(function (n) {
            // find matching old by FeedbackDate 
            var match = oldGroup.find(function (o) {
              return o.FeedbackDate === n.FeedbackDate;
            } //|| (!o.FeedbackDate && !n.FeedbackDate) //(null/undefined allowed to match empty)
            );

            if (match) {
              var updated = updateCrewAssessment(match, n);
              finalSaAssessments.push(updated);
            } else {
              // no match → treat as new
              assessmentsToCreate.push(n);
            }
          });
        } else {
          // counts differ → ignore olds, just create all news
          assessmentsToCreate = assessmentsToCreate.concat(newGroup);
        }
      } // create new assessments


      var created = createCrewAssessments(assessmentsToCreate);
      finalSaAssessments = finalSaAssessments.concat(created); // replace storage with only updated + created

      setCrewAssessmentsToStorage(finalSaAssessments);
      storeFlightsWithAssessments();
    }
    /**
          * Create New Crew Assessments from the api assessments
          * @memberof SaCrewAssessmentFactory
          * @returns {Array} crewAssessments 
          */


    function createCrewAssessments(assessments) {
      var crewAssessments = [];

      for (var i = 0; i < assessments.length; i++) {
        var crewAssessment = createNewCrewAssessment(assessments[i]);

        if (crewAssessment) {
          crewAssessments.push(crewAssessment);
        }
      }

      return crewAssessments;
    }
    /**
           * Create New Crew Assessment from the api assessments
           * @memberof SaCrewAssessmentFactory
           * @returns {object} assessment 
           */


    function createNewCrewAssessment(assessment) {
      // load the user
      var user = UserFactory.getUser();
      if (user == null) return null; // load the crewAssessmentTemplate

      var crewAssessmentTemplates = SaFeedbackInfoFactory.getQuestions();
      if (crewAssessmentTemplates == null) return null; // load the flight

      var flights = FlightFactory.getFlightsByRoutePerDay(assessment.Route, assessment.DutyDate, assessment.FeedbackDate);
      if (flights == null || flights.length == 0) return null; // create the new crewAssessment

      var crewAssessment = getNewCrewAssessment();
      crewAssessment.Id = !assessment.Id ? guid() : assessment.Id;
      crewAssessment.AuthorId = user.id;
      crewAssessment.Route = assessment.Route;
      crewAssessment.DutyDate = assessment.DutyDate;
      crewAssessment.DutyDay = assessment.DutyDay;
      crewAssessment.DutyNo = assessment.DutyNo;
      crewAssessment.AcType = flights[0].AcType;
      crewAssessment.Base = flights[0].Departure;
      crewAssessment = updateAssessmentFlights(crewAssessment, flights);
      crewAssessment.assessedBy = assessment.assessedBy;
      crewAssessment.FeedbackDate = assessment.FeedbackDate;
      var IsExist = true;
      var flightIds = flights.map(function (f) {
        return f.FlightId;
      }); //filter by feedback date

      assessment.CrewAssessmentMembers = crewAssessmentFilteredByFeedbackDate(assessment); //filter by common flights in the route

      var flightIds = flights.map(function (f) {
        return f.FlightId;
      }); // Filter the CrewAssessmentMembers to include only those with common flights in the route

      assessment.CrewAssessmentMembers = filterCrewAssessmentMembersByCommonFlightsInRoute(assessment.CrewAssessmentMembers, flightIds);

      for (var i = 0; i < assessment.CrewAssessmentMembers.length; i++) {
        //check for double crew members, same day for multiday duties
        if (crewAssessment.CrewAssessmentMembers && !crewAssessment.CrewAssessmentMembers.some(function (member) {
          return member.CrewAimsId === assessment.CrewAssessmentMembers[i].CrewAimsId;
        })) {
          var crewMember = SaCrewAssessmentMemberFactory.newMember();
          crewMember.CrewAimsId = assessment.CrewAssessmentMembers[i].CrewAimsId;
          crewMember.CrewId = assessment.CrewAssessmentMembers[i].CrewId;
          crewMember.assessmentItems = crewAssessmentTemplates;
          crewMember.Name = assessment.CrewAssessmentMembers[i].Name;
          crewMember.IsCompleted = false;
          crewMember.IsValid = true;
          crewMember.IsExist = assessment.CrewAssessmentMembers[i].IsExist;
          crewMember.EndPeriod = assessment.CrewAssessmentMembers[i].EndPeriod;

          if (!assessment.CrewAssessmentMembers[i].IsExist) {
            IsExist = false;
          }

          crewAssessment.CrewAssessmentMembers.push(crewMember);
        }
      } //set the Latest End Period


      crewAssessment.LatestEndPeriod = moment.max(crewAssessment.CrewAssessmentMembers.map(function (member) {
        return moment(member.EndPeriod);
      })).toDate();
      crewAssessment.IsExist = IsExist;

      if (IsExist) {
        crewAssessment.Status = "Stored";
      } // return the new crewAssessment


      return crewAssessment;
    }
    /**
          * Store Assessment inside the flights
          * @memberof SaCrewAssessmentFactory
          */


    function storeFlightsWithAssessments() {
      var flights = FlightFactory.getFlightsFromStorage();
      var crewAssessments = getCrewAssessmentsFromStorage();

      for (var i = 0; i < flights.length; i++) {
        for (var j = 0; j < crewAssessments.length; j++) {
          if (flights[i].Route == crewAssessments[j].Route && (crewAssessments[j].FeedbackDate && flights[i].FlightDate == crewAssessments[j].FeedbackDate || !crewAssessments[j].FeedbackDate && flights[i].DutyDate == crewAssessments[j].DutyDate)) {
            flights[i].saAssessment = {
              Id: crewAssessments[j].Id,
              Status: crewAssessments[j].Status,
              IsExist: crewAssessments[j].IsExist,
              //IsAssessedBy: crewAssessments[j].assessedBy.length > 0,
              IsCrewLess: crewAssessments[j].CrewAssessmentMembers.length < 1,
              FeedbackDate: crewAssessments[j].FeedbackDate,
              LatestEndPeriod: crewAssessments[j].LatestEndPeriod
            };
            break;
          }
        }
      }

      FlightFactory.setFlightsToStorage(flights);
    } // Filters the assessmentCrew to include only those matching the FeedbackDate (if any)


    function crewAssessmentFilteredByFeedbackDate(assessment) {
      var filteredCrew = [];

      if (assessment && assessment.CrewAssessmentMembers && assessment.CrewAssessmentMembers.length > 0) {
        for (var i = 0; i < assessment.CrewAssessmentMembers.length; i++) {
          if (!assessment.FeedbackDate || assessment.FeedbackDate == assessment.CrewAssessmentMembers[i].FlightDate) {
            filteredCrew.push(assessment.CrewAssessmentMembers[i]);
          }
        }
      }

      return filteredCrew;
    } // Filters the CrewAssessmentMembers to include only those with common flights in the route


    function filterCrewAssessmentMembersByCommonFlightsInRoute(members, flightIdsInRoute) {
      if (!members || members.length === 0 || !flightIdsInRoute || flightIdsInRoute.length === 0) {
        return [];
      }

      var commonFlightsWithSA = localStorageMD5Service.get('CommonFlightsWithSA') || [];
      var faAimsIds = commonFlightsWithSA.filter(function (entry) {
        return entry.Flights.some(function (flight) {
          return flightIdsInRoute.includes(flight.FlightId);
        });
      }).map(function (entry) {
        return entry.SaAimsId;
      });
      return members.filter(function (member) {
        return faAimsIds.includes(member.CrewAimsId);
      });
    }

    function calculateIsOutdated(memberEndDate) {
      if (!memberEndDate) return false;
      var endDate = new Date(memberEndDate);
      var today = defaultCalendarDate ? new Date(defaultCalendarDate) : new Date(); // Add 1 day to the member's end date

      var endDatePlusOne = new Date(endDate);
      endDatePlusOne.setDate(endDate.getDate() + 1); // Normalize times to midnight for date-only comparison

      endDatePlusOne.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0); // If (endDate + 1 day) is before OR equal to today → outdated

      return endDatePlusOne <= today;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('SaCrewAssessmentMemberFactory', SaCrewAssessmentMemberFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CrewAssessmentMemberFactory
  * @description 
  *   Initializes new Crew Assessment Members
  * @ngInject
  */

  function SaCrewAssessmentMemberFactory() {
    /**
    * Initialize the Crew Assessment Member
    * @memberof CrewAssessmentMemberFactory
    */
    function CrewAssessmentMember() {
      this.CrewAimsId = null;
      this.CrewId = null;
      this.Name = null;
      this.IsCompleted = false;
      this.IsValid = true;
      this.IsOverride = false;
      this.IsManual = false;
      this.IsExist = false;
      this.Review = null;
      this.assessmentItems = [];
      this.IsOutdated = false;
      this.EndPeriod = null;
    }

    var service = {
      newMember: newMember
    };
    /**
     * Create New Crew Assessment Member
     * @memberof CrewAssessmentMemberFactory
     * @returns {object} CrewAssessmentMember 
     */

    function newMember() {
      return new CrewAssessmentMember();
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('SaFeedbackInfoFactory', SaFeedbackInfoFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name SaFeedbacksFactory
  * @description 
  * Add, Update and Get SaFeedbacks Info
  * @ngInject
  */

  function SaFeedbackInfoFactory(GenericService, defaultCalendarDate, CrewRouteFactory, FlightFactory, localStorageMD5Service) {
    var objType = 'SaFeedbackInfo';
    var objCallback = SaFeedbackInfo;
    /**
     * Initialize the SaFeedbackInfo
     * @memberof SaFeedbacksFactory
     */

    function SaFeedbackInfo() {
      this.questions = [];
      this.assessments = [];
      this.saMembers = [];
      this.showSaAssessmentModal = false; // this.storedFeedbacks = [];
    }

    var service = {
      setSaFeedbacks: setSaFeedbacks,
      getFeedbacksInfo: getFeedbacksInfo,
      getQuestions: getQuestions,
      getSaMembersForFeedback: getSaMembersForFeedback,
      hasSyncedFeedbacks: hasSyncedFeedbacks,
      showSaAssessmentReminderModal: showSaAssessmentReminderModal,
      updateShowSaAssessmentModal: updateShowSaAssessmentModal
    };

    function setSaFeedbacks(feedbacksObj) {
      if (feedbacksObj != null && feedbacksObj.Questions != null && feedbacksObj.Assessments != null) {
        // Create an empty array to hold all CrewAssessmentMembers
        var crewAssessmentMembers = []; // Loop through each assessment and take its CrewAssessmentMembers

        feedbacksObj.Assessments.forEach(function (assessment) {
          if (assessment.CrewAssessmentMembers && Array.isArray(assessment.CrewAssessmentMembers)) {
            crewAssessmentMembers = crewAssessmentMembers.concat(assessment.CrewAssessmentMembers);
          }
        });
        var uniqueMembers = {};
        crewAssessmentMembers.forEach(function (member) {
          if (member && member.CrewId) {
            uniqueMembers[member.CrewId] = member;
          }
        });
        var uniqueMembersArray = Object.keys(uniqueMembers).map(function (key) {
          return uniqueMembers[key];
        });
        var saFeedbackInfo = {
          questions: feedbacksObj.Questions,
          assessments: feedbacksObj.Assessments,
          saMembers: uniqueMembersArray,
          showSaAssessmentModal: true
        }; // saMembers: feedbacksObj.SaMembers , storedFeedbacks : feedbacksObj.StoredFeedbacks};

        GenericService.saveOne(saFeedbackInfo, objType, objCallback);
      }
    }
    /**
     * Get Feedbacks Info from local storage
     */


    function getFeedbacksInfo() {
      return GenericService.getOne(objType, objCallback);
    }
    /**
     * Get SA members for the feedbacks
     */


    function getSaMembersForFeedback(saMembersIdsInRoute) {
      var feedbacksInfo = getFeedbacksInfo(); // Check if feedbacksInfo or saMembersIdsInRoute is not defined/null

      if (!saMembersIdsInRoute || !feedbacksInfo || !feedbacksInfo.saMembers || !Array.isArray(feedbacksInfo.saMembers)) {
        console.error("Invalid feedbacksInfo or saMembersIdsInRoute");
        return [];
      } // Get the current date + 1 day


      var nowPlusOne = new Date();
      nowPlusOne.setDate(nowPlusOne.getDate() + 1);

      if (defaultCalendarDate) {
        nowPlusOne = new Date(defaultCalendarDate);
      }

      var commonSaMembers = feedbacksInfo.saMembers.filter(function (member) {
        var memberEndDate = new Date(member.EndPeriod); // Check if the member's ID matches and the endDate is valid

        return saMembersIdsInRoute.includes(member.CrewAimsId) && memberEndDate >= nowPlusOne // End date is greater than or equal to now + 1
        ;
      });
      return commonSaMembers;
    }

    function hasSyncedFeedbacks(dutyNo, dutyDay, feedbackDate) {
      var isSynced = false;
      var feedbacksInfo = getFeedbacksInfo();

      if (feedbacksInfo && feedbacksInfo.assessments && feedbacksInfo.assessments.length > 0) {
        var storedFeedback = feedbacksInfo.assessments.find(function (f) {
          return f.DutyNo == dutyNo && f.DutyDay == dutyDay && (!f.FeedbackDate || f.FeedbackDate == feedbackDate);
        }); //add isexist or id not null

        if (storedFeedback && storedFeedback.Id != null) {
          isSynced = true;
        }
      }

      return isSynced;
    }
    /**
      * The question object
      */


    function question() {
      this.Id = null;
      this.Description = null;
      this.Label = null;
      this.OrderNo = null;
      this.ItemValue = 3;
      this.GetId = GetId;
    } //Object services

    /**
     * Overide default get Id
     * @memberof CrewAssessmentTemplateFactory
     * @returns {number} Id 
     */


    function GetId() {
      return this.Id;
    }
    /**
     * Get questions for the feedback forms
     */


    function getQuestions() {
      var feedbacksInfo = getFeedbacksInfo(); // Assuming feedbacksInfo.questions is an array of question data

      return feedbacksInfo.questions.map(function (qData) {
        var q = new question();
        q.Id = qData.Id;
        q.Description = qData.Description;
        q.Label = qData.Label;
        q.OrderNo = qData.OrderNo;
        q.ItemValue = qData.ItemValue || 3; // Default value if not provided

        return q;
      });
    } // function showSaAssessmentReminderModal() {
    //     // Get all crew routes from storage
    //     var feedbacksInfo = getFeedbacksInfo();
    //     if(feedbacksInfo && feedbacksInfo.showSaAssessmentModal){
    //         var crewRoutes = CrewRouteFactory.getCrewRoutesFromStorage();
    //         var nowUtc = moment.utc();
    //         if(defaultCalendarDate){
    //             nowUtc = moment(defaultCalendarDate).utc();
    //         }
    //         // Return true if at least one route has DutyEnd before nowUtc and Status !== "Stored"
    //         return crewRoutes.some(function(route) {
    //             debugger
    //             return moment(route.DutyEnd).isBefore(nowUtc) && route.Status !== 'Stored';
    //         });
    //     } else {
    //         return false;
    //     }
    // }


    function showSaAssessmentReminderModal() {
      var info = getFeedbacksInfo();
      if (!info || !info.showSaAssessmentModal) return false;
      var nowUtc = defaultCalendarDate ? moment(defaultCalendarDate).utc() : moment.utc();
      var assessments = Array.isArray(info.assessments) ? info.assessments : [];
      return assessments.some(function (a) {
        if (!a || !a.DutyDate) return false;
        var dutyMoment = moment(a.DutyDate).utc();
        if (!dutyMoment.isValid()) return false;
        var isPast = dutyMoment.isBefore(nowUtc);
        var isPending = a.Id == null; // not yet stored/synced on server

        return isPast && isPending && hasAvailableSaAssessmentForm(a);
      });
    }

    function hasAvailableSaAssessmentForm(assessment) {
      var flights = FlightFactory.getFlightsByRoutePerDay(assessment.Route, assessment.DutyDate, assessment.FeedbackDate);
      if (!flights || flights.length === 0) return false;
      var saMembersInRoute = CrewRouteFactory.getSACrewMembersFromRoute(assessment.DutyNo, assessment.DutyDay, assessment.FeedbackDate);
      var saMembersNeedFeedback = getSaMembersForFeedback(saMembersInRoute);
      if (!saMembersNeedFeedback || saMembersNeedFeedback.length === 0) return false;
      var saAimsIdsNeedFeedback = saMembersNeedFeedback.map(function (member) {
        return member.CrewAimsId;
      });
      var flightIds = flights.map(function (flight) {
        return flight.FlightId;
      });
      var commonFlightsWithSA = localStorageMD5Service.get('CommonFlightsWithSA') || [];
      var saAimsIdsWithCommonFlights = commonFlightsWithSA.filter(function (entry) {
        return entry.Flights && entry.Flights.some(function (flight) {
          return flightIds.includes(flight.FlightId);
        });
      }).map(function (entry) {
        return entry.SaAimsId;
      });
      var crewMembers = Array.isArray(assessment.CrewAssessmentMembers) ? assessment.CrewAssessmentMembers : [];
      return crewMembers.some(function (member) {
        var matchesFeedbackDate = !assessment.FeedbackDate || assessment.FeedbackDate == member.FlightDate;
        var needsFeedback = !member.IsExist && saAimsIdsNeedFeedback.includes(member.CrewAimsId);
        var hasCommonFlight = saAimsIdsWithCommonFlights.includes(member.CrewAimsId);
        return matchesFeedbackDate && needsFeedback && hasCommonFlight;
      });
    }

    function updateShowSaAssessmentModal(canShowModal) {
      var feedbacksInfo = getFeedbacksInfo();

      if (feedbacksInfo) {
        feedbacksInfo.showSaAssessmentModal = canShowModal;
        GenericService.saveOne(feedbacksInfo, objType, objCallback);
      }
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('AcknowledgeModalCtrl', AcknowledgeModalCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name AcknowledgeModalCtrl
  * @description 
  * Warning Modal about unread mandatory memos
  * @ngInject
  */

  function AcknowledgeModalCtrl($scope, ScheduleAcknowledgeFactory, $route, $uibModalInstance) {
    $scope.ConfirmAcknowledge = ConfirmAcknowledge;
    $scope.cancel = cancel;
    $scope.showContent = 'confirm';
    $scope.responseObj = {
      success: false,
      message: '',
      Results: []
    };
    $scope.results = [];

    function ConfirmAcknowledge() {
      $scope.showContent = 'loading';
      ScheduleAcknowledgeFactory.acknowledgeChanges().then(function (res) {
        return handleSubmitResponse(res);
      })["catch"](function (res) {
        return handleSubmitResponse(res);
      });
    }

    function handleSubmitResponse(res) {
      $scope.showContent = 'results';
      $scope.responseObj = res;
    }
    /**
    * Closes modal
    * @memberof ProposalInfoModalCtr
    */


    function cancel() {
      $uibModalInstance.close('cancel');

      if ($scope.responseObj.success) {
        $route.reload();
      }
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('ScheduleAcknowledgeFactory', ScheduleAcknowledgeFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name ScheduleAcknowledgeFactory
  * @description 
  *   Get list, Update list & Acknowledge schedule changes
  * @ngInject
  */

  function ScheduleAcknowledgeFactory(localStorageMD5Service, GenericService, $http, apiUrl, defaultCalendarDate) {
    /**
     * Initialize the ScheduleChanges
     * @memberof ScheduleAcknowledgeFactory
     */
    function ScheduleChanges() {
      this.dates = [];
      this.showScheduleChangesModal = false;
    }

    var objType = 'ScheduleChanges';
    var objCallback = ScheduleChanges;
    var response = {
      success: false,
      message: '',
      Results: []
    };
    var service = {
      setAllScheduleChangesToStorage: setAllScheduleChangesToStorage,
      getScheduleChangesFromStorage: getScheduleChangesFromStorage,
      updateShowScheduleChangesModal: updateShowScheduleChangesModal,
      showScheduleChangesModal: showScheduleChangesModal,
      hasScheduleChanges: hasScheduleChanges,
      acknowledgeChanges: acknowledgeChanges
    };
    /**
     * Save All Schedule changes
     * @param {array} objList 
     */

    function setAllScheduleChangesToStorage(objList) {
      if (objList == null || !objList.length > 0) {
        GenericService.removeAll(objType);
      } else {
        var scheduleChanges = {
          dates: objList,
          showScheduleChangesModal: true
        };
        GenericService.saveOne(scheduleChanges, objType, objCallback);
      }
    }
    /**
     * Get all Schedule changes
     */


    function getScheduleChangesFromStorage() {
      var dateList = [];
      var scheduleChanges = GenericService.getOne(objType, objCallback);

      if (scheduleChanges != null && scheduleChanges.dates != null) {
        scheduleChanges.dates.forEach(function (dateS) {
          var stringToDate = moment.utc(dateS);
          dateList.push(stringToDate);
        });
      }

      return dateList;
    }
    /* Update scheduleChanges object to storage
    * @memberof ScheduleAcknowledgeFactory
    * @param {bool} canShowModal whether the modal can be display
    */


    function updateShowScheduleChangesModal(canShowModal) {
      var scheduleChanges = GenericService.getOne(objType, objCallback);
      scheduleChanges.showScheduleChangesModal = canShowModal;
      GenericService.saveOne(scheduleChanges, objType, objCallback);
    }
    /**
     * ShowScheduleChangesModal check
     * @memberof ScheduleAcknowledgeFactory
     * @returns {bool} returns the value of showScheduleChangesModal property
     */


    function showScheduleChangesModal() {
      var scheduleChanges = GenericService.getOne(objType, objCallback);

      if (scheduleChanges && scheduleChanges.dates != null && scheduleChanges.dates.length > 0) {
        var fistChange = moment.utc(scheduleChanges.dates[0]);
        var today = moment.utc();

        if (defaultCalendarDate) {
          today = moment.utc(defaultCalendarDate);
        }

        var datediff = fistChange.diff(today, 'days');
        return datediff <= 1 && scheduleChanges.showScheduleChangesModal;
      } else {
        return false;
      }
    }

    function hasScheduleChanges() {
      var dates = getScheduleChangesFromStorage();
      return dates != null && dates.length > 0;
    }
    /**
     * Acknowledge Changes 
     * @param {date} dateFrom The first schedule change date
     * @param {date} dateTo The last schedule change date
     * @returns {promise} response
     */


    function acknowledgeChanges() {
      //get dates from local storage
      var datesToAcknowledge = getScheduleChangesFromStorage();
      return $http.post(apiUrl + '/ScheduleAcknowledge/AcknowledgeScheduleChanges', datesToAcknowledge, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return updateScheduleChangesCallBack(res);
      })["catch"](function (res) {
        return acknowledgeFailedCallBack(res);
      });
    }
    /**
     * Update Schedule changes dates
     * @param {object} res 
     * @param {object} objectToAdd 
     * @returns {object} response
     */


    function updateScheduleChangesCallBack(res) {
      response.success = res.data.success;

      if (res.data.success) {
        //update local storage
        setAllScheduleChangesToStorage(res.data.data.DatesWithChanges);
        response.message = "Success! Your Acknowledge has been sent";
        response.Results = res.data.data.Results;
      } else {
        response.message = res.data.errorMessage;
      }

      return response;
    }
    /**
    * The callback function upon failure on submit
    * @returns {object} response
    */


    function acknowledgeFailedCallBack(res) {
      response.success = false;
      response.message = "Oops! Something went wrong";

      if (res.data.data && res.data.data.Results) {
        response.Results = res.data.data.Results;
      }

      return response;
    }

    return service;
  }
})();
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  'use strict';

  a3_cabin_reports.factory('RequestFactory', RequestFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name RequestFactory
  * @description 
  *   Add & delete requests and get Roster Requests & get ancillaries
  * @ngInject
  */

  function RequestFactory($http, apiUrl, GenericService) {
    /**
    * Initialize the CrewAssessment
    * @memberof AssessmentSyncResultFactory
    */
    function RequestSubmissionDeadline() {
      this.showSubmissionDeadlineModal = false;
    }

    var submitResponseObj = {
      success: false,
      message: '',
      data: null
    };
    var objType = 'requestSubmissionEndDates';
    var objCallback = RequestSubmissionDeadline;
    var service = {
      setSubmissionDeadlineDateToStorage: setSubmissionDeadlineDateToStorage,
      getSubmissionDeadlineDateFromStorage: getSubmissionDeadlineDateFromStorage,
      showSubmissionDeadlineModal: showSubmissionDeadlineModal,
      showSubmissionDeadlineAlert: showSubmissionDeadlineAlert,
      updateShowSubmissionDeadlineModal: updateShowSubmissionDeadlineModal,
      getActiveRequests: getActiveRequests,
      getAncillaries: getAncillaries,
      sendFlightRequest: sendFlightRequest,
      sendShiftRequest: sendShiftRequest,
      sendOvernightRequest: sendOvernightRequest,
      sendOtherRequest: sendOtherRequest,
      sendGroundRequest: sendGroundRequest,
      deleteFlightRequest: deleteFlightRequest,
      deleteShiftRequest: deleteShiftRequest,
      deleteOvernightRequest: deleteOvernightRequest,
      deleteOtherRequest: deleteOtherRequest,
      deleteGroundRequest: deleteGroundRequest,
      getPastRequests: getPastRequests
    };
    /**
     * Save submission end date of crew member's qualification group to storage
     * @param {array} objList A list of Crew Expiries
     */

    function setSubmissionDeadlineDateToStorage(objList) {
      if (objList != null) {
        var submissionDeadline = {
          submissionEndDate: objList,
          showSubmissionDeadlineModal: true
        };
        GenericService.saveOne(submissionDeadline, objType, objCallback);
      }
    }
    /**
     * Calculates days left
     * @memberof CalendarCtrl
     * @return {string} usage
     */


    function daysDiff(date) {
      var today = moment().startOf('day');
      var expiryDate = moment(date);
      return expiryDate.diff(today, 'days');
    }
    /**
     * Get submission end date of crew member's qualification group from storage
     */


    function getSubmissionDeadlineDateFromStorage() {
      return GenericService.getOne(objType, objCallback);
    }
    /**
     * Shows submission deadline modal
     * @memberof ExpiriesFactory
     * @returns {bool} returns the value of showSubmissionDeadlineModal property
     */


    function showSubmissionDeadlineModal() {
      var needsReminder = false;
      var submissionDeadline = getSubmissionDeadlineDateFromStorage();

      if (submissionDeadline) {
        var diffDays = daysDiff(submissionDeadline.submissionEndDate);

        if (submissionDeadline && submissionDeadline.submissionEndDate && submissionDeadline.showSubmissionDeadlineModal) {
          if (diffDays == 1 || diffDays == -1) {
            needsReminder = true;
          }
        }
      }

      return needsReminder;
    }
    /**
     * Shows submission deadline alert
     * @memberof ExpiriesFactory
     * @returns {bool} returns the value of showSubmissionDeadlineAlert property
     */


    function showSubmissionDeadlineAlert() {
      var needsAlert = false;
      var submissionDeadline = getSubmissionDeadlineDateFromStorage();

      if (submissionDeadline) {
        var diffDays = daysDiff(submissionDeadline.submissionEndDate);

        if (submissionDeadline && submissionDeadline.submissionEndDate) {
          if (diffDays <= 10 && diffDays >= 0) {
            needsAlert = true;
          }
        }
      }

      return needsAlert;
    }
    /* Update submissionEndDate modal object to storage
    * @memberof RequestFactory
    * @param {bool} canShowModal whether the modal can be displayed
    */


    function updateShowSubmissionDeadlineModal(canShowModal) {
      var submissionDeadline = getSubmissionDeadlineDateFromStorage();
      submissionDeadline.showSubmissionDeadlineModal = canShowModal;
      GenericService.saveOne(submissionDeadline, objType, objCallback);
    }
    /**
    * Gets all types of the existing requests
    */


    function getActiveRequests() {
      return $http.get(apiUrl + '/RosterRequests/GetRequests', {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
      ;
    }
    /**
    * Gets all ancilleries
    */


    function getAncillaries() {
      return $http.get(apiUrl + '/RosterRequests/GetAncillaries', {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }
    /**
    * Sends the flight request
    */


    function sendFlightRequest(rosterRequest) {
      var requestTimesFixed = _objectSpread({}, rosterRequest);

      if (rosterRequest.afterTime) {
        requestTimesFixed.afterTime = rosterRequest.afterTime.clone();
        var startDateObj = new Date(requestTimesFixed.afterTime).fromUTC();
        requestTimesFixed.afterTime = moment(startDateObj);
      } else {
        requestTimesFixed.afterTime = null;
      }

      if (rosterRequest.beforeTime) {
        requestTimesFixed.beforeTime = rosterRequest.beforeTime.clone();
        var endDateObj = new Date(requestTimesFixed.beforeTime).fromUTC();
        requestTimesFixed.beforeTime = moment(endDateObj);
      } else {
        requestTimesFixed.beforeTime = null;
      }

      var rosterRequestsURL = apiUrl + '/RosterRequests/FlightRequestInsert';
      return $http.post(rosterRequestsURL, requestTimesFixed, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }
    /**
    * Sends the shift request
    */


    function sendShiftRequest(rosterRequest) {
      var rosterRequestsURL = apiUrl + '/RosterRequests/ShiftTimeRequestInsert';
      return $http.post(rosterRequestsURL, rosterRequest, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }
    /**
    * Sends the overnight request
    */


    function sendOvernightRequest(rosterRequest) {
      var rosterRequestsURL = apiUrl + '/RosterRequests/OvernightsRequestInsert';
      return $http.post(rosterRequestsURL, rosterRequest, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }
    /**
    * Sends the other request
    */


    function sendOtherRequest(rosterRequest) {
      var rosterRequestsURL = apiUrl + '/RosterRequests/OtherRequestInsert';
      return $http.post(rosterRequestsURL, rosterRequest, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }
    /**
    * Sends the ground request
    */


    function sendGroundRequest(rosterRequest) {
      var rosterRequestsURL = apiUrl + '/RosterRequests/GroundDutyRequestInsert';
      return $http.post(rosterRequestsURL, rosterRequest, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }
    /**
    * Gets the response message
    */


    function getResponse(res) {
      submitResponseObj.success = res.data.success;

      if (res.data.success) {
        submitResponseObj.message = "Data retrieved successfully";
        submitResponseObj.data = res.data.data;
      } else {
        submitResponseObj.message = res.data.errorMessage;
      }

      return submitResponseObj;
    }
    /**
    * Gets the creation response message
    */


    function getCreateRequestResponse(res) {
      submitResponseObj.success = res.data.success;

      if (res.data.success) {
        submitResponseObj.message = "Request submited successfully";
        submitResponseObj.data = res.data.data;
      } else {
        submitResponseObj.message = res.data.errorMessage;
      }

      return submitResponseObj;
    }
    /**
    * Gets the response failure message
    */


    function getResponseFailed(res) {
      submitResponseObj.success = false;
      submitResponseObj.message = "Something went wrong!";
      return submitResponseObj;
    }
    /**
    * Deletes the flight request
    */


    function deleteFlightRequest(requestId) {
      var deleteRequestsURL = apiUrl + '/RosterRequests/FlightRequestDelete';
      return $http.post(deleteRequestsURL, requestId, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      });
    }
    /**
    * Deletes the shift request
    */


    function deleteShiftRequest(requestId) {
      var deleteRequestsURL = apiUrl + '/RosterRequests/ShiftTimeRequestDelete';
      return $http.post(deleteRequestsURL, requestId, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      });
    }
    /**
    * Deletes the overnight request
    */


    function deleteOvernightRequest(requestId) {
      var deleteRequestsURL = apiUrl + '/RosterRequests/OvernightsRequestDelete';
      return $http.post(deleteRequestsURL, requestId, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      });
    }
    /**
    * Deletes the other request
    */


    function deleteOtherRequest(requestId) {
      var deleteRequestsURL = apiUrl + '/RosterRequests/OtherRequestDelete';
      return $http.post(deleteRequestsURL, requestId, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      });
    }
    /**
    * Deletes the ground request
    */


    function deleteGroundRequest(requestId) {
      var deleteRequestsURL = apiUrl + '/RosterRequests/GroundDutyRequestDelete';
      return $http.post(deleteRequestsURL, requestId, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      });
    }
    /**
    * Gets all types of the past requests
    */


    function getPastRequests() {
      return $http.get(apiUrl + '/RosterRequests/GetPastRequests', {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
      ;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('requestForm', requestForm);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name requestForm
  * @restrict E
  * @description
  *   Crew Table with a double row per crew member
  * @example
  *   Usage:
  *   <request-form request-type="Ground Duty" ></request-form>
  *   <request-form request-type="Flight" ></request-form>
  * @ngInject
  */

  function requestForm() {
    function link(scope, attrs) {}

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/RosterRequests/requestForm.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('RequestInstructionsCtrl', RequestInstructionsCtrl);
  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name RequestInstructionsCtrl
  * @description 
  *   Get the Roster Request Instructions
  * @ngInject
  */

  function RequestInstructionsCtrl($scope, $uibModalInstance) {
    $scope.page = 1;
    $scope.cancel = cancel;
    $scope.nextPage = nextPage;
    $scope.previousPage = previousPage;
    $scope.instructionPages = 1;
    /**
     * Goes to the next page of  leave instructions
     * @memberof RequestInstructionsCtrl
     */

    function nextPage() {
      $scope.page = $scope.page + 1;
      normalizePage();
    }
    /**
    * Goes to the previous page of leave instructions
    * @memberof RequestInstructionsCtrl
    */


    function previousPage() {
      $scope.page = $scope.page - 1;
      normalizePage();
    }
    /**
     * Normalize the page number if it is out of range
     * @memberof RequestInstructionsCtrl
     */


    function normalizePage() {
      if ($scope.page > $scope.instructionPages || $scope.page < 1) {
        $scope.page = 1;
      }
    }
    /**
     * Close the modal
     * @memberof RequestInstructionsCtrl
     */


    function cancel() {
      $uibModalInstance.close('close');
    }

    ;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('requestItem', requestItem);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name requestItem
  * @restrict E
  * @description
  *   Request info
  * @example
  *   Usage:
  *   <request-item request="request" request-type="Flight" on-deleted="deleteRequest(requestId, requestType)"></request-item>
  * @ngInject
  */

  function requestItem($uibModal, RequestFactory) {
    function link(scope, element, attrs) {
      //scope.request
      scope.loading = false;
      scope.errorMessage = null;
      scope.contents = {
        showPendingIcon: false,
        //sholwAcknowledgedIcon: false,
        showAcceptedIcon: false,
        showRejectedIcon: false,
        showFullRequestComment: false,
        showFullRejectComment: false,
        rejectReason: "",
        infoMessage: "",
        loading: false,
        showErrorMessage: false,
        errorMessage: "",
        textclass: ""
      };
      scope.confirmCancelRequest = confirmCancelRequest;
      scope.toggleFullCommentVisibility = toggleFullCommentVisibility;
      scope.toggleFullRejectCommentVisibility = toggleFullRejectCommentVisibility;
      scope.todayDate = moment().format('DD/MM');
      getFlightDescription();

      function getFlightDescription() {
        scope.request.FlightDescription = null;

        if (scope.request.FlightNo) {
          scope.request.FlightDescription = scope.request.FlightNo;
        } else if (scope.request.FlightDutyCategory) {
          scope.request.FlightDescription = scope.request.FlightDutyCategory;
        } else if (scope.request.AfterTime && scope.request.BeforeTime) {
          scope.request.FlightDescription = moment.utc(scope.request.AfterTime).format('HH:mm') + " - " + moment.utc(scope.request.BeforeTime).format('HH:mm');
        } else if (scope.request.AfterTime) {
          scope.request.FlightDescription = "after " + moment.utc(scope.request.AfterTime).format('HH:mm');
        } else if (scope.request.BeforeTime) {
          scope.request.FlightDescription = "till " + moment.utc(scope.request.BeforeTime).format('HH:mm');
        }
      } //Toggles comments


      function toggleFullCommentVisibility() {
        scope.contents.showFullRequestComment = !scope.contents.showFullRequestComment;
      }

      function toggleFullRejectCommentVisibility() {
        scope.contents.showFullRejectComment = !scope.contents.showFullRejectComment;
      }

      getContents(); //update contents obj:

      function getContents() {
        if (scope.request.StatusText == "FinalAccepted") {
          scope.contents.textclass = "text-green";
          scope.contents.showAcceptedIcon = true;
          scope.contents.infoMessage = "your request has been accepted!";
        } else if (scope.request.StatusText == "Accepted") {
          scope.contents.textclass = "text-indigo";
          scope.contents.showPendingIcon = true;
          scope.contents.infoMessage = "your request is under review!";
        } else if (scope.request.StatusText == "Pending") {
          scope.contents.textclass = "text-light-blue";
          scope.contents.showPendingIcon = true;
          scope.contents.infoMessage = "your request is pending!";
        } else if (scope.request.StatusText == "Acknowledged") {
          scope.contents.textclass = "text-light-blue";
          scope.contents.showPendingIcon = true;
          scope.contents.infoMessage = "your request is under review!";
        } else if (scope.request.StatusText == "Rejected") {
          scope.contents.rejectReason = scope.rejectReason;
          scope.contents.textclass = "text-red";
          scope.contents.showRejectedIcon = true;
          scope.contents.infoMessage = "your request has been rejected!";
        }
      }
      /**
       * Opens confirmation modal for the request cancel action
       * @memberof request
       */


      function confirmCancelRequest() {
        bootbox.dialog({
          message: "<strong>You are about to cancel your request. Are you sure?</strong><br/><br/>",
          title: "Caution!",
          buttons: {
            confirm: {
              label: 'Confirm',
              className: "btn-danger",
              callback: function callback() {
                cancelRequest();
              }
            },
            cancel: {
              label: "Cancel",
              className: "btn-default",
              callback: function callback() {}
            }
          }
        });
      }

      function cancelRequest() {
        scope.contents.loading = true;

        if (scope.requestType == "Flight") {
          RequestFactory.deleteFlightRequest(scope.request.Id).then(function (res) {
            handleDeleteResponse(res);
          })["catch"](function () {
            handleErrorResponse();
          });
        } else if (scope.requestType == "Ground") {
          RequestFactory.deleteGroundRequest(scope.request.Id).then(function (res) {
            handleDeleteResponse(res);
          })["catch"](function () {
            handleErrorResponse();
          });
        } else if (scope.requestType == "ShiftTime") {
          RequestFactory.deleteShiftRequest(scope.request.Id).then(function (res) {
            handleDeleteResponse(res);
          })["catch"](function () {
            handleErrorResponse();
          });
        } else if (scope.requestType == "Overnight") {
          RequestFactory.deleteOvernightRequest(scope.request.Id).then(function (res) {
            handleDeleteResponse(res);
          })["catch"](function () {
            handleErrorResponse();
          });
        } else if (scope.requestType == "Other") {
          RequestFactory.deleteOtherRequest(scope.request.Id).then(function (res) {
            handleDeleteResponse(res);
          })["catch"](function () {
            handleErrorResponse();
          });
        }
      }

      function handleDeleteResponse(res) {
        scope.contents.loading = false;

        if (res.success == true) {
          scope.refreshRequests();
        } else {
          scope.contents.showErrorMessage = true;
          scope.contents.errorMessage = "Cancel request failed.";
        }
      }

      function handleErrorResponse() {
        scope.contents.loading = false;
        scope.contents.showErrorMessage = true;
        scope.contents.errorMessage = "Cancel request failed.";
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/RosterRequests/requestItem.tpl.html',
      scope: {
        request: '=',
        requestType: "@",
        rejectReason: "@",
        refreshRequests: "&",
        isHistoryView: '@'
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('RequestsCtrl', RequestsCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name RequestsCtrl
  * @description 
  *   Shows Roster Requests
  * @ngInject
  */

  function RequestsCtrl($scope, RequestFactory, $timeout, $uibModal, LogService) {
    $scope.state = 'requests';
    $scope.ancillaries = null;
    $scope.activeRequests = null;
    $scope.isAvailableFeature = false;
    $scope.hasAncillaries = false; //for testing true || live false !;

    $scope.showActiveRequests = false; //for testing true || live false !;

    $scope.contentToShow = "loading";
    window.addEventListener('online', function (e) {
      $timeout(checkConnectionStatus());
    });
    $scope.init = checkConnectionStatus();
    $scope.closeAlert = closeAlert;
    $scope.openRequest = openRequest;
    $scope.page = null;
    $scope.closeForm = closeForm;
    $scope.newForm = {};
    $scope.submitRequest = submitRequest;
    $scope.submitForcedRequest = submitForcedRequest;
    $scope.forceSubmitRequest = forceSubmitRequest;
    $scope.getActiveRequests = getActiveRequests;
    $scope.updateFromValue = updateFromValue;
    $scope.dutyCode = "";
    $scope.showHelp = showHelp;
    $scope.instruction = '';
    $scope.flightRequestType = null;
    $scope.setFlightRequestType = setFlightRequestType;
    $scope.resetStart = resetStart;
    $scope.resetEnd = resetEnd; //ground duties request types:

    $scope.singleDayRequestType = true;
    $scope.toggleGroundRequestType = toggleGroundRequestType;
    $scope.updateFromValueGD = updateFromValueGD;
    $scope.submitLoader = false;
    $scope.toggleViewMode = toggleViewMode;
    $scope.getPastRequests = getPastRequests;
    $scope.isHistoryView = false;
    $scope.showPastRequests = false;
    $scope.hasDutyPreferencesSettings = false; //------------ Request List --------------
    // $scope.showMobileRequestListCriteria = true;

    $scope.filterRequest = filterRequest;
    $scope.getRequestBorderStyle = getRequestBorderStyle;
    $scope.getRejectReason = getRejectReason;
    $scope.toggle = {
      Accepted: true,
      Rejected: true,
      Pending: true,
      FinalAccepted: true
    };
    $scope.submissionDeadline = RequestFactory.getSubmissionDeadlineDateFromStorage();
    $scope.daysDiff = daysDiff;
    /**
     * Calculates days left
     * @memberof CalendarCtrl
     * @return {string} usage
     */

    function daysDiff(date) {
      var today = moment().startOf('day');
      var expiryDate = moment(date);
      return expiryDate.diff(today, 'days');
    }
    /**
     * Get ancillaries for the forms
     * @memberof RequestsCtrl  
     */


    function getAncillaries() {
      RequestFactory.getAncillaries().then(function (response) {
        $scope.contentToShow = "";

        if (response.success) {
          if (response.data) {
            $scope.ancillaries = response.data; // Request types based on crew member's qualification group(s) settings

            $scope.hasDutyPreferencesSettings = $scope.ancillaries.ShiftTimeRequests && $scope.ancillaries.ShiftTimeRequests.length > 0;
            $scope.hasOtherRequestsSettings = $scope.ancillaries.HasOtherRequestsSettings;
            $scope.hasFlightRequestsByFlightNoSettings = $scope.ancillaries.HasFlightRequestsByFlightNoSettings;
            $scope.hasFlightRequestsByTimeRangesSettings = $scope.ancillaries.HasFlightRequestsByTimeRangesSettings;
            $scope.flightOrDutyPreferenceIsVisible = $scope.ancillaries.FlightDutyCategories && $scope.ancillaries.FlightDutyCategories.length > 0 || $scope.hasFlightRequestsByFlightNoSettings || $scope.hasFlightRequestsByTimeRangesSettings; // Create Your Request Menu: visibility option                                       

            $scope.isAvailableFeature = $scope.ancillaries.DutyCodes && $scope.ancillaries.DutyCodes.length > 0 || $scope.flightOrDutyPreferenceIsVisible || $scope.hasDutyPreferencesSettings || $scope.hasOtherRequestsSettings;
            $scope.hasAncillaries = true;
            var periodFrom = new Date($scope.ancillaries.RosterPeriodFrom);
            var periodTo = new Date($scope.ancillaries.RosterPeriodTo);
            $scope.newForm.singleDate = periodFrom;
            $scope.newForm.dateFrom = periodFrom;
            $scope.newForm.dateTo = periodTo; //groundDuties

            $scope.newForm.dutyDateFrom = periodFrom;
            $scope.newForm.dutyDateTo = periodFrom;
            $scope.optionsSingle = {
              minDate: periodFrom,
              initDate: periodFrom
            };
            $scope.optionsFrom = {
              minDate: periodFrom,
              initDate: periodFrom
            };
            $scope.optionsTo = {
              minDate: periodFrom,
              initDate: periodTo
            };
            $scope.optionsDutyDateTo = {
              minDate: periodFrom,
              initDate: periodFrom
            }; // Fetch flight category types for the dropdown list

            $scope.ancillaries.flightCategoryTypes = [];

            if ($scope.hasFlightRequestsByFlightNoSettings) {
              $scope.ancillaries.flightCategoryTypes.push({
                Value: 1,
                Text: 'Flight No.'
              });
            }

            if ($scope.ancillaries.FlightDutyCategories && $scope.ancillaries.FlightDutyCategories.length > 0) {
              $scope.ancillaries.flightCategoryTypes.push({
                Value: 2,
                Text: 'Flight Duty Preference'
              });
            }

            if ($scope.hasFlightRequestsByTimeRangesSettings) {
              $scope.ancillaries.flightCategoryTypes.push({
                Value: 3,
                Text: 'Flight Duty Preference with time limit'
              });
            }
          } else {
            //TODO:: fix message
            showError("Ancillaries not found.");
          }
        } else {
          showError(response.message);
        }
      });
    }
    /**
     * Get Active Requests
     * @memberof RequestsCtrl  
     */


    function getActiveRequests() {
      RequestFactory.getActiveRequests().then(function (response) {
        if (response.success) {
          if (response.data) {
            $scope.activeRequests = response.data;
            $scope.instruction = response.data.QualificationGroupInstruction;
            $scope.showActiveRequests = response.data.FlightRequests.length || response.data.GroundDutyRequests.length || response.data.OtherRequests.length || response.data.OvernightsRequests.length || response.data.ShiftTimeRequests.length;
          } else {
            showError("Something went wrong while fetching your roster requests.");
          }
        } else {
          showError(response.message);
        }
      });
    }

    function getPastRequests() {
      RequestFactory.getPastRequests().then(function (response) {
        if (response.success) {
          if (response.data) {
            $scope.pastRequests = response.data;
            $scope.isHistoryView = true;
            $scope.instruction = response.data.QualificationGroupInstruction;
            $scope.showPastRequests = response.data.FlightRequests.length > 0 || response.data.GroundDutyRequests.length > 0 || response.data.OtherRequests.length > 0 || response.data.OvernightsRequests.length > 0 || response.data.ShiftTimeRequests.length > 0;
          } else {
            showError("Something went wrong while fetching your roster requests.");
          }
        } else {
          showError(response.message);
        }
      });
    }
    /**
     * Displays the error message
     * @memberof RequestsCtrl  
     * @param {string} message message to display
     */


    function showError(message) {
      $scope.contentToShow = "error";
      $scope.errorMessage = message;
    }
    /**
     * Displays the success message
     * @memberof RequestsCtrl
     */


    function showSuccess(message) {
      $scope.contentToShow = "success";
      $scope.successMessage = message;
    }

    function closeAlert() {
      $scope.contentToShow = "";
    }
    /**
     * Checks if the client is online or offline 
     * @memberof RequestsCtrl  
     */


    function checkConnectionStatus() {
      var isOnline = window.navigator.onLine;

      if (isOnline) {
        getAncillaries();
        getActiveRequests();
      } else {
        showError("Please check your internet connection!");
      }
    }
    /**
     * Date to always greater than date from
     * @memberof RequestsCtrl  
     */


    function updateFromValue(dateFrom) {
      $scope.newForm.dateTo = dateFrom;
      $scope.optionsTo = {
        minDate: dateFrom
      };
    }
    /**
     * Date picker limits for the ground duty requests
     * @memberof RequestsCtrl  
    */


    function updateFromValueGD(dateFrom, limitation) {
      $scope.newForm.dateTo = dateFrom;
      $scope.optionsDutyDateTo = {
        initDate: dateFrom,
        minDate: dateFrom,
        maxDate: dateFrom.AddDays(limitation - 1)
      };
    }

    function setFlightRequestType() {
      //[{Value: 1, Text:'Flight No.'}, {Value: 2, Text:'Flight Duty Preference'}, {Value: 3, Text:'Time Limitations'}]
      //$scope.flightRequestType = parseInt($scope.newForm.flightRequestType, 10);
      if ($scope.newForm.flightRequestType != null) {
        $scope.flightRequestType = parseInt($scope.newForm.flightRequestType, 10);
      } else {
        $scope.flightRequestType = null;
      }
    }

    function resetStart() {
      $scope.newForm.afterTime = null;
    }

    function resetEnd() {
      $scope.newForm.beforeTime = null;
    }

    function toggleGroundRequestType() {
      if ($scope.newForm.groundRequestType == 'continuous') {
        $scope.singleDayRequestType = false;
      } else {
        $scope.singleDayRequestType = true;
      }
    }
    /**
     * Opens the request type selected
     * @memberof RequestsCtrl
     */


    function openRequest(inputObject, dutyCode) {
      clearForms();

      if (inputObject == "Flight") {
        $scope.page = 'Flight'; // Preselect "Flight Duty Preference" only when Flight page is opened

        if ($scope.ancillaries.flightCategoryTypes && $scope.ancillaries.flightCategoryTypes.length > 0) {
          $scope.newForm.flightRequestType = "2";
          $scope.flightRequestType = 2;
        }
      } else if (inputObject == "Duty Preference") {
        $scope.page = 'Duty Preference';
      } else if (inputObject == "Overnight") {
        $scope.page = 'Overnight';
      } else if (inputObject == "Other") {
        $scope.page = 'Other';
      } else if (inputObject == "Ground Duty") {
        $scope.page = 'Ground Duty';
        $scope.dutyCode = dutyCode;
      }
    }
    /**
     * Submits the request form
     * @memberof RequestsCtrl
     */


    function submitRequest(inputObject, dutyCode) {
      $scope.submitLoader = true;

      if (inputObject == "Flight" && $scope.flightRequestType != null) {
        var rosterRequest = {
          FlightDate: $scope.newForm.singleDate.toString("yyyy/MM/dd"),
          ReasonId: $scope.newForm.requestReason.Id,
          Comments: $scope.newForm.comments,
          Type: $scope.flightRequestType,
          IsForced: false
        };

        if ($scope.flightRequestType == 1) {
          rosterRequest.FlightNo = $scope.newForm.flightNo;
        } else if ($scope.flightRequestType == 2) {
          rosterRequest.FlightDutyCategoryId = $scope.newForm.flightDuty.Id;
        } else if ($scope.flightRequestType == 3) {
          rosterRequest.afterTime = $scope.newForm.afterTime !== null && $scope.newForm.afterTime !== undefined ? moment($scope.newForm.afterTime) : null;
          rosterRequest.beforeTime = $scope.newForm.beforeTime !== null && $scope.newForm.beforeTime !== undefined ? moment($scope.newForm.beforeTime) : null;
        }

        RequestFactory.sendFlightRequest(rosterRequest).then(function (response) {
          handleSubmitResponse(response, rosterRequest);
        });
      } else if (inputObject == "Ground Duty") {
        //validation with duty limitation
        var trimmedFrom = new Date($scope.newForm.dateFrom);
        var trimmedTo = new Date($scope.newForm.dateTo);
        var diffDays = Date.DifferenceInDays(trimmedFrom.trimTime(), trimmedTo.trimTime());

        if (diffDays > dutyCode.Limitation) {
          //show warning message? : 
          $scope.disableSubmit = true;
        }

        if ($scope.singleDayRequestType) {
          $scope.newForm.dateTo = $scope.newForm.dateFrom;
        }

        var rosterRequest = {
          DutyDateFrom: $scope.newForm.dateFrom.toString("yyyy/MM/dd"),
          DutyDateTo: $scope.newForm.dateTo.toString("yyyy/MM/dd"),
          GroundDuty: dutyCode.Code,
          ReasonId: $scope.newForm.requestReason.Id,
          Comments: $scope.newForm.comments,
          IsForced: false
        };
        RequestFactory.sendGroundRequest(rosterRequest).then(function (response) {
          handleSubmitResponse(response, rosterRequest);
        });
      } else if (inputObject == "Duty Preference") {
        var dateFrom = moment(new Date($scope.newForm.dateFrom));
        var dateTo = moment(new Date($scope.newForm.dateTo)); // Check if the request period is less than one month

        var duration = dateTo.diff(dateFrom, 'days');

        if (duration < 27) {
          var title = "<strong>Warning!</strong>";
          var message = "<strong>Please select a period of at least one month. Requests shorter than one month cannot be processed. <br>Thank you for helping us create a more balanced schedule!</strong><br>";
          bootbox.dialog({
            message: message,
            title: title,
            buttons: {
              cancel: {
                label: "Close",
                className: "btn-default",
                callback: function callback() {
                  $scope.$apply(function () {
                    $scope.submitLoader = false;
                  });
                }
              }
            }
          });
          return;
        } //Disabled after customer request (31.12.2025)
        // // Check if the end date exceeds January 31 of the next year
        // // January 31 of the next year
        // var maxEndDate = moment().endOf('year').add(1, 'months').endOf('day');
        // if (dateTo.diff(maxEndDate, 'seconds') > 0) {
        //     var title = "<strong>Warning!</strong>";
        //     var message = "<strong>End dates beyond January 31 of the following year cannot be accepted.<br> Thank you for helping us keep schedules organized!</strong><br>";
        //     bootbox.dialog({
        //         message: message,
        //         title: title,
        //         buttons: {
        //             cancel: {
        //                 label: "Close",
        //                 className: "btn-default",
        //                 callback: function () { 
        //                     $scope.$apply(function () {
        //                         $scope.submitLoader = false;
        //                     });
        //                 }
        //             }
        //         }
        //     });
        //     return;
        // }


        var rosterRequest = {
          DateFrom: $scope.newForm.dateFrom.toString("yyyy/MM/dd"),
          DateTo: $scope.newForm.dateTo.toString("yyyy/MM/dd"),
          ShiftTimeId: $scope.newForm.shiftTime.Id,
          ReasonId: $scope.newForm.requestReason.Id,
          Comments: $scope.newForm.comments
        };
        RequestFactory.sendShiftRequest(rosterRequest).then(function (response) {
          handleSubmitResponse(response);
        });
      } else if (inputObject == "Overnight") {
        var rosterRequest = {
          DateFrom: $scope.newForm.dateFrom.toString("yyyy/MM/dd"),
          DateTo: $scope.newForm.dateTo.toString("yyyy/MM/dd"),
          Minimum: $scope.newForm.minOvernight,
          Maximum: $scope.newForm.maxOvernight,
          ReasonId: $scope.newForm.requestReason.Id,
          Comments: $scope.newForm.comments
        };
        RequestFactory.sendOvernightRequest(rosterRequest).then(function (response) {
          handleSubmitResponse(response);
        });
      } else if (inputObject == "Other") {
        var rosterRequest = {
          DateFrom: $scope.newForm.dateFrom.toString("yyyy/MM/dd"),
          DateTo: $scope.newForm.dateTo.toString("yyyy/MM/dd"),
          ReasonId: $scope.newForm.requestReason.Id,
          RequestFreeText: $scope.newForm.otherComments
        };
        RequestFactory.sendOtherRequest(rosterRequest).then(function (response) {
          handleSubmitResponse(response);
        });
      }
    }
    /**
     * Handles the response from the API
     * @memberof RequestsCtrl  
     * @param {object} response the response object from API
     */


    function handleSubmitResponse(response, rosterRequest) {
      var responseData = null;

      if (response.data) {
        if (typeof response.data === 'string') {
          try {
            responseData = JSON.parse(response.data);
          } catch (error) {
            LogService.error(error, 'Failed to parse JSON');
          }
        } else {
          responseData = response.data;
        }
      }

      if (rosterRequest && response.success == true && responseData && responseData.success == false) {
        if (responseData.isOverlappingDuty) {
          //bootbox for the overlap warning
          showOverlappingMessage();
        } else if (responseData.periodNotFound) {
          showPeriodNotFoundMessage();
        } else if ($scope.page == "Ground Duty" || $scope.page == "Flight") {
          //bootbox to confirm the forced submit - new submit on confirmed
          forceSubmitRequest(rosterRequest, $scope.page, responseData);
        } else {
          //show error message
          showError('Request submission failed.');
        }
      } else if (response.success == false) {
        //show error message
        showError(response.message);
      } else if (responseData.success == false) {
        //show error message
        showError('Request submission failed.');
      } else {
        //show success message
        showSuccess("Request submited successfully."); //refresh request list!

        getActiveRequests();
      }

      closeForm();
    }
    /**
     * Clears forms
     * @memberof RequestsCtrl
     */


    function clearForms() {
      $scope.newForm = {};

      if ($scope.ancillaries) {
        $scope.newForm.singleDate = $scope.ancillaries.RosterPeriodFrom;
        $scope.newForm.dateFrom = $scope.ancillaries.RosterPeriodFrom;
        $scope.newForm.dateTo = $scope.ancillaries.RosterPeriodTo;
        $scope.singleDayRequestType = true;
        $scope.submitLoader = false;
        $scope.disableSubmit = false;
      }
    }
    /**
     * Closes forms
     * @memberof RequestsCtrl
     */


    function closeForm() {
      clearForms();
      $scope.page = null;
    }
    /**
     * Opens confirmation modal when request is submitted
     * @memberof RequestsCtrl
     */


    function forceSubmitRequest(rosterRequest, type, responseData) {
      var rosterPeriodFrom = moment.utc(responseData.rosterPeriodFrom).format('D MMM YYYY');
      var rosterPeriodTo = moment.utc(responseData.rosterPeriodTo).format('D MMM YYYY');
      var title = "<strong>Warning!</strong>";
      console.log(rosterRequest);
      var message = ""; // Check if the limitation is reached and extra gound duties requests are prevented

      if (responseData.limitationReached && responseData.preventExtraGroundDutyRequests) {
        // Show an error message instead of the management approval option
        message = "<strong>You cannot submit this request as you have reached the maximum allowed ground duty requests limit for this Roster Period.</strong>";
        bootbox.dialog({
          message: message,
          title: title,
          buttons: {
            cancel: {
              label: "Close",
              className: "btn-default",
              callback: function callback() {}
            }
          }
        });
        return;
      } // Check if the limitation is reached and extra flight requests are prevented


      if (responseData.limitationReached && responseData.preventExtraFlightRequests) {
        // Show an error message instead of the management approval option
        message = "<strong>You cannot submit this request as you have reached the maximum allowed flight requests limit for this Roster Period.</strong>";
        bootbox.dialog({
          message: message,
          title: title,
          buttons: {
            cancel: {
              label: "Close",
              className: "btn-default",
              callback: function callback() {}
            }
          }
        });
        return;
      }

      if (responseData.limitationReached) {
        message = message + "<strong>You have exceeded the maximum number of Requests " + "(" + responseData.activeRequests + "/" + responseData.maxLimit + ")" + " for this Roster Period " + "(" + rosterPeriodFrom + " to " + rosterPeriodTo + ")." + "</strong><br>";
      }

      if (responseData.isOverdue == true) {
        message = message + "<strong>The Deadline to submit requests for this Roster Period " + "(" + rosterPeriodFrom + " to " + rosterPeriodTo + ") has passed.</strong><br><br>";
      }

      if (type == "Ground Duty" && responseData.hasDailyLimitation == true) {
        message = message + "<strong>The selected date " + rosterRequest.DutyDate + " has limited Availability. The probability to get your request is low.</strong><br>";
      }

      if (type == "Ground Duty" && responseData.weekendRequestsLimitReached == true) {
        message = message + "<strong>You have exceeded the allowed number of Weekends Requests for this Roster Period " + "(" + rosterPeriodFrom + " to " + rosterPeriodTo + ").</strong><br><br>";
      }

      message = message + " <strong>Your request will be ignored by the system. Do you want to send it for Managment Approval? </strong><br>";
      bootbox.dialog({
        message: message,
        title: title,
        buttons: {
          confirm: {
            label: 'Confirm',
            className: "btn-success",
            callback: function callback() {
              submitForcedRequest(rosterRequest, type);
            }
          },
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          }
        }
      });
    }
    /**
     * Opens a modal with overlapping message
     * @memberof RequestsCtrl
     */


    function showOverlappingMessage() {
      var title = "<strong>Warning!</strong>";
      var message = "<strong>You cannot submit 2 requests for the same date.</strong><br>";
      bootbox.dialog({
        message: message,
        title: title,
        buttons: {
          cancel: {
            label: "Close",
            className: "btn-default",
            callback: function callback() {}
          }
        }
      });
    }
    /**
     * Opens a modal with overlapping message
     * @memberof RequestsCtrl
     */


    function showPeriodNotFoundMessage() {
      var title = "<strong>Warning!</strong>";
      var message = "<strong>You cannot send request for this roster period.</strong><br>";
      bootbox.dialog({
        message: message,
        title: title,
        buttons: {
          cancel: {
            label: "Close",
            className: "btn-default",
            callback: function callback() {}
          }
        }
      });
    }
    /**
     * Submits the forced request
     * @memberof RequestsCtrl
     */


    function submitForcedRequest(rosterRequest, type) {
      if (type == "Flight") {
        rosterRequest.IsForced = true;
        RequestFactory.sendFlightRequest(rosterRequest).then(function (response) {
          handleSubmitResponse(response);
        });
      } else if (type == "Ground Duty") {
        rosterRequest.IsForced = true;
        RequestFactory.sendGroundRequest(rosterRequest).then(function (response) {
          handleSubmitResponse(response);
        });
      }
    }

    function getRejectReason(rejectReasonId) {
      var reasonText = "";

      if (rejectReasonId && $scope.ancillaries) {
        var rejectReason = $scope.ancillaries.RejectReasons.find(function (f) {
          return f.Id == rejectReasonId;
        });

        if (rejectReason) {
          reasonText = rejectReason.Text;
        }
      }

      return reasonText;
    }

    function filterRequest(request) {
      var isShown = false;

      if (request.Id > 0) {
        if (request.StatusText == "FinalAccepted" && $scope.toggle.FinalAccepted) {
          isShown = true;
        } else if ((request.ValidationStatusText == "Validated" && request.StatusText != "FinalAccepted" || request.StatusText == "Accepted" || request.StatusText == "Acknowledged") && $scope.toggle.Accepted) {
          isShown = true;
        } else if (request.StatusText == "Pending" && $scope.toggle.Pending) {
          isShown = true;
        } else if (request.StatusText == "Rejected" && $scope.toggle.Rejected) {
          isShown = true;
        }
      }

      return isShown;
    }

    function getRequestBorderStyle(request) {
      var textclass = "";

      if (request.StatusText == "FinalAccepted") {
        textclass = "border-left-green";
      } else if (request.StatusText == "Accepted") {
        textclass = "border-left-indigo";
      } else if (request.StatusText == "Pending" || request.StatusText == "Acknowledged") {
        textclass = "border-left-light-blue";
      } else if (request.StatusText == "Rejected") {
        textclass = "border-left-red";
      } else {
        textclass = "border-left-blue-gray";
      }

      return textclass;
    }

    function showHelp() {
      $uibModal.open({
        templateUrl: 'views/RosterRequests/dlgRequestInstructions.html',
        controller: 'RequestInstructionsCtrl',
        size: 'lg',
        scope: $scope,
        backdrop: 'static',
        keyboard: false,
        resolve: {}
      });
    }

    function toggleViewMode(elem, className) {
      $('body').find('div#' + elem + ' > div').not('.tip').hide("slow");
      $('body').find('div#' + elem + ' div.' + className).not('.tip').show("slow");
    }
  }
})();
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  'use strict';

  a3_cabin_reports.factory('FlightOrdersFactory', FlightOrdersFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name FlightOrdersFactory
  * @description 
  * Get selected flight info
  * @ngInject
  */

  function FlightOrdersFactory($http, apiUrl, GenericService, CabinReportLocalEditFactory, $injector, PaxInfoFactory, FlightFactory) {
    var service = {
      getFlightOrders: getFlightOrders,
      //getFlightOrdersByFlightIdFromLS: getFlightOrdersByFlightIdFromLS, //use getFlightOrdersFlattenedByFlightId
      upsertFlightOrders: upsertFlightOrders,
      cleanOldDataFlightOrders: cleanOldDataFlightOrders,
      getFlightOrdersForCreateReportByFlightId: getFlightOrdersForCreateReportByFlightId,
      getFlightOrdersFlattenedByFlightId: getFlightOrdersFlattenedByFlightId,
      getNotDeliveredReasons: getNotDeliveredReasons,
      saveOrUpdateCabinReport: saveOrUpdateCabinReport,
      setFlightOrders: setFlightOrders
    };
    /**
    * Initialize the FlightOrder 
    * @memberof FlightOrdersFactory
    */

    function FlightOrder() {
      this.FlightId = null;
      this.FlightDate = null;
      this.FlightNumber = null;
      this.DepartureAirport = null;
      this.Orders = null;
    }

    var objFlightOrder = 'flightOrders';
    var objFlightOrderCallback = FlightOrder;
    /**
     * Save flight orders
     * @memberof FlightOrdersFactory
     * @param {Array} flight orders
     */

    function setFlightOrders(orders) {
      // Validate and filter orders
      var validOrders = orders.filter(function (order) {
        return order && order.FlightId;
      }); // Save orders using GenericService

      GenericService.saveAll(validOrders, objFlightOrder);
    }
    /**
     * Get Event Types
     * @memberof FlightOrdersFactory
     * @returns {Array} flight orders 
     */


    function getFlightOrders() {
      // Retrieve orders from GenericService
      var storedOrders = GenericService.list(objFlightOrder, objFlightOrderCallback); // Filter valid orders

      return storedOrders ? storedOrders.filter(function (order) {
        return order && order.FlightId;
      }) : [];
    }

    function getFlightOrdersFlattenedByFlightId(flightId) {
      // Retrieve stored orders
      var storedOrders = getFlightOrders(); // Retrieve the current report

      var report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId); // If a report exists, use its orders as the source of truth

      if (report && report.FlightOrders) {
        return {
          FlightId: flightId,
          Orders: report.FlightOrders.Orders
        };
      } // Fallback to stored orders


      if (storedOrders) {
        var allOrdersForTheFlight = storedOrders.filter(function (x) {
          return x.FlightId == flightId;
        });
        var flattenedOrders = allOrdersForTheFlight.reduce(function (acc, flightOrder) {
          return acc.concat(flightOrder.Orders);
        }, []);
        return {
          FlightId: flightId,
          Orders: flattenedOrders
        };
      }

      return null; // No data available
    }

    function upsertFlightOrders(orders, responseFlightIds) {
      responseFlightIds.forEach(function (flightId) {
        //Find SeatNo from seatMap
        PaxInfoFactory.getPaxInfoList(flightId, function (passengerList) {
          //console.log(orders);
          if (passengerList && orders) {
            orders.forEach(function (flightOrder) {
              if (flightOrder.Orders) {
                flightOrder.Orders.forEach(function (order) {
                  if (order) {
                    var matchedPassenger = passengerList.filter(function (x) {
                      return x.PNR == order.Passenger.PNR && x.Fullname.toUpperCase().includes(order.Passenger.FirstName.toUpperCase());
                    });

                    if (matchedPassenger && matchedPassenger.length > 0) {
                      order.Passenger.Seat = matchedPassenger[0].SeatNo;
                    }
                  }
                });
              }
            });
          } //store to localdb


          var storedOrders = getFlightOrders();

          if (storedOrders) {
            var otherOrders = storedOrders.filter(function (x) {
              return !responseFlightIds.includes(x.FlightId);
            });
            var mergeEvents = otherOrders.concat(orders);
            setFlightOrders(mergeEvents);
          } else {
            setFlightOrders(orders);
          }
        });
      });
    }

    function cleanOldDataFlightOrders(responseFlightIds) {
      var storedOrders = getFlightOrders();

      if (storedOrders) {
        // Filter out null or invalid entries before proceeding
        var validStoredOrders = storedOrders.filter(function (order) {
          return order && order.FlightId;
        });
        var previousOrders = validStoredOrders.filter(function (x) {
          return responseFlightIds.includes(x.FlightId);
        });
        setFlightOrders(previousOrders);
      }
    }

    function getFlightOrdersForCreateReportByFlightId(flightId) {
      var flightOrders = null;
      var flightOrdersLS = getFlightOrdersFlattenedByFlightId(flightId);

      if (flightOrdersLS) {
        flightOrdersLS.Orders.forEach(function (order) {
          //add report properties
          if (order) {
            order.Status = 'Pending';
            order.Feedback = '';
            order.Reason = ''; //for the photo modal

            order.Photos = [];
            order.Label = 'Shop In The Cloud';
          }
        });
        flightOrders = flightOrdersLS;
      }

      return flightOrders;
    }

    function getNotDeliveredReasons() {
      return ['Pax no-show', 'Pax refused to receive', 'Wrong/incomplete order', 'Damaged/Defective product/s', 'Order not loaded'];
    }

    function saveOrUpdateCabinReport(flightId, flattenedOrders) {
      try {
        var report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId); // Check if the flight status is pending or pending overdue

        var flight = FlightFactory.getFlightFromStorage(flightId);

        if (!flight) {
          return;
        }

        if (flight.LineStatus === 'pending' || flight.LineStatus === 'pendingoverdue') {
          var CabinReportLocalEditCreatorFactory = $injector.get('CabinReportLocalEditCreatorFactory');
          report = CabinReportLocalEditCreatorFactory.createNewLocalReportForFlight(flightId);
          report.Status = 'draft'; // Save the report using a method on the report object if it exists

          if (report.saveReport) {
            report.saveReport();
          } // Update the flight with details from the new report


          FlightFactory.updateFlightFromReport(report);
        } // Merge stored and updated orders


        var allOrders = flattenedOrders.Orders.map(function (order) {
          var existingOrder = report && report.FlightOrders && report.FlightOrders.Orders ? report.FlightOrders.Orders.find(function (o) {
            return o.OrderNumber === order.OrderNumber;
          }) : null;
          return existingOrder ? _objectSpread({}, existingOrder, {}, order) : order;
        });

        if (!report.FlightOrders) {
          report.FlightOrders = {
            Orders: []
          };
        }

        report.FlightOrders.Orders = allOrders; // Save report to local storage

        CabinReportLocalEditFactory.setCabinReportToStorage(report); // Verify that the report was saved

        var savedReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId); // Sync with Flight Orders Storage

        setFlightOrders([{
          FlightId: flightId,
          Orders: allOrders
        }]);
      } catch (error) {
        console.error("Error in saveOrUpdateCabinReport:", error);
      }
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('OrderFormModalCtrl', OrderFormModalCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name OrderFormModalCtrl
   * @description 
   * Manages the Order Form Modal
   * @ngInject
   */

  function OrderFormModalCtrl($scope, $uibModalInstance, orderDetails, report, $routeParams, FlightOrdersFactory, CabinReportLocalEditFactory, $uibModal) {
    var flightId = parseInt($routeParams.flightId, 10); // Explicit conversion to number
    // Initialize scope variables

    $scope.order = orderDetails;
    $scope.orderNumber = orderDetails.OrderNumber;
    $scope.orderStatus = orderDetails.Status;
    $scope.feedback = orderDetails.Feedback || '';
    $scope.reason = orderDetails.Reason || null;
    $scope.photo = orderDetails.Photos || [];
    $scope.reasonError = false;
    $scope.handleReasonError = handleReasonError;
    $scope.cancel = cancel;
    $scope.save = save;
    $scope.viewPhoto = viewPhoto;
    $scope.openPhotoModal = openPhotoModal; // Function to handle errors in reason selection

    function handleReasonError(selectedReason) {
      if (selectedReason) {
        $scope.reason = selectedReason;
        $scope.reasonError = false;
      }
    }

    $scope.changeOrderStatus = function (status) {
      $scope.orderStatus = status; // Update the status

      if (status === 'Delivered') {
        $scope.reasonError = false; // Clear error

        $scope.reason = ''; // Reset reason

        $scope.feedback = ''; // Reset feedback
      } else if (status === 'Not Delivered') {
        $scope.reasonError = false; // Clear error

        $scope.reason = ''; // Reset reason

        $scope.feedback = ''; // Reset feedback
      }
    }; // Function to view the attached photo


    function viewPhoto(photo) {
      if (photo && photo.PhotoData) {
        window.open(photo.PhotoData, '_blank');
      }
    } // Attach or replace photo logic


    $scope.attachPhoto = function () {
      // Ensure the `Photos` array exists in the order object
      if (!$scope.order.Photos) {
        $scope.order.Photos = []; // Initialize an empty array if it doesn't exist
      } // Directly open the photo modal without asking for confirmation


      openPhotoModal(); // Function to open the photo modal

      function openPhotoModal() {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Dialogs/dlgItemPhotos.html',
          controller: 'ItemPhotosCtrl',
          size: 'md',
          resolve: {
            item: function item() {
              return $scope.order; // Pass the entire `Order` object to the modal
            }
          }
        }); // Handle the result from the modal

        modalInstance.result.then(function () {}, function () {});
      }
    };

    function openPhotoModal() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgItemPhotos.html',
        controller: 'ItemPhotosCtrl',
        size: 'md',
        windowClass: 'custom-modal-class',
        resolve: {
          item: function item() {
            return $scope.order; // Pass the Order object
          }
        }
      }); // Handle the result from the modal

      modalInstance.result.then(function (updatedItem) {
        if (updatedItem && updatedItem.Photos) {
          $scope.order.Photos = updatedItem.Photos; // Update the Photos array
        }
      }, function () {
        console.log("Photo modal dismissed.");
      });
    } // Save order logic


    function save() {
      // Validate reason if the status is "Not Delivered"
      if ($scope.orderStatus === 'Not Delivered' && !$scope.reason) {
        $scope.reasonError = true;
        return;
      } // Update order details


      var updatedOrder = {
        OrderNumber: $scope.orderNumber,
        Status: $scope.orderStatus || 'Pending',
        Feedback: $scope.feedback || '',
        Reason: $scope.reason || '',
        Photos: $scope.order.Photos || []
      }; // Update flattened orders

      var flattenedOrders = FlightOrdersFactory.getFlightOrdersFlattenedByFlightId(flightId);
      var existingOrder = flattenedOrders.Orders.find(function (order) {
        return order.OrderNumber === updatedOrder.OrderNumber;
      });

      if (existingOrder) {
        Object.assign(existingOrder, updatedOrder);
      } else {
        flattenedOrders.Orders.push(updatedOrder);
      }

      FlightOrdersFactory.saveOrUpdateCabinReport(flightId, flattenedOrders); // Sync with the local report

      var report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight($scope.flightId);

      if (report) {
        if (!report.FlightOrders || !Array.isArray(report.FlightOrders.Orders)) {
          report.FlightOrders = {
            Orders: []
          };
        }

        var reportOrder = report.FlightOrders.Orders.find(function (o) {
          return o.OrderNumber === updatedOrder.OrderNumber;
        });

        if (reportOrder) {
          Object.assign(reportOrder, updatedOrder);
        } else {
          report.FlightOrders.Orders.push(updatedOrder);
        }

        report.updateTotals();
        report.saveReport();
      } // Close the modal


      $uibModalInstance.close(updatedOrder);
    } // Cancel the modal


    function cancel() {
      $uibModalInstance.close(false);
    }

    $scope.deletedPhoto = null; // Store the last deleted photo temporarily

    $scope.deletedPhotoIndex = null; // Store the index of the deleted photo
    // Function to delete a photo

    $scope.deletePhoto = function (index) {
      $scope.deletedPhoto = $scope.order.Photos[index]; // Save the deleted photo

      $scope.deletedPhotoIndex = index; // Save the index

      $scope.order.Photos.splice(index, 1); // Remove the photo
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('passengerShopOrders', passengerShopOrders);
  /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name passengerShopOrders
   * @restrict E
   * @description
   *   Manages the shop order for a single passenger
   * @example
   *   Usage:
   *   <passenger-shop-orders></passenger-shop-orders>
   * @ngInject
   */

  function passengerShopOrders($timeout, FlightOrdersFactory, CabinReportLocalEditFactory, $uibModal) {
    function link($scope) {
      function getOrdersForThePassenger(flightId, passenger) {
        $scope.passengerOrder = null;
        $scope.noOrdersAvailable = false; // Retrieve cabin report

        var report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId); // Use report data if available

        if (report && report.FlightOrders && report.FlightOrders.Orders) {
          var reportOrder = report.FlightOrders.Orders.find(function (o) {
            return o.Passenger && o.Passenger.PNR === passenger.PNR && o.Passenger.LastName === passenger.Surname && o.Passenger.FirstName === passenger.GivenName;
          });

          if (reportOrder) {
            $scope.passengerOrder = {
              OrderNumber: reportOrder.OrderNumber,
              OrderStatus: reportOrder.Status || "Pending",
              Feedback: reportOrder.Feedback || '',
              Reason: reportOrder.Reason || '',
              Photos: reportOrder.Photos || [],
              Items: reportOrder.Items && reportOrder.Items.map(function (item) {
                return {
                  Title: item.Title,
                  Quantity: item.Quantity
                };
              }) || [],
              ReasonError: false
            };
            return;
          }
        } // Fallback to FlightOrdersFactory data


        var flattenedOrders = FlightOrdersFactory.getFlightOrdersFlattenedByFlightId(flightId);

        if (flattenedOrders && flattenedOrders.Orders) {
          var matchingOrder = flattenedOrders.Orders.find(function (order) {
            return order.Passenger && order.Passenger.PNR === passenger.PNR && order.Passenger.LastName === passenger.Surname && order.Passenger.FirstName === passenger.GivenName;
          });

          if (matchingOrder) {
            $scope.passengerOrder = {
              OrderNumber: matchingOrder.OrderNumber,
              OrderStatus: matchingOrder.Status || "Pending",
              Feedback: matchingOrder.Feedback || '',
              Reason: matchingOrder.Reason || '',
              Photos: matchingOrder.Photos || [],
              Items: matchingOrder.Items && matchingOrder.Items.map(function (item) {
                return {
                  Title: item.Title,
                  Quantity: item.Quantity
                };
              }) || [],
              ReasonError: false
            };
          } else {
            $scope.noOrdersAvailable = true;
          }
        } else {
          $scope.noOrdersAvailable = true;
        }
      } // Initial call to populate orders


      getOrdersForThePassenger($scope.flight.FlightId, $scope.passenger); // Change Order Status

      $scope.changeOrderStatus = function (status) {
        $scope.passengerOrder.OrderStatus = status;

        if (status === 'Delivered') {
          $scope.passengerOrder.ReasonError = false;
          $scope.passengerOrder.Reason = '';
          $scope.passengerOrder.Feedback = '';
        } else if (status === 'Not Delivered') {
          $scope.passengerOrder.ReasonError = false;
          $scope.passengerOrder.Reason = '';
          $scope.passengerOrder.Feedback = '';
        }
      }; // Validate Reason


      $scope.validateReason = function () {
        $scope.passengerOrder.ReasonError = !$scope.passengerOrder.Reason;
      }; // Attach a Photo


      $scope.attachPhoto = function () {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Dialogs/dlgItemPhotos.html',
          controller: 'ItemPhotosCtrl',
          size: 'md',
          resolve: {
            item: function item() {
              return $scope.passengerOrder;
            }
          }
        });
        modalInstance.result.then(function (updatedOrder) {
          if (updatedOrder && updatedOrder.Photos) {
            $scope.passengerOrder.Photos = updatedOrder.Photos;
          }
        });
      }; // Delete a Photo


      $scope.deletePhoto = function (index) {
        $scope.passengerOrder.Photos.splice(index, 1);
      }; // Save Order


      $scope.saveOrder = function () {
        if ($scope.passengerOrder.OrderStatus === 'Not Delivered' && !$scope.passengerOrder.Reason) {
          $scope.passengerOrder.ReasonError = true;
          return;
        }

        var updatedOrder = {
          OrderNumber: $scope.passengerOrder.OrderNumber,
          Status: $scope.passengerOrder.OrderStatus,
          Feedback: $scope.passengerOrder.Feedback,
          Reason: $scope.passengerOrder.Reason,
          Photos: $scope.passengerOrder.Photos
        };
        var flattenedOrders = FlightOrdersFactory.getFlightOrdersFlattenedByFlightId($scope.flight.FlightId);
        var existingOrder = flattenedOrders.Orders.find(function (o) {
          return o.OrderNumber === updatedOrder.OrderNumber;
        });

        if (existingOrder) {
          Object.assign(existingOrder, updatedOrder);
        } else {
          flattenedOrders.Orders.push(updatedOrder);
        }

        FlightOrdersFactory.saveOrUpdateCabinReport($scope.flight.FlightId, flattenedOrders);
        var report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight($scope.flight.FlightId);

        if (report) {
          var reportOrder = report.FlightOrders.Orders.find(function (o) {
            return o.OrderNumber === updatedOrder.OrderNumber;
          });

          if (reportOrder) {
            Object.assign(reportOrder, updatedOrder);
          } else {
            report.FlightOrders.Orders.push(updatedOrder);
          }

          report.updateTotals();
          report.saveReport();
        } // Close the modal


        if ($scope.modalInstance) {
          $scope.modalInstance.close($scope.passengerOrder);
        }
      };

      $scope.cancelOrder = function () {
        if ($scope.modalInstance) {
          $scope.modalInstance.dismiss('cancel');
        }
      };
    }

    return {
      restrict: 'E',
      templateUrl: 'views/ShopInTheCloud/passengerShopOrders.tpl.html',
      scope: {
        flight: '=',
        passenger: '=',
        modalInstance: '=',
        orderAvailability: '&onOrderAvailability'
      },
      link: link
    };
  }
})();
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  'use strict';

  a3_cabin_reports.directive('shopInTheCloud', shopInTheCloud);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name shopInTheCloud
  * @restrict E
  * @description
  *   Implementation of shopInTheCloud panel
  * @example
  *   Usage:
  *   <shop-in-the-cloud></shop-in-the-cloud>
  * @ngInject
  */

  function shopInTheCloud(FlightOrdersFactory, $sce, $uibModal, CabinReportLocalEditFactory, SettingsMain) {
    function link(scope, element, attributes) {
      scope.IsShopInTheCloudEnable = SettingsMain.getIsShopInTheCloudEnable();
      scope.showShopInTheCloudPanel = scope.IsShopInTheCloudEnable && scope.flight.LineStatus != 'na' && scope.flight.LineStatus != 'stored';
      scope.openOrder = openOrder; //get from LS the events & the types

      getOrdersForTheFlight(scope.flightId);

      function getOrdersForTheFlight(flightId) {
        scope.showPanel = null; // Retrieve the report first

        var report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);

        if (report && report.FlightOrders && report.FlightOrders.Orders) {
          // Use report orders as the source of truth
          scope.flattenedOrders = {
            FlightId: flightId,
            Orders: report.FlightOrders.Orders.map(function (order) {
              return _objectSpread({}, order, {
                Status: order.Status || "Pending",
                Feedback: order.Feedback || '',
                Reason: order.Reason || '',
                Photos: order.Photos || []
              });
            })
          };
        } else {
          // Fallback to stored orders if no report exists
          scope.flattenedOrders = FlightOrdersFactory.getFlightOrdersFlattenedByFlightId(flightId); // Set defaults for orders if retrieved from storage

          if (scope.flattenedOrders && scope.flattenedOrders.Orders) {
            scope.flattenedOrders.Orders.forEach(function (order) {
              order.Status = order.Status || "Pending";
              order.Feedback = order.Feedback || '';
              order.Reason = order.Reason || '';
              order.Photos = order.Photos || [];
            });
          }
        }
      }

      function openOrder(orderNumber) {
        // Find the order object by order number
        var order = scope.flattenedOrders.Orders.find(function (o) {
          return o.OrderNumber === orderNumber;
        });
        var modalInstance = $uibModal.open({
          templateUrl: 'views/ShopInTheCloud/dlgOrderForm.html',
          controller: 'OrderFormModalCtrl',
          backdrop: 'static',
          keyboard: false,
          size: 'md',
          resolve: {
            orderDetails: function orderDetails() {
              return angular.copy(order);
            },
            report: function report() {
              return CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(scope.flightId); // Pass the report
            }
          }
        });
        modalInstance.result.then(function (updatedOrder) {
          if (updatedOrder) {
            // Update the specific order in flattenedOrders
            var orderToUpdate = scope.flattenedOrders.Orders.find(function (o) {
              return o.OrderNumber === updatedOrder.OrderNumber;
            });

            if (orderToUpdate) {
              Object.assign(orderToUpdate, updatedOrder); // Merge changes into the flattened order
            } else {
              scope.flattenedOrders.Orders.push(updatedOrder); // Add new order
            }

            FlightOrdersFactory.setFlightOrders([{
              FlightId: scope.flightId,
              Orders: scope.flattenedOrders.Orders
            }]); // Find and update the corresponding order in the report

            var report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(scope.flightId);

            if (report) {
              if (!report.FlightOrders || !Array.isArray(report.FlightOrders.Orders)) {
                report.FlightOrders = {
                  Orders: []
                };
              }

              var reportOrder = report.FlightOrders.Orders.find(function (o) {
                return o.OrderNumber === updatedOrder.OrderNumber;
              });

              if (reportOrder) {
                Object.assign(reportOrder, updatedOrder); // Merge changes into the report order
              } else {
                // Add the order if it doesn't exist in the report
                report.FlightOrders.Orders.push(updatedOrder);
              } // Save the updated report


              report.updateTotals();
              report.saveReport();
            } else {
              console.error("Report not found for flight:", scope.flightId);
            }
          }
        }, function () {
          console.log("Order modal dismissed.");
        });
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/ShopInTheCloud/shopInTheCloud.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('FatigueCtrl', FatigueCtrl);

  function FatigueCtrl($scope, $routeParams, FlightFactory, $location, SafetyReportFactory, $timeout) {
    var flightId = $routeParams.flightId;
    var flight = FlightFactory.getFlightFromStorage(flightId);
    $scope.flight = flight;
    $scope.responseMessage = "";
    $scope.showPanel = "submit";
    $scope.operationalPhasesOptions = ['Parked', 'Pushback', 'Taxi-Out', 'Take-Off', 'Climb', 'Cruise', 'Descent', 'Approach', 'Landing', 'Taxi-In'];
    $scope.rateFeltOptions = ['Fully Alert - wide awake', 'Very Lively - responsive, but not at peak', 'OK - somewhat fresh', 'A Little Tired - less than fresh', 'Moderately Tired - let down'];
    $scope.signsPhysicalOptions = ['No physical signs noted ', 'Fidgeting', 'Rubbing eyes', 'Heavy eyelids', 'Yawning', 'Frequent blinking', 'Staring blankly', 'Long blinks', 'Difficulty keeping eyes open', 'Head nodding', 'Micro-sleeps', 'Unintentional sleeps'];
    $scope.signsCognitiveOptions = ['No cognitive signs noted', 'Impaired attention', 'Difficulty concentrating', 'Impaired memory', 'Reduced communication', 'Impaired problem solving', 'Increased risk taking', 'Impaired situational awareness', 'Accidentally doing the wrong thing (error)', 'Accidentally not doing the right thing (omission)', 'Failure to anticipate the event or action'];
    $scope.signsEmotionalOptions = ['No emotional signs', 'More quiet or withdrawn than usual', 'Lacking in energy', 'Lacking in motivation to do the task well', 'Negative mood', 'Irritable or grumpy behavior'];
    $scope.counterMeasuresOptions = ['Controlled rest', 'Caffeine', 'Use of automationy', 'Change of controls', 'Turn up the lights', 'Food, drink', 'Increased checks', 'Workload share', 'Increased communication', 'Inform a colleague'];
    $scope.hours24Options = Array.from({
      length: 21
    }, function (_, i) {
      return i;
    }); // Generates an array with values from 0 to 20

    $scope.hoursAwakeOptions = Array.from({
      length: 21
    }, function (_, i) {
      return i;
    }); // Generates an array with values from 0 to 20

    $scope.formData = {
      flightId: $routeParams.flightId,
      flightNo: flight.FlightNo,
      flightDate: flight.ScheduledDeparture,
      flightDep: flight.Departure,
      flightArr: flight.Arrival,
      flightRegistration: flight.AcTailNo,
      occurenceTitle: "",
      description: "",
      // attachedFiles: [],
      operationalPhase: "",
      rateFelt: "",
      signsPhysical: [],
      signsCognitive: [],
      signsEmotional: [],
      hours24: "",
      hoursAwake: "",
      rateFeltSecond: "",
      counterMeasures: []
    };

    $scope.toggleSelection = function (option, signs) {
      var idx = signs.indexOf(option);

      if (idx > -1) {
        signs.splice(idx, 1);
      } else {
        signs.push(option);
      }
    };

    $scope.isChecked = function (option, signs) {
      return signs.indexOf(option) > -1;
    };

    $scope.getSelectedOptionsText = function (signs) {
      if (signs.length === 0) {
        return "- Select options -";
      }

      return signs.join(', ');
    };

    $scope.isRequiredFieldEmpty = function (field) {
      return !field.length;
    };

    $scope.sizeLimitKb = 25000;
    $scope.fileTooLargeMsg = false;
    $scope.confirmCreateFatigueReport = confirmCreateFatigueReport;
    $scope.fileUploaded = fileUploaded;
    $scope.removeFile = removeFile;
    $scope.isIFileTooLarge = isFileTooLarge;
    $scope.submitFatigueReport = submitFatigueReport;
    $scope.sendFatigueReport = sendFatigueReport;
    $scope.submitted = false;

    function gotoFlightInfo(flightId) {
      $location.path('/flightinfo/' + flightId);
    }

    function submitFatigueReport() {
      if ($scope.fatigueReport.$valid) {
        confirmCreateFatigueReport();
      } else {
        bootbox.alert("Please fill in all the required fields.");
      }
    }

    function confirmCreateFatigueReport() {
      bootbox.dialog({
        message: "<strong>Would you like to proceed with the Fatigue Report?</strong><br/><br/>",
        title: "Send Report",
        buttons: {
          confirm: {
            label: 'Confirm',
            className: "btn-success",
            callback: function callback() {
              $scope.showPanel = "loading";
              SafetyReportFactory.saveFatigueReport($scope.formData).then(function (res) {
                return handleSubmitResponse(res);
              });
            }
          },
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          }
        }
      });
    }

    function handleSubmitResponse(res) {
      var alertStyle = res.success ? "success" : "warning";
      bootbox.dialog({
        message: "<div class='alert alert-" + alertStyle + "'><strong>" + res.message + " </strong></div>",
        title: "Response Message",
        buttons: {
          cancel: {
            label: "Close",
            className: "btn-default",
            callback: function callback() {
              if (res.success) {
                $timeout(gotoFlightInfo(flightId));
              } else {
                $timeout($scope.showPanel = "submit");
              }
            }
          }
        }
      });
    }

    function sendFatigueReport(formData) {
      $scope.submitted = true;

      if ($scope.fatigueReport.$valid && !$scope.isRequiredFieldEmpty(formData.signsPhysical) && !$scope.isRequiredFieldEmpty(formData.signsCognitive) && !$scope.isRequiredFieldEmpty(formData.signsEmotional)) {
        createFatigueReport();
      } else {
        bootbox.alert("Please fill in all the required fields.");
      }
    }

    function createFatigueReport() {
      bootbox.dialog({
        message: "<strong>Would you like to send the Fatigue Report?</strong><br/><br/>",
        title: "Send Report",
        buttons: {
          confirm: {
            label: 'Confirm',
            className: "btn-success",
            callback: function callback() {
              $scope.showPanel = "loading";
              SafetyReportFactory.emailFatigueReport($scope.formData).then(function (res) {
                return handleSubmitResponse(res);
              });
            }
          },
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          }
        }
      });
    }

    function isFileTooLarge(image) {
      var isLarge = false;

      if (image && image.dataURL != null) {
        isLarge = image.dataURL.length > $scope.sizeLimitKb * 1024;
      }

      return isLarge;
    }

    function fileUploaded(data) {
      var fileResult = data; //$scope.imageBrowsed;

      var uploadedFile = {};
      uploadedFile.fileBlobb = fileResult.dataURL;
      uploadedFile.description = fileResult.fileType || fileResult.file.type;
      uploadedFile.fileName = fileResult.fileName; // var files = $scope.formData.attachedFiles;

      if ($scope.formData.attachedFiles.length < 5) {
        // var n = Object.create(attachedFile);
        $scope.formData.attachedFiles.push(uploadedFile);
      } else {
        $scope.showMaxFiles = true;
      }
    }

    function removeFile(attachedFile) {
      var files = $scope.formData.attachedFiles;
      var arrayLenght = files.length;
      var itemIndex = -1;

      for (var i = 0; i < arrayLenght; i++) {
        if (files[i].fileName == attachedFile.fileName) {
          itemIndex = i;
          break;
        }
      }

      if (itemIndex >= 0) {
        files.splice(itemIndex, 1);
        return attachedFile;
      }

      if ($scope.showMaxImages) {
        appendPhoto();
      }

      $scope.showMaxImages = false;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('SafetyCtrl', SafetyCtrl);

  function SafetyCtrl($scope, operationalPhases, $timeout, $routeParams, FlightFactory, $location, SafetyReportFactory) {
    var flightId = $routeParams.flightId;
    var flight = FlightFactory.getFlightFromStorage(flightId);
    $scope.flight = flight;
    $scope.operationalPhases = angular.fromJson(operationalPhases);
    $scope.responseMessage = "";
    $scope.showPanel = "submit";
    $scope.formData = {
      flightId: $routeParams.flightId,
      flightNo: flight.FlightNo,
      flightDate: flight.ScheduledDeparture,
      flightDep: flight.Departure,
      flightArr: flight.Arrival,
      flightRegistration: flight.AcTailNo,
      occurenceTitle: "",
      description: "",
      selectedPhase: "",
      attachedFiles: [],
      isConfidential: false
    };
    $scope.sizeLimitKb = 25000;
    $scope.fileTooLargeMsg = false;
    $scope.fileUploaded = fileUploaded;
    $scope.removeFile = removeFile;
    $scope.isIFileTooLarge = isFileTooLarge;
    $scope.submitForm = submitForm;

    function gotoFlightInfo(flightId) {
      $location.path('/flightinfo/' + flightId);
    }

    function submitForm() {
      if ($scope.formCabinReport.$valid) {
        confirmCreateReport(); //console.log($scope.formData.attachedFiles);        
      } else {
        bootbox.alert("Please fill in all the required fields.");
      }
    }

    function confirmCreateReport() {
      bootbox.dialog({
        message: "<strong>Would you like to proceed with the Safety Report?</strong><br/><br/>",
        title: "Send Report",
        buttons: {
          confirm: {
            label: 'Confirm',
            className: "btn-success",
            callback: function callback() {
              $scope.showPanel = "loading";
              SafetyReportFactory.saveSafetyReport($scope.formData).then(function (res) {
                return handleSubmitResponse(res);
              });
            }
          },
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          }
        }
      });
    }

    function handleSubmitResponse(res) {
      var alertStyle = res.success ? "success" : "warning";
      bootbox.dialog({
        message: "<div class='alert alert-" + alertStyle + "'><strong>" + res.message + " </strong></div>",
        title: "Response Message",
        buttons: {
          cancel: {
            label: "Close",
            className: "btn-default",
            callback: function callback() {
              if (res.success) {
                $timeout(gotoFlightInfo(flightId));
              } else {
                $timeout($scope.showPanel = "submit");
              }
            }
          }
        }
      });
    }

    function isFileTooLarge(image) {
      var isLarge = false;

      if (image && image.dataURL != null) {
        isLarge = image.dataURL.length > $scope.sizeLimitKb * 1024;
      }

      return isLarge;
    }

    function fileUploaded(data) {
      var fileResult = data; //$scope.imageBrowsed;

      var uploadedFile = {};

      if (isFileTooLarge(data)) {
        $scope.fileTooLargeMsg = true;
      } else {
        $scope.fileTooLargeMsg = false;
        uploadedFile.fileBlobb = fileResult.dataURL;
        uploadedFile.description = fileResult.fileType || fileResult.file.type;
        uploadedFile.fileName = fileResult.fileName; // var files = $scope.formData.attachedFiles;

        if ($scope.formData.attachedFiles.length < 5) {
          // var n = Object.create(attachedFile);
          $scope.formData.attachedFiles.push(uploadedFile);
        } else {
          $scope.showMaxFiles = true;
        }
      }
    }

    function removeFile(attachedFile) {
      var files = $scope.formData.attachedFiles;
      var arrayLenght = files.length;
      var itemIndex = -1;

      for (var i = 0; i < arrayLenght; i++) {
        if (files[i].fileName == attachedFile.fileName) {
          itemIndex = i;
          break;
        }
      }

      if (itemIndex >= 0) {
        files.splice(itemIndex, 1);
        return attachedFile;
      }

      if ($scope.showMaxImages) {
        appendPhoto();
      }

      $scope.showMaxImages = false;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('SafetyReportFactory', SafetyReportFactory);

  function SafetyReportFactory($http, apiUrl) {
    var submitResponseObj = {
      success: false,
      message: ''
    };
    var service = {
      saveSafetyReport: saveSafetyReport,
      saveFatigueReport: saveFatigueReport,
      emailFatigueReport: emailFatigueReport
    };

    function saveSafetyReport(safetyReport) {
      var aqdBaseURL = apiUrl + '/SafetyReports/SaveSafetyReport';
      return $http.post(aqdBaseURL, safetyReport, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }

    function saveFatigueReport(fatigueReport) {
      var aqdBaseURL = apiUrl + '/SafetyReports/SaveFatigueReport';
      return $http.post(aqdBaseURL, fatigueReport, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getFatigueResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }

    function getResponse(res) {
      submitResponseObj.success = res.data.success;

      if (res.data.success) {
        submitResponseObj.message = "Safety Report Submited successfully";
      } else {
        submitResponseObj.message = res.data.errorMessage;
      }

      return submitResponseObj;
    }

    function getResponseFailed(res) {
      submitResponseObj.success = false;
      submitResponseObj.message = "Something went wrong!";
      return submitResponseObj;
    }

    function emailFatigueReport(fatigueReport) {
      var aqdBaseURL = apiUrl + '/SafetyReports/EmailFatigueReport';
      return $http.post(aqdBaseURL, fatigueReport, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getFatigueResponse(res);
      })["catch"](function (res) {
        return getFatigueResponseFailed(res);
      });
    }

    function getFatigueResponse(res) {
      submitResponseObj.success = res.data.success;

      if (res.data.success) {
        submitResponseObj.message = "Fatigue Report sent successfully.";
      } else {
        submitResponseObj.message = res.data.errorMessage;
      }

      return submitResponseObj;
    }

    function getFatigueResponseFailed(res) {
      submitResponseObj.success = false;
      submitResponseObj.message = "Something went wrong!";
      return submitResponseObj;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.service("InfoAPIService", InfoAPIService);
  /**
  * @memberof CabinReports
  * @ngdoc service
  * @name InfoAPIService
  * @description 
  *  Information service which gets latest pax and gate data
  * @ngInject
  */

  function InfoAPIService($http, $q, apiUrl, LogService, UserFactory, SyncAPIService, FlightFactory, PaxInfoFactory, AircaftPositionsFactory, GroundDutyFactory, CampaignFactory, LuggageComplianceFactory, FlightCheckInsFactory, PhiloxeniaQuestionsFactory, FlightDelaysFactory, CustomerEventHistoryFactory, JeppesenFlightDetailsFactory) {
    return {
      getPax: getPax,
      sendCustomerIncident: sendCustomerIncident,
      refreshCrewRoute: refreshCrewRoute,
      updateCrewRouteStatusSetter: updateCrewRouteStatusSetter,
      updateFlightStatusSetter: updateFlightStatusSetter,
      updateGroundStatusSetter: updateGroundStatusSetter,
      updateStatusSetter: updateStatusSetter,
      updateFlightLocalStorage: updateFlightLocalStorage,
      updateGroundDutyLocalStorage: updateGroundDutyLocalStorage,
      updateCrewCheckIn: updateCrewCheckIn,
      updatePhiloxeniaQuestions: updatePhiloxeniaQuestions
    };
    /**
     * get latest Passenger information
     * @memberof InfoAPIService
     * @return {object} promise
     */

    function getPax(flightId) {
      //Prepare to request training courses fetch
      var flight = FlightFactory.getFlightFromTotalFlights(flightId);
      var flightInfo = {
        FlightId: flightId,
        FlightCourses: flight ? flight.Courses : []
      };
      var user = UserFactory.getUser();
      var call = $q.defer();
      $http.post(apiUrl + '/info/Pax', flightInfo, {
        'Content-Type': 'application/json'
      }).then(function (responseData) {
        if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined) {
          var err = new Error();
          err.status = -1;
          var msg = "ResponseData error in info/gates :" + JSON.stringify(responseData);
          LogService.debug(msg, err);
          call.reject(err);
          return;
        }

        var newDutyInfo = responseData.data.data;
        newDutyInfo.FlightId = flightId;
        updateFlightLocalStorage(newDutyInfo);
        LuggageComplianceFactory.updateLuggageComplianceStorage(newDutyInfo.LuggageCompliance, flightId);
        updateCrewCheckIn(newDutyInfo);
        updatePhiloxeniaQuestions(newDutyInfo);
        FlightDelaysFactory.upsertFlightDelays(newDutyInfo.FlightDelays);
        call.resolve(responseData);
      }, function (err) {
        call.reject(err);
      });
      return call.promise;
    }
    /**
     * Send Customer Incident
     * @memberof InfoAPIService
     * @return {object} promise
     */


    function sendCustomerIncident(flightDescription, question, description, imageStr) {
      var user = UserFactory.getUser();
      var call = $q.defer();
      var customerIncident = {
        flightDescription: flightDescription,
        question: question,
        description: description,
        image: imageStr
      };
      $http.post(apiUrl + '/customer/Incident', customerIncident, {
        'Content-Type': 'application/json'
      }).then(function (responseData) {
        if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined) {
          var err = new Error();
          err.status = -1;
          var msg = "ResponseData error in customer/Incident :" + JSON.stringify(responseData);
          LogService.debug(msg, err);
          call.reject(err);
          return;
        }

        call.resolve(responseData);
      }, function (err) {
        call.reject(err);
      });
      return call.promise;
    }
    /**
     * Gets latest info for each duty in a crew route
     * @memberof InfoAPIService
     * @param {object} crewRouteDuty 
     * @param {function} callback 
     */


    function refreshCrewRoute(crewRouteDuty, callback) {
      var crewRouteInfo = {
        DutyNo: crewRouteDuty.DutyNo,
        DutyDay: crewRouteDuty.DutyDay,
        Route: crewRouteDuty.Route,
        From: crewRouteDuty.DutyBegin,
        To: crewRouteDuty.DutyEnd,
        FlightCourses: crewRouteDuty.Courses,
        CurrentDutyDate: crewRouteDuty.CurrentDutyDate
      }; //refresh route for the current day (Flight page)

      if (crewRouteDuty.CurrentDutyDate) {
        return $http.post(apiUrl + '/info/RefreshFlight', crewRouteInfo, {
          'Content-Type': 'application/json'
        }).then(callback);
      } //Refresh whole Crew Route (Crew Route page)
      else {
          return $http.post(apiUrl + '/info/RefreshCrewRoute', crewRouteInfo, {
            'Content-Type': 'application/json'
          }).then(callback);
        }
    }
    /**
     * Updates Route's Data Status depending on Refresh respond
     * @memberof InfoAPIService
     * @param {object} newDuty - Refresh respond
     * @param {array} dataStatus 
     */


    function updateCrewRouteStatusSetter(dataStatus, crewRouteStatuses) {
      if (crewRouteStatuses.meals) {
        updateStatusSetter(dataStatus, ["Meals"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Meals"], "N/A", "No available data");
      }

      if (crewRouteStatuses.airportContacts) {
        updateStatusSetter(dataStatus, ["Airport Contacts"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Airport Contacts"], "N/A", "No available data");
      }

      if (crewRouteStatuses.groundServices) {
        updateStatusSetter(dataStatus, ["Ground Services"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Ground Services"], "N/A", "No available data");
      }

      if (crewRouteStatuses.aircraftDifferences) {
        updateStatusSetter(dataStatus, ["Aircraft Differences"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Aircraft Differences"], "N/A", "No available data");
      }

      if (crewRouteStatuses.campaigns) {
        updateStatusSetter(dataStatus, ["Campaigns"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Campaigns"], "N/A", "No available data");
      }

      if (crewRouteStatuses.airportHotels) {
        updateStatusSetter(dataStatus, ["Hotels"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Hotels"], "N/A", "No available data");
      }

      if (crewRouteStatuses.crewAimsMemos) {
        updateStatusSetter(dataStatus, ["Aims Memos"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Aims Memos"], "N/A", "No available data");
      }

      if (crewRouteStatuses.flightServiceEvents) {
        updateStatusSetter(dataStatus, ["Flight Service Events"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Flight Service Events"], "N/A", "No available data");
      }

      if (crewRouteStatuses.misconnectionFlights) {
        updateStatusSetter(dataStatus, ["Misconnection Flights"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Misconnection Flights"], "N/A", "No available data");
      }
    }
    /**
     * Updates Flight's Data Status depending on Refresh respond
     * @memberof InfoAPIService
     * @param {object} newDuty - Refresh respond
     * @param {array} dataStatus 
     */


    function updateFlightStatusSetter(newDuty, dataStatus) {
      if (newDuty.FlightInfo) {
        updateStatusSetter(dataStatus, ["Flight Status"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Flight Status"], "N/A", "No available data");
      }

      if (newDuty.AircraftPositions && newDuty.AircraftPositions.length > 0) {
        updateStatusSetter(dataStatus, ["Aircraft Movement"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Aircraft Movement"], "N/A", "No available data");
      }

      if (newDuty.FlightInfo && newDuty.FlightInfo.crew && newDuty.FlightInfo.crew.length > 0) {
        updateStatusSetter(dataStatus, ["Crew Info"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Crew Info"], "N/A", "No available data");
      }

      if (newDuty.FlightInfo && newDuty.FlightInfo.crew && newDuty.FlightInfo.crew.length > 0 && newDuty.FlightInfo.crew.filter(function (x) {
        return x.PhoneNumber != null;
      }).length > 0) {
        updateStatusSetter(dataStatus, ["Crew Contacts"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Crew Contacts"], "N/A", "No available data");
      }

      if (newDuty.CabinServiceManagementLists && newDuty.CabinServiceManagementLists.length > 0 && newDuty.CabinServiceManagementLists[0].ConnectingFlights && newDuty.CabinServiceManagementLists[0].ConnectingFlights.length > 0) {
        updateStatusSetter(dataStatus, ["Connections"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Connections"], "N/A", "No available data");
      }

      if (newDuty.CabinServiceManagementLists && newDuty.CabinServiceManagementLists.length > 0 && newDuty.CabinServiceManagementLists[0].ConnectingFlights && newDuty.CabinServiceManagementLists.length > 0) {
        updateStatusSetter(dataStatus, ["Pax Info"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Pax Info"], "N/A", "No available data");
      }

      if (newDuty.LuggageCompliance && newDuty.LuggageCompliance.length > 0) {
        updateStatusSetter(dataStatus, ["Luggage Info"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Luggage Info"], "N/A", "No available data");
      }

      if (newDuty.TrainingCourses && newDuty.TrainingCourses.length > 0) {
        updateStatusSetter(dataStatus, ["Training Info"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Training Info"], "N/A", "No available data");
      }

      if (newDuty.ShopInTheCloudIsUpdated) {
        updateStatusSetter(dataStatus, ["Shop In The Cloud"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Shop In The Cloud"], "N/A", "No available data");
      }
    }
    /**
     * Updates Ground Duty's Data Status depending on Refresh respond
     * @memberof InfoAPIService
     * @param {array} newDuty - Refresh respond
     * @param {array} dataStatus 
     */


    function updateGroundStatusSetter(newDuty, dataStatus) {
      if (newDuty) {
        updateStatusSetter(dataStatus, ["Duty Info"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Duty"], "N/A", "No available data");
      }

      if (newDuty && newDuty.RelatedGroundDuties && newDuty.RelatedGroundDuties.length > 1) {
        updateStatusSetter(dataStatus, ["Instructors"], "SUCCESS", "Successfully updated");
        updateStatusSetter(dataStatus, ["Trainees"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Instructors"], "N/A", "No available data");
        updateStatusSetter(dataStatus, ["Trainees"], "N/A", "No available data");
      }
    }
    /**
     * Changes the state of Data Status
     * @memberof InfoAPIService
     * @param {array} dataStatus 
     * @param {array} array - Datatype to change
     * @param {string} status - New status
     * @param {string} text - New text
     */


    function updateStatusSetter(dataStatus, array, status, text) {
      var objsTochange = dataStatus.filter(function (x) {
        var res = array.filter(function (s) {
          return s == x.datatype;
        });
        return res.length > 0 ? true : false;
      });
      objsTochange.forEach(function (x) {
        x.status = status;
        x.text = text;
        var index = dataStatus.map(function (x) {
          return x.datatype;
        }).indexOf(x.datatype);
        dataStatus[index] = x;
      });
    }
    /**
     * Update Flight Info in Local Storage
     * @memberof InfoAPIService
     * @param {object} duty 
     */


    function updateFlightLocalStorage(duty) {
      // save flight gates to local storage
      //var flightGates = duty.FlightGates;
      //FlightGateFactory.processUpdatedData(flightGates);
      //Update Aircraft positions
      if (duty.AircraftPositions != null && duty.AircraftPositions.length > 0) {
        AircaftPositionsFactory.updateAircraftPositionsToStorage(duty.AircraftPositions[0], duty.FlightInfo.FlightId);
      } // update flight to local storage


      FlightFactory.mergeFlightInfo(duty.FlightInfo, duty.ShowPaxNames); //Enrich flight info after sync

      SyncAPIService.updateCabinReportLocalEditFromSynch(); // update paxinfo to local storage

      if (duty.CabinServiceManagementLists && duty.CabinServiceManagementLists.length > 0) {
        PaxInfoFactory.updatePaxInfo(duty.CabinServiceManagementLists[0]);
      }

      if (duty.Campaigns && duty.Campaigns.FlightsCampaigns.length > 0) {
        if (duty.CabinServiceManagementLists) {
          CampaignFactory.updateSeatNoPaxAssignments(duty.Campaigns.FlightsCampaigns, duty.CabinServiceManagementLists);
        }

        CampaignFactory.mergeCampaigns(duty.Campaigns);
      }

      if (duty.CustomerEventHistory && duty.CustomerEventHistory.length) {
        CustomerEventHistoryFactory.refreshPassengerHistory(duty.CustomerEventHistory);
      }

      if (duty.JeppesenFlightDetails && duty.FlightInfo && duty.FlightInfo.FlightId) {
        JeppesenFlightDetailsFactory.setJeppesenFlightDetailsToStorage(duty.FlightInfo.FlightId, duty.JeppesenFlightDetails);

        if (Array.isArray(duty.CTOTHistory)) {
          JeppesenFlightDetailsFactory.setCtotHistoryToStorage(duty.FlightInfo.FlightId, duty.CTOTHistory);
        }
      } // update messages to local storage
      // MessageFactory.markReadAsSynched(duty.Messages);
      // MessageFactory.storeMessagesFromServer(duty.Messages);

    }
    /**
     * Update Ground Duty Info in Local Storage
     * @memberof InfoAPIService
     * @param {object} duty 
     */


    function updateGroundDutyLocalStorage(duty) {
      GroundDutyFactory.mergeGroundDutyInfo(duty);
    }
    /**
     * Update Flight crew check-in Info in Local Storage
     * @memberof InfoAPIService
     * @param {object} duty 
     */


    function updateCrewCheckIn(duty) {
      if (duty.FlightInfo) {
        FlightCheckInsFactory.updateFlightCrewCheckInToStorage(duty);
      }
    }
    /**
     * Update Philoxenia Questions for the current flight in Local Storage
     * @memberof InfoAPIService
     * @param {object} duty 
     */


    function updatePhiloxeniaQuestions(duty) {
      if (duty.PhiloxeniaQuestions) {
        PhiloxeniaQuestionsFactory.updatePhiloxeniaQuestionsToStorage(duty.PhiloxeniaQuestions);
      }
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.service("SyncAPIService", SyncAPIService);
  /**
   * @memberof CabinReports
   * @ngdoc service
   * @name SyncAPIService
   * @description 
   * Generic Sync service which sends all your reports and gets all the latest data
   * @ngInject
   */

  function SyncAPIService($http, $q, apiUrl, FlightFactory, ReportGuidFactory, CabinReportTemplateItemFactory, SyncLogFactory, CabinReportLocalEditFactory, CrewRouteFactory, CrewMealFactory, CabinReportSendToServerFactory, CabinReportSyncResultFactory, AircraftTypeFactory, DataCleanerFactory, WaterUpliftActionFactory, ACSupplyFactory, SpecialMealSourceFactory, SpecialMealTypeFactory, CCMSFactory, TravelValueIncompleteReasonFactory, CCMSCrewPositionFactory, MessageFactory, LogService, CrewAssessmentTemplateFactory, CrewAssessmentFactory, UserFactory, AssessmentSyncResultFactory, SettingsMain, PaxInfoFactory, MemoFactory, FaqFactory, GroundDutyFactory, MemoImagesFactory, AircaftPositionsFactory, AimsCrewMemosFactory, IncompleteServicesSourceFactory, LeaveRequestFactory, CourseFactory, CampaignFactory, CrewHotelFactory, LuggageComplianceFactory, ScheduleAcknowledgeFactory, CrewCallFactory, PreviousDutyFactory, LogCallFactory, CheckInFactory, PhiloxeniaQuestionsFactory, TimeLogFactory, FlightCheckInsFactory, AnnualLeavesFactory, FlightDelaysFactory, ToolkitFactory, CustomerEventFactory, ExpiriesFactory, TraineeCoursesDetailsFactory, RequestFactory, WifiAvailabilityFactory, FlightServiceEventsFactory, PassengerMealServiceFactory, GroomingCategoriesFactory, FlightOrdersFactory, SaFeedbackInfoFactory, SaCrewAssessmentFactory, SaAssessmentSyncResultFactory, ASSFSyncInfoFactory, ASSFReportFactory, JeppesenFlightDetailsFactory, AirlineInfoFactory, localStorageMD5Service, FlightMealCriteriaFactory, MisconnectionFlightsFactory, LotteryFactory) {
    /**
     * Find if a relative old flight exists and if exists update it 
     * @memberof SyncAPIService
     * @param {object} oldflight
     * @param {array} flights
     * @return {boolean} hasRelativeFlight
     */
    function relativeFlightMatcher(oldflight, flights) {
      var relativeFlights = [];
      var found = false;

      for (var i = 0; i < flights.length; i++) {
        if (oldflight.FlightNo == flights[i].FlightNo && oldflight.FlightDate == flights[i].FlightDate && oldflight.Departure == flights[i].Departure) {
          relativeFlights.push(flights[i]);
          found = true;
          break;
        }
      }

      if (!found) {
        var flight = null;
        var oldFlightNo = null;
        var lastDigit = oldflight.FlightNo.substr(oldflight.FlightNo.length - 1, 1);
        oldFlightNo = !isNaN(lastDigit) ? oldflight.FlightNo : oldflight.FlightNo.substr(0, oldflight.FlightNo.length - 1);

        for (var i = 0; i < flights.length; i++) {
          lastDigit = flights[i].FlightNo.substr(flights[i].FlightNo.length - 1, 1);
          flight = !isNaN(lastDigit) ? flights[i].FlightNo : flights[i].FlightNo.substr(0, flights[i].FlightNo.length - 1);

          if (oldFlightNo == flight && oldflight.FlightDate == flights[i].FlightDate && oldflight.Departure == flights[i].Departure) {
            relativeFlights.push(flights[i]);
          }
        }
      }

      if (relativeFlights.length == 1) {
        var cabinReportLocalEdit = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(oldflight.FlightId);
        cabinReportLocalEdit.FlightAimsId = relativeFlights[0].FlightAimsId;
        cabinReportLocalEdit.FlightId = relativeFlights[0].FlightId;
        CabinReportLocalEditFactory.setCabinReportToStorage(cabinReportLocalEdit);
        return true;
      } else if (relativeFlights.length > 1) {
        for (var i = 1; i < relativeFlights.length; i++) {
          for (var j = 0; j < relativeFlights.length - i; j++) {
            if (relativeFlights[j].FlightNo > relativeFlights[j + 1].FlightNo) {
              var a = relativeFlights[j];
              relativeFlights[j] = relativeFlights[j + 1];
              relativeFlights[j + 1] = a;
            }
          }
        }

        var cabinReportLocalEdit = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(oldflight.FlightId);
        cabinReportLocalEdit.FlightAimsId = relativeFlights[0].FlightAimsId;
        cabinReportLocalEdit.FlightId = relativeFlights[0].FlightId;
        CabinReportLocalEditFactory.setCabinReportToStorage(cabinReportLocalEdit);
        return true;
      } else {
        return false;
      }
    }

    ;
    return {
      /**
       * Send and get the latest information 
       * @memberof SyncAPIService
       * @param {object} aimsId
       * @param {array} memoIdsToSend 
       */
      doSync: function doSync(aimsId, memoIdsToSend) {
        //Clear timeLogs from local storage older than 2 days
        TimeLogFactory.cleanOldData(); //clear CrewMeal ratings from local storage that have timestamp older than 20 days

        DataCleanerFactory.deleteOldCrewMealsRatings(); // get the saved cabin reports

        var allSavedReports = CabinReportLocalEditFactory.getCabinReportsFromStorage();
        var IsAssessmentEnabled = SettingsMain.getIsAssessmentEnabled();
        var user = UserFactory.getUser();
        var lastLog = SyncLogFactory.getSyncLog();
        var lastSyncDate = lastLog.date; //Free to send all reports and assessments:

        var messagesToSend = MessageFactory.getUnsynchedReadMessages(); // keep only the ones that are ready to be sent

        var reportsToSend = CabinReportSendToServerFactory.getCompletedListFromCabinReportLocalEdits(allSavedReports);
        var assessmentsToSend = [];

        if (user.position == 'SA') {
          if (IsAssessmentEnabled) {
            assessmentsToSend = CrewAssessmentFactory.getAssementsReadyToSend();
          } //TODO: Get assf report ReadyToSend

        }

        var saAssessmentsToSend = [];

        if (user.position == 'FA') {
          saAssessmentsToSend = SaCrewAssessmentFactory.getAssementsReadyToSend();
        }

        var passengersCampaignsToSend = CampaignFactory.getPaxAssignmentsFromStorage();
        var luggageCompliance = {
          luggageComplianceReports: LuggageComplianceFactory.getLuggageComplianceFromStorage().filter(function (x) {
            return !x.isSynced;
          })
        }; //Get call requests made while offline

        var phoneCallLog = {
          CrewCallReports: LogCallFactory.getLogCallsFromStorage()
        };
        var oneStopShopEvents = CustomerEventFactory.getUnsyncedCustomerEvents();
        var lotteryResultsToSend = LotteryFactory.getPendingResults() || [];
        var syncData = {
          "SyncCabinReports": reportsToSend,
          "Messages": messagesToSend,
          "Assessments": assessmentsToSend,
          "SaAssessments": saAssessmentsToSend,
          "Memos": memoIdsToSend,
          "PassengersCampaigns": passengersCampaignsToSend,
          "LuggageCompliance": luggageCompliance,
          "CrewCallLog": phoneCallLog,
          "LastSyncDate": lastSyncDate,
          "OneStopShopEvents": oneStopShopEvents,
          "LotteryResults": lotteryResultsToSend
        };
        var call = $q.defer();
        $http.post(apiUrl + '/sync', syncData, {
          'Content-Type': 'application/json'
        }).then(function (responseData) {
          if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined || responseData.data.data.SyncCabinData == undefined) {
            var err = new Error();
            err.status = -1;
            var msg = "ResponseData error in sync :" + JSON.stringify(responseData);
            LogService.debug(msg, err);
            call.reject(err);
            return;
          }

          var response = responseData.data.data; //keep flights, will be used to retain a flight for old unsynched reports

          var orgFlights = FlightFactory.getFlightsFromStorage();
          var IsAssessmentEnabled = response.SyncCabinData.IsAssessmentEnabled;
          SettingsMain.setIsAssessmentEnabled(IsAssessmentEnabled); //Save schedule changes dates 

          ScheduleAcknowledgeFactory.setAllScheduleChangesToStorage(response.SyncCabinData.ScheduleChanges);

          if (response.SyncCabinData.CrewCallLog && response.SyncCabinData.CrewCallLog.ResponseSuccess) {
            LogCallFactory.cleanLogsFromStorage();
          }

          var oneStopShop = response.SyncCabinData.OneStopShop; //save toolkit items

          if (oneStopShop.ToolkitItems) {
            ToolkitFactory.setToolkitItemsFromServer(oneStopShop.ToolkitItems);
          } //check OneStopShop CustomerEvents save status


          if (oneStopShop.CustomerEventsSynced) {
            oneStopShop.CustomerEventsSynced.forEach(function (event) {
              var localCustomerEvent = oneStopShopEvents.find(function (x) {
                return x.TemporaryId == event.TemporaryId;
              });
              localCustomerEvent.Synced = event.SaveSuccess; //No Treatment Id reset value

              if (localCustomerEvent.TreatmentId == null) localCustomerEvent.TreatmentId = -1;
              CustomerEventFactory.updateCustomerEvent(localCustomerEvent);
            });
          } //save training courses


          var rawTrainingCourses = response.SyncCabinData.TrainingCourses;
          var courses = [];
          rawTrainingCourses.forEach(function (course) {
            courses.push({
              Id: course.Id,
              Title: course.Title,
              HasLimitedInfo: true
            });
          });
          CourseFactory.setCoursesFromServer(courses); // Enable/Disable SITC from api settings 

          var IsShopInTheCloudEnable = response.SyncCabinData.IsShopInTheCloudEnable;
          SettingsMain.setIsShopInTheCloudEnable(IsShopInTheCloudEnable); //clean crew member info

          var responseFlightIds = response.SyncCabinData.flights.map(function (x) {
            return x.FlightId;
          });
          CrewCallFactory.cleanOldData(responseFlightIds);
          PreviousDutyFactory.cleanOldData(responseFlightIds);
          PhiloxeniaQuestionsFactory.cleanOldData(responseFlightIds);
          LuggageComplianceFactory.cleanOldData(responseFlightIds);
          AircaftPositionsFactory.cleanOldData(responseFlightIds);
          FlightCheckInsFactory.cleanOldData(responseFlightIds);
          ASSFReportFactory.cleanOldData(responseFlightIds);
          JeppesenFlightDetailsFactory.cleanOldData(responseFlightIds);
          FlightMealCriteriaFactory.cleanOldDataMealCriteria(responseFlightIds); //TODO::move to refresh service:
          //DataCleaner for the pax info (indexedDb)

          var pendingFlightIds = CabinReportLocalEditFactory.getFlightIdsWithPendingReports();
          PaxInfoFactory.cleanOldDataPaxInfo(pendingFlightIds); //Data cleaner for the campaigns

          CampaignFactory.cleanOldCampaigns(pendingFlightIds); // //Data cleaner for the aims crew memos
          // AimsCrewMemosFactory.cleanOldAimsCrewMemos();

          AimsCrewMemosFactory.clearAimsCrewMemosFactoryFromStorage(); //Data cleaner for flight delays

          FlightDelaysFactory.cleanOldFlightDelays(responseFlightIds); //Clean old data for the flight service events

          FlightServiceEventsFactory.cleanOldDataServiceEvents(pendingFlightIds); //Clean old data for the flight Flight Orders

          FlightOrdersFactory.cleanOldDataFlightOrders(pendingFlightIds);
          MisconnectionFlightsFactory.cleanOldDataMisconnectionFlights(pendingFlightIds);
          GroomingCategoriesFactory.clearGroomingReportsFromStorage(); //Data cleaner for the customer events (flightDate of the event >= today - 5 days)
          // CustomerEventHistoryFactory.deleteOldHistoryEvents();
          // CustomerEventFactory.deleteOldCustomerEvents();
          // FlightGateFactory.processUpdatedData(response.SyncCabinData.flightGates);
          // clear existing server data

          DataCleanerFactory.deleteAllServerData();
          var fromSync = true;
          GroundDutyFactory.mergeGroundDutiesToStorage(response.SyncCabinData.groundDuties, fromSync);
          CrewRouteFactory.setCrewRoutesToStorage(response.SyncCabinData.CrewRoutes);
          CrewMealFactory.setCrewMealsToStorage(response.SyncCabinData.CateringCrewMeals);
          CrewHotelFactory.setCrewHotelsToStorage(response.SyncCabinData.CrewHotels);
          CheckInFactory.setCheckInInfoToStorage(response.CrewCheckInInfo);
          FlightServiceEventsFactory.setEventTypes(response.FlightServiceEventTypes);
          AnnualLeavesFactory.setAnnualLeavesToStorage(response.AnnualLeaves);
          ExpiriesFactory.setCrewExpiriesToStorage(response.CrewExpiries);
          AimsCrewMemosFactory.setAimsCrewMemosToStorage(response.SyncCabinData.aimsCrewMemos);
          WifiAvailabilityFactory.setRegistrationsToStorage(response.RegistrationsWithWifi);
          PassengerMealServiceFactory.checkAndsetPassengerMealsServicesToStorage(response.PassengerMealServices);
          GroomingCategoriesFactory.setGroomingCategories(response.GroomingCategories);
          ExpiriesFactory.setAllExpiriesToStorage(response.AllExpiries);

          if (response.PassengerMealAncillaries) {
            PassengerMealServiceFactory.setPassengerMealsAncillariesToStorage(response.PassengerMealAncillaries);
          } // Store airline context (logos / selection)


          AirlineInfoFactory.setCrewAirlineInfos(response.CrewAirlineInfos || []);
          AirlineInfoFactory.setCrewAirlineOptions(response.CrewAirlineOptions || []); // Backend default selection (preselected on page load)

          var defaultFleetId = response.SelectedAirline && response.SelectedAirline.FleetId ? response.SelectedAirline.FleetId : null; // Only update the default in storage, do not re-initialize UI selection

          AirlineInfoFactory.setDefaultFleetId(defaultFleetId);

          if (response.RosterRequestAncillaries) {
            RequestFactory.setSubmissionDeadlineDateToStorage(response.RosterRequestAncillaries.SubmissionEndDate);
          } // If the sync response contains common flights with Flight Attendants (FA)


          if (response.SyncCabinData.CommonFlightsWithFA) {
            localStorageMD5Service.set('CommonFlightsWithFA', response.SyncCabinData.CommonFlightsWithFA);
          } // If the sync response contains common flights with Senior Attendants (SA)


          if (response.SyncCabinData.CommonFlightsWithSA) {
            localStorageMD5Service.set('CommonFlightsWithSA', response.SyncCabinData.CommonFlightsWithSA);
          } //save, update or add memos


          var memos = response.SyncCabinData.memos;
          MemoFactory.setMemosFromServer(memos, memoIdsToSend, lastSyncDate);
          LeaveRequestFactory.saveLeaveRequestInformation(response.SyncCabinData.LeaveRequestInformation); //delete leftover memos 

          var serverMemoIds = response.SyncCabinData.memoIds;

          for (var i = 0; i < serverMemoIds.length; i++) {
            MemoFactory.deleteMemoFromStorage(serverMemoIds[i]);
          }

          for (var i = 0; i < memos.length; i++) {
            MemoImagesFactory.deleteMemoImageByMemoId(memos[i].Id);
          }

          var images = response.SyncCabinData.Images;
          MemoImagesFactory.setImagesToServer(images);

          for (var i = 0; i < serverMemoIds.length; i++) {
            MemoImagesFactory.deleteMemoImageByMemoId(serverMemoIds[i]);
          } // save flight data to local storage


          var flightData = response.SyncCabinData.flights;
          var flights = FlightFactory.markScheduleChangedFlights(flightData, orgFlights);
          var cabinReports = response.SyncCabinData.cabinReports;
          var assessmentTemplate = response.SyncCabinData.assessmentTemplate;
          CrewAssessmentTemplateFactory.setCrewAssessmentTemplateToStorage(assessmentTemplate);
          var reportGuids = response.SyncCabinData.guids;
          ReportGuidFactory.setReportGuidsToStorage(reportGuids); // save cabin report template to storage

          var cabinReportTemplateItems = response.SyncCabinData.cabinReportTemplate;
          CabinReportTemplateItemFactory.setCabinReportTemplateItemsToStorage(cabinReportTemplateItems); //store and sync messages

          var messages = response.SyncCabinData.messages;
          MessageFactory.markReadAsSynched(messages);
          MessageFactory.storeMessagesFromServer(messages); // save aircraft types to local storage

          var aircraftTypes = response.SyncCabinData.aircraftTypes;
          AircraftTypeFactory.setAircraftTypesToStorage(aircraftTypes); // save water uplift actions to local storage

          var wuas = response.SyncCabinData.waterUpliftActions;
          WaterUpliftActionFactory.setWaterUpliftActionsToStorage(wuas); // save ac supplies to local storage

          var acSupplies = response.SyncCabinData.acSupplies;
          ACSupplyFactory.setACSuppliesToStorage(acSupplies); // save special meal sources to local storage

          var specialMealSources = response.SyncCabinData.specialMealSources;
          SpecialMealSourceFactory.setSpecialMealSourcesToStorage(specialMealSources); // save special meal types to local storage

          var specialMealTypes = response.SyncCabinData.specialMealTypes;
          SpecialMealTypeFactory.setSpecialMealTypesToStorage(specialMealTypes); // save currencies to local storage

          /*var currencies = response.SyncCabinData.currencies;
          CurrencyFactory.setCurrenciesToStorage(currencies);*/
          //save all FAQs to local storage

          var FAQs = response.SyncCabinData.FAQPairs;
          FaqFactory.setFAQsFromServer(FAQs); // save lotteries to local storage

          if (response.SyncCabinData.Lotteries) {
            LotteryFactory.setLotteriesFromServer(response.SyncCabinData.Lotteries);
          }

          if (response.SyncCabinData.SubmittedLotteryResults) {
            LotteryFactory.setSubmittedLotteriesFromServer(response.SyncCabinData.SubmittedLotteryResults);
          } // save currencies to local storage


          var travelReasons = response.SyncCabinData.travelValueIncompleteReasons;
          TravelValueIncompleteReasonFactory.setReasonsToStorage(travelReasons); // save Incomplete In-Flight Services Reasons and Types:

          var incompleteInFlightServiceListOfValues = response.SyncCabinData.incompleteInFlightServiceListOfValues;
          IncompleteServicesSourceFactory.setIncompleteInFlightServiceListOfValues(incompleteInFlightServiceListOfValues); // save SA Feedbacks: Questions & SA members

          var saFeedbackInfo = response.SAFeedbackInfo;

          if (saFeedbackInfo) {
            SaFeedbackInfoFactory.setSaFeedbacks(saFeedbackInfo);
          }

          if (response.ASSFSyncInfo) {
            ASSFSyncInfoFactory.setASSFInfo(response.ASSFSyncInfo);
          } // log the sync user and date


          SyncLogFactory.setSyncLog(aimsId, response.SyncCabinData.version, response.SyncCabinData.toDate); // save ccms to local storage

          var ccms = response.SyncCabinData.ccms;
          CCMSFactory.setCCMSToStorage(ccms);
          var traineeCourses = response.SyncCabinData.TraineeCourses;
          TraineeCoursesDetailsFactory.setTraineeCoursesToStorage(traineeCourses);
          var traineeFlightCourses = response.SyncCabinData.TraineeFlightCourses;
          TraineeCoursesDetailsFactory.setTraineeFlightCoursesToStorage(traineeFlightCourses); // get the sync results

          var syncResults = CabinReportSyncResultFactory.fromObjectList(response.SyncCabinData.reportResults);
          var flight; // mark sent reports as synched

          for (var j = 0; j < reportsToSend.length; j++) {
            var syncResult = CabinReportSyncResultFactory.getSyncResult(syncResults, reportsToSend[j].ReportGuid);

            if (syncResult != null) {
              if (syncResult.success) {
                CabinReportLocalEditFactory.markReportAsSynched(reportsToSend[j].ReportGuid);
                syncResult.Result = 'Successfully submitted';
              } else {
                syncResult.Result = 'Submission error';
              } // find flight and append report fields


              flight = null;

              if (orgFlights != null) {
                for (i = 0; i < orgFlights.length; i++) {
                  if (orgFlights[i].FlightId != null && orgFlights[i].FlightId == reportsToSend[j].FlightId || orgFlights[i].FlightAimsId != null && orgFlights[i].FlightAimsId == reportsToSend[j].FlightAimsId) {
                    flight = orgFlights[i];
                    break;
                  }
                }
              } //var flight = FlightFactory.getFlightFromStorage(reportsToSend[j].FlightAimsId);


              if (flight != null) {
                syncResult.FlightAimsId = flight.FlightAimsId;
                syncResult.FlightId = flight.FlightId;
                syncResult.ScheduledDepartureDateUTC = flight.ScheduledDepartureDateUTC;
                syncResult.FlightNo = flight.FlightNo;
                syncResult.Departure = flight.Departure;
                syncResult.Arrival = flight.Arrival;
                syncResult.ScheduledDepartureTimeUTC = flight.ScheduledDepartureTimeUTC;
                syncResult.AcTailNo = flight.AcTailNo;
              }
            }
          } // save the sync results


          CabinReportSyncResultFactory.setCabinReportSyncResultsToStorage(syncResults);
          AssessmentSyncResultFactory.setAssessmentSyncResultsToStorage(response.SyncCabinData.assessmentResults);
          SaAssessmentSyncResultFactory.setAssessmentSyncResultsToStorage(response.SaAssessmentResults);
          var lotterySyncResults = response.SyncCabinData.LotteryResultSyncResults || [];
          var lotterySyncSummary = [];

          for (var l = 0; l < lotterySyncResults.length; l++) {
            var lotterySyncResult = lotterySyncResults[l];
            var compositeId = lotterySyncResult.LotteryId + "_" + lotterySyncResult.FlightId;

            if (lotterySyncResult.Success || lotterySyncResult.IsDuplicate) {
              LotteryFactory.removePendingResult(compositeId);
            }

            var lotteryObj = LotteryFactory.getLotteryById(lotterySyncResult.LotteryId);
            var sentMatch = lotteryResultsToSend.filter(function (s) {
              return s.LotteryId == lotterySyncResult.LotteryId && s.FlightId == lotterySyncResult.FlightId;
            })[0];
            lotterySyncSummary.push({
              LotteryId: lotterySyncResult.LotteryId,
              FlightId: lotterySyncResult.FlightId,
              FlightDisplay: sentMatch && sentMatch.FlightDisplay || 'Flight #' + lotterySyncResult.FlightId,
              LotteryName: lotteryObj ? lotteryObj.Name : 'Lottery #' + lotterySyncResult.LotteryId,
              Success: !!(lotterySyncResult.Success || lotterySyncResult.IsDuplicate),
              IsDuplicate: !!lotterySyncResult.IsDuplicate,
              ErrorMessage: lotterySyncResult.ErrorMessage || null
            });
          } // Flag any sent items that received no server response


          for (var m = 0; m < lotteryResultsToSend.length; m++) {
            var sentItem = lotteryResultsToSend[m];
            var alreadyInSummary = lotterySyncSummary.some(function (r) {
              return r.LotteryId == sentItem.LotteryId && r.FlightId == sentItem.FlightId;
            });

            if (!alreadyInSummary) {
              var missedLotteryObj = LotteryFactory.getLotteryById(sentItem.LotteryId);
              lotterySyncSummary.push({
                LotteryId: sentItem.LotteryId,
                FlightId: sentItem.FlightId,
                FlightDisplay: sentItem.FlightDisplay || 'Flight #' + sentItem.FlightId,
                LotteryName: missedLotteryObj ? missedLotteryObj.Name : 'Lottery #' + sentItem.LotteryId,
                Success: false,
                IsDuplicate: false,
                ErrorMessage: 'No response received from server'
              });
            }
          } // delete local flights with no local reports


          DataCleanerFactory.deleteOrphanedLocalFlights(); //**************** ADD CODE TO KEEP FLIGHTS IF THEY STIL HAVE AN NOT SYCNHED REPORT *********************//
          //find flight ids used by draft reports
          //**************** ADD CODE TO KEEP FLIGHTS IF THEY STIL HAVE AN NOT SYCNHED REPORT *********************//
          //find flight ids used by draft reports

          if (allSavedReports) {
            var verifyFlightAimsIds = [];
            var verifyFlightIds = [];

            for (var i = 0; i < allSavedReports.length; i++) {
              if (allSavedReports[i].Status == 'draft' || allSavedReports[i].Status == 'completed') verifyFlightAimsIds.push(allSavedReports[i].FlightAimsId);
              verifyFlightIds.push(allSavedReports[i].FlightId);
            } //search these ids into the newly received flights


            if (verifyFlightAimsIds.length > 0) {
              var missingIds = [];
              var missingAimsIds = [];
              var found, id, aimsId;

              for (var i = 0; i < verifyFlightAimsIds.length; i++) {
                found = false;
                aimsId = verifyFlightAimsIds[i];
                id = verifyFlightIds[i];

                for (var f = 0; f < flights.length; f++) {
                  if (flights[f].FlightId != null && flights[f].FlightId == id || flights[f].FlightAimsId != null && flights[f].FlightAimsId == aimsId) {
                    found = true;
                    break;
                  }
                }

                if (!found) missingIds.push(id);
                missingAimsIds.push(aimsId);
              } //search missing flights in flights stored before sync


              if (orgFlights) {
                for (var m = 0; m < missingIds.length; m++) {
                  id = missingIds[m];
                  aimsId = missingAimsIds[m];

                  for (var o = 0; o < orgFlights.length; o++) {
                    if (orgFlights[o].FlightId != null && orgFlights[o].FlightId == id || orgFlights[o].FlightAimsId != null && orgFlights[o].FlightAimsId == aimsId) {
                      if (!relativeFlightMatcher(orgFlights[o], flights)) {
                        flights.push(orgFlights[o]);
                      }

                      break;
                    }
                  }
                }
              }
            }
          }

          FlightFactory.storeFlightsWithReportsAndMessages(flights, cabinReports, messages); //Fix Assessments in LS: FA and SA

          CrewAssessmentFactory.updateAndMergeAllFaAssessments(response.SyncCabinData.assessments); //update SA Feedbacks/Assessments

          if (saFeedbackInfo) {
            SaCrewAssessmentFactory.updateAndMergeAllSaAssessments(saFeedbackInfo.Assessments);
          } //Update the assfReport obj for each flight in schedule


          if (response.ASSFSyncInfo) {
            ASSFReportFactory.updateFlightsAssfStatus(response.ASSFSyncInfo.SyncedFlightIds);
          } //TimeLogFactory.timeLogToStorage(timeLog, response.SyncCabinData.timelog);
          // attach lottery sync summary for the sync results modal


          responseData.lotterySyncSummary = lotterySyncSummary; // return true

          call.resolve(responseData);
        }, function (err) {
          call.reject(err);
        });
        return call.promise;
      },

      /**
       * Update local reports from synced Fligths 
       * @memberof SyncAPIService
       */
      updateCabinReportLocalEditFromSynch: function updateCabinReportLocalEditFromSynch() {
        var cabinReportLocalEdits = CabinReportLocalEditFactory.getCabinReportsFromStorage();

        if (cabinReportLocalEdits != undefined && cabinReportLocalEdits != null) {
          for (var i = 0; i < cabinReportLocalEdits.length; i++) {
            var flight = FlightFactory.getFlightFromStorage(cabinReportLocalEdits[i].FlightId, cabinReportLocalEdits[i].FlightAimsId);

            if ((cabinReportLocalEdits[i].Status == "draft" || cabinReportLocalEdits[i].Status == "completed") && flight) {
              //console.log(cabinReportLocalEdits[i].FlightAimsId);
              cabinReportLocalEdits[i].Departure = flight.Departure;
              cabinReportLocalEdits[i].Arrival = flight.Arrival;
              cabinReportLocalEdits[i].AcType = flight.AcType;
              cabinReportLocalEdits[i].AcTailNo = flight.AcTailNo;
              cabinReportLocalEdits[i].FlightNo = flight.FlightNo;
              cabinReportLocalEdits[i].DepartureICAO = flight.DepartureICAO;
              cabinReportLocalEdits[i].DepartureCountry = flight.DepartureCountry;
              cabinReportLocalEdits[i].DepartureName = flight.DepartureName;
              cabinReportLocalEdits[i].ArrivalICAO = flight.ArrivalICAO;
              cabinReportLocalEdits[i].ArrivalCountry = flight.ArrivalCountry;
              cabinReportLocalEdits[i].ArrivalName = flight.ArrivalName;
              cabinReportLocalEdits[i].ScheduledDepartureDateUTC = flight.ScheduledDepartureDateUTC;
              cabinReportLocalEdits[i].ScheduledDepartureTimeUTC = flight.ScheduledDepartureTimeUTC;
              cabinReportLocalEdits[i].ScheduledDeparture = flight.ScheduledDeparture;
              cabinReportLocalEdits[i].BookedC = flight.BookedC;
              cabinReportLocalEdits[i].BookedY = flight.BookedY;
              cabinReportLocalEdits[i].BookedInf = flight.BookedInf;
              cabinReportLocalEdits[i].BookedPad = flight.BookedPad;
              cabinReportLocalEdits[i].BookedChld = flight.BookedChld;
              cabinReportLocalEdits[i].ActualC = flight.ActualC;
              cabinReportLocalEdits[i].ActualY = flight.ActualY;
              cabinReportLocalEdits[i].ActualInf = flight.ActualInf;
              cabinReportLocalEdits[i].ActualPad = flight.ActualPad;
              cabinReportLocalEdits[i].ActualChld = flight.ActualChld;
              cabinReportLocalEdits[i].DepartureGate = flight.DepartureGate;
              cabinReportLocalEdits[i].DepartureTimezone = flight.DepartureTimezone;
              cabinReportLocalEdits[i].ArrivalTimezone = flight.ArrivalTimezone;
              cabinReportLocalEdits[i].CallSign = flight.CallSign;
              cabinReportLocalEdits[i].ScheduledArrival = flight.ScheduledArrival;
              cabinReportLocalEdits[i].Route = flight.Route;
              cabinReportLocalEdits[i].DutyDate = flight.DutyDate;
              var manualCCMSCrewPositions = [];

              for (var k = 0; k < cabinReportLocalEdits[i].CCMSCrewPositions.length; k++) {
                if (cabinReportLocalEdits[i].CCMSCrewPositions[k].IsManual) {
                  manualCCMSCrewPositions.push(cabinReportLocalEdits[i].CCMSCrewPositions[k]);
                }
              }

              cabinReportLocalEdits[i].crew = flight.crew;
              var newCCMSCrewPositions = [];
              var IsNew;
              var changeStatus = false;

              for (var h = 0; h < cabinReportLocalEdits[i].crew.length; h++) {
                if (cabinReportLocalEdits[i].crew[h].isDHC == false && cabinReportLocalEdits[i].crew[h].position != 'CP' && cabinReportLocalEdits[i].crew[h].position != 'FO') {
                  var crewPosition = CCMSCrewPositionFactory.createNew();
                  crewPosition.CrewId = cabinReportLocalEdits[i].crew[h].aimsId;
                  crewPosition.Initials = cabinReportLocalEdits[i].crew[h].shortname;
                  crewPosition.Name = cabinReportLocalEdits[i].crew[h].name;
                  crewPosition.Position = cabinReportLocalEdits[i].crew[h].position;
                  crewPosition.IsManual = false;
                  IsNew = false;

                  for (var k = 0; k < cabinReportLocalEdits[i].CCMSCrewPositions.length; k++) {
                    if (flight.crew[h].aimsId == cabinReportLocalEdits[i].CCMSCrewPositions[k].CrewId) {
                      crewPosition.CCMS = cabinReportLocalEdits[i].CCMSCrewPositions[k].CCMS;
                      crewPosition.CrewComments = cabinReportLocalEdits[i].CCMSCrewPositions[k].CrewComments;
                      crewPosition.AdditionalFeedbackId = cabinReportLocalEdits[i].CCMSCrewPositions[k].AdditionalFeedbackId;
                      crewPosition.Route = cabinReportLocalEdits[i].Route;

                      if (crewPosition.CCMS == null) {
                        IsNew = true;
                      }

                      break;
                    }
                  }

                  if (IsNew) {
                    changeStatus = true;
                  }

                  newCCMSCrewPositions.push(crewPosition);
                }
              }

              if (changeStatus) {
                cabinReportLocalEdits[i].Status = "draft";
              }

              cabinReportLocalEdits[i].CCMSCrewPositions = newCCMSCrewPositions.concat(manualCCMSCrewPositions);
            }
          }

          CabinReportLocalEditFactory.setCabinReportsToStorage(cabinReportLocalEdits);
        }
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('SynchCtrl', SynchCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name SynchCtrl
  * @description 
  *  Manage Sync View
  * @ngInject
  */

  function SynchCtrl($scope, $uibModalInstance, UserFactory, CabinReportLocalEditFactory, SyncAPIService, SyncLogFactory, ReportGuidFactory, CabinReportSyncResultFactory, DataCleanerFactory, MessageFactory, CrewAssessmentFactory, AssessmentSyncResultFactory, SettingsMain, $route, $timeout, MemoFactory, FlightFactory, CabinReportRestoreFactory, CampaignFactory, LuggageComplianceFactory, SaAssessmentSyncResultFactory, SaCrewAssessmentFactory) {
    var IsAssessmentEnabled = SettingsMain.getIsAssessmentEnabled();
    var user = UserFactory.getUser();
    var lastLog = SyncLogFactory.getSyncLog();
    var reportstobesynched = CabinReportLocalEditFactory.getCabinReportLocalEditThatNeedToBeSynched();
    var isSA = false;
    var assessmentstobesynched = [];

    if (user.position == 'SA') {
      if (IsAssessmentEnabled) {
        isSA = true;
        assessmentstobesynched = CrewAssessmentFactory.getAssementsReadyToSend();
      }
    }

    $scope.syncResultsVisible = false;
    $scope.isSynching = false; // setup the grid

    $scope.syncTableData = reportstobesynched;
    $scope.IsSA = isSA;
    $scope.IsFA = user.position == 'FA'; // get the last sync date

    $scope.isFirstSync = false;
    $scope.isTooOldSync = false;
    $scope.lastSyncDate = '-';
    $scope.syncVersion = '1.3'; // get the report credits

    $scope.reportCredits = ReportGuidFactory.getRemainingReportGuids(); // display the number of reports to synch

    $scope.number_of_reports_to_sync = $scope.syncTableData.length;
    $scope.syncAssessmentTableData = assessmentstobesynched;
    $scope.number_of_assessments_to_sync = $scope.syncAssessmentTableData.length;
    $scope.syncSaAssessmentTableData = SaCrewAssessmentFactory.getAssementsReadyToSend();
    $scope.number_of_sa_assessments_to_sync = $scope.syncSaAssessmentTableData.length;
    $scope.lotterySyncResultsData = [];
    $scope.lotterySyncSuccesses = 0;
    $scope.lotterySyncFailures = 0;

    if (lastLog == null) {
      $scope.isFirstSync = true;
    } else {
      if (lastLog.date != null) {
        $scope.lastSyncDate = new Date(lastLog.date).toUTC().toString('dd-MM-yyyy HH:mm') + ' UTC';
        if (Date.today().add(-3).days().toUTC().isAfter(new Date(lastLog.date).toUTC())) $scope.isTooOldSync = true;
      }

      if (lastLog.version != null) $scope.syncVersion = lastLog.version;
    }

    $scope.doSynch = doSynch;
    $scope.ok = ok;
    $scope.cancel = cancel;
    $scope.showReportSyncResults = showReportSyncResults;
    $scope.showAssessmentSyncResults = showAssessmentSyncResults;
    $scope.showSaAssessmentSyncResults = showSaAssessmentSyncResults;
    $scope.showLotterySyncResults = showLotterySyncResults;
    $scope.syncResultsOk = syncResultsOk;
    $scope.showSynchError = showSynchError;
    /**
    * Start Synch functionality
    * @memberof SynchCtrl
    */

    function doSynch() {
      //Save reports to indexedDB before the sync
      CabinReportRestoreFactory.backUpReports(); //waiting for memoIds before we sync

      MemoFactory.getStoredMemosIds(function (memoIdsToSend) {
        // get the user
        var user = UserFactory.getUser(); // call the remote service for data

        var q = SyncAPIService.doSync(user.aimsId, memoIdsToSend);
        $scope.isSynching = true;
        q.then(function (response) {
          $scope.isSynching = false;

          if ($scope.number_of_reports_to_sync > 0) {
            $scope.showReportSyncResults('synched');
          } else {
            $scope.showReportSyncResults('synched-no-send');
          }

          $scope.showAssessmentSyncResults();
          $scope.showSaAssessmentSyncResults();
          $scope.showLotterySyncResults(response.lotterySyncSummary);
          DataCleanerFactory.deleteSynchedLocalCabinReports();
          DataCleanerFactory.deleteOrphanedLocalReports();
          DataCleanerFactory.deleteOrphanedCustomerEvents();
          SyncAPIService.updateCabinReportLocalEditFromSynch();
          FlightFactory.initializeFlights();
          MemoFactory.markGroundDutiesUnread();
          $scope.campaigns = CampaignFactory.syncResultFormat(response.data.data.SyncCabinData.Campaigns);
          $scope.luggageCompliance = LuggageComplianceFactory.syncResultFormat(response.data.data.SyncCabinData.LuggageCompliance);
        });
        q["catch"](function (err) {
          $scope.isSynching = false;

          if (err.status == -1) {
            $scope.errorName = "There were problems during the server synchronization. Please try again.";
          } else if (err.status != 401) {
            // if an error was encountered display an error message
            $scope.errorName = "Could not reach the remote server. Please connect to the Internet and try again.";
          } else {
            $uibModalInstance.close('');
          }
        });
      });
    }
    /**
    * show Report Sync Results
    * @memberof SynchCtrl
    */


    function showReportSyncResults() {
      $scope.syncResultsVisible = true; // get the sync results

      $scope.syncResultsTableData = CabinReportSyncResultFactory.getCabinReportSyncResultsFromStorage();
      $scope.syncSuccesses = CabinReportSyncResultFactory.getSuccesses($scope.syncResultsTableData);
      $scope.syncFailures = CabinReportSyncResultFactory.getFailures($scope.syncResultsTableData);

      if ($scope.syncResultsTableData != null) {
        $scope.reports_to_sync = $scope.syncResultsTableData.length;
      } else {
        $scope.reports_to_sync = 0;
      }

      if ($scope.syncSuccesses == 1) {
        $scope.sync_successes_descr = 'Cabin Report was';
      } else {
        $scope.sync_successes_descr = 'Cabin Reports were';
      }

      if ($scope.syncFailures == 1) {
        $scope.sync_failures_descr = 'Cabin Report was';
      } else {
        $scope.sync_failures_descr = 'Cabin Reports were';
      }

      $scope.unreadMessages = MessageFactory.getCountOfUnreadMessages();
    }
    /**
    * show Assessment Sync Results
    * @memberof SynchCtrl
    */


    function showAssessmentSyncResults() {
      $scope.syncResultsVisible = true; // get the sync results

      $scope.syncAssessmentResultsTableData = AssessmentSyncResultFactory.getAssessmentSyncResultsFromStorage();
      $scope.syncAssessmentSuccesses = AssessmentSyncResultFactory.getSuccesses($scope.syncAssessmentResultsTableData);
      $scope.syncAssessmentFailures = AssessmentSyncResultFactory.getFailures($scope.syncAssessmentResultsTableData);

      if ($scope.syncAssessmentResultsTableData != null) {
        $scope.assessments_to_sync = $scope.syncAssessmentResultsTableData.length;
      } else {
        $scope.assessments_to_sync = 0;
      }

      if ($scope.syncAssessmentSuccesses == 1) {
        $scope.sync_assessment_successes_descr = 'Crew Feedback was';
      } else {
        $scope.sync_assessment_successes_descr = 'Crew Feedbacks were';
      }

      if ($scope.syncAssessmentFailures == 1) {
        $scope.sync_assessment_failures_descr = 'Crew Feedbacks was';
      } else {
        $scope.sync_assessment_failures_descr = 'Crew Feedbacks were';
      }
    }
    /**
    * show SA Assessment/Feedbacks Sync Results
    * @memberof SynchCtrl
    */


    function showSaAssessmentSyncResults() {
      $scope.syncResultsVisible = true; // get the sync results

      $scope.syncSaAssessmentResultsTableData = SaAssessmentSyncResultFactory.getAssessmentSyncResultsFromStorage();
      $scope.syncSaAssessmentSuccesses = SaAssessmentSyncResultFactory.getSuccesses($scope.syncSaAssessmentResultsTableData);
      $scope.syncSaAssessmentFailures = SaAssessmentSyncResultFactory.getFailures($scope.syncSaAssessmentResultsTableData);

      if ($scope.syncSaAssessmentResultsTableData != null) {
        $scope.sa_assessments_to_sync = $scope.syncSaAssessmentResultsTableData.length;
      } else {
        $scope.sa_assessments_to_sync = 0;
      }

      if ($scope.syncAssessmentSuccesses == 1) {
        $scope.sync_assessment_successes_descr = 'Crew Feedback was';
      } else {
        $scope.sync_assessment_successes_descr = 'Crew Feedbacks were';
      }

      if ($scope.syncAssessmentFailures == 1) {
        $scope.sync_assessment_failures_descr = 'Crew Feedbacks was';
      } else {
        $scope.sync_assessment_failures_descr = 'Crew Feedbacks were';
      }
    }
    /**
    * Show Lottery Sync Results
    * @memberof SynchCtrl
    */


    function showLotterySyncResults(summary) {
      $scope.syncResultsVisible = true;
      $scope.lotterySyncResultsData = summary || [];
      $scope.lotterySyncSuccesses = $scope.lotterySyncResultsData.filter(function (r) {
        return r.Success || r.IsDuplicate;
      }).length;
      $scope.lotterySyncFailures = $scope.lotterySyncResultsData.filter(function (r) {
        return !r.Success && !r.IsDuplicate;
      }).length;
    }
    /**
    * Close sync Result modal and update cache.
    * @memberof SynchCtrl
    */


    function syncResultsOk() {
      $uibModalInstance.close('synched');
      $route.reload(); // get cache
    }
    /**
    * Show submision sync error
    * @memberof SynchCtrl
    */


    function showSynchError(message) {
      bootbox.dialog({
        message: message,
        title: "<strong>Submission error<strong>",
        buttons: {
          cancel: {
            label: "OK",
            className: "btn-default",
            callback: function callback() {}
          }
        }
      });
    }
    /**
    * Close  modal and update cache.
    * @memberof SynchCtrl
    */


    function cancel() {
      $uibModalInstance.close('cancel'); // get cache
    }
    /**
    * Close  modal
    * @memberof SynchCtrl
    */


    function ok() {
      $uibModalInstance.close('');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('SyncLogFactory', SyncLogFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name SyncLogFactory
  * @description 
  *  Add, update or delete synchronization log
  * @ngInject
  */

  function SyncLogFactory($log, GenericService) {
    /**
    * Initialize the Sync Log
    * @memberof SyncLogFactory
    */
    function SyncLog() {
      var self = this;
      this.userAimsId = null;
      this.date = null;
      this.version = null;
      this.lastShow = null;
      this.isUpdated = false;
      this.lastScheduleDate = null;
      this.forceSync = false; //showing the sync dialog

      this.canShowSync = function () {
        var can = false;
        if (this.lastShow == null) can = true;else if (new Date().add(-10).minutes().toUTC().isAfter(new Date(this.lastShow).toUTC())) {
          can = true;
        }
        return can;
      };
    }

    var objType = 'syncLog';
    var objCallback = SyncLog;
    var service = {
      getSyncLog: getSyncLog,
      setSyncLog: setSyncLog,
      updateSyncVersion: updateSyncVersion,
      setLastShow: setLastShow,
      clearSyncLog: clearSyncLog,
      getLastScheduleDate: getLastScheduleDate,
      setLastScheduleDate: setLastScheduleDate,
      forceSync: forceSync
    };
    /**
     * Get Sync Log
     * @memberof SyncLogFactory
     * @return {object} syncLog  
     */

    function getSyncLog() {
      return GenericService.getOne(objType, objCallback);
    }
    /**
     * Set Sync Log
     * @memberof SyncLogFactory
     * @param {string} userAimsId 
     * @param {string} version 
     * @param {string} lastScheduleDate  
     */


    function setSyncLog(userAimsId, version, lastScheduleDate) {
      var newLog = new SyncLog();
      newLog.userAimsId = userAimsId;
      newLog.date = new Date();
      newLog.version = version;
      newLog.lastShow = new Date();
      newLog.isUpdated = false;
      newLog.forceSync = false;
      newLog.lastScheduleDate = new Date(lastScheduleDate).getTime();
      GenericService.saveOne(newLog, objType, objCallback);
    }
    /**
    * Update Sync Log version
    * @memberof SyncLogFactory
    * @param {string} version 
    */


    function updateSyncVersion(version) {
      var syncLog = SyncLog.getSyncLog();
      syncLog.version = version;
      syncLog.isUpdated = true;
      GenericService.saveOne(syncLog, objType, objCallback);
    }
    /**
     * Set last show of molal
     * @memberof SyncLogFactory
     */


    function setLastShow() {
      var log = getSyncLog();
      if (log == null) log = new SyncLog();
      log.lastShow = new Date();
      GenericService.saveOne(log, objType, objCallback);
    }
    /**
    * Clear Sync Log
    * @memberof SyncLogFactory
    */


    function clearSyncLog() {
      GenericService.removeAll(objType, objCallback);
    }
    /**
     * Get Last Schedule Date
     * @memberof SyncLogFactory
     * @return {string} date 
     */


    function getLastScheduleDate() {
      var syncLog = getSyncLog();

      if (syncLog == null) {
        return null;
      } else {
        return syncLog.lastScheduleDate;
      }
    }
    /**
     * Set Last Schedule Date
     * @memberof SyncLogFactory
     * @param {string} date 
     */


    function setLastScheduleDate(date) {
      var log = getSyncLog();
      if (log == null) log = new SyncLog();
      log.lastScheduleDate = date;
      GenericService.saveOne(log, objType, objCallback);
    }
    /**
     * Forces Sync Modal to appear
     * @memberof SyncLogFactory
     */


    function forceSync() {
      var syncLog = getSyncLog();
      syncLog.forceSync = true;
      GenericService.saveOne(syncLog, objType, objCallback);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.service("SWUpdateService", SWUpdateService);
  /**
  * @memberof CabinReports
  * @ngdoc service
  * @name SWUpdateService
  * @description 
  *  manages the service-worker update
  * @ngInject
  */

  function SWUpdateService(LogService) {
    /**
     * initialize service worker
     * @memberof SWUpdateService
     */
    function initialize() {
      // Delay registration until after the page has loaded
      window.addEventListener('load', function () {
        //kill switch. uncomment this and comment out everything else sw related
        // navigator.serviceWorker.getRegistrations().then(function (registrations) {
        //     //returns installed service workers
        //     if (registrations.length) {
        //       for(var registration of registrations) {
        //         registration.unregister();
        //       }
        //     }
        // });
        //register the service worker and work with the promise it returns
        navigator.serviceWorker.register('service-worker.js').then(function (reg) {
          // use a variable to make sure we refresh the page only once
          var refreshing; //fires when a new Service Worker takes control of the current page (refreshes the page)

          navigator.serviceWorker.addEventListener('controllerchange', function () {
            if (refreshing) return;
            refreshing = true;
            window.location.reload();
          });
        })["catch"](function (e) {
          LogService.error(e, 'Tried to register the service worker');
        });
      });
    }
    /**
     * poll the server for new service worker file (new app version)
     * @memberof SWUpdateService
     */


    function checkUpdates(reg) {
      if (reg == null) return; //ask server for new service worker

      reg.update();
    }
    /**
     * If new service worker has been waiting too long, force update
     * @memberof SWUpdateService
     */


    function checkVersionExpiration(reg) {
      if (reg == null) return;
      reg.waiting.postMessage('checkVersionExpiration');
    }
    /**
     * Activate the new service worker that was waiting
     * @memberof SWUpdateService
     */


    function update(reg) {
      reg.waiting.postMessage('skipWaiting');
    }

    return {
      initialize: initialize,
      checkUpdates: checkUpdates,
      checkVersionExpiration: checkVersionExpiration,
      update: update
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('SearchFlightsCtrl', SearchFlightsCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name SearchFlightsCtrl
  * @description 
  *   Search Flight info modal
  * @ngInject
  */

  function SearchFlightsCtrl($scope, $uibModalInstance, $route, $location, defaultCalendarDate, SearchFlightsFactory, GroundDutyFactory, FlightFactory) {
    $scope.showContent = 'search';
    $scope.hasError = false;
    $scope.flightFound = null;
    $scope.searchFlights = searchFlights;
    $scope.searchCriteriaContent = searchCriteriaContent;
    $scope.closeModal = closeModal;
    $scope.gotoSelectedFlightInfo = gotoSelectedFlightInfo;
    $scope.validationFormError = '';
    $scope.hasPublishedRoster = true; //Date picker:

    $scope.openDatepicker = openDatepicker;
    var today = new Date().toUTC();

    if (defaultCalendarDate) {
      today = new Date(defaultCalendarDate).toUTC();
    }

    function openDatepicker() {
      $scope.searchCriteria.flightDatePicker.opened = true;
    }

    updateSearchCriteriaScope();

    function updateSearchCriteriaScope() {
      var fromDate = null;
      var toDate = null;
      var groundDutyDates = GroundDutyFactory.getFirstAndLastDateOfGroundDuties();
      var flightDates = FlightFactory.getTheFirstAndTheLastFlightDates();

      if (groundDutyDates && flightDates && groundDutyDates.firstDate && flightDates.firstDate) {
        fromDate = groundDutyDates.firstDate < flightDates.firstDate ? groundDutyDates.firstDate : flightDates.firstDate;
        toDate = groundDutyDates.lastDate > flightDates.lastDate ? groundDutyDates.lastDate : flightDates.lastDate;
      } else if (flightDates && flightDates.firstDate) {
        fromDate = flightDates.firstDate;
        toDate = flightDates.lastDate;
      } else if (groundDutyDates && groundDutyDates.firstDate) {
        fromDate = groundDutyDates.firstDate;
        toDate = groundDutyDates.lastDate;
      } else {
        $scope.hasPublishedRoster = false;
        $scope.showContent = "results";
        $scope.hasError = true;
      }

      $scope.searchCriteria = {
        flightDatePicker: {
          value: today,
          format: 'dd-MM-yyyy',
          opened: false,
          options: {
            minDate: fromDate,
            maxDate: toDate
          }
        },
        flightNo: "",
        departure: "",
        arrival: ""
      };
    }

    function searchFlights() {
      $scope.hasError = false;

      if ($scope.searchCriteria.flightNo.length == 0 && $scope.searchCriteria.departure.length == 0 && $scope.searchCriteria.arrival.length == 0) {
        $scope.validationFormError = 'Ensure that at least one optional value is provided.';
      } else {
        $scope.showContent = 'loading';
        SearchFlightsFactory.getFlights($scope.searchCriteria).then(function (res) {
          return handleResponse(res);
        })["catch"](function (res) {
          return handleFailedResponse(res);
        });
      }
    }

    function handleResponse(res) {
      $scope.showContent = 'results';

      if (res.data && res.data.success && res.data.data) {
        $scope.flightsFound = res.data.data; //auto redirect when only one flight in results:
        // if($scope.flightsFound.lenght == 1){
        //     gotoSelectedFlightInfo($scope.flightsFound[0].flightId, $scope.flightsFound[0].flightDate, $scope.flightsFound[0].flightNo, $scope.flightsFound[0].departure);
        // }
      } else {
        $scope.hasError = true;
      }
    }

    function handleFailedResponse(res) {
      $scope.showContent = 'results';
      $scope.hasError = true;
    }

    function searchCriteriaContent() {
      $scope.showContent = 'search';
    }
    /**
     * Redirect to selected flight info
     */


    function gotoSelectedFlightInfo(flightId, flightDate, flightNo, departure) {
      closeModal();
      $location.path('/selectedflightinfo/' + flightId + '/' + flightDate + '/' + flightNo + '/' + departure);
    }
    /**
     * Close the modal
     * @memberof SearchPastGDCtrl
     */


    function closeModal() {
      $uibModalInstance.close('cancel');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('SearchFlightsFactory', SearchFlightsFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name SearchFlightsFactory
  * @description 
  * Get selected flight info
  * @ngInject
  */

  function SearchFlightsFactory($http, $q, apiUrl, $timeout) {
    var service = {
      getFlights: getFlights,
      getFlightInfo: getFlightInfo
    };

    function getFlights(criteria, callback) {
      //test UI:
      //return getFlightsDummy(criteria)
      var flightDate = criteria.flightDatePicker.value.toString('yyyy-MM-dd');
      var uri = encodeURI(apiUrl + '/SearchFlights/GetFlights?flightDate=' + flightDate + '&flightNo=' + criteria.flightNo + '&departure=' + criteria.departure + '&arrival=' + criteria.arrival);
      return $http.get(uri, {
        'Content-Type': 'application/json'
      })["catch"](callback);
    }

    function getFlightInfo(flightId, flightDate, flightNo, departure, callback) {
      var flightDateStr = flightDate.toString('yyyy-MM-dd'); // $http({
      //     url: apiUrl + '/SearchFlights/GetFlightInfo', 
      //     method: "GET",
      //     contentType: "application/json",
      //     params: {flightId: flightId, flightDate: flightDateStr, flightNo: flightNo, departure: departure}
      //  });

      var uri = encodeURI(apiUrl + '/SearchFlights/GetFlightInfo?flightId=' + flightId + '&flightDate=' + flightDateStr + '&flightNo=' + flightNo + '&departure=' + departure);
      return $http.get(uri, {
        'Content-Type': 'application/json'
      })["catch"](callback);
    }

    function getFlightsDummy(criteria) {
      // Create a deferred object to handle the promise
      var deferred = $q.defer(); // Simulate an asynchronous operation (e.g., API call) with a delay

      $timeout(function () {
        var flightDate = criteria.flightDatePicker.value.toString('yyyy-MM-dd'); // Simulate getting flight data asynchronously

        var testSuccessResults = {
          data: getDummyFlightResults(),
          success: true,
          errorMessage: ""
        }; // Resolve the promise with the retrieved data

        deferred.resolve(testSuccessResults);
      }, 2000); // Return the promise

      return deferred.promise;
    }

    function getDummyFlightResults() {
      return {
        "FlightsFound": [{
          "Id": 1,
          "FlightNo": "A3123",
          "FlightDate": "2023-10-20T00:00:00",
          "Registration": "AAA-OK1",
          "STD": "2023-10-20T08:00:00",
          "STA": "2023-10-20T12:00:00",
          "Departure": "ATH",
          "Arrival": "SKG"
        }, {
          "Id": 2,
          "FlightNo": "A3789",
          "FlightDate": "2023-10-21T00:00:00",
          "Registration": "AAA-OK2",
          "STD": "2023-10-21T15:30:00",
          "STA": "2023-10-21T19:30:00",
          "Departure": "SKG",
          "Arrival": "ATH"
        }, {
          "Id": 3,
          "FlightNo": "OA456",
          "FlightDate": "2023-10-22T00:00:00",
          "Registration": "CCC-OK3",
          "STD": "2023-10-22T10:15:00",
          "STA": "2023-10-22T14:15:00",
          "Departure": "ATH",
          "Arrival": "SKG"
        }]
      };
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('SelectedFlightCtrl', SelectedFlightCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name SelectedFlightCtrl
  * @description 
  *   Show selected Flight info page
  * @ngInject
  */

  function SelectedFlightCtrl($scope, $routeParams, defaultCalendarDate, SearchFlightsFactory, $timeout, waterUpliftSupportingAcTypes) {
    //get value from routeParams:
    var flightId = $routeParams.flightId;
    var flightDate = $routeParams.flightDate;
    var flightNo = $routeParams.flightNo;
    var departure = $routeParams.departure;
    window.addEventListener('online', function (e) {
      $timeout(checkConnectionStatus());
    });
    $scope.init = checkConnectionStatus();
    $scope.contentToShow = "loading";
    $scope.flightInfo = null;
    $scope.hasFlightInfo = false;
    $scope.pilotCrewMembers = [];
    $scope.cabinCrewMembers = [];
    $scope.dhcCrewMembers = [];
    $scope.waterQuantity = null;
    $scope.supportsWaterUpliftAcType = false;
    $scope.crewRouteInfoPanel = {
      hasAircraftPositions: true,
      crewRouteDuties: []
    };
    /**
     * Checks if the client is online or offline 
     * @memberof SelectedFlightCtrl  
     */

    function checkConnectionStatus() {
      var isOnline = window.navigator.onLine;

      if (isOnline) {
        getFlightInfo();
      } else {
        showError("Please check your internet connection!");
      }
    }

    function getFlightInfo() {
      SearchFlightsFactory.getFlightInfo(flightId, flightDate, flightNo, departure).then(function (res) {
        return handleResponse(res);
      })["catch"](function (res) {
        return handleFailedResponse(res);
      });
    }

    function handleResponse(res) {
      if (res.data.success) {
        if (res.data.data && res.data.data.Flight) {
          $scope.flightInfo = res.data.data;
          updateFlightInfoScopes(res.data.data);
          updateCrewMembersScopes();
          updatePaxPanelScopes();
          $scope.contentToShow = 'results';
          $scope.hasFlightInfo = true;
        } else {
          showError("Flight Info not found.");
        }
      } else {
        showError(res.data.errorMessage);
      }
    }

    function handleFailedResponse(res) {
      $scope.contentToShow = 'results';
      $scope.hasError = true;
      showError(res.errorMessage);
    }
    /**
     * Displays the error message
     * @memberof SelectedFlightCtrl  
     * @param {string} message message to display
     */


    function showError(message) {
      $scope.contentToShow = "error";
      $scope.errorMessage = message;
    }

    function updateCrewMembersScopes() {
      $scope.pilotCrewMembers = $scope.flightInfo.CrewInfo.filter(function (x) {
        return (x.PositionCode == 'CP' || x.PositionCode == "FO") && !x.DHC;
      });
      $scope.cabinCrewMembers = $scope.flightInfo.CrewInfo.filter(function (x) {
        return (x.PositionCode == 'SA' || x.PositionCode == "FA") && !x.DHC;
      });
      $scope.dhcCrewMembers = $scope.flightInfo.CrewInfo.filter(function (x) {
        return x.DHC;
      });
    }

    function updatePaxPanelScopes() {
      $scope.supportsWaterUpliftAcType = waterUpliftSupportingAcTypes.includes($scope.flightInfo.AcType);
      getWaterQuantity();
    }

    function getWaterQuantity() {
      var totalPax = $scope.flightInfo.Flight.BOOKED_C + $scope.flightInfo.Flight.BOOKED_Y;
      var startDate = moment($scope.flightInfo.Flight.STD);
      var endDate = moment($scope.flightInfo.Flight.STA);
      var duration = moment.duration(endDate.diff(startDate)).asHours();
      var waterQuantity = (0, 18 * totalPax * duration) / 200;
      var formattedwaterQuantity = waterQuantity.toString().substring(0, 4);
      $scope.waterQuantity = formattedwaterQuantity;

      if (waterQuantity) {
        $scope.supportsWaterUpliftAcType = true;
      }
    }

    function updateFlightInfoScopes(flightInfoObj) {
      var flight = {};
      flight.showPreviousAcPos = true;
      flight.showNextAcPos = true;
      flight.hasChangeAircraft = false;
      flight.DutyType = 'Flight';
      flight.FlightId = flightInfoObj.Flight.FlightId;
      flight.FlightNo = flightInfoObj.Flight.FlightNo;
      flight.Departure = flightInfoObj.Flight.DEP;
      flight.Arrival = flightInfoObj.Flight.ARR;
      flight.AcTailNo = flightInfoObj.Flight.Registration;
      flight.AcType = flightInfoObj.Flight.AcType;
      flight.DepartureStand = flightInfoObj.Flight.DEPSTAND;
      flight.ArrivalStand = flightInfoObj.Flight.ARRSTAND;
      flight.BookedC = flightInfoObj.Flight.BOOKED_C;
      flight.BookedY = flightInfoObj.Flight.BOOKED_Y;
      flight.ScheduledDeparture = flightInfoObj.Flight.STD;
      var STD = new Date(flight.ScheduledDeparture);
      flight.ScheduledDepartureDateUTC = STD.toString('yyyy-MM-dd');
      flight.ScheduledDepartureTimeUTC = STD.toString('HH:mm');
      flight.ScheduledArrival = flightInfoObj.Flight.STA;
      flight.CTOT = flightInfoObj.Flight.CTOT;
      flight.ETD = flightInfoObj.Flight.ETD;
      flight.ATD = flightInfoObj.Flight.ATD;
      flight.ETA = flightInfoObj.Flight.ETA;
      flight.ATA = flightInfoObj.Flight.ATA;
      flight.DepartureCountryISO = flightInfoObj.Flight.DepartureCountryISO;
      flight.ArrivalCountryISO = flightInfoObj.Flight.ArrivalCountryISO;
      flight.DepartureEU = flightInfoObj.Flight.DepartureEU;
      flight.ArrivalEU = flightInfoObj.Flight.ArrivalEU;
      flight.DepartureSchengen = flightInfoObj.Flight.DepartureSchengen;
      flight.ArrivalSchengen = flightInfoObj.Flight.ArrivalSchengen;
      var diffMin = Date.DifferenceInMinutes(flight.ScheduledDeparture, flight.ScheduledArrival);
      flight.BTime = Date.MinutesToStringSimple(diffMin);
      flight.Delay = moment(flight.ATD).diff(moment(flight.ScheduledDeparture), 'minutes') || "";
      flight.ArrDelay = moment(flight.ATA).diff(moment(flight.ScheduledArrival), 'minutes') || "";
      flight.flightDelays = {};
      flight.flightDelays.TotalDelay = flightInfoObj.FlightDelays.TotalDelay;
      flight.flightDelays.UnJustified = flightInfoObj.FlightDelays.UnJustified;
      flight.flightDelays.DC93 = flightInfoObj.FlightDelays.DC93;
      flight.flightDelays.DC9 = flightInfoObj.FlightDelays.DC9; //flight.crewMeals : no info

      flight.aircaftPositions = flightInfoObj.AircaftPositions;
      $scope.crewRouteInfoPanel.crewRouteDuties.push(flight);
    }
  }
})();
"use strict";

(function () {
  a3_cabin_reports.directive('traineeSyllabus', traineeSyllabus);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name traineeSyllabus
  * @restrict E
  * @description
  *   Initialize read only view of submitted syllabus
  * @example
  *   Usage:
  *   <trainee-syllabus></trainee-syllabus>
  * @ngInject
  */

  function traineeSyllabus() {
    function link(scope) {
      setSyllabus(scope.traineeSession);

      function setSyllabus(traineeSession) {
        var traineeSessionItems = [];
        scope.phase.Syllabus.ActiveVersion.SyllabusItems.forEach(function (item) {
          if (item.Active == true) {
            var syllabusItem = JSON.parse(JSON.stringify(item));
            syllabusItem.Tries = [];
            syllabusItem.Selected = false;
            var relatedSessionItem = null;

            if (scope.type == "signature") {
              relatedSessionItem = traineeSession.Items.find(function (x) {
                return x.Id == syllabusItem.Id;
              });
            } else {
              relatedSessionItem = traineeSession.Items.find(function (x) {
                return x.SyllabusItemId == syllabusItem.Id;
              });
            }

            if (relatedSessionItem) {
              syllabusItem.Selected = true;
              syllabusItem.Tries = relatedSessionItem.Tries;
              syllabusItem.hasRemarks = relatedSessionItem.Tries.some(function (x) {
                return x.Comments && x.Comments.length > 0;
              }) || relatedSessionItem.Tries.some(function (t) {
                return t.TryGrading.Competences.some(function (x) {
                  return x.Comments && x.Comments.length > 0;
                });
              });
              syllabusItem.Tries.forEach(function (attempt) {
                attempt.Selected = true;
              });
            }

            if (scope.type == "signature") {
              setPanelStyleByProgress(syllabusItem);
            } else {
              setPanelStyleBySelected(syllabusItem);
            }

            traineeSessionItems.push(syllabusItem);
          }
        });
        scope.traineeSession.ItemsGrouped = [];
        scope.traineeSession.ItemsGrouped = SyllabusGrouping(traineeSessionItems);
      }

      function setPanelStyleByProgress(item) {
        var historyTriesCount = item.Tries.length;
        var newTriesCount = item.Tries.filter(function (x) {
          return !x.isReadOnly && x.Selected;
        }).length;
        item.TriesPerformedCount = historyTriesCount + newTriesCount;
        var completedItem = item.TriesPerformedCount >= item.MandatoryCount;

        if (item.MandatoryCount == 0) {
          //non-mandatory items are considered completed if performed at least once
          completedItem = item.TriesPerformedCount >= 1;
        }

        if (completedItem) {
          item.PanelClass = 'panel-green panel-border-left-green ';
        } else {
          item.PanelClass = 'panel-border-left-blue ';
        }
      }

      function setPanelStyleBySelected(item) {
        var historyTriesCount = item.Tries.length;
        item.TriesPerformedCount = historyTriesCount;
        var completedItem = item.TriesPerformedCount >= item.Mandatory;

        if (completedItem) {
          item.PanelClass = 'panel-green panel-border-left-green ';
        } else {
          item.PanelClass = 'panel-border-left-blue ';
        }
      }

      function SyllabusGrouping(items) {
        //Syllabus Items Group By 'GroupId'
        var syllabusGroups = [];
        items.forEach(function (item) {
          if (!syllabusGroups.some(function (x) {
            return x.Id == item.SelectedGroup.Id;
          })) {
            if (!item.SelectedGroup) {
              item.SelectedGroup = {
                Id: 0,
                Title: 'General'
              };
            }

            var syllabusGroup = {
              Id: item.SelectedGroup.Id,
              Title: item.SelectedGroup.Title ? item.SelectedGroup.Title : 'General',
              Items: []
            };
            syllabusGroup.Items.push(item);
            syllabusGroups.push(syllabusGroup);
          } else {
            syllabusGroups.filter(function (x) {
              return x.Id == item.SelectedGroup.Id;
            })[0].Items.push(item);
          }
        });
        return syllabusGroups;
      }
    }

    return {
      restrict: 'E',
      templateUrl: 'views/TraineeCourse/trainee-syllabus.tpl.html',
      scope: {
        phase: "=",
        traineeSession: "=",
        type: "="
      },
      terminal: true,
      link: link
    };
  }
})();
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

(function () {
  'use strict';

  a3_cabin_reports.controller('TraineeCourseCtrl', TraineeCourseCtrl);
  /**
      * @memberof CabinReports
      * @ngdoc controller
      * @name TraineeCourseCtrl
      * @description 
      *
      * @ngInject
      */

  function TraineeCourseCtrl($scope, $routeParams, TraineeCoursesDetailsFactory, TrainingSessionFactory, $location) {
    var traineeCourseId = Number($routeParams.traineeCourseId);
    $scope.hasError = false;
    $scope.isLoading = true;
    $scope.courseDate = $routeParams.date;
    $scope.isTraineeView = true;
    $scope.gotoCalendar = gotoCalendar;
    $scope.setSelectedPhase = setSelectedPhase;
    $scope.responseObj = {
      success: false,
      message: '',
      Results: []
    };
    $scope.results = [];
    $scope.showWarning = false;
    TraineeCoursesDetailsFactory.getTraineeCourse(traineeCourseId).then(function (res) {
      return handleSubmitResponse(res);
    })["catch"](function (res) {
      return handleFailedResponse(res);
    });

    function handleSubmitResponse(res) {
      $scope.responseObj = res;

      if (res.success) {
        $scope.traineeCourse = res.Results.data.traineeCourse;
        $scope.courseDetails = res.Results.data.courseDetails;
        $scope.traineeCourse.Phases.forEach(function (phase) {
          phase.StatusClass = '';

          if (phase.PhaseStatus == 'InProgress') {
            phase.StatusClass = "border-left-blue";
            phase.TextClass = "text-blue";
            phase.BtnClass = "bg-blue text-white";
          } else if (phase.PhaseStatus == 'Pending') {
            phase.StatusClass = "border-left-gray ";
            phase.TextClass = "text-gray";
            phase.BtnClass = "bg-gray text-white";
          } else if (phase.PhaseStatus == 'Completed') {
            phase.StatusClass = "border-left-green";
            phase.TextClass = "text-green";
            phase.BtnClass = "bg-green text-white";
          }
        });
        $scope.traineeCourse.Phases.forEach(function (phase) {
          phase.Sessions.forEach(function (sessionTrainee) {
            if (sessionTrainee) {
              $scope.traineeSession = sessionTrainee;
              $scope.traineeSession.hasDayGrading = sessionTrainee.DayGrading.Comments || sessionTrainee.DayGrading.GradeType != 'NotSet' && sessionTrainee.DayGrading.Grade || sessionTrainee.DayGrading.Competences.length > 0;
              $scope.traineeSession.hasReleaseGrading = sessionTrainee.ReleaseGrading.Comments || sessionTrainee.ReleaseGrading.GradeType != 'NotSet' && sessionTrainee.ReleaseGrading.Grade || sessionTrainee.ReleaseGrading.Competences.length > 0;
              $scope.traineeSession.AcTypes = [];
              $scope.traineeSession.AcTypes = _toConsumableArray(new Set($scope.traineeSession.Sectors.map(function (ses) {
                return ses.AcType;
              }))); //GroupBy AcType

              $scope.traineeSession.SectorsByAcType = [];
              $scope.traineeSession.AcTypes.forEach(function (acType) {
                var group = {
                  AcType: acType,
                  Sectors: $scope.traineeSession.Sectors.filter(function (x) {
                    return x.AcType == acType;
                  })
                };
                $scope.traineeSession.SectorsByAcType.push(group);
              });
            } else {
              trainee.Session = {
                Released: course.selectedPhase.ModuleType == "Training" ? false : true,
                CrewId: trainee.CrewId,
                Items: [],
                Absent: false,
                DayGrading: {
                  Comments: null,
                  Grade: null,
                  Competences: []
                },
                ReleaseGrading: {
                  Comments: null,
                  Grade: null,
                  Competences: []
                },
                NeedsAdditionalTraining: false,
                AdditionalTrainingRemarks: null,
                CompleteAdditionalTraining: false
              };
            }
          });
          getSelectedPhase($scope.traineeCourse);
          var phaseId = $scope.traineeCourse.Phases[0].PhaseId;
          initPhaseDetails(phaseId);
        });
      } else {
        $scope.showWarning = true;
        $scope.responseObj;
      }
    }

    function initPhaseDetails(phaseId) {
      $scope.selectedPhase = $scope.courseDetails.CoursePhases.find(function (x) {
        return x.Id == phaseId;
      });
      $scope.traineePhase = $scope.traineeCourse.Phases.find(function (x) {
        return x.PhaseId == phaseId;
      });
      $scope.selectedTraineePhase = $scope.courseDetails.CoursePhases.find(function (x) {
        return x.Id == phaseId;
      });
      $scope.traineeInstructions = $scope.selectedPhase.TraineeInstructions;
      $scope.examinerInstructions = $scope.selectedPhase.ExaminerInstructions;
      $scope.flatSullabusItems = [];
      $scope.traineeCourse.Phases.forEach(function (phase) {
        phase.Sessions.forEach(function (session) {
          session.Items.forEach(function (item) {
            var flatItem = TrainingSessionFactory.createFlatHistorySullabusItem($scope.traineeCourse, phase, session, item);
            $scope.flatSullabusItems.push(flatItem);
          });
        });
      });
      $scope.flatCourseSullabusItems = [];
      $scope.courseDetails.CoursePhases.filter(function (x) {
        return x.Syllabus;
      }).forEach(function (phase, index, array) {
        phase.Syllabus.ActiveVersion.SyllabusItems.forEach(function (syllabusItem) {
          var syllabusItemHistory = $scope.flatSullabusItems.filter(function (item) {
            return item.ItemId == syllabusItem.Id;
          });
          $scope.flatCourseSullabusItems.push(syllabusItemHistory);
        });
      });
      $scope.isLoading = false;
    }

    function handleFailedResponse(res) {
      $scope.hasError = true;
    }

    function getSelectedPhase(course) {
      var hasSelectedPhase = false;
      var phases = course.Phases;
      phases.forEach(function (phase, index, array) {
        phase.isFirst = index == 0;
        phase.isLast = index + 1 == array.length; // Select the first InProgress & selected phase

        if (!hasSelectedPhase && phase.Status == "InProgress" && phase.isSelected) {
          phase.Selected = true;
          hasSelectedPhase = true;
        }
      }); // Select the first InProgress phase

      if (!hasSelectedPhase && phases.some(function (x) {
        return x.Status == "InProgress";
      })) {
        phases.find(function (x) {
          return x.Status == "InProgress";
        }).Selected = true;
        hasSelectedPhase = true;
      }

      if (!hasSelectedPhase) {
        phases.find(function (x) {
          return x.isFirst;
        }).Selected = true;
      }

      $scope.selectedPhase = phases.find(function (x) {
        return x.Selected;
      });
      return $scope.selectedPhase;
    }

    function setSelectedPhase(phaseId) {
      $scope.selectedPhase = $scope.courseDetails.CoursePhases.find(function (x) {
        return x.Id == phaseId;
      });
      $scope.courseDetails.CoursePhases.find(function (x) {
        return x.Id == phaseId;
      }).Selected = true;
      initPhaseDetails(phaseId);
      return $scope.selectedPhase;
    }

    function gotoCalendar() {
      $location.path("/");
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('traineeCoursesDetails', traineeCoursesDetails);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name traineeCoursesDetails
  * @restrict E
  * @description
  *    Implementation of trainee Courses Details
  * @example
  *   Usage:
  *   <trainee-courses-details></trainee-courses-details>
  * @ngInject
  */

  function traineeCoursesDetails(TraineeCoursesDetailsFactory, $location, $uibModal, $routeParams) {
    function link(scope, attrs) {
      // scope.getTraineeCourse = getTraineeCourse;
      scope.goToTraineeCourse = goToTraineeCourse;
      scope.goToTraineeFlightCourse = goToTraineeFlightCourse;
      scope.HasTraineeView = true;
      scope.isLoading = false;
      scope.traineeCourses = [];
      scope.traineeFlightCourses = [];
      var dutyId = scope.groundDutyId;

      if (dutyId != null) {
        scope.traineeCourses = TraineeCoursesDetailsFactory.getTraineeGroundCourses(dutyId);
      }

      if (scope.flightId != null || scope.Flight != null) {
        var flightId = scope.flightId != null ? scope.flightId : scope.Flight.FlightId;
      }

      if (flightId != null) {
        scope.traineeFlightCourses = TraineeCoursesDetailsFactory.getTraineeFlightCourses(flightId);
      }

      if (scope.traineeCourses.length > 0) {
        var date = scope.groundDuty.DutyDateS;
      }

      if (scope.traineeFlightCourses.length > 0) {
        var flightDate = new moment(scope.flight.FlightDate).format("DD-MM-YYYY");
      }

      manageCourseStatus(scope.traineeCourses, scope.traineeFlightCourses);

      function manageCourseStatus(traineeCourses, traineeFlightCourses) {
        traineeCourses.forEach(function (course) {
          //Pending
          if (course.Status == "1") {
            course.StatusClass = "text-blue";
          } //Completed
          else if (course.Status == "2") {
              course.StatusClass = "text-green";
            } //NotCompleted - stopped
            else if (course.Status == "5") {
                course.StatusClass = "text-orange";
              }
        });
        traineeFlightCourses.forEach(function (course) {
          //Pending
          if (course.Status == "1") {
            course.StatusClass = "text-blue";
          } //Completed
          else if (course.Status == "2") {
              course.StatusClass = "text-green";
            } //NotCompleted - stopped
            else if (course.Status == "5") {
                course.StatusClass = "text-orange";
              }
        });
      }
      /**
      * Redirect to Course Session
      */


      function goToTraineeCourse(traineeCourseId) {
        $location.path('/traineecourse/' + traineeCourseId + '/' + dutyId + '/' + date);
      }

      function goToTraineeFlightCourse(traineeCourseId) {
        $location.path('/traineecourse/' + traineeCourseId + '/' + flightId + '/' + flightDate);
      }
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/TraineeCourse/trainee-courses-details.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('TraineeCoursesDetailsFactory', TraineeCoursesDetailsFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name TraineeCoursesDetailsFactory
   * @description 
   * Get, Set and Submit Trainee Courses Details.
   * @ngInject
   */

  function TraineeCoursesDetailsFactory(localStorageMD5Service, $http, apiUrl, GenericService, $timeout) {
    var objTypeGround = 'traineeCourses';
    var objTypeFlight = 'traineeFlightCourses';
    var objCallbackGround = TraineeCourses;
    var objCallbackFlights = TraineeFlightCourses;
    window.addEventListener('online', function (e) {
      $timeout(checkConnectionStatus());
    });
    var response = {
      success: false,
      message: '',
      Results: []
    };
    var service = {
      setTraineeCoursesToStorage: setTraineeCoursesToStorage,
      getTraineeGroundCourses: getTraineeGroundCourses,
      getTraineeCourses: getTraineeCourses,
      getTraineeCourse: getTraineeCourse,
      setTraineeFlightCoursesToStorage: setTraineeFlightCoursesToStorage,
      getTraineeFlightCourses: getTraineeFlightCourses,
      getFlightCourses: getFlightCourses
    };

    function TraineeCourses() {
      this.DutyDate = null;
      this.Status = null;
      this.GroundDutyId = null;
    }

    function checkConnectionStatus() {
      response.success = false;
      response.message = "Please check the internet connection!";
    }
    /**
    * Set all the trainee courses
    * @memberof TraineeCoursesDetailsFactory
    * @param {array} objects A list of trainee courses.
    */


    function setTraineeCoursesToStorage(data) {
      GenericService.saveAll(data, objTypeGround, objCallbackGround);
    }

    function getTraineeGroundCourses(dutyId) {
      var results = [];
      var listOfValues = localStorageMD5Service.get(objTypeGround);

      if (listOfValues) {
        var traineeCoursesPerDuty = listOfValues.filter(function (item) {
          return item.GroundDutyId == dutyId;
        });
        results = traineeCoursesPerDuty.map(function (item) {
          return item;
        });
      }

      return results;
    }

    function getTraineeCourses() {
      return GenericService.list(objTypeGround, objCallbackGround);
    }

    function getFlightCourses() {
      return GenericService.list(objTypeFlight, objCallbackFlights);
    }

    function TraineeFlightCourses() {}

    function getTraineeCourse(traineeCourseId, callback) {
      return $http.get(apiUrl + '/Training/GetTraineeCourse?traineeCourseId=' + traineeCourseId, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return updateTraineeCourseCallBack(res);
      })["catch"](function (res) {
        return traineeCourseFailedCallBack(res);
      });
    }

    function updateTraineeCourseCallBack(res) {
      response.success = res.data.success;

      if (res.data.success) {
        response.Results = res.data;
      } else {
        response.message = res.data.errorMessage;
      }

      return response;
    }
    /**
    * The callback function upon failure on submit
    * @returns {object} response
    */


    function traineeCourseFailedCallBack(res) {
      if (!window.navigator.onLine) {
        checkConnectionStatus();
      } else {
        response.success = false;
        response.message = "Oops! Something went wrong"; //TODO::Check status=500 error: returns res = {data: {…}, status: 500, config: {…}, statusText: "Internal Server Error", headers: ƒ}
        // res.data.data is null

        if (res.data.data && res.data.data.Results) {
          response.Results = res.data.data.Results;
        } else {
          //log results
          console.log(res);
        }
      }

      return response;
    }

    function setTraineeFlightCoursesToStorage(data) {
      GenericService.saveAll(data, objTypeFlight, objCallbackFlights);
    }

    function getTraineeFlightCourses(flightId) {
      var results = [];
      var listOfValues = localStorageMD5Service.get(objTypeFlight);

      if (listOfValues) {
        var traineeCoursesPerDuty = listOfValues.filter(function (item) {
          return item.FlightId == flightId;
        });
        results = traineeCoursesPerDuty.map(function (item) {
          return item;
        });
      }

      return results;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('TicketCtrl', TicketCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name TicketCtrl
  * @description 
  *  Send a ticket
  * @ngInject
  */

  function TicketCtrl($scope, UserFactory, PhotoFactory, TicketAPIService, $location, $uibModal, version, CabinReportRestoreFactory) {
    var user = UserFactory.getUser();
    user;
    $scope.submitted = false;
    $scope.ticket = {};
    $scope.ticket.photos = [];
    $scope.maximumAttatchedPhotos = 3;
    $scope.showMaxImages = false;
    $scope.quality = 0.6;
    $scope.width = 1280;
    $scope.height = 1024;
    $scope.sizeLimitKb = 1000;
    $scope.imageTooLargeMsg = false;
    $scope.gotoHome = gotoHome;
    $scope.state = 'ticket';
    $scope.restoreReportsAction = restoreReportsAction;
    appendPhoto();
    $scope.sendTicket = sendTicket;
    $scope.imageUploaded = imageUploaded;
    $scope.removePhoto = removePhoto;
    $scope.ticket.Version = version;

    if (user && user.aimsId && UserFactory.isLoggedIn()) {
      $scope.ticket.aimsId = user.aimsId;
      $scope.isLogged = true;
    }
    /**
     * Redirects to home view
     * @memberof TicketCtrl
     */


    function gotoHome() {
      $location.path("/");
    }
    /**
     * Send  application ticket information
     * @memberof TicketCtrl
     */


    function sendTicket() {
      $scope.submitted = true;

      if (validateTicket()) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Dialogs/dlgTicketSend.html',
          controller: 'TicketModalCtrl',
          size: 'md',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            ticket: function ticket() {
              return $scope.ticket;
            }
          }
        });
        modalInstance.result.then(function () {
          $location.path("/");
        });
      }
    }
    /**
     * Validate ticket before sending
     * @memberof TicketCtrl
     * @return {boolean} isValid
     */


    function validateTicket() {
      var isValid = false;

      if ($scope.ticket.aimsId && $scope.ticket.title && $scope.ticket.description) {
        isValid = true;
      }

      return isValid;
    }
    /**
     * is Image Too Large 
     * @memberof TicketCtrl
     * @return {boolean} isValid
     */


    function isImageTooLarge(image) {
      var isLarge = false;

      if (image && image.dataURL != null) {
        isLarge = image.dataURL.length > $scope.sizeLimitKb * 1024;
      }

      return isLarge;
    }
    /**
     * Upload Image
     * @memberof TicketCtrl
     */


    function imageUploaded(data, img) {
      //console.log('told of a new image', imageResult, this.imageBrowsed, $scope.imageBrowsed);
      var imageResult = data; //$scope.imageBrowsed;

      if (imageResult != null) {
        if (isImageTooLarge(data)) {
          $scope.imageTooLargeMsg = true;
        } else {
          $scope.imageTooLargeMsg = false;
          img.PhotoData = imageResult.dataURL;
          img.FileType = imageResult.fileType || imageResult.file.type;
          img.Remarks = imageResult.fileName;
          appendPhoto();
        }
      }
    }
    /**
     * Allows to add more photos up to the maximum number allowed
     * @memberof TicketCtrl
     */


    function appendPhoto() {
      if ($scope.ticket.photos.length < $scope.maximumAttatchedPhotos) {
        var photo = PhotoFactory.createNew();
        $scope.ticket.photos.push(photo);
      } else {
        $scope.showMaxImages = true;
      }
    }
    /**
     * Remove Selected photo
     * @memberof TicketCtrl
     * @param {object} photo
     */


    function removePhoto(photo) {
      PhotoFactory.deleteFromList(photo, $scope.ticket.photos);

      if ($scope.showMaxImages) {
        appendPhoto();
      }

      $scope.showMaxImages = false;
    }
    /**
    * Restore lost reports process and return list of FlightNo for each restored report into a modal.
    * @memberof flightFooter  
    */


    function restoreReportsAction() {
      CabinReportRestoreFactory.restoreReports(function (restoreResults) {
        var bootboxMessage = "";

        if (restoreResults != 'undefined' && restoreResults.length > 0) {
          bootboxMessage = "<h4>Lost reports have been restored successfully for the following flights:</h4>";
          restoreResults.forEach(function (x) {
            bootboxMessage += "<br />";
            bootboxMessage += "- " + x;
          });
        } else {
          bootboxMessage = "No missing reports have been found";
        }

        bootbox.alert({
          title: "Retrieve lost reports",
          message: bootboxMessage
        });
      });
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.service("TicketAPIService", TicketAPIService);
  /**
  * @memberof CabinReports
  * @ngdoc service
  * @name TicketAPIService
  * @description 
  *  Manages the api calls for the Ticket report system
  * @ngInject
  */

  function TicketAPIService($http, $q, apiUrl, localStorageMD5Service, LogService) {
    /**
     * Send Ticket2
     * @memberof TicketAPIService
     * @return {object} promise
     */
    function sendTicket(ticket) {
      var call = $q.defer();
      ticket.DeviceData = getStoredValues();
      $http.post(apiUrl + '/ticket', ticket, {
        'Content-Type': 'application/json'
      }).then(function (responseData) {
        if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined) {
          var err = new Error();
          err.status = -1;
          var msg = "ResponseData error while sending a ticket :" + JSON.stringify(responseData);
          LogService.debug(msg, err);
          call.reject(err);
        } else {
          // return true
          call.resolve(responseData);
        }
      }, function (err) {
        call.reject(err);
      });
      return call.promise;
    }
    /**
    * Get all values from localstorage
    * @memberof TicketAPIService
    */


    function getStoredValues() {
      var values = [];
      var keys = localStorageMD5Service.keys();

      if (keys) {
        var key, value, sizeActual, error;

        for (var i = 0; i < keys.length; i++) {
          key = keys[i];

          try {
            value = localStorageMD5Service.get(key);
            value = angular.toJson(value);
            sizeActual = localStorageMD5Service.usedSize(key);
            error = null;
          } catch (e) {
            error = e.message || e.errorMessage;
          }

          values.push({
            key: key,
            value: value,
            error: error,
            size: value ? value.length : 0,
            sizeActual: sizeActual
          });
        }
      }

      return values;
    }

    return {
      sendTicket: sendTicket
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('TicketModalCtrl', TicketModalCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name TicketCtrl
  * @description 
  *  Report a bug of the application
  * @ngInject
  */

  function TicketModalCtrl($scope, $uibModalInstance, $timeout, TicketAPIService, LogService, PhotoFactory, ticket) {
    $scope.successful = false;
    $scope.error = false;
    var q = TicketAPIService.sendTicket(ticket);
    q.then(function (responseData) {
      if (responseData.data.data) {
        $scope.successful = true;
      } else {
        $scope.error = true;
      }

      $timeout(function () {
        $uibModalInstance.close();
      }, 3000);
    }, function () {
      $scope.error = true;
      $timeout(function () {
        $uibModalInstance.close();
      }, 3000);
    });
  }
})();
"use strict";

(function () {
  // Warning!!! This an auto generated file. Any Changes will be lost. If u want to add or edit go to config.json 
  a3_cabin_reports.constant("version", "appVersion_20170424105730");
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('DebugCtrl', DebugCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name DebugCtrl
  * @description 
  *  Manage Debug view
  * @ngInject
  */

  function DebugCtrl($location, $scope, UserFactory, DebugFactory, localStorageMD5Service) {
    $scope.isSecure = UserFactory.isSecure();
    $scope.adminkey = "";
    $scope.authorized = false; // show logged user info

    var user = UserFactory.getUser();
    $scope.logged_user_info = "-user has not logged in-";
    if (user) $scope.logged_user_info = user.aimsId + ' - ' + user.name;
    $scope.storedValues = [];
    $scope.addKeyName = null;
    $scope.checkAuthorized = checkAuthorized;
    $scope.refreshStoredValues = refreshStoredValues;
    $scope.add = add;
    $scope.update = update;
    $scope["delete"] = deleteFromStorage;
    $scope.exit = exit;
    $scope.updateAll = updateAll;
    /**
    * Update all the local storage 
    * @memberof DebugCtrl
    */

    function updateAll() {
      try {
        var items = JSON.parse($scope.updateAllJson);

        for (var i = 0; i < items.length; i++) {
          var obj = null;
          if (items[i].value != '') obj = angular.fromJson(items[i].value);
          localStorageMD5Service.set(items[i].key, obj);
        }

        $scope.refreshStoredValues();
      } catch (e) {
        alert('Error: ' + e.message || e.errorMessage);
      }
    }
    /**
    * Add a new local storage key
    * @memberof DebugCtrl
    */


    function add() {
      try {
        var key = $scope.addKeyName;
        if (!key || key == '') return false;
        var keys = localStorageMD5Service.keys();

        if (keys && keys.indexOf(key) > 0) {
          alert('Key exists!');
          return false;
        }

        localStorageMD5Service.set(key, ["empty"]);
        $scope.refreshStoredValues();
        $scope.addKeyName = null;
      } catch (e) {
        alert('Error: ' + e.message || e.errorMessage);
      }
    }
    /**
    * Update an existing local storage key
    * @memberof DebugCtrl
    * @param {object} item
    */


    function update(item) {
      try {
        var obj = null;
        if (item.value != '') obj = angular.fromJson(item.value);
        localStorageMD5Service.set(item.key, obj);
        $scope.refreshStoredValues();
      } catch (e) {
        alert('Error: ' + e.message || e.errorMessage);
      }
    }
    /**
    * delete an existing local storage key
    * @memberof DebugCtrl
    * @param {object} item
    */


    function deleteFromStorage(item) {
      if (confirm('Confirm deletion of key ' + item.key)) {
        localStorageMD5Service.remove(item.key);
        $scope.refreshStoredValues();
      }
    }
    /**
    * Check if the user is authorized in order to view key values
    * @memberof DebugCtrl
    */


    function checkAuthorized() {
      var verify = localStorageMD5Service.md5hash($scope.adminkey);
      DebugFactory.CheckAuthorized(verify, function (responseData) {
        if ($scope.authorized != responseData.data.data) {
          $scope.authorized = responseData.data.data;
          $scope.refreshStoredValues();
        }
      })["catch"](function (error) {
        $scope.authorized = responseData.Data;
        console.error('Wrong Password', error.status, error.statusText);
      });
    }
    /**
    * Refresh values from localstorage
    * @memberof DebugCtrl
    */


    function refreshStoredValues() {
      var values = [];

      if ($scope.authorized) {
        var keys = localStorageMD5Service.keys();

        if (keys) {
          var key, value, sizeActual, error;

          for (var i = 0; i < keys.length; i++) {
            key = keys[i];

            try {
              value = localStorageMD5Service.get(key);
              value = angular.toJson(value);
              sizeActual = localStorageMD5Service.usedSize(key);
              error = null;
            } catch (e) {
              error = e.message || e.errorMessage;
            }

            values.push({
              key: key,
              value: value,
              error: error,
              size: value ? value.length : 0,
              sizeActual: sizeActual
            });
          }
        }
      }

      $scope.storedValues = values;
    }
    /**
    * Redirect to main Menu
    * @memberof DebugCtrl
    */


    function exit() {
      $location.path("/");
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('DebugFactory', DebugFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name DebugFactory
  * @description 
  *    Authorize check from API ...
  * @ngInject
  */

  function DebugFactory(GenericService, $http, $q, apiUrl, LogService) {
    /**
    * Initialize Debug
    * @memberof DebugFactory
    */
    var service = {
      CheckAuthorized: CheckAuthorized
    };

    function CheckAuthorized(value, callback) {
      return $http.get(apiUrl + '/debug/CheckAuthorized/' + value, {
        'Content-Type': 'application/json'
      }).then(callback);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('ResetDeviceCtrl', ResetDeviceCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name ResetDeviceCtrl
  * @description 
  *  Manage Reset view
  * @ngInject
  */

  function ResetDeviceCtrl($location, $scope, DataCleanerFactory, UserFactory) {
    $scope.isSecure = UserFactory.isSecure(); // show logged user info

    var user = UserFactory.getUser();
    $scope.logged_user_info = "-user has not logged in-";
    if (user) $scope.logged_user_info = user.aimsId + ' - ' + user.name;
    $scope.resetDevice = resetDevice;
    $scope.cancelReset = cancelReset;
    /**
    * Reset Device storage
    * @memberof ResetDeviceCtrl
    */

    function resetDevice() {
      DataCleanerFactory.deleteAllData();
      bootbox.alert("Your device has been reset.", function () {
        $location.path("/login");
        $scope.$apply();
      });
    }
    /**
    * Cancel Reset and go to main page.
    * @memberof ResetDeviceCtrl
    */


    function cancelReset() {
      $location.path("/");
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('AbsentTraineesModalCtrl', AbsentTraineesModalCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name AbsentTraineesModalCtrl
   * @description 
   * Show absent trainee(s) modal
   * @ngInject
   */

  function AbsentTraineesModalCtrl($scope, $uibModalInstance, absentTrainees) {
    $scope.cancel = cancel;
    $scope.confirm = confirm;
    $scope.absentTrainees = absentTrainees;
    /**
     * Close the modal
     * @memberof AbsentTraineesModalCtrl
     */

    function cancel() {
      $uibModalInstance.close();
    }

    function confirm() {
      $uibModalInstance.close('confirmed');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('additionalTraining', additionalTraining);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name additionalTraining
  * @restrict E
  * @description
  *   Implementation of additional Training
  * @example
  *   Usage:
  *   <additional-training></additional-training>
  * @ngInject
  */

  function additionalTraining($uibModal) {
    function link(scope) {
      scope.filterTrainee = filterTrainee;
      scope.yesAdditional = yesAdditional;
      scope.noAdditional = noAdditional;
      scope.NeedsAdditionalTraining = false;
      scope.clearAdditionalNotes = clearAdditionalNotes;
      scope.remarksSelection = remarksSelection;
      scope.completeAdditional = completeAdditional;
      scope.continueAdditional = continueAdditional;
      scope.selectedTrainee.startAdditional = false;
      scope.initializeAdditional = initializeAdditional;
      scope.toggleAdditional = toggleAdditional;
      scope.selectedTrainee.continueAdditional = false;
      scope.openAdditionalModal = openAdditionalModal;

      function yesAdditional(trainee) {
        scope.selectedTrainee.NeedsAdditionalTraining = true;
        trainee.Session.NeedsAdditionalTraining = true;
        scope.CompleteAdditionalTraining = false;
        trainee.Session.CompleteAdditionalTraining = false;
        trainee.Session.UnderAdditionalTraining = false;
        scope.selectedTrainee.startAdditional = true;
        remarksSelection(trainee);
      }

      function noAdditional(trainee) {
        scope.selectedTrainee.NeedsAdditionalTraining = false;
        trainee.Session.NeedsAdditionalTraining = false;
        scope.CompleteAdditionalTraining = false;
        trainee.Session.CompleteAdditionalTraining = false;
        trainee.Session.UnderAdditionalTraining = false;
        trainee.Session.AdditionalTrainingStatus = 'None';
        clearAdditionalNotes(trainee);
      }

      function clearAdditionalNotes(trainee) {
        scope.selectedTrainee.Session.AdditionalTrainingRemarks = '';
        trainee.Session.AdditionalTrainingRemarks = '';
      }

      function completeAdditional(trainee) {
        scope.selectedTrainee.NeedsAdditionalTraining = false;
        trainee.Session.NeedsAdditionalTraining = false;
        scope.CompleteAdditionalTraining = true;
        trainee.Session.CompleteAdditionalTraining = true;
        trainee.Session.UnderAdditionalTraining = true;
        remarksSelection(trainee);
      }

      function continueAdditional(trainee) {
        scope.selectedTrainee.NeedsAdditionalTraining = true;
        trainee.Session.NeedsAdditionalTraining = true;
        scope.CompleteAdditionalTraining = false;
        trainee.Session.CompleteAdditionalTraining = false;
        trainee.Session.UnderAdditionalTraining = true;
        remarksSelection(trainee);
      }

      function filterTrainee() {
        return function (trainee) {
          var showTrainee = true;

          if (scope.selectedTrainee) {
            //individual grading view: filter selected
            showTrainee = scope.selectedTrainee.CrewId == trainee.CrewId;
          }

          return showTrainee;
        };
      }

      function remarksSelection(trainee) {
        trainee.Session.AdditionalTrainingRemarks = scope.selectedTrainee.Session.AdditionalTrainingRemarks;
      }

      function toggleAdditional(trainee) {
        if (scope.selectedTrainee.continueAdditional) {
          continueAdditional(trainee);
        } else {
          completeAdditional(trainee);
        }
      }

      function initializeAdditional(trainee) {
        if (scope.selectedTrainee.startAdditional) {
          yesAdditional(trainee);
        } else {
          noAdditional(trainee);
        }
      }

      function openAdditionalModal(userInput) {
        $uibModal.open({
          templateUrl: 'views/Dialogs/dlgAdditionalTraining.html',
          controller: 'AdditionalTrainingModalCtrl',
          size: 'md',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            retVal: function retVal() {
              return userInput;
            },
            startAdd: userInput
          }
        });
      }
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/Training/additionalTraining.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('AdditionalTrainingModalCtrl', AdditionalTrainingModalCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name AdditionalTrainingModalCtrl
  * @description 
  *  Manages Additional Training Modal
  * @ngInject
  */

  function AdditionalTrainingModalCtrl($scope, $uibModalInstance, retVal) {
    $scope.ok = ok;
    $scope.cancel = cancel;

    if (retVal) {
      $scope.startAdd = true;
    } else {
      $scope.startAdd = false;
    }
    /**
     * Close modal after confirm
     * @memberof AdditionalTrainingModalCtrl
     */


    function ok() {
      $uibModalInstance.close(null);
    }
    /**
     * Close Modal
     * @memberof AdditionalTrainingModalCtrl
     */


    function cancel() {
      $uibModalInstance.close(null);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('certificateExam', certificateExam);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name certificateExam
  * @restrict E
  * @description
  *   Implementation of certificate exam grading
  * @example
  *   Usage:
  *   <certificate-exam></certificate-exam>
  * @ngInject
  */

  function certificateExam(TrainingSessionFactory, FlightSessionFactory) {
    function link(scope, element, attrs) {
      if (scope.trainees) collapseAll();
      scope.validateTrainee = validateTrainee;
      scope.getRemainingCharacters = getRemainingCharacters;
      scope.collapseAll = collapseAll;
      scope.gradeUp = gradeUp;
      scope.gradeDown = gradeDown;
      var courseId = scope.dutyCourse.Id;
      var isGround = false;

      if (scope.groundDuty) {
        isGround = true;
        var date = scope.groundDuty.DutyDateS;
        var dutyId = scope.groundDuty.Id;
      } else {
        var date = scope.crewRouteDuty.date;
        var dutyNo = scope.crewRouteDuty.DutyNo;
        var dutyDay = scope.crewRouteDuty.DutyDay;
      }

      var gradeBase = scope.selectedPhase.ReleaseGrading.CertificateGradeBase;
      scope.gradeBase = gradeBase;
      scope.gradeMin = 0;
      scope.gradeMax = 100; //Accordion setting

      scope.oneAtATime = true;
      scope.gradingStatus = 'All'; //Initialize trainees 

      scope.sessions = [];
      scope.trainees.filter(function (x) {
        return x.EligibilityStatus && !x.Session.Absent;
      }).forEach(function (trainee) {
        var session = trainee.Session.ReleaseGrading;
        session.Name = trainee.Name;
        session.AimsId = trainee.AimsId;
        session.isOpen = false;
        if (!session.CertificateOutcome) session.CertificateOutcome = "Pass";
        if (gradeBase && !session.Grade) session.Grade = gradeBase;
        if (!gradeBase) session.Grade = null;
        scope.sessions.push(session);
      });
      scope.sessions.forEach(function (traineeSession) {
        validateGrading(traineeSession);
      });

      function validateGrading(trainee) {
        // Invalid grading
        // 1. If none
        // 2. Over gradeMax
        // 3. Below gradeMin
        // 4. Non numeric
        trainee.isCertificateValid = gradeBase ? trainee.Grade != null && trainee.Grade != undefined : true;
      }

      function validateTrainee(trainee) {
        if (gradeBase) {
          validateGrading(trainee);

          if (trainee.isCertificateValid) {
            calculateOutcome(trainee);
          }
        }

        if (isGround) {
          TrainingSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyId, console.log, function (e) {
            console.log(e);
          });
        } else {
          FlightSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyNo, dutyDay, console.log, function (e) {
            console.log(e);
          });
        }
      }

      function gradeUp(trainee) {
        if (trainee.isCertificateValid && trainee.Grade < scope.gradeMax) {
          trainee.Grade++;
        }

        if (!trainee.isCertificateValid) {
          trainee.Grade++;
        }

        validateTrainee(trainee);
      }

      function gradeDown(trainee) {
        if (trainee.isExamValid && trainee.Grade > scope.gradeMin) {
          trainee.Grade--;
        }

        if (!trainee.isExamValid) {
          trainee.Grade--;
        }

        validateTrainee(trainee);
      }

      function calculateOutcome(trainee) {
        if (trainee.Grade < gradeBase) {
          trainee.CertificateOutcome = "Fail";
        } else {
          trainee.CertificateOutcome = "Pass";
        }
      }

      function getRemainingCharacters(text, max) {
        if (typeof text === "undefined" || text === null) return '';
        if (typeof max === "undefined" || max === null || max < 0 || !max) max = 4000;
        var length = text.length;
        return 'characters left: ' + (max - length);
      }

      function collapseAll() {
        scope.isAllOpen = !scope.isAllOpen;
        scope.trainees.forEach(function (trainee) {
          var session = trainee.Session.ReleaseGrading;
          session.isOpen = scope.isAllOpen;
        });
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/Training/certificate-exam.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('CompetenceModalCtrl', CompetenceModalCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name CompetenceModalCtrl
   * @description 
   * Show competence grading helper
   * @ngInject
   */

  function CompetenceModalCtrl($scope, $uibModalInstance, competence) {
    $scope.close = close;
    $scope.competence = competence;
    /**
     * Close the modal
     * @memberof CompetenceModalCtrl
     */

    function close() {
      $uibModalInstance.close($scope.competence.Grading);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('competences', competences);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name certificates
  * @restrict E
  * @description
  *   Implementation of competences
  * @example
  *   Usage:
  *   <competences></competences>
  * @ngInject
  */

  function competences($uibModal, $timeout) {
    function link(scope, element, attrs) {
      scope.manageCompetenceGrading = manageCompetenceGrading;
      scope.selectSubCompetence = selectSubCompetence;
      scope.openGradingModal = openGradingModal;
      scope.trainee.Competences.forEach(function (competence) {
        competence.isCollapsed = competence.hasMandatory || competence.hasOptional;
        competence.showComments = competence.hasMandatory || competence.hasOptional || competence.Comments && competence.Comments != "";
      });
      validateTraineeCompetences(scope.trainee);

      function validateTraineeCompetences(trainee) {
        var missingGrading = trainee.Competences.some(function (c) {
          return c.Grading == null;
        });
        var missingPerformanceIndicators = trainee.Competences.filter(function (c) {
          return c.hasMandatory;
        }).some(function (c) {
          return !c.SubCompetences.some(function (sub) {
            return sub.Selected;
          });
        });
        trainee.isCompetenceValid = !missingGrading && !missingPerformanceIndicators;
      }

      function manageCompetenceGrading(competence) {
        var grading = competence.Grading ? Number(competence.Grading) : null;
        var hadMandatory = competence.hasMandatory;
        var hadOptional = competence.hasOptional;
        competence.hasMandatory = competence.MandatorySub.includes(grading);
        competence.hasOptional = competence.OptionalSub.includes(grading);
        competence.isCollapsed = competence.hasMandatory || competence.hasOptional;
        if (competence.isCollapsed) competence.showComments = true; //From Mandatory to None remove selected Sub Competences

        if ((hadMandatory || hadOptional) && !competence.hasMandatory && !competence.hasOptional) {
          competence.SubCompetences.forEach(function (sub) {
            sub.Selected = false;
          });
        }

        validateTraineeCompetences(scope.trainee);

        switch (competence.Grading) {
          case 5:
            competence.GradingMessage = competence.GradeA;
            break;

          case 4:
            competence.GradingMessage = competence.GradeB;
            break;

          case 3:
            competence.GradingMessage = competence.GradeC;
            break;

          case 2:
            competence.GradingMessage = competence.GradeD;
            break;

          case 1:
            competence.GradingMessage = competence.GradeE;
            break;

          default:
            competence.GradingMessage = "";
        }

        scope.gradingSelection();
      }

      function selectSubCompetence(sub) {
        sub.Selected = !sub.Selected;
        if (sub.Selected) scope.gradingSelection();
        validateTraineeCompetences(scope.trainee);
      }

      function openGradingModal(_competence) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Training/dlgCompetenceGrading.html',
          controller: 'CompetenceModalCtrl',
          backdrop: 'static',
          keyboard: false,
          size: 'md',
          resolve: {
            competence: function competence() {
              return _competence;
            }
          }
        });
        modalInstance.result.then(function (grading) {
          if (grading) {
            manageCompetenceGrading(_competence, grading);
          }
        });
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/Training/competences.tpl.html',
      scope: {
        trainee: "=",
        gradingSelection: "&onGradingSelection"
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('courseFooter', courseFooter);
  /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name courseFooter
   * @restrict E
   * @description
   *   Implementation of courseFooter (appears in course view)
   * @example
   *   Usage:
   *   <course-footer></course-footer>
   * @ngInject 
   */

  function courseFooter($location, $routeParams) {
    function link(scope) {
      scope.gotoCalendar = gotoCalendar;
      scope.gotoGroundDuty = gotoGroundDuty;
      scope.gotoCrewRoute = gotoCrewRoute;
      scope.gotoFlight = gotoFlight;

      function gotoCalendar() {
        $location.path("/");
      }

      function gotoGroundDuty() {
        $location.path('/groundDuty/' + Number($routeParams.dutyId));
      }

      function gotoCrewRoute() {
        var dutyNo = scope.crewRouteDuty.DutyNo;
        var dutyDay = scope.crewRouteDuty.DutyDay;
        $location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
      }

      function gotoFlight() {
        var flightId = Number($routeParams.flightId);
        $location.path('/flightinfo/' + flightId);
      }
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/Training/course-footer.tpl.html",
      scope: false,
      link: link
    };
  }
})();
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

(function () {
  'use strict';

  a3_cabin_reports.directive('course', course);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name course
  * @restrict E
  * @description
  *   Implementation of training course
  * @example
  *   Usage:
  *   <course></course>
  * @ngInject
  */

  function course(GroundDutyFactory, CourseFactory, TrainingSessionFactory, FlightSessionFactory, $timeout, $uibModal, $location, $routeParams, $window) {
    function link(scope) {
      var _courseId = scope.dutyCourse.Id;
      var isGround = false;

      if (scope.groundDuty) {
        isGround = true;
        var _date = scope.groundDuty.DutyDateS;
        var _dutyId = scope.groundDuty.Id;
      } else {
        var _date = scope.crewRouteDuty.date;
        var _dutyNo = scope.crewRouteDuty.DutyNo;
        var _dutyDay = scope.crewRouteDuty.DutyDay;
        var trainingFlightIds = scope.crewRouteDuty.Courses.find(function (x) {
          return x.CourseId == _courseId && new moment(x.Date).isSame(_date);
        }).TrainingFlightIds;
        if (scope.course.Media) scope.course.Media.radioModel = "Flight";
      }

      scope.isGround = isGround;
      scope.updateSession = updateSession;
      scope.availableCourseInfo = false;
      scope.oneTraineeAtATime = true;
      scope.allAbsent = false;
      scope.SubmitSession = SubmitSession;
      scope.close = close;
      scope.updateTraineeSignatures = updateTraineeSignatures;
      scope.checkReleaseAvailability = checkReleaseAvailability;
      scope.setReleaseStatus = setReleaseStatus;
      scope.reloadReleasePanel = reloadReleasePanel;
      scope.showReleasePanel = showReleasePanel;
      scope.filterSelectedSyllabus = filterSelectedSyllabus;
      scope.filterPresentTrainees = filterPresentTrainees;
      scope.selectedPhaseIndex = selectedPhaseIndex();
      scope.releaseTrainee = releaseTrainee;
      scope.showReleaseBtn = showReleaseBtn;
      scope.showGroupReleaseBtn = showGroupReleaseBtn;
      scope.releaseGroup = releaseGroup;
      scope.validateTraineeForm = validateTraineeForm;
      scope.openTraineeSignature = openTraineeSignature;
      scope.resetSignature = resetSignature;
      scope.getTraineeClass = getTraineeClass;
      scope.leftScroll = leftScroll;
      scope.rightScroll = rightScroll;
      scope.togglePanel = togglePanel;
      scope.isReleaseSelected = false;
      scope.toggleBtn = toggleBtn;
      scope.setAdditionalTrainingDetails = setAdditionalTrainingDetails;
      scope.hasLowDayGrading = hasLowDayGrading;
      scope.hasLowSyllabusGrading = hasLowSyllabusGrading;

      if (scope.selectedPhase.ModuleType == "Training" && scope.selectedPhase.EnableAdditionalTraining) {
        scope.AvailableAdditionalTraining = true;
      }

      function setAdditionalTrainingDetails() {
        if (scope.isReleaseSelected) {
          if (scope.selectedTrainee.Session.AdditionalTrainingRemarks != undefined) {
            scope.selectedTrainee.Session.AdditionalTrainingRemarks = '';
          }

          scope.selectedTrainee.Session.CompleteAdditionalTraining = true;
          scope.selectedTrainee.Session.NeedsAdditionalTraining = false;
        }
      }

      function toggleBtn() {
        scope.isReleaseSelected = !scope.isReleaseSelected;
      }

      function selectedPhaseIndex() {
        var index = 0;
        scope.course.CrewCoursePhases.some(function (phase, i) {
          if (phase.PhaseId == scope.selectedPhase.PhaseId) {
            index = i;
            return true;
          }
        });
        return index;
      }

      function filterSelectedSyllabus() {
        return function (syllabus) {
          var showTrainee = true;

          if (scope.traineeSyllabi && scope.traineeSyllabi.length > 1) {
            showTrainee = syllabus.TraineeIds[0] == scope.selectedTrainee.CrewId;
          }

          return showTrainee;
        };
      }

      function filterPresentTrainees() {
        return function (trainee) {
          return !trainee.Session.Absent;
        };
      }

      scope.reloadFooter = true;
      scope.reloadRelease = true;
      setTraineeSessions();
      updateSession();
      setReleaseStatus();

      function ResetTraineeSignatures() {
        scope.trainees.forEach(function (trainee) {
          trainee.Session.Authorized = false;
        });
      }

      function setReleaseStatus() {
        scope.trainees.forEach(function (trainee) {
          trainee.ShowReleaseWarning = false;
        });
        scope.course.AvailableRelease = checkReleaseAvailability(); //Handle trainee signatures

        scope.requiresTraineeSignature = RequiresTraineeSignature();
        if (!scope.requiresTraineeSignature) ResetTraineeSignatures();
        scope.allSignaturesComplete = !scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return !x.Session.Authorized;
        });
        scope.someSignaturesComplete = scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return x.Session.Authorized;
        }); //For flights : check minDays - minSectors

        if (!isGround && scope.course.AvailableRelease && (scope.selectedPhase.MinDays > 0 || scope.selectedPhase.MinSectors > 0)) {
          scope.trainees.filter(function (x) {
            return x.AvailableRelease;
          }).forEach(function (trainee) {
            var phaseInfo = trainee.Phases.find(function (x) {
              return x.PhaseId == scope.selectedPhase.PhaseId;
            });
            var completedDays = 0;
            var completedSectors = 0;

            if (phaseInfo.Sessions) {
              //previous sessions
              completedDays = phaseInfo.Sessions.length;
              phaseInfo.Sessions.forEach(function (pastSession) {
                if (pastSession.Sectors) {
                  completedSectors = completedSectors + pastSession.Sectors.length;
                }
              });
            }

            trainee.CompletedDays = completedDays + 1; //add current day

            trainee.CompletedSectors = completedSectors + trainingFlightIds.length; //add current sectors

            if (trainee.CompletedDays < scope.selectedPhase.MinDays || trainee.CompletedSectors < scope.selectedPhase.MinSectors) {
              trainee.ShowReleaseWarning = true;
            }
          });
        } //For ground: check aircraft visits


        if (isGround && (scope.course.AvailableRelease || scope.selectedPhase.ModuleType == "Check") && scope.selectedPhase.AircraftTypes.length) {
          var trainees = scope.trainees;
          if (scope.selectedPhase.ModuleType != "Check") trainees.filter(function (x) {
            return x.AvailableRelease;
          });
          trainees.forEach(function (trainee) {
            var phaseInfo = trainee.Phases.find(function (x) {
              return x.PhaseId == scope.selectedPhase.PhaseId;
            });
            var visitedAircrafts = [];

            if (phaseInfo.Sessions) {
              //previous sessions
              phaseInfo.Sessions.forEach(function (session) {
                visitedAircrafts = visitedAircrafts.concat(session.AircraftTypesVisited);
              });
            }

            if (scope.course.Media) {
              trainee.visitedAircrafts = visitedAircrafts.concat(scope.course.Media.inputAircrafts); //add current arvis
            }

            trainee.pendingAircrafts = [];
            trainee.pairPendingAircrafts = [];
            var pendingAircrafts = [];
            scope.selectedPhase.AircraftTypes.forEach(function (type) {
              var array = type.split(','); //if arvi requirement is not met

              if (trainee.visitedAircrafts && !array.some(function (x) {
                return trainee.visitedAircrafts.includes(x);
              })) {
                var pendingArviList = [];

                if (array.length > 1) {
                  array.forEach(function (arvi) {
                    pendingArviList.push(arvi);
                  });
                } else {
                  pendingArviList.push(array[0]);
                }

                pendingAircrafts.push(pendingArviList);
              }
            });
            trainee.pendingAircrafts = pendingAircrafts;
            trainee.ShowReleaseWarning = trainee.pendingAircrafts.length > 0;
          });
        }

        scope.showReleaseWarning = scope.trainees.some(function (x) {
          return x.ShowReleaseWarning;
        });
      }

      function reloadReleasePanel() {
        setReleaseStatus();
        scope.reloadRelease = false;
        $timeout(function () {
          scope.reloadRelease = true;
        }, 100);
      }

      function updateSession() {
        scope.trainees.forEach(function (trainee) {
          trainee.Session.selected = false;
        });

        if (scope.selectedTraineeBadge && scope.trainees.find(function (x) {
          return x.CrewId == scope.selectedTraineeBadge.CrewId;
        })) {
          scope.trainees.find(function (x) {
            return x.CrewId == scope.selectedTraineeBadge.CrewId;
          }).Session.selected = true;
          scope.selectedTrainee = scope.trainees.find(function (x) {
            return x.Session.selected;
          });
        }

        if (isGround) {
          TrainingSessionFactory.updateSession(scope.trainees, scope.course, _courseId, _date, _dutyId, console.log, function (e) {
            console.log(e);
          });
        } else {
          FlightSessionFactory.updateSession(scope.trainees, scope.course, _courseId, _date, _dutyNo, _dutyDay, console.log, function (e) {
            console.log(e);
          });
        }
      }

      function setTraineeSessions() {
        var phase = scope.selectedPhase; // Set Day Grading

        var dayCompetences = phase.DayGrading.Competences;
        dayCompetences.forEach(function (competence) {
          competence.MandatorySub = setSubCompetenceValues(competence.MandatorySubCompetences);
          competence.OptionalSub = setSubCompetenceValues(competence.OptionalSubCompetences); //Filter out from optional the ones common with mandatory

          competence.OptionalSub = competence.OptionalSub.filter(function (c) {
            return !competence.MandatorySub.includes(c);
          });
        });
        var dayGradingSessions = scope.trainees.map(function (x) {
          return x.Session.DayGrading;
        });
        dayGradingSessions.forEach(function (traineeSession) {
          traineeSession.Competences = setTraineeCompetences(dayCompetences, traineeSession);
        }); // Set Release Grading

        var releaseCompetences = phase.ReleaseGrading.Competences;
        releaseCompetences.forEach(function (competence) {
          competence.MandatorySub = setSubCompetenceValues(competence.MandatorySubCompetences);
          competence.OptionalSub = setSubCompetenceValues(competence.OptionalSubCompetences); //Filter out from optional the ones common with mandatory

          competence.OptionalSub = competence.OptionalSub.filter(function (c) {
            return !competence.MandatorySub.includes(c);
          });
        });
        var releaseGradingSessions = scope.trainees.map(function (x) {
          return x.Session.ReleaseGrading;
        });
        releaseGradingSessions.forEach(function (traineeSession) {
          traineeSession.Competences = setTraineeCompetences(releaseCompetences, traineeSession);
        }); // Set Syllabus

        if (scope.selectedPhase.Syllabus) setSyllabus(); //Check if all are absent

        if (scope.trainees && scope.trainees.length && !scope.trainees.some(function (x) {
          return !x.Session.Absent;
        })) {
          scope.allAbsent = true;
        }
      }

      function setSyllabus() {
        var traineeSyllabi = [];

        if (!scope.selectedPhase.Syllabus.IsGradable && !scope.selectedPhase.InFlight) {
          //Non Gradable syllabus & Ground: All trainees share the same syllabus
          var traineeSyllabus = {
            TraineeIds: scope.trainees.filter(function (x) {
              return !x.Session.Absent;
            }).map(function (x) {
              return x.CrewId;
            }),
            Items: []
          };
          traineeSyllabi.push(traineeSyllabus);
        } else {
          //Gradable syllabus || flight: each trainee will have its own
          scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          }).forEach(function (trainee) {
            var traineeSyllabus = {
              TraineeIds: [trainee.CrewId],
              Items: []
            };
            traineeSyllabi.push(traineeSyllabus);
          });
        } //Set syllabus item sub competences 


        scope.selectedPhase.Syllabus.SyllabusItems.forEach(function (item) {
          item.Competences.forEach(function (competence) {
            competence.MandatorySub = setSubCompetenceValues(competence.MandatorySubCompetences);
            competence.OptionalSub = setSubCompetenceValues(competence.OptionalSubCompetences); //Filter out from optional the ones common with mandatory

            competence.OptionalSub = competence.OptionalSub.filter(function (c) {
              return !competence.MandatorySub.includes(c);
            });
          });
        });
        scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).forEach(function (trainee) {
          var traineeSessionItems = [];
          scope.selectedPhase.Syllabus.SyllabusItems.forEach(function (item) {
            var syllabusItem = JSON.parse(JSON.stringify(item)); //Get any history tries

            var historyTries = [];

            if (syllabusItem.History && syllabusItem.History.length) {
              var itemsHistory = syllabusItem.History.filter(function (x) {
                return x.CrewId == trainee.CrewId;
              });

              if (itemsHistory.length) {
                var allHistoryTries = [];
                itemsHistory.forEach(function (item) {
                  allHistoryTries = allHistoryTries.concat(item.Tries);
                });
                allHistoryTries.forEach(function (historyTry) {
                  var performedTry = {
                    ActionNo: historyTry.ActionNo,
                    isReadOnly: true,
                    Comments: historyTry.Comments,
                    InstructorName: historyTry.InstructorName,
                    SubmissionDate: historyTry.SubmissionDate,
                    Grade: historyTry.TryGrading.Grade,
                    AcTypes: historyTry.AcTypes,
                    Sectors: historyTry.Sectors
                  };
                  historyTries.push(performedTry);
                });
              }
            }

            var relatedSessionItem = trainee.Session.Items.find(function (x) {
              return x.Id == syllabusItem.Id;
            }); //Pending tries

            var pendingTriesLeft = syllabusItem.MandatoryCount - historyTries.length;

            if (syllabusItem.MandatoryCount == 0 && historyTries.length == 0) {
              //for non-mandatory items: add 1 attempt if not already performed
              pendingTriesLeft = 1;
            }

            var pendingTries = [];

            for (var i = 0; i < pendingTriesLeft; i++) {
              pendingTries.push({
                Comments: null,
                ActionNo: historyTries.length + i + 1,
                isFirstTry: i == 0,
                TryGrading: {
                  Grade: syllabusItem.DefaultGrade ? syllabusItem.DefaultGrade : null,
                  Competences: [],
                  GradeType: syllabusItem.GradeType
                }
              });
            } //Add pending tries to history tries


            var tries = historyTries.concat(pendingTries); //Create syllabus item depending on existing values

            if (!relatedSessionItem) {
              tries.filter(function (x) {
                return !x.isReadOnly;
              }).forEach(function (attempt) {
                attempt.TryGrading.Competences = setTraineeCompetences(syllabusItem.Competences, attempt.TryGrading);
              });
              var newItem = {
                RepeatRequired: false,
                Selected: false,
                Tries: tries,
                PhaseId: scope.selectedPhase.PhaseId,
                Id: syllabusItem.Id
              };
              traineeSessionItems.push(newItem);
              mergeSyllabusItemWithSession(syllabusItem, newItem);
            } else {
              var sessionTries = [];
              tries.forEach(function (tryItem) {
                var relatedSessionTry = relatedSessionItem.Tries.find(function (x) {
                  return x.ActionNo == tryItem.ActionNo;
                });

                if (relatedSessionTry && !tryItem.isReadOnly) {
                  sessionTries.push(deepCopy(relatedSessionTry));
                } else {
                  sessionTries.push(deepCopy(tryItem));
                }
              }); //Add any Extra tries

              if (syllabusItem.MandatoryCount > 0) {
                var extraTries = relatedSessionItem.Tries.filter(function (x) {
                  return x.ActionNo > syllabusItem.MandatoryCount && !x.isReadOnly;
                });
                sessionTries = sessionTries.concat(extraTries);
              }

              sessionTries.filter(function (x) {
                return !x.isReadOnly;
              }).forEach(function (attempt) {
                attempt.TryGrading.Competences = setTraineeCompetences(syllabusItem.Competences, attempt.TryGrading);
              });
              var existingItem = {
                RepeatRequired: relatedSessionItem.RepeatRequired,
                Selected: relatedSessionItem.Selected,
                Tries: sessionTries,
                PhaseId: scope.selectedPhase.PhaseId,
                Id: syllabusItem.Id
              };
              traineeSessionItems.push(existingItem);
              mergeSyllabusItemWithSession(syllabusItem, existingItem);
            }

            var traineeSyllabus = traineeSyllabi.find(function (x) {
              return x.TraineeIds.includes(trainee.CrewId);
            });

            if (!traineeSyllabus.Items.some(function (x) {
              return x.Id == syllabusItem.Id;
            })) {
              traineeSyllabus.Items.push(syllabusItem);
            }
          });
          trainee.Session.Items = traineeSessionItems;
        });
        traineeSyllabi.forEach(function (syllabus) {
          SyllabusGrouping(syllabus);
        });
        scope.traineeSyllabi = traineeSyllabi;
      }

      function mergeSyllabusItemWithSession(syllabusItem, sessionItem) {
        syllabusItem.RepeatRequired = sessionItem.RepeatRequired;
        syllabusItem.Selected = sessionItem.Selected;
        syllabusItem.Tries = sessionItem.Tries;
      }

      function leftScroll() {
        document.querySelector('.horizontal-scroll').scrollLeft -= 500;
      }

      function rightScroll() {
        document.querySelector('.horizontal-scroll').scrollLeft += 500;
      }

      function deepCopy(originalObject) {
        return JSON.parse(JSON.stringify(originalObject));
      }

      function SyllabusGrouping(syllabus) {
        //Syllabus Items Group By 'GroupId'
        var syllabusGroups = [];
        syllabus.Items.forEach(function (item) {
          if (!syllabusGroups.some(function (x) {
            return x.Id == item.SelectedGroup.Id;
          })) {
            if (!item.SelectedGroup) {
              item.SelectedGroup = {
                Id: 0,
                Title: 'General'
              };
            }

            var syllabusGroup = {
              Id: item.SelectedGroup.Id,
              Title: item.SelectedGroup.Title ? item.SelectedGroup.Title : 'General',
              Items: []
            };
            syllabusGroup.Items.push(item);
            syllabusGroups.push(syllabusGroup);
          } else {
            syllabusGroups.filter(function (x) {
              return x.Id == item.SelectedGroup.Id;
            })[0].Items.push(item);
          }
        });
        syllabus.ItemsGrouped = syllabusGroups;
      }

      function setTraineeCompetences(competences, sessionItem) {
        var traineeCompetences = [];
        competences.forEach(function (competence) {
          var traineeCompetence = JSON.parse(JSON.stringify(competence));
          var existingCompetence = sessionItem.Competences.find(function (x) {
            return x.Id == traineeCompetence.Id;
          }); //Get saved values

          traineeCompetence.Grading = existingCompetence ? existingCompetence.Grading : null;
          traineeCompetence.Comments = existingCompetence ? existingCompetence.Comments : null;

          if (existingCompetence) {
            traineeCompetence.SubCompetences.filter(function (x) {
              return existingCompetence.SubCompetences.some(function (y) {
                return y.Id == x.Id;
              });
            }).forEach(function (commonSub) {
              commonSub.Selected = existingCompetence.SubCompetences.find(function (s) {
                return s.Id == commonSub.Id;
              }).Selected;
            });
            traineeCompetence.hasMandatory = traineeCompetence.MandatorySub.includes(Number(traineeCompetence.Grading));
            traineeCompetence.hasOptional = traineeCompetence.OptionalSub.includes(Number(traineeCompetence.Grading));
          }

          traineeCompetences.push(traineeCompetence);
        });
        return traineeCompetences;
      }

      function setSubCompetenceValues(current) {
        var updated = [];
        var first = parseInt(current[0], 10);
        var last = current[current.length - 1];

        if (first) {
          for (var i = first; i <= last; i++) {
            updated.push(i);
          }
        }

        return updated;
      }
      /*****************************************************************  Submit ********************************************************************************/


      function SubmitSession() {
        setReleaseStatus();

        if (!isValidForm()) {
          scope.modalInstance = $uibModal.open({
            templateUrl: 'views/Training/dlgSubmitValidation.html',
            scope: scope,
            backdrop: 'static',
            keyboard: false,
            size: 'lg'
          });
        } else {
          if (isGround) {
            //Last save before submission
            TrainingSessionFactory.updateSession(scope.trainees, scope.course, _courseId, _date, _dutyId, function () {
              // Get all trainees found for this session (filter by course and date)
              TrainingSessionFactory.getSessionTrainees(_courseId, _date, _dutyId, function (Trainees) {
                var _absentTrainees = Trainees.filter(function (x) {
                  return x.Session.Absent;
                });

                if (_absentTrainees.length > 0) {
                  scope.modalInstance = $uibModal.open({
                    templateUrl: 'views/Training/dlgAbsentTrainees.html',
                    controller: 'AbsentTraineesModalCtrl',
                    scope: scope,
                    backdrop: 'static',
                    keyboard: false,
                    size: 'md',
                    resolve: {
                      absentTrainees: function absentTrainees() {
                        return _absentTrainees;
                      }
                    }
                  });
                  scope.modalInstance.result.then(function (response) {
                    if (response === 'confirmed') {
                      manageSubmission(Trainees);
                    }
                  });
                } else {
                  manageSubmission(Trainees);
                }
              });
            });
          } else {
            //Last save before submission
            FlightSessionFactory.updateSession(scope.trainees, scope.course, _courseId, _date, _dutyNo, _dutyDay, function () {
              // Get all trainees found for this session (filter by course and date)
              FlightSessionFactory.getSessionTrainees(_courseId, _date, _dutyNo, _dutyDay, function (Trainees) {
                manageSubmission(Trainees);
              });
            });
          }
        }
      }

      function manageSubmission(Trainees) {
        PrepareSessionForSubmission(Trainees);
        setReleaseStatus();

        var _requiresInstructorSignature = RequiresInstructorSignature();

        var _confirmationMsg = scope.selectedPhase.ReleaseGrading.ConfirmationMessage; // submit now

        var _releaseGrading = (scope.selectedPhase.ReleaseGrading.Comments || scope.selectedPhase.ReleaseGrading.GradeType == 'Numeric' || scope.selectedPhase.ReleaseGrading.GradeType == 'Outcome' || scope.selectedPhase.ReleaseGrading.Competences.length) && scope.selectedPhase.ReleaseGrading.GradeType != 'CertificateExam'; //var isAdditionalTraining = false;   


        var _needsAdditionalTraining = false;

        if (scope.selectedTrainee != null) {
          _needsAdditionalTraining = scope.selectedTrainee.NeedsAdditionalTraining;
        }

        scope.modalInstance = $uibModal.open({
          templateUrl: 'views/Training/dlgSign.html',
          controller: 'SignatureModalCtrl',
          backdrop: 'static',
          keyboard: false,
          size: 'md',
          resolve: {
            courseId: function courseId() {
              return _courseId;
            },
            date: function date() {
              return _date;
            },
            dutyId: function dutyId() {
              return _dutyId;
            },
            dutyNo: function dutyNo() {
              return _dutyNo;
            },
            dutyDay: function dutyDay() {
              return _dutyDay;
            },
            confirmationMsg: function confirmationMsg() {
              return _confirmationMsg;
            },
            requiresInstructorSignature: function requiresInstructorSignature() {
              return _requiresInstructorSignature;
            },
            trainees: function trainees() {
              return scope.trainees;
            },
            submitSession: function submitSession() {
              return SaveSession;
            },
            releaseGrading: function releaseGrading() {
              return _releaseGrading;
            },
            isReleased: function isReleased() {
              return scope.course.ReleasedPhase;
            },
            needsAdditionalTraining: function needsAdditionalTraining() {
              return _needsAdditionalTraining;
            }
          }
        });
        scope.modalInstance.result.then(function (result) {
          if (result.success) {
            $location.path("/");
          }
        });
      }

      function RequiresTraineeSignature() {
        // End of session signature
        var endOfSessionSignature = scope.selectedPhase.DayGrading.TraineeSignature; // End of module signature

        var endOfModuleSignature = scope.course.ReleasedPhase && scope.selectedPhase.ReleaseGrading.TraineeSignature;
        return endOfSessionSignature || endOfModuleSignature;
      }

      function RequiresInstructorSignature() {
        /*  Instructor signature needed if
            1. Syllabus attached needs signature
            2. Completed syllabus items need signature
            3. End of session needs signature
            4. Module is released and end of module needs signature
        */
        // 1. Check if syllabus exists and needs signature
        var syllabusSignature = scope.selectedPhase.Syllabus && scope.selectedPhase.Syllabus.SignatureRequired; // 2. Filter selected syllabus items & check if they need signature

        var selectedItems = [];
        scope.trainees.forEach(function (trainee) {
          var traineeSelectedItems = trainee.Session.Items.filter(function (x) {
            return x.Selected;
          }).map(function (x) {
            return x.Id;
          });
          selectedItems = selectedItems.concat(traineeSelectedItems);
        });
        selectedItems = _toConsumableArray(new Set(selectedItems));
        var syllabusItemSignature = scope.selectedPhase.Syllabus && scope.selectedPhase.Syllabus.SyllabusItems.filter(function (x) {
          return selectedItems.includes(x.Id);
        }).some(function (x) {
          return x.SignatureRequired;
        }); // 3. End of session signature

        var endOfSessionSignature = scope.selectedPhase.DayGrading.InstructorSignature; // 4. End of module signature

        var endOfModuleSignature = scope.course.AvailableRelease && scope.course.ReleasedPhase && scope.selectedPhase.ReleaseGrading.InstructorSignature;
        return syllabusSignature || syllabusItemSignature || endOfSessionSignature || endOfModuleSignature;
      }
      /**
       * Check if Release requirements are met
       * @param {object} group 
       */


      function checkReleaseAvailability() {
        //Available Release if No pending mandatory items
        //Calculate item status for each trainee
        scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).forEach(function (sessionTrainee) {
          if (scope.selectedPhase.Syllabus) {
            var syllabusItems = scope.selectedPhase.Syllabus.SyllabusItems;
            sessionTrainee.Session.Items.forEach(function (sessionItem) {
              var performedTries = sessionItem.Tries.filter(function (x) {
                return x.isReadOnly || x.Selected;
              }).length; // history & current session

              var mandatoryCount = syllabusItems.find(function (x) {
                return x.Id == sessionItem.Id;
              }).MandatoryCount;
              sessionItem.Status = mandatoryCount > 0 && performedTries < mandatoryCount ? "Pending" : "Completed";
            });
            sessionTrainee.AvailableRelease = !sessionTrainee.Session.Items.some(function (x) {
              return x.Status == "Pending";
            });
          } else {
            sessionTrainee.AvailableRelease = true;
          }
        });

        if (scope.selectedPhase.ModuleType == "Training") {
          scope.trainees.filter(function (x) {
            return !x.Session.Absent && !x.AvailableRelease;
          }).forEach(function (trainee) {
            trainee.Session.Released = false;
          });

          if (scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          }).some(function (x) {
            return !x.AvailableRelease;
          })) {
            scope.trainees.filter(function (x) {
              return !x.Session.Absent;
            }).forEach(function (trainee) {
              trainee.Session.Released = false;
            });
          }
        }

        scope.course.ReleasedPhase = scope.trainees.filter(function (x) {
          return !x.Absent;
        }).some(function (x) {
          return x.Session.Released;
        });
        return !scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return !x.AvailableRelease;
        });
      }

      function SaveSession(password, withRelease) {
        scope.submittedSession.SignaturePassword = password;

        if (scope.submittedSession.TraineeSessions.filter(function (x) {
          return x.AdditionalTrainingStatus == 'UnderAdditionalTraining';
        }).length > 0) {
          scope.submittedSession.TraineeSessions.filter(function (x) {
            return !x.Absent && scope.selectedTrainee.AdditionalTrainingStatus == 'UnderAdditionalTraining';
          }).forEach(function (trainee) {
            if (!trainee.NeedsAdditionalTraining) {
              trainee.NeedsAdditionalTraining = false;
              trainee.UnderAdditionalTraining = true;
              trainee.CompleteAdditionalTraining = true;
            }
          });
        }

        if (scope.submittedSession.TraineeSessions.find(function (x) {
          return x.CompleteAdditionalTraining == true;
        })) {
          scope.submittedSession.TraineeSessions.filter(function (x) {
            return !x.Absent && scope.selectedTrainee.AdditionalTrainingStatus == 'UnderAdditionalTraining';
          }).forEach(function (trainee) {
            if (!trainee.NeedsAdditionalTraining) {
              trainee.NeedsAdditionalTraining = false;
              trainee.UnderAdditionalTraining = true;
              trainee.CompleteAdditionalTraining = true;
            }
          });
        }

        if (withRelease) {
          scope.submittedSession.ReleasedPhase = true;
          scope.submittedSession.TraineeSessions.filter(function (x) {
            return !x.Absent;
          }).forEach(function (trainee) {
            trainee.Released = true;
          });
        }

        if (isGround) {
          return TrainingSessionFactory.submitSession(scope.submittedSession);
        } else {
          return FlightSessionFactory.submitSession(scope.submittedSession);
        }
      }

      function PrepareSessionForSubmission(Trainees) {
        // Filter Trainee Sessions
        var trainees = Trainees.filter(function (x) {
          return x.EligibilityStatus;
        });
        trainees.forEach(function (trainee) {
          trainee.Session.Items = trainee.Session.Items.filter(function (x) {
            return x.Selected;
          }); // Empty absent trainee sessions

          if (trainee.Session.Absent) {
            trainee.Session.Items = [];
            trainee.Session.DayGrading.Comments = null;
            trainee.Session.DayGrading.Competences = [];
            trainee.Session.DayGrading.Grade = null;
            trainee.Session.ReleaseGrading.Comments = null;
            trainee.Session.ReleaseGrading.Competences = [];
            trainee.Session.ReleaseGrading.Grade = null;
            trainee.Session.NeedsAdditionalTraining = false;
            trainee.Session.AdditionalTrainingRemarks = null;
          }
        });
        var sessionSectors = [];

        if (!isGround) {
          //Collect session sectors for flight
          trainingFlightIds.forEach(function (flightId) {
            var sector = {
              FlightId: flightId,
              PM: null,
              PF: null,
              SessionSectorSeats: []
            };
            sessionSectors.push(sector);
          });
        } // Create Session


        scope.submittedSession = {
          SessionDate: _date,
          CourseId: _courseId,
          GroundDutyIds: isGround ? [_dutyId] : [],
          Sectors: sessionSectors,
          AircraftVisits: scope.course.Media && scope.course.Media.radioModel == "Aircraft" ? scope.course.Media.inputAircrafts : [],
          SelectedMedia: scope.course.Media ? scope.course.Media.radioModel : "",
          SyntheticDeviceId: scope.course.Media && scope.course.Media.radioModel == "Simulator" ? scope.course.Media.selectedDevice.selection : null,
          ReleasedPhase: scope.course.ReleasedPhase,
          GradeType: scope.selectedPhase.DayGrading.GradeType,
          ReleaseGradeType: scope.selectedPhase.ReleaseGrading.GradeType,
          TraineeSessions: trainees.map(function (x) {
            return x.Session;
          }),
          SyllabusVersionId: scope.selectedPhase.Syllabus ? scope.selectedPhase.Syllabus.SyllabusVersionId : null,
          PhaseId: scope.selectedPhase.PhaseId,
          DowntimeDuration: scope.course.Media && scope.course.Media.radioModel == "Simulator" && scope.downtimeDuration.radioValue == 'true' ? scope.downtimeDuration.minutes : null
        };
      }

      function isValidForm() {
        /*Requirements before submitting a session
            1. OnLine Mode
            2. Date Allowed
            3. Pending syllabus items
            4. Pending syllabus items for different trainee
            5. Media Validation
            6. Day Grading
            7. Release Grading
            8. Certificate Exam Grading
            9. Trainee Signature
        */
        var isValid = false;
        var info = {
          border: "",
          icon: "",
          msg: "",
          scrollToTop: false
        };

        if (!window.navigator.onLine) {
          info = {
            border: "border-left-red",
            icon: "fa-warning text-red",
            msg: "  <strong>Online mode</strong> is required in order to submit a training. <p>Check your connection and try again!</p>",
            scrollToTop: false
          };
        } else if (!dateAllowed()) {
          info = {
            border: "border-left-red",
            icon: "fa-calendar-times-o text-red",
            msg: "You can not submit a session earlier than its duty date!",
            scrollToTop: false
          };
        } else if (scope.requiresTraineeSignature && !scope.allSignaturesComplete) {
          if (scope.selectedTrainee && !scope.selectedTrainee.Session.Authorized) {
            info = {
              border: "border-left-orange",
              icon: "fa-pencil-square-o text-orange",
              msg: "<b>" + scope.selectedTrainee.Name + "</b> needs to sign the form!",
              scrollToTop: false
            };
          } else {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "All trainees need to sign their forms!",
              scrollToTop: true
            };
          }
        } else if (syllabusPending()) {
          var traineeDetailsMsg = "";

          if (scope.selectedTrainee && (scope.selectedPhase.Syllabus.IsGradable || scope.selectedPhase.InFlight)) {
            traineeDetailsMsg = " for <b>" + scope.selectedTrainee.Name + "</b>";
          }

          info = {
            border: "border-left-orange",
            icon: "fa-calendar-times-o text-orange",
            msg: "Form cannot be submitted! <p>Please complete all mandatory syllabus items" + traineeDetailsMsg + "</p>",
            scrollToTop: false
          };
        } else if (traineesPending()) {
          info = {
            border: "border-left-orange",
            icon: "fa-calendar-times-o text-orange",
            msg: "Form cannot be submitted! <p>Please complete all trainee forms. </p>",
            scrollToTop: true
          };
        } else if (!isMediaValid()) {
          if (scope.hasNoAircraft) {
            info = {
              border: "border-left-orange",
              icon: "fa-plane text-orange",
              msg: "You need to provide an aircraft type!",
              scrollToTop: true
            };
          } else if (scope.hasNoDevice) {
            info = {
              border: "border-left-orange",
              icon: "fa-plane text-orange",
              msg: "You need to select a synthetic device!",
              scrollToTop: true
            };
          }
        } else if (!isSyllabusGradingValid()) {
          var invalidTrainees = scope.trainees.filter(function (t) {
            return t.Session.SyllabusValidationErrors && t.Session.SyllabusValidationErrors.Items.length;
          });
          info = {
            border: "border-left-orange",
            icon: "fa-warning text-orange",
            msg: "Some of the selected syllabus items require a grading",
            SyllabusErrors: invalidTrainees.map(function (t) {
              return t.Session.SyllabusValidationErrors;
            }),
            scrollToTop: false
          };
        } else if (!isGradingValid()) {
          if (!scope.gradingValidationInfo.isDayCompetencesValid || !scope.gradingValidationInfo.isReleaseCompetencesValid) {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "You need to grade all competences before submitting!",
              scrollToTop: false
            };
          } else if (!scope.gradingValidationInfo.isDayGradingValid || !scope.gradingValidationInfo.isReleaseGradingValid) {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "You need to grade all trainees!",
              scrollToTop: false
            };
          } else if (!scope.gradingValidationInfo.isCertificateGradingValid) {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "You need to grade all certificate exams!",
              scrollToTop: false
            };
          }
        } else {
          isValid = true;
        }

        scope.info = info;
        return isValid;
      }

      function dateAllowed() {
        var dateAllowed = false; //Submission is allowed only on the day of the training and after

        var trainingDay = moment.utc(_date).valueOf();
        var today = moment.utc().valueOf();

        if (today >= trainingDay) {
          dateAllowed = true;
        }

        return dateAllowed;
      }

      function syllabusPending() {
        var syllabus = scope.selectedPhase.Syllabus;
        var type = scope.selectedPhase.ModuleType;
        return syllabus && type == 'Check' && (scope.selectedTrainee && !scope.selectedTrainee.AvailableRelease || !scope.selectedTrainee && scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return !x.AvailableRelease;
        }));
      }

      function traineesPending() {
        var syllabus = scope.selectedPhase.Syllabus;
        var type = scope.selectedPhase.ModuleType;
        return syllabus && type == 'Check' && scope.selectedTrainee && scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return !x.AvailableRelease;
        });
      }

      function isSyllabusGradingValid() {
        var syllabus = scope.selectedPhase.Syllabus;

        if (syllabus && syllabus.IsGradable) {
          var gradableSyllabusItems = syllabus.SyllabusItems.filter(function (x) {
            return x.IsGradable;
          });
          var gradableSyllabusItemIds = gradableSyllabusItems.map(function (x) {
            return x.Id;
          }); //foreach trainee get selected tries that need grading

          scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          }).forEach(function (trainee) {
            var invalidItems = [];
            trainee.Session.Items.filter(function (x) {
              return x.Selected && gradableSyllabusItemIds.includes(x.Id);
            }).forEach(function (selectedItem) {
              var syllabusItem = gradableSyllabusItems.find(function (x) {
                return x.Id == selectedItem.Id;
              });
              var gradingType = syllabusItem.GradeType; //Numeric or Outcome or Competences

              var traineeSelectedTries = selectedItem.Tries.filter(function (x) {
                return x.Selected;
              });
              traineeSelectedTries.forEach(function (selectedTry) {
                var invalidGrading = gradingType != "Competences" && !selectedTry.TryGrading.Grade;
                var invalidCompetences = gradingType == "Competences" && !selectedTry.TryGrading.isCompetenceValid;

                if (invalidGrading || invalidCompetences) {
                  invalidItems.push(syllabusItem.Title);
                }
              });
            });
            trainee.Session.SyllabusValidationErrors = {
              Name: trainee.Name,
              Items: invalidItems
            };
          });
        }

        return !scope.trainees.some(function (t) {
          return t.Session.SyllabusValidationErrors && t.Session.SyllabusValidationErrors.Items.length;
        });
      }

      function isGradingValid() {
        var isDayGradingValid = scope.selectedPhase.DayGrading.GradeType == "NotSet";
        var isReleaseGradingValid = scope.selectedPhase.ReleaseGrading.GradeType == "NotSet" || scope.selectedPhase.ReleaseGrading.GradeType == "CertificateExam" || !scope.course.AvailableRelease || !scope.course.ReleasedPhase;
        var isCertificateGradingValid = scope.selectedPhase.ReleaseGrading.GradeType != "CertificateExam" || !scope.course.ReleasedPhase;
        var isDayCompetencesValid = scope.selectedPhase.DayGrading.Competences.length == 0;
        var isReleaseCompetencesValid = scope.selectedPhase.ReleaseGrading.Competences.length == 0 || !scope.course.AvailableRelease || !scope.course.ReleasedPhase;
        if (!isDayGradingValid) isDayGradingValid = !scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return !x.Session.DayGrading.isGradeValid;
        });
        if (!isReleaseGradingValid) isReleaseGradingValid = !scope.trainees.filter(function (x) {
          return !x.Session.Absent && x.Session.Released;
        }).some(function (x) {
          return !x.Session.ReleaseGrading.isGradeValid;
        });
        if (!isCertificateGradingValid) isCertificateGradingValid = !scope.trainees.filter(function (x) {
          return !x.Session.Absent && x.AvailableRelease;
        }).some(function (x) {
          return !x.Session.ReleaseGrading.isCertificateValid;
        });
        if (!isDayCompetencesValid) isDayCompetencesValid = !scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return !x.Session.DayGrading.isCompetenceValid;
        });
        if (!isReleaseCompetencesValid) isReleaseCompetencesValid = !scope.trainees.filter(function (x) {
          return !x.Session.Absent && x.Session.Released;
        }).some(function (x) {
          return !x.Session.ReleaseGrading.isCompetenceValid;
        });
        scope.gradingValidationInfo = {
          isDayGradingValid: isDayGradingValid,
          isReleaseGradingValid: isReleaseGradingValid,
          isDayCompetencesValid: isDayCompetencesValid,
          isReleaseCompetencesValid: isReleaseCompetencesValid,
          isCertificateGradingValid: isCertificateGradingValid
        };
        return isDayGradingValid && isReleaseGradingValid && isDayCompetencesValid && isReleaseCompetencesValid && isCertificateGradingValid;
      }

      function isTraineeGradingValid(trainee) {
        var isDayGradingValid = scope.selectedPhase.DayGrading.GradeType == "NotSet";
        var isReleaseGradingValid = scope.selectedPhase.ReleaseGrading.GradeType == "NotSet" || scope.selectedPhase.ReleaseGrading.GradeType == "CertificateExam" || !scope.course.AvailableRelease || !scope.course.ReleasedPhase;
        var isCertificateGradingValid = scope.selectedPhase.ReleaseGrading.GradeType != "CertificateExam" || !scope.course.ReleasedPhase;
        var isDayCompetencesValid = scope.selectedPhase.DayGrading.Competences.length == 0;
        var isReleaseCompetencesValid = scope.selectedPhase.ReleaseGrading.Competences.length == 0 || !scope.course.AvailableRelease || !scope.course.ReleasedPhase;
        if (!isDayGradingValid) isDayGradingValid = trainee.Session.DayGrading.isGradeValid;
        if (!isReleaseGradingValid) isReleaseGradingValid = !trainee.Session.Released || trainee.Session.ReleaseGrading.isGradeValid;
        if (!isCertificateGradingValid) isCertificateGradingValid = !trainee.AvailableRelease || trainee.Session.ReleaseGrading.isCertificateValid;
        if (!isDayCompetencesValid) isDayCompetencesValid = trainee.Session.DayGrading.isCompetenceValid;
        if (!isReleaseCompetencesValid) isReleaseCompetencesValid = !trainee.Session.Released || trainee.Session.ReleaseGrading.isCompetenceValid;
        trainee.Session.gradingValidationInfo = {
          isDayGradingValid: isDayGradingValid,
          isReleaseGradingValid: isReleaseGradingValid,
          isDayCompetencesValid: isDayCompetencesValid,
          isReleaseCompetencesValid: isReleaseCompetencesValid,
          isCertificateGradingValid: isCertificateGradingValid
        };
        return isDayGradingValid && isReleaseGradingValid && isDayCompetencesValid && isReleaseCompetencesValid && isCertificateGradingValid;
      }

      function hasLowDayGrading(trainee) {
        scope.traineeHasLowGrading = false;
        var hasDayNumericGrading = scope.selectedPhase.DayGrading.GradeType == "Numeric";
        var hasDayOutcomeGrading = scope.selectedPhase.DayGrading.GradeType == "Outcome";
        var hasDayCompetences = scope.selectedPhase.DayGrading.Competences.length > 0;

        if (trainee != null) {
          if (hasDayNumericGrading && (trainee.Session.DayGrading.Grade == 1 || trainee.Session.DayGrading.Grade == 2)) {
            scope.traineeHasLowGrading = true;
          }

          if (hasDayOutcomeGrading && (trainee.Session.DayGrading.Grade == "Fail" || trainee.Session.DayGrading.Grade == "PasswithTrainingRecommendation")) {
            scope.traineeHasLowGrading = true;
          }

          if (hasDayCompetences) {
            trainee.Session.DayGrading.Competences.forEach(function (competence) {
              if (competence.hasMandatory) scope.traineeHasLowGrading = true;
            });
          }
        }

        return scope.traineeHasLowGrading;
      }

      function hasLowSyllabusGrading(trainee) {
        scope.traineeHasLowSyllabusGrading = false;
        var syllabus = scope.selectedPhase.Syllabus;

        if (trainee != null) {
          if (syllabus && syllabus.IsGradable) {
            var gradableSyllabusItems = syllabus.SyllabusItems.filter(function (x) {
              return x.IsGradable;
            });
            var gradableSyllabusItemIds = gradableSyllabusItems.map(function (x) {
              return x.Id;
            }); //get selected tries that has low grading

            trainee.Session.Items.filter(function (x) {
              return x.Selected && gradableSyllabusItemIds.includes(x.Id);
            }).forEach(function (selectedItem) {
              var traineeSelectedTries = selectedItem.Tries.filter(function (x) {
                return x.Selected;
              });
              traineeSelectedTries.forEach(function (selectedTry) {
                if (selectedTry.TryGrading.Grade == 1 || selectedTry.TryGrading.Grade == 2 || selectedTry.TryGrading.Grade == 'Fail') scope.traineeHasLowSyllabusGrading = true;

                if (selectedTry.TryGrading.GradeType == 'Competences') {
                  selectedTry.TryGrading.Competences.forEach(function (competence) {
                    if (competence.hasMandatory) scope.traineeHasLowSyllabusGrading = true;
                  });
                }
              });
            });
          }
        }

        return scope.traineeHasLowSyllabusGrading;
      }

      function isMediaValid() {
        scope.hasNoAircraft = scope.course.Media && scope.course.Media.radioModel == "Aircraft" && !scope.course.Media.inputAircrafts.length;
        scope.hasNoDevice = scope.course.Media && scope.course.Media.radioModel == "Simulator" && !scope.course.Media.selectedDevice.selection;
        return !scope.hasNoAircraft && !scope.hasNoDevice;
      }
      /**
       * Triggered after a trainee has successfully signed
       */


      function updateTraineeSignatures() {
        updateSession();
        scope.allSignaturesComplete = !scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return !x.Session.Authorized;
        });
        scope.someSignaturesComplete = scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return x.Session.Authorized;
        });
      }

      function close() {
        scope.modalInstance.close();

        if (scope.info && scope.info.scrollToTop) {
          $window.scrollTo(0, 0);
        }
      }

      function showReleasePanel(syllabus) {
        var retVal = false;
        var phase = scope.selectedPhase;
        var availableCourse = scope.availableCourse && scope.trainees.length;
        var isCheck = phase.ModuleType == 'Check';
        var releaseGrading = (phase.ReleaseGrading.Comments || phase.ReleaseGrading.GradeType == 'Numeric' || phase.ReleaseGrading.GradeType == 'Outcome' || phase.ReleaseGrading.Competences.length) && phase.ReleaseGrading.GradeType != 'CertificateExam';

        if (isCheck) {
          retVal = availableCourse && releaseGrading;
        } else if (scope.traineeSyllabi.length > 1) {
          var crewId = syllabus.TraineeIds[0];
          var trainee = scope.trainees.find(function (x) {
            return x.CrewId == crewId;
          });
          retVal = scope.reloadRelease && trainee.AvailableRelease && trainee.Session.Released && availableCourse && releaseGrading;
        } else {
          retVal = scope.reloadRelease && scope.course.AvailableRelease && scope.course.ReleasedPhase && availableCourse && releaseGrading;
        }

        return retVal;
      }

      function releaseTrainee(syllabus) {
        var crewIds = syllabus.TraineeIds;
        var trainees = scope.trainees.filter(function (x) {
          return crewIds.includes(x.CrewId);
        });
        trainees.forEach(function (trainee) {
          trainee.Session.Released = !trainee.Session.Released;
        });
        scope.course.ReleasedPhase = scope.trainees.filter(function (x) {
          return !x.Absent;
        }).some(function (x) {
          return x.Session.Released;
        });
      }

      function releaseGroup() {
        scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).forEach(function (trainee) {
          trainee.Session.Released = !trainee.Session.Released;
        });
        scope.course.ReleasedPhase = scope.trainees.filter(function (x) {
          return !x.Absent;
        }).some(function (x) {
          return x.Session.Released;
        });
        setReleaseStatus();
      }

      function showReleaseBtn(syllabus) {
        var retVal = false;
        var availableCourse = scope.availableCourse && scope.trainees.length;
        var isCheck = scope.selectedPhase.ModuleType == 'Check';

        if (isCheck) {
          retVal = false;
        } else if (scope.traineeSyllabi.length > 1) {
          var crewId = syllabus.TraineeIds[0];
          var trainee = scope.trainees.find(function (x) {
            return x.CrewId == crewId;
          });
          retVal = scope.reloadRelease && availableCourse && trainee.AvailableRelease && trainee.AdditionalTrainingStatus == 'UnderAdditionalTraining';
        } else {
          retVal = scope.reloadRelease && availableCourse && scope.course.AvailableRelease;
        }

        return retVal;
      }

      function showGroupReleaseBtn() {
        var retVal = false;
        var availableCourse = scope.availableCourse && scope.trainees.length > 0;
        var isCheck = scope.selectedPhase.ModuleType == 'Check';
        var releaseGrading = (scope.selectedPhase.ReleaseGrading.Comments || scope.selectedPhase.ReleaseGrading.GradeType == 'Numeric' || scope.selectedPhase.ReleaseGrading.GradeType == 'Outcome' || scope.selectedPhase.ReleaseGrading.Competences.length) && scope.selectedPhase.ReleaseGrading.GradeType != 'CertificateExam';

        if (isCheck) {
          retVal = false;
        } else {
          retVal = scope.reloadRelease && availableCourse && releaseGrading && !scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          }).some(function (x) {
            return !x.AvailableRelease && x.AdditionalTrainingStatus != 'UnderAdditionalTraining';
          });
        }

        return retVal;
      }

      function getTraineeClass(crewId) {
        isSyllabusGradingValid();
        var textClass = "";
        var trainee = scope.trainees.find(function (x) {
          return x.CrewId == crewId;
        });
        var syllabus = scope.selectedPhase.Syllabus;
        var type = scope.selectedPhase.ModuleType;
        var allSyllabusCompleted = trainee.AvailableRelease; //Draft status

        var selectedItems = trainee.Session.Items.some(function (i) {
          return i.Tries.filter(function (t) {
            return !t.isReadOnly;
          }).some(function (t) {
            return t.Selected;
          });
        }); //Validate syllabus

        var validSyllabusGrading = !trainee.Session.SyllabusValidationErrors || !trainee.Session.SyllabusValidationErrors.Items.length; //Validate Day grading

        var isDayGradingValid = scope.selectedPhase.DayGrading.GradeType == "NotSet";
        var isDayCompetencesValid = scope.selectedPhase.DayGrading.Competences.length == 0;
        if (!isDayGradingValid) isDayGradingValid = trainee.Session.DayGrading.isGradeValid;
        if (!isDayCompetencesValid) isDayCompetencesValid = trainee.Session.DayGrading.isCompetenceValid; //Validate Release grading

        var isReleaseGradingValid = scope.selectedPhase.ReleaseGrading.GradeType == "NotSet" || scope.selectedPhase.ReleaseGrading.GradeType == "CertificateExam" || scope.selectedPhase.ModuleType == "Training" && (!trainee.AvailableRelease || !trainee.Session.Released);
        var isReleaseCompetencesValid = scope.selectedPhase.ReleaseGrading.Competences.length == 0 || scope.selectedPhase.ModuleType == "Training" && (!trainee.AvailableRelease || !trainee.Session.Released);
        if (!isReleaseGradingValid) isReleaseGradingValid = !trainee.Session.Released || trainee.Session.ReleaseGrading.isGradeValid;
        if (!isReleaseCompetencesValid) isReleaseCompetencesValid = !trainee.Session.Released || trainee.Session.ReleaseGrading.isCompetenceValid;

        if (selectedItems) {
          textClass = "bg-amber text-white";

          if (validSyllabusGrading && isDayGradingValid && isDayCompetencesValid && isReleaseGradingValid && isReleaseCompetencesValid && (type == 'Training' || allSyllabusCompleted)) {
            textClass = "bg-green text-white";
          }
        }

        return textClass;
      }

      function togglePanel(panelId) {
        $('#' + panelId).toggle();
      }
      /**
       * Toggle signature panel while trainee hasn't signed yet
       * @param {object} trainee 
       */


      function openTraineeSignature(_trainee) {
        //Enter signature mode : trainee form becomes read-only
        if (!_trainee.Session.Authorized) {
          setReleaseStatus(); //Trainee can sign only if his form is valid

          if (!validateTraineeForm(_trainee)) {
            scope.modalInstance = $uibModal.open({
              templateUrl: 'views/Training/dlgSubmitValidation.html',
              scope: scope,
              backdrop: 'static',
              keyboard: false,
              size: 'lg'
            });
          } else {
            scope.modalInstance = $uibModal.open({
              templateUrl: 'views/Training/dlgTraineeSignature.html',
              controller: 'TraineeSignatureModalCtrl',
              scope: scope,
              backdrop: 'static',
              keyboard: false,
              size: 'md',
              resolve: {
                trainee: function trainee() {
                  return _trainee;
                },
                signatureSuccess: function signatureSuccess() {
                  return updateTraineeSignatures;
                }
              }
            });
          }
        }

        scope.someSignaturesComplete = scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return x.Session.Authorized;
        });
      }

      function validateTraineeForm(trainee) {
        var trainee = scope.selectedTrainee;
        var isValid = false;
        var info = {
          border: "",
          icon: "",
          msg: "",
          scrollToTop: false
        };

        if (!window.navigator.onLine) {
          info = {
            border: "border-left-red",
            icon: "fa-warning text-red",
            msg: "  <strong>Online mode</strong> is required in order to sign. <p>Check your connection and try again!</p>",
            scrollToTop: false
          };
        } else if (syllabusPending()) {
          var traineeDetailsMsg = "";

          if (trainee && (scope.selectedPhase.Syllabus.IsGradable || scope.selectedPhase.InFlight)) {
            traineeDetailsMsg = " for <b>" + trainee.Name + "</b>";
          }

          info = {
            border: "border-left-orange",
            icon: "fa-calendar-times-o text-orange",
            msg: "Form cannot be submitted! <p>Please complete all mandatory syllabus items" + traineeDetailsMsg + "</p>",
            scrollToTop: false
          };
        } else if (!isSyllabusGradingValid() && trainee.Session.SyllabusValidationErrors && trainee.Session.SyllabusValidationErrors.Items.length) {
          info = {
            border: "border-left-orange",
            icon: "fa-warning text-orange",
            msg: "Some of the selected syllabus items require a grading",
            SyllabusErrors: trainee.Session.SyllabusValidationErrors,
            scrollToTop: false
          };
        } else if (!isTraineeGradingValid(trainee)) {
          if (!trainee.Session.gradingValidationInfo.isDayCompetencesValid || !trainee.Session.gradingValidationInfo.isReleaseCompetencesValid) {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "You need to grade all competences!",
              scrollToTop: false
            };
          } else if (!trainee.Session.isDayGradingValid || !trainee.Session.isReleaseGradingValid) {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "You need to select an overall grade !",
              scrollToTop: false
            };
          } else if (!trainee.Session.isCertificateGradingValid) {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "You need to grade all certificate exams!",
              scrollToTop: false
            };
          }
        } else {
          isValid = true;
        }

        scope.info = info;
        return isValid;
      }

      function resetSignature(_trainee2) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Training/dlgResetSignature.html',
          controller: 'TraineeSignatureModalCtrl',
          scope: scope,
          backdrop: 'static',
          keyboard: false,
          size: 'md',
          resolve: {
            trainee: function trainee() {
              return _trainee2;
            },
            signatureSuccess: function signatureSuccess() {
              return updateTraineeSignatures;
            }
          }
        });
        modalInstance.result.then(function (confirm) {
          if (confirm) {
            _trainee2.Session.Authorized = false;
            scope.trainees.find(function (x) {
              return x.CrewId == _trainee2.CrewId;
            }).Session.Authorized = false;
            updateTraineeSignatures();
          }
        });
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/Training/course.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CourseFactory', CourseFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name CourseFactory
   * @description 
   *   Add, Update, Delete and Get Training Courses.
   * @ngInject
   */

  function CourseFactory(IndexedDBService, GroundDutyFactory, $http, apiUrl) {
    /**
     * Initialize Course
     * @memberof CourseFactory
     */
    function Course() {
      this.Id = null;
    }

    var objType = 'Courses';
    var objCallback = Course;
    var service = {
      setCoursesFromServer: setCoursesFromServer,
      setCoursesToStorage: setCoursesToStorage,
      //save all courses
      getCourseFromStorage: getCourseFromStorage,
      addCourseToStorage: addCourseToStorage,
      //update course
      saveOneCourseToStorage: saveOneCourseToStorage,
      //save course
      getCoursesFromStorage: getCoursesFromStorage,
      //get all
      updateCourseInfo: updateCourseInfo,
      updateFlightCourseInfo: updateFlightCourseInfo,
      getCoursesFromStorageByIds: getCoursesFromStorageByIds,
      setCourseOutdated: setCourseOutdated,
      upsertCourse: upsertCourse
    };
    /**
     * Get Course By Id
     * @memberof CourseFactory
     * @param {function} callback  
     */

    function getCourseFromStorage(courseId, callback, errorCallback) {
      IndexedDBService.getById(objType, courseId).then(function (result) {
        callback(result);
      })["catch"](errorCallback);
    }

    ;
    /**
     * Get Courses
     * @memberof CourseFactory
     * @param {function} callback  
     */

    function getCoursesFromStorage(callback, errorCallback) {
      IndexedDBService.getAll(objType).then(function (results) {
        callback(results);
      })["catch"](errorCallback);
    }

    ;
    /**
     * Get Course By Ids
     * @memberof CourseFactory
     * @param {function} callback  
     */

    function getCoursesFromStorageByIds(courseIds, callback, errorCallback) {
      IndexedDBService.getAll(objType).then(function (results) {
        var selectedResults = [];
        results.forEach(function (result) {
          if (courseIds.includes(result.Id) && selectedResults.filter(function (x) {
            return x.Id == result.Id;
          }).length == 0) {
            selectedResults.push(result);
          }
        });
        callback(selectedResults);
      })["catch"](errorCallback);
    }

    ;

    function updateCourseInfo(courseId, dutyId, callback, errorOnSaveCallback, errorOnNetwork) {
      var traingingApiURL = apiUrl + '/Training?courseId=' + courseId + '&dutyId=' + dutyId;
      $http.get(traingingApiURL, {
        'Content-Type': 'application/json'
      }).then(function (data) {
        var course = data.data;
        course.FetchedTime = moment.utc().toJSON();
        var duty = GroundDutyFactory.getGroundDutyFromStorage(dutyId);
        course.FetchedDutyCodes = duty.RelatedGroundDuties.filter(function (x) {
          return !x.IsInstructor;
        }).map(function (x) {
          return String(x.GroundDutyNo);
        });
        course.LastFetchedDutyId = dutyId; //Upsert course in IndexDB 

        upsertCourse(course, function (course) {
          callback(course);
        }, errorOnSaveCallback);
      })["catch"](errorOnNetwork);
    }

    function updateFlightCourseInfo(crewRouteCourse, date, dutyNo, dutyDay, callback, errorOnSaveCallback, errorOnNetwork) {
      var traingingApiURL = apiUrl + '/Training/GetCrewRouteTraining';
      $http.post(traingingApiURL, crewRouteCourse, {
        'Content-Type': 'application/json'
      }).then(function (data) {
        var course = data.data;
        course.FetchedTime = moment.utc().toJSON();
        course.FetchedCrewRoute = {
          date: date,
          dutyNo: dutyNo,
          dutyDay: dutyDay
        }; //Upsert course in IndexDB 

        upsertCourse(course, function (course) {
          callback(course);
        }, errorOnSaveCallback);
      })["catch"](errorOnNetwork);
    }

    function upsertCourse(course, callback, errorOnSaveCallback) {
      getCourseFromStorage(course.Id, function (localCourse) {
        if (localCourse) {
          saveOneCourseToStorage(course);
        } else {
          addCourseToStorage(course);
        }

        callback(course);
      }, errorOnSaveCallback);
    }

    function setCourseOutdated(courseId, callback, errorCallback) {
      getCourseFromStorage(courseId, function (localCourse) {
        if (localCourse) {
          localCourse.NeedsRefresh = true;
          saveOneCourseToStorage(localCourse);
        }

        if (callback) {
          callback();
        }
      }, errorCallback);
    }
    /**
     * Set Courses from server API  
     * @memberof CourseFactory
     * @param {array} courses Courses Object
     * @param {array} courseIdsToSend  Current courses of the storage
     * @param {string} lastSyncDate  Last Sync Date 
     */


    function setCoursesFromServer(courses, callback, errorCallback) {
      getCoursesFromStorage(function (localCourses) {
        // No courses found - Save All Incoming
        if (!localCourses || localCourses.length == 0) {
          setCoursesToStorage(courses);
        } else {
          for (var j = 0; j < courses.length; j++) {
            var IsCourseIncluded = false;

            for (var h = 0; h < localCourses.length; h++) {
              if (courses[j].Id == localCourses[h].Id) {
                IsCourseIncluded = true;
                break;
              }
            } //Update existing course


            if (IsCourseIncluded) {
              localCourses[h].Title = courses[j].Title; //Update title from sync

              saveOneCourseToStorage(localCourses[h]);
            } //Add a new Course
            else {
                addCourseToStorage(courses[j]);
              }
          }

          localCourses.filter(function (x) {
            return !courses.some(function (z) {
              return z.Id == x.Id;
            });
          }).forEach(function (course) {
            IndexedDBService.remove(objType, course.Id);
          });
        }
      });
    }
    /**
     * Set Courses
     * @memberof CourseFactory
     * @param {array} Courses A list of courses to set to indexedDB
     */


    function setCoursesToStorage(Courses, callback, errorCallback) {
      IndexedDBService.addAll(objType, Courses).then(callback)["catch"](errorCallback);
    }

    ;
    /**
     * Add Course to Storage
     * @memberof CourseFactory
     * @param {object} Course
     */

    function addCourseToStorage(Course, callback, errorCallback) {
      IndexedDBService.add(objType, Course).then(callback)["catch"](errorCallback);
    }

    ;
    /**
     * Update Course to Storage
     * @memberof CourseFactory
     * @param {object} Course
     */

    function saveOneCourseToStorage(Course, callback, errorCallback) {
      IndexedDBService.put(objType, Course).then(callback)["catch"](errorCallback);
    }

    ;
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('FlightCourseCtrl', FlightCourseCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name FlightCourseCtrl
   * @description 
   *
   * @ngInject
   */

  function FlightCourseCtrl($route, $filter, $timeout, FlightSessionFactory, CrewRouteFactory, FlightFactory, GroundDutyFactory, CourseFactory, $scope, $location, $routeParams) {
    $scope.gotoCourse = gotoCourse;
    $scope.gotoCrewRoute = gotoCrewRoute;
    $scope.gotoFlight = gotoFlight;
    $scope.stickySelectedTrainee = stickySelectedTrainee;
    $scope.toggleView = toggleView;
    $scope.refreshCourse = refresh;
    $scope.courseTrainees = [];
    var courseId = Number($routeParams.courseId);
    var dutyNo = Number($routeParams.dutyNo);
    var dutyDay = Number($routeParams.dutyDay);
    $scope.viewFromFlight = Number($routeParams.flightId);
    var crewRouteDuty = CrewRouteFactory.getCrewRouteFromStorage(dutyNo, dutyDay);
    var date = $routeParams.date;
    crewRouteDuty.date = date;
    var crewRouteCourse = crewRouteDuty.Courses.find(function (x) {
      return x.CourseId == courseId && new moment(x.Date).isSame(date);
    });
    $scope.isEdit = false;
    $scope.loading = false;
    $scope.refreshSuccess = true; //show refresh icon

    if (!crewRouteDuty) {
      // go to dashboard if no groundDuty
      $location.path("/");
    } else {
      $scope.flights = FlightFactory.getFlightsByDutyNo(dutyNo, dutyDay);
      $scope.currentFlight = $scope.flights.filter(function (f) {
        return f.FlightId == Number($routeParams.flightId);
      });
      var crewRouteTrainees = FlightSessionFactory.getCrewRouteFlightTrainees(dutyNo, dutyDay, crewRouteCourse.TrainingFlightIds); //Get Crew Route's course

      CourseFactory.getCourseFromStorage(courseId, function (savedCourse) {
        var dutyCourse = savedCourse;
        $scope.dutyCourse = dutyCourse;
        initCourse(false);
      });
      $scope.crewRouteDuty = crewRouteDuty;
    }

    function initCourse(afterRefresh) {
      var courseId = $scope.dutyCourse.Id;
      FlightSessionFactory.getSession(courseId, date, dutyNo, dutyDay, crewRouteCourse.TrainingFlightIds, afterRefresh, function (course) {
        if (course && !course.HasLimitedInfo) {
          $scope.availableCourse = true;
          $scope.selectedPhase = course.selectedPhase;
          $scope.trainees = course.CourseTrainees;
          course.SequenceWarning = false;
        }

        $scope.course = course;
        manageCourseStatus($scope.dutyCourse, course, afterRefresh);
        toggleView('History'); //default

        if ($scope.trainees) {
          stickySelectedTrainee(); //Check for status change (new trainees found on a submitted session (reset) || failed certificate trainees want to retake the test)

          if (afterRefresh && $scope.isCourseComplete && $scope.trainees.length) {
            CrewRouteFactory.setCoursePending(dutyNo, dutyDay, courseId, date);
            $scope.isCourseComplete = false;
            $route.reload();
          }
        }

        $scope.reload = false;
        $timeout(function () {
          $scope.reload = true;
        }, 100);
      });
    }

    function gotoCourse(course) {
      $location.path('/course/' + course.Id + '/' + groundDuty.DutyDateS + "/" + groundDuty.Id);
    }

    function gotoCrewRoute() {
      $location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
    }

    function gotoFlight() {
      var flightId = Number($routeParams.flightId);
      $location.path('/flightinfo/' + flightId);
    }

    function refresh() {
      $scope.loading = true;

      if ($scope.isOffline) {
        $timeout(function () {
          $scope.loading = false;
        }, 100);
        $scope.refreshSuccess = false;
        $scope.availableCourseInfo = false;
        $scope.refreshErrorMsg = "Online mode is required in order to get course. Please connect to the internet and try again.";
      } else {
        CourseFactory.updateFlightCourseInfo(crewRouteCourse, date, dutyNo, dutyDay, function () {
          $scope.loading = false;
          $scope.refreshSuccess = true;
          $scope.availableCourseInfo = true;
          initCourse(true);
          $scope.reload = false;
          $timeout(function () {
            $scope.reload = true;
          }, 100);
        }, function () {
          $scope.loading = false;
          $scope.refreshSuccess = false;
          $scope.availableCourseInfo = false;
          $scope.refreshErrorMsg = "Something went wrong! Please Try again.";
        }, function (error) {
          console.log(error);
          $scope.loading = false;
          $scope.refreshSuccess = false;
          $scope.availableCourseInfo = false;
          $scope.refreshErrorMsg = "Oops! Something went wrong!"; //null exception!
          // if (error.data.errorMessage) {
          //     $scope.refreshErrorMsg = error.data.errorMessage;
          // }
        });
      }
    }

    function manageCourseStatus(dutyCourse, course, afterRefresh) {
      // COMPLETED : has been submitted
      var isCourseComplete = crewRouteCourse.Status == "Completed"; // NEEDS SUBMIT : 1 hour has passed since the end of the course

      var now = moment.utc();

      if (!dutyCourse.IsCompleted) {
        var needsSubmit = false;
        var fetched = moment.utc(crewRouteDuty.DutyEnd);
        var duration = moment.duration(now.diff(fetched)).asHours();

        if (duration > 1) {
          needsSubmit = true;
        }
      } // LIMITED : no info available


      var isCourseLimited = !course || course.HasLimitedInfo || course.HasLimitedSession && !afterRefresh; // OUTDATED : NeedsRefresh || 18 hours since last refresh

      var isCourseOutdated = false;

      if (course && course.FetchedTime) {
        var now = moment.utc();
        var fetched = moment.utc(course.FetchedTime);
        var duration = moment.duration(now.diff(fetched)).asHours();

        if (duration > 18 || course.NeedsRefresh) {
          isCourseOutdated = true;
        }
      }

      var hasAdditionalTrainingRequest = false;

      if (course.SubmittedSessions && course.SubmittedSessions.length > 0) {
        if (course.SubmittedSessions.map(function (x) {
          return x.TraineesSessions.filter(function (y) {
            return y.UnderAdditionalTraining == true;
          }).length > 0;
        })) {
          hasAdditionalTrainingRequest = true;
          course.hasAdditionalTrainingRequest = true;
        }

        ;
      }

      var isUnderAdditionalTraining = false;

      if (course.SubmittedSessions && course.SubmittedSessions.length > 0) {
        if (course.SubmittedSessions.map(function (x) {
          return x.TraineesSessions.find(function (y) {
            return y.UnderAdditionalTraining == true;
          });
        })) {
          isUnderAdditionalTraining = true;
          course.isUnderAdditionalTraining = true;
        }

        ;
      }

      $scope.headerMsg = "Refresh Course";
      if (isCourseLimited) $scope.headerMsg = "Fetch Course";
      $scope.hasPendingTraining = !isCourseComplete;
      $scope.hasUnsetTraining = needsSubmit;
      $scope.isCourseLimited = isCourseLimited;
      $scope.isCourseComplete = isCourseComplete;
      $scope.isCourseOutdated = isCourseOutdated;
      $scope.hasAdditionalTrainingRequest = hasAdditionalTrainingRequest;
      $scope.hasNotifications = isCourseLimited || isCourseOutdated || isCourseComplete;
    }

    function stickySelectedTrainee() {
      if ($scope.trainees && $scope.trainees.filter(function (x) {
        return !x.Session.Absent;
      }).length) {
        if ($scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).find(function (x) {
          return x.Session.selected;
        })) {
          $scope.selectedTrainee = $scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          }).find(function (x) {
            return x.Session.selected;
          });
        } else {
          $scope.selectedTrainee = $scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          })[0];
        }
      } else {
        $scope.selectedTrainee = null;
      }

      if ($scope.selectedTrainee) $scope.selectedTraineeBadge = {
        CrewId: $scope.selectedTrainee.CrewId
      };
    }

    function toggleView(mode) {
      $scope.viewMode = mode;
    }
  }
})();
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

(function () {
  'use strict';

  a3_cabin_reports.factory('FlightSessionFactory', FlightSessionFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name FlightSessionFactory
   * @description 
   *   Add, Update, Delete and Flight Sessions.
   * @ngInject
   */

  function FlightSessionFactory(IndexedDBService, CrewRouteFactory, FlightFactory, CourseFactory, $http, apiUrl, $filter) {
    /**
     * Initialize Session
     * @memberof FlightSessionFactory
     */
    function Session() {
      this.Id = null;
    }

    var objType = 'FlightSessions';
    var objCallback = Session;
    var service = {
      getAll: getAll,
      getSession: getSession,
      setSession: setSession,
      updateSession: updateSession,
      getSessionTrainees: getSessionTrainees,
      submitSession: submitSession,
      remove: remove,
      getCrewRouteFlightTrainees: getCrewRouteFlightTrainees,
      applyTraineeInfoToSession: applyTraineeInfoToSession
    };
    /**
     * Get all flight training sessions
     * @memberof FlightSessionFactory
     * @param {function} callback  
     */

    function getAll(callback) {
      IndexedDBService.getAll(objType).then(function (results) {
        callback(results);
      });
    }

    ;
    /**
     * Get session By day and courseId
     * @memberof FlightSessionFactory
     * @param {function} callback  
     */

    function getSession(courseId, day, dutyNo, dutyDay, trainingFlightIds, afterRefresh, callback, errorCallback) {
      IndexedDBService.getById(objType, [day, courseId, dutyNo, dutyDay]).then(function (session) {
        CourseFactory.getCourseFromStorage(courseId, function (course) {
          if (course && !course.HasLimitedInfo && course.CrewCoursePhases && course.CourseTrainees) {
            mergeCourseWithSession(course, session, dutyNo, dutyDay, trainingFlightIds, afterRefresh);
          }

          callback(course);
        }, errorCallback);
      })["catch"](errorCallback);
    }

    ;
    /**
     * Remove session By day, dutyNo, dutyDay and courseId
     * @memberof FlightSessionFactory
     * @param {function} callback  
     */

    function remove(courseId, day, dutyNo, dutyDay, callback, errorCallback) {
      IndexedDBService.remove(objType, [day, courseId, dutyNo, dutyDay]).then(callback)["catch"](errorCallback);
    }

    ;
    /**
    * Get session Trainees By day and courseId
    * @memberof FlightSessionFactory
    * @param {function} callback  
    */

    function getSessionTrainees(courseId, day, dutyNo, dutyDay, callback, errorCallback) {
      IndexedDBService.getById(objType, [day, courseId, dutyNo, dutyDay]).then(function (session) {
        var trainees = session && session.trainees ? session.trainees : [];
        callback(trainees);
      })["catch"](errorCallback);
    }

    ;
    /**
    * Set session
    * @memberof FlightSessionFactory
    * @param {function} callback  
    */

    function setSession(session, callback, errorCallback) {
      IndexedDBService.getById(objType, [session.day, session.courseId, session.dutyNo, session.dutyDay]).then(function (result) {
        if (result) {
          saveSessionToStorage(session).then(callback)["catch"](errorCallback);
          ;
        } else {
          addSessionToStorage(session).then(callback)["catch"](errorCallback);
        }
      })["catch"](errorCallback);
    }

    ;
    /**
    * Set session
    * @memberof FlightSessionFactory
    * @param {function} callback  
    */

    function updateSession(trainees, session, courseId, day, dutyNo, dutyDay, callback, errorCallback) {
      IndexedDBService.getById(objType, [day, courseId, dutyNo, dutyDay]).then(function (localSession) {
        var isNewSession = false;

        if (!localSession) {
          localSession = {
            courseId: courseId,
            day: day,
            dutyNo: dutyNo,
            dutyDay: dutyDay,
            trainees: []
          };
          isNewSession = true;
        } else {
          localSession.trainees = [];
        }

        if (session) {
          localSession.Media = session.Media;
          localSession.ReleasedPhase = session.ReleasedPhase;
          localSession.PilotFunctions = session.PilotFunctions;
          localSession.TraineeEligibilty = session.TraineeEligibilty;
        }

        trainees.forEach(function (trainee) {
          localSession.trainees.push(trainee);
        });

        if (isNewSession) {
          addSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        } else {
          saveSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        }
      })["catch"](errorCallback);
    }

    function mergeCourseWithSession(course, session, dutyNo, dutyDay, trainingFlightIds, afterRefresh) {
      course.HasLimitedSession = session == undefined;
      var hasPreviousSessions = mergeSyllabusWithHistory(course.CourseTrainees, course.CrewCoursePhases);
      filterTraineesByEligibility(dutyNo, dutyDay, course, trainingFlightIds, session, afterRefresh);
      course.CrewCoursePhases.forEach(function (phase) {
        calculatePhaseStatus(phase, course);
      });
      course.selectedPhase = getSelectedPhase(course); // Calculate eligible trainees phase status

      course.CourseTrainees.forEach(function (trainee) {
        var traineePhase = trainee.Phases.find(function (x) {
          return x.PhaseId == course.selectedPhase.PhaseId;
        });

        if (traineePhase) {
          trainee.ActivePhaseStatus = traineePhase.PhaseStatus;
        } else {
          trainee.ActivePhaseStatus = "Pending";
        }

        trainee.Selectable = trainee.ActivePhaseStatus == "InProgress";
      }); // Non InProgress trainees will be marked as NonEligible (remove further ahead trainees on multiple InProgress phases)

      course.CourseTrainees.filter(function (x) {
        return !x.Selectable;
      }).forEach(function (invalidPhaseTrainee) {
        invalidPhaseTrainee.EligibilityStatus = false;
        invalidPhaseTrainee.EligibilityDesc = "AlreadySubmitted";
        course.NonEligibleTrainees.push(invalidPhaseTrainee);
      });
      course.CourseTrainees = course.CourseTrainees.filter(function (x) {
        return x.EligibilityStatus;
      }); // Get trainee sessions

      course.CourseTrainees.forEach(function (trainee) {
        var sessionTrainee = session ? session.trainees.find(function (x) {
          return x.CrewId == trainee.CrewId;
        }) : null;

        if (sessionTrainee) {
          trainee.Session = sessionTrainee.Session;
        } else {
          trainee.Session = {
            Released: course.selectedPhase.ModuleType == "Training" ? false : true,
            CrewId: trainee.CrewId,
            Items: [],
            Absent: false,
            DayGrading: {
              Comments: null,
              Grade: null,
              Competences: []
            },
            ReleaseGrading: {
              Comments: null,
              Grade: null,
              Competences: []
            },
            NeedsAdditionalTraining: false,
            AdditionalTrainingRemarks: null,
            CompleteAdditionalTraining: false
          };
        }
      });
      /*  Set default values for release option
          Training Modules: 'No' release as default
          Check Module: 'Yes' release as default
      */

      course.ReleasedPhase = course.selectedPhase.ModuleType == "Training" ? false : true;

      if (session) {
        course.Media = session.Media;
        course.ReleasedPhase = session.ReleasedPhase;
        course.PilotFunctions = session.PilotFunctions;
        course.TraineeEligibilty = session.TraineeEligibilty;
      }
    }

    function getSelectedPhase(course) {
      var hasSelectedPhase = false;
      var phases = course.CrewCoursePhases;
      phases.forEach(function (phase, index, array) {
        phase.isFirst = index == 0;
        phase.isLast = index + 1 == array.length; // Select the first InProgress & selected phase

        if (!hasSelectedPhase && phase.Status == "InProgress" && phase.isSelected) {
          phase.Selected = true;
          hasSelectedPhase = true;
        }
      }); // Select the first InProgress phase

      if (!hasSelectedPhase && phases.some(function (x) {
        return x.Status == "InProgress";
      })) {
        phases.find(function (x) {
          return x.Status == "InProgress";
        }).Selected = true;
        hasSelectedPhase = true;
      }

      if (!hasSelectedPhase) {
        phases.find(function (x) {
          return x.isFirst;
        }).Selected = true;
      }

      var selectedPhase = phases.find(function (x) {
        return x.Selected;
      });
      return selectedPhase;
    }

    function filterTraineesByEligibility(dutyNo, dutyDay, course, trainingFlightIds, session, afterRefresh) {
      var _course$CourseTrainee;

      // Trainee Eligiblity cases
      // 1. After refresh - Save newly fetched eligibility in session
      // 2. No refresh & Session exists - Get last fetched eligibility from session
      // 3. No refresh & No session exists - Rely on previously fetched eligibility (different duty - same course)
      var traineeEligibility = course.TraineeEligibilty;

      if (!afterRefresh && session && session.TraineeEligibilty) {
        traineeEligibility = session.TraineeEligibilty;
      }

      if (session) session.TraineeEligibilty = traineeEligibility; //update session eligibility
      // Get crew route trainees without any training records

      var trainees = getCrewRouteFlightTrainees(dutyNo, dutyDay, trainingFlightIds);
      var inactiveTrainees = trainees.filter(function (x) {
        return !course.CourseTrainees.some(function (z) {
          return z.CrewId == x.CrewId;
        });
      }); //Exclude Non valid trainees

      var eligibleTraineeIds = Object.keys(traineeEligibility).filter(function (x) {
        return traineeEligibility[x] == "NotStarted" || traineeEligibility[x] == "ValidPhase" || traineeEligibility[x] == "FailedCertificate";
      }).map(Number); // traineeEligibility[x] == "UnderAdditionalTraining" |

      var eligibleTrainees = inactiveTrainees.filter(function (x) {
        return eligibleTraineeIds.includes(x.CrewId);
      });
      eligibleTrainees.forEach(function (trainee) {
        trainee.EligibilityStatus = true;
      });
      createNewPhaseTrainees(dutyNo, dutyDay, trainingFlightIds, course, eligibleTrainees); // Merge eligibleTrainees (inactive) with CourseTrainees (eligible & active)

      course.CourseTrainees.forEach(function (trainee) {
        trainee.EligibilityStatus = true;
      });

      (_course$CourseTrainee = course.CourseTrainees).push.apply(_course$CourseTrainee, _toConsumableArray(eligibleTrainees)); // Non eligible trainees


      var nonEligibleTrainees = inactiveTrainees.filter(function (x) {
        return !eligibleTraineeIds.includes(x.CrewId);
      });
      course.NonEligibleTrainees = nonEligibleTrainees;
      nonEligibleTrainees.forEach(function (trainee) {
        trainee.EligibilityStatus = false;
        trainee.EligibilityDesc = traineeEligibility[trainee.CrewId];
      }); // Result:
      // CourseTrainees = eligible trainees (active or new)
      // Non EligibleTrainees
    }
    /**
     * Create first phase foreach trainee
     * @param {object} groundDuty
     * @param {object} course
     * @param {array} trainees Eligible trainees that haven't yet started training
     */


    function createNewPhaseTrainees(dutyNo, dutyDay, trainingFlightIds, course, trainees) {
      var flights = FlightFactory.getFlightsByDutyNo(dutyNo, dutyDay).filter(function (f) {
        return trainingFlightIds.some(function (z) {
          return z == f.FlightId;
        });
      }); //Match TrainingIndicators with PhaseDutyNos

      var crewCoursePhaseDutyNos = [];
      var crewrouteTrainingIndicators = [];
      course.CrewCoursePhases.forEach(function (coursePhase) {
        crewCoursePhaseDutyNos = crewCoursePhaseDutyNos.concat(coursePhase.FlightTrainingIndicators);
      });
      flights.forEach(function (flight) {
        crewrouteTrainingIndicators.push(flight.TrainingIndicatorId.toString());
      });
      var relatedDutyNos = crewCoursePhaseDutyNos.filter(function (x) {
        return crewrouteTrainingIndicators.includes(x);
      });
      var relatedPhases = course.CrewCoursePhases.filter(function (x) {
        return x.FlightTrainingIndicators.some(function (fti) {
          return relatedDutyNos.includes(fti);
        });
      }); //From related phases, select first in order

      relatedPhases = $filter('orderBy')(relatedPhases, 'OrderNo');
      var firstPhase = relatedPhases[0];
      trainees.forEach(function (trainee) {
        trainee.Phases = [{
          PhaseId: firstPhase.PhaseId,
          PhaseStatus: "InProgress",
          RepeatRequestedItems: [],
          isSelected: true //selectedPhase

        }];
      });
    }

    function getCrewRouteFlightTrainees(dutyNo, dutyDay, trainingFlightIds) {
      var flights = FlightFactory.getFlightsByDutyNo(dutyNo, dutyDay).filter(function (f) {
        return trainingFlightIds.some(function (z) {
          return z == f.FlightId;
        });
      });
      var trainees = [];
      flights.forEach(function (flight) {
        flight.crew.filter(function (x) {
          return x.IsTrainee;
        }).forEach(function (trainee) {
          if (!trainees.some(function (x) {
            return x.id == trainee.id;
          })) {
            //do not push duplicates : trainees that are in multiple flights
            trainees.push(trainee);
          }
        });
      });
      trainees.forEach(function (trainee) {
        trainee.CrewId = trainee.id;
        trainee.Id = trainee.id;
        trainee.Name = trainee.name;
        trainee.AimsId = trainee.aimsId;
      });
      return trainees;
    }

    function calculatePhaseStatus(phase, course) {
      course.CourseTrainees.forEach(function (trainee) {
        var traineePhase = trainee.Phases.find(function (x) {
          return x.PhaseId == phase.PhaseId;
        });

        if (traineePhase && traineePhase.PhaseStatus == "InProgress") {
          phase.Status = "InProgress";
        } else if (!traineePhase && phase.Status != "InProgress") {
          phase.Status = "Pending";
        } else if (traineePhase && traineePhase.PhaseStatus == "Completed" && phase.Status != "InProgress") {
          phase.Status = "Completed";
        } //Selected phase, If at least one trainee has it selected


        if (traineePhase && !phase.isSelected) {
          phase.isSelected = traineePhase.isSelected;
        }
      });
    }

    function mergeSyllabusWithHistory(trainees, phases) {
      var flatSullabusItems = [];
      trainees.forEach(function (trainee) {
        trainee.Phases.forEach(function (phase) {
          phase.Sessions.forEach(function (session) {
            session.Items.forEach(function (item) {
              var flatItem = createFlatHistorySullabusItem(trainee, phase, session, item);
              flatSullabusItems.push(flatItem);
            });
          });
        });
      });
      phases.filter(function (x) {
        return x.Syllabus;
      }).forEach(function (phase, index, array) {
        phase.Syllabus.SyllabusItems.forEach(function (syllabusItem) {
          syllabusItem.History = flatSullabusItems.filter(function (item) {
            return item.ItemId == syllabusItem.Id;
          });
        });
      });
      var hasPreviousSessions = flatSullabusItems.length > 0;
      return hasPreviousSessions;
    }

    function createFlatHistorySullabusItem(trainee, phase, session, item) {
      var flatItem = {
        CrewId: trainee.CrewId,
        PhaseId: phase.PhaseId,
        SessionId: session.SessionId,
        SessionComments: session.SessionComments,
        SubmissionDate: item.SubmissionDate,
        RepeatRequired: item.RepeatRequired,
        Tries: item.Tries,
        ItemId: item.SyllabusItemId,
        Grade: session.Grade,
        GradeType: session.GradeType,
        InstructorName: session.InstructorName,
        InstructorAimsId: session.InstructorAimsId
      };
      return flatItem;
    }
    /**
     * Add Session to Storage
     * @memberof FlightSessionFactory
     * @param {object} Session
     */


    function addSessionToStorage(session) {
      return IndexedDBService.add(objType, session);
    }

    ;
    /**
     * Update Session to Storage
     * @memberof FlightSessionFactory
     * @param {object} Session
     */

    function saveSessionToStorage(session) {
      return IndexedDBService.put(objType, session);
    }

    ;

    function submitSession(submittedSession, callback) {
      var traingingApiURL = apiUrl + '/Training/SubmitTraining';
      return $http.post(traingingApiURL, submittedSession, {
        'Content-Type': 'application/json'
      }).then(callback);
    }

    function applyTraineeInfoToSession(course, courseId, day, dutyNo, dutyDay, callback, errorCallback) {
      IndexedDBService.getById(objType, [day, courseId, dutyNo, dutyDay]).then(function (localSession) {
        var isNewSession = false;

        if (!localSession) {
          localSession = {
            courseId: courseId,
            day: day,
            dutyNo: dutyNo,
            dutyDay: dutyDay,
            trainees: [],
            TraineeEligibilty: course.TraineeEligibilty,
            CourseTrainees: course.CourseTrainees
          };
          isNewSession = true;
        } else {
          localSession.CourseTrainees = course.CourseTrainees;
          localSession.TraineeEligibilty = course.TraineeEligibilty;
        }

        if (isNewSession) {
          addSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        } else {
          saveSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        }
      })["catch"](errorCallback);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('grading', grading);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name grading
  * @restrict E
  * @description
  *   Implementation of overall grading
  * @example
  *   Usage:
  *   <grading></grading>
  * @ngInject
  */

  function grading() {
    function link(scope, element, attrs) {
      scope.getRemainingCharacters = getRemainingCharacters;
      scope.validateGrading = validateGrading;
      scope.filterValidTrainees = filterValidTrainees;
      scope.filterTrainee = filterTrainee;
      scope.saveComment = saveComment;
      scope.isDayGrading = scope.type == "day";
      scope.hasCertificateExam = scope.type == "certificate";
      scope.isCheck = scope.phase == "Check"; //Separate DayGrading and ReleaseGrading 

      scope.sessions = [];
      scope.trainees.filter(function (x) {
        return !x.Session.Absent;
      }).forEach(function (trainee) {
        var session = scope.isDayGrading ? trainee.Session.DayGrading : trainee.Session.ReleaseGrading;
        session.Name = trainee.Name;
        session.AimsId = trainee.AimsId;
        session.CrewId = trainee.CrewId;

        if (scope.isDayGrading || !scope.isDayGrading && !scope.isCheck && trainee.AvailableRelease || !scope.isDayGrading && scope.isCheck) {
          scope.sessions.push(session);
        }
      });
      scope.sessions.forEach(function (traineeSession) {
        validateGrading(traineeSession);
      });
      filterValidTrainees();
      /**
       * Calculate remaining characters for comment input
       * @param {string} text 
       * @param {number} max 
       */

      function getRemainingCharacters(text, max) {
        if (typeof text === "undefined" || text === null) return '';
        if (typeof max === "undefined" || max === null || max < 0 || !max) max = 4000;
        var length = text.length;
        return 'characters left: ' + (max - length);
      }

      function validateGrading(trainee) {
        trainee.isGradeValid = trainee.Grade != null && trainee.Grade != undefined;
      }

      function filterValidTrainees() {
        scope.sessions.forEach(function (traineeSession) {
          traineeSession.isValid = traineeSession.isGradeValid && (!scope.settings.Competences.length || traineeSession.isCompetenceValid);
        });
      }

      function filterTrainee() {
        return function (trainee) {
          var showTrainee = true;

          if (scope.selected) {
            //individual grading view: filter selected
            showTrainee = scope.selected.CrewId == trainee.CrewId;
          }

          return showTrainee;
        };
      }

      function saveComment() {
        scope.commentInput();
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/Training/grading.tpl.html',
      scope: {
        trainees: "=",
        settings: "=",
        type: "@",
        phase: "=",
        selected: "=",
        commentInput: "&onCommentInput"
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('GroundCourseCtrl', GroundCourseCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name GroundCourseCtrl
   * @description 
   *
   * @ngInject
   */

  function GroundCourseCtrl($route, $filter, $timeout, TrainingSessionFactory, CrewRouteFactory, FlightFactory, GroundDutyFactory, CourseFactory, $scope, $location, $routeParams) {
    $scope.gotoCourse = gotoCourse;
    $scope.gotoGroundDuty = gotoGroundDuty;
    $scope.stickySelectedTrainee = stickySelectedTrainee;
    $scope.toggleView = toggleView;
    $scope.refreshCourse = refresh;
    $scope.courseTrainees = [];
    var courseId = Number($routeParams.courseId);
    var groundDutyId = Number($routeParams.dutyId);
    var groundDuty = GroundDutyFactory.getGroundDutyFromStorage(groundDutyId);
    $scope.isEdit = false;
    $scope.loading = false;
    $scope.allAbsent = false;
    $scope.refreshSuccess = true; //show refresh icon

    if (!groundDuty) {
      // go to dashboard if no groundDuty
      $location.path("/");
    } else {
      var date = groundDuty.DutyDateS;

      if (groundDuty.RelatedGroundDuties) {
        var courses = GroundDutyFactory.getGroundDutyActiveCourses(groundDutyId);

        if (courses.length) {
          CourseFactory.getCourseFromStorage(courseId, function (dutyCourse) {
            $scope.dutyCourse = dutyCourse;
            initCourse(false);
          });
        }
      }

      $scope.groundDuty = groundDuty;
      $scope.groundDutyId = groundDutyId;
    }

    function initCourse(afterRefresh) {
      var courseId = $scope.dutyCourse.Id;
      TrainingSessionFactory.getSession(courseId, date, groundDutyId, afterRefresh, function (course) {
        if (course && !course.HasLimitedInfo) {
          $scope.availableCourse = true;
          $scope.selectedPhase = course.selectedPhase;
          $scope.trainees = course.CourseTrainees; //only eligible trainees

          course.SequenceWarning = false;
        }

        $scope.course = course;
        manageCourseStatus($scope.dutyCourse, course, afterRefresh);
        toggleView('History'); //default

        if ($scope.trainees) {
          applyAttendanceFromGroundDuty(groundDuty, $scope.trainees);
          stickySelectedTrainee();

          if ($scope.trainees.length && !$scope.trainees.some(function (x) {
            return !x.Session.Absent;
          })) {
            $scope.allAbsent = true;
          } //Check for status change (new trainees found on a submitted session (reset) || failed certificate trainees want to retake the test)


          if (afterRefresh && $scope.isCourseComplete && $scope.trainees.length) {
            GroundDutyFactory.setCoursePending(groundDutyId, courseId);
            $scope.isCourseComplete = false;
            $route.reload();
          }
        }

        $scope.reload = false;
        $timeout(function () {
          $scope.reload = true;
        }, 100);
      });
    }

    function applyAttendanceFromGroundDuty(groundDuty, trainees) {
      groundDuty.Trainees.forEach(function (related) {
        related.CrewMembers.forEach(function (crew) {
          var trainee = trainees.find(function (x) {
            return x.CrewId == crew.Id;
          });

          if (trainee) {
            trainee.Session.Absent = crew.Absent;
          }
        });
      });
    }

    function gotoCourse(course) {
      $location.path('/course/' + course.Id + '/' + groundDuty.DutyDateS + "/" + groundDuty.Id);
    }

    function refresh() {
      $scope.loading = true;

      if ($scope.isOffline) {
        $timeout(function () {
          $scope.loading = false;
        }, 100);
        $scope.refreshSuccess = false;
        $scope.availableCourseInfo = false;
        $scope.refreshErrorMsg = "Online mode is required in order to get course. Please connect to the internet and try again.";
      } else {
        CourseFactory.updateCourseInfo($scope.dutyCourse.Id, groundDutyId, function () {
          $scope.loading = false;
          $scope.refreshSuccess = true;
          $scope.availableCourseInfo = true;
          initCourse(true);
          $scope.reload = false;
          $timeout(function () {
            $scope.reload = true;
          }, 100);
        }, function () {
          $scope.loading = false;
          $scope.refreshSuccess = false;
          $scope.availableCourseInfo = false;
          $scope.refreshErrorMsg = "Something went wrong! Please Try again.";
        }, function (error) {
          console.log(error);
          $scope.loading = false;
          $scope.refreshSuccess = false;
          $scope.availableCourseInfo = false;
          $scope.refreshErrorMsg = "Oops! Something went wrong!"; //null exception!
          // if (error.data.errorMessage) {
          //     $scope.refreshErrorMsg = error.data.errorMessage;
          // }
        });
      }
    }

    function manageCourseStatus(dutyCourse, course, afterRefresh) {
      // COMPLETED : has been submitted
      var isCourseComplete = courses.find(function (x) {
        return x.CourseId == dutyCourse.Id && x.Status == "Completed";
      }) != null; // NEEDS SUBMIT : 1 hour has passed since the end of the course

      var now = moment.utc();

      if (!dutyCourse.IsCompleted) {
        var needsSubmit = false;
        var fetched = moment.utc(groundDuty.DutyEnd);
        var duration = moment.duration(now.diff(fetched)).asHours();

        if (duration > 1) {
          needsSubmit = true;
        }
      } // LIMITED : no info available


      var isCourseLimited = !course || course.HasLimitedInfo || course.HasLimitedSession && !afterRefresh; // OUTDATED : NeedsRefresh || 18 hours since last refresh

      var isCourseOutdated = false;

      if (course && course.FetchedTime) {
        var now = moment.utc();
        var fetched = moment.utc(course.FetchedTime);
        var duration = moment.duration(now.diff(fetched)).asHours();

        if (duration > 18 || course.NeedsRefresh) {
          isCourseOutdated = true;
        }
      } // ADDITIONAL TRAINING : One trainee, at least, is under additional training


      var hasAdditionalTrainingRequest = false; // if (course.selectedPhase.NeedsAdditionalTraining)       
      //     hasAdditionalTrainingRequest = true; 
      //     course.hasAdditionalTrainingRequest = true;

      $scope.headerMsg = "Refresh Course";
      if (isCourseLimited) $scope.headerMsg = "Fetch Course";
      $scope.hasPendingTraining = !isCourseComplete;
      $scope.hasUnsetTraining = needsSubmit;
      $scope.isCourseLimited = isCourseLimited;
      $scope.isCourseComplete = isCourseComplete;
      $scope.isCourseOutdated = isCourseOutdated;
      $scope.hasNotifications = isCourseLimited || isCourseOutdated || isCourseComplete;
      $scope.hasAdditionalTrainingRequest = hasAdditionalTrainingRequest;
    }

    function gotoGroundDuty() {
      $location.path('/groundDuty/' + groundDutyId);
    }

    function stickySelectedTrainee() {
      var availableRelease = $scope.selectedPhase.ModuleType == "Check" || !$scope.trainees.filter(function (x) {
        return !x.Session.Absent;
      }).some(function (tr) {
        return tr.Session.Items.some(function (i) {
          return i.Status == "Pending";
        });
      });
      var individualGrading = $scope.trainees && $scope.trainees.filter(function (x) {
        return !x.Session.Absent;
      }).length && $scope.selectedPhase && ($scope.selectedPhase.Syllabus && $scope.selectedPhase.Syllabus.IsGradable || $scope.selectedPhase.HasDayGrading || $scope.selectedPhase.HasReleaseGrading && availableRelease || RequiresTraineeSignature());

      if (individualGrading) {
        if ($scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).find(function (x) {
          return x.Session.selected;
        })) {
          $scope.selectedTrainee = $scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          }).find(function (x) {
            return x.Session.selected;
          });
        } else {
          $scope.selectedTrainee = $scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          })[0];
        }
      } else {
        $scope.selectedTrainee = null;
      }

      if ($scope.selectedTrainee) $scope.selectedTraineeBadge = {
        CrewId: $scope.selectedTrainee.CrewId
      };
    }

    function RequiresTraineeSignature() {
      // End of session signature
      var endOfSessionSignature = $scope.selectedPhase.DayGrading.TraineeSignature; // End of module signature

      var endOfModuleSignature = $scope.course.ReleasedPhase && $scope.selectedPhase.ReleaseGrading.TraineeSignature;
      return endOfSessionSignature || endOfModuleSignature;
    }

    function toggleView(mode) {
      $scope.viewMode = mode;
    }
  }
})();
"use strict";

(function () {
  a3_cabin_reports.directive('instructions', instructions);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name notifications
  * @restrict E
  * @description
  *   Show selected module's trainee & instructor instructions
  * @example
  *   Usage:
  *   <instructions></instructions>
  * @ngInject
  */

  function instructions($filter, $routeParams, $location, UserFactory) {
    function link(scope, attrs) {
      scope.warningMessageText = "";
      scope.viewModuleHistory = viewModuleHistory;

      if (!scope.course.isParallel) {
        var currentActiveOrderNo = scope.selectedPhase.OrderNo;
        scope.course.CrewCoursePhases.forEach(function (phase) {
          if (phase.OrderNo < currentActiveOrderNo && phase.Status != "Completed") {
            phase.SequentialWarning = true;
          } //check if phase has any history


          var oldSessions = [];
          scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          }).forEach(function (trainee) {
            var historyPhase = trainee.Phases.find(function (x) {
              return x.PhaseId == phase.PhaseId;
            });
            if (historyPhase && historyPhase.Sessions) oldSessions = oldSessions.concat(historyPhase.Sessions);
          });
          phase.hasHistory = oldSessions.length > 0;
        });
      }

      scope.course.CrewCoursePhases.forEach(function (phase) {
        phase.StatusClass = '';

        if (phase.SequentialWarning) {
          phase.StatusClass = "panel-danger border-left-red";
          phase.BtnClass = "bg-red text-white";
        } else if (phase.Status == 'InProgress') {
          phase.StatusClass = "border-left-blue";
          phase.TextClass = "text-blue";
          phase.BtnClass = "bg-blue text-white";
        } else if (phase.Status == 'Pending') {
          phase.StatusClass = "border-left-gray ";
          phase.TextClass = "text-gray";
          phase.BtnClass = "bg-gray text-white";
        } else if (phase.Status == 'Completed') {
          phase.StatusClass = "border-left-green";
          phase.TextClass = "text-green";
          phase.BtnClass = "bg-green text-white";
        }

        if (phase.PhaseId == scope.selectedPhase.PhaseId) {
          phase.StatusClass = phase.StatusClass + " panel-info";
        }
      });
      var furtherAheadPhases = [];
      furtherAheadPhases = scope.course.CrewCoursePhases.filter(function (x) {
        return x.SequentialWarning;
      });
      furtherAheadPhases = $filter('orderBy')(furtherAheadPhases, 'OrderNo');

      if (furtherAheadPhases.length > 0) {
        scope.course.SequenceWarning = true;
        scope.warningMessageText = "<strong>" + furtherAheadPhases[furtherAheadPhases.length - 1].Title + "</strong> is not completed. Confirm that you want to continue to <strong>" + scope.selectedPhase.Title + ".</strong>";
      }

      scope.traineeInstructions = scope.selectedPhase.TraineeInstructions;
      scope.examinerInstructions = scope.selectedPhase.ExaminerInstructions;
      scope.isInstructorView = false;
      var traineesAimsIds = scope.trainees.map(function (x) {
        return x.AimsId;
      });
      var user = UserFactory.getUser();

      if (!traineesAimsIds.includes(user.aimsId)) {
        scope.isInstructorView = true;
      }

      scope.status = {
        isInstructorOpen: true,
        isTraineeOpen: false
      };
      scope.continueSubmission = continueSubmission;
      scope.cancelSubmission = cancelSubmission;

      function continueSubmission() {
        scope.course.SequenceWarning = false;
      }

      function cancelSubmission() {
        if (scope.isGround) {
          gotoGroundDuty();
        } else {
          gotoCrewRoute();
        }
      }

      function gotoGroundDuty() {
        $location.path('/groundDuty/' + Number($routeParams.dutyId));
      }

      function gotoCrewRoute() {
        var dutyNo = scope.crewRouteDuty.DutyNo;
        var dutyDay = scope.crewRouteDuty.DutyDay;
        $location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
      }

      function viewModuleHistory(phaseId) {
        var courseId = Number($routeParams.courseId);
        var dutyId = Number($routeParams.dutyId);
        var date = $routeParams.date;

        if (dutyId) {
          $location.path('/groundHistory/' + courseId + '/' + dutyId + '/' + date + '/' + phaseId);
        } else {
          var dutyNo = scope.crewRouteDuty.DutyNo;
          var dutyDay = scope.crewRouteDuty.DutyDay;
          $location.path('/flightHistory/' + courseId + '/' + dutyNo + '/' + dutyDay + '/' + date + '/' + phaseId);
        }
      }
    }

    return {
      restrict: 'E',
      templateUrl: "views/Training/instructions.tpl.html",
      scope: false,
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_cabin_reports.directive('media', media);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name ground Media
  * @restrict E
  * @description
  *   Initialize panel with media of training selection, aircraft types & synthetic devices
  * @example
  *   Usage:
  *   <media></media>
  * @ngInject
  */

  function media($location, CourseFactory) {
    function link($scope, attrs) {
      $scope.addAircraftRow = addAircraftRow;
      $scope.removeAircraftRow = removeAircraftRow;
      $scope.showDowntimeDuration = showDowntimeDuration;
      $scope.clearDowntimeDuration = clearDowntimeDuration;
      $scope.isObjectEmpty = isObjectEmpty;
      $scope.downtimeDuration = {
        radioValue: 'false',
        show: false,
        minutes: null
      };
      $scope.sessionDuration = $scope.groundDuty ? (new Date($scope.groundDuty.DutyEnd) - new Date($scope.groundDuty.DutyBegin)) / (1000 * 60) : undefined;
      $scope.downtimeDurationValueChanged = downtimeDurationValueChanged;
      initializeMedia();
      $scope.filterSyntheticDevices = filterSyntheticDevices;

      function isObjectEmpty(obj) {
        return Object.keys(obj).length === 0;
      }

      function initializeMedia() {
        if ($scope.course) {
          if (!$scope.course.Media) {
            // Create Media object
            $scope.course.Media = {
              inputAircrafts: [],
              selectedAircraft: {
                selection: undefined
              },
              selectedDevice: {
                selection: undefined
              },
              radioModel: ""
            };
          }

          if ($scope.course.Media.radioModel == "" || mediaRemoved()) {
            //Auto select media on init or if selection was removed in admin settings
            if ($scope.selectedPhase.InSimulator) $scope.course.Media.radioModel = "Simulator";
            if ($scope.selectedPhase.InAircraft) $scope.course.Media.radioModel = "Aircraft";
            if ($scope.selectedPhase.InClassroom) $scope.course.Media.radioModel = "Classroom";
          }

          if ($scope.selectedPhase.InSimulator) {
            // Check if training centers exist
            if ($scope.course.TrainingCenters && $scope.course.TrainingCenters.length > 0) {
              var defaultCenter = $scope.course.TrainingCenters.find(function (x) {
                return x.IsDefault;
              });

              if (defaultCenter) {
                $scope.course.selectedTrainingCenter = defaultCenter.Id;
                filterSyntheticDevices(defaultCenter.Id);
              } else {
                // If no default center, select "No Center"
                $scope.course.selectedTrainingCenter = 'No Center'; // No need to filter devices based on training center, show all devices

                filterSyntheticDevices('No Center');
              }
            } // Auto-select the first device if not already selected and devices exist


            if ($scope.course.SyntheticDevices && !isObjectEmpty($scope.course.SyntheticDevices)) {
              if (!$scope.course.Media.selectedDevice) {
                $scope.course.Media.selectedDevice = {};
              }

              if (!$scope.course.Media.selectedDevice.selection) {
                // Select the first available device
                $scope.course.Media.selectedDevice.selection = Object.keys($scope.course.SyntheticDevices)[0];
              }
            } else {
              // No devices available, clear the selection
              $scope.course.Media.selectedDevice.selection = undefined;
            }
          } // Create downtime duration object


          $scope.downtimeDuration = {
            radioValue: 'false',
            show: false,
            minutes: null
          };
        }
      }

      function filterSyntheticDevices(trainingCenterId) {
        if (!$scope.course.AllSyntheticDevices) {
          return;
        }

        if (trainingCenterId && trainingCenterId !== 'No Center') {
          $scope.course.SyntheticDevices = $scope.course.AllSyntheticDevices.filter(function (device) {
            return device.TrainingCenterId == trainingCenterId;
          });

          if ($scope.course.SyntheticDevices && $scope.course.SyntheticDevices.length > 0) {
            var defaultDevice = $scope.course.SyntheticDevices.find(function (device) {
              return device.IsDefault;
            });

            if (defaultDevice) {
              $scope.course.Media.selectedDevice.selection = defaultDevice.Id;
            } else {
              $scope.course.Media.selectedDevice.selection = null;
            }
          } else {
            $scope.course.Media.selectedDevice.selection = $scope.course.AllSyntheticDevices;
          }
        } else {
          $scope.course.SyntheticDevices = $scope.course.AllSyntheticDevices;
        }
      }

      function mediaRemoved() {
        return $scope.course.Media.radioModel == "Simulator" && !$scope.selectedPhase.InSimulator || $scope.course.Media.radioModel == "Aircraft" && !$scope.selectedPhase.InAircraft || $scope.course.Media.radioModel == "Classroom" && !$scope.selectedPhase.InClassroom;
      }

      function addAircraftRow() {
        var aircraftTypes = $scope.course.AircraftTypes;

        if ($scope.course.Media.selectedAircraft.selection != undefined && aircraftTypes && aircraftTypes.includes($scope.course.Media.selectedAircraft.selection) && (!$scope.course.Media.inputAircrafts || !$scope.course.Media.inputAircrafts.includes($scope.course.Media.selectedAircraft.selection))) {
          //Add to selected
          if (!$scope.course.Media.inputAircrafts) {
            $scope.course.Media.inputAircrafts = [];
          }

          $scope.course.Media.inputAircrafts.push($scope.course.Media.selectedAircraft.selection); //Remove from options

          $scope.course.AircraftTypes = aircraftTypes.filter(function (aircraft) {
            return aircraft != $scope.course.Media.selectedAircraft.selection;
          }); //Clear 

          $scope.course.Media.selectedAircraft.selection = undefined;
        }
      }

      function removeAircraftRow(aircraft) {
        //Remove from selected
        var acIndex = $scope.course.Media.inputAircrafts.indexOf(aircraft);
        $scope.course.Media.inputAircrafts.splice(acIndex, 1); //Add back to options

        $scope.course.AircraftTypes.push(aircraft);
      }

      function showDowntimeDuration(showDowntime) {
        if (showDowntime == true) {
          $scope.downtimeDuration.show = true;
        } else {
          $scope.downtimeDuration.show = false;
        }
      }

      function clearDowntimeDuration() {
        $scope.downtimeDuration.minutes = null;
      }

      ;

      function downtimeDurationValueChanged() {
        if ($scope.downtimeDuration.minutes > $scope.sessionDuration) {
          $scope.downtimeDuration.minutes = $scope.sessionDuration;
        }

        return $scope.downtimeDuration.minutes;
      }
    }

    return {
      restrict: 'E',
      templateUrl: "views/Training/media.tpl.html",
      $scope: false,
      terminal: true,
      link: link
    };
  }
})();
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

(function () {
  'use strict';

  a3_cabin_reports.controller('ModuleHistoryCtrl', ModuleHistoryCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name ModuleHistoryCtrl
   * @description 
   *
   * @ngInject
   */

  function ModuleHistoryCtrl($scope, $routeParams, TrainingSessionFactory, CourseFactory, FlightSessionFactory, $location) {
    $scope.rightScroll = rightScroll;
    $scope.leftScroll = leftScroll;
    $scope.selectedTrainee = selectedTrainee;
    $scope.selectedSession = selectedSession;
    $scope.gotoCourse = gotoCourse;
    var isGround = false;

    if ($routeParams.dutyId) {
      isGround = true;
      var courseId = Number($routeParams.courseId);
      var dutyId = Number($routeParams.dutyId);
      var date = $routeParams.date;
      var phaseId = Number($routeParams.phaseId);
    } else {
      var courseId = Number($routeParams.courseId);
      var dutyNo = Number($routeParams.dutyNo);
      var dutyDay = Number($routeParams.dutyDay);
      var date = $routeParams.date;
      var phaseId = Number($routeParams.phaseId);
    }

    CourseFactory.getCourseFromStorage(courseId, function (course) {
      $scope.phase = course.CrewCoursePhases.find(function (x) {
        return x.PhaseId == phaseId;
      });
      $scope.course = course;

      if (isGround) {
        TrainingSessionFactory.getSessionTrainees(courseId, date, dutyId, function (trainees) {
          initHistory(trainees);
        });
      } else {
        FlightSessionFactory.getSessionTrainees(courseId, date, dutyNo, dutyDay, function (trainees) {
          initHistory(trainees);
        });
      }
    });

    function initHistory(trainees) {
      if (trainees && trainees.length) {
        trainees.forEach(function (trainee) {
          trainee.HistoryPhase = trainee.Phases.find(function (x) {
            return x.PhaseId == phaseId;
          });
        });
        $scope.historyTrainees = setHistoryTrainees(trainees);
        $scope.selectedTraineeBadge = {
          crewId: trainees[0].CrewId,
          traineeSessionId: trainees[0].HistoryPhase.Sessions[0].Id
        };
        $scope.selectedSubmittedSessionBadge = {
          sessionId: trainees[0].HistoryPhase.Sessions[0].SessionId
        };
      }
    }

    function setHistoryTrainees(trainees) {
      var historyTrainees = trainees.filter(function (x) {
        return x.HistoryPhase && x.HistoryPhase.Sessions && !x.Session.Absent;
      });
      historyTrainees.forEach(function (trainee) {
        trainee.HistoryPhase.hasSectors = trainee.HistoryPhase.Sessions.some(function (x) {
          return x.Sectors && x.Sectors.length > 0;
        });
        trainee.HistoryPhase.Sessions.forEach(function (session) {
          session.hasDayGrading = session.DayGrading.Comments || session.DayGrading.GradeType != 'NotSet' && session.DayGrading.Grade || session.DayGrading.Competences.length > 0;
          session.hasReleaseGrading = session.ReleaseGrading.Comments || session.ReleaseGrading.GradeType != 'NotSet' && session.ReleaseGrading.Grade || session.ReleaseGrading.Competences.length > 0;
          session.AcTypes = _toConsumableArray(new Set(session.Sectors.map(function (ses) {
            return ses.AcType;
          }))); //GroupBy AcType

          session.SectorsByAcType = [];
          session.AcTypes.forEach(function (acType) {
            var group = {
              AcType: acType,
              Sectors: session.Sectors.filter(function (x) {
                return x.AcType == acType;
              })
            };
            session.SectorsByAcType.push(group);
          });
        });
        setTraineeSummary(trainee.HistoryPhase);
      });
      return historyTrainees;
    }

    function setTraineeSummary(phase) {
      var sectorSummary = [];
      var totalSectors = 0; //Unique ac types of all sessions

      var allAcTypes = [];
      phase.Sessions.forEach(function (session) {
        allAcTypes = allAcTypes.concat(session.AcTypes);
      });
      allAcTypes = _toConsumableArray(new Set(allAcTypes)); //Group by ac type

      allAcTypes.forEach(function (acType) {
        var sectors = [];
        phase.Sessions.forEach(function (session) {
          sectors = sectors.concat(session.Sectors.filter(function (x) {
            return x.AcType == acType;
          }));
        });
        var sectorGroup = {
          AcType: acType,
          Sectors: sectors
        };
        totalSectors = totalSectors + sectors.length;
        sectorSummary.push(sectorGroup);
      });
      phase.SectorSummary = sectorSummary;
      phase.TotalSectors = totalSectors;
    }

    function selectedTrainee() {
      return function (trainee) {
        var showSession = false;

        if (trainee.CrewId === $scope.selectedTraineeBadge.crewId) {
          showSession = true;
        }

        return showSession;
      };
    }

    function selectedSession() {
      return function (historyTrainee) {
        var showSession = false;

        if (historyTrainee.SessionId === $scope.selectedSubmittedSessionBadge.sessionId) {
          showSession = true;
        }

        return showSession;
      };
    }

    function leftScroll() {
      document.querySelector('.horizontal-scroll').scrollLeft -= 500;
    }

    function rightScroll() {
      document.querySelector('.horizontal-scroll').scrollLeft += 500;
    }

    function gotoCourse() {
      if (isGround) {
        $location.path('/groundcourse/' + Number($routeParams.courseId) + '/' + Number($routeParams.dutyId) + '/' + $routeParams.date);
      } else {
        $location.path('/flightcourse/' + Number($routeParams.courseId) + '/' + Number($routeParams.dutyNo) + '/' + Number($routeParams.dutyDay) + '/' + $routeParams.date);
      }
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('nonEligibleTrainees', nonEligibleTrainees);
  /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name nonEligibleTrainees
   * @restrict E
   * @description
   *   Show trainees that are not eligible for this training session
   * @example
   *   Usage:
   *   <non-eligible-trainees></non-eligible-trainees>
   * @ngInject 
   */

  function nonEligibleTrainees(FlightSessionFactory, $routeParams) {
    function link(scope) {
      scope.categories = setCategories(); //Collect duty trainees

      var dutyTrainees = [];

      if (scope.groundDuty) {
        scope.groundDuty.Trainees.forEach(function (related) {
          related.CrewMembers.forEach(function (trainee) {
            dutyTrainees.push(trainee);
          });
        });
      } else {
        var date = $routeParams.date;
        var dutyNo = Number($routeParams.dutyNo);
        var dutyDay = Number($routeParams.dutyDay);
        var crewRouteCourse = scope.crewRouteDuty.Courses.find(function (x) {
          return x.CourseId == scope.course.Id && new moment(x.Date).isSame(date);
        });
        var dutyTrainees = FlightSessionFactory.getCrewRouteFlightTrainees(dutyNo, dutyDay, crewRouteCourse.TrainingFlightIds);
      }

      if (scope.course && scope.course.CourseTrainees) {
        categorizeTrainee(dutyTrainees);
      }

      scope.dutyTrainees = dutyTrainees;

      function setCategories() {
        var parallelMessage = "Trainees may have already completed this module";
        var sequentialMessage = "Trainees have either completed this module or are not yet ready to start it";
        return [{
          title: "InvalidPhase",
          msg: scope.course.isParallel ? parallelMessage : sequentialMessage,
          trainees: [],
          all: false
        }, {
          title: "Submitted",
          msg: "Trainees have already been submitted",
          trainees: [],
          all: false
        }, {
          title: "RecurrentPeriod",
          msg: "Trainees have completed the course earlier",
          trainees: [],
          all: false
        }, {
          title: "InvalidRole",
          msg: "For this training, flight crew trainees can only be assessed by a flight crew instructor",
          trainees: [],
          all: false
        }];
      }

      function categorizeTrainee(dutyTrainees) {
        var allEligibilityTrainees = scope.course.CourseTrainees.concat(scope.course.NonEligibleTrainees);
        dutyTrainees.forEach(function (dutyTrainee) {
          var courseTrainee = allEligibilityTrainees.find(function (x) {
            return x.CrewId == dutyTrainee.Id;
          });

          if (courseTrainee) {
            // if (courseTrainee.ActivePhaseStatus == 'Completed') {
            //     scope.categories.find(x => x.title=="Completed").trainees.push(dutyTrainee);
            // }
            if (!courseTrainee.EligibilityStatus && courseTrainee.EligibilityDesc == 'AlreadySubmitted') {
              scope.categories.find(function (x) {
                return x.title == "Submitted";
              }).trainees.push(dutyTrainee);
            }

            if (!courseTrainee.EligibilityStatus && courseTrainee.EligibilityDesc == 'InvalidPhase') {
              scope.categories.find(function (x) {
                return x.title == "InvalidPhase";
              }).trainees.push(dutyTrainee);
            }

            if (!courseTrainee.EligibilityStatus && courseTrainee.EligibilityDesc == 'CooldownPending') {
              scope.categories.find(function (x) {
                return x.title == "RecurrentPeriod";
              }).trainees.push(dutyTrainee);
            }

            if (!courseTrainee.EligibilityStatus && courseTrainee.EligibilityDesc == 'InvalidRole') {
              scope.categories.find(function (x) {
                return x.title == "InvalidRole";
              }).trainees.push(dutyTrainee);
            }
          }
        });
        var allCategory = scope.categories.find(function (x) {
          return x.trainees.length == dutyTrainees.length;
        }); //all trainees in same category

        if (allCategory) {
          allCategory.all = true;
        }
      }
    }

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/Training/non-eligible-trainees.tpl.html",
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('NotificationModalCtrl', NotificationModalCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name NotificationModalCtrl
   * @description 
   * Shows Show Signature 
   * @ngInject
   */

  function NotificationModalCtrl($scope, $uibModalInstance) {
    $scope.close = close;
    /**
     * Close the modal
     * @memberof NotificationModalCtrl
     */

    function close() {
      $uibModalInstance.close($scope.success);
    }
  }
})();
"use strict";

(function () {
  a3_cabin_reports.directive('notifications', notifications);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name notifications
  * @restrict E
  * @description
  *   Initialize panel with information messages about session's status and necessary actions
  * @example
  *   Usage:
  *   <notifications></notifications>
  * @ngInject
  */

  function notifications($routeParams) {
    function link(scope) {
      var info = {
        msg: "",
        border: "",
        text: "",
        showHistory: false
      };
      var date = $routeParams.date;
      scope.filterSession = filterSession;
      scope.selectSession = selectSession;
      scope.historyAvailable = false;
      scope.additionalTrainingRequested = false;
      scope.underAdditionalTraining = false;
      scope.showReleaseOption = false; //If already submitted : show submitted sessions menu and select first [and no additional training is needed]

      if (scope.course.SubmittedSessions && scope.course.SubmittedSessions.length) {
        var submittedDay = scope.course.SubmittedSessions[0].DutyDay;
        var isSame = moment(date).isSame(submittedDay);

        if (isSame) {
          scope.course.historyAvailable = true;
          scope.historyAvailable = true;
          scope.selectedSubmittedSession = {
            sessionId: scope.course.SubmittedSessions[0].SessionId
          };
          scope.course.SubmittedSessions.forEach(function (submittedSession) {
            submittedSession.TraineesSessions.forEach(function (traineeSession) {
              scope.additionalTrainingRequested = traineeSession.NeedsAdditionalRequest;
            });
          });
          scope.course.SubmittedSessions.forEach(function (submittedSession) {
            if (submittedSession.TraineesSessions.some(function (x) {
              return x.IsReleased == false && x.NeedsAdditionalRequest == false;
            })) {
              scope.showReleaseOption = true;
            }

            ;
          });
        }
      } // 1. Check if session has been already submitted 


      var isCourseComplete = scope.isCourseComplete;

      if (isCourseComplete) {
        info = {
          msg: "Training form already submitted for this day.",
          border: "border-left-orange",
          text: "text-orange",
          showHistory: true //show what was submitted in read-only view

        };
      } // 2. Check if course is Outdated


      var isCourseOutdated = scope.isCourseOutdated;

      if (isCourseOutdated) {
        info = {
          msg: "You have an outdated version of this course. Please Refresh Course.",
          border: "border-left-orange",
          text: "text-orange",
          showHistory: false
        };
      } // 3. Check if course needs an initial fetch


      var isCourseLimited = scope.isCourseLimited;

      if (isCourseLimited && !isCourseComplete) {
        isCourseLimited = true;
        info = {
          msg: "You need to perform an initial fetch to receive all available information.",
          border: "border-left-blue",
          text: "text-blue",
          showHistory: false
        };
      } // Result


      scope.info = info;
      /**
       * Filter submitted sessions based on selected from the top menu
       * @returns if session is currently selected
       */

      function filterSession() {
        return function (traineeSession) {
          var showSessionTrainees = false;

          if (traineeSession.SessionId === scope.selectedSubmittedSession.sessionId) {
            showSessionTrainees = true;
          }

          return showSessionTrainees;
        };
      }

      function selectSession(sessionId) {
        scope.selectedSubmittedSession.sessionId = sessionId;
      }
    }

    return {
      restrict: 'E',
      templateUrl: "views/Training/notifications.tpl.html",
      scope: false,
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('releasableModule', releasableModule);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name releasableModule
  * @restrict E
  * @description
  *    Implementation of releasable Module
  * @example
  *   Usage:
  *   <releasable-module></releasable-module>
  * @ngInject
  */

  function releasableModule(TrainingSessionFactory, $uibModal, $location) {
    function link(scope) {
      scope.Submit = Submit;
      scope.selectedTrainee = selectedTrainee;
      scope.toggleTrainee = toggleTrainee;
      scope.getRemainingCharacters = getRemainingCharacters;
      scope.leftScroll = leftScroll;
      scope.rightScroll = rightScroll;
      scope.validateGrading = validateGrading;
      scope.getTraineeClass = getTraineeClass;
      scope.openTraineeSignature = openTraineeSignature;
      scope.resetSignature = resetSignature;
      scope.close = close;

      var _isGround = scope.groundDuty != null && scope.groundDuty != null;

      var phaseId = scope.course.SubmittedSessions[0].PhaseId;
      var phase = scope.course.CrewCoursePhases.find(function (x) {
        return x.PhaseId == phaseId;
      });
      scope.settings = phase.ReleaseGrading; //Collect all trainee sessions that could be released

      var trainees = [];
      scope.course.SubmittedSessions.forEach(function (session) {
        session.TraineesSessions.filter(function (x) {
          return x.CouldBeReleased && !x.NeedsAdditionalRequest && !x.UnderAdditionalTraining && !x.IsStoppedTraineeCourse;
        }).forEach(function (traineeSession) {
          traineeSession.RadioModel = true; //set default realease option true

          trainees.push(traineeSession);
        });
      });

      if (trainees.length) {
        initializeTrainees(trainees, phase);
      }

      scope.phase = phase;
      scope.trainees = trainees;

      function initializeTrainees(trainees, phase) {
        scope.selectedTraineeBadge = {
          crewId: trainees[0].CrewId
        }; // Set Release Grading

        var releaseCompetences = phase.ReleaseGrading.Competences;
        releaseCompetences.forEach(function (competence) {
          competence.MandatorySub = setSubCompetenceValues(competence.MandatorySubCompetences);
          competence.OptionalSub = setSubCompetenceValues(competence.OptionalSubCompetences); //Filter out from optional the ones common with mandatory

          competence.OptionalSub = competence.OptionalSub.filter(function (c) {
            return !competence.MandatorySub.includes(c);
          });
        }); //Set Trainee Competences

        trainees.forEach(function (traineeSession) {
          var competences = [];
          releaseCompetences.forEach(function (competence) {
            competences.push(JSON.parse(JSON.stringify(competence)));
          });
          traineeSession.ReleaseGrading.Competences = competences;
        }); //Initialize validation

        trainees.forEach(function (traineeSession) {
          traineeSession.ReleaseGrading.isGradeValid = scope.settings.GradeType == "NotSet";
          traineeSession.ReleaseGrading.isReleaseGradingValid = scope.settings.Competences.length == 0;
        }); //For ground: check aircraft visits

        if (_isGround && phase.AircraftTypes.length) {
          trainees.forEach(function (trainee) {
            var visitedAircrafts = trainee.AllVisitedAcTypes;
            var pendingAircrafts = [];
            phase.AircraftTypes.forEach(function (type) {
              var array = type.split(','); //if arvi requirement is not met

              if (!array.some(function (x) {
                return visitedAircrafts.includes(x);
              })) {
                var pendingArviList = [];

                if (array.length > 1) {
                  array.forEach(function (arvi) {
                    pendingArviList.push(arvi);
                  });
                } else {
                  pendingArviList.push(array[0]);
                }

                pendingAircrafts.push(pendingArviList);
              }
            });
            trainee.pendingAircrafts = pendingAircrafts;
            trainee.ShowReleaseWarning = trainee.pendingAircrafts.length > 0;
          });
        }

        scope.showReleaseWarning = trainees.some(function (x) {
          return x.ShowReleaseWarning;
        });
      }

      function selectedTrainee() {
        return function (trainee) {
          var showTrainee = false;

          if (trainee.CrewId === scope.selectedTraineeBadge.crewId) {
            showTrainee = true;
          }

          return showTrainee;
        };
      }

      function close() {
        scope.modalInstance.close();
      }

      function toggleTrainee() {
        if (!scope.selectedTraineeBadge.crewId) {
          scope.selectedTraineeBadge.crewId = scope.trainees.find(function (x) {
            return x.RadioModel;
          }).CrewId;
        }

        var selectedCrewId = scope.selectedTraineeBadge.crewId;
        var selectedTrainee = scope.trainees.find(function (x) {
          return x.CrewId == selectedCrewId;
        });

        if (selectedTrainee && !selectedTrainee.RadioModel) {
          if (scope.trainees.find(function (x) {
            return x.RadioModel;
          })) {
            scope.selectedTraineeBadge.crewId = scope.trainees.find(function (x) {
              return x.RadioModel;
            }).CrewId;
          } else {
            scope.selectedTraineeBadge.crewId = null;
          }
        }
      }

      function getTraineeClass(crewId) {
        var textClass = "";
        var trainee = scope.trainees.find(function (x) {
          return x.CrewId == crewId;
        }); //Validate Release grading

        var isReleaseGradingValid = trainee.ReleaseGrading.isGradeValid;
        var isReleaseCompetencesValid = trainee.ReleaseGrading.isCompetenceValid;

        if (isReleaseGradingValid && isReleaseCompetencesValid) {
          textClass = "bg-green text-white";
        } else {
          textClass = "bg-amber text-white";
        }

        return textClass;
      }

      function Submit() {
        if (!isValidForm()) {
          scope.modalInstance = $uibModal.open({
            templateUrl: 'views/Training/dlgSubmitValidation.html',
            scope: scope,
            backdrop: 'static',
            keyboard: false,
            size: 'lg'
          });
        } else {
          scope.modalInstance = $uibModal.open({
            templateUrl: 'views/Training/dlgSign.html',
            controller: 'ReleaseSignatureModalCtrl',
            backdrop: 'static',
            keyboard: false,
            size: 'md',
            resolve: {
              courseId: function courseId() {
                return scope.course.Id;
              },
              isGround: function isGround() {
                return _isGround;
              },
              confirmationMsg: function confirmationMsg() {
                return scope.settings.ConfirmationMessage;
              },
              requiresInstructorSignature: function requiresInstructorSignature() {
                return scope.settings.InstructorSignature;
              },
              trainees: function trainees() {
                return scope.trainees.filter(function (x) {
                  return x.RadioModel;
                });
              },
              submitRelease: function submitRelease() {
                return SubmitRelease;
              }
            }
          });
          scope.modalInstance.result.then(function (result) {
            if (result.success) {
              $location.path("/");
            }
          });
        }
      }

      function SubmitRelease(password) {
        var submittedSessions = {
          SignaturePassword: password,
          TraineesSessions: trainees.filter(function (x) {
            return x.RadioModel;
          })
        };
        return TrainingSessionFactory.releaseSession(submittedSessions);
      }

      function validateGrading(trainee) {
        trainee.ReleaseGrading.isGradeValid = trainee.ReleaseGrading.Grade != null && trainee.ReleaseGrading.Grade != undefined;
      }
      /**
      * Calculate remaining characters for comment input
      * @param {string} text 
      * @param {number} max 
      */


      function getRemainingCharacters(text, max) {
        if (typeof text === "undefined" || text === null) return '';
        if (typeof max === "undefined" || max === null || max < 0 || !max) max = 4000;
        var length = text.length;
        return 'characters left: ' + (max - length);
      }

      function setSubCompetenceValues(current) {
        var updated = [];
        var first = parseInt(current[0], 10);
        var last = current[current.length - 1];

        if (first) {
          for (var i = first; i <= last; i++) {
            updated.push(i);
          }
        }

        return updated;
      }

      function leftScroll() {
        document.querySelector('.horizontal-scroll').scrollLeft -= 500;
      }

      function rightScroll() {
        document.querySelector('.horizontal-scroll').scrollLeft += 500;
      }

      function isValidForm() {
        /*Requirements before split release
            1. OnLine Mode
            2. Valid Release Grading
            3. Trainee Signature
        */
        var selectedTrainee = scope.trainees.find(function (x) {
          return x.CrewId == scope.selectedTraineeBadge.crewId;
        });
        var isValid = false;
        var info = {
          border: "",
          icon: "",
          msg: ""
        };

        if (!window.navigator.onLine) {
          info = {
            border: "border-left-red",
            icon: "fa-warning text-red",
            msg: "  <strong>Online mode</strong> is required in order to submit a training. <p>Check your connection and try again!</p>"
          };
        } else if (scope.settings.TraineeSignature && scope.trainees.filter(function (x) {
          return x.RadioModel;
        }).some(function (x) {
          return !x.Authorized;
        })) {
          if (selectedTrainee && !selectedTrainee.Authorized) {
            info = {
              border: "border-left-orange",
              icon: "fa-pencil-square-o text-orange",
              msg: "<b>" + selectedTrainee.TraineeName + "</b> needs to sign the form!",
              scrollToTop: false
            };
          } else {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "All trainees need to sign their forms!",
              scrollToTop: true
            };
          }
        } else if (!isGradingValid()) {
          info = {
            border: "border-left-orange",
            icon: "fa-warning text-orange",
            msg: ""
          };

          if (selectedTrainee && !selectedTrainee.ReleaseGrading.isCompetenceValid) {
            info.msg = "You need to grade all competences for <b>" + selectedTrainee.TraineeName + "</b> before submitting!";
          } else if (selectedTrainee && !selectedTrainee.ReleaseGrading.isGradeValid) {
            info.msg = "You need to grade <b>" + selectedTrainee.TraineeName + "</b> before submitting!";
          } else if (!scope.gradingValidationInfo.isReleaseCompetencesValid || !scope.gradingValidationInfo.isReleaseGradingValid) {
            info.msg = "You need to grade all trainees before submitting!";
          }
        } else {
          isValid = true;
        }

        scope.info = info;
        return isValid;
      }

      function validateTraineeForm(trainee) {
        /*Requirements before trainee signature
            1. OnLine Mode
            2. Valid Trainee Release Grading
        */
        var isValid = false;
        var info = {
          border: "",
          icon: "",
          msg: ""
        };

        if (!window.navigator.onLine) {
          info = {
            border: "border-left-red",
            icon: "fa-warning text-red",
            msg: "  <strong>Online mode</strong> is required in order to submit a training. <p>Check your connection and try again!</p>"
          };
        } else if (!trainee.ReleaseGrading.isCompetenceValid) {
          info = {
            border: "border-left-orange",
            icon: "fa-warning text-orange",
            msg: "You need to grade all competences!"
          };
        } else if (!trainee.ReleaseGrading.isGradeValid) {
          info = {
            border: "border-left-orange",
            icon: "fa-warning text-orange",
            msg: "You need to select an overall grade!"
          };
        } else {
          isValid = true;
        }

        scope.info = info;
        return isValid;
      }

      function isGradingValid() {
        var isReleaseGradingValid = scope.settings.GradeType == "NotSet";
        var isReleaseCompetencesValid = scope.settings.Competences.length == 0;
        if (!isReleaseGradingValid) isReleaseGradingValid = !scope.trainees.filter(function (x) {
          return x.RadioModel;
        }).some(function (x) {
          return !x.ReleaseGrading.isGradeValid;
        });
        if (!isReleaseCompetencesValid) isReleaseCompetencesValid = !scope.trainees.filter(function (x) {
          return x.RadioModel;
        }).some(function (x) {
          return !x.ReleaseGrading.isCompetenceValid;
        });
        scope.gradingValidationInfo = {
          isReleaseGradingValid: isReleaseGradingValid,
          isReleaseCompetencesValid: isReleaseCompetencesValid
        };
        return isReleaseGradingValid && isReleaseCompetencesValid;
      }

      function openTraineeSignature(_trainee) {
        //Enter signature mode : trainee form becomes read-only
        if (!_trainee.Authorized) {
          //Trainee can sign only if his form is valid
          if (!validateTraineeForm(_trainee)) {
            scope.modalInstance = $uibModal.open({
              templateUrl: 'views/Training/dlgSubmitValidation.html',
              scope: scope,
              backdrop: 'static',
              keyboard: false,
              size: 'lg'
            });
          } else {
            _trainee.Session = {
              Authorized: false
            };
            _trainee.Name = _trainee.TraineeName;
            scope.modalInstance = $uibModal.open({
              templateUrl: 'views/Training/dlgTraineeSignature.html',
              controller: 'TraineeSignatureModalCtrl',
              scope: scope,
              backdrop: 'static',
              keyboard: false,
              size: 'md',
              resolve: {
                trainee: function trainee() {
                  return _trainee;
                },
                signatureSuccess: function signatureSuccess() {
                  return function () {
                    _trainee.Authorized = true;
                  };
                }
              }
            });
          }
        }
      }

      function resetSignature(_trainee2) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Training/dlgResetSignature.html',
          controller: 'TraineeSignatureModalCtrl',
          scope: scope,
          backdrop: 'static',
          keyboard: false,
          size: 'md',
          resolve: {
            trainee: function trainee() {
              return _trainee2;
            },
            signatureSuccess: function signatureSuccess() {
              return function () {};
            }
          }
        });
        modalInstance.result.then(function (confirm) {
          if (confirm) {
            _trainee2.Authorized = false;
            _trainee2.Session.Authorized = false;
          }
        });
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/Training/releasable-module.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_cabin_reports.directive('releaseWarning', releaseWarning);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name releaseWarning
  * @restrict E
  * @description
  *   Soft rules alert in release
  * @example
  *   Usage:
  *   <release-warning></release-warning>
  * @ngInject
  */

  function releaseWarning() {
    function link(scope, attrs) {
      scope.filterSelectedTrainee = filterSelectedTrainee;
      scope.warningTrainees = scope.trainees.filter(function (x) {
        return !x.Session.Absent && x.ShowReleaseWarning;
      });

      function filterSelectedTrainee() {
        return function (trainee) {
          var showTrainee = false;

          if (scope.selectedTrainee) {
            showTrainee = trainee.CrewId == scope.selectedTrainee.CrewId;
          }

          return showTrainee;
        };
      }
    }

    return {
      restrict: 'E',
      templateUrl: "views/Training/releaseWarning.tpl.html",
      scope: false,
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('ReleaseSignatureModalCtrl', ReleaseSignatureModalCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name SignatureModalCtrl
   * @description 
   * Shows Show Signature 
   * @ngInject
   */

  function ReleaseSignatureModalCtrl($scope, $routeParams, CourseFactory, $uibModalInstance, courseId, isGround, confirmationMsg, requiresInstructorSignature, trainees, submitRelease) {
    $scope.close = close;
    $scope.submit = submit;
    $scope.confirm = confirm;
    $scope.confirmAircraft = confirmAircraft;
    $scope.errorMessage = "";
    $scope.successMessage = "";
    $scope.responseText = null;
    $scope.responseHasErrors = null;
    $scope.success = false;
    $scope.isLoading = false;
    $scope.formData = {};
    $scope.requiredSignature = requiresInstructorSignature;
    $scope.isConfirmed = true;
    $scope.finalPendigArVis = [];

    if (isGround && hasPendingAircraftVisits()) {
      $scope.aircraftVisits = true;
    } else if (confirmationMsg) {
      $scope.confirmationMsg = confirmationMsg;
      $scope.isConfirmed = false;
    } else {
      if (!requiresInstructorSignature) {
        //if signature isn't required continue with submit 
        $scope.isLoading = true;
        submit();
      }
    }

    function hasPendingAircraftVisits() {
      var released = trainees.filter(function (x) {
        return x.RadioModel;
      });
      var pendingVisits = released.some(function (x) {
        return x.pendingAircrafts && x.pendingAircrafts.length > 0;
      });

      if (pendingVisits) {
        var maxLength = 0;
        released.forEach(function (trainee) {
          if (trainee.pendingAircrafts.length > maxLength) {
            var maxList = trainee.pendingAircrafts;
            maxLength = maxList.length;
            $scope.finalPendigArVis = trainee.pendingAircrafts;
          }
        });
      }

      return pendingVisits;
    }

    function confirm() {
      $scope.isConfirmed = true;

      if (!requiresInstructorSignature) {
        //if signature isn't required continue with submit 
        $scope.isLoading = true;
        submit();
      }
    }

    function confirmAircraft() {
      $scope.aircraftVisits = false;

      if (confirmationMsg) {
        $scope.confirmationMsg = confirmationMsg;
        $scope.isConfirmed = false;
      }
    }

    function submit() {
      $scope.errorMessage = "";
      $scope.successMessage = "";
      $scope.isLoading = true;
      $scope.success = false;
      var signaturePassword = $scope.formData.password;

      if (!signaturePassword && requiresInstructorSignature) {
        $scope.isLoading = false;
        $scope.errorMessage = "Signature is required. Please enter your password.";
      } else {
        submitRelease(signaturePassword).then(function (data) {
          $scope.isLoading = false;
          var errorMessage = data.data.errorMessage;
          $scope.successMessage = "Training has been submitted."; //always show errorMessage even if success is true

          if (errorMessage && errorMessage.length > 0) {
            $scope.errorMessage = errorMessage; //not Release Trainees

            var responseTrainees = data.data.data.data;
            var responseTraineeCrewIds = responseTrainees.map(function (trainee) {
              return trainee.CrewId;
            });
            $scope.traineeInfo = trainees.filter(function (x) {
              return responseTraineeCrewIds.includes(x.CrewId);
            });
          } else {
            $scope.errorMessage = null;
          }

          CourseFactory.setCourseOutdated(courseId);
          $scope.success = true;
        })["catch"](function (data) {
          $scope.isLoading = false;

          if (data.data && data.data.errorMessage) {
            $scope.errorMessage = data.data.errorMessage;
          } else {
            $scope.errorMessage = "Failed to save Training Session";
          }
        });
      } // clear password


      $scope.formData.password = "";
    }
    /**
     * Close the modal
     * @memberof SignModalCtrl
     */


    function close() {
      var result = {
        "success": $scope.success
      };
      $uibModalInstance.close(result);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('SignatureModalCtrl', SignatureModalCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name SignatureModalCtrl
   * @description 
   * Shows Show Signature 
   * @ngInject
   */

  function SignatureModalCtrl($scope, $routeParams, $uibModalInstance, TrainingSessionFactory, FlightSessionFactory, GroundDutyFactory, CrewRouteFactory, CourseFactory, courseId, date, dutyId, dutyNo, dutyDay, confirmationMsg, requiresInstructorSignature, trainees, submitSession, releaseGrading, isReleased, needsAdditionalTraining) {
    $scope.close = close;
    $scope.submit = submit;
    $scope.confirm = confirm;
    $scope.confirmSubmit = confirmSubmit;
    $scope.releaseSubmit = releaseSubmit;
    $scope.confirmAircraft = confirmAircraft;
    $scope.errorMessage = "";
    $scope.successMessage = "";
    $scope.responseText = null;
    $scope.responseHasErrors = null;
    $scope.success = false;
    $scope.isLoading = false;
    $scope.withGrading = false;
    $scope.formData = {};
    var requiredSignature = requiresInstructorSignature;
    $scope.requiredSignature = requiredSignature;
    $scope.releaseWarning = false;
    $scope.isConfirmed = true;
    $scope.releaseGrading = releaseGrading;
    $scope.finalPendigArVis = [];
    $scope.needsAdditionalTraining = needsAdditionalTraining;
    var isGroundDuty = false;

    if (dutyId) {
      isGroundDuty = true;
    }

    if (releaseNotSelected()) {
      $scope.releaseWarning = true;
    } else if (isGroundDuty && hasPendingAircraftVisits()) {
      $scope.aircraftVisits = true;
    } else if (confirmationMsg && isReleased) {
      $scope.confirmationMsg = confirmationMsg;
      $scope.isConfirmed = false;
    } else {
      if (!requiresInstructorSignature) {
        //if signature isn't required continue with submit 
        $scope.isLoading = true;
        submit();
      }
    }

    function releaseNotSelected() {
      var allAvailable = !trainees.filter(function (x) {
        return !x.Session.Absent;
      }).some(function (x) {
        return !x.AvailableRelease;
      });
      var notReleased = trainees.filter(function (x) {
        return !x.Session.Absent;
      }).some(function (x) {
        return !x.Session.Released;
      });
      return allAvailable && notReleased;
    }

    function hasPendingAircraftVisits() {
      var released = !trainees.filter(function (x) {
        return !x.Session.Absent;
      }).some(function (x) {
        return !x.Session.Released;
      }) || $scope.withGrading;
      var pendingVisits = released && trainees.filter(function (x) {
        return !x.Session.Absent;
      }).some(function (x) {
        return x.pendingAircrafts && x.pendingAircrafts.length > 0;
      });

      if (pendingVisits) {
        var maxLength = 0;
        trainees.filter(function (x) {
          return !x.Session.Absent;
        }).forEach(function (trainee) {
          if (trainee.pendingAircrafts.length > maxLength) {
            var maxList = trainee.pendingAircrafts;
            maxLength = maxList.length;
            $scope.finalPendigArVis = trainee.pendingAircrafts;
          }
        });
      }

      return pendingVisits;
    }

    function confirm() {
      $scope.isConfirmed = true;

      if (!requiresInstructorSignature) {
        //if signature isn't required continue with submit 
        $scope.isLoading = true;
        submit();
      }
    }

    function confirmSubmit() {
      $scope.releaseWarning = false;

      if (isGroundDuty && hasPendingAircraftVisits()) {
        $scope.aircraftVisits = true;
      }
    }

    function confirmAircraft() {
      $scope.aircraftVisits = false;

      if (confirmationMsg) {
        $scope.confirmationMsg = confirmationMsg;
        $scope.isConfirmed = false;
      }
    }

    function releaseSubmit() {
      $scope.withGrading = true;
      $scope.releaseWarning = false;

      if (hasPendingAircraftVisits()) {
        $scope.aircraftVisits = true;
      } else if (confirmationMsg) {
        $scope.confirmationMsg = confirmationMsg;
        $scope.isConfirmed = false;
      }
    }

    function submit() {
      $scope.errorMessage = "";
      $scope.successMessage = "";
      $scope.isLoading = true;
      $scope.success = false;
      var signaturePassword = $scope.formData.password;

      if (!signaturePassword && requiredSignature) {
        $scope.isLoading = false;
        $scope.errorMessage = "Signature is required. Please enter your password.";
      } else {
        submitSession(signaturePassword, $scope.withGrading).then(function (data) {
          $scope.isLoading = false;
          var errorMessage = data.data.errorMessage;
          $scope.successMessage = "Training has been submitted."; //always show errorMessage even if success is true

          if (errorMessage && errorMessage.length > 0) {
            $scope.errorMessage = errorMessage; //not Release Trainees

            var responseTrainees = data.data.data.data;
            var responseTraineeCrewIds = responseTrainees.map(function (trainee) {
              return trainee.CrewId;
            });
            $scope.traineeInfo = trainees.filter(function (x) {
              return responseTraineeCrewIds.includes(x.CrewId);
            });
          } else {
            $scope.errorMessage = null;
          }

          if (dutyId) {
            //isGround
            TrainingSessionFactory.remove(courseId, date, dutyId);
            GroundDutyFactory.setCourseCompleted(dutyId, courseId);
          } else {
            //isFlight
            FlightSessionFactory.remove(courseId, date, dutyNo, dutyDay);
            CrewRouteFactory.setCourseCompleted(dutyNo, dutyDay, courseId, date);
          }

          CourseFactory.setCourseOutdated(courseId);
          $scope.success = true;
        })["catch"](function (data) {
          $scope.isLoading = false;

          if (data.data && data.data.errorMessage) {
            $scope.errorMessage = data.data.errorMessage;
          } else {
            $scope.errorMessage = "Failed to save Training Session";
          }
        });
      } // clear password


      $scope.formData.password = "";
    }
    /**
     * Close the modal
     * @memberof SignModalCtrl
     */


    function close() {
      var result = {
        "success": $scope.success
      };
      $uibModalInstance.close(result);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('syllabusItemHeader', syllabusItemHeader);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name syllabusItemHeader
  * @restrict E
  * @description
  *   Panel heading for syllabus items
  * @example
  *   Usage:
  *   <syllabus-item-header></syllabus-item-header>
  * @ngInject
  */

  function syllabusItemHeader() {
    function link(scope, element, attrs) {
      scope.selectTry = selectTry;
      scope.selectGrading = selectGrading; //find first not ReadOnly try

      scope.pendingAttempt = scope.item.Tries.find(function (x) {
        return x.isFirstTry;
      });
      scope.firstTry = scope.item.Tries[0];

      function selectTry() {
        if (scope.pendingAttempt) {
          scope.itemSelection();
        }
      }

      function selectGrading() {
        scope.gradingSelection();
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/Training/syllabus-item-header.tpl.html',
      scope: {
        item: "=",
        itemSelection: "&onItemSelection",
        gradingSelection: "&onGradingSelection"
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('syllabus', syllabus);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name certificates
  * @restrict E
  * @description
  *   Implementation of syllabus
  * @example
  *   Usage:
  *   <syllabus></syllabus>
  * @ngInject
  */

  function syllabus(TrainingSessionFactory, FlightSessionFactory, $timeout) {
    function link(scope, element, attrs) {
      var isGround = false;
      var courseId = scope.dutyCourse.Id;

      if (scope.groundDuty) {
        isGround = true;
        var date = scope.groundDuty.DutyDateS;
        var dutyId = scope.groundDuty.Id;
      } else {
        var date = scope.crewRouteDuty.date;
        var dutyNo = scope.crewRouteDuty.DutyNo;
        var dutyDay = scope.crewRouteDuty.DutyDay;
      }

      scope.updateTraineesSyllabus = updateTraineesSyllabus;
      scope.selectTry = selectTry;
      scope.updateTry = updateTry;
      scope.oneAtATime = true;
      scope.addTry = addTry;
      scope.removeTry = removeTry;
      scope.setPanelStyle = setPanelStyle;
      scope.selectTryFromHeader = selectTryFromHeader;
      scope.gradeFromHeader = gradeFromHeader;
      scope.nonGradableSyllabus = scope.traineeSyllabi[0].Items.every(function (item) {
        return !item.IsGradable;
      });
      scope.personalizedRemarks = false;
      scope.showPersonalizedRemarks = false;
      scope.personalizedRemarksChanged = personalizedRemarksChanged;
      scope.addTraineeRemarksRow = addTraineeRemarksRow;
      scope.traineesPersonalizedRemarks = [];
      scope.updatePersonalizeRemarks = updatePersonalizeRemarks;
      scope.deleteTraineeRemarks = deleteTraineeRemarks;
      scope.isAddRemarksButtonDisabled = isAddRemarksButtonDisabled;
      scope.traineeValueChanged = traineeValueChanged;
      scope.hasSelectedTrainee = false;
      scope.traineeSyllabi.forEach(function (traineeSyllabus) {
        traineeSyllabus.Items.forEach(function (syllabusItem) {
          syllabusItem.usePersonalizedRemarks = false;
          syllabusItem.traineesPersonalizedRemarks = [];
          syllabusItem.Tries.forEach(function (attempt) {
            //Check if default grade exists & set status
            if (syllabusItem.IsGradable && !attempt.isReadOnly) {
              itemAutoSelection(syllabusItem, attempt); //select item depending on grade existence
            }
          });
          setPanelStyle(syllabusItem); //ui depending on validation & status

          updateTraineesSyllabus(syllabusItem, traineeSyllabus); //copy values to all trainee syllabi 
        });
      }); //Multiple syllabi - Get session to store competence grading

      if (scope.traineeSyllabi.length > 1) {
        scope.traineeSyllabi.forEach(function (traineeSyllabus) {
          var crewId = traineeSyllabus.TraineeIds[0];
          var trainee = scope.trainees.find(function (x) {
            return x.CrewId == crewId;
          });
          traineeSyllabus.TraineeName = trainee.Name;
          traineeSyllabus.TraineeAimsId = trainee.AimsId;
        });
      }

      function gradeFromHeader(syllabus, syllabusItem) {
        var firstPendingTry = syllabusItem.Tries.filter(function (x) {
          return !x.isReadOnly;
        })[0];
        updateTry(syllabus, syllabusItem, firstPendingTry);
        setPanelStyle(syllabusItem);
        updateTraineesSyllabus(syllabusItem, syllabus);
        triggerSyllabusClick();
      }

      function selectTryFromHeader(syllabus, syllabusItem) {
        var firstPendingTry = syllabusItem.Tries.filter(function (x) {
          return !x.isReadOnly;
        })[0];
        selectTry(syllabus, syllabusItem, firstPendingTry);

        if (isGround) {
          TrainingSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyId, console.log, function (e) {
            console.log(e);
          });
        } else {
          FlightSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyNo, dutyDay, console.log, function (e) {
            console.log(e);
          });
        }

        triggerSyllabusClick();
      }

      function triggerSyllabusClick() {
        //preventDefault() and stopPropagation() prevents setReleaseStatus() to be triggered
        $timeout(function () {
          var el = document.getElementById('syllabus');
          angular.element(el).triggerHandler('click');
        }, 0);
      }

      function selectTry(syllabus, syllabusItem, attempt) {
        attempt.Selected = !attempt.Selected;
        syllabusItem.Selected = syllabusItem.Tries.filter(function (t) {
          return !t.isReadOnly;
        }).some(function (t) {
          return t.Selected;
        });
        setPanelStyle(syllabusItem);
        updateTraineesSyllabus(syllabusItem, syllabus);
      }

      function updateTry(syllabus, syllabusItem, attempt) {
        if (syllabusItem.IsGradable) {
          itemAutoSelection(syllabusItem, attempt); //select item depending on grade existence
        }

        setPanelStyle(syllabusItem); //ui depending on validation & status

        updateTraineesSyllabus(syllabusItem, syllabus); //copy values to all trainee syllabi 

        updateSession(); //save in IndexDb
      }

      function itemAutoSelection(syllabusItem, attempt) {
        var hasCompetencesGrading = attempt.TryGrading.Competences.some(function (x) {
          return x.Grading;
        });

        if (attempt.TryGrading.Grade || hasCompetencesGrading) {
          attempt.Selected = true;
          syllabusItem.Selected = true;
        } else {
          attempt.Selected = false;
          syllabusItem.Selected = false; //Check if any of the tries has grading - If not, deselect item

          var pendingTries = syllabusItem.Tries.filter(function (x) {
            return !x.isReadOnly;
          }); //filter out history tries

          for (var i = 0; i < pendingTries.length; i++) {
            var itemTry = pendingTries[i];
            var tryCompetenceGrading = itemTry.TryGrading.Competences.some(function (x) {
              return x.Grading;
            });

            if (itemTry.TryGrading.Grade || tryCompetenceGrading) {
              syllabusItem.Selected = true;
              break;
            }
          }
        }
      }

      function setPanelStyle(item) {
        var historyTriesCount = item.Tries.filter(function (x) {
          return x.isReadOnly;
        }).length;
        var newTriesCount = item.Tries.filter(function (x) {
          return !x.isReadOnly && x.Selected;
        }).length;
        item.TriesPerformedCount = historyTriesCount + newTriesCount;
        var completedItem = item.TriesPerformedCount >= item.MandatoryCount;

        if (item.MandatoryCount == 0) {
          //non-mandatory items are considered completed if performed at least once
          completedItem = item.TriesPerformedCount >= 1;
        }

        var invalidItem = false;
        var nonCompetentItem = false;

        if (item.IsGradable && item.Selected) {
          var gradingType = item.GradeType; //Numeric or Outcome or Competences

          var traineeSelectedTries = item.Tries.filter(function (x) {
            return x.Selected;
          });
          traineeSelectedTries.forEach(function (selectedTry) {
            var invalidGrading = gradingType != "Competences" && !selectedTry.TryGrading.Grade;
            var invalidCompetences = gradingType == "Competences" && !selectedTry.TryGrading.isCompetenceValid;

            if (invalidGrading || invalidCompetences) {
              invalidItem = true;
            }
          });

          if (!invalidItem && traineeSelectedTries.some(function (t) {
            return t.TryGrading.Grade === "Fail";
          })) {
            nonCompetentItem = true;
          }

          if (!invalidItem && gradingType == "Outcome" && item.MandatoryCount > 0) {
            // Get the grades from the tries
            var tries = item.Tries.map(function (t) {
              return t.TryGrading.Grade;
            });
            var mandatoryTries = item.MandatoryCount;
            var competentCount = 0;
            var nonCompetentCount = 0;
            var isCompetent = false;

            for (var i = 0; i < tries.length; i++) {
              if (tries[i] === 'Pass') {
                competentCount++;
                nonCompetentCount = 0; // reset non-competent count

                if (competentCount >= mandatoryTries) {
                  // item.PanelClass = 'panel-border-left-green';
                  isCompetent = true;
                }
              } else {
                if (tries[i] === 'Fail') {
                  nonCompetentCount++;
                  competentCount = 0;

                  if (nonCompetentCount >= mandatoryTries) {
                    // item.PanelClass = 'panel-border-left-pink';
                    nonCompetentItem = true;
                    break; // Exit if mandatory fails are reached
                  }
                }
              }
            }

            if (nonCompetentItem) {
              item.PanelClass = 'panel-border-left-pink';
            } else if (isCompetent) {
              item.PanelClass = 'panel-border-left-green';
            } else {
              item.PanelClass = 'panel-border-left-blue';
            }

            return;
          } // if (!invalidItem && gradingType != "Outcome" && traineeSelectedTries.some(t => t.TryGrading.Grade === "Fail")) {
          //     nonCompetentItem = true;
          // }

        } // if (completedItem && !nonCompetentItem) {
        //     item.PanelClass = 'panel-green panel-border-left-green ';
        // } else if ((completedItem && nonCompetentItem)) {
        //     item.PanelClass = 'panel-border-left-pink';
        // }
        // else {
        //     item.PanelClass = 'panel-border-left-blue ';
        // }
        // if (invalidItem) {
        //     item.PanelClass = 'panel-border-left-orange ';
        // }


        if (invalidItem) {
          item.PanelClass = 'panel-border-left-orange';
        } else if (completedItem && nonCompetentItem) {
          item.PanelClass = 'panel-border-left-pink';
        } else if (completedItem && !nonCompetentItem) {
          item.PanelClass = 'panel-green panel-border-left-green';
        } else {
          item.PanelClass = 'panel-border-left-blue';
        }
      }

      function updateTraineesSyllabus(item, syllabus) {
        var crewIds = syllabus.TraineeIds;
        scope.trainees.filter(function (x) {
          return crewIds.includes(x.CrewId);
        }).forEach(function (trainee) {
          var sessionItem = trainee.Session.Items.find(function (sessionItem) {
            return item.Id == sessionItem.Id;
          });
          sessionItem.RepeatRequired = item.RepeatRequired;
          sessionItem.Selected = item.Selected;
          sessionItem.PhaseId = item.PhaseId;
          sessionItem.Tries = deepCopy(item.Tries);
          sessionItem.SyllabusItemId = item.Id;
          sessionItem.TriesPerformedCount = item.TriesPerformedCount;
        });
        updatePersonalizeRemarks(item);
      }

      function deepCopy(originalObject) {
        return JSON.parse(JSON.stringify(originalObject));
      }

      function addTry(item, syllabus) {
        var competences = deepCopy(item.Competences);
        var newTry = {
          Comments: null,
          ActionNo: item.Tries.length + 1,
          Selected: true,
          TryGrading: {
            Grade: null,
            Competences: competences,
            GradeType: item.GradeType
          }
        };
        item.Selected = true;
        item.Tries.push(newTry);
        setPanelStyle(item);
        updateTraineesSyllabus(item, syllabus);
      }

      function removeTry(item, syllabus) {
        item.Tries.pop();

        if (!item.Tries.filter(function (x) {
          return !x.isReadOnly;
        }).length) {
          item.Selected = false;
        }

        setPanelStyle(item);
        updateTraineesSyllabus(item, syllabus);
      }

      function updateSession() {
        if (isGround) {
          TrainingSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyId, console.log, function (e) {
            console.log(e);
          });
        } else {
          FlightSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyNo, dutyDay, console.log, function (e) {
            console.log(e);
          });
        }
      } // if syllabus is non-gradable instructor can add persomalized trainee remarks


      function addTraineeRemarksRow(syllabusItem, selectedTraineeId) {
        if (selectedTraineeId) {
          var selectedTrainee = scope.trainees.find(function (trainee) {
            return trainee.CrewId == selectedTraineeId;
          });

          if (selectedTrainee) {
            scope.selectedTraineeName = selectedTrainee.Name;
            var newTraineeRemarks = {
              id: selectedTrainee.CrewId,
              name: selectedTrainee.Name,
              remarks: "",
              // Add an empty remarks field for the new trainee
              syllabusItemId: syllabusItem.Id
            };
            syllabusItem.selectedTrainee = newTraineeRemarks;
            syllabusItem.traineesPersonalizedRemarks.push(newTraineeRemarks);
          }
        }
      }

      scope.getAvailableTrainees = function (allTrainees, item) {
        if (!item || !item.traineesPersonalizedRemarks) {
          return allTrainees;
        } // Get the IDs of already selected trainees


        var selectedTraineeIds = item.traineesPersonalizedRemarks.map(function (remark) {
          return remark.id;
        }); // Filter out the selected trainees

        return allTrainees.filter(function (trainee) {
          return !selectedTraineeIds.includes(trainee.CrewId);
        });
      };

      function personalizedRemarksChanged(item) {
        if (item.usePersonalizedRemarks) {
          item.showPersonalizedRemarks = true;
          item.Tries.forEach(function (itemTry) {
            itemTry.Comments = ""; // Clear comments when enabling personalized remarks
          });
        } else {
          item.showPersonalizedRemarks = false;
          item.usePersonalizedRemarks = false;
          scope.traineesPersonalizedRemarks = [];
        }
      }

      function updatePersonalizeRemarks(item) {
        if (item.traineesPersonalizedRemarks && item.traineesPersonalizedRemarks.length > 0) {
          item.traineesPersonalizedRemarks.forEach(function (personalizedRemark) {
            var trainee = scope.trainees.find(function (x) {
              return x.CrewId == personalizedRemark.id;
            });

            if (trainee) {
              var sessionItem = trainee.Session.Items.find(function (item) {
                return item.SyllabusItemId == personalizedRemark.syllabusItemId;
              });

              if (sessionItem && sessionItem.Tries.length > 0) {
                sessionItem.Tries[0].Comments = personalizedRemark.remarks;
              }
            }
          });
        }
      }

      function deleteTraineeRemarks(traineeRemarks, item) {
        if (item) {
          // Remove the trainee remarks from the array
          var index = item.traineesPersonalizedRemarks.findIndex(function (remarks) {
            return remarks.id === traineeRemarks.id;
          });

          if (index !== -1) {
            item.traineesPersonalizedRemarks.splice(index, 1); // After deleting, sync the changes with the Session

            updatePersonalizeRemarks(item); // Enable the deleted trainee for the current item

            item.selectedTrainee = null;
          } else {
            console.error("Trainee remarks not found for deletion.");
          }
        } else {
          console.error("Syllabus item not found for the trainee remarks.");
        }
      }

      function isAddRemarksButtonDisabled(item) {
        return !scope.getAvailableTrainees(scope.trainees, item).length;
      }

      ;

      function traineeValueChanged(selectedTrainee) {
        if (selectedTrainee) {
          scope.hasSelectedTrainee = true;
        } else {
          scope.hasSelectedTrainee = false;
        }
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/Training/syllabus.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('TraineeSignatureModalCtrl', TraineeSignatureModalCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name TraineeSignatureModalCtrl
   * @description 
   * Shows Show Signature 
   * @ngInject
   */

  function TraineeSignatureModalCtrl($scope, $timeout, $uibModalInstance, trainee, TrainingSessionFactory, signatureSuccess) {
    $scope.close = close;
    $scope.confirmReset = confirmReset;
    $scope.traineeSign = traineeSign;
    $scope["continue"] = continueWarning;
    $scope.confirmation = false;
    initialiazeTrainee(trainee);

    function initialiazeTrainee(trainee) {
      var signatureTrainee = deepCopy(trainee);
      signatureTrainee.Session.Authorized = trainee.Session.Authorized ? trainee.Session.Authorized : false;
      signatureTrainee.errorMessage = "";
      signatureTrainee.successMessage = "";
      signatureTrainee.responseText = null;
      signatureTrainee.responseHasErrors = null;
      signatureTrainee.success = false;
      signatureTrainee.isLoading = false;
      signatureTrainee.password = "";
      signatureTrainee.username = trainee.AimsId;
      signatureTrainee.PositionCode = trainee.position ? trainee.position : trainee.PositionCode;
      $scope.signatureTrainee = signatureTrainee;
    }

    function deepCopy(originalObject) {
      return JSON.parse(JSON.stringify(originalObject));
    }

    function traineeSign(signatureTrainee) {
      if (!signatureTrainee.password || !signatureTrainee.username) {
        signatureTrainee.errorMessage = "Signature is required. Please enter your username and password.";
      } else {
        signatureTrainee.isLoading = true; //Individually authorize trainee

        var credentials = {
          CrewId: signatureTrainee.CrewId,
          Password: signatureTrainee.password,
          Username: signatureTrainee.username,
          PositionCode: signatureTrainee.PositionCode
        };

        if ($scope.isOffline) {
          $timeout(function () {
            signatureTrainee.isLoading = false;
          }, 100);
          signatureTrainee.errorMessage = "Online mode is required in order to sign. Please connect to the internet and try again.";
        } else {
          TrainingSessionFactory.authorizeTrainee(credentials, function (responseData) {
            signatureTrainee.isLoading = false;
            signatureTrainee.success = true;
            signatureTrainee.Session.Authorized = true;
            trainee.Session.Authorized = true;
            signatureSuccess();
          })["catch"](function (data) {
            signatureTrainee.isLoading = false;

            if (data.data && data.data.errorMessage) {
              signatureTrainee.errorMessage = data.data.errorMessage;
            } else {
              signatureTrainee.errorMessage = "An error occured during your authentication";
            }
          });
        }
      } // clear credentials


      trainee.username = "";
      trainee.password = "";
    }
    /**
     * Close the modal
     */


    function close() {
      $uibModalInstance.close(false);
    }
    /**
     * Confirm
     */


    function confirmReset() {
      $uibModalInstance.close(true);
    }

    function continueWarning() {
      $scope.confirmation = true;
    }
  }
})();
"use strict";

(function () {
  a3_cabin_reports.directive('trainingMenu', trainingMenu);
  /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name ground Course List
   * @restrict E
   * @description
   *   Initialize navigation menu panel with with status indicators
   * @example
   *   Usage:
   *   <training-menu type="ground, crewroute, flight" id="groundDutyId, flightId" ></training-menu>
   * @ngInject
   */

  function trainingMenu(CourseFactory, GroundDutyFactory, FlightFactory, CrewRouteFactory, $location, TrainingSessionFactory, FlightSessionFactory, $filter, $routeParams) {
    function link($scope, attrs) {
      $scope.gotoCourse = gotoCourse;
      $scope.hasPendingTraining = false;
      $scope.hasUnsetTraining = false;
      var groundSessions = [];
      var flightSessions = [];
      TrainingSessionFactory.getAll(function (savedGroundSessions) {
        FlightSessionFactory.getAll(function (savedFlightSessions) {
          groundSessions = savedGroundSessions;
          flightSessions = savedFlightSessions;
          $scope.courses = [];
          var duty = null;
          var dutyCourses = [];

          if ($scope.type == 'ground') {
            duty = GroundDutyFactory.getGroundDutyFromStorage($scope.id);
            $scope.duty = duty;

            if (duty && duty.RelatedGroundDuties) {
              dutyCourses = GroundDutyFactory.getGroundDutyActiveCourses($scope.id);

              if (dutyCourses) {
                CourseFactory.getCoursesFromStorageByIds(dutyCourses.map(function (course) {
                  return course.CourseId;
                }), function (savedCourses) {
                  manageGroundCourseStatuses(duty, dutyCourses, savedCourses); //Overall panel color

                  if (savedCourses.some(function (x) {
                    return x.Status == "Draft";
                  })) {
                    $scope.PanelClass = "border-bottom-orange";
                  } else if (savedCourses.some(function (x) {
                    return x.Status == "Pending" || x.Status == "Outdated";
                  })) {
                    $scope.PanelClass = "border-bottom-blue";
                  } else {
                    $scope.PanelClass = "border-bottom-green";
                  }

                  $scope.courses = savedCourses;
                });
              }
            }
          } else if ($scope.type == 'crewroute' || $scope.type == 'flight') {
            if ($scope.type == 'crewroute') {
              duty = CrewRouteFactory.getCrewRouteFromStorage($scope.dutyNo, $scope.dutyDay);
            } else {
              duty = FlightFactory.getFlightFromTotalFlights($scope.id);
            }

            if (duty && duty.Courses) {
              dutyCourses = duty.Courses;
              CourseFactory.getCoursesFromStorageByIds(dutyCourses.map(function (course) {
                return course.CourseId;
              }), function (savedCourses) {
                dutyCourses.forEach(function (dutyCourse) {
                  var savedCourse = savedCourses.find(function (x) {
                    return x.Id == dutyCourse.CourseId;
                  });

                  if (savedCourse) {
                    var course = {
                      Id: savedCourse.Id,
                      Title: savedCourse.Title,
                      Day: new moment(dutyCourse.Date)
                    };
                    manageFlightCourseStatus(course, dutyCourse);
                    $scope.courses.push(course);
                  }
                });
                $scope.courses.forEach(function (course) {
                  course.FullDate = course.Day.format("YYYY-MM-DD");
                  course.Day = course.Day.format("DD/MM");

                  if ($scope.courses.filter(function (x) {
                    return x.Id == course.Id;
                  }).length > 1) {
                    course.IsMultiday = true;
                  }
                }); //Overall panel color

                if ($scope.courses.some(function (x) {
                  return x.Status == "Draft";
                })) {
                  $scope.PanelClass = "border-bottom-orange";
                } else if ($scope.courses.some(function (x) {
                  return x.Status == "Pending" || x.Status == "Outdated";
                })) {
                  $scope.PanelClass = "border-bottom-blue";
                } else {
                  $scope.PanelClass = "border-bottom-green";
                }
              });
            }
          }
        });
      });

      function manageFlightCourseStatus(course, crewRouteCourse) {
        var now = moment.utc();
        var flights = FlightFactory.getFlightsFromStorage().filter(function (x) {
          return crewRouteCourse.TrainingFlightIds.includes(x.FlightId);
        });
        flights = $filter('orderBy')(flights, 'ScheduledArrival');
        var dutyEnd = flights[flights.length - 1].ScheduledArrival;
        var dutyDate = new moment(crewRouteCourse.Date).format("YYYY-MM-DD");
        var status = "";

        if (crewRouteCourse.Status == "Pending") {
          //Pending
          course.Status = "Pending";
          course.StatusClass = "text-blue";
          course.StatusDesc = "pending"; //Outdated

          dutyEnd = moment.utc(dutyEnd);
          var duration = moment.duration(now.diff(dutyEnd)).asHours();

          if (duration > 1) {
            course.Status = "Outdated";
          } //Draft


          if (flightSessions && flightSessions.length > 0) {
            var existingSession = flightSessions.find(function (s) {
              return s != null && s.courseId == crewRouteCourse.CourseId && s.day == dutyDate && s.dutyDay == $scope.dutyDay && s.dutyNo == $scope.dutyNo;
            });

            if (existingSession && !existingSession.HasLimitedInfo && existingSession.trainees && existingSession.trainees.length) {
              //a training session with trainees exists
              course.Status = "Draft";
              course.StatusClass = "text-orange";
              course.StatusDesc = "draft";
            }
          }
        } else if (crewRouteCourse.Status == "Completed") {
          //Completed
          course.Status = "Completed";
          course.StatusClass = "text-green";
          course.StatusDesc = "synced";
        }

        return status;
      }

      function manageGroundCourseStatuses(duty, dutyCourses, courses) {
        var now = moment.utc();
        courses.forEach(function (course) {
          var dutyCourse = dutyCourses.find(function (x) {
            return x.CourseId == course.Id;
          });
          course.Status = dutyCourse.Status;
          /*Statuses
          	Completed : session has been sent
          	Outdated  :	session submission is overdue
          	Draft	  : session completion has started but not submitted
          	Pending   : session submission not yet due
          */

          if (course.Status == "Pending") {
            course.StatusClass = "text-blue";
            course.StatusDesc = "pending"; //Outdated

            var dutyEnd = moment.utc(duty.DutyEnd);
            var duration = moment.duration(now.diff(dutyEnd)).asHours();

            if (duration > 1) {
              course.Status = "Outdated";
            } //Draft


            if (groundSessions && groundSessions.length) {
              var existingSession = groundSessions.find(function (s) {
                return s.courseId == course.Id && s.day == duty.DutyDateS && s.dutyId == duty.Id;
              });

              if (existingSession && !existingSession.HasLimitedInfo && existingSession.trainees && existingSession.trainees.length) {
                //a training session with trainees exists
                course.Status = "Draft";
                course.StatusClass = "text-orange";
                course.StatusDesc = "draft";
              }
            }
          } else if (course.Status == "Completed") {
            //Completed
            course.Status = "Completed";
            course.StatusClass = "text-green";
            course.StatusDesc = "synced";
          }
        });
      }
      /**
       * Redirect to Course Session
       */


      function gotoCourse(course) {
        if ($scope.type == "ground") {
          $location.path('/groundcourse/' + course.Id + '/' + $scope.duty.Id + "/" + $scope.duty.DutyDateS);
        } else if ($scope.type == "crewroute") {
          $location.path('/flightcourse/' + course.Id + '/' + $scope.dutyNo + '/' + $scope.dutyDay + '/' + course.FullDate);
        } else if ($scope.type == "flight") {
          $location.path('/flightcourse/' + course.Id + '/' + $scope.dutyNo + '/' + $scope.dutyDay + '/' + course.FullDate + '/' + Number($routeParams.flightId));
        }
      }
    }

    return {
      restrict: 'E',
      templateUrl: "views/Training/training-menu.tpl.html",
      scope: {
        type: '@',
        id: '=',
        dutyNo: '=',
        dutyDay: '='
      },
      terminal: true,
      link: link
    };
  }
})();
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  'use strict';

  a3_cabin_reports.factory('TrainingSessionFactory', TrainingSessionFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name TrainingSessionFactory
   * @description 
   *   Add, Update, Delete and Get Training Courses.
   * @ngInject
   */

  function TrainingSessionFactory(IndexedDBService, CourseFactory, $http, apiUrl, GroundDutyFactory, $filter) {
    /**
     * Initialize Session
     * @memberof TrainingSessionFactory
     */
    function Session() {
      this.Id = null;
    }

    var objType = 'TrainingSessions';
    var objCallback = Session;
    var service = {
      getAll: getAll,
      getSession: getSession,
      setSession: setSession,
      updateSession: updateSession,
      getSessionTrainees: getSessionTrainees,
      submitSession: submitSession,
      remove: remove,
      authorizeTrainee: authorizeTrainee,
      getDutySessions: getDutySessions,
      applyTraineeInfoToSession: applyTraineeInfoToSession,
      releaseSession: releaseSession,
      createFlatHistorySullabusItem: createFlatHistorySullabusItem
    };
    /**
     * Get all ground training sessions
     * @memberof TrainingSessionFactory
     * @param {function} callback  
     */

    function getAll(callback) {
      IndexedDBService.getAll(objType).then(function (results) {
        callback(results);
      });
    }

    ;
    /**
     * Get session By day and courseId
     * @memberof TrainingSessionFactory
     * @param {function} callback  
     */

    function getSession(courseId, day, dutyId, afterRefresh, callback, errorCallback) {
      IndexedDBService.getById(objType, [day, courseId, dutyId]).then(function (session) {
        CourseFactory.getCourseFromStorage(courseId, function (course) {
          if (course && !course.HasLimitedInfo && course.CrewCoursePhases && course.CourseTrainees) {
            mergeCourseWithSession(course, session, dutyId, afterRefresh);
          }

          callback(course);
        }, errorCallback);
      })["catch"](errorCallback);
    }

    function getDutySessions(day, dutyId, callback) {
      IndexedDBService.getAll(objType).then(function (results) {
        results = results.filter(function (x) {
          return x.day == day && x.dutyId == dutyId;
        });
        callback(results);
      });
    }
    /**
     * Remove session By day,dutyID (Optional) and courseId
     * @memberof TrainingSessionFactory
     * @param {function} callback  
     */


    function remove(courseId, day, dutyId, callback, errorCallback) {
      IndexedDBService.remove(objType, [day, courseId, dutyId]).then(callback)["catch"](errorCallback);
    }

    ;
    /**
     * Get session Trainees By day and courseId
     * @memberof TrainingSessionFactory
     * @param {function} callback  
     */

    function getSessionTrainees(courseId, day, dutyId, callback, errorCallback) {
      IndexedDBService.getById(objType, [day, courseId, dutyId]).then(function (session) {
        var trainees = session && session.trainees ? session.trainees : [];
        callback(trainees);
      })["catch"](errorCallback);
    }

    ;
    /**
     * Set session
     * @memberof TrainingSessionFactory
     * @param {function} callback  
     */

    function setSession(session, callback, errorCallback) {
      IndexedDBService.getById(objType, [session.day, session.courseId, session.dutyId]).then(function (result) {
        if (result) {
          saveSessionToStorage(session).then(callback)["catch"](errorCallback);
          ;
        } else {
          addSessionToStorage(session).then(callback)["catch"](errorCallback);
        }
      })["catch"](errorCallback);
    }

    ;
    /**
     * Set session
     * @memberof TrainingSessionFactory
     * @param {function} callback  
     */

    function updateSession(trainees, session, courseId, day, dutyId, callback, errorCallback) {
      IndexedDBService.getById(objType, [day, courseId, dutyId]).then(function (localSession) {
        var isNewSession = false;

        if (!localSession) {
          localSession = {
            courseId: courseId,
            day: day,
            dutyId: dutyId,
            trainees: []
          };
          isNewSession = true;
        } else {
          localSession.trainees = [];
        }

        if (session) {
          localSession.Media = session.Media;
          localSession.ReleasedPhase = session.ReleasedPhase;
          localSession.TraineeEligibilty = session.TraineeEligibilty;
        }

        trainees.forEach(function (trainee) {
          localSession.trainees.push(trainee);
        });

        if (isNewSession) {
          addSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        } else {
          saveSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        }
      })["catch"](errorCallback);
    }

    function mergeCourseWithSession(course, session, dutyId, afterRefresh) {
      course.HasLimitedSession = session == undefined;
      var hasPreviousSessions = mergeSyllabusWithHistory(course.CourseTrainees, course.CrewCoursePhases);
      filterTraineesByEligibility(dutyId, course, session, afterRefresh);
      course.CrewCoursePhases.forEach(function (phase) {
        calculatePhaseStatus(phase, course, session);
      });
      course.selectedPhase = getSelectedPhase(course); // Calculate eligible trainees phase status

      course.CourseTrainees.forEach(function (trainee) {
        var traineePhase = trainee.Phases.find(function (x) {
          return x.PhaseId == course.selectedPhase.PhaseId;
        });

        if (traineePhase) {
          trainee.ActivePhaseStatus = traineePhase.PhaseStatus;
        } else {
          trainee.ActivePhaseStatus = "Pending";
        }

        trainee.Selectable = trainee.ActivePhaseStatus == "InProgress";
      }); //Filter By Role: Filter out trainees that have a flight crew role

      if (course.selectedPhase.FilterByRole) {
        course.CourseTrainees.filter(function (x) {
          return x.Selectable && x.PositionCode != 'SA' && x.PositionCode != 'FA';
        }).forEach(function (flightCrewTrainee) {
          flightCrewTrainee.EligibilityStatus = false;
          flightCrewTrainee.EligibilityDesc = "InvalidRole";
          course.NonEligibleTrainees.push(flightCrewTrainee);
        });
      } // Non InProgress trainees will be marked as NonEligible (remove further ahead trainees on multiple InProgress phases)


      course.CourseTrainees.filter(function (x) {
        return !x.Selectable;
      }).forEach(function (invalidPhaseTrainee) {
        invalidPhaseTrainee.EligibilityStatus = false;
        invalidPhaseTrainee.EligibilityDesc = "AlreadySubmitted";
        course.NonEligibleTrainees.push(invalidPhaseTrainee);
      });
      course.CourseTrainees = course.CourseTrainees.filter(function (x) {
        return x.EligibilityStatus;
      }); // Get trainee sessions

      course.CourseTrainees.forEach(function (trainee) {
        var sessionTrainee = session ? session.trainees.find(function (x) {
          return x.CrewId == trainee.CrewId;
        }) : null;

        if (sessionTrainee) {
          trainee.Session = sessionTrainee.Session;
          sessionTrainee.Session.AdditionalTrainingStatus = sessionTrainee.AdditionalTrainingStatus;
        } else {
          var _trainee$Session;

          trainee.Session = (_trainee$Session = {
            Released: course.selectedPhase.ModuleType == "Training" ? false : true,
            CrewId: trainee.CrewId,
            Items: [],
            Absent: false,
            DayGrading: {
              Comments: null,
              Grade: null,
              Competences: []
            },
            ReleaseGrading: {
              Comments: null,
              Grade: null,
              Competences: []
            },
            NeedsAdditionalTraining: false,
            AdditionalTrainingRemarks: null,
            CompleteAdditionalTraining: false
          }, _defineProperty(_trainee$Session, "NeedsAdditionalTraining", false), _defineProperty(_trainee$Session, "AdditionalTrainingStatus", null), _trainee$Session);
        }
      });
      /*  Set default values for release option
          Training Modules: 'No' release as default
          Check Module: 'Yes' release as default
      */

      course.ReleasedPhase = course.selectedPhase.ModuleType == "Training" ? false : true;

      if (session) {
        course.Media = session.Media;
        course.ReleasedPhase = session.ReleasedPhase;
        course.TraineeEligibilty = session.TraineeEligibilty;
      }
    }

    function getSelectedPhase(course) {
      var hasSelectedPhase = false;
      var phases = course.CrewCoursePhases;
      phases.forEach(function (phase, index, array) {
        phase.isFirst = index == 0;
        phase.isLast = index + 1 == array.length; // Select the first InProgress & selected phase

        if (!hasSelectedPhase && phase.Status == "InProgress" && phase.isSelected) {
          phase.Selected = true;
          hasSelectedPhase = true;
        }
      }); // Select the first InProgress phase

      if (!hasSelectedPhase && phases.some(function (x) {
        return x.Status == "InProgress";
      })) {
        phases.find(function (x) {
          return x.Status == "InProgress";
        }).Selected = true;
        hasSelectedPhase = true;
      }

      if (!hasSelectedPhase) {
        phases.find(function (x) {
          return x.isFirst;
        }).Selected = true;
      }

      var selectedPhase = phases.find(function (x) {
        return x.Selected;
      });
      return selectedPhase;
    }

    function filterTraineesByEligibility(dutyId, course, session, afterRefresh) {
      var _course$CourseTrainee;

      var groundDuty = GroundDutyFactory.getGroundDutyFromStorage(dutyId); // Trainee Eligiblity cases
      // 1. After refresh - Save newly fetched eligibility in session
      // 2. No refresh & Session exists - Get last fetched eligibility from session
      // 3. No refresh & No session exists - Rely on previously fetched eligibility (different duty - same course)

      var traineeEligibility = course.TraineeEligibilty;

      if (!afterRefresh && session && session.TraineeEligibilty) {
        traineeEligibility = session.TraineeEligibilty;
      }

      if (session) session.TraineeEligibilty = traineeEligibility; //update session eligibility
      // Get ground duty trainees without any training records

      var trainees = getGroundCourseTrainees(groundDuty, course.Id);
      var inactiveTrainees = trainees.filter(function (x) {
        return !course.CourseTrainees.some(function (z) {
          return z.CrewId == x.CrewId;
        });
      }); //Exclude Non valid trainees

      var eligibleTraineeIds = Object.keys(traineeEligibility).filter(function (x) {
        return traineeEligibility[x] == "NotStarted" || traineeEligibility[x] == "ValidPhase" || traineeEligibility[x] == "FailedCertificate";
      }).map(Number);
      var eligibleTrainees = inactiveTrainees.filter(function (x) {
        return eligibleTraineeIds.includes(x.CrewId);
      });
      eligibleTrainees.forEach(function (trainee) {
        trainee.EligibilityStatus = true;
      });
      createNewPhaseTrainees(groundDuty, course, eligibleTrainees); // Merge eligibleTrainees (inactive) with CourseTrainees (eligible & active)

      course.CourseTrainees.forEach(function (trainee) {
        trainee.EligibilityStatus = true;
      });

      (_course$CourseTrainee = course.CourseTrainees).push.apply(_course$CourseTrainee, _toConsumableArray(eligibleTrainees)); // Non eligible trainees


      var nonEligibleTrainees = inactiveTrainees.filter(function (x) {
        return !eligibleTraineeIds.includes(x.CrewId);
      });
      course.NonEligibleTrainees = nonEligibleTrainees;
      nonEligibleTrainees.forEach(function (trainee) {
        trainee.EligibilityStatus = false;
        trainee.EligibilityDesc = traineeEligibility[trainee.CrewId];
      }); // Result:
      // CourseTrainees = eligible trainees (active or new)
      // Non EligibleTrainees
    }
    /**
     * Create first phase foreach trainee
     * @param {object} groundDuty 
     * @param {object} course 
     * @param {array} trainees Eligible trainees that haven't yet started training
     */


    function createNewPhaseTrainees(groundDuty, course, trainees) {
      //Match GroundDutyNos with PhaseDutyNos
      var crewCoursePhaseDutyNos = [];
      var groundDutyTraineeDutyNos = [];
      course.CrewCoursePhases.forEach(function (coursePhase) {
        crewCoursePhaseDutyNos = crewCoursePhaseDutyNos.concat(coursePhase.GroundDutyCodes);
      });
      groundDuty.Trainees.forEach(function (relatedDuty) {
        groundDutyTraineeDutyNos.push(relatedDuty.GroundDutyNo.toString());
      });
      var relatedDutyNos = crewCoursePhaseDutyNos.filter(function (x) {
        return groundDutyTraineeDutyNos.includes(x);
      });
      var relatedPhases = course.CrewCoursePhases.filter(function (x) {
        return x.GroundDutyCodes.some(function (gdc) {
          return relatedDutyNos.includes(gdc);
        });
      }); //From related phases, select first in order

      relatedPhases = $filter('orderBy')(relatedPhases, 'OrderNo');
      var firstPhase = relatedPhases[0];
      trainees.forEach(function (trainee) {
        trainee.Phases = [{
          PhaseId: firstPhase.PhaseId,
          PhaseStatus: "InProgress",
          RepeatRequestedItems: [],
          isSelected: true //selectedPhase

        }];
      });
    }

    function getGroundCourseTrainees(groundDuty, courseId) {
      var trainees = [];
      groundDuty.RelatedGroundDuties.filter(function (x) {
        return x.Courses && x.Courses.map(function (course) {
          return course.CourseId;
        }).includes(courseId);
      }).forEach(function (item) {
        item.CrewMembers.forEach(function (crewMember) {
          var trainee = {
            AimsId: crewMember.AIMS_ID,
            CrewId: crewMember.Id,
            Name: crewMember.Name,
            PositionCode: crewMember.PositionCode
          };
          trainees.push(trainee);
        });
      });
      return trainees;
    }

    function calculatePhaseStatus(phase, course) {
      course.CourseTrainees.forEach(function (trainee) {
        var traineePhase = trainee.Phases.find(function (x) {
          return x.PhaseId == phase.PhaseId;
        });

        if (traineePhase && traineePhase.PhaseStatus == "InProgress") {
          phase.Status = "InProgress";
        } else if (!traineePhase && phase.Status != "InProgress") {
          phase.Status = "Pending";
        } else if (traineePhase && traineePhase.PhaseStatus == "Completed" && phase.Status != "InProgress") {
          phase.Status = "Completed";
        } //Selected phase, If at least one trainee has it selected


        if (traineePhase && !phase.isSelected) {
          phase.isSelected = traineePhase.isSelected;
        }
      });
    }

    function mergeSyllabusWithHistory(trainees, phases) {
      var flatSullabusItems = [];
      trainees.forEach(function (trainee) {
        trainee.Phases.forEach(function (phase) {
          phase.Sessions.forEach(function (session) {
            session.Items.forEach(function (item) {
              var flatItem = createFlatHistorySullabusItem(trainee, phase, session, item);
              flatSullabusItems.push(flatItem);
            });
          });
        });
      });
      phases.filter(function (x) {
        return x.Syllabus;
      }).forEach(function (phase, index, array) {
        phase.Syllabus.SyllabusItems.forEach(function (syllabusItem) {
          syllabusItem.History = flatSullabusItems.filter(function (item) {
            return item.ItemId == syllabusItem.Id;
          });
        });
      });
      var hasPreviousSessions = flatSullabusItems.length > 0;
      return hasPreviousSessions;
    }

    function createFlatHistorySullabusItem(trainee, phase, session, item) {
      var flatItem = {
        CrewId: trainee.CrewId,
        PhaseId: phase.PhaseId,
        SessionId: session.SessionId,
        SessionComments: session.SessionComments,
        SubmissionDate: item.SubmissionDate,
        RepeatRequired: item.RepeatRequired,
        Tries: item.Tries,
        ItemId: item.SyllabusItemId,
        Grade: session.Grade,
        GradeType: session.GradeType,
        InstructorName: session.InstructorName,
        InstructorAimsId: session.InstructorAimsId
      };
      return flatItem;
    }
    /**
     * Add Session to Storage
     * @memberof TrainingSessionFactory
     * @param {object} Session
     */


    function addSessionToStorage(session) {
      return IndexedDBService.add(objType, session);
    }

    ;
    /**
     * Update Session to Storage
     * @memberof TrainingSessionFactory
     * @param {object} Session
     */

    function saveSessionToStorage(session) {
      return IndexedDBService.put(objType, session);
    }

    ;

    function submitSession(submittedSession, callback) {
      var traingingApiURL = apiUrl + '/Training/SubmitTraining';
      return $http.post(traingingApiURL, submittedSession, {
        'Content-Type': 'application/json'
      }).then(callback);
    }
    /**
     * Authorize Trainee for submission
     * @param {string} credentials Trainee's password, username, crewId, position
     * @param {function} callback 
     * @param {function} errorCallback 
     */


    function authorizeTrainee(credentials, callback, errorCallback) {
      return $http.post(apiUrl + '/Training/AuthorizeTrainee', credentials, {
        'Content-Type': 'application/json'
      }).then(callback)["catch"](errorCallback);
    }

    function applyTraineeInfoToSession(course, courseId, day, dutyId, callback, errorCallback) {
      IndexedDBService.getById(objType, [day, courseId, dutyId]).then(function (localSession) {
        var isNewSession = false;

        if (!localSession) {
          localSession = {
            courseId: courseId,
            day: day,
            dutyId: dutyId,
            trainees: [],
            TraineeEligibilty: course.TraineeEligibilty,
            CourseTrainees: course.CourseTrainees
          };
          isNewSession = true;
        } else {
          localSession.TraineeEligibilty = course.TraineeEligibilty;
          localSession.CourseTrainees = course.CourseTrainees;
        }

        if (isNewSession) {
          addSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        } else {
          saveSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        }
      })["catch"](errorCallback);
    }

    function releaseSession(submittedSessions, callback, errorCallback) {
      var traingingApiURL = apiUrl + '/Training/ReleaseSession';
      return $http.post(traingingApiURL, submittedSessions, {
        'Content-Type': 'application/json'
      }).then(callback)["catch"](errorCallback);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('WifiAvailabilityFactory', WifiAvailabilityFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name WifiAvailabilityFactory
  * @description 
  *   Storage of aircraft registrations with Wi-Fi connectivity.
  * @ngInject
  */

  function WifiAvailabilityFactory(GenericService) {
    var objType = 'WifiAvailability';
    var objCallback = WifiAvailability;
    /**
     * Initialize the WifiAvailability
     * @memberof WifiAvailabilityFactory
     */

    function WifiAvailability() {
      this.Registrations = [];
    }

    var service = {
      setRegistrationsToStorage: setRegistrationsToStorage,
      getRegistrationsFromStorage: getRegistrationsFromStorage
    };
    /**
     * Save registrations with Wi-Fi connectivity to storage
     * @param {array} objList A list of aircraft registrations
     */

    function setRegistrationsToStorage(objList) {
      if (objList != null) {
        var registrations = {
          registrations: objList
        };
        GenericService.saveOne(registrations, objType, objCallback);
      }
    }
    /**
     * Get registrations from storage
     */


    function getRegistrationsFromStorage() {
      return GenericService.getOne(objType, objCallback);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('wifiPrograms', wifiPrograms);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name wifiPrograms
  * @restrict EA
  * @description
  *   Implementation of wifiPrograms
  *
  *   Initialize the wifi programs panel needs to have flight in scope
  * @example
  *   Usage:
  *   <wifi-programs></wifi-programs>
  * @ngInject
  */

  function wifiPrograms() {
    /**
     * Initialize wifiVouchers
     * @memberof wifiVouchers
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attributes attributes of this element
     */
    function link(scope, element, attrs) {//   scope.textAndSurfCodes = [];
      //   scope.streamCodes = [];
    }

    return {
      restrict: 'EA',
      terminal: true,
      templateUrl: 'views/WifiVouchers/wifiPrograms.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('wifiVouchers', wifiVouchers);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name wifiVouchers
  * @restrict EA
  * @description
  *   Implementation of wifiVouchers
  *
  *   Initialize the wifi vouchers panel needs to have flight in scope
  * @example
  *   Usage:
  *   <wifi-vouchers></wifi-vouchers>
  * @ngInject
  */

  function wifiVouchers(WifiVouchersFactory, WifiAvailabilityFactory, $timeout) {
    /**
     * Initialize wifiVouchers
     * @memberof wifiVouchers
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attributes attributes of this element
     */
    function link(scope, element, attrs) {
      var wifiAvailability = WifiAvailabilityFactory.getRegistrationsFromStorage();

      if (wifiAvailability) {
        scope.supportsWifi = wifiAvailability.registrations.includes(scope.flight.AcTailNo);
      } else {
        scope.supportsWifi = false;
      }

      scope.retrieve = retrieve; // scope.createVoucher = createVoucher;

      scope.showPanel = '';
      scope.submitMessage = '';
      scope.pnrNo = null;
      scope.wifiVouchersCodes = [];
      scope.textAndSurfCodes = [];
      scope.streamCodes = [];
      scope.isFlightView = true;

      function retrieve(pnrNo) {
        if (scope.isOffline) {
          scope.showPanel = "offline";
        } else {
          scope.showPanel = "loading";
          var RequestWifiVouchers = {
            PNR: pnrNo,
            FlightId: scope.flight.FlightId,
            Flight: scope.paxInfo.STDLocal
          };
          WifiVouchersFactory.retrieveWifiVouchers(RequestWifiVouchers).then(function (res) {
            return handleSubmitResponse(res);
          });
        }
      }

      function handleSubmitResponse(res) {
        if (res.success) {
          scope.notRetrieved = false;
          scope.textAndSurfCodes = [];
          scope.streamCodes = [];
          manageResponseMessage("success", res.message);
          scope.wifiVouchersCodes = res.data;
          scope.wifiVouchersCodes.forEach(function (code) {
            if (code.Type == 'Text & Surf') {
              scope.textAndSurfCodes.push(code.VoucherCode);
            }
          });
          scope.wifiVouchersCodes.forEach(function (code) {
            if (code.Type == 'Stream') {
              scope.streamCodes.push(code.VoucherCode);
            }
          });
        } else {
          manageResponseMessage("failure", res.message);
        }
      }
      /**
          * Manage message alerts
          * @param {string} panelToShow 
          * @param {string} message 
          */


      function manageResponseMessage(panelToShow, message) {
        scope.submitMessage = message;
        scope.showPanel = panelToShow;
      }
    }

    return {
      restrict: 'EA',
      terminal: true,
      templateUrl: 'views/WifiVouchers/wifiVouchers.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('WifiVouchersFactory', WifiVouchersFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name WifiVouchersFactory
  * @description 
  * Get Wifi VouchersFactory.
  * @ngInject
  */

  function WifiVouchersFactory($http, apiUrl) {
    var submitResponseObj = {
      success: false,
      message: '',
      data: ''
    };
    var service = {
      retrieveWifiVouchers: retrieveWifiVouchers,
      createWifiVoucher: createWifiVoucher
    };
    /**
     * Retrieve Wifi Vouchers
     * @memberof WifiVouchersFactory
     * @param {function} callback  
     */

    function retrieveWifiVouchers(requestObj) {
      var objectToAdd = requestObj;
      return $http.post(apiUrl + '/WifiVouchers/RetrieveVouchers/', requestObj, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return retrieveVouchersSuccessCallBack(res, objectToAdd);
      })["catch"](function (res) {
        return vouchersFailedCallBack(res);
      });
    }
    /**
     * The callback function upon successful retrieve
     * @param {object} res 
     * @param {object} objectToAdd 
     * @returns {object} submitResponseObj
     */


    function retrieveVouchersSuccessCallBack(res, objectToAdd) {
      submitResponseObj.success = res.data.success;

      if (res.data.success && objectToAdd.PNR != null) {
        submitResponseObj.message = "Success! Your input has been sent";
        submitResponseObj.data = res.data.data.Result;
      } else if (res.data.success && objectToAdd.PNR == null) {
        submitResponseObj.message = "You have to fill PNR No";
      } else {
        submitResponseObj.message = res.data.errorMessage;
      }

      return submitResponseObj;
    }
    /**
     * Create Wifi Vouchers
     * @memberof WifiVouchersFactory
     * @param {function} callback  
     */


    function createWifiVoucher(requestObj) {
      var objectToAdd = requestObj;
      return $http.post(apiUrl + '/WifiVouchers/CreateVoucher/', requestObj, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return createVouchersSuccessCallBack(res, objectToAdd);
      })["catch"](function (res) {
        return vouchersFailedCallBack(res);
      });
    }

    function createVouchersSuccessCallBack(res, objectToAdd) {
      submitResponseObj.success = res.data.success;

      if (res.data.success && objectToAdd.PNR != null && res.data.data.Result && res.data.data.Result.Vouchers) {
        submitResponseObj.message = "Success! Your input has been sent";
        submitResponseObj.data = res.data.data.Result.Vouchers;
      } else {
        submitResponseObj.message = res.data.errorMessage;
      }

      return submitResponseObj;
    }
    /**
    * The callback function upon failure on retrieve
    * @returns {object} submitResponseObj
    */


    function vouchersFailedCallBack(res) {
      submitResponseObj.success = false;
      submitResponseObj.message = "Oops! Something went wrong";
      return submitResponseObj;
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('additionalTrainingReadOnly', additionalTrainingReadOnly);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name additionalTrainingReadOnly
  * @restrict E
  * @description
  *    Implementation of additional Training ReadOnly
  * @example
  *   Usage:
  *   <additional-training-read-only></additional-training-read-only>
  * @ngInject
  */

  function additionalTrainingReadOnly() {
    function link(scope, element, attrs) {}

    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/TrainingReadOnly/additional-training-read-only.tpl.html',
      scope: {
        traineeSession: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('competencesReadOnly', competencesReadOnly);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name competencesReadOnly
  * @restrict E
  * @description
  *    Implementation of competences read only
  * @example
  *   Usage:
  *   <competences-read-only></competences-read-only>
  * @ngInject
  */

  function competencesReadOnly() {
    function link(scope, element, attrs) {
      if (scope.trainee.Competences) {
        scope.trainee.Competences.forEach(function (competence) {
          competence.hasSelectedSubCompetence = competence.SubCompetences.some(function (x) {
            return x.Selected;
          });
        });
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/TrainingReadOnly/competences-read-only.tpl.html',
      scope: {
        trainee: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_cabin_reports.directive('courseReadOnly', courseReadOnly);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name courseReadOnly
  * @restrict E
  * @description
  *   Initialize read only view of what was submitted
  * @example
  *   Usage:
  *   <course-read-only></course-read-only>
  * @ngInject
  */

  function courseReadOnly() {
    function link(scope) {
      scope.leftScroll = leftScroll;
      scope.rightScroll = rightScroll;
      scope.selectedTraineeSession = selectedTraineeSession;
      scope.selected = false;
      scope.selectedAbsentTraineeSession = selectedAbsentTraineeSession;
      scope.selectedPhase = scope.phases.find(function (x) {
        return x.PhaseId == scope.session.PhaseId;
      });
      scope.selectedTraineeBadge = {
        crewId: scope.session.TraineesSessions[0].CrewId
      };

      function leftScroll() {
        document.querySelector('.horizontal-scroll').scrollLeft -= 500;
      }

      function rightScroll() {
        document.querySelector('.horizontal-scroll').scrollLeft += 500;
      }

      function selectedTraineeSession() {
        return function (traineeSession) {
          var showSession = false;

          if (traineeSession.CrewId === scope.selectedTraineeBadge.crewId) {
            showSession = true;
          }

          return showSession;
        };
      }

      function selectedAbsentTraineeSession() {
        return function (traineeSession) {
          var showPanel = false;

          if (traineeSession.CrewId === scope.selectedTraineeBadge.crewId && traineeSession.Items.length == 0) {
            showPanel = true;
          }

          return showPanel;
        };
      }
    }

    return {
      restrict: 'E',
      templateUrl: "views/TrainingReadOnly/course-read-only.tpl.html",
      scope: {
        phases: "=",
        session: "="
      },
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('gradingReadOnly', gradingReadOnly);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name gradingReadOnly
  * @restrict E
  * @description
  *    Implementation of grading read only
  * @example
  *   Usage:
  *   <grading-read-only></grading-read-only>
  * @ngInject
  */

  function gradingReadOnly() {
    function link(scope, element, attrs) {
      if (scope.settings) {
        scope.grading.GradeType = scope.settings.GradeType;
      }
    }

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/TrainingReadOnly/grading-read-only.tpl.html',
      scope: {
        grading: "=",
        settings: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.directive('sectorHistory', sectorHistory);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name sectorHistory
  * @restrict E
  * @description
  *    Implementation of sector history
  * @example
  *   Usage:
  *   <sector-history></sector-history>
  * @ngInject
  */

  function sectorHistory() {
    function link(scope, element, attrs) {}

    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/TrainingReadOnly/sector-history.tpl.html',
      scope: {
        history: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_cabin_reports.directive('syllabusProgressReadOnly', syllabusProgressReadOnly);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name syllabusReadOnly
  * @restrict E
  * @description
  *   Initialize read only view of submitted syllabus
  * @example
  *   Usage:
  *   <syllabus-progress-read-only></syllabus-progress-read-only>
  * @ngInject
  */

  function syllabusProgressReadOnly() {
    function link(scope) {
      scope.showRemarks = {
        value: false
      };
      scope.oneAtATime = true;
      scope.filterItems = filterItems;
      scope.toggleItems = toggleItems;
      setSyllabus(scope.history);

      function setSyllabus(history) {
        var traineeSessionItems = [];
        scope.phase.Syllabus.SyllabusItems.forEach(function (item) {
          var syllabusItem = JSON.parse(JSON.stringify(item));
          syllabusItem.Tries = [];
          syllabusItem.Selected = false;
          var relatedSessionItem = history.SyllabusProgress.find(function (x) {
            return x.SyllabusItemId == syllabusItem.Id;
          });

          if (relatedSessionItem) {
            syllabusItem.hasRemarks = relatedSessionItem.Tries.some(function (x) {
              return x.Comments && x.Comments.length > 0;
            }) || relatedSessionItem.Tries.some(function (t) {
              return t.TryGrading.Competences.some(function (x) {
                return x.Comments && x.Comments.length > 0;
              });
            });
            syllabusItem.Selected = true;
            syllabusItem.Tries = relatedSessionItem.Tries;
            syllabusItem.Tries.forEach(function (attempt) {
              attempt.Selected = true;
            });
          }

          setPanelStyle(syllabusItem);
          traineeSessionItems.push(syllabusItem);
        });
        history.ItemsGrouped = SyllabusGrouping(traineeSessionItems);
      }

      function setPanelStyle(item) {
        var historyTriesCount = item.Tries.filter(function (x) {
          return x.isReadOnly;
        }).length;
        var newTriesCount = item.Tries.filter(function (x) {
          return !x.isReadOnly && x.Selected;
        }).length;
        item.TriesPerformedCount = historyTriesCount + newTriesCount;
        var completedItem = item.TriesPerformedCount >= item.MandatoryCount;

        if (item.MandatoryCount == 0) {
          //non-mandatory items are considered completed if performed at least once
          completedItem = item.TriesPerformedCount >= 1;
        }

        if (completedItem) {
          item.PanelClass = 'panel-green panel-border-left-green ';
        } else {
          item.PanelClass = 'panel-border-left-blue ';
        }
      }

      function SyllabusGrouping(items) {
        //Syllabus Items Group By 'GroupId'
        var syllabusGroups = [];
        items.forEach(function (item) {
          if (!syllabusGroups.some(function (x) {
            return x.Id == item.SelectedGroup.Id;
          })) {
            if (!item.SelectedGroup) {
              item.SelectedGroup = {
                Id: 0,
                Title: 'General'
              };
            }

            var syllabusGroup = {
              Id: item.SelectedGroup.Id,
              Title: item.SelectedGroup.Title ? item.SelectedGroup.Title : 'General',
              Items: []
            };
            syllabusGroup.Items.push(item);
            syllabusGroups.push(syllabusGroup);
          } else {
            syllabusGroups.filter(function (x) {
              return x.Id == item.SelectedGroup.Id;
            })[0].Items.push(item);
          }
        });
        return syllabusGroups;
      }

      function filterItems() {
        return function (item) {
          var showItem = true;

          if (scope.showRemarks.value) {
            showItem = item.hasRemarks;
          } else {
            scope.oneAtATime = true;
          }

          return showItem;
        };
      }

      function toggleItems() {
        scope.oneAtATime = !scope.showRemarks.value;
        scope.history.ItemsGrouped.forEach(function (syllabusGroup) {
          syllabusGroup.Items.forEach(function (item) {
            item.isOpen = scope.showRemarks.value;
          });
        });
      }
    }

    return {
      restrict: 'E',
      templateUrl: 'views/TrainingReadOnly/syllabus-progress-read-only.tpl.html',
      scope: {
        phase: "=",
        history: "="
      },
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_cabin_reports.directive('syllabusReadOnly', syllabusReadOnly);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name syllabusReadOnly
  * @restrict E
  * @description
  *   Initialize read only view of submitted syllabus
  * @example
  *   Usage:
  *   <syllabus-read-only></syllabus-read-only>
  * @ngInject
  */

  function syllabusReadOnly() {
    function link(scope) {
      setSyllabus(scope.traineeSession);

      function setSyllabus(traineeSession) {
        var traineeSessionItems = [];
        scope.phase.Syllabus.SyllabusItems.forEach(function (item) {
          var syllabusItem = JSON.parse(JSON.stringify(item));
          syllabusItem.Tries = [];
          syllabusItem.Selected = false;
          var relatedSessionItem = null;

          if (scope.type == "signature") {
            relatedSessionItem = traineeSession.Items.find(function (x) {
              return x.Id == syllabusItem.Id;
            });
          } else {
            relatedSessionItem = traineeSession.Items.find(function (x) {
              return x.SyllabusItemId == syllabusItem.Id;
            });
          }

          if (relatedSessionItem) {
            syllabusItem.Selected = true;
            syllabusItem.Tries = relatedSessionItem.Tries;
          }

          if (scope.type == "signature") {
            setPanelStyleByProgress(syllabusItem);
          } else {
            setPanelStyleBySelected(syllabusItem);
          }

          traineeSessionItems.push(syllabusItem);
        });
        traineeSession.ItemsGrouped = SyllabusGrouping(traineeSessionItems);
        traineeSession.ItemsGrouped.forEach(function (group) {
          group.Items.forEach(function (item) {
            //find first not ReadOnly try
            item.firstTry = item.Tries.find(function (x) {
              return !x.isReadOnly;
            });
          });
        });
      }

      function setPanelStyleByProgress(item) {
        var historyTriesCount = item.Tries.filter(function (x) {
          return x.isReadOnly;
        }).length;
        var newTriesCount = item.Tries.filter(function (x) {
          return !x.isReadOnly && x.Selected;
        }).length;
        item.TriesPerformedCount = historyTriesCount + newTriesCount;
        var completedItem = item.TriesPerformedCount >= item.MandatoryCount;

        if (item.MandatoryCount == 0) {
          //non-mandatory items are considered completed if performed at least once
          completedItem = item.TriesPerformedCount >= 1;
        }

        var nonCompetentItem = false;

        if (item.IsGradable && item.Selected) {
          var gradingType = item.GradeType; //Numeric or Outcome or Competences

          var traineeSelectedTries = item.Tries.filter(function (x) {
            return x.Selected;
          });
          traineeSelectedTries.forEach(function (selectedTry) {
            if (!invalidItem && gradingType == "Outcome" && selectedTry.TryGrading.Grade == "Fail") {
              nonCompetentItem = true;
            }
          });
        }

        if (completedItem && !nonCompetentItem) {
          item.PanelClass = 'panel-green panel-border-left-green ';
        } else if (completedItem && nonCompetentItem) {
          item.PanelClass = 'panel-border-left-pink';
        } else {
          item.PanelClass = 'panel-border-left-blue ';
        }
      }

      function setPanelStyleBySelected(item) {
        var newTriesCount = item.Tries.filter(function (x) {
          return x.Selected;
        }).length;
        var selectedItem = newTriesCount > 0;
        var nonCompetentItem = false;
        var completedItem = item.Tries.length >= item.MandatoryCount;

        if (item.MandatoryCount == 0) {
          //non-mandatory items are considered completed if performed at least once
          completedItem = item.TriesPerformedCount >= 1;
        }

        if (item.IsGradable && item.Selected) {
          var outcomeType = item.GradeType == "Outcome";
          var traineeSelectedTries = item.Tries.filter(function (x) {
            return x.Selected;
          });

          if (outcomeType) {
            traineeSelectedTries.forEach(function (selectedTry) {
              if (outcomeType && selectedTry.TryGrading.Grade == "Fail") {
                nonCompetentItem = true;
              }
            });
          }
        }

        if (completedItem && selectedItem && !nonCompetentItem) {
          item.PanelClass = 'panel-green panel-border-left-green ';
        } else if (completedItem && selectedItem && nonCompetentItem) {
          item.PanelClass = 'panel-border-left-pink';
        } else {
          item.PanelClass = 'panel-border-left-blue ';
        }
      }

      function SyllabusGrouping(items) {
        //Syllabus Items Group By 'GroupId'
        var syllabusGroups = [];
        items.forEach(function (item) {
          if (!syllabusGroups.some(function (x) {
            return x.Id == item.SelectedGroup.Id;
          })) {
            if (!item.SelectedGroup) {
              item.SelectedGroup = {
                Id: 0,
                Title: 'General'
              };
            }

            var syllabusGroup = {
              Id: item.SelectedGroup.Id,
              Title: item.SelectedGroup.Title ? item.SelectedGroup.Title : 'General',
              Items: []
            };
            syllabusGroup.Items.push(item);
            syllabusGroups.push(syllabusGroup);
          } else {
            syllabusGroups.filter(function (x) {
              return x.Id == item.SelectedGroup.Id;
            })[0].Items.push(item);
          }
        });
        return syllabusGroups;
      }
    }

    return {
      restrict: 'E',
      templateUrl: 'views/TrainingReadOnly/syllabus-read-only.tpl.html',
      scope: {
        phase: "=",
        traineeSession: "=",
        type: "="
      },
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('ACSupplyFactory', ACSupplyFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name ACSupplyFactory
  * @description 
  *   Manage ACSupplies.
  * @ngInject
  */

  function ACSupplyFactory(GenericValuesFactory) {
    /**
     * Initialiaze ACSupply object 
     * @memberof ACSupplyFactory
     */
    function ACSupply() {
      this.Code = null;
    }

    var callback = ACSupply;
    var type = 'acSupplies';
    var service = {
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      toObjectList: toObjectList,
      getACSuppliesFromStorage: getACSuppliesFromStorage,
      getACSuppliesFromStorageAsStrings: getACSuppliesFromStorageAsStrings,
      setACSuppliesToStorage: setACSuppliesToStorage
    };
    /**
     * Extend given ACSupply object 
     * @memberof ACSupplyFactory
     * @param {object} obj The ACSupply object that will be extended
     * @returns {object} ACSupply
     */

    function fromObject(obj) {
      return GenericValuesFactory.fromObject(obj, callback);
    }
    /**
     * Extend given ACSupply object list
     * @memberof ACSupplyFactory
     * @param {array} objList The list of ACSupply objects that will be extended
     * @returns {object} ACSupplies
     */


    function fromObjectList(objList) {
      return GenericValuesFactory.fromObjectList(objList, callback);
    }
    /**
     * Get all the ACSupply's Code from given list
     * @memberof ACSupplyFactory
     * @param {array} objectList An object list
     * @returns {array} ACSupplies
     */


    function toObjectList(objList) {
      return GenericValuesFactory.objList(objList);
    }
    /**
     * Get all the ACSupply objects
     * @memberof ACSupplyFactory
     * @returns {array} ACSupplies
     */


    function getACSuppliesFromStorage() {
      return GenericValuesFactory.getValuesFromStorage(callback, type);
    }
    /**
    * Get all the ACSupply's codes from local storage
    * @memberof ACSupplyFactory
    * @returns {array} ACSupplies
    */


    function getACSuppliesFromStorageAsStrings() {
      return GenericValuesFactory.getValuesFromStorageAsStrings(callback, type);
    }
    /**
     * Set all the ACSupplies
     * @memberof ACSupplyFactory
     * @param {array} objects A list of ACSupplies.
     */


    function setACSuppliesToStorage(objList) {
      GenericValuesFactory.setValuesToStorage(objList, type);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('AircraftTypeFactory', AircraftTypeFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name AircraftTypeFactory
  * @description 
  *   Manage Aircraft Types.
  * @ngInject
  */

  function AircraftTypeFactory(GenericValuesFactory) {
    /**
     * Initialiaze AircraftType object 
     * @memberof AircraftTypeFactory
     */
    function AircraftType() {
      this.Code = null;
    }

    var callback = AircraftType;
    var type = 'aircraftTypes';
    var service = {
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      toObjectList: toObjectList,
      getAircraftTypesFromStorage: getAircraftTypesFromStorage,
      setAircraftTypesToStorage: setAircraftTypesToStorage
    };
    /**
     * Extend given AircraftType object 
     * @memberof AircraftTypeFactory
     * @param {object} obj The AircraftType object that will be extended
     * @returns {object} AircraftType
     */

    function fromObject(obj) {
      return GenericValuesFactory.fromObject(obj, callback);
    }
    /**
     * Extend given AircraftType object list
     * @memberof AircraftTypeFactory
     * @param {array} objList The list of AircraftType objects that will be extended
     * @returns {object} AircraftTypes
     */


    function fromObjectList(objList) {
      return GenericValuesFactory.fromObjectList(objList, callback);
    }
    /**
     * Extend given AircraftType object list
     * @memberof AircraftTypeFactory
     * @param {array} objList The list of AircraftType objects that will be extended
     * @returns {object} AircraftTypes
     */


    function toObjectList(objList) {
      return GenericValuesFactory.objList(objList);
    }
    /**
     * Get all the AircraftType objects
     * @memberof AircraftTypeFactory
     * @returns {array} AircraftTypes
     */


    function getAircraftTypesFromStorage() {
      return GenericValuesFactory.getValuesFromStorage(callback, type);
    }
    /**
     * Set all the AircraftTypes
     * @memberof AircraftTypeFactory
     * @param {array} objects A list of AircraftTypes.
     */


    function setAircraftTypesToStorage(objList) {
      GenericValuesFactory.setValuesToStorage(objList, type);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('AssfSignatureCtrl', AssfSignatureCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name AssfSignatureCtrl
  * @description 
  *  Manages the Assf Signature Modal View
  * @ngInject
  */

  function AssfSignatureCtrl($scope, $uibModalInstance, reportData, signatureType) {
    $scope.assfReport = reportData;
    $scope.signatureField = signatureType.charAt(0).toLowerCase() + signatureType.slice(1) + 'Signature';

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.save = function () {
      $uibModalInstance.close();
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('BarTrolleyCtrl', BarTrolleyCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name BarTrolleyCtrl
  * @description 
  *  Manages the Bar Trolley Modal View
  * @ngInject
  */

  function BarTrolleyCtrl($scope, $uibModalInstance, ModalDialogResultFactory, BarTrolleyFactory, bart) {
    var result = ModalDialogResultFactory.createNew();

    if (bart == null) {
      result.Object = BarTrolleyFactory.createNew();
      result.isInsertMode = true;
    } else {
      result.Object = BarTrolleyFactory.fromObject(bart);
      result.isInsertMode = false;
    }

    $scope.bart = result.Object;
    $scope.ok = ok;
    $scope.cancel = cancel;
    /**
     * Close modal after u check position
     * @memberof BarTrolleyCtrl
     */

    function ok() {
      if (result.Object.Position == null || result.Object.Position == '') result.Object.Position = '-';
      $uibModalInstance.close(result);
    }
    /**
     * Close Modal
     * @memberof BarTrolleyCtrl
     */


    function cancel() {
      $uibModalInstance.close(null);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('BarTrolleyFactory', BarTrolleyFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name BarTrolleyFactory
  * @description 
  *   Manage Report's BarTrolley.
  * @ngInject
  */

  function BarTrolleyFactory(GenericModalFactory) {
    /**
     * Initialiaze BarTrolley object 
     * @memberof BarTrolleyFactory
     */
    function BarTrolley() {
      this.Id = null;
      this.Position = null;
      this.SealFound = null;
      this.SealLeft = null;
      this.Label = 'Bar trolleys';
      this.Photos = [];
      this.PhotoRemarks = null;
    }

    var service = {
      createNew: createNew,
      fromObject: fromObject,
      deleteFromList: deleteFromList
    };
    /**
     * Create a new BarTrolley object 
     * @memberof BarTrolleyFactory
     * @returns {object} BarTrolley
     */

    function createNew() {
      return GenericModalFactory.createNew(BarTrolley);
    }
    /**
     * Extend given BarTrolley object 
     * @memberof BarTrolleyFactory
     * @param {object} obj The BarTrolley object that will be extended
     * @returns {object} BarTrolley
     */


    function fromObject(obj) {
      return GenericModalFactory.fromObject(obj, BarTrolley);
    }
    /**
     * Delete BarTrolley object from given list
     * @memberof BarTrolleyFactory
     * @param {object} obj The BarTrolley object that will be deleted
     * @returns {array} BarTrollies
     */


    function deleteFromList(obj, objList) {
      return GenericModalFactory.deleteFromList(obj, objList);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CCMSFactory', CCMSFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CCMSFactory
  * @description 
  *   Manage CCMS.
  * @ngInject
  */

  function CCMSFactory(GenericService) {
    /**
     * Initialiaze CCMS object 
     * @memberof CCMSFactory
     */
    function CCMS() {
      this.Aircraft = null;
      this.Positions = new Array();
      this.CrewComments = new Array();
    }

    var objType = 'ccms';
    var objCallback = CCMS;
    var service = {
      getCCMSFromStorage: getCCMSFromStorage,
      setCCMSToStorage: setCCMSToStorage
    };
    /**
     * Get all the CCMS objects
     * @memberof CCMSFactory
     * @returns {array} CCMS
     */

    function getCCMSFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Set all the CCMS
     * @memberof CCMSFactory
     * @param {array} objects A list of CCMS.
     */


    function setCCMSToStorage(ccms) {
      GenericService.saveAll(ccms, objType, objCallback);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('CCMSCrewPositionCtrl', CCMSCrewPositionCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name CCMSCrewPositionCtrl
  * @description 
  *  Manages the CCMS Crew Position Modal View
  * @ngInject
  */

  function CCMSCrewPositionCtrl($scope, $uibModalInstance, ModalDialogResultFactory, CCMSCrewPositionFactory, crew) {
    var result = ModalDialogResultFactory.createNew();

    if (crew == null) {
      result.Object = CCMSCrewPositionFactory.createNew();
      result.Object.IsManual = true;
      result.isInsertMode = true;
    } else {
      result.Object = CCMSCrewPositionFactory.fromObject(crew);
      result.isInsertMode = false;
    }

    $scope.crew = result.Object;
    $scope.ok = ok;
    $scope.cancel = cancel;
    /**
     * Close modal after u check position
     * @memberof CCMSCrewPositionCtrl
     */

    function ok() {
      if (result.Object.CrewId == null || result.Object.CrewId == '') result.Object.CrewId = '-';
      $uibModalInstance.close(result);
    }
    /**
     * Close Modal
     * @memberof CCMSCrewPositionCtrl
     */


    function cancel() {
      $uibModalInstance.close(null);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('CCMSCrewPositionFactory', CCMSCrewPositionFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name CCMSCrewPositionFactory
  * @description 
  *   Manage Report's CCMSCrewPositions.
  * @ngInject
  */

  function CCMSCrewPositionFactory(GenericModalFactory) {
    /**
     * Initialiaze CCMSCrewPosition object 
     * @memberof CCMSCrewPositionFactory
     */
    function CCMSCrewPosition() {
      this.Id = null;
      this.CrewId = null;
      this.Initials = null;
      this.Name = null;
      this.Position = null;
      this.CCMS = null;
      this.IsManual = false;
      this.CrewComments = null;
      this.HasCrewComments = false;
      this.needsAdditionalFeedback = false;
      this.HasAdditionalFeedbackComments = false;
      this.AdditionalFeedbackId = null;
      this.FeedbackAuthorName = null;
      this.Route = null;
    }

    var service = {
      createNew: createNew,
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      deleteFromList: deleteFromList
    };
    /**
     * Create a new CCMSCrewPosition object 
     * @memberof CCMSCrewPositionFactory
     * @returns {object} CCMSCrewPosition
     */

    function createNew() {
      return GenericModalFactory.createNew(CCMSCrewPosition);
    }
    /**
     * Extend given CCMSCrewPosition object 
     * @memberof CCMSCrewPositionFactory
     * @param {object} obj The CCMSCrewPosition object that will be extended
     * @returns {object} CCMSCrewPosition
     */


    function fromObject(obj) {
      return GenericModalFactory.fromObject(obj, CCMSCrewPosition);
    }
    /**
     * Delete CCMSCrewPosition object from given list
     * @memberof CCMSCrewPositionFactory
     * @param {object} obj The CCMSCrewPosition object that will be deleted
     * @returns {array} CCMSCrewPositions
     */


    function deleteFromList(obj, objList) {
      return GenericModalFactory.deleteFromList(obj, objList);
    }
    /**
     * Extend given CCMSCrewPosition object List 
     * @memberof CCMSCrewPositionFactory
     * @param {object} obj The CCMSCrewPosition object that will be extended
     * @returns {array} CCMSCrewPositions
     */


    function fromObjectList(objList) {
      return GenericModalFactory.fromObjectList(objList, CCMSCrewPosition);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('FirstAidKitCtrl', FirstAidKitCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name FirstAidKitCtrl
  * @description 
  *  Manages the First Aid Kit Modal View
  * @ngInject
  */

  function FirstAidKitCtrl($scope, $uibModalInstance, ModalDialogResultFactory, FirstAidKitFactory, fak, IsEMK) {
    var result = ModalDialogResultFactory.createNew();
    console.log("emk " + IsEMK);

    if (fak == null) {
      result.Object = FirstAidKitFactory.createNew();
      result.Object.IsEMK = IsEMK;
      result.isInsertMode = true;
    } else {
      result.Object = FirstAidKitFactory.fromObject(fak);
      result.isInsertMode = false;
    }

    $scope.fak = result.Object;
    $scope.IsEMK = IsEMK;
    $scope.ok = ok;
    $scope.cancel = cancel;
    /**
     * Close modal after u check position
     * @memberof FirstAidKitCtrl
     */

    function ok() {
      if (result.Object.Position == null || result.Object.Position == '') result.Object.Position = '-';
      $uibModalInstance.close(result);
    }
    /**
     * Close Modal
     * @memberof FirstAidKitCtrl
     */


    function cancel() {
      $uibModalInstance.close(null);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('FirstAidKitFactory', FirstAidKitFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name FirstAidKitFactory
  * @description 
  *   Manage Report's FirstAidKits.
  * @ngInject
  */

  function FirstAidKitFactory(GenericModalFactory) {
    /**
     * Initialiaze FirstAidKit object 
     * @memberof FirstAidKitFactory
     */
    function FirstAidKit() {
      this.Id = null;
      this.Position = null;
      this.SealFound = null;
      this.SealLeft = null;
      this.IsEMK = false;
    }

    var service = {
      createNew: createNew,
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      deleteFromList: deleteFromList
    };
    /**
     * Create a new FirstAidKit object 
     * @memberof FirstAidKitFactory
     * @returns {object} FirstAidKit
     */

    function createNew() {
      return GenericModalFactory.createNew(FirstAidKit);
    }
    /**
     * Extend given FirstAidKit object 
     * @memberof FirstAidKitFactory
     * @param {object} obj The FirstAidKit object that will be extended
     * @returns {object} FirstAidKit
     */


    function fromObject(obj) {
      return GenericModalFactory.fromObject(obj, FirstAidKit);
    }
    /**
     * Delete FirstAidKit object from given list
     * @memberof FirstAidKitFactory
     * @param {object} obj The FirstAidKit object that will be deleted
     * @returns {array} FirstAidKits
     */


    function deleteFromList(obj, objList) {
      return GenericModalFactory.deleteFromList(obj, objList);
    }
    /**
     * Extend given FirstAidKit object List 
     * @memberof FirstAidKitFactory
     * @param {object} obj The FirstAidKit object that will be extended
     * @returns {array} FirstAidKits
     */


    function fromObjectList(objList) {
      return GenericModalFactory.fromObjectList(objList, FirstAidKit);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('FlightDetailCtrl', FlightDetailCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name FlightDetailCtrl
  * @description 
  *  Manages the Flight Detail Modal View
  * @ngInject
  */

  function FlightDetailCtrl($scope, $uibModalInstance, ModalDialogResultFactory, CabinReportLocalEditFactory, AircraftTypeFactory, fd) {
    var result = ModalDialogResultFactory.createNew();
    result.Object = CabinReportLocalEditFactory.fromObject(fd);
    var reportAircraftTypes = new Array();
    var allAircraftTypes = AircraftTypeFactory.getAircraftTypesFromStorage();

    for (var c = 0; c < allAircraftTypes.length; c++) {
      reportAircraftTypes.push(allAircraftTypes[c].Code);
    }

    $scope.aircraftTypes = reportAircraftTypes;
    $scope.fd = result.Object;
    $scope.ok = ok;
    $scope.cancel = cancel;
    /**
     * Close modal after u check position
     * @memberof FlightDetailCtrl
     */

    function ok() {
      if (result.Object.AcType == null || result.Object.AcType == '') result.Object.AcType = '-';
      $uibModalInstance.close(result);
    }
    /**
    * Close Modal
    * @memberof FlightDetailCtrl
    */


    function cancel() {
      $uibModalInstance.close(null);
    }
  }
})();
"use strict";

(function () {
  "use strict";

  a3_cabin_reports.controller("FoundPropertyCtrl", FoundPropertyCtrl);
  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name FoundPropertyCtrl
   * @description
   *  Manages the Special Modal View
   * @ngInject
   */

  function FoundPropertyCtrl($scope, $uibModalInstance, foundProperty) {
    console.log("MODAL INPUT foundProperty:", angular.copy(foundProperty)); // Image compression settings

    $scope.quality = 0.4;
    $scope.maxWidth = 1024;
    $scope.maxHeight = 768;
    $scope.categories = ["Bag", "Book", "Camera", "Charger / Powerbank", "Clothing", "Cosmetics", "Duty Free", "Earphones / Headphones", "eBook Reader", "Footwear", "Glasses / Sunglasses", "Headwear", "Jewellery", "Kids / Infant care", "Laptop", "Medical Item", "Mobile Phone", "Other", "Passport / ID / Documents", "Pillow", "Tablet", "Toy", "Umbrella", "Videogames", "Wallet", "Watch"];
    $scope.seats = ["A", "B", "C", "D", "E", "F"];

    $scope.clearFoundPropertyDescription = function () {
      $scope.foundProperty.DetailedDescription = "";
    };

    $scope.clearFoundPropertyComments = function () {
      $scope.foundProperty.Comments = "";
    };

    $scope.foundProperty = foundProperty || {
      Category: "",
      DetailedDescription: "",
      Images: [],
      SeatRow: "",
      Seat: "",
      Comments: "",
      Signature: [],
      AgentName: ""
    };
    $scope.foundProperty.Photos = $scope.foundProperty.Photos || [];
    /**
     * Resize and compress image
     * @memberof FoundPropertyCtrl
     */

    function resizeAndCompressImage(dataURL, fileType, callback) {
      var img = new Image();

      img.onload = function () {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d"); // Calculate new dimensions while maintaining aspect ratio

        var width = img.width;
        var height = img.height;

        if (width > $scope.maxWidth || height > $scope.maxHeight) {
          var ratio = Math.min($scope.maxWidth / width, $scope.maxHeight / height);
          width = Math.floor(width * ratio);
          height = Math.floor(height * ratio);
        }

        canvas.width = width;
        canvas.height = height; // Draw and compress

        ctx.drawImage(img, 0, 0, width, height); // Convert to compressed base64

        var compressedDataURL = canvas.toDataURL(fileType || "image/jpeg", $scope.quality);
        var base64Data = compressedDataURL.split(",")[1];
        callback(base64Data, fileType);
      };

      img.src = dataURL;
    }

    $scope.addPhotos = function (files) {
      if (!files || !files.length) return;
      Array.from(files).forEach(function (file) {
        var reader = new FileReader();

        reader.onload = function (e) {
          var result = e.target.result;

          if (!result || !result.includes(",")) {
            return;
          }

          var fileType = file.type || "image/jpeg"; // Resize and compress the image

          resizeAndCompressImage(result, fileType, function (compressedBase64, finalFileType) {
            $scope.$apply(function () {
              $scope.foundProperty.Images = $scope.foundProperty.Images || [];
              $scope.foundProperty.Images.push({
                PhotoData: compressedBase64,
                FileType: finalFileType
              });
            });
          });
        };

        reader.readAsDataURL(file);
      });
    }; // Tracks whether user is trying to save as completed (strict validation)


    $scope.submitAttempted = false;

    $scope.onSaveCompletedClick = function () {
      $scope.submitAttempted = true;
      $scope.ok(); // will validate via isFoundPropertyValid()
    };

    $scope.onSaveDraftClick = function () {
      // Draft should NOT trigger required validation UI
      $scope.submitAttempted = false;
      $scope.saveAsDraft();
    };

    $scope.ok = function () {
      $scope.foundProperty.Status = $scope.isFoundPropertyValid() ? "completed" : "draft";
      $uibModalInstance.close($scope.foundProperty);
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss("cancel");
    };

    $scope.saveAsDraft = function () {
      $scope.foundProperty.Status = "draft";
      $uibModalInstance.close($scope.foundProperty);
    };

    function hasValue(value) {
      return value != null && String(value).trim() !== "";
    }

    $scope.hasAnyValue = function () {
      return hasValue($scope.foundProperty.Category) || hasValue($scope.foundProperty.DetailedDescription) || hasValue($scope.foundProperty.SeatRow) || hasValue($scope.foundProperty.Seat) || hasValue($scope.foundProperty.Comments) || Array.isArray($scope.foundProperty.Images) && $scope.foundProperty.Images.length > 0 || hasValue($scope.foundProperty.AgentName) || Array.isArray($scope.foundProperty.Signature) && $scope.foundProperty.Signature.length > 0;
    };

    $scope.isFoundPropertyValid = function () {
      var fp = $scope.foundProperty;
      return hasValue(fp.Category) && hasValue(fp.AgentName) && Array.isArray(fp.Signature) && fp.Signature.length > 0;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('FoundPropertyFactory', FoundPropertyFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name FoundPropertyFactory
  * @description 
  *   Manage Report's found property.
  * @ngInject
  */

  function FoundPropertyFactory(GenericModalFactory) {
    /**
     * Initialiaze Found Property object 
     * @memberof FoundPropertyFactory
     */
    function FoundProperty() {
      this.Id = null;
      this.Category = null;
      this.DetailedDescription = null;
      this.SeatRow = null;
      this.Seat = null;
      this.Label = 'Found Property';
      this.Images = [];
      this.Comments = null;
      this.Signature = null;
      this.AgentName = null;
      this.Status = 'draft'; // 'draft' or 'completed'
    }

    var service = {
      createNew: createNew
    };
    /**
     * Create a new Found Property object 
     * @memberof FoundPropertyFactory
     * @returns {object} FoundProperty
     */

    function createNew() {
      return GenericModalFactory.createNew(FoundProperty);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('IncompleteServicesIssueCtrl', IncompleteServicesIssueCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name IncompleteServicesIssueCtrl
  * @description 
  *  Manages the Special Modal View
  * @ngInject
  */

  function IncompleteServicesIssueCtrl($scope, $uibModalInstance, ModalDialogResultFactory, IncompleteServicesIssueFactory, IncompleteServicesSourceFactory, service, fleetId) {
    // setup available reasons and services
    var a3Reasons = IncompleteServicesSourceFactory.getA3ReasonsFromStorage();
    var oaReasons = IncompleteServicesSourceFactory.getOAReasonsFromStorage();
    var a3Services = IncompleteServicesSourceFactory.getA3ServicesFromStorage();
    var oaServices = IncompleteServicesSourceFactory.getOAServicesFromStorage();
    if (!(a3Reasons instanceof Array)) a3Reasons = [];
    if (!(oaReasons instanceof Array)) oaReasons = [];
    if (!(a3Services instanceof Array)) a3Services = [];
    if (!(oaServices instanceof Array)) oaServices = [];

    if (fleetId == 1) {
      $scope.availableReasons = a3Reasons;
      $scope.availableServices = a3Services;
    } else {
      $scope.availableReasons = oaReasons;
      $scope.availableServices = oaServices;
    } //Both:
    // $scope.availableReasons = a3Reasons.concat(oaReasons).unique();
    // $scope.availableServices = a3Services.concat(oaServices).unique();


    var result = ModalDialogResultFactory.createNew();

    if (service == null) {
      result.Object = IncompleteServicesIssueFactory.createNew();
      result.isInsertMode = true;
    } else {
      result.Object = IncompleteServicesIssueFactory.fromObject(service);
      result.isInsertMode = false;
    }

    $scope.service = result.Object;
    $scope.service.ServiceClass = $scope.service.ServiceClass == null ? 'Y' : $scope.service.ServiceClass;
    $scope.ok = ok;
    $scope.cancel = cancel;
    $scope.clearIncompleteServiceRemarks = clearIncompleteServiceRemarks;
    $scope.addRows = addRows;
    $scope.removeRow = removeRow;

    function removeRow(index) {
      $scope.service.Rows.splice(index, 1);
    }

    function addRows() {
      var RowSet = {
        From: null,
        To: null
      };
      $scope.service.Rows.push(RowSet);
    }
    /**
     * Clear Field
     * @memberof IncompleteServicesIssueCtrl
     */


    function clearField(target, fieldName) {
      if (target[fieldName] == null || target[fieldName] == '') return false;
      bootbox.dialog({
        message: "Please confirm that you wish to clear this field",
        title: "<strong>Attention<strong>",
        buttons: {
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          },
          ok: {
            label: "Ok",
            className: "btn-warning",
            callback: function callback() {
              target[fieldName] = null;
              $scope.$apply();
              return true;
            }
          }
        }
      });
    }
    /**
     * Clear Special Meal Issue remarks
     * @memberof SpecialMealIssueCtrl
     */


    function clearIncompleteServiceRemarks(service) {
      clearField(service, "Remarks"); //sup.Remarks = null;
    }
    /**
     * set date and close modal
     * @memberof SpecialMealIssueCtrl
     */


    function ok() {
      var test = $scope.service;
      $uibModalInstance.close(result);
    }
    /**
     * Close modal after u check position
     * @memberof SpecialMealIssueCtrl
     */


    function cancel() {
      $uibModalInstance.close(null);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('IncompleteServicesIssueFactory', IncompleteServicesIssueFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name IncompleteInFlightServicesFactory
  * @description 
  *   Manage Incomplete In-Flight Services Reasons.
  * @ngInject
  */

  function IncompleteServicesIssueFactory(GenericModalFactory) {
    var service = {
      createNew: createNew,
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      deleteFromList: deleteFromList
    };
    /**
    * Initialiaze IncompleteService object 
    * @memberof IncompleteInFlightServicesFactory
    */

    function IncompleteService() {
      this.Id = null;
      this.ServiceClass = null;
      this.Rows = [];
      this.ServiceType = null;
      this.Reason = null;
      this.Remarks = null;
    }
    /**
     * Create new IncompleteService object 
     * @memberof IncompleteInFlightServicesFactory
     */


    function createNew() {
      var newObj = GenericModalFactory.createNew(IncompleteService);
      var RowSet = {
        From: null,
        To: null
      };
      newObj.Rows.push(RowSet);
      return newObj;
    }
    /**
     * Extend given IncompleteService object 
     * @memberof IncompleteInFlightServicesFactory
     * @param {object} obj The IncompleteService object that will be extended
     * @returns {object} IncompleteService
     */


    function fromObject(obj) {
      return GenericModalFactory.fromObject(obj, IncompleteService);
    }
    /**
     * Delete IncompleteService object from given list
     * @memberof IncompleteInFlightServicesFactory
     * @param {object} obj The IncompleteService object that will be deleted
     * @returns {array} IncompleteServices
     */


    function deleteFromList(obj, objList) {
      return GenericModalFactory.deleteFromList(obj, objList);
    }
    /**
     * Extend given IncompleteService object List 
     * @memberof IncompleteInFlightServicesFactory
     * @param {object} obj The IncompleteService object that will be extended
     * @returns {array} IncompleteServices
     */


    function fromObjectList(objList) {
      return GenericModalFactory.fromObjectList(objList, IncompleteService);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('IncompleteServicesSourceFactory', IncompleteServicesSourceFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name IncompleteInFlightServicesFactory
  * @description 
  *   Manage Incomplete In-Flight Services Reasons.
  * @ngInject
  */

  function IncompleteServicesSourceFactory(localStorageMD5Service) {
    var service = {
      setIncompleteInFlightServiceListOfValues: setIncompleteInFlightServiceListOfValues,
      getA3ReasonsFromStorage: getA3ReasonsFromStorage,
      getOAReasonsFromStorage: getOAReasonsFromStorage,
      getA3ServicesFromStorage: getA3ServicesFromStorage,
      getOAServicesFromStorage: getOAServicesFromStorage
    }; //Get From LocalStorage

    /**
     * Get all the Incomplete In-Flight Services Reasons for A3
     * @memberof IncompleteInFlightServicesFactory
     * @returns {array} TravelValueIncompleteReasons
     */

    function getA3ReasonsFromStorage() {
      var results = [];
      var listOfValues = localStorageMD5Service.get('incompleteInFlightServiceListOfValues');

      if (listOfValues) {
        var A3Reasons = listOfValues.filter(function (item) {
          return item.Fleet == "A3" && item.Type == "Reason";
        });
        results = A3Reasons.map(function (item) {
          return item.Value;
        });
      }

      return results;
    }
    /**
     * Get all the Incomplete In-Flight Services Reasons for OA
     * @memberof IncompleteInFlightServicesFactory
     * @returns {array} TravelValueIncompleteReasons
     */


    function getOAReasonsFromStorage() {
      var results = [];
      var listOfValues = localStorageMD5Service.get('incompleteInFlightServiceListOfValues');

      if (listOfValues) {
        var OAReasons = listOfValues.filter(function (item) {
          return item.Fleet == "OA" && item.Type == "Reason";
        });
        results = OAReasons.map(function (item) {
          return item.Value;
        });
      }

      return results;
    }
    /**
     * Get all the Incomplete In-Flight Services Types for A3
     * @memberof IncompleteInFlightServicesFactory
     * @returns {array} TravelValueIncompleteReasons
     */


    function getA3ServicesFromStorage() {
      var results = [];
      var listOfValues = localStorageMD5Service.get('incompleteInFlightServiceListOfValues');

      if (listOfValues) {
        var A3Services = listOfValues.filter(function (item) {
          return item.Fleet == "A3" && item.Type == "ServiceType";
        });
        results = A3Services.map(function (item) {
          return item.Value;
        });
      }

      return results;
    }
    /**
     * Get all the Incomplete In-Flight Services Types for OA
     * @memberof IncompleteInFlightServicesFactory
     * @returns {array} TravelValueIncompleteReasons
     */


    function getOAServicesFromStorage() {
      var results = [];
      var listOfValues = localStorageMD5Service.get('incompleteInFlightServiceListOfValues');

      if (listOfValues) {
        var A3Services = listOfValues.filter(function (item) {
          return item.Fleet == "OA" && item.Type == "ServiceType";
        });
        results = A3Services.map(function (item) {
          return item.Value;
        });
      }

      return results;
    } //Set to LocalStorage

    /**
     * Set all the Incomplete In-Flight Services List Of Values 
     * @memberof IncompleteInFlightServicesFactory
     * @param {array} objects A list of IncompleteInFlightServicesFactory.
     */


    function setIncompleteInFlightServiceListOfValues(data) {
      localStorageMD5Service.set('incompleteInFlightServiceListOfValues', data);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('ItemPhotosCtrl', ItemPhotosCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name ItemPhotosCtrl
  * @description 
  *  Manages the Item Photos Modal View
  * @ngInject
  */

  function ItemPhotosCtrl($scope, $uibModalInstance, PhotoFactory, item) {
    $scope.item = item;
    $scope.quality = 0.4;
    $scope.width = 1024;
    $scope.height = 768;
    $scope.comment = "Recommended for printed documents with smaller font";
    $scope.sizeLimitKb = 100;
    $scope.isImageTooLarge = isImageTooLarge;
    $scope.settingsSet = settingsSet;
    $scope.settingsName = settingsName;
    $scope.settingsText = settingsText;
    $scope.settings = 3;
    $scope.settingsMinus = settingsMinus;
    $scope.settingsPlus = settingsPlus;
    $scope.settingsDefault = settingsDefault;
    $scope.imageChanged = imageChanged;
    $scope.imageError = imageError;
    $scope.rotateImageLeft = rotateImageLeft;
    $scope.rotateImageRight = rotateImageRight;
    $scope.cancel = cancel;
    $scope.ok = ok;
    $scope.viewPhoto = viewPhoto;
    $scope.deletePhoto = deletePhoto;
    $scope.settingsText();
    /**
     * is Image Too Large 
     * @memberof ItemPhotosCtrl
     */

    function isImageTooLarge() {
      var b = false;
      var i = $scope.item;

      if (i != null && i.Photos != null && i.Photos.length > 0 && i.Photos[0].PhotoData != null) {
        b = i.Photos[0].PhotoData.length > $scope.sizeLimitKb * 1024;
      }

      return b;
    }
    /**
     * Set settings
     * @memberof ItemPhotosCtrl
     */


    function settingsSet() {
      if ($scope.settings == 0) {
        $scope.width = 320;
        $scope.height = 240;
        $scope.comment = "Not recommended";
      } else if ($scope.settings == 1) {
        $scope.width = 640;
        $scope.height = 480;
        $scope.comment = "Recommended for objects/places";
      } else if ($scope.settings == 2) {
        $scope.width = 800;
        $scope.height = 600;
        $scope.comment = "Recommended for printed documents";
      } else if ($scope.settings == 3) {
        $scope.width = 1024;
        $scope.height = 768;
        $scope.comment = "Recommended for printed documents with smaller font";
      } else if ($scope.settings == 4) {
        $scope.width = 1280;
        $scope.height = 1024;
        $scope.comment = "Recommended for handwritten documents";
      }
    }
    /**
     * Show settings name
     * @memberof ItemPhotosCtrl
     */


    function settingsName() {
      if ($scope.settings == 0) return 'xsmall';else if ($scope.settings == 1) return 'small';else if ($scope.settings == 2) return 'normal';else if ($scope.settings == 3) return 'medium';else if ($scope.settings == 4) return 'high';else return 'High' + $scope.settings;
    }
    /**
     * Show settings text comment
     * @memberof ItemPhotosCtrl
     */


    function settingsText() {
      return $scope.comment + " (" + $scope.width + 'x' + $scope.height + ' ' + $scope.quality + ")";
    }
    /**
     * Lower image settings
     * @memberof ItemPhotosCtrl
     */


    function settingsMinus() {
      $scope.settings--;
      if ($scope.settings < 0) $scope.settings = 0;
      $scope.settingsSet();
    }
    /**
     * Higher image settings
     * @memberof ItemPhotosCtrl
     */


    function settingsPlus() {
      $scope.settings++;
      if ($scope.settings > 4) $scope.settings = 4;
      $scope.settingsSet();
    }
    /**
     * Set default image settings
     * @memberof ItemPhotosCtrl
     */


    function settingsDefault() {
      $scope.settings = 2;
      $scope.settingsSet();
    }
    /**
    * Change Image settings
    * @memberof ItemPhotosCtrl
    */


    function imageChanged(data) {
      //console.log('told of a new image', imageResult, this.imageBrowsed, $scope.imageBrowsed);
      var imageResult = data; //$scope.imageBrowsed;

      if (imageResult != null) {
        item.Photos = [];
        var img = PhotoFactory.createNew();
        img.PhotoData = imageResult.dataURL;
        img.FileType = imageResult.fileType || imageResult.file.type;
        item.Photos.push(img);
        $scope.filename = null;
      }
    }
    /**
     * Change Image settings
     * @memberof ItemPhotosCtrl
     */


    function imageError(err) {
      console.log('told of an error', err);
    }
    /**
     * Rotate Image to the Left
     * @memberof ItemPhotosCtrl
     */


    function rotateImageLeft(image) {
      var origImg = new Image();
      origImg.src = image.PhotoData;
      var oc = document.createElement('canvas');
      var octx = oc.getContext('2d');
      octx.mozImageSmoothingEnabled = false;
      octx.webkitImageSmoothingEnabled = false; // Inverse height and width as canvas size

      oc.width = origImg.height;
      oc.height = origImg.width; // Save original grid

      octx.save(); // Set origin of canvas to center | 0,0 is now w/2 and h/2

      octx.translate(Math.floor(origImg.height / 2), Math.floor(origImg.width / 2)); // Rotate the whole grid by X degrees

      octx.rotate(-1 * Math.PI / 2); // Draw the image into the rotated grid

      octx.drawImage(origImg, -Math.floor(origImg.width / 2), -Math.floor(origImg.height / 2), Math.floor(origImg.width), Math.floor(origImg.height)); // Restore grid coordinates

      octx.restore();
      image.PhotoData = oc.toDataURL('image/jpeg', $scope.quality);
    }
    /**
     * Rotate Image to the Left
     * @memberof ItemPhotosCtrl
     */


    function rotateImageRight(image) {
      var origImg = new Image();
      origImg.src = image.PhotoData;
      var oc = document.createElement('canvas');
      var octx = oc.getContext('2d');
      octx.mozImageSmoothingEnabled = false;
      octx.webkitImageSmoothingEnabled = false; // Inverse height and width as canvas size

      oc.width = origImg.height;
      oc.height = origImg.width; // Save original grid

      octx.save(); // Set origin of canvas to center | 0,0 is now w/2 and h/2

      octx.translate(Math.floor(origImg.height / 2), Math.floor(origImg.width / 2)); // Rotate the whole grid by X degrees

      octx.rotate(Math.PI / 2); // Draw the image into the rotated grid

      octx.drawImage(origImg, -Math.floor(origImg.width / 2), -Math.floor(origImg.height / 2), Math.floor(origImg.width), Math.floor(origImg.height)); // Restore grid coordinates

      octx.restore();
      image.PhotoData = oc.toDataURL(image.FileType, $scope.quality);
    }
    /**
     * Close Modal
     * @memberof BarTrolleyCtrl
     */


    function ok() {
      $uibModalInstance.close();
    }
    /**
     * Close Modal
     * @memberof BarTrolleyCtrl
     */


    function cancel() {
      $uibModalInstance.close();
    }
    /**
     * View  photo in new window
     * @memberof ItemPhotosCtrl
     */


    function viewPhoto(pho) {
      window.open(pho.PhotoData);
    }
    /**
     * Delete photo
     * @memberof ItemPhotosCtrl
     */


    function deletePhoto(pho) {
      bootbox.dialog({
        message: "Are you sure you want to delete this photo?",
        title: "<strong>Delete record<strong>",
        buttons: {
          no: {
            label: "No",
            className: "btn-default",
            callback: function callback() {}
          },
          yes: {
            label: "Yes",
            className: "btn-warning",
            callback: function callback() {
              PhotoFactory.deleteFromList(pho, item.Photos);
              $scope.$apply();
            }
          }
        }
      });
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('MedicalIncidentCtrl', MedicalIncidentCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name MedicalIncidentCtrl
  * @description 
  *  Manages the Medical Incident Modal View
  * @ngInject
  */

  function MedicalIncidentCtrl($scope, $timeout, $uibModalInstance, ModalDialogResultFactory, MedicalIncidentFactory, med) {
    $scope.clearField = clearField;
    $scope.clearMedicalRemarks = clearMedicalRemarks;
    $scope.clearMedicalSignature = clearMedicalSignature;
    $scope.ok = ok;
    $scope.cancel = cancel;
    var result = ModalDialogResultFactory.createNew();

    if (med == null) {
      result.Object = MedicalIncidentFactory.createNew();
      result.isInsertMode = true;
    } else {
      result.Object = MedicalIncidentFactory.fromObject(med);
      result.isInsertMode = false;
    }

    $scope.med = result.Object;
    $timeout(function () {
      $('.modal-medical').find('textarea').each(function (index, item) {
        if (item.value != '') autoAdjustTextarea(item);
      });
    }, 500);
    /**
     * Clear Field
     * @memberof MedicalIncidentCtrl
     */

    function clearField(target, fieldName) {
      if (target[fieldName] == null || target[fieldName] == '') return false;
      bootbox.dialog({
        message: "Please confirm that you wish to clear this field",
        title: "<strong>Attention<strong>",
        buttons: {
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          },
          ok: {
            label: "Ok",
            className: "btn-warning",
            callback: function callback() {
              target[fieldName] = null;
              $scope.$apply();
              return true;
            }
          }
        }
      });
    }
    /**
     * Clear  medical remarks
     * @memberof MedicalIncidentCtrl
     */


    function clearMedicalRemarks(med) {
      $scope.clearField(med, "Symptoms");
    }
    /**
     * Clear medical signature function
     * @memberof MedicalIncidentCtrl
     */


    function clearMedicalSignature(med) {
      $scope.clearField(med, "Signature"); //med.Signature = null;
    }
    /**
     * Close modal after u check Name
     * @memberof MedicalIncidentCtrl
     */


    function ok() {
      if (result.Object.Name == null || result.Object.Name == '') result.Object.Name = '-';
      $uibModalInstance.close(result);
    }
    /**
     * Close modal
     * @memberof MedicalIncidentCtrl
     */


    function cancel() {
      $uibModalInstance.close(null);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('MedicalIncidentFactory', MedicalIncidentFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name MedicalIncidentFactory
  * @description 
  *   Manage Report's MedicalIncindents.
  * @ngInject
  */

  function MedicalIncidentFactory(GenericModalFactory) {
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name MedicalIncidentFactory
    * @description 
    *   Manage Report's MedicalIncindents.
    * @ngInject
    */
    function MedicalIncident() {
      this.Id = null;
      this.FAKUsed = null;
      this.Medicine = null;
      this.Symptoms = null;
      this.Signature = null;
      this.Name = null;
      this.Phone = null;
      this.Email = null;
      this.DoctorInvolved = null;
      this.DoctorName = null;
      this.DoctorPhone = null;
      this.EMFAKUsed = null;
    }

    var service = {
      createNew: createNew,
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      deleteFromList: deleteFromList
    };
    /**
     * Create a new MedicalIncident object 
     * @memberof MedicalIncidentFactory
     * @returns {object} MedicalIncident
     */

    function createNew() {
      return GenericModalFactory.createNew(MedicalIncident);
    }
    /**
     * Create a new MedicalIncident object 
     * @memberof MedicalIncidentFactory
     * @returns {object} MedicalIncident
     */


    function fromObject(obj) {
      return GenericModalFactory.fromObject(obj, MedicalIncident);
    }
    /**
     * Delete MedicalIncident object from given list
     * @memberof MedicalIncidentFactory
     * @param {object} obj The MedicalIncident object that will be deleted
     * @returns {array} MedicalIncindents
     */


    function deleteFromList(obj, objList) {
      return GenericModalFactory.deleteFromList(obj, objList);
    }
    /**
     * Extend given MedicalIncident object List 
     * @memberof MedicalIncidentFactory
     * @param {object} obj The MedicalIncident object that will be extended
     * @returns {array} MedicalIncindents
     */


    function fromObjectList(objList) {
      return GenericModalFactory.fromObjectList(objList, MedicalIncident);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('OpenReportDialogCtrl', OpenReportDialogCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name OpenReportDialogCtrl
  * @description 
  *  Manages the open report modal functionality 
  * @ngInject
  */

  function OpenReportDialogCtrl($scope, $uibModalInstance, $location, apiUrl, UserFactory, FlightFactory, CabinReportLocalEditFactory, flightId) {
    var user = UserFactory.getUser();
    var allServerReports = [];
    var flight = FlightFactory.getFlightFromStorage(flightId);
    if (flight == null) return; // load the reports

    var serverReportForThisUser = flight.getServerCabinReportForUser(user.aimsId);
    var serverReportsByAnotherUser = flight.getServerCabinReportsByAnotherUser(user.aimsId);
    var localReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId); // the user can create a new report only if there is not an existing one and
    // there is not a server report by him

    if (localReport != null || serverReportForThisUser != null) $scope.canCreateNewLocalReport = false;else $scope.canCreateNewLocalReport = true;

    if (serverReportForThisUser != null) {
      serverReportForThisUser.IsSameUser = " (YOU)";
      allServerReports.push(serverReportForThisUser);
    }

    for (var i = 0; i < serverReportsByAnotherUser.length; i++) {
      allServerReports.push(serverReportsByAnotherUser[i]);
    }

    $scope.localReport = localReport;
    $scope.serverReports = allServerReports;
    $scope.cancel = cancel;
    $scope.createNewLocalReport = createNewLocalReport;
    $scope.openLocalReport = openLocalReport;
    $scope.openServerReport = openServerReport;
    /**
     * Close Modal
     * @memberof OpenReportDialogCtrl
     */

    function cancel() {
      $uibModalInstance.dismiss('');
    }
    /**
     * Create new report and close modal
     * @memberof OpenReportDialogCtrl
     */


    function createNewLocalReport() {
      $location.path("report/new:" + -1 + "/" + flightId);
      $uibModalInstance.dismiss('');
    }
    /**
     * Open Local Report
     * @memberof OpenReportDialogCtrl
     * @param {object} report
     */


    function openLocalReport(report) {
      $location.path("report/" + report.ReportGuid);
      $uibModalInstance.dismiss('');
    }
    /**
     * Open Server stored Report
     * @memberof OpenReportDialogCtrl
     * @param {object} report
     */


    function openServerReport(report) {
      // get user token and send it as a parameter on the call
      var token = '';

      if (user != null) {
        token = user.token;
        token = encodeURIComponent(token);
        $location.path("reportsHistory/" + report.ReportId + "/" + flightId + "/Cabin");
      }

      $uibModalInstance.dismiss('');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('PhotoFactory', PhotoFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name PhotoFactory
  * @description 
  *   Manage Report's Photos.
  * @ngInject
  */

  function PhotoFactory(GenericModalFactory) {
    /**
     * Initialiaze Photo object 
     * @memberof PhotoFactory
     */
    function Photo() {
      this.Id = null;
      this.Remarks = null;
      this.RemarksShort = null;
      this.PhotoData = null;
      this.FileType = null;
    }

    var service = {
      createNew: createNew,
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      deleteFromList: deleteFromList
    };
    /**
     * Create a new Photo object 
     * @memberof PhotoFactory
     * @returns {object} Photo
     */

    function createNew() {
      return GenericModalFactory.createNew(Photo);
    }
    /**
     * Extend given Photo object 
     * @memberof PhotoFactory
     * @param {object} obj The Photo object that will be extended
     * @returns {object} Photo
     */


    function fromObject(obj) {
      return GenericModalFactory.fromObject(obj, Photo);
    }
    /**
     * Delete Photo object from given list
     * @memberof PhotoFactory
     * @param {object} obj The Photo object that will be deleted
     * @returns {array} Photos
     */


    function deleteFromList(obj, objList) {
      return GenericModalFactory.deleteFromList(obj, objList);
    }
    /**
     * Extend given Photo object 
     * @memberof PhotoFactory
     * @param {object} obj The Photo object that will be extended
     * @returns {object} Photo
     */


    function fromObjectList(objList) {
      return GenericModalFactory.fromObjectList(objList, Photo);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('SeatChangeCtrl', SeatChangeCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name SeatChangeCtrl
  * @description 
  *  Manages the seat change Modal View
  * @ngInject
  */

  function SeatChangeCtrl(changedSeat, report, paxInfo, PaxInfoFactory, $scope, $uibModalInstance) {
    var paxInfo = paxInfo;
    var allPassengers = getPassengers();
    $scope.allPassengers = allPassengers;
    $scope.clearChangedSeatsRemarks = clearChangedSeatsRemarks;
    var result = {};

    if (changedSeat == null) {
      $scope.editMode = false;
      result.Object = null;
      result.isInsertMode = true;
    } else {
      $scope.editMode = true;
      result.Object = Object.assign({}, changedSeat);
      result.Object.check = true;
      result.isInsertMode = false;
    }

    $scope.changedSeat = result.Object;
    $scope.showSeatChangeWarning = false;
    $scope.showSeatChangeError = false;
    $scope.submitSeatChange = submitSeatChange;
    $scope.saveSeatChange = saveSeatChange;
    $scope.cancel = cancel;
    /**
     * Clear Field
     * @memberof SeatChangeCtrl
     */

    function clearField(target, fieldName) {
      if (target[fieldName] == null || target[fieldName] == '') return false;
      bootbox.dialog({
        message: "Please confirm that you wish to clear this field",
        title: "<strong>Attention<strong>",
        buttons: {
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          },
          ok: {
            label: "Ok",
            className: "btn-warning",
            callback: function callback() {
              target[fieldName] = null;
              $scope.$apply();
              return true;
            }
          }
        }
      });
    }
    /**
     * fix any input into 000A format
     * @memberof SeatChangeCtrl
     */


    function formatSeatInput() {
      var missingZeroes = 4 - $scope.changedSeat.NewSeatNo.length;

      for (var i = 0; i < missingZeroes; i++) {
        $scope.changedSeat.NewSeatNo = '0' + $scope.changedSeat.NewSeatNo;
      }
    }
    /**
     * Clear Seat Change remarks
     * @memberof SeatChangeCtrl
     * @param {object} changedSeat
     */


    function clearChangedSeatsRemarks(changedSeat) {
      clearField(changedSeat, "Remarks");
    }
    /**
     * Gets called when user hits submit. checks input then saves
     * @memberof SeatChangeCtrl
     */


    function submitSeatChange() {
      $scope.showSeatChangeError = false;

      if (!isSeatAvailable()) {
        return;
      }

      saveSeatChange();
    }
    /**
     * Save the new seat change to the report
     * @memberof SeatChangeCtrl
     */


    function saveSeatChange() {
      result.Object = $scope.changedSeat;

      for (var i = 0; i < allPassengers.length; i++) {
        if (allPassengers[i].SeatNo == result.Object.OriginalSeatNo) {
          result.Object.UCI = allPassengers[i].UCI;
          result.Object.PNR = allPassengers[i].PNR;
          result.Object.Name = allPassengers[i].Fullname;
        }
      }

      $uibModalInstance.close(result);
    }
    /**
     * Check if seat exists and is empty. fires warnings and errors
     * @memberof SeatChangeCtrl
     * @return {boolean} isSeatAvailable
     */


    function isSeatAvailable() {
      $scope.changedSeat.NewSeatNo = $scope.changedSeat.NewSeatNo.toUpperCase();
      formatSeatInput();

      if (paxInfo) {
        for (var i = 0; i < paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
            if (paxInfo.Seatmap[i].Columns[j].SeatNo == $scope.changedSeat.NewSeatNo) {
              if (paxInfo.Seatmap[i].Columns[j].IsEmptySeat && !IsAlreadyGivenSeat($scope.changedSeat.NewSeatNo)) {
                return true;
              }

              $scope.showSeatChangeWarning = true;
              return false;
            }
          }
        }
      } //not found in seatmap


      $scope.showSeatChangeError = true;
      $scope.changedSeat.NewSeatNo = '';
      return false;
    }

    function IsAlreadyGivenSeat(newSeatNo) {
      return report.ChangedSeats.some(function (item) {
        return item.NewSeatNo == newSeatNo;
      });
    }
    /**
     * Close modal
     * @memberof SeatChangeCtrl
     */


    function cancel() {
      $uibModalInstance.close(null);
    }
    /**
     * Get all passengers and have not been changed already
     * @memberof SeatChangeCtrl
     * @return {array} passengers
     */


    function getPassengers() {
      var passengersList = [];

      if (paxInfo) {
        for (var i = 0; i < paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
            var alreadyChanged = false;

            for (var k = 0; k < report.ChangedSeats.length; k++) {
              if (report.ChangedSeats[k].UCI == paxInfo.Seatmap[i].Columns[j].UCI && report.ChangedSeats[k].PNR == paxInfo.Seatmap[i].Columns[j].PNR && report.ChangedSeats[k].OriginalSeatNo == paxInfo.Seatmap[i].Columns[j].SeatNo) {
                alreadyChanged = true;
              }
            }

            if (!alreadyChanged && paxInfo.Seatmap[i].Columns[j].SeatNo && !paxInfo.Seatmap[i].Columns[j].IsEmptySeat) {
              passengersList.push(paxInfo.Seatmap[i].Columns[j]);
            }
          }
        }
      }

      return passengersList;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('ServerCabinReportFactory', ServerCabinReportFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name ServerCabinReportFactory
  * @description 
  *   Manage Servers Cabin Reports
  * @ngInject
  */

  function ServerCabinReportFactory(GenericService) {
    /**
     * Initialiaze ServerCabinReport object 
     * @memberof ServerCabinReportFactory
     */
    function ServerCabinReport() {
      this.AuthorAimsId = null;
      this.AuthorName = null;
      this.Created = null;
      this.FlightAimsId = null;
      this.FlightId = null;
      this.LastUpdated = null;
      this.ReportGuid = null;
      this.ReportId = null;
      this.ReportedItems = null;
      this.Source = null;
      this.getDescription = getDescription;
      this.isNothingToReport = isNothingToReport;
    }

    var objCallback = ServerCabinReport;
    var service = {
      fromObjectList: fromObjectList,
      constSourceLocalOwn: 'localOwn',
      constSourceLocalOther: 'localOther',
      constSourceStoredOwn: 'storedOwn',
      constSourceStoredOther: 'storedOther'
    };
    /**
     * Get  ServerCabinReport Description
     * @memberof ServerCabinReportFactory
     * @returns {string} Description
     */

    function getDescription() {
      if (this.Created == null && this.AuthorName == null && this.ReportedItems == null) return '-null-';else return (this.AuthorAimsId || '?') + ' ' + (this.AuthorName || '?') + ' @ ' + (this.Created || '?') + (this.ReportedItems || 0) == 0 ? ' :: Nothing to report' : (this.ReportedItems || 0) + ' items logged';
    }
    /**
     * If there is something to report
     * @memberof ServerCabinReportFactory
     * @returns {bool} isNothingToReport
     */


    function isNothingToReport() {
      return (this.ReportedItems || 0) == 0;
    } //Factory Settings

    /**
     * Extend given ServerCabinReport object List 
     * @memberof ServerCabinReportFactory
     * @param {object} obj The ServerCabinReport object that will be extended
     * @returns {array} ServerCabinReports
     */


    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallback);
    }

    ;
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('SpecialMealIssueCtrl', SpecialMealIssueCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name SpecialMealIssueCtrl
  * @description 
  *  Manages the Special Modal View
  * @ngInject
  */

  function SpecialMealIssueCtrl($scope, $timeout, $uibModalInstance, ModalDialogResultFactory, SpecialMealIssueFactory, SpecialMealTypeFactory, SpecialMealSourceFactory, smi) {
    // setup special meal types
    var smts = SpecialMealTypeFactory.getSpecialMealTypesFromStorageAsStrings();
    if (!(smts instanceof Array)) smts = [];
    $scope.specialMealTypes = smts; // setup datetime picker

    $scope.dateOptions = {
      formatYear: 'yyyy',
      startingDay: 1
    };
    $scope.opened = false;

    $scope.open = function ($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.opened = true;
    }; // setup special meal sources


    var smss = SpecialMealSourceFactory.getSpecialMealSourcesFromStorageAsStrings();
    if (!(smss instanceof Array)) smss = [];
    $scope.specialMealSources = smss;
    $scope.clearField = clearField;
    $scope.clearSpecialMealIssueRemarks = clearSpecialMealIssueRemarks;
    var result = ModalDialogResultFactory.createNew();

    if (smi == null) {
      result.Object = SpecialMealIssueFactory.createNew();
      result.isInsertMode = true;
    } else {
      result.Object = SpecialMealIssueFactory.fromObject(smi);

      if (smi.ReturnDate) {
        result.Object.ReturnDate = new Date(smi.ReturnDate);
      }

      result.isInsertMode = false;
    }

    $scope.smi = result.Object;
    $scope.ok = ok;
    $scope.cancel = cancel;
    $timeout(function () {
      $('.modal-special').find('textarea').each(function (index, item) {
        if (item.value != '') autoAdjustTextarea(item);
      });
    }, 500);
    /**
     * Clear Field
     * @memberof SpecialMealIssueCtrl
     */

    function clearField(target, fieldName) {
      if (target[fieldName] == null || target[fieldName] == '') return false;
      bootbox.dialog({
        message: "Please confirm that you wish to clear this field",
        title: "<strong>Attention<strong>",
        buttons: {
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          },
          ok: {
            label: "Ok",
            className: "btn-warning",
            callback: function callback() {
              target[fieldName] = null;
              $scope.$apply();
              return true;
            }
          }
        }
      });
    }
    /**
     * Clear Special Meal Issue remarks
     * @memberof SpecialMealIssueCtrl
     */


    function clearSpecialMealIssueRemarks(smi) {
      $scope.clearField(smi, "Remarks"); //sup.Remarks = null;
    }
    /**
     * set date and close modal
     * @memberof SpecialMealIssueCtrl
     */


    function ok() {
      if (result.Object.Name == null || result.Object.Name == '') result.Object.Name = '-';

      if ($scope.smi.ReturnDate != null) {
        var date = new Date($scope.smi.ReturnDate);
        var offset = date.getTimezoneOffset() / 60;
        var hours = date.getHours();
        date.setHours(hours - offset);
        result.Object.ReturnDate = date.toISOString();
      }

      $uibModalInstance.close(result);
    }
    /**
     * Close modal after u check position
     * @memberof SpecialMealIssueCtrl
     */


    function cancel() {
      $uibModalInstance.close(null);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('SpecialMealIssueFactory', SpecialMealIssueFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name SpecialMealIssueFactory
  * @description 
  *   Manage Report's SpecialMealIssues.
  * @ngInject
  */

  function SpecialMealIssueFactory(GenericModalFactory) {
    /**
     * Initialiaze SpecialMealIssue object 
     * @memberof SpecialMealIssueFactory
     */
    function SpecialMealIssue() {
      this.Id = null;
      this.Name = null;
      this.Phone = null;
      this.Email = null;
      this.Source = null;
      this.MealType = null;
      this.ReturnDate = null;
      this.Remarks = null;
    }

    var service = {
      createNew: createNew,
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      deleteFromList: deleteFromList
    };
    /**
     * Create new SpecialMealIssue object 
     * @memberof SpecialMealIssueFactory
     */

    function createNew() {
      return GenericModalFactory.createNew(SpecialMealIssue);
    }

    ;
    /**
     * Extend given SpecialMealIssue object 
     * @memberof SpecialMealIssueFactory
     * @param {object} obj The SpecialMealIssue object that will be extended
     * @returns {object} SpecialMealIssue
     */

    function fromObject(obj) {
      return GenericModalFactory.fromObject(obj, SpecialMealIssue);
    }
    /**
     * Delete SpecialMealIssue object from given list
     * @memberof SpecialMealIssueFactory
     * @param {object} obj The SpecialMealIssue object that will be deleted
     * @returns {array} SpecialMealIssues
     */


    function deleteFromList(obj, objList) {
      return GenericModalFactory.deleteFromList(obj, objList);
    }
    /**
     * Extend given SpecialMealIssue object List 
     * @memberof SpecialMealIssueFactory
     * @param {object} obj The SpecialMealIssue object that will be extended
     * @returns {array} SpecialMealIssues
     */


    function fromObjectList(objList) {
      return GenericModalFactory.fromObjectList(objList, SpecialMealIssue);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('SpecialMealSourceFactory', SpecialMealSourceFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name SpecialMealSourceFactory
  * @description 
  *   Manage Report's SpecialMealSources.
  * @ngInject
  */

  function SpecialMealSourceFactory(GenericValuesFactory) {
    /**
     * Initialiaze SpecialMealSource object 
     * @memberof SpecialMealSourceFactory
     */
    function SpecialMealSource() {
      this.Code = null;
    }

    var callback = SpecialMealSource;
    var type = 'specialMealSources';
    var service = {
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      toObjectList: toObjectList,
      getSpecialMealSourcesFromStorage: getSpecialMealSourcesFromStorage,
      getSpecialMealSourcesFromStorageAsStrings: getSpecialMealSourcesFromStorageAsStrings,
      setSpecialMealSourcesToStorage: setSpecialMealSourcesToStorage
    };
    /**
     * Create a new SpecialMealSource object 
     * @memberof SpecialMealSourceFactory
     * @returns {object} SpecialMealSource
     */

    function fromObject(obj) {
      return GenericValuesFactory.fromObject(obj, callback);
    }
    /**
     * Extend given SpecialMealSource object List 
     * @memberof SpecialMealSourceFactory
     * @param {object} obj The SpecialMealSource object that will be extended
     * @returns {array} SpecialMealSources
     */


    function fromObjectList(objList) {
      return GenericValuesFactory.fromObjectList(objList, callback);
    }
    /**
    * Get all the SpecialMealSource's Code from given list
    * @memberof SpecialMealSourceFactory
    * @param {array} objectList An object list
    * @returns {array} SpecialMealSources
    */


    function toObjectList(objList) {
      return GenericValuesFactory.objList(objList);
    }
    /**
     * Get all the SpecialMealSource objects
     * @memberof SpecialMealSourceFactory
     * @returns {array} SpecialMealSources
     */


    function getSpecialMealSourcesFromStorage() {
      return GenericValuesFactory.getValuesFromStorage(callback, type);
    }
    /**
     * Get all the SpecialMealSource's codes
     * @memberof SpecialMealSourceFactory
     * @returns {array} SpecialMealSources
     */


    function getSpecialMealSourcesFromStorageAsStrings() {
      return GenericValuesFactory.getValuesFromStorageAsStrings(callback, type);
    }
    /**
     * Set all the SpecialMealSources
     * @memberof SpecialMealSourceFactory
     * @param {array} objects A list of SpecialMealSources.
     */


    function setSpecialMealSourcesToStorage(objList) {
      GenericValuesFactory.setValuesToStorage(objList, type);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('SpecialMealTypeFactory', SpecialMealTypeFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name SpecialMealTypeFactory
  * @description 
  *   Manage SpecialMealTypes.
  * @ngInject
  */

  function SpecialMealTypeFactory(localStorageMD5Service) {
    /**
     * Initialiaze SpecialMealType object 
     * @memberof SpecialMealTypeFactory
     */
    function SpecialMealType() {
      this.Code = null;
    }

    var callback = SpecialMealType;
    var type = 'specialMealTypes';
    var service = {
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      formObjects: formObjects,
      toObjectList: toObjectList,
      getSpecialMealTypesFromStorage: getSpecialMealTypesFromStorage,
      getSpecialMealTypesFromStorageAsStrings: getSpecialMealTypesFromStorageAsStrings,
      setSpecialMealTypesToStorage: setSpecialMealTypesToStorage,
      getSpecialMealTypesFromStorageAsObjects: getSpecialMealTypesFromStorageAsObjects
    };
    /**
     * Extend given SpecialMealType object 
     * @memberof SpecialMealTypeFactory
     * @param {object} obj The SpecialMealType object that will be extended
     * @returns {object} SpecialMealType
     */

    function fromObject(obj) {
      if (obj == null) return null;
      var specialMealType = new SpecialMealType();
      specialMealType.Code = obj.code + ' - ' + obj.label;
      return specialMealType;
    }
    /**
     * Extend given SpecialMealType object list
     * @memberof SpecialMealTypeFactory
     * @param {array} objList The list of SpecialMealType objects that will be extended
     * @returns {object} SpecialMealTypes
     */


    function fromObjectList(objList) {
      if (objList == null) return null;
      var arrayLength = objList.length;
      var specialMealTypes = [];

      for (var i = 0; i < arrayLength; i++) {
        var specialMealType = new SpecialMealType();
        specialMealType.Code = objList[i].code + ' - ' + objList[i].label;
        specialMealTypes.push(specialMealType);
      }

      return specialMealTypes;
    }
    /**
     * Extend given SpecialMealType object list
     * @memberof SpecialMealTypeFactory
     * @param {array} objList The list of SpecialMealType objects that will be extended
     * @returns {object} SpecialMealTypes
     */


    function formObjects(objList) {
      if (objList == null) return null;
      var arrayLength = objList.length;
      var specialMealTypes = new Array();

      for (var i = 0; i < arrayLength; i++) {
        var specialMealType = new SpecialMealType();
        specialMealType.Code = objList[i].code;
        specialMealType.Label = objList[i].label;
        specialMealTypes.push(specialMealType);
      }

      return specialMealTypes;
    }
    /**
     * Get all the SpecialMealType's Code from given list
     * @memberof SpecialMealTypeFactory
     * @param {array} objectList An object list
     * @returns {array} SpecialMealTypes
     */


    function toObjectList(objList) {
      if (specialMealTypeList == null) return null;
      var arrayLength = specialMealTypeList.length;
      var objList = [];

      for (var i = 0; i < arrayLength; i++) {
        objList.push(specialMealTypeList[i].Code);
      }

      return objList;
    }
    /**
     * Get all the SpecialMealType objects
     * @memberof SpecialMealTypeFactory
     * @returns {array} SpecialMealTypes
     */


    function getSpecialMealTypesFromStorage() {
      var specialMealTypes = localStorageMD5Service.get('specialMealTypes');
      return fromObjectList(specialMealTypes);
    }
    /**
     * Get all the SpecialMealType full objects
     * @memberof SpecialMealTypeFactory
     * @returns {array} SpecialMealTypes
     */


    function getSpecialMealTypesFromStorageAsObjects() {
      var specialMealTypes = localStorageMD5Service.get('specialMealTypes');
      return formObjects(specialMealTypes);
    }
    /**
     * Get all the SpecialMealType's codes from local storage
     * @memberof SpecialMealTypeFactory
     * @returns {array} SpecialMealTypes
     */


    function getSpecialMealTypesFromStorageAsStrings() {
      var result = [];
      var objs = getSpecialMealTypesFromStorage();

      for (var i = 0; i < objs.length; i++) {
        result.push(objs[i].Code);
      }

      return result;
    }
    /**
     * Set all the SpecialMealTypes
     * @memberof SpecialMealTypeFactory
     * @param {array} objects A list of SpecialMealTypes.
     */


    function setSpecialMealTypesToStorage(specialMealTypes) {
      localStorageMD5Service.set('specialMealTypes', specialMealTypes);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('SupplyCtrl', SupplyCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name SupplyCtrl
  * @description 
  *  Manages the Supply Modal View
  * @ngInject
  */

  function SupplyCtrl($scope, $timeout, $uibModalInstance, ModalDialogResultFactory, SupplyFactory, ACSupplyFactory, sup) {
    // setup supply types
    var smts = ACSupplyFactory.getACSuppliesFromStorageAsStrings();
    if (!(smts instanceof Array)) smts = [];
    $scope.supplyTypes = smts;
    $scope.clearField = clearField; // clear remarks function

    $scope.clearSupplyRemarks = clearSupplyRemarks;
    var result = ModalDialogResultFactory.createNew();

    if (sup == null) {
      result.Object = SupplyFactory.createNew();
      result.isInsertMode = true;
    } else {
      result.Object = SupplyFactory.fromObject(sup);
      result.isInsertMode = false;
    }

    $scope.sup = result.Object;
    $scope.ok = ok;
    $scope.cancel = cancel;
    $timeout(function () {
      $('.modal-supplies').find('textarea').each(function (index, item) {
        if (item.value != '') autoAdjustTextarea(item);
      });
    }, 500);
    /**
     * Clear Field
     * @memberof SupplyCtrl
     */

    function clearField(target, fieldName) {
      if (target[fieldName] == null || target[fieldName] == '') return false;
      bootbox.dialog({
        message: "Please confirm that you wish to clear this field",
        title: "<strong>Attention<strong>",
        buttons: {
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          },
          ok: {
            label: "Ok",
            className: "btn-warning",
            callback: function callback() {
              target[fieldName] = null;
              $scope.$apply();
              return true;
            }
          }
        }
      });
    }
    /**
     * Clear Supply Remarks
     * @memberof SupplyCtrl
     * @param {object} supply
     */


    function clearSupplyRemarks(sup) {
      $scope.clearField(sup, "Remarks"); //sup.Remarks = null;
    }
    /**
     * Close modal after u check SupplyType
     * @memberof SupplyCtrl
     */


    function ok() {
      if (result.Object.SupplyType == null || result.Object.SupplyType == '') result.Object.SupplyType = '-';
      $uibModalInstance.close(result);
    }
    /**
     * Close modal
     * @memberof SupplyCtrl
     */


    function cancel() {
      $uibModalInstance.close(null);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('SupplyFactory', SupplyFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name SupplyFactory
  * @description 
  *   Manage Report's Supplies.
  * @ngInject
  */

  function SupplyFactory(GenericModalFactory) {
    /**
     * Initialiaze a object 
     * @memberof SupplyFactory
     */
    function Supply() {
      this.SupplyType = null;
      this.Remarks = null;
    }

    var service = {
      createNew: createNew,
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      deleteFromList: deleteFromList
    };
    /**
     * Initialiaze Supply object 
     * @memberof SupplyFactory
     */

    function createNew() {
      return GenericModalFactory.createNew(Supply);
    }
    /**
     * Extend given Supply object 
     * @memberof SupplyFactory
     * @param {object} obj The Supply object that will be extended
     * @returns {object} Supply
     */


    function fromObject(obj) {
      return GenericModalFactory.fromObject(obj, Supply);
    }
    /**
     * Delete Supply object from given list
     * @memberof SupplyFactory
     * @param {object} obj The Supply object that will be deleted
     * @returns {array} Supplies
     */


    function deleteFromList(obj, objList) {
      return GenericModalFactory.deleteFromList(obj, objList);
    }
    /**
     * Extend given Supply object List 
     * @memberof SupplyFactory
     * @param {object} obj The Supply object that will be extended
     * @returns {array} Supplies
     */


    function fromObjectList(objList) {
      return GenericModalFactory.fromObjectList(objList, Supply);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('TravelValueIncompleteReasonFactory', TravelValueIncompleteReasonFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name TravelValueIncompleteReasonFactory
  * @description 
  *   Manage  Travel Value Incomplete Reasons.
  * @ngInject
  */

  function TravelValueIncompleteReasonFactory(localStorageMD5Service) {
    var service = {
      getReasonsFromStorage: getReasonsFromStorage,
      setReasonsToStorage: setReasonsToStorage
    };
    /**
     * Get all the Travel Value Incomplete Reasons full objects
     * @memberof TravelValueIncompleteReasonFactory
     * @returns {array} TravelValueIncompleteReasons
     */

    function getReasonsFromStorage() {
      var results = localStorageMD5Service.get('travelValueIncompleteReasons');
      return results || [];
    }
    /**
     * Set all the Travel Value Incomplete Reasons
     * @memberof TravelValueIncompleteReasonFactory
     * @param {array} objects A list of TravelValueIncompleteReasons.
     */


    function setReasonsToStorage(data) {
      localStorageMD5Service.set('travelValueIncompleteReasons', data);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('TravelValueSealCtrl', TravelValueSealCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name TravelValueSealCtrl
  * @description 
  *  Manages Travel Value Seal Modal View
  * @ngInject
  */

  function TravelValueSealCtrl($scope, $uibModalInstance, ModalDialogResultFactory, TravelValueSealFactory, tvs) {
    var result = ModalDialogResultFactory.createNew();

    if (tvs == null) {
      result.Object = TravelValueSealFactory.createNew();
      result.isInsertMode = true;
    } else {
      result.Object = TravelValueSealFactory.fromObject(tvs);
      result.isInsertMode = false;
    }

    $scope.tvs = result.Object;
    $scope.ok = ok;
    $scope.cancel = cancel;
    /**
     * Close modal after u check Label
     * @memberof TravelValueSealCtrl
     */

    function ok() {
      if (result.Object.Label == null || result.Object.Label == '') result.Object.Label = '-';
      $uibModalInstance.close(result);
    }
    /**
     * Close modal 
     * @memberof TravelValueSealCtrl
     */


    function cancel() {
      $uibModalInstance.close(null);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('TravelValueSealFactory', TravelValueSealFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name TravelValueSealFactory
  * @description 
  *   Manage Report's TravelValueSeals.
  * @ngInject
  */

  function TravelValueSealFactory(GenericModalFactory) {
    /**
     * Initialiaze TravelValueSeal object 
     * @memberof TravelValueSealFactory
     */
    function TravelValueSeal() {
      this.Id = null;
      this.Position = null;
      this.SealFound = null;
      this.SealLeft = null;
    }

    var service = {
      createNew: createNew,
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      deleteFromList: deleteFromList
    };
    /**
     * Create new  TravelValueSeal object 
     * @memberof TravelValueSealFactory
     */

    function createNew() {
      return GenericModalFactory.createNew(TravelValueSeal);
    }
    /**
     * Extend given TravelValueSeal object 
     * @memberof TravelValueSealFactory
     * @param {object} obj The TravelValueSeal object that will be extended
     * @returns {object} TravelValueSeal
     */


    function fromObject(obj) {
      return GenericModalFactory.fromObject(obj, TravelValueSeal);
    }
    /**
     * Delete TravelValueSeal object from given list
     * @memberof TravelValueSealFactory
     * @param {object} obj The TravelValueSeal object that will be deleted
     * @returns {array} TravelValueSeals
     */


    function deleteFromList(obj, objList) {
      return GenericModalFactory.deleteFromList(obj, objList);
    }
    /**
     * Extend given TravelValueSeal object List 
     * @memberof TravelValueSealFactory
     * @param {object} obj The TravelValueSeal object that will be extended
     * @returns {array} TravelValueSeals
     */


    function fromObjectList(objList) {
      return GenericModalFactory.fromObjectList(objList, TravelValueSeal);
    }

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.controller('UPGDCtrl', UPGDCtrl);
  /**
  * @memberof CabinReports
  * @ngdoc controller
  * @name UPGDCtrl
  * @description 
  *  Manages the UPGD Modal View
  * @ngInject
  */

  function UPGDCtrl(upgradedPassenger, report, paxInfo, PaxInfoFactory, $scope, $uibModalInstance) {
    // get eligible passengers
    var paxInfo = paxInfo;
    var eligiblePassengers = getEligiblePassengers();
    $scope.eligiblePassengers = eligiblePassengers;
    $scope.clearUPGDRemarks = clearUPGDRemarks;
    var result = {};

    if (upgradedPassenger == null) {
      $scope.editMode = false;
      result.Object = null;
      result.isInsertMode = true;
    } else {
      $scope.editMode = true;
      result.Object = Object.assign({}, upgradedPassenger);
      result.Object.check = true;
      result.isInsertMode = false;
    }

    $scope.upgradedPassenger = result.Object;
    $scope.showUpgradeWarning = false;
    $scope.showUpgradeError = false;
    $scope.submitUpgrade = submitUpgrade;
    $scope.saveUpgrade = saveUpgrade;
    $scope.cancel = cancel;
    /**
     * Clear Field
     * @memberof UPGDCtrl
     */

    function clearField(target, fieldName) {
      if (target[fieldName] == null || target[fieldName] == '') return false;
      bootbox.dialog({
        message: "Please confirm that you wish to clear this field",
        title: "<strong>Attention<strong>",
        buttons: {
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          },
          ok: {
            label: "Ok",
            className: "btn-warning",
            callback: function callback() {
              target[fieldName] = null;
              $scope.$apply();
              return true;
            }
          }
        }
      });
    }
    /**
     * fix any input into 000A format
     * @memberof UPGDCtrl
     */


    function formatSeatInput() {
      var missingZeroes = 4 - $scope.upgradedPassenger.UpgradedSeatNo.length;

      for (var i = 0; i < missingZeroes; i++) {
        $scope.upgradedPassenger.UpgradedSeatNo = '0' + $scope.upgradedPassenger.UpgradedSeatNo;
      }
    }
    /**
     * Clear upgrade remarks
     * @memberof UPGDCtrl
     * @param {object} upgradedPassenger
     */


    function clearUPGDRemarks(upgradedPassenger) {
      clearField(upgradedPassenger, "Remarks");
    }
    /**
     * Gets called when user hits submit. checks input then saves
     * @memberof UPGDCtrl
     */


    function submitUpgrade() {
      $scope.showUpgradeError = false;

      if (!isSeatAvailable()) {
        return;
      }

      saveUpgrade();
    }
    /**
     * Save the new upgrade to the report
     * @memberof UPGDCtrl
     */


    function saveUpgrade() {
      result.Object = $scope.upgradedPassenger;

      for (var i = 0; i < eligiblePassengers.length; i++) {
        if (eligiblePassengers[i].SeatNo == result.Object.OriginalSeatNo) {
          result.Object.UCI = eligiblePassengers[i].UCI;
          result.Object.PNR = eligiblePassengers[i].PNR;
        }
      }

      $uibModalInstance.close(result);
    }
    /**
     * Check if seat exists and is empty. fires warnings and errors
     * @memberof UPGDCtrl
     * @return {boolean} isSeatAvailable
     */


    function isSeatAvailable() {
      $scope.upgradedPassenger.UpgradedSeatNo = $scope.upgradedPassenger.UpgradedSeatNo.toUpperCase();
      formatSeatInput();

      if (paxInfo) {
        for (var i = 0; i < paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
            if (paxInfo.Seatmap[i].Columns[j].SeatNo == $scope.upgradedPassenger.UpgradedSeatNo) {
              if (paxInfo.Seatmap[i].Columns[j].IsEmptySeat) {
                return true;
              }

              $scope.showUpgradeWarning = true;
              return false;
            }
          }
        }
      } //not found in seatmap


      $scope.showUpgradeError = true;
      $scope.upgradedPassenger.UpgradedSeatNo = '';
      return false;
    }
    /**
     * Close modal
     * @memberof UPGDCtrl
     */


    function cancel() {
      $uibModalInstance.close(null);
    }
    /**
     * Get all passengers that are eligible for upgrade, are in Y cabin and have not been upgraded already
     * @memberof UPGDCtrl
     * @return {array} eligiblePassengers
     */


    function getEligiblePassengers() {
      var eligiblePassengersList = [];

      if (paxInfo) {
        for (var i = 0; i < paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
            if (paxInfo.Seatmap[i].Columns[j].IsEligibleForUpgrade && paxInfo.Seatmap[i].Columns[j].Cabin == 'Y') {
              var alreadyUpgraded = false;

              for (var k = 0; k < report.UpgradedPassengers.length; k++) {
                if (report.UpgradedPassengers[k].UCI == paxInfo.Seatmap[i].Columns[j].UCI && report.UpgradedPassengers[k].PNR == paxInfo.Seatmap[i].Columns[j].PNR && report.UpgradedPassengers[k].OriginalSeatNo == paxInfo.Seatmap[i].Columns[j].SeatNo) {
                  alreadyUpgraded = true;
                }
              }

              if (!alreadyUpgraded) {
                eligiblePassengersList.push(paxInfo.Seatmap[i].Columns[j]);
              }
            }
          }
        }
      }

      return eligiblePassengersList;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_cabin_reports.factory('WaterUpliftActionFactory', WaterUpliftActionFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name WaterUpliftActionFactory
  * @description 
  *   Manage Water Uplift Actions.
  * @ngInject
  */

  function WaterUpliftActionFactory(GenericValuesFactory) {
    /**
     * Initialiaze WaterUpliftAction object 
     * @memberof WaterUpliftActionFactory
     */
    function WaterUpliftAction() {
      this.Code = null;
    }

    var callback = WaterUpliftAction;
    var type = 'waterUpliftActions';
    var service = {
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      toObjectList: toObjectList,
      getWaterUpliftActionsFromStorageAsStrings: getWaterUpliftActionsFromStorageAsStrings,
      setWaterUpliftActionsToStorage: setWaterUpliftActionsToStorage
    };
    /**
     * Extend given WaterUpliftAction object 
     * @memberof WaterUpliftActionFactory
     * @param {object} obj The WaterUpliftAction object that will be extended
     * @returns {object} WaterUpliftAction
     */

    function fromObject(obj) {
      return GenericValuesFactory.fromObject(obj, callback);
    }

    ;
    /**
     * Extend given WaterUpliftAction object 
     * @memberof WaterUpliftActionFactory
     * @param {object} obj The WaterUpliftAction object that will be extended
     * @returns {object} WaterUpliftAction
     */

    function fromObjectList(objList) {
      return GenericValuesFactory.fromObjectList(objList, callback);
    }

    ;
    /**
     * Get all the WaterUpliftAction's Code from given list
     * @memberof WaterUpliftActionFactory
     * @param {array} objectList An object list
     * @returns {array} WaterUpliftActions
     */

    function toObjectList(objList) {
      return GenericValuesFactory.objList(objList);
    }

    ;
    /**
     * Get all the WaterUpliftAction's codes from local storage
     * @memberof WaterUpliftActionFactory
     * @returns {array} WaterUpliftActions
     */

    function getWaterUpliftActionsFromStorageAsStrings() {
      return GenericValuesFactory.getValuesFromStorageAsStrings(callback, type);
    }
    /**
     * Get all the WaterUpliftAction's codes from local storage
     * @memberof WaterUpliftActionFactory
     * @returns {array} WaterUpliftActions
     */


    function setWaterUpliftActionsToStorage(objList) {
      GenericValuesFactory.setValuesToStorage(objList, type);
    }

    return service;
  }
})();